/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = __webpack_require__(2);

	var _index3 = __webpack_require__(3);

	var _index4 = __webpack_require__(4);

	var _index5 = __webpack_require__(5);

	var _index6 = __webpack_require__(6);

	var _index7 = __webpack_require__(7);

	var _session = __webpack_require__(8);

	var _session2 = _interopRequireDefault(_session);

	var _toast = __webpack_require__(10);

	var _toast2 = _interopRequireDefault(_toast);

	var _translateLoader = __webpack_require__(12);

	var _translateLoader2 = _interopRequireDefault(_translateLoader);

	var _httpInterceptor = __webpack_require__(13);

	var _httpInterceptor2 = _interopRequireDefault(_httpInterceptor);

	var _offLineToast = __webpack_require__(15);

	var _offLineToast2 = _interopRequireDefault(_offLineToast);

	__webpack_require__(16);

	__webpack_require__(17);

	__webpack_require__(37);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix', ['satellizer', 'pascalprecht.translate', 'ui.router', 'ngMaterial', 'phoenix.access', 'phoenix.control', 'phoenix.variables']).config(_index.authDefinition).config(_index2.config).config(_index3.configRoutes).config(_index4.locale).run(_index5.runBlock).run(_offLineToast2.default).config(_index6.themeDefinition).config(['$httpProvider', _index7.httpInterceptor]).service('SessionService', _session2.default).service('ToastService', _toast2.default).factory('translateLoaderFactory', ['$q', '$http', '$window', 'EnvironmentConfig', _translateLoader2.default]).factory('httpInterceptor', ['$q', '$injector', '$document', '$rootScope', 'EnvironmentConfig', _httpInterceptor2.default]);

	// modules
	/* eslint-disable angular/di */

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	authDefinition.$inject = ["$authProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authDefinition = authDefinition;
	function authDefinition($authProvider) {
	  'ngInject';

	  $authProvider.loginUrl = 'auth/login';
	  $authProvider.storageType = 'localStorage';
	  $authProvider.tokenName = 'token';
	  $authProvider.tokenPrefix = '';
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	config.$inject = ["$locationProvider", "$logProvider", "$qProvider", "$translateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = config;
	function config($locationProvider, $logProvider, $qProvider, $translateProvider) {
	  'ngInject';

	  // remove hash from url

	  $locationProvider.html5Mode(true);
	  $logProvider.debugEnabled(false);

	  // define localStorage as main store provider
	  $translateProvider.useSanitizeValueStrategy('escape');
	  $qProvider.errorOnUnhandledRejections(false);
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	configRoutes.$inject = ["$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configRoutes = configRoutes;
	function configRoutes($urlRouterProvider) {
	  'ngInject';

	  $urlRouterProvider.otherwise('/access/login');
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	locale.$inject = ["$translateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locale = locale;
	function locale($translateProvider) {
	  'ngInject';
	  // verify user

	  var user = angular.fromJson(localStorage.getItem('user'));
	  // if user not defined set a default lang
	  var locale = user && user.attributes ? user.attributes.locale : $translateProvider.resolveClientLocale().replace('-', '_');

	  var langs = ['pt_BR', 'en_US', 'es_UY'];
	  var langMap = {
	    'pt*': 'pt_BR',
	    'en*': 'en_US',
	    'es*': 'es_UY',
	    '*': 'en_US'
	  };

	  $translateProvider.registerAvailableLanguageKeys(langs, langMap).preferredLanguage(locale).forceAsyncReload(true).useLoader('translateLoaderFactory');

	  // $translateProvider.fallbackLanguage(langs)
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	runBlock.$inject = ["$auth", "$state", "$transitions", "$window", "$translate", "$q", "AccessService", "EnvironmentConfig", "HttpService", "InternalChatService", "SessionService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runBlock = runBlock;
	function runBlock($auth, $state, $transitions, $window, $translate, $q, AccessService, EnvironmentConfig, HttpService, InternalChatService, SessionService) {
	  'ngInject';

	  $transitions.onBefore({}, function (transition) {
	    var currentTransition = transition.router.globals.transition;
	    if (currentTransition && currentTransition !== transition) {
	      currentTransition.abort();
	    }

	    var isParent = $state.includes(transition.$to().name, { inherit: false });

	    if (transition.$from() !== transition.$to() && !isParent) {
	      HttpService.cancelRequests();
	    }

	    return transition;
	  });

	  $transitions.onStart({}, function (transition) {
	    var to = transition.$to();
	    var defer = $q.defer();

	    if (to.name === 'external') {
	      $window.localStorage.clear();
	    }

	    var storagedKeys = Object.keys($window.localStorage);
	    var mandatoryKyes = ['token', 'enterprise', 'user', 'role'];
	    var match = _.intersection(storagedKeys, mandatoryKyes);
	    var tokenExpired = false;
	    var revalidateToken = false;

	    var permissions = $window.localStorage.getItem('role') || false;
	    var keepConn = angular.fromJson($window.localStorage.getItem('keep_conn')) || false;

	    if ($auth.isAuthenticated()) {
	      var nowTimestamp = new Date().valueOf();
	      var expiration = $auth.getPayload().exp * 1000;
	      var diffInMinutes = moment(expiration).diff(nowTimestamp, 'minutes');

	      tokenExpired = $auth.getPayload() && nowTimestamp > expiration;
	      revalidateToken = keepConn ? diffInMinutes < 10 : false;
	    }

	    if (revalidateToken) {
	      AccessService.refreshToken().then(function () {
	        defer.resolve();
	      }).catch(function () {
	        defer.resolve();
	        SessionService.logout();
	      });
	    } else if (to.data && to.data.requiresLogin && (!$auth.isAuthenticated() || tokenExpired || match.length < 4)) {
	      defer.reject();
	      $window.localStorage.clear();
	      $state.go('signin');
	    } else {
	      defer.resolve();
	    }

	    if (to.parent.name !== '' && $auth.isAuthenticated() && angular.isDefined($auth.getPayload())) {
	      InternalChatService.chatEvent('update');
	      if (to.parent.name === 'access' && $auth.isAuthenticated() || permissions && !to.data.canAccess.includes(permissions)) {
	        transition.abort();
	        $state.go('control');
	      }
	    }
	    return defer.promise;
	  });

	  var isReloading = false;
	  $transitions.onSuccess({}, function (transition) {
	    var toState = transition.to();
	    var toParams = transition.params('to');
	    var fromState = transition.from();
	    var fromParams = transition.params('from');

	    var user = angular.fromJson($window.localStorage.getItem('user'));
	    var locale = user ? user.attributes.locale.replace('_', '-') : $translate.resolveClientLocale().replace('_', '-');

	    var excludedPages = ['/control'];
	    var translate = toState.data && toState.data.pageTitle ? 'PAGE_TITLE.' + toState.data.pageTitle : 'PAGE_TITLE.DEFAULT';
	    $translate([translate]).then(function (t) {
	      if (t[translate] !== translate) {
	        $window.document.title = t[translate];
	      }
	    });

	    /* eslint-disable no-undef */
	    if (!excludedPages.includes(toState.url)) {
	      gtag('event', 'page_view', {
	        page_title: toState.name,
	        page_path: '/' + toState.name,
	        language: locale,
	        event_category: $window.localStorage.getItem('role'),
	        event_label: EnvironmentConfig.VERSION
	      });
	    } else {
	      gtag('config', EnvironmentConfig.ANALYTICS_TRACKER_ID, {
	        send_page_view: false
	      });
	    }
	    /* eslint-enable no-undef */

	    var name = [toState.name];
	    if (toState.name.includes('.')) {
	      name = toState.name.split('.');
	    }

	    if (fromState.name === toState.name && fromParams.id !== toParams.id) {
	      if (!isReloading) {
	        isReloading = true;
	        $state.go(name[0], { id: toParams.id }, { reload: true }).finally(function () {
	          isReloading = false;
	        });
	      }
	    }
	  });
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	themeDefinition.$inject = ["$mdThemingProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.themeDefinition = themeDefinition;
	function themeDefinition($mdThemingProvider) {
	  'ngInject';
	  // disable theme generation
	  // $mdThemingProvider.generateThemesOnDemand(true);

	  $mdThemingProvider.theme('default').primaryPalette('grey').accentPalette('blue-grey');
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.httpInterceptor = httpInterceptor;
	function httpInterceptor($httpProvider) {
	  $httpProvider.interceptors.push('httpInterceptor');
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SessionService = function () {
	  SessionService.$inject = ["$state", "$window", "InternalChatService", "UserNotificationService", "StateManagement", "MainService"];
	  function SessionService($state, $window, InternalChatService, UserNotificationService, StateManagement, MainService) {
	    'ngInject';

	    _classCallCheck(this, SessionService);

	    this.$state = $state;
	    this.$window = $window;
	    this.StateManagement = StateManagement;
	    this.MainService = MainService;

	    this.InternalChatService = InternalChatService;
	    this.UserNotificationService = UserNotificationService;
	  }

	  _createClass(SessionService, [{
	    key: 'logout',
	    value: function logout() {
	      var _this = this;

	      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      if (request) {
	        this.MainService.create(_constants.API.V5, 'auth/logout').promise.finally(function () {
	          _this.clear();
	        });
	      } else {
	        this.clear();
	      }
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.UserNotificationService.unsubscribeNotification();
	      this.InternalChatService.closeChatEvent();
	      this.clearStorage();
	      this.StateManagement.clearSessionStore();
	      this.$state.go('signin');
	    }
	  }, {
	    key: 'clearStorage',
	    value: function clearStorage() {
	      var _this2 = this;

	      ['token', 'role', 'coords', 'search', 'section', 'user', 'enterprise', 'notification_dtk', 'notification_attempt', 'notification_subscribed', 'alertPriorities', 'translations-age', 'keep_conn', 'refresh_token'].forEach(function (item) {
	        _this2.$window.localStorage.removeItem(item);
	      });
	    }
	  }]);

	  return SessionService;
	}();

	exports.default = SessionService;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API = exports.API = {
	  AUTH: 'auth',
	  ADDRESSES: 'addresses',
	  ALERTS: 'alerts',
	  BILLING: 'billing',
	  CHECKLISTS: 'checklist',
	  CLIENTS: 'clients',
	  CHIPS: 'chips',
	  DASHBOARD: 'dashboard',
	  DEVICES: 'devices',
	  ENTERPRISES: 'enterprises',
	  ENUM: 'enum',
	  ERBS: 'erb-station',
	  EVENTS: 'events',
	  FILES: 'files',
	  FUELS: 'fuels',
	  GEOFENCES: 'fences',
	  IDENTIFICATIONS: 'identifications',
	  MAPBOX: 'mapbox',
	  PROTOCOLS: 'protocols',
	  REPORTS: 'reports',
	  BEHAVIOR_CONFIGS: 'behavior-configs',
	  RISK_AREAS: 'risk-area',
	  SHARINGS: 'sharings',
	  SERVICE_ORDERS: 'service-orders',
	  SURVEYS: 'surveys',
	  TRAJECTORIES: 'trajectories',
	  TERMS_TEMPLATES: 'terms-templates',
	  TICKETS: 'tickets',
	  TRIPS: 'trips',
	  USERS: 'users',
	  VEHICLES: 'vehicles',
	  V1: 'v1',
	  V2: 'v2',
	  V3: 'v3',
	  V4: 'v4',
	  V5: 'v5'
	};

	var ROLES = exports.ROLES = {
	  INTERNALS: ['ROOT', 'MANAGER', 'FINANCE', 'SUPPORT', 'SALES'],
	  MANAGER: ['ACCOUNT', 'ADMIN', 'ENTERPRISE'],
	  CLIENT: ['OWNER', 'REGULAR'],
	  READ_ONLY: ['VISITOR'],
	  OPERATOR: ['CALLCENTER'],
	  PROVIDER: ['PROVIDER']
	};

	var GOOGLE_KEY = exports.GOOGLE_KEY = 'AIzaSyA0vofJLHikkZkKHJ6W6enGQ67lzLvfKAs';
	var GOOGLE_REGEOCODING = exports.GOOGLE_REGEOCODING = 'https://maps.googleapis.com/maps/api/geocode/json';
	var GOOGLE_DIRECTIONS = exports.GOOGLE_DIRECTIONS = 'https://maps.googleapis.com/maps/api/directions/json';
	var GOOGLE_STREETVIEW = exports.GOOGLE_STREETVIEW = 'https://www.google.com/maps/embed/v1/streetview';

	var weekdays = exports.weekdays = {
	  pt_BR: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
	  es_UY: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
	  en_US: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	};

	var months = exports.months = {
	  pt_BR: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
	  es_UY: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
	  en_US: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	};

	var SUBSCRIBER = exports.SUBSCRIBER = {
	  SUBSCRIPTIONS: 'subscriptions',
	  ALERT: 'alert',
	  REGISTER_TOKEN: 'device-tokens'
	};

	var NOTIFICATIONS = exports.NOTIFICATIONS = {
	  icon: 'https://cdn.softruck.com/front-phoenix/images/icon.png',
	  audio: 'https://cdn.softruck.com/front-phoenix/audios/alarm_0.ogg'
	};

	var IMPORTABLES = exports.IMPORTABLES = {
	  devices: {
	    available: true,
	    keys: ['name', 'imei', 'code'],
	    required: ['name', 'imei']
	  },
	  chips: {
	    available: true,
	    keys: ['serial', 'number', 'carrier', 'apn', 'apn_username', 'apn_password', 'service_provider'],
	    required: ['serial', 'number', 'service_provider']
	  },
	  users: {
	    available: false,
	    keys: [],
	    required: []
	  },
	  vehicles: {
	    available: true,
	    keys: ['plate', 'vin', 'year'],
	    required: ['plate']
	  }

	  // alerts
	};var TAGS = exports.TAGS = ['accelerometer', 'antenna', 'configuration', 'course', 'engine', 'gsm', 'hourmeter', 'rain', 'reserved', 'tilt', 'vehicle', 'battery', 'calibration', 'device', 'door', 'emergency', 'fence', 'firmware', 'ftpfile', 'fuel', 'gps', 'gprs', 'idle', 'ibutton', 'ignition', 'input', 'jamming', 'motion', 'operation', 'output', 'power', 'photo', 'rfid', 'rpm', 'roaming', 'route', 'serial', 'shift', 'sim', 'sleep', 'sms', 'speed', 'stop', 'taximeter', 'temperature', 'transfer', 'tow', 'ufsxxx', 'unknown', 'upc', 'camera', 'rs232', 'anchor', 'storage', 'engine_seal', 'uncategorized', 'hardware', 'fatigue', 'pairing', 'buffer', 'movement', 'module', 'user'];
	var PRIORITIES = exports.PRIORITIES = {
	  HIGH: ['battery', 'communication', 'emergency', 'watcher', 'power', 'jamming'],
	  MEDIUM: ['gsm', 'firmware', 'gps', 'gprs', 'tow', 'speed', 'geo', 'ibutton', 'ignition', 'input', 'output', 'accelerometer', 'motion', 'sleep', 'movement', 'tilt'],
	  LOW: ['antenna', 'configuration', 'course', 'engine', 'hourmeter', 'rain', 'reserved', 'vehicle', 'calibration', 'device', 'door', 'fence', 'ftpfile', 'fuel', 'idle', 'operation', 'photo', 'rfid', 'rpm', 'roaming', 'route', 'serial', 'shift', 'sim', 'sms', 'stop', 'taximeter', 'temperature', 'transfer', 'ufsxxx', 'unknown', 'upc', 'camera', 'rs232', 'anchor', 'storage', 'engine_seal', 'uncategorized', 'hardware', 'fatigue', 'pairing', 'buffer', 'module', 'user']

	  // files
	};var EXPORT_TYPE = exports.EXPORT_TYPE = {
	  CSV: 'text/csv;charset=utf-8',
	  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
	};
	var FILES = exports.FILES = {
	  SHEETS: {
	    MIMES: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv'],
	    EXTENSIONS: ['.xlsx', '.xls', '.csv']
	  }

	  // Max reports intervals in seconds
	};var INTERVAL_IN_SECONDS = exports.INTERVAL_IN_SECONDS = {
	  day: 86400, // 1 day
	  week: 604800, // 1 week
	  month: 2678400, // 31 days - 1 month
	  quarter: 7776000 // 90 days


	  // addresses
	};var ADDRESSES_TYPE = exports.ADDRESSES_TYPE = {
	  USERS: ['HOME', 'WORK', 'OTHER'],
	  ENTERPRISES: ['BILLING', 'OTHER']
	};
	var ADDRESSES_KEYS = exports.ADDRESSES_KEYS = {
	  city: { key: 'administrative_area_level_2' },
	  country: { key: 'country', shortKey: 'country_code' },
	  region: { key: 'administrative_area_level_1', shortKey: 'region_short' },
	  street: { key: 'route' },
	  street_number: { key: 'street_number' },
	  zip_code: { key: 'postal_code' }
	};

	var USER_NATURE = exports.USER_NATURE = ['driver', 'owner', 'manager'];

	// enterprises
	var CUSTOMIZATION_LAYOUT = exports.CUSTOMIZATION_LAYOUT = ['left', 'center', 'right'];

	// devices
	var DEVICE_STATUS = exports.DEVICE_STATUS = [true, false];
	var ONWERSHIP = exports.ONWERSHIP = [true, false];

	// service orders
	var TASK_RESOUCES = exports.TASK_RESOUCES = ['service-orders', 'protocols'];
	var TASK_EXPENSE_TYPES = exports.TASK_EXPENSE_TYPES = ['materials', 'labor', 'transportation', 'subcontractor', 'indirect', 'equipment', 'fees', 'training', 'other'];
	var TASK_PRIORITIES = exports.TASK_PRIORITIES = ['low', 'medium', 'high', 'max'];
	var TASK_CUSTOM_FIELDS_FORMATS = exports.TASK_CUSTOM_FIELDS_FORMATS = ['text', 'number', 'date', 'enum', 'checkbox'];

	// protocols
	var PROTOCOL_TYPES = exports.PROTOCOL_TYPES = ['appropriation', 'theft', 'robbery', 'kidnapping', 'other', 'assistance'];
	var PROTOCOL_STATUS = exports.PROTOCOL_STATUS = ['todo', 'doing', 'done', 'canceled'];
	var PROTOCOL_CONDITION = exports.PROTOCOL_CONDITION = ['denied', 'answered', 'under evaluation'];

	// sharings
	// export const SHARINGS_TYPES = ['history', 'live-location', 'service-order']
	var SHARINGS_TYPES = exports.SHARINGS_TYPES = ['live-location'];
	var SHARINGS_SOURCES = exports.SHARINGS_SOURCES = ['protocols', 'sharings'];

	// users
	var LANGUAGES = exports.LANGUAGES = ['pt_BR', 'en_US', 'es_UY'];

	// textarea
	var TEXT_LAYOUT = exports.TEXT_LAYOUT = {
	  skin: 'lightgray',
	  inline: false,
	  menubar: false,
	  statusbar: false,
	  selector: 'textarea',
	  toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist outdent indent',
	  plugins: 'lists code table codesample autoresize',
	  max_height: '120',
	  min_height: '80'

	  // vehicles
	};var COLORS = exports.COLORS = {
	  '#FF9800': { name: 'orange', hex: '#FF9800' },
	  '#FF5722': { name: 'red', hex: '#FF5722' },
	  '#795548': { name: 'brown', hex: '#795548' },
	  '#9E9E9E': { name: 'grey', hex: '#9E9E9E' },
	  '#C0C0C0': { name: 'silver', hex: '#C0C0C0' },
	  '#8BC34A': { name: 'green', hex: '#8BC34A' },
	  '#2196F3': { name: 'blue', hex: '#2196F3' },
	  '#FFC107': { name: 'gold', hex: '#FFC107' },
	  '#FFEB3B': { name: 'yellow', hex: '#FFEB3B' },
	  '#FFFFFF': { name: 'white', hex: '#FFFFFF' },
	  '#9C27B0': { name: 'purple', hex: '#9C27B0' },
	  '#C2185B': { name: 'wine', hex: '#C2185B' },
	  '#212121': { name: 'black', hex: '#212121' },
	  '#F8BBD0': { name: 'pink', hex: '#F8BBD0' },
	  '#E1C699': { name: 'beige', hex: '#E1C699' }
	};
	var ASSET_TYPES = exports.ASSET_TYPES = [{ name: 'car', type: 'vehicle' }, { name: 'utility', type: 'vehicle' }, { name: 'van', type: 'vehicle' }, { name: 'scooter', type: 'vehicle' }, { name: 'motorcycle', type: 'vehicle' }, { name: 'tricycle', type: 'vehicle' }, { name: 'quadricycle', type: 'vehicle' }, { name: 'pickup truck', type: 'vehicle' }, { name: 'truck', type: 'vehicle' }, { name: 'bus', type: 'vehicle' }, { name: 'micro bus', type: 'vehicle' }, { name: 'other', type: 'vehicle' }, { name: 'implement', type: 'vehicle' }, { name: 'agricultural machine', type: 'vehicle' }, { name: 'tractor truck', type: 'vehicle' }, { name: 'tractor', type: 'vehicle' }, { name: 'bicycle', type: 'vehicle' }, { name: 'trailer', type: 'vehicle' }, { name: 'tram', type: 'vehicle' }, { name: 'null', type: 'vehicle' }];

	// trajectories
	var trajectoryInterval = exports.trajectoryInterval = ['case', ['==', ['get', 'spd'], 0], '#5792f0', // blue
	['==', ['get', 'spd'], 1], '#fda943', // orange
	['==', ['get', 'spd'], 2], '#d21e27', // red
	['==', ['get', 'spd'], 3], '#8f1614', // dark-red
	'#E91E63'];

	var REDUCED_SEG_KEYS = exports.REDUCED_SEG_KEYS = ['vDis', 'dur', 'gpsCnt', 'hisDur', 'stCnt', 'stDur', 'alCnt', 'alTags'];
	var DEFAULT_REDUCED_SEG = exports.DEFAULT_REDUCED_SEG = {
	  vDis: 0,
	  dur: 0,
	  gpsCnt: 0,
	  hisDur: 0,
	  stCnt: 0,
	  stDur: 0,
	  alCnt: 0,
	  alTags: []

	  // device io options
	};var DEVICES_IO = exports.DEVICES_IO = {
	  IN: ['falling_edge', 'rising_edge', 'rising_falling_edge', 'panic_button', 'anti_theft', 'ignition_line'],
	  OUT: ['general', 'lock', 'pulse', 'buzzer']

	  // Sections quill toolbar
	};var TOOLBARSECTION = exports.TOOLBARSECTION = ['align', 'code', 'size'];

	// LOGS
	var LOGS = exports.LOGS = ['users', 'vehicles', 'enterprises', 'chips', 'protocols', 'service_orders'];
	var OPERATION = exports.OPERATION = ['INSERT', 'UPDATE', 'DELETE'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _reloadDialog = __webpack_require__(11);

	var _reloadDialog2 = _interopRequireDefault(_reloadDialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ToastService = function () {
	  ToastService.$inject = ["$mdToast", "$translate"];
	  function ToastService($mdToast, $translate) {
	    'ngInject';

	    _classCallCheck(this, ToastService);

	    this.$mdToast = $mdToast;
	    this.$translate = $translate;
	  }

	  _createClass(ToastService, [{
	    key: 'error',
	    value: function error(message) {
	      var toTranslate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var type = arguments[2];
	      var detail = arguments[3];

	      if (!type) type = 'simple';
	      if (toTranslate) message = this.$translate.instant(message);
	      this.$mdToast.show({
	        template: internals[type]('error', 'cancel', message, detail),
	        hideDelay: 4000,
	        position: 'bottom left'
	      });
	    }
	  }, {
	    key: 'success',
	    value: function success(message) {
	      var toTranslate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var type = arguments[2];
	      var detail = arguments[3];

	      if (!type) type = 'simple';
	      if (toTranslate) message = this.$translate.instant(message);
	      this.$mdToast.show({
	        template: internals[type]('success', 'check_circle', message, detail),
	        hideDelay: 4000,
	        position: 'bottom left'
	      });
	    }
	  }, {
	    key: 'offLine',
	    value: function offLine(message) {
	      var toTranslate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      if (toTranslate) message = this.$translate.instant(message);
	      this.$mdToast.show({
	        template: internals.simple('error', 'wifi_off', message),
	        hideDelay: 0,
	        position: 'bottom left'
	      });
	    }
	  }, {
	    key: 'reload',
	    value: function reload(title, text) {
	      var toTranslate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	      var titleTranslate = void 0,
	          textTranslate = void 0;

	      if (toTranslate) {
	        titleTranslate = this.$translate.instant(title);
	        textTranslate = this.$translate.instant(text);
	      }
	      this.$mdToast.show({
	        template: internals.withBtn('info', 'refresh', titleTranslate, textTranslate),
	        hideDelay: 0,
	        position: 'bottom left',
	        controller: _reloadDialog2.default,
	        controllerAs: 'ctrl'
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.$mdToast.hide();
	    }
	  }]);

	  return ToastService;
	}();

	exports.default = ToastService;


	var internals = {
	  simple: function simple(type, icon, message) {
	    return '<md-toast class="md-toast">\n    <div class="md-toast-content">\n      <div class="st-icon toast-' + type + '">\n        <i class="material-symbols-outlined">' + icon + '</i>\n      </div>\n      <div>\n        <div class="toast-title">' + message + '</div>\n      </div>\n    </div>\n  </md-toast>';
	  },
	  complete: function complete(type, icon, message, detail) {
	    return '<md-toast class="md-toast">\n    <div class="md-toast-content">\n      <div class="st-icon toast-' + type + '">\n        <i class="material-symbols-outlined">' + icon + '</i>\n      </div>\n      <div>\n        <div class="toast-title">' + message + '</div>\n        <div class="toast-details">' + detail + '</div>\n      </div>\n    </div>\n  </md-toast>';
	  },
	  withBtn: function withBtn(type, icon, message, detail) {
	    return '<md-toast class="md-toast">\n    <div class="md-toast-content">\n      <div layout layout-align="start start" class="w-full">\n        <div class="st-icon toast-' + type + '">\n          <i class="material-symbols-outlined">' + icon + '</i>\n        </div>\n        <div>\n          <div class="toast-title">' + message + '</div>\n          <div class="toast-details">' + detail + '</div>\n        </div>\n        <button class="altnav-action save ml-auto" type="button" ng-click="ctrl.reloadNoCache()" translate="TOAST.INFO.ACTION.RELOAD"></button>\n      </div>\n    </div>\n  </md-toast>';
	  }
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ReloadDialogController = function () {
	  ReloadDialogController.$inject = ["$window"];
	  function ReloadDialogController($window) {
	    'ngInject';

	    _classCallCheck(this, ReloadDialogController);

	    this.$window = $window;
	  }

	  _createClass(ReloadDialogController, [{
	    key: 'reloadNoCache',
	    value: function reloadNoCache() {
	      this.$window.location.href = this.$window.location.href.split('?')[0] + '?nocache=' + new Date().getTime();
	    }
	  }]);

	  return ReloadDialogController;
	}();

	exports.default = ReloadDialogController;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function ($q, $http, $window, EnvironmentConfig) {
	  // let lastModified
	  // verify and define translation age
	  // const translationAge = localStorage.getItem('translations-age') * 1 || 0
	  var baseUrl = EnvironmentConfig.ENV === 'development' ? ['./languages'] : [EnvironmentConfig.CLOUD_FRONT_URL, 'front-phoenix/locales'];
	  var headers = { 'Content-Type': 'application/json' };

	  var internals = {
	    addToLocalstorage: function addToLocalstorage(res) {
	      $window.localStorage.setItem('translations-age', new Date(res.headers('last-modified')).valueOf());
	    },

	    getLang: function getLang(options) {
	      var deferred = $q.defer();
	      var file = options.key + '.json?' + EnvironmentConfig.VERSION;

	      $http({ url: [].concat(baseUrl, [file]).join('/'), method: 'GET', skipAuthorization: true, headers: headers }).then(function (res) {
	        if (res && res.data) {
	          internals.addToLocalstorage(res);
	          deferred.resolve(res.data);
	        }
	      });

	      return deferred;
	    }
	  };

	  return function (options) {
	    return internals.getLang(options).promise;
	  };
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function ($q, $injector, $document, $rootScope, EnvironmentConfig) {
	  var countCheckVersion = 0;
	  var expectedErrors = [400, 401, 403, 404, 409, 422];
	  var internals = {
	    isServerError: function isServerError(rejection) {
	      return rejection.status >= 500 && rejection.status <= 510;
	    },
	    checkAccessDenied: function checkAccessDenied(rejection) {
	      if ([401, 403].includes(rejection.status) && rejection.data.message === 'access_denied_for_this_enterprise_account_type') {
	        var DialogService = $injector.get('DialogService');
	        var opts = {
	          url: 'app/components/upgrade-plan/upgrade-plan.html',
	          parent: angular.element($document[0].querySelector('.st-content-wrapper')),
	          clickOutsideToClose: false,
	          escapeToClose: false,
	          multiple: false,
	          hasBackdrop: false
	        };
	        DialogService.openDialog(opts);
	        return true;
	      }
	      return false;
	    },
	    checkOldToken: function checkOldToken(rejection) {
	      if (rejection.status === 401 && rejection.data.message === 'old_token') {
	        var _state = $injector.get('$state');
	        _state.go('signin');
	      }
	    },
	    checkDeactivations: function checkDeactivations(rejection) {
	      var internal = rejection.config.url.includes(EnvironmentConfig.API);
	      if (internal && rejection.status === 403 && ['token_expired', 'deactivated_user', 'deactivated_enterprise', 'client_without_access'].includes(rejection.data.message)) {
	        var _session = $injector.get('SessionService');
	        _session.logout(rejection.data.message !== 'token_expired');
	      }
	    },
	    checkAuthorization: function checkAuthorization(config) {
	      var skipAuthorization = config.skipAuthorization || false;
	      return config.headers.Authorization || skipAuthorization;
	    },
	    checkVersion: function checkVersion(version) {
	      if (!version || countCheckVersion > 0 || version === EnvironmentConfig.VERSION) return;

	      var serveVersion = version.split('.').map(Number);
	      var localVersion = EnvironmentConfig.VERSION.split('.').map(Number);

	      for (var i = 0; i < localVersion.length; i++) {
	        if (localVersion[i] > serveVersion[i]) break;

	        if (localVersion[i] < serveVersion[i]) {
	          if (i === 0) {
	            countCheckVersion++;
	            var opts = {
	              controllerName: 'ReloadDialogController',
	              url: 'app/components/dialog/reload/reload.dialog.html',
	              controllerAlias: 'ctrl',
	              parent: angular.element('#page-body'),
	              clickOutsideToClose: false,
	              escapeToClose: false,
	              hasBackdrop: true
	            };
	            var DialogService = $injector.get('DialogService');
	            DialogService.openDialog(opts);
	          } else {
	            countCheckVersion++;
	            var ToastService = $injector.get('ToastService');
	            ToastService.reload('TOAST.INFO.RELOAD.TITLE', 'TOAST.INFO.RELOAD.TEXT');
	          }
	          break;
	        }
	      }
	    }
	  };

	  return {
	    request: function request(config) {
	      if (config.url.includes(EnvironmentConfig.API)) {
	        if (!internals.checkAuthorization(config)) {
	          return $q.reject({
	            status: 403
	          });
	        }
	        $rootScope.requestLoading = true;
	      }
	      return config;
	    },
	    response: function response(_response) {
	      if (_response.config.url.includes(EnvironmentConfig.API)) {
	        $rootScope.clientStatus = _response.headers('client-status');
	        $rootScope.apiVersion = _response.headers('api-version');
	        $rootScope.requestLoading = false;
	        internals.checkVersion(_response.headers('api-consumer-version'));
	      }
	      if (['PATCH', 'DELETE', 'PUT', 'POST'].includes(_response.config.method) && !_responseErrorConfig2.default.successBlackList.find(function (el) {
	        return _response.config.url.includes(el);
	      })) {
	        var ToastService = $injector.get('ToastService');
	        switch (_response.config.method) {
	          case 'PATCH':
	            ToastService.success('TOAST.SUCCESS.EDIT');
	            break;
	          case 'DELETE':
	            ToastService.success('TOAST.SUCCESS.DELETE');
	            break;
	          case 'PUT':
	            ToastService.success('TOAST.SUCCESS.EDIT');
	            break;
	          case 'POST':
	            ToastService.success('TOAST.SUCCESS.CREATE');
	            break;
	          default:
	            break;
	        }
	      }
	      return _response;
	    },
	    responseError: function responseError(rejection) {
	      internals.checkOldToken(rejection);
	      internals.checkDeactivations(rejection);
	      $rootScope.requestLoading = true;
	      var ToastService = $injector.get('ToastService');
	      if (_responseErrorConfig2.default.errorBlackList.find(function (el) {
	        return rejection.config.url.includes(el);
	      })) return;
	      if (!internals.checkAccessDenied(rejection) && expectedErrors.includes(rejection.status)) {
	        if (rejection.data && rejection.data.suggestedMessage) ToastService.error('' + rejection.data.suggestedMessage, false);else ToastService.error('TOAST.ERROR.SERVER');
	      } else if (internals.isServerError(rejection)) {
	        ToastService.error('TOAST.ERROR.SERVER');
	      }
	      return $q.reject(rejection);
	    }
	  };
	};

	var _responseErrorConfig = __webpack_require__(14);

	var _responseErrorConfig2 = _interopRequireDefault(_responseErrorConfig);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  errorBlackList: [
	  // 'enterprises/public',
	  'configuration/subscriptions', 'tracking', 'vehicles/consult', 'auth/logout'],
	  successBlackList: ['documents/signed-link', 'amazonaws.com/', 'auth/login', 'auth/logout', 'auth/refresh-token', 'auth/access-code', 'v4/trajectories/geom', 'v5/trajectories/geom', 'commands/diagnostic', 'users/check-username', 'devices/check-names']
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	OffLineToast.$inject = ["$window", "ToastService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function OffLineToast($window, ToastService) {
	  'ngInject';

	  $window.addEventListener('offline', function () {
	    ToastService.offLine('TOAST.ERROR.OFFLINE');
	  });

	  $window.addEventListener('online', function () {
	    ToastService.close();
	  });
	}

	exports.default = OffLineToast;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";

	angular.module("phoenix.variables", []).constant("EnvironmentConfig", { "VERSION": "3.33.1", "API": "https://api.app.softruck.com/api", "TRACKING_API": "https://api.tracking.softruck.com", "GEOCODE": "https://geocoder.softruck.com", "INTERCOMKEY": "yoy23wrb", "DOMAIN": "https://app.softruck.com/access/login", "MAPBOX": "pk.eyJ1IjoibWFyY2Vsb3NvZnRydWNrIiwiYSI6ImNqemlxdW55YTAyNmwzbnF0NzU5c3h4aGMifQ.8paId-mJJ636tKpbwS2mhA", "SALT": "prod_softruck_salt", "ENV": "production", "MEDIA": "https://media-api.softruck.com", "ANALYTICS_TRACKER_ID": "UA-156296370-3", "HOTJAR_ID": "5137918", "CLOUD_FRONT_URL": "https://cdn.softruck.com", "SHARING": "https://share.softruck.com", "ROUTE_DOMAIN": ".softruck.com", "FIREBASE": { "apiKey": "AIzaSyC9UESvzqdsqfSSpFHrIRkaUMPk7BMjMqA", "authDomain": "phoenix-notifications.firebaseapp.com", "databaseURL": "https://phoenix-notifications.firebaseio.com", "projectId": "phoenix-notifications", "storageBucket": "phoenix-notifications.appspot.com", "messagingSenderId": "502467249959", "appId": "1:502467249959:web:85d292104a4a4253e1cb02", "vapidKey": "BERuf-xWfG97jY_U_ELITQ-gCR9ydqs8jcyZysE9-Pjaqw_mtjGuhlJchvQhZYLY-4y9nysZQ_bSlL3S4mlgvnI" } });

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _passwordMeter = __webpack_require__(18);

	var _passwordMeter2 = _interopRequireDefault(_passwordMeter);

	__webpack_require__(19);

	__webpack_require__(27);

	__webpack_require__(31);

	__webpack_require__(33);

	__webpack_require__(35);

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access', ['ui.router', 'phoenix.access.signin', 'phoenix.access.forgot', 'phoenix.access.code', 'phoenix.access.reset', 'phoenix.access.external']).directive('passwordMeter', _passwordMeter2.default.directiveFactory).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'access',
	    url: '/access',
	    abstract: true,
	    templateUrl: 'app/access/access.html',
	    resolve: { /* @ngInject */
	      publicEnterprise: ["EnvironmentConfig", "$http", "$location", "$rootScope", "$window", function publicEnterprise(EnvironmentConfig, $http, $location, $rootScope, $window) {
	        var subdomain = $location.host().split('.')[0];
	        if (['app', 'beta', 'release', 'localhost'].includes(subdomain)) {
	          return;
	        }

	        var qs = 'domain=' + subdomain;
	        return $http({
	          url: [EnvironmentConfig.API, _constants.API.V5, _constants.API.ENTERPRISES + '/public?q=' + encodeURIComponent((0, _helper._encodeBase64)(qs))].join('/'),
	          method: 'GET',
	          skipAuthorization: true
	        }).then(function (res) {
	          $rootScope.currentEnterprise = res.data.data;
	          $rootScope.mediaApi = EnvironmentConfig.MEDIA;
	        }).catch(function () {
	          $window.location.href = EnvironmentConfig.DOMAIN;
	        });
	      }]
	    }
	  });
	}]);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PasswordMeter = function () {
	  function PasswordMeter() {
	    _classCallCheck(this, PasswordMeter);

	    this.restrict = 'E';
	    this.template = '<div class="strength-meter">' + '<div class="strength-meter-fill" data-strength="{{strength}}"></div>' + '</div>';
	    this.scope = {
	      password: '=ngModel'
	    };
	  }

	  _createClass(PasswordMeter, [{
	    key: 'link',
	    value: function link(scope) {
	      scope.$watch('password', function (newVal) {
	        // Rules
	        // The string must be eight characters or longer
	        // The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
	        // The string must contain at least 1 numeric character
	        // The string must contain at least 1 uppercase alphabetical character
	        // The string must contain at least 1 lowercase alphabetical character
	        scope.strength = isSatisfied(newVal && /(?=.{8,})/.test(newVal)) + isSatisfied(newVal && /(?=.[!@#\$%\^&])/.test(newVal)) + isSatisfied(newVal && /(?=.*[0-9])/.test(newVal)) + isSatisfied(newVal && /(?=.*[A-Z])/.test(newVal)) + isSatisfied(newVal && /(?=.*[a-z])/.test(newVal));

	        function isSatisfied(criteria) {
	          return criteria ? 1 : 0;
	        }
	      }, true);
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new PasswordMeter();
	    }
	  }]);

	  return PasswordMeter;
	}();

	exports.default = PasswordMeter;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _signin = __webpack_require__(20);

	var _signin2 = _interopRequireDefault(_signin);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access.signin', ['ui.router', 'satellizer']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'signin',
	    url: '/login',
	    parent: 'access',
	    controller: _signin2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/access/signin/signin.html'
	  });
	}]).controller('SigninController', _signin2.default);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SigninController = function () {
	  SigninController.$inject = ["AccessService", "$state"];
	  function SigninController(AccessService, $state) {
	    'ngInject';

	    _classCallCheck(this, SigninController);

	    this.AccessService = AccessService;
	    this.$state = $state;

	    this.attempts = 0;
	    this.user = {
	      keep_connected: false
	    };
	  }

	  _createClass(SigninController, [{
	    key: 'login',
	    value: function login() {
	      var data = {
	        username: this.user.username,
	        password: this.user.password
	      };
	      this.authenticate(data);
	    }
	  }, {
	    key: 'authenticate',
	    value: function authenticate(data) {
	      var _this = this;

	      this.loading = true;
	      this.AccessService.login(data).promise.then(function (res) {
	        var decoded = angular.fromJson((0, _helper._decodeBase64)(res.data.token.split('.')[1]));
	        _this.$state.go('control', { uid: decoded.uid, eid: decoded.eid, cid: decoded.cid, token: res.data.token, refresh: res.data.refresh_token, keep_conn: _this.user.keep_connected });
	      }).catch(function () {
	        _this.loading = false;
	        _this.attempts++;
	        if (_this.attempts > 3) _this.$state.go('forgot');
	      });
	    }
	  }]);

	  return SigninController;
	}();

	exports.default = SigninController;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cleanPayload = cleanPayload;
	exports.cleanBulkPayload = cleanBulkPayload;
	exports._encodeBase64 = _encodeBase64;
	exports._decodeBase64 = _decodeBase64;
	exports.hashify = hashify;
	exports.decodify = decodify;
	exports.validationMaxReportInterval = validationMaxReportInterval;
	exports.finalBiggerInitial = finalBiggerInitial;
	exports.utf8Decode = utf8Decode;
	exports.omit = omit;
	exports.generatePassword = generatePassword;
	exports.calculateItemsPerScreen = calculateItemsPerScreen;

	var _constants = __webpack_require__(9);

	var _hashids = __webpack_require__(26);

	var _hashids2 = _interopRequireDefault(_hashids);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global Buffer */
	function cleanPayload(payload) {
	  var isCreating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var propertyKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'attributes';

	  return Object.keys(payload[propertyKey]).forEach(function (k) {
	    if (isCreating) {
	      if (payload[propertyKey][k] === '' || payload[propertyKey][k] == null) {
	        delete payload[propertyKey][k];
	      }
	    } else {
	      if (payload[propertyKey][k] === null) {
	        delete payload[propertyKey][k];
	      }
	      if (payload[propertyKey][k] === '') {
	        payload[propertyKey][k] = null;
	      }
	    }
	  });
	}

	function cleanBulkPayload(payload) {
	  var isCreating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	  if (!angular.isArray(payload.data)) return;

	  return payload.data.forEach(function (p) {
	    return Object.keys(p.attributes).forEach(function (k) {
	      if (isCreating) {
	        if (p.attributes[k] === '' || p.attributes[k] == null) {
	          delete p.attributes[k];
	        }
	      } else {
	        if (p.attributes[k] === null) {
	          delete p.attributes[k];
	        }
	        if (p.attributes[k] === '') {
	          p.attributes[k] = null;
	        }
	      }
	    });
	  });
	}

	function _encodeBase64(data) {
	  return Buffer.from(data, 'utf8').toString('base64');
	}

	function _decodeBase64(data) {
	  return Buffer.from(data, 'base64').toString('utf8');
	}

	function hashify(salt, id) {
	  if (!angular.isNumber(id)) return id;
	  var hashids = new _hashids2.default(salt, 15);
	  return hashids.encode(id);
	}

	function decodify(salt, id) {
	  if (!angular.isString(id)) return id;
	  var hashids = new _hashids2.default(salt, 15);
	  return hashids.decode(id)[0];
	}

	function validationMaxReportInterval(initial, final) {
	  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'month';

	  if (!initial || !final) return true;

	  var from = moment(initial);
	  var to = moment(final);

	  return to.diff(from, 'seconds') < _constants.INTERVAL_IN_SECONDS[interval];
	}

	function finalBiggerInitial(initial, final) {
	  if (!initial || !final) return true;

	  var from = moment(initial);
	  var to = moment(final);

	  return to.diff(from, 'seconds') >= 0;
	}

	function utf8Decode(utf8String) {
	  if (!angular.isString(utf8String)) return utf8String;

	  /* eslint-disable */
	  var unicodeString = utf8String.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, function (c) {
	    return String.fromCharCode((c.charCodeAt(0) & 0x0f) << 12 | (c.charCodeAt(1) & 0x3f) << 6 | c.charCodeAt(2) & 0x3f);
	  }).replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (c) {
	    return String.fromCharCode((c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f);
	  });
	  /* eslint-enable */
	  return unicodeString;
	}

	function omit(obj, arr) {
	  for (var key in obj) {
	    if (angular.isDefined(obj[key])) {
	      if (arr.includes(key)) {
	        delete obj[key];
	      } else if (angular.isArray(obj[key])) {
	        for (var i = 0; i < obj[key].length; i++) {
	          omit(obj[key][i], arr);
	        }
	      } else if (angular.isObject(obj[key])) {
	        omit(obj[key], arr);
	      }
	    }
	  }
	  return obj;
	}

	function generatePassword() {
	  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
	  var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	  var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	  var lowercase = 'abcdefghijklmnopqrstuvwxyz';
	  var numbers = '0123456789';
	  var symbols = '!@#$%^&*()_+~`|}{[]:;?><,./-=';

	  var characterSets = {
	    uppercase: uppercase,
	    lowercase: lowercase,
	    numbers: numbers,
	    symbols: symbols
	  };

	  var allCharacters = '';
	  if (content.length > 0) {
	    allCharacters = content.map(function (set) {
	      return characterSets[set] || '';
	    }).join('');
	  } else {
	    allCharacters = uppercase + lowercase + numbers + symbols;
	  }

	  var password = '';

	  content.forEach(function (set) {
	    var characters = characterSets[set];
	    if (characters) {
	      password += characters[Math.floor(Math.random() * characters.length)];
	    }
	  });

	  for (var i = password.length; i < length; i++) {
	    password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
	  }

	  password = password.split('').sort(function () {
	    return 0.5 - Math.random();
	  }).join('');

	  return password;
	}

	function calculateItemsPerScreen(layoutSelectors) {
	  var defaultItemCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
	  var defaultItemHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 58;

	  return new Promise(function (resolve, reject) {
	    if (angular.isObject(layoutSelectors) && layoutSelectors.contentSelector && angular.isArray(layoutSelectors.excludedElements)) {
	      setTimeout(function () {
	        // eslint-disable-line
	        var getElementHeight = function getElementHeight(selector) {
	          var element = document.querySelector(selector); // eslint-disable-line
	          return element ? element.clientHeight : 0;
	        };

	        var contentHeight = getElementHeight(layoutSelectors.contentSelector);
	        var excludedHeight = layoutSelectors.excludedElements.reduce(function (acc, ele) {
	          return acc + getElementHeight(ele);
	        }, 0);

	        var minItems = Math.ceil((contentHeight - excludedHeight) / defaultItemHeight);
	        resolve(Math.max(defaultItemCount, minItems));
	      }, 100);
	    } else {
	      reject(new Error('Invalid layoutSelectors object'));
	    }
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22).Buffer))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */

	'use strict'

	var base64 = __webpack_require__(23)
	var ieee754 = __webpack_require__(24)
	var isArray = __webpack_require__(25)

	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()

	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()

	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }

	  return that
	}

	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */

	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}

	Buffer.poolSize = 8192 // not used by this implementation

	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}

	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }

	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }

	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }

	  return fromObject(that, value)
	}

	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}

	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}

	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}

	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}

	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}

	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }

	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }

	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)

	  var actual = that.write(string, encoding)

	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }

	  return that
	}

	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer

	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }

	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }

	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }

	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}

	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)

	    if (that.length === 0) {
	      return that
	    }

	    obj.copy(that, 0, 0, len)
	    return that
	  }

	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }

	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }

	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}

	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}

	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length
	  var y = b.length

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}

	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }

	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }

	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }

	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}

	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }

	  var len = string.length
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength

	function slowToString (encoding, start, end) {
	  var loweredCase = false

	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.

	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }

	  if (end === undefined || end > this.length) {
	    end = this.length
	  }

	  if (end <= 0) {
	    return ''
	  }

	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0

	  if (end <= start) {
	    return ''
	  }

	  if (!encoding) encoding = 'utf8'

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true

	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}

	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}

	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}

	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}

	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}

	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}

	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }

	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }

	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }

	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }

	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0

	  if (this === target) return 0

	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)

	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)

	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1

	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }

	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }

	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }

	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length

	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }

	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }

	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }

	  return -1
	}

	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}

	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}

	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }

	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8'

	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []

	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }

	    res.push(codePoint)
	    i += bytesPerSequence
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}

	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length

	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len

	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end

	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }

	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }

	  if (end < start) end = start

	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }

	  return newBuf
	}

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }

	  return val
	}

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }

	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }

	  return val
	}

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }

	  var len = end - start
	  var i

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }

	  return len
	}

	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }

	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }

	  if (end <= start) {
	    return this
	  }

	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0

	  if (!val) val = 0

	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }

	  return this
	}

	// HELPER FUNCTIONS
	// ================

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []

	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }

	    leadSurrogate = null

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }

	  return byteArray
	}

	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}

	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict'

	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray

	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63

	function getLens (b64) {
	  var len = b64.length

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

	  var curByte = 0

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen

	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }

	  return parts.join('')
	}


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]

	  i += d

	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

	  value = Math.abs(value)

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }

	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== "undefined") {
			factory(module, exports);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod, mod.exports);
			global.Hashids = mod.exports;
		}
	})(this, function (module, exports) {
		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		function _classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		var _createClass = function () {
			function defineProperties(target, props) {
				for (var i = 0; i < props.length; i++) {
					var descriptor = props[i];
					descriptor.enumerable = descriptor.enumerable || false;
					descriptor.configurable = true;
					if ("value" in descriptor) descriptor.writable = true;
					Object.defineProperty(target, descriptor.key, descriptor);
				}
			}

			return function (Constructor, protoProps, staticProps) {
				if (protoProps) defineProperties(Constructor.prototype, protoProps);
				if (staticProps) defineProperties(Constructor, staticProps);
				return Constructor;
			};
		}();

		var Hashids = function () {
			function Hashids() {
				var salt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
				var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
				var alphabet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

				_classCallCheck(this, Hashids);

				var minAlphabetLength = 16;
				var sepDiv = 3.5;
				var guardDiv = 12;

				var errorAlphabetLength = 'error: alphabet must contain at least X unique characters';
				var errorAlphabetSpace = 'error: alphabet cannot contain spaces';

				var uniqueAlphabet = '',
				    sepsLength = void 0,
				    diff = void 0;

				/* funcs */

				this.escapeRegExp = function (s) {
					return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
				};
				this.parseInt = function (v, radix) {
					return (/^(\-|\+)?([0-9]+|Infinity)$/.test(v) ? parseInt(v, radix) : NaN
					);
				};

				/* alphabet vars */

				this.seps = 'cfhistuCFHISTU';
				this.minLength = parseInt(minLength, 10) > 0 ? minLength : 0;
				this.salt = typeof salt === 'string' ? salt : '';

				if (typeof alphabet === 'string') {
					this.alphabet = alphabet;
				}

				for (var i = 0; i !== this.alphabet.length; i++) {
					if (uniqueAlphabet.indexOf(this.alphabet.charAt(i)) === -1) {
						uniqueAlphabet += this.alphabet.charAt(i);
					}
				}

				this.alphabet = uniqueAlphabet;

				if (this.alphabet.length < minAlphabetLength) {
					throw errorAlphabetLength.replace('X', minAlphabetLength);
				}

				if (this.alphabet.search(' ') !== -1) {
					throw errorAlphabetSpace;
				}

				/*
	   	`this.seps` should contain only characters present in `this.alphabet`
	   	`this.alphabet` should not contains `this.seps`
	   */

				for (var _i = 0; _i !== this.seps.length; _i++) {

					var j = this.alphabet.indexOf(this.seps.charAt(_i));
					if (j === -1) {
						this.seps = this.seps.substr(0, _i) + ' ' + this.seps.substr(_i + 1);
					} else {
						this.alphabet = this.alphabet.substr(0, j) + ' ' + this.alphabet.substr(j + 1);
					}
				}

				this.alphabet = this.alphabet.replace(/ /g, '');

				this.seps = this.seps.replace(/ /g, '');
				this.seps = this._shuffle(this.seps, this.salt);

				if (!this.seps.length || this.alphabet.length / this.seps.length > sepDiv) {

					sepsLength = Math.ceil(this.alphabet.length / sepDiv);

					if (sepsLength > this.seps.length) {

						diff = sepsLength - this.seps.length;
						this.seps += this.alphabet.substr(0, diff);
						this.alphabet = this.alphabet.substr(diff);
					}
				}

				this.alphabet = this._shuffle(this.alphabet, this.salt);
				var guardCount = Math.ceil(this.alphabet.length / guardDiv);

				if (this.alphabet.length < 3) {
					this.guards = this.seps.substr(0, guardCount);
					this.seps = this.seps.substr(guardCount);
				} else {
					this.guards = this.alphabet.substr(0, guardCount);
					this.alphabet = this.alphabet.substr(guardCount);
				}
			}

			_createClass(Hashids, [{
				key: 'encode',
				value: function encode() {
					for (var _len = arguments.length, numbers = Array(_len), _key = 0; _key < _len; _key++) {
						numbers[_key] = arguments[_key];
					}

					var ret = '';

					if (!numbers.length) {
						return ret;
					}

					if (numbers[0] && numbers[0].constructor === Array) {
						numbers = numbers[0];
						if (!numbers.length) {
							return ret;
						}
					}

					for (var i = 0; i !== numbers.length; i++) {
						numbers[i] = this.parseInt(numbers[i], 10);
						if (numbers[i] >= 0) {
							continue;
						} else {
							return ret;
						}
					}

					return this._encode(numbers);
				}
			}, {
				key: 'decode',
				value: function decode(id) {

					var ret = [];

					if (!id || !id.length || typeof id !== 'string') {
						return ret;
					}

					return this._decode(id, this.alphabet);
				}
			}, {
				key: 'encodeHex',
				value: function encodeHex(hex) {

					hex = hex.toString();
					if (!/^[0-9a-fA-F]+$/.test(hex)) {
						return '';
					}

					var numbers = hex.match(/[\w\W]{1,12}/g);

					for (var i = 0; i !== numbers.length; i++) {
						numbers[i] = parseInt('1' + numbers[i], 16);
					}

					return this.encode.apply(this, numbers);
				}
			}, {
				key: 'decodeHex',
				value: function decodeHex(id) {

					var ret = [];

					var numbers = this.decode(id);

					for (var i = 0; i !== numbers.length; i++) {
						ret += numbers[i].toString(16).substr(1);
					}

					return ret;
				}
			}, {
				key: '_encode',
				value: function _encode(numbers) {

					var ret = void 0,
					    alphabet = this.alphabet,
					    numbersIdInt = 0;

					for (var i = 0; i !== numbers.length; i++) {
						numbersIdInt += numbers[i] % (i + 100);
					}

					ret = alphabet.charAt(numbersIdInt % alphabet.length);
					var lottery = ret;

					for (var _i2 = 0; _i2 !== numbers.length; _i2++) {

						var number = numbers[_i2];
						var buffer = lottery + this.salt + alphabet;

						alphabet = this._shuffle(alphabet, buffer.substr(0, alphabet.length));
						var last = this._toAlphabet(number, alphabet);

						ret += last;

						if (_i2 + 1 < numbers.length) {
							number %= last.charCodeAt(0) + _i2;
							var sepsIndex = number % this.seps.length;
							ret += this.seps.charAt(sepsIndex);
						}
					}

					if (ret.length < this.minLength) {

						var guardIndex = (numbersIdInt + ret[0].charCodeAt(0)) % this.guards.length;
						var guard = this.guards[guardIndex];

						ret = guard + ret;

						if (ret.length < this.minLength) {

							guardIndex = (numbersIdInt + ret[2].charCodeAt(0)) % this.guards.length;
							guard = this.guards[guardIndex];

							ret += guard;
						}
					}

					var halfLength = parseInt(alphabet.length / 2, 10);
					while (ret.length < this.minLength) {

						alphabet = this._shuffle(alphabet, alphabet);
						ret = alphabet.substr(halfLength) + ret + alphabet.substr(0, halfLength);

						var excess = ret.length - this.minLength;
						if (excess > 0) {
							ret = ret.substr(excess / 2, this.minLength);
						}
					}

					return ret;
				}
			}, {
				key: '_decode',
				value: function _decode(id, alphabet) {

					var ret = [],
					    i = 0,
					    r = new RegExp('[' + this.escapeRegExp(this.guards) + ']', 'g'),
					    idBreakdown = id.replace(r, ' '),
					    idArray = idBreakdown.split(' ');

					if (idArray.length === 3 || idArray.length === 2) {
						i = 1;
					}

					idBreakdown = idArray[i];
					if (typeof idBreakdown[0] !== 'undefined') {

						var lottery = idBreakdown[0];
						idBreakdown = idBreakdown.substr(1);

						r = new RegExp('[' + this.escapeRegExp(this.seps) + ']', 'g');
						idBreakdown = idBreakdown.replace(r, ' ');
						idArray = idBreakdown.split(' ');

						for (var j = 0; j !== idArray.length; j++) {

							var subId = idArray[j];
							var buffer = lottery + this.salt + alphabet;

							alphabet = this._shuffle(alphabet, buffer.substr(0, alphabet.length));
							ret.push(this._fromAlphabet(subId, alphabet));
						}

						if (this._encode(ret) !== id) {
							ret = [];
						}
					}

					return ret;
				}
			}, {
				key: '_shuffle',
				value: function _shuffle(alphabet, salt) {

					var integer = void 0;

					if (!salt.length) {
						return alphabet;
					}

					alphabet = alphabet.split("");

					for (var i = alphabet.length - 1, v = 0, p = 0, j = 0; i > 0; i--, v++) {

						v %= salt.length;
						p += integer = salt.charCodeAt(v);
						j = (integer + v + p) % i;

						var tmp = alphabet[j];
						alphabet[j] = alphabet[i];
						alphabet[i] = tmp;
					}

					alphabet = alphabet.join("");

					return alphabet;
				}
			}, {
				key: '_toAlphabet',
				value: function _toAlphabet(input, alphabet) {

					var id = '';

					do {
						id = alphabet.charAt(input % alphabet.length) + id;
						input = parseInt(input / alphabet.length, 10);
					} while (input);

					return id;
				}
			}, {
				key: '_fromAlphabet',
				value: function _fromAlphabet(input, alphabet) {

					return input.split("").map(function (item) {
						return alphabet.indexOf(item);
					}).reduce(function (carry, item) {
						return carry * alphabet.length + item;
					}, 0);
				}
			}]);

			return Hashids;
		}();

		exports.default = Hashids;
		module.exports = exports['default'];
	});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _forgot = __webpack_require__(28);

	var _forgot2 = _interopRequireDefault(_forgot);

	var _access = __webpack_require__(29);

	var _access2 = _interopRequireDefault(_access);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access.forgot', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'forgot',
	    url: '/forgot-password',
	    parent: 'access',
	    controller: _forgot2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/access/forgot/forgot.html'
	  });
	}]).controller('ForgotController', _forgot2.default).service('AccessService', _access2.default);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ForgotController = function () {
	  ForgotController.$inject = ["$http", "$q", "$state", "EnvironmentConfig"];
	  function ForgotController($http, $q, $state, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, ForgotController);

	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(ForgotController, [{
	    key: 'sendPassword',
	    value: function sendPassword() {
	      var _this = this;

	      this.loading = true;

	      var obj = {
	        data: {
	          attributes: {
	            username: this.user.username
	          }
	        }
	      };

	      return this.$http({
	        url: this.EnvironmentConfig.API + '/' + _constants.API.V5 + '/' + _constants.API.USERS + '/forgot-password',
	        method: 'POST',
	        data: obj,
	        skipAuthorization: true
	      }).then(function () {
	        _this.loading = false;
	        _this.$state.go('signin');
	      }).catch(function (error) {
	        return _this.$q.reject(error);
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }]);

	  return ForgotController;
	}();

	exports.default = ForgotController;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AccessService = function () {
	  AccessService.$inject = ["$http", "$q", "$window", "DialogService", "EnvironmentConfig"];
	  function AccessService($http, $q, $window, DialogService, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, AccessService);

	    this.$http = $http;
	    this.$q = $q;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(AccessService, [{
	    key: 'login',
	    value: function login(data) {
	      var deferred = this.$q.defer();
	      this.$http({
	        url: [this.EnvironmentConfig.API, _constants.API.V5, 'auth', 'login'].join('/'),
	        method: 'POST',
	        data: data,
	        skipAuthorization: true
	      }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'refreshToken',
	    value: function refreshToken() {
	      var _this = this;

	      var data = {
	        refresh_token: this.$window.localStorage.getItem('refresh_token'),
	        auth_token: this.$window.localStorage.getItem('token')
	      };
	      var custom = { escapeToClose: false };
	      var opts = Object.assign(_dialog.DIALOG._opts(_dialog.DIALOG.UPDATING.path, _dialog.DIALOG.UPDATING.ctrl), custom);

	      this.DialogService.openDialog(opts);
	      this.$window.localStorage.setItem('authenticating_token', true);

	      return this.$http({
	        url: this.EnvironmentConfig.API + '/' + _constants.API.V5 + '/auth/refresh-token',
	        method: 'POST',
	        data: data
	      }).then(function (res) {
	        _this.$window.localStorage.setItem('token', res.data.data.token);
	        _this.$window.localStorage.setItem('refresh_token', res.data.data.refresh_token);
	        _this.$window.localStorage.removeItem('authenticating_token');
	      }).catch(function (error) {
	        return _this.$q.reject(error);
	      });
	    }
	  }, {
	    key: 'generateAccessCode',
	    value: function generateAccessCode(data) {
	      var deferred = this.$q.defer();

	      this.$http({
	        url: this.EnvironmentConfig.API + '/' + _constants.API.V5 + '/' + _constants.API.USERS + '/generate-access-code',
	        method: 'POST',
	        data: data,
	        skipAuthorization: true
	      }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'loginByCode',
	    value: function loginByCode(data) {
	      var deferred = this.$q.defer();

	      this.$http({
	        url: this.EnvironmentConfig.API + '/' + _constants.API.V5 + '/' + _constants.API.AUTH + '/access-code',
	        method: 'POST',
	        data: data,
	        skipAuthorization: true
	      }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return AccessService;
	}();

	exports.default = AccessService;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DIALOG = exports.DIALOG = {
	  ALERT_FILTER: {
	    path: 'app/internal/monitoring/center/components/alerts-filter/alerts-filter.html',
	    ctrl: 'AlertsFilterController'
	  },
	  STRONG_CONFIRMATION_ACTION: {
	    path: 'app/components/dialog/strong-confirmation/strong-confirmation.dialog.html',
	    ctrl: 'StrongConfirmationDialogController'
	  },
	  CONFIRMATION_ACTION: {
	    path: 'app/components/dialog/confirmation/confirmation.dialog.html',
	    ctrl: 'ConfirmationDialogController'
	  },
	  CREATE_EVENT: {
	    path: 'app/internal/monitoring/center/components/create-events/create-events.dialog.html',
	    ctrl: 'CreateEventsController'
	  },
	  ALERT_DETAILS: {
	    path: 'app/internal/monitoring/center/components/alerts-details/alerts-details.dialog.html',
	    ctrl: 'AlertsDetailsController'
	  },
	  EVENT_DETAILS: {
	    path: 'app/internal/monitoring/center/components/events-details/events-details.dialog.html',
	    ctrl: 'EventsDetailsController'
	  },
	  TASK_ACKNOWLEDGEMENTS_ACTION: {
	    path: 'app/components/task/acknowledgements/acknowledgements.dialog.html',
	    ctrl: 'TaskAcknowledgementsController'
	  },
	  TASK_COMPLETE_DATE: {
	    path: 'app/components/task/complete-date/complete-date.dialog.html',
	    ctrl: 'TaskCompleteDateController'
	  },
	  TASK_EXPENSES_ACTION: {
	    path: 'app/components/task/expenses/expenses.dialog.html',
	    ctrl: 'TaskExpensesController'
	  },
	  TASK_LOCATIONS_ACTION: {
	    path: 'app/components/task/locations/locations.dialog.html',
	    ctrl: 'TaskLocationsController'
	  },
	  TASK_CUSTOM_FIELDS: {
	    path: 'app/components/task/custom-fields/custom-fields.dialog.html',
	    ctrl: 'TaskCustomFieldsController'
	  },
	  TASK_TEMPLATE_ITEM: {
	    path: 'app/components/task/template-items/template-items.dialog.html',
	    ctrl: 'TaskTemplateItemsController'
	  },
	  TASK_SETTINGS: {
	    path: 'app/components/task/settings/settings.dialog.html',
	    ctrl: 'TaskSettingsController'
	  },
	  TASK_SHARINGS: {
	    path: 'app/components/task/sharings/sharings.dialog.html',
	    ctrl: 'TaskSharingController'
	  },
	  UPDATING: {
	    path: 'app/components/dialog/updating/updating.dialog.html',
	    ctrl: 'UpdatingDialogController'
	  },
	  _opts: function _opts(path, controller) {
	    return {
	      url: path,
	      controllerName: controller,
	      controllerAlias: 'ctrl',
	      bindToController: true,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      hasBackdrop: true,
	      parent: angular.element('#page-body')
	    };
	  }
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _code = __webpack_require__(32);

	var _code2 = _interopRequireDefault(_code);

	var _access = __webpack_require__(29);

	var _access2 = _interopRequireDefault(_access);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access.code', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'code',
	    url: '/code-password',
	    parent: 'access',
	    controller: _code2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/access/code/code.html'
	  });
	}]).controller('CodeController', _code2.default).service('AccessService', _access2.default);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CodeController = function () {
	  CodeController.$inject = ["$document", "$interval", "$scope", "$state", "$timeout", "AccessService"];
	  function CodeController($document, $interval, $scope, $state, $timeout, AccessService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, CodeController);

	    this.$document = $document;
	    this.$interval = $interval;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.AccessService = AccessService;

	    this.step = 1;
	    this.user = {
	      code: []
	    };

	    this.$scope.$on('$destroy', function () {
	      _this.stopTheCount();
	    });
	  }

	  _createClass(CodeController, [{
	    key: 'generateCode',
	    value: function generateCode() {
	      var _this2 = this;

	      this.loading = true;

	      if (this.actionType === 'send') {
	        var obj = {
	          data: {
	            attributes: {
	              username: this.user.username
	            }
	          }
	        };

	        this.AccessService.generateAccessCode(obj).promise.then(function () {
	          _this2.goToStep3();
	        }).finally(function () {
	          _this2.loading = false;
	        });
	      } else {
	        this.goToStep3();
	        this.loading = false;
	      }
	    }
	  }, {
	    key: 'authenticate',
	    value: function authenticate() {
	      var _this3 = this;

	      this.loading = true;

	      var obj = {
	        username: this.user.username,
	        code: this.user.code.join('')
	      };

	      this.AccessService.loginByCode(obj).promise.then(function (res) {
	        var decoded = angular.fromJson((0, _helper._decodeBase64)(res.data.token.split('.')[1]));
	        _this3.$state.go('control', { uid: decoded.uid, eid: decoded.eid, cid: decoded.cid, token: res.data.token, refresh: res.data.refresh_token, keep_conn: _this3.user.keep_connected });
	      }).catch(function () {
	        _this3.invalidCode = true;
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'startTheCount',
	    value: function startTheCount() {
	      var _this4 = this;

	      this.count = _initial.count();
	      this.timer = this.$interval(function () {
	        if (_this4.count > 0) {
	          _this4.count--;
	        } else {
	          _this4.stopTheCount();
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'stopTheCount',
	    value: function stopTheCount() {
	      if (!this.timer) return;
	      this.$interval.cancel(this.timer);
	      this.timer = null;
	    }
	  }, {
	    key: 'goToStep3',
	    value: function goToStep3() {
	      var _this5 = this;

	      this.step = 3;
	      this.form.$setPristine();
	      this.$timeout(function () {
	        _this5.$document[0].querySelector('[name="code_0"]').focus();
	        if (_this5.actionType === 'send') {
	          _this5.startTheCount();
	        }
	      }, 100);
	    }
	  }, {
	    key: 'backStep',
	    value: function backStep() {
	      if (this.step === 3) {
	        this.invalidCode = false;
	        this.user.code = [];

	        if (this.actionType === 'send') {
	          this.stopTheCount();
	        }
	      }
	      this.step--;
	    }
	  }, {
	    key: 'moveFocus',
	    value: function moveFocus(event, index) {
	      var _this6 = this;

	      var html = this.$document[0];
	      var input = event.target;
	      var nextInput = html.querySelector('[name="code_' + (index + 1) + '"]');
	      var prevInput = html.querySelector('[name="code_' + (index - 1) + '"]');
	      this.invalidCode = false;

	      if (event.type === 'paste' && index === 0) {
	        var clipboardData = event.originalEvent.clipboardData;
	        var pastedData = clipboardData.getData('text/plain');

	        if (/^\d{6}$/.test(pastedData)) {
	          pastedData.split('').forEach(function (letter, i) {
	            var field = html.querySelector('[name="code_' + i + '"]');
	            if (field) {
	              field.value = letter;
	              _this6.user.code[i] = letter;
	            }
	          });
	          html.querySelector('[name="code_5"]').focus();
	          event.preventDefault();
	          return;
	        }
	      }

	      if (input.value && nextInput) {
	        nextInput.focus();
	      }

	      if (event.key === 'Backspace' && !input.value && prevInput) {
	        prevInput.focus();
	      }
	    }
	  }]);

	  return CodeController;
	}();

	exports.default = CodeController;


	var _initial = {
	  count: function count() {
	    return 59;
	  }
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _reset = __webpack_require__(34);

	var _reset2 = _interopRequireDefault(_reset);

	var _access = __webpack_require__(29);

	var _access2 = _interopRequireDefault(_access);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access.reset', ['ui.router', 'satellizer']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'reset',
	    url: '/reset-password/:token',
	    parent: 'access',
	    controller: _reset2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/access/reset/reset.html',
	    params: {
	      token: { dynamic: true }
	    }
	  });
	}]).controller('ResetController', _reset2.default).service('AccessService', _access2.default);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ResetController = function () {
	  ResetController.$inject = ["$http", "$state", "EnvironmentConfig"];
	  function ResetController($http, $state, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, ResetController);

	    this.$http = $http;
	    this.$state = $state;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(ResetController, [{
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this = this;

	      if (this.user.password !== this.user.confirm_password) return;
	      this.loading = true;

	      var obj = {
	        data: {
	          attributes: {
	            password: this.user.password,
	            confirm_password: this.user.confirm_password
	          }
	        }
	      };

	      return this.$http({
	        url: this.EnvironmentConfig.API + '/' + _constants.API.V5 + '/' + _constants.API.USERS + '/forgot-password/' + this.$state.params.token,
	        method: 'PATCH',
	        data: obj,
	        skipAuthorization: true
	      }).then(function () {
	        _this.$state.go('signin');
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }]);

	  return ResetController;
	}();

	exports.default = ResetController;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _external = __webpack_require__(36);

	var _external2 = _interopRequireDefault(_external);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.access.external', ['ui.router', 'satellizer']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'external',
	    url: '/external?token',
	    parent: 'access',
	    controller: _external2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/access/external/external.html',
	    params: {
	      token: { dynamic: true }
	    }
	  });
	}]).controller('ExternalLoginController', _external2.default);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ExternalLoginController = function () {
	  ExternalLoginController.$inject = ["$state", "$timeout", "EnvironmentConfig"];
	  function ExternalLoginController($state, $timeout, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, ExternalLoginController);

	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.authenticate();
	  }

	  _createClass(ExternalLoginController, [{
	    key: 'authenticate',
	    value: function authenticate() {
	      var _this = this;

	      this.loading = true;
	      this.$timeout(function () {
	        var token = _this.$state.params.token;

	        var decoded = angular.fromJson((0, _helper._decodeBase64)(token.split('.')[1]));
	        var uid = decoded.uid;
	        var eid = decoded.eid;
	        _this.$state.go('control', { uid: uid, eid: eid, token: token });
	        _this.loading = false;
	      }, 300);
	    }
	  }]);

	  return ExternalLoginController;
	}();

	exports.default = ExternalLoginController;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _main = __webpack_require__(38);

	var _main2 = _interopRequireDefault(_main);

	var _internalChat = __webpack_require__(39);

	var _internalChat2 = _interopRequireDefault(_internalChat);

	__webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.control', ['ui.router', 'phoenix.internal']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'control',
	    url: '/control',
	    params: {
	      cid: null,
	      eid: null,
	      uid: null,
	      token: null,
	      refresh: null,
	      keep_conn: null
	    },
	    resolve: { /* @ngInject */
	      auth: ["$window", "$stateParams", function auth($window, $stateParams) {
	        var token = $window.localStorage.getItem('token');
	        if (token && token === $stateParams.token || $stateParams.token == null) {
	          return;
	        }
	        $window.localStorage.setItem('token', $stateParams.token);

	        var refreshToken = $window.localStorage.getItem('refresh_token');
	        if (refreshToken && refreshToken === $stateParams.refresh || $stateParams.refresh == null) {
	          return;
	        }
	        $window.localStorage.setItem('refresh_token', $stateParams.refresh);

	        if ($stateParams.keep_conn == null) {
	          return;
	        }
	        $window.localStorage.setItem('keep_conn', $stateParams.keep_conn);
	      }],
	      user: ["MainService", "$state", "$stateParams", "$window", function user(MainService, $state, $stateParams, $window) {
	        var user = $window.localStorage.getItem('user');
	        if (user && user.uid === $stateParams.uid) {
	          return;
	        }
	        if ($stateParams.uid == null || $stateParams.token == null) {
	          return;
	        }
	        var obj = {
	          attributes: ['name', 'username', 'locale', 'phone1', 'phone2', 'email', 'emergency_contact', 'emergency_phone', 'cpf', 'document_number', 'created_at', 'updated_at'],
	          includes: {
	            addresses: ['*'],
	            roles: ['name'],
	            document: ['file_size', 'created_at', 'folder', 'key_name', 'mime', 'name']
	          }
	        };
	        return MainService.raw(_constants.API.V5, _constants.API.USERS + '/' + $stateParams.uid, obj).promise.catch(function () {
	          $window.localStorage.clear();
	          $state.go('signin');
	        });
	      }],
	      enterprise: ["MainService", "$stateParams", "$window", function enterprise(MainService, $stateParams, $window) {
	        var enterprise = $window.localStorage.getItem('enterprise');
	        if (enterprise && enterprise.eid === $stateParams.eid) {
	          return;
	        }
	        if ($stateParams.eid == null || $stateParams.token == null) {
	          return;
	        }
	        var obj = {
	          attributes: ['name', 'phone1', 'phone2', 'email', 'cnpj', 'timezone', 'main_client', 'support'],
	          includes: {
	            addresses: ['*'],
	            country: ['*'],
	            document: ['file_size', 'created_at', 'folder', 'key_name', 'mime', 'name']
	          }
	        };
	        return MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + $stateParams.eid, obj).promise;
	      }]
	    },
	    onEnter: ["user", "enterprise", "$q", "$state", "$timeout", "$window", "GeoLocation", "InternalChatService", function onEnter(user, enterprise, $q, $state, $timeout, $window, GeoLocation, InternalChatService) {
	      $q.all([user, enterprise]).then(function (res) {
	        var token = $window.localStorage.getItem('token');
	        if (user && enterprise && token) {
	          $window.localStorage.setItem('user', angular.toJson(res[0].data));
	          $window.localStorage.setItem('enterprise', angular.toJson(res[1].data));
	          $window.localStorage.setItem('role', res[0].data.relationships.roles[0].attributes.name);
	          InternalChatService.chatEvent('boot');
	        }
	      }).finally(function () {
	        $timeout(function () {
	          var role = $window.localStorage.getItem('role');
	          switch (role) {
	            case 'REGULAR':
	            case 'OWNER':
	              $state.go('vehicles-list');
	              break;
	            case 'CALLCENTER':
	              $state.go('protocols-list');
	              break;
	            case 'PROVIDER':
	              $state.go('service-orders-list');
	              break;
	            case null:
	              $window.localStorage.clear();
	              $state.go('signin');
	              break;
	            default:
	              $state.go('dashboard');
	              break;
	          }
	        }, 100);
	        GeoLocation.getCoords();
	      });
	    }]
	  });
	}]).service('MainService', _main2.default).service('InternalChatService', _internalChat2.default);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MainService = function () {
	  MainService.$inject = ["$http", "$q", "EnvironmentConfig", "HttpService"];
	  function MainService($http, $q, EnvironmentConfig, HttpService) {
	    'ngInject';

	    _classCallCheck(this, MainService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.HttpService = HttpService;
	  }

	  _createClass(MainService, [{
	    key: 'export',
	    value: function _export(version, model, obj) {
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, version, model].join('/');

	      if (obj && obj.search) {
	        query.push(this._buildSearchableParam(obj.search));
	      }
	      if (obj && obj.filters) {
	        query.push(this._buildFilterParams(obj.filters));
	      }
	      if (obj && obj.sort) {
	        query.push(this._buildSortParams(obj.sort));
	      }
	      if (obj && obj.locale) {
	        query.push('locale=' + obj.locale);
	      }
	      if (obj && obj.format) {
	        query.push('format=' + obj.format);
	      }
	      if (obj && obj.filename) {
	        query.push('filename=' + obj.filename);
	      }
	      if (obj && obj.desired) {
	        query.push(this._buildDesiredParams(obj.desired));
	      }

	      if (obj) {
	        url = url + ('?q=' + encodeURIComponent((0, _helper._encodeBase64)(query.join('&'))));
	      }

	      this.HttpService.createCancelableRequest({ url: url, method: 'GET', responseType: 'blob' }).then(function (res) {
	        if (res && angular.isDefined(res.data)) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'raw',
	    value: function raw(version, model, obj) {
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, version, model].join('/');

	      if (obj && obj.count) {
	        query.push(this._buildCountParam(obj.count));
	      }
	      if (obj && obj.page) {
	        query.push(this._buildPageParam(obj.page));
	      }
	      if (obj && obj.limit) {
	        query.push(this._buildLimitParam(obj.limit));
	      }
	      if (obj && obj.search) {
	        query.push(this._buildSearchableParam(obj.search));
	      }
	      if (obj && obj.attributes) {
	        query.push(this._buildAttributesParams(obj.attributes));
	      }
	      if (obj && obj.includes) {
	        query.push(this._buildIncludeParams(obj.includes));
	      }
	      if (obj && obj.filters) {
	        query.push(this._buildFilterParams(obj.filters));
	      }
	      if (obj && obj.sort) {
	        query.push(this._buildSortParams(obj.sort));
	      }
	      if (obj && obj.any) {
	        query.push(this._buildAnyParams(obj.any));
	      }

	      if (obj) {
	        url = url + ('?q=' + encodeURIComponent((0, _helper._encodeBase64)(query.join('&'))));
	      }

	      this.HttpService.createCancelableRequest({ url: url, method: 'GET', headers: { 'api-consumer-version': 'front_phoenix-web' } }).then(function (res) {
	        if (res && angular.isDefined(res.data)) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'show',
	    value: function show(version, model, identifier) {
	      var deferred = this.$q.defer();
	      this.HttpService.createCancelableRequest({ url: [this.EnvironmentConfig.API, version, model, identifier].join('/'), method: 'GET', headers: { 'api-consumer-version': 'front_phoenix-web' } }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'update',
	    value: function update(version, model, identifier, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, identifier].join('/'), method: 'PATCH', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'create',
	    value: function create(version, model, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model].join('/'), method: 'POST', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'edit',
	    value: function edit(version, model, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model].join('/'), method: 'PATCH', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'deleteMany',
	    value: function deleteMany(version, model, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model].join('/'), method: 'DELETE', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(version, model, identifier) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, identifier].join('/'), method: 'DELETE' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: '_buildDesiredParams',
	    value: function _buildDesiredParams(params) {
	      var desired = [];
	      params.map(function (i) {
	        return desired.push(i.a);
	      });
	      return 'desired=' + desired;
	    }
	  }, {
	    key: '_buildCountParam',
	    value: function _buildCountParam(params) {
	      return 'count=' + params;
	    }
	  }, {
	    key: '_buildPageParam',
	    value: function _buildPageParam(params) {
	      return 'page=' + params;
	    }
	  }, {
	    key: '_buildLimitParam',
	    value: function _buildLimitParam(params) {
	      return 'limit=' + params;
	    }
	  }, {
	    key: '_buildSearchableParam',
	    value: function _buildSearchableParam(params) {
	      return 'search=' + params.replace(/&/g, '%26').replace(/\?/g, '').replace(/'/g, '').replace(/--/g, '').replace(/=/g, '').replace(/\/\//g, '');
	    }
	  }, {
	    key: '_buildAttributesParams',
	    value: function _buildAttributesParams(params) {
	      return 'attributes=' + params.join(',');
	    }
	  }, {
	    key: '_buildAnyParams',
	    value: function _buildAnyParams(params) {
	      var many = [];
	      for (var key in params) {
	        many.push(key + '=' + params[key].value);
	      }

	      return many.join('&');
	    }
	  }, {
	    key: '_buildFilterParams',
	    value: function _buildFilterParams(params) {
	      var filters = [];
	      for (var key in params) {
	        if (angular.isArray(params[key])) {
	          for (var index in params[key]) {
	            filters.push('filters[' + key + '][' + params[key][index].operator + '][' + index + ']=' + params[key][index].value);
	          }
	        } else {
	          filters.push('filters[' + key + '][' + params[key].operator + ']=' + params[key].value);
	        }
	      }

	      return filters.join('&');
	    }
	  }, {
	    key: '_buildIncludeParams',
	    value: function _buildIncludeParams(params) {
	      var includes = [];
	      for (var item in params) {
	        includes.push('includes[' + item + ']=' + params[item].join(','));
	      }

	      return includes.join('&');
	    }
	  }, {
	    key: '_buildSortParams',
	    value: function _buildSortParams(params) {
	      return 'sort[' + params.prop + ']=' + (params.order === 'ASC' ? '1' : '-1');
	    }
	  }]);

	  return MainService;
	}();

	exports.default = MainService;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var InternalChatService = function () {
	  InternalChatService.$inject = ["EnvironmentConfig", "$rootScope", "$state", "$window"];
	  function InternalChatService(EnvironmentConfig, $rootScope, $state, $window) {
	    'ngInject';

	    _classCallCheck(this, InternalChatService);

	    this.EnvironmentConfig = EnvironmentConfig;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$window = $window;
	  }

	  _createClass(InternalChatService, [{
	    key: '_setChatPolicy',
	    value: function _setChatPolicy() {
	      return {
	        app_id: this.EnvironmentConfig.INTERCOMKEY,
	        user_id: this.user.id,
	        user_uuid: this.user.uuid,
	        name: this.user.attributes.username,
	        email: this.user.attributes.email,
	        phone: this.user.attributes.phone1,
	        role: this.role,
	        created_at: this.user.attributes.created_at,
	        updated_at: this.user.attributes.updated_at,
	        enterprise: this.enterprise.attributes.name,
	        company_name: this.enterprise.attributes.name,
	        client_status: this.$rootScope.clientStatus,
	        api_version: this.$rootScope.apiVersion,
	        app_name: this.$window.location.host.split('.')[0] || 'app'
	      };
	    }

	    // options: update & boot

	  }, {
	    key: 'chatEvent',
	    value: function chatEvent(key) {
	      this.user = angular.fromJson(this.$window.localStorage.getItem('user'));
	      this.enterprise = this.enterprise || angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      this.role = this.role || this.$window.localStorage.getItem('role');

	      if (_constants.ROLES.MANAGER.includes(this.role) && this.enterprise.attributes.support) {
	        this.$window.Intercom(key, this._setChatPolicy());
	      }
	    }
	  }, {
	    key: 'closeChatEvent',
	    value: function closeChatEvent() {
	      this.$window.Intercom('shutdown');
	    }
	  }]);

	  return InternalChatService;
	}();

	exports.default = InternalChatService;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _internal = __webpack_require__(41);

	var _internal2 = _interopRequireDefault(_internal);

	__webpack_require__(42);

	__webpack_require__(69);

	__webpack_require__(111);

	__webpack_require__(157);

	__webpack_require__(187);

	__webpack_require__(239);

	__webpack_require__(244);

	__webpack_require__(248);

	__webpack_require__(252);

	__webpack_require__(299);

	__webpack_require__(309);

	__webpack_require__(321);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.internal', ['ui.router', 'phoenix.directives', 'phoenix.filters', 'phoenix.services', 'phoenix.controller', 'phoenix.internal.fleet', 'phoenix.internal.management', 'phoenix.internal.monitoring', 'phoenix.internal.operational', 'phoenix.internal.organization', 'phoenix.internal.reports', 'phoenix.internal.audit', 'phoenix.internal.settings', 'md.data.table', 'datetime', 'daterangepicker', 'ngFileUpload', 'ui.tinymce', __webpack_require__(338), 'angular-sortable-view', 'idf.br-filters', 'ngclipboard']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'internal',
	    abstract: true,
	    templateUrl: 'app/internal/internal.html',
	    alias: 'internal',
	    controller: _internal2.default,
	    controllerAs: 'ctrl'
	  });
	}]).controller('InternalController', _internal2.default);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var InternalController = function () {
	  InternalController.$inject = ["$scope", "$translate", "$window", "DialogService", "FirebaseMessagingService"];
	  function InternalController($scope, $translate, $window, DialogService, FirebaseMessagingService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, InternalController);

	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.FirebaseMessagingService = FirebaseMessagingService;

	    this.FirebaseMessagingService.initializeApp();

	    this.$scope.$on('$locationChangeStart', function () {
	      _this.DialogService.closeDialog();
	    });

	    this.$scope.checkScroll = function () {
	      _this.$scope.$broadcast('scrollEvent');
	    };

	    this.setLanguageDefault();
	    this.saveTokenWhenOut();
	    this.checkTokenWhenReturn();
	  }

	  _createClass(InternalController, [{
	    key: 'setLanguageDefault',
	    value: function setLanguageDefault() {
	      var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	      this.$translate.use(user.attributes.locale);
	    }
	  }, {
	    key: 'saveTokenWhenOut',
	    value: function saveTokenWhenOut() {
	      var _this2 = this;

	      angular.element(this.$window).on('blur', function () {
	        _this2.$scope.lastToken = _this2.$window.localStorage.getItem('token');
	      });
	    }
	  }, {
	    key: 'checkTokenWhenReturn',
	    value: function checkTokenWhenReturn() {
	      var _this3 = this;

	      angular.element(this.$window).on('focus', function () {
	        var currentToken = _this3.$window.localStorage.getItem('token');
	        var authentication = !!_this3.$window.localStorage.getItem('authenticating_token');

	        if (_this3.$scope.lastToken && _this3.$scope.lastToken !== currentToken) {
	          _this3.$window.location.reload();
	        }

	        if (authentication) {
	          var custom = { escapeToClose: false };
	          var opts = Object.assign(_dialog.DIALOG._opts(_dialog.DIALOG.UPDATING.path, _dialog.DIALOG.UPDATING.ctrl), custom);
	          _this3.DialogService.openDialog(opts);
	        }
	      });
	    }
	  }]);

	  return InternalController;
	}();

	exports.default = InternalController;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(43);

	__webpack_require__(49);

	__webpack_require__(65);

	angular.module('phoenix.internal.fleet', ['ui.router', 'phoenix.internal.fleet.fuels', 'phoenix.internal.fleet.trips', 'phoenix.internal.fleet.identifications']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'fleet',
	    url: '/fleet',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _fuelsList = __webpack_require__(44);

	var _fuelsList2 = _interopRequireDefault(_fuelsList);

	var _fuelsCreate = __webpack_require__(47);

	var _fuelsCreate2 = _interopRequireDefault(_fuelsCreate);

	var _fuels = __webpack_require__(48);

	var _fuels2 = _interopRequireDefault(_fuels);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.fleet.fuels', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'fuels-list',
	    url: '/fuels/list?search?predicates',
	    parent: 'fleet',
	    menu: true,
	    alias: 'fuels',
	    controller: _fuelsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/fuels/list/fuels.list.html',
	    params: {
	      search: { dynamic: true },
	      predicates: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'fuels-create',
	    url: '/fuels/create',
	    parent: 'fleet',
	    controller: _fuelsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/fuels/create/fuels.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'fuels-edit',
	    url: '/fuels/edit/:id',
	    parent: 'fleet',
	    controller: _fuelsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/fuels/create/fuels.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('FuelsListController', _fuelsList2.default).controller('FuelsCreateController', _fuelsCreate2.default).service('FuelsService', _fuels2.default);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _baseList = __webpack_require__(45);

	var _baseList2 = _interopRequireDefault(_baseList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FuelsListController = function (_BaseListController) {
	  FuelsListController.$inject = ["$state", "$scope", "$translate", "GenericService"];
	  _inherits(FuelsListController, _BaseListController);

	  function FuelsListController($state, $scope, $translate, GenericService) {
	    'ngInject';

	    _classCallCheck(this, FuelsListController);

	    var _this = _possibleConstructorReturn(this, (FuelsListController.__proto__ || Object.getPrototypeOf(FuelsListController)).call(this, $scope, GenericService));

	    _this.$state = $state;
	    _this.$translate = $translate;

	    var query = {
	      limit: 15,
	      page: 1,
	      search: _this.$state.params.search,
	      order: { prop: 'code', order: 'ASC' },
	      predicates: _this.$state.params.predicates
	    };

	    _this.options = {
	      new: 'screen',
	      export: true,
	      stats: false
	    };

	    _this.setProps(_constants.API.V1, _constants.API.FUELS, query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(FuelsListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.PLATE_CODE', 'PANEL.HEADER.ODOMETER_DATE', 'PANEL.HEADER.TOTAL_FUEL', 'PANEL.HEADER.PRICE_UNITY'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.PLATE_CODE'],
	          sort: true,
	          prop: 'vehicle.plate'
	        }, {
	          label: t['PANEL.HEADER.ODOMETER_DATE'],
	          sort: true,
	          prop: 'fueled_odometer'
	        }, {
	          label: t['PANEL.HEADER.TOTAL_FUEL'],
	          sort: true,
	          prop: 'total_amount'
	        }, {
	          label: t['PANEL.HEADER.PRICE_UNITY'],
	          sort: true,
	          prop: 'total_price'
	        }];
	      });
	    }
	  }]);

	  return FuelsListController;
	}(_baseList2.default);

	exports.default = FuelsListController;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _fileSaver = __webpack_require__(46);

	var _fileSaver2 = _interopRequireDefault(_fileSaver);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BaseListController = function () {
	  BaseListController.$inject = ["$scope", "GenericService", "$window", "$document", "$translate"];
	  function BaseListController($scope, GenericService, $window, $document, $translate) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, BaseListController);

	    this.$scope = $scope;
	    this.GenericService = GenericService;
	    this.$window = $window;
	    this.$document = $document;
	    this.$translate = $translate;

	    this.day = 0;
	    this.items = [];
	    this.filters = [];
	    var watchNavbar = this.$scope.$on('scrollEvent', function () {
	      _this.loadMore();
	    });

	    this.$scope.$on('$destroy', watchNavbar);
	    this.$scope.$on('order', function (ev, data) {
	      _this.order(data);
	    });
	    this.$scope.$on('export', function (ev, data) {
	      _this.export(data);
	    });
	    this.$scope.$on('searchList', function (ev, data) {
	      _this.search(data);
	    });
	  }

	  _createClass(BaseListController, [{
	    key: 'setProps',
	    value: function setProps(version, model, obj, sort) {
	      var hasActivation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	      var _this2 = this;

	      var hasFilterFields = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	      var onLoad = arguments[6];

	      this.loading = true;
	      var objFormatted = obj;
	      var layout = {
	        contentSelector: '#content',
	        excludedElements: ['#navbar-wrapper', '.st-filter-bar']
	      };

	      (0, _helper.calculateItemsPerScreen)(layout).then(function (res) {
	        objFormatted.limit = res;
	      }).finally(function () {
	        _this2.loading = false;
	        _this2.version = version;
	        _this2.model = model;
	        _this2.query = obj;
	        _this2.sort = sort;
	        _this2.hasActivation = hasActivation;
	        _this2.onLoad = onLoad;
	        _this2.loadData(_this2.query.page, _this2.query.predicates);
	        if (hasFilterFields) _this2.getFilterFields();
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(data) {
	      if (this.loading) {
	        return;
	      }
	      this.items = [];
	      this.query.search = data;
	      this.loadData(1, this.query.predicates);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page, pr) {
	      var _this3 = this;

	      this.loading = true;
	      this.query.page = page;
	      this.query.predicates = pr;
	      if (this.query.acc_on) {
	        if (this.responseLength < this.query.limit) {
	          this.query.acc_on = moment().subtract(++this.day, 'd').format('YYYY-MM-DD');
	          this.query.page = 1;
	        }
	      }
	      this.GenericService.list(this.version, this.model, this.query).promise.then(function (res) {
	        _this3.triggeredOnce = true;
	        _this3.loading = false;
	        _this3.responseLength = res.rows.length;
	        res.rows.map(function (r) {
	          r.enabled = r.activation_history ? !!r.activation_history.length : _this3.hasActivation ? internals.isActive(r[_this3.hasActivation.prop]) : false;
	        });
	        _this3.items = _this3.items.concat(res.rows);
	        _this3.totalPage = res.total_pages;
	        _this3.currentPage = res.current_page;
	        _this3.$state.go('.', { search: _this3.query.search, predicates: _this3.query.predicates, from: _this3.query.startDate, to: _this3.query.endDate }, { notify: false });
	        _this3.amount = res.count;
	        if (_this3.onLoad && angular.isFunction(_this3.onLoad)) {
	          _this3.onLoad(_this3.items);
	        }
	      }).catch(function () {
	        _this3.loading = false;
	        _this3.triggeredOnce = true;
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      if (this.responseLength === this.query.limit && !this.loading && (this.responseLength !== 0 || this.query.acc_on)) {
	        this.loadData(++this.currentPage, this.query.predicates);
	      }
	    }
	  }, {
	    key: 'sortBy',
	    value: function sortBy(params) {
	      if (_.isObject(params)) {
	        this.query.order = params;
	      } else {
	        this.query.order = this.sort[params];
	      }
	      this.items = [];
	      this.loadData(1, this.query.predicates);
	    }
	  }, {
	    key: 'archive',
	    value: function archive(item) {
	      var data = void 0;
	      if (this.version === 'v3') {
	        data = { uuids: [item.uuid] };
	      } else {
	        data = { ids: [item.id] };
	      }

	      this.GenericService.archive(this.version, this.model, data).promise.then(function () {
	        item.archived_at = moment();
	      });
	    }
	  }, {
	    key: 'unarchive',
	    value: function unarchive(item) {
	      var data = void 0;
	      if (this.version === 'v3') {
	        data = { uuids: [item.uuid] };
	      } else {
	        data = { ids: [item.id] };
	      }

	      this.GenericService.unarchive(this.version, this.model, data).promise.then(function () {
	        item.archived_at = null;
	      });
	    }
	  }, {
	    key: 'order',
	    value: function order(data) {
	      this.sortBy(data);
	    }
	  }, {
	    key: 'getFilterFields',
	    value: function getFilterFields() {
	      var _this4 = this;

	      this.GenericService.getFilterFields(this.version, this.model).promise.then(function (res) {
	        var exportList = [];

	        for (var index = 0; index < res.length; index++) {
	          var translatedAttr = _this4.$translate.instant('FILTER_LIST.BUTTON.' + res[index].a.toUpperCase());
	          exportList.push(internals.formatExport(res[index], translatedAttr));
	        }
	        _this4.exportList = exportList;
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(data) {
	      var desired = data.toExport.map(function (r) {
	        return {
	          a: r.a,
	          t: r.t
	        };
	      });
	      var query = {
	        order: this.query.order,
	        predicates: this.query.predicates || null,
	        export: {
	          desired: desired,
	          format: data.type,
	          emails: data.emails || null,
	          filename: _.deburr(data.filename)
	        }
	      };

	      this.GenericService.export('v1', this.model, query).promise.then(function (res) {
	        var type = {
	          CSV: 'text/csv;charset=utf-8',
	          XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
	        };

	        var blob = new Blob([res], { type: type[query.export.format] });
	        _fileSaver2.default.saveAs(blob, query.export.filename, { autoBom: true });
	      });
	    }
	  }]);

	  return BaseListController;
	}();

	exports.default = BaseListController;


	var internals = {
	  uriToJson: function uriToJson(uri) {
	    return angular.fromJson(atob(decodeURIComponent(uri)));
	  },
	  formatExport: function formatExport(filter, translatedAttr) {
	    return {
	      a: filter.a,
	      t: filter.t,
	      attr: translatedAttr
	    };
	  },
	  isActive: function isActive(deactivation) {
	    return deactivation == null;
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

	//# sourceMappingURL=FileSaver.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FuelsCreateController = function () {
	  FuelsCreateController.$inject = ["$state", "FuelsService", "GenericService", "GeocodingService"];
	  function FuelsCreateController($state, FuelsService, GenericService, GeocodingService) {
	    'ngInject';

	    _classCallCheck(this, FuelsCreateController);

	    this.$state = $state;
	    this.FuelsService = FuelsService;
	    this.GenericService = GenericService;
	    this.GeocodingService = GeocodingService;

	    this.isEdit();
	  }

	  _createClass(FuelsCreateController, [{
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.GenericService.show(_constants.API.V1, _constants.API.FUELS, this.$state.params.id).promise.then(function (res) {
	          _this.fuel = res;
	          _this.address = _this.fuel.location;
	          _this.fuel.fueled_at = _this.fuel.fueled_at ? new Date(_this.fuel.fueled_at) : '';
	          _this.options = {
	            archive: !_this.fuel.archived_at,
	            unarchive: _this.fuel.archived_at,
	            delete: _this.fuel.archived_at
	          };
	        });
	      }
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(query) {
	      if (_.isUndefined(query) || query.length === 0) {
	        return;
	      }
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'getVehicle',
	    value: function getVehicle(query) {
	      return this.GenericService.list(_constants.API.V1, _constants.API.VEHICLES, { search: query }).promise.then(function (res) {
	        return res.rows;
	      });
	    }
	  }, {
	    key: 'getLastRegister',
	    value: function getLastRegister() {
	      var _this2 = this;

	      if (_.isUndefined(this.fuel.vehicle) || _.isNull(this.fuel.vehicle)) {
	        return;
	      }
	      var data = {
	        d: this.fuel.fueled_at,
	        o: this.fuel.odometer
	      };
	      this.FuelsService.lastRegister(this.fuel.vehicle.id, data).promise.then(function (res) {
	        _this2.fuel.fuel_type = res.fuel_type;
	        _this2.fuel.last_fueled_at = res.fueled_at ? new Date(res.fueled_at) : '';
	        _this2.fuel.last_odometer = res.fueled_odometer;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      var data = {
	        vehicle_id: this.fuel.vehicle.id,
	        fueled_at: this.fuel.fueled_at || '',
	        fueled_odometer: this.fuel.fueled_odometer,
	        invoice_no: this.fuel.invoice_no,
	        fuel_type: this.fuel.fuel_type,
	        total_amount: this.fuel.total_amount,
	        total_price: this.fuel.total_price,
	        unity_price: this.fuel.unity_price,
	        comments: this.fuel.comments
	      };
	      _.map(data, function (i, k) {
	        if (/^ *$/.test(i)) {
	          data[k] = null;
	        }
	      });
	      if (this.fuel.id) {
	        this.GenericService.update(_constants.API.V1, _constants.API.FUELS, this.fuel.id, data).promise.then(function (res) {
	          _this3.fuel = res;
	          _this3.fuel.fueled_at = _this3.fuel.fueled_at ? new Date(_this3.fuel.fueled_at) : '';
	        }).finally(function () {
	          _this3.processing = false;
	        });
	      } else {
	        this.GenericService.create(_constants.API.V1, _constants.API.FUELS, data).promise.then(function () {
	          _this3.$state.go('fuels-list');
	        }).finally(function () {
	          _this3.processing = false;
	        });
	      }
	    }
	  }, {
	    key: 'updateTotalPrice',
	    value: function updateTotalPrice() {
	      this.fuel.total_price = this.fuel.total_amount * this.fuel.unity_price;
	    }
	  }]);

	  return FuelsCreateController;
	}();

	exports.default = FuelsCreateController;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FuelsService = function () {
	  FuelsService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function FuelsService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, FuelsService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(FuelsService, [{
	    key: 'lastRegister',
	    value: function lastRegister(id, obj) {
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, _constants.API.V1, _constants.API.FUELS, id, 'last'].join('/');
	      if (obj.d) {
	        query.push('fueled_at=' + obj.d);
	      }
	      if (obj.o) {
	        query.push('fueled_odometer=' + obj.o);
	      }

	      this.$http({ url: url + (query.length ? '?' + query.join('&') : ''), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return FuelsService;
	}();

	exports.default = FuelsService;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _tripsList = __webpack_require__(50);

	var _tripsList2 = _interopRequireDefault(_tripsList);

	var _tripsCreate = __webpack_require__(51);

	var _tripsCreate2 = _interopRequireDefault(_tripsCreate);

	var _tripsPanel = __webpack_require__(56);

	var _tripsPanel2 = _interopRequireDefault(_tripsPanel);

	var _trips = __webpack_require__(64);

	var _trips2 = _interopRequireDefault(_trips);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.fleet.trips', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'trips-list',
	    url: '/trips/list?search&predicates',
	    parent: 'fleet',
	    menu: true,
	    alias: 'trips',
	    controller: _tripsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/trips/list/trips.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      predicates: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'trips-panel',
	    url: '/trips/panel?f&t&v&r',
	    parent: 'fleet',
	    controller: _tripsPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/trips/panel/trips.panel.html',
	    params: {
	      f: { dynamic: true },
	      t: { dynamic: true },
	      v: { dynamic: true },
	      r: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'trips-create',
	    url: '/trips/create',
	    parent: 'fleet',
	    controller: _tripsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/trips/create/trips.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'trips-edit',
	    url: '/trips/edit/:id',
	    parent: 'fleet',
	    controller: _tripsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/trips/create/trips.create.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('TripsListController', _tripsList2.default).controller('TripsCreateController', _tripsCreate2.default).controller('TripsStatsController', _tripsCreate2.default).service('TripsService', _trips2.default);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _baseList = __webpack_require__(45);

	var _baseList2 = _interopRequireDefault(_baseList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TripsListController = function (_BaseListController) {
	  TripsListController.$inject = ["$state", "$scope", "$translate", "GenericService"];
	  _inherits(TripsListController, _BaseListController);

	  function TripsListController($state, $scope, $translate, GenericService) {
	    'ngInject';

	    _classCallCheck(this, TripsListController);

	    var _this = _possibleConstructorReturn(this, (TripsListController.__proto__ || Object.getPrototypeOf(TripsListController)).call(this, $scope, GenericService));

	    _this.$state = $state;
	    _this.$translate = $translate;

	    var query = {
	      limit: 15,
	      page: 1,
	      search: _this.$state.params.search,
	      order: { prop: 'start_at', order: 'ASC' },
	      predicates: _this.$state.params.predicates
	    };

	    _this.options = {
	      new: 'screen',
	      export: true,
	      stats: true
	    };

	    _this.setProps(_constants.API.V1, _constants.API.TRIPS, query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(TripsListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.CODE_PLATE', 'PANEL.HEADER.ENTERPRISE_OS', 'PANEL.HEADER.DISTANCE_DURATION', 'PANEL.HEADER.STARTS_ENDS'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.CODE_PLATE'],
	          sort: true,
	          prop: 'code'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_OS'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.DISTANCE_DURATION'],
	          sort: true,
	          prop: 'estimated_distance'
	        }, {
	          label: t['PANEL.HEADER.STARTS_ENDS'],
	          sort: true,
	          prop: 'start_at'
	        }];
	      });
	    }
	  }]);

	  return TripsListController;
	}(_baseList2.default);

	exports.default = TripsListController;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _polyline = __webpack_require__(53);

	var polyline = _interopRequireWildcard(_polyline);

	var _timeToInt = __webpack_require__(54);

	var _timeToInt2 = _interopRequireDefault(_timeToInt);

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _trips = __webpack_require__(55);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TripsCreateController = function () {
	  TripsCreateController.$inject = ["$state", "EnvironmentConfig", "DialogService", "GeocodingService", "GeoLocation", "MapHelper", "TripsService", "GenericService"];
	  function TripsCreateController($state, EnvironmentConfig, DialogService, GeocodingService, GeoLocation, MapHelper, TripsService, GenericService) {
	    'ngInject';

	    _classCallCheck(this, TripsCreateController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GeocodingService = GeocodingService;
	    this.GeoLocation = GeoLocation;
	    this.MapHelper = MapHelper;
	    this.TripsService = TripsService;
	    this.GenericService = GenericService;

	    this.getGeoLocation();
	  }

	  _createClass(TripsCreateController, [{
	    key: 'getGeoLocation',
	    value: function getGeoLocation() {
	      var _this = this;

	      this.coords = null;

	      var getGeoLocation = this.GeoLocation.getCoords();
	      getGeoLocation.then(function (res) {
	        _this.coords = { center: [res.lng, res.lat] };
	      }).finally(function () {
	        _this.loadMap();
	      });
	    }
	  }, {
	    key: 'loadMap',
	    value: function loadMap() {
	      var _this2 = this;

	      this.MapHelper.mapBuilder('streets', this.coords);

	      this.MapHelper.map.on('load', function () {
	        _this2.addSources();
	        _this2.addLayers();
	        _this2.isEdit();
	      });
	    }
	  }, {
	    key: 'addSources',
	    value: function addSources() {
	      var data = {
	        type: 'geojson',
	        data: {
	          type: 'FeatureCollection',
	          features: []
	        }
	      };
	      this.MapHelper.addSources(['path', 'circles', 'arrows', 'dashed'], [data, data, data, data]);
	    }
	  }, {
	    key: 'addLayers',
	    value: function addLayers() {
	      var layers = [this.MapHelper.layerBuilder('expected', 'line', { source: 'path', layout: _trips.mapConfig.path.layout, paint: _trips.mapConfig.path.paint }), this.MapHelper.layerBuilder('waypoints', 'circle', { source: 'circles', paint: _trips.mapConfig.waypoints.paint }), this.MapHelper.layerBuilder('routearrows', 'symbol', { source: 'arrows', layout: _trips.mapConfig.arrows.layout, paint: _trips.mapConfig.arrows.paint }), this.MapHelper.layerBuilder('dashedLines', 'line', { source: 'dashed', layout: _trips.mapConfig.dashed.layout, paint: _trips.mapConfig.dashed.paint })];

	      this.MapHelper.addLayers(layers);
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this3 = this;

	      if (this.$state.params.id) {
	        this.GenericService.show(_constants.API.V1, _constants.API.TRIPS, this.$state.params.id).promise.then(function (res) {
	          _this3.trip = res;
	          _this3.drawPath();
	          _this3.options = {
	            archive: !_this3.trip.archived_at,
	            unarchive: _this3.trip.archived_at,
	            delete: _this3.trip.archived_at
	          };
	        });
	      } else if (this.$state.params.fromTripSource) {
	        this.GenericService.show(_constants.API.V1, _constants.API.TRIPS, this.$state.params.fromTripSource).promise.then(function (res) {
	          _this3.trip = {};
	          _this3.trip.locations = res.locations;
	          _this3.trip.estimated_distance = res.estimated_distance;
	          _this3.trip.estimated_driving_time = res.estimated_driving_time;
	          _this3.trip.estimated_trip_time = res.estimated_trip_time;
	          _this3.trip.expected_path = res.expected_path;
	          _this3.drawPath();
	          _this3.$state.go('.', { fromTripSource: _this3.$state.params.fromTripSource }, { notify: false });
	        });
	      }
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(query) {
	      if (_.isUndefined(query) || query.length === 0) {
	        return;
	      }
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'getVehicle',
	    value: function getVehicle(query) {
	      return this.GenericService.list(_constants.API.V1, _constants.API.VEHICLES, { search: query, order: { prop: 'plate', order: 'ASC' } }).promise.then(function (res) {
	        return res.rows;
	      });
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(query) {
	      return this.GenericService.list(_constants.API.V1, _constants.API.USERS, { search: query, order: { prop: 'name', order: 'ASC' }, enterprise_id: this.trip.vehicle.enterprise_id }).promise.then(function (res) {
	        return res.rows;
	      });
	    }
	  }, {
	    key: 'addLocationToTrip',
	    value: function addLocationToTrip(location) {
	      var data = {
	        action: location.action,
	        address: location.address.formatted_address,
	        duration: (0, _timeToInt2.default)()(location.duration, 'short'),
	        order: this.trip.locations ? (this.trip.locations.length + 1) * 100000 : 100000,
	        coordinates: [location.address.geometry.location.lat, location.address.geometry.location.lng]
	      };
	      if (_.isUndefined(this.trip.locations)) {
	        this.trip.locations = [];
	      }
	      this.trip.locations.push(data);
	      if (this.trip.locations.length >= 2) {
	        this.triggerRoutes();
	      }
	      this.selectedLocation = null;
	      this.formLocations.$setPristine();
	    }
	  }, {
	    key: 'removeLocationsFromTrip',
	    value: function removeLocationsFromTrip(location) {
	      this.trip.locations.splice(this.trip.locations.indexOf(location), 1);
	      if (this.trip.locations.length >= 2) {
	        this.triggerRoutes();
	      }
	    }
	  }, {
	    key: 'addUserToTrip',
	    value: function addUserToTrip(user) {
	      var data = {
	        common_hours: (0, _timeToInt2.default)()(user.common_hours, 'short'),
	        extra_hours: (0, _timeToInt2.default)()(user.extra_hours, 'short'),
	        extra_night_hours: (0, _timeToInt2.default)()(user.extra_night_hours, 'short'),
	        holding_hours: (0, _timeToInt2.default)()(user.holding_hours, 'short'),
	        night_hours: (0, _timeToInt2.default)()(user.night_hours, 'short'),
	        role: user.role,
	        user: user.user,
	        user_id: user.user.id
	      };
	      if (_.isUndefined(this.trip.users)) {
	        this.trip.users = [];
	      }
	      this.trip.users.push(data);
	      this.selectedUser = null;
	      this.formUsers.$setPristine();
	    }
	  }, {
	    key: 'removeUsersFromTrip',
	    value: function removeUsersFromTrip(user) {
	      this.trip.users.splice(this.trip.users.indexOf(user), 1);
	    }
	  }, {
	    key: 'addExpensesToTrip',
	    value: function addExpensesToTrip(expense) {
	      if (_.isUndefined(this.trip.expenses)) {
	        this.trip.expenses = [];
	      }
	      this.trip.expenses.push(expense);
	      this.selectedExpense = null;
	      this.formExpenses.$setPristine();
	    }
	  }, {
	    key: 'removeExpensesFromTrip',
	    value: function removeExpensesFromTrip(expense) {
	      this.trip.expenses.splice(this.trip.expenses.indexOf(expense), 1);
	    }
	  }, {
	    key: 'addRevenuesToTrip',
	    value: function addRevenuesToTrip(revenue) {
	      if (_.isUndefined(this.trip.revenues)) {
	        this.trip.revenues = [];
	      }
	      this.trip.revenues.push(revenue);
	      this.selectedRevenue = null;
	      this.formRevenues.$setPristine();
	    }
	  }, {
	    key: 'removeRevenuesFromTrip',
	    value: function removeRevenuesFromTrip(revenue) {
	      this.trip.revenues.splice(this.trip.revenues.indexOf(revenue), 1);
	    }
	  }, {
	    key: 'triggerRoutes',
	    value: function triggerRoutes() {
	      var _this4 = this;

	      var coords = '';
	      this.trip.locations.forEach(function (e, idx, array) {
	        if (idx === array.length - 1) {
	          coords += e.coordinates[1] + ',' + e.coordinates[0];
	        } else {
	          coords += e.coordinates[1] + ',' + e.coordinates[0] + ';';
	        }
	      });
	      this.TripsService.getTripPath(coords).promise.then(function (res) {
	        _this4.tripDetails = res;
	        _this4.trip.estimated_distance = parseInt(res.trips[0].distance);
	        _this4.trip.estimated_driving_time = parseInt(res.trips[0].duration);
	        _this4.trip.estimated_trip_time = parseInt(res.trips[0].duration) + _.sumBy(_this4.trip.locations, function (e) {
	          return e.duration;
	        });
	        _this4.trip.expected_path = polyline.encode(res.trips[0].geometry.coordinates);
	        _this4.drawPath();
	      });
	    }
	  }, {
	    key: 'drawPath',
	    value: function drawPath() {
	      var steps = [];
	      var dashedLine = [];
	      var expectedLine = turf.lineString(polyline.decode(this.trip.expected_path), { name: 'Expected' });
	      _.forEach(this.trip.locations, function (l, k) {
	        var point = [l.coordinates[1], l.coordinates[0]];
	        var nearest = turf.nearestPointOnLine(expectedLine, point);
	        steps.push(turf.point(point, { name: l.address, action: l.action, index: k + 1 }));
	        dashedLine.push([point, nearest.geometry.coordinates]);
	      });

	      this.MapHelper.setDataToSource('path', expectedLine);
	      this.MapHelper.setDataToSource('arrows', expectedLine);
	      this.MapHelper.setDataToSource('circles', turf.featureCollection(steps));
	      this.MapHelper.setDataToSource('dashed', turf.multiLineString(dashedLine));

	      this.MapHelper.map.fitBounds(turf.bbox(expectedLine), {
	        padding: 50
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this5 = this;

	      var users = _.forEach(this.trip.users, function (e, i) {
	        _this5.trip.users[i] = _.omit(e, ['trip_id', 'user', 'enterprise_id', '$$hashKey']);
	      }) || [];
	      var expenses = _.forEach(this.trip.expenses, function (e, i) {
	        _this5.trip.expenses[i] = _.omit(e, ['trip_id', 'enterprise_id', '$$hashKey']);
	      }) || [];
	      var locations = _.forEach(this.trip.locations, function (e, i) {
	        _this5.trip.locations[i] = _.omit(e, ['id', 'trip_id', '$$hashKey']);
	      }) || [];
	      var revenues = _.forEach(this.trip.revenues, function (e, i) {
	        _this5.trip.revenues[i] = _.omit(e, ['trip_id', '$$hashKey', 'metricUnity']);
	      }) || [];
	      var data = {
	        vehicle_id: this.trip.vehicle.id,
	        service_order: this.trip.service_order,
	        start_at: this.trip.start_at,
	        end_at: this.trip.end_at,
	        users: users.length ? users : '[]',
	        expenses: expenses.length ? expenses : '[]',
	        locations: locations.length ? locations : '[]',
	        revenues: revenues.length ? revenues : '[]',
	        estimated_distance: this.trip.estimated_distance,
	        estimated_driving_time: this.trip.estimated_driving_time,
	        estimated_trip_time: this.trip.estimated_trip_time,
	        expected_path: this.trip.expected_path
	      };
	      _.map(data, function (i, k) {
	        if (/^ *$/.test(i)) {
	          data[k] = null;
	        }
	      });
	      if (angular.isDefined(this.$state.params.id)) {
	        this.GenericService.update(_constants.API.V1, _constants.API.TRIPS, this.trip.id, data).promise.then(function (res) {
	          _this5.trip = res;
	        });
	      } else {
	        this.GenericService.create(_constants.API.V1, _constants.API.TRIPS, data).promise.then(function (res) {
	          _this5.trip = res;
	          _this5.$state.go('trips-edit', { id: _this5.trip.id }, { notify: false });
	        });
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this6 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        _this6.GenericService.delete(_constants.API.V1, _constants.API.TRIPS, _this6.$state.params.id).promise.then(function () {
	          _this6.$state.go('trips-list');
	        });
	      });
	    }
	  }, {
	    key: '_move',
	    value: function _move(a, b, c, d, e) {
	      var before = e - 1;
	      var after = e + 1;

	      if (e - 1 < 0) {
	        this.trip.locations[e].order = (this.trip.locations[after].order - 100000) / 2 + 100000;
	      } else {
	        this.trip.locations[e].order = (this.trip.locations[after].order - this.trip.locations[before].order) / 2 + this.trip.locations[before].order;
	      }
	      if (this.trip.locations.length >= 2) {
	        this.triggerRoutes();
	      }
	    }
	  }, {
	    key: '_updateUnityBase',
	    value: function _updateUnityBase() {
	      switch (this.selectedRevenue.type) {
	        case 'distance':
	          this.selectedRevenue.metricUnity = 'distance_value';
	          this.selectedRevenue.unity_base_price = 'km';
	          break;
	        case 'time':
	          this.selectedRevenue.metricUnity = 'time_value';
	          this.selectedRevenue.unity_base_price = 'hour';
	          break;
	        case 'cubic':
	          this.selectedRevenue.metricUnity = 'cubic_value';
	          this.selectedRevenue.unity_base_price = 'm3';
	          break;
	        case 'weight':
	          this.selectedRevenue.metricUnity = 'weight_value';
	          this.selectedRevenue.unity_base_price = 'kg';
	          break;
	        case 'fixed':
	          this.selectedRevenue.metricUnity = 'fixed_value';
	          this.selectedRevenue.unity_base_price = 'unit';
	          this.selectedRevenue.fixed_value = 1;
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: '_updateTare',
	    value: function _updateTare() {
	      this.selectedRevenue.tare = this.selectedRevenue.gross_weight - this.selectedRevenue.net_weight;
	    }
	  }, {
	    key: '_updatePeriod',
	    value: function _updatePeriod() {
	      this.minValidDate = this.trip.start_at ? moment(this.trip.start_at, 'YYYY-MM-DD HH:mm:ss:sss').toISOString() : null;
	      this.maxValidDate = this.trip.end_at ? moment(this.trip.end_at, 'YYYY-MM-DD HH:mm:ss:sss').toISOString() : null;
	    }
	  }, {
	    key: '_updateTotalPrice',
	    value: function _updateTotalPrice() {
	      this.selectedRevenue.total_price = this.selectedRevenue.base_price * this.selectedRevenue[this.selectedRevenue.metricUnity];
	    }
	  }, {
	    key: '_updateTotalExpensesPrice',
	    value: function _updateTotalExpensesPrice() {
	      this.selectedExpense.total_price = this.selectedExpense.amount * this.selectedExpense.unity_price;
	    }
	  }]);

	  return TripsCreateController;
	}();

	exports.default = TripsCreateController;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.turf={})}(this,function(t){"use strict";function e(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.bbox,i=n.id;if(void 0===t)throw new Error("geometry is required");if(e&&e.constructor!==Object)throw new Error("properties must be an Object");r&&N(r),i&&C(i);var o={type:"Feature"};return i&&(o.id=i),r&&(o.bbox=r),o.properties=e||{},o.geometry=t,o}function n(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var i=n.bbox;if(!t)throw new Error("type is required");if(!e)throw new Error("coordinates is required");if(!Array.isArray(e))throw new Error("coordinates must be an Array");i&&N(i);var s;switch(t){case"Point":s=r(e).geometry;break;case"LineString":s=a(e).geometry;break;case"Polygon":s=o(e).geometry;break;case"MultiPoint":s=l(e).geometry;break;case"MultiLineString":s=h(e).geometry;break;case"MultiPolygon":s=p(e).geometry;break;default:throw new Error(t+" is invalid")}return i&&(s.bbox=i),s}function r(t,n,r){if(!t)throw new Error("coordinates is required");if(!Array.isArray(t))throw new Error("coordinates must be an Array");if(t.length<2)throw new Error("coordinates must be at least 2 numbers long");if(!b(t[0])||!b(t[1]))throw new Error("coordinates must contain numbers");return e({type:"Point",coordinates:t},n,r)}function i(t,e,n){if(!t)throw new Error("coordinates is required");if(!Array.isArray(t))throw new Error("coordinates must be an Array");return c(t.map(function(t){return r(t,e)}),n)}function o(t,n,r){if(!t)throw new Error("coordinates is required");for(var i=0;i<t.length;i++){var o=t[i];if(o.length<4)throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");for(var s=0;s<o[o.length-1].length;s++){if(0===i&&0===s&&!b(o[0][0])||!b(o[0][1]))throw new Error("coordinates must contain numbers");if(o[o.length-1][s]!==o[0][s])throw new Error("First and last Position are not equivalent.")}}return e({type:"Polygon",coordinates:t},n,r)}function s(t,e,n){if(!t)throw new Error("coordinates is required");if(!Array.isArray(t))throw new Error("coordinates must be an Array");return c(t.map(function(t){return o(t,e)}),n)}function a(t,n,r){if(!t)throw new Error("coordinates is required");if(t.length<2)throw new Error("coordinates must be an array of two or more positions");if(!b(t[0][1])||!b(t[0][1]))throw new Error("coordinates must contain numbers");return e({type:"LineString",coordinates:t},n,r)}function u(t,e,n){if(!t)throw new Error("coordinates is required");if(!Array.isArray(t))throw new Error("coordinates must be an Array");return c(t.map(function(t){return a(t,e)}),n)}function c(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.bbox,r=e.id;if(!t)throw new Error("No features passed");if(!Array.isArray(t))throw new Error("features must be an Array");n&&N(n),r&&C(r);var i={type:"FeatureCollection"};return r&&(i.id=r),n&&(i.bbox=n),i.features=t,i}function h(t,n,r){if(!t)throw new Error("coordinates is required");return e({type:"MultiLineString",coordinates:t},n,r)}function l(t,n,r){if(!t)throw new Error("coordinates is required");return e({type:"MultiPoint",coordinates:t},n,r)}function p(t,n,r){if(!t)throw new Error("coordinates is required");return e({type:"MultiPolygon",coordinates:t},n,r)}function f(t,n,r){if(!t)throw new Error("geometries is required");if(!Array.isArray(t))throw new Error("geometries must be an Array");return e({type:"GeometryCollection",geometries:t},n,r)}function g(t,e){if(void 0===t||null===t||isNaN(t))throw new Error("num is required");if(e&&!(e>=0))throw new Error("precision must be a positive number");var n=Math.pow(10,e||0);return Math.round(t*n)/n}function d(t,e){if(void 0===t||null===t)throw new Error("radians is required");if(e&&"string"!=typeof e)throw new Error("units must be a string");var n=qo[e||"kilometers"];if(!n)throw new Error(e+" units is invalid");return t*n}function y(t,e){if(void 0===t||null===t)throw new Error("distance is required");if(e&&"string"!=typeof e)throw new Error("units must be a string");var n=qo[e||"kilometers"];if(!n)throw new Error(e+" units is invalid");return t/n}function _(t,e){return v(y(t,e))}function m(t){if(null===t||void 0===t)throw new Error("bearing is required");var e=t%360;return e<0&&(e+=360),e}function v(t){if(null===t||void 0===t)throw new Error("radians is required");return 180*(t%(2*Math.PI))/Math.PI}function x(t){if(null===t||void 0===t)throw new Error("degrees is required");return t%360*Math.PI/180}function E(t,e,n){if(null===t||void 0===t)throw new Error("length is required");if(!(t>=0))throw new Error("length must be a positive number");return d(y(t,e),n||"kilometers")}function w(t,e,n){if(null===t||void 0===t)throw new Error("area is required");if(!(t>=0))throw new Error("area must be a positive number");var r=Bo[e||"meters"];if(!r)throw new Error("invalid original units");var i=Bo[n||"kilometers"];if(!i)throw new Error("invalid final units");return t/r*i}function b(t){return!isNaN(t)&&null!==t&&!Array.isArray(t)}function I(t){return!!t&&t.constructor===Object}function N(t){if(!t)throw new Error("bbox is required");if(!Array.isArray(t))throw new Error("bbox must be an Array");if(4!==t.length&&6!==t.length)throw new Error("bbox must be an Array of 4 or 6 numbers");t.forEach(function(t){if(!b(t))throw new Error("bbox must only contain numbers")})}function C(t){if(!t)throw new Error("id is required");if(-1===["string","number"].indexOf(typeof t))throw new Error("id must be a number or a string")}function S(t,e,n){if(null!==t)for(var r,i,o,s,a,u,c,h,l=0,p=0,f=t.type,g="FeatureCollection"===f,d="Feature"===f,y=g?t.features.length:1,_=0;_<y;_++){a=(h=!!(c=g?t.features[_].geometry:d?t.geometry:t)&&"GeometryCollection"===c.type)?c.geometries.length:1;for(var m=0;m<a;m++){var v=0,x=0;if(null!==(s=h?c.geometries[m]:c)){u=s.coordinates;var E=s.type;switch(l=!n||"Polygon"!==E&&"MultiPolygon"!==E?0:1,E){case null:break;case"Point":e(u,p,_,v,x),p++,v++;break;case"LineString":case"MultiPoint":for(r=0;r<u.length;r++)e(u[r],p,_,v,x),p++,"MultiPoint"===E&&v++;"LineString"===E&&v++;break;case"Polygon":case"MultiLineString":for(r=0;r<u.length;r++){for(i=0;i<u[r].length-l;i++)e(u[r][i],p,_,v,x),p++;"MultiLineString"===E&&v++,"Polygon"===E&&x++}"Polygon"===E&&v++;break;case"MultiPolygon":for(r=0;r<u.length;r++){for("MultiPolygon"===E&&(x=0),i=0;i<u[r].length;i++){for(o=0;o<u[r][i].length-l;o++)e(u[r][i][o],p,_,v,x),p++;x++}v++}break;case"GeometryCollection":for(r=0;r<s.geometries.length;r++)S(s.geometries[r],e,n);break;default:throw new Error("Unknown Geometry Type")}}}}}function M(t,e,n,r){var i=n;return S(t,function(t,r,o,s,a){i=0===r&&void 0===n?t:e(i,t,r,o,s,a)},r),i}function L(t,e){var n;switch(t.type){case"FeatureCollection":for(n=0;n<t.features.length;n++)e(t.features[n].properties,n);break;case"Feature":e(t.properties,0)}}function P(t,e,n){var r=n;return L(t,function(t,i){r=0===i&&void 0===n?t:e(r,t,i)}),r}function O(t,e){if("Feature"===t.type)e(t,0);else if("FeatureCollection"===t.type)for(var n=0;n<t.features.length;n++)e(t.features[n],n)}function R(t,e,n){var r=n;return O(t,function(t,i){r=0===i&&void 0===n?t:e(r,t,i)}),r}function T(t){var e=[];return S(t,function(t){e.push(t)}),e}function A(t,e){var n,r,i,o,s,a,u,c,h,l,p=0,f="FeatureCollection"===t.type,g="Feature"===t.type,d=f?t.features.length:1;for(n=0;n<d;n++){for(a=f?t.features[n].geometry:g?t.geometry:t,c=f?t.features[n].properties:g?t.properties:{},h=f?t.features[n].bbox:g?t.bbox:void 0,l=f?t.features[n].id:g?t.id:void 0,s=(u=!!a&&"GeometryCollection"===a.type)?a.geometries.length:1,i=0;i<s;i++)if(null!==(o=u?a.geometries[i]:a))switch(o.type){case"Point":case"LineString":case"MultiPoint":case"Polygon":case"MultiLineString":case"MultiPolygon":e(o,p,c,h,l);break;case"GeometryCollection":for(r=0;r<o.geometries.length;r++)e(o.geometries[r],p,c,h,l);break;default:throw new Error("Unknown Geometry Type")}else e(null,p,c,h,l);p++}}function D(t,e,n){var r=n;return A(t,function(t,i,o,s,a){r=0===i&&void 0===n?t:e(r,t,i,o,s,a)}),r}function F(t,n){A(t,function(t,r,i,o,s){var a=null===t?null:t.type;switch(a){case null:case"Point":case"LineString":case"Polygon":return void n(e(t,i,{bbox:o,id:s}),r,0)}var u;switch(a){case"MultiPoint":u="Point";break;case"MultiLineString":u="LineString";break;case"MultiPolygon":u="Polygon"}t.coordinates.forEach(function(t,o){n(e({type:u,coordinates:t},i),r,o)})})}function q(t,e,n){var r=n;return F(t,function(t,i,o){r=0===i&&0===o&&void 0===n?t:e(r,t,i,o)}),r}function G(t,e){F(t,function(t,n,r){var i=0;if(t.geometry){var o=t.geometry.type;"Point"!==o&&"MultiPoint"!==o&&M(t,function(o,s,u,c,h,l){var p=a([o,s],t.properties);return e(p,n,r,l,i),i++,s})}})}function B(t,e,n){var r=n,i=!1;return G(t,function(t,o,s,a,u){r=!1===i&&void 0===n?t:e(r,t,o,s,a,u),i=!0}),r}function k(t,e){if(!t)throw new Error("geojson is required");F(t,function(t,n,r){if(null!==t.geometry){var i=t.geometry.type,o=t.geometry.coordinates;switch(i){case"LineString":e(t,n,r,0,0);break;case"Polygon":for(var s=0;s<o.length;s++)e(a(o[s],t.properties),n,r,s)}}})}function z(t,e,n){var r=n;return k(t,function(t,i,o,s){r=0===i&&void 0===n?t:e(r,t,i,o,s)}),r}function j(t){var e=[1/0,1/0,-1/0,-1/0];return S(t,function(t){e[0]>t[0]&&(e[0]=t[0]),e[1]>t[1]&&(e[1]=t[1]),e[2]<t[0]&&(e[2]=t[0]),e[3]<t[1]&&(e[3]=t[1])}),e}function X(t){if(!t)throw new Error("obj is required");var e=U(t);if(e.length>1&&b(e[0])&&b(e[1]))return e;throw new Error("Coordinate is not a valid Point")}function U(t){if(!t)throw new Error("obj is required");var e;if(t.length?e=t:t.coordinates?e=t.coordinates:t.geometry&&t.geometry.coordinates&&(e=t.geometry.coordinates),e)return Y(e),e;throw new Error("No valid coordinates")}function Y(t){if(t.length>1&&b(t[0])&&b(t[1]))return!0;if(Array.isArray(t[0])&&t[0].length)return Y(t[0]);throw new Error("coordinates must only contain numbers")}function V(t,e,n){if(!e||!n)throw new Error("type and name required");if(!t||t.type!==e)throw new Error("Invalid input to "+n+": must be a "+e+", given "+t.type)}function H(t,e,n){if(!t)throw new Error("No feature passed");if(!n)throw new Error(".featureOf() requires a name");if(!t||"Feature"!==t.type||!t.geometry)throw new Error("Invalid input to "+n+", Feature with geometry required");if(!t.geometry||t.geometry.type!==e)throw new Error("Invalid input to "+n+": must be a "+e+", given "+t.geometry.type)}function W(t,e,n){if(!t)throw new Error("No featureCollection passed");if(!n)throw new Error(".collectionOf() requires a name");if(!t||"FeatureCollection"!==t.type)throw new Error("Invalid input to "+n+", FeatureCollection required");for(var r=0;r<t.features.length;r++){var i=t.features[r];if(!i||"Feature"!==i.type||!i.geometry)throw new Error("Invalid input to "+n+", Feature with geometry required");if(!i.geometry||i.geometry.type!==e)throw new Error("Invalid input to "+n+": must be a "+e+", given "+i.geometry.type)}}function J(t){if(!t)throw new Error("geojson is required");if(void 0!==t.geometry)return t.geometry;if(t.coordinates||t.geometries)return t;throw new Error("geojson must be a valid Feature or Geometry Object")}function Z(){throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType")}function K(t,e){if(!t)throw new Error((e||"geojson")+" is required");if(t.geometry&&t.geometry.type)return t.geometry.type;if(t.type)return t.type;throw new Error((e||"geojson")+" is invalid")}function Q(t,e,n){n=n||{};for(var r=Object.keys(Xo),i=0;i<r.length;i++){var o=r[i],s=n[o];s=void 0!==s&&null!==s?s:Xo[o],Uo[o]=s}Uo.verbose&&console.log("MarchingSquaresJS-isoContours: computing isocontour for "+e);var a=function(t){var e=[],n=0;t.rows,t.cols;return t.cells.forEach(function(r,i){r.forEach(function(r,o){if(void 0!==r&&!function(t){return 5===t.cval||10===t.cval}(r)&&!tt(r)){var s=function(t,e,n){var r,i,o,s=t.length,a=[],u=[0,0,1,1,0,0,0,0,-1,0,1,1,-1,0,-1,0],c=[0,-1,0,0,1,1,1,1,0,-1,0,0,0,-1,0,0],h=["none","bottom","right","right","top","top","top","top","left","bottom","right","right","left","bottom","left","none"],l=(t[e][n],t[e][n]),p=l.cval,f=nt(l,o=["none","left","bottom","left","right","none","bottom","left","top","top","none","top","right","right","bottom","none"][p]);a.push([n+f[0],e+f[1]]),f=nt(l,o=h[p]),a.push([n+f[0],e+f[1]]),et(l);for(var g=n+u[p],d=e+c[p],y=p;g>=0&&d>=0&&d<s&&(g!=n||d!=e)&&void 0!==(l=t[d][g]);){if(0===(p=l.cval)||15===p)return{path:a,info:"mergeable"};o=h[p],r=u[p],i=c[p],5!==p&&10!==p||(5===p?l.flipped?-1===c[y]?(o="left",r=-1,i=0):(o="right",r=1,i=0):-1===u[y]&&(o="bottom",r=0,i=-1):10===p&&(l.flipped?-1===u[y]?(o="top",r=0,i=1):(o="bottom",r=0,i=-1):1===c[y]&&(o="left",r=-1,i=0))),f=nt(l,o),a.push([g+f[0],d+f[1]]),et(l),g+=r,d+=i,y=p}return{path:a,info:"closed"}}(t.cells,i,o),a=!1;if("mergeable"===s.info)for(var u=s.path[s.path.length-1][0],c=s.path[s.path.length-1][1],h=n-1;h>=0;h--)if(Math.abs(e[h][0][0]-u)<=1e-7&&Math.abs(e[h][0][1]-c)<=1e-7){for(var l=s.path.length-2;l>=0;--l)e[h].unshift(s.path[l]);a=!0;break}a||(e[n++]=s.path)}})}),e}(function(t,e){for(var n=t.length-1,r=t[0].length-1,i={rows:n,cols:r,cells:[]},o=0;o<n;++o){i.cells[o]=[];for(var s=0;s<r;++s){var a=0,u=t[o+1][s],c=t[o+1][s+1],h=t[o][s+1],l=t[o][s];if(!(isNaN(u)||isNaN(c)||isNaN(h)||isNaN(l))){a|=u>=e?8:0,a|=c>=e?4:0,a|=h>=e?2:0;var p=!1;if(5===(a|=l>=e?1:0)||10===a){var f=(u+c+h+l)/4;5===a&&f<e?(a=10,p=!0):10===a&&f<e&&(a=5,p=!0)}if(0!==a&&15!==a){var g,d,y,_;g=d=y=_=.5,1===a?(y=1-$(e,u,l),d=1-$(e,h,l)):2===a?(d=$(e,l,h),_=1-$(e,c,h)):3===a?(y=1-$(e,u,l),_=1-$(e,c,h)):4===a?(g=$(e,u,c),_=$(e,h,c)):5===a?(g=$(e,u,c),_=$(e,h,c),d=1-$(e,h,l),y=1-$(e,u,l)):6===a?(d=$(e,l,h),g=$(e,u,c)):7===a?(y=1-$(e,u,l),g=$(e,u,c)):8===a?(y=$(e,l,u),g=1-$(e,c,u)):9===a?(d=1-$(e,h,l),g=1-$(e,c,u)):10===a?(g=1-$(e,c,u),_=1-$(e,c,h),d=$(e,l,h),y=$(e,l,u)):11===a?(g=1-$(e,c,u),_=1-$(e,c,h)):12===a?(y=$(e,l,u),_=$(e,h,c)):13===a?(d=1-$(e,h,l),_=$(e,h,c)):14===a?(y=$(e,l,u),d=$(e,l,h)):console.log("MarchingSquaresJS-isoContours: Illegal cval detected: "+a),i.cells[o][s]={cval:a,flipped:p,top:g,right:_,bottom:d,left:y}}}}}return i}(t,e));return"function"==typeof Uo.successCallback&&Uo.successCallback(a),a}function $(t,e,n){return(t-e)/(n-e)}function tt(t){return 0===t.cval||15===t.cval}function et(t){tt(t)||5===t.cval||10===t.cval||(t.cval=15)}function nt(t,e){return"top"===e?[t.top,1]:"bottom"===e?[t.bottom,0]:"right"===e?[1,t.right]:"left"===e?[0,t.left]:void 0}function rt(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.zProperty||"elevation",r=e.flip,i=e.flags;W(t,"Point","input must contain Points");for(var o=function(t,e){var n={};O(t,function(t){var e=U(t)[1];n[e]||(n[e]=[]),n[e].push(t)});return Object.keys(n).map(function(t){var e=n[t],r=e.sort(function(t,e){return U(t)[0]-U(e)[0]});return r}).sort(function(t,n){return e?U(t[0])[1]-U(n[0])[1]:U(n[0])[1]-U(t[0])[1]})}(t,r),s=[],a=0;a<o.length;a++){for(var u=o[a],c=[],h=0;h<u.length;h++){var l=u[h];l.properties[n]?c.push(l.properties[n]):c.push(0),!0===i&&(l.properties.matrixPosition=[a,h])}s.push(c)}return s}function it(t,e,n,r,i){for(n=n||0,r=r||t.length-1,i=i||function(t,e){return t<e?-1:t>e?1:0};r>n;){if(r-n>600){var o=r-n+1,s=e-n+1,a=Math.log(o),u=.5*Math.exp(2*a/3),c=.5*Math.sqrt(a*u*(o-u)/o)*(s-o/2<0?-1:1);it(t,e,Math.max(n,Math.floor(e-s*u/o+c)),Math.min(r,Math.floor(e+(o-s)*u/o+c)),i)}var h=t[e],l=n,p=r;for(ot(t,n,e),i(t[r],h)>0&&ot(t,n,r);l<p;){for(ot(t,l,p),l++,p--;i(t[l],h)<0;)l++;for(;i(t[p],h)>0;)p--}0===i(t[n],h)?ot(t,n,p):ot(t,++p,r),p<=e&&(n=p+1),e<=p&&(r=p-1)}}function ot(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function st(t,e){if(!(this instanceof st))return new st(t,e);this._maxEntries=Math.max(4,t||9),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),e&&this._initFormat(e),this.clear()}function at(t,e){ut(t,0,t.children.length,e,t)}function ut(t,e,n,r,i){i||(i=yt(null)),i.minX=1/0,i.minY=1/0,i.maxX=-1/0,i.maxY=-1/0;for(var o,s=e;s<n;s++)o=t.children[s],ct(i,t.leaf?r(o):o);return i}function ct(t,e){return t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),t}function ht(t,e){return t.minX-e.minX}function lt(t,e){return t.minY-e.minY}function pt(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function ft(t){return t.maxX-t.minX+(t.maxY-t.minY)}function gt(t,e){return t.minX<=e.minX&&t.minY<=e.minY&&e.maxX<=t.maxX&&e.maxY<=t.maxY}function dt(t,e){return e.minX<=t.maxX&&e.minY<=t.maxY&&e.maxX>=t.minX&&e.maxY>=t.minY}function yt(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function _t(t,e,n,r,i){for(var o,s=[e,n];s.length;)(n=s.pop())-(e=s.pop())<=r||(o=e+Math.ceil((n-e)/r/2)*r,Yo(t,o,e,n,i),s.push(e,o,o,n))}function mt(t,e){return e={exports:{}},t(e,e.exports),e.exports}function vt(t,e){if(!(this instanceof vt))return new vt(t,e);if(this.data=t||[],this.length=this.data.length,this.compare=e||function(t,e){return t<e?-1:t>e?1:0},this.length>0)for(var n=(this.length>>1)-1;n>=0;n--)this._down(n)}function xt(t,e,n){e=Math.max(0,void 0===e?2:e),n=n||0;for(var r,i=function(t){for(var e=t[0],n=t[0],r=t[0],i=t[0],o=0;o<t.length;o++){var s=t[o];s[0]<e[0]&&(e=s),s[0]>r[0]&&(r=s),s[1]<n[1]&&(n=s),s[1]>i[1]&&(i=s)}var a=[e,n,r,i],u=a.slice();for(o=0;o<t.length;o++)is(t[o],a)||u.push(t[o]);var c=ts(u),h=[];for(o=0;o<c.length;o++)h.push(u[c[o]]);return h}(t),o=Vo(16,["[0]","[1]","[0]","[1]"]).load(t),s=[],a=0;a<i.length;a++){var u=i[a];o.remove(u),r=Nt(u,r),s.push(r)}var c=Vo(16);for(a=0;a<s.length;a++)c.insert(It(s[a]));for(var h=e*e,l=n*n;s.length;){var p=s.shift(),f=p.p,g=p.next.p,d=Ct(f,g);if(!(d<l)){var y=d/h;(u=function(t,e,n,r,i,o,s){var a=new ns(null,Et),u=t.data;for(;u;){for(var c=0;c<u.children.length;c++){var h=u.children[c],l=u.leaf?St(h,n,r):function(t,e,n){if(wt(t,n)||wt(e,n))return 0;var r=Mt(t[0],t[1],e[0],e[1],n.minX,n.minY,n.maxX,n.minY);if(0===r)return 0;var i=Mt(t[0],t[1],e[0],e[1],n.minX,n.minY,n.minX,n.maxY);if(0===i)return 0;var o=Mt(t[0],t[1],e[0],e[1],n.maxX,n.minY,n.maxX,n.maxY);if(0===o)return 0;var s=Mt(t[0],t[1],e[0],e[1],n.minX,n.maxY,n.maxX,n.maxY);return 0===s?0:Math.min(r,i,o,s)}(n,r,h);l>o||a.push({node:h,dist:l})}for(;a.length&&!a.peek().node.children;){var p=a.pop(),f=p.node,g=St(f,e,n),d=St(f,r,i);if(p.dist<g&&p.dist<d&&bt(n,f,s)&&bt(r,f,s))return f}(u=a.pop())&&(u=u.node)}return null}(o,p.prev.p,f,g,p.next.next.p,y,c))&&Math.min(Ct(u,f),Ct(u,g))<=y&&(s.push(p),s.push(Nt(u,p)),o.remove(u),c.remove(p),c.insert(It(p)),c.insert(It(p.next)))}}p=r;var _=[];do{_.push(p.p),p=p.next}while(p!==r);return _.push(p.p),_}function Et(t,e){return t.dist-e.dist}function wt(t,e){return t[0]>=e.minX&&t[0]<=e.maxX&&t[1]>=e.minY&&t[1]<=e.maxY}function bt(t,e,n){for(var r=Math.min(t[0],e[0]),i=Math.min(t[1],e[1]),o=Math.max(t[0],e[0]),s=Math.max(t[1],e[1]),a=n.search({minX:r,minY:i,maxX:o,maxY:s}),u=0;u<a.length;u++)if(function(t,e,n,r){return t!==r&&e!==n&&os(t,e,n)>0!=os(t,e,r)>0&&os(n,r,t)>0!=os(n,r,e)>0}(a[u].p,a[u].next.p,t,e))return!1;return!0}function It(t){var e=t.p,n=t.next.p;return t.minX=Math.min(e[0],n[0]),t.minY=Math.min(e[1],n[1]),t.maxX=Math.max(e[0],n[0]),t.maxY=Math.max(e[1],n[1]),t}function Nt(t,e){var n={p:t,prev:null,next:null,minX:0,minY:0,maxX:0,maxY:0};return e?(n.next=e.next,n.prev=e,e.next.prev=n,e.next=n):(n.prev=n,n.next=n),n}function Ct(t,e){var n=t[0]-e[0],r=t[1]-e[1];return n*n+r*r}function St(t,e,n){var r=e[0],i=e[1],o=n[0]-r,s=n[1]-i;if(0!==o||0!==s){var a=((t[0]-r)*o+(t[1]-i)*s)/(o*o+s*s);a>1?(r=n[0],i=n[1]):a>0&&(r+=o*a,i+=s*a)}return o=t[0]-r,s=t[1]-i,o*o+s*s}function Mt(t,e,n,r,i,o,s,a){var u,c,h,l,p=n-t,f=r-e,g=s-i,d=a-o,y=t-i,_=e-o,m=p*p+f*f,v=p*g+f*d,x=g*g+d*d,E=p*y+f*_,w=g*y+d*_,b=m*x-v*v,I=b,N=b;0===b?(c=0,I=1,l=w,N=x):(l=m*w-v*E,(c=v*w-x*E)<0?(c=0,l=w,N=x):c>I&&(c=I,l=w+v,N=x)),l<0?(l=0,-E<0?c=0:-E>m?c=I:(c=-E,I=m)):l>N&&(l=N,-E+v<0?c=0:-E+v>m?c=I:(c=-E+v,I=m)),u=0===c?0:c/I;var C=(1-(h=0===l?0:l/N))*i+h*s-((1-u)*t+u*n),S=(1-h)*o+h*a-((1-u)*e+u*r);return C*C+S*S}function Lt(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.concavity||1/0,r=[];if(S(t,function(t){r.push([t[0],t[1]])}),!r.length)return null;var i=ss(r,n);return i.length>3?o([i]):null}function Pt(t,e,n){if("object"!=typeof(n=n||{}))throw new Error("options is invalid");var r=n.ignoreBoundary;if(!t)throw new Error("point is required");if(!e)throw new Error("polygon is required");var i=X(t),o=U(e),s=e.geometry?e.geometry.type:e.type,a=e.bbox;if(a&&!1===function(t,e){return e[0]<=t[0]&&e[1]<=t[1]&&e[2]>=t[0]&&e[3]>=t[1]}(i,a))return!1;"Polygon"===s&&(o=[o]);for(var u=0,c=!1;u<o.length&&!c;u++)if(Ot(i,o[u][0],r)){for(var h=!1,l=1;l<o[u].length&&!h;)Ot(i,o[u][l],!r)&&(h=!0),l++;h||(c=!0)}return c}function Ot(t,e,n){var r=!1;e[0][0]===e[e.length-1][0]&&e[0][1]===e[e.length-1][1]&&(e=e.slice(0,e.length-1));for(var i=0,o=e.length-1;i<e.length;o=i++){var s=e[i][0],a=e[i][1],u=e[o][0],c=e[o][1];if(t[1]*(s-u)+a*(u-t[0])+c*(t[0]-s)==0&&(s-t[0])*(u-t[0])<=0&&(a-t[1])*(c-t[1])<=0)return!n;a>t[1]!=c>t[1]&&t[0]<(u-s)*(t[1]-a)/(c-a)+s&&(r=!r)}return r}function Rt(t,e){var n=[];return A(e,function(e){O(t,function(t){Pt(t,e)&&n.push(t)})}),c(n)}function Tt(t,e){if("FeatureCollection"!==t.type)throw new Error("points must be a FeatureCollection");var n=!1;return c(function(t){if(t.length<3)return[];t.sort(Dt);var e,n,r,i,o,s,a=t.length-1,u=t[a].x,c=t[0].x,h=t[a].y,l=h;for(;a--;)t[a].y<h&&(h=t[a].y),t[a].y>l&&(l=t[a].y);var p,f=c-u,g=l-h,d=f>g?f:g,y=.5*(c+u),_=.5*(l+h),m=[new At({x:y-20*d,y:_-d,__sentinel:!0},{x:y,y:_+20*d,__sentinel:!0},{x:y+20*d,y:_-d,__sentinel:!0})],v=[],x=[];a=t.length;for(;a--;){for(x.length=0,p=m.length;p--;)(f=t[a].x-m[p].x)>0&&f*f>m[p].r?(v.push(m[p]),m.splice(p,1)):(g=t[a].y-m[p].y,f*f+g*g>m[p].r||(x.push(m[p].a,m[p].b,m[p].b,m[p].c,m[p].c,m[p].a),m.splice(p,1)));for(Ft(x),p=x.length;p;)n=x[--p],e=x[--p],r=t[a],i=n.x-e.x,o=n.y-e.y,s=2*(i*(r.y-n.y)-o*(r.x-n.x)),Math.abs(s)>1e-12&&m.push(new At(e,n,r))}Array.prototype.push.apply(v,m),a=v.length;for(;a--;)(v[a].a.__sentinel||v[a].b.__sentinel||v[a].c.__sentinel)&&v.splice(a,1);return v}(t.features.map(function(t){var r={x:t.geometry.coordinates[0],y:t.geometry.coordinates[1]};return e?r.z=t.properties[e]:3===t.geometry.coordinates.length&&(n=!0,r.z=t.geometry.coordinates[2]),r})).map(function(t){var e=[t.a.x,t.a.y],r=[t.b.x,t.b.y],i=[t.c.x,t.c.y],s={};return n?(e.push(t.a.z),r.push(t.b.z),i.push(t.c.z)):s={a:t.a.z,b:t.b.z,c:t.c.z},o([[e,r,i,e]],s)}))}function At(t,e,n){this.a=t,this.b=e,this.c=n;var r,i,o=e.x-t.x,s=e.y-t.y,a=n.x-t.x,u=n.y-t.y,c=o*(t.x+e.x)+s*(t.y+e.y),h=a*(t.x+n.x)+u*(t.y+n.y),l=2*(o*(n.y-e.y)-s*(n.x-e.x));this.x=(u*c-s*h)/l,this.y=(o*h-a*c)/l,r=this.x-t.x,i=this.y-t.y,this.r=r*r+i*i}function Dt(t,e){return e.x-t.x}function Ft(t){var e,n,r,i,o,s=t.length;t:for(;s;)for(n=t[--s],e=t[--s],r=s;r;)if(o=t[--r],i=t[--r],e===i&&n===o||e===o&&n===i){t.splice(s,2),t.splice(r,2),s-=2;continue t}}function qt(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.units,i=X(t),o=X(e),s=x(o[1]-i[1]),a=x(o[0]-i[0]),u=x(i[1]),c=x(o[1]),h=Math.pow(Math.sin(s/2),2)+Math.pow(Math.sin(a/2),2)*Math.cos(u)*Math.cos(c);return d(2*Math.atan2(Math.sqrt(h),Math.sqrt(1-h)),r)}function Gt(t){if(!t)throw new Error("geojson is required");switch(t.type){case"Feature":return Bt(t);case"FeatureCollection":return function(t){var e={type:"FeatureCollection"};return Object.keys(t).forEach(function(n){switch(n){case"type":case"features":return;default:e[n]=t[n]}}),e.features=t.features.map(function(t){return Bt(t)}),e}(t);case"Point":case"LineString":case"Polygon":case"MultiPoint":case"MultiLineString":case"MultiPolygon":case"GeometryCollection":return zt(t);default:throw new Error("unknown GeoJSON type")}}function Bt(t){var e={type:"Feature"};return Object.keys(t).forEach(function(n){switch(n){case"type":case"properties":case"geometry":return;default:e[n]=t[n]}}),e.properties=kt(t.properties),e.geometry=zt(t.geometry),e}function kt(t){var e={};return t?(Object.keys(t).forEach(function(n){var r=t[n];"object"==typeof r?null===r?e[n]=null:r.length?e[n]=r.map(function(t){return t}):e[n]=kt(r):e[n]=r}),e):e}function zt(t){var e={type:t.type};return t.bbox&&(e.bbox=t.bbox),"GeometryCollection"===t.type?(e.geometries=t.geometries.map(function(t){return zt(t)}),e):(e.coordinates=jt(t.coordinates),e)}function jt(t){return"object"!=typeof t[0]?t.slice():t.map(function(t){return jt(t)})}function Xt(t,e){function n(t,e){e.length&&e.pop();for(var n=c[t<0?~t:t],r=0,i=n.length;r<i;++r)e.push(u(n[r],r));t<0&&hs(e,i)}function r(t){return u(t)}function i(t){for(var e=[],r=0,i=t.length;r<i;++r)n(t[r],e);return e.length<2&&e.push(e[0]),e}function o(t){for(var e=i(t);e.length<4;)e.push(e[0]);return e}function s(t){return t.map(o)}function a(t){var e,n=t.type;switch(n){case"GeometryCollection":return{type:n,geometries:t.geometries.map(a)};case"Point":e=r(t.coordinates);break;case"MultiPoint":e=t.coordinates.map(r);break;case"LineString":e=i(t.arcs);break;case"MultiLineString":e=t.arcs.map(i);break;case"Polygon":e=s(t.arcs);break;case"MultiPolygon":e=t.arcs.map(s);break;default:return null}return{type:n,coordinates:e}}var u=cs(t.transform),c=t.arcs;return a(e)}function Ut(t,e){function n(t){switch(t.type){case"GeometryCollection":t.geometries.forEach(n);break;case"Polygon":r(t.arcs);break;case"MultiPolygon":t.arcs.forEach(r)}}function r(t){t.forEach(function(e){e.forEach(function(e){(o[e=e<0?~e:e]||(o[e]=[])).push(t)})}),s.push(t)}function i(e){return function(t){for(var e,n=-1,r=t.length,i=t[r-1],o=0;++n<r;)e=i,i=t[n],o+=e[0]*i[1]-e[1]*i[0];return Math.abs(o)}(Xt(t,{type:"Polygon",arcs:[e]}).coordinates[0])}var o={},s=[],a=[];return e.forEach(n),s.forEach(function(t){if(!t._){var e=[],n=[t];for(t._=1,a.push(e);t=n.pop();)e.push(t),t.forEach(function(t){t.forEach(function(t){o[t<0?~t:t].forEach(function(t){t._||(t._=1,n.push(t))})})})}}),s.forEach(function(t){delete t._}),{type:"MultiPolygon",arcs:a.map(function(e){var n,r=[];if(e.forEach(function(t){t.forEach(function(t){t.forEach(function(t){o[t<0?~t:t].length<2&&r.push(t)})})}),r=ls(t,r),(n=r.length)>1)for(var s,a,u=1,c=i(r[0]);u<n;++u)(s=i(r[u]))>c&&(a=r[0],r[0]=r[u],r[u]=a,c=s);return r})}}function Yt(t,e,n){for(var r,i=e+(n---e>>1);e<i;++e,--n)r=t[e],t[e]=t[n],t[n]=r}function Vt(t){return null==t?{type:null}:("FeatureCollection"===t.type?function(t){var e={type:"GeometryCollection",geometries:t.features.map(Ht)};null!=t.bbox&&(e.bbox=t.bbox);return e}:"Feature"===t.type?Ht:Wt)(t)}function Ht(t){var e,n=Wt(t.geometry);null!=t.id&&(n.id=t.id),null!=t.bbox&&(n.bbox=t.bbox);for(e in t.properties){n.properties=t.properties;break}return n}function Wt(t){if(null==t)return{type:null};var e="GeometryCollection"===t.type?{type:"GeometryCollection",geometries:t.geometries.map(Wt)}:"Point"===t.type||"MultiPoint"===t.type?{type:t.type,coordinates:t.coordinates}:{type:t.type,arcs:t.coordinates};return null!=t.bbox&&(e.bbox=t.bbox),e}function Jt(t){var e,n=t[0],r=t[1];return r<n&&(e=n,n=r,r=e),n+31*r}function Zt(t,e){var n,r=t[0],i=t[1],o=e[0],s=e[1];return i<r&&(n=r,r=i,i=n),s<o&&(n=o,o=s,s=n),r===o&&i===s}function Kt(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.mutate;if("FeatureCollection"!==K(t))throw new Error("geojson must be a FeatureCollection");if(!t.features.length)throw new Error("geojson is empty");!1!==n&&void 0!==n||(t=Gt(t));var r=[],i=z(t,function(t,e){var n=function(t,e){var n,r=t.geometry.coordinates,i=e.geometry.coordinates,o=Qt(r[0]),s=Qt(r[r.length-1]),u=Qt(i[0]),c=Qt(i[i.length-1]);if(o===c)n=i.concat(r.slice(1));else if(u===s)n=r.concat(i.slice(1));else if(o===u)n=r.slice(1).reverse().concat(i);else{if(s!==c)return null;n=r.concat(i.reverse().slice(1))}return a(n)}(t,e);return n||(r.push(t),e)});return i&&r.push(i),r.length?1===r.length?r[0]:h(r.map(function(t){return t.coordinates})):null}function Qt(t){return t[0].toString()+","+t[1].toString()}function $t(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.mutate;if("FeatureCollection"!==K(t))throw new Error("geojson must be a FeatureCollection");if(!t.features.length)throw new Error("geojson is empty");!1!==n&&void 0!==n||(t=Gt(t));var r=function(t){var e={};F(t,function(t){e[t.geometry.type]=!0});var n=Object.keys(e);return 1===n.length?n[0]:null}(t);if(!r)throw new Error("geojson must be homogenous");switch(r){case"LineString":return Kt(t,e);case"Polygon":return function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.mutate;if("FeatureCollection"!==K(t))throw new Error("geojson must be a FeatureCollection");if(!t.features.length)throw new Error("geojson is empty");!1!==n&&void 0!==n||(t=Gt(t));var r=[];F(t,function(t){r.push(t.geometry)});var i=ws({geoms:f(r).geometry});return ps(i,i.objects.geoms.geometries)}(t,e);default:throw new Error(r+" is not supported")}}function te(t,n){var r="object"==typeof n?n.mutate:n;if(!t)throw new Error("geojson is required");var i=K(t),o=[];switch(i){case"LineString":o=ee(t);break;case"MultiLineString":case"Polygon":U(t).forEach(function(t){o.push(ee(t))});break;case"MultiPolygon":U(t).forEach(function(t){var e=[];t.forEach(function(t){e.push(ee(t))}),o.push(e)});break;case"Point":return t;case"MultiPoint":var s={};U(t).forEach(function(t){var e=t.join("-");s.hasOwnProperty(e)||(o.push(t),s[e]=!0)});break;default:throw new Error(i+" geometry not supported")}return t.coordinates?!0===r?(t.coordinates=o,t):{type:i,coordinates:o}:!0===r?(t.geometry.coordinates=o,t):e({type:i,coordinates:o},t.properties,t.bbox,t.id)}function ee(t){var e=U(t);if(2===e.length&&!function(t,e){return t[0]===e[0]&&t[1]===e[1]}(e[0],e[1]))return e;var n,r,i,o=[],s=e.length-1;o.push(e[0]);for(var a=1;a<s;a++)n=e[a-1],r=e[a],function(t,e,n){var r=n[0],i=n[1],o=t[0],s=t[1],a=e[0],u=e[1],c=a-o,h=u-s;return(r-o)*h-(i-s)*c==0&&(Math.abs(c)>=Math.abs(h)?c>0?o<=r&&r<=a:a<=r&&r<=o:h>0?s<=i&&i<=u:u<=i&&i<=s)}(n,i=e[a+1],r)||o.push(r);return o.push(i),o}function ne(t,e){var n=t.x-e.x,r=t.y-e.y;return n*n+r*r}function re(t,e,n){var r=e.x,i=e.y,o=n.x-r,s=n.y-i;if(0!==o||0!==s){var a=((t.x-r)*o+(t.y-i)*s)/(o*o+s*s);a>1?(r=n.x,i=n.y):a>0&&(r+=o*a,i+=s*a)}return o=t.x-r,s=t.y-i,o*o+s*s}function ie(t,e,n,r,i){for(var o,s=r,a=e+1;a<n;a++){var u=re(t[a],t[e],t[n]);u>s&&(o=a,s=u)}s>r&&(o-e>1&&ie(t,e,o,r,i),i.push(t[o]),n-o>1&&ie(t,o,n,r,i))}function oe(t,e,n){if(t.length<=2)return t;var r=void 0!==e?e*e:1;return t=n?t:function(t,e){for(var n,r=t[0],i=[r],o=1,s=t.length;o<s;o++)ne(n=t[o],r)>e&&(i.push(n),r=n);return r!==n&&i.push(n),i}(t,r),t=function(t,e){var n=t.length-1,r=[t[0]];return ie(t,0,n,e,r),r.push(t[n]),r}(t,r)}function se(t,e,n){return oe(t.map(function(t){return{x:t[0],y:t[1],z:t[2]}}),e,n).map(function(t){return t.z?[t.x,t.y,t.z]:[t.x,t.y]})}function ae(t,e,n){return t.map(function(t){var r=t.map(function(t){return{x:t[0],y:t[1]}});if(r.length<4)throw new Error("invalid polygon");for(var i=oe(r,e,n).map(function(t){return[t.x,t.y]});!function(t){return!(t.length<3||3===t.length&&t[2][0]===t[0][0]&&t[2][1]===t[0][1])}(i);)i=oe(r,e-=.01*e,n).map(function(t){return[t.x,t.y]});return i[i.length-1][0]===i[0][0]&&i[i.length-1][1]===i[0][1]||i.push(i[0]),i})}function ue(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.resolution||1e4,r=e.sharpness||.85;if(!t)throw new Error("line is required");if(!b(n))throw new Error("resolution must be an number");if(!b(r))throw new Error("sharpness must be an number");for(var i=[],o=new bs({points:J(t).coordinates.map(function(t){return{x:t[0],y:t[1]}}),duration:n,sharpness:r}),s=0;s<o.duration;s+=10){var u=o.pos(s);Math.floor(s/100)%2==0&&i.push([u.x,u.y])}return a(i,t.properties)}function ce(t){N(t);var e=Number(t[0]),n=Number(t[1]),r=Number(t[2]),i=Number(t[3]);if(6===t.length)throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");var s=[e,n];return o([[s,[r,n],[r,i],[e,i],s]])}function he(t){return ce(j(t))}function le(t){var e=t[0],n=t[1],r=t[2],i=t[3];if(qt(t.slice(0,2),[r,n])>=qt(t.slice(0,2),[e,i])){var o=(n+i)/2;return[e,o-(r-e)/2,r,o+(r-e)/2]}var s=(e+r)/2;return[s-(i-n)/2,n,s+(i-n)/2,i]}function pe(t,e,n,i){if(i=i||{},!I(i))throw new Error("options is invalid");var o=i.units,s=i.properties,a=X(t),u=x(a[0]),c=x(a[1]),h=x(n),l=y(e,o),p=Math.asin(Math.sin(c)*Math.cos(l)+Math.cos(c)*Math.sin(l)*Math.cos(h));return r([v(u+Math.atan2(Math.sin(h)*Math.sin(l)*Math.cos(c),Math.cos(l)-Math.sin(c)*Math.sin(p))),v(p)],s)}function fe(t,e,n){var r=(n=n||{}).steps||64,i=n.properties;if(!t)throw new Error("center is required");if(!e)throw new Error("radius is required");if("object"!=typeof n)throw new Error("options must be an object");if("number"!=typeof r)throw new Error("steps must be a number");r=r||64,i=i||t.properties||{};for(var s=[],a=0;a<r;a++)s.push(pe(t,e,-360*a/r,n).geometry.coordinates);return s.push(s[0]),o([s],i)}function ge(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");if(!0===n.final)return function(t,e){var n=ge(e,t);return n=(n+180)%360}(t,e);var r=X(t),i=X(e),o=x(r[0]),s=x(i[0]),a=x(r[1]),u=x(i[1]),c=Math.sin(s-o)*Math.cos(u),h=Math.cos(a)*Math.sin(u)-Math.sin(a)*Math.cos(u)*Math.cos(s-o);return v(Math.atan2(c,h))}function de(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.properties;if(!t)throw new Error("geojson is required");var i=j(t);return r([(i[0]+i[2])/2,(i[1]+i[3])/2],n)}function ye(t,e){var n=0,i=0,o=0;return S(t,function(t){n+=t[0],i+=t[1],o++},!0),r([n/o,i/o],e)}function _e(t,e){switch(K(t)){case"Point":return t;case"Polygon":var n=[];S(t,function(t){n.push(t)});var i,o,s,a,u,c,h,l,p=ye(t,e),f=p.geometry.coordinates,g=0,d=0,y=0,_=n.map(function(t){return[t[0]-f[0],t[1]-f[1]]});for(i=0;i<n.length-1;i++)a=(o=_[i])[0],c=o[1],u=(s=_[i+1])[0],y+=l=a*(h=s[1])-u*c,g+=(a+u)*l,d+=(c+h)*l;if(0===y)return p;var m=1/(6*(.5*y));return r([f[0]+m*g,f[1]+m*d],e);default:var v=Lt(t);return v?_e(v,e):ye(t,e)}}function me(t){var e=[];return"FeatureCollection"===t.type?O(t,function(t){S(t,function(n){e.push(r(n,t.properties))})}):S(t,function(n){e.push(r(n,t.properties))}),c(e)}function ve(t,e,n){n=n||2;var r=e&&e.length,i=r?e[0]*n:t.length,o=xe(t,0,i,n,!0),s=[];if(!o)return s;var a,u,c,h,l,p,f;if(r&&(o=function(t,e,n,r){var i,o,s,a,u,c=[];for(i=0,o=e.length;i<o;i++)s=e[i]*r,a=i<o-1?e[i+1]*r:t.length,(u=xe(t,s,a,r,!1))===u.next&&(u.steiner=!0),c.push(function(t){var e=t,n=t;do{e.x<n.x&&(n=e),e=e.next}while(e!==t);return n}(u));for(c.sort(be),i=0;i<c.length;i++)!function(t,e){if(e=function(t,e){var n,r=e,i=t.x,o=t.y,s=-1/0;do{if(o<=r.y&&o>=r.next.y&&r.next.y!==r.y){var a=r.x+(o-r.y)*(r.next.x-r.x)/(r.next.y-r.y);if(a<=i&&a>s){if(s=a,a===i){if(o===r.y)return r;if(o===r.next.y)return r.next}n=r.x<r.next.x?r:r.next}}r=r.next}while(r!==e);if(!n)return null;if(i===s)return n.prev;var u,c=n,h=n.x,l=n.y,p=1/0;for(r=n.next;r!==c;)i>=r.x&&r.x>=h&&i!==r.x&&Ne(o<l?i:s,o,h,l,o<l?s:i,o,r.x,r.y)&&((u=Math.abs(o-r.y)/(i-r.x))<p||u===p&&r.x>n.x)&&Le(r,t)&&(n=r,p=u),r=r.next;return n}(t,e)){var n=Pe(e,t);Ee(n,n.next)}}(c[i],n),n=Ee(n,n.next);return n}(t,e,o,n)),t.length>80*n){a=c=t[0],u=h=t[1];for(var g=n;g<i;g+=n)l=t[g],p=t[g+1],l<a&&(a=l),p<u&&(u=p),l>c&&(c=l),p>h&&(h=p);f=0!==(f=Math.max(c-a,h-u))?1/f:0}return we(o,s,n,a,u,f),s}function xe(t,e,n,r,i){var o,s;if(i===Ae(t,e,n,r)>0)for(o=e;o<n;o+=r)s=Oe(o,t[o],t[o+1],s);else for(o=n-r;o>=e;o-=r)s=Oe(o,t[o],t[o+1],s);return s&&Se(s,s.next)&&(Re(s),s=s.next),s}function Ee(t,e){if(!t)return t;e||(e=t);var n,r=t;do{if(n=!1,r.steiner||!Se(r,r.next)&&0!==Ce(r.prev,r,r.next))r=r.next;else{if(Re(r),(r=e=r.prev)===r.next)break;n=!0}}while(n||r!==e);return e}function we(t,e,n,r,i,o,s){if(t){!s&&o&&function(t,e,n,r){var i=t;do{null===i.z&&(i.z=Ie(i.x,i.y,e,n,r)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,n,r,i,o,s,a,u,c=1;do{for(n=t,t=null,o=null,s=0;n;){for(s++,r=n,a=0,e=0;e<c&&(a++,r=r.nextZ);e++);for(u=c;a>0||u>0&&r;)0!==a&&(0===u||!r||n.z<=r.z)?(i=n,n=n.nextZ,a--):(i=r,r=r.nextZ,u--),o?o.nextZ=i:t=i,i.prevZ=o,o=i;n=r}o.nextZ=null,c*=2}while(s>1)}(i)}(t,r,i,o);for(var a,u,c=t;t.prev!==t.next;)if(a=t.prev,u=t.next,o?function(t,e,n,r){var i=t.prev,o=t,s=t.next;if(Ce(i,o,s)>=0)return!1;var a=i.x<o.x?i.x<s.x?i.x:s.x:o.x<s.x?o.x:s.x,u=i.y<o.y?i.y<s.y?i.y:s.y:o.y<s.y?o.y:s.y,c=i.x>o.x?i.x>s.x?i.x:s.x:o.x>s.x?o.x:s.x,h=i.y>o.y?i.y>s.y?i.y:s.y:o.y>s.y?o.y:s.y,l=Ie(a,u,e,n,r),p=Ie(c,h,e,n,r),f=t.nextZ;for(;f&&f.z<=p;){if(f!==t.prev&&f!==t.next&&Ne(i.x,i.y,o.x,o.y,s.x,s.y,f.x,f.y)&&Ce(f.prev,f,f.next)>=0)return!1;f=f.nextZ}f=t.prevZ;for(;f&&f.z>=l;){if(f!==t.prev&&f!==t.next&&Ne(i.x,i.y,o.x,o.y,s.x,s.y,f.x,f.y)&&Ce(f.prev,f,f.next)>=0)return!1;f=f.prevZ}return!0}(t,r,i,o):function(t){var e=t.prev,n=t,r=t.next;if(Ce(e,n,r)>=0)return!1;var i=t.next.next;for(;i!==t.prev;){if(Ne(e.x,e.y,n.x,n.y,r.x,r.y,i.x,i.y)&&Ce(i.prev,i,i.next)>=0)return!1;i=i.next}return!0}(t))e.push(a.i/n),e.push(t.i/n),e.push(u.i/n),Re(t),t=u.next,c=u.next;else if((t=u)===c){s?1===s?we(t=function(t,e,n){var r=t;do{var i=r.prev,o=r.next.next;!Se(i,o)&&Me(i,r,r.next,o)&&Le(i,o)&&Le(o,i)&&(e.push(i.i/n),e.push(r.i/n),e.push(o.i/n),Re(r),Re(r.next),r=t=o),r=r.next}while(r!==t);return r}(t,e,n),e,n,r,i,o,2):2===s&&function(t,e,n,r,i,o){var s=t;do{for(var a=s.next.next;a!==s.prev;){if(s.i!==a.i&&function(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var n=t;do{if(n.i!==t.i&&n.next.i!==t.i&&n.i!==e.i&&n.next.i!==e.i&&Me(n,n.next,t,e))return!0;n=n.next}while(n!==t);return!1}(t,e)&&Le(t,e)&&Le(e,t)&&function(t,e){var n=t,r=!1,i=(t.x+e.x)/2,o=(t.y+e.y)/2;do{n.y>o!=n.next.y>o&&n.next.y!==n.y&&i<(n.next.x-n.x)*(o-n.y)/(n.next.y-n.y)+n.x&&(r=!r),n=n.next}while(n!==t);return r}(t,e)}(s,a)){var u=Pe(s,a);return s=Ee(s,s.next),u=Ee(u,u.next),we(s,e,n,r,i,o),void we(u,e,n,r,i,o)}a=a.next}s=s.next}while(s!==t)}(t,e,n,r,i,o):we(Ee(t),e,n,r,i,o,1);break}}}function be(t,e){return t.x-e.x}function Ie(t,e,n,r,i){return t=32767*(t-n)*i,e=32767*(e-r)*i,t=16711935&(t|t<<8),t=252645135&(t|t<<4),t=858993459&(t|t<<2),t=1431655765&(t|t<<1),e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),t|e<<1}function Ne(t,e,n,r,i,o,s,a){return(i-s)*(e-a)-(t-s)*(o-a)>=0&&(t-s)*(r-a)-(n-s)*(e-a)>=0&&(n-s)*(o-a)-(i-s)*(r-a)>=0}function Ce(t,e,n){return(e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y)}function Se(t,e){return t.x===e.x&&t.y===e.y}function Me(t,e,n,r){return!!(Se(t,e)&&Se(n,r)||Se(t,r)&&Se(n,e))||Ce(t,e,n)>0!=Ce(t,e,r)>0&&Ce(n,r,t)>0!=Ce(n,r,e)>0}function Le(t,e){return Ce(t.prev,t,t.next)<0?Ce(t,e,t.next)>=0&&Ce(t,t.prev,e)>=0:Ce(t,e,t.prev)<0||Ce(t,t.next,e)<0}function Pe(t,e){var n=new Te(t.i,t.x,t.y),r=new Te(e.i,e.x,e.y),i=t.next,o=e.prev;return t.next=e,e.prev=t,n.next=i,i.prev=n,r.next=n,n.prev=r,o.next=r,r.prev=o,r}function Oe(t,e,n,r){var i=new Te(t,e,n);return r?(i.next=r.next,i.prev=r,r.next.prev=i,r.next=i):(i.prev=i,i.next=i),i}function Re(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)}function Te(t,e,n){this.i=t,this.x=e,this.y=n,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1}function Ae(t,e,n,r){for(var i=0,o=e,s=n-r;o<n;o+=r)i+=(t[s]-t[o])*(t[o+1]+t[s+1]),s=o;return i}function De(t){var e=function(t){for(var e=t[0][0].length,n={vertices:[],holes:[],dimensions:e},r=0,i=0;i<t.length;i++){for(var o=0;o<t[i].length;o++)for(var s=0;s<e;s++)n.vertices.push(t[i][o][s]);i>0&&(r+=t[i-1].length,n.holes.push(r))}return n}(t),n=Is(e.vertices,e.holes,2),r=[],i=[];n.forEach(function(t,r){var o=n[r];i.push([e.vertices[2*o],e.vertices[2*o+1]])});for(var s=0;s<i.length;s+=3){var a=i.slice(s,s+3);a.push(i[s]),r.push(o([a]))}return r}function Fe(t,e){if(!t)throw new Error("targetPoint is required");if(!e)throw new Error("points is required");var n,r=1/0;return O(e,function(e,i){var o=qt(t,e);o<r&&((n=Gt(e)).properties.featureIndex=i,n.properties.distanceToPoint=o,r=o)}),n}function qe(t,e,n,r,i){Ge(t,e,n||0,r||t.length-1,i||function(t,e){return t<e?-1:t>e?1:0})}function Ge(t,e,n,r,i){for(;r>n;){if(r-n>600){var o=r-n+1,s=e-n+1,a=Math.log(o),u=.5*Math.exp(2*a/3),c=.5*Math.sqrt(a*u*(o-u)/o)*(s-o/2<0?-1:1);Ge(t,e,Math.max(n,Math.floor(e-s*u/o+c)),Math.min(r,Math.floor(e+(o-s)*u/o+c)),i)}var h=t[e],l=n,p=r;for(Be(t,n,e),i(t[r],h)>0&&Be(t,n,r);l<p;){for(Be(t,l,p),l++,p--;i(t[l],h)<0;)l++;for(;i(t[p],h)>0;)p--}0===i(t[n],h)?Be(t,n,p):Be(t,++p,r),p<=e&&(n=p+1),e<=p&&(r=p-1)}}function Be(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function ke(t,e){if(!(this instanceof ke))return new ke(t,e);this._maxEntries=Math.max(4,t||9),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),e&&this._initFormat(e),this.clear()}function ze(t,e){je(t,0,t.children.length,e,t)}function je(t,e,n,r,i){i||(i=Ze(null)),i.minX=1/0,i.minY=1/0,i.maxX=-1/0,i.maxY=-1/0;for(var o,s=e;s<n;s++)o=t.children[s],Xe(i,t.leaf?r(o):o);return i}function Xe(t,e){return t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),t}function Ue(t,e){return t.minX-e.minX}function Ye(t,e){return t.minY-e.minY}function Ve(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function He(t){return t.maxX-t.minX+(t.maxY-t.minY)}function We(t,e){return t.minX<=e.minX&&t.minY<=e.minY&&e.maxX<=t.maxX&&e.maxY<=t.maxY}function Je(t,e){return e.minX<=t.maxX&&e.minY<=t.maxY&&e.maxX>=t.minX&&e.maxY>=t.minY}function Ze(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function Ke(t,e,n,r,i){for(var o,s=[e,n];s.length;)(n=s.pop())-(e=s.pop())<=r||(qe(t,o=e+Math.ceil((n-e)/r/2)*r,e,n,i),s.push(e,o,o,n))}function Qe(t){var e=ke(t);return e.insert=function(t){if(Array.isArray(t)){var e=t;(t=$e(e)).bbox=e}else t.bbox=t.bbox?t.bbox:tn(t);return ke.prototype.insert.call(this,t)},e.load=function(t){var e=[];return Array.isArray(t)?t.forEach(function(t){var n=$e(t);n.bbox=t,e.push(n)}):O(t,function(t){t.bbox=t.bbox?t.bbox:tn(t),e.push(t)}),ke.prototype.load.call(this,e)},e.remove=function(t){if(Array.isArray(t)){var e=t;(t=$e(e)).bbox=e}return ke.prototype.remove.call(this,t)},e.clear=function(){return ke.prototype.clear.call(this)},e.search=function(t){return{type:"FeatureCollection",features:ke.prototype.search.call(this,this.toBBox(t))}},e.collides=function(t){return ke.prototype.collides.call(this,this.toBBox(t))},e.all=function(){return{type:"FeatureCollection",features:ke.prototype.all.call(this)}},e.toJSON=function(){return ke.prototype.toJSON.call(this)},e.fromJSON=function(t){return ke.prototype.fromJSON.call(this,t)},e.toBBox=function(t){var e;return e=t.bbox?t.bbox:Array.isArray(t)&&4===t.length?t:tn(t),{minX:e[0],minY:e[1],maxX:e[2],maxY:e[3]}},e}function $e(t){var e=[t[0],t[1]],n=[t[0],t[3]],r=[t[2],t[3]];return{type:"Feature",bbox:t,properties:{},geometry:{type:"Polygon",coordinates:[[e,[t[2],t[1]],r,n,e]]}}}function tn(t){var e=[1/0,1/0,-1/0,-1/0];return S(t,function(t){e[0]>t[0]&&(e[0]=t[0]),e[1]>t[1]&&(e[1]=t[1]),e[2]<t[0]&&(e[2]=t[0]),e[3]<t[1]&&(e[3]=t[1])}),e}function en(t){if(!t)throw new Error("geojson is required");var e=[];return F(t,function(t){!function(t,e){var n=[],r=t.geometry;switch(r.type){case"Polygon":n=U(r);break;case"LineString":n=[U(r)]}n.forEach(function(n){var r=function(t,e){var n=[];return t.reduce(function(t,r){var i=a([t,r],e);return i.bbox=function(t,e){var n=t[0],r=t[1],i=e[0],o=e[1];return[n<i?n:i,r<o?r:o,n>i?n:i,r>o?r:o]}(t,r),n.push(i),r}),n}(n,t.properties);r.forEach(function(t){t.id=e.length,e.push(t)})})}(t,e)}),c(e)}function nn(t,n){var r={},i=[];if("LineString"===t.type&&(t=e(t)),"LineString"===n.type&&(n=e(n)),"Feature"===t.type&&"Feature"===n.type&&"LineString"===t.geometry.type&&"LineString"===n.geometry.type&&2===t.geometry.coordinates.length&&2===n.geometry.coordinates.length){var o=rn(t,n);return o&&i.push(o),c(i)}var s=Qe();return s.load(en(n)),O(en(t),function(t){O(s.search(t),function(e){var n=rn(t,e);if(n){var o=U(n).join(",");r[o]||(r[o]=!0,i.push(n))}})}),c(i)}function rn(t,e){var n=U(t),i=U(e);if(2!==n.length)throw new Error("<intersects> line1 must only contain 2 coordinates");if(2!==i.length)throw new Error("<intersects> line2 must only contain 2 coordinates");var o=n[0][0],s=n[0][1],a=n[1][0],u=n[1][1],c=i[0][0],h=i[0][1],l=i[1][0],p=i[1][1],f=(p-h)*(a-o)-(l-c)*(u-s),g=(l-c)*(s-h)-(p-h)*(o-c),d=(a-o)*(s-h)-(u-s)*(o-c);if(0===f)return null;var y=g/f,_=d/f;if(y>=0&&y<=1&&_>=0&&_<=1){return r([o+y*(a-o),s+y*(u-s)])}return null}function on(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var i=t.geometry?t.geometry.type:t.type;if("LineString"!==i&&"MultiLineString"!==i)throw new Error("lines must be LineString or MultiLineString");var o=r([1/0,1/0],{dist:1/0}),s=0;return F(t,function(t){for(var i=U(t),u=0;u<i.length-1;u++){var c=r(i[u]);c.properties.dist=qt(e,c,n);var h=r(i[u+1]);h.properties.dist=qt(e,h,n);var l=qt(c,h,n),p=Math.max(c.properties.dist,h.properties.dist),f=ge(c,h),g=pe(e,p,f+90,n),d=pe(e,p,f-90,n),y=nn(a([g.geometry.coordinates,d.geometry.coordinates]),a([c.geometry.coordinates,h.geometry.coordinates])),_=null;y.features.length>0&&((_=y.features[0]).properties.dist=qt(e,_,n),_.properties.location=s+qt(c,_,n)),c.properties.dist<o.properties.dist&&((o=c).properties.index=u,o.properties.location=s),h.properties.dist<o.properties.dist&&((o=h).properties.index=u+1,o.properties.location=s+l),_&&_.properties.dist<o.properties.dist&&((o=_).properties.index=u),s+=l}}),o}function sn(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.final;if(!t)throw new Error("start point is required");if(!e)throw new Error("end point is required");var i;return(i=r?an(X(e),X(t)):an(X(t),X(e)))>180?-(360-i):i}function an(t,e){var n=x(t[1]),r=x(e[1]),i=x(e[0]-t[0]);i>Math.PI&&(i-=2*Math.PI),i<-Math.PI&&(i+=2*Math.PI);var o=Math.log(Math.tan(r/2+Math.PI/4)/Math.tan(n/2+Math.PI/4));return(v(Math.atan2(i,o))+360)%360}function un(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.units;if(!t)throw new Error("from point is required");if(!e)throw new Error("to point is required");var i=X(t),o=X(e);o[0]+=o[0]-i[0]>180?-360:i[0]-o[0]>180?360:0;return E(function(t,e,n){var r=n=void 0===n?Fo:Number(n),i=t[1]*Math.PI/180,o=e[1]*Math.PI/180,s=o-i,a=Math.abs(e[0]-t[0])*Math.PI/180;a>Math.PI&&(a-=2*Math.PI);var u=Math.log(Math.tan(o/2+Math.PI/4)/Math.tan(i/2+Math.PI/4)),c=Math.abs(u)>1e-11?s/u:Math.cos(i);return Math.sqrt(s*s+c*c*a*a)*r}(i,o),"meters",r)}function cn(t,e){return ln(t,"mercator",e)}function hn(t,e){return ln(t,"wgs84",e)}function ln(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.mutate;if(!t)throw new Error("geojson is required");return Array.isArray(t)&&b(t[0])?t="mercator"===e?pn(t):fn(t):(!0!==r&&(t=Gt(t)),S(t,function(t){var n="mercator"===e?pn(t):fn(t);t[0]=n[0],t[1]=n[1]})),t}function pn(t){var e=Math.PI/180,n=20037508.342789244,r=[6378137*(Math.abs(t[0])<=180?t[0]:t[0]-360*function(t){return t<0?-1:t>0?1:0}(t[0]))*e,6378137*Math.log(Math.tan(.25*Math.PI+.5*t[1]*e))];return r[0]>n&&(r[0]=n),r[0]<-n&&(r[0]=-n),r[1]>n&&(r[1]=n),r[1]<-n&&(r[1]=-n),r}function fn(t){var e=180/Math.PI;return[t[0]*e/6378137,(.5*Math.PI-2*Math.atan(Math.exp(-t[1]/6378137)))*e]}function gn(t,n,i){if(i=i||{},!I(i))throw new Error("options is invalid");if(!t)throw new Error("pt is required");if(Array.isArray(t)?t=r(t):"Point"===t.type?t=e(t):H(t,"Point","point"),!n)throw new Error("line is required");Array.isArray(n)?n=a(n):"LineString"===n.type?n=e(n):H(n,"LineString","line");var o=1/0,s=t.geometry.coordinates;return G(n,function(t){var e=t.geometry.coordinates[0],n=t.geometry.coordinates[1],a=function(t,e,n,i){var o=i.mercator,s=!0!==o?qt(e,t,i):dn(e,t,i),a=m(!0!==o?ge(e,t):sn(e,t)),u=m(!0!==o?ge(e,n):sn(e,n)),c=Math.abs(a-u);if(c>90)return s;var h=(u+180)%360,l=m(!0!==o?ge(n,t):sn(n,t)),p=Math.abs(l-h);p>180&&(p=Math.abs(p-360));return p>90?!0!==o?qt(t,n,i):dn(t,n,i):!0!==o?s*Math.sin(x(c)):function(t,e,n,i){var o=0;(Math.abs(t[0])>=180||Math.abs(e[0])>=180||Math.abs(n[0])>=180)&&(o=t[0]>0||e[0]>0||n[0]>0?-180:180);var s=r(n),a=cn([t[0]+o,t[1]]),u=cn([e[0]+o,e[1]]),c=cn([n[0]+o,n[1]]),h=hn(function(t,e,n){var r=t[0],i=t[1],o=e[0],s=e[1],a=n[0],u=n[1],c=o-r,h=s-i,l=((a-r)*c+(u-i)*h)/(c*c+h*h);return[r+l*c,i+l*h]}(a,u,c));return 0!==o&&(h[0]-=o),un(s,h,i)}(e,n,t,i)}(s,e,n,i);o>a&&(o=a)}),o}function dn(t,e,n){var r=n.units,i=0;Math.abs(t[0])>=180&&(i=t[0]>0?-180:180),Math.abs(e[0])>=180&&(i=e[0]>0?-180:180);var o=cn([t[0]+i,t[1]]),s=cn([e[0]+i,e[1]]),a=function(t){return t*t},u=a(o[0]-s[0])+a(o[1]-s[1]);return E(Math.sqrt(u),"meters",r)}function yn(t){for(var n=function(t){if("FeatureCollection"!==t.type)return"Feature"!==t.type?c([e(t)]):c([t]);return t}(t),i=de(n),o=!1,s=0;!o&&s<n.features.length;){var a,u=n.features[s].geometry,h=!1;if("Point"===u.type)i.geometry.coordinates[0]===u.coordinates[0]&&i.geometry.coordinates[1]===u.coordinates[1]&&(o=!0);else if("MultiPoint"===u.type){var l=!1;for(a=0;!l&&a<u.coordinates.length;)i.geometry.coordinates[0]===u.coordinates[a][0]&&i.geometry.coordinates[1]===u.coordinates[a][1]&&(o=!0,l=!0),a++}else if("LineString"===u.type)for(a=0;!h&&a<u.coordinates.length-1;)_n(i.geometry.coordinates[0],i.geometry.coordinates[1],u.coordinates[a][0],u.coordinates[a][1],u.coordinates[a+1][0],u.coordinates[a+1][1])&&(h=!0,o=!0),a++;else if("MultiLineString"===u.type)for(var p=0;p<u.coordinates.length;){h=!1,a=0;for(var f=u.coordinates[p];!h&&a<f.length-1;)_n(i.geometry.coordinates[0],i.geometry.coordinates[1],f[a][0],f[a][1],f[a+1][0],f[a+1][1])&&(h=!0,o=!0),a++;p++}else"Polygon"!==u.type&&"MultiPolygon"!==u.type||Pt(i,u)&&(o=!0);s++}if(o)return i;var g=c([]);for(s=0;s<n.features.length;s++)g.features=g.features.concat(me(n.features[s]).features);return r(Fe(i,g).geometry.coordinates)}function _n(t,e,n,r,i,o){return Math.sqrt((i-n)*(i-n)+(o-r)*(o-r))===Math.sqrt((t-n)*(t-n)+(e-r)*(e-r))+Math.sqrt((i-t)*(i-t)+(o-e)*(o-e))}function mn(t){return D(t,function(t,e){return t+vn(e)},0)}function vn(t){var e,n=0;switch(t.type){case"Polygon":return xn(t.coordinates);case"MultiPolygon":for(e=0;e<t.coordinates.length;e++)n+=xn(t.coordinates[e]);return n;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(e=0;e<t.geometries.length;e++)n+=vn(t.geometries[e]);return n}}function xn(t){var e=0;if(t&&t.length>0){e+=Math.abs(En(t[0]));for(var n=1;n<t.length;n++)e-=Math.abs(En(t[n]))}return e}function En(t){var e,n,r,i,o,s,a=0,u=t.length;if(u>2){for(s=0;s<u;s++)s===u-2?(r=u-2,i=u-1,o=0):s===u-1?(r=u-1,i=0,o=1):(r=s,i=s+1,o=s+2),e=t[r],n=t[i],a+=(wn(t[o][0])-wn(e[0]))*Math.sin(wn(n[1]));a=a*Ss*Ss/2}return a}function wn(t){return t*Math.PI/180}function bn(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");if(!t)throw new Error("geojson is required");return B(t,function(t,n){var r=n.geometry.coordinates;return t+qt(r[0],r[1],e)},0)}function In(t,e,n,r){if(r=r||{},!I(r))throw new Error("options is invalid");var i,o=[];if("Feature"===t.type)i=t.geometry.coordinates;else{if("LineString"!==t.type)throw new Error("input must be a LineString Feature or Geometry");i=t.coordinates}for(var s,u,c,h=0,l=0;l<i.length&&!(e>=h&&l===i.length-1);l++){if(h>e&&0===o.length){if(!(s=e-h))return o.push(i[l]),a(o);u=ge(i[l],i[l-1])-180,c=pe(i[l],s,u,r),o.push(c.geometry.coordinates)}if(h>=n)return(s=n-h)?(u=ge(i[l],i[l-1])-180,c=pe(i[l],s,u,r),o.push(c.geometry.coordinates),a(o)):(o.push(i[l]),a(o));if(h>=e&&o.push(i[l]),l===i.length-1)return a(o);h+=qt(i[l],i[l+1],r)}return a(i[i.length-1])}function Nn(t,e,n){var r=(n=n||{}).ignoreEndVertices;if(!I(n))throw new Error("invalid options");if(!t)throw new Error("pt is required");if(!e)throw new Error("line is required");for(var i=X(t),o=U(e),s=0;s<o.length-1;s++){var a=!1;if(r&&(0===s&&(a="start"),s===o.length-2&&(a="end"),0===s&&s+1===o.length-1&&(a="both")),function(t,e,n,r){var i=n[0],o=n[1],s=t[0],a=t[1],u=e[0],c=e[1],h=n[0]-s,l=n[1]-a,p=u-s,f=c-a;if(h*f-l*p!=0)return!1;{if(!r)return Math.abs(p)>=Math.abs(f)?p>0?s<=i&&i<=u:u<=i&&i<=s:f>0?a<=o&&o<=c:c<=o&&o<=a;if("start"===r)return Math.abs(p)>=Math.abs(f)?p>0?s<i&&i<=u:u<=i&&i<s:f>0?a<o&&o<=c:c<=o&&o<a;if("end"===r)return Math.abs(p)>=Math.abs(f)?p>0?s<=i&&i<u:u<i&&i<=s:f>0?a<=o&&o<c:c<o&&o<=a;if("both"===r)return Math.abs(p)>=Math.abs(f)?p>0?s<i&&i<u:u<i&&i<s:f>0?a<o&&o<c:c<o&&o<a}}(o[s],o[s+1],i,a))return!0}return!1}function Cn(t,e){var n=K(t),r=K(e),i=J(t),o=J(e);switch(n){case"Point":switch(r){case"MultiPoint":return function(t,e){var n,r=!1;for(n=0;n<e.coordinates.length;n++)if(Mn(e.coordinates[n],t.coordinates)){r=!0;break}return r}(i,o);case"LineString":return Nn(i,o,{ignoreEndVertices:!0});case"Polygon":return Pt(i,o,{ignoreBoundary:!0});default:throw new Error("feature2 "+r+" geometry not supported")}case"MultiPoint":switch(r){case"MultiPoint":return function(t,e){for(var n=0;n<t.coordinates.length;n++){for(var r=!1,i=0;i<e.coordinates.length;i++)Mn(t.coordinates[n],e.coordinates[i])&&(r=!0);if(!r)return!1}return!0}(i,o);case"LineString":return function(t,e){for(var n=!1,r=0;r<t.coordinates.length;r++){if(!Nn(t.coordinates[r],e))return!1;n||(n=Nn(t.coordinates[r],e,{ignoreEndVertices:!0}))}return n}(i,o);case"Polygon":return function(t,e){for(var n=!0,r=0;r<t.coordinates.length;r++){var i=Pt(t.coordinates[1],e);if(!i){n=!1;break}i=Pt(t.coordinates[1],e,{ignoreBoundary:!0})}return n&&i}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"LineString":switch(r){case"LineString":return function(t,e){for(var n=0;n<t.coordinates.length;n++)if(!Nn(t.coordinates[n],e))return!1;return!0}(i,o);case"Polygon":return function(t,e){var n=j(e),r=j(t);if(!Sn(n,r))return!1;for(var i=!1,o=0;o<t.coordinates.length-1;o++){if(!Pt(t.coordinates[o],e))return!1;if(i||(i=Pt(t.coordinates[o],e,{ignoreBoundary:!0})),!i){var s=function(t,e){return[(t[0]+e[0])/2,(t[1]+e[1])/2]}(t.coordinates[o],t.coordinates[o+1]);i=Pt(s,e,{ignoreBoundary:!0})}}return i}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"Polygon":switch(r){case"Polygon":return function(t,e){var n=j(t);if(!Sn(j(e),n))return!1;for(var r=0;r<t.coordinates[0].length;r++)if(!Pt(t.coordinates[0][r],e))return!1;return!0}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}default:throw new Error("feature1 "+n+" geometry not supported")}}function Sn(t,e){return!(t[0]>e[0])&&(!(t[2]<e[2])&&(!(t[1]>e[1])&&!(t[3]<e[3])))}function Mn(t,e){return t[0]===e[0]&&t[1]===e[1]}function Ln(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var i=n.mask,o=n.properties,s=[];if(null===e||void 0===e)throw new Error("cellSide is required");if(!b(e))throw new Error("cellSide is invalid");if(!t)throw new Error("bbox is required");if(!Array.isArray(t))throw new Error("bbox must be array");if(4!==t.length)throw new Error("bbox must contain 4 numbers");if(i&&-1===["Polygon","MultiPolygon"].indexOf(K(i)))throw new Error("options.mask must be a (Multi)Polygon");for(var a=t[0],u=t[1],h=t[2],l=t[3],p=e/qt([a,u],[h,u],n)*(h-a),f=e/qt([a,u],[a,l],n)*(l-u),g=h-a,d=l-u,y=Math.floor(g/p),_=(d-Math.floor(d/f)*f)/2,m=a+(g-y*p)/2;m<=h;){for(var v=u+_;v<=l;){var x=r([m,v],o);i?Cn(x,i)&&s.push(x):s.push(x),v+=f}m+=p}return c(s)}function Pn(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.precision,r=e.coordinates,i=e.mutate;if(n=void 0===n||null===n||isNaN(n)?6:n,r=void 0===r||null===r||isNaN(r)?3:r,!t)throw new Error("<geojson> is required");if("number"!=typeof n)throw new Error("<precision> must be a number");if("number"!=typeof r)throw new Error("<coordinates> must be a number");!1!==i&&void 0!==i||(t=JSON.parse(JSON.stringify(t)));var o=Math.pow(10,n);return S(t,function(t){!function(t,e,n){t.length>n&&t.splice(n,t.length);for(var r=0;r<t.length;r++)t[r]=Math.round(t[r]*e)/e}(t,o,r)}),t}function On(t,e){if(!t||!e)return!1;if(t.length!==e.length)return!1;for(var n=0,r=t.length;n<r;n++)if(t[n]instanceof Array&&e[n]instanceof Array){if(!On(t[n],e[n]))return!1}else if(t[n]!==e[n])return!1;return!0}function Rn(t,e){if(void 0===e&&(e=!0),3!=t.length)throw new Error("This function requires an array of three points [x,y]");return(t[1][0]-t[0][0])*(t[2][1]-t[0][1])-(t[1][1]-t[0][1])*(t[2][0]-t[0][0])>=0==e}function Tn(t,e){if(!t||!e)return!1;if(t.length!=e.length)return!1;for(var n=0,r=t.length;n<r;n++)if(t[n]instanceof Array&&e[n]instanceof Array){if(!Tn(t[n],e[n]))return!1}else if(t[n]!=e[n])return!1;return!0}function An(t,e){var n=[],r=Qe();return F(e,function(e){if(n.forEach(function(t,e){t.id=e}),n.length){var i=r.search(e);if(i.features.length){var o=Fn(e,i);n=n.filter(function(t){return t.id!==o.id}),r.remove(o),O(Dn(o,e),function(t){n.push(t),r.insert(t)})}}else(n=Dn(t,e).features).forEach(function(t){t.bbox||(t.bbox=le(j(t)))}),r.load(c(n))}),c(n)}function Dn(t,e){var n=[],r=U(t)[0],i=U(t)[t.geometry.coordinates.length-1];if(qn(r,X(e))||qn(i,X(e)))return c([t]);var o=Qe(),s=en(t);o.load(s);var u=o.search(e);if(!u.features.length)return c([t]);var h=Fn(e,u),l=R(s,function(t,r,i){var o=U(r)[1],s=X(e);return i===h.id?(t.push(s),n.push(a(t)),qn(s,o)?[s]:[s,o]):(t.push(o),t)},[r]);return l.length>1&&n.push(a(l)),c(n)}function Fn(t,e){if(!e.features.length)throw new Error("lines must contain features");if(1===e.features.length)return e.features[0];var n,r=1/0;return O(e,function(e){var i=on(e,t).properties.dist;i<r&&(n=e,r=i)}),n}function qn(t,e){return t[0]===e[0]&&t[1]===e[1]}function Gn(t,e,n,r,i){if(i=i||{},!I(i))throw new Error("options is invalid");var o=i.steps,s=i.units;if(!t)throw new Error("center is required");if(!e)throw new Error("radius is required");if(void 0===n||null===n)throw new Error("bearing1 is required");if(void 0===r||null===r)throw new Error("bearing2 is required");if("object"!=typeof i)throw new Error("options must be an object");o=o||64;var u=Bn(n),c=Bn(r),h=t.properties;if(u===c)return a(fe(t,e,i).geometry.coordinates[0],h);for(var l=u,p=u<c?c:c+360,f=l,g=[],d=0;f<p;)g.push(pe(t,e,f,s).geometry.coordinates),f=l+360*++d/o;return f>p&&g.push(pe(t,e,p,s).geometry.coordinates),a(g,h)}function Bn(t){var e=t%360;return e<0&&(e+=360),e}function kn(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.properties,r=K(t),i=U(t);if(n=n||t.properties||{},!i.length)throw new Error("polygon must contain coordinates");switch(r){case"Polygon":return zn(i,n);case"MultiPolygon":var o=[];return i.forEach(function(t){o.push(zn(t,n))}),c(o);default:throw new Error("geom "+r+" not supported")}}function zn(t,e){return t.length>1?h(t,e):a(t[0],e)}function jn(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.properties,r=e.autoComplete,i=e.orderCoords;if(!t)throw new Error("lines is required");r=void 0===r||r,i=void 0===i||i;switch(K(t)){case"FeatureCollection":case"GeometryCollection":var o=[];return(t.features?t.features:t.geometries).forEach(function(t){o.push(U(Xn(t,{},r,i)))}),p(o,n)}return Xn(t,n,r,i)}function Xn(t,e,n,r){e=e||t.properties||{};var i=U(t),s=K(t);if(!i.length)throw new Error("line must contain coordinates");switch(s){case"LineString":return n&&(i=Un(i)),o([i],e);case"MultiLineString":var u=[],c=0;return i.forEach(function(t){if(n&&(t=Un(t)),r){var e=function(t){var e=t[0],n=t[1],r=t[2],i=t[3];return Math.abs(e-r)*Math.abs(n-i)}(j(a(t)));e>c?(u.unshift(t),c=e):u.push(t)}else u.push(t)}),o(u,e);default:throw new Error("geometry type "+s+" is not supported")}}function Un(t){var e=t[0],n=e[0],r=e[1],i=t[t.length-1],o=i[0],s=i[1];return n===o&&r===s||t.push(e),t}function Yn(t,e,n){var r,i,o,s,a,u=t.length,c=Hn(t[0],e),h=[];for(n||(n=[]),r=1;r<u;r++){for(i=t[r-1],s=a=Hn(o=t[r],e);;){if(!(c|s)){h.push(i),s!==a?(h.push(o),r<u-1&&(n.push(h),h=[])):r===u-1&&h.push(o);break}if(c&s)break;c?c=Hn(i=Vn(i,o,c,e),e):s=Hn(o=Vn(i,o,s,e),e)}c=a}return h.length&&n.push(h),n}function Vn(t,e,n,r){return 8&n?[t[0]+(e[0]-t[0])*(r[3]-t[1])/(e[1]-t[1]),r[3]]:4&n?[t[0]+(e[0]-t[0])*(r[1]-t[1])/(e[1]-t[1]),r[1]]:2&n?[r[2],t[1]+(e[1]-t[1])*(r[2]-t[0])/(e[0]-t[0])]:1&n?[r[0],t[1]+(e[1]-t[1])*(r[0]-t[0])/(e[0]-t[0])]:null}function Hn(t,e){var n=0;return t[0]<e[0]?n|=1:t[0]>e[2]&&(n|=2),t[1]<e[1]?n|=4:t[1]>e[3]&&(n|=8),n}function Wn(t,e){for(var n=[],r=0;r<t.length;r++){var i=Gs.polygon(t[r],e);i.length>0&&(i[0][0]===i[i.length-1][0]&&i[0][1]===i[i.length-1][1]||i.push(i[0]),i.length>=4&&n.push(i))}return n}function Jn(t){return"[object Arguments]"===Object.prototype.toString.call(t)}function Zn(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||"object"!=typeof t&&"object"!=typeof e?(n.strict,t===e):function(t,e,n){var r,i;if(Kn(t)||Kn(e))return!1;if(t.prototype!==e.prototype)return!1;if(Jn(t))return!!Jn(e)&&(t=Bs.call(t),e=Bs.call(e),Zn(t,e,n));if(Qn(t)){if(!Qn(e))return!1;if(t.length!==e.length)return!1;for(r=0;r<t.length;r++)if(t[r]!==e[r])return!1;return!0}try{var o=Object.keys(t),s=Object.keys(e)}catch(t){return!1}if(o.length!==s.length)return!1;for(o.sort(),s.sort(),r=o.length-1;r>=0;r--)if(o[r]!==s[r])return!1;for(r=o.length-1;r>=0;r--)if(i=o[r],!Zn(t[i],e[i],n))return!1;return typeof t==typeof e}(t,e,n))}function Kn(t){return null===t||void 0===t}function Qn(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length)&&("function"==typeof t.copy&&"function"==typeof t.slice&&!(t.length>0&&"number"!=typeof t[0]))}function $n(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.tolerance||0,i=[],o=Qe();o.load(en(t));var s;return G(e,function(t){var e=!1;O(o.search(t),function(n){if(!1===e){var i=U(t).sort(),o=U(n).sort();Zn(i,o)?(e=!0,s=s?tr(s,t):t):(0===r?Nn(i[0],n)&&Nn(i[1],n):on(n,i[0]).properties.dist<=r&&on(n,i[1]).properties.dist<=r)?(e=!0,s=s?tr(s,t):t):(0===r?Nn(o[0],t)&&Nn(o[1],t):on(t,o[0]).properties.dist<=r&&on(t,o[1]).properties.dist<=r)&&(s=s?tr(s,n):n)}}),!1===e&&s&&(i.push(s),s=void 0)}),s&&i.push(s),c(i)}function tr(t,e){var n=U(e),r=U(t),i=r[0],o=r[r.length-1],s=t.geometry.coordinates;return Zn(n[0],i)?s.unshift(n[1]):Zn(n[0],o)?s.push(n[1]):Zn(n[1],i)?s.unshift(n[0]):Zn(n[1],o)&&s.push(n[0]),t}function er(t){var e=t%360;return e<0&&(e+=360),e}function nr(t,e,n,i){if(i=i||{},!I(i))throw new Error("options is invalid");var o=i.units,s=i.properties;if(!t)throw new Error("origin is required");if(void 0===e||null===e)throw new Error("distance is required");if(void 0===n||null===n)throw new Error("bearing is required");if(!(e>=0))throw new Error("distance must be greater than 0");var a=E(e,o,"meters"),u=X(t),c=function(t,e,n,r){r=void 0===r?Fo:Number(r);var i=e/r,o=t[0]*Math.PI/180,s=x(t[1]),a=x(n),u=i*Math.cos(a),c=s+u;Math.abs(c)>Math.PI/2&&(c=c>0?Math.PI-c:-Math.PI-c);var h=Math.log(Math.tan(c/2+Math.PI/4)/Math.tan(s/2+Math.PI/4)),l=Math.abs(h)>1e-11?u/h:Math.cos(s),p=i*Math.sin(a)/l;return[(180*(o+p)/Math.PI+540)%360-180,180*c/Math.PI]}(u,a,n);return c[0]+=c[0]-u[0]>180?-360:u[0]-c[0]>180?360:0,r(c,s)}function rr(t,e,n,r,i,o){for(var s=0;s<t.length;s++){var a=t[s],u=t[s+1];s===t.length-1&&(u=t[0]),r=ir(a,u,e),n<=0&&r>0?function(t,e,n){return ir(t,e,n)<0}(e,a,i)||(i=a):n>0&&r<=0&&(function(t,e,n){return ir(t,e,n)>0}(e,a,o)||(o=a)),n=r}return[i,o]}function ir(t,e,n){return(e[0]-t[0])*(n[1]-t[1])-(n[0]-t[0])*(e[1]-t[1])}function or(t){if(!t)throw new Error("line is required");var e=t.geometry?t.geometry.type:t.type;if(!Array.isArray(t)&&"LineString"!==e)throw new Error("geometry must be a LineString");for(var n,r,i=U(t),o=0,s=1;s<i.length;)n=r||i[0],o+=((r=i[s])[0]-n[0])*(r[1]+n[1]),s++;return o>0}function sr(t,e){switch("Feature"===t.type?t.geometry.type:t.type){case"GeometryCollection":return A(t,function(t){sr(t,e)}),t;case"LineString":return ar(U(t),e),t;case"Polygon":return ur(U(t),e),t;case"MultiLineString":return U(t).forEach(function(t){ar(t,e)}),t;case"MultiPolygon":return U(t).forEach(function(t){ur(t,e)}),t;case"Point":case"MultiPoint":return t}}function ar(t,e){or(t)===e&&t.reverse()}function ur(t,e){or(t[0])!==e&&t[0].reverse();for(var n=1;n<t.length;n++)or(t[n])===e&&t[n].reverse()}function cr(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.zProperty||"elevation",r=e.flip,i=e.flags;W(t,"Point","input must contain Points");for(var o=function(t,e){var n={};O(t,function(t){var e=U(t)[1];n[e]||(n[e]=[]),n[e].push(t)});return Object.keys(n).map(function(t){var e=n[t],r=e.sort(function(t,e){return U(t)[0]-U(e)[0]});return r}).sort(function(t,n){return e?U(t[0])[1]-U(n[0])[1]:U(n[0])[1]-U(t[0])[1]})}(t,r),s=[],a=0;a<o.length;a++){for(var u=o[a],c=[],h=0;h<u.length;h++){var l=u[h];l.properties[n]?c.push(l.properties[n]):c.push(0),!0===i&&(l.properties.matrixPosition=[a,h])}s.push(c)}return s}function hr(t,e,n,r){r=r||{};for(var i=Object.keys(ks),o=0;o<i.length;o++){var s=i[o],a=r[s];a=void 0!==a&&null!==a?a:ks[s],zs[s]=a}zs.verbose&&console.log("MarchingSquaresJS-isoBands: computing isobands for ["+e+":"+(e+n)+"]");var u,c=function(t,e,n){for(var r=t.length-1,i=t[0].length-1,o={rows:r,cols:i,cells:[]},s=e+Math.abs(n),a=0;a<r;++a){o.cells[a]=[];for(var u=0;u<i;++u){var c=0,h=t[a+1][u],l=t[a+1][u+1],p=t[a][u+1],f=t[a][u];if(!(isNaN(h)||isNaN(l)||isNaN(p)||isNaN(f))){c|=h<e?0:h>s?128:64,c|=l<e?0:l>s?32:16,c|=p<e?0:p>s?8:4;var g=+(c|=f<e?0:f>s?2:1),d=0;if(17===c||18===c||33===c||34===c||38===c||68===c||72===c||98===c||102===c||132===c||136===c||137===c||152===c||153===c){var y=(h+l+p+f)/4;d=y>s?2:y<e?0:1,34===c?1===d?c=35:0===d&&(c=136):136===c?1===d?(c=35,d=4):0===d&&(c=34):17===c?1===d?(c=155,d=4):0===d&&(c=153):68===c?1===d?(c=103,d=4):0===d&&(c=102):153===c?1===d&&(c=155):102===c?1===d&&(c=103):152===c?d<2&&(c=156,d=1):137===c?d<2&&(c=139,d=1):98===c?d<2&&(c=99,d=1):38===c?d<2&&(c=39,d=1):18===c?d>0?(c=156,d=4):c=152:33===c?d>0?(c=139,d=4):c=137:72===c?d>0?(c=99,d=4):c=98:132===c&&(d>0?(c=39,d=4):c=38)}if(0!=c&&170!=c){var _,m,v,x,E,w,b,I;_=m=v=x=E=w=b=I=.5;var N=[];1===c?(v=1-lr(e,p,f),I=1-lr(e,h,f),N.push(Sa[c])):169===c?(v=lr(s,f,p),I=lr(s,f,h),N.push(Sa[c])):4===c?(w=1-lr(e,l,p),x=lr(e,f,p),N.push(Na[c])):166===c?(w=lr(s,p,l),x=1-lr(s,p,f),N.push(Na[c])):16===c?(E=lr(e,p,l),m=lr(e,h,l),N.push(Ia[c])):154===c?(E=1-lr(s,l,p),m=1-lr(s,l,h),N.push(Ia[c])):64===c?(b=lr(e,f,h),_=1-lr(e,l,h),N.push(La[c])):106===c?(b=1-lr(s,h,f),_=lr(s,h,l),N.push(La[c])):168===c?(x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),N.push(Ca[c]),N.push(Sa[c])):2===c?(x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),N.push(Ca[c]),N.push(Sa[c])):162===c?(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),N.push(Ca[c]),N.push(Sa[c])):8===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),N.push(Ia[c]),N.push(Na[c])):138===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Ia[c]),N.push(Na[c])):32===c?(E=lr(s,p,l),w=lr(e,p,l),_=lr(e,h,l),m=lr(s,h,l),N.push(Ia[c]),N.push(Na[c])):42===c?(I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l),N.push(Ma[c]),N.push(La[c])):128===c&&(I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Ma[c]),N.push(La[c])),5===c?(w=1-lr(e,l,p),I=1-lr(e,h,f),N.push(Na[c])):165===c?(w=lr(s,p,l),I=lr(s,f,h),N.push(Na[c])):20===c?(x=lr(e,f,p),m=lr(e,h,l),N.push(Ca[c])):150===c?(x=1-lr(s,p,f),m=1-lr(s,l,h),N.push(Ca[c])):80===c?(E=lr(e,p,l),b=lr(e,f,h),N.push(Ia[c])):90===c?(E=1-lr(s,l,p),b=1-lr(s,h,f),N.push(Ia[c])):65===c?(v=1-lr(e,p,f),_=1-lr(e,l,h),N.push(Sa[c])):105===c?(v=lr(s,f,p),_=lr(s,h,l),N.push(Sa[c])):160===c?(E=lr(s,p,l),w=lr(e,p,l),I=lr(e,f,h),b=lr(s,f,h),N.push(Ia[c]),N.push(Na[c])):10===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),I=1-lr(s,h,f),b=1-lr(e,h,f),N.push(Ia[c]),N.push(Na[c])):130===c?(x=1-lr(e,p,f),v=1-lr(s,p,f),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Ca[c]),N.push(Sa[c])):40===c?(x=lr(s,f,p),v=lr(e,f,p),_=lr(e,h,l),m=lr(s,h,l),N.push(Ca[c]),N.push(Sa[c])):101===c?(w=lr(s,p,l),_=lr(s,h,l),N.push(Na[c])):69===c?(w=1-lr(e,l,p),_=1-lr(e,l,h),N.push(Na[c])):149===c?(I=lr(s,f,h),m=1-lr(s,l,h),N.push(Ma[c])):21===c?(I=1-lr(e,h,f),m=lr(e,h,l),N.push(Ma[c])):86===c?(x=1-lr(s,p,f),b=1-lr(s,h,f),N.push(Ca[c])):84===c?(x=lr(e,f,p),b=lr(e,f,h),N.push(Ca[c])):89===c?(E=1-lr(s,l,p),v=lr(s,f,p),N.push(Sa[c])):81===c?(E=lr(e,p,l),v=1-lr(e,p,f),N.push(Sa[c])):96===c?(E=lr(s,p,l),w=lr(e,p,l),b=lr(e,f,h),_=lr(s,h,l),N.push(Ia[c]),N.push(Na[c])):74===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),b=1-lr(s,h,f),_=1-lr(e,l,h),N.push(Ia[c]),N.push(Na[c])):24===c?(E=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),m=lr(e,h,l),N.push(Ia[c]),N.push(Sa[c])):146===c?(E=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),m=1-lr(s,l,h),N.push(Ia[c]),N.push(Sa[c])):6===c?(w=1-lr(e,l,p),x=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),N.push(Na[c]),N.push(Ca[c])):164===c?(w=lr(s,p,l),x=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),N.push(Na[c]),N.push(Ca[c])):129===c?(v=1-lr(e,p,f),I=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Sa[c]),N.push(Ma[c])):41===c?(v=lr(s,f,p),I=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l),N.push(Sa[c]),N.push(Ma[c])):66===c?(x=1-lr(e,p,f),v=1-lr(s,p,f),b=1-lr(s,h,f),_=1-lr(e,l,h),N.push(Ca[c]),N.push(Sa[c])):104===c?(x=lr(s,f,p),v=lr(e,f,p),b=lr(e,f,h),_=lr(s,h,l),N.push(Sa[c]),N.push(Pa[c])):144===c?(E=lr(e,p,l),I=lr(e,f,h),b=lr(s,f,h),m=1-lr(s,l,h),N.push(Ia[c]),N.push(La[c])):26===c?(E=1-lr(s,l,p),I=1-lr(s,h,f),b=1-lr(e,h,f),m=lr(e,h,l),N.push(Ia[c]),N.push(La[c])):36===c?(w=lr(s,p,l),x=lr(e,f,p),_=lr(e,h,l),m=lr(s,h,l),N.push(Na[c]),N.push(Ca[c])):134===c?(w=1-lr(e,l,p),x=1-lr(s,p,f),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Na[c]),N.push(Ca[c])):9===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),v=lr(s,f,p),I=1-lr(e,h,f),N.push(Ia[c]),N.push(Na[c])):161===c?(E=lr(s,p,l),w=lr(e,p,l),v=1-lr(e,p,f),I=lr(s,f,h),N.push(Ia[c]),N.push(Na[c])):37===c?(w=lr(s,p,l),I=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l),N.push(Na[c]),N.push(Ma[c])):133===c?(w=1-lr(e,l,p),I=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h),N.push(Na[c]),N.push(Ma[c])):148===c?(x=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),m=1-lr(s,l,h),N.push(Ca[c]),N.push(La[c])):22===c?(x=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),m=lr(e,h,l),N.push(Ca[c]),N.push(La[c])):82===c?(E=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),b=1-lr(s,h,f),N.push(Ia[c]),N.push(Sa[c])):88===c?(E=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),b=lr(e,f,h),N.push(Ia[c]),N.push(Sa[c])):73===c?(E=1-lr(e,l,p),w=1-lr(s,l,p),v=lr(s,f,p),_=1-lr(e,l,h),N.push(Ia[c]),N.push(Na[c])):97===c?(E=lr(s,p,l),w=lr(e,p,l),v=1-lr(e,p,f),_=lr(s,h,l),N.push(Ia[c]),N.push(Na[c])):145===c?(E=lr(e,p,l),v=1-lr(e,p,f),I=lr(s,f,h),m=1-lr(s,l,h),N.push(Ia[c]),N.push(Ma[c])):25===c?(E=1-lr(s,l,p),v=lr(s,f,p),I=1-lr(e,h,f),m=lr(e,h,l),N.push(Ia[c]),N.push(Ma[c])):70===c?(w=1-lr(e,l,p),x=1-lr(s,p,f),b=1-lr(s,h,f),_=1-lr(e,l,h),N.push(Na[c]),N.push(Ca[c])):100===c?(w=lr(s,p,l),x=lr(e,f,p),b=lr(e,f,h),_=lr(s,h,l),N.push(Na[c]),N.push(Ca[c])):34===c?(0===d?(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)):(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)),N.push(Ia[c]),N.push(Na[c]),N.push(Ma[c]),N.push(La[c])):35===c?(4===d?(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)):(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)),N.push(Ia[c]),N.push(Na[c]),N.push(Sa[c]),N.push(La[c])):136===c?(0===d?(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)):(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)),N.push(Ia[c]),N.push(Na[c]),N.push(Ma[c]),N.push(La[c])):153===c?(0===d?(E=lr(e,p,l),v=1-lr(e,p,f),I=1-lr(e,h,f),m=lr(e,h,l)):(E=1-lr(s,l,p),v=lr(s,f,p),I=lr(s,f,h),m=1-lr(s,l,h)),N.push(Ia[c]),N.push(Sa[c])):102===c?(0===d?(w=1-lr(e,l,p),x=lr(e,f,p),b=lr(e,f,h),_=1-lr(e,l,h)):(w=lr(s,p,l),x=1-lr(s,p,f),b=1-lr(s,h,f),_=lr(s,h,l)),N.push(Na[c]),N.push(La[c])):155===c?(4===d?(E=lr(e,p,l),v=1-lr(e,p,f),I=1-lr(e,h,f),m=lr(e,h,l)):(E=1-lr(s,l,p),v=lr(s,f,p),I=lr(s,f,h),m=1-lr(s,l,h)),N.push(Ia[c]),N.push(Ma[c])):103===c?(4===d?(w=1-lr(e,l,p),x=lr(e,f,p),b=lr(e,f,h),_=1-lr(e,l,h)):(w=lr(s,p,l),x=1-lr(s,p,f),b=1-lr(s,h,f),_=lr(s,h,l)),N.push(Na[c]),N.push(Ca[c])):152===c?(0===d?(E=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),m=lr(e,h,l)):(E=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),m=1-lr(s,l,h)),N.push(Ia[c]),N.push(Ca[c]),N.push(Sa[c])):156===c?(4===d?(E=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),m=lr(e,h,l)):(E=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),m=1-lr(s,l,h)),N.push(Ia[c]),N.push(Sa[c]),N.push(La[c])):137===c?(0===d?(E=lr(s,p,l),w=lr(e,p,l),v=1-lr(e,p,f),I=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)):(E=1-lr(e,l,p),w=1-lr(s,l,p),v=lr(s,f,p),I=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)),N.push(Ia[c]),N.push(Na[c]),N.push(Sa[c])):139===c?(4===d?(E=lr(s,p,l),w=lr(e,p,l),v=1-lr(e,p,f),I=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)):(E=1-lr(e,l,p),w=1-lr(s,l,p),v=lr(s,f,p),I=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)),N.push(Ia[c]),N.push(Na[c]),N.push(Ma[c])):98===c?(0===d?(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),b=lr(e,f,h),_=1-lr(e,l,h)):(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),b=1-lr(s,h,f),_=lr(s,h,l)),N.push(Ia[c]),N.push(Na[c]),N.push(La[c])):99===c?(4===d?(E=1-lr(e,l,p),w=1-lr(s,l,p),x=lr(s,f,p),v=lr(e,f,p),b=lr(e,f,h),_=1-lr(e,l,h)):(E=lr(s,p,l),w=lr(e,p,l),x=1-lr(e,p,f),v=1-lr(s,p,f),b=1-lr(s,h,f),_=lr(s,h,l)),N.push(Ia[c]),N.push(Na[c]),N.push(Sa[c])):38===c?(0===d?(w=1-lr(e,l,p),x=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)):(w=lr(s,p,l),x=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)),N.push(Na[c]),N.push(Ma[c]),N.push(La[c])):39===c?(4===d?(w=1-lr(e,l,p),x=lr(e,f,p),I=lr(e,f,h),b=lr(s,f,h),_=1-lr(s,l,h),m=1-lr(e,l,h)):(w=lr(s,p,l),x=1-lr(s,p,f),I=1-lr(s,h,f),b=1-lr(e,h,f),_=lr(e,h,l),m=lr(s,h,l)),N.push(Na[c]),N.push(Ca[c]),N.push(La[c])):85===c&&(E=1,w=0,x=1,v=0,I=0,b=1,_=0,m=1),(_<0||_>1||m<0||m>1||E<0||E>1||x<0||x>1||I<0||I>1||b<0||b>1)&&console.log("MarchingSquaresJS-isoBands: "+c+" "+g+" "+h+","+l+","+p+","+f+" "+d+" "+_+" "+m+" "+E+" "+w+" "+x+" "+v+" "+I+" "+b),o.cells[a][u]={cval:c,cval_real:g,flipped:d,topleft:_,topright:m,righttop:E,rightbottom:w,bottomright:x,bottomleft:v,leftbottom:I,lefttop:b,edges:N}}}}}return o}(t,e,n);return zs.polygons?(zs.verbose&&console.log("MarchingSquaresJS-isoBands: returning single polygons for each grid cell"),u=function(t){var e=[],n=0;return t.cells.forEach(function(t,r){t.forEach(function(t,i){if(void 0!==t){var o=Ra[t.cval](t);"object"==typeof o&&pr(o)?"object"==typeof o[0]&&pr(o[0])?"object"==typeof o[0][0]&&pr(o[0][0])?o.forEach(function(t){t.forEach(function(t){t[0]+=i,t[1]+=r}),e[n++]=t}):(o.forEach(function(t){t[0]+=i,t[1]+=r}),e[n++]=o):console.log("MarchingSquaresJS-isoBands: bandcell polygon with malformed coordinates"):console.log("MarchingSquaresJS-isoBands: bandcell polygon with null coordinates")}})}),e}(c)):(zs.verbose&&console.log("MarchingSquaresJS-isoBands: returning polygon paths for entire data grid"),u=function(t){for(var e=[],n=t.rows,r=t.cols,i=[],o=0;o<n;o++)for(var s=0;s<r;s++)if(void 0!==t.cells[o][s]&&t.cells[o][s].edges.length>0){var a=t.cells[o][s],u=function(t){if(t.edges.length>0){var e=t.edges[t.edges.length-1],n=t.cval_real;switch(e){case 0:return n&Xs?{p:[1,t.righttop],x:-1,y:0,o:1}:{p:[t.topleft,1],x:0,y:-1,o:0};case 1:return n&Us?{p:[t.topleft,1],x:0,y:-1,o:0}:{p:[1,t.rightbottom],x:-1,y:0,o:0};case 2:return n&Us?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[t.topleft,1],x:0,y:-1,o:0};case 3:return n&Ys?{p:[t.topleft,1],x:0,y:-1,o:0}:{p:[t.bottomleft,0],x:0,y:1,o:0};case 4:return n&Xs?{p:[1,t.righttop],x:-1,y:0,o:1}:{p:[t.topright,1],x:0,y:-1,o:1};case 5:return n&Us?{p:[t.topright,1],x:0,y:-1,o:1}:{p:[1,t.rightbottom],x:-1,y:0,o:0};case 6:return n&Us?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[t.topright,1],x:0,y:-1,o:1};case 7:return n&Ys?{p:[t.topright,1],x:0,y:-1,o:1}:{p:[t.bottomleft,0],x:0,y:1,o:0};case 8:return n&Us?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[1,t.righttop],x:-1,y:0,o:1};case 9:return n&Ys?{p:[1,t.righttop],x:-1,y:0,o:1}:{p:[t.bottomleft,0],x:0,y:1,o:0};case 10:return n&Ys?{p:[0,t.leftbottom],x:1,y:0,o:0}:{p:[1,t.righttop],x:-1,y:0,o:1};case 11:return n&js?{p:[1,t.righttop],x:-1,y:0,o:1}:{p:[0,t.lefttop],x:1,y:0,o:1};case 12:return n&Us?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[1,t.rightbottom],x:-1,y:0,o:0};case 13:return n&Ys?{p:[1,t.rightbottom],x:-1,y:0,o:0}:{p:[t.bottomleft,0],x:0,y:1,o:0};case 14:return n&Ys?{p:[0,t.leftbottom],x:1,y:0,o:0}:{p:[1,t.rightbottom],x:-1,y:0,o:0};case 15:return n&js?{p:[1,t.rightbottom],x:-1,y:0,o:0}:{p:[0,t.lefttop],x:1,y:0,o:1};case 16:return n&Us?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[0,t.leftbottom],x:1,y:0,o:0};case 17:return n&js?{p:[t.bottomright,0],x:0,y:1,o:1}:{p:[0,t.lefttop],x:1,y:0,o:1};case 18:return n&Ys?{p:[0,t.leftbottom],x:1,y:0,o:0}:{p:[t.bottomleft,0],x:0,y:1,o:0};case 19:return n&js?{p:[t.bottomleft,0],x:0,y:1,o:0}:{p:[0,t.lefttop],x:1,y:0,o:1};case 20:return n&js?{p:[t.topleft,1],x:0,y:-1,o:0}:{p:[0,t.leftbottom],x:1,y:0,o:0};case 21:return n&Xs?{p:[0,t.leftbottom],x:1,y:0,o:0}:{p:[t.topright,1],x:0,y:-1,o:1};case 22:return n&js?{p:[t.topleft,1],x:0,y:-1,o:0}:{p:[0,t.lefttop],x:1,y:0,o:1};case 23:return n&Xs?{p:[0,t.lefttop],x:1,y:0,o:1}:{p:[t.topright,1],x:0,y:-1,o:1};default:console.log("MarchingSquaresJS-isoBands: edge index out of range!"),console.log(t)}}return null}(a),c=null,h=s,l=o;null!==u&&i.push([u.p[0]+h,u.p[1]+l]);do{if(null===(c=function(t,e,n,r){var i,o,s,a,u,c=t.cval;switch(e){case-1:switch(r){case 0:i=Na[c],s=ea[c],a=na[c],u=ra[c];break;default:i=Ia[c],s=Qs[c],a=$s[c],u=ta[c]}break;case 1:switch(r){case 0:i=Ma[c],s=fa[c],a=ga[c],u=da[c];break;default:i=La[c],s=ha[c],a=la[c],u=pa[c]}break;default:switch(n){case-1:switch(r){case 0:i=Pa[c],s=Vs[c],a=Hs[c],u=Ws[c];break;default:i=Oa[c],s=Js[c],a=Zs[c],u=Ks[c]}break;case 1:switch(r){case 0:i=Sa[c],s=ia[c],a=oa[c],u=sa[c];break;default:i=Ca[c],s=aa[c],a=ua[c],u=ca[c]}}}{if(o=t.edges.indexOf(i),void 0===t.edges[o])return null;!function(t,e){delete t.edges[e];for(var n=e+1;n<t.edges.length;n++)t.edges[n-1]=t.edges[n];t.edges.pop()}(t,o)}switch(c=t.cval_real,i){case 0:c&Xs?(e=t.topleft,n=1):(e=1,n=t.righttop);break;case 1:c&Us?(e=1,n=t.rightbottom):(e=t.topleft,n=1);break;case 2:c&Us?(e=t.topleft,n=1):(e=t.bottomright,n=0);break;case 3:c&Ys?(e=t.bottomleft,n=0):(e=t.topleft,n=1);break;case 4:c&Xs?(e=t.topright,n=1):(e=1,n=t.righttop);break;case 5:c&Us?(e=1,n=t.rightbottom):(e=t.topright,n=1);break;case 6:c&Us?(e=t.topright,n=1):(e=t.bottomright,n=0);break;case 7:c&Ys?(e=t.bottomleft,n=0):(e=t.topright,n=1);break;case 8:c&Us?(e=1,n=t.righttop):(e=t.bottomright,n=0);break;case 9:c&Ys?(e=t.bottomleft,n=0):(e=1,n=t.righttop);break;case 10:c&Ys?(e=1,n=t.righttop):(e=0,n=t.leftbottom);break;case 11:c&js?(e=0,n=t.lefttop):(e=1,n=t.righttop);break;case 12:c&Us?(e=1,n=t.rightbottom):(e=t.bottomright,n=0);break;case 13:c&Ys?(e=t.bottomleft,n=0):(e=1,n=t.rightbottom);break;case 14:c&Ys?(e=1,n=t.rightbottom):(e=0,n=t.leftbottom);break;case 15:c&js?(e=0,n=t.lefttop):(e=1,n=t.rightbottom);break;case 16:c&Us?(e=0,n=t.leftbottom):(e=t.bottomright,n=0);break;case 17:c&js?(e=0,n=t.lefttop):(e=t.bottomright,n=0);break;case 18:c&Ys?(e=t.bottomleft,n=0):(e=0,n=t.leftbottom);break;case 19:c&js?(e=0,n=t.lefttop):(e=t.bottomleft,n=0);break;case 20:c&js?(e=0,n=t.leftbottom):(e=t.topleft,n=1);break;case 21:c&Xs?(e=t.topright,n=1):(e=0,n=t.leftbottom);break;case 22:c&js?(e=0,n=t.lefttop):(e=t.topleft,n=1);break;case 23:c&Xs?(e=t.topright,n=1):(e=0,n=t.lefttop);break;default:return console.log("MarchingSquaresJS-isoBands: edge index out of range!"),console.log(t),null}void 0!==e&&void 0!==n&&void 0!==s&&void 0!==a&&void 0!==u||(console.log("MarchingSquaresJS-isoBands: undefined value!"),console.log(t),console.log(e+" "+n+" "+s+" "+a+" "+u));return{p:[e,n],x:s,y:a,o:u}}(t.cells[l][h],u.x,u.y,u.o)))break;if(i.push([c.p[0]+h,c.p[1]+l]),h+=c.x,l+=c.y,u=c,l<0||l>=n||h<0||h>=r||void 0===t.cells[l][h]){h-=c.x,l-=c.y;var p=function(t,e,n,r,i,o){var s=t.cells[n][e],a=s.cval_real,u=e+r,c=n+i,h=[],l=!1;for(;!l;){if(void 0===t.cells[c]||void 0===t.cells[c][u])if(c-=i,u-=r,s=t.cells[c][u],a=s.cval_real,-1===i)if(0===o)if(a&Ys)h.push([u,c]),r=-1,i=0,o=0;else{if(!(a&Us)){h.push([u+s.bottomright,c]),r=0,i=1,o=1,l=!0;break}h.push([u+1,c]),r=1,i=0,o=0}else{if(!(a&Ys)){if(a&Us){h.push([u+s.bottomright,c]),r=0,i=1,o=1,l=!0;break}h.push([u+s.bottomleft,c]),r=0,i=1,o=0,l=!0;break}h.push([u,c]),r=-1,i=0,o=0}else if(1===i)if(0===o){if(!(a&Xs)){if(a&js){h.push([u+s.topleft,c+1]),r=0,i=-1,o=0,l=!0;break}h.push([u+s.topright,c+1]),r=0,i=-1,o=1,l=!0;break}h.push([u+1,c+1]),r=1,i=0,o=1}else h.push([u+1,c+1]),r=1,i=0,o=1;else if(-1===r)if(0===o){if(!(a&js)){if(a&Ys){h.push([u,c+s.leftbottom]),r=1,i=0,o=0,l=!0;break}h.push([u,c+s.lefttop]),r=1,i=0,o=1,l=!0;break}h.push([u,c+1]),r=0,i=1,o=0}else{if(!(a&js)){console.log("MarchingSquaresJS-isoBands: wtf");break}h.push([u,c+1]),r=0,i=1,o=0}else{if(1!==r){console.log("MarchingSquaresJS-isoBands: we came from nowhere!");break}if(0===o){if(!(a&Us)){h.push([u+1,c+s.rightbottom]),r=-1,i=0,o=0,l=!0;break}h.push([u+1,c]),r=0,i=-1,o=1}else{if(!(a&Us)){if(a&Xs){h.push([u+1,c+s.righttop]),r=-1,i=0,o=1;break}h.push([u+1,c+s.rightbottom]),r=-1,i=0,o=0,l=!0;break}h.push([u+1,c]),r=0,i=-1,o=1}}else if(s=t.cells[c][u],a=s.cval_real,-1===r)if(0===o)if(void 0!==t.cells[c-1]&&void 0!==t.cells[c-1][u])r=0,i=-1,o=1;else{if(!(a&Ys)){h.push([u+s.bottomright,c]),r=0,i=1,o=1,l=!0;break}h.push([u,c])}else{if(!(a&js)){console.log("MarchingSquaresJS-isoBands: found entry from top at "+u+","+c);break}console.log("MarchingSquaresJS-isoBands: proceeding in x-direction!")}else if(1===r){if(0===o){console.log("MarchingSquaresJS-isoBands: wtf");break}if(void 0!==t.cells[c+1]&&void 0!==t.cells[c+1][u])r=0,i=1,o=0;else{if(!(a&Xs)){h.push([u+s.topleft,c+1]),r=0,i=-1,o=0,l=!0;break}h.push([u+1,c+1]),r=1,i=0,o=1}}else if(-1===i){if(1!==o){console.log("MarchingSquaresJS-isoBands: wtf");break}if(void 0!==t.cells[c][u+1])r=1,i=0,o=1;else{if(!(a&Us)){h.push([u+1,c+s.righttop]),r=-1,i=0,o=1,l=!0;break}h.push([u+1,c]),r=0,i=-1,o=1}}else{if(1!==i){console.log("MarchingSquaresJS-isoBands: where did we came from???");break}if(0!==o){console.log("MarchingSquaresJS-isoBands: wtf");break}if(void 0!==t.cells[c][u-1])r=-1,i=0,o=0;else{if(!(a&js)){h.push([u,c+s.leftbottom]),r=1,i=0,o=0,l=!0;break}h.push([u,c+1]),r=0,i=1,o=0}}if(u+=r,c+=i,u===e&&c===n)break}return{path:h,i:u,j:c,x:r,y:i,o:o}}(t,h,l,c.x,c.y,c.o);if(null===p)break;p.path.forEach(function(t){i.push(t)}),h=p.i,l=p.j,u=p}}while(void 0!==t.cells[l][h]&&t.cells[l][h].edges.length>0);e.push(i),i=[],t.cells[o][s].edges.length>0&&s--}return e}(c)),"function"==typeof zs.successCallback&&zs.successCallback(u),u}function lr(t,e,n){return(t-e)/(n-e)}function pr(t){return t.constructor.toString().indexOf("Array")>-1}function fr(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.pivot,i=n.mutate;if(!t)throw new Error("geojson is required");if(void 0===e||null===e||isNaN(e))throw new Error("angle is required");return 0===e?t:(r||(r=ye(t)),!1!==i&&void 0!==i||(t=Gt(t)),S(t,function(t){var n=sn(r,t)+e,i=un(r,t),o=U(nr(r,i,n));t[0]=o[0],t[1]=o[1]}),t)}function gr(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.origin,i=n.mutate;if(!t)throw new Error("geojson required");if("number"!=typeof e||0===e)throw new Error("invalid factor");var o=Array.isArray(r)||"object"==typeof r;return!0!==i&&(t=Gt(t)),"FeatureCollection"!==t.type||o?dr(t,e,r):(O(t,function(n,i){t.features[i]=dr(n,e,r)}),t)}function dr(t,e,n){var i="Point"===K(t);return n=function(t,e){void 0!==e&&null!==e||(e="centroid");if(Array.isArray(e)||"object"==typeof e)return X(e);var n=t.bbox?t.bbox:j(t),i=n[0],o=n[1],s=n[2],a=n[3];switch(e){case"sw":case"southwest":case"westsouth":case"bottomleft":return r([i,o]);case"se":case"southeast":case"eastsouth":case"bottomright":return r([s,o]);case"nw":case"northwest":case"westnorth":case"topleft":return r([i,a]);case"ne":case"northeast":case"eastnorth":case"topright":return r([s,a]);case"center":return de(t);case void 0:case null:case"centroid":return ye(t);default:throw new Error("invalid origin")}}(t,n),1===e||i?t:(S(t,function(t){var r=un(n,t),i=sn(n,t),o=U(nr(n,r*e,i));t[0]=o[0],t[1]=o[1],3===t.length&&(t[2]*=e)}),t)}function yr(t){var e=t[0],n=t[1];return[n[0]-e[0],n[1]-e[1]]}function _r(t,e){return t[0]*e[1]-e[0]*t[1]}function mr(t,e){return!function(t,e){return 0===_r(yr(t),yr(e))}(t,e)&&function(t,e){var n=t[0],r=yr(t),i=e[0],o=yr(e),s=_r(r,o);return function(t,e){return[t[0]+e[0],t[1]+e[1]]}(n,function(t,e){return[t*e[0],t*e[1]]}(_r(function(t,e){return[t[0]-e[0],t[1]-e[1]]}(i,n),o)/s,r))}(t,e)}function vr(t,e,n){var r=[],i=_(e,n),o=U(t),s=[];return o.forEach(function(t,e){if(e!==o.length-1){var n=function(t,e,n){var r=Math.sqrt((t[0]-e[0])*(t[0]-e[0])+(t[1]-e[1])*(t[1]-e[1])),i=t[0]+n*(e[1]-t[1])/r,o=e[0]+n*(e[1]-t[1])/r,s=t[1]+n*(t[0]-e[0])/r,a=e[1]+n*(t[0]-e[0])/r;return[[i,s],[o,a]]}(t,o[e+1],i);if(r.push(n),e>0){var a=r[e-1],u=mr(n,a);!1!==u&&(a[1]=u,n[0]=u),s.push(a[0]),e===o.length-2&&(s.push(n[0]),s.push(n[1]))}2===o.length&&(s.push(n[0]),s.push(n[1]))}}),a(s,t.properties)}function xr(t,e,n){var r=e[0]-t[0],i=e[1]-t[1],o=n[0]-e[0],s=n[1]-e[1];return Math.sign(r*s-o*i)}function Er(t,e){return e.geometry.coordinates[0].every(function(e){return Pt(r(e),t)})}function wr(t,e){for(var n=0;n<t.coordinates.length-1;n++)if(function(t,e,n){var r=n[0]-t[0],i=n[1]-t[1],o=e[0]-t[0],s=e[1]-t[1];if(r*s-i*o!=0)return!1;return Math.abs(o)>=Math.abs(s)?o>0?t[0]<=n[0]&&n[0]<=e[0]:e[0]<=n[0]&&n[0]<=t[0]:s>0?t[1]<=n[1]&&n[1]<=e[1]:e[1]<=n[1]&&n[1]<=t[1]}(t.coordinates[n],t.coordinates[n+1],e.coordinates))return!0;return!1}function br(t,e){return nn(e,kn(t)).features.length>0}function Ir(t,e){return!(t[0]>e[0])&&(!(t[2]<e[2])&&(!(t[1]>e[1])&&!(t[3]<e[3])))}function Nr(t,e){return t[0]===e[0]&&t[1]===e[1]}function Cr(t,e){for(var n=!1,r=!1,i=t.coordinates.length,o=0;o<i&&!n&&!r;){for(var s=0;s<e.coordinates.length-1;s++){var a=!0;0!==s&&s!==e.coordinates.length-2||(a=!1),Lr(e.coordinates[s],e.coordinates[s+1],t.coordinates[o],a)?n=!0:r=!0}o++}return n&&r}function Sr(t,e){return nn(t,kn(e)).features.length>0}function Mr(t,e){for(var n=!1,i=!1,o=t.coordinates[0].length,s=0;s<o&&n&&i;)Pt(r(t.coordinates[0][s]),e)?n=!0:i=!0,s++;return i&&i}function Lr(t,e,n,r){var i=n[0]-t[0],o=n[1]-t[1],s=e[0]-t[0],a=e[1]-t[1];return 0==i*a-o*s&&(r?Math.abs(s)>=Math.abs(a)?s>0?t[0]<=n[0]&&n[0]<=e[0]:e[0]<=n[0]&&n[0]<=t[0]:a>0?t[1]<=n[1]&&n[1]<=e[1]:e[1]<=n[1]&&n[1]<=t[1]:Math.abs(s)>=Math.abs(a)?s>0?t[0]<n[0]&&n[0]<e[0]:e[0]<n[0]&&n[0]<t[0]:a>0?t[1]<n[1]&&n[1]<e[1]:e[1]<n[1]&&n[1]<t[1])}function Pr(t){return t.coordinates.map(function(e){return{type:t.type.replace("Multi",""),coordinates:e}})}function Or(t,e){return t.hasOwnProperty("coordinates")?t.coordinates.length===e.coordinates.length:t.length===e.length}function Rr(t,e){return ka(t,e,{strict:!0})}function Tr(t,e){if(!t)throw new Error("feature1 is required");if(!e)throw new Error("feature2 is required");var n=K(t);if(n!==K(e))throw new Error("features must be of the same type");if("Point"===n)throw new Error("Point geometry not supported");if(new ja({precision:6}).compare(t,e))return!1;var r=0;switch(n){case"MultiPoint":var i=T(t),o=T(e);i.forEach(function(t){o.forEach(function(e){t[0]===e[0]&&t[1]===e[1]&&r++})});break;case"LineString":case"MultiLineString":G(t,function(t){G(e,function(e){$n(t,e).features.length&&r++})});break;case"Polygon":case"MultiPolygon":G(t,function(t){G(e,function(e){nn(t,e).features.length&&r++})})}return r>0}function Ar(t,e,n){n=n||[];for(var r=0;r<t;r++)n[r]=e;return n}function Dr(t,e){if(t.geometry&&t.geometry.type)return t.geometry.type;if(t.type)return t.type;throw new Error("Invalid GeoJSON object for "+e)}function Fr(t){for(var e=t,n=[];e.parent;)n.unshift(e),e=e.parent;return n}function qr(t,e){e=e||{},this.nodes=[],this.diagonal=!!e.diagonal,this.grid=[];for(var n=0;n<t.length;n++){this.grid[n]=[];for(var r=0,i=t[n];r<i.length;r++){var o=new Gr(n,r,i[r]);this.grid[n][r]=o,this.nodes.push(o)}}this.init()}function Gr(t,e,n){this.x=t,this.y=e,this.weight=n}function Br(t){this.content=[],this.scoreFunction=t}function kr(t){return t[0]}function zr(t){return t[1]}function jr(){this._=null}function Xr(t){t.U=t.C=t.L=t.R=t.P=t.N=null}function Ur(t,e){var n=e,r=e.R,i=n.U;i?i.L===n?i.L=r:i.R=r:t._=r,r.U=i,n.U=r,n.R=r.L,n.R&&(n.R.U=n),r.L=n}function Yr(t,e){var n=e,r=e.L,i=n.U;i?i.L===n?i.L=r:i.R=r:t._=r,r.U=i,n.U=r,n.L=r.R,n.L&&(n.L.U=n),r.R=n}function Vr(t){for(;t.L;)t=t.L;return t}function Hr(t,e,n,r){var i=[null,null],o=uu.push(i)-1;return i.left=t,i.right=e,n&&Jr(i,t,e,n),r&&Jr(i,e,t,r),su[t.index].halfedges.push(o),su[e.index].halfedges.push(o),i}function Wr(t,e,n){var r=[e,n];return r.left=t,r}function Jr(t,e,n,r){t[0]||t[1]?t.left===n?t[1]=r:t[0]=r:(t[0]=r,t.left=e,t.right=n)}function Zr(t,e,n,r,i){var o,s=t[0],a=t[1],u=s[0],c=s[1],h=0,l=1,p=a[0]-u,f=a[1]-c;if(o=e-u,p||!(o>0)){if(o/=p,p<0){if(o<h)return;o<l&&(l=o)}else if(p>0){if(o>l)return;o>h&&(h=o)}if(o=r-u,p||!(o<0)){if(o/=p,p<0){if(o>l)return;o>h&&(h=o)}else if(p>0){if(o<h)return;o<l&&(l=o)}if(o=n-c,f||!(o>0)){if(o/=f,f<0){if(o<h)return;o<l&&(l=o)}else if(f>0){if(o>l)return;o>h&&(h=o)}if(o=i-c,f||!(o<0)){if(o/=f,f<0){if(o>l)return;o>h&&(h=o)}else if(f>0){if(o<h)return;o<l&&(l=o)}return!(h>0||l<1)||(h>0&&(t[0]=[u+h*p,c+h*f]),l<1&&(t[1]=[u+l*p,c+l*f]),!0)}}}}}function Kr(t,e,n,r,i){var o=t[1];if(o)return!0;var s,a,u=t[0],c=t.left,h=t.right,l=c[0],p=c[1],f=h[0],g=h[1],d=(l+f)/2,y=(p+g)/2;if(g===p){if(d<e||d>=r)return;if(l>f){if(u){if(u[1]>=i)return}else u=[d,n];o=[d,i]}else{if(u){if(u[1]<n)return}else u=[d,i];o=[d,n]}}else if(s=(l-f)/(g-p),a=y-s*d,s<-1||s>1)if(l>f){if(u){if(u[1]>=i)return}else u=[(n-a)/s,n];o=[(i-a)/s,i]}else{if(u){if(u[1]<n)return}else u=[(i-a)/s,i];o=[(n-a)/s,n]}else if(p<g){if(u){if(u[0]>=r)return}else u=[e,s*e+a];o=[r,s*r+a]}else{if(u){if(u[0]<e)return}else u=[r,s*r+a];o=[e,s*e+a]}return t[0]=u,t[1]=o,!0}function Qr(t,e){var n=t.site,r=e.left,i=e.right;return n===i&&(i=r,r=n),i?Math.atan2(i[1]-r[1],i[0]-r[0]):(n===r?(r=e[1],i=e[0]):(r=e[0],i=e[1]),Math.atan2(r[0]-i[0],i[1]-r[1]))}function $r(t,e){return e[+(e.left!==t.site)]}function ti(t,e){return e[+(e.left===t.site)]}function ei(t){var e=t.P,n=t.N;if(e&&n){var r=e.site,i=t.site,o=n.site;if(r!==o){var s=i[0],a=i[1],u=r[0]-s,c=r[1]-a,h=o[0]-s,l=o[1]-a,p=2*(u*l-c*h);if(!(p>=-pu)){var f=u*u+c*c,g=h*h+l*l,d=(l*f-c*g)/p,y=(u*g-h*f)/p,_=cu.pop()||new function(){Xr(this),this.x=this.y=this.arc=this.site=this.cy=null};_.arc=t,_.site=i,_.x=d+s,_.y=(_.cy=y+a)+Math.sqrt(d*d+y*y),t.circle=_;for(var m=null,v=au._;v;)if(_.y<v.y||_.y===v.y&&_.x<=v.x){if(!v.L){m=v.P;break}v=v.L}else{if(!v.R){m=v;break}v=v.R}au.insert(m,_),m||(iu=_)}}}}function ni(t){var e=t.circle;e&&(e.P||(iu=e.N),au.remove(e),cu.push(e),Xr(e),t.circle=null)}function ri(t){var e=hu.pop()||new function(){Xr(this),this.edge=this.site=this.circle=null};return e.site=t,e}function ii(t){ni(t),ou.remove(t),hu.push(t),Xr(t)}function oi(t){var e=t.circle,n=e.x,r=e.cy,i=[n,r],o=t.P,s=t.N,a=[t];ii(t);for(var u=o;u.circle&&Math.abs(n-u.circle.x)<lu&&Math.abs(r-u.circle.cy)<lu;)o=u.P,a.unshift(u),ii(u),u=o;a.unshift(u),ni(u);for(var c=s;c.circle&&Math.abs(n-c.circle.x)<lu&&Math.abs(r-c.circle.cy)<lu;)s=c.N,a.push(c),ii(c),c=s;a.push(c),ni(c);var h,l=a.length;for(h=1;h<l;++h)c=a[h],u=a[h-1],Jr(c.edge,u.site,c.site,i);u=a[0],(c=a[l-1]).edge=Hr(u.site,c.site,null,i),ei(u),ei(c)}function si(t){for(var e,n,r,i,o=t[0],s=t[1],a=ou._;a;)if((r=ai(a,s)-o)>lu)a=a.L;else{if(!((i=o-function(t,e){var n=t.N;if(n)return ai(n,e);var r=t.site;return r[1]===e?r[0]:1/0}(a,s))>lu)){r>-lu?(e=a.P,n=a):i>-lu?(e=a,n=a.N):e=n=a;break}if(!a.R){e=a;break}a=a.R}!function(t){su[t.index]={site:t,halfedges:[]}}(t);var u=ri(t);if(ou.insert(e,u),e||n){if(e===n)return ni(e),n=ri(e.site),ou.insert(u,n),u.edge=n.edge=Hr(e.site,u.site),ei(e),void ei(n);if(n){ni(e),ni(n);var c=e.site,h=c[0],l=c[1],p=t[0]-h,f=t[1]-l,g=n.site,d=g[0]-h,y=g[1]-l,_=2*(p*y-f*d),m=p*p+f*f,v=d*d+y*y,x=[(y*m-f*v)/_+h,(p*v-d*m)/_+l];Jr(n.edge,c,g,x),u.edge=Hr(c,t,null,x),n.edge=Hr(t,g,null,x),ei(e),ei(n)}else u.edge=Hr(e.site,u.site)}}function ai(t,e){var n=t.site,r=n[0],i=n[1],o=i-e;if(!o)return r;var s=t.P;if(!s)return-1/0;var a=(n=s.site)[0],u=n[1],c=u-e;if(!c)return a;var h=a-r,l=1/o-1/c,p=h/c;return l?(-p+Math.sqrt(p*p-2*l*(h*h/(-2*c)-u+c/2+i-o/2)))/l+r:(r+a)/2}function ui(t,e,n){return(t[0]-n[0])*(e[1]-t[1])-(t[0]-e[0])*(n[1]-t[1])}function ci(t,e){return e[1]-t[1]||e[0]-t[0]}function hi(t,e){var n,r,i,o=t.sort(ci).pop();for(uu=[],su=new Array(t.length),ou=new jr,au=new jr;;)if(i=iu,o&&(!i||o[1]<i.y||o[1]===i.y&&o[0]<i.x))o[0]===n&&o[1]===r||(si(o),n=o[0],r=o[1]),o=t.pop();else{if(!i)break;oi(i.arc)}if(function(){for(var t,e,n,r,i=0,o=su.length;i<o;++i)if((t=su[i])&&(r=(e=t.halfedges).length)){var s=new Array(r),a=new Array(r);for(n=0;n<r;++n)s[n]=n,a[n]=Qr(t,uu[e[n]]);for(s.sort(function(t,e){return a[e]-a[t]}),n=0;n<r;++n)a[n]=e[s[n]];for(n=0;n<r;++n)e[n]=a[n]}}(),e){var s=+e[0][0],a=+e[0][1],u=+e[1][0],c=+e[1][1];!function(t,e,n,r){for(var i,o=uu.length;o--;)Kr(i=uu[o],t,e,n,r)&&Zr(i,t,e,n,r)&&(Math.abs(i[0][0]-i[1][0])>lu||Math.abs(i[0][1]-i[1][1])>lu)||delete uu[o]}(s,a,u,c),function(t,e,n,r){var i,o,s,a,u,c,h,l,p,f,g,d,y=su.length,_=!0;for(i=0;i<y;++i)if(o=su[i]){for(s=o.site,a=(u=o.halfedges).length;a--;)uu[u[a]]||u.splice(a,1);for(a=0,c=u.length;a<c;)g=(f=ti(o,uu[u[a]]))[0],d=f[1],l=(h=$r(o,uu[u[++a%c]]))[0],p=h[1],(Math.abs(g-l)>lu||Math.abs(d-p)>lu)&&(u.splice(a,0,uu.push(Wr(s,f,Math.abs(g-t)<lu&&r-d>lu?[t,Math.abs(l-t)<lu?p:r]:Math.abs(d-r)<lu&&n-g>lu?[Math.abs(p-r)<lu?l:n,r]:Math.abs(g-n)<lu&&d-e>lu?[n,Math.abs(l-n)<lu?p:e]:Math.abs(d-e)<lu&&g-t>lu?[Math.abs(p-e)<lu?l:t,e]:null))-1),++c);c&&(_=!1)}if(_){var m,v,x,E=1/0;for(i=0,_=null;i<y;++i)(o=su[i])&&(x=(m=(s=o.site)[0]-t)*m+(v=s[1]-e)*v)<E&&(E=x,_=o);if(_){var w=[t,e],b=[t,r],I=[n,r],N=[n,e];_.halfedges.push(uu.push(Wr(s=_.site,w,b))-1,uu.push(Wr(s,b,I))-1,uu.push(Wr(s,I,N))-1,uu.push(Wr(s,N,w))-1)}}for(i=0;i<y;++i)(o=su[i])&&(o.halfedges.length||delete su[i])}(s,a,u,c)}this.edges=uu,this.cells=su,ou=au=uu=su=null}function li(t){return(t=t.slice()).push(t[0]),o([t])}function pi(t,e,n,r){var i=(r=r||{}).steps||64,s=r.units||"kilometers",a=r.angle||0,u=r.pivot||t,c=r.properties||t.properties||{};if(!t)throw new Error("center is required");if(!e)throw new Error("xSemiAxis is required");if(!n)throw new Error("ySemiAxis is required");if(!I(r))throw new Error("options must be an object");if(!b(i))throw new Error("steps must be a number");if(!b(a))throw new Error("angle must be a number");var h=X(t);if("degrees"===s)var l=x(a);else e=nr(t,e,90,{units:s}),n=nr(t,n,0,{units:s}),e=X(e)[0]-h[0],n=X(n)[1]-h[1];for(var p=[],f=0;f<i;f+=1){var g=-360*f/i,d=e*n/Math.sqrt(Math.pow(n,2)+Math.pow(e,2)*Math.pow(fi(g),2)),y=e*n/Math.sqrt(Math.pow(e,2)+Math.pow(n,2)/Math.pow(fi(g),2));if(g<-90&&g>=-270&&(d=-d),g<-180&&g>=-360&&(y=-y),"degrees"===s){var _=d*Math.cos(l)+y*Math.sin(l),m=y*Math.cos(l)-d*Math.sin(l);d=_,y=m}p.push([d+h[0],y+h[1]])}return p.push(p[0]),"degrees"===s?o([p],c):fr(o([p],c),a,{pivot:u})}function fi(t){var e=t*Math.PI/180;return Math.tan(e)}function gi(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.properties,i=e.weight;if(!t)throw new Error("geojson is required");var o=0,s=0,a=0;return A(t,function(t,e,n){var r=n[i];if(r=void 0===r||null===r?1:r,!b(r))throw new Error("weight value must be a number for feature index "+e);(r=Number(r))>0&&S(t,function(t){o+=t[0]*r,s+=t[1]*r,a+=r})}),r([o/a,s/a],n)}function di(t,e,n,i){var o=n.properties.tolerance||.001,s=0,a=0,u=0,c=0;if(O(n,function(e){var n=e.properties.weight,r=void 0===n||null===n?1:n;if(r=Number(r),!b(r))throw new Error("weight value must be a number");if(r>0){c+=1;var i=r*qt(e,t);0===i&&(i=1);var o=r/i;s+=e.geometry.coordinates[0]*o,a+=e.geometry.coordinates[1]*o,u+=o}}),c<1)throw new Error("no features to measure");var h=s/u,l=a/u;return 1===c||0===i||Math.abs(h-e[0])<o&&Math.abs(l-e[1])<o?r([h,l],{medianCandidates:n.properties.medianCandidates}):(n.properties.medianCandidates.push([h,l]),di([h,l],t,n,i-1))}function yi(t,e){return{x:t[0]-e[0],y:t[1]-e[1]}}function _i(t){if(I(t)&&(t=t.bbox),t&&!Array.isArray(t))throw new Error("bbox is invalid");return t?function(t){return[Math.random()*(t[2]-t[0])+t[0],Math.random()*(t[3]-t[1])+t[1]]}(t):[360*Ei(),180*Ei()]}function mi(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.bbox;void 0!==t&&null!==t||(t=1);for(var i=[],o=0;o<t;o++)i.push(r(_i(n)));return c(i)}function vi(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.bbox,r=e.num_vertices,i=e.max_radial_length;void 0!==t&&null!==t||(t=1),b(r)||(r=10),b(i)||(i=10);for(var s=[],a=0;a<t;a++){var u=[],h=Array.apply(null,new Array(r+1)).map(Math.random);h.forEach(function(t,e,n){n[e]=e>0?t+n[e-1]:t}),h.forEach(function(t){t=2*t*Math.PI/h[h.length-1];var e=Math.random();u.push([e*i*Math.sin(t),e*i*Math.cos(t)])}),u[u.length-1]=u[0],u=u.map(function(t){return function(e){return[e[0]+t[0],e[1]+t[1]]}}(_i(n))),s.push(o([u]))}return c(s)}function xi(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.bbox,r=e.num_vertices,i=e.max_length,o=e.max_rotation;void 0!==t&&null!==t||(t=1),(!b(r)||r<2)&&(r=10),b(i)||(i=1e-4),b(o)||(o=Math.PI/8);for(var s=[],u=0;u<t;u++){for(var h=[_i(n)],l=0;l<r-1;l++){var p=(0===l?2*Math.random()*Math.PI:Math.tan((h[l][1]-h[l-1][1])/(h[l][0]-h[l-1][0])))+(Math.random()-.5)*o*2,f=Math.random()*i;h.push([h[l][0]+f*Math.cos(p),h[l][1]+f*Math.sin(p)])}s.push(a(h))}return c(s)}function Ei(){return Math.random()-.5}function wi(t,e){if(!t)throw new Error("geojson is required");if("FeatureCollection"!==t.type)throw new Error("geojson must be a FeatureCollection");if(void 0===e||null===e)throw new Error("filter is required");var n=[];return O(t,function(t){Ci(t.properties,e)&&n.push(t)}),c(n)}function bi(t,e,n){if(!t)throw new Error("geojson is required");if("FeatureCollection"!==t.type)throw new Error("geojson must be a FeatureCollection");if(void 0===e||null===e)throw new Error("property is required");for(var r=Ni(t,e),i=Object.keys(r),o=0;o<i.length;o++){for(var s=i[o],a=r[s],u=[],h=0;h<a.length;h++)u.push(t.features[a[h]]);n(c(u),s,o)}}function Ii(t,e,n,r){var i=r;return bi(t,e,function(t,e,o){i=0===o&&void 0===r?t:n(i,t,e,o)}),i}function Ni(t,e){var n={};return O(t,function(t,r){var i=t.properties||{};if(i.hasOwnProperty(e)){var o=i[e];n.hasOwnProperty(o)?n[o].push(r):n[o]=[r]}}),n}function Ci(t,e){if(void 0===t)return!1;var n=typeof e;if("number"===n||"string"===n)return t.hasOwnProperty(e);if(Array.isArray(e)){for(var r=0;r<e.length;r++)if(!Ci(t,e[r]))return!1;return!0}return Si(t,e)}function Si(t,e){for(var n=Object.keys(e),r=0;r<n.length;r++){var i=n[r];if(t[i]!==e[i])return!1}return!0}function Mi(t,e){if(!e)return{};if(!e.length)return{};for(var n={},r=0;r<e.length;r++){var i=e[r];t.hasOwnProperty(i)&&(n[i]=t[i])}return n}function Li(){}function Pi(t){this.message=t||""}function Oi(t){this.message=t||""}function Ri(){}function Ti(t){return null===t?Ac:t.color}function Ai(t){return null===t?null:t.parent}function Di(t,e){null!==t&&(t.color=e)}function Fi(t){return null===t?null:t.left}function qi(t){return null===t?null:t.right}function Gi(){this.root_=null,this.size_=0}function Bi(){}function ki(){this.array_=[],arguments[0]instanceof vc&&this.addAll(arguments[0])}function zi(){}function ji(t){this.message=t||""}function Xi(){this.array_=[]}function Ui(t){switch(t.type){case"Polygon":return mn(t)>1?t:null;case"MultiPolygon":var e=[];if(F(t,function(t){mn(t)>1&&e.push(t.geometry.coordinates)}),e.length)return{type:"MultiPolygon",coordinates:e}}}function Yi(){this.reset()}function Vi(t,e,n){var r=t.s=e+n,i=r-e,o=r-i;t.t=e-o+(n-i)}function Hi(t){return t>1?kf:t<-1?-kf:Math.asin(t)}function Wi(){}function Ji(t,e){t&&eg.hasOwnProperty(t.type)&&eg[t.type](t,e)}function Zi(t,e,n){var r,i=-1,o=t.length-n;for(e.lineStart();++i<o;)r=t[i],e.point(r[0],r[1],r[2]);e.lineEnd()}function Ki(t,e){var n=-1,r=t.length;for(e.polygonStart();++n<r;)Zi(t[n],e,1);e.polygonEnd()}function Qi(t){return[Hf(t[1],t[0]),Hi(t[2])]}function $i(t){var e=t[0],n=t[1],r=Wf(n);return[r*Wf(e),r*Kf(e),Kf(n)]}function to(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function eo(t,e){return[t[1]*e[2]-t[2]*e[1],t[2]*e[0]-t[0]*e[2],t[0]*e[1]-t[1]*e[0]]}function no(t,e){t[0]+=e[0],t[1]+=e[1],t[2]+=e[2]}function ro(t,e){return[t[0]*e,t[1]*e,t[2]*e]}function io(t){var e=Qf(t[0]*t[0]+t[1]*t[1]+t[2]*t[2]);t[0]/=e,t[1]/=e,t[2]/=e}function oo(t,e){return[t>Bf?t-jf:t<-Bf?t+jf:t,e]}function so(t,e,n){return(t%=jf)?e||n?rg(uo(t),co(e,n)):uo(t):e||n?co(e,n):oo}function ao(t){return function(e,n){return e+=t,[e>Bf?e-jf:e<-Bf?e+jf:e,n]}}function uo(t){var e=ao(t);return e.invert=ao(-t),e}function co(t,e){function n(t,e){var n=Wf(e),a=Wf(t)*n,u=Kf(t)*n,c=Kf(e),h=c*r+a*i;return[Hf(u*o-h*s,a*r-c*i),Hi(h*o+u*s)]}var r=Wf(t),i=Kf(t),o=Wf(e),s=Kf(e);return n.invert=function(t,e){var n=Wf(e),a=Wf(t)*n,u=Kf(t)*n,c=Kf(e),h=c*o-u*s;return[Hf(u*o+c*s,a*r+h*i),Hi(h*r-a*i)]},n}function ho(t,e){(e=$i(e))[0]-=t,io(e);var n=function(t){return t>1?0:t<-1?Bf:Math.acos(t)}(-e[1]);return((-e[2]<0?-n:n)+jf-Gf)%jf}function lo(t,e,n,r){this.x=t,this.z=e,this.o=n,this.e=r,this.v=!1,this.n=this.p=null}function po(t){if(e=t.length){for(var e,n,r=0,i=t[0];++r<e;)i.n=n=t[r],n.p=i,i=n;i.n=n=t[0],n.p=i}}function fo(t,e,n,r){function i(i,o){return t<=i&&i<=n&&e<=o&&o<=r}function o(i,o,a,c){var h=0,l=0;if(null==i||(h=s(i,a))!==(l=s(o,a))||u(i,o)<0^a>0)do{c.point(0===h||3===h?t:n,h>1?r:e)}while((h=(h+a+4)%4)!==l);else c.point(o[0],o[1])}function s(r,i){return Yf(r[0]-t)<Gf?i>0?0:3:Yf(r[0]-n)<Gf?i>0?2:1:Yf(r[1]-e)<Gf?i>0?1:0:i>0?3:2}function a(t,e){return u(t.x,e.x)}function u(t,e){var n=s(t,1),r=s(e,1);return n!==r?n-r:0===n?e[1]-t[1]:1===n?t[0]-e[0]:2===n?t[1]-e[1]:e[0]-t[0]}return function(s){function u(t,e){i(t,e)&&E.point(t,e)}function c(o,s){var a=i(o,s);if(l&&p.push([o,s]),v)f=o,g=s,d=a,v=!1,a&&(E.lineStart(),E.point(o,s));else if(a&&m)E.point(o,s);else{var u=[y=Math.max(pg,Math.min(lg,y)),_=Math.max(pg,Math.min(lg,_))],c=[o=Math.max(pg,Math.min(lg,o)),s=Math.max(pg,Math.min(lg,s))];sg(u,c,t,e,n,r)?(m||(E.lineStart(),E.point(u[0],u[1])),E.point(c[0],c[1]),a||E.lineEnd(),x=!1):a&&(E.lineStart(),E.point(o,s),x=!1)}y=o,_=s,m=a}var h,l,p,f,g,d,y,_,m,v,x,E=s,w=og(),b={point:u,lineStart:function(){b.point=c,l&&l.push(p=[]),v=!0,m=!1,y=_=NaN},lineEnd:function(){h&&(c(f,g),d&&m&&w.rejoin(),h.push(w.result())),b.point=u,m&&E.lineEnd()},polygonStart:function(){E=w,h=[],l=[],x=!0},polygonEnd:function(){var e=function(){for(var e=0,n=0,i=l.length;n<i;++n)for(var o,s,a=l[n],u=1,c=a.length,h=a[0],p=h[0],f=h[1];u<c;++u)o=p,s=f,p=(h=a[u])[0],f=h[1],s<=r?f>r&&(p-o)*(r-s)>(f-s)*(t-o)&&++e:f<=r&&(p-o)*(r-s)<(f-s)*(t-o)&&--e;return e}(),n=x&&e,i=(h=hg(h)).length;(n||i)&&(s.polygonStart(),n&&(s.lineStart(),o(null,null,1,s),s.lineEnd()),i&&ug(h,a,e,o,s),s.polygonEnd()),E=s,h=l=p=null}};return b}}function go(t){return t.length>1}function yo(t,e){return((t=t.x)[0]<0?t[1]-kf-Gf:kf-t[1])-((e=e.x)[0]<0?e[1]-kf-Gf:kf-e[1])}function _o(t){return function(e){var n=new mo;for(var r in t)n[r]=t[r];return n.stream=e,n}}function mo(){}function vo(t,e,n){var r=e[1][0]-e[0][0],i=e[1][1]-e[0][1],o=t.clipExtent&&t.clipExtent();t.scale(150).translate([0,0]),null!=o&&t.clipExtent(null),ng(n,t.stream(vg));var s=vg.result(),a=Math.min(r/(s[1][0]-s[0][0]),i/(s[1][1]-s[0][1])),u=+e[0][0]+(r-a*(s[1][0]+s[0][0]))/2,c=+e[0][1]+(i-a*(s[1][1]+s[0][1]))/2;return null!=o&&t.clipExtent(o),t.scale(150*a).translate([u,c])}function xo(t){return function(t){function e(t){return t=c(t[0]*Uf,t[1]*Uf),[t[0]*d+s,a-t[1]*d]}function n(t,e){return t=o(t,e),[t[0]*d+s,a-t[1]*d]}function r(){c=rg(u=so(x,E,w),o);var t=o(m,v);return s=y-t[0]*d,a=_+t[1]*d,i()}function i(){return f=g=null,e}var o,s,a,u,c,h,l,p,f,g,d=150,y=480,_=250,m=0,v=0,x=0,E=0,w=0,b=null,I=Eg,N=null,C=gg,S=.5,M=Ng(n,S);e.stream=function(t){return f&&g===t?f:f=Cg(I(u,M(C(g=t))))},e.clipAngle=function(t){return arguments.length?(I=+t?wg(b=t*Uf,6*Uf):(b=null,Eg),i()):b*Xf},e.clipExtent=function(t){return arguments.length?(C=null==t?(N=h=l=p=null,gg):fo(N=+t[0][0],h=+t[0][1],l=+t[1][0],p=+t[1][1]),i()):null==N?null:[[N,h],[l,p]]},e.scale=function(t){return arguments.length?(d=+t,r()):d},e.translate=function(t){return arguments.length?(y=+t[0],_=+t[1],r()):[y,_]},e.center=function(t){return arguments.length?(m=t[0]%360*Uf,v=t[1]%360*Uf,r()):[m*Xf,v*Xf]},e.rotate=function(t){return arguments.length?(x=t[0]%360*Uf,E=t[1]%360*Uf,w=t.length>2?t[2]%360*Uf:0,r()):[x*Xf,E*Xf,w*Xf]},e.precision=function(t){return arguments.length?(M=Ng(n,S=t*t),i()):Qf(S)},e.fitExtent=function(t,n){return vo(e,t,n)},e.fitSize=function(t,n){return function(t,e,n){return vo(t,[[0,0],e],n)}(e,t,n)};return function(){return o=t.apply(this,arguments),e.invert=o.invert&&function(t){return(t=c.invert((t[0]-s)/d,(a-t[1])/d))&&[t[0]*Xf,t[1]*Xf]},r()}}(function(){return t})()}function Eo(t,e){return[t,Zf($f((kf+e)/2))]}function wo(t,e){return[Zf($f((kf+e)/2)),-t]}function bo(t,n,r,i){var o=t.properties||{},s="Feature"===t.type?t.geometry:t;if("GeometryCollection"===s.type){var a=[];return A(t,function(t){var e=bo(t,n,r,i);e&&a.push(e)}),c(a)}var u,h=j(t),l=h[1]>50&&h[3]>50;u=l?{type:s.type,coordinates:No(s.coordinates,So(s))}:cn(s);var p=(new bh).read(u),f=d(y(n,r),"meters"),g=gp.bufferOp(p,f);if(g=(new Ih).write(g),!Io(g.coordinates)){var _;return(_=l?{type:g.type,coordinates:Co(g.coordinates,So(s))}:hn(g)).geometry?_:e(_,o)}}function Io(t){return Array.isArray(t[0])?Io(t[0]):isNaN(t[0])}function No(t,e){return"object"!=typeof t[0]?e(t):t.map(function(t){return No(t,e)})}function Co(t,e){return"object"!=typeof t[0]?e.invert(t):t.map(function(t){return Co(t,e)})}function So(t){var e=de(t).geometry.coordinates.reverse(),n=e.map(function(t){return-t});return Sg().center(e).rotate(n).scale(Fo)}function Mo(){for(var t=new bh,e=t.read(JSON.stringify(arguments[0].geometry)),n=1;n<arguments.length;n++)e=Df.union(e,t.read(JSON.stringify(arguments[n].geometry)));return e=(new Ih).write(e),{type:"Feature",geometry:e,properties:arguments[0].properties}}function Lo(t,n){var r=J(t),i=J(n);if(te(Pn(i,{precision:4})).coordinates[0].length<4)return null;if(te(Pn(r,{precision:4})).coordinates[0].length<4)return null;var o=new bh,s=o.read(Pn(r)),a=o.read(Pn(i)),u=Cf.intersection(s,a);if(u.isEmpty())return null;return e((new Ih).write(u))}function Po(t,e){return function(t,e,n){var r,i;if(!Array.isArray(e))throw new Error("Get closest expects an array as second argument");return e.forEach(function(e,o){var s=n(e,t);s>=0&&(void 0===i||s<i)&&(i=s,r=o)}),r}(t,e,function(t,e){return t-e})}function Oo(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.properties||{},i=n.triangles,s=n.mask;if(null===e||void 0===e)throw new Error("cellSide is required");if(!b(e))throw new Error("cellSide is invalid");if(!t)throw new Error("bbox is required");if(!Array.isArray(t))throw new Error("bbox must be array");if(4!==t.length)throw new Error("bbox must contain 4 numbers");if(s&&-1===["Polygon","MultiPolygon"].indexOf(K(s)))throw new Error("options.mask must be a (Multi)Polygon");var a=t[0],u=t[1],h=t[2],l=t[3],p=(u+l)/2,f=(a+h)/2,g=2*e/qt([a,p],[h,p],n)*(h-a),d=2*e/qt([f,u],[f,l],n)*(l-u),y=g/2,_=2*y,m=Math.sqrt(3)/2*d,v=h-a,x=l-u,E=.75*_,w=m,N=(v-_)/(_-y/2),C=Math.floor(N),S=(C*E-y/2-v)/2-y/2+E/2,M=Math.floor((x-m)/m),L=(x-M*m)/2,P=M*m-x>m/2;P&&(L-=m/4);for(var O=[],R=[],T=0;T<6;T++){var A=2*Math.PI/6*T;O.push(Math.cos(A)),R.push(Math.sin(A))}for(var D=[],F=0;F<=C;F++)for(var q=0;q<=M;q++){var G=F%2==1;if((0!==q||!G)&&(0!==q||!P)){var B=F*E+a-S,k=q*w+u+L;if(G&&(k-=m/2),!0===i)(function(t,e,n,r,i,s){for(var a=[],u=0;u<6;u++){var c=[];c.push(t),c.push([t[0]+e*i[u],t[1]+n*s[u]]),c.push([t[0]+e*i[(u+1)%6],t[1]+n*s[(u+1)%6]]),c.push(t),a.push(o([c],r))}return a})([B,k],g/2,d/2,r,O,R).forEach(function(t){s?Lo(s,t)&&D.push(t):D.push(t)});else{var z=function(t,e,n,r,i,s){for(var a=[],u=0;u<6;u++){var c=t[0]+e*i[u],h=t[1]+n*s[u];a.push([c,h])}return a.push(a[0].slice()),o([a],r)}([B,k],g/2,d/2,r,O,R);s?Lo(s,z)&&D.push(z):D.push(z)}}}return c(D)}function Ro(t){if(t.features.length<=1)return t;var e=function(t){var e=Vo(),n=[];return F(t,function(t,e){var r=j(t);n.push({minX:r[0],minY:r[1],maxX:r[2],maxY:r[3],geojson:t,index:e})}),e.load(n),e}(t),n=[],r={};return F(t,function(t,i){if(r[i])return!0;for(e.remove({index:i},To),r[i]=!0;;){var o=j(t),s=e.search({minX:o[0],minY:o[1],maxX:o[2],maxY:o[3]});if(s.length>0){var a=s.map(function(t){return r[t.index]=!0,e.remove({index:t.index},To),t.geojson});a.push(t),t=Mo.apply(this,a)}if(0===s.length)break}n.push(t)}),c(n)}function To(t,e){return t.index===e.index}function Ao(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.properties,i=n.mask,s=[];if(null===e||void 0===e)throw new Error("cellSide is required");if(!b(e))throw new Error("cellSide is invalid");if(!t)throw new Error("bbox is required");if(!Array.isArray(t))throw new Error("bbox must be array");if(4!==t.length)throw new Error("bbox must contain 4 numbers");if(i&&-1===["Polygon","MultiPolygon"].indexOf(K(i)))throw new Error("options.mask must be a (Multi)Polygon");for(var a=t[0],u=t[1],h=t[2],l=t[3],p=e/qt([a,u],[h,u],n)*(h-a),f=e/qt([a,u],[a,l],n)*(l-u),g=h-a,d=l-u,y=Math.floor(g/p),_=Math.floor(d/f),m=(d-_*f)/2,v=a+(g-y*p)/2,x=0;x<y;x++){for(var E=u+m,w=0;w<_;w++){var N=o([[[v,E],[v,E+f],[v+p,E+f],[v+p,E],[v,E]]],r);i?Lo(i,N)&&s.push(N):s.push(N),E+=f}v+=p}return c(s)}function Do(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.properties,i=n.mask,s=[];if(null===e||void 0===e)throw new Error("cellSide is required");if(!b(e))throw new Error("cellSide is invalid");if(!t)throw new Error("bbox is required");if(!Array.isArray(t))throw new Error("bbox must be array");if(4!==t.length)throw new Error("bbox must contain 4 numbers");if(i&&-1===["Polygon","MultiPolygon"].indexOf(K(i)))throw new Error("options.mask must be a (Multi)Polygon");for(var a=e/qt([t[0],t[1]],[t[2],t[1]],n)*(t[2]-t[0]),u=e/qt([t[0],t[1]],[t[0],t[3]],n)*(t[3]-t[1]),h=0,l=t[0];l<=t[2];){for(var p=0,f=t[1];f<=t[3];){var g=null,d=null;h%2==0&&p%2==0?(g=o([[[l,f],[l,f+u],[l+a,f],[l,f]]],r),d=o([[[l,f+u],[l+a,f+u],[l+a,f],[l,f+u]]],r)):h%2==0&&p%2==1?(g=o([[[l,f],[l+a,f+u],[l+a,f],[l,f]]],r),d=o([[[l,f],[l,f+u],[l+a,f+u],[l,f]]],r)):p%2==0&&h%2==1?(g=o([[[l,f],[l,f+u],[l+a,f+u],[l,f]]],r),d=o([[[l,f],[l+a,f+u],[l+a,f],[l,f]]],r)):p%2==1&&h%2==1&&(g=o([[[l,f],[l,f+u],[l+a,f],[l,f]]],r),d=o([[[l,f+u],[l+a,f+u],[l+a,f],[l,f+u]]],r)),i?(Lo(i,g)&&s.push(g),Lo(i,d)&&s.push(d)):(s.push(g),s.push(d)),f+=u,p++}h++,l+=a}return c(s)}var Fo=6371008.8,qo={meters:Fo,metres:Fo,millimeters:1e3*Fo,millimetres:1e3*Fo,centimeters:100*Fo,centimetres:100*Fo,kilometers:Fo/1e3,kilometres:Fo/1e3,miles:Fo/1609.344,nauticalmiles:Fo/1852,inches:39.37*Fo,yards:Fo/1.0936,feet:3.28084*Fo,radians:1,degrees:Fo/111325},Go={meters:1,metres:1,millimeters:1e3,millimetres:1e3,centimeters:100,centimetres:100,kilometers:.001,kilometres:.001,miles:1/1609.344,nauticalmiles:1/1852,inches:39.37,yards:1/1.0936,feet:3.28084,radians:1/Fo,degrees:1/111325},Bo={meters:1,metres:1,millimeters:1e6,millimetres:1e6,centimeters:1e4,centimetres:1e4,kilometers:1e-6,kilometres:1e-6,acres:247105e-9,miles:3.86e-7,yards:1.195990046,feet:10.763910417,inches:1550.003100006},ko=Object.freeze({earthRadius:Fo,factors:qo,unitsFactors:Go,areaFactors:Bo,feature:e,geometry:n,point:r,points:i,polygon:o,polygons:s,lineString:a,lineStrings:u,featureCollection:c,multiLineString:h,multiPoint:l,multiPolygon:p,geometryCollection:f,round:g,radiansToLength:d,lengthToRadians:y,lengthToDegrees:_,bearingToAzimuth:m,radiansToDegrees:v,degreesToRadians:x,convertLength:E,convertArea:w,isNumber:b,isObject:I,validateBBox:N,validateId:C,radians2degrees:function(){throw new Error("method has been renamed to `radiansToDegrees`")},degrees2radians:function(){throw new Error("method has been renamed to `degreesToRadians`")},distanceToDegrees:function(){throw new Error("method has been renamed to `lengthToDegrees`")},distanceToRadians:function(){throw new Error("method has been renamed to `lengthToRadians`")},radiansToDistance:function(){throw new Error("method has been renamed to `radiansToLength`")},bearingToAngle:function(){throw new Error("method has been renamed to `bearingToAzimuth`")},convertDistance:function(){throw new Error("method has been renamed to `convertLength`")}}),zo=Object.freeze({coordEach:S,coordReduce:M,propEach:L,propReduce:P,featureEach:O,featureReduce:R,coordAll:T,geomEach:A,geomReduce:D,flattenEach:F,flattenReduce:q,segmentEach:G,segmentReduce:B,lineEach:k,lineReduce:z}),jo=Object.freeze({getCoord:X,getCoords:U,containsNumber:Y,geojsonType:V,featureOf:H,collectionOf:W,getGeom:J,getGeomType:Z,getType:K}),Xo={successCallback:null,verbose:!1},Uo={},Yo=it,Vo=st;st.prototype={all:function(){return this._all(this.data,[])},search:function(t){var e=this.data,n=[],r=this.toBBox;if(!dt(t,e))return n;for(var i,o,s,a,u=[];e;){for(i=0,o=e.children.length;i<o;i++)s=e.children[i],dt(t,a=e.leaf?r(s):s)&&(e.leaf?n.push(s):gt(t,a)?this._all(s,n):u.push(s));e=u.pop()}return n},collides:function(t){var e=this.data,n=this.toBBox;if(!dt(t,e))return!1;for(var r,i,o,s,a=[];e;){for(r=0,i=e.children.length;r<i;r++)if(o=e.children[r],s=e.leaf?n(o):o,dt(t,s)){if(e.leaf||gt(t,s))return!0;a.push(o)}e=a.pop()}return!1},load:function(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(var e=0,n=t.length;e<n;e++)this.insert(t[e]);return this}var r=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===r.height)this._splitRoot(this.data,r);else{if(this.data.height<r.height){var i=this.data;this.data=r,r=i}this._insert(r,this.data.height-r.height-1,!0)}else this.data=r;return this},insert:function(t){return t&&this._insert(t,this.data.height-1),this},clear:function(){return this.data=yt([]),this},remove:function(t,e){if(!t)return this;for(var n,r,i,o,s=this.data,a=this.toBBox(t),u=[],c=[];s||u.length;){if(s||(s=u.pop(),r=u[u.length-1],n=c.pop(),o=!0),s.leaf&&-1!==(i=function(t,e,n){if(!n)return e.indexOf(t);for(var r=0;r<e.length;r++)if(n(t,e[r]))return r;return-1}(t,s.children,e)))return s.children.splice(i,1),u.push(s),this._condense(u),this;o||s.leaf||!gt(s,a)?r?(n++,s=r.children[n],o=!1):s=null:(u.push(s),c.push(n),n=0,r=s,s=s.children[0])}return this},toBBox:function(t){return t},compareMinX:ht,compareMinY:lt,toJSON:function(){return this.data},fromJSON:function(t){return this.data=t,this},_all:function(t,e){for(var n=[];t;)t.leaf?e.push.apply(e,t.children):n.push.apply(n,t.children),t=n.pop();return e},_build:function(t,e,n,r){var i,o=n-e+1,s=this._maxEntries;if(o<=s)return i=yt(t.slice(e,n+1)),at(i,this.toBBox),i;r||(r=Math.ceil(Math.log(o)/Math.log(s)),s=Math.ceil(o/Math.pow(s,r-1))),(i=yt([])).leaf=!1,i.height=r;var a,u,c,h,l=Math.ceil(o/s),p=l*Math.ceil(Math.sqrt(s));for(_t(t,e,n,p,this.compareMinX),a=e;a<=n;a+=p)for(_t(t,a,c=Math.min(a+p-1,n),l,this.compareMinY),u=a;u<=c;u+=l)h=Math.min(u+l-1,c),i.children.push(this._build(t,u,h,r-1));return at(i,this.toBBox),i},_chooseSubtree:function(t,e,n,r){for(var i,o,s,a,u,c,h,l;r.push(e),!e.leaf&&r.length-1!==n;){for(h=l=1/0,i=0,o=e.children.length;i<o;i++)u=pt(s=e.children[i]),(c=function(t,e){return(Math.max(e.maxX,t.maxX)-Math.min(e.minX,t.minX))*(Math.max(e.maxY,t.maxY)-Math.min(e.minY,t.minY))}(t,s)-u)<l?(l=c,h=u<h?u:h,a=s):c===l&&u<h&&(h=u,a=s);e=a||e.children[0]}return e},_insert:function(t,e,n){var r=this.toBBox,i=n?t:r(t),o=[],s=this._chooseSubtree(i,this.data,e,o);for(s.children.push(t),ct(s,i);e>=0&&o[e].children.length>this._maxEntries;)this._split(o,e),e--;this._adjustParentBBoxes(i,o,e)},_split:function(t,e){var n=t[e],r=n.children.length,i=this._minEntries;this._chooseSplitAxis(n,i,r);var o=this._chooseSplitIndex(n,i,r),s=yt(n.children.splice(o,n.children.length-o));s.height=n.height,s.leaf=n.leaf,at(n,this.toBBox),at(s,this.toBBox),e?t[e-1].children.push(s):this._splitRoot(n,s)},_splitRoot:function(t,e){this.data=yt([t,e]),this.data.height=t.height+1,this.data.leaf=!1,at(this.data,this.toBBox)},_chooseSplitIndex:function(t,e,n){var r,i,o,s,a,u,c,h;for(u=c=1/0,r=e;r<=n-e;r++)s=function(t,e){var n=Math.max(t.minX,e.minX),r=Math.max(t.minY,e.minY),i=Math.min(t.maxX,e.maxX),o=Math.min(t.maxY,e.maxY);return Math.max(0,i-n)*Math.max(0,o-r)}(i=ut(t,0,r,this.toBBox),o=ut(t,r,n,this.toBBox)),a=pt(i)+pt(o),s<u?(u=s,h=r,c=a<c?a:c):s===u&&a<c&&(c=a,h=r);return h},_chooseSplitAxis:function(t,e,n){var r=t.leaf?this.compareMinX:ht,i=t.leaf?this.compareMinY:lt;this._allDistMargin(t,e,n,r)<this._allDistMargin(t,e,n,i)&&t.children.sort(r)},_allDistMargin:function(t,e,n,r){t.children.sort(r);var i,o,s=this.toBBox,a=ut(t,0,e,s),u=ut(t,n-e,n,s),c=ft(a)+ft(u);for(i=e;i<n-e;i++)o=t.children[i],ct(a,t.leaf?s(o):o),c+=ft(a);for(i=n-e-1;i>=e;i--)o=t.children[i],ct(u,t.leaf?s(o):o),c+=ft(u);return c},_adjustParentBBoxes:function(t,e,n){for(var r=n;r>=0;r--)ct(e[r],t)},_condense:function(t){for(var e,n=t.length-1;n>=0;n--)0===t[n].children.length?n>0?(e=t[n-1].children).splice(e.indexOf(t[n]),1):this.clear():at(t[n],this.toBBox)},_initFormat:function(t){var e=["return a"," - b",";"];this.compareMinX=new Function("a","b",e.join(t[0])),this.compareMinY=new Function("a","b",e.join(t[1])),this.toBBox=new Function("a","return {minX: a"+t[0]+", minY: a"+t[1]+", maxX: a"+t[2]+", maxY: a"+t[3]+"};")}};var Ho=function(t,e,n){var r=t*e,i=Wo*t,o=i-(i-t),s=t-o,a=Wo*e,u=a-(a-e),c=e-u,h=s*c-(r-o*u-s*u-o*c);return n?(n[0]=h,n[1]=r,n):[h,r]},Wo=+(Math.pow(2,27)+1),Jo=function(t,e){var n=0|t.length,r=0|e.length;if(1===n&&1===r)return function(t,e){var n=t+e,r=n-t,i=t-(n-r)+(e-r);return i?[i,n]:[n]}(t[0],e[0]);var i,o,s=n+r,a=new Array(s),u=0,c=0,h=0,l=Math.abs,p=t[c],f=l(p),g=e[h],d=l(g);f<d?(o=p,(c+=1)<n&&(f=l(p=t[c]))):(o=g,(h+=1)<r&&(d=l(g=e[h]))),c<n&&f<d||h>=r?(i=p,(c+=1)<n&&(f=l(p=t[c]))):(i=g,(h+=1)<r&&(d=l(g=e[h])));for(var y,_,m=i+o,v=m-i,x=o-v,E=x,w=m;c<n&&h<r;)f<d?(i=p,(c+=1)<n&&(f=l(p=t[c]))):(i=g,(h+=1)<r&&(d=l(g=e[h]))),(x=(o=E)-(v=(m=i+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y;for(;c<n;)(x=(o=E)-(v=(m=(i=p)+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y,(c+=1)<n&&(p=t[c]);for(;h<r;)(x=(o=E)-(v=(m=(i=g)+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y,(h+=1)<r&&(g=e[h]);return E&&(a[u++]=E),w&&(a[u++]=w),u||(a[u++]=0),a.length=u,a},Zo=function(t,e,n){var r=t+e,i=r-t,o=e-i,s=t-(r-i);return n?(n[0]=s+o,n[1]=r,n):[s+o,r]},Ko=function(t,e){var n=t.length;if(1===n){var r=Ho(t[0],e);return r[0]?r:[r[1]]}var i=new Array(2*n),o=[.1,.1],s=[.1,.1],a=0;Ho(t[0],e,o),o[0]&&(i[a++]=o[0]);for(var u=1;u<n;++u){Ho(t[u],e,s);var c=o[1];Zo(c,s[0],o),o[0]&&(i[a++]=o[0]);var h=s[1],l=o[1],p=h+l,f=l-(p-h);o[1]=p,f&&(i[a++]=f)}return o[1]&&(i[a++]=o[1]),0===a&&(i[a++]=0),i.length=a,i},Qo=function(t,e){var n=0|t.length,r=0|e.length;if(1===n&&1===r)return function(t,e){var n=t+e,r=n-t,i=t-(n-r)+(e-r);return i?[i,n]:[n]}(t[0],-e[0]);var i,o,s=n+r,a=new Array(s),u=0,c=0,h=0,l=Math.abs,p=t[c],f=l(p),g=-e[h],d=l(g);f<d?(o=p,(c+=1)<n&&(f=l(p=t[c]))):(o=g,(h+=1)<r&&(d=l(g=-e[h]))),c<n&&f<d||h>=r?(i=p,(c+=1)<n&&(f=l(p=t[c]))):(i=g,(h+=1)<r&&(d=l(g=-e[h])));for(var y,_,m=i+o,v=m-i,x=o-v,E=x,w=m;c<n&&h<r;)f<d?(i=p,(c+=1)<n&&(f=l(p=t[c]))):(i=g,(h+=1)<r&&(d=l(g=-e[h]))),(x=(o=E)-(v=(m=i+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y;for(;c<n;)(x=(o=E)-(v=(m=(i=p)+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y,(c+=1)<n&&(p=t[c]);for(;h<r;)(x=(o=E)-(v=(m=(i=g)+o)-i))&&(a[u++]=x),E=w-((y=w+m)-(_=y-w))+(m-_),w=y,(h+=1)<r&&(g=-e[h]);return E&&(a[u++]=E),w&&(a[u++]=w),u||(a[u++]=0),a.length=u,a},$o=mt(function(t){function e(t,e){for(var n=new Array(t.length-1),r=1;r<t.length;++r)for(var i=n[r-1]=new Array(t.length-1),o=0,s=0;o<t.length;++o)o!==e&&(i[s++]=t[r][o]);return n}function n(t){return 1&t?"-":""}function r(t){if(1===t.length)return t[0];if(2===t.length)return["sum(",t[0],",",t[1],")"].join("");var e=t.length>>1;return["sum(",r(t.slice(0,e)),",",r(t.slice(e)),")"].join("")}function i(t){if(2===t.length)return[["sum(prod(",t[0][0],",",t[1][1],"),prod(-",t[0][1],",",t[1][0],"))"].join("")];for(var o=[],s=0;s<t.length;++s)o.push(["scale(",r(i(e(t,s))),",",n(s),t[0][s],")"].join(""));return o}function o(t){for(var n=[],o=[],s=function(t){for(var e=new Array(t),n=0;n<t;++n){e[n]=new Array(t);for(var r=0;r<t;++r)e[n][r]=["m",r,"[",t-n-1,"]"].join("")}return e}(t),a=[],u=0;u<t;++u)0==(1&u)?n.push.apply(n,i(e(s,u))):o.push.apply(o,i(e(s,u))),a.push("m"+u);var c=r(n),h=r(o),l="orientation"+t+"Exact",p=["function ",l,"(",a.join(),"){var p=",c,",n=",h,",d=sub(p,n);return d[d.length-1];};return ",l].join("");return new Function("sum","prod","scale","sub",p)(Jo,Ho,Ko,Qo)}var s=5,a=o(3),u=o(4),c=[function(){return 0},function(){return 0},function(t,e){return e[0]-t[0]},function(t,e,n){var r,i=(t[1]-n[1])*(e[0]-n[0]),o=(t[0]-n[0])*(e[1]-n[1]),s=i-o;if(i>0){if(o<=0)return s;r=i+o}else{if(!(i<0))return s;if(o>=0)return s;r=-(i+o)}var u=3.3306690738754716e-16*r;return s>=u||s<=-u?s:a(t,e,n)},function(t,e,n,r){var i=t[0]-r[0],o=e[0]-r[0],s=n[0]-r[0],a=t[1]-r[1],c=e[1]-r[1],h=n[1]-r[1],l=t[2]-r[2],p=e[2]-r[2],f=n[2]-r[2],g=o*h,d=s*c,y=s*a,_=i*h,m=i*c,v=o*a,x=l*(g-d)+p*(y-_)+f*(m-v),E=7.771561172376103e-16*((Math.abs(g)+Math.abs(d))*Math.abs(l)+(Math.abs(y)+Math.abs(_))*Math.abs(p)+(Math.abs(m)+Math.abs(v))*Math.abs(f));return x>E||-x>E?x:u(t,e,n,r)}];!function(){for(;c.length<=s;)c.push(o(c.length));for(var e=[],n=["slow"],r=0;r<=s;++r)e.push("a"+r),n.push("o"+r);var i=["function getOrientation(",e.join(),"){switch(arguments.length){case 0:case 1:return 0;"];for(r=2;r<=s;++r)i.push("case ",r,":return o",r,"(",e.slice(0,r).join(),");");i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation"),n.push(i.join(""));var a=Function.apply(void 0,n);for(t.exports=a.apply(void 0,[function(t){var e=c[t.length];return e||(e=c[t.length]=o(t.length)),e.apply(void 0,t)}].concat(c)),r=0;r<=s;++r)t.exports[r]=c[r]}()}),ts=function(t){var e=t.length;if(e<3){for(var n=new Array(e),r=0;r<e;++r)n[r]=r;return 2===e&&t[0][0]===t[1][0]&&t[0][1]===t[1][1]?[0]:n}var i=new Array(e);for(r=0;r<e;++r)i[r]=r;i.sort(function(e,n){var r=t[e][0]-t[n][0];return r||t[e][1]-t[n][1]});var o=[i[0],i[1]],s=[i[0],i[1]];for(r=2;r<e;++r){for(var a=i[r],u=t[a],c=o.length;c>1&&es(t[o[c-2]],t[o[c-1]],u)<=0;)c-=1,o.pop();for(o.push(a),c=s.length;c>1&&es(t[s[c-2]],t[s[c-1]],u)>=0;)c-=1,s.pop();s.push(a)}n=new Array(s.length+o.length-2);for(var h=0,l=(r=0,o.length);r<l;++r)n[h++]=o[r];for(var p=s.length-2;p>0;--p)n[h++]=s[p];return n},es=$o[3],ns=vt,rs=vt;vt.prototype={push:function(t){this.data.push(t),this.length++,this._up(this.length-1)},pop:function(){if(0!==this.length){var t=this.data[0];return this.length--,this.length>0&&(this.data[0]=this.data[this.length],this._down(0)),this.data.pop(),t}},peek:function(){return this.data[0]},_up:function(t){for(var e=this.data,n=this.compare,r=e[t];t>0;){var i=t-1>>1,o=e[i];if(n(r,o)>=0)break;e[t]=o,t=i}e[t]=r},_down:function(t){for(var e=this.data,n=this.compare,r=this.length>>1,i=e[t];t<r;){var o=1+(t<<1),s=o+1,a=e[o];if(s<this.length&&n(e[s],a)<0&&(o=s,a=e[s]),n(a,i)>=0)break;e[t]=a,t=o}e[t]=i}},ns.default=rs;var is=function(t,e){for(var n=t[0],r=t[1],i=!1,o=0,s=e.length-1;o<e.length;s=o++){var a=e[o][0],u=e[o][1],c=e[s][0],h=e[s][1];u>r!=h>r&&n<(c-a)*(r-u)/(h-u)+a&&(i=!i)}return i},os=$o[3],ss=xt,as=xt;ss.default=as;var us=function(t){return t},cs=function(t){if(null==t)return us;var e,n,r=t.scale[0],i=t.scale[1],o=t.translate[0],s=t.translate[1];return function(t,a){a||(e=n=0);var u=2,c=t.length,h=new Array(c);for(h[0]=(e+=t[0])*r+o,h[1]=(n+=t[1])*i+s;u<c;)h[u]=t[u],++u;return h}},hs=function(t,e){for(var n,r=t.length,i=r-e;i<--r;)n=t[i],t[i++]=t[r],t[r]=n},ls=function(t,e){function n(t,e){for(var n in t){var i=t[n];delete e[i.start],delete i.start,delete i.end,i.forEach(function(t){r[t<0?~t:t]=1}),s.push(i)}}var r={},i={},o={},s=[],a=-1;return e.forEach(function(n,r){var i,o=t.arcs[n<0?~n:n];o.length<3&&!o[1][0]&&!o[1][1]&&(i=e[++a],e[a]=n,e[r]=i)}),e.forEach(function(e){var n,r,s=function(e){var n,r=t.arcs[e<0?~e:e],i=r[0];return t.transform?(n=[0,0],r.forEach(function(t){n[0]+=t[0],n[1]+=t[1]})):n=r[r.length-1],e<0?[n,i]:[i,n]}(e),a=s[0],u=s[1];if(n=o[a])if(delete o[n.end],n.push(e),n.end=u,r=i[u]){delete i[r.start];var c=r===n?n:n.concat(r);i[c.start=n.start]=o[c.end=r.end]=c}else i[n.start]=o[n.end]=n;else if(n=i[u])if(delete i[n.start],n.unshift(e),n.start=a,r=o[a]){delete o[r.end];var h=r===n?n:r.concat(n);i[h.start=r.start]=o[h.end=n.end]=h}else i[n.start]=o[n.end]=n;else i[(n=[e]).start=a]=o[n.end=u]=n}),n(o,i),n(i,o),e.forEach(function(t){r[t<0?~t:t]||s.push([t])}),s},ps=function(t){return Xt(t,Ut.apply(this,arguments))},fs=function(t,e,n,r,i,o){3===arguments.length&&(r=o=Array,i=null);for(var s=new r(t=1<<Math.max(4,Math.ceil(Math.log(t)/Math.LN2))),a=new o(t),u=t-1,c=0;c<t;++c)s[c]=i;return{set:function(r,o){for(var c=e(r)&u,h=s[c],l=0;h!=i;){if(n(h,r))return a[c]=o;if(++l>=t)throw new Error("full hashmap");h=s[c=c+1&u]}return s[c]=r,a[c]=o,o},maybeSet:function(r,o){for(var c=e(r)&u,h=s[c],l=0;h!=i;){if(n(h,r))return a[c];if(++l>=t)throw new Error("full hashmap");h=s[c=c+1&u]}return s[c]=r,a[c]=o,o},get:function(r,o){for(var c=e(r)&u,h=s[c],l=0;h!=i;){if(n(h,r))return a[c];if(++l>=t)break;h=s[c=c+1&u]}return o},keys:function(){for(var t=[],e=0,n=s.length;e<n;++e){var r=s[e];r!=i&&t.push(r)}return t}}},gs=function(t,e){return t[0]===e[0]&&t[1]===e[1]},ds=new ArrayBuffer(16),ys=new Float64Array(ds),_s=new Uint32Array(ds),ms=function(t){ys[0]=t[0],ys[1]=t[1];var e=_s[0]^_s[1];return 2147483647&(e=e<<5^e>>7^_s[2]^_s[3])},vs=function(t){function e(t,e,n,r){if(p[n]!==t){p[n]=t;var i=f[n];if(i>=0){var o=g[n];i===e&&o===r||i===r&&o===e||(++y,d[n]=1)}else f[n]=e,g[n]=r}}function n(t){return ms(u[t])}function r(t,e){return gs(u[t],u[e])}var i,o,s,a,u=t.coordinates,c=t.lines,h=t.rings,l=function(){for(var t=fs(1.4*u.length,n,r,Int32Array,-1,Int32Array),e=new Int32Array(u.length),i=0,o=u.length;i<o;++i)e[i]=t.maybeSet(i,i);return e}(),p=new Int32Array(u.length),f=new Int32Array(u.length),g=new Int32Array(u.length),d=new Int8Array(u.length),y=0;for(i=0,o=u.length;i<o;++i)p[i]=f[i]=g[i]=-1;for(i=0,o=c.length;i<o;++i){var _=c[i],m=_[0],v=_[1];for(s=l[m],a=l[++m],++y,d[s]=1;++m<=v;)e(i,s,s=a,a=l[m]);++y,d[a]=1}for(i=0,o=u.length;i<o;++i)p[i]=-1;for(i=0,o=h.length;i<o;++i){var x=h[i],E=x[0]+1,w=x[1];for(e(i,l[w-1],s=l[E-1],a=l[E]);++E<=w;)e(i,s,s=a,a=l[E])}p=f=g=null;var b,I=function(t,e,n,r,i){3===arguments.length&&(r=Array,i=null);for(var o=new r(t=1<<Math.max(4,Math.ceil(Math.log(t)/Math.LN2))),s=t-1,a=0;a<t;++a)o[a]=i;return{add:function(r){for(var a=e(r)&s,u=o[a],c=0;u!=i;){if(n(u,r))return!0;if(++c>=t)throw new Error("full hashset");u=o[a=a+1&s]}return o[a]=r,!0},has:function(r){for(var a=e(r)&s,u=o[a],c=0;u!=i;){if(n(u,r))return!0;if(++c>=t)break;u=o[a=a+1&s]}return!1},values:function(){for(var t=[],e=0,n=o.length;e<n;++e){var r=o[e];r!=i&&t.push(r)}return t}}}(1.4*y,ms,gs);for(i=0,o=u.length;i<o;++i)d[b=l[i]]&&I.add(u[b]);return I},xs=function(t){var e,n,r,i=vs(t),o=t.coordinates,s=t.lines,a=t.rings;for(n=0,r=s.length;n<r;++n)for(var u=s[n],c=u[0],h=u[1];++c<h;)i.has(o[c])&&(e={0:c,1:u[1]},u[1]=c,u=u.next=e);for(n=0,r=a.length;n<r;++n)for(var l=a[n],p=l[0],f=p,g=l[1],d=i.has(o[p]);++f<g;)i.has(o[f])&&(d?(e={0:f,1:l[1]},l[1]=f,l=l.next=e):(!function(t,e,n,r){Yt(t,e,n),Yt(t,e,e+r),Yt(t,e+r,n)}(o,p,g,g-f),o[g]=o[p],d=!0,f=p));return t},Es=function(t){function e(t){var e,n,r,i,o,s,a,u;if(r=f.get(e=c[t[0]]))for(a=0,u=r.length;a<u;++a)if(i=r[a],function(t,e){var n=t[0],r=e[0],i=t[1],o=e[1];if(n-i!=r-o)return!1;for(;n<=i;++n,++r)if(!gs(c[n],c[r]))return!1;return!0}(i,t))return t[0]=i[0],void(t[1]=i[1]);if(o=f.get(n=c[t[1]]))for(a=0,u=o.length;a<u;++a)if(s=o[a],function(t,e){var n=t[0],r=e[0],i=t[1],o=e[1];if(n-i!=r-o)return!1;for(;n<=i;++n,--o)if(!gs(c[n],c[o]))return!1;return!0}(s,t))return t[1]=s[0],void(t[0]=s[1]);r?r.push(t):f.set(e,[t]),o?o.push(t):f.set(n,[t]),g.push(t)}function n(t,e){var n=t[0],r=e[0],o=t[1]-n;if(o!==e[1]-r)return!1;for(var s=i(t),a=i(e),u=0;u<o;++u)if(!gs(c[n+(u+s)%o],c[r+(u+a)%o]))return!1;return!0}function r(t,e){var n=t[0],r=e[0],o=t[1],s=e[1],a=o-n;if(a!==s-r)return!1;for(var u=i(t),h=a-i(e),l=0;l<a;++l)if(!gs(c[n+(l+u)%a],c[s-(l+h)%a]))return!1;return!0}function i(t){for(var e=t[0],n=t[1],r=e,i=r,o=c[r];++r<n;){var s=c[r];(s[0]<o[0]||s[0]===o[0]&&s[1]<o[1])&&(i=r,o=s)}return i-e}var o,s,a,u,c=t.coordinates,h=t.lines,l=t.rings,p=h.length+l.length;for(delete t.lines,delete t.rings,a=0,u=h.length;a<u;++a)for(o=h[a];o=o.next;)++p;for(a=0,u=l.length;a<u;++a)for(s=l[a];s=s.next;)++p;var f=fs(2*p*1.4,ms,gs),g=t.arcs=[];for(a=0,u=h.length;a<u;++a){o=h[a];do{e(o)}while(o=o.next)}for(a=0,u=l.length;a<u;++a)if((s=l[a]).next)do{e(s)}while(s=s.next);else!function(t){var e,o,s,a,u;if(o=f.get(e=c[t[0]]))for(a=0,u=o.length;a<u;++a){if(s=o[a],n(s,t))return t[0]=s[0],void(t[1]=s[1]);if(r(s,t))return t[0]=s[1],void(t[1]=s[0])}if(o=f.get(e=c[t[0]+i(t)]))for(a=0,u=o.length;a<u;++a){if(s=o[a],n(s,t))return t[0]=s[0],void(t[1]=s[1]);if(r(s,t))return t[0]=s[1],void(t[1]=s[0])}o?o.push(t):f.set(e,[t]),g.push(t)}(s);return t},ws=function(t,e){function n(t){t&&h.hasOwnProperty(t.type)&&h[t.type](t)}function r(t){var e=[];do{var n=c.get(t);e.push(t[0]<t[1]?n:~n)}while(t=t.next);return e}function i(t){return t.map(r)}var o=function(t){function e(t){null!=t&&c.hasOwnProperty(t.type)&&c[t.type](t)}function n(t){var e=t[0],n=t[1];e<o&&(o=e),e>a&&(a=e),n<s&&(s=n),n>u&&(u=n)}function r(t){t.forEach(n)}function i(t){t.forEach(r)}var o=1/0,s=1/0,a=-1/0,u=-1/0,c={GeometryCollection:function(t){t.geometries.forEach(e)},Point:function(t){n(t.coordinates)},MultiPoint:function(t){t.coordinates.forEach(n)},LineString:function(t){r(t.arcs)},MultiLineString:function(t){t.arcs.forEach(r)},Polygon:function(t){t.arcs.forEach(r)},MultiPolygon:function(t){t.arcs.forEach(i)}};for(var h in t)e(t[h]);return a>=o&&u>=s?[o,s,a,u]:void 0}(t=function(t){var e,n={};for(e in t)n[e]=Vt(t[e]);return n}(t)),s=e>0&&o&&function(t,e,n){function r(t){return[Math.round((t[0]-c)*f),Math.round((t[1]-h)*g)]}function i(t,e){for(var n,r,i,o,s,a=-1,u=0,l=t.length,p=new Array(l);++a<l;)n=t[a],o=Math.round((n[0]-c)*f),s=Math.round((n[1]-h)*g),o===r&&s===i||(p[u++]=[r=o,i=s]);for(p.length=u;u<e;)u=p.push([p[0][0],p[0][1]]);return p}function o(t){return i(t,2)}function s(t){return i(t,4)}function a(t){return t.map(s)}function u(t){null!=t&&d.hasOwnProperty(t.type)&&d[t.type](t)}var c=e[0],h=e[1],l=e[2],p=e[3],f=l-c?(n-1)/(l-c):1,g=p-h?(n-1)/(p-h):1,d={GeometryCollection:function(t){t.geometries.forEach(u)},Point:function(t){t.coordinates=r(t.coordinates)},MultiPoint:function(t){t.coordinates=t.coordinates.map(r)},LineString:function(t){t.arcs=o(t.arcs)},MultiLineString:function(t){t.arcs=t.arcs.map(o)},Polygon:function(t){t.arcs=a(t.arcs)},MultiPolygon:function(t){t.arcs=t.arcs.map(a)}};for(var y in t)u(t[y]);return{scale:[1/f,1/g],translate:[c,h]}}(t,o,e),a=Es(xs(function(t){function e(t){t&&c.hasOwnProperty(t.type)&&c[t.type](t)}function n(t){for(var e=0,n=t.length;e<n;++e)u[++o]=t[e];var r={0:o-n+1,1:o};return s.push(r),r}function r(t){for(var e=0,n=t.length;e<n;++e)u[++o]=t[e];var r={0:o-n+1,1:o};return a.push(r),r}function i(t){return t.map(r)}var o=-1,s=[],a=[],u=[],c={GeometryCollection:function(t){t.geometries.forEach(e)},LineString:function(t){t.arcs=n(t.arcs)},MultiLineString:function(t){t.arcs=t.arcs.map(n)},Polygon:function(t){t.arcs=t.arcs.map(r)},MultiPolygon:function(t){t.arcs=t.arcs.map(i)}};for(var h in t)e(t[h]);return{type:"Topology",coordinates:u,lines:s,rings:a,objects:t}}(t))),u=a.coordinates,c=fs(1.4*a.arcs.length,Jt,Zt);t=a.objects,a.bbox=o,a.arcs=a.arcs.map(function(t,e){return c.set(t,e),u.slice(t[0],t[1]+1)}),delete a.coordinates,u=null;var h={GeometryCollection:function(t){t.geometries.forEach(n)},LineString:function(t){t.arcs=r(t.arcs)},MultiLineString:function(t){t.arcs=t.arcs.map(r)},Polygon:function(t){t.arcs=t.arcs.map(r)},MultiPolygon:function(t){t.arcs=t.arcs.map(i)}};for(var l in t)n(t[l]);return s&&(a.transform=s,a.arcs=function(t){for(var e=-1,n=t.length;++e<n;){for(var r,i,o=t[e],s=0,a=1,u=o.length,c=o[0],h=c[0],l=c[1];++s<u;)r=(c=o[s])[0],i=c[1],r===h&&i===l||(o[a++]=[r-h,i-l],h=r,l=i);1===a&&(o[a++]=[0,0]),o.length=a}return t}(a.arcs)),a},bs=function(t){this.points=t.points||[],this.duration=t.duration||1e4,this.sharpness=t.sharpness||.85,this.centers=[],this.controls=[],this.stepLength=t.stepLength||60,this.length=this.points.length,this.delay=0;for(var e=0;e<this.length;e++)this.points[e].z=this.points[e].z||0;for(e=0;e<this.length-1;e++){var n=this.points[e],r=this.points[e+1];this.centers.push({x:(n.x+r.x)/2,y:(n.y+r.y)/2,z:(n.z+r.z)/2})}this.controls.push([this.points[0],this.points[0]]);for(e=0;e<this.centers.length-1;e++){n=this.centers[e],r=this.centers[e+1];var i=this.points[e+1].x-(this.centers[e].x+this.centers[e+1].x)/2,o=this.points[e+1].y-(this.centers[e].y+this.centers[e+1].y)/2,s=this.points[e+1].z-(this.centers[e].y+this.centers[e+1].z)/2;this.controls.push([{x:(1-this.sharpness)*this.points[e+1].x+this.sharpness*(this.centers[e].x+i),y:(1-this.sharpness)*this.points[e+1].y+this.sharpness*(this.centers[e].y+o),z:(1-this.sharpness)*this.points[e+1].z+this.sharpness*(this.centers[e].z+s)},{x:(1-this.sharpness)*this.points[e+1].x+this.sharpness*(this.centers[e+1].x+i),y:(1-this.sharpness)*this.points[e+1].y+this.sharpness*(this.centers[e+1].y+o),z:(1-this.sharpness)*this.points[e+1].z+this.sharpness*(this.centers[e+1].z+s)}])}return this.controls.push([this.points[this.length-1],this.points[this.length-1]]),this.steps=this.cacheSteps(this.stepLength),this};bs.prototype.cacheSteps=function(t){var e=[],n=this.pos(0);e.push(0);for(var r=0;r<this.duration;r+=10){var i=this.pos(r);Math.sqrt((i.x-n.x)*(i.x-n.x)+(i.y-n.y)*(i.y-n.y)+(i.z-n.z)*(i.z-n.z))>t&&(e.push(r),n=i)}return e},bs.prototype.vector=function(t){var e=this.pos(t+10),n=this.pos(t-10);return{angle:180*Math.atan2(e.y-n.y,e.x-n.x)/3.14,speed:Math.sqrt((n.x-e.x)*(n.x-e.x)+(n.y-e.y)*(n.y-e.y)+(n.z-e.z)*(n.z-e.z))}},bs.prototype.pos=function(t){var e=t-this.delay;e<0&&(e=0),e>this.duration&&(e=this.duration-1);var n=e/this.duration;if(n>=1)return this.points[this.length-1];var r=Math.floor((this.points.length-1)*n);return function(t,e,n,r,i){var o=function(t){var e=t*t;return[e*t,3*e*(1-t),3*t*(1-t)*(1-t),(1-t)*(1-t)*(1-t)]}(t);return{x:i.x*o[0]+r.x*o[1]+n.x*o[2]+e.x*o[3],y:i.y*o[0]+r.y*o[1]+n.y*o[2]+e.y*o[3],z:i.z*o[0]+r.z*o[1]+n.z*o[2]+e.z*o[3]}}((this.length-1)*n-r,this.points[r],this.controls[r][1],this.controls[r+1][0],this.points[r+1])};var Is=ve,Ns=ve;ve.deviation=function(t,e,n,r){var i=e&&e.length,o=i?e[0]*n:t.length,s=Math.abs(Ae(t,0,o,n));if(i)for(var a=0,u=e.length;a<u;a++){var c=e[a]*n,h=a<u-1?e[a+1]*n:t.length;s-=Math.abs(Ae(t,c,h,n))}var l=0;for(a=0;a<r.length;a+=3){var p=r[a]*n,f=r[a+1]*n,g=r[a+2]*n;l+=Math.abs((t[p]-t[g])*(t[f+1]-t[p+1])-(t[p]-t[f])*(t[g+1]-t[p+1]))}return 0===s&&0===l?0:Math.abs((l-s)/s)},ve.flatten=function(t){for(var e=t[0][0].length,n={vertices:[],holes:[],dimensions:e},r=0,i=0;i<t.length;i++){for(var o=0;o<t[i].length;o++)for(var s=0;s<e;s++)n.vertices.push(t[i][o][s]);i>0&&(r+=t[i-1].length,n.holes.push(r))}return n},Is.default=Ns,ke.prototype={all:function(){return this._all(this.data,[])},search:function(t){var e=this.data,n=[],r=this.toBBox;if(!Je(t,e))return n;for(var i,o,s,a,u=[];e;){for(i=0,o=e.children.length;i<o;i++)s=e.children[i],Je(t,a=e.leaf?r(s):s)&&(e.leaf?n.push(s):We(t,a)?this._all(s,n):u.push(s));e=u.pop()}return n},collides:function(t){var e=this.data,n=this.toBBox;if(!Je(t,e))return!1;for(var r,i,o,s,a=[];e;){for(r=0,i=e.children.length;r<i;r++)if(o=e.children[r],s=e.leaf?n(o):o,Je(t,s)){if(e.leaf||We(t,s))return!0;a.push(o)}e=a.pop()}return!1},load:function(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(var e=0,n=t.length;e<n;e++)this.insert(t[e]);return this}var r=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===r.height)this._splitRoot(this.data,r);else{if(this.data.height<r.height){var i=this.data;this.data=r,r=i}this._insert(r,this.data.height-r.height-1,!0)}else this.data=r;return this},insert:function(t){return t&&this._insert(t,this.data.height-1),this},clear:function(){return this.data=Ze([]),this},remove:function(t,e){if(!t)return this;for(var n,r,i,o,s=this.data,a=this.toBBox(t),u=[],c=[];s||u.length;){if(s||(s=u.pop(),r=u[u.length-1],n=c.pop(),o=!0),s.leaf&&-1!==(i=function(t,e,n){if(!n)return e.indexOf(t);for(var r=0;r<e.length;r++)if(n(t,e[r]))return r;return-1}(t,s.children,e)))return s.children.splice(i,1),u.push(s),this._condense(u),this;o||s.leaf||!We(s,a)?r?(n++,s=r.children[n],o=!1):s=null:(u.push(s),c.push(n),n=0,r=s,s=s.children[0])}return this},toBBox:function(t){return t},compareMinX:Ue,compareMinY:Ye,toJSON:function(){return this.data},fromJSON:function(t){return this.data=t,this},_all:function(t,e){for(var n=[];t;)t.leaf?e.push.apply(e,t.children):n.push.apply(n,t.children),t=n.pop();return e},_build:function(t,e,n,r){var i,o=n-e+1,s=this._maxEntries;if(o<=s)return i=Ze(t.slice(e,n+1)),ze(i,this.toBBox),i;r||(r=Math.ceil(Math.log(o)/Math.log(s)),s=Math.ceil(o/Math.pow(s,r-1))),(i=Ze([])).leaf=!1,i.height=r;var a,u,c,h,l=Math.ceil(o/s),p=l*Math.ceil(Math.sqrt(s));for(Ke(t,e,n,p,this.compareMinX),a=e;a<=n;a+=p)for(Ke(t,a,c=Math.min(a+p-1,n),l,this.compareMinY),u=a;u<=c;u+=l)h=Math.min(u+l-1,c),i.children.push(this._build(t,u,h,r-1));return ze(i,this.toBBox),i},_chooseSubtree:function(t,e,n,r){for(var i,o,s,a,u,c,h,l;r.push(e),!e.leaf&&r.length-1!==n;){for(h=l=1/0,i=0,o=e.children.length;i<o;i++)u=Ve(s=e.children[i]),(c=function(t,e){return(Math.max(e.maxX,t.maxX)-Math.min(e.minX,t.minX))*(Math.max(e.maxY,t.maxY)-Math.min(e.minY,t.minY))}(t,s)-u)<l?(l=c,h=u<h?u:h,a=s):c===l&&u<h&&(h=u,a=s);e=a||e.children[0]}return e},_insert:function(t,e,n){var r=this.toBBox,i=n?t:r(t),o=[],s=this._chooseSubtree(i,this.data,e,o);for(s.children.push(t),Xe(s,i);e>=0&&o[e].children.length>this._maxEntries;)this._split(o,e),e--;this._adjustParentBBoxes(i,o,e)},_split:function(t,e){var n=t[e],r=n.children.length,i=this._minEntries;this._chooseSplitAxis(n,i,r);var o=this._chooseSplitIndex(n,i,r),s=Ze(n.children.splice(o,n.children.length-o));s.height=n.height,s.leaf=n.leaf,ze(n,this.toBBox),ze(s,this.toBBox),e?t[e-1].children.push(s):this._splitRoot(n,s)},_splitRoot:function(t,e){this.data=Ze([t,e]),this.data.height=t.height+1,this.data.leaf=!1,ze(this.data,this.toBBox)},_chooseSplitIndex:function(t,e,n){var r,i,o,s,a,u,c,h;for(u=c=1/0,r=e;r<=n-e;r++)s=function(t,e){var n=Math.max(t.minX,e.minX),r=Math.max(t.minY,e.minY),i=Math.min(t.maxX,e.maxX),o=Math.min(t.maxY,e.maxY);return Math.max(0,i-n)*Math.max(0,o-r)}(i=je(t,0,r,this.toBBox),o=je(t,r,n,this.toBBox)),a=Ve(i)+Ve(o),s<u?(u=s,h=r,c=a<c?a:c):s===u&&a<c&&(c=a,h=r);return h},_chooseSplitAxis:function(t,e,n){var r=t.leaf?this.compareMinX:Ue,i=t.leaf?this.compareMinY:Ye;this._allDistMargin(t,e,n,r)<this._allDistMargin(t,e,n,i)&&t.children.sort(r)},_allDistMargin:function(t,e,n,r){t.children.sort(r);var i,o,s=this.toBBox,a=je(t,0,e,s),u=je(t,n-e,n,s),c=He(a)+He(u);for(i=e;i<n-e;i++)o=t.children[i],Xe(a,t.leaf?s(o):o),c+=He(a);for(i=n-e-1;i>=e;i--)o=t.children[i],Xe(u,t.leaf?s(o):o),c+=He(u);return c},_adjustParentBBoxes:function(t,e,n){for(var r=n;r>=0;r--)Xe(e[r],t)},_condense:function(t){for(var e,n=t.length-1;n>=0;n--)0===t[n].children.length?n>0?(e=t[n-1].children).splice(e.indexOf(t[n]),1):this.clear():ze(t[n],this.toBBox)},_initFormat:function(t){var e=["return a"," - b",";"];this.compareMinX=new Function("a","b",e.join(t[0])),this.compareMinY=new Function("a","b",e.join(t[1])),this.toBBox=new Function("a","return {minX: a"+t[0]+", minY: a"+t[1]+", maxX: a"+t[2]+", maxY: a"+t[3]+"};")}};var Cs=Object.freeze({toMercator:cn,toWgs84:hn}),Ss=6378137,Ms=function(t,e,n){function r(t,n,r,i){var u=o[t][n],c=o[t][n+1],h=o[r][i],l=o[r][i+1],p=function(t,e,n,r){if(On(t,n)||On(t,r)||On(e,n)||On(r,n))return null;var i=t[0],o=t[1],s=e[0],a=e[1],u=n[0],c=n[1],h=r[0],l=r[1],p=(i-s)*(c-l)-(o-a)*(u-h);return 0===p?null:[((i*a-o*s)*(u-h)-(i-s)*(u*l-c*h))/p,((i*a-o*s)*(c-l)-(o-a)*(u*l-c*h))/p]}(u,c,h,l);if(null!==p){var f,g;if(f=c[0]!==u[0]?(p[0]-u[0])/(c[0]-u[0]):(p[1]-u[1])/(c[1]-u[1]),g=l[0]!==h[0]?(p[0]-h[0])/(l[0]-h[0]):(p[1]-h[1])/(l[1]-h[1]),!(f>=1||f<=0||g>=1||g<=0)){var d=p,y=!a[d];y&&(a[d]=!0),e?s.push(e(p,t,n,u,c,f,r,i,h,l,g,y)):s.push(p)}}}function i(t,e){var n,r,i,s,a=o[t][e],u=o[t][e+1];return a[0]<u[0]?(n=a[0],r=u[0]):(n=u[0],r=a[0]),a[1]<u[1]?(i=a[1],s=u[1]):(i=u[1],s=a[1]),{minX:n,minY:i,maxX:r,maxY:s,ring:t,edge:e}}if("Polygon"!==t.geometry.type)throw new Error("The input feature must be a Polygon");void 0===n&&(n=1);var o=t.geometry.coordinates,s=[],a={};if(n){for(var u=[],c=0;c<o.length;c++)for(var h=0;h<o[c].length-1;h++)u.push(i(c,h));var l=Vo();l.load(u)}for(var p=0;p<o.length;p++)for(var f=0;f<o[p].length-1;f++)if(n){l.search(i(p,f)).forEach(function(t){var e=t.ring,n=t.edge;r(p,f,e,n)})}else for(var g=0;g<o.length;g++)for(var d=0;d<o[g].length-1;d++)r(p,f,g,d);return e||(s={type:"Feature",geometry:{type:"MultiPoint",coordinates:s}}),s},Ls=function(t){function e(){for(var t=[],e=0;e<g.features.length;e++)-1==g.features[e].properties.parent&&t.push(e);if(t.length>1)for(e=0;e<t.length;e++){for(var n=-1,r=0;r<g.features.length;r++)t[e]!=r&&Pt(g.features[t[e]].geometry.coordinates[0][0],g.features[r],{ignoreBoundary:!0})&&mn(g.features[r])<1/0&&(n=r);g.features[t[e]].properties.parent=n}}function n(){for(var t=0;t<g.features.length;t++)if(-1==g.features[t].properties.parent){var e=g.features[t].properties.winding;g.features[t].properties.netWinding=e,r(t,e)}}function r(t,e){for(var n=0;n<g.features.length;n++)if(g.features[n].properties.parent==t){var i=e+g.features[n].properties.winding;g.features[n].properties.netWinding=i,r(n,i)}}if("Feature"!=t.type)throw new Error("The input must a geojson object of type Feature");if(void 0===t.geometry||null==t.geometry)throw new Error("The input must a geojson object with a non-empty geometry");if("Polygon"!=t.geometry.type)throw new Error("The input must be a geojson Polygon");for(var i=t.geometry.coordinates.length,s=[],a=0;a<i;a++){var u=t.geometry.coordinates[a];Tn(u[0],u[u.length-1])||u.push(u[0]),s.push.apply(s,u.slice(0,u.length-1))}if(!function(t){for(var e={},n=1,r=0,i=t.length;r<i;++r){if(e.hasOwnProperty(t[r])){n=0;break}e[t[r]]=1}return n}(s))throw new Error("The input polygon may not have duplicate vertices (except for the first and last vertex of each ring)");var h=s.length,l=Ms(t,function(t,e,n,r,i,o,s,a,u,c,h,l){return[t,e,n,r,i,o,s,a,u,c,h,l]}),p=l.length;if(0==p){var f=[];for(a=0;a<i;a++)f.push(o([t.geometry.coordinates[a]],{parent:-1,winding:function(t){for(var e=0,n=0;n<t.length-1;n++)t[n][0]<t[e][0]&&(e=n);if(Rn([t[(e-1).modulo(t.length-1)],t[e],t[(e+1).modulo(t.length-1)]],!0))var r=1;else r=-1;return r}(t.geometry.coordinates[a])}));var g=c(f);return e(),n(),g}var d=[],y=[];for(a=0;a<i;a++){d.push([]);for(var _=0;_<t.geometry.coordinates[a].length-1;_++)d[a].push([new Ps(t.geometry.coordinates[a][(_+1).modulo(t.geometry.coordinates[a].length-1)],1,[a,_],[a,(_+1).modulo(t.geometry.coordinates[a].length-1)],void 0)]),y.push(new Os(t.geometry.coordinates[a][_],[a,(_-1).modulo(t.geometry.coordinates[a].length-1)],[a,_],void 0,void 0,!1,!0))}for(a=0;a<p;a++)d[l[a][1]][l[a][2]].push(new Ps(l[a][0],l[a][5],[l[a][1],l[a][2]],[l[a][6],l[a][7]],void 0)),l[a][11]&&y.push(new Os(l[a][0],[l[a][1],l[a][2]],[l[a][6],l[a][7]],void 0,void 0,!0,!0));var m=y.length;for(a=0;a<d.length;a++)for(_=0;_<d[a].length;_++)d[a][_].sort(function(t,e){return t.param<e.param?-1:1});var v=[];for(a=0;a<m;a++)v.push({minX:y[a].coord[0],minY:y[a].coord[1],maxX:y[a].coord[0],maxY:y[a].coord[1],index:a});var x=Vo();x.load(v);for(a=0;a<d.length;a++)for(_=0;_<d[a].length;_++)for(var E=0;E<d[a][_].length;E++){b=E==d[a][_].length-1?d[a][(_+1).modulo(t.geometry.coordinates[a].length-1)][0].coord:d[a][_][E+1].coord;var w=x.search({minX:b[0],minY:b[1],maxX:b[0],maxY:b[1]})[0];d[a][_][E].nxtIsectAlongEdgeIn=w.index}for(a=0;a<d.length;a++)for(_=0;_<d[a].length;_++)for(E=0;E<d[a][_].length;E++){var b=d[a][_][E].coord,I=(w=x.search({minX:b[0],minY:b[1],maxX:b[0],maxY:b[1]})[0]).index;I<h?y[I].nxtIsectAlongRingAndEdge2=d[a][_][E].nxtIsectAlongEdgeIn:Tn(y[I].ringAndEdge1,d[a][_][E].ringAndEdgeIn)?y[I].nxtIsectAlongRingAndEdge1=d[a][_][E].nxtIsectAlongEdgeIn:y[I].nxtIsectAlongRingAndEdge2=d[a][_][E].nxtIsectAlongEdgeIn}var N=[];for(a=0,_=0;_<i;_++){var C=a;for(E=0;E<t.geometry.coordinates[_].length-1;E++)y[a].coord[0]<y[C].coord[0]&&(C=a),a++;var S=y[C].nxtIsectAlongRingAndEdge2;for(E=0;E<y.length;E++)if(y[E].nxtIsectAlongRingAndEdge1==C||y[E].nxtIsectAlongRingAndEdge2==C){var M=E;break}var L=Rn([y[M].coord,y[C].coord,y[S].coord],!0)?1:-1;N.push({isect:C,parent:-1,winding:L})}N.sort(function(t,e){return y[t.isect].coord>y[e.isect].coord?-1:1});for(f=[];N.length>0;){var P=N.pop(),O=P.isect,R=P.parent,T=P.winding,A=f.length,D=[y[O].coord],F=O;if(y[O].ringAndEdge1Walkable)var q=y[O].ringAndEdge1,G=y[O].nxtIsectAlongRingAndEdge1;else q=y[O].ringAndEdge2,G=y[O].nxtIsectAlongRingAndEdge2;for(;!Tn(y[O].coord,y[G].coord);){D.push(y[G].coord);var B=void 0;for(a=0;a<N.length;a++)if(N[a].isect==G){B=a;break}if(void 0!=B&&N.splice(B,1),Tn(q,y[G].ringAndEdge1)){if(q=y[G].ringAndEdge2,y[G].ringAndEdge2Walkable=!1,y[G].ringAndEdge1Walkable){var k={isect:G};Rn([y[F].coord,y[G].coord,y[y[G].nxtIsectAlongRingAndEdge2].coord],1==T)?(k.parent=R,k.winding=-T):(k.parent=A,k.winding=T),N.push(k)}F=G,G=y[G].nxtIsectAlongRingAndEdge2}else{if(q=y[G].ringAndEdge1,y[G].ringAndEdge1Walkable=!1,y[G].ringAndEdge2Walkable){k={isect:G};Rn([y[F].coord,y[G].coord,y[y[G].nxtIsectAlongRingAndEdge1].coord],1==T)?(k.parent=R,k.winding=-T):(k.parent=A,k.winding=T),N.push(k)}F=G,G=y[G].nxtIsectAlongRingAndEdge1}}D.push(y[G].coord),f.push(o([D],{index:A,parent:R,winding:T,netWinding:void 0}))}g=c(f);return e(),n(),g},Ps=function(t,e,n,r,i){this.coord=t,this.param=e,this.ringAndEdgeIn=n,this.ringAndEdgeOut=r,this.nxtIsectAlongEdgeIn=i},Os=function(t,e,n,r,i,o,s){this.coord=t,this.ringAndEdge1=e,this.ringAndEdge2=n,this.nxtIsectAlongRingAndEdge1=r,this.nxtIsectAlongRingAndEdge2=i,this.ringAndEdge1Walkable=o,this.ringAndEdge2Walkable=s};Number.prototype.modulo=function(t){return(this%t+t)%t};var Rs=Math.PI/180,Ts=180/Math.PI,As=function(t,e){this.lon=t,this.lat=e,this.x=Rs*t,this.y=Rs*e};As.prototype.view=function(){return String(this.lon).slice(0,4)+","+String(this.lat).slice(0,4)},As.prototype.antipode=function(){var t=-1*this.lat,e=this.lon<0?180+this.lon:-1*(180-this.lon);return new As(e,t)};var Ds=function(){this.coords=[],this.length=0};Ds.prototype.move_to=function(t){this.length++,this.coords.push(t)};var Fs=function(t){this.properties=t||{},this.geometries=[]};Fs.prototype.json=function(){if(this.geometries.length<=0)return{geometry:{type:"LineString",coordinates:null},type:"Feature",properties:this.properties};if(1===this.geometries.length)return{geometry:{type:"LineString",coordinates:this.geometries[0].coords},type:"Feature",properties:this.properties};for(var t=[],e=0;e<this.geometries.length;e++)t.push(this.geometries[e].coords);return{geometry:{type:"MultiLineString",coordinates:t},type:"Feature",properties:this.properties}},Fs.prototype.wkt=function(){for(var t="",e="LINESTRING(",n=function(t){e+=t[0]+" "+t[1]+","},r=0;r<this.geometries.length;r++){if(0===this.geometries[r].coords.length)return"LINESTRING(empty)";this.geometries[r].coords.forEach(n),t+=e.substring(0,e.length-1)+")"}return t};var qs=function(t,e,n){if(!t||void 0===t.x||void 0===t.y)throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");if(!e||void 0===e.x||void 0===e.y)throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");this.start=new As(t.x,t.y),this.end=new As(e.x,e.y),this.properties=n||{};var r=this.start.x-this.end.x,i=this.start.y-this.end.y,o=Math.pow(Math.sin(i/2),2)+Math.cos(this.start.y)*Math.cos(this.end.y)*Math.pow(Math.sin(r/2),2);if(this.g=2*Math.asin(Math.sqrt(o)),this.g===Math.PI)throw new Error("it appears "+t.view()+" and "+e.view()+" are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");if(isNaN(this.g))throw new Error("could not calculate great circle between "+t+" and "+e)};qs.prototype.interpolate=function(t){var e=Math.sin((1-t)*this.g)/Math.sin(this.g),n=Math.sin(t*this.g)/Math.sin(this.g),r=e*Math.cos(this.start.y)*Math.cos(this.start.x)+n*Math.cos(this.end.y)*Math.cos(this.end.x),i=e*Math.cos(this.start.y)*Math.sin(this.start.x)+n*Math.cos(this.end.y)*Math.sin(this.end.x),o=e*Math.sin(this.start.y)+n*Math.sin(this.end.y),s=Ts*Math.atan2(o,Math.sqrt(Math.pow(r,2)+Math.pow(i,2)));return[Ts*Math.atan2(i,r),s]},qs.prototype.Arc=function(t,e){var n=[];if(!t||t<=2)n.push([this.start.lon,this.start.lat]),n.push([this.end.lon,this.end.lat]);else for(var r=1/(t-1),i=0;i<t;++i){var o=r*i,s=this.interpolate(o);n.push(s)}for(var a=!1,u=0,c=e&&e.offset?e.offset:10,h=180-c,l=-180+c,p=360-c,f=1;f<n.length;++f){var g=n[f-1][0],d=n[f][0],y=Math.abs(d-g);y>p&&(d>h&&g<l||g>h&&d<l)?a=!0:y>u&&(u=y)}var _=[];if(a&&u<c){var m=[];_.push(m);for(var v=0;v<n.length;++v){var x=parseFloat(n[v][0]);if(v>0&&Math.abs(x-n[v-1][0])>p){var E=parseFloat(n[v-1][0]),w=parseFloat(n[v-1][1]),b=parseFloat(n[v][0]),I=parseFloat(n[v][1]);if(E>-180&&E<l&&180===b&&v+1<n.length&&n[v-1][0]>-180&&n[v-1][0]<l){m.push([-180,n[v][1]]),v++,m.push([n[v][0],n[v][1]]);continue}if(E>h&&E<180&&-180===b&&v+1<n.length&&n[v-1][0]>h&&n[v-1][0]<180){m.push([180,n[v][1]]),v++,m.push([n[v][0],n[v][1]]);continue}if(E<l&&b>h){var N=E;E=b,b=N;var C=w;w=I,I=C}if(E>h&&b<l&&(b+=360),E<=180&&b>=180&&E<b){var S=(180-E)/(b-E),M=S*I+(1-S)*w;m.push([n[v-1][0]>h?180:-180,M]),(m=[]).push([n[v-1][0]>h?-180:180,M]),_.push(m)}else m=[],_.push(m);m.push([x,n[v][1]])}else m.push([n[v][0],n[v][1]])}}else{var L=[];_.push(L);for(var P=0;P<n.length;++P)L.push([n[P][0],n[P][1]])}for(var O=new Fs(this.properties),R=0;R<_.length;++R){var T=new Ds;O.geometries.push(T);for(var A=_[R],D=0;D<A.length;++D)T.move_to(A[D])}return O};var Gs=Yn;Yn.polyline=Yn,Yn.polygon=function(t,e){var n,r,i,o,s,a,u;for(r=1;r<=8;r*=2){for(n=[],o=!(Hn(i=t[t.length-1],e)&r),s=0;s<t.length;s++)(u=!(Hn(a=t[s],e)&r))!==o&&n.push(Vn(i,a,r,e)),u&&n.push(a),i=a,o=u;if(!(t=n).length)break}return n};var Bs=Array.prototype.slice,ks={successCallback:null,verbose:!1,polygons:!1},zs={},js=64,Xs=16,Us=4,Ys=1,Vs=[],Hs=[],Ws=[],Js=[],Zs=[],Ks=[],Qs=[],$s=[],ta=[],ea=[],na=[],ra=[],ia=[],oa=[],sa=[],aa=[],ua=[],ca=[],ha=[],la=[],pa=[],fa=[],ga=[],da=[];Qs[85]=ea[85]=-1,$s[85]=na[85]=0,ta[85]=ra[85]=1,ha[85]=fa[85]=1,la[85]=ga[85]=0,pa[85]=da[85]=1,Vs[85]=Js[85]=0,Hs[85]=Zs[85]=-1,Ws[85]=sa[85]=0,aa[85]=ia[85]=0,ua[85]=oa[85]=1,Ks[85]=ca[85]=1,fa[1]=fa[169]=0,ga[1]=ga[169]=-1,da[1]=da[169]=0,ia[1]=ia[169]=-1,oa[1]=oa[169]=0,sa[1]=sa[169]=0,ea[4]=ea[166]=0,na[4]=na[166]=-1,ra[4]=ra[166]=1,aa[4]=aa[166]=1,ua[4]=ua[166]=0,ca[4]=ca[166]=0,Qs[16]=Qs[154]=0,$s[16]=$s[154]=1,ta[16]=ta[154]=1,Js[16]=Js[154]=1,Zs[16]=Zs[154]=0,Ks[16]=Ks[154]=1,ha[64]=ha[106]=0,la[64]=la[106]=1,pa[64]=pa[106]=0,Vs[64]=Vs[106]=-1,Hs[64]=Hs[106]=0,Ws[64]=Ws[106]=1,ha[2]=ha[168]=0,la[2]=la[168]=-1,pa[2]=pa[168]=1,fa[2]=fa[168]=0,ga[2]=ga[168]=-1,da[2]=da[168]=0,ia[2]=ia[168]=-1,oa[2]=oa[168]=0,sa[2]=sa[168]=0,aa[2]=aa[168]=-1,ua[2]=ua[168]=0,ca[2]=ca[168]=1,Qs[8]=Qs[162]=0,$s[8]=$s[162]=-1,ta[8]=ta[162]=0,ea[8]=ea[162]=0,na[8]=na[162]=-1,ra[8]=ra[162]=1,ia[8]=ia[162]=1,oa[8]=oa[162]=0,sa[8]=sa[162]=1,aa[8]=aa[162]=1,ua[8]=ua[162]=0,ca[8]=ca[162]=0,Qs[32]=Qs[138]=0,$s[32]=$s[138]=1,ta[32]=ta[138]=1,ea[32]=ea[138]=0,na[32]=na[138]=1,ra[32]=ra[138]=0,Vs[32]=Vs[138]=1,Hs[32]=Hs[138]=0,Ws[32]=Ws[138]=0,Js[32]=Js[138]=1,Zs[32]=Zs[138]=0,Ks[32]=Ks[138]=1,fa[128]=fa[42]=0,ga[128]=ga[42]=1,da[128]=da[42]=1,ha[128]=ha[42]=0,la[128]=la[42]=1,pa[128]=pa[42]=0,Vs[128]=Vs[42]=-1,Hs[128]=Hs[42]=0,Ws[128]=Ws[42]=1,Js[128]=Js[42]=-1,Zs[128]=Zs[42]=0,Ks[128]=Ks[42]=0,ea[5]=ea[165]=-1,na[5]=na[165]=0,ra[5]=ra[165]=0,fa[5]=fa[165]=1,ga[5]=ga[165]=0,da[5]=da[165]=0,aa[20]=aa[150]=0,ua[20]=ua[150]=1,ca[20]=ca[150]=1,Js[20]=Js[150]=0,Zs[20]=Zs[150]=-1,Ks[20]=Ks[150]=1,Qs[80]=Qs[90]=-1,$s[80]=$s[90]=0,ta[80]=ta[90]=1,ha[80]=ha[90]=1,la[80]=la[90]=0,pa[80]=pa[90]=1,ia[65]=ia[105]=0,oa[65]=oa[105]=1,sa[65]=sa[105]=0,Vs[65]=Vs[105]=0,Hs[65]=Hs[105]=-1,Ws[65]=Ws[105]=0,Qs[160]=Qs[10]=-1,$s[160]=$s[10]=0,ta[160]=ta[10]=1,ea[160]=ea[10]=-1,na[160]=na[10]=0,ra[160]=ra[10]=0,fa[160]=fa[10]=1,ga[160]=ga[10]=0,da[160]=da[10]=0,ha[160]=ha[10]=1,la[160]=la[10]=0,pa[160]=pa[10]=1,aa[130]=aa[40]=0,ua[130]=ua[40]=1,ca[130]=ca[40]=1,ia[130]=ia[40]=0,oa[130]=oa[40]=1,sa[130]=sa[40]=0,Vs[130]=Vs[40]=0,Hs[130]=Hs[40]=-1,Ws[130]=Ws[40]=0,Js[130]=Js[40]=0,Zs[130]=Zs[40]=-1,Ks[130]=Ks[40]=1,ea[37]=ea[133]=0,na[37]=na[133]=1,ra[37]=ra[133]=1,fa[37]=fa[133]=0,ga[37]=ga[133]=1,da[37]=da[133]=0,Vs[37]=Vs[133]=-1,Hs[37]=Hs[133]=0,Ws[37]=Ws[133]=0,Js[37]=Js[133]=1,Zs[37]=Zs[133]=0,Ks[37]=Ks[133]=0,aa[148]=aa[22]=-1,ua[148]=ua[22]=0,ca[148]=ca[22]=0,fa[148]=fa[22]=0,ga[148]=ga[22]=-1,da[148]=da[22]=1,ha[148]=ha[22]=0,la[148]=la[22]=1,pa[148]=pa[22]=1,Js[148]=Js[22]=-1,Zs[148]=Zs[22]=0,Ks[148]=Ks[22]=1,Qs[82]=Qs[88]=0,$s[82]=$s[88]=-1,ta[82]=ta[88]=1,aa[82]=aa[88]=1,ua[82]=ua[88]=0,ca[82]=ca[88]=1,ia[82]=ia[88]=-1,oa[82]=oa[88]=0,sa[82]=sa[88]=1,ha[82]=ha[88]=0,la[82]=la[88]=-1,pa[82]=pa[88]=0,Qs[73]=Qs[97]=0,$s[73]=$s[97]=1,ta[73]=ta[97]=0,ea[73]=ea[97]=0,na[73]=na[97]=-1,ra[73]=ra[97]=0,ia[73]=ia[97]=1,oa[73]=oa[97]=0,sa[73]=sa[97]=0,Vs[73]=Vs[97]=1,Hs[73]=Hs[97]=0,Ws[73]=Ws[97]=1,Qs[145]=Qs[25]=0,$s[145]=$s[25]=-1,ta[145]=ta[25]=0,ia[145]=ia[25]=1,oa[145]=oa[25]=0,sa[145]=sa[25]=1,fa[145]=fa[25]=0,ga[145]=ga[25]=1,da[145]=da[25]=1,Js[145]=Js[25]=-1,Zs[145]=Zs[25]=0,Ks[145]=Ks[25]=0,ea[70]=ea[100]=0,na[70]=na[100]=1,ra[70]=ra[100]=0,aa[70]=aa[100]=-1,ua[70]=ua[100]=0,ca[70]=ca[100]=1,ha[70]=ha[100]=0,la[70]=la[100]=-1,pa[70]=pa[100]=1,Vs[70]=Vs[100]=1,Hs[70]=Hs[100]=0,Ws[70]=Ws[100]=0,ea[101]=ea[69]=0,na[101]=na[69]=1,ra[101]=ra[69]=0,Vs[101]=Vs[69]=1,Hs[101]=Hs[69]=0,Ws[101]=Ws[69]=0,fa[149]=fa[21]=0,ga[149]=ga[21]=1,da[149]=da[21]=1,Js[149]=Js[21]=-1,Zs[149]=Zs[21]=0,Ks[149]=Ks[21]=0,aa[86]=aa[84]=-1,ua[86]=ua[84]=0,ca[86]=ca[84]=1,ha[86]=ha[84]=0,la[86]=la[84]=-1,pa[86]=pa[84]=1,Qs[89]=Qs[81]=0,$s[89]=$s[81]=-1,ta[89]=ta[81]=0,ia[89]=ia[81]=1,oa[89]=oa[81]=0,sa[89]=sa[81]=1,Qs[96]=Qs[74]=0,$s[96]=$s[74]=1,ta[96]=ta[74]=0,ea[96]=ea[74]=-1,na[96]=na[74]=0,ra[96]=ra[74]=1,ha[96]=ha[74]=1,la[96]=la[74]=0,pa[96]=pa[74]=0,Vs[96]=Vs[74]=1,Hs[96]=Hs[74]=0,Ws[96]=Ws[74]=1,Qs[24]=Qs[146]=0,$s[24]=$s[146]=-1,ta[24]=ta[146]=1,aa[24]=aa[146]=1,ua[24]=ua[146]=0,ca[24]=ca[146]=1,ia[24]=ia[146]=0,oa[24]=oa[146]=1,sa[24]=sa[146]=1,Js[24]=Js[146]=0,Zs[24]=Zs[146]=-1,Ks[24]=Ks[146]=0,ea[6]=ea[164]=-1,na[6]=na[164]=0,ra[6]=ra[164]=1,aa[6]=aa[164]=-1,ua[6]=ua[164]=0,ca[6]=ca[164]=0,fa[6]=fa[164]=0,ga[6]=ga[164]=-1,da[6]=da[164]=1,ha[6]=ha[164]=1,la[6]=la[164]=0,pa[6]=pa[164]=0,ia[129]=ia[41]=0,oa[129]=oa[41]=1,sa[129]=sa[41]=1,fa[129]=fa[41]=0,ga[129]=ga[41]=1,da[129]=da[41]=0,Vs[129]=Vs[41]=-1,Hs[129]=Hs[41]=0,Ws[129]=Ws[41]=0,Js[129]=Js[41]=0,Zs[129]=Zs[41]=-1,Ks[129]=Ks[41]=0,aa[66]=aa[104]=0,ua[66]=ua[104]=1,ca[66]=ca[104]=0,ia[66]=ia[104]=-1,oa[66]=oa[104]=0,sa[66]=sa[104]=1,ha[66]=ha[104]=0,la[66]=la[104]=-1,pa[66]=pa[104]=0,Vs[66]=Vs[104]=0,Hs[66]=Hs[104]=-1,Ws[66]=Ws[104]=1,Qs[144]=Qs[26]=-1,$s[144]=$s[26]=0,ta[144]=ta[26]=0,fa[144]=fa[26]=1,ga[144]=ga[26]=0,da[144]=da[26]=1,ha[144]=ha[26]=0,la[144]=la[26]=1,pa[144]=pa[26]=1,Js[144]=Js[26]=-1,Zs[144]=Zs[26]=0,Ks[144]=Ks[26]=1,ea[36]=ea[134]=0,na[36]=na[134]=1,ra[36]=ra[134]=1,aa[36]=aa[134]=0,ua[36]=ua[134]=1,ca[36]=ca[134]=0,Vs[36]=Vs[134]=0,Hs[36]=Hs[134]=-1,Ws[36]=Ws[134]=1,Js[36]=Js[134]=1,Zs[36]=Zs[134]=0,Ks[36]=Ks[134]=0,Qs[9]=Qs[161]=-1,$s[9]=$s[161]=0,ta[9]=ta[161]=0,ea[9]=ea[161]=0,na[9]=na[161]=-1,ra[9]=ra[161]=0,ia[9]=ia[161]=1,oa[9]=oa[161]=0,sa[9]=sa[161]=0,fa[9]=fa[161]=1,ga[9]=ga[161]=0,da[9]=da[161]=1,Qs[136]=0,$s[136]=1,ta[136]=1,ea[136]=0,na[136]=1,ra[136]=0,aa[136]=-1,ua[136]=0,ca[136]=1,ia[136]=-1,oa[136]=0,sa[136]=0,fa[136]=0,ga[136]=-1,da[136]=0,ha[136]=0,la[136]=-1,pa[136]=1,Vs[136]=1,Hs[136]=0,Ws[136]=0,Js[136]=1,Zs[136]=0,Ks[136]=1,Qs[34]=0,$s[34]=-1,ta[34]=0,ea[34]=0,na[34]=-1,ra[34]=1,aa[34]=1,ua[34]=0,ca[34]=0,ia[34]=1,oa[34]=0,sa[34]=1,fa[34]=0,ga[34]=1,da[34]=1,ha[34]=0,la[34]=1,pa[34]=0,Vs[34]=-1,Hs[34]=0,Ws[34]=1,Js[34]=-1,Zs[34]=0,Ks[34]=0,Qs[35]=0,$s[35]=1,ta[35]=1,ea[35]=0,na[35]=-1,ra[35]=1,aa[35]=1,ua[35]=0,ca[35]=0,ia[35]=-1,oa[35]=0,sa[35]=0,fa[35]=0,ga[35]=-1,da[35]=0,ha[35]=0,la[35]=1,pa[35]=0,Vs[35]=-1,Hs[35]=0,Ws[35]=1,Js[35]=1,Zs[35]=0,Ks[35]=1,Qs[153]=0,$s[153]=1,ta[153]=1,ia[153]=-1,oa[153]=0,sa[153]=0,fa[153]=0,ga[153]=-1,da[153]=0,Js[153]=1,Zs[153]=0,Ks[153]=1,ea[102]=0,na[102]=-1,ra[102]=1,aa[102]=1,ua[102]=0,ca[102]=0,ha[102]=0,la[102]=1,pa[102]=0,Vs[102]=-1,Hs[102]=0,Ws[102]=1,Qs[155]=0,$s[155]=-1,ta[155]=0,ia[155]=1,oa[155]=0,sa[155]=1,fa[155]=0,ga[155]=1,da[155]=1,Js[155]=-1,Zs[155]=0,Ks[155]=0,ea[103]=0,na[103]=1,ra[103]=0,aa[103]=-1,ua[103]=0,ca[103]=1,ha[103]=0,la[103]=-1,pa[103]=1,Vs[103]=1,Hs[103]=0,Ws[103]=0,Qs[152]=0,$s[152]=1,ta[152]=1,aa[152]=-1,ua[152]=0,ca[152]=1,ia[152]=-1,oa[152]=0,sa[152]=0,fa[152]=0,ga[152]=-1,da[152]=0,ha[152]=0,la[152]=-1,pa[152]=1,Js[152]=1,Zs[152]=0,Ks[152]=1,Qs[156]=0,$s[156]=-1,ta[156]=1,aa[156]=1,ua[156]=0,ca[156]=1,ia[156]=-1,oa[156]=0,sa[156]=0,fa[156]=0,ga[156]=-1,da[156]=0,ha[156]=0,la[156]=1,pa[156]=1,Js[156]=-1,Zs[156]=0,Ks[156]=1,Qs[137]=0,$s[137]=1,ta[137]=1,ea[137]=0,na[137]=1,ra[137]=0,ia[137]=-1,oa[137]=0,sa[137]=0,fa[137]=0,ga[137]=-1,da[137]=0,Vs[137]=1,Hs[137]=0,Ws[137]=0,Js[137]=1,Zs[137]=0,Ks[137]=1,Qs[139]=0,$s[139]=1,ta[139]=1,ea[139]=0,na[139]=-1,ra[139]=0,ia[139]=1,oa[139]=0,sa[139]=0,fa[139]=0,ga[139]=1,da[139]=0,Vs[139]=-1,Hs[139]=0,Ws[139]=0,Js[139]=1,Zs[139]=0,Ks[139]=1,Qs[98]=0,$s[98]=-1,ta[98]=0,ea[98]=0,na[98]=-1,ra[98]=1,aa[98]=1,ua[98]=0,ca[98]=0,ia[98]=1,oa[98]=0,sa[98]=1,ha[98]=0,la[98]=1,pa[98]=0,Vs[98]=-1,Hs[98]=0,Ws[98]=1,Qs[99]=0,$s[99]=1,ta[99]=0,ea[99]=0,na[99]=-1,ra[99]=1,aa[99]=1,ua[99]=0,ca[99]=0,ia[99]=-1,oa[99]=0,sa[99]=1,ha[99]=0,la[99]=-1,pa[99]=0,Vs[99]=1,Hs[99]=0,Ws[99]=1,ea[38]=0,na[38]=-1,ra[38]=1,aa[38]=1,ua[38]=0,ca[38]=0,fa[38]=0,ga[38]=1,da[38]=1,ha[38]=0,la[38]=1,pa[38]=0,Vs[38]=-1,Hs[38]=0,Ws[38]=1,Js[38]=-1,Zs[38]=0,Ks[38]=0,ea[39]=0,na[39]=1,ra[39]=1,aa[39]=-1,ua[39]=0,ca[39]=0,fa[39]=0,ga[39]=-1,da[39]=1,ha[39]=0,la[39]=1,pa[39]=0,Vs[39]=-1,Hs[39]=0,Ws[39]=1,Js[39]=1,Zs[39]=0,Ks[39]=0;var ya=function(t){return[[t.bottomleft,0],[0,0],[0,t.leftbottom]]},_a=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0]]},ma=function(t){return[[t.topright,1],[1,1],[1,t.righttop]]},va=function(t){return[[0,t.lefttop],[0,1],[t.topleft,1]]},xa=function(t){return[[t.bottomright,0],[t.bottomleft,0],[0,t.leftbottom],[0,t.lefttop]]},Ea=function(t){return[[t.bottomright,0],[t.bottomleft,0],[1,t.righttop],[1,t.rightbottom]]},wa=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.topleft,1],[t.topright,1]]},ba=function(t){return[[0,t.leftbottom],[0,t.lefttop],[t.topleft,1],[t.topright,1]]},Ia=[],Na=[],Ca=[],Sa=[],Ma=[],La=[],Pa=[],Oa=[];Sa[1]=Ma[1]=18,Sa[169]=Ma[169]=18,Ca[4]=Na[4]=12,Ca[166]=Na[166]=12,Ia[16]=Oa[16]=4,Ia[154]=Oa[154]=4,La[64]=Pa[64]=22,La[106]=Pa[106]=22,Ca[2]=La[2]=17,Sa[2]=Ma[2]=18,Ca[168]=La[168]=17,Sa[168]=Ma[168]=18,Ia[8]=Sa[8]=9,Na[8]=Ca[8]=12,Ia[162]=Sa[162]=9,Na[162]=Ca[162]=12,Ia[32]=Oa[32]=4,Na[32]=Pa[32]=1,Ia[138]=Oa[138]=4,Na[138]=Pa[138]=1,Ma[128]=Oa[128]=21,La[128]=Pa[128]=22,Ma[42]=Oa[42]=21,La[42]=Pa[42]=22,Na[5]=Ma[5]=14,Na[165]=Ma[165]=14,Ca[20]=Oa[20]=6,Ca[150]=Oa[150]=6,Ia[80]=La[80]=11,Ia[90]=La[90]=11,Sa[65]=Pa[65]=3,Sa[105]=Pa[105]=3,Ia[160]=La[160]=11,Na[160]=Ma[160]=14,Ia[10]=La[10]=11,Na[10]=Ma[10]=14,Ca[130]=Oa[130]=6,Sa[130]=Pa[130]=3,Ca[40]=Oa[40]=6,Sa[40]=Pa[40]=3,Na[101]=Pa[101]=1,Na[69]=Pa[69]=1,Ma[149]=Oa[149]=21,Ma[21]=Oa[21]=21,Ca[86]=La[86]=17,Ca[84]=La[84]=17,Ia[89]=Sa[89]=9,Ia[81]=Sa[81]=9,Ia[96]=Pa[96]=0,Na[96]=La[96]=15,Ia[74]=Pa[74]=0,Na[74]=La[74]=15,Ia[24]=Ca[24]=8,Sa[24]=Oa[24]=7,Ia[146]=Ca[146]=8,Sa[146]=Oa[146]=7,Na[6]=La[6]=15,Ca[6]=Ma[6]=16,Na[164]=La[164]=15,Ca[164]=Ma[164]=16,Sa[129]=Oa[129]=7,Ma[129]=Pa[129]=20,Sa[41]=Oa[41]=7,Ma[41]=Pa[41]=20,Ca[66]=Pa[66]=2,Sa[66]=La[66]=19,Ca[104]=Pa[104]=2,Sa[104]=La[104]=19,Ia[144]=Ma[144]=10,La[144]=Oa[144]=23,Ia[26]=Ma[26]=10,La[26]=Oa[26]=23,Na[36]=Oa[36]=5,Ca[36]=Pa[36]=2,Na[134]=Oa[134]=5,Ca[134]=Pa[134]=2,Ia[9]=Ma[9]=10,Na[9]=Sa[9]=13,Ia[161]=Ma[161]=10,Na[161]=Sa[161]=13,Na[37]=Oa[37]=5,Ma[37]=Pa[37]=20,Na[133]=Oa[133]=5,Ma[133]=Pa[133]=20,Ca[148]=Ma[148]=16,La[148]=Oa[148]=23,Ca[22]=Ma[22]=16,La[22]=Oa[22]=23,Ia[82]=Ca[82]=8,Sa[82]=La[82]=19,Ia[88]=Ca[88]=8,Sa[88]=La[88]=19,Ia[73]=Pa[73]=0,Na[73]=Sa[73]=13,Ia[97]=Pa[97]=0,Na[97]=Sa[97]=13,Ia[145]=Sa[145]=9,Ma[145]=Oa[145]=21,Ia[25]=Sa[25]=9,Ma[25]=Oa[25]=21,Na[70]=Pa[70]=1,Ca[70]=La[70]=17,Na[100]=Pa[100]=1,Ca[100]=La[100]=17,Ia[34]=Sa[34]=9,Na[34]=Ca[34]=12,Ma[34]=Oa[34]=21,La[34]=Pa[34]=22,Ia[136]=Oa[136]=4,Na[136]=Pa[136]=1,Ca[136]=La[136]=17,Sa[136]=Ma[136]=18,Ia[35]=Oa[35]=4,Na[35]=Ca[35]=12,Sa[35]=Ma[35]=18,La[35]=Pa[35]=22,Ia[153]=Oa[153]=4,Sa[153]=Ma[153]=18,Na[102]=Ca[102]=12,La[102]=Pa[102]=22,Ia[155]=Sa[155]=9,Ma[155]=Oa[155]=23,Na[103]=Pa[103]=1,Ca[103]=La[103]=17,Ia[152]=Oa[152]=4,Ca[152]=La[152]=17,Sa[152]=Ma[152]=18,Ia[156]=Ca[156]=8,Sa[156]=Ma[156]=18,La[156]=Oa[156]=23,Ia[137]=Oa[137]=4,Na[137]=Pa[137]=1,Sa[137]=Ma[137]=18,Ia[139]=Oa[139]=4,Na[139]=Sa[139]=13,Ma[139]=Pa[139]=20,Ia[98]=Sa[98]=9,Na[98]=Ca[98]=12,La[98]=Pa[98]=22,Ia[99]=Pa[99]=0,Na[99]=Ca[99]=12,Sa[99]=La[99]=19,Na[38]=Ca[38]=12,Ma[38]=Oa[38]=21,La[38]=Pa[38]=22,Na[39]=Oa[39]=5,Ca[39]=Ma[39]=16,La[39]=Pa[39]=22;var Ra=[];Ra[1]=Ra[169]=ya,Ra[4]=Ra[166]=_a,Ra[16]=Ra[154]=ma,Ra[64]=Ra[106]=va,Ra[168]=Ra[2]=xa,Ra[162]=Ra[8]=Ea,Ra[138]=Ra[32]=wa,Ra[42]=Ra[128]=ba,Ra[5]=Ra[165]=function(t){return[[0,0],[0,t.leftbottom],[1,t.rightbottom],[1,0]]},Ra[20]=Ra[150]=function(t){return[[1,0],[t.bottomright,0],[t.topright,1],[1,1]]},Ra[80]=Ra[90]=function(t){return[[1,1],[1,t.righttop],[0,t.lefttop],[0,1]]},Ra[65]=Ra[105]=function(t){return[[t.bottomleft,0],[0,0],[0,1],[t.topleft,1]]},Ra[160]=Ra[10]=function(t){return[[1,t.righttop],[1,t.rightbottom],[0,t.leftbottom],[0,t.lefttop]]},Ra[130]=Ra[40]=function(t){return[[t.topleft,1],[t.topright,1],[t.bottomright,0],[t.bottomleft,0]]},Ra[85]=function(){return[[0,0],[0,1],[1,1],[1,0]]},Ra[101]=Ra[69]=function(t){return[[1,t.rightbottom],[1,0],[0,0],[0,1],[t.topleft,1]]},Ra[149]=Ra[21]=function(t){return[[t.topright,1],[1,1],[1,0],[0,0],[0,t.leftbottom]]},Ra[86]=Ra[84]=function(t){return[[1,0],[t.bottomright,0],[0,t.lefttop],[0,1],[1,1]]},Ra[89]=Ra[81]=function(t){return[[1,1],[1,t.righttop],[t.bottomleft,0],[0,0],[0,1]]},Ra[96]=Ra[74]=function(t){return[[1,t.righttop],[1,t.rightbottom],[0,t.lefttop],[0,1],[t.topleft,1]]},Ra[24]=Ra[146]=function(t){return[[1,1],[1,t.righttop],[t.bottomright,0],[t.bottomleft,0],[t.topright,1]]},Ra[6]=Ra[164]=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0],[0,t.leftbottom],[0,t.lefttop]]},Ra[129]=Ra[41]=function(t){return[[t.topright,1],[t.bottomleft,0],[0,0],[0,t.leftbottom],[t.topleft,1]]},Ra[66]=Ra[104]=function(t){return[[t.bottomright,0],[t.bottomleft,0],[0,t.lefttop],[0,1],[t.topleft,1]]},Ra[144]=Ra[26]=function(t){return[[1,1],[1,t.righttop],[0,t.leftbottom],[0,t.lefttop],[t.topright,1]]},Ra[36]=Ra[134]=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0],[t.topleft,1],[t.topright,1]]},Ra[9]=Ra[161]=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.bottomleft,0],[0,0],[0,t.leftbottom]]},Ra[37]=Ra[133]=function(t){return[[1,t.rightbottom],[1,0],[0,0],[0,t.leftbottom],[t.topleft,1],[t.topright,1]]},Ra[148]=Ra[22]=function(t){return[[1,1],[1,0],[t.bottomright,0],[0,t.leftbottom],[0,t.lefttop],[t.topright,1]]},Ra[82]=Ra[88]=function(t){return[[1,1],[1,t.righttop],[t.bottomright,0],[t.bottomleft,0],[0,t.lefttop],[0,1]]},Ra[73]=Ra[97]=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.bottomleft,0],[0,0],[0,1],[t.topleft,1]]},Ra[145]=Ra[25]=function(t){return[[1,1],[1,t.righttop],[t.bottomleft,0],[0,0],[0,t.leftbottom],[t.topright,1]]},Ra[70]=Ra[100]=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0],[0,t.lefttop],[0,1],[t.topleft,1]]},Ra[34]=function(t){return[ba(t),Ea(t)]},Ra[35]=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.bottomright,0],[t.bottomleft,0],[0,t.leftbottom],[0,t.lefttop],[t.topleft,1],[t.topright,1]]},Ra[136]=function(t){return[wa(t),xa(t)]},Ra[153]=function(t){return[ma(t),ya(t)]},Ra[102]=function(t){return[_a(t),va(t)]},Ra[155]=function(t){return[[1,1],[1,t.righttop],[t.bottomleft,0],[0,0],[0,t.leftbottom],[t.topright,1]]},Ra[103]=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0],[0,t.lefttop],[0,1],[t.topleft,1]]},Ra[152]=function(t){return[ma(t),xa(t)]},Ra[156]=function(t){return[[1,1],[1,t.righttop],[t.bottomright,0],[t.bottomleft,0],[0,t.leftbottom],[0,t.lefttop],[t.topright,1]]},Ra[137]=function(t){return[wa(t),ya(t)]},Ra[139]=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.bottomleft,0],[0,0],[0,t.leftbottom],[t.topleft,1],[t.topright,1]]},Ra[98]=function(t){return[Ea(t),va(t)]},Ra[99]=function(t){return[[1,t.righttop],[1,t.rightbottom],[t.bottomright,0],[t.bottomleft,0],[0,t.lefttop],[0,1],[t.topleft,1]]},Ra[38]=function(t){return[_a(t),ba(t)]},Ra[39]=function(t){return[[1,t.rightbottom],[1,0],[t.bottomright,0],[0,t.leftbottom],[0,t.lefttop],[t.topleft,1],[t.topright,1]]};var Ta=function t(e){this.id=t.buildId(e),this.coordinates=e,this.innerEdges=[],this.outerEdges=[],this.outerEdgesSorted=!1};Ta.buildId=function(t){return t.join(",")},Ta.prototype.removeInnerEdge=function(t){this.innerEdges=this.innerEdges.filter(function(e){return e.from.id!==t.from.id})},Ta.prototype.removeOuterEdge=function(t){this.outerEdges=this.outerEdges.filter(function(e){return e.to.id!==t.to.id})},Ta.prototype.addOuterEdge=function(t){this.outerEdges.push(t),this.outerEdgesSorted=!1},Ta.prototype.sortOuterEdges=function(){var t=this;this.outerEdgesSorted||(this.outerEdges.sort(function(e,n){var r=e.to,i=n.to;if(r.coordinates[0]-t.coordinates[0]>=0&&i.coordinates[0]-t.coordinates[0]<0)return 1;if(r.coordinates[0]-t.coordinates[0]<0&&i.coordinates[0]-t.coordinates[0]>=0)return-1;if(r.coordinates[0]-t.coordinates[0]==0&&i.coordinates[0]-t.coordinates[0]==0)return r.coordinates[1]-t.coordinates[1]>=0||i.coordinates[1]-t.coordinates[1]>=0?r.coordinates[1]-i.coordinates[1]:i.coordinates[1]-r.coordinates[1];var o=xr(t.coordinates,r.coordinates,i.coordinates);if(o<0)return 1;if(o>0)return-1;return Math.pow(r.coordinates[0]-t.coordinates[0],2)+Math.pow(r.coordinates[1]-t.coordinates[1],2)-(Math.pow(i.coordinates[0]-t.coordinates[0],2)+Math.pow(i.coordinates[1]-t.coordinates[1],2))}),this.outerEdgesSorted=!0)},Ta.prototype.getOuterEdges=function(){return this.sortOuterEdges(),this.outerEdges},Ta.prototype.getOuterEdge=function(t){return this.sortOuterEdges(),this.outerEdges[t]},Ta.prototype.addInnerEdge=function(t){this.innerEdges.push(t)};var Aa=function(t,e){this.from=t,this.to=e,this.next=void 0,this.label=void 0,this.symetric=void 0,this.ring=void 0,this.from.addOuterEdge(this),this.to.addInnerEdge(this)};Aa.prototype.getSymetric=function(){return this.symetric||(this.symetric=new Aa(this.to,this.from),this.symetric.symetric=this),this.symetric},Aa.prototype.deleteEdge=function(){this.from.removeOuterEdge(this),this.to.removeInnerEdge(this)},Aa.prototype.isEqual=function(t){return this.from.id===t.from.id&&this.to.id===t.to.id},Aa.prototype.toString=function(){return"Edge { "+this.from.id+" -> "+this.to.id+" }"},Aa.prototype.toLineString=function(){return a([this.from.coordinates,this.to.coordinates])},Aa.prototype.compareTo=function(t){return xr(t.from.coordinates,t.to.coordinates,this.to.coordinates)};var Da=function(){this.edges=[],this.polygon=void 0,this.envelope=void 0},Fa={length:{configurable:!0}};Da.prototype.push=function(t){this[this.edges.length]=t,this.edges.push(t),this.polygon=this.envelope=void 0},Da.prototype.get=function(t){return this.edges[t]},Fa.length.get=function(){return this.edges.length},Da.prototype.forEach=function(t){this.edges.forEach(t)},Da.prototype.map=function(t){return this.edges.map(t)},Da.prototype.some=function(t){return this.edges.some(t)},Da.prototype.isValid=function(){return!0},Da.prototype.isHole=function(){var t=this,e=this.edges.reduce(function(e,n,r){return n.from.coordinates[1]>t.edges[e].from.coordinates[1]&&(e=r),e},0),n=(0===e?this.length:e)-1,r=(e+1)%this.length,i=xr(this.edges[n].from.coordinates,this.edges[e].from.coordinates,this.edges[r].from.coordinates);return 0===i?this.edges[n].from.coordinates[0]>this.edges[r].from.coordinates[0]:i>0},Da.prototype.toMultiPoint=function(){return l(this.edges.map(function(t){return t.from.coordinates}))},Da.prototype.toPolygon=function(){if(this.polygon)return this.polygon;var t=this.edges.map(function(t){return t.from.coordinates});return t.push(this.edges[0].from.coordinates),this.polygon=o([t])},Da.prototype.getEnvelope=function(){return this.envelope?this.envelope:this.envelope=he(this.toPolygon())},Da.findEdgeRingContaining=function(t,e){var n,i,o=t.getEnvelope();return e.forEach(function(e){var s=e.getEnvelope();if(i&&(n=i.getEnvelope()),!function(t,e){var n=t.geometry.coordinates.map(function(t){return t[0]}),r=t.geometry.coordinates.map(function(t){return t[1]}),i=e.geometry.coordinates.map(function(t){return t[0]}),o=e.geometry.coordinates.map(function(t){return t[1]});return Math.max(null,n)===Math.max(null,i)&&Math.max(null,r)===Math.max(null,o)&&Math.min(null,n)===Math.min(null,i)&&Math.min(null,r)===Math.min(null,o)}(s,o)&&Er(s,o)){var a=t.map(function(t){return t.from.coordinates}).find(function(t){return!e.some(function(e){return function(t,e){return t[0]===e[0]&&t[1]===e[1]}(t,e.from.coordinates)})});a&&e.inside(r(a))&&(i&&!Er(n,s)||(i=e))}}),i},Da.prototype.inside=function(t){return Pt(t,this.toPolygon())},Object.defineProperties(Da.prototype,Fa);var qa=function(){this.edges=[],this.nodes={}};qa.fromGeoJson=function(t){!function(t){if(!t)throw new Error("No geojson passed");if("FeatureCollection"!==t.type&&"GeometryCollection"!==t.type&&"MultiLineString"!==t.type&&"LineString"!==t.type&&"Feature"!==t.type)throw new Error("Invalid input type '"+t.type+"'. Geojson must be FeatureCollection, GeometryCollection, LineString, MultiLineString or Feature")}(t);var e=new qa;return F(t,function(t){H(t,"LineString","Graph::fromGeoJson"),M(t,function(t,n){if(t){var r=e.getNode(t),i=e.getNode(n);e.addEdge(r,i)}return n})}),e},qa.prototype.getNode=function(t){var e=Ta.buildId(t),n=this.nodes[e];return n||(n=this.nodes[e]=new Ta(t)),n},qa.prototype.addEdge=function(t,e){var n=new Aa(t,e),r=n.getSymetric();this.edges.push(n),this.edges.push(r)},qa.prototype.deleteDangles=function(){var t=this;Object.keys(this.nodes).map(function(e){return t.nodes[e]}).forEach(function(e){return t._removeIfDangle(e)})},qa.prototype._removeIfDangle=function(t){var e=this;if(t.innerEdges.length<=1){var n=t.getOuterEdges().map(function(t){return t.to});this.removeNode(t),n.forEach(function(t){return e._removeIfDangle(t)})}},qa.prototype.deleteCutEdges=function(){var t=this;this._computeNextCWEdges(),this._findLabeledEdgeRings(),this.edges.forEach(function(e){e.label===e.symetric.label&&(t.removeEdge(e.symetric),t.removeEdge(e))})},qa.prototype._computeNextCWEdges=function(t){var e=this;void 0===t?Object.keys(this.nodes).forEach(function(t){return e._computeNextCWEdges(e.nodes[t])}):t.getOuterEdges().forEach(function(e,n){t.getOuterEdge((0===n?t.getOuterEdges().length:n)-1).symetric.next=e})},qa.prototype._computeNextCCWEdges=function(t,e){for(var n,r,i=t.getOuterEdges(),o=i.length-1;o>=0;--o){var s=i[o],a=s.symetric,u=void 0,c=void 0;s.label===e&&(u=s),a.label===e&&(c=a),u&&c&&(c&&(r=c),u&&(r&&(r.next=u,r=void 0),n||(n=u)))}r&&(r.next=n)},qa.prototype._findLabeledEdgeRings=function(){var t=[],e=0;return this.edges.forEach(function(n){if(!(n.label>=0)){t.push(n);var r=n;do{r.label=e,r=r.next}while(!n.isEqual(r));e++}}),t},qa.prototype.getEdgeRings=function(){var t=this;this._computeNextCWEdges(),this.edges.forEach(function(t){t.label=void 0}),this._findLabeledEdgeRings().forEach(function(e){t._findIntersectionNodes(e).forEach(function(n){t._computeNextCCWEdges(n,e.label)})});var e=[];return this.edges.forEach(function(n){n.ring||e.push(t._findEdgeRing(n))}),e},qa.prototype._findIntersectionNodes=function(t){var e=[],n=t,r=function(){var r=0;n.from.getOuterEdges().forEach(function(e){e.label===t.label&&++r}),r>1&&e.push(n.from),n=n.next};do{r()}while(!t.isEqual(n));return e},qa.prototype._findEdgeRing=function(t){var e=t,n=new Da;do{n.push(e),e.ring=n,e=e.next}while(!t.isEqual(e));return n},qa.prototype.removeNode=function(t){var e=this;t.getOuterEdges().forEach(function(t){return e.removeEdge(t)}),t.innerEdges.forEach(function(t){return e.removeEdge(t)}),delete this.nodes[t.id]},qa.prototype.removeEdge=function(t){this.edges=this.edges.filter(function(e){return!e.isEqual(t)}),t.deleteEdge()};var Ga=mt(function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}(t.exports="function"==typeof Object.keys?Object.keys:n).shim=n}),Ba=(Ga.shim,mt(function(t,e){function n(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function r(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}var i="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();(e=t.exports=i?n:r).supported=n,e.unsupported=r})),ka=(Ba.supported,Ba.unsupported,mt(function(t){function e(t){return null===t||void 0===t}function n(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length)&&("function"==typeof t.copy&&"function"==typeof t.slice&&!(t.length>0&&"number"!=typeof t[0]))}var r=Array.prototype.slice,i=t.exports=function(t,o,s){return s||(s={}),t===o||(t instanceof Date&&o instanceof Date?t.getTime()===o.getTime():!t||!o||"object"!=typeof t&&"object"!=typeof o?s.strict?t===o:t==o:function(t,o,s){var a,u;if(e(t)||e(o))return!1;if(t.prototype!==o.prototype)return!1;if(Ba(t))return!!Ba(o)&&(t=r.call(t),o=r.call(o),i(t,o,s));if(n(t)){if(!n(o))return!1;if(t.length!==o.length)return!1;for(a=0;a<t.length;a++)if(t[a]!==o[a])return!1;return!0}try{var c=Ga(t),h=Ga(o)}catch(t){return!1}if(c.length!=h.length)return!1;for(c.sort(),h.sort(),a=c.length-1;a>=0;a--)if(c[a]!=h[a])return!1;for(a=c.length-1;a>=0;a--)if(u=c[a],!i(t[u],o[u],s))return!1;return typeof t==typeof o}(t,o,s))}})),za=function(t){this.precision=t&&t.precision?t.precision:17,this.direction=!(!t||!t.direction)&&t.direction,this.pseudoNode=!(!t||!t.pseudoNode)&&t.pseudoNode,this.objectComparator=t&&t.objectComparator?t.objectComparator:Rr};za.prototype.compare=function(t,e){if(t.type!==e.type||!Or(t,e))return!1;switch(t.type){case"Point":return this.compareCoord(t.coordinates,e.coordinates);case"LineString":return this.compareLine(t.coordinates,e.coordinates,0,!1);case"Polygon":return this.comparePolygon(t,e);case"Feature":return this.compareFeature(t,e);default:if(0===t.type.indexOf("Multi")){var n=this,r=Pr(t),i=Pr(e);return r.every(function(t){return this.some(function(e){return n.compare(t,e)})},i)}}return!1},za.prototype.compareCoord=function(t,e){if(t.length!==e.length)return!1;for(var n=0;n<t.length;n++)if(t[n].toFixed(this.precision)!==e[n].toFixed(this.precision))return!1;return!0},za.prototype.compareLine=function(t,e,n,r){if(!Or(t,e))return!1;var i=this.pseudoNode?t:this.removePseudo(t),o=this.pseudoNode?e:this.removePseudo(e);if(!r||this.compareCoord(i[0],o[0])||(o=this.fixStartIndex(o,i))){var s=this.compareCoord(i[n],o[n]);return this.direction||s?this.comparePath(i,o):!!this.compareCoord(i[n],o[o.length-(1+n)])&&this.comparePath(i.slice().reverse(),o)}},za.prototype.fixStartIndex=function(t,e){for(var n,r=-1,i=0;i<t.length;i++)if(this.compareCoord(t[i],e[0])){r=i;break}return r>=0&&(n=[].concat(t.slice(r,t.length),t.slice(1,r+1))),n},za.prototype.comparePath=function(t,e){var n=this;return t.every(function(t,e){return n.compareCoord(t,this[e])},e)},za.prototype.comparePolygon=function(t,e){if(this.compareLine(t.coordinates[0],e.coordinates[0],1,!0)){var n=t.coordinates.slice(1,t.coordinates.length),r=e.coordinates.slice(1,e.coordinates.length),i=this;return n.every(function(t){return this.some(function(e){return i.compareLine(t,e,1,!0)})},r)}return!1},za.prototype.compareFeature=function(t,e){return!(t.id!==e.id||!this.objectComparator(t.properties,e.properties)||!this.compareBBox(t,e))&&this.compare(t.geometry,e.geometry)},za.prototype.compareBBox=function(t,e){return!!(!t.bbox&&!e.bbox||t.bbox&&e.bbox&&this.compareCoord(t.bbox,e.bbox))},za.prototype.removePseudo=function(t){return t};var ja=za,Xa=mt(function(t){function e(t,e,n,r){this.dataset=[],this.epsilon=1,this.minPts=2,this.distance=this._euclideanDistance,this.clusters=[],this.noise=[],this._visited=[],this._assigned=[],this._datasetLength=0,this._init(t,e,n,r)}e.prototype.run=function(t,e,n,r){this._init(t,e,n,r);for(var i=0;i<this._datasetLength;i++)if(1!==this._visited[i]){this._visited[i]=1;var o=this._regionQuery(i);if(o.length<this.minPts)this.noise.push(i);else{var s=this.clusters.length;this.clusters.push([]),this._addToCluster(i,s),this._expandCluster(s,o)}}return this.clusters},e.prototype._init=function(t,e,n,r){if(t){if(!(t instanceof Array))throw Error("Dataset must be of type array, "+typeof t+" given");this.dataset=t,this.clusters=[],this.noise=[],this._datasetLength=t.length,this._visited=new Array(this._datasetLength),this._assigned=new Array(this._datasetLength)}e&&(this.epsilon=e),n&&(this.minPts=n),r&&(this.distance=r)},e.prototype._expandCluster=function(t,e){for(var n=0;n<e.length;n++){var r=e[n];if(1!==this._visited[r]){this._visited[r]=1;var i=this._regionQuery(r);i.length>=this.minPts&&(e=this._mergeArrays(e,i))}1!==this._assigned[r]&&this._addToCluster(r,t)}},e.prototype._addToCluster=function(t,e){this.clusters[e].push(t),this._assigned[t]=1},e.prototype._regionQuery=function(t){for(var e=[],n=0;n<this._datasetLength;n++){this.distance(this.dataset[t],this.dataset[n])<this.epsilon&&e.push(n)}return e},e.prototype._mergeArrays=function(t,e){for(var n=e.length,r=0;r<n;r++){var i=e[r];t.indexOf(i)<0&&t.push(i)}return t},e.prototype._euclideanDistance=function(t,e){for(var n=0,r=Math.min(t.length,e.length);r--;)n+=(t[r]-e[r])*(t[r]-e[r]);return Math.sqrt(n)},t.exports&&(t.exports=e)}),Ua=mt(function(t){function e(t,e,n){this.k=3,this.dataset=[],this.assignments=[],this.centroids=[],this.init(t,e,n)}e.prototype.init=function(t,e,n){this.assignments=[],this.centroids=[],void 0!==t&&(this.dataset=t),void 0!==e&&(this.k=e),void 0!==n&&(this.distance=n)},e.prototype.run=function(t,e){this.init(t,e);for(var n=this.dataset.length,r=0;r<this.k;r++)this.centroids[r]=this.randomCentroid();for(var i=!0;i;){i=this.assign();for(var o=0;o<this.k;o++){for(var s=new Array(h),a=0,u=0;u<h;u++)s[u]=0;for(var c=0;c<n;c++){var h=this.dataset[c].length;if(o===this.assignments[c]){for(u=0;u<h;u++)s[u]+=this.dataset[c][u];a++}}if(a>0){for(u=0;u<h;u++)s[u]/=a;this.centroids[o]=s}else this.centroids[o]=this.randomCentroid(),i=!0}}return this.getClusters()},e.prototype.randomCentroid=function(){var t,e,n=this.dataset.length-1;do{e=Math.round(Math.random()*n),t=this.dataset[e]}while(this.centroids.indexOf(t)>=0);return t},e.prototype.assign=function(){for(var t,e=!1,n=this.dataset.length,r=0;r<n;r++)(t=this.argmin(this.dataset[r],this.centroids,this.distance))!=this.assignments[r]&&(this.assignments[r]=t,e=!0);return e},e.prototype.getClusters=function(){for(var t,e=new Array(this.k),n=0;n<this.assignments.length;n++)void 0===e[t=this.assignments[n]]&&(e[t]=[]),e[t].push(n);return e},e.prototype.argmin=function(t,e,n){for(var r,i=Number.MAX_VALUE,o=0,s=e.length,a=0;a<s;a++)(r=n(t,e[a]))<i&&(i=r,o=a);return o},e.prototype.distance=function(t,e){for(var n=0,r=Math.min(t.length,e.length);r--;){var i=t[r]-e[r];n+=i*i}return Math.sqrt(n)},t.exports&&(t.exports=e)}),Ya=mt(function(t){function e(t,e,n){this._queue=[],this._priorities=[],this._sorting="desc",this._init(t,e,n)}e.prototype.insert=function(t,e){for(var n=this._queue.length,r=n;r--;){var i=this._priorities[r];"desc"===this._sorting?e>i&&(n=r):e<i&&(n=r)}this._insertAt(t,e,n)},e.prototype.remove=function(t){for(var e=this._queue.length;e--;){if(t===this._queue[e]){this._queue.splice(e,1),this._priorities.splice(e,1);break}}},e.prototype.forEach=function(t){this._queue.forEach(t)},e.prototype.getElements=function(){return this._queue},e.prototype.getElementPriority=function(t){return this._priorities[t]},e.prototype.getPriorities=function(){return this._priorities},e.prototype.getElementsWithPriorities=function(){for(var t=[],e=0,n=this._queue.length;e<n;e++)t.push([this._queue[e],this._priorities[e]]);return t},e.prototype._init=function(t,e,n){if(t&&e){if(this._queue=[],this._priorities=[],t.length!==e.length)throw new Error("Arrays must have the same length");for(var r=0;r<t.length;r++)this.insert(t[r],e[r])}n&&(this._sorting=n)},e.prototype._insertAt=function(t,e,n){this._queue.length===n?(this._queue.push(t),this._priorities.push(e)):(this._queue.splice(n,0,t),this._priorities.splice(n,0,e))},t.exports&&(t.exports=e)}),Va=mt(function(t){function e(t,e,n,r){this.epsilon=1,this.minPts=1,this.distance=this._euclideanDistance,this._reachability=[],this._processed=[],this._coreDistance=0,this._orderedList=[],this._init(t,e,n,r)}if(t.exports)var n=Ya;e.prototype.run=function(t,e,r,i){this._init(t,e,r,i);for(var o=0,s=this.dataset.length;o<s;o++)if(1!==this._processed[o]){this._processed[o]=1,this.clusters.push([o]);var a=this.clusters.length-1;this._orderedList.push(o);var u=new n(null,null,"asc"),c=this._regionQuery(o);void 0!==this._distanceToCore(o)&&(this._updateQueue(o,c,u),this._expandCluster(a,u))}return this.clusters},e.prototype.getReachabilityPlot=function(){for(var t=[],e=0,n=this._orderedList.length;e<n;e++){var r=this._orderedList[e],i=this._reachability[r];t.push([r,i])}return t},e.prototype._init=function(t,e,n,r){if(t){if(!(t instanceof Array))throw Error("Dataset must be of type array, "+typeof t+" given");this.dataset=t,this.clusters=[],this._reachability=new Array(this.dataset.length),this._processed=new Array(this.dataset.length),this._coreDistance=0,this._orderedList=[]}e&&(this.epsilon=e),n&&(this.minPts=n),r&&(this.distance=r)},e.prototype._updateQueue=function(t,e,n){var r=this;this._coreDistance=this._distanceToCore(t),e.forEach(function(e){if(void 0===r._processed[e]){var i=r.distance(r.dataset[t],r.dataset[e]),o=Math.max(r._coreDistance,i);void 0===r._reachability[e]?(r._reachability[e]=o,n.insert(e,o)):o<r._reachability[e]&&(r._reachability[e]=o,n.remove(e),n.insert(e,o))}})},e.prototype._expandCluster=function(t,e){for(var n=e.getElements(),r=0,i=n.length;r<i;r++){var o=n[r];if(void 0===this._processed[o]){var s=this._regionQuery(o);this._processed[o]=1,this.clusters[t].push(o),this._orderedList.push(o),void 0!==this._distanceToCore(o)&&(this._updateQueue(o,s,e),this._expandCluster(t,e))}}},e.prototype._distanceToCore=function(t){for(var e=this.epsilon,n=0;n<e;n++){if(this._regionQuery(t,n).length>=this.minPts)return n}},e.prototype._regionQuery=function(t,e){e=e||this.epsilon;for(var n=[],r=0,i=this.dataset.length;r<i;r++)this.distance(this.dataset[t],this.dataset[r])<e&&n.push(r);return n},e.prototype._euclideanDistance=function(t,e){for(var n=0,r=Math.min(t.length,e.length);r--;)n+=(t[r]-e[r])*(t[r]-e[r]);return Math.sqrt(n)},t.exports&&(t.exports=e)}),Ha=mt(function(t){t.exports&&(t.exports={DBSCAN:Xa,KMEANS:Ua,OPTICS:Va,PriorityQueue:Ya})}),Wa=(Ha.DBSCAN,Ha.KMEANS,Ha.OPTICS,Ha.PriorityQueue,function(t,e,n){for(var r=t.length,i=0,o=0;o<r;o++){var s=(t[o]||0)-(e[o]||0);i+=s*s}return n?Math.sqrt(i):i}),Ja=Wa,Za=function(t,e,n){var r=Math.abs(t-e);return n?r:r*r},Ka=Wa,Qa=function(t,e){for(var n={},r=[],i=e<<2,o=t.length,s=t[0].length>0;r.length<e&&i-- >0;){var a=t[Math.floor(Math.random()*o)],u=s?a.join("_"):""+a;n[u]||(n[u]=!0,r.push(a))}if(r.length<e)throw new Error("Error initializating clusters");return r},$a=function(t,e){var n=t[0].length?Ja:Za,r=[],i=t.length,o=t[0].length>0,s=t[Math.floor(Math.random()*i)];o&&s.join("_");for(r.push(s);r.length<e;){for(var a=[],u=r.length,c=0,h=[],l=0;l<i;l++){for(var p=1/0,f=0;f<u;f++){var g=n(t[l],r[f]);g<=p&&(p=g)}a[l]=p}for(var d=0;d<i;d++)c+=a[d];for(var y=0;y<i;y++)h[y]={i:y,v:t[y],pr:a[y]/c,cs:0};h.sort(function(t,e){return t.pr-e.pr}),h[0].cs=h[0].pr;for(var _=1;_<i;_++)h[_].cs=h[_-1].cs+h[_].pr;for(var m=Math.random(),v=0;v<i-1&&h[v++].cs<m;);r.push(h[v-1].v)}return r},tu=1e4,eu=function(t,e,n,r){var i=[],o=[],s=[],a=[],u=!1,c=r||tu,h=t.length,l=t[0].length,p=l>0,f=[];if(n)i="kmrand"==n?Qa(t,e):"kmpp"==n?$a(t,e):n;else for(var g={};i.length<e;){var d=Math.floor(Math.random()*h);g[d]||(g[d]=!0,i.push(t[d]))}do{Ar(e,0,f);for(var y=0;y<h;y++){for(var _=1/0,m=0,v=0;v<e;v++)(a=p?Ka(t[y],i[v]):Math.abs(t[y]-i[v]))<=_&&(_=a,m=v);s[y]=m,f[m]++}for(var x=[],E=(o=[],0);E<e;E++)x[E]=p?Ar(l,0,x[E]):0,o[E]=i[E];if(p){for(var w=0;w<e;w++)i[w]=[];for(var b=0;b<h;b++)for(var I=x[s[b]],N=t[b],C=0;C<l;C++)I[C]+=N[C];u=!0;for(var S=0;S<e;S++){for(var M=i[S],L=x[S],P=o[S],O=f[S],R=0;R<l;R++)M[R]=L[R]/O||0;if(u)for(var T=0;T<l;T++)if(P[T]!=M[T]){u=!1;break}}}else{for(var A=0;A<h;A++)x[s[A]]+=t[A];for(var D=0;D<e;D++)i[D]=x[D]/f[D]||0;u=!0;for(var F=0;F<e;F++)if(o[F]!=i[F]){u=!1;break}}u=u||--c<=0}while(!u);return{it:tu-c,k:e,idxs:s,centroids:i}},nu={search:function(t,e,n,r){t.cleanDirty();var i=(r=r||{}).heuristic||nu.heuristics.manhattan,o=r.closest||!1,s=new Br(function(t){return t.f}),a=e;for(e.h=i(e,n),s.push(e);s.size()>0;){var u=s.pop();if(u===n)return Fr(u);u.closed=!0;for(var c=t.neighbors(u),h=0,l=c.length;h<l;++h){var p=c[h];if(!p.closed&&!p.isWall()){var f=u.g+p.getCost(u),g=p.visited;(!g||f<p.g)&&(p.visited=!0,p.parent=u,p.h=p.h||i(p,n),p.g=f,p.f=p.g+p.h,t.markDirty(p),o&&(p.h<a.h||p.h===a.h&&p.g<a.g)&&(a=p),g?s.rescoreElement(p):s.push(p))}}}return o?Fr(a):[]},heuristics:{manhattan:function(t,e){return Math.abs(e.x-t.x)+Math.abs(e.y-t.y)},diagonal:function(t,e){var n=Math.sqrt(2),r=Math.abs(e.x-t.x),i=Math.abs(e.y-t.y);return 1*(r+i)+(n-2)*Math.min(r,i)}},cleanNode:function(t){t.f=0,t.g=0,t.h=0,t.visited=!1,t.closed=!1,t.parent=null}};qr.prototype.init=function(){this.dirtyNodes=[];for(var t=0;t<this.nodes.length;t++)nu.cleanNode(this.nodes[t])},qr.prototype.cleanDirty=function(){for(var t=0;t<this.dirtyNodes.length;t++)nu.cleanNode(this.dirtyNodes[t]);this.dirtyNodes=[]},qr.prototype.markDirty=function(t){this.dirtyNodes.push(t)},qr.prototype.neighbors=function(t){var e=[],n=t.x,r=t.y,i=this.grid;return i[n-1]&&i[n-1][r]&&e.push(i[n-1][r]),i[n+1]&&i[n+1][r]&&e.push(i[n+1][r]),i[n]&&i[n][r-1]&&e.push(i[n][r-1]),i[n]&&i[n][r+1]&&e.push(i[n][r+1]),this.diagonal&&(i[n-1]&&i[n-1][r-1]&&e.push(i[n-1][r-1]),i[n+1]&&i[n+1][r-1]&&e.push(i[n+1][r-1]),i[n-1]&&i[n-1][r+1]&&e.push(i[n-1][r+1]),i[n+1]&&i[n+1][r+1]&&e.push(i[n+1][r+1])),e},qr.prototype.toString=function(){for(var t,e,n,r,i=[],o=this.grid,s=0,a=o.length;s<a;s++){for(t=[],n=0,r=(e=o[s]).length;n<r;n++)t.push(e[n].weight);i.push(t.join(" "))}return i.join("\n")},Gr.prototype.toString=function(){return"["+this.x+" "+this.y+"]"},Gr.prototype.getCost=function(t){return t&&t.x!==this.x&&t.y!==this.y?1.41421*this.weight:this.weight},Gr.prototype.isWall=function(){return 0===this.weight},Br.prototype={push:function(t){this.content.push(t),this.sinkDown(this.content.length-1)},pop:function(){var t=this.content[0],e=this.content.pop();return this.content.length>0&&(this.content[0]=e,this.bubbleUp(0)),t},remove:function(t){var e=this.content.indexOf(t),n=this.content.pop();e!==this.content.length-1&&(this.content[e]=n,this.scoreFunction(n)<this.scoreFunction(t)?this.sinkDown(e):this.bubbleUp(e))},size:function(){return this.content.length},rescoreElement:function(t){this.sinkDown(this.content.indexOf(t))},sinkDown:function(t){for(var e=this.content[t];t>0;){var n=(t+1>>1)-1,r=this.content[n];if(!(this.scoreFunction(e)<this.scoreFunction(r)))break;this.content[n]=e,this.content[t]=r,t=n}},bubbleUp:function(t){for(var e=this.content.length,n=this.content[t],r=this.scoreFunction(n);;){var i,o=t+1<<1,s=o-1,a=null;if(s<e){var u=this.content[s];(i=this.scoreFunction(u))<r&&(a=s)}if(o<e){var c=this.content[o];this.scoreFunction(c)<(null===a?r:i)&&(a=o)}if(null===a)break;this.content[t]=this.content[a],this.content[a]=n,t=a}}};var ru=function(t){return function(){return t}};jr.prototype={constructor:jr,insert:function(t,e){var n,r,i;if(t){if(e.P=t,e.N=t.N,t.N&&(t.N.P=e),t.N=e,t.R){for(t=t.R;t.L;)t=t.L;t.L=e}else t.R=e;n=t}else this._?(t=Vr(this._),e.P=null,e.N=t,t.P=t.L=e,n=t):(e.P=e.N=null,this._=e,n=null);for(e.L=e.R=null,e.U=n,e.C=!0,t=e;n&&n.C;)n===(r=n.U).L?(i=r.R)&&i.C?(n.C=i.C=!1,r.C=!0,t=r):(t===n.R&&(Ur(this,n),n=(t=n).U),n.C=!1,r.C=!0,Yr(this,r)):(i=r.L)&&i.C?(n.C=i.C=!1,r.C=!0,t=r):(t===n.L&&(Yr(this,n),n=(t=n).U),n.C=!1,r.C=!0,Ur(this,r)),n=t.U;this._.C=!1},remove:function(t){t.N&&(t.N.P=t.P),t.P&&(t.P.N=t.N),t.N=t.P=null;var e,n,r,i=t.U,o=t.L,s=t.R;if(n=o?s?Vr(s):o:s,i?i.L===t?i.L=n:i.R=n:this._=n,o&&s?(r=n.C,n.C=t.C,n.L=o,o.U=n,n!==s?(i=n.U,n.U=t.U,t=n.R,i.L=t,n.R=s,s.U=n):(n.U=i,i=n,t=n.R)):(r=t.C,t=n),t&&(t.U=i),!r)if(t&&t.C)t.C=!1;else{do{if(t===this._)break;if(t===i.L){if((e=i.R).C&&(e.C=!1,i.C=!0,Ur(this,i),e=i.R),e.L&&e.L.C||e.R&&e.R.C){e.R&&e.R.C||(e.L.C=!1,e.C=!0,Yr(this,e),e=i.R),e.C=i.C,i.C=e.R.C=!1,Ur(this,i),t=this._;break}}else if((e=i.L).C&&(e.C=!1,i.C=!0,Yr(this,i),e=i.L),e.L&&e.L.C||e.R&&e.R.C){e.L&&e.L.C||(e.R.C=!1,e.C=!0,Ur(this,e),e=i.L),e.C=i.C,i.C=e.L.C=!1,Yr(this,i),t=this._;break}e.C=!0,t=i,i=i.U}while(!t.C);t&&(t.C=!1)}}};var iu,ou,su,au,uu,cu=[],hu=[],lu=1e-6,pu=1e-12;hi.prototype={constructor:hi,polygons:function(){var t=this.edges;return this.cells.map(function(e){var n=e.halfedges.map(function(n){return $r(e,t[n])});return n.data=e.site.data,n})},triangles:function(){var t=[],e=this.edges;return this.cells.forEach(function(n,r){if(o=(i=n.halfedges).length)for(var i,o,s,a=n.site,u=-1,c=e[i[o-1]],h=c.left===a?c.right:c.left;++u<o;)s=h,h=(c=e[i[u]]).left===a?c.right:c.left,s&&h&&r<s.index&&r<h.index&&ui(a,s,h)<0&&t.push([a.data,s.data,h.data])}),t},links:function(){return this.edges.filter(function(t){return t.right}).map(function(t){return{source:t.left.data,target:t.right.data}})},find:function(t,e,n){for(var r,i,o=this,s=o._found||0,a=o.cells.length;!(i=o.cells[s]);)if(++s>=a)return null;var u=t-i.site[0],c=e-i.site[1],h=u*u+c*c;do{i=o.cells[r=s],s=null,i.halfedges.forEach(function(n){var r=o.edges[n],a=r.left;if(a!==i.site&&a||(a=r.right)){var u=t-a[0],c=e-a[1],l=u*u+c*c;l<h&&(h=l,s=a.index)}})}while(null!==s);return o._found=r,null==n||h<=n*n?i.site:null}};var fu=function(){function t(t){return new hi(t.map(function(r,i){var o=[Math.round(e(r,i,t)/lu)*lu,Math.round(n(r,i,t)/lu)*lu];return o.index=i,o.data=r,o}),r)}var e=kr,n=zr,r=null;return t.polygons=function(e){return t(e).polygons()},t.links=function(e){return t(e).links()},t.triangles=function(e){return t(e).triangles()},t.x=function(n){return arguments.length?(e="function"==typeof n?n:ru(+n),t):e},t.y=function(e){return arguments.length?(n="function"==typeof e?e:ru(+e),t):n},t.extent=function(e){return arguments.length?(r=null==e?null:[[+e[0][0],+e[0][1]],[+e[1][0],+e[1][1]]],t):r&&[[r[0][0],r[0][1]],[r[1][0],r[1][1]]]},t.size=function(e){return arguments.length?(r=null==e?null:[[0,0],[+e[0],+e[1]]],t):r&&[r[1][0]-r[0][0],r[1][1]-r[0][1]]},t},gu=Object.freeze({randomPosition:_i,randomPoint:mi,randomPolygon:vi,randomLineString:xi}),du=Object.freeze({getCluster:wi,clusterEach:bi,clusterReduce:Ii,createBins:Ni,applyFilter:Ci,propertiesContainsFilter:Si,filterProperties:Mi});"fill"in Array.prototype||Object.defineProperty(Array.prototype,"fill",{configurable:!0,value:function(t){if(void 0===this||null===this)throw new TypeError(this+" is not an object");var e=Object(this),n=Math.max(Math.min(e.length,9007199254740991),0)||0,r=1 in arguments?parseInt(Number(arguments[1]),10)||0:0;r=r<0?Math.max(n+r,0):Math.min(r,n);var i=2 in arguments&&void 0!==arguments[2]?parseInt(Number(arguments[2]),10)||0:n;for(i=i<0?Math.max(n+arguments[2],0):Math.min(i,n);r<i;)e[r]=t,++r;return e},writable:!0}),Number.isFinite=Number.isFinite||function(t){return"number"==typeof t&&isFinite(t)},Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t},Number.parseFloat=Number.parseFloat||parseFloat,Number.isNaN=Number.isNaN||function(t){return t!=t},Math.trunc=Math.trunc||function(t){return t<0?Math.ceil(t):Math.floor(t)};var yu=function(){};yu.prototype.interfaces_=function(){return[]},yu.prototype.getClass=function(){return yu},yu.prototype.equalsWithTolerance=function(t,e,n){return Math.abs(t-e)<=n};var _u=function(){},mu=function(){},vu={MAX_VALUE:{configurable:!0}};mu.isNaN=function(t){return Number.isNaN(t)},mu.doubleToLongBits=function(t){return t},mu.longBitsToDouble=function(t){return t},mu.isInfinite=function(t){return!Number.isFinite(t)},vu.MAX_VALUE.get=function(){return Number.MAX_VALUE},Object.defineProperties(mu,vu);var xu=function(){},Eu=function(){},wu=function(){},bu=function t(){if(this.x=null,this.y=null,this.z=null,0===arguments.length)this.x=0,this.y=0,this.z=t.NULL_ORDINATE;else if(1===arguments.length){var e=arguments[0];this.x=e.x,this.y=e.y,this.z=e.z}else 2===arguments.length?(this.x=arguments[0],this.y=arguments[1],this.z=t.NULL_ORDINATE):3===arguments.length&&(this.x=arguments[0],this.y=arguments[1],this.z=arguments[2])},Iu={DimensionalComparator:{configurable:!0},serialVersionUID:{configurable:!0},NULL_ORDINATE:{configurable:!0},X:{configurable:!0},Y:{configurable:!0},Z:{configurable:!0}};bu.prototype.setOrdinate=function(t,e){switch(t){case bu.X:this.x=e;break;case bu.Y:this.y=e;break;case bu.Z:this.z=e;break;default:throw new _u("Invalid ordinate index: "+t)}},bu.prototype.equals2D=function(){if(1===arguments.length){var t=arguments[0];return this.x===t.x&&this.y===t.y}if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!yu.equalsWithTolerance(this.x,e.x,n)&&!!yu.equalsWithTolerance(this.y,e.y,n)}},bu.prototype.getOrdinate=function(t){switch(t){case bu.X:return this.x;case bu.Y:return this.y;case bu.Z:return this.z}throw new _u("Invalid ordinate index: "+t)},bu.prototype.equals3D=function(t){return this.x===t.x&&this.y===t.y&&(this.z===t.z||mu.isNaN(this.z))&&mu.isNaN(t.z)},bu.prototype.equals=function(t){return t instanceof bu&&this.equals2D(t)},bu.prototype.equalInZ=function(t,e){return yu.equalsWithTolerance(this.z,t.z,e)},bu.prototype.compareTo=function(t){var e=t;return this.x<e.x?-1:this.x>e.x?1:this.y<e.y?-1:this.y>e.y?1:0},bu.prototype.clone=function(){},bu.prototype.copy=function(){return new bu(this)},bu.prototype.toString=function(){return"("+this.x+", "+this.y+", "+this.z+")"},bu.prototype.distance3D=function(t){var e=this.x-t.x,n=this.y-t.y,r=this.z-t.z;return Math.sqrt(e*e+n*n+r*r)},bu.prototype.distance=function(t){var e=this.x-t.x,n=this.y-t.y;return Math.sqrt(e*e+n*n)},bu.prototype.hashCode=function(){var t=17;return t=37*t+bu.hashCode(this.x),t=37*t+bu.hashCode(this.y)},bu.prototype.setCoordinate=function(t){this.x=t.x,this.y=t.y,this.z=t.z},bu.prototype.interfaces_=function(){return[xu,Eu,Li]},bu.prototype.getClass=function(){return bu},bu.hashCode=function(){if(1===arguments.length){var t=arguments[0],e=mu.doubleToLongBits(t);return Math.trunc((e^e)>>>32)}},Iu.DimensionalComparator.get=function(){return Nu},Iu.serialVersionUID.get=function(){return 0x5cbf2c235c7e5800},Iu.NULL_ORDINATE.get=function(){return mu.NaN},Iu.X.get=function(){return 0},Iu.Y.get=function(){return 1},Iu.Z.get=function(){return 2},Object.defineProperties(bu,Iu);var Nu=function(t){if(this._dimensionsToTest=2,0===arguments.length);else if(1===arguments.length){var e=arguments[0];if(2!==e&&3!==e)throw new _u("only 2 or 3 dimensions may be specified");this._dimensionsToTest=e}};Nu.prototype.compare=function(t,e){var n=t,r=e,i=Nu.compare(n.x,r.x);if(0!==i)return i;var o=Nu.compare(n.y,r.y);if(0!==o)return o;if(this._dimensionsToTest<=2)return 0;return Nu.compare(n.z,r.z)},Nu.prototype.interfaces_=function(){return[wu]},Nu.prototype.getClass=function(){return Nu},Nu.compare=function(t,e){return t<e?-1:t>e?1:mu.isNaN(t)?mu.isNaN(e)?0:-1:mu.isNaN(e)?1:0};var Cu=function(){};Cu.prototype.create=function(){},Cu.prototype.interfaces_=function(){return[]},Cu.prototype.getClass=function(){return Cu};var Su=function(){},Mu={INTERIOR:{configurable:!0},BOUNDARY:{configurable:!0},EXTERIOR:{configurable:!0},NONE:{configurable:!0}};Su.prototype.interfaces_=function(){return[]},Su.prototype.getClass=function(){return Su},Su.toLocationSymbol=function(t){switch(t){case Su.EXTERIOR:return"e";case Su.BOUNDARY:return"b";case Su.INTERIOR:return"i";case Su.NONE:return"-"}throw new _u("Unknown location value: "+t)},Mu.INTERIOR.get=function(){return 0},Mu.BOUNDARY.get=function(){return 1},Mu.EXTERIOR.get=function(){return 2},Mu.NONE.get=function(){return-1},Object.defineProperties(Su,Mu);var Lu=function(t,e){return t.interfaces_&&t.interfaces_().indexOf(e)>-1},Pu=function(){},Ou={LOG_10:{configurable:!0}};Pu.prototype.interfaces_=function(){return[]},Pu.prototype.getClass=function(){return Pu},Pu.log10=function(t){var e=Math.log(t);return mu.isInfinite(e)?e:mu.isNaN(e)?e:e/Pu.LOG_10},Pu.min=function(t,e,n,r){var i=t;return e<i&&(i=e),n<i&&(i=n),r<i&&(i=r),i},Pu.clamp=function(){if("number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1],n=arguments[2];return t<e?e:t>n?n:t}if(Number.isInteger(arguments[2])&&Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var r=arguments[0],i=arguments[1],o=arguments[2];return r<i?i:r>o?o:r}},Pu.wrap=function(t,e){return t<0?e- -t%e:t%e},Pu.max=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],r=t;return e>r&&(r=e),n>r&&(r=n),r}if(4===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3],u=i;return o>u&&(u=o),s>u&&(u=s),a>u&&(u=a),u}},Pu.average=function(t,e){return(t+e)/2},Ou.LOG_10.get=function(){return Math.log(10)},Object.defineProperties(Pu,Ou);var Ru=function(t){this.str=t};Ru.prototype.append=function(t){this.str+=t},Ru.prototype.setCharAt=function(t,e){this.str=this.str.substr(0,t)+e+this.str.substr(t+1)},Ru.prototype.toString=function(t){return this.str};var Tu=function(t){this.value=t};Tu.prototype.intValue=function(){return this.value},Tu.prototype.compareTo=function(t){return this.value<t?-1:this.value>t?1:0},Tu.isNaN=function(t){return Number.isNaN(t)};var Au=function(){};Au.isWhitespace=function(t){return t<=32&&t>=0||127===t},Au.toUpperCase=function(t){return t.toUpperCase()};var Du=function t(){if(this._hi=0,this._lo=0,0===arguments.length)this.init(0);else if(1===arguments.length){if("number"==typeof arguments[0]){var e=arguments[0];this.init(e)}else if(arguments[0]instanceof t){var n=arguments[0];this.init(n)}else if("string"==typeof arguments[0]){var r=arguments[0];t.call(this,t.parse(r))}}else if(2===arguments.length){var i=arguments[0],o=arguments[1];this.init(i,o)}},Fu={PI:{configurable:!0},TWO_PI:{configurable:!0},PI_2:{configurable:!0},E:{configurable:!0},NaN:{configurable:!0},EPS:{configurable:!0},SPLIT:{configurable:!0},MAX_PRINT_DIGITS:{configurable:!0},TEN:{configurable:!0},ONE:{configurable:!0},SCI_NOT_EXPONENT_CHAR:{configurable:!0},SCI_NOT_ZERO:{configurable:!0}};Du.prototype.le=function(t){return(this._hi<t._hi||this._hi===t._hi)&&this._lo<=t._lo},Du.prototype.extractSignificantDigits=function(t,e){var n=this.abs(),r=Du.magnitude(n._hi),i=Du.TEN.pow(r);(n=n.divide(i)).gt(Du.TEN)?(n=n.divide(Du.TEN),r+=1):n.lt(Du.ONE)&&(n=n.multiply(Du.TEN),r-=1);for(var o=r+1,s=new Ru,a=Du.MAX_PRINT_DIGITS-1,u=0;u<=a;u++){t&&u===o&&s.append(".");var c=Math.trunc(n._hi);if(c<0)break;var h=!1,l=0;c>9?(h=!0,l="9"):l="0"+c,s.append(l),n=n.subtract(Du.valueOf(c)).multiply(Du.TEN),h&&n.selfAdd(Du.TEN);var p=!0,f=Du.magnitude(n._hi);if(f<0&&Math.abs(f)>=a-u&&(p=!1),!p)break}return e[0]=r,s.toString()},Du.prototype.sqr=function(){return this.multiply(this)},Du.prototype.doubleValue=function(){return this._hi+this._lo},Du.prototype.subtract=function(){if(arguments[0]instanceof Du){var t=arguments[0];return this.add(t.negate())}if("number"==typeof arguments[0]){var e=arguments[0];return this.add(-e)}},Du.prototype.equals=function(){if(1===arguments.length){var t=arguments[0];return this._hi===t._hi&&this._lo===t._lo}},Du.prototype.isZero=function(){return 0===this._hi&&0===this._lo},Du.prototype.selfSubtract=function(){if(arguments[0]instanceof Du){var t=arguments[0];return this.isNaN()?this:this.selfAdd(-t._hi,-t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.isNaN()?this:this.selfAdd(-e,0)}},Du.prototype.getSpecialNumberString=function(){return this.isZero()?"0.0":this.isNaN()?"NaN ":null},Du.prototype.min=function(t){return this.le(t)?this:t},Du.prototype.selfDivide=function(){if(1===arguments.length){if(arguments[0]instanceof Du){var t=arguments[0];return this.selfDivide(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfDivide(e,0)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1],i=null,o=null,s=null,a=null,u=null,c=null,h=null,l=null;return u=this._hi/n,c=Du.SPLIT*u,i=c-u,l=Du.SPLIT*n,i=c-i,o=u-i,s=l-n,h=u*n,s=l-s,a=n-s,l=i*s-h+i*a+o*s+o*a,c=(this._hi-h-l+this._lo-u*r)/n,l=u+c,this._hi=l,this._lo=u-l+c,this}},Du.prototype.dump=function(){return"DD<"+this._hi+", "+this._lo+">"},Du.prototype.divide=function(){if(arguments[0]instanceof Du){var t=arguments[0],e=null,n=null,r=null,i=null,o=null,s=null,a=null,u=null;n=(o=this._hi/t._hi)-(e=(s=Du.SPLIT*o)-(e=s-o)),u=e*(r=(u=Du.SPLIT*t._hi)-(r=u-t._hi))-(a=o*t._hi)+e*(i=t._hi-r)+n*r+n*i,s=(this._hi-a-u+this._lo-o*t._lo)/t._hi;return new Du(u=o+s,o-u+s)}if("number"==typeof arguments[0]){var c=arguments[0];return mu.isNaN(c)?Du.createNaN():Du.copy(this).selfDivide(c,0)}},Du.prototype.ge=function(t){return(this._hi>t._hi||this._hi===t._hi)&&this._lo>=t._lo},Du.prototype.pow=function(t){if(0===t)return Du.valueOf(1);var e=new Du(this),n=Du.valueOf(1),r=Math.abs(t);if(r>1)for(;r>0;)r%2==1&&n.selfMultiply(e),(r/=2)>0&&(e=e.sqr());else n=e;return t<0?n.reciprocal():n},Du.prototype.ceil=function(){if(this.isNaN())return Du.NaN;var t=Math.ceil(this._hi),e=0;return t===this._hi&&(e=Math.ceil(this._lo)),new Du(t,e)},Du.prototype.compareTo=function(t){var e=t;return this._hi<e._hi?-1:this._hi>e._hi?1:this._lo<e._lo?-1:this._lo>e._lo?1:0},Du.prototype.rint=function(){if(this.isNaN())return this;return this.add(.5).floor()},Du.prototype.setValue=function(){if(arguments[0]instanceof Du){var t=arguments[0];return this.init(t),this}if("number"==typeof arguments[0]){var e=arguments[0];return this.init(e),this}},Du.prototype.max=function(t){return this.ge(t)?this:t},Du.prototype.sqrt=function(){if(this.isZero())return Du.valueOf(0);if(this.isNegative())return Du.NaN;var t=1/Math.sqrt(this._hi),e=this._hi*t,n=Du.valueOf(e),r=this.subtract(n.sqr())._hi*(.5*t);return n.add(r)},Du.prototype.selfAdd=function(){if(1===arguments.length){if(arguments[0]instanceof Du){var t=arguments[0];return this.selfAdd(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0],n=null,r=null,i=null,o=null,s=null,a=null;return i=this._hi+e,s=i-this._hi,o=i-s,o=e-s+(this._hi-o),a=o+this._lo,n=i+a,r=a+(i-n),this._hi=n+r,this._lo=r+(n-this._hi),this}}else if(2===arguments.length){var u=arguments[0],c=arguments[1],h=null,l=null,p=null,f=null,g=null,d=null,y=null;f=this._hi+u,l=this._lo+c,g=f-(d=f-this._hi),p=l-(y=l-this._lo);var _=(h=f+(d=(g=u-d+(this._hi-g))+l))+(d=(p=c-y+(this._lo-p))+(d+(f-h))),m=d+(h-_);return this._hi=_,this._lo=m,this}},Du.prototype.selfMultiply=function(){if(1===arguments.length){if(arguments[0]instanceof Du){var t=arguments[0];return this.selfMultiply(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfMultiply(e,0)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1],i=null,o=null,s=null,a=null,u=null,c=null;i=(u=Du.SPLIT*this._hi)-this._hi,c=Du.SPLIT*n,i=u-i,o=this._hi-i,s=c-n;var h=(u=this._hi*n)+(c=i*(s=c-s)-u+i*(a=n-s)+o*s+o*a+(this._hi*r+this._lo*n)),l=c+(i=u-h);return this._hi=h,this._lo=l,this}},Du.prototype.selfSqr=function(){return this.selfMultiply(this)},Du.prototype.floor=function(){if(this.isNaN())return Du.NaN;var t=Math.floor(this._hi),e=0;return t===this._hi&&(e=Math.floor(this._lo)),new Du(t,e)},Du.prototype.negate=function(){return this.isNaN()?this:new Du(-this._hi,-this._lo)},Du.prototype.clone=function(){},Du.prototype.multiply=function(){if(arguments[0]instanceof Du){var t=arguments[0];return t.isNaN()?Du.createNaN():Du.copy(this).selfMultiply(t)}if("number"==typeof arguments[0]){var e=arguments[0];return mu.isNaN(e)?Du.createNaN():Du.copy(this).selfMultiply(e,0)}},Du.prototype.isNaN=function(){return mu.isNaN(this._hi)},Du.prototype.intValue=function(){return Math.trunc(this._hi)},Du.prototype.toString=function(){var t=Du.magnitude(this._hi);return t>=-3&&t<=20?this.toStandardNotation():this.toSciNotation()},Du.prototype.toStandardNotation=function(){var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!0,e),r=e[0]+1,i=n;if("."===n.charAt(0))i="0"+n;else if(r<0)i="0."+Du.stringOfChar("0",-r)+n;else if(-1===n.indexOf(".")){var o=r-n.length;i=n+Du.stringOfChar("0",o)+".0"}return this.isNegative()?"-"+i:i},Du.prototype.reciprocal=function(){var t=null,e=null,n=null,r=null,i=null,o=null,s=null,a=null;e=(i=1/this._hi)-(t=(o=Du.SPLIT*i)-(t=o-i)),n=(a=Du.SPLIT*this._hi)-this._hi;var u=i+(o=(1-(s=i*this._hi)-(a=t*(n=a-n)-s+t*(r=this._hi-n)+e*n+e*r)-i*this._lo)/this._hi);return new Du(u,i-u+o)},Du.prototype.toSciNotation=function(){if(this.isZero())return Du.SCI_NOT_ZERO;var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!1,e),r=Du.SCI_NOT_EXPONENT_CHAR+e[0];if("0"===n.charAt(0))throw new Error("Found leading zero: "+n);var i="";n.length>1&&(i=n.substring(1));var o=n.charAt(0)+"."+i;return this.isNegative()?"-"+o+r:o+r},Du.prototype.abs=function(){return this.isNaN()?Du.NaN:this.isNegative()?this.negate():new Du(this)},Du.prototype.isPositive=function(){return(this._hi>0||0===this._hi)&&this._lo>0},Du.prototype.lt=function(t){return(this._hi<t._hi||this._hi===t._hi)&&this._lo<t._lo},Du.prototype.add=function(){if(arguments[0]instanceof Du){var t=arguments[0];return Du.copy(this).selfAdd(t)}if("number"==typeof arguments[0]){var e=arguments[0];return Du.copy(this).selfAdd(e)}},Du.prototype.init=function(){if(1===arguments.length){if("number"==typeof arguments[0]){var t=arguments[0];this._hi=t,this._lo=0}else if(arguments[0]instanceof Du){var e=arguments[0];this._hi=e._hi,this._lo=e._lo}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this._hi=n,this._lo=r}},Du.prototype.gt=function(t){return(this._hi>t._hi||this._hi===t._hi)&&this._lo>t._lo},Du.prototype.isNegative=function(){return(this._hi<0||0===this._hi)&&this._lo<0},Du.prototype.trunc=function(){return this.isNaN()?Du.NaN:this.isPositive()?this.floor():this.ceil()},Du.prototype.signum=function(){return this._hi>0?1:this._hi<0?-1:this._lo>0?1:this._lo<0?-1:0},Du.prototype.interfaces_=function(){return[Li,xu,Eu]},Du.prototype.getClass=function(){return Du},Du.sqr=function(t){return Du.valueOf(t).selfMultiply(t)},Du.valueOf=function(){if("string"==typeof arguments[0]){var t=arguments[0];return Du.parse(t)}if("number"==typeof arguments[0]){var e=arguments[0];return new Du(e)}},Du.sqrt=function(t){return Du.valueOf(t).sqrt()},Du.parse=function(t){for(var e=0,n=t.length;Au.isWhitespace(t.charAt(e));)e++;var r=!1;if(e<n){var i=t.charAt(e);"-"!==i&&"+"!==i||(e++,"-"===i&&(r=!0))}for(var o=new Du,s=0,a=0,u=0;!(e>=n);){var c=t.charAt(e);if(e++,Au.isDigit(c)){var h=c-"0";o.selfMultiply(Du.TEN),o.selfAdd(h),s++}else{if("."!==c){if("e"===c||"E"===c){var l=t.substring(e);try{u=Tu.parseInt(l)}catch(e){throw e instanceof Error?new Error("Invalid exponent "+l+" in string "+t):e}break}throw new Error("Unexpected character '"+c+"' at position "+e+" in string "+t)}a=s}}var p=o,f=s-a-u;if(0===f)p=o;else if(f>0){var g=Du.TEN.pow(f);p=o.divide(g)}else if(f<0){var d=Du.TEN.pow(-f);p=o.multiply(d)}return r?p.negate():p},Du.createNaN=function(){return new Du(mu.NaN,mu.NaN)},Du.copy=function(t){return new Du(t)},Du.magnitude=function(t){var e=Math.abs(t),n=Math.log(e)/Math.log(10),r=Math.trunc(Math.floor(n));return 10*Math.pow(10,r)<=e&&(r+=1),r},Du.stringOfChar=function(t,e){for(var n=new Ru,r=0;r<e;r++)n.append(t);return n.toString()},Fu.PI.get=function(){return new Du(3.141592653589793,1.2246467991473532e-16)},Fu.TWO_PI.get=function(){return new Du(6.283185307179586,2.4492935982947064e-16)},Fu.PI_2.get=function(){return new Du(1.5707963267948966,6.123233995736766e-17)},Fu.E.get=function(){return new Du(2.718281828459045,1.4456468917292502e-16)},Fu.NaN.get=function(){return new Du(mu.NaN,mu.NaN)},Fu.EPS.get=function(){return 1.23259516440783e-32},Fu.SPLIT.get=function(){return 134217729},Fu.MAX_PRINT_DIGITS.get=function(){return 32},Fu.TEN.get=function(){return Du.valueOf(10)},Fu.ONE.get=function(){return Du.valueOf(1)},Fu.SCI_NOT_EXPONENT_CHAR.get=function(){return"E"},Fu.SCI_NOT_ZERO.get=function(){return"0.0E0"},Object.defineProperties(Du,Fu);var qu=function(){},Gu={DP_SAFE_EPSILON:{configurable:!0}};qu.prototype.interfaces_=function(){return[]},qu.prototype.getClass=function(){return qu},qu.orientationIndex=function(t,e,n){var r=qu.orientationIndexFilter(t,e,n);if(r<=1)return r;var i=Du.valueOf(e.x).selfAdd(-t.x),o=Du.valueOf(e.y).selfAdd(-t.y),s=Du.valueOf(n.x).selfAdd(-e.x),a=Du.valueOf(n.y).selfAdd(-e.y);return i.selfMultiply(a).selfSubtract(o.selfMultiply(s)).signum()},qu.signOfDet2x2=function(t,e,n,r){return t.multiply(r).selfSubtract(e.multiply(n)).signum()},qu.intersection=function(t,e,n,r){var i=Du.valueOf(r.y).selfSubtract(n.y).selfMultiply(Du.valueOf(e.x).selfSubtract(t.x)),o=Du.valueOf(r.x).selfSubtract(n.x).selfMultiply(Du.valueOf(e.y).selfSubtract(t.y)),s=i.subtract(o),a=Du.valueOf(r.x).selfSubtract(n.x).selfMultiply(Du.valueOf(t.y).selfSubtract(n.y)),u=Du.valueOf(r.y).selfSubtract(n.y).selfMultiply(Du.valueOf(t.x).selfSubtract(n.x)),c=a.subtract(u).selfDivide(s).doubleValue(),h=Du.valueOf(t.x).selfAdd(Du.valueOf(e.x).selfSubtract(t.x).selfMultiply(c)).doubleValue(),l=Du.valueOf(e.x).selfSubtract(t.x).selfMultiply(Du.valueOf(t.y).selfSubtract(n.y)),p=Du.valueOf(e.y).selfSubtract(t.y).selfMultiply(Du.valueOf(t.x).selfSubtract(n.x)),f=l.subtract(p).selfDivide(s).doubleValue(),g=Du.valueOf(n.y).selfAdd(Du.valueOf(r.y).selfSubtract(n.y).selfMultiply(f)).doubleValue();return new bu(h,g)},qu.orientationIndexFilter=function(t,e,n){var r=null,i=(t.x-n.x)*(e.y-n.y),o=(t.y-n.y)*(e.x-n.x),s=i-o;if(i>0){if(o<=0)return qu.signum(s);r=i+o}else{if(!(i<0))return qu.signum(s);if(o>=0)return qu.signum(s);r=-i-o}var a=qu.DP_SAFE_EPSILON*r;return s>=a||-s>=a?qu.signum(s):2},qu.signum=function(t){return t>0?1:t<0?-1:0},Gu.DP_SAFE_EPSILON.get=function(){return 1e-15},Object.defineProperties(qu,Gu);var Bu=function(){},ku={X:{configurable:!0},Y:{configurable:!0},Z:{configurable:!0},M:{configurable:!0}};ku.X.get=function(){return 0},ku.Y.get=function(){return 1},ku.Z.get=function(){return 2},ku.M.get=function(){return 3},Bu.prototype.setOrdinate=function(t,e,n){},Bu.prototype.size=function(){},Bu.prototype.getOrdinate=function(t,e){},Bu.prototype.getCoordinate=function(){},Bu.prototype.getCoordinateCopy=function(t){},Bu.prototype.getDimension=function(){},Bu.prototype.getX=function(t){},Bu.prototype.clone=function(){},Bu.prototype.expandEnvelope=function(t){},Bu.prototype.copy=function(){},Bu.prototype.getY=function(t){},Bu.prototype.toCoordinateArray=function(){},Bu.prototype.interfaces_=function(){return[Eu]},Bu.prototype.getClass=function(){return Bu},Object.defineProperties(Bu,ku);var zu=function(){},ju=function(t){function e(){t.call(this,"Projective point not representable on the Cartesian plane.")}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(zu),Xu=function(){};Xu.arraycopy=function(t,e,n,r,i){for(var o=0,s=e;s<e+i;s++)n[r+o]=t[s],o++},Xu.getProperty=function(t){return{"line.separator":"\n"}[t]};var Uu=function t(){if(this.x=null,this.y=null,this.w=null,0===arguments.length)this.x=0,this.y=0,this.w=1;else if(1===arguments.length){var e=arguments[0];this.x=e.x,this.y=e.y,this.w=1}else if(2===arguments.length){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var n=arguments[0],r=arguments[1];this.x=n,this.y=r,this.w=1}else if(arguments[0]instanceof t&&arguments[1]instanceof t){var i=arguments[0],o=arguments[1];this.x=i.y*o.w-o.y*i.w,this.y=o.x*i.w-i.x*o.w,this.w=i.x*o.y-o.x*i.y}else if(arguments[0]instanceof bu&&arguments[1]instanceof bu){var s=arguments[0],a=arguments[1];this.x=s.y-a.y,this.y=a.x-s.x,this.w=s.x*a.y-a.x*s.y}}else if(3===arguments.length){var u=arguments[0],c=arguments[1],h=arguments[2];this.x=u,this.y=c,this.w=h}else if(4===arguments.length){var l=arguments[0],p=arguments[1],f=arguments[2],g=arguments[3],d=l.y-p.y,y=p.x-l.x,_=l.x*p.y-p.x*l.y,m=f.y-g.y,v=g.x-f.x,x=f.x*g.y-g.x*f.y;this.x=y*x-v*_,this.y=m*_-d*x,this.w=d*v-m*y}};Uu.prototype.getY=function(){var t=this.y/this.w;if(mu.isNaN(t)||mu.isInfinite(t))throw new ju;return t},Uu.prototype.getX=function(){var t=this.x/this.w;if(mu.isNaN(t)||mu.isInfinite(t))throw new ju;return t},Uu.prototype.getCoordinate=function(){var t=new bu;return t.x=this.getX(),t.y=this.getY(),t},Uu.prototype.interfaces_=function(){return[]},Uu.prototype.getClass=function(){return Uu},Uu.intersection=function(t,e,n,r){var i=t.y-e.y,o=e.x-t.x,s=t.x*e.y-e.x*t.y,a=n.y-r.y,u=r.x-n.x,c=n.x*r.y-r.x*n.y,h=i*u-a*o,l=(o*c-u*s)/h,p=(a*s-i*c)/h;if(mu.isNaN(l)||mu.isInfinite(l)||mu.isNaN(p)||mu.isInfinite(p))throw new ju;return new bu(l,p)};var Yu=function t(){if(this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,0===arguments.length)this.init();else if(1===arguments.length){if(arguments[0]instanceof bu){var e=arguments[0];this.init(e.x,e.x,e.y,e.y)}else if(arguments[0]instanceof t){var n=arguments[0];this.init(n)}}else if(2===arguments.length){var r=arguments[0],i=arguments[1];this.init(r.x,i.x,r.y,i.y)}else if(4===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2],u=arguments[3];this.init(o,s,a,u)}},Vu={serialVersionUID:{configurable:!0}};Yu.prototype.getArea=function(){return this.getWidth()*this.getHeight()},Yu.prototype.equals=function(t){if(!(t instanceof Yu))return!1;var e=t;return this.isNull()?e.isNull():this._maxx===e.getMaxX()&&this._maxy===e.getMaxY()&&this._minx===e.getMinX()&&this._miny===e.getMinY()},Yu.prototype.intersection=function(t){if(this.isNull()||t.isNull()||!this.intersects(t))return new Yu;var e=this._minx>t._minx?this._minx:t._minx,n=this._miny>t._miny?this._miny:t._miny,r=this._maxx<t._maxx?this._maxx:t._maxx,i=this._maxy<t._maxy?this._maxy:t._maxy;return new Yu(e,r,n,i)},Yu.prototype.isNull=function(){return this._maxx<this._minx},Yu.prototype.getMaxX=function(){return this._maxx},Yu.prototype.covers=function(){if(1===arguments.length){if(arguments[0]instanceof bu){var t=arguments[0];return this.covers(t.x,t.y)}if(arguments[0]instanceof Yu){var e=arguments[0];return!this.isNull()&&!e.isNull()&&(e.getMinX()>=this._minx&&e.getMaxX()<=this._maxx&&e.getMinY()>=this._miny&&e.getMaxY()<=this._maxy)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];return!this.isNull()&&(n>=this._minx&&n<=this._maxx&&r>=this._miny&&r<=this._maxy)}},Yu.prototype.intersects=function(){if(1===arguments.length){if(arguments[0]instanceof Yu){var t=arguments[0];return!this.isNull()&&!t.isNull()&&!(t._minx>this._maxx||t._maxx<this._minx||t._miny>this._maxy||t._maxy<this._miny)}if(arguments[0]instanceof bu){var e=arguments[0];return this.intersects(e.x,e.y)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];return!this.isNull()&&!(n>this._maxx||n<this._minx||r>this._maxy||r<this._miny)}},Yu.prototype.getMinY=function(){return this._miny},Yu.prototype.getMinX=function(){return this._minx},Yu.prototype.expandToInclude=function(){if(1===arguments.length){if(arguments[0]instanceof bu){var t=arguments[0];this.expandToInclude(t.x,t.y)}else if(arguments[0]instanceof Yu){var e=arguments[0];if(e.isNull())return null;this.isNull()?(this._minx=e.getMinX(),this._maxx=e.getMaxX(),this._miny=e.getMinY(),this._maxy=e.getMaxY()):(e._minx<this._minx&&(this._minx=e._minx),e._maxx>this._maxx&&(this._maxx=e._maxx),e._miny<this._miny&&(this._miny=e._miny),e._maxy>this._maxy&&(this._maxy=e._maxy))}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this.isNull()?(this._minx=n,this._maxx=n,this._miny=r,this._maxy=r):(n<this._minx&&(this._minx=n),n>this._maxx&&(this._maxx=n),r<this._miny&&(this._miny=r),r>this._maxy&&(this._maxy=r))}},Yu.prototype.minExtent=function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return t<e?t:e},Yu.prototype.getWidth=function(){return this.isNull()?0:this._maxx-this._minx},Yu.prototype.compareTo=function(t){var e=t;return this.isNull()?e.isNull()?0:-1:e.isNull()?1:this._minx<e._minx?-1:this._minx>e._minx?1:this._miny<e._miny?-1:this._miny>e._miny?1:this._maxx<e._maxx?-1:this._maxx>e._maxx?1:this._maxy<e._maxy?-1:this._maxy>e._maxy?1:0},Yu.prototype.translate=function(t,e){if(this.isNull())return null;this.init(this.getMinX()+t,this.getMaxX()+t,this.getMinY()+e,this.getMaxY()+e)},Yu.prototype.toString=function(){return"Env["+this._minx+" : "+this._maxx+", "+this._miny+" : "+this._maxy+"]"},Yu.prototype.setToNull=function(){this._minx=0,this._maxx=-1,this._miny=0,this._maxy=-1},Yu.prototype.getHeight=function(){return this.isNull()?0:this._maxy-this._miny},Yu.prototype.maxExtent=function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return t>e?t:e},Yu.prototype.expandBy=function(){if(1===arguments.length){var t=arguments[0];this.expandBy(t,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this.isNull())return null;this._minx-=e,this._maxx+=e,this._miny-=n,this._maxy+=n,(this._minx>this._maxx||this._miny>this._maxy)&&this.setToNull()}},Yu.prototype.contains=function(){if(1===arguments.length){if(arguments[0]instanceof Yu){var t=arguments[0];return this.covers(t)}if(arguments[0]instanceof bu){var e=arguments[0];return this.covers(e)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];return this.covers(n,r)}},Yu.prototype.centre=function(){return this.isNull()?null:new bu((this.getMinX()+this.getMaxX())/2,(this.getMinY()+this.getMaxY())/2)},Yu.prototype.init=function(){if(0===arguments.length)this.setToNull();else if(1===arguments.length){if(arguments[0]instanceof bu){var t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof Yu){var e=arguments[0];this._minx=e._minx,this._maxx=e._maxx,this._miny=e._miny,this._maxy=e._maxy}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this.init(n.x,r.x,n.y,r.y)}else if(4===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];i<o?(this._minx=i,this._maxx=o):(this._minx=o,this._maxx=i),s<a?(this._miny=s,this._maxy=a):(this._miny=a,this._maxy=s)}},Yu.prototype.getMaxY=function(){return this._maxy},Yu.prototype.distance=function(t){if(this.intersects(t))return 0;var e=0;this._maxx<t._minx?e=t._minx-this._maxx:this._minx>t._maxx&&(e=this._minx-t._maxx);var n=0;return this._maxy<t._miny?n=t._miny-this._maxy:this._miny>t._maxy&&(n=this._miny-t._maxy),0===e?n:0===n?e:Math.sqrt(e*e+n*n)},Yu.prototype.hashCode=function(){var t=17;return t=37*t+bu.hashCode(this._minx),t=37*t+bu.hashCode(this._maxx),t=37*t+bu.hashCode(this._miny),t=37*t+bu.hashCode(this._maxy)},Yu.prototype.interfaces_=function(){return[xu,Li]},Yu.prototype.getClass=function(){return Yu},Yu.intersects=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2];return n.x>=(t.x<e.x?t.x:e.x)&&n.x<=(t.x>e.x?t.x:e.x)&&n.y>=(t.y<e.y?t.y:e.y)&&n.y<=(t.y>e.y?t.y:e.y)}if(4===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2],s=arguments[3],a=Math.min(o.x,s.x),u=Math.max(o.x,s.x),c=Math.min(r.x,i.x),h=Math.max(r.x,i.x);return!(c>u)&&(!(h<a)&&(a=Math.min(o.y,s.y),u=Math.max(o.y,s.y),c=Math.min(r.y,i.y),h=Math.max(r.y,i.y),!(c>u)&&!(h<a)))}},Vu.serialVersionUID.get=function(){return 0x51845cd552189800},Object.defineProperties(Yu,Vu);var Hu={typeStr:/^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,emptyTypeStr:/^\s*(\w+)\s*EMPTY\s*$/,spaces:/\s+/,parenComma:/\)\s*,\s*\(/,doubleParenComma:/\)\s*\)\s*,\s*\(\s*\(/,trimParens:/^\s*\(?(.*?)\)?\s*$/},Wu=function(t){this.geometryFactory=t||new _h};Wu.prototype.read=function(t){var e,n,r;t=t.replace(/[\n\r]/g," ");var i=Hu.typeStr.exec(t);if(-1!==t.search("EMPTY")&&((i=Hu.emptyTypeStr.exec(t))[2]=void 0),i&&(n=i[1].toLowerCase(),r=i[2],Zu[n]&&(e=Zu[n].apply(this,[r]))),void 0===e)throw new Error("Could not parse WKT "+t);return e},Wu.prototype.write=function(t){return this.extractGeometry(t)},Wu.prototype.extractGeometry=function(t){var e=t.getGeometryType().toLowerCase();if(!Ju[e])return null;var n=e.toUpperCase();return t.isEmpty()?n+" EMPTY":n+"("+Ju[e].apply(this,[t])+")"};var Ju={coordinate:function(t){return t.x+" "+t.y},point:function(t){return Ju.coordinate.call(this,t._coordinates._coordinates[0])},multipoint:function(t){for(var e=[],n=0,r=t._geometries.length;n<r;++n)e.push("("+Ju.point.apply(this,[t._geometries[n]])+")");return e.join(",")},linestring:function(t){for(var e=[],n=0,r=t._points._coordinates.length;n<r;++n)e.push(Ju.coordinate.apply(this,[t._points._coordinates[n]]));return e.join(",")},linearring:function(t){for(var e=[],n=0,r=t._points._coordinates.length;n<r;++n)e.push(Ju.coordinate.apply(this,[t._points._coordinates[n]]));return e.join(",")},multilinestring:function(t){for(var e=[],n=0,r=t._geometries.length;n<r;++n)e.push("("+Ju.linestring.apply(this,[t._geometries[n]])+")");return e.join(",")},polygon:function(t){var e=[];e.push("("+Ju.linestring.apply(this,[t._shell])+")");for(var n=0,r=t._holes.length;n<r;++n)e.push("("+Ju.linestring.apply(this,[t._holes[n]])+")");return e.join(",")},multipolygon:function(t){for(var e=[],n=0,r=t._geometries.length;n<r;++n)e.push("("+Ju.polygon.apply(this,[t._geometries[n]])+")");return e.join(",")},geometrycollection:function(t){for(var e=[],n=0,r=t._geometries.length;n<r;++n)e.push(this.extractGeometry(t._geometries[n]));return e.join(",")}},Zu={point:function(t){if(void 0===t)return this.geometryFactory.createPoint();var e=t.trim().split(Hu.spaces);return this.geometryFactory.createPoint(new bu(Number.parseFloat(e[0]),Number.parseFloat(e[1])))},multipoint:function(t){if(void 0===t)return this.geometryFactory.createMultiPoint();for(var e,n=t.trim().split(","),r=[],i=0,o=n.length;i<o;++i)e=n[i].replace(Hu.trimParens,"$1"),r.push(Zu.point.apply(this,[e]));return this.geometryFactory.createMultiPoint(r)},linestring:function(t){if(void 0===t)return this.geometryFactory.createLineString();for(var e,n=t.trim().split(","),r=[],i=0,o=n.length;i<o;++i)e=n[i].trim().split(Hu.spaces),r.push(new bu(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLineString(r)},linearring:function(t){if(void 0===t)return this.geometryFactory.createLinearRing();for(var e,n=t.trim().split(","),r=[],i=0,o=n.length;i<o;++i)e=n[i].trim().split(Hu.spaces),r.push(new bu(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLinearRing(r)},multilinestring:function(t){if(void 0===t)return this.geometryFactory.createMultiLineString();for(var e,n=t.trim().split(Hu.parenComma),r=[],i=0,o=n.length;i<o;++i)e=n[i].replace(Hu.trimParens,"$1"),r.push(Zu.linestring.apply(this,[e]));return this.geometryFactory.createMultiLineString(r)},polygon:function(t){if(void 0===t)return this.geometryFactory.createPolygon();for(var e,n,r,i,o=t.trim().split(Hu.parenComma),s=[],a=0,u=o.length;a<u;++a)e=o[a].replace(Hu.trimParens,"$1"),n=Zu.linestring.apply(this,[e]),r=this.geometryFactory.createLinearRing(n._points),0===a?i=r:s.push(r);return this.geometryFactory.createPolygon(i,s)},multipolygon:function(t){if(void 0===t)return this.geometryFactory.createMultiPolygon();for(var e,n=t.trim().split(Hu.doubleParenComma),r=[],i=0,o=n.length;i<o;++i)e=n[i].replace(Hu.trimParens,"$1"),r.push(Zu.polygon.apply(this,[e]));return this.geometryFactory.createMultiPolygon(r)},geometrycollection:function(t){if(void 0===t)return this.geometryFactory.createGeometryCollection();for(var e=(t=t.replace(/,\s*([A-Za-z])/g,"|$1")).trim().split("|"),n=[],r=0,i=e.length;r<i;++r)n.push(this.read(e[r]));return this.geometryFactory.createGeometryCollection(n)}},Ku=function(t){this.parser=new Wu(t)};Ku.prototype.write=function(t){return this.parser.write(t)},Ku.toLineString=function(t,e){if(2!==arguments.length)throw new Error("Not implemented");return"LINESTRING ( "+t.x+" "+t.y+", "+e.x+" "+e.y+" )"};var Qu=function(t){function e(e){t.call(this,e),this.name="RuntimeException",this.message=e,this.stack=(new t).stack}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),$u=function(t){function e(){if(t.call(this),0===arguments.length)t.call(this);else if(1===arguments.length){var e=arguments[0];t.call(this,e)}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Qu),tc=function(){};tc.prototype.interfaces_=function(){return[]},tc.prototype.getClass=function(){return tc},tc.shouldNeverReachHere=function(){if(0===arguments.length)tc.shouldNeverReachHere(null);else if(1===arguments.length){var t=arguments[0];throw new $u("Should never reach here"+(null!==t?": "+t:""))}},tc.isTrue=function(){var t,e;if(1===arguments.length)t=arguments[0],tc.isTrue(t,null);else if(2===arguments.length&&(t=arguments[0],e=arguments[1],!t))throw null===e?new $u:new $u(e)},tc.equals=function(){var t,e,n;if(2===arguments.length)t=arguments[0],e=arguments[1],tc.equals(t,e,null);else if(3===arguments.length&&(t=arguments[0],e=arguments[1],n=arguments[2],!e.equals(t)))throw new $u("Expected "+t+" but encountered "+e+(null!==n?": "+n:""))};var ec=function(){this._result=null,this._inputLines=Array(2).fill().map(function(){return Array(2)}),this._intPt=new Array(2).fill(null),this._intLineIndex=null,this._isProper=null,this._pa=null,this._pb=null,this._precisionModel=null,this._intPt[0]=new bu,this._intPt[1]=new bu,this._pa=this._intPt[0],this._pb=this._intPt[1],this._result=0},nc={DONT_INTERSECT:{configurable:!0},DO_INTERSECT:{configurable:!0},COLLINEAR:{configurable:!0},NO_INTERSECTION:{configurable:!0},POINT_INTERSECTION:{configurable:!0},COLLINEAR_INTERSECTION:{configurable:!0}};ec.prototype.getIndexAlongSegment=function(t,e){return this.computeIntLineIndex(),this._intLineIndex[t][e]},ec.prototype.getTopologySummary=function(){var t=new Ru;return this.isEndPoint()&&t.append(" endpoint"),this._isProper&&t.append(" proper"),this.isCollinear()&&t.append(" collinear"),t.toString()},ec.prototype.computeIntersection=function(t,e,n,r){this._inputLines[0][0]=t,this._inputLines[0][1]=e,this._inputLines[1][0]=n,this._inputLines[1][1]=r,this._result=this.computeIntersect(t,e,n,r)},ec.prototype.getIntersectionNum=function(){return this._result},ec.prototype.computeIntLineIndex=function(){if(0===arguments.length)null===this._intLineIndex&&(this._intLineIndex=Array(2).fill().map(function(){return Array(2)}),this.computeIntLineIndex(0),this.computeIntLineIndex(1));else if(1===arguments.length){var t=arguments[0];this.getEdgeDistance(t,0)>this.getEdgeDistance(t,1)?(this._intLineIndex[t][0]=0,this._intLineIndex[t][1]=1):(this._intLineIndex[t][0]=1,this._intLineIndex[t][1]=0)}},ec.prototype.isProper=function(){return this.hasIntersection()&&this._isProper},ec.prototype.setPrecisionModel=function(t){this._precisionModel=t},ec.prototype.isInteriorIntersection=function(){if(0===arguments.length)return!!this.isInteriorIntersection(0)||!!this.isInteriorIntersection(1);if(1===arguments.length){for(var t=arguments[0],e=0;e<this._result;e++)if(!this._intPt[e].equals2D(this._inputLines[t][0])&&!this._intPt[e].equals2D(this._inputLines[t][1]))return!0;return!1}},ec.prototype.getIntersection=function(t){return this._intPt[t]},ec.prototype.isEndPoint=function(){return this.hasIntersection()&&!this._isProper},ec.prototype.hasIntersection=function(){return this._result!==ec.NO_INTERSECTION},ec.prototype.getEdgeDistance=function(t,e){return ec.computeEdgeDistance(this._intPt[e],this._inputLines[t][0],this._inputLines[t][1])},ec.prototype.isCollinear=function(){return this._result===ec.COLLINEAR_INTERSECTION},ec.prototype.toString=function(){return Ku.toLineString(this._inputLines[0][0],this._inputLines[0][1])+" - "+Ku.toLineString(this._inputLines[1][0],this._inputLines[1][1])+this.getTopologySummary()},ec.prototype.getEndpoint=function(t,e){return this._inputLines[t][e]},ec.prototype.isIntersection=function(t){for(var e=0;e<this._result;e++)if(this._intPt[e].equals2D(t))return!0;return!1},ec.prototype.getIntersectionAlongSegment=function(t,e){return this.computeIntLineIndex(),this._intPt[this._intLineIndex[t][e]]},ec.prototype.interfaces_=function(){return[]},ec.prototype.getClass=function(){return ec},ec.computeEdgeDistance=function(t,e,n){var r=Math.abs(n.x-e.x),i=Math.abs(n.y-e.y),o=-1;if(t.equals(e))o=0;else if(t.equals(n))o=r>i?r:i;else{var s=Math.abs(t.x-e.x),a=Math.abs(t.y-e.y);0!==(o=r>i?s:a)||t.equals(e)||(o=Math.max(s,a))}return tc.isTrue(!(0===o&&!t.equals(e)),"Bad distance calculation"),o},ec.nonRobustComputeEdgeDistance=function(t,e,n){var r=t.x-e.x,i=t.y-e.y,o=Math.sqrt(r*r+i*i);return tc.isTrue(!(0===o&&!t.equals(e)),"Invalid distance calculation"),o},nc.DONT_INTERSECT.get=function(){return 0},nc.DO_INTERSECT.get=function(){return 1},nc.COLLINEAR.get=function(){return 2},nc.NO_INTERSECTION.get=function(){return 0},nc.POINT_INTERSECTION.get=function(){return 1},nc.COLLINEAR_INTERSECTION.get=function(){return 2},Object.defineProperties(ec,nc);var rc=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isInSegmentEnvelopes=function(t){var e=new Yu(this._inputLines[0][0],this._inputLines[0][1]),n=new Yu(this._inputLines[1][0],this._inputLines[1][1]);return e.contains(t)&&n.contains(t)},e.prototype.computeIntersection=function(){if(3!==arguments.length)return t.prototype.computeIntersection.apply(this,arguments);var e=arguments[0],n=arguments[1],r=arguments[2];if(this._isProper=!1,Yu.intersects(n,r,e)&&0===sc.orientationIndex(n,r,e)&&0===sc.orientationIndex(r,n,e))return this._isProper=!0,(e.equals(n)||e.equals(r))&&(this._isProper=!1),this._result=t.POINT_INTERSECTION,null;this._result=t.NO_INTERSECTION},e.prototype.normalizeToMinimum=function(t,e,n,r,i){i.x=this.smallestInAbsValue(t.x,e.x,n.x,r.x),i.y=this.smallestInAbsValue(t.y,e.y,n.y,r.y),t.x-=i.x,t.y-=i.y,e.x-=i.x,e.y-=i.y,n.x-=i.x,n.y-=i.y,r.x-=i.x,r.y-=i.y},e.prototype.safeHCoordinateIntersection=function(t,n,r,i){var o=null;try{o=Uu.intersection(t,n,r,i)}catch(s){if(!(s instanceof ju))throw s;o=e.nearestEndpoint(t,n,r,i)}return o},e.prototype.intersection=function(t,n,r,i){var o=this.intersectionWithNormalization(t,n,r,i);return this.isInSegmentEnvelopes(o)||(o=new bu(e.nearestEndpoint(t,n,r,i))),null!==this._precisionModel&&this._precisionModel.makePrecise(o),o},e.prototype.smallestInAbsValue=function(t,e,n,r){var i=t,o=Math.abs(i);return Math.abs(e)<o&&(i=e,o=Math.abs(e)),Math.abs(n)<o&&(i=n,o=Math.abs(n)),Math.abs(r)<o&&(i=r),i},e.prototype.checkDD=function(t,e,n,r,i){var o=qu.intersection(t,e,n,r),s=this.isInSegmentEnvelopes(o);Xu.out.println("DD in env = "+s+"  --------------------- "+o),i.distance(o)>1e-4&&Xu.out.println("Distance = "+i.distance(o))},e.prototype.intersectionWithNormalization=function(t,e,n,r){var i=new bu(t),o=new bu(e),s=new bu(n),a=new bu(r),u=new bu;this.normalizeToEnvCentre(i,o,s,a,u);var c=this.safeHCoordinateIntersection(i,o,s,a);return c.x+=u.x,c.y+=u.y,c},e.prototype.computeCollinearIntersection=function(e,n,r,i){var o=Yu.intersects(e,n,r),s=Yu.intersects(e,n,i),a=Yu.intersects(r,i,e),u=Yu.intersects(r,i,n);return o&&s?(this._intPt[0]=r,this._intPt[1]=i,t.COLLINEAR_INTERSECTION):a&&u?(this._intPt[0]=e,this._intPt[1]=n,t.COLLINEAR_INTERSECTION):o&&a?(this._intPt[0]=r,this._intPt[1]=e,!r.equals(e)||s||u?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):o&&u?(this._intPt[0]=r,this._intPt[1]=n,!r.equals(n)||s||a?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):s&&a?(this._intPt[0]=i,this._intPt[1]=e,!i.equals(e)||o||u?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):s&&u?(this._intPt[0]=i,this._intPt[1]=n,!i.equals(n)||o||a?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):t.NO_INTERSECTION},e.prototype.normalizeToEnvCentre=function(t,e,n,r,i){var o=t.x<e.x?t.x:e.x,s=t.y<e.y?t.y:e.y,a=t.x>e.x?t.x:e.x,u=t.y>e.y?t.y:e.y,c=n.x<r.x?n.x:r.x,h=n.y<r.y?n.y:r.y,l=n.x>r.x?n.x:r.x,p=n.y>r.y?n.y:r.y,f=((o>c?o:c)+(a<l?a:l))/2,g=((s>h?s:h)+(u<p?u:p))/2;i.x=f,i.y=g,t.x-=i.x,t.y-=i.y,e.x-=i.x,e.y-=i.y,n.x-=i.x,n.y-=i.y,r.x-=i.x,r.y-=i.y},e.prototype.computeIntersect=function(e,n,r,i){if(this._isProper=!1,!Yu.intersects(e,n,r,i))return t.NO_INTERSECTION;var o=sc.orientationIndex(e,n,r),s=sc.orientationIndex(e,n,i);if(o>0&&s>0||o<0&&s<0)return t.NO_INTERSECTION;var a=sc.orientationIndex(r,i,e),u=sc.orientationIndex(r,i,n);if(a>0&&u>0||a<0&&u<0)return t.NO_INTERSECTION;return 0===o&&0===s&&0===a&&0===u?this.computeCollinearIntersection(e,n,r,i):(0===o||0===s||0===a||0===u?(this._isProper=!1,e.equals2D(r)||e.equals2D(i)?this._intPt[0]=e:n.equals2D(r)||n.equals2D(i)?this._intPt[0]=n:0===o?this._intPt[0]=new bu(r):0===s?this._intPt[0]=new bu(i):0===a?this._intPt[0]=new bu(e):0===u&&(this._intPt[0]=new bu(n))):(this._isProper=!0,this._intPt[0]=this.intersection(e,n,r,i)),t.POINT_INTERSECTION)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.nearestEndpoint=function(t,e,n,r){var i=t,o=sc.distancePointLine(t,n,r),s=sc.distancePointLine(e,n,r);return s<o&&(o=s,i=e),(s=sc.distancePointLine(n,t,e))<o&&(o=s,i=n),(s=sc.distancePointLine(r,t,e))<o&&(o=s,i=r),i},e}(ec),ic=function(){};ic.prototype.interfaces_=function(){return[]},ic.prototype.getClass=function(){return ic},ic.orientationIndex=function(t,e,n){var r=e.x-t.x,i=e.y-t.y,o=n.x-e.x,s=n.y-e.y;return ic.signOfDet2x2(r,i,o,s)},ic.signOfDet2x2=function(t,e,n,r){var i=null,o=null,s=null;if(i=1,0===t||0===r)return 0===e||0===n?0:e>0?n>0?-i:i:n>0?i:-i;if(0===e||0===n)return r>0?t>0?i:-i:t>0?-i:i;if(e>0?r>0?e<=r||(i=-i,o=t,t=n,n=o,o=e,e=r,r=o):e<=-r?(i=-i,n=-n,r=-r):(o=t,t=-n,n=o,o=e,e=-r,r=o):r>0?-e<=r?(i=-i,t=-t,e=-e):(o=-t,t=n,n=o,o=-e,e=r,r=o):e>=r?(t=-t,e=-e,n=-n,r=-r):(i=-i,o=-t,t=-n,n=o,o=-e,e=-r,r=o),t>0){if(!(n>0))return i;if(!(t<=n))return i}else{if(n>0)return-i;if(!(t>=n))return-i;i=-i,t=-t,n=-n}for(;;){if(s=Math.floor(n/t),n-=s*t,(r-=s*e)<0)return-i;if(r>e)return i;if(t>n+n){if(e<r+r)return i}else{if(e>r+r)return-i;n=t-n,r=e-r,i=-i}if(0===r)return 0===n?0:-i;if(0===n)return i;if(s=Math.floor(t/n),t-=s*n,(e-=s*r)<0)return i;if(e>r)return-i;if(n>t+t){if(r<e+e)return-i}else{if(r>e+e)return i;t=n-t,e=r-e,i=-i}if(0===e)return 0===t?0:i;if(0===t)return-i}};var oc=function(){this._p=null,this._crossingCount=0,this._isPointOnSegment=!1;var t=arguments[0];this._p=t};oc.prototype.countSegment=function(t,e){if(t.x<this._p.x&&e.x<this._p.x)return null;if(this._p.x===e.x&&this._p.y===e.y)return this._isPointOnSegment=!0,null;if(t.y===this._p.y&&e.y===this._p.y){var n=t.x,r=e.x;return n>r&&(n=e.x,r=t.x),this._p.x>=n&&this._p.x<=r&&(this._isPointOnSegment=!0),null}if(t.y>this._p.y&&e.y<=this._p.y||e.y>this._p.y&&t.y<=this._p.y){var i=t.x-this._p.x,o=t.y-this._p.y,s=e.x-this._p.x,a=e.y-this._p.y,u=ic.signOfDet2x2(i,o,s,a);if(0===u)return this._isPointOnSegment=!0,null;a<o&&(u=-u),u>0&&this._crossingCount++}},oc.prototype.isPointInPolygon=function(){return this.getLocation()!==Su.EXTERIOR},oc.prototype.getLocation=function(){return this._isPointOnSegment?Su.BOUNDARY:this._crossingCount%2==1?Su.INTERIOR:Su.EXTERIOR},oc.prototype.isOnSegment=function(){return this._isPointOnSegment},oc.prototype.interfaces_=function(){return[]},oc.prototype.getClass=function(){return oc},oc.locatePointInRing=function(){if(arguments[0]instanceof bu&&Lu(arguments[1],Bu)){for(var t=arguments[0],e=arguments[1],n=new oc(t),r=new bu,i=new bu,o=1;o<e.size();o++)if(e.getCoordinate(o,r),e.getCoordinate(o-1,i),n.countSegment(r,i),n.isOnSegment())return n.getLocation();return n.getLocation()}if(arguments[0]instanceof bu&&arguments[1]instanceof Array){for(var s=arguments[0],a=arguments[1],u=new oc(s),c=1;c<a.length;c++){var h=a[c],l=a[c-1];if(u.countSegment(h,l),u.isOnSegment())return u.getLocation()}return u.getLocation()}};var sc=function(){},ac={CLOCKWISE:{configurable:!0},RIGHT:{configurable:!0},COUNTERCLOCKWISE:{configurable:!0},LEFT:{configurable:!0},COLLINEAR:{configurable:!0},STRAIGHT:{configurable:!0}};sc.prototype.interfaces_=function(){return[]},sc.prototype.getClass=function(){return sc},sc.orientationIndex=function(t,e,n){return qu.orientationIndex(t,e,n)},sc.signedArea=function(){if(arguments[0]instanceof Array){var t=arguments[0];if(t.length<3)return 0;for(var e=0,n=t[0].x,r=1;r<t.length-1;r++){var i=t[r].x-n,o=t[r+1].y;e+=i*(t[r-1].y-o)}return e/2}if(Lu(arguments[0],Bu)){var s=arguments[0],a=s.size();if(a<3)return 0;var u=new bu,c=new bu,h=new bu;s.getCoordinate(0,c),s.getCoordinate(1,h);var l=c.x;h.x-=l;for(var p=0,f=1;f<a-1;f++)u.y=c.y,c.x=h.x,c.y=h.y,s.getCoordinate(f+1,h),h.x-=l,p+=c.x*(u.y-h.y);return p/2}},sc.distanceLineLine=function(t,e,n,r){if(t.equals(e))return sc.distancePointLine(t,n,r);if(n.equals(r))return sc.distancePointLine(r,t,e);var i=!1;if(Yu.intersects(t,e,n,r)){var o=(e.x-t.x)*(r.y-n.y)-(e.y-t.y)*(r.x-n.x);if(0===o)i=!0;else{var s=(t.y-n.y)*(r.x-n.x)-(t.x-n.x)*(r.y-n.y),a=((t.y-n.y)*(e.x-t.x)-(t.x-n.x)*(e.y-t.y))/o,u=s/o;(u<0||u>1||a<0||a>1)&&(i=!0)}}else i=!0;return i?Pu.min(sc.distancePointLine(t,n,r),sc.distancePointLine(e,n,r),sc.distancePointLine(n,t,e),sc.distancePointLine(r,t,e)):0},sc.isPointInRing=function(t,e){return sc.locatePointInRing(t,e)!==Su.EXTERIOR},sc.computeLength=function(t){var e=t.size();if(e<=1)return 0;var n=0,r=new bu;t.getCoordinate(0,r);for(var i=r.x,o=r.y,s=1;s<e;s++){t.getCoordinate(s,r);var a=r.x,u=r.y,c=a-i,h=u-o;n+=Math.sqrt(c*c+h*h),i=a,o=u}return n},sc.isCCW=function(t){var e=t.length-1;if(e<3)throw new _u("Ring has fewer than 4 points, so orientation cannot be determined");for(var n=t[0],r=0,i=1;i<=e;i++){var o=t[i];o.y>n.y&&(n=o,r=i)}var s=r;do{(s-=1)<0&&(s=e)}while(t[s].equals2D(n)&&s!==r);var a=r;do{a=(a+1)%e}while(t[a].equals2D(n)&&a!==r);var u=t[s],c=t[a];if(u.equals2D(n)||c.equals2D(n)||u.equals2D(c))return!1;var h=sc.computeOrientation(u,n,c),l=!1;return l=0===h?u.x>c.x:h>0,l},sc.locatePointInRing=function(t,e){return oc.locatePointInRing(t,e)},sc.distancePointLinePerpendicular=function(t,e,n){var r=(n.x-e.x)*(n.x-e.x)+(n.y-e.y)*(n.y-e.y),i=((e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y))/r;return Math.abs(i)*Math.sqrt(r)},sc.computeOrientation=function(t,e,n){return sc.orientationIndex(t,e,n)},sc.distancePointLine=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(0===e.length)throw new _u("Line array must contain at least one vertex");for(var n=t.distance(e[0]),r=0;r<e.length-1;r++){var i=sc.distancePointLine(t,e[r],e[r+1]);i<n&&(n=i)}return n}if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];if(s.x===a.x&&s.y===a.y)return o.distance(s);var u=(a.x-s.x)*(a.x-s.x)+(a.y-s.y)*(a.y-s.y),c=((o.x-s.x)*(a.x-s.x)+(o.y-s.y)*(a.y-s.y))/u;if(c<=0)return o.distance(s);if(c>=1)return o.distance(a);var h=((s.y-o.y)*(a.x-s.x)-(s.x-o.x)*(a.y-s.y))/u;return Math.abs(h)*Math.sqrt(u)}},sc.isOnLine=function(t,e){for(var n=new rc,r=1;r<e.length;r++){var i=e[r-1],o=e[r];if(n.computeIntersection(t,i,o),n.hasIntersection())return!0}return!1},ac.CLOCKWISE.get=function(){return-1},ac.RIGHT.get=function(){return sc.CLOCKWISE},ac.COUNTERCLOCKWISE.get=function(){return 1},ac.LEFT.get=function(){return sc.COUNTERCLOCKWISE},ac.COLLINEAR.get=function(){return 0},ac.STRAIGHT.get=function(){return sc.COLLINEAR},Object.defineProperties(sc,ac);var uc=function(){};uc.prototype.filter=function(t){},uc.prototype.interfaces_=function(){return[]},uc.prototype.getClass=function(){return uc};var cc=function(){var t=arguments[0];this._envelope=null,this._factory=null,this._SRID=null,this._userData=null,this._factory=t,this._SRID=t.getSRID()},hc={serialVersionUID:{configurable:!0},SORTINDEX_POINT:{configurable:!0},SORTINDEX_MULTIPOINT:{configurable:!0},SORTINDEX_LINESTRING:{configurable:!0},SORTINDEX_LINEARRING:{configurable:!0},SORTINDEX_MULTILINESTRING:{configurable:!0},SORTINDEX_POLYGON:{configurable:!0},SORTINDEX_MULTIPOLYGON:{configurable:!0},SORTINDEX_GEOMETRYCOLLECTION:{configurable:!0},geometryChangedFilter:{configurable:!0}};cc.prototype.isGeometryCollection=function(){return this.getSortIndex()===cc.SORTINDEX_GEOMETRYCOLLECTION},cc.prototype.getFactory=function(){return this._factory},cc.prototype.getGeometryN=function(t){return this},cc.prototype.getArea=function(){return 0},cc.prototype.isRectangle=function(){return!1},cc.prototype.equals=function(){if(arguments[0]instanceof cc){var t=arguments[0];return null!==t&&this.equalsTopo(t)}if(arguments[0]instanceof Object){var e=arguments[0];if(!(e instanceof cc))return!1;var n=e;return this.equalsExact(n)}},cc.prototype.equalsExact=function(t){return this===t||this.equalsExact(t,0)},cc.prototype.geometryChanged=function(){this.apply(cc.geometryChangedFilter)},cc.prototype.geometryChangedAction=function(){this._envelope=null},cc.prototype.equalsNorm=function(t){return null!==t&&this.norm().equalsExact(t.norm())},cc.prototype.getLength=function(){return 0},cc.prototype.getNumGeometries=function(){return 1},cc.prototype.compareTo=function(){if(1===arguments.length){var t=arguments[0],e=t;return this.getSortIndex()!==e.getSortIndex()?this.getSortIndex()-e.getSortIndex():this.isEmpty()&&e.isEmpty()?0:this.isEmpty()?-1:e.isEmpty()?1:this.compareToSameClass(t)}if(2===arguments.length){var n=arguments[0],r=arguments[1];return this.getSortIndex()!==n.getSortIndex()?this.getSortIndex()-n.getSortIndex():this.isEmpty()&&n.isEmpty()?0:this.isEmpty()?-1:n.isEmpty()?1:this.compareToSameClass(n,r)}},cc.prototype.getUserData=function(){return this._userData},cc.prototype.getSRID=function(){return this._SRID},cc.prototype.getEnvelope=function(){return this.getFactory().toGeometry(this.getEnvelopeInternal())},cc.prototype.checkNotGeometryCollection=function(t){if(t.getSortIndex()===cc.SORTINDEX_GEOMETRYCOLLECTION)throw new _u("This method does not support GeometryCollection arguments")},cc.prototype.equal=function(t,e,n){return 0===n?t.equals(e):t.distance(e)<=n},cc.prototype.norm=function(){var t=this.copy();return t.normalize(),t},cc.prototype.getPrecisionModel=function(){return this._factory.getPrecisionModel()},cc.prototype.getEnvelopeInternal=function(){return null===this._envelope&&(this._envelope=this.computeEnvelopeInternal()),new Yu(this._envelope)},cc.prototype.setSRID=function(t){this._SRID=t},cc.prototype.setUserData=function(t){this._userData=t},cc.prototype.compare=function(t,e){for(var n=t.iterator(),r=e.iterator();n.hasNext()&&r.hasNext();){var i=n.next(),o=r.next(),s=i.compareTo(o);if(0!==s)return s}return n.hasNext()?1:r.hasNext()?-1:0},cc.prototype.hashCode=function(){return this.getEnvelopeInternal().hashCode()},cc.prototype.isGeometryCollectionOrDerived=function(){return this.getSortIndex()===cc.SORTINDEX_GEOMETRYCOLLECTION||this.getSortIndex()===cc.SORTINDEX_MULTIPOINT||this.getSortIndex()===cc.SORTINDEX_MULTILINESTRING||this.getSortIndex()===cc.SORTINDEX_MULTIPOLYGON},cc.prototype.interfaces_=function(){return[Eu,xu,Li]},cc.prototype.getClass=function(){return cc},cc.hasNonEmptyElements=function(t){for(var e=0;e<t.length;e++)if(!t[e].isEmpty())return!0;return!1},cc.hasNullElements=function(t){for(var e=0;e<t.length;e++)if(null===t[e])return!0;return!1},hc.serialVersionUID.get=function(){return 0x799ea46522854c00},hc.SORTINDEX_POINT.get=function(){return 0},hc.SORTINDEX_MULTIPOINT.get=function(){return 1},hc.SORTINDEX_LINESTRING.get=function(){return 2},hc.SORTINDEX_LINEARRING.get=function(){return 3},hc.SORTINDEX_MULTILINESTRING.get=function(){return 4},hc.SORTINDEX_POLYGON.get=function(){return 5},hc.SORTINDEX_MULTIPOLYGON.get=function(){return 6},hc.SORTINDEX_GEOMETRYCOLLECTION.get=function(){return 7},hc.geometryChangedFilter.get=function(){return lc},Object.defineProperties(cc,hc);var lc=function(){};lc.interfaces_=function(){return[uc]},lc.filter=function(t){t.geometryChangedAction()};var pc=function(){};pc.prototype.filter=function(t){},pc.prototype.interfaces_=function(){return[]},pc.prototype.getClass=function(){return pc};var fc=function(){},gc={Mod2BoundaryNodeRule:{configurable:!0},EndPointBoundaryNodeRule:{configurable:!0},MultiValentEndPointBoundaryNodeRule:{configurable:!0},MonoValentEndPointBoundaryNodeRule:{configurable:!0},MOD2_BOUNDARY_RULE:{configurable:!0},ENDPOINT_BOUNDARY_RULE:{configurable:!0},MULTIVALENT_ENDPOINT_BOUNDARY_RULE:{configurable:!0},MONOVALENT_ENDPOINT_BOUNDARY_RULE:{configurable:!0},OGC_SFS_BOUNDARY_RULE:{configurable:!0}};fc.prototype.isInBoundary=function(t){},fc.prototype.interfaces_=function(){return[]},fc.prototype.getClass=function(){return fc},gc.Mod2BoundaryNodeRule.get=function(){return dc},gc.EndPointBoundaryNodeRule.get=function(){return yc},gc.MultiValentEndPointBoundaryNodeRule.get=function(){return _c},gc.MonoValentEndPointBoundaryNodeRule.get=function(){return mc},gc.MOD2_BOUNDARY_RULE.get=function(){return new dc},gc.ENDPOINT_BOUNDARY_RULE.get=function(){return new yc},gc.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get=function(){return new _c},gc.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get=function(){return new mc},gc.OGC_SFS_BOUNDARY_RULE.get=function(){return fc.MOD2_BOUNDARY_RULE},Object.defineProperties(fc,gc);var dc=function(){};dc.prototype.isInBoundary=function(t){return t%2==1},dc.prototype.interfaces_=function(){return[fc]},dc.prototype.getClass=function(){return dc};var yc=function(){};yc.prototype.isInBoundary=function(t){return t>0},yc.prototype.interfaces_=function(){return[fc]},yc.prototype.getClass=function(){return yc};var _c=function(){};_c.prototype.isInBoundary=function(t){return t>1},_c.prototype.interfaces_=function(){return[fc]},_c.prototype.getClass=function(){return _c};var mc=function(){};mc.prototype.isInBoundary=function(t){return 1===t},mc.prototype.interfaces_=function(){return[fc]},mc.prototype.getClass=function(){return mc};var vc=function(){};vc.prototype.add=function(){},vc.prototype.addAll=function(){},vc.prototype.isEmpty=function(){},vc.prototype.iterator=function(){},vc.prototype.size=function(){},vc.prototype.toArray=function(){},vc.prototype.remove=function(){};var xc=function(t){function e(e){t.call(this),this.message=e||""}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={name:{configurable:!0}};return n.name.get=function(){return"IndexOutOfBoundsException"},Object.defineProperties(e,n),e}(Error),Ec=function(){};Ec.prototype.hasNext=function(){},Ec.prototype.next=function(){},Ec.prototype.remove=function(){};var wc=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(){},e.prototype.set=function(){},e.prototype.isEmpty=function(){},e}(vc);(Pi.prototype=new Error).name="NoSuchElementException";var bc=function(t){function e(){t.call(this),this.array_=[],arguments[0]instanceof vc&&this.addAll(arguments[0])}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.ensureCapacity=function(){},e.prototype.interfaces_=function(){return[t,vc]},e.prototype.add=function(t){return 1===arguments.length?this.array_.push(t):this.array_.splice(arguments[0],arguments[1]),!0},e.prototype.clear=function(){this.array_=[]},e.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},e.prototype.set=function(t,e){var n=this.array_[t];return this.array_[t]=e,n},e.prototype.iterator=function(){return new Ic(this)},e.prototype.get=function(t){if(t<0||t>=this.size())throw new xc;return this.array_[t]},e.prototype.isEmpty=function(){return 0===this.array_.length},e.prototype.size=function(){return this.array_.length},e.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},e.prototype.remove=function(t){for(var e=!1,n=0,r=this.array_.length;n<r;n++)if(this.array_[n]===t){this.array_.splice(n,1),e=!0;break}return e},e}(wc),Ic=function(t){function e(e){t.call(this),this.arrayList_=e,this.position_=0}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.next=function(){if(this.position_===this.arrayList_.size())throw new Pi;return this.arrayList_.get(this.position_++)},e.prototype.hasNext=function(){return this.position_<this.arrayList_.size()},e.prototype.set=function(t){return this.arrayList_.set(this.position_-1,t)},e.prototype.remove=function(){this.arrayList_.remove(this.arrayList_.get(this.position_))},e}(Ec),Nc=function(t){function e(){if(t.call(this),0===arguments.length);else if(1===arguments.length){var e=arguments[0];this.ensureCapacity(e.length),this.add(e,!0)}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this.ensureCapacity(n.length),this.add(n,r)}}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={coordArrayType:{configurable:!0}};return n.coordArrayType.get=function(){return new Array(0).fill(null)},e.prototype.getCoordinate=function(t){return this.get(t)},e.prototype.addAll=function(){if(2===arguments.length){for(var e=arguments[0],n=arguments[1],r=!1,i=e.iterator();i.hasNext();)this.add(i.next(),n),r=!0;return r}return t.prototype.addAll.apply(this,arguments)},e.prototype.clone=function(){for(var e=t.prototype.clone.call(this),n=0;n<this.size();n++)e.add(n,this.get(n).copy());return e},e.prototype.toCoordinateArray=function(){return this.toArray(e.coordArrayType)},e.prototype.add=function(){if(1===arguments.length){var e=arguments[0];t.prototype.add.call(this,e)}else if(2===arguments.length){if(arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var n=arguments[0],r=arguments[1];return this.add(n,r,!0),!0}if(arguments[0]instanceof bu&&"boolean"==typeof arguments[1]){var i=arguments[0];if(!arguments[1]&&this.size()>=1){if(this.get(this.size()-1).equals2D(i))return null}t.prototype.add.call(this,i)}else if(arguments[0]instanceof Object&&"boolean"==typeof arguments[1]){var o=arguments[0],s=arguments[1];return this.add(o,s),!0}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var a=arguments[0],u=arguments[1];if(arguments[2])for(var c=0;c<a.length;c++)this.add(a[c],u);else for(var h=a.length-1;h>=0;h--)this.add(a[h],u);return!0}if("boolean"==typeof arguments[2]&&Number.isInteger(arguments[0])&&arguments[1]instanceof bu){var l=arguments[0],p=arguments[1];if(!arguments[2]){var f=this.size();if(f>0){if(l>0){if(this.get(l-1).equals2D(p))return null}if(l<f){if(this.get(l).equals2D(p))return null}}}t.prototype.add.call(this,l,p)}}else if(4===arguments.length){var g=arguments[0],d=arguments[1],y=arguments[2],_=arguments[3],m=1;y>_&&(m=-1);for(var v=y;v!==_;v+=m)this.add(g[v],d);return!0}},e.prototype.closeRing=function(){this.size()>0&&this.add(new bu(this.get(0)),!1)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},Object.defineProperties(e,n),e}(bc),Cc=function(){},Sc={ForwardComparator:{configurable:!0},BidirectionalComparator:{configurable:!0},coordArrayType:{configurable:!0}};Sc.ForwardComparator.get=function(){return Mc},Sc.BidirectionalComparator.get=function(){return Lc},Sc.coordArrayType.get=function(){return new Array(0).fill(null)},Cc.prototype.interfaces_=function(){return[]},Cc.prototype.getClass=function(){return Cc},Cc.isRing=function(t){return!(t.length<4)&&!!t[0].equals2D(t[t.length-1])},Cc.ptNotInList=function(t,e){for(var n=0;n<t.length;n++){var r=t[n];if(Cc.indexOf(r,e)<0)return r}return null},Cc.scroll=function(t,e){var n=Cc.indexOf(e,t);if(n<0)return null;var r=new Array(t.length).fill(null);Xu.arraycopy(t,n,r,0,t.length-n),Xu.arraycopy(t,0,r,t.length-n,n),Xu.arraycopy(r,0,t,0,t.length)},Cc.equals=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(t===e)return!0;if(null===t||null===e)return!1;if(t.length!==e.length)return!1;for(var n=0;n<t.length;n++)if(!t[n].equals(e[n]))return!1;return!0}if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2];if(r===i)return!0;if(null===r||null===i)return!1;if(r.length!==i.length)return!1;for(var s=0;s<r.length;s++)if(0!==o.compare(r[s],i[s]))return!1;return!0}},Cc.intersection=function(t,e){for(var n=new Nc,r=0;r<t.length;r++)e.intersects(t[r])&&n.add(t[r],!0);return n.toCoordinateArray()},Cc.hasRepeatedPoints=function(t){for(var e=1;e<t.length;e++)if(t[e-1].equals(t[e]))return!0;return!1},Cc.removeRepeatedPoints=function(t){if(!Cc.hasRepeatedPoints(t))return t;return new Nc(t,!1).toCoordinateArray()},Cc.reverse=function(t){for(var e=t.length-1,n=Math.trunc(e/2),r=0;r<=n;r++){var i=t[r];t[r]=t[e-r],t[e-r]=i}},Cc.removeNull=function(t){for(var e=0,n=0;n<t.length;n++)null!==t[n]&&e++;var r=new Array(e).fill(null);if(0===e)return r;for(var i=0,o=0;o<t.length;o++)null!==t[o]&&(r[i++]=t[o]);return r},Cc.copyDeep=function(){if(1===arguments.length){for(var t=arguments[0],e=new Array(t.length).fill(null),n=0;n<t.length;n++)e[n]=new bu(t[n]);return e}if(5===arguments.length)for(var r=arguments[0],i=arguments[1],o=arguments[2],s=arguments[3],a=arguments[4],u=0;u<a;u++)o[s+u]=new bu(r[i+u])},Cc.isEqualReversed=function(t,e){for(var n=0;n<t.length;n++){var r=t[n],i=e[t.length-n-1];if(0!==r.compareTo(i))return!1}return!0},Cc.envelope=function(t){for(var e=new Yu,n=0;n<t.length;n++)e.expandToInclude(t[n]);return e},Cc.toCoordinateArray=function(t){return t.toArray(Cc.coordArrayType)},Cc.atLeastNCoordinatesOrNothing=function(t,e){return e.length>=t?e:[]},Cc.indexOf=function(t,e){for(var n=0;n<e.length;n++)if(t.equals(e[n]))return n;return-1},Cc.increasingDirection=function(t){for(var e=0;e<Math.trunc(t.length/2);e++){var n=t.length-1-e,r=t[e].compareTo(t[n]);if(0!==r)return r}return 1},Cc.compare=function(t,e){for(var n=0;n<t.length&&n<e.length;){var r=t[n].compareTo(e[n]);if(0!==r)return r;n++}return n<e.length?-1:n<t.length?1:0},Cc.minCoordinate=function(t){for(var e=null,n=0;n<t.length;n++)(null===e||e.compareTo(t[n])>0)&&(e=t[n]);return e},Cc.extract=function(t,e,n){e=Pu.clamp(e,0,t.length);var r=(n=Pu.clamp(n,-1,t.length))-e+1;n<0&&(r=0),e>=t.length&&(r=0),n<e&&(r=0);var i=new Array(r).fill(null);if(0===r)return i;for(var o=0,s=e;s<=n;s++)i[o++]=t[s];return i},Object.defineProperties(Cc,Sc);var Mc=function(){};Mc.prototype.compare=function(t,e){return Cc.compare(t,e)},Mc.prototype.interfaces_=function(){return[wu]},Mc.prototype.getClass=function(){return Mc};var Lc=function(){};Lc.prototype.compare=function(t,e){var n=t,r=e;if(n.length<r.length)return-1;if(n.length>r.length)return 1;if(0===n.length)return 0;var i=Cc.compare(n,r);return Cc.isEqualReversed(n,r)?0:i},Lc.prototype.OLDcompare=function(t,e){var n=t,r=e;if(n.length<r.length)return-1;if(n.length>r.length)return 1;if(0===n.length)return 0;for(var i=Cc.increasingDirection(n),o=Cc.increasingDirection(r),s=i>0?0:n.length-1,a=o>0?0:n.length-1,u=0;u<n.length;u++){var c=n[s].compareTo(r[a]);if(0!==c)return c;s+=i,a+=o}return 0},Lc.prototype.interfaces_=function(){return[wu]},Lc.prototype.getClass=function(){return Lc};var Pc=function(){};Pc.prototype.get=function(){},Pc.prototype.put=function(){},Pc.prototype.size=function(){},Pc.prototype.values=function(){},Pc.prototype.entrySet=function(){};var Oc=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Pc);(Oi.prototype=new Error).name="OperationNotSupported",(Ri.prototype=new vc).contains=function(){};var Rc=function(t){function e(){t.call(this),this.array_=[],arguments[0]instanceof vc&&this.addAll(arguments[0])}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.contains=function(t){for(var e=0,n=this.array_.length;e<n;e++){if(this.array_[e]===t)return!0}return!1},e.prototype.add=function(t){return!this.contains(t)&&(this.array_.push(t),!0)},e.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},e.prototype.remove=function(t){throw new Error},e.prototype.size=function(){return this.array_.length},e.prototype.isEmpty=function(){return 0===this.array_.length},e.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},e.prototype.iterator=function(){return new Tc(this)},e}(Ri),Tc=function(t){function e(e){t.call(this),this.hashSet_=e,this.position_=0}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.next=function(){if(this.position_===this.hashSet_.size())throw new Pi;return this.hashSet_.array_[this.position_++]},e.prototype.hasNext=function(){return this.position_<this.hashSet_.size()},e.prototype.remove=function(){throw new Oi},e}(Ec),Ac=0;(Gi.prototype=new Oc).get=function(t){for(var e=this.root_;null!==e;){var n=t.compareTo(e.key);if(n<0)e=e.left;else{if(!(n>0))return e.value;e=e.right}}return null},Gi.prototype.put=function(t,e){if(null===this.root_)return this.root_={key:t,value:e,left:null,right:null,parent:null,color:Ac,getValue:function(){return this.value},getKey:function(){return this.key}},this.size_=1,null;var n,r,i=this.root_;do{if(n=i,(r=t.compareTo(i.key))<0)i=i.left;else{if(!(r>0)){var o=i.value;return i.value=e,o}i=i.right}}while(null!==i);var s={key:t,left:null,right:null,value:e,parent:n,color:Ac,getValue:function(){return this.value},getKey:function(){return this.key}};return r<0?n.left=s:n.right=s,this.fixAfterInsertion(s),this.size_++,null},Gi.prototype.fixAfterInsertion=function(t){for(t.color=1;null!=t&&t!==this.root_&&1===t.parent.color;)if(Ai(t)===Fi(Ai(Ai(t)))){var e=qi(Ai(Ai(t)));1===Ti(e)?(Di(Ai(t),Ac),Di(e,Ac),Di(Ai(Ai(t)),1),t=Ai(Ai(t))):(t===qi(Ai(t))&&(t=Ai(t),this.rotateLeft(t)),Di(Ai(t),Ac),Di(Ai(Ai(t)),1),this.rotateRight(Ai(Ai(t))))}else{var n=Fi(Ai(Ai(t)));1===Ti(n)?(Di(Ai(t),Ac),Di(n,Ac),Di(Ai(Ai(t)),1),t=Ai(Ai(t))):(t===Fi(Ai(t))&&(t=Ai(t),this.rotateRight(t)),Di(Ai(t),Ac),Di(Ai(Ai(t)),1),this.rotateLeft(Ai(Ai(t))))}this.root_.color=Ac},Gi.prototype.values=function(){var t=new bc,e=this.getFirstEntry();if(null!==e)for(t.add(e.value);null!==(e=Gi.successor(e));)t.add(e.value);return t},Gi.prototype.entrySet=function(){var t=new Rc,e=this.getFirstEntry();if(null!==e)for(t.add(e);null!==(e=Gi.successor(e));)t.add(e);return t},Gi.prototype.rotateLeft=function(t){if(null!=t){var e=t.right;t.right=e.left,null!=e.left&&(e.left.parent=t),e.parent=t.parent,null===t.parent?this.root_=e:t.parent.left===t?t.parent.left=e:t.parent.right=e,e.left=t,t.parent=e}},Gi.prototype.rotateRight=function(t){if(null!=t){var e=t.left;t.left=e.right,null!=e.right&&(e.right.parent=t),e.parent=t.parent,null===t.parent?this.root_=e:t.parent.right===t?t.parent.right=e:t.parent.left=e,e.right=t,t.parent=e}},Gi.prototype.getFirstEntry=function(){var t=this.root_;if(null!=t)for(;null!=t.left;)t=t.left;return t},Gi.successor=function(t){if(null===t)return null;if(null!==t.right){for(var e=t.right;null!==e.left;)e=e.left;return e}for(var n=t.parent,r=t;null!==n&&r===n.right;)r=n,n=n.parent;return n},Gi.prototype.size=function(){return this.size_};var Dc=function(){};Dc.prototype.interfaces_=function(){return[]},Dc.prototype.getClass=function(){return Dc},Bi.prototype=new Ri,(ki.prototype=new Bi).contains=function(t){for(var e=0,n=this.array_.length;e<n;e++){if(0===this.array_[e].compareTo(t))return!0}return!1},ki.prototype.add=function(t){if(this.contains(t))return!1;for(var e=0,n=this.array_.length;e<n;e++){if(1===this.array_[e].compareTo(t))return this.array_.splice(e,0,t),!0}return this.array_.push(t),!0},ki.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},ki.prototype.remove=function(t){throw new Oi},ki.prototype.size=function(){return this.array_.length},ki.prototype.isEmpty=function(){return 0===this.array_.length},ki.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},ki.prototype.iterator=function(){return new Fc(this)};var Fc=function(t){this.treeSet_=t,this.position_=0};Fc.prototype.next=function(){if(this.position_===this.treeSet_.size())throw new Pi;return this.treeSet_.array_[this.position_++]},Fc.prototype.hasNext=function(){return this.position_<this.treeSet_.size()},Fc.prototype.remove=function(){throw new Oi};var qc=function(){};qc.sort=function(){var t,e,n,r,i=arguments[0];if(1===arguments.length)r=function(t,e){return t.compareTo(e)},i.sort(r);else if(2===arguments.length)n=arguments[1],r=function(t,e){return n.compare(t,e)},i.sort(r);else if(3===arguments.length){(e=i.slice(arguments[1],arguments[2])).sort();var o=i.slice(0,arguments[1]).concat(e,i.slice(arguments[2],i.length));for(i.splice(0,i.length),t=0;t<o.length;t++)i.push(o[t])}else if(4===arguments.length)for(e=i.slice(arguments[1],arguments[2]),n=arguments[3],r=function(t,e){return n.compare(t,e)},e.sort(r),o=i.slice(0,arguments[1]).concat(e,i.slice(arguments[2],i.length)),i.splice(0,i.length),t=0;t<o.length;t++)i.push(o[t])},qc.asList=function(t){for(var e=new bc,n=0,r=t.length;n<r;n++)e.add(t[n]);return e};var Gc=function(){},Bc={P:{configurable:!0},L:{configurable:!0},A:{configurable:!0},FALSE:{configurable:!0},TRUE:{configurable:!0},DONTCARE:{configurable:!0},SYM_FALSE:{configurable:!0},SYM_TRUE:{configurable:!0},SYM_DONTCARE:{configurable:!0},SYM_P:{configurable:!0},SYM_L:{configurable:!0},SYM_A:{configurable:!0}};Bc.P.get=function(){return 0},Bc.L.get=function(){return 1},Bc.A.get=function(){return 2},Bc.FALSE.get=function(){return-1},Bc.TRUE.get=function(){return-2},Bc.DONTCARE.get=function(){return-3},Bc.SYM_FALSE.get=function(){return"F"},Bc.SYM_TRUE.get=function(){return"T"},Bc.SYM_DONTCARE.get=function(){return"*"},Bc.SYM_P.get=function(){return"0"},Bc.SYM_L.get=function(){return"1"},Bc.SYM_A.get=function(){return"2"},Gc.prototype.interfaces_=function(){return[]},Gc.prototype.getClass=function(){return Gc},Gc.toDimensionSymbol=function(t){switch(t){case Gc.FALSE:return Gc.SYM_FALSE;case Gc.TRUE:return Gc.SYM_TRUE;case Gc.DONTCARE:return Gc.SYM_DONTCARE;case Gc.P:return Gc.SYM_P;case Gc.L:return Gc.SYM_L;case Gc.A:return Gc.SYM_A}throw new _u("Unknown dimension value: "+t)},Gc.toDimensionValue=function(t){switch(Au.toUpperCase(t)){case Gc.SYM_FALSE:return Gc.FALSE;case Gc.SYM_TRUE:return Gc.TRUE;case Gc.SYM_DONTCARE:return Gc.DONTCARE;case Gc.SYM_P:return Gc.P;case Gc.SYM_L:return Gc.L;case Gc.SYM_A:return Gc.A}throw new _u("Unknown dimension symbol: "+t)},Object.defineProperties(Gc,Bc);var kc=function(){};kc.prototype.filter=function(t){},kc.prototype.interfaces_=function(){return[]},kc.prototype.getClass=function(){return kc};var zc=function(){};zc.prototype.filter=function(t,e){},zc.prototype.isDone=function(){},zc.prototype.isGeometryChanged=function(){},zc.prototype.interfaces_=function(){return[]},zc.prototype.getClass=function(){return zc};var jc=function(t){function e(e,n){if(t.call(this,n),this._geometries=e||[],t.hasNullElements(this._geometries))throw new _u("geometries must not contain null elements")}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){for(var t=new Yu,e=0;e<this._geometries.length;e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());return t},e.prototype.getGeometryN=function(t){return this._geometries[t]},e.prototype.getSortIndex=function(){return t.SORTINDEX_GEOMETRYCOLLECTION},e.prototype.getCoordinates=function(){for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=0;n<this._geometries.length;n++)for(var r=this._geometries[n].getCoordinates(),i=0;i<r.length;i++)t[++e]=r[i];return t},e.prototype.getArea=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getArea();return t},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var r=e;if(this._geometries.length!==r._geometries.length)return!1;for(var i=0;i<this._geometries.length;i++)if(!this._geometries[i].equalsExact(r._geometries[i],n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){for(var t=0;t<this._geometries.length;t++)this._geometries[t].normalize();qc.sort(this._geometries)},e.prototype.getCoordinate=function(){return this.isEmpty()?null:this._geometries[0].getCoordinate()},e.prototype.getBoundaryDimension=function(){for(var t=Gc.FALSE,e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getBoundaryDimension());return t},e.prototype.getDimension=function(){for(var t=Gc.FALSE,e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getDimension());return t},e.prototype.getLength=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getLength();return t},e.prototype.getNumPoints=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getNumPoints();return t},e.prototype.getNumGeometries=function(){return this._geometries.length},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[n]=this._geometries[n].reverse();return this.getFactory().createGeometryCollection(e)},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0],e=new ki(qc.asList(this._geometries)),n=new ki(qc.asList(t._geometries));return this.compare(e,n)}if(2===arguments.length){for(var r=arguments[0],i=arguments[1],o=r,s=this.getNumGeometries(),a=o.getNumGeometries(),u=0;u<s&&u<a;){var c=this.getGeometryN(u),h=o.getGeometryN(u),l=c.compareToSameClass(h,i);if(0!==l)return l;u++}return u<s?1:u<a?-1:0}},e.prototype.apply=function(){if(Lu(arguments[0],pc))for(var t=arguments[0],e=0;e<this._geometries.length;e++)this._geometries[e].apply(t);else if(Lu(arguments[0],zc)){var n=arguments[0];if(0===this._geometries.length)return null;for(var r=0;r<this._geometries.length&&(this._geometries[r].apply(n),!n.isDone());r++);n.isGeometryChanged()&&this.geometryChanged()}else if(Lu(arguments[0],kc)){var i=arguments[0];i.filter(this);for(var o=0;o<this._geometries.length;o++)this._geometries[o].apply(i)}else if(Lu(arguments[0],uc)){var s=arguments[0];s.filter(this);for(var a=0;a<this._geometries.length;a++)this._geometries[a].apply(s)}},e.prototype.getBoundary=function(){return this.checkNotGeometryCollection(this),tc.shouldNeverReachHere(),null},e.prototype.clone=function(){var e=t.prototype.clone.call(this);e._geometries=new Array(this._geometries.length).fill(null);for(var n=0;n<this._geometries.length;n++)e._geometries[n]=this._geometries[n].clone();return e},e.prototype.getGeometryType=function(){return"GeometryCollection"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.isEmpty=function(){for(var t=0;t<this._geometries.length;t++)if(!this._geometries[t].isEmpty())return!1;return!0},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x4f07bcb1f857d800},Object.defineProperties(e,n),e}(cc),Xc=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return cc.SORTINDEX_MULTILINESTRING},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return this.isClosed()?Gc.FALSE:0},e.prototype.isClosed=function(){if(this.isEmpty())return!1;for(var t=0;t<this._geometries.length;t++)if(!this._geometries[t].isClosed())return!1;return!0},e.prototype.getDimension=function(){return 1},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[t-1-n]=this._geometries[n].reverse();return this.getFactory().createMultiLineString(e)},e.prototype.getBoundary=function(){return new Uc(this).getBoundary()},e.prototype.getGeometryType=function(){return"MultiLineString"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[Dc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x7155d2ab4afa8000},Object.defineProperties(e,n),e}(jc),Uc=function(){if(this._geom=null,this._geomFact=null,this._bnRule=null,this._endpointMap=null,1===arguments.length){var t=arguments[0],e=fc.MOD2_BOUNDARY_RULE;this._geom=t,this._geomFact=t.getFactory(),this._bnRule=e}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this._geom=n,this._geomFact=n.getFactory(),this._bnRule=r}};Uc.prototype.boundaryMultiLineString=function(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();var e=this.computeBoundaryCoordinates(t);return 1===e.length?this._geomFact.createPoint(e[0]):this._geomFact.createMultiPointFromCoords(e)},Uc.prototype.getBoundary=function(){return this._geom instanceof Jc?this.boundaryLineString(this._geom):this._geom instanceof Xc?this.boundaryMultiLineString(this._geom):this._geom.getBoundary()},Uc.prototype.boundaryLineString=function(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();if(t.isClosed()){return this._bnRule.isInBoundary(2)?t.getStartPoint():this._geomFact.createMultiPoint()}return this._geomFact.createMultiPoint([t.getStartPoint(),t.getEndPoint()])},Uc.prototype.getEmptyMultiPoint=function(){return this._geomFact.createMultiPoint()},Uc.prototype.computeBoundaryCoordinates=function(t){var e=new bc;this._endpointMap=new Gi;for(var n=0;n<t.getNumGeometries();n++){var r=t.getGeometryN(n);0!==r.getNumPoints()&&(this.addEndpoint(r.getCoordinateN(0)),this.addEndpoint(r.getCoordinateN(r.getNumPoints()-1)))}for(var i=this._endpointMap.entrySet().iterator();i.hasNext();){var o=i.next(),s=o.getValue().count;this._bnRule.isInBoundary(s)&&e.add(o.getKey())}return Cc.toCoordinateArray(e)},Uc.prototype.addEndpoint=function(t){var e=this._endpointMap.get(t);null===e&&(e=new Yc,this._endpointMap.put(t,e)),e.count++},Uc.prototype.interfaces_=function(){return[]},Uc.prototype.getClass=function(){return Uc},Uc.getBoundary=function(){if(1===arguments.length){var t=arguments[0];return new Uc(t).getBoundary()}if(2===arguments.length){var e=arguments[0],n=arguments[1];return new Uc(e,n).getBoundary()}};var Yc=function(){this.count=null};Yc.prototype.interfaces_=function(){return[]},Yc.prototype.getClass=function(){return Yc};var Vc=function(){},Hc={NEWLINE:{configurable:!0},SIMPLE_ORDINATE_FORMAT:{configurable:!0}};Vc.prototype.interfaces_=function(){return[]},Vc.prototype.getClass=function(){return Vc},Vc.chars=function(t,e){for(var n=new Array(e).fill(null),r=0;r<e;r++)n[r]=t;return String(n)},Vc.getStackTrace=function(){if(1===arguments.length){var t=arguments[0],e=new function(){},n=new function(){}(e);return t.printStackTrace(n),e.toString()}if(2===arguments.length){for(var r=arguments[0],i=arguments[1],o="",s=new function(){}(new function(){}(Vc.getStackTrace(r))),a=0;a<i;a++)try{o+=s.readLine()+Vc.NEWLINE}catch(t){if(!(t instanceof zi))throw t;tc.shouldNeverReachHere()}return o}},Vc.split=function(t,e){for(var n=e.length,r=new bc,i=""+t,o=i.indexOf(e);o>=0;){var s=i.substring(0,o);r.add(s),o=(i=i.substring(o+n)).indexOf(e)}i.length>0&&r.add(i);for(var a=new Array(r.size()).fill(null),u=0;u<a.length;u++)a[u]=r.get(u);return a},Vc.toString=function(){if(1===arguments.length){var t=arguments[0];return Vc.SIMPLE_ORDINATE_FORMAT.format(t)}},Vc.spaces=function(t){return Vc.chars(" ",t)},Hc.NEWLINE.get=function(){return Xu.getProperty("line.separator")},Hc.SIMPLE_ORDINATE_FORMAT.get=function(){return new function(){}("0.#")},Object.defineProperties(Vc,Hc);var Wc=function(){};Wc.prototype.interfaces_=function(){return[]},Wc.prototype.getClass=function(){return Wc},Wc.copyCoord=function(t,e,n,r){for(var i=Math.min(t.getDimension(),n.getDimension()),o=0;o<i;o++)n.setOrdinate(r,o,t.getOrdinate(e,o))},Wc.isRing=function(t){var e=t.size();return 0===e||!(e<=3)&&(t.getOrdinate(0,Bu.X)===t.getOrdinate(e-1,Bu.X)&&t.getOrdinate(0,Bu.Y)===t.getOrdinate(e-1,Bu.Y))},Wc.isEqual=function(t,e){var n=t.size();if(n!==e.size())return!1;for(var r=Math.min(t.getDimension(),e.getDimension()),i=0;i<n;i++)for(var o=0;o<r;o++){var s=t.getOrdinate(i,o),a=e.getOrdinate(i,o);if(t.getOrdinate(i,o)!==e.getOrdinate(i,o)&&(!mu.isNaN(s)||!mu.isNaN(a)))return!1}return!0},Wc.extend=function(t,e,n){var r=t.create(n,e.getDimension()),i=e.size();if(Wc.copy(e,0,r,0,i),i>0)for(var o=i;o<n;o++)Wc.copy(e,i-1,r,o,1);return r},Wc.reverse=function(t){for(var e=t.size()-1,n=Math.trunc(e/2),r=0;r<=n;r++)Wc.swap(t,r,e-r)},Wc.swap=function(t,e,n){if(e===n)return null;for(var r=0;r<t.getDimension();r++){var i=t.getOrdinate(e,r);t.setOrdinate(e,r,t.getOrdinate(n,r)),t.setOrdinate(n,r,i)}},Wc.copy=function(t,e,n,r,i){for(var o=0;o<i;o++)Wc.copyCoord(t,e+o,n,r+o)},Wc.toString=function(){if(1===arguments.length){var t=arguments[0],e=t.size();if(0===e)return"()";var n=t.getDimension(),r=new Ru;r.append("(");for(var i=0;i<e;i++){i>0&&r.append(" ");for(var o=0;o<n;o++)o>0&&r.append(","),r.append(Vc.toString(t.getOrdinate(i,o)))}return r.append(")"),r.toString()}},Wc.ensureValidRing=function(t,e){var n=e.size();if(0===n)return e;if(n<=3)return Wc.createClosedRing(t,e,4);return e.getOrdinate(0,Bu.X)===e.getOrdinate(n-1,Bu.X)&&e.getOrdinate(0,Bu.Y)===e.getOrdinate(n-1,Bu.Y)?e:Wc.createClosedRing(t,e,n+1)},Wc.createClosedRing=function(t,e,n){var r=t.create(n,e.getDimension()),i=e.size();Wc.copy(e,0,r,0,i);for(var o=i;o<n;o++)Wc.copy(e,0,r,o,1);return r};var Jc=function(t){function e(e,n){t.call(this,n),this._points=null,this.init(e)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){return this.isEmpty()?new Yu:this._points.expandEnvelope(new Yu)},e.prototype.isRing=function(){return this.isClosed()&&this.isSimple()},e.prototype.getSortIndex=function(){return t.SORTINDEX_LINESTRING},e.prototype.getCoordinates=function(){return this._points.toCoordinateArray()},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var r=e;if(this._points.size()!==r._points.size())return!1;for(var i=0;i<this._points.size();i++)if(!this.equal(this._points.getCoordinate(i),r._points.getCoordinate(i),n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){for(var t=0;t<Math.trunc(this._points.size()/2);t++){var e=this._points.size()-1-t;if(!this._points.getCoordinate(t).equals(this._points.getCoordinate(e)))return this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e))>0&&Wc.reverse(this._points),null}},e.prototype.getCoordinate=function(){return this.isEmpty()?null:this._points.getCoordinate(0)},e.prototype.getBoundaryDimension=function(){return this.isClosed()?Gc.FALSE:0},e.prototype.isClosed=function(){return!this.isEmpty()&&this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints()-1))},e.prototype.getEndPoint=function(){return this.isEmpty()?null:this.getPointN(this.getNumPoints()-1)},e.prototype.getDimension=function(){return 1},e.prototype.getLength=function(){return sc.computeLength(this._points)},e.prototype.getNumPoints=function(){return this._points.size()},e.prototype.reverse=function(){var t=this._points.copy();Wc.reverse(t);return this.getFactory().createLineString(t)},e.prototype.compareToSameClass=function(){if(1===arguments.length){for(var t=arguments[0],e=0,n=0;e<this._points.size()&&n<t._points.size();){var r=this._points.getCoordinate(e).compareTo(t._points.getCoordinate(n));if(0!==r)return r;e++,n++}return e<this._points.size()?1:n<t._points.size()?-1:0}if(2===arguments.length){var i=arguments[0];return arguments[1].compare(this._points,i._points)}},e.prototype.apply=function(){if(Lu(arguments[0],pc))for(var t=arguments[0],e=0;e<this._points.size();e++)t.filter(this._points.getCoordinate(e));else if(Lu(arguments[0],zc)){var n=arguments[0];if(0===this._points.size())return null;for(var r=0;r<this._points.size()&&(n.filter(this._points,r),!n.isDone());r++);n.isGeometryChanged()&&this.geometryChanged()}else if(Lu(arguments[0],kc)){arguments[0].filter(this)}else if(Lu(arguments[0],uc)){arguments[0].filter(this)}},e.prototype.getBoundary=function(){return new Uc(this).getBoundary()},e.prototype.isEquivalentClass=function(t){return t instanceof e},e.prototype.clone=function(){var e=t.prototype.clone.call(this);return e._points=this._points.clone(),e},e.prototype.getCoordinateN=function(t){return this._points.getCoordinate(t)},e.prototype.getGeometryType=function(){return"LineString"},e.prototype.copy=function(){return new e(this._points.copy(),this._factory)},e.prototype.getCoordinateSequence=function(){return this._points},e.prototype.isEmpty=function(){return 0===this._points.size()},e.prototype.init=function(t){if(null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),1===t.size())throw new _u("Invalid number of points in LineString (found "+t.size()+" - must be 0 or >= 2)");this._points=t},e.prototype.isCoordinate=function(t){for(var e=0;e<this._points.size();e++)if(this._points.getCoordinate(e).equals(t))return!0;return!1},e.prototype.getStartPoint=function(){return this.isEmpty()?null:this.getPointN(0)},e.prototype.getPointN=function(t){return this.getFactory().createPoint(this._points.getCoordinate(t))},e.prototype.interfaces_=function(){return[Dc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x2b2b51ba435c8e00},Object.defineProperties(e,n),e}(cc),Zc=function(){};Zc.prototype.interfaces_=function(){return[]},Zc.prototype.getClass=function(){return Zc};var Kc=function(t){function e(e,n){t.call(this,n),this._coordinates=e||null,this.init(this._coordinates)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){if(this.isEmpty())return new Yu;var t=new Yu;return t.expandToInclude(this._coordinates.getX(0),this._coordinates.getY(0)),t},e.prototype.getSortIndex=function(){return t.SORTINDEX_POINT},e.prototype.getCoordinates=function(){return this.isEmpty()?[]:[this.getCoordinate()]},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&(!(!this.isEmpty()||!e.isEmpty())||this.isEmpty()===e.isEmpty()&&this.equal(e.getCoordinate(),this.getCoordinate(),n))}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){},e.prototype.getCoordinate=function(){return 0!==this._coordinates.size()?this._coordinates.getCoordinate(0):null},e.prototype.getBoundaryDimension=function(){return Gc.FALSE},e.prototype.getDimension=function(){return 0},e.prototype.getNumPoints=function(){return this.isEmpty()?0:1},e.prototype.reverse=function(){return this.copy()},e.prototype.getX=function(){if(null===this.getCoordinate())throw new Error("getX called on empty Point");return this.getCoordinate().x},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0];return this.getCoordinate().compareTo(t.getCoordinate())}if(2===arguments.length){var e=arguments[0];return arguments[1].compare(this._coordinates,e._coordinates)}},e.prototype.apply=function(){if(Lu(arguments[0],pc)){var t=arguments[0];if(this.isEmpty())return null;t.filter(this.getCoordinate())}else if(Lu(arguments[0],zc)){var e=arguments[0];if(this.isEmpty())return null;e.filter(this._coordinates,0),e.isGeometryChanged()&&this.geometryChanged()}else if(Lu(arguments[0],kc)){arguments[0].filter(this)}else if(Lu(arguments[0],uc)){arguments[0].filter(this)}},e.prototype.getBoundary=function(){return this.getFactory().createGeometryCollection(null)},e.prototype.clone=function(){var e=t.prototype.clone.call(this);return e._coordinates=this._coordinates.clone(),e},e.prototype.getGeometryType=function(){return"Point"},e.prototype.copy=function(){return new e(this._coordinates.copy(),this._factory)},e.prototype.getCoordinateSequence=function(){return this._coordinates},e.prototype.getY=function(){if(null===this.getCoordinate())throw new Error("getY called on empty Point");return this.getCoordinate().y},e.prototype.isEmpty=function(){return 0===this._coordinates.size()},e.prototype.init=function(t){null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),tc.isTrue(t.size()<=1),this._coordinates=t},e.prototype.isSimple=function(){return!0},e.prototype.interfaces_=function(){return[Zc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x44077bad161cbc00},Object.defineProperties(e,n),e}(cc),Qc=function(){};Qc.prototype.interfaces_=function(){return[]},Qc.prototype.getClass=function(){return Qc};var $c=function(t){function e(e,n,r){if(t.call(this,r),this._shell=null,this._holes=null,null===e&&(e=this.getFactory().createLinearRing()),null===n&&(n=[]),t.hasNullElements(n))throw new _u("holes must not contain null elements");if(e.isEmpty()&&t.hasNonEmptyElements(n))throw new _u("shell is empty but holes are not");this._shell=e,this._holes=n}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){return this._shell.getEnvelopeInternal()},e.prototype.getSortIndex=function(){return t.SORTINDEX_POLYGON},e.prototype.getCoordinates=function(){if(this.isEmpty())return[];for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=this._shell.getCoordinates(),r=0;r<n.length;r++)t[++e]=n[r];for(var i=0;i<this._holes.length;i++)for(var o=this._holes[i].getCoordinates(),s=0;s<o.length;s++)t[++e]=o[s];return t},e.prototype.getArea=function(){var t=0;t+=Math.abs(sc.signedArea(this._shell.getCoordinateSequence()));for(var e=0;e<this._holes.length;e++)t-=Math.abs(sc.signedArea(this._holes[e].getCoordinateSequence()));return t},e.prototype.isRectangle=function(){if(0!==this.getNumInteriorRing())return!1;if(null===this._shell)return!1;if(5!==this._shell.getNumPoints())return!1;for(var t=this._shell.getCoordinateSequence(),e=this.getEnvelopeInternal(),n=0;n<5;n++){var r=t.getX(n);if(r!==e.getMinX()&&r!==e.getMaxX())return!1;var i=t.getY(n);if(i!==e.getMinY()&&i!==e.getMaxY())return!1}for(var o=t.getX(0),s=t.getY(0),a=1;a<=4;a++){var u=t.getX(a),c=t.getY(a);if(u!==o===(c!==s))return!1;o=u,s=c}return!0},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var r=e,i=this._shell,o=r._shell;if(!i.equalsExact(o,n))return!1;if(this._holes.length!==r._holes.length)return!1;for(var s=0;s<this._holes.length;s++)if(!this._holes[s].equalsExact(r._holes[s],n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){if(0===arguments.length){this.normalize(this._shell,!0);for(var t=0;t<this._holes.length;t++)this.normalize(this._holes[t],!1);qc.sort(this._holes)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(e.isEmpty())return null;var r=new Array(e.getCoordinates().length-1).fill(null);Xu.arraycopy(e.getCoordinates(),0,r,0,r.length);var i=Cc.minCoordinate(e.getCoordinates());Cc.scroll(r,i),Xu.arraycopy(r,0,e.getCoordinates(),0,r.length),e.getCoordinates()[r.length]=r[0],sc.isCCW(e.getCoordinates())===n&&Cc.reverse(e.getCoordinates())}},e.prototype.getCoordinate=function(){return this._shell.getCoordinate()},e.prototype.getNumInteriorRing=function(){return this._holes.length},e.prototype.getBoundaryDimension=function(){return 1},e.prototype.getDimension=function(){return 2},e.prototype.getLength=function(){var t=0;t+=this._shell.getLength();for(var e=0;e<this._holes.length;e++)t+=this._holes[e].getLength();return t},e.prototype.getNumPoints=function(){for(var t=this._shell.getNumPoints(),e=0;e<this._holes.length;e++)t+=this._holes[e].getNumPoints();return t},e.prototype.reverse=function(){var t=this.copy();t._shell=this._shell.copy().reverse(),t._holes=new Array(this._holes.length).fill(null);for(var e=0;e<this._holes.length;e++)t._holes[e]=this._holes[e].copy().reverse();return t},e.prototype.convexHull=function(){return this.getExteriorRing().convexHull()},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0],e=this._shell,n=t._shell;return e.compareToSameClass(n)}if(2===arguments.length){var r=arguments[0],i=arguments[1],o=r,s=this._shell,a=o._shell,u=s.compareToSameClass(a,i);if(0!==u)return u;for(var c=this.getNumInteriorRing(),h=o.getNumInteriorRing(),l=0;l<c&&l<h;){var p=this.getInteriorRingN(l),f=o.getInteriorRingN(l),g=p.compareToSameClass(f,i);if(0!==g)return g;l++}return l<c?1:l<h?-1:0}},e.prototype.apply=function(t){if(Lu(t,pc)){this._shell.apply(t);for(var e=0;e<this._holes.length;e++)this._holes[e].apply(t)}else if(Lu(t,zc)){if(this._shell.apply(t),!t.isDone())for(var n=0;n<this._holes.length&&(this._holes[n].apply(t),!t.isDone());n++);t.isGeometryChanged()&&this.geometryChanged()}else if(Lu(t,kc))t.filter(this);else if(Lu(t,uc)){t.filter(this),this._shell.apply(t);for(var r=0;r<this._holes.length;r++)this._holes[r].apply(t)}},e.prototype.getBoundary=function(){if(this.isEmpty())return this.getFactory().createMultiLineString();var t=new Array(this._holes.length+1).fill(null);t[0]=this._shell;for(var e=0;e<this._holes.length;e++)t[e+1]=this._holes[e];return t.length<=1?this.getFactory().createLinearRing(t[0].getCoordinateSequence()):this.getFactory().createMultiLineString(t)},e.prototype.clone=function(){var e=t.prototype.clone.call(this);e._shell=this._shell.clone(),e._holes=new Array(this._holes.length).fill(null);for(var n=0;n<this._holes.length;n++)e._holes[n]=this._holes[n].clone();return e},e.prototype.getGeometryType=function(){return"Polygon"},e.prototype.copy=function(){for(var t=this._shell.copy(),n=new Array(this._holes.length).fill(null),r=0;r<n.length;r++)n[r]=this._holes[r].copy();return new e(t,n,this._factory)},e.prototype.getExteriorRing=function(){return this._shell},e.prototype.isEmpty=function(){return this._shell.isEmpty()},e.prototype.getInteriorRingN=function(t){return this._holes[t]},e.prototype.interfaces_=function(){return[Qc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x307ffefd8dc97200},Object.defineProperties(e,n),e}(cc),th=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return cc.SORTINDEX_MULTIPOINT},e.prototype.isValid=function(){return!0},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getCoordinate=function(){if(1===arguments.length){var e=arguments[0];return this._geometries[e].getCoordinate()}return t.prototype.getCoordinate.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return Gc.FALSE},e.prototype.getDimension=function(){return 0},e.prototype.getBoundary=function(){return this.getFactory().createGeometryCollection(null)},e.prototype.getGeometryType=function(){return"MultiPoint"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[Zc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x6fb1ed4162e0fc00},Object.defineProperties(e,n),e}(jc),eh=function(t){function e(e,n){e instanceof bu&&n instanceof _h&&(e=n.getCoordinateSequenceFactory().create(e)),t.call(this,e,n),this.validateConstruction()}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={MINIMUM_VALID_SIZE:{configurable:!0},serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return cc.SORTINDEX_LINEARRING},e.prototype.getBoundaryDimension=function(){return Gc.FALSE},e.prototype.isClosed=function(){return!!this.isEmpty()||t.prototype.isClosed.call(this)},e.prototype.reverse=function(){var t=this._points.copy();Wc.reverse(t);return this.getFactory().createLinearRing(t)},e.prototype.validateConstruction=function(){if(!this.isEmpty()&&!t.prototype.isClosed.call(this))throw new _u("Points of LinearRing do not form a closed linestring");if(this.getCoordinateSequence().size()>=1&&this.getCoordinateSequence().size()<e.MINIMUM_VALID_SIZE)throw new _u("Invalid number of points in LinearRing (found "+this.getCoordinateSequence().size()+" - must be 0 or >= 4)")},e.prototype.getGeometryType=function(){return"LinearRing"},e.prototype.copy=function(){return new e(this._points.copy(),this._factory)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.MINIMUM_VALID_SIZE.get=function(){return 4},n.serialVersionUID.get=function(){return-0x3b229e262367a600},Object.defineProperties(e,n),e}(Jc),nh=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return cc.SORTINDEX_MULTIPOLYGON},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return 1},e.prototype.getDimension=function(){return 2},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[n]=this._geometries[n].reverse();return this.getFactory().createMultiPolygon(e)},e.prototype.getBoundary=function(){if(this.isEmpty())return this.getFactory().createMultiLineString();for(var t=new bc,e=0;e<this._geometries.length;e++)for(var n=this._geometries[e].getBoundary(),r=0;r<n.getNumGeometries();r++)t.add(n.getGeometryN(r));var i=new Array(t.size()).fill(null);return this.getFactory().createMultiLineString(t.toArray(i))},e.prototype.getGeometryType=function(){return"MultiPolygon"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[Qc]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x7a5aa1369171980},Object.defineProperties(e,n),e}(jc),rh=function(t){this._factory=t||null,this._isUserDataCopied=!1},ih={NoOpGeometryOperation:{configurable:!0},CoordinateOperation:{configurable:!0},CoordinateSequenceOperation:{configurable:!0}};rh.prototype.setCopyUserData=function(t){this._isUserDataCopied=t},rh.prototype.edit=function(t,e){if(null===t)return null;var n=this.editInternal(t,e);return this._isUserDataCopied&&n.setUserData(t.getUserData()),n},rh.prototype.editInternal=function(t,e){return null===this._factory&&(this._factory=t.getFactory()),t instanceof jc?this.editGeometryCollection(t,e):t instanceof $c?this.editPolygon(t,e):t instanceof Kc?e.edit(t,this._factory):t instanceof Jc?e.edit(t,this._factory):(tc.shouldNeverReachHere("Unsupported Geometry class: "+t.getClass().getName()),null)},rh.prototype.editGeometryCollection=function(t,e){for(var n=e.edit(t,this._factory),r=new bc,i=0;i<n.getNumGeometries();i++){var o=this.edit(n.getGeometryN(i),e);null===o||o.isEmpty()||r.add(o)}return n.getClass()===th?this._factory.createMultiPoint(r.toArray([])):n.getClass()===Xc?this._factory.createMultiLineString(r.toArray([])):n.getClass()===nh?this._factory.createMultiPolygon(r.toArray([])):this._factory.createGeometryCollection(r.toArray([]))},rh.prototype.editPolygon=function(t,e){var n=e.edit(t,this._factory);if(null===n&&(n=this._factory.createPolygon(null)),n.isEmpty())return n;var r=this.edit(n.getExteriorRing(),e);if(null===r||r.isEmpty())return this._factory.createPolygon();for(var i=new bc,o=0;o<n.getNumInteriorRing();o++){var s=this.edit(n.getInteriorRingN(o),e);null===s||s.isEmpty()||i.add(s)}return this._factory.createPolygon(r,i.toArray([]))},rh.prototype.interfaces_=function(){return[]},rh.prototype.getClass=function(){return rh},rh.GeometryEditorOperation=function(){},ih.NoOpGeometryOperation.get=function(){return oh},ih.CoordinateOperation.get=function(){return sh},ih.CoordinateSequenceOperation.get=function(){return ah},Object.defineProperties(rh,ih);var oh=function(){};oh.prototype.edit=function(t,e){return t},oh.prototype.interfaces_=function(){return[rh.GeometryEditorOperation]},oh.prototype.getClass=function(){return oh};var sh=function(){};sh.prototype.edit=function(t,e){var n=this.editCoordinates(t.getCoordinates(),t);return null===n?t:t instanceof eh?e.createLinearRing(n):t instanceof Jc?e.createLineString(n):t instanceof Kc?n.length>0?e.createPoint(n[0]):e.createPoint():t},sh.prototype.interfaces_=function(){return[rh.GeometryEditorOperation]},sh.prototype.getClass=function(){return sh};var ah=function(){};ah.prototype.edit=function(t,e){return t instanceof eh?e.createLinearRing(this.edit(t.getCoordinateSequence(),t)):t instanceof Jc?e.createLineString(this.edit(t.getCoordinateSequence(),t)):t instanceof Kc?e.createPoint(this.edit(t.getCoordinateSequence(),t)):t},ah.prototype.interfaces_=function(){return[rh.GeometryEditorOperation]},ah.prototype.getClass=function(){return ah};var uh=function(){if(this._dimension=3,this._coordinates=null,1===arguments.length){if(arguments[0]instanceof Array)this._coordinates=arguments[0],this._dimension=3;else if(Number.isInteger(arguments[0])){var t=arguments[0];this._coordinates=new Array(t).fill(null);for(var e=0;e<t;e++)this._coordinates[e]=new bu}else if(Lu(arguments[0],Bu)){var n=arguments[0];if(null===n)return this._coordinates=new Array(0).fill(null),null;this._dimension=n.getDimension(),this._coordinates=new Array(n.size()).fill(null);for(var r=0;r<this._coordinates.length;r++)this._coordinates[r]=n.getCoordinateCopy(r)}}else if(2===arguments.length)if(arguments[0]instanceof Array&&Number.isInteger(arguments[1])){var i=arguments[0],o=arguments[1];this._coordinates=i,this._dimension=o,null===i&&(this._coordinates=new Array(0).fill(null))}else if(Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var s=arguments[0],a=arguments[1];this._coordinates=new Array(s).fill(null),this._dimension=a;for(var u=0;u<s;u++)this._coordinates[u]=new bu}},ch={serialVersionUID:{configurable:!0}};uh.prototype.setOrdinate=function(t,e,n){switch(e){case Bu.X:this._coordinates[t].x=n;break;case Bu.Y:this._coordinates[t].y=n;break;case Bu.Z:this._coordinates[t].z=n;break;default:throw new _u("invalid ordinateIndex")}},uh.prototype.size=function(){return this._coordinates.length},uh.prototype.getOrdinate=function(t,e){switch(e){case Bu.X:return this._coordinates[t].x;case Bu.Y:return this._coordinates[t].y;case Bu.Z:return this._coordinates[t].z}return mu.NaN},uh.prototype.getCoordinate=function(){if(1===arguments.length){var t=arguments[0];return this._coordinates[t]}if(2===arguments.length){var e=arguments[0],n=arguments[1];n.x=this._coordinates[e].x,n.y=this._coordinates[e].y,n.z=this._coordinates[e].z}},uh.prototype.getCoordinateCopy=function(t){return new bu(this._coordinates[t])},uh.prototype.getDimension=function(){return this._dimension},uh.prototype.getX=function(t){return this._coordinates[t].x},uh.prototype.clone=function(){for(var t=new Array(this.size()).fill(null),e=0;e<this._coordinates.length;e++)t[e]=this._coordinates[e].clone();return new uh(t,this._dimension)},uh.prototype.expandEnvelope=function(t){for(var e=0;e<this._coordinates.length;e++)t.expandToInclude(this._coordinates[e]);return t},uh.prototype.copy=function(){for(var t=new Array(this.size()).fill(null),e=0;e<this._coordinates.length;e++)t[e]=this._coordinates[e].copy();return new uh(t,this._dimension)},uh.prototype.toString=function(){if(this._coordinates.length>0){var t=new Ru(17*this._coordinates.length);t.append("("),t.append(this._coordinates[0]);for(var e=1;e<this._coordinates.length;e++)t.append(", "),t.append(this._coordinates[e]);return t.append(")"),t.toString()}return"()"},uh.prototype.getY=function(t){return this._coordinates[t].y},uh.prototype.toCoordinateArray=function(){return this._coordinates},uh.prototype.interfaces_=function(){return[Bu,Li]},uh.prototype.getClass=function(){return uh},ch.serialVersionUID.get=function(){return-0xcb44a778db18e00},Object.defineProperties(uh,ch);var hh=function(){},lh={serialVersionUID:{configurable:!0},instanceObject:{configurable:!0}};hh.prototype.readResolve=function(){return hh.instance()},hh.prototype.create=function(){if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new uh(t)}if(Lu(arguments[0],Bu)){var e=arguments[0];return new uh(e)}}else if(2===arguments.length){var n=arguments[0],r=arguments[1];return r>3&&(r=3),r<2?new uh(n):new uh(n,r)}},hh.prototype.interfaces_=function(){return[Cu,Li]},hh.prototype.getClass=function(){return hh},hh.instance=function(){return hh.instanceObject},lh.serialVersionUID.get=function(){return-0x38e49fa6cf6f2e00},lh.instanceObject.get=function(){return new hh},Object.defineProperties(hh,lh);var ph=function(t){function e(){t.call(this),this.map_=new Map}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return this.map_.get(t)||null},e.prototype.put=function(t,e){return this.map_.set(t,e),e},e.prototype.values=function(){for(var t=new bc,e=this.map_.values(),n=e.next();!n.done;)t.add(n.value),n=e.next();return t},e.prototype.entrySet=function(){var t=new Rc;return this.map_.entries().forEach(function(e){return t.add(e)}),t},e.prototype.size=function(){return this.map_.size()},e}(Pc),fh=function t(){if(this._modelType=null,this._scale=null,0===arguments.length)this._modelType=t.FLOATING;else if(1===arguments.length)if(arguments[0]instanceof dh){var e=arguments[0];this._modelType=e,e===t.FIXED&&this.setScale(1)}else if("number"==typeof arguments[0]){var n=arguments[0];this._modelType=t.FIXED,this.setScale(n)}else if(arguments[0]instanceof t){var r=arguments[0];this._modelType=r._modelType,this._scale=r._scale}},gh={serialVersionUID:{configurable:!0},maximumPreciseValue:{configurable:!0}};fh.prototype.equals=function(t){if(!(t instanceof fh))return!1;var e=t;return this._modelType===e._modelType&&this._scale===e._scale},fh.prototype.compareTo=function(t){var e=t,n=this.getMaximumSignificantDigits(),r=e.getMaximumSignificantDigits();return new Tu(n).compareTo(new Tu(r))},fh.prototype.getScale=function(){return this._scale},fh.prototype.isFloating=function(){return this._modelType===fh.FLOATING||this._modelType===fh.FLOATING_SINGLE},fh.prototype.getType=function(){return this._modelType},fh.prototype.toString=function(){var t="UNKNOWN";return this._modelType===fh.FLOATING?t="Floating":this._modelType===fh.FLOATING_SINGLE?t="Floating-Single":this._modelType===fh.FIXED&&(t="Fixed (Scale="+this.getScale()+")"),t},fh.prototype.makePrecise=function(){if("number"==typeof arguments[0]){var t=arguments[0];if(mu.isNaN(t))return t;if(this._modelType===fh.FLOATING_SINGLE){return t}return this._modelType===fh.FIXED?Math.round(t*this._scale)/this._scale:t}if(arguments[0]instanceof bu){var e=arguments[0];if(this._modelType===fh.FLOATING)return null;e.x=this.makePrecise(e.x),e.y=this.makePrecise(e.y)}},fh.prototype.getMaximumSignificantDigits=function(){var t=16;return this._modelType===fh.FLOATING?t=16:this._modelType===fh.FLOATING_SINGLE?t=6:this._modelType===fh.FIXED&&(t=1+Math.trunc(Math.ceil(Math.log(this.getScale())/Math.log(10)))),t},fh.prototype.setScale=function(t){this._scale=Math.abs(t)},fh.prototype.interfaces_=function(){return[Li,xu]},fh.prototype.getClass=function(){return fh},fh.mostPrecise=function(t,e){return t.compareTo(e)>=0?t:e},gh.serialVersionUID.get=function(){return 0x6bee6404e9a25c00},gh.maximumPreciseValue.get=function(){return 9007199254740992},Object.defineProperties(fh,gh);var dh=function t(e){this._name=e||null,t.nameToTypeMap.put(e,this)},yh={serialVersionUID:{configurable:!0},nameToTypeMap:{configurable:!0}};dh.prototype.readResolve=function(){return dh.nameToTypeMap.get(this._name)},dh.prototype.toString=function(){return this._name},dh.prototype.interfaces_=function(){return[Li]},dh.prototype.getClass=function(){return dh},yh.serialVersionUID.get=function(){return-552860263173159e4},yh.nameToTypeMap.get=function(){return new ph},Object.defineProperties(dh,yh),fh.Type=dh,fh.FIXED=new dh("FIXED"),fh.FLOATING=new dh("FLOATING"),fh.FLOATING_SINGLE=new dh("FLOATING SINGLE");var _h=function t(){this._precisionModel=new fh,this._SRID=0,this._coordinateSequenceFactory=t.getDefaultCoordinateSequenceFactory(),0===arguments.length||(1===arguments.length?Lu(arguments[0],Cu)?this._coordinateSequenceFactory=arguments[0]:arguments[0]instanceof fh&&(this._precisionModel=arguments[0]):2===arguments.length?(this._precisionModel=arguments[0],this._SRID=arguments[1]):3===arguments.length&&(this._precisionModel=arguments[0],this._SRID=arguments[1],this._coordinateSequenceFactory=arguments[2]))},mh={serialVersionUID:{configurable:!0}};_h.prototype.toGeometry=function(t){return t.isNull()?this.createPoint(null):t.getMinX()===t.getMaxX()&&t.getMinY()===t.getMaxY()?this.createPoint(new bu(t.getMinX(),t.getMinY())):t.getMinX()===t.getMaxX()||t.getMinY()===t.getMaxY()?this.createLineString([new bu(t.getMinX(),t.getMinY()),new bu(t.getMaxX(),t.getMaxY())]):this.createPolygon(this.createLinearRing([new bu(t.getMinX(),t.getMinY()),new bu(t.getMinX(),t.getMaxY()),new bu(t.getMaxX(),t.getMaxY()),new bu(t.getMaxX(),t.getMinY()),new bu(t.getMinX(),t.getMinY())]),null)},_h.prototype.createLineString=function(t){return t?t instanceof Array?new Jc(this.getCoordinateSequenceFactory().create(t),this):Lu(t,Bu)?new Jc(t,this):void 0:new Jc(this.getCoordinateSequenceFactory().create([]),this)},_h.prototype.createMultiLineString=function(){if(0===arguments.length)return new Xc(null,this);if(1===arguments.length){var t=arguments[0];return new Xc(t,this)}},_h.prototype.buildGeometry=function(t){for(var e=null,n=!1,r=!1,i=t.iterator();i.hasNext();){var o=i.next(),s=o.getClass();null===e&&(e=s),s!==e&&(n=!0),o.isGeometryCollectionOrDerived()&&(r=!0)}if(null===e)return this.createGeometryCollection();if(n||r)return this.createGeometryCollection(_h.toGeometryArray(t));var a=t.iterator().next();if(t.size()>1){if(a instanceof $c)return this.createMultiPolygon(_h.toPolygonArray(t));if(a instanceof Jc)return this.createMultiLineString(_h.toLineStringArray(t));if(a instanceof Kc)return this.createMultiPoint(_h.toPointArray(t));tc.shouldNeverReachHere("Unhandled class: "+a.getClass().getName())}return a},_h.prototype.createMultiPointFromCoords=function(t){return this.createMultiPoint(null!==t?this.getCoordinateSequenceFactory().create(t):null)},_h.prototype.createPoint=function(){if(0===arguments.length)return this.createPoint(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof bu){var t=arguments[0];return this.createPoint(null!==t?this.getCoordinateSequenceFactory().create([t]):null)}if(Lu(arguments[0],Bu)){var e=arguments[0];return new Kc(e,this)}}},_h.prototype.getCoordinateSequenceFactory=function(){return this._coordinateSequenceFactory},_h.prototype.createPolygon=function(){if(0===arguments.length)return new $c(null,null,this);if(1===arguments.length){if(Lu(arguments[0],Bu)){var t=arguments[0];return this.createPolygon(this.createLinearRing(t))}if(arguments[0]instanceof Array){var e=arguments[0];return this.createPolygon(this.createLinearRing(e))}if(arguments[0]instanceof eh){var n=arguments[0];return this.createPolygon(n,null)}}else if(2===arguments.length){var r=arguments[0],i=arguments[1];return new $c(r,i,this)}},_h.prototype.getSRID=function(){return this._SRID},_h.prototype.createGeometryCollection=function(){if(0===arguments.length)return new jc(null,this);if(1===arguments.length){var t=arguments[0];return new jc(t,this)}},_h.prototype.createGeometry=function(t){return new rh(this).edit(t,{edit:function(){if(2===arguments.length){var t=arguments[0];return this._coordinateSequenceFactory.create(t)}}})},_h.prototype.getPrecisionModel=function(){return this._precisionModel},_h.prototype.createLinearRing=function(){if(0===arguments.length)return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return this.createLinearRing(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(Lu(arguments[0],Bu)){var e=arguments[0];return new eh(e,this)}}},_h.prototype.createMultiPolygon=function(){if(0===arguments.length)return new nh(null,this);if(1===arguments.length){var t=arguments[0];return new nh(t,this)}},_h.prototype.createMultiPoint=function(){if(0===arguments.length)return new th(null,this);if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new th(t,this)}if(arguments[0]instanceof Array){var e=arguments[0];return this.createMultiPoint(null!==e?this.getCoordinateSequenceFactory().create(e):null)}if(Lu(arguments[0],Bu)){var n=arguments[0];if(null===n)return this.createMultiPoint(new Array(0).fill(null));for(var r=new Array(n.size()).fill(null),i=0;i<n.size();i++){var o=this.getCoordinateSequenceFactory().create(1,n.getDimension());Wc.copy(n,i,o,0,1),r[i]=this.createPoint(o)}return this.createMultiPoint(r)}}},_h.prototype.interfaces_=function(){return[Li]},_h.prototype.getClass=function(){return _h},_h.toMultiPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toGeometryArray=function(t){if(null===t)return null;var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.getDefaultCoordinateSequenceFactory=function(){return hh.instance()},_h.toMultiLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toMultiPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toLinearRingArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.toPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_h.createPointFromInternalCoord=function(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)},mh.serialVersionUID.get=function(){return-0x5ea75f2051eeb400},Object.defineProperties(_h,mh);var vh=["Point","MultiPoint","LineString","MultiLineString","Polygon","MultiPolygon"],xh=function(t){this.geometryFactory=t||new _h};xh.prototype.read=function(t){var e,n=(e="string"==typeof t?JSON.parse(t):t).type;if(!Eh[n])throw new Error("Unknown GeoJSON type: "+e.type);return-1!==vh.indexOf(n)?Eh[n].apply(this,[e.coordinates]):"GeometryCollection"===n?Eh[n].apply(this,[e.geometries]):Eh[n].apply(this,[e])},xh.prototype.write=function(t){var e=t.getGeometryType();if(!wh[e])throw new Error("Geometry is not supported");return wh[e].apply(this,[t])};var Eh={Feature:function(t){var e={};for(var n in t)e[n]=t[n];if(t.geometry){var r=t.geometry.type;if(!Eh[r])throw new Error("Unknown GeoJSON type: "+t.type);e.geometry=this.read(t.geometry)}return t.bbox&&(e.bbox=Eh.bbox.apply(this,[t.bbox])),e},FeatureCollection:function(t){var e={};if(t.features){e.features=[];for(var n=0;n<t.features.length;++n)e.features.push(this.read(t.features[n]))}return t.bbox&&(e.bbox=this.parse.bbox.apply(this,[t.bbox])),e},coordinates:function(t){for(var e=[],n=0;n<t.length;++n){var r=t[n];e.push(new bu(r[0],r[1]))}return e},bbox:function(t){return this.geometryFactory.createLinearRing([new bu(t[0],t[1]),new bu(t[2],t[1]),new bu(t[2],t[3]),new bu(t[0],t[3]),new bu(t[0],t[1])])},Point:function(t){var e=new bu(t[0],t[1]);return this.geometryFactory.createPoint(e)},MultiPoint:function(t){for(var e=[],n=0;n<t.length;++n)e.push(Eh.Point.apply(this,[t[n]]));return this.geometryFactory.createMultiPoint(e)},LineString:function(t){var e=Eh.coordinates.apply(this,[t]);return this.geometryFactory.createLineString(e)},MultiLineString:function(t){for(var e=[],n=0;n<t.length;++n)e.push(Eh.LineString.apply(this,[t[n]]));return this.geometryFactory.createMultiLineString(e)},Polygon:function(t){for(var e=Eh.coordinates.apply(this,[t[0]]),n=this.geometryFactory.createLinearRing(e),r=[],i=1;i<t.length;++i){var o=t[i],s=Eh.coordinates.apply(this,[o]),a=this.geometryFactory.createLinearRing(s);r.push(a)}return this.geometryFactory.createPolygon(n,r)},MultiPolygon:function(t){for(var e=[],n=0;n<t.length;++n){var r=t[n];e.push(Eh.Polygon.apply(this,[r]))}return this.geometryFactory.createMultiPolygon(e)},GeometryCollection:function(t){for(var e=[],n=0;n<t.length;++n){var r=t[n];e.push(this.read(r))}return this.geometryFactory.createGeometryCollection(e)}},wh={coordinate:function(t){return[t.x,t.y]},Point:function(t){return{type:"Point",coordinates:wh.coordinate.apply(this,[t.getCoordinate()])}},MultiPoint:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var r=t._geometries[n],i=wh.Point.apply(this,[r]);e.push(i.coordinates)}return{type:"MultiPoint",coordinates:e}},LineString:function(t){for(var e=[],n=t.getCoordinates(),r=0;r<n.length;++r){var i=n[r];e.push(wh.coordinate.apply(this,[i]))}return{type:"LineString",coordinates:e}},MultiLineString:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var r=t._geometries[n],i=wh.LineString.apply(this,[r]);e.push(i.coordinates)}return{type:"MultiLineString",coordinates:e}},Polygon:function(t){var e=[],n=wh.LineString.apply(this,[t._shell]);e.push(n.coordinates);for(var r=0;r<t._holes.length;++r){var i=t._holes[r],o=wh.LineString.apply(this,[i]);e.push(o.coordinates)}return{type:"Polygon",coordinates:e}},MultiPolygon:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var r=t._geometries[n],i=wh.Polygon.apply(this,[r]);e.push(i.coordinates)}return{type:"MultiPolygon",coordinates:e}},GeometryCollection:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var r=t._geometries[n],i=r.getGeometryType();e.push(wh[i].apply(this,[r]))}return{type:"GeometryCollection",geometries:e}}},bh=function(t){this.geometryFactory=t||new _h,this.precisionModel=this.geometryFactory.getPrecisionModel(),this.parser=new xh(this.geometryFactory)};bh.prototype.read=function(t){var e=this.parser.read(t);return this.precisionModel.getType()===fh.FIXED&&this.reducePrecision(e),e},bh.prototype.reducePrecision=function(t){var e,n;if(t.coordinate)this.precisionModel.makePrecise(t.coordinate);else if(t.points)for(e=0,n=t.points.length;e<n;e++)this.precisionModel.makePrecise(t.points[e]);else if(t.geometries)for(e=0,n=t.geometries.length;e<n;e++)this.reducePrecision(t.geometries[e])};var Ih=function(){this.parser=new xh(this.geometryFactory)};Ih.prototype.write=function(t){return this.parser.write(t)};var Nh=function(){},Ch={ON:{configurable:!0},LEFT:{configurable:!0},RIGHT:{configurable:!0}};Nh.prototype.interfaces_=function(){return[]},Nh.prototype.getClass=function(){return Nh},Nh.opposite=function(t){return t===Nh.LEFT?Nh.RIGHT:t===Nh.RIGHT?Nh.LEFT:t},Ch.ON.get=function(){return 0},Ch.LEFT.get=function(){return 1},Ch.RIGHT.get=function(){return 2},Object.defineProperties(Nh,Ch),(ji.prototype=new Error).name="EmptyStackException",(Xi.prototype=new wc).add=function(t){return this.array_.push(t),!0},Xi.prototype.get=function(t){if(t<0||t>=this.size())throw new Error;return this.array_[t]},Xi.prototype.push=function(t){return this.array_.push(t),t},Xi.prototype.pop=function(t){if(0===this.array_.length)throw new ji;return this.array_.pop()},Xi.prototype.peek=function(){if(0===this.array_.length)throw new ji;return this.array_[this.array_.length-1]},Xi.prototype.empty=function(){return 0===this.array_.length},Xi.prototype.isEmpty=function(){return this.empty()},Xi.prototype.search=function(t){return this.array_.indexOf(t)},Xi.prototype.size=function(){return this.array_.length},Xi.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t};var Sh=function(){this._minIndex=-1,this._minCoord=null,this._minDe=null,this._orientedDe=null};Sh.prototype.getCoordinate=function(){return this._minCoord},Sh.prototype.getRightmostSide=function(t,e){var n=this.getRightmostSideOfSegment(t,e);return n<0&&(n=this.getRightmostSideOfSegment(t,e-1)),n<0&&(this._minCoord=null,this.checkForRightmostCoordinate(t)),n},Sh.prototype.findRightmostEdgeAtVertex=function(){var t=this._minDe.getEdge().getCoordinates();tc.isTrue(this._minIndex>0&&this._minIndex<t.length,"rightmost point expected to be interior vertex of edge");var e=t[this._minIndex-1],n=t[this._minIndex+1],r=sc.computeOrientation(this._minCoord,n,e),i=!1;e.y<this._minCoord.y&&n.y<this._minCoord.y&&r===sc.COUNTERCLOCKWISE?i=!0:e.y>this._minCoord.y&&n.y>this._minCoord.y&&r===sc.CLOCKWISE&&(i=!0),i&&(this._minIndex=this._minIndex-1)},Sh.prototype.getRightmostSideOfSegment=function(t,e){var n=t.getEdge().getCoordinates();if(e<0||e+1>=n.length)return-1;if(n[e].y===n[e+1].y)return-1;var r=Nh.LEFT;return n[e].y<n[e+1].y&&(r=Nh.RIGHT),r},Sh.prototype.getEdge=function(){return this._orientedDe},Sh.prototype.checkForRightmostCoordinate=function(t){for(var e=t.getEdge().getCoordinates(),n=0;n<e.length-1;n++)(null===this._minCoord||e[n].x>this._minCoord.x)&&(this._minDe=t,this._minIndex=n,this._minCoord=e[n])},Sh.prototype.findRightmostEdgeAtNode=function(){var t=this._minDe.getNode().getEdges();this._minDe=t.getRightmostEdge(),this._minDe.isForward()||(this._minDe=this._minDe.getSym(),this._minIndex=this._minDe.getEdge().getCoordinates().length-1)},Sh.prototype.findEdge=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();n.isForward()&&this.checkForRightmostCoordinate(n)}tc.isTrue(0!==this._minIndex||this._minCoord.equals(this._minDe.getCoordinate()),"inconsistency in rightmost processing"),0===this._minIndex?this.findRightmostEdgeAtNode():this.findRightmostEdgeAtVertex(),this._orientedDe=this._minDe;this.getRightmostSide(this._minDe,this._minIndex)===Nh.LEFT&&(this._orientedDe=this._minDe.getSym())},Sh.prototype.interfaces_=function(){return[]},Sh.prototype.getClass=function(){return Sh};var Mh=function(t){function e(n,r){t.call(this,e.msgWithCoord(n,r)),this.pt=r?new bu(r):null,this.name="TopologyException"}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCoordinate=function(){return this.pt},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.msgWithCoord=function(t,e){return e?t:t+" [ "+e+" ]"},e}(Qu),Lh=function(){this.array_=[]};Lh.prototype.addLast=function(t){this.array_.push(t)},Lh.prototype.removeFirst=function(){return this.array_.shift()},Lh.prototype.isEmpty=function(){return 0===this.array_.length};var Ph=function(){this._finder=null,this._dirEdgeList=new bc,this._nodes=new bc,this._rightMostCoord=null,this._env=null,this._finder=new Sh};Ph.prototype.clearVisitedEdges=function(){for(var t=this._dirEdgeList.iterator();t.hasNext();){t.next().setVisited(!1)}},Ph.prototype.getRightmostCoordinate=function(){return this._rightMostCoord},Ph.prototype.computeNodeDepth=function(t){for(var e=null,n=t.getEdges().iterator();n.hasNext();){var r=n.next();if(r.isVisited()||r.getSym().isVisited()){e=r;break}}if(null===e)throw new Mh("unable to find edge to compute depths at "+t.getCoordinate());t.getEdges().computeDepths(e);for(var i=t.getEdges().iterator();i.hasNext();){var o=i.next();o.setVisited(!0),this.copySymDepths(o)}},Ph.prototype.computeDepth=function(t){this.clearVisitedEdges();var e=this._finder.getEdge();e.setEdgeDepths(Nh.RIGHT,t),this.copySymDepths(e),this.computeDepths(e)},Ph.prototype.create=function(t){this.addReachable(t),this._finder.findEdge(this._dirEdgeList),this._rightMostCoord=this._finder.getCoordinate()},Ph.prototype.findResultEdges=function(){for(var t=this._dirEdgeList.iterator();t.hasNext();){var e=t.next();e.getDepth(Nh.RIGHT)>=1&&e.getDepth(Nh.LEFT)<=0&&!e.isInteriorAreaEdge()&&e.setInResult(!0)}},Ph.prototype.computeDepths=function(t){var e=new Rc,n=new Lh,r=t.getNode();for(n.addLast(r),e.add(r),t.setVisited(!0);!n.isEmpty();){var i=n.removeFirst();e.add(i),this.computeNodeDepth(i);for(var o=i.getEdges().iterator();o.hasNext();){var s=o.next().getSym();if(!s.isVisited()){var a=s.getNode();e.contains(a)||(n.addLast(a),e.add(a))}}}},Ph.prototype.compareTo=function(t){var e=t;return this._rightMostCoord.x<e._rightMostCoord.x?-1:this._rightMostCoord.x>e._rightMostCoord.x?1:0},Ph.prototype.getEnvelope=function(){if(null===this._env){for(var t=new Yu,e=this._dirEdgeList.iterator();e.hasNext();)for(var n=e.next().getEdge().getCoordinates(),r=0;r<n.length-1;r++)t.expandToInclude(n[r]);this._env=t}return this._env},Ph.prototype.addReachable=function(t){var e=new Xi;for(e.add(t);!e.empty();){var n=e.pop();this.add(n,e)}},Ph.prototype.copySymDepths=function(t){var e=t.getSym();e.setDepth(Nh.LEFT,t.getDepth(Nh.RIGHT)),e.setDepth(Nh.RIGHT,t.getDepth(Nh.LEFT))},Ph.prototype.add=function(t,e){t.setVisited(!0),this._nodes.add(t);for(var n=t.getEdges().iterator();n.hasNext();){var r=n.next();this._dirEdgeList.add(r);var i=r.getSym().getNode();i.isVisited()||e.push(i)}},Ph.prototype.getNodes=function(){return this._nodes},Ph.prototype.getDirectedEdges=function(){return this._dirEdgeList},Ph.prototype.interfaces_=function(){return[xu]},Ph.prototype.getClass=function(){return Ph};var Oh=function t(){if(this.location=null,1===arguments.length){if(arguments[0]instanceof Array){var e=arguments[0];this.init(e.length)}else if(Number.isInteger(arguments[0])){var n=arguments[0];this.init(1),this.location[Nh.ON]=n}else if(arguments[0]instanceof t){var r=arguments[0];if(this.init(r.location.length),null!==r)for(var i=0;i<this.location.length;i++)this.location[i]=r.location[i]}}else if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];this.init(3),this.location[Nh.ON]=o,this.location[Nh.LEFT]=s,this.location[Nh.RIGHT]=a}};Oh.prototype.setAllLocations=function(t){for(var e=0;e<this.location.length;e++)this.location[e]=t},Oh.prototype.isNull=function(){for(var t=0;t<this.location.length;t++)if(this.location[t]!==Su.NONE)return!1;return!0},Oh.prototype.setAllLocationsIfNull=function(t){for(var e=0;e<this.location.length;e++)this.location[e]===Su.NONE&&(this.location[e]=t)},Oh.prototype.isLine=function(){return 1===this.location.length},Oh.prototype.merge=function(t){if(t.location.length>this.location.length){var e=new Array(3).fill(null);e[Nh.ON]=this.location[Nh.ON],e[Nh.LEFT]=Su.NONE,e[Nh.RIGHT]=Su.NONE,this.location=e}for(var n=0;n<this.location.length;n++)this.location[n]===Su.NONE&&n<t.location.length&&(this.location[n]=t.location[n])},Oh.prototype.getLocations=function(){return this.location},Oh.prototype.flip=function(){if(this.location.length<=1)return null;var t=this.location[Nh.LEFT];this.location[Nh.LEFT]=this.location[Nh.RIGHT],this.location[Nh.RIGHT]=t},Oh.prototype.toString=function(){var t=new Ru;return this.location.length>1&&t.append(Su.toLocationSymbol(this.location[Nh.LEFT])),t.append(Su.toLocationSymbol(this.location[Nh.ON])),this.location.length>1&&t.append(Su.toLocationSymbol(this.location[Nh.RIGHT])),t.toString()},Oh.prototype.setLocations=function(t,e,n){this.location[Nh.ON]=t,this.location[Nh.LEFT]=e,this.location[Nh.RIGHT]=n},Oh.prototype.get=function(t){return t<this.location.length?this.location[t]:Su.NONE},Oh.prototype.isArea=function(){return this.location.length>1},Oh.prototype.isAnyNull=function(){for(var t=0;t<this.location.length;t++)if(this.location[t]===Su.NONE)return!0;return!1},Oh.prototype.setLocation=function(){if(1===arguments.length){var t=arguments[0];this.setLocation(Nh.ON,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.location[e]=n}},Oh.prototype.init=function(t){this.location=new Array(t).fill(null),this.setAllLocations(Su.NONE)},Oh.prototype.isEqualOnSide=function(t,e){return this.location[e]===t.location[e]},Oh.prototype.allPositionsEqual=function(t){for(var e=0;e<this.location.length;e++)if(this.location[e]!==t)return!1;return!0},Oh.prototype.interfaces_=function(){return[]},Oh.prototype.getClass=function(){return Oh};var Rh=function t(){if(this.elt=new Array(2).fill(null),1===arguments.length){if(Number.isInteger(arguments[0])){var e=arguments[0];this.elt[0]=new Oh(e),this.elt[1]=new Oh(e)}else if(arguments[0]instanceof t){var n=arguments[0];this.elt[0]=new Oh(n.elt[0]),this.elt[1]=new Oh(n.elt[1])}}else if(2===arguments.length){var r=arguments[0],i=arguments[1];this.elt[0]=new Oh(Su.NONE),this.elt[1]=new Oh(Su.NONE),this.elt[r].setLocation(i)}else if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];this.elt[0]=new Oh(o,s,a),this.elt[1]=new Oh(o,s,a)}else if(4===arguments.length){var u=arguments[0],c=arguments[1],h=arguments[2],l=arguments[3];this.elt[0]=new Oh(Su.NONE,Su.NONE,Su.NONE),this.elt[1]=new Oh(Su.NONE,Su.NONE,Su.NONE),this.elt[u].setLocations(c,h,l)}};Rh.prototype.getGeometryCount=function(){var t=0;return this.elt[0].isNull()||t++,this.elt[1].isNull()||t++,t},Rh.prototype.setAllLocations=function(t,e){this.elt[t].setAllLocations(e)},Rh.prototype.isNull=function(t){return this.elt[t].isNull()},Rh.prototype.setAllLocationsIfNull=function(){if(1===arguments.length){var t=arguments[0];this.setAllLocationsIfNull(0,t),this.setAllLocationsIfNull(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.elt[e].setAllLocationsIfNull(n)}},Rh.prototype.isLine=function(t){return this.elt[t].isLine()},Rh.prototype.merge=function(t){for(var e=0;e<2;e++)null===this.elt[e]&&null!==t.elt[e]?this.elt[e]=new Oh(t.elt[e]):this.elt[e].merge(t.elt[e])},Rh.prototype.flip=function(){this.elt[0].flip(),this.elt[1].flip()},Rh.prototype.getLocation=function(){if(1===arguments.length){var t=arguments[0];return this.elt[t].get(Nh.ON)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return this.elt[e].get(n)}},Rh.prototype.toString=function(){var t=new Ru;return null!==this.elt[0]&&(t.append("A:"),t.append(this.elt[0].toString())),null!==this.elt[1]&&(t.append(" B:"),t.append(this.elt[1].toString())),t.toString()},Rh.prototype.isArea=function(){if(0===arguments.length)return this.elt[0].isArea()||this.elt[1].isArea();if(1===arguments.length){var t=arguments[0];return this.elt[t].isArea()}},Rh.prototype.isAnyNull=function(t){return this.elt[t].isAnyNull()},Rh.prototype.setLocation=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.elt[t].setLocation(Nh.ON,e)}else if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2];this.elt[n].setLocation(r,i)}},Rh.prototype.isEqualOnSide=function(t,e){return this.elt[0].isEqualOnSide(t.elt[0],e)&&this.elt[1].isEqualOnSide(t.elt[1],e)},Rh.prototype.allPositionsEqual=function(t,e){return this.elt[t].allPositionsEqual(e)},Rh.prototype.toLine=function(t){this.elt[t].isArea()&&(this.elt[t]=new Oh(this.elt[t].location[0]))},Rh.prototype.interfaces_=function(){return[]},Rh.prototype.getClass=function(){return Rh},Rh.toLineLabel=function(t){for(var e=new Rh(Su.NONE),n=0;n<2;n++)e.setLocation(n,t.getLocation(n));return e};var Th=function(){this._startDe=null,this._maxNodeDegree=-1,this._edges=new bc,this._pts=new bc,this._label=new Rh(Su.NONE),this._ring=null,this._isHole=null,this._shell=null,this._holes=new bc,this._geometryFactory=null;var t=arguments[0],e=arguments[1];this._geometryFactory=e,this.computePoints(t),this.computeRing()};Th.prototype.computeRing=function(){if(null!==this._ring)return null;for(var t=new Array(this._pts.size()).fill(null),e=0;e<this._pts.size();e++)t[e]=this._pts.get(e);this._ring=this._geometryFactory.createLinearRing(t),this._isHole=sc.isCCW(this._ring.getCoordinates())},Th.prototype.isIsolated=function(){return 1===this._label.getGeometryCount()},Th.prototype.computePoints=function(t){this._startDe=t;var e=t,n=!0;do{if(null===e)throw new Mh("Found null DirectedEdge");if(e.getEdgeRing()===this)throw new Mh("Directed Edge visited twice during ring-building at "+e.getCoordinate());this._edges.add(e);var r=e.getLabel();tc.isTrue(r.isArea()),this.mergeLabel(r),this.addPoints(e.getEdge(),e.isForward(),n),n=!1,this.setEdgeRing(e,this),e=this.getNext(e)}while(e!==this._startDe)},Th.prototype.getLinearRing=function(){return this._ring},Th.prototype.getCoordinate=function(t){return this._pts.get(t)},Th.prototype.computeMaxNodeDegree=function(){this._maxNodeDegree=0;var t=this._startDe;do{var e=t.getNode().getEdges().getOutgoingDegree(this);e>this._maxNodeDegree&&(this._maxNodeDegree=e),t=this.getNext(t)}while(t!==this._startDe);this._maxNodeDegree*=2},Th.prototype.addPoints=function(t,e,n){var r=t.getCoordinates();if(e){var i=1;n&&(i=0);for(var o=i;o<r.length;o++)this._pts.add(r[o])}else{var s=r.length-2;n&&(s=r.length-1);for(var a=s;a>=0;a--)this._pts.add(r[a])}},Th.prototype.isHole=function(){return this._isHole},Th.prototype.setInResult=function(){var t=this._startDe;do{t.getEdge().setInResult(!0),t=t.getNext()}while(t!==this._startDe)},Th.prototype.containsPoint=function(t){var e=this.getLinearRing();if(!e.getEnvelopeInternal().contains(t))return!1;if(!sc.isPointInRing(t,e.getCoordinates()))return!1;for(var n=this._holes.iterator();n.hasNext();){if(n.next().containsPoint(t))return!1}return!0},Th.prototype.addHole=function(t){this._holes.add(t)},Th.prototype.isShell=function(){return null===this._shell},Th.prototype.getLabel=function(){return this._label},Th.prototype.getEdges=function(){return this._edges},Th.prototype.getMaxNodeDegree=function(){return this._maxNodeDegree<0&&this.computeMaxNodeDegree(),this._maxNodeDegree},Th.prototype.getShell=function(){return this._shell},Th.prototype.mergeLabel=function(){if(1===arguments.length){var t=arguments[0];this.mergeLabel(t,0),this.mergeLabel(t,1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],r=e.getLocation(n,Nh.RIGHT);if(r===Su.NONE)return null;if(this._label.getLocation(n)===Su.NONE)return this._label.setLocation(n,r),null}},Th.prototype.setShell=function(t){this._shell=t,null!==t&&t.addHole(this)},Th.prototype.toPolygon=function(t){for(var e=new Array(this._holes.size()).fill(null),n=0;n<this._holes.size();n++)e[n]=this._holes.get(n).getLinearRing();return t.createPolygon(this.getLinearRing(),e)},Th.prototype.interfaces_=function(){return[]},Th.prototype.getClass=function(){return Th};var Ah=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.setEdgeRing=function(t,e){t.setMinEdgeRing(e)},e.prototype.getNext=function(t){return t.getNextMin()},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Th),Dh=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.buildMinimalRings=function(){var t=new bc,e=this._startDe;do{if(null===e.getMinEdgeRing()){var n=new Ah(e,this._geometryFactory);t.add(n)}e=e.getNext()}while(e!==this._startDe);return t},e.prototype.setEdgeRing=function(t,e){t.setEdgeRing(e)},e.prototype.linkDirectedEdgesForMinimalEdgeRings=function(){var t=this._startDe;do{t.getNode().getEdges().linkMinimalDirectedEdges(this),t=t.getNext()}while(t!==this._startDe)},e.prototype.getNext=function(t){return t.getNext()},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Th),Fh=function(){if(this._label=null,this._isInResult=!1,this._isCovered=!1,this._isCoveredSet=!1,this._isVisited=!1,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this._label=t}};Fh.prototype.setVisited=function(t){this._isVisited=t},Fh.prototype.setInResult=function(t){this._isInResult=t},Fh.prototype.isCovered=function(){return this._isCovered},Fh.prototype.isCoveredSet=function(){return this._isCoveredSet},Fh.prototype.setLabel=function(t){this._label=t},Fh.prototype.getLabel=function(){return this._label},Fh.prototype.setCovered=function(t){this._isCovered=t,this._isCoveredSet=!0},Fh.prototype.updateIM=function(t){tc.isTrue(this._label.getGeometryCount()>=2,"found partial label"),this.computeIM(t)},Fh.prototype.isInResult=function(){return this._isInResult},Fh.prototype.isVisited=function(){return this._isVisited},Fh.prototype.interfaces_=function(){return[]},Fh.prototype.getClass=function(){return Fh};var qh=function(t){function e(){t.call(this),this._coord=null,this._edges=null;var e=arguments[0],n=arguments[1];this._coord=e,this._edges=n,this._label=new Rh(0,Su.NONE)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isIncidentEdgeInResult=function(){for(var t=this.getEdges().getEdges().iterator();t.hasNext();){if(t.next().getEdge().isInResult())return!0}return!1},e.prototype.isIsolated=function(){return 1===this._label.getGeometryCount()},e.prototype.getCoordinate=function(){return this._coord},e.prototype.print=function(t){t.println("node "+this._coord+" lbl: "+this._label)},e.prototype.computeIM=function(t){},e.prototype.computeMergedLocation=function(t,e){var n=Su.NONE;if(n=this._label.getLocation(e),!t.isNull(e)){var r=t.getLocation(e);n!==Su.BOUNDARY&&(n=r)}return n},e.prototype.setLabel=function(){if(2!==arguments.length)return t.prototype.setLabel.apply(this,arguments);var e=arguments[0],n=arguments[1];null===this._label?this._label=new Rh(e,n):this._label.setLocation(e,n)},e.prototype.getEdges=function(){return this._edges},e.prototype.mergeLabel=function(){if(arguments[0]instanceof e){var t=arguments[0];this.mergeLabel(t._label)}else if(arguments[0]instanceof Rh)for(var n=arguments[0],r=0;r<2;r++){var i=this.computeMergedLocation(n,r);this._label.getLocation(r)===Su.NONE&&this._label.setLocation(r,i)}},e.prototype.add=function(t){this._edges.insert(t),t.setNode(this)},e.prototype.setLabelBoundary=function(t){if(null===this._label)return null;var e=Su.NONE;null!==this._label&&(e=this._label.getLocation(t));var n=null;switch(e){case Su.BOUNDARY:n=Su.INTERIOR;break;case Su.INTERIOR:default:n=Su.BOUNDARY}this._label.setLocation(t,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Fh),Gh=function(){this.nodeMap=new Gi,this.nodeFact=null;var t=arguments[0];this.nodeFact=t};Gh.prototype.find=function(t){return this.nodeMap.get(t)},Gh.prototype.addNode=function(){if(arguments[0]instanceof bu){var t=arguments[0],e=this.nodeMap.get(t);return null===e&&(e=this.nodeFact.createNode(t),this.nodeMap.put(t,e)),e}if(arguments[0]instanceof qh){var n=arguments[0],r=this.nodeMap.get(n.getCoordinate());return null===r?(this.nodeMap.put(n.getCoordinate(),n),n):(r.mergeLabel(n),r)}},Gh.prototype.print=function(t){for(var e=this.iterator();e.hasNext();){e.next().print(t)}},Gh.prototype.iterator=function(){return this.nodeMap.values().iterator()},Gh.prototype.values=function(){return this.nodeMap.values()},Gh.prototype.getBoundaryNodes=function(t){for(var e=new bc,n=this.iterator();n.hasNext();){var r=n.next();r.getLabel().getLocation(t)===Su.BOUNDARY&&e.add(r)}return e},Gh.prototype.add=function(t){var e=t.getCoordinate();this.addNode(e).add(t)},Gh.prototype.interfaces_=function(){return[]},Gh.prototype.getClass=function(){return Gh};var Bh=function(){},kh={NE:{configurable:!0},NW:{configurable:!0},SW:{configurable:!0},SE:{configurable:!0}};Bh.prototype.interfaces_=function(){return[]},Bh.prototype.getClass=function(){return Bh},Bh.isNorthern=function(t){return t===Bh.NE||t===Bh.NW},Bh.isOpposite=function(t,e){if(t===e)return!1;return 2===(t-e+4)%4},Bh.commonHalfPlane=function(t,e){if(t===e)return t;if(2===(t-e+4)%4)return-1;var n=t<e?t:e;return 0===n&&3===(t>e?t:e)?3:n},Bh.isInHalfPlane=function(t,e){return e===Bh.SE?t===Bh.SE||t===Bh.SW:t===e||t===e+1},Bh.quadrant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new _u("Cannot compute the quadrant for point ( "+t+", "+e+" )");return t>=0?e>=0?Bh.NE:Bh.SE:e>=0?Bh.NW:Bh.SW}if(arguments[0]instanceof bu&&arguments[1]instanceof bu){var n=arguments[0],r=arguments[1];if(r.x===n.x&&r.y===n.y)throw new _u("Cannot compute the quadrant for two identical points "+n);return r.x>=n.x?r.y>=n.y?Bh.NE:Bh.SE:r.y>=n.y?Bh.NW:Bh.SW}},kh.NE.get=function(){return 0},kh.NW.get=function(){return 1},kh.SW.get=function(){return 2},kh.SE.get=function(){return 3},Object.defineProperties(Bh,kh);var zh=function(){if(this._edge=null,this._label=null,this._node=null,this._p0=null,this._p1=null,this._dx=null,this._dy=null,this._quadrant=null,1===arguments.length){var t=arguments[0];this._edge=t}else if(3===arguments.length){var e=arguments[0],n=arguments[1],r=arguments[2];this._edge=e,this.init(n,r),this._label=null}else if(4===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];this._edge=i,this.init(o,s),this._label=a}};zh.prototype.compareDirection=function(t){return this._dx===t._dx&&this._dy===t._dy?0:this._quadrant>t._quadrant?1:this._quadrant<t._quadrant?-1:sc.computeOrientation(t._p0,t._p1,this._p1)},zh.prototype.getDy=function(){return this._dy},zh.prototype.getCoordinate=function(){return this._p0},zh.prototype.setNode=function(t){this._node=t},zh.prototype.print=function(t){var e=Math.atan2(this._dy,this._dx),n=this.getClass().getName(),r=n.lastIndexOf("."),i=n.substring(r+1);t.print("  "+i+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+e+"   "+this._label)},zh.prototype.compareTo=function(t){var e=t;return this.compareDirection(e)},zh.prototype.getDirectedCoordinate=function(){return this._p1},zh.prototype.getDx=function(){return this._dx},zh.prototype.getLabel=function(){return this._label},zh.prototype.getEdge=function(){return this._edge},zh.prototype.getQuadrant=function(){return this._quadrant},zh.prototype.getNode=function(){return this._node},zh.prototype.toString=function(){var t=Math.atan2(this._dy,this._dx),e=this.getClass().getName(),n=e.lastIndexOf(".");return"  "+e.substring(n+1)+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+t+"   "+this._label},zh.prototype.computeLabel=function(t){},zh.prototype.init=function(t,e){this._p0=t,this._p1=e,this._dx=e.x-t.x,this._dy=e.y-t.y,this._quadrant=Bh.quadrant(this._dx,this._dy),tc.isTrue(!(0===this._dx&&0===this._dy),"EdgeEnd with identical endpoints found")},zh.prototype.interfaces_=function(){return[xu]},zh.prototype.getClass=function(){return zh};var jh=function(t){function e(){var e=arguments[0],n=arguments[1];if(t.call(this,e),this._isForward=null,this._isInResult=!1,this._isVisited=!1,this._sym=null,this._next=null,this._nextMin=null,this._edgeRing=null,this._minEdgeRing=null,this._depth=[0,-999,-999],this._isForward=n,n)this.init(e.getCoordinate(0),e.getCoordinate(1));else{var r=e.getNumPoints()-1;this.init(e.getCoordinate(r),e.getCoordinate(r-1))}this.computeDirectedLabel()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getNextMin=function(){return this._nextMin},e.prototype.getDepth=function(t){return this._depth[t]},e.prototype.setVisited=function(t){this._isVisited=t},e.prototype.computeDirectedLabel=function(){this._label=new Rh(this._edge.getLabel()),this._isForward||this._label.flip()},e.prototype.getNext=function(){return this._next},e.prototype.setDepth=function(t,e){if(-999!==this._depth[t]&&this._depth[t]!==e)throw new Mh("assigned depths do not match",this.getCoordinate());this._depth[t]=e},e.prototype.isInteriorAreaEdge=function(){for(var t=!0,e=0;e<2;e++)this._label.isArea(e)&&this._label.getLocation(e,Nh.LEFT)===Su.INTERIOR&&this._label.getLocation(e,Nh.RIGHT)===Su.INTERIOR||(t=!1);return t},e.prototype.setNextMin=function(t){this._nextMin=t},e.prototype.print=function(e){t.prototype.print.call(this,e),e.print(" "+this._depth[Nh.LEFT]+"/"+this._depth[Nh.RIGHT]),e.print(" ("+this.getDepthDelta()+")"),this._isInResult&&e.print(" inResult")},e.prototype.setMinEdgeRing=function(t){this._minEdgeRing=t},e.prototype.isLineEdge=function(){var t=this._label.isLine(0)||this._label.isLine(1),e=!this._label.isArea(0)||this._label.allPositionsEqual(0,Su.EXTERIOR),n=!this._label.isArea(1)||this._label.allPositionsEqual(1,Su.EXTERIOR);return t&&e&&n},e.prototype.setEdgeRing=function(t){this._edgeRing=t},e.prototype.getMinEdgeRing=function(){return this._minEdgeRing},e.prototype.getDepthDelta=function(){var t=this._edge.getDepthDelta();return this._isForward||(t=-t),t},e.prototype.setInResult=function(t){this._isInResult=t},e.prototype.getSym=function(){return this._sym},e.prototype.isForward=function(){return this._isForward},e.prototype.getEdge=function(){return this._edge},e.prototype.printEdge=function(t){this.print(t),t.print(" "),this._isForward?this._edge.print(t):this._edge.printReverse(t)},e.prototype.setSym=function(t){this._sym=t},e.prototype.setVisitedEdge=function(t){this.setVisited(t),this._sym.setVisited(t)},e.prototype.setEdgeDepths=function(t,e){var n=this.getEdge().getDepthDelta();this._isForward||(n=-n);var r=1;t===Nh.LEFT&&(r=-1);var i=Nh.opposite(t),o=e+n*r;this.setDepth(t,e),this.setDepth(i,o)},e.prototype.getEdgeRing=function(){return this._edgeRing},e.prototype.isInResult=function(){return this._isInResult},e.prototype.setNext=function(t){this._next=t},e.prototype.isVisited=function(){return this._isVisited},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.depthFactor=function(t,e){return t===Su.EXTERIOR&&e===Su.INTERIOR?1:t===Su.INTERIOR&&e===Su.EXTERIOR?-1:0},e}(zh),Xh=function(){};Xh.prototype.createNode=function(t){return new qh(t,null)},Xh.prototype.interfaces_=function(){return[]},Xh.prototype.getClass=function(){return Xh};var Uh=function(){if(this._edges=new bc,this._nodes=null,this._edgeEndList=new bc,0===arguments.length)this._nodes=new Gh(new Xh);else if(1===arguments.length){var t=arguments[0];this._nodes=new Gh(t)}};Uh.prototype.printEdges=function(t){t.println("Edges:");for(var e=0;e<this._edges.size();e++){t.println("edge "+e+":");var n=this._edges.get(e);n.print(t),n.eiList.print(t)}},Uh.prototype.find=function(t){return this._nodes.find(t)},Uh.prototype.addNode=function(){if(arguments[0]instanceof qh){var t=arguments[0];return this._nodes.addNode(t)}if(arguments[0]instanceof bu){var e=arguments[0];return this._nodes.addNode(e)}},Uh.prototype.getNodeIterator=function(){return this._nodes.iterator()},Uh.prototype.linkResultDirectedEdges=function(){for(var t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkResultDirectedEdges()}},Uh.prototype.debugPrintln=function(t){Xu.out.println(t)},Uh.prototype.isBoundaryNode=function(t,e){var n=this._nodes.find(e);if(null===n)return!1;var r=n.getLabel();return null!==r&&r.getLocation(t)===Su.BOUNDARY},Uh.prototype.linkAllDirectedEdges=function(){for(var t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkAllDirectedEdges()}},Uh.prototype.matchInSameDirection=function(t,e,n,r){return!!t.equals(n)&&(sc.computeOrientation(t,e,r)===sc.COLLINEAR&&Bh.quadrant(t,e)===Bh.quadrant(n,r))},Uh.prototype.getEdgeEnds=function(){return this._edgeEndList},Uh.prototype.debugPrint=function(t){Xu.out.print(t)},Uh.prototype.getEdgeIterator=function(){return this._edges.iterator()},Uh.prototype.findEdgeInSameDirection=function(t,e){for(var n=0;n<this._edges.size();n++){var r=this._edges.get(n),i=r.getCoordinates();if(this.matchInSameDirection(t,e,i[0],i[1]))return r;if(this.matchInSameDirection(t,e,i[i.length-1],i[i.length-2]))return r}return null},Uh.prototype.insertEdge=function(t){this._edges.add(t)},Uh.prototype.findEdgeEnd=function(t){for(var e=this.getEdgeEnds().iterator();e.hasNext();){var n=e.next();if(n.getEdge()===t)return n}return null},Uh.prototype.addEdges=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this._edges.add(n);var r=new jh(n,!0),i=new jh(n,!1);r.setSym(i),i.setSym(r),this.add(r),this.add(i)}},Uh.prototype.add=function(t){this._nodes.add(t),this._edgeEndList.add(t)},Uh.prototype.getNodes=function(){return this._nodes.values()},Uh.prototype.findEdge=function(t,e){for(var n=0;n<this._edges.size();n++){var r=this._edges.get(n),i=r.getCoordinates();if(t.equals(i[0])&&e.equals(i[1]))return r}return null},Uh.prototype.interfaces_=function(){return[]},Uh.prototype.getClass=function(){return Uh},Uh.linkResultDirectedEdges=function(t){for(var e=t.iterator();e.hasNext();){e.next().getEdges().linkResultDirectedEdges()}};var Yh=function(){this._geometryFactory=null,this._shellList=new bc;var t=arguments[0];this._geometryFactory=t};Yh.prototype.sortShellsAndHoles=function(t,e,n){for(var r=t.iterator();r.hasNext();){var i=r.next();i.isHole()?n.add(i):e.add(i)}},Yh.prototype.computePolygons=function(t){for(var e=new bc,n=t.iterator();n.hasNext();){var r=n.next().toPolygon(this._geometryFactory);e.add(r)}return e},Yh.prototype.placeFreeHoles=function(t,e){for(var n=e.iterator();n.hasNext();){var r=n.next();if(null===r.getShell()){var i=this.findEdgeRingContaining(r,t);if(null===i)throw new Mh("unable to assign hole to a shell",r.getCoordinate(0));r.setShell(i)}}},Yh.prototype.buildMinimalEdgeRings=function(t,e,n){for(var r=new bc,i=t.iterator();i.hasNext();){var o=i.next();if(o.getMaxNodeDegree()>2){o.linkDirectedEdgesForMinimalEdgeRings();var s=o.buildMinimalRings(),a=this.findShell(s);null!==a?(this.placePolygonHoles(a,s),e.add(a)):n.addAll(s)}else r.add(o)}return r},Yh.prototype.containsPoint=function(t){for(var e=this._shellList.iterator();e.hasNext();){if(e.next().containsPoint(t))return!0}return!1},Yh.prototype.buildMaximalEdgeRings=function(t){for(var e=new bc,n=t.iterator();n.hasNext();){var r=n.next();if(r.isInResult()&&r.getLabel().isArea()&&null===r.getEdgeRing()){var i=new Dh(r,this._geometryFactory);e.add(i),i.setInResult()}}return e},Yh.prototype.placePolygonHoles=function(t,e){for(var n=e.iterator();n.hasNext();){var r=n.next();r.isHole()&&r.setShell(t)}},Yh.prototype.getPolygons=function(){return this.computePolygons(this._shellList)},Yh.prototype.findEdgeRingContaining=function(t,e){for(var n=t.getLinearRing(),r=n.getEnvelopeInternal(),i=n.getCoordinateN(0),o=null,s=null,a=e.iterator();a.hasNext();){var u=a.next(),c=u.getLinearRing(),h=c.getEnvelopeInternal();null!==o&&(s=o.getLinearRing().getEnvelopeInternal());var l=!1;h.contains(r)&&sc.isPointInRing(i,c.getCoordinates())&&(l=!0),l&&(null===o||s.contains(h))&&(o=u)}return o},Yh.prototype.findShell=function(t){for(var e=0,n=null,r=t.iterator();r.hasNext();){var i=r.next();i.isHole()||(n=i,e++)}return tc.isTrue(e<=1,"found two shells in MinimalEdgeRing list"),n},Yh.prototype.add=function(){if(1===arguments.length){var t=arguments[0];this.add(t.getEdgeEnds(),t.getNodes())}else if(2===arguments.length){var e=arguments[0],n=arguments[1];Uh.linkResultDirectedEdges(n);var r=this.buildMaximalEdgeRings(e),i=new bc,o=this.buildMinimalEdgeRings(r,this._shellList,i);this.sortShellsAndHoles(o,this._shellList,i),this.placeFreeHoles(this._shellList,i)}},Yh.prototype.interfaces_=function(){return[]},Yh.prototype.getClass=function(){return Yh};var Vh=function(){};Vh.prototype.getBounds=function(){},Vh.prototype.interfaces_=function(){return[]},Vh.prototype.getClass=function(){return Vh};var Hh=function(){this._bounds=null,this._item=null;var t=arguments[0],e=arguments[1];this._bounds=t,this._item=e};Hh.prototype.getItem=function(){return this._item},Hh.prototype.getBounds=function(){return this._bounds},Hh.prototype.interfaces_=function(){return[Vh,Li]},Hh.prototype.getClass=function(){return Hh};var Wh=function(){this._size=null,this._items=null,this._size=0,this._items=new bc,this._items.add(null)};Wh.prototype.poll=function(){if(this.isEmpty())return null;var t=this._items.get(1);return this._items.set(1,this._items.get(this._size)),this._size-=1,this.reorder(1),t},Wh.prototype.size=function(){return this._size},Wh.prototype.reorder=function(t){for(var e=null,n=this._items.get(t);2*t<=this._size&&((e=2*t)!==this._size&&this._items.get(e+1).compareTo(this._items.get(e))<0&&e++,this._items.get(e).compareTo(n)<0);t=e)this._items.set(t,this._items.get(e));this._items.set(t,n)},Wh.prototype.clear=function(){this._size=0,this._items.clear()},Wh.prototype.isEmpty=function(){return 0===this._size},Wh.prototype.add=function(t){this._items.add(null),this._size+=1;var e=this._size;for(this._items.set(0,t);t.compareTo(this._items.get(Math.trunc(e/2)))<0;e/=2)this._items.set(e,this._items.get(Math.trunc(e/2)));this._items.set(e,t)},Wh.prototype.interfaces_=function(){return[]},Wh.prototype.getClass=function(){return Wh};var Jh=function(){};Jh.prototype.visitItem=function(t){},Jh.prototype.interfaces_=function(){return[]},Jh.prototype.getClass=function(){return Jh};var Zh=function(){};Zh.prototype.insert=function(t,e){},Zh.prototype.remove=function(t,e){},Zh.prototype.query=function(){},Zh.prototype.interfaces_=function(){return[]},Zh.prototype.getClass=function(){return Zh};var Kh=function(){if(this._childBoundables=new bc,this._bounds=null,this._level=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this._level=t}},Qh={serialVersionUID:{configurable:!0}};Kh.prototype.getLevel=function(){return this._level},Kh.prototype.size=function(){return this._childBoundables.size()},Kh.prototype.getChildBoundables=function(){return this._childBoundables},Kh.prototype.addChildBoundable=function(t){tc.isTrue(null===this._bounds),this._childBoundables.add(t)},Kh.prototype.isEmpty=function(){return this._childBoundables.isEmpty()},Kh.prototype.getBounds=function(){return null===this._bounds&&(this._bounds=this.computeBounds()),this._bounds},Kh.prototype.interfaces_=function(){return[Vh,Li]},Kh.prototype.getClass=function(){return Kh},Qh.serialVersionUID.get=function(){return 0x5a1e55ec41369800},Object.defineProperties(Kh,Qh);var $h=function(){};$h.reverseOrder=function(){return{compare:function(t,e){return e.compareTo(t)}}},$h.min=function(t){return $h.sort(t),t.get(0)},$h.sort=function(t,e){var n=t.toArray();e?qc.sort(n,e):qc.sort(n);for(var r=t.iterator(),i=0,o=n.length;i<o;i++)r.next(),r.set(n[i])},$h.singletonList=function(t){var e=new bc;return e.add(t),e};var tl=function(){this._boundable1=null,this._boundable2=null,this._distance=null,this._itemDistance=null;var t=arguments[0],e=arguments[1],n=arguments[2];this._boundable1=t,this._boundable2=e,this._itemDistance=n,this._distance=this.distance()};tl.prototype.expandToQueue=function(t,e){var n=tl.isComposite(this._boundable1),r=tl.isComposite(this._boundable2);if(n&&r)return tl.area(this._boundable1)>tl.area(this._boundable2)?(this.expand(this._boundable1,this._boundable2,t,e),null):(this.expand(this._boundable2,this._boundable1,t,e),null);if(n)return this.expand(this._boundable1,this._boundable2,t,e),null;if(r)return this.expand(this._boundable2,this._boundable1,t,e),null;throw new _u("neither boundable is composite")},tl.prototype.isLeaves=function(){return!(tl.isComposite(this._boundable1)||tl.isComposite(this._boundable2))},tl.prototype.compareTo=function(t){var e=t;return this._distance<e._distance?-1:this._distance>e._distance?1:0},tl.prototype.expand=function(t,e,n,r){for(var i=t.getChildBoundables().iterator();i.hasNext();){var o=i.next(),s=new tl(o,e,this._itemDistance);s.getDistance()<r&&n.add(s)}},tl.prototype.getBoundable=function(t){return 0===t?this._boundable1:this._boundable2},tl.prototype.getDistance=function(){return this._distance},tl.prototype.distance=function(){return this.isLeaves()?this._itemDistance.distance(this._boundable1,this._boundable2):this._boundable1.getBounds().distance(this._boundable2.getBounds())},tl.prototype.interfaces_=function(){return[xu]},tl.prototype.getClass=function(){return tl},tl.area=function(t){return t.getBounds().getArea()},tl.isComposite=function(t){return t instanceof Kh};var el=function t(){if(this._root=null,this._built=!1,this._itemBoundables=new bc,this._nodeCapacity=null,0===arguments.length){var e=t.DEFAULT_NODE_CAPACITY;this._nodeCapacity=e}else if(1===arguments.length){var n=arguments[0];tc.isTrue(n>1,"Node capacity must be greater than 1"),this._nodeCapacity=n}},nl={IntersectsOp:{configurable:!0},serialVersionUID:{configurable:!0},DEFAULT_NODE_CAPACITY:{configurable:!0}};el.prototype.getNodeCapacity=function(){return this._nodeCapacity},el.prototype.lastNode=function(t){return t.get(t.size()-1)},el.prototype.size=function(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.size(this._root));if(1===arguments.length){for(var t=0,e=arguments[0].getChildBoundables().iterator();e.hasNext();){var n=e.next();n instanceof Kh?t+=this.size(n):n instanceof Hh&&(t+=1)}return t}},el.prototype.removeItem=function(t,e){for(var n=null,r=t.getChildBoundables().iterator();r.hasNext();){var i=r.next();i instanceof Hh&&i.getItem()===e&&(n=i)}return null!==n&&(t.getChildBoundables().remove(n),!0)},el.prototype.itemsTree=function(){if(0===arguments.length){this.build();var t=this.itemsTree(this._root);return null===t?new bc:t}if(1===arguments.length){for(var e=arguments[0],n=new bc,r=e.getChildBoundables().iterator();r.hasNext();){var i=r.next();if(i instanceof Kh){var o=this.itemsTree(i);null!==o&&n.add(o)}else i instanceof Hh?n.add(i.getItem()):tc.shouldNeverReachHere()}return n.size()<=0?null:n}},el.prototype.insert=function(t,e){tc.isTrue(!this._built,"Cannot insert items into an STR packed R-tree after it has been built."),this._itemBoundables.add(new Hh(t,e))},el.prototype.boundablesAtLevel=function(){if(1===arguments.length){var t=arguments[0],e=new bc;return this.boundablesAtLevel(t,this._root,e),e}if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2];if(tc.isTrue(n>-2),r.getLevel()===n)return i.add(r),null;for(var o=r.getChildBoundables().iterator();o.hasNext();){var s=o.next();s instanceof Kh?this.boundablesAtLevel(n,s,i):(tc.isTrue(s instanceof Hh),-1===n&&i.add(s))}return null}},el.prototype.query=function(){if(1===arguments.length){var t=arguments[0];this.build();var e=new bc;return this.isEmpty()?e:(this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.query(t,this._root,e),e)}if(2===arguments.length){var n=arguments[0],r=arguments[1];if(this.build(),this.isEmpty())return null;this.getIntersectsOp().intersects(this._root.getBounds(),n)&&this.query(n,this._root,r)}else if(3===arguments.length)if(Lu(arguments[2],Jh)&&arguments[0]instanceof Object&&arguments[1]instanceof Kh)for(var i=arguments[0],o=arguments[1],s=arguments[2],a=o.getChildBoundables(),u=0;u<a.size();u++){var c=a.get(u);this.getIntersectsOp().intersects(c.getBounds(),i)&&(c instanceof Kh?this.query(i,c,s):c instanceof Hh?s.visitItem(c.getItem()):tc.shouldNeverReachHere())}else if(Lu(arguments[2],wc)&&arguments[0]instanceof Object&&arguments[1]instanceof Kh)for(var h=arguments[0],l=arguments[1],p=arguments[2],f=l.getChildBoundables(),g=0;g<f.size();g++){var d=f.get(g);this.getIntersectsOp().intersects(d.getBounds(),h)&&(d instanceof Kh?this.query(h,d,p):d instanceof Hh?p.add(d.getItem()):tc.shouldNeverReachHere())}},el.prototype.build=function(){if(this._built)return null;this._root=this._itemBoundables.isEmpty()?this.createNode(0):this.createHigherLevels(this._itemBoundables,-1),this._itemBoundables=null,this._built=!0},el.prototype.getRoot=function(){return this.build(),this._root},el.prototype.remove=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.build(),!!this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.remove(t,this._root,e)}if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2],o=this.removeItem(r,i);if(o)return!0;for(var s=null,a=r.getChildBoundables().iterator();a.hasNext();){var u=a.next();if(this.getIntersectsOp().intersects(u.getBounds(),n)&&(u instanceof Kh&&(o=this.remove(n,u,i)))){s=u;break}}return null!==s&&s.getChildBoundables().isEmpty()&&r.getChildBoundables().remove(s),o}},el.prototype.createHigherLevels=function(t,e){tc.isTrue(!t.isEmpty());var n=this.createParentBoundables(t,e+1);return 1===n.size()?n.get(0):this.createHigherLevels(n,e+1)},el.prototype.depth=function(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.depth(this._root));if(1===arguments.length){for(var t=0,e=arguments[0].getChildBoundables().iterator();e.hasNext();){var n=e.next();if(n instanceof Kh){var r=this.depth(n);r>t&&(t=r)}}return t+1}},el.prototype.createParentBoundables=function(t,e){tc.isTrue(!t.isEmpty());var n=new bc;n.add(this.createNode(e));var r=new bc(t);$h.sort(r,this.getComparator());for(var i=r.iterator();i.hasNext();){var o=i.next();this.lastNode(n).getChildBoundables().size()===this.getNodeCapacity()&&n.add(this.createNode(e)),this.lastNode(n).addChildBoundable(o)}return n},el.prototype.isEmpty=function(){return this._built?this._root.isEmpty():this._itemBoundables.isEmpty()},el.prototype.interfaces_=function(){return[Li]},el.prototype.getClass=function(){return el},el.compareDoubles=function(t,e){return t>e?1:t<e?-1:0},nl.IntersectsOp.get=function(){return rl},nl.serialVersionUID.get=function(){return-0x35ef64c82d4c5400},nl.DEFAULT_NODE_CAPACITY.get=function(){return 10},Object.defineProperties(el,nl);var rl=function(){},il=function(){};il.prototype.distance=function(t,e){},il.prototype.interfaces_=function(){return[]},il.prototype.getClass=function(){return il};var ol=function(t){function e(n){n=n||e.DEFAULT_NODE_CAPACITY,t.call(this,n)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={STRtreeNode:{configurable:!0},serialVersionUID:{configurable:!0},xComparator:{configurable:!0},yComparator:{configurable:!0},intersectsOp:{configurable:!0},DEFAULT_NODE_CAPACITY:{configurable:!0}};return e.prototype.createParentBoundablesFromVerticalSlices=function(t,e){tc.isTrue(t.length>0);for(var n=new bc,r=0;r<t.length;r++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[r],e));return n},e.prototype.createNode=function(t){return new sl(t)},e.prototype.size=function(){return 0===arguments.length?t.prototype.size.call(this):t.prototype.size.apply(this,arguments)},e.prototype.insert=function(){if(2!==arguments.length)return t.prototype.insert.apply(this,arguments);var e=arguments[0],n=arguments[1];if(e.isNull())return null;t.prototype.insert.call(this,e,n)},e.prototype.getIntersectsOp=function(){return e.intersectsOp},e.prototype.verticalSlices=function(t,e){for(var n=Math.trunc(Math.ceil(t.size()/e)),r=new Array(e).fill(null),i=t.iterator(),o=0;o<e;o++){r[o]=new bc;for(var s=0;i.hasNext()&&s<n;){var a=i.next();r[o].add(a),s++}}return r},e.prototype.query=function(){if(1===arguments.length){var e=arguments[0];return t.prototype.query.call(this,e)}if(2===arguments.length){var n=arguments[0],r=arguments[1];t.prototype.query.call(this,n,r)}else if(3===arguments.length)if(Lu(arguments[2],Jh)&&arguments[0]instanceof Object&&arguments[1]instanceof Kh){var i=arguments[0],o=arguments[1],s=arguments[2];t.prototype.query.call(this,i,o,s)}else if(Lu(arguments[2],wc)&&arguments[0]instanceof Object&&arguments[1]instanceof Kh){var a=arguments[0],u=arguments[1],c=arguments[2];t.prototype.query.call(this,a,u,c)}},e.prototype.getComparator=function(){return e.yComparator},e.prototype.createParentBoundablesFromVerticalSlice=function(e,n){return t.prototype.createParentBoundables.call(this,e,n)},e.prototype.remove=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return t.prototype.remove.call(this,e,n)}return t.prototype.remove.apply(this,arguments)},e.prototype.depth=function(){return 0===arguments.length?t.prototype.depth.call(this):t.prototype.depth.apply(this,arguments)},e.prototype.createParentBoundables=function(t,n){tc.isTrue(!t.isEmpty());var r=Math.trunc(Math.ceil(t.size()/this.getNodeCapacity())),i=new bc(t);$h.sort(i,e.xComparator);var o=this.verticalSlices(i,Math.trunc(Math.ceil(Math.sqrt(r))));return this.createParentBoundablesFromVerticalSlices(o,n)},e.prototype.nearestNeighbour=function(){if(1===arguments.length){if(Lu(arguments[0],il)){var t=arguments[0],n=new tl(this.getRoot(),this.getRoot(),t);return this.nearestNeighbour(n)}if(arguments[0]instanceof tl){var r=arguments[0];return this.nearestNeighbour(r,mu.POSITIVE_INFINITY)}}else if(2===arguments.length){if(arguments[0]instanceof e&&Lu(arguments[1],il)){var i=arguments[0],o=arguments[1],s=new tl(this.getRoot(),i.getRoot(),o);return this.nearestNeighbour(s)}if(arguments[0]instanceof tl&&"number"==typeof arguments[1]){var a=arguments[0],u=arguments[1],c=null,h=new Wh;for(h.add(a);!h.isEmpty()&&u>0;){var l=h.poll(),p=l.getDistance();if(p>=u)break;l.isLeaves()?(u=p,c=l):l.expandToQueue(h,u)}return[c.getBoundable(0).getItem(),c.getBoundable(1).getItem()]}}else if(3===arguments.length){var f=arguments[0],g=arguments[1],d=arguments[2],y=new Hh(f,g),_=new tl(this.getRoot(),y,d);return this.nearestNeighbour(_)[0]}},e.prototype.interfaces_=function(){return[Zh,Li]},e.prototype.getClass=function(){return e},e.centreX=function(t){return e.avg(t.getMinX(),t.getMaxX())},e.avg=function(t,e){return(t+e)/2},e.centreY=function(t){return e.avg(t.getMinY(),t.getMaxY())},n.STRtreeNode.get=function(){return sl},n.serialVersionUID.get=function(){return 0x39920f7d5f261e0},n.xComparator.get=function(){return{interfaces_:function(){return[wu]},compare:function(n,r){return t.compareDoubles(e.centreX(n.getBounds()),e.centreX(r.getBounds()))}}},n.yComparator.get=function(){return{interfaces_:function(){return[wu]},compare:function(n,r){return t.compareDoubles(e.centreY(n.getBounds()),e.centreY(r.getBounds()))}}},n.intersectsOp.get=function(){return{interfaces_:function(){return[t.IntersectsOp]},intersects:function(t,e){return t.intersects(e)}}},n.DEFAULT_NODE_CAPACITY.get=function(){return 10},Object.defineProperties(e,n),e}(el),sl=function(t){function e(){var e=arguments[0];t.call(this,e)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.computeBounds=function(){for(var t=null,e=this.getChildBoundables().iterator();e.hasNext();){var n=e.next();null===t?t=new Yu(n.getBounds()):t.expandToInclude(n.getBounds())}return t},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Kh),al=function(){};al.prototype.interfaces_=function(){return[]},al.prototype.getClass=function(){return al},al.relativeSign=function(t,e){return t<e?-1:t>e?1:0},al.compare=function(t,e,n){if(e.equals2D(n))return 0;var r=al.relativeSign(e.x,n.x),i=al.relativeSign(e.y,n.y);switch(t){case 0:return al.compareValue(r,i);case 1:return al.compareValue(i,r);case 2:return al.compareValue(i,-r);case 3:return al.compareValue(-r,i);case 4:return al.compareValue(-r,-i);case 5:return al.compareValue(-i,-r);case 6:return al.compareValue(-i,r);case 7:return al.compareValue(r,-i)}return tc.shouldNeverReachHere("invalid octant value"),0},al.compareValue=function(t,e){return t<0?-1:t>0?1:e<0?-1:e>0?1:0};var ul=function(){this._segString=null,this.coord=null,this.segmentIndex=null,this._segmentOctant=null,this._isInterior=null;var t=arguments[0],e=arguments[1],n=arguments[2],r=arguments[3];this._segString=t,this.coord=new bu(e),this.segmentIndex=n,this._segmentOctant=r,this._isInterior=!e.equals2D(t.getCoordinate(n))};ul.prototype.getCoordinate=function(){return this.coord},ul.prototype.print=function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex)},ul.prototype.compareTo=function(t){var e=t;return this.segmentIndex<e.segmentIndex?-1:this.segmentIndex>e.segmentIndex?1:this.coord.equals2D(e.coord)?0:al.compare(this._segmentOctant,this.coord,e.coord)},ul.prototype.isEndPoint=function(t){return 0===this.segmentIndex&&!this._isInterior||this.segmentIndex===t},ul.prototype.isInterior=function(){return this._isInterior},ul.prototype.interfaces_=function(){return[xu]},ul.prototype.getClass=function(){return ul};var cl=function(){this._nodeMap=new Gi,this._edge=null;var t=arguments[0];this._edge=t};cl.prototype.getSplitCoordinates=function(){var t=new Nc;this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var r=e.next();this.addEdgeCoordinates(n,r,t),n=r}return t.toCoordinateArray()},cl.prototype.addCollapsedNodes=function(){var t=new bc;this.findCollapsesFromInsertedNodes(t),this.findCollapsesFromExistingVertices(t);for(var e=t.iterator();e.hasNext();){var n=e.next().intValue();this.add(this._edge.getCoordinate(n),n)}},cl.prototype.print=function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){e.next().print(t)}},cl.prototype.findCollapsesFromExistingVertices=function(t){for(var e=0;e<this._edge.size()-2;e++){var n=this._edge.getCoordinate(e),r=this._edge.getCoordinate(e+2);n.equals2D(r)&&t.add(new Tu(e+1))}},cl.prototype.addEdgeCoordinates=function(t,e,n){var r=this._edge.getCoordinate(e.segmentIndex),i=e.isInterior()||!e.coord.equals2D(r);n.add(new bu(t.coord),!1);for(var o=t.segmentIndex+1;o<=e.segmentIndex;o++)n.add(this._edge.getCoordinate(o));i&&n.add(new bu(e.coord))},cl.prototype.iterator=function(){return this._nodeMap.values().iterator()},cl.prototype.addSplitEdges=function(t){this.addEndpoints(),this.addCollapsedNodes();for(var e=this.iterator(),n=e.next();e.hasNext();){var r=e.next(),i=this.createSplitEdge(n,r);t.add(i),n=r}},cl.prototype.findCollapseIndex=function(t,e,n){if(!t.coord.equals2D(e.coord))return!1;var r=e.segmentIndex-t.segmentIndex;return e.isInterior()||r--,1===r&&(n[0]=t.segmentIndex+1,!0)},cl.prototype.findCollapsesFromInsertedNodes=function(t){for(var e=new Array(1).fill(null),n=this.iterator(),r=n.next();n.hasNext();){var i=n.next();this.findCollapseIndex(r,i,e)&&t.add(new Tu(e[0])),r=i}},cl.prototype.getEdge=function(){return this._edge},cl.prototype.addEndpoints=function(){var t=this._edge.size()-1;this.add(this._edge.getCoordinate(0),0),this.add(this._edge.getCoordinate(t),t)},cl.prototype.createSplitEdge=function(t,e){var n=e.segmentIndex-t.segmentIndex+2,r=this._edge.getCoordinate(e.segmentIndex),i=e.isInterior()||!e.coord.equals2D(r);i||n--;var o=new Array(n).fill(null),s=0;o[s++]=new bu(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)o[s++]=this._edge.getCoordinate(a);return i&&(o[s]=new bu(e.coord)),new fl(o,this._edge.getData())},cl.prototype.add=function(t,e){var n=new ul(this._edge,t,e,this._edge.getSegmentOctant(e)),r=this._nodeMap.get(n);return null!==r?(tc.isTrue(r.coord.equals2D(t),"Found equal nodes with different coordinates"),r):(this._nodeMap.put(n,n),n)},cl.prototype.checkSplitEdgesCorrectness=function(t){var e=this._edge.getCoordinates(),n=t.get(0).getCoordinate(0);if(!n.equals2D(e[0]))throw new Qu("bad split edge start point at "+n);var r=t.get(t.size()-1).getCoordinates(),i=r[r.length-1];if(!i.equals2D(e[e.length-1]))throw new Qu("bad split edge end point at "+i)},cl.prototype.interfaces_=function(){return[]},cl.prototype.getClass=function(){return cl};var hl=function(){};hl.prototype.interfaces_=function(){return[]},hl.prototype.getClass=function(){return hl},hl.octant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new _u("Cannot compute the octant for point ( "+t+", "+e+" )");var n=Math.abs(t),r=Math.abs(e);return t>=0?e>=0?n>=r?0:1:n>=r?7:6:e>=0?n>=r?3:2:n>=r?4:5}if(arguments[0]instanceof bu&&arguments[1]instanceof bu){var i=arguments[0],o=arguments[1],s=o.x-i.x,a=o.y-i.y;if(0===s&&0===a)throw new _u("Cannot compute the octant for two identical points "+i);return hl.octant(s,a)}};var ll=function(){};ll.prototype.getCoordinates=function(){},ll.prototype.size=function(){},ll.prototype.getCoordinate=function(t){},ll.prototype.isClosed=function(){},ll.prototype.setData=function(t){},ll.prototype.getData=function(){},ll.prototype.interfaces_=function(){return[]},ll.prototype.getClass=function(){return ll};var pl=function(){};pl.prototype.addIntersection=function(t,e){},pl.prototype.interfaces_=function(){return[ll]},pl.prototype.getClass=function(){return pl};var fl=function(){this._nodeList=new cl(this),this._pts=null,this._data=null;var t=arguments[0],e=arguments[1];this._pts=t,this._data=e};fl.prototype.getCoordinates=function(){return this._pts},fl.prototype.size=function(){return this._pts.length},fl.prototype.getCoordinate=function(t){return this._pts[t]},fl.prototype.isClosed=function(){return this._pts[0].equals(this._pts[this._pts.length-1])},fl.prototype.getSegmentOctant=function(t){return t===this._pts.length-1?-1:this.safeOctant(this.getCoordinate(t),this.getCoordinate(t+1))},fl.prototype.setData=function(t){this._data=t},fl.prototype.safeOctant=function(t,e){return t.equals2D(e)?0:hl.octant(t,e)},fl.prototype.getData=function(){return this._data},fl.prototype.addIntersection=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.addIntersectionNode(t,e)}else if(4===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[3],o=new bu(n.getIntersection(i));this.addIntersection(o,r)}},fl.prototype.toString=function(){return Ku.toLineString(new uh(this._pts))},fl.prototype.getNodeList=function(){return this._nodeList},fl.prototype.addIntersectionNode=function(t,e){var n=e,r=n+1;if(r<this._pts.length){var i=this._pts[r];t.equals2D(i)&&(n=r)}return this._nodeList.add(t,n)},fl.prototype.addIntersections=function(t,e,n){for(var r=0;r<t.getIntersectionNum();r++)this.addIntersection(t,e,n,r)},fl.prototype.interfaces_=function(){return[pl]},fl.prototype.getClass=function(){return fl},fl.getNodedSubstrings=function(){if(1===arguments.length){var t=arguments[0],e=new bc;return fl.getNodedSubstrings(t,e),e}if(2===arguments.length)for(var n=arguments[0],r=arguments[1],i=n.iterator();i.hasNext();){i.next().getNodeList().addSplitEdges(r)}};var gl=function(){if(this.p0=null,this.p1=null,0===arguments.length)this.p0=new bu,this.p1=new bu;else if(1===arguments.length){var t=arguments[0];this.p0=new bu(t.p0),this.p1=new bu(t.p1)}else if(2===arguments.length)this.p0=arguments[0],this.p1=arguments[1];else if(4===arguments.length){var e=arguments[0],n=arguments[1],r=arguments[2],i=arguments[3];this.p0=new bu(e,n),this.p1=new bu(r,i)}},dl={serialVersionUID:{configurable:!0}};gl.prototype.minX=function(){return Math.min(this.p0.x,this.p1.x)},gl.prototype.orientationIndex=function(){if(arguments[0]instanceof gl){var t=arguments[0],e=sc.orientationIndex(this.p0,this.p1,t.p0),n=sc.orientationIndex(this.p0,this.p1,t.p1);return e>=0&&n>=0?Math.max(e,n):e<=0&&n<=0?Math.max(e,n):0}if(arguments[0]instanceof bu){var r=arguments[0];return sc.orientationIndex(this.p0,this.p1,r)}},gl.prototype.toGeometry=function(t){return t.createLineString([this.p0,this.p1])},gl.prototype.isVertical=function(){return this.p0.x===this.p1.x},gl.prototype.equals=function(t){if(!(t instanceof gl))return!1;var e=t;return this.p0.equals(e.p0)&&this.p1.equals(e.p1)},gl.prototype.intersection=function(t){var e=new rc;return e.computeIntersection(this.p0,this.p1,t.p0,t.p1),e.hasIntersection()?e.getIntersection(0):null},gl.prototype.project=function(){if(arguments[0]instanceof bu){var t=arguments[0];if(t.equals(this.p0)||t.equals(this.p1))return new bu(t);var e=this.projectionFactor(t),n=new bu;return n.x=this.p0.x+e*(this.p1.x-this.p0.x),n.y=this.p0.y+e*(this.p1.y-this.p0.y),n}if(arguments[0]instanceof gl){var r=arguments[0],i=this.projectionFactor(r.p0),o=this.projectionFactor(r.p1);if(i>=1&&o>=1)return null;if(i<=0&&o<=0)return null;var s=this.project(r.p0);i<0&&(s=this.p0),i>1&&(s=this.p1);var a=this.project(r.p1);return o<0&&(a=this.p0),o>1&&(a=this.p1),new gl(s,a)}},gl.prototype.normalize=function(){this.p1.compareTo(this.p0)<0&&this.reverse()},gl.prototype.angle=function(){return Math.atan2(this.p1.y-this.p0.y,this.p1.x-this.p0.x)},gl.prototype.getCoordinate=function(t){return 0===t?this.p0:this.p1},gl.prototype.distancePerpendicular=function(t){return sc.distancePointLinePerpendicular(t,this.p0,this.p1)},gl.prototype.minY=function(){return Math.min(this.p0.y,this.p1.y)},gl.prototype.midPoint=function(){return gl.midPoint(this.p0,this.p1)},gl.prototype.projectionFactor=function(t){if(t.equals(this.p0))return 0;if(t.equals(this.p1))return 1;var e=this.p1.x-this.p0.x,n=this.p1.y-this.p0.y,r=e*e+n*n;if(r<=0)return mu.NaN;return((t.x-this.p0.x)*e+(t.y-this.p0.y)*n)/r},gl.prototype.closestPoints=function(t){var e=this.intersection(t);if(null!==e)return[e,e];var n=new Array(2).fill(null),r=mu.MAX_VALUE,i=null,o=this.closestPoint(t.p0);r=o.distance(t.p0),n[0]=o,n[1]=t.p0;var s=this.closestPoint(t.p1);(i=s.distance(t.p1))<r&&(r=i,n[0]=s,n[1]=t.p1);var a=t.closestPoint(this.p0);(i=a.distance(this.p0))<r&&(r=i,n[0]=this.p0,n[1]=a);var u=t.closestPoint(this.p1);return(i=u.distance(this.p1))<r&&(r=i,n[0]=this.p1,n[1]=u),n},gl.prototype.closestPoint=function(t){var e=this.projectionFactor(t);if(e>0&&e<1)return this.project(t);return this.p0.distance(t)<this.p1.distance(t)?this.p0:this.p1},gl.prototype.maxX=function(){return Math.max(this.p0.x,this.p1.x)},gl.prototype.getLength=function(){return this.p0.distance(this.p1)},gl.prototype.compareTo=function(t){var e=t,n=this.p0.compareTo(e.p0);return 0!==n?n:this.p1.compareTo(e.p1)},gl.prototype.reverse=function(){var t=this.p0;this.p0=this.p1,this.p1=t},gl.prototype.equalsTopo=function(t){return this.p0.equals(t.p0)&&(this.p1.equals(t.p1)||this.p0.equals(t.p1))&&this.p1.equals(t.p0)},gl.prototype.lineIntersection=function(t){try{return Uu.intersection(this.p0,this.p1,t.p0,t.p1)}catch(t){if(!(t instanceof ju))throw t}return null},gl.prototype.maxY=function(){return Math.max(this.p0.y,this.p1.y)},gl.prototype.pointAlongOffset=function(t,e){var n=this.p0.x+t*(this.p1.x-this.p0.x),r=this.p0.y+t*(this.p1.y-this.p0.y),i=this.p1.x-this.p0.x,o=this.p1.y-this.p0.y,s=Math.sqrt(i*i+o*o),a=0,u=0;if(0!==e){if(s<=0)throw new Error("Cannot compute offset from zero-length line segment");a=e*i/s,u=e*o/s}return new bu(n-u,r+a)},gl.prototype.setCoordinates=function(){if(1===arguments.length){var t=arguments[0];this.setCoordinates(t.p0,t.p1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.p0.x=e.x,this.p0.y=e.y,this.p1.x=n.x,this.p1.y=n.y}},gl.prototype.segmentFraction=function(t){var e=this.projectionFactor(t);return e<0?e=0:(e>1||mu.isNaN(e))&&(e=1),e},gl.prototype.toString=function(){return"LINESTRING( "+this.p0.x+" "+this.p0.y+", "+this.p1.x+" "+this.p1.y+")"},gl.prototype.isHorizontal=function(){return this.p0.y===this.p1.y},gl.prototype.distance=function(){if(arguments[0]instanceof gl){var t=arguments[0];return sc.distanceLineLine(this.p0,this.p1,t.p0,t.p1)}if(arguments[0]instanceof bu){var e=arguments[0];return sc.distancePointLine(e,this.p0,this.p1)}},gl.prototype.pointAlong=function(t){var e=new bu;return e.x=this.p0.x+t*(this.p1.x-this.p0.x),e.y=this.p0.y+t*(this.p1.y-this.p0.y),e},gl.prototype.hashCode=function(){var t=mu.doubleToLongBits(this.p0.x);t^=31*mu.doubleToLongBits(this.p0.y);var e=Math.trunc(t)^Math.trunc(t>>32),n=mu.doubleToLongBits(this.p1.x);n^=31*mu.doubleToLongBits(this.p1.y);return e^(Math.trunc(n)^Math.trunc(n>>32))},gl.prototype.interfaces_=function(){return[xu,Li]},gl.prototype.getClass=function(){return gl},gl.midPoint=function(t,e){return new bu((t.x+e.x)/2,(t.y+e.y)/2)},dl.serialVersionUID.get=function(){return 0x2d2172135f411c00},Object.defineProperties(gl,dl);var yl=function(){this.tempEnv1=new Yu,this.tempEnv2=new Yu,this._overlapSeg1=new gl,this._overlapSeg2=new gl};yl.prototype.overlap=function(){if(2===arguments.length);else if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],r=arguments[3];t.getLineSegment(e,this._overlapSeg1),n.getLineSegment(r,this._overlapSeg2),this.overlap(this._overlapSeg1,this._overlapSeg2)}},yl.prototype.interfaces_=function(){return[]},yl.prototype.getClass=function(){return yl};var _l=function(){this._pts=null,this._start=null,this._end=null,this._env=null,this._context=null,this._id=null;var t=arguments[0],e=arguments[1],n=arguments[2],r=arguments[3];this._pts=t,this._start=e,this._end=n,this._context=r};_l.prototype.getLineSegment=function(t,e){e.p0=this._pts[t],e.p1=this._pts[t+1]},_l.prototype.computeSelect=function(t,e,n,r){var i=this._pts[e],o=this._pts[n];if(r.tempEnv1.init(i,o),n-e==1)return r.select(this,e),null;if(!t.intersects(r.tempEnv1))return null;var s=Math.trunc((e+n)/2);e<s&&this.computeSelect(t,e,s,r),s<n&&this.computeSelect(t,s,n,r)},_l.prototype.getCoordinates=function(){for(var t=new Array(this._end-this._start+1).fill(null),e=0,n=this._start;n<=this._end;n++)t[e++]=this._pts[n];return t},_l.prototype.computeOverlaps=function(t,e){this.computeOverlapsInternal(this._start,this._end,t,t._start,t._end,e)},_l.prototype.setId=function(t){this._id=t},_l.prototype.select=function(t,e){this.computeSelect(t,this._start,this._end,e)},_l.prototype.getEnvelope=function(){if(null===this._env){var t=this._pts[this._start],e=this._pts[this._end];this._env=new Yu(t,e)}return this._env},_l.prototype.getEndIndex=function(){return this._end},_l.prototype.getStartIndex=function(){return this._start},_l.prototype.getContext=function(){return this._context},_l.prototype.getId=function(){return this._id},_l.prototype.computeOverlapsInternal=function(t,e,n,r,i,o){var s=this._pts[t],a=this._pts[e],u=n._pts[r],c=n._pts[i];if(e-t==1&&i-r==1)return o.overlap(this,t,n,r),null;if(o.tempEnv1.init(s,a),o.tempEnv2.init(u,c),!o.tempEnv1.intersects(o.tempEnv2))return null;var h=Math.trunc((t+e)/2),l=Math.trunc((r+i)/2);t<h&&(r<l&&this.computeOverlapsInternal(t,h,n,r,l,o),l<i&&this.computeOverlapsInternal(t,h,n,l,i,o)),h<e&&(r<l&&this.computeOverlapsInternal(h,e,n,r,l,o),l<i&&this.computeOverlapsInternal(h,e,n,l,i,o))},_l.prototype.interfaces_=function(){return[]},_l.prototype.getClass=function(){return _l};var ml=function(){};ml.prototype.interfaces_=function(){return[]},ml.prototype.getClass=function(){return ml},ml.getChainStartIndices=function(t){var e=0,n=new bc;n.add(new Tu(e));do{var r=ml.findChainEnd(t,e);n.add(new Tu(r)),e=r}while(e<t.length-1);return ml.toIntArray(n)},ml.findChainEnd=function(t,e){for(var n=e;n<t.length-1&&t[n].equals2D(t[n+1]);)n++;if(n>=t.length-1)return t.length-1;for(var r=Bh.quadrant(t[n],t[n+1]),i=e+1;i<t.length;){if(!t[i-1].equals2D(t[i])){if(Bh.quadrant(t[i-1],t[i])!==r)break}i++}return i-1},ml.getChains=function(){if(1===arguments.length){var t=arguments[0];return ml.getChains(t,null)}if(2===arguments.length){for(var e=arguments[0],n=arguments[1],r=new bc,i=ml.getChainStartIndices(e),o=0;o<i.length-1;o++){var s=new _l(e,i[o],i[o+1],n);r.add(s)}return r}},ml.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e};var vl=function(){};vl.prototype.computeNodes=function(t){},vl.prototype.getNodedSubstrings=function(){},vl.prototype.interfaces_=function(){return[]},vl.prototype.getClass=function(){return vl};var xl=function(){if(this._segInt=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.setSegmentIntersector(t)}};xl.prototype.setSegmentIntersector=function(t){this._segInt=t},xl.prototype.interfaces_=function(){return[vl]},xl.prototype.getClass=function(){return xl};var El=function(t){function e(e){e?t.call(this,e):t.call(this),this._monoChains=new bc,this._index=new ol,this._idCounter=0,this._nodedSegStrings=null,this._nOverlaps=0}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={SegmentOverlapAction:{configurable:!0}};return e.prototype.getMonotoneChains=function(){return this._monoChains},e.prototype.getNodedSubstrings=function(){return fl.getNodedSubstrings(this._nodedSegStrings)},e.prototype.getIndex=function(){return this._index},e.prototype.add=function(t){for(var e=ml.getChains(t.getCoordinates(),t).iterator();e.hasNext();){var n=e.next();n.setId(this._idCounter++),this._index.insert(n.getEnvelope(),n),this._monoChains.add(n)}},e.prototype.computeNodes=function(t){this._nodedSegStrings=t;for(var e=t.iterator();e.hasNext();)this.add(e.next());this.intersectChains()},e.prototype.intersectChains=function(){for(var t=new wl(this._segInt),e=this._monoChains.iterator();e.hasNext();)for(var n=e.next(),r=this._index.query(n.getEnvelope()).iterator();r.hasNext();){var i=r.next();if(i.getId()>n.getId()&&(n.computeOverlaps(i,t),this._nOverlaps++),this._segInt.isDone())return null}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.SegmentOverlapAction.get=function(){return wl},Object.defineProperties(e,n),e}(xl),wl=function(t){function e(){t.call(this),this._si=null;var e=arguments[0];this._si=e}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.overlap=function(){if(4!==arguments.length)return t.prototype.overlap.apply(this,arguments);var e=arguments[0],n=arguments[1],r=arguments[2],i=arguments[3],o=e.getContext(),s=r.getContext();this._si.processIntersections(o,n,s,i)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(yl),bl=function t(){if(this._quadrantSegments=t.DEFAULT_QUADRANT_SEGMENTS,this._endCapStyle=t.CAP_ROUND,this._joinStyle=t.JOIN_ROUND,this._mitreLimit=t.DEFAULT_MITRE_LIMIT,this._isSingleSided=!1,this._simplifyFactor=t.DEFAULT_SIMPLIFY_FACTOR,0===arguments.length);else if(1===arguments.length){var e=arguments[0];this.setQuadrantSegments(e)}else if(2===arguments.length){var n=arguments[0],r=arguments[1];this.setQuadrantSegments(n),this.setEndCapStyle(r)}else if(4===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];this.setQuadrantSegments(i),this.setEndCapStyle(o),this.setJoinStyle(s),this.setMitreLimit(a)}},Il={CAP_ROUND:{configurable:!0},CAP_FLAT:{configurable:!0},CAP_SQUARE:{configurable:!0},JOIN_ROUND:{configurable:!0},JOIN_MITRE:{configurable:!0},JOIN_BEVEL:{configurable:!0},DEFAULT_QUADRANT_SEGMENTS:{configurable:!0},DEFAULT_MITRE_LIMIT:{configurable:!0},DEFAULT_SIMPLIFY_FACTOR:{configurable:!0}};bl.prototype.getEndCapStyle=function(){return this._endCapStyle},bl.prototype.isSingleSided=function(){return this._isSingleSided},bl.prototype.setQuadrantSegments=function(t){this._quadrantSegments=t,0===this._quadrantSegments&&(this._joinStyle=bl.JOIN_BEVEL),this._quadrantSegments<0&&(this._joinStyle=bl.JOIN_MITRE,this._mitreLimit=Math.abs(this._quadrantSegments)),t<=0&&(this._quadrantSegments=1),this._joinStyle!==bl.JOIN_ROUND&&(this._quadrantSegments=bl.DEFAULT_QUADRANT_SEGMENTS)},bl.prototype.getJoinStyle=function(){return this._joinStyle},bl.prototype.setJoinStyle=function(t){this._joinStyle=t},bl.prototype.setSimplifyFactor=function(t){this._simplifyFactor=t<0?0:t},bl.prototype.getSimplifyFactor=function(){return this._simplifyFactor},bl.prototype.getQuadrantSegments=function(){return this._quadrantSegments},bl.prototype.setEndCapStyle=function(t){this._endCapStyle=t},bl.prototype.getMitreLimit=function(){return this._mitreLimit},bl.prototype.setMitreLimit=function(t){this._mitreLimit=t},bl.prototype.setSingleSided=function(t){this._isSingleSided=t},bl.prototype.interfaces_=function(){return[]},bl.prototype.getClass=function(){return bl},bl.bufferDistanceError=function(t){var e=Math.PI/2/t;return 1-Math.cos(e/2)},Il.CAP_ROUND.get=function(){return 1},Il.CAP_FLAT.get=function(){return 2},Il.CAP_SQUARE.get=function(){return 3},Il.JOIN_ROUND.get=function(){return 1},Il.JOIN_MITRE.get=function(){return 2},Il.JOIN_BEVEL.get=function(){return 3},Il.DEFAULT_QUADRANT_SEGMENTS.get=function(){return 8},Il.DEFAULT_MITRE_LIMIT.get=function(){return 5},Il.DEFAULT_SIMPLIFY_FACTOR.get=function(){return.01},Object.defineProperties(bl,Il);var Nl=function(t){this._distanceTol=null,this._isDeleted=null,this._angleOrientation=sc.COUNTERCLOCKWISE,this._inputLine=t||null},Cl={INIT:{configurable:!0},DELETE:{configurable:!0},KEEP:{configurable:!0},NUM_PTS_TO_CHECK:{configurable:!0}};Nl.prototype.isDeletable=function(t,e,n,r){var i=this._inputLine[t],o=this._inputLine[e],s=this._inputLine[n];return!!this.isConcave(i,o,s)&&(!!this.isShallow(i,o,s,r)&&this.isShallowSampled(i,o,t,n,r))},Nl.prototype.deleteShallowConcavities=function(){for(var t=1,e=this.findNextNonDeletedIndex(t),n=this.findNextNonDeletedIndex(e),r=!1;n<this._inputLine.length;){var i=!1;this.isDeletable(t,e,n,this._distanceTol)&&(this._isDeleted[e]=Nl.DELETE,i=!0,r=!0),t=i?n:e,e=this.findNextNonDeletedIndex(t),n=this.findNextNonDeletedIndex(e)}return r},Nl.prototype.isShallowConcavity=function(t,e,n,r){if(!(sc.computeOrientation(t,e,n)===this._angleOrientation))return!1;return sc.distancePointLine(e,t,n)<r},Nl.prototype.isShallowSampled=function(t,e,n,r,i){var o=Math.trunc((r-n)/Nl.NUM_PTS_TO_CHECK);o<=0&&(o=1);for(var s=n;s<r;s+=o)if(!this.isShallow(t,e,this._inputLine[s],i))return!1;return!0},Nl.prototype.isConcave=function(t,e,n){var r=sc.computeOrientation(t,e,n)===this._angleOrientation;return r},Nl.prototype.simplify=function(t){this._distanceTol=Math.abs(t),t<0&&(this._angleOrientation=sc.CLOCKWISE),this._isDeleted=new Array(this._inputLine.length).fill(null);var e=!1;do{e=this.deleteShallowConcavities()}while(e);return this.collapseLine()},Nl.prototype.findNextNonDeletedIndex=function(t){for(var e=t+1;e<this._inputLine.length&&this._isDeleted[e]===Nl.DELETE;)e++;return e},Nl.prototype.isShallow=function(t,e,n,r){return sc.distancePointLine(e,t,n)<r},Nl.prototype.collapseLine=function(){for(var t=new Nc,e=0;e<this._inputLine.length;e++)this._isDeleted[e]!==Nl.DELETE&&t.add(this._inputLine[e]);return t.toCoordinateArray()},Nl.prototype.interfaces_=function(){return[]},Nl.prototype.getClass=function(){return Nl},Nl.simplify=function(t,e){return new Nl(t).simplify(e)},Cl.INIT.get=function(){return 0},Cl.DELETE.get=function(){return 1},Cl.KEEP.get=function(){return 1},Cl.NUM_PTS_TO_CHECK.get=function(){return 10},Object.defineProperties(Nl,Cl);var Sl=function(){this._ptList=null,this._precisionModel=null,this._minimimVertexDistance=0,this._ptList=new bc},Ml={COORDINATE_ARRAY_TYPE:{configurable:!0}};Sl.prototype.getCoordinates=function(){return this._ptList.toArray(Sl.COORDINATE_ARRAY_TYPE)},Sl.prototype.setPrecisionModel=function(t){this._precisionModel=t},Sl.prototype.addPt=function(t){var e=new bu(t);if(this._precisionModel.makePrecise(e),this.isRedundant(e))return null;this._ptList.add(e)},Sl.prototype.revere=function(){},Sl.prototype.addPts=function(t,e){if(e)for(var n=0;n<t.length;n++)this.addPt(t[n]);else for(var r=t.length-1;r>=0;r--)this.addPt(t[r])},Sl.prototype.isRedundant=function(t){if(this._ptList.size()<1)return!1;var e=this._ptList.get(this._ptList.size()-1);return t.distance(e)<this._minimimVertexDistance},Sl.prototype.toString=function(){return(new _h).createLineString(this.getCoordinates()).toString()},Sl.prototype.closeRing=function(){if(this._ptList.size()<1)return null;var t=new bu(this._ptList.get(0)),e=this._ptList.get(this._ptList.size()-1);if(t.equals(e))return null;this._ptList.add(t)},Sl.prototype.setMinimumVertexDistance=function(t){this._minimimVertexDistance=t},Sl.prototype.interfaces_=function(){return[]},Sl.prototype.getClass=function(){return Sl},Ml.COORDINATE_ARRAY_TYPE.get=function(){return new Array(0).fill(null)},Object.defineProperties(Sl,Ml);var Ll=function(){},Pl={PI_TIMES_2:{configurable:!0},PI_OVER_2:{configurable:!0},PI_OVER_4:{configurable:!0},COUNTERCLOCKWISE:{configurable:!0},CLOCKWISE:{configurable:!0},NONE:{configurable:!0}};Ll.prototype.interfaces_=function(){return[]},Ll.prototype.getClass=function(){return Ll},Ll.toDegrees=function(t){return 180*t/Math.PI},Ll.normalize=function(t){for(;t>Math.PI;)t-=Ll.PI_TIMES_2;for(;t<=-Math.PI;)t+=Ll.PI_TIMES_2;return t},Ll.angle=function(){if(1===arguments.length){var t=arguments[0];return Math.atan2(t.y,t.x)}if(2===arguments.length){var e=arguments[0],n=arguments[1],r=n.x-e.x,i=n.y-e.y;return Math.atan2(i,r)}},Ll.isAcute=function(t,e,n){var r=t.x-e.x,i=t.y-e.y;return r*(n.x-e.x)+i*(n.y-e.y)>0},Ll.isObtuse=function(t,e,n){var r=t.x-e.x,i=t.y-e.y;return r*(n.x-e.x)+i*(n.y-e.y)<0},Ll.interiorAngle=function(t,e,n){var r=Ll.angle(e,t),i=Ll.angle(e,n);return Math.abs(i-r)},Ll.normalizePositive=function(t){if(t<0){for(;t<0;)t+=Ll.PI_TIMES_2;t>=Ll.PI_TIMES_2&&(t=0)}else{for(;t>=Ll.PI_TIMES_2;)t-=Ll.PI_TIMES_2;t<0&&(t=0)}return t},Ll.angleBetween=function(t,e,n){var r=Ll.angle(e,t),i=Ll.angle(e,n);return Ll.diff(r,i)},Ll.diff=function(t,e){var n=null;return(n=t<e?e-t:t-e)>Math.PI&&(n=2*Math.PI-n),n},Ll.toRadians=function(t){return t*Math.PI/180},Ll.getTurn=function(t,e){var n=Math.sin(e-t);return n>0?Ll.COUNTERCLOCKWISE:n<0?Ll.CLOCKWISE:Ll.NONE},Ll.angleBetweenOriented=function(t,e,n){var r=Ll.angle(e,t),i=Ll.angle(e,n)-r;return i<=-Math.PI?i+Ll.PI_TIMES_2:i>Math.PI?i-Ll.PI_TIMES_2:i},Pl.PI_TIMES_2.get=function(){return 2*Math.PI},Pl.PI_OVER_2.get=function(){return Math.PI/2},Pl.PI_OVER_4.get=function(){return Math.PI/4},Pl.COUNTERCLOCKWISE.get=function(){return sc.COUNTERCLOCKWISE},Pl.CLOCKWISE.get=function(){return sc.CLOCKWISE},Pl.NONE.get=function(){return sc.COLLINEAR},Object.defineProperties(Ll,Pl);var Ol=function t(){this._maxCurveSegmentError=0,this._filletAngleQuantum=null,this._closingSegLengthFactor=1,this._segList=null,this._distance=0,this._precisionModel=null,this._bufParams=null,this._li=null,this._s0=null,this._s1=null,this._s2=null,this._seg0=new gl,this._seg1=new gl,this._offset0=new gl,this._offset1=new gl,this._side=0,this._hasNarrowConcaveAngle=!1;var e=arguments[0],n=arguments[1],r=arguments[2];this._precisionModel=e,this._bufParams=n,this._li=new rc,this._filletAngleQuantum=Math.PI/2/n.getQuadrantSegments(),n.getQuadrantSegments()>=8&&n.getJoinStyle()===bl.JOIN_ROUND&&(this._closingSegLengthFactor=t.MAX_CLOSING_SEG_LEN_FACTOR),this.init(r)},Rl={OFFSET_SEGMENT_SEPARATION_FACTOR:{configurable:!0},INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR:{configurable:!0},CURVE_VERTEX_SNAP_DISTANCE_FACTOR:{configurable:!0},MAX_CLOSING_SEG_LEN_FACTOR:{configurable:!0}};Ol.prototype.addNextSegment=function(t,e){if(this._s0=this._s1,this._s1=this._s2,this._s2=t,this._seg0.setCoordinates(this._s0,this._s1),this.computeOffsetSegment(this._seg0,this._side,this._distance,this._offset0),this._seg1.setCoordinates(this._s1,this._s2),this.computeOffsetSegment(this._seg1,this._side,this._distance,this._offset1),this._s1.equals(this._s2))return null;var n=sc.computeOrientation(this._s0,this._s1,this._s2),r=n===sc.CLOCKWISE&&this._side===Nh.LEFT||n===sc.COUNTERCLOCKWISE&&this._side===Nh.RIGHT;0===n?this.addCollinear(e):r?this.addOutsideTurn(n,e):this.addInsideTurn(n,e)},Ol.prototype.addLineEndCap=function(t,e){var n=new gl(t,e),r=new gl;this.computeOffsetSegment(n,Nh.LEFT,this._distance,r);var i=new gl;this.computeOffsetSegment(n,Nh.RIGHT,this._distance,i);var o=e.x-t.x,s=e.y-t.y,a=Math.atan2(s,o);switch(this._bufParams.getEndCapStyle()){case bl.CAP_ROUND:this._segList.addPt(r.p1),this.addFilletArc(e,a+Math.PI/2,a-Math.PI/2,sc.CLOCKWISE,this._distance),this._segList.addPt(i.p1);break;case bl.CAP_FLAT:this._segList.addPt(r.p1),this._segList.addPt(i.p1);break;case bl.CAP_SQUARE:var u=new bu;u.x=Math.abs(this._distance)*Math.cos(a),u.y=Math.abs(this._distance)*Math.sin(a);var c=new bu(r.p1.x+u.x,r.p1.y+u.y),h=new bu(i.p1.x+u.x,i.p1.y+u.y);this._segList.addPt(c),this._segList.addPt(h)}},Ol.prototype.getCoordinates=function(){return this._segList.getCoordinates()},Ol.prototype.addMitreJoin=function(t,e,n,r){var i=!0,o=null;try{o=Uu.intersection(e.p0,e.p1,n.p0,n.p1);(r<=0?1:o.distance(t)/Math.abs(r))>this._bufParams.getMitreLimit()&&(i=!1)}catch(t){if(!(t instanceof ju))throw t;o=new bu(0,0),i=!1}i?this._segList.addPt(o):this.addLimitedMitreJoin(e,n,r,this._bufParams.getMitreLimit())},Ol.prototype.addFilletCorner=function(t,e,n,r,i){var o=e.x-t.x,s=e.y-t.y,a=Math.atan2(s,o),u=n.x-t.x,c=n.y-t.y,h=Math.atan2(c,u);r===sc.CLOCKWISE?a<=h&&(a+=2*Math.PI):a>=h&&(a-=2*Math.PI),this._segList.addPt(e),this.addFilletArc(t,a,h,r,i),this._segList.addPt(n)},Ol.prototype.addOutsideTurn=function(t,e){if(this._offset0.p1.distance(this._offset1.p0)<this._distance*Ol.OFFSET_SEGMENT_SEPARATION_FACTOR)return this._segList.addPt(this._offset0.p1),null;this._bufParams.getJoinStyle()===bl.JOIN_MITRE?this.addMitreJoin(this._s1,this._offset0,this._offset1,this._distance):this._bufParams.getJoinStyle()===bl.JOIN_BEVEL?this.addBevelJoin(this._offset0,this._offset1):(e&&this._segList.addPt(this._offset0.p1),this.addFilletCorner(this._s1,this._offset0.p1,this._offset1.p0,t,this._distance),this._segList.addPt(this._offset1.p0))},Ol.prototype.createSquare=function(t){this._segList.addPt(new bu(t.x+this._distance,t.y+this._distance)),this._segList.addPt(new bu(t.x+this._distance,t.y-this._distance)),this._segList.addPt(new bu(t.x-this._distance,t.y-this._distance)),this._segList.addPt(new bu(t.x-this._distance,t.y+this._distance)),this._segList.closeRing()},Ol.prototype.addSegments=function(t,e){this._segList.addPts(t,e)},Ol.prototype.addFirstSegment=function(){this._segList.addPt(this._offset1.p0)},Ol.prototype.addLastSegment=function(){this._segList.addPt(this._offset1.p1)},Ol.prototype.initSideSegments=function(t,e,n){this._s1=t,this._s2=e,this._side=n,this._seg1.setCoordinates(t,e),this.computeOffsetSegment(this._seg1,n,this._distance,this._offset1)},Ol.prototype.addLimitedMitreJoin=function(t,e,n,r){var i=this._seg0.p1,o=Ll.angle(i,this._seg0.p0),s=Ll.angleBetweenOriented(this._seg0.p0,i,this._seg1.p1)/2,a=Ll.normalize(o+s),u=Ll.normalize(a+Math.PI),c=r*n,h=n-c*Math.abs(Math.sin(s)),l=i.x+c*Math.cos(u),p=i.y+c*Math.sin(u),f=new bu(l,p),g=new gl(i,f),d=g.pointAlongOffset(1,h),y=g.pointAlongOffset(1,-h);this._side===Nh.LEFT?(this._segList.addPt(d),this._segList.addPt(y)):(this._segList.addPt(y),this._segList.addPt(d))},Ol.prototype.computeOffsetSegment=function(t,e,n,r){var i=e===Nh.LEFT?1:-1,o=t.p1.x-t.p0.x,s=t.p1.y-t.p0.y,a=Math.sqrt(o*o+s*s),u=i*n*o/a,c=i*n*s/a;r.p0.x=t.p0.x-c,r.p0.y=t.p0.y+u,r.p1.x=t.p1.x-c,r.p1.y=t.p1.y+u},Ol.prototype.addFilletArc=function(t,e,n,r,i){var o=r===sc.CLOCKWISE?-1:1,s=Math.abs(e-n),a=Math.trunc(s/this._filletAngleQuantum+.5);if(a<1)return null;for(var u=s/a,c=0,h=new bu;c<s;){var l=e+o*c;h.x=t.x+i*Math.cos(l),h.y=t.y+i*Math.sin(l),this._segList.addPt(h),c+=u}},Ol.prototype.addInsideTurn=function(t,e){if(this._li.computeIntersection(this._offset0.p0,this._offset0.p1,this._offset1.p0,this._offset1.p1),this._li.hasIntersection())this._segList.addPt(this._li.getIntersection(0));else if(this._hasNarrowConcaveAngle=!0,this._offset0.p1.distance(this._offset1.p0)<this._distance*Ol.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR)this._segList.addPt(this._offset0.p1);else{if(this._segList.addPt(this._offset0.p1),this._closingSegLengthFactor>0){var n=new bu((this._closingSegLengthFactor*this._offset0.p1.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset0.p1.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(n);var r=new bu((this._closingSegLengthFactor*this._offset1.p0.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset1.p0.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(r)}else this._segList.addPt(this._s1);this._segList.addPt(this._offset1.p0)}},Ol.prototype.createCircle=function(t){var e=new bu(t.x+this._distance,t.y);this._segList.addPt(e),this.addFilletArc(t,0,2*Math.PI,-1,this._distance),this._segList.closeRing()},Ol.prototype.addBevelJoin=function(t,e){this._segList.addPt(t.p1),this._segList.addPt(e.p0)},Ol.prototype.init=function(t){this._distance=t,this._maxCurveSegmentError=t*(1-Math.cos(this._filletAngleQuantum/2)),this._segList=new Sl,this._segList.setPrecisionModel(this._precisionModel),this._segList.setMinimumVertexDistance(t*Ol.CURVE_VERTEX_SNAP_DISTANCE_FACTOR)},Ol.prototype.addCollinear=function(t){this._li.computeIntersection(this._s0,this._s1,this._s1,this._s2);this._li.getIntersectionNum()>=2&&(this._bufParams.getJoinStyle()===bl.JOIN_BEVEL||this._bufParams.getJoinStyle()===bl.JOIN_MITRE?(t&&this._segList.addPt(this._offset0.p1),this._segList.addPt(this._offset1.p0)):this.addFilletCorner(this._s1,this._offset0.p1,this._offset1.p0,sc.CLOCKWISE,this._distance))},Ol.prototype.closeRing=function(){this._segList.closeRing()},Ol.prototype.hasNarrowConcaveAngle=function(){return this._hasNarrowConcaveAngle},Ol.prototype.interfaces_=function(){return[]},Ol.prototype.getClass=function(){return Ol},Rl.OFFSET_SEGMENT_SEPARATION_FACTOR.get=function(){return.001},Rl.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get=function(){return.001},Rl.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get=function(){return 1e-6},Rl.MAX_CLOSING_SEG_LEN_FACTOR.get=function(){return 80},Object.defineProperties(Ol,Rl);var Tl=function(){this._distance=0,this._precisionModel=null,this._bufParams=null;var t=arguments[0],e=arguments[1];this._precisionModel=t,this._bufParams=e};Tl.prototype.getOffsetCurve=function(t,e){if(this._distance=e,0===e)return null;var n=e<0,r=Math.abs(e),i=this.getSegGen(r);t.length<=1?this.computePointCurve(t[0],i):this.computeOffsetCurve(t,n,i);var o=i.getCoordinates();return n&&Cc.reverse(o),o},Tl.prototype.computeSingleSidedBufferCurve=function(t,e,n){var r=this.simplifyTolerance(this._distance);if(e){n.addSegments(t,!0);var i=Nl.simplify(t,-r),o=i.length-1;n.initSideSegments(i[o],i[o-1],Nh.LEFT),n.addFirstSegment();for(var s=o-2;s>=0;s--)n.addNextSegment(i[s],!0)}else{n.addSegments(t,!1);var a=Nl.simplify(t,r),u=a.length-1;n.initSideSegments(a[0],a[1],Nh.LEFT),n.addFirstSegment();for(var c=2;c<=u;c++)n.addNextSegment(a[c],!0)}n.addLastSegment(),n.closeRing()},Tl.prototype.computeRingBufferCurve=function(t,e,n){var r=this.simplifyTolerance(this._distance);e===Nh.RIGHT&&(r=-r);var i=Nl.simplify(t,r),o=i.length-1;n.initSideSegments(i[o-1],i[0],e);for(var s=1;s<=o;s++){var a=1!==s;n.addNextSegment(i[s],a)}n.closeRing()},Tl.prototype.computeLineBufferCurve=function(t,e){var n=this.simplifyTolerance(this._distance),r=Nl.simplify(t,n),i=r.length-1;e.initSideSegments(r[0],r[1],Nh.LEFT);for(var o=2;o<=i;o++)e.addNextSegment(r[o],!0);e.addLastSegment(),e.addLineEndCap(r[i-1],r[i]);var s=Nl.simplify(t,-n),a=s.length-1;e.initSideSegments(s[a],s[a-1],Nh.LEFT);for(var u=a-2;u>=0;u--)e.addNextSegment(s[u],!0);e.addLastSegment(),e.addLineEndCap(s[1],s[0]),e.closeRing()},Tl.prototype.computePointCurve=function(t,e){switch(this._bufParams.getEndCapStyle()){case bl.CAP_ROUND:e.createCircle(t);break;case bl.CAP_SQUARE:e.createSquare(t)}},Tl.prototype.getLineCurve=function(t,e){if(this._distance=e,e<0&&!this._bufParams.isSingleSided())return null;if(0===e)return null;var n=Math.abs(e),r=this.getSegGen(n);if(t.length<=1)this.computePointCurve(t[0],r);else if(this._bufParams.isSingleSided()){var i=e<0;this.computeSingleSidedBufferCurve(t,i,r)}else this.computeLineBufferCurve(t,r);return r.getCoordinates()},Tl.prototype.getBufferParameters=function(){return this._bufParams},Tl.prototype.simplifyTolerance=function(t){return t*this._bufParams.getSimplifyFactor()},Tl.prototype.getRingCurve=function(t,e,n){if(this._distance=n,t.length<=2)return this.getLineCurve(t,n);if(0===n)return Tl.copyCoordinates(t);var r=this.getSegGen(n);return this.computeRingBufferCurve(t,e,r),r.getCoordinates()},Tl.prototype.computeOffsetCurve=function(t,e,n){var r=this.simplifyTolerance(this._distance);if(e){var i=Nl.simplify(t,-r),o=i.length-1;n.initSideSegments(i[o],i[o-1],Nh.LEFT),n.addFirstSegment();for(var s=o-2;s>=0;s--)n.addNextSegment(i[s],!0)}else{var a=Nl.simplify(t,r),u=a.length-1;n.initSideSegments(a[0],a[1],Nh.LEFT),n.addFirstSegment();for(var c=2;c<=u;c++)n.addNextSegment(a[c],!0)}n.addLastSegment()},Tl.prototype.getSegGen=function(t){return new Ol(this._precisionModel,this._bufParams,t)},Tl.prototype.interfaces_=function(){return[]},Tl.prototype.getClass=function(){return Tl},Tl.copyCoordinates=function(t){for(var e=new Array(t.length).fill(null),n=0;n<e.length;n++)e[n]=new bu(t[n]);return e};var Al=function(){this._subgraphs=null,this._seg=new gl,this._cga=new sc;var t=arguments[0];this._subgraphs=t},Dl={DepthSegment:{configurable:!0}};Al.prototype.findStabbedSegments=function(){if(1===arguments.length){for(var t=arguments[0],e=new bc,n=this._subgraphs.iterator();n.hasNext();){var r=n.next(),i=r.getEnvelope();t.y<i.getMinY()||t.y>i.getMaxY()||this.findStabbedSegments(t,r.getDirectedEdges(),e)}return e}if(3===arguments.length)if(Lu(arguments[2],wc)&&arguments[0]instanceof bu&&arguments[1]instanceof jh)for(var o=arguments[0],s=arguments[1],a=arguments[2],u=s.getEdge().getCoordinates(),c=0;c<u.length-1;c++){this._seg.p0=u[c],this._seg.p1=u[c+1],this._seg.p0.y>this._seg.p1.y&&this._seg.reverse();if(!(Math.max(this._seg.p0.x,this._seg.p1.x)<o.x)&&!(this._seg.isHorizontal()||o.y<this._seg.p0.y||o.y>this._seg.p1.y||sc.computeOrientation(this._seg.p0,this._seg.p1,o)===sc.RIGHT)){var h=s.getDepth(Nh.LEFT);this._seg.p0.equals(u[c])||(h=s.getDepth(Nh.RIGHT));var l=new Fl(this._seg,h);a.add(l)}}else if(Lu(arguments[2],wc)&&arguments[0]instanceof bu&&Lu(arguments[1],wc))for(var p=arguments[0],f=arguments[1],g=arguments[2],d=f.iterator();d.hasNext();){var y=d.next();y.isForward()&&this.findStabbedSegments(p,y,g)}},Al.prototype.getDepth=function(t){var e=this.findStabbedSegments(t);if(0===e.size())return 0;return $h.min(e)._leftDepth},Al.prototype.interfaces_=function(){return[]},Al.prototype.getClass=function(){return Al},Dl.DepthSegment.get=function(){return Fl},Object.defineProperties(Al,Dl);var Fl=function(){this._upwardSeg=null,this._leftDepth=null;var t=arguments[0],e=arguments[1];this._upwardSeg=new gl(t),this._leftDepth=e};Fl.prototype.compareTo=function(t){var e=t;if(this._upwardSeg.minX()>=e._upwardSeg.maxX())return 1;if(this._upwardSeg.maxX()<=e._upwardSeg.minX())return-1;var n=this._upwardSeg.orientationIndex(e._upwardSeg);return 0!==n?n:0!=(n=-1*e._upwardSeg.orientationIndex(this._upwardSeg))?n:this._upwardSeg.compareTo(e._upwardSeg)},Fl.prototype.compareX=function(t,e){var n=t.p0.compareTo(e.p0);return 0!==n?n:t.p1.compareTo(e.p1)},Fl.prototype.toString=function(){return this._upwardSeg.toString()},Fl.prototype.interfaces_=function(){return[xu]},Fl.prototype.getClass=function(){return Fl};var ql=function(t,e,n){this.p0=t||null,this.p1=e||null,this.p2=n||null};ql.prototype.area=function(){return ql.area(this.p0,this.p1,this.p2)},ql.prototype.signedArea=function(){return ql.signedArea(this.p0,this.p1,this.p2)},ql.prototype.interpolateZ=function(t){if(null===t)throw new _u("Supplied point is null.");return ql.interpolateZ(t,this.p0,this.p1,this.p2)},ql.prototype.longestSideLength=function(){return ql.longestSideLength(this.p0,this.p1,this.p2)},ql.prototype.isAcute=function(){return ql.isAcute(this.p0,this.p1,this.p2)},ql.prototype.circumcentre=function(){return ql.circumcentre(this.p0,this.p1,this.p2)},ql.prototype.area3D=function(){return ql.area3D(this.p0,this.p1,this.p2)},ql.prototype.centroid=function(){return ql.centroid(this.p0,this.p1,this.p2)},ql.prototype.inCentre=function(){return ql.inCentre(this.p0,this.p1,this.p2)},ql.prototype.interfaces_=function(){return[]},ql.prototype.getClass=function(){return ql},ql.area=function(t,e,n){return Math.abs(((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2)},ql.signedArea=function(t,e,n){return((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2},ql.det=function(t,e,n,r){return t*r-e*n},ql.interpolateZ=function(t,e,n,r){var i=e.x,o=e.y,s=n.x-i,a=r.x-i,u=n.y-o,c=r.y-o,h=s*c-a*u,l=t.x-i,p=t.y-o,f=(c*l-a*p)/h,g=(-u*l+s*p)/h;return e.z+f*(n.z-e.z)+g*(r.z-e.z)},ql.longestSideLength=function(t,e,n){var r=t.distance(e),i=e.distance(n),o=n.distance(t),s=r;return i>s&&(s=i),o>s&&(s=o),s},ql.isAcute=function(t,e,n){return!!Ll.isAcute(t,e,n)&&(!!Ll.isAcute(e,n,t)&&!!Ll.isAcute(n,t,e))},ql.circumcentre=function(t,e,n){var r=n.x,i=n.y,o=t.x-r,s=t.y-i,a=e.x-r,u=e.y-i,c=2*ql.det(o,s,a,u),h=ql.det(s,o*o+s*s,u,a*a+u*u),l=ql.det(o,o*o+s*s,a,a*a+u*u);return new bu(r-h/c,i+l/c)},ql.perpendicularBisector=function(t,e){var n=e.x-t.x,r=e.y-t.y,i=new Uu(t.x+n/2,t.y+r/2,1),o=new Uu(t.x-r+n/2,t.y+n+r/2,1);return new Uu(i,o)},ql.angleBisector=function(t,e,n){var r=e.distance(t),i=r/(r+e.distance(n)),o=n.x-t.x,s=n.y-t.y;return new bu(t.x+i*o,t.y+i*s)},ql.area3D=function(t,e,n){var r=e.x-t.x,i=e.y-t.y,o=e.z-t.z,s=n.x-t.x,a=n.y-t.y,u=n.z-t.z,c=i*u-o*a,h=o*s-r*u,l=r*a-i*s,p=c*c+h*h+l*l,f=Math.sqrt(p)/2;return f},ql.centroid=function(t,e,n){var r=(t.x+e.x+n.x)/3,i=(t.y+e.y+n.y)/3;return new bu(r,i)},ql.inCentre=function(t,e,n){var r=e.distance(n),i=t.distance(n),o=t.distance(e),s=r+i+o,a=(r*t.x+i*e.x+o*n.x)/s,u=(r*t.y+i*e.y+o*n.y)/s;return new bu(a,u)};var Gl=function(){this._inputGeom=null,this._distance=null,this._curveBuilder=null,this._curveList=new bc;var t=arguments[0],e=arguments[1],n=arguments[2];this._inputGeom=t,this._distance=e,this._curveBuilder=n};Gl.prototype.addPoint=function(t){if(this._distance<=0)return null;var e=t.getCoordinates(),n=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(n,Su.EXTERIOR,Su.INTERIOR)},Gl.prototype.addPolygon=function(t){var e=this._distance,n=Nh.LEFT;this._distance<0&&(e=-this._distance,n=Nh.RIGHT);var r=t.getExteriorRing(),i=Cc.removeRepeatedPoints(r.getCoordinates());if(this._distance<0&&this.isErodedCompletely(r,this._distance))return null;if(this._distance<=0&&i.length<3)return null;this.addPolygonRing(i,e,n,Su.EXTERIOR,Su.INTERIOR);for(var o=0;o<t.getNumInteriorRing();o++){var s=t.getInteriorRingN(o),a=Cc.removeRepeatedPoints(s.getCoordinates());this._distance>0&&this.isErodedCompletely(s,-this._distance)||this.addPolygonRing(a,e,Nh.opposite(n),Su.INTERIOR,Su.EXTERIOR)}},Gl.prototype.isTriangleErodedCompletely=function(t,e){var n=new ql(t[0],t[1],t[2]),r=n.inCentre();return sc.distancePointLine(r,n.p0,n.p1)<Math.abs(e)},Gl.prototype.addLineString=function(t){if(this._distance<=0&&!this._curveBuilder.getBufferParameters().isSingleSided())return null;var e=Cc.removeRepeatedPoints(t.getCoordinates()),n=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(n,Su.EXTERIOR,Su.INTERIOR)},Gl.prototype.addCurve=function(t,e,n){if(null===t||t.length<2)return null;var r=new fl(t,new Rh(0,Su.BOUNDARY,e,n));this._curveList.add(r)},Gl.prototype.getCurves=function(){return this.add(this._inputGeom),this._curveList},Gl.prototype.addPolygonRing=function(t,e,n,r,i){if(0===e&&t.length<eh.MINIMUM_VALID_SIZE)return null;var o=r,s=i;t.length>=eh.MINIMUM_VALID_SIZE&&sc.isCCW(t)&&(o=i,s=r,n=Nh.opposite(n));var a=this._curveBuilder.getRingCurve(t,n,e);this.addCurve(a,o,s)},Gl.prototype.add=function(t){if(t.isEmpty())return null;t instanceof $c?this.addPolygon(t):t instanceof Jc?this.addLineString(t):t instanceof Kc?this.addPoint(t):t instanceof th?this.addCollection(t):t instanceof Xc?this.addCollection(t):t instanceof nh?this.addCollection(t):t instanceof jc&&this.addCollection(t)},Gl.prototype.isErodedCompletely=function(t,e){var n=t.getCoordinates();if(n.length<4)return e<0;if(4===n.length)return this.isTriangleErodedCompletely(n,e);var r=t.getEnvelopeInternal(),i=Math.min(r.getHeight(),r.getWidth());return e<0&&2*Math.abs(e)>i},Gl.prototype.addCollection=function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},Gl.prototype.interfaces_=function(){return[]},Gl.prototype.getClass=function(){return Gl};var Bl=function(){};Bl.prototype.locate=function(t){},Bl.prototype.interfaces_=function(){return[]},Bl.prototype.getClass=function(){return Bl};var kl=function(){this._parent=null,this._atStart=null,this._max=null,this._index=null,this._subcollectionIterator=null;var t=arguments[0];this._parent=t,this._atStart=!0,this._index=0,this._max=t.getNumGeometries()};kl.prototype.next=function(){if(this._atStart)return this._atStart=!1,kl.isAtomic(this._parent)&&this._index++,this._parent;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return this._subcollectionIterator.next();this._subcollectionIterator=null}if(this._index>=this._max)throw new Pi;var t=this._parent.getGeometryN(this._index++);return t instanceof jc?(this._subcollectionIterator=new kl(t),this._subcollectionIterator.next()):t},kl.prototype.remove=function(){throw new Error(this.getClass().getName())},kl.prototype.hasNext=function(){if(this._atStart)return!0;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return!0;this._subcollectionIterator=null}return!(this._index>=this._max)},kl.prototype.interfaces_=function(){return[Ec]},kl.prototype.getClass=function(){return kl},kl.isAtomic=function(t){return!(t instanceof jc)};var zl=function(){this._geom=null;var t=arguments[0];this._geom=t};zl.prototype.locate=function(t){return zl.locate(t,this._geom)},zl.prototype.interfaces_=function(){return[Bl]},zl.prototype.getClass=function(){return zl},zl.isPointInRing=function(t,e){return!!e.getEnvelopeInternal().intersects(t)&&sc.isPointInRing(t,e.getCoordinates())},zl.containsPointInPolygon=function(t,e){if(e.isEmpty())return!1;var n=e.getExteriorRing();if(!zl.isPointInRing(t,n))return!1;for(var r=0;r<e.getNumInteriorRing();r++){var i=e.getInteriorRingN(r);if(zl.isPointInRing(t,i))return!1}return!0},zl.containsPoint=function(t,e){if(e instanceof $c)return zl.containsPointInPolygon(t,e);if(e instanceof jc)for(var n=new kl(e);n.hasNext();){var r=n.next();if(r!==e&&zl.containsPoint(t,r))return!0}return!1},zl.locate=function(t,e){return e.isEmpty()?Su.EXTERIOR:zl.containsPoint(t,e)?Su.INTERIOR:Su.EXTERIOR};var jl=function(){this._edgeMap=new Gi,this._edgeList=null,this._ptInAreaLocation=[Su.NONE,Su.NONE]};jl.prototype.getNextCW=function(t){this.getEdges();var e=this._edgeList.indexOf(t),n=e-1;return 0===e&&(n=this._edgeList.size()-1),this._edgeList.get(n)},jl.prototype.propagateSideLabels=function(t){for(var e=Su.NONE,n=this.iterator();n.hasNext();){var r=n.next().getLabel();r.isArea(t)&&r.getLocation(t,Nh.LEFT)!==Su.NONE&&(e=r.getLocation(t,Nh.LEFT))}if(e===Su.NONE)return null;for(var i=e,o=this.iterator();o.hasNext();){var s=o.next(),a=s.getLabel();if(a.getLocation(t,Nh.ON)===Su.NONE&&a.setLocation(t,Nh.ON,i),a.isArea(t)){var u=a.getLocation(t,Nh.LEFT),c=a.getLocation(t,Nh.RIGHT);if(c!==Su.NONE){if(c!==i)throw new Mh("side location conflict",s.getCoordinate());u===Su.NONE&&tc.shouldNeverReachHere("found single null side (at "+s.getCoordinate()+")"),i=u}else tc.isTrue(a.getLocation(t,Nh.LEFT)===Su.NONE,"found single null side"),a.setLocation(t,Nh.RIGHT,i),a.setLocation(t,Nh.LEFT,i)}}},jl.prototype.getCoordinate=function(){var t=this.iterator();if(!t.hasNext())return null;return t.next().getCoordinate()},jl.prototype.print=function(t){Xu.out.println("EdgeEndStar:   "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){e.next().print(t)}},jl.prototype.isAreaLabelsConsistent=function(t){return this.computeEdgeEndLabels(t.getBoundaryNodeRule()),this.checkAreaLabelsConsistent(0)},jl.prototype.checkAreaLabelsConsistent=function(t){var e=this.getEdges();if(e.size()<=0)return!0;var n=e.size()-1,r=e.get(n).getLabel().getLocation(t,Nh.LEFT);tc.isTrue(r!==Su.NONE,"Found unlabelled area edge");for(var i=r,o=this.iterator();o.hasNext();){var s=o.next().getLabel();tc.isTrue(s.isArea(t),"Found non-area edge");var a=s.getLocation(t,Nh.LEFT),u=s.getLocation(t,Nh.RIGHT);if(a===u)return!1;if(u!==i)return!1;i=a}return!0},jl.prototype.findIndex=function(t){this.iterator();for(var e=0;e<this._edgeList.size();e++){if(this._edgeList.get(e)===t)return e}return-1},jl.prototype.iterator=function(){return this.getEdges().iterator()},jl.prototype.getEdges=function(){return null===this._edgeList&&(this._edgeList=new bc(this._edgeMap.values())),this._edgeList},jl.prototype.getLocation=function(t,e,n){return this._ptInAreaLocation[t]===Su.NONE&&(this._ptInAreaLocation[t]=zl.locate(e,n[t].getGeometry())),this._ptInAreaLocation[t]},jl.prototype.toString=function(){var t=new Ru;t.append("EdgeEndStar:   "+this.getCoordinate()),t.append("\n");for(var e=this.iterator();e.hasNext();){var n=e.next();t.append(n),t.append("\n")}return t.toString()},jl.prototype.computeEdgeEndLabels=function(t){for(var e=this.iterator();e.hasNext();){e.next().computeLabel(t)}},jl.prototype.computeLabelling=function(t){this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()),this.propagateSideLabels(0),this.propagateSideLabels(1);for(var e=[!1,!1],n=this.iterator();n.hasNext();)for(var r=n.next().getLabel(),i=0;i<2;i++)r.isLine(i)&&r.getLocation(i)===Su.BOUNDARY&&(e[i]=!0);for(var o=this.iterator();o.hasNext();)for(var s=o.next(),a=s.getLabel(),u=0;u<2;u++)if(a.isAnyNull(u)){var c=Su.NONE;if(e[u])c=Su.EXTERIOR;else{var h=s.getCoordinate();c=this.getLocation(u,h,t)}a.setAllLocationsIfNull(u,c)}},jl.prototype.getDegree=function(){return this._edgeMap.size()},jl.prototype.insertEdgeEnd=function(t,e){this._edgeMap.put(t,e),this._edgeList=null},jl.prototype.interfaces_=function(){return[]},jl.prototype.getClass=function(){return jl};var Xl=function(t){function e(){t.call(this),this._resultAreaEdgeList=null,this._label=null,this._SCANNING_FOR_INCOMING=1,this._LINKING_TO_OUTGOING=2}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.linkResultDirectedEdges=function(){this.getResultAreaEdges();for(var t=null,e=null,n=this._SCANNING_FOR_INCOMING,r=0;r<this._resultAreaEdgeList.size();r++){var i=this._resultAreaEdgeList.get(r),o=i.getSym();if(i.getLabel().isArea())switch(null===t&&i.isInResult()&&(t=i),n){case this._SCANNING_FOR_INCOMING:if(!o.isInResult())continue;e=o,n=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(!i.isInResult())continue;e.setNext(i),n=this._SCANNING_FOR_INCOMING}}if(n===this._LINKING_TO_OUTGOING){if(null===t)throw new Mh("no outgoing dirEdge found",this.getCoordinate());tc.isTrue(t.isInResult(),"unable to link last incoming dirEdge"),e.setNext(t)}},e.prototype.insert=function(t){var e=t;this.insertEdgeEnd(e,e)},e.prototype.getRightmostEdge=function(){var t=this.getEdges(),e=t.size();if(e<1)return null;var n=t.get(0);if(1===e)return n;var r=t.get(e-1),i=n.getQuadrant(),o=r.getQuadrant();return Bh.isNorthern(i)&&Bh.isNorthern(o)?n:Bh.isNorthern(i)||Bh.isNorthern(o)?0!==n.getDy()?n:0!==r.getDy()?r:(tc.shouldNeverReachHere("found two horizontal edges incident on node"),null):r},e.prototype.print=function(t){Xu.out.println("DirectedEdgeStar: "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){var n=e.next();t.print("out "),n.print(t),t.println(),t.print("in "),n.getSym().print(t),t.println()}},e.prototype.getResultAreaEdges=function(){if(null!==this._resultAreaEdgeList)return this._resultAreaEdgeList;this._resultAreaEdgeList=new bc;for(var t=this.iterator();t.hasNext();){var e=t.next();(e.isInResult()||e.getSym().isInResult())&&this._resultAreaEdgeList.add(e)}return this._resultAreaEdgeList},e.prototype.updateLabelling=function(t){for(var e=this.iterator();e.hasNext();){var n=e.next().getLabel();n.setAllLocationsIfNull(0,t.getLocation(0)),n.setAllLocationsIfNull(1,t.getLocation(1))}},e.prototype.linkAllDirectedEdges=function(){this.getEdges();for(var t=null,e=null,n=this._edgeList.size()-1;n>=0;n--){var r=this._edgeList.get(n),i=r.getSym();null===e&&(e=i),null!==t&&i.setNext(t),t=r}e.setNext(t)},e.prototype.computeDepths=function(){if(1===arguments.length){var t=arguments[0],e=this.findIndex(t),n=t.getDepth(Nh.LEFT),r=t.getDepth(Nh.RIGHT),i=this.computeDepths(e+1,this._edgeList.size(),n);if(this.computeDepths(0,e,i)!==r)throw new Mh("depth mismatch at "+t.getCoordinate())}else if(3===arguments.length){for(var o=arguments[0],s=arguments[1],a=arguments[2],u=o;u<s;u++){var c=this._edgeList.get(u);c.setEdgeDepths(Nh.RIGHT,a),a=c.getDepth(Nh.LEFT)}return a}},e.prototype.mergeSymLabels=function(){for(var t=this.iterator();t.hasNext();){var e=t.next();e.getLabel().merge(e.getSym().getLabel())}},e.prototype.linkMinimalDirectedEdges=function(t){for(var e=null,n=null,r=this._SCANNING_FOR_INCOMING,i=this._resultAreaEdgeList.size()-1;i>=0;i--){var o=this._resultAreaEdgeList.get(i),s=o.getSym();switch(null===e&&o.getEdgeRing()===t&&(e=o),r){case this._SCANNING_FOR_INCOMING:if(s.getEdgeRing()!==t)continue;n=s,r=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(o.getEdgeRing()!==t)continue;n.setNextMin(o),r=this._SCANNING_FOR_INCOMING}}r===this._LINKING_TO_OUTGOING&&(tc.isTrue(null!==e,"found null for first outgoing dirEdge"),tc.isTrue(e.getEdgeRing()===t,"unable to link last incoming dirEdge"),n.setNextMin(e))},e.prototype.getOutgoingDegree=function(){if(0===arguments.length){for(var t=0,e=this.iterator();e.hasNext();){e.next().isInResult()&&t++}return t}if(1===arguments.length){for(var n=arguments[0],r=0,i=this.iterator();i.hasNext();){i.next().getEdgeRing()===n&&r++}return r}},e.prototype.getLabel=function(){return this._label},e.prototype.findCoveredLineEdges=function(){for(var t=Su.NONE,e=this.iterator();e.hasNext();){var n=e.next(),r=n.getSym();if(!n.isLineEdge()){if(n.isInResult()){t=Su.INTERIOR;break}if(r.isInResult()){t=Su.EXTERIOR;break}}}if(t===Su.NONE)return null;for(var i=t,o=this.iterator();o.hasNext();){var s=o.next(),a=s.getSym();s.isLineEdge()?s.getEdge().setCovered(i===Su.INTERIOR):(s.isInResult()&&(i=Su.EXTERIOR),a.isInResult()&&(i=Su.INTERIOR))}},e.prototype.computeLabelling=function(e){t.prototype.computeLabelling.call(this,e),this._label=new Rh(Su.NONE);for(var n=this.iterator();n.hasNext();)for(var r=n.next().getEdge().getLabel(),i=0;i<2;i++){var o=r.getLocation(i);o!==Su.INTERIOR&&o!==Su.BOUNDARY||this._label.setLocation(i,Su.INTERIOR)}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(jl),Ul=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createNode=function(t){return new qh(t,new Xl)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Xh),Yl=function t(){this._pts=null,this._orientation=null;var e=arguments[0];this._pts=e,this._orientation=t.orientation(e)};Yl.prototype.compareTo=function(t){var e=t;return Yl.compareOriented(this._pts,this._orientation,e._pts,e._orientation)},Yl.prototype.interfaces_=function(){return[xu]},Yl.prototype.getClass=function(){return Yl},Yl.orientation=function(t){return 1===Cc.increasingDirection(t)},Yl.compareOriented=function(t,e,n,r){for(var i=e?1:-1,o=r?1:-1,s=e?t.length:-1,a=r?n.length:-1,u=e?0:t.length-1,c=r?0:n.length-1;;){var h=t[u].compareTo(n[c]);if(0!==h)return h;var l=(u+=i)===s,p=(c+=o)===a;if(l&&!p)return-1;if(!l&&p)return 1;if(l&&p)return 0}};var Vl=function(){this._edges=new bc,this._ocaMap=new Gi};Vl.prototype.print=function(t){t.print("MULTILINESTRING ( ");for(var e=0;e<this._edges.size();e++){var n=this._edges.get(e);e>0&&t.print(","),t.print("(");for(var r=n.getCoordinates(),i=0;i<r.length;i++)i>0&&t.print(","),t.print(r[i].x+" "+r[i].y);t.println(")")}t.print(")  ")},Vl.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next())},Vl.prototype.findEdgeIndex=function(t){for(var e=0;e<this._edges.size();e++)if(this._edges.get(e).equals(t))return e;return-1},Vl.prototype.iterator=function(){return this._edges.iterator()},Vl.prototype.getEdges=function(){return this._edges},Vl.prototype.get=function(t){return this._edges.get(t)},Vl.prototype.findEqualEdge=function(t){var e=new Yl(t.getCoordinates());return this._ocaMap.get(e)},Vl.prototype.add=function(t){this._edges.add(t);var e=new Yl(t.getCoordinates());this._ocaMap.put(e,t)},Vl.prototype.interfaces_=function(){return[]},Vl.prototype.getClass=function(){return Vl};var Hl=function(){};Hl.prototype.processIntersections=function(t,e,n,r){},Hl.prototype.isDone=function(){},Hl.prototype.interfaces_=function(){return[]},Hl.prototype.getClass=function(){return Hl};var Wl=function(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._hasInterior=!1,this._properIntersectionPoint=null,this._li=null,this._isSelfIntersection=null,this.numIntersections=0,this.numInteriorIntersections=0,this.numProperIntersections=0,this.numTests=0;var t=arguments[0];this._li=t};Wl.prototype.isTrivialIntersection=function(t,e,n,r){if(t===n&&1===this._li.getIntersectionNum()){if(Wl.isAdjacentSegments(e,r))return!0;if(t.isClosed()){var i=t.size()-1;if(0===e&&r===i||0===r&&e===i)return!0}}return!1},Wl.prototype.getProperIntersectionPoint=function(){return this._properIntersectionPoint},Wl.prototype.hasProperInteriorIntersection=function(){return this._hasProperInterior},Wl.prototype.getLineIntersector=function(){return this._li},Wl.prototype.hasProperIntersection=function(){return this._hasProper},Wl.prototype.processIntersections=function(t,e,n,r){if(t===n&&e===r)return null;this.numTests++;var i=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[r],a=n.getCoordinates()[r+1];this._li.computeIntersection(i,o,s,a),this._li.hasIntersection()&&(this.numIntersections++,this._li.isInteriorIntersection()&&(this.numInteriorIntersections++,this._hasInterior=!0),this.isTrivialIntersection(t,e,n,r)||(this._hasIntersection=!0,t.addIntersections(this._li,e,0),n.addIntersections(this._li,r,1),this._li.isProper()&&(this.numProperIntersections++,this._hasProper=!0,this._hasProperInterior=!0)))},Wl.prototype.hasIntersection=function(){return this._hasIntersection},Wl.prototype.isDone=function(){return!1},Wl.prototype.hasInteriorIntersection=function(){return this._hasInterior},Wl.prototype.interfaces_=function(){return[Hl]},Wl.prototype.getClass=function(){return Wl},Wl.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)};var Jl=function(){this.coord=null,this.segmentIndex=null,this.dist=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.coord=new bu(t),this.segmentIndex=e,this.dist=n};Jl.prototype.getSegmentIndex=function(){return this.segmentIndex},Jl.prototype.getCoordinate=function(){return this.coord},Jl.prototype.print=function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex),t.println(" dist = "+this.dist)},Jl.prototype.compareTo=function(t){var e=t;return this.compare(e.segmentIndex,e.dist)},Jl.prototype.isEndPoint=function(t){return 0===this.segmentIndex&&0===this.dist||this.segmentIndex===t},Jl.prototype.toString=function(){return this.coord+" seg # = "+this.segmentIndex+" dist = "+this.dist},Jl.prototype.getDistance=function(){return this.dist},Jl.prototype.compare=function(t,e){return this.segmentIndex<t?-1:this.segmentIndex>t?1:this.dist<e?-1:this.dist>e?1:0},Jl.prototype.interfaces_=function(){return[xu]},Jl.prototype.getClass=function(){return Jl};var Zl=function(){this._nodeMap=new Gi,this.edge=null;var t=arguments[0];this.edge=t};Zl.prototype.print=function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){e.next().print(t)}},Zl.prototype.iterator=function(){return this._nodeMap.values().iterator()},Zl.prototype.addSplitEdges=function(t){this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var r=e.next(),i=this.createSplitEdge(n,r);t.add(i),n=r}},Zl.prototype.addEndpoints=function(){var t=this.edge.pts.length-1;this.add(this.edge.pts[0],0,0),this.add(this.edge.pts[t],t,0)},Zl.prototype.createSplitEdge=function(t,e){var n=e.segmentIndex-t.segmentIndex+2,r=this.edge.pts[e.segmentIndex],i=e.dist>0||!e.coord.equals2D(r);i||n--;var o=new Array(n).fill(null),s=0;o[s++]=new bu(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)o[s++]=this.edge.pts[a];return i&&(o[s]=e.coord),new ep(o,new Rh(this.edge._label))},Zl.prototype.add=function(t,e,n){var r=new Jl(t,e,n),i=this._nodeMap.get(r);return null!==i?i:(this._nodeMap.put(r,r),r)},Zl.prototype.isIntersection=function(t){for(var e=this.iterator();e.hasNext();){if(e.next().coord.equals(t))return!0}return!1},Zl.prototype.interfaces_=function(){return[]},Zl.prototype.getClass=function(){return Zl};var Kl=function(){};Kl.prototype.getChainStartIndices=function(t){var e=0,n=new bc;n.add(new Tu(e));do{var r=this.findChainEnd(t,e);n.add(new Tu(r)),e=r}while(e<t.length-1);return Kl.toIntArray(n)},Kl.prototype.findChainEnd=function(t,e){for(var n=Bh.quadrant(t[e],t[e+1]),r=e+1;r<t.length;){if(Bh.quadrant(t[r-1],t[r])!==n)break;r++}return r-1},Kl.prototype.interfaces_=function(){return[]},Kl.prototype.getClass=function(){return Kl},Kl.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e};var Ql=function(){this.e=null,this.pts=null,this.startIndex=null,this.env1=new Yu,this.env2=new Yu;var t=arguments[0];this.e=t,this.pts=t.getCoordinates();var e=new Kl;this.startIndex=e.getChainStartIndices(this.pts)};Ql.prototype.getCoordinates=function(){return this.pts},Ql.prototype.getMaxX=function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return e>n?e:n},Ql.prototype.getMinX=function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return e<n?e:n},Ql.prototype.computeIntersectsForChain=function(){if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],r=arguments[3];this.computeIntersectsForChain(this.startIndex[t],this.startIndex[t+1],e,e.startIndex[n],e.startIndex[n+1],r)}else if(6===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3],u=arguments[4],c=arguments[5],h=this.pts[i],l=this.pts[o],p=s.pts[a],f=s.pts[u];if(o-i==1&&u-a==1)return c.addIntersections(this.e,i,s.e,a),null;if(this.env1.init(h,l),this.env2.init(p,f),!this.env1.intersects(this.env2))return null;var g=Math.trunc((i+o)/2),d=Math.trunc((a+u)/2);i<g&&(a<d&&this.computeIntersectsForChain(i,g,s,a,d,c),d<u&&this.computeIntersectsForChain(i,g,s,d,u,c)),g<o&&(a<d&&this.computeIntersectsForChain(g,o,s,a,d,c),d<u&&this.computeIntersectsForChain(g,o,s,d,u,c))}},Ql.prototype.getStartIndexes=function(){return this.startIndex},Ql.prototype.computeIntersects=function(t,e){for(var n=0;n<this.startIndex.length-1;n++)for(var r=0;r<t.startIndex.length-1;r++)this.computeIntersectsForChain(n,t,r,e)},Ql.prototype.interfaces_=function(){return[]},Ql.prototype.getClass=function(){return Ql};var $l=function t(){this._depth=Array(2).fill().map(function(){return Array(3)});for(var e=0;e<2;e++)for(var n=0;n<3;n++)this._depth[e][n]=t.NULL_VALUE},tp={NULL_VALUE:{configurable:!0}};$l.prototype.getDepth=function(t,e){return this._depth[t][e]},$l.prototype.setDepth=function(t,e,n){this._depth[t][e]=n},$l.prototype.isNull=function(){if(0===arguments.length){for(var t=0;t<2;t++)for(var e=0;e<3;e++)if(this._depth[t][e]!==$l.NULL_VALUE)return!1;return!0}if(1===arguments.length){var n=arguments[0];return this._depth[n][1]===$l.NULL_VALUE}if(2===arguments.length){var r=arguments[0],i=arguments[1];return this._depth[r][i]===$l.NULL_VALUE}},$l.prototype.normalize=function(){for(var t=0;t<2;t++)if(!this.isNull(t)){var e=this._depth[t][1];this._depth[t][2]<e&&(e=this._depth[t][2]),e<0&&(e=0);for(var n=1;n<3;n++){var r=0;this._depth[t][n]>e&&(r=1),this._depth[t][n]=r}}},$l.prototype.getDelta=function(t){return this._depth[t][Nh.RIGHT]-this._depth[t][Nh.LEFT]},$l.prototype.getLocation=function(t,e){return this._depth[t][e]<=0?Su.EXTERIOR:Su.INTERIOR},$l.prototype.toString=function(){return"A: "+this._depth[0][1]+","+this._depth[0][2]+" B: "+this._depth[1][1]+","+this._depth[1][2]},$l.prototype.add=function(){if(1===arguments.length)for(var t=arguments[0],e=0;e<2;e++)for(var n=1;n<3;n++){var r=t.getLocation(e,n);r!==Su.EXTERIOR&&r!==Su.INTERIOR||(this.isNull(e,n)?this._depth[e][n]=$l.depthAtLocation(r):this._depth[e][n]+=$l.depthAtLocation(r))}else if(3===arguments.length){var i=arguments[0],o=arguments[1];arguments[2]===Su.INTERIOR&&this._depth[i][o]++}},$l.prototype.interfaces_=function(){return[]},$l.prototype.getClass=function(){return $l},$l.depthAtLocation=function(t){return t===Su.EXTERIOR?0:t===Su.INTERIOR?1:$l.NULL_VALUE},tp.NULL_VALUE.get=function(){return-1},Object.defineProperties($l,tp);var ep=function(t){function e(){if(t.call(this),this.pts=null,this._env=null,this.eiList=new Zl(this),this._name=null,this._mce=null,this._isIsolated=!0,this._depth=new $l,this._depthDelta=0,1===arguments.length){var n=arguments[0];e.call(this,n,null)}else if(2===arguments.length){var r=arguments[0],i=arguments[1];this.pts=r,this._label=i}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDepth=function(){return this._depth},e.prototype.getCollapsedEdge=function(){var t=new Array(2).fill(null);t[0]=this.pts[0],t[1]=this.pts[1];return new e(t,Rh.toLineLabel(this._label))},e.prototype.isIsolated=function(){return this._isIsolated},e.prototype.getCoordinates=function(){return this.pts},e.prototype.setIsolated=function(t){this._isIsolated=t},e.prototype.setName=function(t){this._name=t},e.prototype.equals=function(t){if(!(t instanceof e))return!1;var n=t;if(this.pts.length!==n.pts.length)return!1;for(var r=!0,i=!0,o=this.pts.length,s=0;s<this.pts.length;s++)if(this.pts[s].equals2D(n.pts[s])||(r=!1),this.pts[s].equals2D(n.pts[--o])||(i=!1),!r&&!i)return!1;return!0},e.prototype.getCoordinate=function(){if(0===arguments.length)return this.pts.length>0?this.pts[0]:null;if(1===arguments.length){var t=arguments[0];return this.pts[t]}},e.prototype.print=function(t){t.print("edge "+this._name+": "),t.print("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.print(","),t.print(this.pts[e].x+" "+this.pts[e].y);t.print(")  "+this._label+" "+this._depthDelta)},e.prototype.computeIM=function(t){e.updateIM(this._label,t)},e.prototype.isCollapsed=function(){return!!this._label.isArea()&&(3===this.pts.length&&!!this.pts[0].equals(this.pts[2]))},e.prototype.isClosed=function(){return this.pts[0].equals(this.pts[this.pts.length-1])},e.prototype.getMaximumSegmentIndex=function(){return this.pts.length-1},e.prototype.getDepthDelta=function(){return this._depthDelta},e.prototype.getNumPoints=function(){return this.pts.length},e.prototype.printReverse=function(t){t.print("edge "+this._name+": ");for(var e=this.pts.length-1;e>=0;e--)t.print(this.pts[e]+" ");t.println("")},e.prototype.getMonotoneChainEdge=function(){return null===this._mce&&(this._mce=new Ql(this)),this._mce},e.prototype.getEnvelope=function(){if(null===this._env){this._env=new Yu;for(var t=0;t<this.pts.length;t++)this._env.expandToInclude(this.pts[t])}return this._env},e.prototype.addIntersection=function(t,e,n,r){var i=new bu(t.getIntersection(r)),o=e,s=t.getEdgeDistance(n,r),a=o+1;if(a<this.pts.length){var u=this.pts[a];i.equals2D(u)&&(o=a,s=0)}this.eiList.add(i,o,s)},e.prototype.toString=function(){var t=new Ru;t.append("edge "+this._name+": "),t.append("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.append(","),t.append(this.pts[e].x+" "+this.pts[e].y);return t.append(")  "+this._label+" "+this._depthDelta),t.toString()},e.prototype.isPointwiseEqual=function(t){if(this.pts.length!==t.pts.length)return!1;for(var e=0;e<this.pts.length;e++)if(!this.pts[e].equals2D(t.pts[e]))return!1;return!0},e.prototype.setDepthDelta=function(t){this._depthDelta=t},e.prototype.getEdgeIntersectionList=function(){return this.eiList},e.prototype.addIntersections=function(t,e,n){for(var r=0;r<t.getIntersectionNum();r++)this.addIntersection(t,e,n,r)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.updateIM=function(){if(2!==arguments.length)return t.prototype.updateIM.apply(this,arguments);var e=arguments[0],n=arguments[1];n.setAtLeastIfValid(e.getLocation(0,Nh.ON),e.getLocation(1,Nh.ON),1),e.isArea()&&(n.setAtLeastIfValid(e.getLocation(0,Nh.LEFT),e.getLocation(1,Nh.LEFT),2),n.setAtLeastIfValid(e.getLocation(0,Nh.RIGHT),e.getLocation(1,Nh.RIGHT),2))},e}(Fh),np=function(t){this._workingPrecisionModel=null,this._workingNoder=null,this._geomFact=null,this._graph=null,this._edgeList=new Vl,this._bufParams=t||null};np.prototype.setWorkingPrecisionModel=function(t){this._workingPrecisionModel=t},np.prototype.insertUniqueEdge=function(t){var e=this._edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),r=t.getLabel();e.isPointwiseEqual(t)||(r=new Rh(t.getLabel())).flip(),n.merge(r);var i=np.depthDelta(r),o=e.getDepthDelta()+i;e.setDepthDelta(o)}else this._edgeList.add(t),t.setDepthDelta(np.depthDelta(t.getLabel()))},np.prototype.buildSubgraphs=function(t,e){for(var n=new bc,r=t.iterator();r.hasNext();){var i=r.next(),o=i.getRightmostCoordinate(),s=new Al(n).getDepth(o);i.computeDepth(s),i.findResultEdges(),n.add(i),e.add(i.getDirectedEdges(),i.getNodes())}},np.prototype.createSubgraphs=function(t){for(var e=new bc,n=t.getNodes().iterator();n.hasNext();){var r=n.next();if(!r.isVisited()){var i=new Ph;i.create(r),e.add(i)}}return $h.sort(e,$h.reverseOrder()),e},np.prototype.createEmptyResultGeometry=function(){return this._geomFact.createPolygon()},np.prototype.getNoder=function(t){if(null!==this._workingNoder)return this._workingNoder;var e=new El,n=new rc;return n.setPrecisionModel(t),e.setSegmentIntersector(new Wl(n)),e},np.prototype.buffer=function(t,e){var n=this._workingPrecisionModel;null===n&&(n=t.getPrecisionModel()),this._geomFact=t.getFactory();var r=new Tl(n,this._bufParams),i=new Gl(t,e,r).getCurves();if(i.size()<=0)return this.createEmptyResultGeometry();this.computeNodedEdges(i,n),this._graph=new Uh(new Ul),this._graph.addEdges(this._edgeList.getEdges());var o=this.createSubgraphs(this._graph),s=new Yh(this._geomFact);this.buildSubgraphs(o,s);var a=s.getPolygons();if(a.size()<=0)return this.createEmptyResultGeometry();return this._geomFact.buildGeometry(a)},np.prototype.computeNodedEdges=function(t,e){var n=this.getNoder(e);n.computeNodes(t);for(var r=n.getNodedSubstrings().iterator();r.hasNext();){var i=r.next(),o=i.getCoordinates();if(2!==o.length||!o[0].equals2D(o[1])){var s=i.getData(),a=new ep(i.getCoordinates(),new Rh(s));this.insertUniqueEdge(a)}}},np.prototype.setNoder=function(t){this._workingNoder=t},np.prototype.interfaces_=function(){return[]},np.prototype.getClass=function(){return np},np.depthDelta=function(t){var e=t.getLocation(0,Nh.LEFT),n=t.getLocation(0,Nh.RIGHT);return e===Su.INTERIOR&&n===Su.EXTERIOR?1:e===Su.EXTERIOR&&n===Su.INTERIOR?-1:0},np.convertSegStrings=function(t){for(var e=new _h,n=new bc;t.hasNext();){var r=t.next(),i=e.createLineString(r.getCoordinates());n.add(i)}return e.buildGeometry(n)};var rp=function(){if(this._noder=null,this._scaleFactor=null,this._offsetX=null,this._offsetY=null,this._isScaled=!1,2===arguments.length){var t=arguments[0],e=arguments[1];this._noder=t,this._scaleFactor=e,this._offsetX=0,this._offsetY=0,this._isScaled=!this.isIntegerPrecision()}else if(4===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2],o=arguments[3];this._noder=n,this._scaleFactor=r,this._offsetX=i,this._offsetY=o,this._isScaled=!this.isIntegerPrecision()}};rp.prototype.rescale=function(){if(Lu(arguments[0],vc))for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.rescale(e.getCoordinates())}else if(arguments[0]instanceof Array){for(var n=arguments[0],r=0;r<n.length;r++)n[r].x=n[r].x/this._scaleFactor+this._offsetX,n[r].y=n[r].y/this._scaleFactor+this._offsetY;2===n.length&&n[0].equals2D(n[1])&&Xu.out.println(n)}},rp.prototype.scale=function(){if(Lu(arguments[0],vc)){for(var t=arguments[0],e=new bc,n=t.iterator();n.hasNext();){var r=n.next();e.add(new fl(this.scale(r.getCoordinates()),r.getData()))}return e}if(arguments[0]instanceof Array){for(var i=arguments[0],o=new Array(i.length).fill(null),s=0;s<i.length;s++)o[s]=new bu(Math.round((i[s].x-this._offsetX)*this._scaleFactor),Math.round((i[s].y-this._offsetY)*this._scaleFactor),i[s].z);return Cc.removeRepeatedPoints(o)}},rp.prototype.isIntegerPrecision=function(){return 1===this._scaleFactor},rp.prototype.getNodedSubstrings=function(){var t=this._noder.getNodedSubstrings();return this._isScaled&&this.rescale(t),t},rp.prototype.computeNodes=function(t){var e=t;this._isScaled&&(e=this.scale(t)),this._noder.computeNodes(e)},rp.prototype.interfaces_=function(){return[vl]},rp.prototype.getClass=function(){return rp};var ip=function(){this._li=new rc,this._segStrings=null;var t=arguments[0];this._segStrings=t},op={fact:{configurable:!0}};ip.prototype.checkEndPtVertexIntersections=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();){var e=t.next().getCoordinates();this.checkEndPtVertexIntersections(e[0],this._segStrings),this.checkEndPtVertexIntersections(e[e.length-1],this._segStrings)}else if(2===arguments.length)for(var n=arguments[0],r=arguments[1].iterator();r.hasNext();)for(var i=r.next().getCoordinates(),o=1;o<i.length-1;o++)if(i[o].equals(n))throw new Qu("found endpt/interior pt intersection at index "+o+" :pt "+n)},ip.prototype.checkInteriorIntersections=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();)for(var e=t.next(),n=this._segStrings.iterator();n.hasNext();){var r=n.next();this.checkInteriorIntersections(e,r)}else if(2===arguments.length)for(var i=arguments[0],o=arguments[1],s=i.getCoordinates(),a=o.getCoordinates(),u=0;u<s.length-1;u++)for(var c=0;c<a.length-1;c++)this.checkInteriorIntersections(i,u,o,c);else if(4===arguments.length){var h=arguments[0],l=arguments[1],p=arguments[2],f=arguments[3];if(h===p&&l===f)return null;var g=h.getCoordinates()[l],d=h.getCoordinates()[l+1],y=p.getCoordinates()[f],_=p.getCoordinates()[f+1];if(this._li.computeIntersection(g,d,y,_),this._li.hasIntersection()&&(this._li.isProper()||this.hasInteriorIntersection(this._li,g,d)||this.hasInteriorIntersection(this._li,y,_)))throw new Qu("found non-noded intersection at "+g+"-"+d+" and "+y+"-"+_)}},ip.prototype.checkValid=function(){this.checkEndPtVertexIntersections(),this.checkInteriorIntersections(),this.checkCollapses()},ip.prototype.checkCollapses=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();){var e=t.next();this.checkCollapses(e)}else if(1===arguments.length)for(var n=arguments[0].getCoordinates(),r=0;r<n.length-2;r++)this.checkCollapse(n[r],n[r+1],n[r+2])},ip.prototype.hasInteriorIntersection=function(t,e,n){for(var r=0;r<t.getIntersectionNum();r++){var i=t.getIntersection(r);if(!i.equals(e)&&!i.equals(n))return!0}return!1},ip.prototype.checkCollapse=function(t,e,n){if(t.equals(n))throw new Qu("found non-noded collapse at "+ip.fact.createLineString([t,e,n]))},ip.prototype.interfaces_=function(){return[]},ip.prototype.getClass=function(){return ip},op.fact.get=function(){return new _h},Object.defineProperties(ip,op);var sp=function(){this._li=null,this._pt=null,this._originalPt=null,this._ptScaled=null,this._p0Scaled=null,this._p1Scaled=null,this._scaleFactor=null,this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,this._corner=new Array(4).fill(null),this._safeEnv=null;var t=arguments[0],e=arguments[1],n=arguments[2];if(this._originalPt=t,this._pt=t,this._scaleFactor=e,this._li=n,e<=0)throw new _u("Scale factor must be non-zero");1!==e&&(this._pt=new bu(this.scale(t.x),this.scale(t.y)),this._p0Scaled=new bu,this._p1Scaled=new bu),this.initCorners(this._pt)},ap={SAFE_ENV_EXPANSION_FACTOR:{configurable:!0}};sp.prototype.intersectsScaled=function(t,e){var n=Math.min(t.x,e.x),r=Math.max(t.x,e.x),i=Math.min(t.y,e.y),o=Math.max(t.y,e.y),s=this._maxx<n||this._minx>r||this._maxy<i||this._miny>o;if(s)return!1;var a=this.intersectsToleranceSquare(t,e);return tc.isTrue(!(s&&a),"Found bad envelope test"),a},sp.prototype.initCorners=function(t){this._minx=t.x-.5,this._maxx=t.x+.5,this._miny=t.y-.5,this._maxy=t.y+.5,this._corner[0]=new bu(this._maxx,this._maxy),this._corner[1]=new bu(this._minx,this._maxy),this._corner[2]=new bu(this._minx,this._miny),this._corner[3]=new bu(this._maxx,this._miny)},sp.prototype.intersects=function(t,e){return 1===this._scaleFactor?this.intersectsScaled(t,e):(this.copyScaled(t,this._p0Scaled),this.copyScaled(e,this._p1Scaled),this.intersectsScaled(this._p0Scaled,this._p1Scaled))},sp.prototype.scale=function(t){return Math.round(t*this._scaleFactor)},sp.prototype.getCoordinate=function(){return this._originalPt},sp.prototype.copyScaled=function(t,e){e.x=this.scale(t.x),e.y=this.scale(t.y)},sp.prototype.getSafeEnvelope=function(){if(null===this._safeEnv){var t=sp.SAFE_ENV_EXPANSION_FACTOR/this._scaleFactor;this._safeEnv=new Yu(this._originalPt.x-t,this._originalPt.x+t,this._originalPt.y-t,this._originalPt.y+t)}return this._safeEnv},sp.prototype.intersectsPixelClosure=function(t,e){return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.hasIntersection())))},sp.prototype.intersectsToleranceSquare=function(t,e){var n=!1,r=!1;return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.isProper()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.isProper()||(this._li.hasIntersection()&&(n=!0),this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.isProper()||(this._li.hasIntersection()&&(r=!0),this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.isProper()||(!(!n||!r)||(!!t.equals(this._pt)||!!e.equals(this._pt))))))},sp.prototype.addSnappedNode=function(t,e){var n=t.getCoordinate(e),r=t.getCoordinate(e+1);return!!this.intersects(n,r)&&(t.addIntersection(this.getCoordinate(),e),!0)},sp.prototype.interfaces_=function(){return[]},sp.prototype.getClass=function(){return sp},ap.SAFE_ENV_EXPANSION_FACTOR.get=function(){return.75},Object.defineProperties(sp,ap);var up=function(){this.tempEnv1=new Yu,this.selectedSegment=new gl};up.prototype.select=function(){if(1===arguments.length);else if(2===arguments.length){var t=arguments[0],e=arguments[1];t.getLineSegment(e,this.selectedSegment),this.select(this.selectedSegment)}},up.prototype.interfaces_=function(){return[]},up.prototype.getClass=function(){return up};var cp=function(){this._index=null;var t=arguments[0];this._index=t},hp={HotPixelSnapAction:{configurable:!0}};cp.prototype.snap=function(){if(1===arguments.length){var t=arguments[0];return this.snap(t,null,-1)}if(3===arguments.length){var e=arguments[0],n=arguments[1],r=arguments[2],i=e.getSafeEnvelope(),o=new lp(e,n,r);return this._index.query(i,{interfaces_:function(){return[Jh]},visitItem:function(t){t.select(i,o)}}),o.isNodeAdded()}},cp.prototype.interfaces_=function(){return[]},cp.prototype.getClass=function(){return cp},hp.HotPixelSnapAction.get=function(){return lp},Object.defineProperties(cp,hp);var lp=function(t){function e(){t.call(this),this._hotPixel=null,this._parentEdge=null,this._hotPixelVertexIndex=null,this._isNodeAdded=!1;var e=arguments[0],n=arguments[1],r=arguments[2];this._hotPixel=e,this._parentEdge=n,this._hotPixelVertexIndex=r}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isNodeAdded=function(){return this._isNodeAdded},e.prototype.select=function(){if(2!==arguments.length)return t.prototype.select.apply(this,arguments);var e=arguments[0],n=arguments[1],r=e.getContext();if(null!==this._parentEdge&&r===this._parentEdge&&n===this._hotPixelVertexIndex)return null;this._isNodeAdded=this._hotPixel.addSnappedNode(r,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(up),pp=function(){this._li=null,this._interiorIntersections=null;var t=arguments[0];this._li=t,this._interiorIntersections=new bc};pp.prototype.processIntersections=function(t,e,n,r){if(t===n&&e===r)return null;var i=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[r],a=n.getCoordinates()[r+1];if(this._li.computeIntersection(i,o,s,a),this._li.hasIntersection()&&this._li.isInteriorIntersection()){for(var u=0;u<this._li.getIntersectionNum();u++)this._interiorIntersections.add(this._li.getIntersection(u));t.addIntersections(this._li,e,0),n.addIntersections(this._li,r,1)}},pp.prototype.isDone=function(){return!1},pp.prototype.getInteriorIntersections=function(){return this._interiorIntersections},pp.prototype.interfaces_=function(){return[Hl]},pp.prototype.getClass=function(){return pp};var fp=function(){this._pm=null,this._li=null,this._scaleFactor=null,this._noder=null,this._pointSnapper=null,this._nodedSegStrings=null;var t=arguments[0];this._pm=t,this._li=new rc,this._li.setPrecisionModel(t),this._scaleFactor=t.getScale()};fp.prototype.checkCorrectness=function(t){var e=fl.getNodedSubstrings(t),n=new ip(e);try{n.checkValid()}catch(t){if(!(t instanceof zu))throw t;t.printStackTrace()}},fp.prototype.getNodedSubstrings=function(){return fl.getNodedSubstrings(this._nodedSegStrings)},fp.prototype.snapRound=function(t,e){var n=this.findInteriorIntersections(t,e);this.computeIntersectionSnaps(n),this.computeVertexSnaps(t)},fp.prototype.findInteriorIntersections=function(t,e){var n=new pp(e);return this._noder.setSegmentIntersector(n),this._noder.computeNodes(t),n.getInteriorIntersections()},fp.prototype.computeVertexSnaps=function(){if(Lu(arguments[0],vc))for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.computeVertexSnaps(e)}else if(arguments[0]instanceof fl)for(var n=arguments[0],r=n.getCoordinates(),i=0;i<r.length;i++){var o=new sp(r[i],this._scaleFactor,this._li);this._pointSnapper.snap(o,n,i)&&n.addIntersection(r[i],i)}},fp.prototype.computeNodes=function(t){this._nodedSegStrings=t,this._noder=new El,this._pointSnapper=new cp(this._noder.getIndex()),this.snapRound(t,this._li)},fp.prototype.computeIntersectionSnaps=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),r=new sp(n,this._scaleFactor,this._li);this._pointSnapper.snap(r)}},fp.prototype.interfaces_=function(){return[vl]},fp.prototype.getClass=function(){return fp};var gp=function(){if(this._argGeom=null,this._distance=null,this._bufParams=new bl,this._resultGeometry=null,this._saveException=null,1===arguments.length){var t=arguments[0];this._argGeom=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this._argGeom=e,this._bufParams=n}},dp={CAP_ROUND:{configurable:!0},CAP_BUTT:{configurable:!0},CAP_FLAT:{configurable:!0},CAP_SQUARE:{configurable:!0},MAX_PRECISION_DIGITS:{configurable:!0}};gp.prototype.bufferFixedPrecision=function(t){var e=new rp(new fp(new fh(1)),t.getScale()),n=new np(this._bufParams);n.setWorkingPrecisionModel(t),n.setNoder(e),this._resultGeometry=n.buffer(this._argGeom,this._distance)},gp.prototype.bufferReducedPrecision=function(){var t=this;if(0===arguments.length){for(var e=gp.MAX_PRECISION_DIGITS;e>=0;e--){try{t.bufferReducedPrecision(e)}catch(e){if(!(e instanceof Mh))throw e;t._saveException=e}if(null!==t._resultGeometry)return null}throw this._saveException}if(1===arguments.length){var n=arguments[0],r=gp.precisionScaleFactor(this._argGeom,this._distance,n),i=new fh(r);this.bufferFixedPrecision(i)}},gp.prototype.computeGeometry=function(){if(this.bufferOriginalPrecision(),null!==this._resultGeometry)return null;var t=this._argGeom.getFactory().getPrecisionModel();t.getType()===fh.FIXED?this.bufferFixedPrecision(t):this.bufferReducedPrecision()},gp.prototype.setQuadrantSegments=function(t){this._bufParams.setQuadrantSegments(t)},gp.prototype.bufferOriginalPrecision=function(){try{var t=new np(this._bufParams);this._resultGeometry=t.buffer(this._argGeom,this._distance)}catch(t){if(!(t instanceof Qu))throw t;this._saveException=t}},gp.prototype.getResultGeometry=function(t){return this._distance=t,this.computeGeometry(),this._resultGeometry},gp.prototype.setEndCapStyle=function(t){this._bufParams.setEndCapStyle(t)},gp.prototype.interfaces_=function(){return[]},gp.prototype.getClass=function(){return gp},gp.bufferOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return new gp(t).getResultGeometry(e)}if(3===arguments.length){if(Number.isInteger(arguments[2])&&arguments[0]instanceof cc&&"number"==typeof arguments[1]){var n=arguments[0],r=arguments[1],i=arguments[2],o=new gp(n);o.setQuadrantSegments(i);return o.getResultGeometry(r)}if(arguments[2]instanceof bl&&arguments[0]instanceof cc&&"number"==typeof arguments[1]){var s=arguments[0],a=arguments[1],u=arguments[2];return new gp(s,u).getResultGeometry(a)}}else if(4===arguments.length){var c=arguments[0],h=arguments[1],l=arguments[2],p=arguments[3],f=new gp(c);f.setQuadrantSegments(l),f.setEndCapStyle(p);return f.getResultGeometry(h)}},gp.precisionScaleFactor=function(t,e,n){var r=t.getEnvelopeInternal(),i=Pu.max(Math.abs(r.getMaxX()),Math.abs(r.getMaxY()),Math.abs(r.getMinX()),Math.abs(r.getMinY()))+2*(e>0?e:0),o=n-Math.trunc(Math.log(i)/Math.log(10)+1);return Math.pow(10,o)},dp.CAP_ROUND.get=function(){return bl.CAP_ROUND},dp.CAP_BUTT.get=function(){return bl.CAP_FLAT},dp.CAP_FLAT.get=function(){return bl.CAP_FLAT},dp.CAP_SQUARE.get=function(){return bl.CAP_SQUARE},dp.MAX_PRECISION_DIGITS.get=function(){return 12},Object.defineProperties(gp,dp);var yp=function(){this._pt=[new bu,new bu],this._distance=mu.NaN,this._isNull=!0};yp.prototype.getCoordinates=function(){return this._pt},yp.prototype.getCoordinate=function(t){return this._pt[t]},yp.prototype.setMinimum=function(){if(1===arguments.length){var t=arguments[0];this.setMinimum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var r=e.distance(n);r<this._distance&&this.initialize(e,n,r)}},yp.prototype.initialize=function(){if(0===arguments.length)this._isNull=!0;else if(2===arguments.length){var t=arguments[0],e=arguments[1];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=t.distance(e),this._isNull=!1}else if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2];this._pt[0].setCoordinate(n),this._pt[1].setCoordinate(r),this._distance=i,this._isNull=!1}},yp.prototype.getDistance=function(){return this._distance},yp.prototype.setMaximum=function(){if(1===arguments.length){var t=arguments[0];this.setMaximum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var r=e.distance(n);r>this._distance&&this.initialize(e,n,r)}},yp.prototype.interfaces_=function(){return[]},yp.prototype.getClass=function(){return yp};var _p=function(){};_p.prototype.interfaces_=function(){return[]},_p.prototype.getClass=function(){return _p},_p.computeDistance=function(){if(arguments[2]instanceof yp&&arguments[0]instanceof Jc&&arguments[1]instanceof bu)for(var t=arguments[0],e=arguments[1],n=arguments[2],r=t.getCoordinates(),i=new gl,o=0;o<r.length-1;o++){i.setCoordinates(r[o],r[o+1]);var s=i.closestPoint(e);n.setMinimum(s,e)}else if(arguments[2]instanceof yp&&arguments[0]instanceof $c&&arguments[1]instanceof bu){var a=arguments[0],u=arguments[1],c=arguments[2];_p.computeDistance(a.getExteriorRing(),u,c);for(var h=0;h<a.getNumInteriorRing();h++)_p.computeDistance(a.getInteriorRingN(h),u,c)}else if(arguments[2]instanceof yp&&arguments[0]instanceof cc&&arguments[1]instanceof bu){var l=arguments[0],p=arguments[1],f=arguments[2];if(l instanceof Jc)_p.computeDistance(l,p,f);else if(l instanceof $c)_p.computeDistance(l,p,f);else if(l instanceof jc)for(var g=l,d=0;d<g.getNumGeometries();d++){var y=g.getGeometryN(d);_p.computeDistance(y,p,f)}else f.setMinimum(l.getCoordinate(),p)}else if(arguments[2]instanceof yp&&arguments[0]instanceof gl&&arguments[1]instanceof bu){var _=arguments[0],m=arguments[1],v=arguments[2],x=_.closestPoint(m);v.setMinimum(x,m)}};var mp=function(t){this._maxPtDist=new yp,this._inputGeom=t||null},vp={MaxPointDistanceFilter:{configurable:!0},MaxMidpointDistanceFilter:{configurable:!0}};mp.prototype.computeMaxMidpointDistance=function(t){var e=new Ep(this._inputGeom);t.apply(e),this._maxPtDist.setMaximum(e.getMaxPointDistance())},mp.prototype.computeMaxVertexDistance=function(t){var e=new xp(this._inputGeom);t.apply(e),this._maxPtDist.setMaximum(e.getMaxPointDistance())},mp.prototype.findDistance=function(t){return this.computeMaxVertexDistance(t),this.computeMaxMidpointDistance(t),this._maxPtDist.getDistance()},mp.prototype.getDistancePoints=function(){return this._maxPtDist},mp.prototype.interfaces_=function(){return[]},mp.prototype.getClass=function(){return mp},vp.MaxPointDistanceFilter.get=function(){return xp},vp.MaxMidpointDistanceFilter.get=function(){return Ep},Object.defineProperties(mp,vp);var xp=function(t){this._maxPtDist=new yp,this._minPtDist=new yp,this._geom=t||null};xp.prototype.filter=function(t){this._minPtDist.initialize(),_p.computeDistance(this._geom,t,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},xp.prototype.getMaxPointDistance=function(){return this._maxPtDist},xp.prototype.interfaces_=function(){return[pc]},xp.prototype.getClass=function(){return xp};var Ep=function(t){this._maxPtDist=new yp,this._minPtDist=new yp,this._geom=t||null};Ep.prototype.filter=function(t,e){if(0===e)return null;var n=t.getCoordinate(e-1),r=t.getCoordinate(e),i=new bu((n.x+r.x)/2,(n.y+r.y)/2);this._minPtDist.initialize(),_p.computeDistance(this._geom,i,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},Ep.prototype.isDone=function(){return!1},Ep.prototype.isGeometryChanged=function(){return!1},Ep.prototype.getMaxPointDistance=function(){return this._maxPtDist},Ep.prototype.interfaces_=function(){return[zc]},Ep.prototype.getClass=function(){return Ep};var wp=function(t){this._comps=t||null};wp.prototype.filter=function(t){t instanceof $c&&this._comps.add(t)},wp.prototype.interfaces_=function(){return[kc]},wp.prototype.getClass=function(){return wp},wp.getPolygons=function(){if(1===arguments.length){var t=arguments[0];return wp.getPolygons(t,new bc)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof $c?n.add(e):e instanceof jc&&e.apply(new wp(n)),n}};var bp=function(){if(this._lines=null,this._isForcedToLineString=!1,1===arguments.length){var t=arguments[0];this._lines=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this._lines=e,this._isForcedToLineString=n}};bp.prototype.filter=function(t){if(this._isForcedToLineString&&t instanceof eh){var e=t.getFactory().createLineString(t.getCoordinateSequence());return this._lines.add(e),null}t instanceof Jc&&this._lines.add(t)},bp.prototype.setForceToLineString=function(t){this._isForcedToLineString=t},bp.prototype.interfaces_=function(){return[uc]},bp.prototype.getClass=function(){return bp},bp.getGeometry=function(){if(1===arguments.length){var t=arguments[0];return t.getFactory().buildGeometry(bp.getLines(t))}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e.getFactory().buildGeometry(bp.getLines(e,n))}},bp.getLines=function(){if(1===arguments.length){var t=arguments[0];return bp.getLines(t,!1)}if(2===arguments.length){if(Lu(arguments[0],vc)&&Lu(arguments[1],vc)){for(var e=arguments[0],n=arguments[1],r=e.iterator();r.hasNext();){var i=r.next();bp.getLines(i,n)}return n}if(arguments[0]instanceof cc&&"boolean"==typeof arguments[1]){var o=arguments[0],s=arguments[1],a=new bc;return o.apply(new bp(a,s)),a}if(arguments[0]instanceof cc&&Lu(arguments[1],vc)){var u=arguments[0],c=arguments[1];return u instanceof Jc?c.add(u):u.apply(new bp(c)),c}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&Lu(arguments[0],vc)&&Lu(arguments[1],vc)){for(var h=arguments[0],l=arguments[1],p=arguments[2],f=h.iterator();f.hasNext();){var g=f.next();bp.getLines(g,l,p)}return l}if("boolean"==typeof arguments[2]&&arguments[0]instanceof cc&&Lu(arguments[1],vc)){var d=arguments[0],y=arguments[1],_=arguments[2];return d.apply(new bp(y,_)),y}}};var Ip=function(){if(this._boundaryRule=fc.OGC_SFS_BOUNDARY_RULE,this._isIn=null,this._numBoundaries=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];if(null===t)throw new _u("Rule must be non-null");this._boundaryRule=t}};Ip.prototype.locateInternal=function(){if(arguments[0]instanceof bu&&arguments[1]instanceof $c){var t=arguments[0],e=arguments[1];if(e.isEmpty())return Su.EXTERIOR;var n=e.getExteriorRing(),r=this.locateInPolygonRing(t,n);if(r===Su.EXTERIOR)return Su.EXTERIOR;if(r===Su.BOUNDARY)return Su.BOUNDARY;for(var i=0;i<e.getNumInteriorRing();i++){var o=e.getInteriorRingN(i),s=this.locateInPolygonRing(t,o);if(s===Su.INTERIOR)return Su.EXTERIOR;if(s===Su.BOUNDARY)return Su.BOUNDARY}return Su.INTERIOR}if(arguments[0]instanceof bu&&arguments[1]instanceof Jc){var a=arguments[0],u=arguments[1];if(!u.getEnvelopeInternal().intersects(a))return Su.EXTERIOR;var c=u.getCoordinates();return u.isClosed()||!a.equals(c[0])&&!a.equals(c[c.length-1])?sc.isOnLine(a,c)?Su.INTERIOR:Su.EXTERIOR:Su.BOUNDARY}if(arguments[0]instanceof bu&&arguments[1]instanceof Kc){var h=arguments[0];return arguments[1].getCoordinate().equals2D(h)?Su.INTERIOR:Su.EXTERIOR}},Ip.prototype.locateInPolygonRing=function(t,e){return e.getEnvelopeInternal().intersects(t)?sc.locatePointInRing(t,e.getCoordinates()):Su.EXTERIOR},Ip.prototype.intersects=function(t,e){return this.locate(t,e)!==Su.EXTERIOR},Ip.prototype.updateLocationInfo=function(t){t===Su.INTERIOR&&(this._isIn=!0),t===Su.BOUNDARY&&this._numBoundaries++},Ip.prototype.computeLocation=function(t,e){if(e instanceof Kc&&this.updateLocationInfo(this.locateInternal(t,e)),e instanceof Jc)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof $c)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof Xc)for(var n=e,r=0;r<n.getNumGeometries();r++){var i=n.getGeometryN(r);this.updateLocationInfo(this.locateInternal(t,i))}else if(e instanceof nh)for(var o=e,s=0;s<o.getNumGeometries();s++){var a=o.getGeometryN(s);this.updateLocationInfo(this.locateInternal(t,a))}else if(e instanceof jc)for(var u=new kl(e);u.hasNext();){var c=u.next();c!==e&&this.computeLocation(t,c)}},Ip.prototype.locate=function(t,e){return e.isEmpty()?Su.EXTERIOR:e instanceof Jc?this.locateInternal(t,e):e instanceof $c?this.locateInternal(t,e):(this._isIn=!1,this._numBoundaries=0,this.computeLocation(t,e),this._boundaryRule.isInBoundary(this._numBoundaries)?Su.BOUNDARY:this._numBoundaries>0||this._isIn?Su.INTERIOR:Su.EXTERIOR)},Ip.prototype.interfaces_=function(){return[]},Ip.prototype.getClass=function(){return Ip};var Np=function t(){if(this._component=null,this._segIndex=null,this._pt=null,2===arguments.length){var e=arguments[0],n=arguments[1];t.call(this,e,t.INSIDE_AREA,n)}else if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2];this._component=r,this._segIndex=i,this._pt=o}},Cp={INSIDE_AREA:{configurable:!0}};Np.prototype.isInsideArea=function(){return this._segIndex===Np.INSIDE_AREA},Np.prototype.getCoordinate=function(){return this._pt},Np.prototype.getGeometryComponent=function(){return this._component},Np.prototype.getSegmentIndex=function(){return this._segIndex},Np.prototype.interfaces_=function(){return[]},Np.prototype.getClass=function(){return Np},Cp.INSIDE_AREA.get=function(){return-1},Object.defineProperties(Np,Cp);var Sp=function(t){this._pts=t||null};Sp.prototype.filter=function(t){t instanceof Kc&&this._pts.add(t)},Sp.prototype.interfaces_=function(){return[kc]},Sp.prototype.getClass=function(){return Sp},Sp.getPoints=function(){if(1===arguments.length){var t=arguments[0];return t instanceof Kc?$h.singletonList(t):Sp.getPoints(t,new bc)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof Kc?n.add(e):e instanceof jc&&e.apply(new Sp(n)),n}};var Mp=function(){this._locations=null;var t=arguments[0];this._locations=t};Mp.prototype.filter=function(t){(t instanceof Kc||t instanceof Jc||t instanceof $c)&&this._locations.add(new Np(t,0,t.getCoordinate()))},Mp.prototype.interfaces_=function(){return[kc]},Mp.prototype.getClass=function(){return Mp},Mp.getLocations=function(t){var e=new bc;return t.apply(new Mp(e)),e};var Lp=function(){if(this._geom=null,this._terminateDistance=0,this._ptLocator=new Ip,this._minDistanceLocation=null,this._minDistance=mu.MAX_VALUE,2===arguments.length){var t=arguments[0],e=arguments[1];this._geom=[t,e],this._terminateDistance=0}else if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2];this._geom=new Array(2).fill(null),this._geom[0]=n,this._geom[1]=r,this._terminateDistance=i}};Lp.prototype.computeContainmentDistance=function(){if(0===arguments.length){var t=new Array(2).fill(null);if(this.computeContainmentDistance(0,t),this._minDistance<=this._terminateDistance)return null;this.computeContainmentDistance(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],r=1-e,i=wp.getPolygons(this._geom[e]);if(i.size()>0){var o=Mp.getLocations(this._geom[r]);if(this.computeContainmentDistance(o,i,n),this._minDistance<=this._terminateDistance)return this._minDistanceLocation[r]=n[0],this._minDistanceLocation[e]=n[1],null}}else if(3===arguments.length)if(arguments[2]instanceof Array&&Lu(arguments[0],wc)&&Lu(arguments[1],wc)){for(var s=arguments[0],a=arguments[1],u=arguments[2],c=0;c<s.size();c++)for(var h=s.get(c),l=0;l<a.size();l++)if(this.computeContainmentDistance(h,a.get(l),u),this._minDistance<=this._terminateDistance)return null}else if(arguments[2]instanceof Array&&arguments[0]instanceof Np&&arguments[1]instanceof $c){var p=arguments[0],f=arguments[1],g=arguments[2],d=p.getCoordinate();if(Su.EXTERIOR!==this._ptLocator.locate(d,f))return this._minDistance=0,g[0]=p,g[1]=new Np(f,d),null}},Lp.prototype.computeMinDistanceLinesPoints=function(t,e,n){for(var r=0;r<t.size();r++)for(var i=t.get(r),o=0;o<e.size();o++){var s=e.get(o);if(this.computeMinDistance(i,s,n),this._minDistance<=this._terminateDistance)return null}},Lp.prototype.computeFacetDistance=function(){var t=new Array(2).fill(null),e=bp.getLines(this._geom[0]),n=bp.getLines(this._geom[1]),r=Sp.getPoints(this._geom[0]),i=Sp.getPoints(this._geom[1]);return this.computeMinDistanceLines(e,n,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(e,i,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(n,r,t),this.updateMinDistance(t,!0),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistancePoints(r,i,t),void this.updateMinDistance(t,!1))))},Lp.prototype.nearestLocations=function(){return this.computeMinDistance(),this._minDistanceLocation},Lp.prototype.updateMinDistance=function(t,e){if(null===t[0])return null;e?(this._minDistanceLocation[0]=t[1],this._minDistanceLocation[1]=t[0]):(this._minDistanceLocation[0]=t[0],this._minDistanceLocation[1]=t[1])},Lp.prototype.nearestPoints=function(){this.computeMinDistance();return[this._minDistanceLocation[0].getCoordinate(),this._minDistanceLocation[1].getCoordinate()]},Lp.prototype.computeMinDistance=function(){if(0===arguments.length){if(null!==this._minDistanceLocation)return null;if(this._minDistanceLocation=new Array(2).fill(null),this.computeContainmentDistance(),this._minDistance<=this._terminateDistance)return null;this.computeFacetDistance()}else if(3===arguments.length)if(arguments[2]instanceof Array&&arguments[0]instanceof Jc&&arguments[1]instanceof Kc){var t=arguments[0],e=arguments[1],n=arguments[2];if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>this._minDistance)return null;for(var r=t.getCoordinates(),i=e.getCoordinate(),o=0;o<r.length-1;o++){var s=sc.distancePointLine(i,r[o],r[o+1]);if(s<this._minDistance){this._minDistance=s;var a=new gl(r[o],r[o+1]).closestPoint(i);n[0]=new Np(t,o,a),n[1]=new Np(e,0,i)}if(this._minDistance<=this._terminateDistance)return null}}else if(arguments[2]instanceof Array&&arguments[0]instanceof Jc&&arguments[1]instanceof Jc){var u=arguments[0],c=arguments[1],h=arguments[2];if(u.getEnvelopeInternal().distance(c.getEnvelopeInternal())>this._minDistance)return null;for(var l=u.getCoordinates(),p=c.getCoordinates(),f=0;f<l.length-1;f++)for(var g=0;g<p.length-1;g++){var d=sc.distanceLineLine(l[f],l[f+1],p[g],p[g+1]);if(d<this._minDistance){this._minDistance=d;var y=new gl(l[f],l[f+1]),_=new gl(p[g],p[g+1]),m=y.closestPoints(_);h[0]=new Np(u,f,m[0]),h[1]=new Np(c,g,m[1])}if(this._minDistance<=this._terminateDistance)return null}}},Lp.prototype.computeMinDistancePoints=function(t,e,n){for(var r=0;r<t.size();r++)for(var i=t.get(r),o=0;o<e.size();o++){var s=e.get(o),a=i.getCoordinate().distance(s.getCoordinate());if(a<this._minDistance&&(this._minDistance=a,n[0]=new Np(i,0,i.getCoordinate()),n[1]=new Np(s,0,s.getCoordinate())),this._minDistance<=this._terminateDistance)return null}},Lp.prototype.distance=function(){if(null===this._geom[0]||null===this._geom[1])throw new _u("null geometries are not supported");return this._geom[0].isEmpty()||this._geom[1].isEmpty()?0:(this.computeMinDistance(),this._minDistance)},Lp.prototype.computeMinDistanceLines=function(t,e,n){for(var r=0;r<t.size();r++)for(var i=t.get(r),o=0;o<e.size();o++){var s=e.get(o);if(this.computeMinDistance(i,s,n),this._minDistance<=this._terminateDistance)return null}},Lp.prototype.interfaces_=function(){return[]},Lp.prototype.getClass=function(){return Lp},Lp.distance=function(t,e){return new Lp(t,e).distance()},Lp.isWithinDistance=function(t,e,n){return new Lp(t,e,n).distance()<=n},Lp.nearestPoints=function(t,e){return new Lp(t,e).nearestPoints()};var Pp=function(){this._pt=[new bu,new bu],this._distance=mu.NaN,this._isNull=!0};Pp.prototype.getCoordinates=function(){return this._pt},Pp.prototype.getCoordinate=function(t){return this._pt[t]},Pp.prototype.setMinimum=function(){if(1===arguments.length){var t=arguments[0];this.setMinimum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var r=e.distance(n);r<this._distance&&this.initialize(e,n,r)}},Pp.prototype.initialize=function(){if(0===arguments.length)this._isNull=!0;else if(2===arguments.length){var t=arguments[0],e=arguments[1];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=t.distance(e),this._isNull=!1}else if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2];this._pt[0].setCoordinate(n),this._pt[1].setCoordinate(r),this._distance=i,this._isNull=!1}},Pp.prototype.toString=function(){return Ku.toLineString(this._pt[0],this._pt[1])},Pp.prototype.getDistance=function(){return this._distance},Pp.prototype.setMaximum=function(){if(1===arguments.length){var t=arguments[0];this.setMaximum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var r=e.distance(n);r>this._distance&&this.initialize(e,n,r)}},Pp.prototype.interfaces_=function(){return[]},Pp.prototype.getClass=function(){return Pp};var Op=function(){};Op.prototype.interfaces_=function(){return[]},Op.prototype.getClass=function(){return Op},Op.computeDistance=function(){if(arguments[2]instanceof Pp&&arguments[0]instanceof Jc&&arguments[1]instanceof bu)for(var t=arguments[0],e=arguments[1],n=arguments[2],r=new gl,i=t.getCoordinates(),o=0;o<i.length-1;o++){r.setCoordinates(i[o],i[o+1]);var s=r.closestPoint(e);n.setMinimum(s,e)}else if(arguments[2]instanceof Pp&&arguments[0]instanceof $c&&arguments[1]instanceof bu){var a=arguments[0],u=arguments[1],c=arguments[2];Op.computeDistance(a.getExteriorRing(),u,c);for(var h=0;h<a.getNumInteriorRing();h++)Op.computeDistance(a.getInteriorRingN(h),u,c)}else if(arguments[2]instanceof Pp&&arguments[0]instanceof cc&&arguments[1]instanceof bu){var l=arguments[0],p=arguments[1],f=arguments[2];if(l instanceof Jc)Op.computeDistance(l,p,f);else if(l instanceof $c)Op.computeDistance(l,p,f);else if(l instanceof jc)for(var g=l,d=0;d<g.getNumGeometries();d++){var y=g.getGeometryN(d);Op.computeDistance(y,p,f)}else f.setMinimum(l.getCoordinate(),p)}else if(arguments[2]instanceof Pp&&arguments[0]instanceof gl&&arguments[1]instanceof bu){var _=arguments[0],m=arguments[1],v=arguments[2],x=_.closestPoint(m);v.setMinimum(x,m)}};var Rp=function(){this._g0=null,this._g1=null,this._ptDist=new Pp,this._densifyFrac=0;var t=arguments[0],e=arguments[1];this._g0=t,this._g1=e},Tp={MaxPointDistanceFilter:{configurable:!0},MaxDensifiedByFractionDistanceFilter:{configurable:!0}};Rp.prototype.getCoordinates=function(){return this._ptDist.getCoordinates()},Rp.prototype.setDensifyFraction=function(t){if(t>1||t<=0)throw new _u("Fraction is not in range (0.0 - 1.0]");this._densifyFrac=t},Rp.prototype.compute=function(t,e){this.computeOrientedDistance(t,e,this._ptDist),this.computeOrientedDistance(e,t,this._ptDist)},Rp.prototype.distance=function(){return this.compute(this._g0,this._g1),this._ptDist.getDistance()},Rp.prototype.computeOrientedDistance=function(t,e,n){var r=new Ap(e);if(t.apply(r),n.setMaximum(r.getMaxPointDistance()),this._densifyFrac>0){var i=new Dp(e,this._densifyFrac);t.apply(i),n.setMaximum(i.getMaxPointDistance())}},Rp.prototype.orientedDistance=function(){return this.computeOrientedDistance(this._g0,this._g1,this._ptDist),this._ptDist.getDistance()},Rp.prototype.interfaces_=function(){return[]},Rp.prototype.getClass=function(){return Rp},Rp.distance=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return new Rp(t,e).distance()}if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2],o=new Rp(n,r);return o.setDensifyFraction(i),o.distance()}},Tp.MaxPointDistanceFilter.get=function(){return Ap},Tp.MaxDensifiedByFractionDistanceFilter.get=function(){return Dp},Object.defineProperties(Rp,Tp);var Ap=function(){this._maxPtDist=new Pp,this._minPtDist=new Pp,this._euclideanDist=new Op,this._geom=null;var t=arguments[0];this._geom=t};Ap.prototype.filter=function(t){this._minPtDist.initialize(),Op.computeDistance(this._geom,t,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},Ap.prototype.getMaxPointDistance=function(){return this._maxPtDist},Ap.prototype.interfaces_=function(){return[pc]},Ap.prototype.getClass=function(){return Ap};var Dp=function(){this._maxPtDist=new Pp,this._minPtDist=new Pp,this._geom=null,this._numSubSegs=0;var t=arguments[0],e=arguments[1];this._geom=t,this._numSubSegs=Math.trunc(Math.round(1/e))};Dp.prototype.filter=function(t,e){if(0===e)return null;for(var n=t.getCoordinate(e-1),r=t.getCoordinate(e),i=(r.x-n.x)/this._numSubSegs,o=(r.y-n.y)/this._numSubSegs,s=0;s<this._numSubSegs;s++){var a=n.x+s*i,u=n.y+s*o,c=new bu(a,u);this._minPtDist.initialize(),Op.computeDistance(this._geom,c,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)}},Dp.prototype.isDone=function(){return!1},Dp.prototype.isGeometryChanged=function(){return!1},Dp.prototype.getMaxPointDistance=function(){return this._maxPtDist},Dp.prototype.interfaces_=function(){return[zc]},Dp.prototype.getClass=function(){return Dp};var Fp=function(t,e,n){this._minValidDistance=null,this._maxValidDistance=null,this._minDistanceFound=null,this._maxDistanceFound=null,this._isValid=!0,this._errMsg=null,this._errorLocation=null,this._errorIndicator=null,this._input=t||null,this._bufDistance=e||null,this._result=n||null},qp={VERBOSE:{configurable:!0},MAX_DISTANCE_DIFF_FRAC:{configurable:!0}};Fp.prototype.checkMaximumDistance=function(t,e,n){var r=new Rp(e,t);if(r.setDensifyFraction(.25),this._maxDistanceFound=r.orientedDistance(),this._maxDistanceFound>n){this._isValid=!1;var i=r.getCoordinates();this._errorLocation=i[1],this._errorIndicator=t.getFactory().createLineString(i),this._errMsg="Distance between buffer curve and input is too large ("+this._maxDistanceFound+" at "+Ku.toLineString(i[0],i[1])+")"}},Fp.prototype.isValid=function(){var t=Math.abs(this._bufDistance),e=Fp.MAX_DISTANCE_DIFF_FRAC*t;return this._minValidDistance=t-e,this._maxValidDistance=t+e,!(!this._input.isEmpty()&&!this._result.isEmpty())||(this._bufDistance>0?this.checkPositiveValid():this.checkNegativeValid(),Fp.VERBOSE&&Xu.out.println("Min Dist= "+this._minDistanceFound+"  err= "+(1-this._minDistanceFound/this._bufDistance)+"  Max Dist= "+this._maxDistanceFound+"  err= "+(this._maxDistanceFound/this._bufDistance-1)),this._isValid)},Fp.prototype.checkNegativeValid=function(){if(!(this._input instanceof $c||this._input instanceof nh||this._input instanceof jc))return null;var t=this.getPolygonLines(this._input);if(this.checkMinimumDistance(t,this._result,this._minValidDistance),!this._isValid)return null;this.checkMaximumDistance(t,this._result,this._maxValidDistance)},Fp.prototype.getErrorIndicator=function(){return this._errorIndicator},Fp.prototype.checkMinimumDistance=function(t,e,n){var r=new Lp(t,e,n);if(this._minDistanceFound=r.distance(),this._minDistanceFound<n){this._isValid=!1;var i=r.nearestPoints();this._errorLocation=r.nearestPoints()[1],this._errorIndicator=t.getFactory().createLineString(i),this._errMsg="Distance between buffer curve and input is too small ("+this._minDistanceFound+" at "+Ku.toLineString(i[0],i[1])+" )"}},Fp.prototype.checkPositiveValid=function(){var t=this._result.getBoundary();if(this.checkMinimumDistance(this._input,t,this._minValidDistance),!this._isValid)return null;this.checkMaximumDistance(this._input,t,this._maxValidDistance)},Fp.prototype.getErrorLocation=function(){return this._errorLocation},Fp.prototype.getPolygonLines=function(t){for(var e=new bc,n=new bp(e),r=wp.getPolygons(t).iterator();r.hasNext();){r.next().apply(n)}return t.getFactory().buildGeometry(e)},Fp.prototype.getErrorMessage=function(){return this._errMsg},Fp.prototype.interfaces_=function(){return[]},Fp.prototype.getClass=function(){return Fp},qp.VERBOSE.get=function(){return!1},qp.MAX_DISTANCE_DIFF_FRAC.get=function(){return.012},Object.defineProperties(Fp,qp);var Gp=function(t,e,n){this._isValid=!0,this._errorMsg=null,this._errorLocation=null,this._errorIndicator=null,this._input=t||null,this._distance=e||null,this._result=n||null},Bp={VERBOSE:{configurable:!0},MAX_ENV_DIFF_FRAC:{configurable:!0}};Gp.prototype.isValid=function(){return this.checkPolygonal(),this._isValid?(this.checkExpectedEmpty(),this._isValid?(this.checkEnvelope(),this._isValid?(this.checkArea(),this._isValid?(this.checkDistance(),this._isValid):this._isValid):this._isValid):this._isValid):this._isValid},Gp.prototype.checkEnvelope=function(){if(this._distance<0)return null;var t=this._distance*Gp.MAX_ENV_DIFF_FRAC;0===t&&(t=.001);var e=new Yu(this._input.getEnvelopeInternal());e.expandBy(this._distance);var n=new Yu(this._result.getEnvelopeInternal());n.expandBy(t),n.contains(e)||(this._isValid=!1,this._errorMsg="Buffer envelope is incorrect",this._errorIndicator=this._input.getFactory().toGeometry(n)),this.report("Envelope")},Gp.prototype.checkDistance=function(){var t=new Fp(this._input,this._distance,this._result);t.isValid()||(this._isValid=!1,this._errorMsg=t.getErrorMessage(),this._errorLocation=t.getErrorLocation(),this._errorIndicator=t.getErrorIndicator()),this.report("Distance")},Gp.prototype.checkArea=function(){var t=this._input.getArea(),e=this._result.getArea();this._distance>0&&t>e&&(this._isValid=!1,this._errorMsg="Area of positive buffer is smaller than input",this._errorIndicator=this._result),this._distance<0&&t<e&&(this._isValid=!1,this._errorMsg="Area of negative buffer is larger than input",this._errorIndicator=this._result),this.report("Area")},Gp.prototype.checkPolygonal=function(){this._result instanceof $c||this._result instanceof nh||(this._isValid=!1),this._errorMsg="Result is not polygonal",this._errorIndicator=this._result,this.report("Polygonal")},Gp.prototype.getErrorIndicator=function(){return this._errorIndicator},Gp.prototype.getErrorLocation=function(){return this._errorLocation},Gp.prototype.checkExpectedEmpty=function(){return this._input.getDimension()>=2?null:this._distance>0?null:(this._result.isEmpty()||(this._isValid=!1,this._errorMsg="Result is non-empty",this._errorIndicator=this._result),void this.report("ExpectedEmpty"))},Gp.prototype.report=function(t){if(!Gp.VERBOSE)return null;Xu.out.println("Check "+t+": "+(this._isValid?"passed":"FAILED"))},Gp.prototype.getErrorMessage=function(){return this._errorMsg},Gp.prototype.interfaces_=function(){return[]},Gp.prototype.getClass=function(){return Gp},Gp.isValidMsg=function(t,e,n){var r=new Gp(t,e,n);return r.isValid()?null:r.getErrorMessage()},Gp.isValid=function(t,e,n){return!!new Gp(t,e,n).isValid()},Bp.VERBOSE.get=function(){return!1},Bp.MAX_ENV_DIFF_FRAC.get=function(){return.012},Object.defineProperties(Gp,Bp);var kp=function(){this._pts=null,this._data=null;var t=arguments[0],e=arguments[1];this._pts=t,this._data=e};kp.prototype.getCoordinates=function(){return this._pts},kp.prototype.size=function(){return this._pts.length},kp.prototype.getCoordinate=function(t){return this._pts[t]},kp.prototype.isClosed=function(){return this._pts[0].equals(this._pts[this._pts.length-1])},kp.prototype.getSegmentOctant=function(t){return t===this._pts.length-1?-1:hl.octant(this.getCoordinate(t),this.getCoordinate(t+1))},kp.prototype.setData=function(t){this._data=t},kp.prototype.getData=function(){return this._data},kp.prototype.toString=function(){return Ku.toLineString(new uh(this._pts))},kp.prototype.interfaces_=function(){return[ll]},kp.prototype.getClass=function(){return kp};var zp=function(){this._findAllIntersections=!1,this._isCheckEndSegmentsOnly=!1,this._li=null,this._interiorIntersection=null,this._intSegments=null,this._intersections=new bc,this._intersectionCount=0,this._keepIntersections=!0;var t=arguments[0];this._li=t,this._interiorIntersection=null};zp.prototype.getInteriorIntersection=function(){return this._interiorIntersection},zp.prototype.setCheckEndSegmentsOnly=function(t){this._isCheckEndSegmentsOnly=t},zp.prototype.getIntersectionSegments=function(){return this._intSegments},zp.prototype.count=function(){return this._intersectionCount},zp.prototype.getIntersections=function(){return this._intersections},zp.prototype.setFindAllIntersections=function(t){this._findAllIntersections=t},zp.prototype.setKeepIntersections=function(t){this._keepIntersections=t},zp.prototype.processIntersections=function(t,e,n,r){if(!this._findAllIntersections&&this.hasIntersection())return null;if(t===n&&e===r)return null;if(this._isCheckEndSegmentsOnly){if(!(this.isEndSegment(t,e)||this.isEndSegment(n,r)))return null}var i=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[r],a=n.getCoordinates()[r+1];this._li.computeIntersection(i,o,s,a),this._li.hasIntersection()&&this._li.isInteriorIntersection()&&(this._intSegments=new Array(4).fill(null),this._intSegments[0]=i,this._intSegments[1]=o,this._intSegments[2]=s,this._intSegments[3]=a,this._interiorIntersection=this._li.getIntersection(0),this._keepIntersections&&this._intersections.add(this._interiorIntersection),this._intersectionCount++)},zp.prototype.isEndSegment=function(t,e){return 0===e||e>=t.size()-2},zp.prototype.hasIntersection=function(){return null!==this._interiorIntersection},zp.prototype.isDone=function(){return!this._findAllIntersections&&null!==this._interiorIntersection},zp.prototype.interfaces_=function(){return[Hl]},zp.prototype.getClass=function(){return zp},zp.createAllIntersectionsFinder=function(t){var e=new zp(t);return e.setFindAllIntersections(!0),e},zp.createAnyIntersectionFinder=function(t){return new zp(t)},zp.createIntersectionCounter=function(t){var e=new zp(t);return e.setFindAllIntersections(!0),e.setKeepIntersections(!1),e};var jp=function(){this._li=new rc,this._segStrings=null,this._findAllIntersections=!1,this._segInt=null,this._isValid=!0;var t=arguments[0];this._segStrings=t};jp.prototype.execute=function(){if(null!==this._segInt)return null;this.checkInteriorIntersections()},jp.prototype.getIntersections=function(){return this._segInt.getIntersections()},jp.prototype.isValid=function(){return this.execute(),this._isValid},jp.prototype.setFindAllIntersections=function(t){this._findAllIntersections=t},jp.prototype.checkInteriorIntersections=function(){this._isValid=!0,this._segInt=new zp(this._li),this._segInt.setFindAllIntersections(this._findAllIntersections);var t=new El;if(t.setSegmentIntersector(this._segInt),t.computeNodes(this._segStrings),this._segInt.hasIntersection())return this._isValid=!1,null},jp.prototype.checkValid=function(){if(this.execute(),!this._isValid)throw new Mh(this.getErrorMessage(),this._segInt.getInteriorIntersection())},jp.prototype.getErrorMessage=function(){if(this._isValid)return"no intersections found";var t=this._segInt.getIntersectionSegments();return"found non-noded intersection between "+Ku.toLineString(t[0],t[1])+" and "+Ku.toLineString(t[2],t[3])},jp.prototype.interfaces_=function(){return[]},jp.prototype.getClass=function(){return jp},jp.computeIntersections=function(t){var e=new jp(t);return e.setFindAllIntersections(!0),e.isValid(),e.getIntersections()};var Xp=function t(){this._nv=null;var e=arguments[0];this._nv=new jp(t.toSegmentStrings(e))};Xp.prototype.checkValid=function(){this._nv.checkValid()},Xp.prototype.interfaces_=function(){return[]},Xp.prototype.getClass=function(){return Xp},Xp.toSegmentStrings=function(t){for(var e=new bc,n=t.iterator();n.hasNext();){var r=n.next();e.add(new kp(r.getCoordinates(),r))}return e},Xp.checkValid=function(t){new Xp(t).checkValid()};var Up=function(t){this._mapOp=t};Up.prototype.map=function(t){for(var e=new bc,n=0;n<t.getNumGeometries();n++){var r=this._mapOp.map(t.getGeometryN(n));r.isEmpty()||e.add(r)}return t.getFactory().createGeometryCollection(_h.toGeometryArray(e))},Up.prototype.interfaces_=function(){return[]},Up.prototype.getClass=function(){return Up},Up.map=function(t,e){return new Up(e).map(t)};var Yp=function(){this._op=null,this._geometryFactory=null,this._ptLocator=null,this._lineEdgesList=new bc,this._resultLineList=new bc;var t=arguments[0],e=arguments[1],n=arguments[2];this._op=t,this._geometryFactory=e,this._ptLocator=n};Yp.prototype.collectLines=function(t){for(var e=this._op.getGraph().getEdgeEnds().iterator();e.hasNext();){var n=e.next();this.collectLineEdge(n,t,this._lineEdgesList),this.collectBoundaryTouchEdge(n,t,this._lineEdgesList)}},Yp.prototype.labelIsolatedLine=function(t,e){var n=this._ptLocator.locate(t.getCoordinate(),this._op.getArgGeometry(e));t.getLabel().setLocation(e,n)},Yp.prototype.build=function(t){return this.findCoveredLineEdges(),this.collectLines(t),this.buildLines(t),this._resultLineList},Yp.prototype.collectLineEdge=function(t,e,n){var r=t.getLabel(),i=t.getEdge();t.isLineEdge()&&(t.isVisited()||!Cf.isResultOfOp(r,e)||i.isCovered()||(n.add(i),t.setVisitedEdge(!0)))},Yp.prototype.findCoveredLineEdges=function(){for(var t=this._op.getGraph().getNodes().iterator();t.hasNext();){t.next().getEdges().findCoveredLineEdges()}for(var e=this._op.getGraph().getEdgeEnds().iterator();e.hasNext();){var n=e.next(),r=n.getEdge();if(n.isLineEdge()&&!r.isCoveredSet()){var i=this._op.isCoveredByA(n.getCoordinate());r.setCovered(i)}}},Yp.prototype.labelIsolatedLines=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),r=n.getLabel();n.isIsolated()&&(r.isNull(0)?this.labelIsolatedLine(n,0):this.labelIsolatedLine(n,1))}},Yp.prototype.buildLines=function(t){for(var e=this._lineEdgesList.iterator();e.hasNext();){var n=e.next(),r=this._geometryFactory.createLineString(n.getCoordinates());this._resultLineList.add(r),n.setInResult(!0)}},Yp.prototype.collectBoundaryTouchEdge=function(t,e,n){var r=t.getLabel();return t.isLineEdge()?null:t.isVisited()?null:t.isInteriorAreaEdge()?null:t.getEdge().isInResult()?null:(tc.isTrue(!(t.isInResult()||t.getSym().isInResult())||!t.getEdge().isInResult()),void(Cf.isResultOfOp(r,e)&&e===Cf.INTERSECTION&&(n.add(t.getEdge()),t.setVisitedEdge(!0))))},Yp.prototype.interfaces_=function(){return[]},Yp.prototype.getClass=function(){return Yp};var Vp=function(){this._op=null,this._geometryFactory=null,this._resultPointList=new bc;var t=arguments[0],e=arguments[1];this._op=t,this._geometryFactory=e};Vp.prototype.filterCoveredNodeToPoint=function(t){var e=t.getCoordinate();if(!this._op.isCoveredByLA(e)){var n=this._geometryFactory.createPoint(e);this._resultPointList.add(n)}},Vp.prototype.extractNonCoveredResultNodes=function(t){for(var e=this._op.getGraph().getNodes().iterator();e.hasNext();){var n=e.next();if(!n.isInResult()&&(!n.isIncidentEdgeInResult()&&(0===n.getEdges().getDegree()||t===Cf.INTERSECTION))){var r=n.getLabel();Cf.isResultOfOp(r,t)&&this.filterCoveredNodeToPoint(n)}}},Vp.prototype.build=function(t){return this.extractNonCoveredResultNodes(t),this._resultPointList},Vp.prototype.interfaces_=function(){return[]},Vp.prototype.getClass=function(){return Vp};var Hp=function(){this._inputGeom=null,this._factory=null,this._pruneEmptyGeometry=!0,this._preserveGeometryCollectionType=!0,this._preserveCollections=!1,this._preserveType=!1};Hp.prototype.transformPoint=function(t,e){return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(),t))},Hp.prototype.transformPolygon=function(t,e){var n=!0,r=this.transformLinearRing(t.getExteriorRing(),t);null!==r&&r instanceof eh&&!r.isEmpty()||(n=!1);for(var i=new bc,o=0;o<t.getNumInteriorRing();o++){var s=this.transformLinearRing(t.getInteriorRingN(o),t);null===s||s.isEmpty()||(s instanceof eh||(n=!1),i.add(s))}if(n)return this._factory.createPolygon(r,i.toArray([]));var a=new bc;return null!==r&&a.add(r),a.addAll(i),this._factory.buildGeometry(a)},Hp.prototype.createCoordinateSequence=function(t){return this._factory.getCoordinateSequenceFactory().create(t)},Hp.prototype.getInputGeometry=function(){return this._inputGeom},Hp.prototype.transformMultiLineString=function(t,e){for(var n=new bc,r=0;r<t.getNumGeometries();r++){var i=this.transformLineString(t.getGeometryN(r),t);null!==i&&(i.isEmpty()||n.add(i))}return this._factory.buildGeometry(n)},Hp.prototype.transformCoordinates=function(t,e){return this.copy(t)},Hp.prototype.transformLineString=function(t,e){return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(),t))},Hp.prototype.transformMultiPoint=function(t,e){for(var n=new bc,r=0;r<t.getNumGeometries();r++){var i=this.transformPoint(t.getGeometryN(r),t);null!==i&&(i.isEmpty()||n.add(i))}return this._factory.buildGeometry(n)},Hp.prototype.transformMultiPolygon=function(t,e){for(var n=new bc,r=0;r<t.getNumGeometries();r++){var i=this.transformPolygon(t.getGeometryN(r),t);null!==i&&(i.isEmpty()||n.add(i))}return this._factory.buildGeometry(n)},Hp.prototype.copy=function(t){return t.copy()},Hp.prototype.transformGeometryCollection=function(t,e){for(var n=new bc,r=0;r<t.getNumGeometries();r++){var i=this.transform(t.getGeometryN(r));null!==i&&(this._pruneEmptyGeometry&&i.isEmpty()||n.add(i))}return this._preserveGeometryCollectionType?this._factory.createGeometryCollection(_h.toGeometryArray(n)):this._factory.buildGeometry(n)},Hp.prototype.transform=function(t){if(this._inputGeom=t,this._factory=t.getFactory(),t instanceof Kc)return this.transformPoint(t,null);if(t instanceof th)return this.transformMultiPoint(t,null);if(t instanceof eh)return this.transformLinearRing(t,null);if(t instanceof Jc)return this.transformLineString(t,null);if(t instanceof Xc)return this.transformMultiLineString(t,null);if(t instanceof $c)return this.transformPolygon(t,null);if(t instanceof nh)return this.transformMultiPolygon(t,null);if(t instanceof jc)return this.transformGeometryCollection(t,null);throw new _u("Unknown Geometry subtype: "+t.getClass().getName())},Hp.prototype.transformLinearRing=function(t,e){var n=this.transformCoordinates(t.getCoordinateSequence(),t);if(null===n)return this._factory.createLinearRing(null);var r=n.size();return r>0&&r<4&&!this._preserveType?this._factory.createLineString(n):this._factory.createLinearRing(n)},Hp.prototype.interfaces_=function(){return[]},Hp.prototype.getClass=function(){return Hp};var Wp=function t(){if(this._snapTolerance=0,this._srcPts=null,this._seg=new gl,this._allowSnappingToSourceVertices=!1,this._isClosed=!1,arguments[0]instanceof Jc&&"number"==typeof arguments[1]){var e=arguments[0],n=arguments[1];t.call(this,e.getCoordinates(),n)}else if(arguments[0]instanceof Array&&"number"==typeof arguments[1]){var r=arguments[0],i=arguments[1];this._srcPts=r,this._isClosed=t.isClosed(r),this._snapTolerance=i}};Wp.prototype.snapVertices=function(t,e){for(var n=this._isClosed?t.size()-1:t.size(),r=0;r<n;r++){var i=t.get(r),o=this.findSnapForVertex(i,e);null!==o&&(t.set(r,new bu(o)),0===r&&this._isClosed&&t.set(t.size()-1,new bu(o)))}},Wp.prototype.findSnapForVertex=function(t,e){for(var n=0;n<e.length;n++){if(t.equals2D(e[n]))return null;if(t.distance(e[n])<this._snapTolerance)return e[n]}return null},Wp.prototype.snapTo=function(t){var e=new Nc(this._srcPts);this.snapVertices(e,t),this.snapSegments(e,t);return e.toCoordinateArray()},Wp.prototype.snapSegments=function(t,e){if(0===e.length)return null;var n=e.length;e[0].equals2D(e[e.length-1])&&(n=e.length-1);for(var r=0;r<n;r++){var i=e[r],o=this.findSegmentIndexToSnap(i,t);o>=0&&t.add(o+1,new bu(i),!1)}},Wp.prototype.findSegmentIndexToSnap=function(t,e){for(var n=mu.MAX_VALUE,r=-1,i=0;i<e.size()-1;i++){if(this._seg.p0=e.get(i),this._seg.p1=e.get(i+1),this._seg.p0.equals2D(t)||this._seg.p1.equals2D(t)){if(this._allowSnappingToSourceVertices)continue;return-1}var o=this._seg.distance(t);o<this._snapTolerance&&o<n&&(n=o,r=i)}return r},Wp.prototype.setAllowSnappingToSourceVertices=function(t){this._allowSnappingToSourceVertices=t},Wp.prototype.interfaces_=function(){return[]},Wp.prototype.getClass=function(){return Wp},Wp.isClosed=function(t){return!(t.length<=1)&&t[0].equals2D(t[t.length-1])};var Jp=function(t){this._srcGeom=t||null},Zp={SNAP_PRECISION_FACTOR:{configurable:!0}};Jp.prototype.snapTo=function(t,e){var n=this.extractTargetCoordinates(t);return new Kp(e,n).transform(this._srcGeom)},Jp.prototype.snapToSelf=function(t,e){var n=this.extractTargetCoordinates(this._srcGeom),r=new Kp(t,n,!0).transform(this._srcGeom),i=r;return e&&Lu(i,Qc)&&(i=r.buffer(0)),i},Jp.prototype.computeSnapTolerance=function(t){return this.computeMinimumSegmentLength(t)/10},Jp.prototype.extractTargetCoordinates=function(t){for(var e=new ki,n=t.getCoordinates(),r=0;r<n.length;r++)e.add(n[r]);return e.toArray(new Array(0).fill(null))},Jp.prototype.computeMinimumSegmentLength=function(t){for(var e=mu.MAX_VALUE,n=0;n<t.length-1;n++){var r=t[n].distance(t[n+1]);r<e&&(e=r)}return e},Jp.prototype.interfaces_=function(){return[]},Jp.prototype.getClass=function(){return Jp},Jp.snap=function(t,e,n){var r=new Array(2).fill(null),i=new Jp(t);r[0]=i.snapTo(e,n);var o=new Jp(e);return r[1]=o.snapTo(r[0],n),r},Jp.computeOverlaySnapTolerance=function(){if(1===arguments.length){var t=arguments[0],e=Jp.computeSizeBasedSnapTolerance(t),n=t.getPrecisionModel();if(n.getType()===fh.FIXED){var r=1/n.getScale()*2/1.415;r>e&&(e=r)}return e}if(2===arguments.length){var i=arguments[0],o=arguments[1];return Math.min(Jp.computeOverlaySnapTolerance(i),Jp.computeOverlaySnapTolerance(o))}},Jp.computeSizeBasedSnapTolerance=function(t){var e=t.getEnvelopeInternal();return Math.min(e.getHeight(),e.getWidth())*Jp.SNAP_PRECISION_FACTOR},Jp.snapToSelf=function(t,e,n){return new Jp(t).snapToSelf(e,n)},Zp.SNAP_PRECISION_FACTOR.get=function(){return 1e-9},Object.defineProperties(Jp,Zp);var Kp=function(t){function e(e,n,r){t.call(this),this._snapTolerance=e||null,this._snapPts=n||null,this._isSelfSnap=void 0!==r&&r}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.snapLine=function(t,e){var n=new Wp(t,this._snapTolerance);return n.setAllowSnappingToSourceVertices(this._isSelfSnap),n.snapTo(e)},e.prototype.transformCoordinates=function(t,e){var n=t.toCoordinateArray(),r=this.snapLine(n,this._snapPts);return this._factory.getCoordinateSequenceFactory().create(r)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Hp),Qp=function(){this._isFirst=!0,this._commonMantissaBitsCount=53,this._commonBits=0,this._commonSignExp=null};Qp.prototype.getCommon=function(){return mu.longBitsToDouble(this._commonBits)},Qp.prototype.add=function(t){var e=mu.doubleToLongBits(t);if(this._isFirst)return this._commonBits=e,this._commonSignExp=Qp.signExpBits(this._commonBits),this._isFirst=!1,null;if(Qp.signExpBits(e)!==this._commonSignExp)return this._commonBits=0,null;this._commonMantissaBitsCount=Qp.numCommonMostSigMantissaBits(this._commonBits,e),this._commonBits=Qp.zeroLowerBits(this._commonBits,64-(12+this._commonMantissaBitsCount))},Qp.prototype.toString=function(){if(1===arguments.length){var t=arguments[0],e=mu.longBitsToDouble(t),n="0000000000000000000000000000000000000000000000000000000000000000"+mu.toBinaryString(t),r=n.substring(n.length-64);return r.substring(0,1)+"  "+r.substring(1,12)+"(exp) "+r.substring(12)+" [ "+e+" ]"}},Qp.prototype.interfaces_=function(){return[]},Qp.prototype.getClass=function(){return Qp},Qp.getBit=function(t,e){return 0!=(t&1<<e)?1:0},Qp.signExpBits=function(t){return t>>52},Qp.zeroLowerBits=function(t,e){return t&~((1<<e)-1)},Qp.numCommonMostSigMantissaBits=function(t,e){for(var n=0,r=52;r>=0;r--){if(Qp.getBit(t,r)!==Qp.getBit(e,r))return n;n++}return 52};var $p=function(){this._commonCoord=null,this._ccFilter=new ef},tf={CommonCoordinateFilter:{configurable:!0},Translater:{configurable:!0}};$p.prototype.addCommonBits=function(t){var e=new nf(this._commonCoord);t.apply(e),t.geometryChanged()},$p.prototype.removeCommonBits=function(t){if(0===this._commonCoord.x&&0===this._commonCoord.y)return t;var e=new bu(this._commonCoord);e.x=-e.x,e.y=-e.y;var n=new nf(e);return t.apply(n),t.geometryChanged(),t},$p.prototype.getCommonCoordinate=function(){return this._commonCoord},$p.prototype.add=function(t){t.apply(this._ccFilter),this._commonCoord=this._ccFilter.getCommonCoordinate()},$p.prototype.interfaces_=function(){return[]},$p.prototype.getClass=function(){return $p},tf.CommonCoordinateFilter.get=function(){return ef},tf.Translater.get=function(){return nf},Object.defineProperties($p,tf);var ef=function(){this._commonBitsX=new Qp,this._commonBitsY=new Qp};ef.prototype.filter=function(t){this._commonBitsX.add(t.x),this._commonBitsY.add(t.y)},ef.prototype.getCommonCoordinate=function(){return new bu(this._commonBitsX.getCommon(),this._commonBitsY.getCommon())},ef.prototype.interfaces_=function(){return[pc]},ef.prototype.getClass=function(){return ef};var nf=function(){this.trans=null;var t=arguments[0];this.trans=t};nf.prototype.filter=function(t,e){var n=t.getOrdinate(e,0)+this.trans.x,r=t.getOrdinate(e,1)+this.trans.y;t.setOrdinate(e,0,n),t.setOrdinate(e,1,r)},nf.prototype.isDone=function(){return!1},nf.prototype.isGeometryChanged=function(){return!0},nf.prototype.interfaces_=function(){return[zc]},nf.prototype.getClass=function(){return nf};var rf=function(t,e){this._geom=new Array(2).fill(null),this._snapTolerance=null,this._cbr=null,this._geom[0]=t,this._geom[1]=e,this.computeSnapTolerance()};rf.prototype.selfSnap=function(t){return new Jp(t).snapTo(t,this._snapTolerance)},rf.prototype.removeCommonBits=function(t){this._cbr=new $p,this._cbr.add(t[0]),this._cbr.add(t[1]);var e=new Array(2).fill(null);return e[0]=this._cbr.removeCommonBits(t[0].copy()),e[1]=this._cbr.removeCommonBits(t[1].copy()),e},rf.prototype.prepareResult=function(t){return this._cbr.addCommonBits(t),t},rf.prototype.getResultGeometry=function(t){var e=this.snap(this._geom),n=Cf.overlayOp(e[0],e[1],t);return this.prepareResult(n)},rf.prototype.checkValid=function(t){t.isValid()||Xu.out.println("Snapped geometry is invalid")},rf.prototype.computeSnapTolerance=function(){this._snapTolerance=Jp.computeOverlaySnapTolerance(this._geom[0],this._geom[1])},rf.prototype.snap=function(t){var e=this.removeCommonBits(t);return Jp.snap(e[0],e[1],this._snapTolerance)},rf.prototype.interfaces_=function(){return[]},rf.prototype.getClass=function(){return rf},rf.overlayOp=function(t,e,n){return new rf(t,e).getResultGeometry(n)},rf.union=function(t,e){return rf.overlayOp(t,e,Cf.UNION)},rf.intersection=function(t,e){return rf.overlayOp(t,e,Cf.INTERSECTION)},rf.symDifference=function(t,e){return rf.overlayOp(t,e,Cf.SYMDIFFERENCE)},rf.difference=function(t,e){return rf.overlayOp(t,e,Cf.DIFFERENCE)};var of=function(t,e){this._geom=new Array(2).fill(null),this._geom[0]=t,this._geom[1]=e};of.prototype.getResultGeometry=function(t){var e=null,n=!1,r=null;try{e=Cf.overlayOp(this._geom[0],this._geom[1],t);n=!0}catch(t){if(!(t instanceof Qu))throw t;r=t}if(!n)try{e=rf.overlayOp(this._geom[0],this._geom[1],t)}catch(t){throw t instanceof Qu?r:t}return e},of.prototype.interfaces_=function(){return[]},of.prototype.getClass=function(){return of},of.overlayOp=function(t,e,n){return new of(t,e).getResultGeometry(n)},of.union=function(t,e){return of.overlayOp(t,e,Cf.UNION)},of.intersection=function(t,e){return of.overlayOp(t,e,Cf.INTERSECTION)},of.symDifference=function(t,e){return of.overlayOp(t,e,Cf.SYMDIFFERENCE)},of.difference=function(t,e){return of.overlayOp(t,e,Cf.DIFFERENCE)};var sf=function(){this.mce=null,this.chainIndex=null;var t=arguments[0],e=arguments[1];this.mce=t,this.chainIndex=e};sf.prototype.computeIntersections=function(t,e){this.mce.computeIntersectsForChain(this.chainIndex,t.mce,t.chainIndex,e)},sf.prototype.interfaces_=function(){return[]},sf.prototype.getClass=function(){return sf};var af=function t(){if(this._label=null,this._xValue=null,this._eventType=null,this._insertEvent=null,this._deleteEventIndex=null,this._obj=null,2===arguments.length){var e=arguments[0],n=arguments[1];this._eventType=t.DELETE,this._xValue=e,this._insertEvent=n}else if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2];this._eventType=t.INSERT,this._label=r,this._xValue=i,this._obj=o}},uf={INSERT:{configurable:!0},DELETE:{configurable:!0}};af.prototype.isDelete=function(){return this._eventType===af.DELETE},af.prototype.setDeleteEventIndex=function(t){this._deleteEventIndex=t},af.prototype.getObject=function(){return this._obj},af.prototype.compareTo=function(t){var e=t;return this._xValue<e._xValue?-1:this._xValue>e._xValue?1:this._eventType<e._eventType?-1:this._eventType>e._eventType?1:0},af.prototype.getInsertEvent=function(){return this._insertEvent},af.prototype.isInsert=function(){return this._eventType===af.INSERT},af.prototype.isSameLabel=function(t){return null!==this._label&&this._label===t._label},af.prototype.getDeleteEventIndex=function(){return this._deleteEventIndex},af.prototype.interfaces_=function(){return[xu]},af.prototype.getClass=function(){return af},uf.INSERT.get=function(){return 1},uf.DELETE.get=function(){return 2},Object.defineProperties(af,uf);var cf=function(){};cf.prototype.interfaces_=function(){return[]},cf.prototype.getClass=function(){return cf};var hf=function(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._properIntersectionPoint=null,this._li=null,this._includeProper=null,this._recordIsolated=null,this._isSelfIntersection=null,this._numIntersections=0,this.numTests=0,this._bdyNodes=null,this._isDone=!1,this._isDoneWhenProperInt=!1;var t=arguments[0],e=arguments[1],n=arguments[2];this._li=t,this._includeProper=e,this._recordIsolated=n};hf.prototype.isTrivialIntersection=function(t,e,n,r){if(t===n&&1===this._li.getIntersectionNum()){if(hf.isAdjacentSegments(e,r))return!0;if(t.isClosed()){var i=t.getNumPoints()-1;if(0===e&&r===i||0===r&&e===i)return!0}}return!1},hf.prototype.getProperIntersectionPoint=function(){return this._properIntersectionPoint},hf.prototype.setIsDoneIfProperInt=function(t){this._isDoneWhenProperInt=t},hf.prototype.hasProperInteriorIntersection=function(){return this._hasProperInterior},hf.prototype.isBoundaryPointInternal=function(t,e){for(var n=e.iterator();n.hasNext();){var r=n.next().getCoordinate();if(t.isIntersection(r))return!0}return!1},hf.prototype.hasProperIntersection=function(){return this._hasProper},hf.prototype.hasIntersection=function(){return this._hasIntersection},hf.prototype.isDone=function(){return this._isDone},hf.prototype.isBoundaryPoint=function(t,e){return null!==e&&(!!this.isBoundaryPointInternal(t,e[0])||!!this.isBoundaryPointInternal(t,e[1]))},hf.prototype.setBoundaryNodes=function(t,e){this._bdyNodes=new Array(2).fill(null),this._bdyNodes[0]=t,this._bdyNodes[1]=e},hf.prototype.addIntersections=function(t,e,n,r){if(t===n&&e===r)return null;this.numTests++;var i=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[r],a=n.getCoordinates()[r+1];this._li.computeIntersection(i,o,s,a),this._li.hasIntersection()&&(this._recordIsolated&&(t.setIsolated(!1),n.setIsolated(!1)),this._numIntersections++,this.isTrivialIntersection(t,e,n,r)||(this._hasIntersection=!0,!this._includeProper&&this._li.isProper()||(t.addIntersections(this._li,e,0),n.addIntersections(this._li,r,1)),this._li.isProper()&&(this._properIntersectionPoint=this._li.getIntersection(0).copy(),this._hasProper=!0,this._isDoneWhenProperInt&&(this._isDone=!0),this.isBoundaryPoint(this._li,this._bdyNodes)||(this._hasProperInterior=!0))))},hf.prototype.interfaces_=function(){return[]},hf.prototype.getClass=function(){return hf},hf.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)};var lf=function(t){function e(){t.call(this),this.events=new bc,this.nOverlaps=null}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.prepareEvents=function(){$h.sort(this.events);for(var t=0;t<this.events.size();t++){var e=this.events.get(t);e.isDelete()&&e.getInsertEvent().setDeleteEventIndex(t)}},e.prototype.computeIntersections=function(){if(1===arguments.length){var t=arguments[0];this.nOverlaps=0,this.prepareEvents();for(var e=0;e<this.events.size();e++){var n=this.events.get(e);if(n.isInsert()&&this.processOverlaps(e,n.getDeleteEventIndex(),n,t),t.isDone())break}}else if(3===arguments.length)if(arguments[2]instanceof hf&&Lu(arguments[0],wc)&&Lu(arguments[1],wc)){var r=arguments[0],i=arguments[1],o=arguments[2];this.addEdges(r,r),this.addEdges(i,i),this.computeIntersections(o)}else if("boolean"==typeof arguments[2]&&Lu(arguments[0],wc)&&arguments[1]instanceof hf){var s=arguments[0],a=arguments[1];arguments[2]?this.addEdges(s,null):this.addEdges(s),this.computeIntersections(a)}},e.prototype.addEdge=function(t,e){for(var n=t.getMonotoneChainEdge(),r=n.getStartIndexes(),i=0;i<r.length-1;i++){var o=new sf(n,i),s=new af(e,n.getMinX(i),o);this.events.add(s),this.events.add(new af(n.getMaxX(i),s))}},e.prototype.processOverlaps=function(t,e,n,r){for(var i=n.getObject(),o=t;o<e;o++){var s=this.events.get(o);if(s.isInsert()){var a=s.getObject();n.isSameLabel(s)||(i.computeIntersections(a,r),this.nOverlaps++)}}},e.prototype.addEdges=function(){if(1===arguments.length)for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.addEdge(e,e)}else if(2===arguments.length)for(var n=arguments[0],r=arguments[1],i=n.iterator();i.hasNext();){var o=i.next();this.addEdge(o,r)}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(cf),pf=function(){this._min=mu.POSITIVE_INFINITY,this._max=mu.NEGATIVE_INFINITY},ff={NodeComparator:{configurable:!0}};pf.prototype.getMin=function(){return this._min},pf.prototype.intersects=function(t,e){return!(this._min>e||this._max<t)},pf.prototype.getMax=function(){return this._max},pf.prototype.toString=function(){return Ku.toLineString(new bu(this._min,0),new bu(this._max,0))},pf.prototype.interfaces_=function(){return[]},pf.prototype.getClass=function(){return pf},ff.NodeComparator.get=function(){return gf},Object.defineProperties(pf,ff);var gf=function(){};gf.prototype.compare=function(t,e){var n=t,r=e,i=(n._min+n._max)/2,o=(r._min+r._max)/2;return i<o?-1:i>o?1:0},gf.prototype.interfaces_=function(){return[wu]},gf.prototype.getClass=function(){return gf};var df=function(t){function e(){t.call(this),this._item=null;var e=arguments[0],n=arguments[1],r=arguments[2];this._min=e,this._max=n,this._item=r}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.query=function(t,e,n){if(!this.intersects(t,e))return null;n.visitItem(this._item)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(pf),yf=function(t){function e(){t.call(this),this._node1=null,this._node2=null;var e=arguments[0],n=arguments[1];this._node1=e,this._node2=n,this.buildExtent(this._node1,this._node2)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.buildExtent=function(t,e){this._min=Math.min(t._min,e._min),this._max=Math.max(t._max,e._max)},e.prototype.query=function(t,e,n){if(!this.intersects(t,e))return null;null!==this._node1&&this._node1.query(t,e,n),null!==this._node2&&this._node2.query(t,e,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(pf),_f=function(){this._leaves=new bc,this._root=null,this._level=0};_f.prototype.buildTree=function(){$h.sort(this._leaves,new pf.NodeComparator);for(var t=this._leaves,e=null,n=new bc;;){if(this.buildLevel(t,n),1===n.size())return n.get(0);e=t,t=n,n=e}},_f.prototype.insert=function(t,e,n){if(null!==this._root)throw new Error("Index cannot be added to once it has been queried");this._leaves.add(new df(t,e,n))},_f.prototype.query=function(t,e,n){this.init(),this._root.query(t,e,n)},_f.prototype.buildRoot=function(){if(null!==this._root)return null;this._root=this.buildTree()},_f.prototype.printNode=function(t){Xu.out.println(Ku.toLineString(new bu(t._min,this._level),new bu(t._max,this._level)))},_f.prototype.init=function(){if(null!==this._root)return null;this.buildRoot()},_f.prototype.buildLevel=function(t,e){this._level++,e.clear();for(var n=0;n<t.size();n+=2){var r=t.get(n);if(null===(n+1<t.size()?t.get(n):null))e.add(r);else{var i=new yf(t.get(n),t.get(n+1));e.add(i)}}},_f.prototype.interfaces_=function(){return[]},_f.prototype.getClass=function(){return _f};var mf=function(){this._items=new bc};mf.prototype.visitItem=function(t){this._items.add(t)},mf.prototype.getItems=function(){return this._items},mf.prototype.interfaces_=function(){return[Jh]},mf.prototype.getClass=function(){return mf};var vf=function(){this._index=null;var t=arguments[0];if(!Lu(t,Qc))throw new _u("Argument must be Polygonal");this._index=new wf(t)},xf={SegmentVisitor:{configurable:!0},IntervalIndexedGeometry:{configurable:!0}};vf.prototype.locate=function(t){var e=new oc(t),n=new Ef(e);return this._index.query(t.y,t.y,n),e.getLocation()},vf.prototype.interfaces_=function(){return[Bl]},vf.prototype.getClass=function(){return vf},xf.SegmentVisitor.get=function(){return Ef},xf.IntervalIndexedGeometry.get=function(){return wf},Object.defineProperties(vf,xf);var Ef=function(){this._counter=null;var t=arguments[0];this._counter=t};Ef.prototype.visitItem=function(t){var e=t;this._counter.countSegment(e.getCoordinate(0),e.getCoordinate(1))},Ef.prototype.interfaces_=function(){return[Jh]},Ef.prototype.getClass=function(){return Ef};var wf=function(){this._index=new _f;var t=arguments[0];this.init(t)};wf.prototype.init=function(t){for(var e=bp.getLines(t).iterator();e.hasNext();){var n=e.next().getCoordinates();this.addLine(n)}},wf.prototype.addLine=function(t){for(var e=1;e<t.length;e++){var n=new gl(t[e-1],t[e]),r=Math.min(n.p0.y,n.p1.y),i=Math.max(n.p0.y,n.p1.y);this._index.insert(r,i,n)}},wf.prototype.query=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new mf;return this._index.query(t,e,n),n.getItems()}if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2];this._index.query(r,i,o)}},wf.prototype.interfaces_=function(){return[]},wf.prototype.getClass=function(){return wf};var bf=function(t){function e(){if(t.call(this),this._parentGeom=null,this._lineEdgeMap=new ph,this._boundaryNodeRule=null,this._useBoundaryDeterminationRule=!0,this._argIndex=null,this._boundaryNodes=null,this._hasTooFewPoints=!1,this._invalidPoint=null,this._areaPtLocator=null,this._ptLocator=new Ip,2===arguments.length){var e=arguments[0],n=arguments[1],r=fc.OGC_SFS_BOUNDARY_RULE;this._argIndex=e,this._parentGeom=n,this._boundaryNodeRule=r,null!==n&&this.add(n)}else if(3===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2];this._argIndex=i,this._parentGeom=o,this._boundaryNodeRule=s,null!==o&&this.add(o)}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.insertBoundaryPoint=function(t,n){var r=this._nodes.addNode(n).getLabel(),i=1;Su.NONE;r.getLocation(t,Nh.ON)===Su.BOUNDARY&&i++;var o=e.determineBoundary(this._boundaryNodeRule,i);r.setLocation(t,o)},e.prototype.computeSelfNodes=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.computeSelfNodes(t,e,!1)}if(3===arguments.length){var n=arguments[0],r=arguments[1],i=arguments[2],o=new hf(n,!0,!1);o.setIsDoneIfProperInt(i);var s=this.createEdgeSetIntersector(),a=this._parentGeom instanceof eh||this._parentGeom instanceof $c||this._parentGeom instanceof nh,u=r||!a;return s.computeIntersections(this._edges,o,u),this.addSelfIntersectionNodes(this._argIndex),o}},e.prototype.computeSplitEdges=function(t){for(var e=this._edges.iterator();e.hasNext();){e.next().eiList.addSplitEdges(t)}},e.prototype.computeEdgeIntersections=function(t,e,n){var r=new hf(e,n,!0);r.setBoundaryNodes(this.getBoundaryNodes(),t.getBoundaryNodes());return this.createEdgeSetIntersector().computeIntersections(this._edges,t._edges,r),r},e.prototype.getGeometry=function(){return this._parentGeom},e.prototype.getBoundaryNodeRule=function(){return this._boundaryNodeRule},e.prototype.hasTooFewPoints=function(){return this._hasTooFewPoints},e.prototype.addPoint=function(){if(arguments[0]instanceof Kc){var t=arguments[0].getCoordinate();this.insertPoint(this._argIndex,t,Su.INTERIOR)}else if(arguments[0]instanceof bu){var e=arguments[0];this.insertPoint(this._argIndex,e,Su.INTERIOR)}},e.prototype.addPolygon=function(t){this.addPolygonRing(t.getExteriorRing(),Su.EXTERIOR,Su.INTERIOR);for(var e=0;e<t.getNumInteriorRing();e++){var n=t.getInteriorRingN(e);this.addPolygonRing(n,Su.INTERIOR,Su.EXTERIOR)}},e.prototype.addEdge=function(t){this.insertEdge(t);var e=t.getCoordinates();this.insertPoint(this._argIndex,e[0],Su.BOUNDARY),this.insertPoint(this._argIndex,e[e.length-1],Su.BOUNDARY)},e.prototype.addLineString=function(t){var e=Cc.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return this._hasTooFewPoints=!0,this._invalidPoint=e[0],null;var n=new ep(e,new Rh(this._argIndex,Su.INTERIOR));this._lineEdgeMap.put(t,n),this.insertEdge(n),tc.isTrue(e.length>=2,"found LineString with single point"),this.insertBoundaryPoint(this._argIndex,e[0]),this.insertBoundaryPoint(this._argIndex,e[e.length-1])},e.prototype.getInvalidPoint=function(){return this._invalidPoint},e.prototype.getBoundaryPoints=function(){for(var t=this.getBoundaryNodes(),e=new Array(t.size()).fill(null),n=0,r=t.iterator();r.hasNext();){var i=r.next();e[n++]=i.getCoordinate().copy()}return e},e.prototype.getBoundaryNodes=function(){return null===this._boundaryNodes&&(this._boundaryNodes=this._nodes.getBoundaryNodes(this._argIndex)),this._boundaryNodes},e.prototype.addSelfIntersectionNode=function(t,e,n){if(this.isBoundaryNode(t,e))return null;n===Su.BOUNDARY&&this._useBoundaryDeterminationRule?this.insertBoundaryPoint(t,e):this.insertPoint(t,e,n)},e.prototype.addPolygonRing=function(t,e,n){if(t.isEmpty())return null;var r=Cc.removeRepeatedPoints(t.getCoordinates());if(r.length<4)return this._hasTooFewPoints=!0,this._invalidPoint=r[0],null;var i=e,o=n;sc.isCCW(r)&&(i=n,o=e);var s=new ep(r,new Rh(this._argIndex,Su.BOUNDARY,i,o));this._lineEdgeMap.put(t,s),this.insertEdge(s),this.insertPoint(this._argIndex,r[0],Su.BOUNDARY)},e.prototype.insertPoint=function(t,e,n){var r=this._nodes.addNode(e),i=r.getLabel();null===i?r._label=new Rh(t,n):i.setLocation(t,n)},e.prototype.createEdgeSetIntersector=function(){return new lf},e.prototype.addSelfIntersectionNodes=function(t){for(var e=this._edges.iterator();e.hasNext();)for(var n=e.next(),r=n.getLabel().getLocation(t),i=n.eiList.iterator();i.hasNext();){var o=i.next();this.addSelfIntersectionNode(t,o.coord,r)}},e.prototype.add=function(){if(1!==arguments.length)return t.prototype.add.apply(this,arguments);var e=arguments[0];if(e.isEmpty())return null;if(e instanceof nh&&(this._useBoundaryDeterminationRule=!1),e instanceof $c)this.addPolygon(e);else if(e instanceof Jc)this.addLineString(e);else if(e instanceof Kc)this.addPoint(e);else if(e instanceof th)this.addCollection(e);else if(e instanceof Xc)this.addCollection(e);else if(e instanceof nh)this.addCollection(e);else{if(!(e instanceof jc))throw new Error(e.getClass().getName());this.addCollection(e)}},e.prototype.addCollection=function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},e.prototype.locate=function(t){return Lu(this._parentGeom,Qc)&&this._parentGeom.getNumGeometries()>50?(null===this._areaPtLocator&&(this._areaPtLocator=new vf(this._parentGeom)),this._areaPtLocator.locate(t)):this._ptLocator.locate(t,this._parentGeom)},e.prototype.findEdge=function(){if(1===arguments.length){var e=arguments[0];return this._lineEdgeMap.get(e)}return t.prototype.findEdge.apply(this,arguments)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.determineBoundary=function(t,e){return t.isInBoundary(e)?Su.BOUNDARY:Su.INTERIOR},e}(Uh),If=function(){if(this._li=new rc,this._resultPrecisionModel=null,this._arg=null,1===arguments.length){var t=arguments[0];this.setComputationPrecision(t.getPrecisionModel()),this._arg=new Array(1).fill(null),this._arg[0]=new bf(0,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],r=fc.OGC_SFS_BOUNDARY_RULE;e.getPrecisionModel().compareTo(n.getPrecisionModel())>=0?this.setComputationPrecision(e.getPrecisionModel()):this.setComputationPrecision(n.getPrecisionModel()),this._arg=new Array(2).fill(null),this._arg[0]=new bf(0,e,r),this._arg[1]=new bf(1,n,r)}else if(3===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2];i.getPrecisionModel().compareTo(o.getPrecisionModel())>=0?this.setComputationPrecision(i.getPrecisionModel()):this.setComputationPrecision(o.getPrecisionModel()),this._arg=new Array(2).fill(null),this._arg[0]=new bf(0,i,s),this._arg[1]=new bf(1,o,s)}};If.prototype.getArgGeometry=function(t){return this._arg[t].getGeometry()},If.prototype.setComputationPrecision=function(t){this._resultPrecisionModel=t,this._li.setPrecisionModel(this._resultPrecisionModel)},If.prototype.interfaces_=function(){return[]},If.prototype.getClass=function(){return If};var Nf=function(){};Nf.prototype.interfaces_=function(){return[]},Nf.prototype.getClass=function(){return Nf},Nf.map=function(){if(arguments[0]instanceof cc&&Lu(arguments[1],Nf.MapOp)){for(var t=arguments[0],e=arguments[1],n=new bc,r=0;r<t.getNumGeometries();r++){var i=e.map(t.getGeometryN(r));null!==i&&n.add(i)}return t.getFactory().buildGeometry(n)}if(Lu(arguments[0],vc)&&Lu(arguments[1],Nf.MapOp)){for(var o=arguments[0],s=arguments[1],a=new bc,u=o.iterator();u.hasNext();){var c=u.next(),h=s.map(c);null!==h&&a.add(h)}return a}},Nf.MapOp=function(){};var Cf=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n),this._ptLocator=new Ip,this._geomFact=null,this._resultGeom=null,this._graph=null,this._edgeList=new Vl,this._resultPolyList=new bc,this._resultLineList=new bc,this._resultPointList=new bc,this._graph=new Uh(new Ul),this._geomFact=e.getFactory()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.insertUniqueEdge=function(t){var e=this._edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),r=t.getLabel();e.isPointwiseEqual(t)||(r=new Rh(t.getLabel())).flip();var i=e.getDepth();i.isNull()&&i.add(n),i.add(r),n.merge(r)}else this._edgeList.add(t)},e.prototype.getGraph=function(){return this._graph},e.prototype.cancelDuplicateResultEdges=function(){for(var t=this._graph.getEdgeEnds().iterator();t.hasNext();){var e=t.next(),n=e.getSym();e.isInResult()&&n.isInResult()&&(e.setInResult(!1),n.setInResult(!1))}},e.prototype.isCoveredByLA=function(t){return!!this.isCovered(t,this._resultLineList)||!!this.isCovered(t,this._resultPolyList)},e.prototype.computeGeometry=function(t,n,r,i){var o=new bc;return o.addAll(t),o.addAll(n),o.addAll(r),o.isEmpty()?e.createEmptyResult(i,this._arg[0].getGeometry(),this._arg[1].getGeometry(),this._geomFact):this._geomFact.buildGeometry(o)},e.prototype.mergeSymLabels=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().mergeSymLabels()}},e.prototype.isCovered=function(t,e){for(var n=e.iterator();n.hasNext();){var r=n.next();if(this._ptLocator.locate(t,r)!==Su.EXTERIOR)return!0}return!1},e.prototype.replaceCollapsedEdges=function(){for(var t=new bc,e=this._edgeList.iterator();e.hasNext();){var n=e.next();n.isCollapsed()&&(e.remove(),t.add(n.getCollapsedEdge()))}this._edgeList.addAll(t)},e.prototype.updateNodeLabelling=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){var e=t.next(),n=e.getEdges().getLabel();e.getLabel().merge(n)}},e.prototype.getResultGeometry=function(t){return this.computeOverlay(t),this._resultGeom},e.prototype.insertUniqueEdges=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.insertUniqueEdge(n)}},e.prototype.computeOverlay=function(t){this.copyPoints(0),this.copyPoints(1),this._arg[0].computeSelfNodes(this._li,!1),this._arg[1].computeSelfNodes(this._li,!1),this._arg[0].computeEdgeIntersections(this._arg[1],this._li,!0);var e=new bc;this._arg[0].computeSplitEdges(e),this._arg[1].computeSplitEdges(e),this.insertUniqueEdges(e),this.computeLabelsFromDepths(),this.replaceCollapsedEdges(),Xp.checkValid(this._edgeList.getEdges()),this._graph.addEdges(this._edgeList.getEdges()),this.computeLabelling(),this.labelIncompleteNodes(),this.findResultAreaEdges(t),this.cancelDuplicateResultEdges();var n=new Yh(this._geomFact);n.add(this._graph),this._resultPolyList=n.getPolygons();var r=new Yp(this,this._geomFact,this._ptLocator);this._resultLineList=r.build(t);var i=new Vp(this,this._geomFact,this._ptLocator);this._resultPointList=i.build(t),this._resultGeom=this.computeGeometry(this._resultPointList,this._resultLineList,this._resultPolyList,t)},e.prototype.labelIncompleteNode=function(t,e){var n=this._ptLocator.locate(t.getCoordinate(),this._arg[e].getGeometry());t.getLabel().setLocation(e,n)},e.prototype.copyPoints=function(t){for(var e=this._arg[t].getNodeIterator();e.hasNext();){var n=e.next();this._graph.addNode(n.getCoordinate()).setLabel(t,n.getLabel().getLocation(t))}},e.prototype.findResultAreaEdges=function(t){for(var n=this._graph.getEdgeEnds().iterator();n.hasNext();){var r=n.next(),i=r.getLabel();i.isArea()&&!r.isInteriorAreaEdge()&&e.isResultOfOp(i.getLocation(0,Nh.RIGHT),i.getLocation(1,Nh.RIGHT),t)&&r.setInResult(!0)}},e.prototype.computeLabelsFromDepths=function(){for(var t=this._edgeList.iterator();t.hasNext();){var e=t.next(),n=e.getLabel(),r=e.getDepth();if(!r.isNull()){r.normalize();for(var i=0;i<2;i++)n.isNull(i)||!n.isArea()||r.isNull(i)||(0===r.getDelta(i)?n.toLine(i):(tc.isTrue(!r.isNull(i,Nh.LEFT),"depth of LEFT side has not been initialized"),n.setLocation(i,Nh.LEFT,r.getLocation(i,Nh.LEFT)),tc.isTrue(!r.isNull(i,Nh.RIGHT),"depth of RIGHT side has not been initialized"),n.setLocation(i,Nh.RIGHT,r.getLocation(i,Nh.RIGHT))))}}},e.prototype.computeLabelling=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().computeLabelling(this._arg)}this.mergeSymLabels(),this.updateNodeLabelling()},e.prototype.labelIncompleteNodes=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){var e=t.next(),n=e.getLabel();e.isIsolated()&&(n.isNull(0)?this.labelIncompleteNode(e,0):this.labelIncompleteNode(e,1)),e.getEdges().updateLabelling(n)}},e.prototype.isCoveredByA=function(t){return!!this.isCovered(t,this._resultPolyList)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(If);Cf.overlayOp=function(t,e,n){return new Cf(t,e).getResultGeometry(n)},Cf.intersection=function(t,e){if(t.isEmpty()||e.isEmpty())return Cf.createEmptyResult(Cf.INTERSECTION,t,e,t.getFactory());if(t.isGeometryCollection()){var n=e;return Up.map(t,{interfaces_:function(){return[Nf.MapOp]},map:function(t){return t.intersection(n)}})}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),of.overlayOp(t,e,Cf.INTERSECTION)},Cf.symDifference=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return Cf.createEmptyResult(Cf.SYMDIFFERENCE,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),of.overlayOp(t,e,Cf.SYMDIFFERENCE)},Cf.resultDimension=function(t,e,n){var r=e.getDimension(),i=n.getDimension(),o=-1;switch(t){case Cf.INTERSECTION:o=Math.min(r,i);break;case Cf.UNION:o=Math.max(r,i);break;case Cf.DIFFERENCE:o=r;break;case Cf.SYMDIFFERENCE:o=Math.max(r,i)}return o},Cf.createEmptyResult=function(t,e,n,r){var i=null;switch(Cf.resultDimension(t,e,n)){case-1:i=r.createGeometryCollection(new Array(0).fill(null));break;case 0:i=r.createPoint();break;case 1:i=r.createLineString();break;case 2:i=r.createPolygon()}return i},Cf.difference=function(t,e){return t.isEmpty()?Cf.createEmptyResult(Cf.DIFFERENCE,t,e,t.getFactory()):e.isEmpty()?t.copy():(t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),of.overlayOp(t,e,Cf.DIFFERENCE))},Cf.isResultOfOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=t.getLocation(0),r=t.getLocation(1);return Cf.isResultOfOp(n,r,e)}if(3===arguments.length){var i=arguments[0],o=arguments[1],s=arguments[2];switch(i===Su.BOUNDARY&&(i=Su.INTERIOR),o===Su.BOUNDARY&&(o=Su.INTERIOR),s){case Cf.INTERSECTION:return i===Su.INTERIOR&&o===Su.INTERIOR;case Cf.UNION:return i===Su.INTERIOR||o===Su.INTERIOR;case Cf.DIFFERENCE:return i===Su.INTERIOR&&o!==Su.INTERIOR;case Cf.SYMDIFFERENCE:return i===Su.INTERIOR&&o!==Su.INTERIOR||i!==Su.INTERIOR&&o===Su.INTERIOR}return!1}},Cf.INTERSECTION=1,Cf.UNION=2,Cf.DIFFERENCE=3,Cf.SYMDIFFERENCE=4;var Sf=function(){this._g=null,this._boundaryDistanceTolerance=null,this._linework=null,this._ptLocator=new Ip,this._seg=new gl;var t=arguments[0],e=arguments[1];this._g=t,this._boundaryDistanceTolerance=e,this._linework=this.extractLinework(t)};Sf.prototype.isWithinToleranceOfBoundary=function(t){for(var e=0;e<this._linework.getNumGeometries();e++)for(var n=this._linework.getGeometryN(e).getCoordinateSequence(),r=0;r<n.size()-1;r++){n.getCoordinate(r,this._seg.p0),n.getCoordinate(r+1,this._seg.p1);if(this._seg.distance(t)<=this._boundaryDistanceTolerance)return!0}return!1},Sf.prototype.getLocation=function(t){return this.isWithinToleranceOfBoundary(t)?Su.BOUNDARY:this._ptLocator.locate(t,this._g)},Sf.prototype.extractLinework=function(t){var e=new Mf;t.apply(e);var n=e.getLinework(),r=_h.toLineStringArray(n);return t.getFactory().createMultiLineString(r)},Sf.prototype.interfaces_=function(){return[]},Sf.prototype.getClass=function(){return Sf};var Mf=function(){this._linework=null,this._linework=new bc};Mf.prototype.getLinework=function(){return this._linework},Mf.prototype.filter=function(t){if(t instanceof $c){var e=t;this._linework.add(e.getExteriorRing());for(var n=0;n<e.getNumInteriorRing();n++)this._linework.add(e.getInteriorRingN(n))}},Mf.prototype.interfaces_=function(){return[kc]},Mf.prototype.getClass=function(){return Mf};var Lf=function(){this._g=null,this._doLeft=!0,this._doRight=!0;var t=arguments[0];this._g=t};Lf.prototype.extractPoints=function(t,e,n){for(var r=t.getCoordinates(),i=0;i<r.length-1;i++)this.computeOffsetPoints(r[i],r[i+1],e,n)},Lf.prototype.setSidesToGenerate=function(t,e){this._doLeft=t,this._doRight=e},Lf.prototype.getPoints=function(t){for(var e=new bc,n=bp.getLines(this._g).iterator();n.hasNext();){var r=n.next();this.extractPoints(r,t,e)}return e},Lf.prototype.computeOffsetPoints=function(t,e,n,r){var i=e.x-t.x,o=e.y-t.y,s=Math.sqrt(i*i+o*o),a=n*i/s,u=n*o/s,c=(e.x+t.x)/2,h=(e.y+t.y)/2;if(this._doLeft){var l=new bu(c-u,h+a);r.add(l)}if(this._doRight){var p=new bu(c+u,h-a);r.add(p)}},Lf.prototype.interfaces_=function(){return[]},Lf.prototype.getClass=function(){return Lf};var Pf=function t(){this._geom=null,this._locFinder=null,this._location=new Array(3).fill(null),this._invalidLocation=null,this._boundaryDistanceTolerance=t.TOLERANCE,this._testCoords=new bc;var e=arguments[0],n=arguments[1],r=arguments[2];this._boundaryDistanceTolerance=t.computeBoundaryDistanceTolerance(e,n),this._geom=[e,n,r],this._locFinder=[new Sf(this._geom[0],this._boundaryDistanceTolerance),new Sf(this._geom[1],this._boundaryDistanceTolerance),new Sf(this._geom[2],this._boundaryDistanceTolerance)]},Of={TOLERANCE:{configurable:!0}};Pf.prototype.reportResult=function(t,e,n){Xu.out.println("Overlay result invalid - A:"+Su.toLocationSymbol(e[0])+" B:"+Su.toLocationSymbol(e[1])+" expected:"+(n?"i":"e")+" actual:"+Su.toLocationSymbol(e[2]))},Pf.prototype.isValid=function(t){this.addTestPts(this._geom[0]),this.addTestPts(this._geom[1]);var e=this.checkValid(t);return e},Pf.prototype.checkValid=function(){if(1===arguments.length){for(var t=arguments[0],e=0;e<this._testCoords.size();e++){var n=this._testCoords.get(e);if(!this.checkValid(t,n))return this._invalidLocation=n,!1}return!0}if(2===arguments.length){var r=arguments[0],i=arguments[1];return this._location[0]=this._locFinder[0].getLocation(i),this._location[1]=this._locFinder[1].getLocation(i),this._location[2]=this._locFinder[2].getLocation(i),!!Pf.hasLocation(this._location,Su.BOUNDARY)||this.isValidResult(r,this._location)}},Pf.prototype.addTestPts=function(t){var e=new Lf(t);this._testCoords.addAll(e.getPoints(5*this._boundaryDistanceTolerance))},Pf.prototype.isValidResult=function(t,e){var n=Cf.isResultOfOp(e[0],e[1],t),r=!(n^e[2]===Su.INTERIOR);return r||this.reportResult(t,e,n),r},Pf.prototype.getInvalidLocation=function(){return this._invalidLocation},Pf.prototype.interfaces_=function(){return[]},Pf.prototype.getClass=function(){return Pf},Pf.hasLocation=function(t,e){for(var n=0;n<3;n++)if(t[n]===e)return!0;return!1},Pf.computeBoundaryDistanceTolerance=function(t,e){return Math.min(Jp.computeSizeBasedSnapTolerance(t),Jp.computeSizeBasedSnapTolerance(e))},Pf.isValid=function(t,e,n,r){return new Pf(t,e,r).isValid(n)},Of.TOLERANCE.get=function(){return 1e-6},Object.defineProperties(Pf,Of);var Rf=function t(e){this._geomFactory=null,this._skipEmpty=!1,this._inputGeoms=null,this._geomFactory=t.extractFactory(e),this._inputGeoms=e};Rf.prototype.extractElements=function(t,e){if(null===t)return null;for(var n=0;n<t.getNumGeometries();n++){var r=t.getGeometryN(n);this._skipEmpty&&r.isEmpty()||e.add(r)}},Rf.prototype.combine=function(){for(var t=new bc,e=this._inputGeoms.iterator();e.hasNext();){var n=e.next();this.extractElements(n,t)}return 0===t.size()?null!==this._geomFactory?this._geomFactory.createGeometryCollection(null):null:this._geomFactory.buildGeometry(t)},Rf.prototype.interfaces_=function(){return[]},Rf.prototype.getClass=function(){return Rf},Rf.combine=function(){if(1===arguments.length){var t=arguments[0];return new Rf(t).combine()}if(2===arguments.length){var e=arguments[0],n=arguments[1];return new Rf(Rf.createList(e,n)).combine()}if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2];return new Rf(Rf.createList(r,i,o)).combine()}},Rf.extractFactory=function(t){return t.isEmpty()?null:t.iterator().next().getFactory()},Rf.createList=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new bc;return n.add(t),n.add(e),n}if(3===arguments.length){var r=arguments[0],i=arguments[1],o=arguments[2],s=new bc;return s.add(r),s.add(i),s.add(o),s}};var Tf=function(){this._inputPolys=null,this._geomFactory=null;var t=arguments[0];this._inputPolys=t,null===this._inputPolys&&(this._inputPolys=new bc)},Af={STRTREE_NODE_CAPACITY:{configurable:!0}};Tf.prototype.reduceToGeometries=function(t){for(var e=new bc,n=t.iterator();n.hasNext();){var r=n.next(),i=null;Lu(r,wc)?i=this.unionTree(r):r instanceof cc&&(i=r),e.add(i)}return e},Tf.prototype.extractByEnvelope=function(t,e,n){for(var r=new bc,i=0;i<e.getNumGeometries();i++){var o=e.getGeometryN(i);o.getEnvelopeInternal().intersects(t)?r.add(o):n.add(o)}return this._geomFactory.buildGeometry(r)},Tf.prototype.unionOptimized=function(t,e){var n=t.getEnvelopeInternal(),r=e.getEnvelopeInternal();if(!n.intersects(r)){return Rf.combine(t,e)}if(t.getNumGeometries()<=1&&e.getNumGeometries()<=1)return this.unionActual(t,e);var i=n.intersection(r);return this.unionUsingEnvelopeIntersection(t,e,i)},Tf.prototype.union=function(){if(null===this._inputPolys)throw new Error("union() method cannot be called twice");if(this._inputPolys.isEmpty())return null;this._geomFactory=this._inputPolys.iterator().next().getFactory();for(var t=new ol(Tf.STRTREE_NODE_CAPACITY),e=this._inputPolys.iterator();e.hasNext();){var n=e.next();t.insert(n.getEnvelopeInternal(),n)}this._inputPolys=null;var r=t.itemsTree();return this.unionTree(r)},Tf.prototype.binaryUnion=function(){if(1===arguments.length){var t=arguments[0];return this.binaryUnion(t,0,t.size())}if(3===arguments.length){var e=arguments[0],n=arguments[1],r=arguments[2];if(r-n<=1){var i=Tf.getGeometry(e,n);return this.unionSafe(i,null)}if(r-n==2)return this.unionSafe(Tf.getGeometry(e,n),Tf.getGeometry(e,n+1));var o=Math.trunc((r+n)/2),s=this.binaryUnion(e,n,o),a=this.binaryUnion(e,o,r);return this.unionSafe(s,a)}},Tf.prototype.repeatedUnion=function(t){for(var e=null,n=t.iterator();n.hasNext();){var r=n.next();e=null===e?r.copy():e.union(r)}return e},Tf.prototype.unionSafe=function(t,e){return null===t&&null===e?null:null===t?e.copy():null===e?t.copy():this.unionOptimized(t,e)},Tf.prototype.unionActual=function(t,e){return Tf.restrictToPolygons(t.union(e))},Tf.prototype.unionTree=function(t){var e=this.reduceToGeometries(t);return this.binaryUnion(e)},Tf.prototype.unionUsingEnvelopeIntersection=function(t,e,n){var r=new bc,i=this.extractByEnvelope(n,t,r),o=this.extractByEnvelope(n,e,r),s=this.unionActual(i,o);r.add(s);return Rf.combine(r)},Tf.prototype.bufferUnion=function(){if(1===arguments.length){var t=arguments[0];return t.get(0).getFactory().buildGeometry(t).buffer(0)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e.getFactory().createGeometryCollection([e,n]).buffer(0)}},Tf.prototype.interfaces_=function(){return[]},Tf.prototype.getClass=function(){return Tf},Tf.restrictToPolygons=function(t){if(Lu(t,Qc))return t;var e=wp.getPolygons(t);return 1===e.size()?e.get(0):t.getFactory().createMultiPolygon(_h.toPolygonArray(e))},Tf.getGeometry=function(t,e){return e>=t.size()?null:t.get(e)},Tf.union=function(t){return new Tf(t).union()},Af.STRTREE_NODE_CAPACITY.get=function(){return 4},Object.defineProperties(Tf,Af);var Df=function(){};Df.prototype.interfaces_=function(){return[]},Df.prototype.getClass=function(){return Df},Df.union=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return Cf.createEmptyResult(Cf.UNION,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),of.overlayOp(t,e,Cf.UNION)};var Ff=function(){return new Yi};Yi.prototype={constructor:Yi,reset:function(){this.s=this.t=0},add:function(t){Vi(qf,t,this.t),Vi(this,qf.s,this.s),this.s?this.t+=qf.t:this.s=qf.t},valueOf:function(){return this.s}};var qf=new Yi,Gf=1e-6,Bf=Math.PI,kf=Bf/2,zf=Bf/4,jf=2*Bf,Xf=180/Bf,Uf=Bf/180,Yf=Math.abs,Vf=Math.atan,Hf=Math.atan2,Wf=Math.cos,Jf=Math.exp,Zf=Math.log,Kf=Math.sin,Qf=Math.sqrt,$f=Math.tan,tg={Feature:function(t,e){Ji(t.geometry,e)},FeatureCollection:function(t,e){for(var n=t.features,r=-1,i=n.length;++r<i;)Ji(n[r].geometry,e)}},eg={Sphere:function(t,e){e.sphere()},Point:function(t,e){t=t.coordinates,e.point(t[0],t[1],t[2])},MultiPoint:function(t,e){for(var n=t.coordinates,r=-1,i=n.length;++r<i;)t=n[r],e.point(t[0],t[1],t[2])},LineString:function(t,e){Zi(t.coordinates,e,0)},MultiLineString:function(t,e){for(var n=t.coordinates,r=-1,i=n.length;++r<i;)Zi(n[r],e,0)},Polygon:function(t,e){Ki(t.coordinates,e)},MultiPolygon:function(t,e){for(var n=t.coordinates,r=-1,i=n.length;++r<i;)Ki(n[r],e)},GeometryCollection:function(t,e){for(var n=t.geometries,r=-1,i=n.length;++r<i;)Ji(n[r],e)}},ng=function(t,e){t&&tg.hasOwnProperty(t.type)?tg[t.type](t,e):Ji(t,e)},rg=(Ff(),Ff(),Ff(),function(t,e){function n(n,r){return n=t(n,r),e(n[0],n[1])}return t.invert&&e.invert&&(n.invert=function(n,r){return(n=e.invert(n,r))&&t.invert(n[0],n[1])}),n});oo.invert=oo;var ig=function(t){function e(e){return e=t(e[0]*Uf,e[1]*Uf),e[0]*=Xf,e[1]*=Xf,e}return t=so(t[0]*Uf,t[1]*Uf,t.length>2?t[2]*Uf:0),e.invert=function(e){return e=t.invert(e[0]*Uf,e[1]*Uf),e[0]*=Xf,e[1]*=Xf,e},e},og=function(){var t,e=[];return{point:function(e,n){t.push([e,n])},lineStart:function(){e.push(t=[])},lineEnd:Wi,rejoin:function(){e.length>1&&e.push(e.pop().concat(e.shift()))},result:function(){var n=e;return e=[],t=null,n}}},sg=function(t,e,n,r,i,o){var s,a=t[0],u=t[1],c=0,h=1,l=e[0]-a,p=e[1]-u;if(s=n-a,l||!(s>0)){if(s/=l,l<0){if(s<c)return;s<h&&(h=s)}else if(l>0){if(s>h)return;s>c&&(c=s)}if(s=i-a,l||!(s<0)){if(s/=l,l<0){if(s>h)return;s>c&&(c=s)}else if(l>0){if(s<c)return;s<h&&(h=s)}if(s=r-u,p||!(s>0)){if(s/=p,p<0){if(s<c)return;s<h&&(h=s)}else if(p>0){if(s>h)return;s>c&&(c=s)}if(s=o-u,p||!(s<0)){if(s/=p,p<0){if(s>h)return;s>c&&(c=s)}else if(p>0){if(s<c)return;s<h&&(h=s)}return c>0&&(t[0]=a+c*l,t[1]=u+c*p),h<1&&(e[0]=a+h*l,e[1]=u+h*p),!0}}}}},ag=function(t,e){return Yf(t[0]-e[0])<Gf&&Yf(t[1]-e[1])<Gf},ug=function(t,e,n,r,i){var o,s,a=[],u=[];if(t.forEach(function(t){if(!((e=t.length-1)<=0)){var e,n,r=t[0],s=t[e];if(ag(r,s)){for(i.lineStart(),o=0;o<e;++o)i.point((r=t[o])[0],r[1]);i.lineEnd()}else a.push(n=new lo(r,t,null,!0)),u.push(n.o=new lo(r,null,n,!1)),a.push(n=new lo(s,t,null,!1)),u.push(n.o=new lo(s,null,n,!0))}}),a.length){for(u.sort(e),po(a),po(u),o=0,s=u.length;o<s;++o)u[o].e=n=!n;for(var c,h,l=a[0];;){for(var p=l,f=!0;p.v;)if((p=p.n)===l)return;c=p.z,i.lineStart();do{if(p.v=p.o.v=!0,p.e){if(f)for(o=0,s=c.length;o<s;++o)i.point((h=c[o])[0],h[1]);else r(p.x,p.n.x,1,i);p=p.n}else{if(f)for(c=p.p.z,o=c.length-1;o>=0;--o)i.point((h=c[o])[0],h[1]);else r(p.x,p.p.x,-1,i);p=p.p}c=(p=p.o).z,f=!f}while(!p.v);i.lineEnd()}}},cg=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN},hg=(function(t){1===t.length&&(t=function(t){return function(e,n){return cg(t(e),n)}}(t))}(cg),function(t){for(var e,n,r,i=t.length,o=-1,s=0;++o<i;)s+=t[o].length;for(n=new Array(s);--i>=0;)for(e=(r=t[i]).length;--e>=0;)n[--s]=r[e];return n}),lg=1e9,pg=-lg,fg=Ff(),gg=(Ff(),function(t){return t}),dg=(Ff(),Ff(),1/0),yg=dg,_g=-dg,mg=_g,vg={point:function(t,e){t<dg&&(dg=t),t>_g&&(_g=t),e<yg&&(yg=e),e>mg&&(mg=e)},lineStart:Wi,lineEnd:Wi,polygonStart:Wi,polygonEnd:Wi,result:function(){var t=[[dg,yg],[_g,mg]];return _g=mg=-(yg=dg=1/0),t}},xg=(Ff(),function(t,e,n,r){return function(i,o){function s(e,n){var r=i(e,n);t(e=r[0],n=r[1])&&o.point(e,n)}function a(t,e){var n=i(t,e);y.point(n[0],n[1])}function u(){E.point=a,y.lineStart()}function c(){E.point=s,y.lineEnd()}function h(t,e){d.push([t,e]);var n=i(t,e);v.point(n[0],n[1])}function l(){v.lineStart(),d=[]}function p(){h(d[0][0],d[0][1]),v.lineEnd();var t,e,n,r,i=v.clean(),s=m.result(),a=s.length;if(d.pop(),f.push(d),d=null,a)if(1&i){if(n=s[0],(e=n.length-1)>0){for(x||(o.polygonStart(),x=!0),o.lineStart(),t=0;t<e;++t)o.point((r=n[t])[0],r[1]);o.lineEnd()}}else a>1&&2&i&&s.push(s.pop().concat(s.shift())),g.push(s.filter(go))}var f,g,d,y=e(o),_=i.invert(r[0],r[1]),m=og(),v=e(m),x=!1,E={point:s,lineStart:u,lineEnd:c,polygonStart:function(){E.point=h,E.lineStart=l,E.lineEnd=p,g=[],f=[]},polygonEnd:function(){E.point=s,E.lineStart=u,E.lineEnd=c,g=hg(g);var t=function(t,e){var n=e[0],r=e[1],i=[Kf(n),-Wf(n),0],o=0,s=0;fg.reset();for(var a=0,u=t.length;a<u;++a)if(h=(c=t[a]).length)for(var c,h,l=c[h-1],p=l[0],f=l[1]/2+zf,g=Kf(f),d=Wf(f),y=0;y<h;++y,p=m,g=x,d=E,l=_){var _=c[y],m=_[0],v=_[1]/2+zf,x=Kf(v),E=Wf(v),w=m-p,b=w>=0?1:-1,I=b*w,N=I>Bf,C=g*x;if(fg.add(Hf(C*b*Kf(I),d*E+C*Wf(I))),o+=N?w+b*jf:w,N^p>=n^m>=n){var S=eo($i(l),$i(_));io(S);var M=eo(i,S);io(M);var L=(N^w>=0?-1:1)*Hi(M[2]);(r>L||r===L&&(S[0]||S[1]))&&(s+=N^w>=0?1:-1)}}return(o<-Gf||o<Gf&&fg<-Gf)^1&s}(f,_);g.length?(x||(o.polygonStart(),x=!0),ug(g,yo,t,n,o)):t&&(x||(o.polygonStart(),x=!0),o.lineStart(),n(null,null,1,o),o.lineEnd()),x&&(o.polygonEnd(),x=!1),g=f=null},sphere:function(){o.polygonStart(),o.lineStart(),n(null,null,1,o),o.lineEnd(),o.polygonEnd()}};return E}}),Eg=xg(function(){return!0},function(t){var e,n=NaN,r=NaN,i=NaN;return{lineStart:function(){t.lineStart(),e=1},point:function(o,s){var a=o>0?Bf:-Bf,u=Yf(o-n);Yf(u-Bf)<Gf?(t.point(n,r=(r+s)/2>0?kf:-kf),t.point(i,r),t.lineEnd(),t.lineStart(),t.point(a,r),t.point(o,r),e=0):i!==a&&u>=Bf&&(Yf(n-i)<Gf&&(n-=i*Gf),Yf(o-a)<Gf&&(o-=a*Gf),r=function(t,e,n,r){var i,o,s=Kf(t-n);return Yf(s)>Gf?Vf((Kf(e)*(o=Wf(r))*Kf(n)-Kf(r)*(i=Wf(e))*Kf(t))/(i*o*s)):(e+r)/2}(n,r,o,s),t.point(i,r),t.lineEnd(),t.lineStart(),t.point(a,r),e=0),t.point(n=o,r=s),i=a},lineEnd:function(){t.lineEnd(),n=r=NaN},clean:function(){return 2-e}}},function(t,e,n,r){var i;if(null==t)i=n*kf,r.point(-Bf,i),r.point(0,i),r.point(Bf,i),r.point(Bf,0),r.point(Bf,-i),r.point(0,-i),r.point(-Bf,-i),r.point(-Bf,0),r.point(-Bf,i);else if(Yf(t[0]-e[0])>Gf){var o=t[0]<e[0]?Bf:-Bf;i=n*o/2,r.point(-o,i),r.point(0,i),r.point(o,i)}else r.point(e[0],e[1])},[-Bf,-kf]),wg=function(t,e){function n(t,e){return Wf(t)*Wf(e)>o}function r(t,e,n){var r=[1,0,0],i=eo($i(t),$i(e)),s=to(i,i),a=i[0],u=s-a*a;if(!u)return!n&&t;var c=o*s/u,h=-o*a/u,l=eo(r,i),p=ro(r,c);no(p,ro(i,h));var f=l,g=to(p,f),d=to(f,f),y=g*g-d*(to(p,p)-1);if(!(y<0)){var _=Qf(y),m=ro(f,(-g-_)/d);if(no(m,p),m=Qi(m),!n)return m;var v,x=t[0],E=e[0],w=t[1],b=e[1];E<x&&(v=x,x=E,E=v);var I=E-x,N=Yf(I-Bf)<Gf;if(!N&&b<w&&(v=w,w=b,b=v),N||I<Gf?N?w+b>0^m[1]<(Yf(m[0]-x)<Gf?w:b):w<=m[1]&&m[1]<=b:I>Bf^(x<=m[0]&&m[0]<=E)){var C=ro(f,(-g+_)/d);return no(C,p),[m,Qi(C)]}}}function i(e,n){var r=s?t:Bf-t,i=0;return e<-r?i|=1:e>r&&(i|=2),n<-r?i|=4:n>r&&(i|=8),i}var o=Wf(t),s=o>0,a=Yf(o)>Gf;return xg(n,function(t){var e,o,u,c,h;return{lineStart:function(){c=u=!1,h=1},point:function(l,p){var f,g=[l,p],d=n(l,p),y=s?d?0:i(l,p):d?i(l+(l<0?Bf:-Bf),p):0;if(!e&&(c=u=d)&&t.lineStart(),d!==u&&(!(f=r(e,g))||ag(e,f)||ag(g,f))&&(g[0]+=Gf,g[1]+=Gf,d=n(g[0],g[1])),d!==u)h=0,d?(t.lineStart(),f=r(g,e),t.point(f[0],f[1])):(f=r(e,g),t.point(f[0],f[1]),t.lineEnd()),e=f;else if(a&&e&&s^d){var _;y&o||!(_=r(g,e,!0))||(h=0,s?(t.lineStart(),t.point(_[0][0],_[0][1]),t.point(_[1][0],_[1][1]),t.lineEnd()):(t.point(_[1][0],_[1][1]),t.lineEnd(),t.lineStart(),t.point(_[0][0],_[0][1])))}!d||e&&ag(e,g)||t.point(g[0],g[1]),e=g,u=d,o=y},lineEnd:function(){u&&t.lineEnd(),e=null},clean:function(){return h|(c&&u)<<1}}},function(n,r,i,o){!function(t,e,n,r,i,o){if(n){var s=Wf(e),a=Kf(e),u=r*n;null==i?(i=e+r*jf,o=e-u/2):(i=ho(s,i),o=ho(s,o),(r>0?i<o:i>o)&&(i+=r*jf));for(var c,h=i;r>0?h>o:h<o;h-=u)c=Qi([s,-a*Wf(h),-a*Kf(h)]),t.point(c[0],c[1])}}(o,t,e,i,n,r)},s?[0,-t]:[-Bf,t-Bf])};mo.prototype={constructor:mo,point:function(t,e){this.stream.point(t,e)},sphere:function(){this.stream.sphere()},lineStart:function(){this.stream.lineStart()},lineEnd:function(){this.stream.lineEnd()},polygonStart:function(){this.stream.polygonStart()},polygonEnd:function(){this.stream.polygonEnd()}};var bg=16,Ig=Wf(30*Uf),Ng=function(t,e){return+e?function(t,e){function n(r,i,o,s,a,u,c,h,l,p,f,g,d,y){var _=c-r,m=h-i,v=_*_+m*m;if(v>4*e&&d--){var x=s+p,E=a+f,w=u+g,b=Qf(x*x+E*E+w*w),I=Hi(w/=b),N=Yf(Yf(w)-1)<Gf||Yf(o-l)<Gf?(o+l)/2:Hf(E,x),C=t(N,I),S=C[0],M=C[1],L=S-r,P=M-i,O=m*L-_*P;(O*O/v>e||Yf((_*L+m*P)/v-.5)>.3||s*p+a*f+u*g<Ig)&&(n(r,i,o,s,a,u,S,M,N,x/=b,E/=b,w,d,y),y.point(S,M),n(S,M,N,x,E,w,c,h,l,p,f,g,d,y))}}return function(e){function r(n,r){n=t(n,r),e.point(n[0],n[1])}function i(){_=NaN,w.point=o,e.lineStart()}function o(r,i){var o=$i([r,i]),s=t(r,i);n(_,m,y,v,x,E,_=s[0],m=s[1],y=r,v=o[0],x=o[1],E=o[2],bg,e),e.point(_,m)}function s(){w.point=r,e.lineEnd()}function a(){i(),w.point=u,w.lineEnd=c}function u(t,e){o(h=t,e),l=_,p=m,f=v,g=x,d=E,w.point=o}function c(){n(_,m,y,v,x,E,l,p,h,f,g,d,bg,e),w.lineEnd=s,s()}var h,l,p,f,g,d,y,_,m,v,x,E,w={point:r,lineStart:i,lineEnd:s,polygonStart:function(){e.polygonStart(),w.lineStart=a},polygonEnd:function(){e.polygonEnd(),w.lineStart=i}};return w}}(t,e):function(t){return _o({point:function(e,n){e=t(e,n),this.stream.point(e[0],e[1])}})}(t)},Cg=_o({point:function(t,e){this.stream.point(t*Uf,e*Uf)}});Eo.invert=function(t,e){return[t,2*Vf(Jf(e))-kf]},wo.invert=function(t,e){return[-e,2*Vf(Jf(t))-kf]};var Sg=function(){var t=function(t){function e(){var e=Bf*a(),s=o(ig(o.rotate()).invert([0,0]));return c(null==h?[[s[0]-e,s[1]-e],[s[0]+e,s[1]+e]]:t===Eo?[[Math.max(s[0]-e,h),n],[Math.min(s[0]+e,r),i]]:[[h,Math.max(s[1]-e,n)],[r,Math.min(s[1]+e,i)]])}var n,r,i,o=xo(t),s=o.center,a=o.scale,u=o.translate,c=o.clipExtent,h=null;return o.scale=function(t){return arguments.length?(a(t),e()):a()},o.translate=function(t){return arguments.length?(u(t),e()):u()},o.center=function(t){return arguments.length?(s(t),e()):s()},o.clipExtent=function(t){return arguments.length?(null==t?h=n=r=i=null:(h=+t[0][0],n=+t[0][1],r=+t[1][0],i=+t[1][1]),e()):null==h?null:[[h,n],[r,i]]},e()}(wo),e=t.center,n=t.rotate;return t.center=function(t){return arguments.length?e([-t[1],t[0]]):(t=e(),[t[1],-t[0]])},t.rotate=function(t){return arguments.length?n([t[0],t[1],t.length>2?t[2]+90:90]):(t=n(),[t[0],t[1],t[2]-90])},n([0,0,90]).scale(159.155)};t.projection=Cs,t.random=gu,t.clusters=du,t.helpers=ko,t.invariant=jo,t.meta=zo,t.isolines=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.zProperty||"elevation",i=n.commonProperties||{},o=n.breaksProperties||[];if(W(t,"Point","Input must contain Points"),!e)throw new Error("breaks is required");if(!Array.isArray(e))throw new Error("breaks must be an Array");if(!I(i))throw new Error("commonProperties must be an Object");if(!Array.isArray(o))throw new Error("breaksProperties must be an Array");var s=rt(t,{zProperty:r,flip:!0});return c(function(t,e,n){var r=j(n),i=r[2]-r[0],o=r[3]-r[1],s=r[0],a=r[1],u=e[0].length-1,c=e.length-1,h=i/u,l=o/c,p=function(t){t[0]=t[0]*h+s,t[1]=t[1]*l+a};return t.forEach(function(t){S(t,p)}),t}(function(t,e,n,r,i){for(var o=[],s=1;s<e.length;s++){var a=+e[s],u=Object.assign({},r,i[s]);u[n]=a;var c=h(Q(t,a),u);o.push(c)}return o}(s,e,r,i,o),s,t))},t.convex=Lt,t.pointsWithinPolygon=Rt,t.concave=function(t,n){if(n=n||{},!I(n))throw new Error("options is invalid");if(!t)throw new Error("points is required");var r=n.maxEdge||1/0;if(!b(r))throw new Error("maxEdge is invalid");var i=Tt(function(t){var e=[],n={};return O(t,function(t){if(t.geometry){var r=t.geometry.coordinates.join("-");n.hasOwnProperty(r)||(e.push(t),n[r]=!0)}}),c(e)}(t));if(i.features=i.features.filter(function(t){var e=t.geometry.coordinates[0][0],i=t.geometry.coordinates[0][1],o=t.geometry.coordinates[0][2],s=qt(e,i,n),a=qt(i,o,n),u=qt(e,o,n);return s<=r&&a<=r&&u<=r}),i.features.length<1)return null;var o=$t(i,n);return 1===o.coordinates.length&&(o.coordinates=o.coordinates[0],o.type="Polygon"),e(o)},t.collect=function(t,e,n,r){var i=Vo(6),o=e.features.map(function(t){return{minX:t.geometry.coordinates[0],minY:t.geometry.coordinates[1],maxX:t.geometry.coordinates[0],maxY:t.geometry.coordinates[1],property:t.properties[n]}});return i.load(o),t.features.forEach(function(t){t.properties||(t.properties={});var e=j(t),n=[];i.search({minX:e[0],minY:e[1],maxX:e[2],maxY:e[3]}).forEach(function(e){Pt([e.minX,e.minY],t)&&n.push(e.property)}),t.properties[r]=n}),t},t.flip=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.mutate;if(!t)throw new Error("geojson is required");return!1!==n&&void 0!==n||(t=Gt(t)),S(t,function(t){var e=t[0],n=t[1];t[0]=n,t[1]=e}),t},t.simplify=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=void 0!==e.tolerance?e.tolerance:1,r=e.highQuality||!1,i=e.mutate||!1;if(!t)throw new Error("geojson is required");if(n&&n<0)throw new Error("invalid tolerance");return!0!==i&&(t=Gt(t)),A(t,function(t){!function(t,e,n){var r=t.type;if("Point"===r||"MultiPoint"===r)return t;te(t,!0);var i=t.coordinates;switch(r){case"LineString":t.coordinates=se(i,e,n);break;case"MultiLineString":t.coordinates=i.map(function(t){return se(t,e,n)});break;case"Polygon":t.coordinates=ae(i,e,n);break;case"MultiPolygon":t.coordinates=i.map(function(t){return ae(t,e,n)})}}(t,n,r)}),t},t.bezierSpline=ue,t.tag=function(t,e,n,r){return t=Gt(t),e=Gt(e),O(t,function(t){t.properties||(t.properties={}),O(e,function(e){void 0===t.properties[r]&&Pt(t,e)&&(t.properties[r]=e.properties[n])})}),t},t.sample=function(t,e){if(!t)throw new Error("featurecollection is required");if(null===e||void 0===e)throw new Error("num is required");if("number"!=typeof e)throw new Error("num must be a number");return c(function(t,e){for(var n,r,i=t.slice(0),o=t.length,s=o-e;o-- >s;)r=Math.floor((o+1)*Math.random()),n=i[r],i[r]=i[o],i[o]=n;return i.slice(s)}(t.features,e))},t.envelope=he,t.square=le,t.circle=fe,t.midpoint=function(t,e){return pe(t,qt(t,e)/2,ge(t,e))},t.center=de,t.centerOfMass=_e,t.centroid=ye,t.combine=function(t){function n(t,e,n){n?r[e].coordinates=r[e].coordinates.concat(t.geometry.coordinates):r[e].coordinates.push(t.geometry.coordinates),r[e].properties.push(t.properties)}var r={MultiPoint:{coordinates:[],properties:[]},MultiLineString:{coordinates:[],properties:[]},MultiPolygon:{coordinates:[],properties:[]}},i=Object.keys(r).reduce(function(t,e){return t[e.replace("Multi","")]=e,t},{});return O(t,function(t){t.geometry&&(r[t.geometry.type]?n(t,t.geometry.type,!0):i[t.geometry.type]&&n(t,i[t.geometry.type],!1))}),c(Object.keys(r).filter(function(t){return r[t].coordinates.length}).sort().map(function(t){return e({type:t,coordinates:r[t].coordinates},{collectedProperties:r[t].properties})}))},t.distance=qt,t.explode=me,t.bbox=j,t.tesselate=function(t){if(!t.geometry||"Polygon"!==t.geometry.type&&"MultiPolygon"!==t.geometry.type)throw new Error("input must be a Polygon or MultiPolygon");var e={type:"FeatureCollection",features:[]};return"Polygon"===t.geometry.type?e.features=De(t.geometry.coordinates):t.geometry.coordinates.forEach(function(t){e.features=e.features.concat(De(t))}),e},t.bboxPolygon=ce,t.booleanPointInPolygon=Pt,t.nearestPoint=Fe,t.nearestPointOnLine=on,t.nearestPointToLine=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.units,i=n.properties||{};if(!t)throw new Error("points is required");if(!(t=function(t){var e=[];switch(t.geometry?t.geometry.type:t.type){case"GeometryCollection":return A(t,function(t){"Point"===t.type&&e.push({type:"Feature",properties:{},geometry:t})}),{type:"FeatureCollection",features:e};case"FeatureCollection":return t.features=t.features.filter(function(t){return"Point"===t.geometry.type}),t;default:throw new Error("points must be a Point Collection")}}(t)).features.length)throw new Error("points must contain features");if(!e)throw new Error("line is required");if("LineString"!==K(e))throw new Error("line must be a LineString");var o=1/0,s=null;return O(t,function(t){var n=gn(t,e,{units:r});n<o&&(o=n,s=t)}),s&&(s.properties=Object.assign({dist:o},s.properties,i)),s},t.planepoint=function(t,e){var n=X(t),r=J(e).coordinates[0];if(r.length<4)throw new Error("OuterRing of a Polygon must have 4 or more Positions.");var i=e.properties||{},o=i.a,s=i.b,a=i.c,u=n[0],c=n[1],h=r[0][0],l=r[0][1],p=void 0!==o?o:r[0][2],f=r[1][0],g=r[1][1],d=void 0!==s?s:r[1][2],y=r[2][0],_=r[2][1],m=void 0!==a?a:r[2][2];return(m*(u-h)*(c-g)+p*(u-f)*(c-_)+d*(u-y)*(c-l)-d*(u-h)*(c-_)-m*(u-f)*(c-l)-p*(u-y)*(c-g))/((u-h)*(c-g)+(u-f)*(c-_)+(u-y)*(c-l)-(u-h)*(c-_)-(u-f)*(c-l)-(u-y)*(c-g))},t.tin=Tt,t.bearing=ge,t.destination=pe,t.kinks=function(t){var e,n,i={type:"FeatureCollection",features:[]};if("LineString"===(n="Feature"===t.type?t.geometry:t).type)e=[n.coordinates];else if("MultiLineString"===n.type)e=n.coordinates;else if("MultiPolygon"===n.type)e=[].concat.apply([],n.coordinates);else{if("Polygon"!==n.type)throw new Error("Input must be a LineString, MultiLineString, Polygon, or MultiPolygon Feature or Geometry");e=n.coordinates}return e.forEach(function(t){e.forEach(function(e){for(var n=0;n<t.length-1;n++)for(var o=n;o<e.length-1;o++){if(t===e){if(1===Math.abs(n-o))continue;if(0===n&&o===t.length-2&&t[n][0]===t[t.length-1][0]&&t[n][1]===t[t.length-1][1])continue}var s=function(t,e,n,r,i,o,s,a){var u,c,h,l,p,f={x:null,y:null,onLine1:!1,onLine2:!1};return 0==(u=(a-o)*(n-t)-(s-i)*(r-e))?null!==f.x&&null!==f.y&&f:(c=e-o,h=t-i,l=(s-i)*c-(a-o)*h,p=(n-t)*c-(r-e)*h,c=l/u,h=p/u,f.x=t+c*(n-t),f.y=e+c*(r-e),c>=0&&c<=1&&(f.onLine1=!0),h>=0&&h<=1&&(f.onLine2=!0),!(!f.onLine1||!f.onLine2)&&[f.x,f.y])}(t[n][0],t[n][1],t[n+1][0],t[n+1][1],e[o][0],e[o][1],e[o+1][0],e[o+1][1]);s&&i.features.push(r([s[0],s[1]]))}})}),i},t.pointOnFeature=yn,t.area=mn,t.along=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var i;if("Feature"===t.type)i=t.geometry.coordinates;else{if("LineString"!==t.type)throw new Error("input must be a LineString Feature or Geometry");i=t.coordinates}if(!b(e))throw new Error("distance must be a number");for(var o=0,s=0;s<i.length&&!(e>=o&&s===i.length-1);s++){if(o>=e){var a=e-o;if(a){var u=ge(i[s],i[s-1])-180;return pe(i[s],a,u,n)}return r(i[s])}o+=qt(i[s],i[s+1],n)}return r(i[i.length-1])},t.length=bn,t.lineSlice=function(t,e,n){var r=U(n);if("LineString"!==K(n))throw new Error("line must be a LineString");for(var i,o=on(n,t),s=on(n,e),u=[(i=o.properties.index<=s.properties.index?[o,s]:[s,o])[0].geometry.coordinates],c=i[0].properties.index+1;c<i[1].properties.index+1;c++)u.push(r[c]);return u.push(i[1].geometry.coordinates),a(u,n.properties)},t.lineSliceAlong=In,t.pointGrid=Ln,t.truncate=Pn,t.flatten=function(t){if(!t)throw new Error("geojson is required");var e=[];return F(t,function(t){e.push(t)}),c(e)},t.lineIntersect=nn,t.lineChunk=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.units,i=n.reverse;if(!t)throw new Error("geojson is required");if(e<=0)throw new Error("segmentLength must be greater than 0");var o=[];return F(t,function(t){i&&(t.geometry.coordinates=t.geometry.coordinates.reverse()),function(t,e,n,r){var i=bn(t,{units:n});if(i<=e)return r(t);var o=i/e;Number.isInteger(o)||(o=Math.floor(o)+1);for(var s=0;s<o;s++){var a=In(t,e*s,e*(s+1),{units:n});r(a,s)}}(t,e,r,function(t){o.push(t)})}),c(o)},t.unkinkPolygon=function(t){var e=[];return F(t,function(t){"Polygon"===t.geometry.type&&O(Ls(t),function(n){e.push(o(n.geometry.coordinates,t.properties))})}),c(e)},t.greatCircle=function(t,e,n){if("object"!=typeof(n=n||{}))throw new Error("options is invalid");var r=n.properties,i=n.npoints,o=n.offset;return t=X(t),e=X(e),r=r||{},i=i||100,o=o||10,new qs({x:t[0],y:t[1]},{x:e[0],y:e[1]},r).Arc(i,{offset:o}).json()},t.lineSegment=en,t.lineSplit=function(t,e){if(!t)throw new Error("line is required");if(!e)throw new Error("splitter is required");var n=K(t),r=K(e);if("LineString"!==n)throw new Error("line must be LineString");if("FeatureCollection"===r)throw new Error("splitter cannot be a FeatureCollection");if("GeometryCollection"===r)throw new Error("splitter cannot be a GeometryCollection");var i=Pn(e,{precision:7});switch(r){case"Point":return Dn(t,i);case"MultiPoint":return An(t,i);case"LineString":case"MultiLineString":case"Polygon":case"MultiPolygon":return An(t,nn(t,i))}},t.lineArc=Gn,t.polygonToLine=kn,t.lineToPolygon=jn,t.bboxClip=function(t,e){var n=function(t){return t.geometry?t.geometry.type:t.type}(t),r=U(t),i=t.properties;switch(n){case"LineString":case"MultiLineString":var s=[];return"LineString"===n&&(r=[r]),r.forEach(function(t){Gs(t,e,s)}),1===s.length?a(s[0],i):h(s,i);case"Polygon":return o(Wn(r,e),i);case"MultiPolygon":return p(r.map(function(t){return Wn(t,e)}),i);default:throw new Error("geometry "+n+" not supported")}},t.lineOverlap=$n,t.sector=function(t,e,n,r,i){if(i=i||{},!I(i))throw new Error("options is invalid");if(!t)throw new Error("center is required");if(void 0===n||null===n)throw new Error("bearing1 is required");if(void 0===r||null===r)throw new Error("bearing2 is required");if(!e)throw new Error("radius is required");if("object"!=typeof i)throw new Error("options must be an object");if(er(n)===er(r))return fe(t,e,i);var s=U(t),a=[[s]];return S(Gn(t,e,n,r,i),function(t){a[0].push(t)}),a[0].push(s),o(a)},t.rhumbBearing=sn,t.rhumbDistance=un,t.rhumbDestination=nr,t.polygonTangents=function(t,e){var n,i,o,s=U(t),a=U(e);switch(K(e)){case"Polygon":n=a[0][0],i=a[0][0],o=ir(a[0][0],a[0][a[0].length-1],s);var u=rr(a[0],s,o,void 0,n,i);n=u[0],i=u[1];break;case"MultiPolygon":n=a[0][0][0],i=a[0][0][0],o=ir(a[0][0][0],a[0][0][a[0][0].length-1],s),a.forEach(function(t){var e=rr(t[0],s,o,void 0,n,i);n=e[0],i=e[1]})}return c([r(n),r(i)])},t.rewind=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.reverse||!1,r=e.mutate||!1;if(!t)throw new Error("<geojson> is required");if("boolean"!=typeof n)throw new Error("<reverse> must be a boolean");if("boolean"!=typeof r)throw new Error("<mutate> must be a boolean");!1===r&&(t=Gt(t));var i=[];switch(t.type){case"GeometryCollection":return A(t,function(t){sr(t,n)}),t;case"FeatureCollection":return O(t,function(t){O(sr(t,n),function(t){i.push(t)})}),c(i)}return sr(t,n)},t.isobands=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.zProperty||"elevation",i=n.commonProperties||{},s=n.breaksProperties||[];if(W(t,"Point","Input must contain Points"),!e)throw new Error("breaks is required");if(!Array.isArray(e))throw new Error("breaks is not an Array");if(!I(i))throw new Error("commonProperties is not an Object");if(!Array.isArray(s))throw new Error("breaksProperties is not an Array");var a=cr(t,{zProperty:r,flip:!0}),u=function(t,e,n){for(var r=[],i=1;i<e.length;i++){var s=+e[i-1],a=+e[i],u=hr(t,s,a-s),c=function(t){var e=[],n=[];t.forEach(function(t){var r=mn(o([t]));n.push(r),e.push({ring:t,area:r})}),n.sort(function(t,e){return e-t});var r=[];return n.forEach(function(t){for(var n=0;n<e.length;n++)if(e[n].area===t){r.push(e[n].ring),e.splice(n,1);break}}),r}(u),h=function(t){for(var e=t.map(function(t){return{lrCoordinates:t,grouped:!1}}),n=[];!function(t){for(var e=0;e<t.length;e++)if(!1===t[e].grouped)return!1;return!0}(e);)for(var r=0;r<e.length;r++)if(!e[r].grouped){var i=[];i.push(e[r].lrCoordinates),e[r].grouped=!0;for(var s=o([e[r].lrCoordinates]),a=r+1;a<e.length;a++)if(!e[a].grouped){var u=o([e[a].lrCoordinates]);(function(t,e){for(var n=me(t),r=0;r<n.features.length;r++)if(!Pt(n.features[r],e))return!1;return!0})(u,s)&&(i.push(e[a].lrCoordinates),e[a].grouped=!0)}n.push(i)}return n}(c),l={};l.groupedRings=h,l[n]=s+"-"+a,r.push(l)}return r}(a,e,r);return c((u=function(t,e,n){var r=j(n),i=r[2]-r[0],o=r[3]-r[1],s=r[0],a=r[1],u=e[0].length-1,c=e.length-1,h=i/u,l=o/c,p=function(t){t[0]=t[0]*h+s,t[1]=t[1]*l+a};return t.forEach(function(t){t.groupedRings.forEach(function(t){t.forEach(function(t){t.forEach(p)})})}),t}(u,a,t)).map(function(t,e){if(s[e]&&!I(s[e]))throw new Error("Each mappedProperty is required to be an Object");var n=Object.assign({},i,s[e]);return n[r]=t[r],p(t.groupedRings,n)}))},t.transformRotate=fr,t.transformScale=gr,t.transformTranslate=function(t,e,n,r){if(r=r||{},!I(r))throw new Error("options is invalid");var i=r.units,o=r.zTranslation,s=r.mutate;if(!t)throw new Error("geojson is required");if(void 0===e||null===e||isNaN(e))throw new Error("distance is required");if(o&&"number"!=typeof o&&isNaN(o))throw new Error("zTranslation is not a number");if(o=void 0!==o?o:0,0===e&&0===o)return t;if(void 0===n||null===n||isNaN(n))throw new Error("direction is required");return e<0&&(e=-e,n=-n),!1!==s&&void 0!==s||(t=Gt(t)),S(t,function(t){var r=U(nr(t,e,n,{units:i}));t[0]=r[0],t[1]=r[1],o&&3===t.length&&(t[2]+=o)}),t},t.lineOffset=function(t,e,n){if(n=n||{},!I(n))throw new Error("options is invalid");var r=n.units;if(!t)throw new Error("geojson is required");if(void 0===e||null===e||isNaN(e))throw new Error("distance is required");var i=K(t),o=t.properties;switch(i){case"LineString":return vr(t,e,r);case"MultiLineString":var s=[];return F(t,function(t){s.push(vr(t,e,r).geometry.coordinates)}),h(s,o);default:throw new Error("geometry "+i+" is not supported")}},t.polygonize=function(t){var e=qa.fromGeoJson(t);e.deleteDangles(),e.deleteCutEdges();var n=[],r=[];return e.getEdgeRings().filter(function(t){return t.isValid()}).forEach(function(t){t.isHole()?n.push(t):r.push(t)}),n.forEach(function(t){Da.findEdgeRingContaining(t,r)&&r.push(t)}),c(r.map(function(t){return t.toPolygon()}))},t.booleanDisjoint=function(t,e){var n;return F(t,function(t){F(e,function(e){if(!1===n)return!1;n=function(t,e){switch(t.type){case"Point":switch(e.type){case"Point":return!function(t,e){return t[0]===e[0]&&t[1]===e[1]}(t.coordinates,e.coordinates);case"LineString":return!wr(e,t);case"Polygon":return!Pt(t,e)}break;case"LineString":switch(e.type){case"Point":return!wr(t,e);case"LineString":return!function(t,e){return nn(t,e).features.length>0}(t,e);case"Polygon":return!br(e,t)}break;case"Polygon":switch(e.type){case"Point":return!Pt(e,t);case"LineString":return!br(t,e);case"Polygon":return!function(t,e){for(var n=0;n<t.coordinates[0].length;n++)if(Pt(t.coordinates[0][n],e))return!0;for(var r=0;r<e.coordinates[0].length;r++)if(Pt(e.coordinates[0][r],t))return!0;return!1}(e,t)}}}(t.geometry,e.geometry)})}),n},t.booleanContains=function(t,e){var n=K(t),r=K(e),i=J(t),o=J(e),s=U(t),a=U(e);switch(n){case"Point":switch(r){case"Point":return Nr(s,a);default:throw new Error("feature2 "+r+" geometry not supported")}case"MultiPoint":switch(r){case"Point":return function(t,e){var n,r=!1;for(n=0;n<t.coordinates.length;n++)if(Nr(t.coordinates[n],e.coordinates)){r=!0;break}return r}(i,o);case"MultiPoint":return function(t,e){for(var n=0;n<e.coordinates.length;n++){for(var r=!1,i=0;i<t.coordinates.length;i++)if(Nr(e.coordinates[n],t.coordinates[i])){r=!0;break}if(!r)return!1}return!0}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"LineString":switch(r){case"Point":return Nn(o,i,{ignoreEndVertices:!0});case"LineString":return function(t,e){for(var n=!1,r=0;r<e.coordinates.length;r++)if(Nn({type:"Point",coordinates:e.coordinates[r]},t,{ignoreEndVertices:!0})&&(n=!0),!Nn({type:"Point",coordinates:e.coordinates[r]},t,{ignoreEndVertices:!1}))return!1;return n}(i,o);case"MultiPoint":return function(t,e){for(var n=!1,r=0;r<e.coordinates.length;r++)if(Nn(e.coordinates[r],t,{ignoreEndVertices:!0})&&(n=!0),!Nn(e.coordinates[r],t))return!1;return!!n}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"Polygon":switch(r){case"Point":return Pt(o,i,{ignoreBoundary:!0});case"LineString":return function(t,e){var n=!1,r=0,i=j(t),o=j(e);if(!Ir(i,o))return!1;for(;r<e.coordinates.length-1;r++){var s=function(t,e){return[(t[0]+e[0])/2,(t[1]+e[1])/2]}(e.coordinates[r],e.coordinates[r+1]);if(Pt({type:"Point",coordinates:s},t,{ignoreBoundary:!0})){n=!0;break}}return n}(i,o);case"Polygon":return function(t,e){var n=j(t),r=j(e);if(!Ir(n,r))return!1;for(var i=0;i<e.coordinates[0].length;i++)if(!Pt(e.coordinates[0][i],t))return!1;return!0}(i,o);case"MultiPoint":return function(t,e){for(var n=0;n<e.coordinates.length;n++)if(!Pt(e.coordinates[n],t,{ignoreBoundary:!0}))return!1;return!0}(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}default:throw new Error("feature1 "+n+" geometry not supported")}},t.booleanCrosses=function(t,e){var n=K(t),r=K(e),i=J(t),o=J(e);switch(n){case"MultiPoint":switch(r){case"LineString":return Cr(i,o);case"Polygon":return Mr(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"LineString":switch(r){case"MultiPoint":return Cr(o,i);case"LineString":return function(t,e){if(nn(t,e).features.length>0)for(var n=0;n<t.coordinates.length-1;n++)for(var r=0;r<e.coordinates.length-1;r++){var i=!0;if(0!==r&&r!==e.coordinates.length-2||(i=!1),Lr(t.coordinates[n],t.coordinates[n+1],e.coordinates[r],i))return!0}return!1}(i,o);case"Polygon":return Sr(i,o);default:throw new Error("feature2 "+r+" geometry not supported")}case"Polygon":switch(r){case"MultiPoint":return Mr(o,i);case"LineString":return Sr(o,i);default:throw new Error("feature2 "+r+" geometry not supported")}default:throw new Error("feature1 "+n+" geometry not supported")}},t.booleanClockwise=or,t.booleanOverlap=Tr,t.booleanPointOnLine=Nn,t.booleanEqual=function(t,e){if(!t)throw new Error("feature1 is required");if(!e)throw new Error("feature2 is required");return K(t)===K(e)&&new ja({precision:6}).compare(te(t),te(e))},t.booleanWithin=Cn,t.clone=Gt,t.cleanCoords=te,t.clustersDbscan=function(t,e,n){if("object"!=typeof(n=n||{}))throw new Error("options is invalid");var r=n.minPoints,i=n.units;if(W(t,"Point","Input must contain Points"),null===e||void 0===e)throw new Error("maxDistance is required");if(!(Math.sign(e)>0))throw new Error("Invalid maxDistance");if(!(void 0===r||null===r||Math.sign(r)>0))throw new Error("Invalid minPoints");t=Gt(t),r=r||3;var o=new Ha.DBSCAN,s=-1;return o.run(T(t),E(e,i),r,qt).forEach(function(e){s++,e.forEach(function(e){var n=t.features[e];n.properties||(n.properties={}),n.properties.cluster=s,n.properties.dbscan="core"})}),o.noise.forEach(function(e){var n=t.features[e];n.properties||(n.properties={}),n.properties.cluster?n.properties.dbscan="edge":n.properties.dbscan="noise"}),t},t.clustersKmeans=function(t,e){if("object"!=typeof(e=e||{}))throw new Error("options is invalid");var n=e.numberOfClusters,r=e.mutate;W(t,"Point","Input must contain Points");var i=t.features.length;(n=n||Math.round(Math.sqrt(i/2)))>i&&(n=i),!1!==r&&void 0!==r||(t=Gt(t));var o=T(t),s=o.slice(0,n),a=eu(o,n,s),u={};return a.centroids.forEach(function(t,e){u[e]=t}),O(t,function(t,e){var n=a.idxs[e];t.properties.cluster=n,t.properties.centroid=u[n]}),t},t.pointToLineDistance=gn,t.booleanParallel=function(t,e){if(!t)throw new Error("line1 is required");if(!e)throw new Error("line2 is required");if("LineString"!==Dr(t,"line1"))throw new Error("line1 must be a LineString");if("LineString"!==Dr(e,"line2"))throw new Error("line2 must be a LineString");for(var n=en(te(t)).features,r=en(te(e)).features,i=0;i<n.length;i++){var o=n[i].geometry.coordinates;if(!r[i])break;if(!function(t,e){var n=m(sn(t[0],t[1])),r=m(sn(e[0],e[1]));return n===r}(o,r[i].geometry.coordinates))return!1}return!0},t.shortestPath=function(t,n,i){if(i=i||{},!I(i))throw new Error("options is invalid");var o=i.resolution,s=i.minDistance,u=i.obstacles||c([]);if(!t)throw new Error("start is required");if(!n)throw new Error("end is required");if(o&&!b(o)||o<=0)throw new Error("options.resolution must be a number, greater than 0");if(s)throw new Error("options.minDistance is not yet implemented");var h=X(t),l=X(n);switch(t=r(h),n=r(l),K(u)){case"FeatureCollection":if(0===u.features.length)return a([h,l]);break;case"Polygon":u=c([e(J(u))]);break;default:throw new Error("invalid obstacles")}var p=u;p.features.push(t),p.features.push(n);var f=j(gr(ce(j(p)),1.15));o||(o=qt([f[0],f[1]],[f[2],f[1]],i)/100);p.features.pop(),p.features.pop();for(var g=f[0],d=f[1],y=f[2],_=f[3],m=o/qt([g,d],[y,d],i)*(y-g),v=o/qt([g,d],[g,_],i)*(_-d),x=y-g,E=_-d,w=(x-Math.floor(x/m)*m)/2,N=[],C=[],S=[],M=[],L=1/0,P=1/0,O=_-(E-Math.floor(E/v)*v)/2,R=0;O>=d;){for(var T=[],A=[],D=g+w,F=0;D<=y;){var q=r([D,O]),G=function(t,e){for(var n=0;n<e.features.length;n++)if(Pt(t,e.features[n]))return!0;return!1}(q,u);T.push(G?0:1),A.push(D+"|"+O);var B=qt(q,t);!G&&B<L&&(L=B,S={x:F,y:R});var k=qt(q,n);!G&&k<P&&(P=k,M={x:F,y:R}),D+=m,F++}C.push(T),N.push(A),O-=v,R++}var z=new qr(C,{diagonal:!0}),U=z.grid[S.y][S.x],Y=z.grid[M.y][M.x],V=[h];return nu.search(z,U,Y).forEach(function(t){var e=N[t.x][t.y].split("|");V.push([+e[0],+e[1]])}),V.push(l),te(a(V))},t.voronoi=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.bbox||[-180,-85,180,85];if(!t)throw new Error("points is required");if(!Array.isArray(n))throw new Error("bbox is invalid");return W(t,"Point","points"),c(fu().x(function(t){return t.geometry.coordinates[0]}).y(function(t){return t.geometry.coordinates[1]}).extent([[n[0],n[1]],[n[2],n[3]]]).polygons(t.features).map(li))},t.ellipse=pi,t.centerMean=gi,t.centerMedian=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.counter||10;if(!b(n))throw new Error("counter must be a number");var r=e.weight,i=gi(t,{weight:e.weight}),o=c([]);return O(t,function(t){o.features.push(ye(t,{weight:t.properties[r]}))}),o.properties={tolerance:e.tolerance,medianCandidates:[]},di(i.geometry.coordinates,[0,0],o,n)},t.standardDeviationalEllipse=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.steps||64,r=e.weight,i=e.properties||{};if(!b(n))throw new Error("steps must be a number");if(!I(i))throw new Error("properties must be a number");var o=T(t).length,s=gi(t,{weight:r}),a=0,u=0,h=0;O(t,function(t){var e=t.properties[r]||1,n=yi(U(t),U(s));a+=Math.pow(n.x,2)*e,u+=Math.pow(n.y,2)*e,h+=n.x*n.y*e});var l=a-u,p=Math.sqrt(Math.pow(l,2)+4*Math.pow(h,2)),f=2*h,g=Math.atan((l+p)/f),d=180*g/Math.PI,y=0,_=0,m=0;O(t,function(t){var e=t.properties[r]||1,n=yi(U(t),U(s));y+=Math.pow(n.x*Math.cos(g)-n.y*Math.sin(g),2)*e,_+=Math.pow(n.x*Math.sin(g)+n.y*Math.cos(g),2)*e,m+=e});var v=Math.sqrt(2*y/m),x=Math.sqrt(2*_/m),E=pi(s,v,x,{units:"degrees",angle:d,steps:n,properties:i}),w=Rt(t,c([E])),N={meanCenterCoordinates:U(s),semiMajorAxis:v,semiMinorAxis:x,numberOfFeatures:o,angle:d,percentageWithinEllipse:100*T(w).length/o};return E.properties.standardDeviationalEllipse=N,E},t.difference=function(t,n){var r=J(t),i=J(n),o=t.properties||{};if(r=Ui(r),i=Ui(i),!r)return null;if(!i)return e(r,o);var s=new bh,a=s.read(r),u=s.read(i),c=Cf.difference(a,u);return c.isEmpty()?null:e((new Ih).write(c),o)},t.buffer=function(t,e,n){var r=(n=n||{}).units,i=n.steps||64;if(!t)throw new Error("geojson is required");if("object"!=typeof n)throw new Error("options must be an object");if("number"!=typeof i)throw new Error("steps must be an number");if(void 0===e)throw new Error("radius is required");if(i<=0)throw new Error("steps must be greater than 0");i=i||64,r=r||"kilometers";var o=[];switch(t.type){case"GeometryCollection":return A(t,function(t){var n=bo(t,e,r,i);n&&o.push(n)}),c(o);case"FeatureCollection":return O(t,function(t){var n=bo(t,e,r,i);n&&O(n,function(t){t&&o.push(t)})}),c(o)}return bo(t,e,r,i)},t.union=Mo,t.intersect=Lo,t.dissolve=function(t,e){if(e=e||{},!I(e))throw new Error("options is invalid");var n=e.propertyName;W(t,"Polygon","dissolve");var r=Gt(t),i=r.features,o=[];i.forEach(function(t,e){t.properties.origIndexPosition=e});var s=Qe();s.load(r);for(var u in i){var c=i[u],h=!1;if(s.search(c).features.forEach(function(t){c=i[u];var e=t.properties.origIndexPosition;if(o.length>0&&0!==e)if(e>o[o.length-1])e-=o.length;else{var r=Po(e,o);0!==r&&(e-=r)}if(e!==+u){var l=i[e];l&&c&&(void 0!==n&&l.properties[n]!==c.properties[n]||Tr(c,l)&&function(t,e){var n=a(T(t)),r=a(T(e));return nn(n,r).features.length>0}(c,l)&&(i[u]=Mo(c,l),o.push(t.properties.origIndexPosition),o.sort(function(t,e){return t-e}),s.remove(t),i.splice(e,1),c.properties.origIndexPosition=u,s.remove(c,function(t,e){return t.properties.origIndexPosition===e.properties.origIndexPosition}),h=!0))}}),h){if(!c)continue;c.properties.origIndexPosition=u,s.insert(c),u--}}return i.forEach(function(t){delete t.properties.origIndexPosition,delete t.bbox}),r},t.hexGrid=Oo,t.mask=function(t,e){var n=function(t){return o(t&&t.geometry.coordinates||[[[180,90],[-180,90],[-180,-90],[180,-90],[180,90]]])}(e),r=function(t){var e=[],n=[];return F(t,function(t){var r=t.geometry.coordinates,i=r[0],s=r.slice(1);e.push(o([i])),s.forEach(function(t){n.push(o([t]))})}),[c(e),c(n)]}(t),i=r[0],s=r[1];return function(t,e,n){var r=[];return r.push(t.geometry.coordinates[0]),F(e,function(t){r.push(t.geometry.coordinates[0])}),F(n,function(t){r.push(t.geometry.coordinates[0])}),o(r)}(n,i=Ro(i),s=Ro(s))},t.squareGrid=Ao,t.triangleGrid=Do,t.interpolate=function(t,e,n){if("object"!=typeof(n=n||{}))throw new Error("options is invalid");var r=n.gridType,i=n.property,o=n.weight;if(!t)throw new Error("points is required");if(W(t,"Point","input must contain Points"),!e)throw new Error("cellSize is required");if(void 0!==o&&"number"!=typeof o)throw new Error("weight must be a number");i=i||"elevation",r=r||"square",o=o||1;var s,a=j(t);switch(r){case"point":case"points":s=Ln(a,e,n);break;case"square":case"squares":s=Ao(a,e,n);break;case"hex":case"hexes":s=Oo(a,e,n);break;case"triangle":case"triangles":s=Do(a,e,n);break;default:throw new Error("invalid gridType")}var u=[];return O(s,function(e){var s=0,a=0;O(t,function(t){var u,c=qt("point"===r?e:ye(e),t,n);if(void 0!==i&&(u=t.properties[i]),void 0===u&&(u=t.geometry.coordinates[2]),void 0===u)throw new Error("zValue is missing");0===c&&(s=u);var h=1/Math.pow(c,o);a+=h,s+=h*u});var c=Gt(e);c.properties[i]=s/a,u.push(c)}),c(u)},t.pointOnSurface=yn,t.polygonToLineString=kn,t.lineStringToPolygon=jn,t.inside=Pt,t.within=Rt,t.bezier=ue,t.nearest=Fe,t.pointOnLine=on,t.lineDistance=bn,t.radians2degrees=v,t.degrees2radians=x,t.distanceToDegrees=_,t.distanceToRadians=y,t.radiansToDistance=d,t.bearingToAngle=m,t.convertDistance=E,t.toMercator=cn,t.toWgs84=hn,t.randomPosition=_i,t.randomPoint=mi,t.randomPolygon=vi,t.randomLineString=xi,t.getCluster=wi,t.clusterEach=bi,t.clusterReduce=Ii,t.createBins=Ni,t.applyFilter=Ci,t.propertiesContainsFilter=Si,t.filterProperties=Mi,t.earthRadius=Fo,t.factors=qo,t.unitsFactors=Go,t.areaFactors=Bo,t.feature=e,t.geometry=n,t.point=r,t.points=i,t.polygon=o,t.polygons=s,t.lineString=a,t.lineStrings=u,t.featureCollection=c,t.multiLineString=h,t.multiPoint=l,t.multiPolygon=p,t.geometryCollection=f,t.round=g,t.radiansToLength=d,t.lengthToRadians=y,t.lengthToDegrees=_,t.bearingToAzimuth=m,t.radiansToDegrees=v,t.degreesToRadians=x,t.convertLength=E,t.convertArea=w,t.isNumber=b,t.isObject=I,t.validateBBox=N,t.validateId=C,t.getCoord=X,t.getCoords=U,t.containsNumber=Y,t.geojsonType=V,t.featureOf=H,t.collectionOf=W,t.getGeom=J,t.getGeomType=Z,t.getType=K,t.coordEach=S,t.coordReduce=M,t.propEach=L,t.propReduce=P,t.featureEach=O,t.featureReduce=R,t.coordAll=T,t.geomEach=A,t.geomReduce=D,t.flattenEach=F,t.flattenReduce=q,t.segmentEach=G,t.segmentReduce=B,t.lineEach=k,t.lineReduce=z,Object.defineProperty(t,"__esModule",{value:!0})});


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
	 *
	 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
	 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
	 *
	 * @module polyline
	 */

	var polyline = {};

	function py2_round(value) {
	    // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
	    return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
	}

	function encode(current, previous, factor) {
	    current = py2_round(current * factor);
	    previous = py2_round(previous * factor);
	    var coordinate = current - previous;
	    coordinate <<= 1;
	    if (current - previous < 0) {
	        coordinate = ~coordinate;
	    }
	    var output = '';
	    while (coordinate >= 0x20) {
	        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
	        coordinate >>= 5;
	    }
	    output += String.fromCharCode(coordinate + 63);
	    return output;
	}

	/**
	 * Decodes to a [latitude, longitude] coordinates array.
	 *
	 * This is adapted from the implementation in Project-OSRM.
	 *
	 * @param {String} str
	 * @param {Number} precision
	 * @returns {Array}
	 *
	 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
	 */
	polyline.decode = function(str, precision) {
	    var index = 0,
	        lat = 0,
	        lng = 0,
	        coordinates = [],
	        shift = 0,
	        result = 0,
	        byte = null,
	        latitude_change,
	        longitude_change,
	        factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);

	    // Coordinates have variable length when encoded, so just keep
	    // track of whether we've hit the end of the string. In each
	    // loop iteration, a single coordinate is decoded.
	    while (index < str.length) {

	        // Reset shift, result, and byte
	        byte = null;
	        shift = 0;
	        result = 0;

	        do {
	            byte = str.charCodeAt(index++) - 63;
	            result |= (byte & 0x1f) << shift;
	            shift += 5;
	        } while (byte >= 0x20);

	        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

	        shift = result = 0;

	        do {
	            byte = str.charCodeAt(index++) - 63;
	            result |= (byte & 0x1f) << shift;
	            shift += 5;
	        } while (byte >= 0x20);

	        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

	        lat += latitude_change;
	        lng += longitude_change;

	        coordinates.push([lat / factor, lng / factor]);
	    }

	    return coordinates;
	};

	/**
	 * Encodes the given [latitude, longitude] coordinates array.
	 *
	 * @param {Array.<Array.<Number>>} coordinates
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.encode = function(coordinates, precision) {
	    if (!coordinates.length) { return ''; }

	    var factor = Math.pow(10, Number.isInteger(precision) ? precision : 5),
	        output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);

	    for (var i = 1; i < coordinates.length; i++) {
	        var a = coordinates[i], b = coordinates[i - 1];
	        output += encode(a[0], b[0], factor);
	        output += encode(a[1], b[1], factor);
	    }

	    return output;
	};

	function flipped(coords) {
	    var flipped = [];
	    for (var i = 0; i < coords.length; i++) {
	        var coord = coords[i].slice();
	        flipped.push([coord[1], coord[0]]);
	    }
	    return flipped;
	}

	/**
	 * Encodes a GeoJSON LineString feature/geometry.
	 *
	 * @param {Object} geojson
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.fromGeoJSON = function(geojson, precision) {
	    if (geojson && geojson.type === 'Feature') {
	        geojson = geojson.geometry;
	    }
	    if (!geojson || geojson.type !== 'LineString') {
	        throw new Error('Input must be a GeoJSON LineString');
	    }
	    return polyline.encode(flipped(geojson.coordinates), precision);
	};

	/**
	 * Decodes to a GeoJSON LineString geometry.
	 *
	 * @param {String} str
	 * @param {Number} precision
	 * @returns {Object}
	 */
	polyline.toGeoJSON = function(str, precision) {
	    var coords = polyline.decode(str, precision);
	    return {
	        type: 'LineString',
	        coordinates: flipped(coords)
	    };
	};

	if (typeof module === 'object' && module.exports) {
	    module.exports = polyline;
	}


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = timeToInt;
	function timeToInt() {
	  'use strict';

	  return function (input, short) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return;
	    }

	    var time = input.split(':');

	    if (short) {
	      return +time[0] * 60 * 60 + +time[1] * 60;
	    }
	    return +time[0] * 60 * 60 + +time[1] * 60 + +time[2];
	  };
	}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mapConfig = exports.mapConfig = {
	  path: {
	    paint: {
	      'line-opacity': 0.85,
	      'line-color': '#BDBDBD',
	      'line-width': {
	        'base': 4,
	        'stops': [[9, 5], [13, 9], [18, 12]]
	      }
	    },
	    layout: {
	      'line-join': 'round',
	      'line-cap': 'round'
	    }
	  },
	  dashed: {
	    paint: {
	      'line-opacity': 0.85,
	      'line-color': '#BDBDBD',
	      'line-width': {
	        'base': 3,
	        'stops': [[9, 5], [13, 9], [18, 12]]
	      },
	      'line-dasharray': [0.3, 2.4]
	    },
	    layout: {
	      'line-join': 'round',
	      'line-cap': 'round'
	    }
	  },
	  arrows: {
	    layout: {
	      'symbol-placement': 'line',
	      'text-field': '→',
	      'text-size': {
	        'base': 1,
	        'stops': [[4, 32], [8, 24], [12, 12]]
	      },
	      'symbol-spacing': {
	        'base': 1,
	        'stops': [[9, 15], [12, 30], [22, 60]]
	      },
	      'text-keep-upright': false
	    },
	    paint: {
	      'text-color': '#FFFFFF'
	    }
	  },
	  waypoints: {
	    paint: {
	      'circle-stroke-color': '#FFFFFF',
	      'circle-radius': 4,
	      'circle-color': {
	        'property': 'action',
	        'type': 'categorical',
	        'stops': [['load', '#607D8B'], ['unload', '#4CAF50'], ['stop', '#F44336'], ['holding', '#FFC107']]
	      },
	      'circle-stroke-width': 2
	    },
	    layout: {}
	  }
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _bar = __webpack_require__(57);

	var _bar2 = _interopRequireDefault(_bar);

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TripsStatsController = function () {
	  TripsStatsController.$inject = ["$state", "$translate", "$window", "DialogService", "EnvironmentConfig", "GenericService", "TripsService"];
	  function TripsStatsController($state, $translate, $window, DialogService, EnvironmentConfig, GenericService, TripsService) {
	    'ngInject';

	    _classCallCheck(this, TripsStatsController);

	    this.$state = $state;
	    this.$translate = $translate;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GenericService = GenericService;
	    this.TripsService = TripsService;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.trips = {
	      range: {
	        startDate: moment().subtract(30, 'd'),
	        endDate: moment()
	      }
	    };

	    this.dateRangeConfig = {
	      locale: {
	        format: 'DD/MM/YYYY',
	        applyLabel: this.$translate.instant('TRIPS.ACTION.APPLY'),
	        cancelLabel: this.$translate.instant('TRIPS.ACTION.CANCEL'),
	        daysOfWeek: _constants.weekdays[user.locale],
	        monthNames: _constants.months[user.locale]
	      },
	      maxSpan: {
	        days: 31
	      },
	      maxDate: moment(new Date())
	    };

	    this.selectedVehicles = [];
	    this.selectedUsers = [];
	    this.loadData();
	  }

	  _createClass(TripsStatsController, [{
	    key: 'addNew',
	    value: function addNew(type) {
	      var _this = this;

	      var status = {
	        url: 'app/components/new-item/add-' + type + '.html',
	        controllerName: 'AddNewItemController',
	        controllerAlias: 'ctrl',
	        clickOutsideToClose: true,
	        escapeToClose: true,
	        hasBackdrop: false
	      };

	      this.DialogService.openDialog(status).then(function (res) {
	        if (type === 'user') {
	          _this.selectedUsers.push(res);
	          _this.loadData();
	        } else {
	          _this.selectedVehicles.push(res);
	          _this.loadData();
	        }
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      this.loading = true;

	      var data = {
	        f: moment(this.trips.range.startDate).format('YYYY-MM-DD'),
	        t: moment(this.trips.range.endDate).format('YYYY-MM-DD')
	      };

	      if (this.selectedUsers.length) {
	        data.r = encodeURIComponent(btoa(angular.toJson(_.map(this.selectedUsers, function (u) {
	          return (0, _helper.decodify)(_this2.EnvironmentConfig.SALT, u.id);
	        })))); // eslint-disable-line
	      } else {
	        delete data.r;
	      }
	      if (this.selectedVehicles.length) {
	        data.v = encodeURIComponent(btoa(angular.toJson(_.map(this.selectedVehicles, function (v) {
	          return (0, _helper.decodify)(_this2.EnvironmentConfig.SALT, v.id);
	        })))); // eslint-disable-line
	      } else {
	        delete data.v;
	      }

	      this.TripsService.getReport(data).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.reported = res;
	        _this2.$state.go('.', { f: _this2.trips.f, t: _this2.trips.t }, { notify: false });
	        _this2.buildGraph();
	      }).catch(function () {
	        _this2.reported = null;
	      });
	    }
	  }, {
	    key: 'buildGraph',
	    value: function buildGraph() {
	      var graphs = [['bar', 'distance', 'distance', ['estDist_values']], ['bar', 'time', 'time', ['estTripTime_values', 'estDriv_values']]];
	      for (var index = 0; index < graphs.length; index++) {
	        (0, _bar2.default)(graphs[index][0], graphs[index][1], graphs[index][2], graphs[index][3], this.reported, this.$translate);
	      }
	    }
	  }]);

	  return TripsStatsController;
	}();

	exports.default = TripsStatsController;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	generateBarChart.$inject = ["type", "_format", "bindTo", "datakeys", "sample", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _builddata = __webpack_require__(58);

	var _builddata2 = _interopRequireDefault(_builddata);

	var _buildnames = __webpack_require__(59);

	var _buildnames2 = _interopRequireDefault(_buildnames);

	var _randomcolors = __webpack_require__(60);

	var _randomcolors2 = _interopRequireDefault(_randomcolors);

	var _formatNumber = __webpack_require__(61);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global c3 */

	function generateBarChart(type, _format, bindTo, datakeys, sample, $translate) {
	  'ngInject';

	  return c3.generate({
	    bindto: '#' + bindTo,
	    data: {
	      columns: (0, _builddata2.default)(null, datakeys, sample),
	      names: (0, _buildnames2.default)(datakeys, $translate),
	      type: type
	    },
	    color: {
	      pattern: (0, _randomcolors2.default)()
	    },
	    legend: {
	      show: true,
	      position: 'inset',
	      inset: {
	        anchor: 'top-right',
	        x: 0,
	        y: 0,
	        step: 1
	      }
	    },
	    bar: {
	      width: {
	        ratio: 0.2
	      }
	    },
	    size: {
	      height: 256
	    },
	    grid: {
	      y: {
	        show: true
	      }
	    },
	    tooltip: {
	      grouped: false
	    },
	    axis: {
	      y: {
	        tick: {
	          count: 7,
	          format: function format(d) {
	            return (0, _formatNumber2.default)(d, _format);
	          }
	        }
	      }
	    }
	  });
	}
	exports.default = generateBarChart;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildData;
	function buildData(dates, datakeys, sample) {
	  var data = [];

	  if (dates) data.push(['x'].concat(angular.fromJson(sample[dates])));

	  for (var index = 0; index < datakeys.length; index++) {
	    data.push(['data' + index].concat(sample[datakeys[index]]));
	  }
	  return data;
	}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildNames;
	function buildNames(datakeys, $translate) {
	  var obj = {};
	  for (var index = 0; index < datakeys.length; index++) {
	    obj['data' + index] = $translate.instant('VISUALIZATIONS.' + datakeys[index].toUpperCase());
	  }

	  return obj;
	}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = randomColor;
	function randomColor() {
	  var colors = [['#511845', '#900c3f', '#c70039', '#ff5733'], ['#202040', '#543864', '#ff6363', '#ffbd69'], ['#00bcd4', '#b2ebf2', '#ff5722', '#dd2c00'], ['#363062', '#4d4c7d', '#827397', '#d8b9c3'], ['#ffa41b', '#000839', '#005082', '#00a8cc'], ['#721b65', '#b80d57', '#f8615a', '#ffd868'], ['#204051', '#3b6978', '#84a9ac', '#cae8d5'], ['#142850', '#27496d', '#0c7b93', '#00a8cc'], ['#42240c', '#c81912', '#f64b3c', '#fdba9a'], ['#222831', '#30475e', '#f2a365', '#ececec']];

	  return colors[Math.floor(Math.random() * 10)];
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatNumber;

	var _floatToTime = __webpack_require__(62);

	var _floatToTime2 = _interopRequireDefault(_floatToTime);

	var _distance = __webpack_require__(63);

	var _distance2 = _interopRequireDefault(_distance);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function formatNumber(i, type) {
	  switch (type) {
	    case 'number':
	      i = parseInt(i);
	      break;
	    case 'distance':
	      i = (0, _distance2.default)()(i);
	      break;
	    case 'percent':
	      i = (i * 100).toFixed(1) + '%';
	      break;
	    case 'speed':
	      i = parseInt(i) + 'km/h';
	      break;
	    case 'time':
	      i = (0, _floatToTime2.default)()(i);
	      break;
	    case 'boolean':
	      i = Boolean(i);
	      break;
	    default:
	      break;
	  }
	  return i;
	}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = floatToTime;
	function floatToTime() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '00:00';
	    }

	    var sign = input >= 0 ? 1 : -1;
	    input = input * sign;
	    var hour = Math.floor(input);
	    var decpart = input - hour;
	    var min = 1 / 60;
	    decpart = min * Math.round(decpart / min);
	    var minute = Math.floor(decpart * 60) + '';

	    if (minute.length < 2) {
	      minute = '0' + minute;
	    }

	    sign = sign === 1 ? '' : '-';

	    return '' + sign + hour + ':' + minute;
	  };
	}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = distance;
	function distance() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '0km';
	    }

	    if (input < 9999) {
	      return input.toFixed(1) + 'km';
	    } else if (input > 9999 && input < 9999999) {
	      return (input / 1000).toFixed(1) + 'k km';
	    } else if (input > 9999990) {
	      return (input / 1000000).toFixed(1) + 'kk km';
	    }
	  };
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TripsService = function () {
	  TripsService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function TripsService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, TripsService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(TripsService, [{
	    key: 'getTripPath',
	    value: function getTripPath(coords) {
	      var deferred = this.$q.defer();
	      this.$http({ url: ['https://api.mapbox.com/optimized-trips/v1/mapbox/driving', coords, '?source=first&destination=last&roundtrip=false&geometries=geojson&overview=full&language=pt-BR&access_token=pk.eyJ1IjoibWFyY2Vsb3NvZnRydWNrIiwiYSI6ImNqemlxdW55YTAyNmwzbnF0NzU5c3h4aGMifQ.8paId-mJJ636tKpbwS2mhA'].join('/'), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getReport',
	    value: function getReport(obj) {
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, _constants.API.V1, _constants.API.TRIPS, 'report'].join('/');
	      if (obj.f) {
	        query.push('from_day=' + obj.f);
	      }
	      if (obj.t) {
	        query.push('to_day=' + obj.t);
	      }
	      if (obj.v) {
	        query.push('vehicles=' + obj.v);
	      }
	      if (obj.r) {
	        query.push('responsibles=' + obj.r);
	      }

	      this.$http({ url: url + (query.length ? '?' + query.join('&') : ''), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return TripsService;
	}();

	exports.default = TripsService;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _identificationsList = __webpack_require__(66);

	var _identificationsList2 = _interopRequireDefault(_identificationsList);

	var _identificationsCreate = __webpack_require__(67);

	var _identificationsCreate2 = _interopRequireDefault(_identificationsCreate);

	var _identifications = __webpack_require__(68);

	var _identifications2 = _interopRequireDefault(_identifications);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.fleet.identifications', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'identifications-list',
	    url: '/identifications/list?search&predicates',
	    parent: 'fleet',
	    menu: true,
	    alias: 'identifications',
	    controller: _identificationsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/identifications/list/identifications.list.html',
	    params: {
	      search: { dynamic: true },
	      predicates: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'identifications-create',
	    url: '/identifications/create',
	    parent: 'fleet',
	    controller: _identificationsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/identifications/create/identifications.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'identifications-edit',
	    url: '/identifications/edit/:id',
	    parent: 'fleet',
	    controller: _identificationsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/fleet/identifications/create/identifications.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('IdentificationsListController', _identificationsList2.default).controller('IdentificationsCreateController', _identificationsCreate2.default).service('IdentificationsService', _identifications2.default);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _baseList = __webpack_require__(45);

	var _baseList2 = _interopRequireDefault(_baseList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IdentificationsListController = function (_BaseListController) {
	  IdentificationsListController.$inject = ["$state", "$scope", "$translate", "GenericService"];
	  _inherits(IdentificationsListController, _BaseListController);

	  function IdentificationsListController($state, $scope, $translate, GenericService) {
	    'ngInject';

	    _classCallCheck(this, IdentificationsListController);

	    var _this = _possibleConstructorReturn(this, (IdentificationsListController.__proto__ || Object.getPrototypeOf(IdentificationsListController)).call(this, $scope, GenericService));

	    _this.$state = $state;
	    _this.$translate = $translate;

	    var query = {
	      limit: 15,
	      page: 1,
	      search: _this.$state.params.search,
	      order: { prop: 'code', order: 'ASC' },
	      predicates: _this.$state.params.predicates
	    };

	    _this.options = {
	      new: 'screen',
	      export: true,
	      stats: false
	    };

	    _this.setProps(_constants.API.V1, _constants.API.IDENTIFICATIONS, query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(IdentificationsListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.CODE_TYPE', 'PANEL.HEADER.DRIVER_ENTERPRISE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.CODE_TYPE'],
	          sort: true,
	          prop: 'code'
	        }, {
	          label: t['PANEL.HEADER.DRIVER_ENTERPRISE'],
	          sort: true,
	          prop: 'user.name'
	        }];
	      });
	    }
	  }]);

	  return IdentificationsListController;
	}(_baseList2.default);

	exports.default = IdentificationsListController;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var IdentificationsCreateController = function () {
	  IdentificationsCreateController.$inject = ["$scope", "$state", "$window", "EnvironmentConfig", "GenericService"];
	  function IdentificationsCreateController($scope, $state, $window, EnvironmentConfig, GenericService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, IdentificationsCreateController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GenericService = GenericService;

	    this.usersOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: '' }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.usersOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });

	    this.types = ['rfid', 'ibutton'];
	    this.isEdit();
	  }

	  _createClass(IdentificationsCreateController, [{
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this2 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.GenericService.show(_constants.API.V1, _constants.API.IDENTIFICATIONS, this.$state.params.id).promise.then(function (res) {
	          _this2.identification = res;
	          _this2.options = {
	            archive: !_this2.identification.archived_at,
	            unarchive: _this2.identification.archived_at,
	            delete: _this2.identification.archived_at
	          };
	          _this2.selectedEnterprise = {
	            id: (0, _helper.hashify)(_this2.EnvironmentConfig.SALT, _this2.identification.enterprise.id),
	            attributes: _this2.identification.enterprise
	          };
	          _this2.selectedUser = {
	            id: _this2.identification.user.id,
	            attributes: _this2.identification.user
	          };
	          _this2.usersOptions.filters['enterprise.id'].value = _this2.selectedEnterprise.id;
	        });
	      } else {
	        this.fixEnterprise();
	      }
	    }
	  }, {
	    key: 'fixEnterprise',
	    value: function fixEnterprise() {
	      this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      this.selectedEnterprise.id = (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id);
	      this.usersOptions.filters['enterprise.id'].value = this.selectedEnterprise.id;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      var data = {
	        enterprise_id: (0, _helper.decodify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id),
	        code: this.identification.code,
	        type: this.identification.type,
	        user_id: this.selectedUser ? (0, _helper.decodify)(this.EnvironmentConfig.SALT, this.selectedUser.id) : null
	      };
	      if (this.identification.id) {
	        this.GenericService.update(_constants.API.V1, _constants.API.IDENTIFICATIONS, this.identification.id, data).promise.then(function () {
	          _this3.form.$setPristine();
	        }).finally(function () {
	          _this3.processing = false;
	        });
	      } else {
	        this.GenericService.create(_constants.API.V1, _constants.API.IDENTIFICATIONS, data).promise.then(function () {
	          _this3.$state.go('identifications-list');
	        }).finally(function () {
	          _this3.processing = false;
	        });
	      }
	    }
	  }]);

	  return IdentificationsCreateController;
	}();

	exports.default = IdentificationsCreateController;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var IdentificationsService = function () {
	  IdentificationsService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function IdentificationsService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, IdentificationsService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(IdentificationsService, [{
	    key: 'associateUser',
	    value: function associateUser(id, userId) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V1, _constants.API.IDENTIFICATIONS, id, 'associate-driver', userId].join('/'), method: 'PUT' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'disassociateUser',
	    value: function disassociateUser(id) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V1, _constants.API.IDENTIFICATIONS, id, 'disassociate'].join('/'), method: 'PUT' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return IdentificationsService;
	}();

	exports.default = IdentificationsService;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(70);

	__webpack_require__(74);

	__webpack_require__(84);

	__webpack_require__(95);

	angular.module('phoenix.internal.management', ['ui.router', 'phoenix.internal.management.files', 'phoenix.internal.management.geofences', 'phoenix.internal.management.users', 'phoenix.internal.management.vehicles']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'management',
	    url: '/management',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _filesList = __webpack_require__(71);

	var _filesList2 = _interopRequireDefault(_filesList);

	var _newReportPoints = __webpack_require__(73);

	var _newReportPoints2 = _interopRequireDefault(_newReportPoints);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.management.files', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'files-list',
	    url: '/files/list?search&filters',
	    parent: 'management',
	    controller: _filesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/files/list/files.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  });
	}]).controller('FilesListController', _filesList2.default).controller('NewReportFileController', _newReportPoints2.default);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FilesListController = function (_ListController) {
	  FilesListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  _inherits(FilesListController, _ListController);

	  function FilesListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, FilesListController);

	    var _this = _possibleConstructorReturn(this, (FilesListController.__proto__ || Object.getPrototypeOf(FilesListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$translate = $translate;

	    _this.query = {
	      attributes: ['created_at', 'updated_at', 'file_address', 'file_format', 'from_date', 'status', 'timezone', 'to_date'],
	      includes: {
	        enterprise: ['name', 'cnpj'],
	        vehicle: ['plate', 'vin', 'type_name'],
	        user: ['name', 'email', 'phone1'],
	        device: ['name', 'imei']
	      },
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'new-report-points',
	      export: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.DEVICES + '/reports/points', _this.query, false);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(FilesListController, [{
	    key: 'checkAvailability',
	    value: function checkAvailability(file) {
	      var now = new Date();
	      var fileDate = new Date(file.attributes.created_at);

	      file.attributes.expired = now.setDate(now.getDate() - 60) > fileDate;
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.VEHICLE_TYPE', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.NAME_IMEI', 'PANEL.HEADER.FORMAT_STATUS', 'PANEL.HEADER.NAME_EMAIL'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.VEHICLE_TYPE'],
	          sort: true,
	          prop: 'vehicle.plate'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.NAME_IMEI'],
	          sort: true,
	          prop: 'device.name'
	        }, {
	          label: t['PANEL.HEADER.FORMAT_STATUS'],
	          sort: true,
	          prop: 'status'
	        }, {
	          label: t['PANEL.HEADER.NAME_EMAIL'],
	          sort: true,
	          prop: 'user.name'
	        }];
	      });
	    }
	  }]);

	  return FilesListController;
	}(_list2.default);

	exports.default = FilesListController;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ListController = function () {
	  ListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  function ListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ListController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.MainService = MainService;

	    this.items = [];
	    this.filters = [];

	    var watchNavbar = this.$scope.$on('scrollEvent', function () {
	      _this.loadMore();
	    });

	    this.$scope.$on('$destroy', watchNavbar);
	    this.$scope.$on('order', function (ev, data) {
	      _this.order(data);
	    });
	    this.$scope.$on('advancedFilter', function (ev, data) {
	      _this.advancedFilter(data);
	    });
	    this.$scope.$on('selectAll', function (ev, data) {
	      _this.selectAll(data);
	    });
	    this.$scope.$on('changeFilter', function (ev, _ref) {
	      var data = _ref.data,
	          options = _ref.options;
	      _this.setFilter(data, options);
	    });
	    this.$scope.$on('complementeFilter', function (ev, data) {
	      _this.setFilter(data);
	    });
	    this.$scope.$on('searchList', function (ev, data) {
	      _this.search(data);
	    });
	  }

	  _createClass(ListController, [{
	    key: 'setFilter',
	    value: function setFilter(data, options) {
	      var _this2 = this;

	      if (!options.keepFilters) {
	        this.query.filters = {};
	        this.query.search = null;
	      }
	      if (angular.isArray(data) && data.length > 0) {
	        data.forEach(function (f) {
	          _this2.query.filters[f.key] = f.val;
	        });
	      } else if (data.key) {
	        this.query.filters[data.key] = data.val;
	      }
	      this._triggerData();
	    }
	  }, {
	    key: 'setProps',
	    value: function setProps(version, model, obj) {
	      var _this3 = this;

	      var filterPropagation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	      var callback = arguments[4];

	      this.loading = true;
	      var objFormatted = obj;
	      var layout = {
	        contentSelector: '#content',
	        excludedElements: ['#navbar-wrapper', '.st-filter-bar']
	      };

	      (0, _helper.calculateItemsPerScreen)(layout).then(function (res) {
	        objFormatted.limit = res;
	      }).finally(function () {
	        _this3.loading = false;
	        _this3.version = version;
	        _this3.model = model;
	        _this3.query = objFormatted;
	        _this3.filterPropagation = filterPropagation;
	        _this3.callback = callback;
	        _this3._mountQuery(objFormatted);
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(data) {
	      if (this.loading) {
	        return;
	      }
	      this.query.filters = {};
	      this.query.search = data;
	      this._triggerData();
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(query) {
	      var _this4 = this;

	      this.loading = true;
	      this.MainService.raw(this.version, this.model, query).promise.then(function (res) {
	        _this4.loading = false;
	        _this4.items = _this4.items.concat(res.data);
	        if (_this4.select) {
	          _this4.items.forEach(function (e) {
	            e.selected = true;
	          });
	        }
	        _this4.responseLength = res.data.length;
	        _this4.amount = res.count;
	        if (_this4.filterPropagation) {
	          _this4.$state.go('.', { search: query.search, filters: internals.jsonToUri(query.filters) }, { notify: false });
	        }
	      }).finally(function () {
	        _this4.loading = false;
	        if (angular.isFunction(_this4.callback)) {
	          _this4.callback(_this4.items);
	        }
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      if ((this.responseLength === this.query.limit || this.items.length < this.amount) && !this.loading) {
	        this.query.page += 1;
	        this.loadData(this.query);
	      }
	    }
	  }, {
	    key: 'order',
	    value: function order(params) {
	      this.query.sort = params;
	      this._triggerData();
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll(params) {
	      this.select = params.prop;
	      this.items.forEach(function (e) {
	        e.selected = params.prop;
	      });
	    }
	  }, {
	    key: 'advancedFilter',
	    value: function advancedFilter(data) {
	      this.query.filters = data;
	      this._triggerData();
	    }
	  }, {
	    key: '_triggerData',
	    value: function _triggerData() {
	      this.items = [];
	      this.query.page = 1;
	      this.loadData(this.query);
	    }
	  }, {
	    key: '_mountQuery',
	    value: function _mountQuery(obj) {
	      if (this.$state.params.filters) {
	        this.query.filters = internals.uriToJson(this.$state.params.filters);
	      }
	      if (this.$state.params.search) {
	        this.query.search = this.$state.params.search;
	      }
	      this.loadData(obj);
	    }
	  }]);

	  return ListController;
	}();

	exports.default = ListController;


	var internals = {
	  uriToJson: function uriToJson(uri) {
	    if (uri) {
	      return angular.fromJson((0, _helper._decodeBase64)(decodeURIComponent(uri)));
	    }
	  },
	  jsonToUri: function jsonToUri(data) {
	    if (Object.keys(data).length > 0) {
	      return encodeURIComponent((0, _helper._encodeBase64)(angular.toJson(data)));
	    }
	  }
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewReportFileController = function () {
	  NewReportFileController.$inject = ["$window", "DialogService", "MainService"];
	  function NewReportFileController($window, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, NewReportFileController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.dtk = this.$window.localStorage.getItem('notification_dtk');
	    this.report = {
	      type: 'CSV'
	    };
	  }

	  _createClass(NewReportFileController, [{
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(res) {
	      var _this = this;

	      this.selectedDevice = res;
	      if (!this.selectedDevice) {
	        return;
	      }
	      this.items = [];
	      this.loading = true;
	      var obj = {
	        includes: {
	          vehicle: ['plate', 'vin', 'type_name', 'deleted_at'],
	          enterprise: ['name', 'cnpj']
	        },
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        count: true,
	        limit: 10,
	        page: 1
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.selectedDevice.id + '/association-history', obj).promise.then(function (res) {
	        _this.loading = false;
	        _this.items = _this.addSecondInCreatedAt(res);
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'addSecondInCreatedAt',
	    value: function addSecondInCreatedAt(result) {
	      result.data = result.data.map(function (item) {
	        item.attributes.created_at = moment(item.attributes.created_at).add(1, 'second').format();
	        return item;
	      });
	      return result;
	    }
	  }, {
	    key: 'updatePeriod',
	    value: function updatePeriod() {
	      if (this.selectedAssociation == null) {
	        return;
	      }

	      this.form.to_date.$setValidity('interval', (0, _helper.validationMaxReportInterval)(this.report.from_date, this.report.to_date, 'quarter'));
	      this.form.to_date.$setValidity('finalBiggerInitial', (0, _helper.finalBiggerInitial)(this.report.from_date, this.report.to_date));
	    }
	  }, {
	    key: 'updateInputsFromAndTo',
	    value: function updateInputsFromAndTo(item) {
	      var formatDate = 'yyyy-MM-DDTHH:mm:ss';
	      var deletedAt = item.attributes.deleted_at === null ? moment().subtract(1, 'second') : moment(item.attributes.deleted_at);
	      var createdAt = moment(item.attributes.created_at);

	      this.report.from_date = createdAt.format(formatDate);
	      this.report.min_date = createdAt.format(formatDate);
	      this.report.to_date = deletedAt.diff(createdAt, 'days') < 30 ? deletedAt.format(formatDate) : createdAt.add(30, 'days').format(formatDate);
	      this.report.max_date = item.attributes.deleted_at === null ? moment().format(formatDate) : deletedAt.add(1, 'second').format(formatDate);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;

	      this.updatePeriod();
	      if (!this.form.$valid) return;
	      this.processing = true;
	      var obj = {
	        data: {
	          vehicle_id: this.selectedAssociation.relationships.vehicle.id,
	          from_date: this.report.from_date,
	          to_date: this.report.to_date,
	          type: this.report.type
	        }
	      };

	      if (this.dtk) {
	        obj.data.dtk = this.dtk;
	      }
	      this.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/' + this.selectedDevice.id + '/reports/points', obj).promise.then(function () {
	        _this2.processing = false;
	        _this2.close();
	      }).catch(function () {
	        _this2.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewReportFileController;
	}();

	exports.default = NewReportFileController;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _geofencesList = __webpack_require__(75);

	var _geofencesList2 = _interopRequireDefault(_geofencesList);

	var _geofences = __webpack_require__(76);

	var _geofences2 = _interopRequireDefault(_geofences);

	var _geofencesCreate = __webpack_require__(78);

	var _geofencesCreate2 = _interopRequireDefault(_geofencesCreate);

	var _geofence = __webpack_require__(79);

	var _geofence2 = _interopRequireDefault(_geofence);

	var _geofenceDraw = __webpack_require__(81);

	var _geofenceDraw2 = _interopRequireDefault(_geofenceDraw);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.management.geofences', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'geofences',
	    url: '/geofences',
	    parent: 'management',
	    menu: true,
	    alias: 'geofences',
	    controller: _geofences2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/geofences/map/geofences.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    redirectTo: 'geofences.list'
	  }).state({
	    name: 'geofences.list',
	    url: '/list?search',
	    alias: 'geofences.list',
	    controller: _geofencesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/geofences/list/geofences.list.html',
	    params: {
	      search: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'geofences.create',
	    url: '/create',
	    controller: _geofencesCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/geofences/create/geofences.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'geofences.edit',
	    url: '/edit/:id',
	    controller: _geofencesCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/geofences/create/geofences.create.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  });
	}]).controller('GeofencesListController', _geofencesList2.default).controller('GeofencesCreateController', _geofencesCreate2.default).service('GeofenceService', _geofence2.default).service('GeofenceDrawService', _geofenceDraw2.default);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _baseList = __webpack_require__(45);

	var _baseList2 = _interopRequireDefault(_baseList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var GeofencesListController = function (_BaseListController) {
	  GeofencesListController.$inject = ["$state", "$scope", "$translate", "GenericService"];
	  _inherits(GeofencesListController, _BaseListController);

	  function GeofencesListController($state, $scope, $translate, GenericService) {
	    'ngInject';

	    _classCallCheck(this, GeofencesListController);

	    var _this = _possibleConstructorReturn(this, (GeofencesListController.__proto__ || Object.getPrototypeOf(GeofencesListController)).call(this, $scope, GenericService));

	    _this.$state = $state;
	    _this.$translate = $translate;

	    _this.query = {
	      limit: 15,
	      page: 1,
	      search: _this.$state.params.search
	    };

	    _this.setProps(_constants.API.V3, _constants.API.GEOFENCES, _this.query, null, false, false, _this.onLoad.bind(_this));
	    _this.translateKeys();
	    _this.$scope.$emit('geofences.list');
	    return _this;
	  }

	  _createClass(GeofencesListController, [{
	    key: 'onLoad',
	    value: function onLoad(items) {
	      this.$scope.$emit('geofences.list', items);
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.CODE_TYPE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.CODE_TYPE'],
	          sort: false,
	          prop: 'code'
	        }];
	      });
	    }
	  }]);

	  return GeofencesListController;
	}(_baseList2.default);

	exports.default = GeofencesListController;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _geofence = __webpack_require__(77);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GeofencesMapController = function () {
	  GeofencesMapController.$inject = ["$mdDialog", "$scope", "$state", "$translate", "GenericService", "GeofenceService", "GeofenceDrawService", "GeoLocation", "MapHelper"];
	  function GeofencesMapController($mdDialog, $scope, $state, $translate, GenericService, GeofenceService, GeofenceDrawService, GeoLocation, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, GeofencesMapController);

	    this.$mdDialog = $mdDialog;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.GenericService = GenericService;
	    this.GeofenceService = GeofenceService;
	    this.GeofenceDrawService = GeofenceDrawService;
	    this.GeoLocation = GeoLocation;
	    this.MapHelper = MapHelper;
	    this.mapLoaded = false;
	    this.geofences = [];
	    this.getGeoLocation();

	    this.$scope.$on('geofences.list', this.listGeofences.bind(this));
	    this.$scope.$on('geofences.create', this.createGeofence.bind(this));

	    this.mapStyle = {
	      layer: 'streets',
	      version: 'v12'
	    };

	    this.options = {
	      new: 'child-screen'
	    };
	  }

	  _createClass(GeofencesMapController, [{
	    key: 'getGeoLocation',
	    value: function getGeoLocation() {
	      var _this = this;

	      this.coords = null;

	      var getGeoLocation = this.GeoLocation.getCoords();
	      getGeoLocation.then(function (res) {
	        _this.coords = { center: [res.lng, res.lat] };
	      }).finally(function () {
	        _this.buildMap();
	      });
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap() {
	      var _this2 = this;

	      var mapOptions = Object.assign({}, _constants.behaveMapConfig, {
	        minZoom: 3
	      }, this.coords);

	      this.MapHelper.mapBuilder(this.mapStyle, mapOptions, { navigation: true });

	      this.MapHelper.map.once('load', function () {
	        _this2.MapHelper.map.resize();
	        _this2.GeofenceService.build({ data: (0, _geofence.formatGeofences)(_this2.geofences) });
	        _this2.GeofenceDrawService.build();
	        _this2.GeofenceDrawService.onUpdateGeofence(function (geofence) {
	          _this2.$scope.$broadcast('geofence-polygon', geofence);
	        });
	        if (_this2.mode === 'create') {
	          _this2.GeofenceDrawService.show();
	        }
	        _this2.mapLoaded = true;
	      });
	      /* eslint-disable */
	      this.MapHelper.map.addControl(new MapboxGeocoder({
	        accessToken: mapboxgl.accessToken,
	        mapboxgl: mapboxgl,
	        placeholder: '' + this.$translate.instant('GEOFENCES.PLACEHOLDER.SEARCH')
	      }), 'top-left');
	      /* eslint-enable */
	    }
	  }, {
	    key: 'listGeofences',
	    value: function listGeofences(_ev, geofences) {
	      this.geofences = geofences;
	      if (this.mapLoaded) {
	        this.GeofenceService.setData((0, _geofence.formatGeofences)(this.geofences));
	        if (this.mode === 'create') {
	          this.GeofenceDrawService.hide();
	          this.GeofenceService.show();
	        }
	      }
	      this.mode = 'list';
	    }
	  }, {
	    key: 'createGeofence',
	    value: function createGeofence(_ev, geofence) {
	      if (geofence) {
	        geofence = (0, _geofence.formatGeofence)(geofence, {
	          valid: true
	        });
	      }
	      this.GeofenceDrawService.setGeofence(geofence);
	      if (this.mapLoaded) {
	        this.GeofenceDrawService.show();
	        this.GeofenceService.hide();
	      }
	      this.mode = 'create';
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this3 = this;

	      var confirm = this.$mdDialog.confirm().title(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.TITLE')).textContent(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.TEXT')).ok(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.OK')).cancel(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.NOK'));

	      this.$mdDialog.show(confirm).then(function () {
	        _this3.GenericService.delete(_constants.API.V3, _constants.API.GEOFENCES, { id: _this3.$state.params.id }).promise.then(function () {
	          _this3.$state.go('geofences.list');
	        }).catch(function () {});
	      });
	    }
	  }]);

	  return GeofencesMapController;
	}();

	exports.default = GeofencesMapController;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatGeofence = formatGeofence;
	exports.formatGeofences = formatGeofences;

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function formatGeofence(geo) {
	  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  if (geo.geometry.type === 'Point') {
	    return turf.circle(geo.geometry, geo.radius, {
	      steps: 50,
	      units: 'meters',
	      properties: Object.assign({
	        radius: geo.radius,
	        color: geo.color,
	        name: geo.name
	      }, properties)
	    });
	  } else {
	    return turf.feature(geo.geometry, Object.assign({
	      color: geo.color,
	      name: geo.name
	    }, properties));
	  }
	}

	function formatGeofences() {
	  var geofences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	  return turf.featureCollection(geofences.map(formatGeofence));
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _helper = __webpack_require__(21);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GeofencesCreateController = function () {
	  GeofencesCreateController.$inject = ["$scope", "$state", "$timeout", "$window", "EnvironmentConfig", "GenericService", "GeofenceDrawService", "MainService", "ToastService"];
	  function GeofencesCreateController($scope, $state, $timeout, $window, EnvironmentConfig, GenericService, GeofenceDrawService, MainService, ToastService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, GeofencesCreateController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GenericService = GenericService;
	    this.GeofenceDrawService = GeofenceDrawService;
	    this.MainService = MainService;
	    this.ToastService = ToastService;
	    this.processing = false;
	    this.colors = ['#F24B3F', '#F98A29', '#F6C52E', '#4ED41F', '#20B02A', '#57CCF2', '#216DD9', '#8E3FD4', '#BE22CA'];
	    this.geofence = {
	      triggers: {
	        in: true,
	        out: true
	      },
	      color: this.colors[0]
	    };

	    this.geofenceType = 'circle';

	    this.$scope.$on('geofence-polygon', function (ev, geoFeature) {
	      // Forces angular digest
	      _this.$timeout(function () {
	        _this.geoFeature = geoFeature;
	      }, 10);
	    });
	    this.isEdit();
	  }

	  _createClass(GeofencesCreateController, [{
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this2 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.GenericService.show(_constants.API.V3, _constants.API.GEOFENCES, this.$state.params.id).promise.then(function (res) {
	          _this2.geofence = res;
	          _this2.selectedEnterprise = internals._initialEnterprise(res);
	          _this2.$scope.$emit('geofences.create', _this2.geofence);
	          _this2.geoFeature = turf.feature(_this2.geofence.geometry, {
	            color: _this2.geofence.color,
	            name: _this2.geofence.name,
	            radius: _this2.geofence.radius
	          });
	        });
	      } else {
	        this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	        this.$scope.$emit('geofences.create');
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      if (this.geoFeature) {
	        this.processing = true;
	        var data = {
	          eid: (0, _helper.decodify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	        };
	        if (this.geoFeature.geometry.type === 'Point') {
	          data.radius = Math.round(this.geoFeature.properties.radius);
	        }
	        data = Object.assign(data, _.pick(this.geofence, ['name', 'triggers', 'color', 'description']), {
	          geometry: this.geoFeature.geometry
	        });

	        if (this.geofence._id) {
	          this.GenericService.update(_constants.API.V3, _constants.API.GEOFENCES, this.geofence._id, data).promise.then(function () {
	            _this3.$state.go('geofences.list');
	          }).finally(function () {
	            _this3.processing = false;
	          });
	        } else {
	          this.GenericService.create(_constants.API.V3, _constants.API.GEOFENCES, data).promise.then(function () {
	            _this3.$state.go('geofences.list');
	          }).finally(function () {
	            _this3.processing = false;
	          });
	        }
	      } else {
	        this.ToastService.error('TOAST.ERROR.GEOFENCE_NEEDS_TO_BE_DRAWN');
	      }
	    }
	  }, {
	    key: 'updateColor',
	    value: function updateColor(color) {
	      this.geofence.color = color;
	    }
	  }, {
	    key: 'updateGeofenceType',
	    value: function updateGeofenceType() {
	      this.GeofenceDrawService.selectEditorType(this.geofenceType);
	    }
	  }]);

	  return GeofencesCreateController;
	}();

	exports.default = GeofencesCreateController;


	var internals = {
	  _initialEnterprise: function _initialEnterprise(res) {
	    return {
	      id: res.enterprise.id,
	      attributes: res.enterprise
	    };
	  }
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _geofence = __webpack_require__(80);

	var _geofence2 = _interopRequireDefault(_geofence);

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultSrcOptions = {
	  name: 'src-geofences',
	  data: null,
	  singleNavigation: false,
	  layersToHide: []
	};

	var GeofenceService = function () {
	  GeofenceService.$inject = ["$http", "MapHelper"];
	  function GeofenceService($http, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, GeofenceService);

	    this.$http = $http;
	    this.MapHelper = MapHelper;
	  }

	  _createClass(GeofenceService, [{
	    key: 'build',
	    value: function build() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSrcOptions;

	      var srcOptions = Object.assign({}, defaultSrcOptions, options);
	      this.srcName = srcOptions.name;

	      this.MapHelper.addSources([srcOptions.name], [this.MapHelper.sourceBuilder(srcOptions.data)]);
	      var layers = [this.MapHelper.layerBuilder('geofence', 'fill', {
	        source: srcOptions.name,
	        layout: _geofence2.default.area.layout,
	        paint: _geofence2.default.area.paint,
	        minzoom: 0
	      }), this.MapHelper.layerBuilder('geofence-border', 'line', {
	        source: srcOptions.name,
	        layout: _geofence2.default.border.layout,
	        paint: _geofence2.default.border.paint,
	        minzoom: 0
	      }), this.MapHelper.layerBuilder('geofence-label', 'symbol', {
	        source: srcOptions.name,
	        layout: _geofence2.default.label.layout,
	        paint: _geofence2.default.label.paint,
	        minzoom: 0
	      })];
	      this.MapHelper.addLayers(layers);
	      if (srcOptions.data.features.length > 0) {
	        this.MapHelper.map.fitBounds(turf.bbox(srcOptions.data), { padding: 150 });
	      }

	      this.MapHelper.map.on('click', 'geofence', function (e) {
	        _this.MapHelper.map.fire('geofence.select', e);
	      });
	    }
	  }, {
	    key: 'setData',
	    value: function setData(data) {
	      this.MapHelper.setDataToSource(this.srcName, data);
	      if (data.features.length > 0) {
	        this.MapHelper.map.fitBounds(turf.bbox(data), { padding: 150 });
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.MapHelper.map.setLayoutProperty('geofence', 'visibility', 'none');
	      this.MapHelper.map.setLayoutProperty('geofence-border', 'visibility', 'none');
	      this.MapHelper.map.setLayoutProperty('geofence-label', 'visibility', 'none');
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.MapHelper.map.setLayoutProperty('geofence', 'visibility', 'visible');
	      this.MapHelper.map.setLayoutProperty('geofence-border', 'visibility', 'visible');
	      this.MapHelper.map.setLayoutProperty('geofence-label', 'visibility', 'visible');
	    }
	  }, {
	    key: 'hideLayers',
	    value: function hideLayers(layers) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var layer = _step.value;

	          this.MapHelper.map.setLayoutProperty(layer, 'visibility', 'none');
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'showLayers',
	    value: function showLayers(layers) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;

	      try {
	        for (var _iterator2 = layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var layer = _step2.value;

	          this.MapHelper.map.setLayoutProperty(layer, 'visibility', 'visible');
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }]);

	  return GeofenceService;
	}();

	exports.default = GeofenceService;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  area: {
	    layout: {},
	    paint: {
	      'fill-color': ['get', 'color'], // #ed6498 #D15159 #d13737 ef3b5e
	      'fill-opacity': 0.3
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  },
	  border: {
	    layout: {},
	    paint: {
	      'line-opacity': 0.6,
	      'line-color': ['get', 'color'],
	      'line-width': {
	        'stops': [[11, 1], [12, 2]]
	      }
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  },
	  label: {
	    layout: {
	      'icon-allow-overlap': false,
	      'text-field': '{name}',
	      'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Regular'],
	      'text-size': ['interpolate', ['linear'], ['zoom'], 11, 11, 13, 13],
	      'text-transform': 'none',
	      'text-justify': 'center',
	      'text-letter-spacing': 0.05
	    },
	    paint: {
	      'text-color': '#fff',
	      'text-halo-color': '#212121',
	      'text-halo-width': 1,
	      'text-opacity': 1
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _geofenceDraw = __webpack_require__(82);

	var _geofenceDraw2 = _interopRequireDefault(_geofenceDraw);

	var _radiusMode = __webpack_require__(83);

	var _radiusMode2 = _interopRequireDefault(_radiusMode);

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultSrcOptions = {
	  name: 'src-geofences',
	  data: null,
	  singleNavigation: false,
	  layersToHide: []
	};

	var GeofenceDrawService = function () {
	  GeofenceDrawService.$inject = ["$http", "MapHelper"];
	  function GeofenceDrawService($http, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, GeofenceDrawService);

	    this.$http = $http;
	    this.MapHelper = MapHelper;

	    this.editorType = 'circle';
	    this.onUpdateGeofenceList = [];
	  }

	  _createClass(GeofenceDrawService, [{
	    key: 'build',
	    value: function build() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSrcOptions;

	      var srcOptions = Object.assign({}, defaultSrcOptions, options);
	      this.srcName = srcOptions.name;

	      this.draw = new MapboxDraw({
	        displayControlsDefault: false,
	        modes: Object.assign({
	          draw_radius: _radiusMode2.default
	        }, MapboxDraw.modes),
	        controls: {
	          trash: true,
	          draw_circle: _radiusMode2.default
	        },
	        userProperties: true,
	        styles: _geofenceDraw2.default
	      });

	      this.MapHelper.map.on('draw.create', this.addGeofenceDraw.bind(this));
	      this.MapHelper.map.on('draw.update', this.addGeofenceDraw.bind(this));
	      this.MapHelper.map.on('draw.delete', function () {
	        if (_this.draw.getAll().features.length === 0) {
	          _this.polygonFeature = null;
	        }
	        _this.startEditor();
	      });
	      this.onUpdateGeofenceList = [];
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.MapHelper.map.addControl(this.draw);
	      if (this.geofence) {
	        var featureId = this.draw.add(this.geofence)[0];
	        this.draw.setFeatureProperty(featureId, 'valid', this.valid);
	        this.fitToGeofenceDraw();
	      } else {
	        this.editorType = 'circle';
	        this.startEditor();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.MapHelper.map.removeControl(this.draw);
	    }
	  }, {
	    key: 'onUpdateGeofence',
	    value: function onUpdateGeofence(cb) {
	      this.onUpdateGeofenceList.push(cb);
	    }
	  }, {
	    key: 'fireOnUpdateGeofence',
	    value: function fireOnUpdateGeofence(geofence) {
	      this.onUpdateGeofenceList.forEach(function (cb) {
	        return cb(geofence);
	      });
	    }
	  }, {
	    key: 'clearEditor',
	    value: function clearEditor() {
	      this.draw.deleteAll();
	      this.valid = false;
	      this.polygonFeature = null;
	      this.broadcastUpdatedPolygon();
	    }
	  }, {
	    key: 'startEditor',
	    value: function startEditor() {
	      this.clearEditor();
	      if (this.editorType === 'circle') {
	        this.draw.changeMode('draw_radius');
	      } else {
	        this.draw.changeMode('draw_polygon');
	      }
	    }
	  }, {
	    key: 'selectEditorType',
	    value: function selectEditorType(type) {
	      this.editorType = type;
	      this.startEditor();
	    }
	  }, {
	    key: 'setGeofence',
	    value: function setGeofence(geofence) {
	      if (geofence) {
	        this.valid = true;
	      }
	      this.geofence = geofence;
	    }
	  }, {
	    key: 'geofenceDraw',
	    value: function geofenceDraw() {
	      if (this.geofence) {
	        var featureId = this.draw.add(this.geofence)[0];
	        this.draw.setFeatureProperty(featureId, 'valid', this.valid);
	        this.fitToGeofenceDraw();
	      } else {
	        this.editorType = 'circle';
	        this.startEditor();
	      }
	    }
	  }, {
	    key: 'fitToGeofenceDraw',
	    value: function fitToGeofenceDraw() {
	      var features = this.draw.getAll().features;
	      if (features.length > 0 && features[0].geometry.coordinates.length > 0) {
	        this.MapHelper.map.fitBounds(turf.bbox(this.draw.getAll().features[0]), {
	          padding: 150
	        });
	      }
	    }
	  }, {
	    key: 'addGeofenceDraw',
	    value: function addGeofenceDraw(e) {
	      this.polygonFeature = e.features[0];
	      if (this.polygonFeature.geometry.type === 'Polygon') {
	        if (turf.kinks(this.polygonFeature).features.length > 0) {
	          this.valid = false;
	        } else {
	          this.valid = true;
	        }
	        this.draw.setFeatureProperty(this.polygonFeature.id, 'valid', this.valid);
	      } else {
	        this.valid = true;
	      }
	      this.broadcastUpdatedPolygon();
	    }
	  }, {
	    key: 'broadcastUpdatedPolygon',
	    value: function broadcastUpdatedPolygon() {
	      if (this.valid) {
	        if (this.polygonFeature.properties.radius && this.polygonFeature.geometry.type === 'Polygon') {
	          var point = turf.centroid(this.polygonFeature, this.polygonFeature.properties);
	          this.fireOnUpdateGeofence(point);
	        } else {
	          this.fireOnUpdateGeofence(this.polygonFeature);
	        }
	      } else {
	        this.fireOnUpdateGeofence(null);
	      }
	    }
	  }]);

	  return GeofenceDrawService;
	}();

	exports.default = GeofenceDrawService;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  id: 'gl-draw-polygon-fill-inactive',
	  type: 'fill',
	  filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
	  paint: {
	    'fill-color': ['case', ['boolean', ['get', 'user_valid'], false], '#5e56f7', '#e83e33'],
	    'fill-outline-color': ['case', ['boolean', ['get', 'user_valid'], false], '#3bb2d0', '#e83e33'],
	    'fill-opacity': 0.1
	  }
	}, {
	  id: 'gl-draw-polygon-fill-active',
	  type: 'fill',
	  filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
	  paint: {
	    'fill-color': '#fbb03b',
	    'fill-outline-color': '#fbb03b',
	    'fill-opacity': 0.1
	  }
	}, {
	  id: 'gl-draw-polygon-midpoint',
	  type: 'circle',
	  filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
	  paint: {
	    'circle-radius': 3,
	    'circle-color': '#fbb03b'
	  }
	}, {
	  id: 'gl-draw-polygon-stroke-inactive',
	  type: 'line',
	  filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': ['case', ['boolean', ['get', 'user_valid'], false], '#3bb2d0', '#e83e33'],
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-polygon-stroke-active',
	  type: 'line',
	  filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': '#fbb03b',
	    'line-dasharray': [0.2, 2],
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-line-inactive',
	  type: 'line',
	  filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': '#3bb2d0',
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-line-active',
	  type: 'line',
	  filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': '#fbb03b',
	    'line-dasharray': [0.2, 2],
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
	  type: 'circle',
	  filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
	  paint: {
	    'circle-radius': 5,
	    'circle-color': '#fff'
	  }
	}, {
	  id: 'gl-draw-polygon-and-line-vertex-inactive',
	  type: 'circle',
	  filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
	  paint: {
	    'circle-radius': 3,
	    'circle-color': '#fbb03b'
	  }
	}, {
	  id: 'gl-draw-point-point-stroke-inactive',
	  type: 'circle',
	  filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
	  paint: {
	    'circle-radius': 5,
	    'circle-opacity': 1,
	    'circle-color': '#fff'
	  }
	}, {
	  id: 'gl-draw-point-inactive',
	  type: 'circle',
	  filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
	  paint: {
	    'circle-radius': 3,
	    'circle-color': '#3bb2d0'
	  }
	}, {
	  id: 'gl-draw-point-stroke-active',
	  type: 'circle',
	  filter: ['all', ['==', '$type', 'Point'], ['==', 'active', 'true'], ['!=', 'meta', 'midpoint']],
	  paint: {
	    'circle-radius': 7,
	    'circle-color': '#fff'
	  }
	}, {
	  id: 'gl-draw-point-active',
	  type: 'circle',
	  filter: ['all', ['==', '$type', 'Point'], ['!=', 'meta', 'midpoint'], ['==', 'active', 'true']],
	  paint: {
	    'circle-radius': 5,
	    'circle-color': '#fbb03b'
	  }
	}, {
	  id: 'gl-draw-polygon-fill-static',
	  type: 'fill',
	  filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
	  paint: {
	    'fill-color': '#404040',
	    'fill-outline-color': '#404040',
	    'fill-opacity': 0.1
	  }
	}, {
	  id: 'gl-draw-polygon-stroke-static',
	  type: 'line',
	  filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': '#404040',
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-line-static',
	  type: 'line',
	  filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
	  layout: {
	    'line-cap': 'round',
	    'line-join': 'round'
	  },
	  paint: {
	    'line-color': '#404040',
	    'line-width': 2
	  }
	}, {
	  id: 'gl-draw-point-static',
	  type: 'circle',
	  filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
	  paint: {
	    'circle-radius': 5,
	    'circle-color': '#404040'
	  }
	}];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	var RadiusMode = MapboxDraw.modes.draw_line_string; // custom mapbopx-gl-draw mode that modifies draw_line_string
	// shows a center point, radius line, and circle polygon while drawing
	// forces draw.create on creation of second vertex
	// import numeral from 'numeral'


	function createVertex(parentId, coordinates, path, selected) {
	  return {
	    type: 'Feature',
	    properties: {
	      meta: 'vertex',
	      parent: parentId,
	      coord_path: path,
	      active: selected ? 'true' : 'false'
	    },
	    geometry: {
	      type: 'Point',
	      coordinates: coordinates
	    }
	  };
	}

	function getDisplayMeasurements(lineFeature) {
	  // create metric and standard display strings for the line
	  var drawnLength = turf.lineDistance(lineFeature) * 1000; // meters
	  var feetMeasurement = drawnLength * 3.28084;
	  var milesMeasurement = drawnLength * 3.28084 / 5280;

	  return {
	    feet: feetMeasurement + ' ft',
	    miles: milesMeasurement + ' mi'
	  };
	}

	var doubleClickZoom = {
	  enable: function enable(ctx) {
	    setTimeout(function () {
	      // eslint-disable-line
	      // First check we've got a map and some context.
	      if (!ctx.map || !ctx.map.doubleClickZoom || !ctx._ctx || !ctx._ctx.store || !ctx._ctx.store.getInitialConfigValue) return;
	      // Now check initial state wasn't false (we leave it disabled if so)
	      if (!ctx._ctx.store.getInitialConfigValue('doubleClickZoom')) return;
	      ctx.map.doubleClickZoom.enable();
	    }, 0);
	  }
	};

	RadiusMode.clickAnywhere = function (state, e) {
	  // this ends the drawing after the user creates a second point, triggering this.onStop
	  if (state.currentVertexPosition === 1) {
	    state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
	    return this.changeMode('simple_select', {
	      featureIds: [state.line.id]
	    });
	  }
	  this.updateUIClasses({
	    mouse: 'add'
	  });
	  state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	  if (state.direction === 'forward') {
	    state.currentVertexPosition += 1; // eslint-disable-line
	    state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	  } else {
	    state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
	  }

	  return null;
	};

	// creates the final geojson point feature with a radius property
	// triggers draw.create
	RadiusMode.onStop = function (state) {
	  doubleClickZoom.enable(this);

	  this.activateUIButton();

	  // check to see if we've deleted this feature
	  if (angular.isUndefined(this.getFeature(state.line.id))) return;

	  // remove last added coordinate
	  state.line.removeCoordinate('0');
	  if (state.line.isValid()) {
	    var lineGeoJson = state.line.toGeoJSON();
	    // reconfigure the geojson line into a geojson point with a radius property
	    var pointWithRadius = {
	      type: 'Feature',
	      geometry: {
	        type: 'Point',
	        coordinates: lineGeoJson.geometry.coordinates[0]
	      },
	      properties: {
	        radius: (turf.lineDistance(lineGeoJson) * 1000).toFixed(1)
	      }
	    };

	    var polygonCircle = turf.circle(pointWithRadius, pointWithRadius.properties.radius, {
	      steps: 50,
	      units: 'meters',
	      properties: {
	        active: 'true',
	        valid: true,
	        radius: pointWithRadius.properties.radius
	      }
	    });

	    polygonCircle.properties.active = 'true';
	    var polygon = this.newFeature(polygonCircle);

	    this.addFeature(polygon);
	    this.deleteFeature([state.line.id], {
	      silent: true
	    });
	    this.map.fire('draw.create', {
	      features: [pointWithRadius]
	    });
	  } else {
	    this.deleteFeature([state.line.id], {
	      silent: true
	    });
	    this.changeMode('simple_select', {}, {
	      silent: true
	    });
	  }
	};

	RadiusMode.toDisplayFeatures = function (state, geojson, display) {
	  // const isActiveLine = geojson.properties.id === state.line.id
	  geojson.properties.active = 'true';
	  // if (!isActiveLine) return display(geojson)

	  // Only render the line if it has at least one real coordinate
	  if (geojson.geometry.coordinates.length < 2) return null;
	  geojson.properties.meta = 'feature';

	  // displays center vertex as a point feature
	  display(createVertex(state.line.id, geojson.geometry.coordinates[state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1], '' + (state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1), false));

	  // displays the line as it is drawn
	  display(geojson);

	  var displayMeasurements = getDisplayMeasurements(geojson);

	  // create custom feature for the current pointer position
	  var currentVertex = {
	    type: 'Feature',
	    properties: {
	      meta: 'currentPosition',
	      radiusFeet: displayMeasurements.feet,
	      radiusMiles: displayMeasurements.miles,
	      parent: state.line.id,
	      active: 'true'
	    },
	    geometry: {
	      type: 'Point',
	      coordinates: geojson.geometry.coordinates[1]
	    }
	  };
	  display(currentVertex);

	  // create custom feature for radius circlemarker
	  var center = geojson.geometry.coordinates[0];
	  var radiusInKm = turf.lineDistance(geojson, {});
	  if (radiusInKm > 0) {
	    var circleFeature = turf.circle(center, radiusInKm, {
	      properties: {
	        meta: 'radius',
	        active: 'true'
	      }
	    });
	    circleFeature.properties.meta = 'radius';
	    circleFeature.properties.active = 'true';
	    display(circleFeature);
	  }

	  return null;
	};

	exports.default = RadiusMode;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _usersList = __webpack_require__(85);

	var _usersList2 = _interopRequireDefault(_usersList);

	var _usersEdit = __webpack_require__(86);

	var _usersEdit2 = _interopRequireDefault(_usersEdit);

	var _addresses = __webpack_require__(87);

	var _addresses2 = _interopRequireDefault(_addresses);

	var _subscriptions = __webpack_require__(88);

	var _subscriptions2 = _interopRequireDefault(_subscriptions);

	var _acknowledgements = __webpack_require__(89);

	var _acknowledgements2 = _interopRequireDefault(_acknowledgements);

	var _sessions = __webpack_require__(90);

	var _sessions2 = _interopRequireDefault(_sessions);

	var _security = __webpack_require__(91);

	var _security2 = _interopRequireDefault(_security);

	var _timeRestrictions = __webpack_require__(92);

	var _timeRestrictions2 = _interopRequireDefault(_timeRestrictions);

	var _restrictInput = __webpack_require__(93);

	var _restrictInput2 = _interopRequireDefault(_restrictInput);

	var _changePassword = __webpack_require__(94);

	var _changePassword2 = _interopRequireDefault(_changePassword);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.management.users', ['ui.router', 'rzModule']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'users-list',
	    url: '/users/list?search&filters',
	    parent: 'management',
	    menu: true,
	    alias: 'users',
	    controller: _usersList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/list/users.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'users-edit',
	    url: '/users/edit/:id',
	    parent: 'management',
	    controller: _usersEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/edit/users.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            roles: ['name'],
	            document: ['file_size', 'created_at', 'folder', 'key_name', 'mime', 'name'],
	            enterprise: ['name', 'cnpj', 'email']
	          }
	        };
	        return MainService.raw(_constants.API.V5, _constants.API.USERS + '/' + $stateParams.id, obj);
	      }]
	    },
	    redirectTo: 'users-edit.addresses'
	  }).state({
	    name: 'users-edit.addresses',
	    url: '/addresses',
	    controller: _addresses2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/tabs/addresses/_addresses.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  }).state({
	    name: 'users-edit.subscriptions',
	    url: '/subscriptions',
	    controller: _subscriptions2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/tabs/subscriptions/_subscriptions.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  }).state({
	    name: 'users-edit.acknowledgements',
	    url: '/acknowledgements',
	    controller: _acknowledgements2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/tabs/acknowledgements/_acknowledgements.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  }).state({
	    name: 'users-edit.sessions',
	    url: '/sessions',
	    controller: _sessions2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/tabs/sessions/_sessions.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  }).state({
	    name: 'users-edit.security',
	    url: '/security',
	    controller: _security2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/users/tabs/security/_security.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  });
	  // .state({
	  //   name: 'users-edit.time-restrictions',
	  //   url: '/time-restrictions',
	  //   controller: UsersTimeRestrictionsController,
	  //   controllerAs: 'ctrl',
	  //   templateUrl: 'app/internal/management/users/tabs/time-restrictions/_time-restrictions.html',
	  //   data: {
	  //     requiresLogin: true,
	  //     canAccess: [...ROLES.INTERNALS, ...ROLES.MANAGER, ...ROLES.READ_ONLY]
	  //   }
	  // })
	}]).controller('UsersListController', _usersList2.default).controller('UsersEditController', _usersEdit2.default).controller('UsersAddressesController', _addresses2.default).controller('UsersSubscriptionsController', _subscriptions2.default).controller('UsersAcknowledgementsController', _acknowledgements2.default).controller('UsersSessionsController', _sessions2.default).controller('UsersSecurityController', _security2.default).controller('UsersTimeRestrictionsController', _timeRestrictions2.default).directive('restrictInput', _restrictInput2.default.directiveFactory).controller('ChangePasswordController', _changePassword2.default);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var UsersListController = function (_ListController) {
	  UsersListController.$inject = ["$state", "$scope", "$translate", "DialogService", "MainService"];
	  _inherits(UsersListController, _ListController);

	  function UsersListController($state, $scope, $translate, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, UsersListController);

	    var _this = _possibleConstructorReturn(this, (UsersListController.__proto__ || Object.getPrototypeOf(UsersListController)).call(this, $scope, $state, $translate, MainService));

	    _this.DialogService = DialogService;

	    _this.query = {
	      attributes: ['*'],
	      includes: {
	        enterprise: ['name', 'cnpj', 'fantasy_name', 'email'],
	        roles: ['*']
	      },
	      filters: {},
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      export: true,
	      stats: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.USERS, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(UsersListController, [{
	    key: 'checkStatus',
	    value: function checkStatus(user) {
	      if (user.attributes.active) {
	        return;
	      }
	      user.attributes.active = !user.attributes.deactivated_at;
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(user) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = user.attributes.active ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'users',
	          id: user.id
	        }]
	      };

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'USER_ACTIVATION', action: 'save' }).then(function () {
	        _this2.MainService.edit(_constants.API.V5, _constants.API.USERS + '/set-activation/' + action, obj).promise.then(function () {
	          user.attributes.deactivated_at = user.attributes.deactivated_at ? null : new Date();
	          user.attributes.ative = !user.attributes.ative;
	        });
	      }).catch(function () {
	        _this2.checkStatus(user);
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(user) {
	      var opts = {
	        url: 'app/components/change-password/change-password.dialog.html',
	        controllerName: 'ChangePasswordController',
	        controllerAlias: 'ctrl',
	        escapeToClose: true,
	        hasBackdrop: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(opts, user);
	    }
	  }, {
	    key: 'resendEmail',
	    value: function resendEmail(user) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'SEND_EMAIL', label: 'SEND_USER_EMAIL', action: 'send' }).then(function () {
	        var obj = {
	          data: {
	            attributes: {
	              username: user.attributes.username
	            }
	          }
	        };
	        _this3.MainService.create(_constants.API.V5, _constants.API.USERS + '/forgot-password', obj);
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this4 = this;

	      var keys = ['PANEL.HEADER.NAME_USERNAME', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.EMAIL_PHONE', 'PANEL.HEADER.DOC_REGISTRY', 'PANEL.HEADER.ROLE_LOCALE', 'PANEL.HEADER.EMERGENCY_CONTACT'];

	      this.$translate(keys).then(function (t) {
	        _this4.headers = [{
	          label: t['PANEL.HEADER.NAME_USERNAME'],
	          sort: true,
	          prop: 'name'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.EMAIL_PHONE'],
	          sort: true,
	          prop: 'email'
	        }, {
	          label: t['PANEL.HEADER.DOC_REGISTRY'],
	          sort: true,
	          prop: 'cpf'
	        }, {
	          label: t['PANEL.HEADER.EMERGENCY_CONTACT'],
	          sort: true,
	          prop: 'emergency_contact'
	        }];
	      });
	    }
	  }]);

	  return UsersListController;
	}(_list2.default);

	exports.default = UsersListController;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersEditController = function () {
	  UsersEditController.$inject = ["$scope", "$state", "$window", "DialogService", "MainService", "StateManagement", "selectedItem"];
	  function UsersEditController($scope, $state, $window, DialogService, MainService, StateManagement, selectedItem) {
	    'ngInject';

	    _classCallCheck(this, UsersEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;
	    this.selectedItem = selectedItem;
	    this.roleUser = this.$window.localStorage.getItem('role');
	    this.roleReadOnly = true;
	    this.loggedInUser = angular.fromJson($window.localStorage.getItem('user'));
	    this.showTabSecurity = this.$state.params.id === this.loggedInUser.id;

	    this.roles = [];
	    this.languages = _constants.LANGUAGES;

	    this.loadData();
	    this.currentRole();
	  }

	  _createClass(UsersEditController, [{
	    key: 'currentRole',
	    value: function currentRole() {
	      if (this.roles !== 'ACCOUNT' && _constants.ROLES.MANAGER.includes(this.roleUser)) {
	        this.getRoles();
	        this.roleReadOnly = false;
	      }
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      var _this = this;

	      var obj = {
	        attributes: ['name']
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.USERS + '/roles', obj).promise.then(function (res) {
	        _this.roles = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.user).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _constants.API.USERS, _this2.user.id).promise.then(function () {
	          _this2.$state.go('users-list');
	        });
	      });
	    }
	  }, {
	    key: 'checkUserName',
	    value: function checkUserName() {
	      var _this3 = this;

	      this.processing = true;

	      var validation = function validation(value) {
	        _this3.form.username.$setValidity('usernameTaken', value);
	      };

	      if (this.user.attributes.username && this.user.attributes.username !== this.usernameCurrent && this.lastUsernameCheck !== this.user.attributes.username && !this.checking) {
	        this.checking = true;
	        var username = {
	          data: {
	            usernames: [this.user.attributes.username]
	          }
	        };

	        this.MainService.create(_constants.API.V5, _constants.API.USERS + '/check-usernames', username).promise.then(function (res) {
	          _this3.lastUsernameCheck = res.data[0].username;
	          _this3.lastTakenCheck = !res.data[0].isTaken;
	          validation(_this3.lastTakenCheck);
	        }).finally(function () {
	          _this3.checking = false;
	          _this3.processing = false;
	        });
	      } else if (this.user.attributes.username === this.usernameCurrent || !this.user.attributes.username) {
	        validation(true);
	        this.processing = false;
	      } else if (this.lastUsernameCheck === this.user.attributes.username) {
	        validation(this.lastTakenCheck);
	        this.processing = false;
	      }
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this4 = this;

	      this.loading = true;
	      this.selectedItem.promise.then(function (res) {
	        _this4.loading = false;
	        _this4.user = res.data;
	        _this4.usernameCurrent = angular.copy(_this4.user.attributes.username);
	        _this4.StateManagement.setData(['user'], [_this4.user]);
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this5 = this;

	      if (this.processing) return;
	      this.processing = true;
	      var user = {
	        data: {
	          attributes: {
	            name: this.user.attributes.name,
	            username: this.user.attributes.username,
	            email: this.user.attributes.email,
	            cpf: this.user.attributes.cpf,
	            phone1: this.user.attributes.phone1,
	            locale: this.user.attributes.locale,
	            document_number: this.user.attributes.document_number,
	            birthdate: this.user.attributes.birthdate,
	            phone2: this.user.attributes.phone2,
	            emergency_contact: this.user.attributes.emergency_contact,
	            emergency_phone: this.user.attributes.emergency_phone
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: this.user.relationships.enterprise.id
	            },
	            roles: {
	              type: 'roles',
	              id: this.user.relationships.roles[0].id
	            }
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(user.data);
	      this.MainService.update(_constants.API.V5, _constants.API.USERS, this.$state.params.id, user).promise.then(function () {
	        _this5.processing = false;
	      }).catch(function () {
	        _this5.processing = false;
	      });
	    }
	  }]);

	  return UsersEditController;
	}();

	exports.default = UsersEditController;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersAddressesController = function () {
	  UsersAddressesController.$inject = ["$state", "DialogService", "MainService"];
	  function UsersAddressesController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, UsersAddressesController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.path = [_constants.API.USERS, this.$state.params.id, _constants.API.ADDRESSES].join('/');
	    this.opt = _dialog.DIALOG._opts('app/components/address-form/address-form.html', 'AddressFormController');

	    this.loadAddresses = this.loadAddresses.bind(this);
	    this.loadAddresses(1);
	  }

	  _createClass(UsersAddressesController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.opt, { attributes: { model: 'users' } }).then(function (address) {
	        _this.MainService.create(_constants.API.V5, _this.path, address).promise.then(function (res) {
	          address = Object.assign(address, res.data);
	          _this.items.push(address);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data, index) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'ADDRESSES', label: 'ADDRESSES', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _this2.path, data.id).promise.then(function () {
	          _this2.items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      this.DialogService.openDialog(this.opt, item).then(function (address) {
	        _this3.MainService.update(_constants.API.V5, _this3.path, item.id, address).promise.then(function (res) {
	          address = Object.assign(address, res.data);
	          _this3.items[index] = address;
	        });
	      });
	    }
	  }, {
	    key: 'loadAddresses',
	    value: function loadAddresses(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, this.path, obj).promise.then(function (res) {
	        _this4.loading = false;
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return UsersAddressesController;
	}();

	exports.default = UsersAddressesController;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersSubscriptionsController = function () {
	  UsersSubscriptionsController.$inject = ["$rootScope", "$scope", "$state", "MainService", "StateManagement"];
	  function UsersSubscriptionsController($rootScope, $scope, $state, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, UsersSubscriptionsController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    var loadData = function loadData() {
	      return _this.loadData();
	    };

	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('user')) {
	        loadData();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(UsersSubscriptionsController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      var _StateManagement$getD = this.StateManagement.getData(['user']),
	          user = _StateManagement$getD.user;

	      this.loading = true;
	      var path = [user.uuid, 'configuration', 'subscriptions'].join('/');

	      this.loading = false;
	      this.MainService.show(_constants.API.V4, _constants.API.USERS, path).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.items = res.data;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }]);

	  return UsersSubscriptionsController;
	}();

	exports.default = UsersSubscriptionsController;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersAcknowledgementsController = function () {
	  UsersAcknowledgementsController.$inject = ["$state", "MainService"];
	  function UsersAcknowledgementsController($state, MainService) {
	    'ngInject';

	    _classCallCheck(this, UsersAcknowledgementsController);

	    this.$state = $state;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.loadAcknowledgements = this.loadAcknowledgements.bind(this);
	    this.loadAcknowledgements(1);
	  }

	  _createClass(UsersAcknowledgementsController, [{
	    key: 'loadAcknowledgements',
	    value: function loadAcknowledgements(page) {
	      var _this = this;

	      this.items = [];
	      this.loading = true;

	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/acknowledgements/' + this.$state.params.id, obj).promise.then(function (res) {
	        _this.items = res.data;
	        _this.meta.count = res.count;
	        _this.meta.page = page;
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }]);

	  return UsersAcknowledgementsController;
	}();

	exports.default = UsersAcknowledgementsController;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersSessionsController = function () {
	  UsersSessionsController.$inject = ["$auth", "$state", "DialogService", "MainService", "SessionService"];
	  function UsersSessionsController($auth, $state, DialogService, MainService, SessionService) {
	    'ngInject';

	    _classCallCheck(this, UsersSessionsController);

	    this.$auth = $auth;
	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.SessionService = SessionService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.obj = {
	      attributes: ['*'],
	      sort: {
	        prop: 'created_at',
	        order: 'ASC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.path = [_constants.API.USERS, this.$state.params.id, 'sessions'].join('/');
	    this.payload = this.$auth.getPayload();

	    this.loadSessions = this.loadSessions.bind(this);
	    this.reorder = this.reorder.bind(this);
	    this.loadSessions(1);
	  }

	  _createClass(UsersSessionsController, [{
	    key: 'delete',
	    value: function _delete(data) {
	      var _this = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'SESSIONS', label: 'SESSIONS', action: 'delete' }).then(function () {
	        if (data.attributes.currentSession) {
	          _this.SessionService.logout();
	        } else {
	          _this.MainService.delete(_constants.API.V5, _this.path, data.id).promise.then(function () {
	            _this.loadSessions(1);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.obj.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.loadSessions(1);
	    }
	  }, {
	    key: 'loadSessions',
	    value: function loadSessions(page) {
	      var _this2 = this;

	      this.loading = true;
	      this.obj.page = page;

	      this.MainService.raw(_constants.API.V5, this.path, this.obj).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.items = res.data;
	        _this2.items.forEach(function (i) {
	          i.attributes.currentSession = i.id === _this2.payload.aid;
	          i.attributes.user_agent_name = internal._checkUserAgent(i.attributes.user_agent_name);
	          return i;
	        });
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }]);

	  return UsersSessionsController;
	}();

	exports.default = UsersSessionsController;


	var internal = {
	  _checkUserAgent: function _checkUserAgent(data) {
	    var objectRegex = /^\s*\{(?:[^{}]|"(?:\\.|[^"\\])*"|\[(?:[^[\]]|"(?:\\.|[^"\\])*")*\])*\}\s*$/;

	    if (objectRegex.test(data)) {
	      return internal._parseAgentData(angular.fromJson(data));
	    } else {
	      return internal._parseUserAgentData(data);
	    }
	  },
	  _parseAgentData: function _parseAgentData(data) {
	    return {
	      browser: {
	        name: data.browserName || '',
	        version: data.browserVersion || ''
	      },
	      operation_system: {
	        name: data.OSName || '',
	        version: data.OSVersion || ''
	      },
	      device: {
	        model: data.deviceModel || '',
	        type: data.deviceType || ''
	      },
	      user_agent: data.userAgent || ''
	    };
	  },
	  _parseUserAgentData: function _parseUserAgentData(data) {
	    var regex = /^(?:(\w+)_v([\w.]+)(?:_(\w+)_v([\w.]+))?|(\w+\/[\w.]+))$/;
	    var match = data.match(regex);

	    return {
	      browser: {
	        name: match[1] || '',
	        version: match[2] || ''
	      },
	      operation_system: {
	        name: match[3] || '',
	        version: match[4] || ''
	      }
	    };
	  }
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersSecurityController = function () {
	  UsersSecurityController.$inject = ["$window", "$state", "MainService"];
	  function UsersSecurityController($window, $state, MainService) {
	    'ngInject';

	    _classCallCheck(this, UsersSecurityController);

	    this.$window = $window;
	    this.$state = $state;
	    this.MainService = MainService;

	    this.loggedInUser = angular.fromJson($window.localStorage.getItem('user'));

	    if (this.$state.params.id !== this.loggedInUser.id) {
	      this.$state.go('users-edit.addresses');
	    }

	    this.security = internals._initialSecurity();
	  }

	  _createClass(UsersSecurityController, [{
	    key: 'checkEqualPassword',
	    value: function checkEqualPassword() {
	      this.form.confirm.$setValidity('dontMatch', this.security.attributes.new_password === this.confirmPassword);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.checkEqualPassword();
	      if (!this.form.$valid) return;

	      var obj = {
	        data: this.security
	      };

	      this.processing = true;
	      this.MainService.edit(_constants.API.V5, _constants.API.USERS + '/update-password', obj).promise.finally(function () {
	        _this.processing = false;
	        _this.security = internals._initialSecurity();
	        _this.confirmPassword = null;
	        _this.form.$setPristine();
	      });
	    }
	  }]);

	  return UsersSecurityController;
	}();

	exports.default = UsersSecurityController;


	var internals = {
	  _initialSecurity: function _initialSecurity() {
	    return {
	      attributes: {
	        old_password: null,
	        new_password: null
	      }
	    };
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersTimeRestrictionsController = function UsersTimeRestrictionsController($state, DialogService, MainService) {
	  'ngInject';

	  _classCallCheck(this, UsersTimeRestrictionsController);

	  this.$state = $state;
	  this.DialogService = DialogService;
	  this.MainService = MainService;
	};
	UsersTimeRestrictionsController.$inject = ["$state", "DialogService", "MainService"];

	exports.default = UsersTimeRestrictionsController;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var RestrictInput = function () {
	  function RestrictInput() {
	    _classCallCheck(this, RestrictInput);

	    this.restrict = 'A';
	    this.require = 'ngModel';
	  }

	  _createClass(RestrictInput, [{
	    key: 'link',
	    value: function link(scope, element, attrs, modelCtrl) {
	      modelCtrl.$parsers.push(function (inputValue) {
	        if (angular.isUndefined(inputValue)) {
	          return '';
	        }

	        var cleanInputValue = inputValue.replace(new RegExp(attrs.restrictInput, 'g'), '').replace(/ +/g, '');

	        if (attrs.restrictInputUppercase) {
	          cleanInputValue = cleanInputValue.toUpperCase();
	        }
	        if (cleanInputValue !== inputValue) {
	          modelCtrl.$setViewValue(cleanInputValue);
	          modelCtrl.$render();
	        }
	        return cleanInputValue;
	      });
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new RestrictInput();
	    }
	  }]);

	  return RestrictInput;
	}();

	exports.default = RestrictInput;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChangePasswordController = function () {
	  ChangePasswordController.$inject = ["DialogService", "MainService", "locals"];
	  function ChangePasswordController(DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, ChangePasswordController);

	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.user = angular.copy(locals.item);

	    this.type = 'automatically';
	    this.showForm = true;
	    this.oneTimePassword = false;
	  }

	  _createClass(ChangePasswordController, [{
	    key: 'finish',
	    value: function finish() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      var automatically = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.processing = true;
	      this.newPassword = automatically ? (0, _helper.generatePassword)() : this.newPassword;

	      var obj = {
	        data: {
	          attributes: {
	            password: this.newPassword,
	            otp: this.oneTimePassword
	          }
	        }
	      };

	      this.MainService.edit(_constants.API.V5, _constants.API.USERS + '/' + this.user.id + '/reset-password', obj).promise.then(function () {
	        if (automatically) {
	          _this.showForm = false;
	        } else {
	          _this.finish();
	        }
	      }).finally(function () {
	        _this.processing = false;
	      });
	    }
	  }]);

	  return ChangePasswordController;
	}();

	exports.default = ChangePasswordController;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _vehiclesList = __webpack_require__(96);

	var _vehiclesList2 = _interopRequireDefault(_vehiclesList);

	var _vehiclesEdit = __webpack_require__(97);

	var _vehiclesEdit2 = _interopRequireDefault(_vehiclesEdit);

	var _vehiclesPanel = __webpack_require__(98);

	var _vehiclesPanel2 = _interopRequireDefault(_vehiclesPanel);

	var _newVehicle = __webpack_require__(104);

	var _newVehicle2 = _interopRequireDefault(_newVehicle);

	var _general = __webpack_require__(105);

	var _general2 = _interopRequireDefault(_general);

	var _users = __webpack_require__(106);

	var _users2 = _interopRequireDefault(_users);

	var _verifiedRecord = __webpack_require__(107);

	var _verifiedRecord2 = _interopRequireDefault(_verifiedRecord);

	var _behaviorConfig = __webpack_require__(108);

	var _behaviorConfig2 = _interopRequireDefault(_behaviorConfig);

	var _associationConfig = __webpack_require__(109);

	var _associationConfig2 = _interopRequireDefault(_associationConfig);

	var _vehicles = __webpack_require__(110);

	var _vehicles2 = _interopRequireDefault(_vehicles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.management.vehicles', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'vehicles-list',
	    url: '/vehicles/list?search&filters',
	    parent: 'management',
	    menu: true,
	    alias: 'vehicles',
	    controller: _vehiclesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/vehicles/list/vehicles.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  }).state({
	    name: 'vehicles-panel',
	    url: '/vehicles/panel',
	    parent: 'management',
	    controller: _vehiclesPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/vehicles/panel/vehicles.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'vehicles-edit',
	    url: '/vehicles/edit/:id',
	    parent: 'management',
	    controller: _vehiclesEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/vehicles/edit/vehicles.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            type: ['*'],
	            document: ['file_size', 'created_at', 'folder', 'key_name', 'mime', 'name'],
	            enterprise: ['name', 'cnpj', 'email']
	          }
	        };
	        return MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + $stateParams.id, obj);
	      }]
	    },
	    redirectTo: 'vehicles-edit.general'
	  }).state({
	    name: 'vehicles-edit.general',
	    url: '/general',
	    controller: _general2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/vehicles/tabs/general/_general.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'vehicles-edit.users',
	    url: '/users',
	    controller: _users2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/management/vehicles/tabs/users/_users.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('VehiclesListController', _vehiclesList2.default).controller('VehiclesEditController', _vehiclesEdit2.default).controller('VehiclesStatsController', _vehiclesPanel2.default).controller('NewVehicleController', _newVehicle2.default).controller('VehicleGeneralController', _general2.default).controller('VehicleUserController', _users2.default).controller('VerifiedRecordDialogController', _verifiedRecord2.default).controller('BehaviorConfigDialogController', _behaviorConfig2.default).controller('AssociationConfigDialogController', _associationConfig2.default).service('VehiclesService', _vehicles2.default);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var VehiclesListController = function (_ListController) {
	  VehiclesListController.$inject = ["$mdDialog", "$state", "$scope", "$translate", "DialogService", "GeocodingService", "MainService"];
	  _inherits(VehiclesListController, _ListController);

	  function VehiclesListController($mdDialog, $state, $scope, $translate, DialogService, GeocodingService, MainService) {
	    'ngInject';

	    _classCallCheck(this, VehiclesListController);

	    var _this = _possibleConstructorReturn(this, (VehiclesListController.__proto__ || Object.getPrototypeOf(VehiclesListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$mdDialog = $mdDialog;
	    _this.$translate = $translate;
	    _this.DialogService = DialogService;
	    _this.GeocodingService = GeocodingService;

	    _this.query = {
	      attributes: ['*'],
	      includes: {
	        last_gps: ['*'],
	        devices: ['name', 'imei', 'code']
	      },
	      filters: {},
	      sort: {
	        prop: 'plate',
	        order: 'ASC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      export: true,
	      stats: true
	    };

	    _this.colors = _constants.COLORS;
	    _this.setProps(_constants.API.V5, _constants.API.VEHICLES, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(VehiclesListController, [{
	    key: 'resolveAddress',
	    value: function resolveAddress(vehicle) {
	      if (!vehicle.relationships || vehicle.relationships.address || !vehicle.relationships.last_gps) {
	        return;
	      }
	      this.GeocodingService.getAddressFromCoords(vehicle.relationships.last_gps.attributes.last_gps_raw.lng, vehicle.relationships.last_gps.attributes.last_gps_raw.lat).promise.then(function (res) {
	        vehicle.relationships.address = res.display_name;
	      });
	    }
	  }, {
	    key: 'openPanel',
	    value: function openPanel(vehicle) {
	      this.checkStatus(vehicle);
	      this.checkUsers(vehicle);
	      this.resolveAddress(vehicle);
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus(vehicle) {
	      if (vehicle.attributes.active) {
	        return;
	      }
	      vehicle.attributes.active = !vehicle.attributes.deactivated_at;
	    }
	  }, {
	    key: 'checkUsers',
	    value: function checkUsers(vehicle) {
	      if (!vehicle.attributes.user_names) return;

	      vehicle.relationships ? vehicle.relationships.users = [] : vehicle.relationships = { users: [] };

	      vehicle.attributes.user_names.split(';').forEach(function (u) {
	        vehicle.relationships.users.push({
	          attributes: { name: u },
	          type: 'users'
	        });
	      });
	    }
	  }, {
	    key: 'getMainDevice',
	    value: function getMainDevice(vehicle) {
	      if (!vehicle.relationships.devices) return '-';
	      if (!vehicle.relationships.last_gps || vehicle.relationships.devices.length === 1) return vehicle.relationships.devices[0].attributes.imei;
	      var main = vehicle.relationships.devices.filter(function (d) {
	        return d.id === vehicle.relationships.last_gps.attributes.device_id;
	      })[0];
	      return main.attributes.imei;
	    }
	  }, {
	    key: 'updateVerified',
	    value: function updateVerified(vehicle) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts('app/internal/management/vehicles/components/verified-record/verified-record.dialog.html', 'VerifiedRecordDialogController');

	      this.DialogService.openDialog(opt, vehicle).then(function (res) {
	        var item = {
	          data: {
	            attributes: res.attributes
	          }
	        };

	        _this2.MainService.update(_constants.API.V5, _constants.API.VEHICLES, vehicle.id, item).promise.then(function () {
	          vehicle.attributes.plate = res.attributes.plate;
	          vehicle.attributes.brand_name = res.attributes.brand;
	          vehicle.attributes.type_name = res.attributes.type;
	          vehicle.attributes.model_name = res.attributes.model;
	          vehicle.attributes.trim_name = res.attributes.trim;
	          vehicle.attributes.year = res.attributes.year;
	          vehicle.attributes.color = res.attributes.color;
	          vehicle.attributes.vin = res.attributes.vin;
	        });
	      });
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(vehicle) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = vehicle.attributes.active ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'vehicle',
	          id: vehicle.id
	        }]
	      };

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'VEHICLE_ACTIVATION', action: 'save' }).then(function () {
	        _this3.MainService.edit(_constants.API.V5, _constants.API.VEHICLES + '/set-activation/' + action, obj).promise.then(function () {
	          vehicle.attributes.deactivated_at = vehicle.attributes.deactivated_at ? null : new Date();
	          vehicle.attributes.ative = !vehicle.attributes.ative;
	        });
	      }).catch(function () {
	        _this3.checkStatus(vehicle);
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this4 = this;

	      var keys = ['PANEL.HEADER.PLATE_CODE', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.BRAND_MODEL', 'PANEL.HEADER.TYPE_COLOR', 'PANEL.HEADER.LAST_GPS_IMEI'];

	      this.$translate(keys).then(function (t) {
	        _this4.headers = [{
	          label: t['PANEL.HEADER.PLATE_CODE'],
	          sort: true,
	          prop: 'plate'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise_name'
	        }, {
	          label: t['PANEL.HEADER.BRAND_MODEL'],
	          sort: true,
	          prop: 'brand_name'
	        }, {
	          label: t['PANEL.HEADER.TYPE_COLOR'],
	          sort: true,
	          prop: 'type_name'
	        }, {
	          label: t['PANEL.HEADER.LAST_GPS_IMEI'],
	          sort: true,
	          prop: 'last_gps.last_gps_time'
	        }];
	      });
	    }
	  }]);

	  return VehiclesListController;
	}(_list2.default);

	exports.default = VehiclesListController;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehiclesEditController = function () {
	  VehiclesEditController.$inject = ["$state", "DialogService", "MainService", "Upload", "selectedItem", "StateManagement"];
	  function VehiclesEditController($state, DialogService, MainService, Upload, selectedItem, StateManagement) {
	    'ngInject';

	    _classCallCheck(this, VehiclesEditController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.Upload = Upload;
	    this.selectedItem = selectedItem;
	    this.StateManagement = StateManagement;

	    this.loadData();
	    this.colors = _constants.COLORS;
	    this.types = _constants.ASSET_TYPES;

	    this.maxYear = new Date().getFullYear() + 1;
	  }

	  _createClass(VehiclesEditController, [{
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var obj = {
	        data: [{ id: this.vehicle.id, type: 'vehicles' }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.vehicle).then(function () {
	        _this.MainService.deleteMany(_constants.API.V5, _constants.API.VEHICLES, obj).promise.then(function () {
	          _this.$state.go('vehicles-list');
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      this.loading = true;
	      this.selectedItem.promise.then(function (res) {
	        _this2.loading = false;
	        _this2.vehicle = res.data;

	        _this2.selectedEnterprise = res.data.relationships.enterprise;
	        _this2.StateManagement.setData(['vehicle'], [_this2.vehicle]);
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      var vehicle = {
	        data: {
	          attributes: {
	            plate: this.vehicle.attributes.plate,
	            vin: this.vehicle.attributes.vin,
	            code: this.vehicle.attributes.code,
	            description: this.vehicle.attributes.description
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: this.selectedEnterprise.id
	            }
	          }
	        }
	      };

	      if (this.forceEdit) {
	        vehicle.data.attributes.year = this.vehicle.attributes.year.toString();
	        vehicle.data.attributes.color = this.vehicle.attributes.color;
	        vehicle.data.attributes.brand = this.vehicle.attributes.brand_name;
	        vehicle.data.attributes.model = this.vehicle.attributes.model_name;
	        vehicle.data.attributes.trim = this.vehicle.attributes.trim_name;
	        vehicle.data.attributes.type = this.vehicle.attributes.type_name;
	      }

	      (0, _helper.cleanPayload)(vehicle.data);
	      this.MainService.update(_constants.API.V5, _constants.API.VEHICLES, this.$state.params.id, vehicle).promise.then(function () {
	        _this3.processing = false;
	      }).catch(function () {
	        _this3.processing = false;
	      });
	    }
	  }]);

	  return VehiclesEditController;
	}();

	exports.default = VehiclesEditController;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _timeseries = __webpack_require__(99);

	var _timeseries2 = _interopRequireDefault(_timeseries);

	var _donut = __webpack_require__(102);

	var _donut2 = _interopRequireDefault(_donut);

	var _colorPalettes = __webpack_require__(103);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehiclesStatsController = function () {
	  VehiclesStatsController.$inject = ["$translate", "MainService"];
	  function VehiclesStatsController($translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, VehiclesStatsController);

	    this.$translate = $translate;
	    this.MainService = MainService;

	    this.prepareAssetTypes();
	    this.manageItens();
	    this.distribution();

	    this.selectedKeys = ['created'];
	  }

	  _createClass(VehiclesStatsController, [{
	    key: 'prepareAssetTypes',
	    value: function prepareAssetTypes() {
	      var _this = this;

	      this.vehicleTypeNames = {};
	      _constants.ASSET_TYPES.forEach(function (type, index) {
	        _this.vehicleTypeNames[_constants.ASSET_TYPES[index].name] = _this.$translate.instant('VEHICLES.ENUM.TYPE.' + type.name.toUpperCase());
	      });
	    }
	  }, {
	    key: 'distribution',
	    value: function distribution() {
	      var _this2 = this;

	      this.loadingDistribution = true;
	      this.MainService.raw(_constants.API.V4, 'assets/reports/models').promise.then(function (res) {
	        _this2.loadingDistribution = false;
	        _this2.modelDistribution = res.data;
	        _this2.modelsList = Object.keys(_this2.modelDistribution);
	        _this2.selectedModels = _this2.modelsList;

	        var options = {
	          bindTo: 'vehicles-distribution',
	          type: 'donut',
	          format: 'number',
	          legend: false,
	          size: {
	            height: 300
	          },
	          palette: _colorPalettes.PALETTES.old_green
	        };

	        var report = {
	          names: _this2.vehicleTypeNames,
	          data: _this2.modelDistribution
	        };

	        _this2.models = (0, _donut2.default)(options, report);
	        _this2.selectModelKeys();
	      }).catch(function () {
	        _this2.loadingDistribution = false;
	      });
	    }
	  }, {
	    key: 'manageItens',
	    value: function manageItens() {
	      var _this3 = this;

	      this.loadingManage = true;
	      var query = {
	        startDate: moment().add(1, 'd').format('YYYY-MM-DD'),
	        granularity: 'day',
	        recurrence: 30
	      };
	      this.MainService.raw(_constants.API.V4, ['assets', 'reports', 'management', query.startDate, query.granularity, query.recurrence].join('/')).promise.then(function (res) {
	        _this3.loadingManage = false;
	        var size = res.data.dates.length;

	        var options = {
	          bindTo: 'manage-items',
	          type: 'bar',
	          legend: false,
	          format: 'number',
	          palette: _colorPalettes.PALETTES.old_green,
	          size: {
	            height: 300
	          },
	          region: {
	            start: res.data.dates[0],
	            size: size
	          },
	          axis: {
	            x: true,
	            y: true
	          },
	          noData: 'Sem dados',
	          labels: {
	            x: 'Dias',
	            y: 'Unidades'
	          }
	        };

	        var report = {
	          names: {
	            created: 'Criados',
	            deleted: 'Deletados'
	          },
	          data: [['dates'].concat(_toConsumableArray(res.data.dates.splice(0, size - 1))), ['created'].concat(_toConsumableArray(res.data.created.splice(0, size - 1))), ['deleted'].concat(_toConsumableArray(res.data.deleted.splice(0, size - 1)))],
	          lines: {
	            y: [],
	            x: []
	          }
	        };

	        _this3.managedItems = (0, _timeseries2.default)(options, report);
	        _this3.selectManagedKeys();
	      }).catch(function () {
	        _this3.loadingManage = false;
	      });
	    }
	  }, {
	    key: 'selectManagedKeys',
	    value: function selectManagedKeys() {
	      this.managedItems.hide();
	      this.managedItems.show(this.selectedKeys);
	    }
	  }, {
	    key: 'selectModelKeys',
	    value: function selectModelKeys() {
	      this.models.hide();
	      this.models.show(this.selectedModels);
	    }
	  }]);

	  return VehiclesStatsController;
	}();

	exports.default = VehiclesStatsController;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = timeseriesGraph;

	var _formatNumber = __webpack_require__(100);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	var _buildTimeseriesRegions = __webpack_require__(101);

	var _buildTimeseriesRegions2 = _interopRequireDefault(_buildTimeseriesRegions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global c3 */
	function timeseriesGraph(options, report) {
	  return c3.generate({
	    bindto: '#' + options.bindTo,
	    data: {
	      x: 'dates',
	      columns: report.data,
	      type: options.type,
	      names: report.names,
	      hide: options.hide || false,
	      empty: {
	        label: {
	          text: options.noData
	        }
	      }
	    },
	    color: {
	      pattern: options.palette
	    },
	    legend: {
	      show: options.legend
	    },
	    regions: (0, _buildTimeseriesRegions2.default)(options.region.start, options.region.size),
	    size: {
	      height: options.size.height
	    },
	    point: {
	      show: true,
	      r: 3
	    },
	    grid: {
	      y: {
	        show: true
	      },
	      x: {
	        show: false
	      }
	    },
	    interaction: {
	      enabled: true
	    },
	    bar: {
	      width: {
	        ratio: 0.8
	      }
	    },
	    axis: {
	      y: {
	        show: options.axis.y,
	        min: 0,
	        inner: false,
	        label: options.labels.y,
	        lines: report.lines.y || [],
	        tick: {
	          outer: false,
	          format: function format(d) {
	            return (0, _formatNumber2.default)(d, options.format);
	          },
	          count: 5
	        },
	        padding: {
	          top: 10,
	          bottom: 0
	        }
	      },
	      x: {
	        show: options.axis.x,
	        label: options.labels.x,
	        type: 'timeseries',
	        tick: {
	          format: '%d-%m-%Y'
	        }
	      }
	    }
	  });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatNumber;

	var _floatToTime = __webpack_require__(62);

	var _floatToTime2 = _interopRequireDefault(_floatToTime);

	var _distance = __webpack_require__(63);

	var _distance2 = _interopRequireDefault(_distance);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function formatNumber(i, type) {
	  switch (type) {
	    case 'number':
	      i = parseInt(i);
	      break;
	    case 'distance':
	      i = (0, _distance2.default)()(i);
	      break;
	    case 'percentage':
	      i = i.toFixed(0) + '%';
	      break;
	    case 'percent':
	      i = (i * 100).toFixed(1) + '%';
	      break;
	    case 'speed':
	      i = parseInt(i) + 'km/h';
	      break;
	    case 'time':
	      i = (0, _floatToTime2.default)()(i);
	      break;
	    case 'boolean':
	      i = Boolean(i);
	      break;
	    case 'voltage':
	      i = i.toFixed(1) + 'V';
	      break;
	    case 'milivoltage':
	      i = (i / 1000).toFixed(1) + 'V';
	      break;
	    default:
	      break;
	  }
	  return i;
	}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _buildTimeseriesRegions;
	function _buildTimeseriesRegions(start, size) {
	  var regions = [];
	  for (var index = 1; index < size; index += 8) {
	    var day = moment(start).add(index, 'd').format('YYYY-MM-DD');
	    var nextDay = moment(start).add(index + 4, 'd').format('YYYY-MM-DD');
	    regions.push({ start: day, end: nextDay });
	  }
	  return regions;
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = donutGraph;

	var _formatNumber = __webpack_require__(100);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function donutGraph(options, report) {
	  return c3.generate({
	    bindto: '#' + options.bindTo,
	    data: {
	      json: report.data,
	      type: options.type,
	      names: report.names,
	      empty: {
	        label: {
	          text: options.noData
	        }
	      }
	    },
	    donut: {
	      title: options.title,
	      width: options.width_whole,
	      label: {
	        show: false
	      }
	    },
	    tooltip: {
	      format: {
	        format: function format(value) {
	          return (0, _formatNumber2.default)(value, options.format);
	        }
	      }
	    },
	    size: {
	      height: options.size.height
	    },
	    color: {
	      pattern: options.palette
	    },
	    legend: {
	      show: options.legend
	    }
	  });
	} /* global c3 */

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PALETTES = exports.PALETTES = {
	  green: ['#425F57', '#749F82', '#A8E890', '#CFFF8D'],
	  california: ['#FF731D', '#FFF7E9', '#5F9DF7', '#1746A2'],
	  blue: ['#06283D', '#256D85', '#47B5FF', '#DFF6FF'],
	  sunny: ['#FD841F', '#E14D2A', '#CD104D', '#9C2C77'],
	  retro: ['#FA7070', '#FBF2CF', '#C6EBC5', '#A1C298'],
	  neon: ['#293462', '#1CD6CE', '#FEDB39', '#D61C4E'],
	  beach: ['#541690', '#FF4949', '#FF8D29', '#FFCD38'],
	  gold: ['#FD841F', '#E14D2A', '#CD104D', '#9C2C77'],
	  cold: ['#242F9B', '#646FD4', '#9BA3EB', '#DBDFFD'],
	  space: ['#370665', '#35589A', '#F14A16', '#FC9918'],
	  space_cool: ['#142F43', '#FFAB4C', '#FF5F7E', '#B000B9'],
	  old_green: ['#253B6E', '#1F5F8B', '#1891AC', '#D2ECF9']
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewVehicleController = function () {
	  NewVehicleController.$inject = ["$scope", "$window", "DialogService", "EnvironmentConfig", "MainService", "VehiclesService"];
	  function NewVehicleController($scope, $window, DialogService, EnvironmentConfig, MainService, VehiclesService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, NewVehicleController);

	    this.$scope = $scope;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.VehiclesService = VehiclesService;

	    this.step = {
	      main: true,
	      users: false,
	      devices: false
	    };

	    this.users = [];
	    this.devices = [];

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.countryCode = this.selectedEnterprise.relationships.country ? this.selectedEnterprise.relationships.country.attributes.code : 'BRA';
	    this.verifiedRegistry = this.countryCode === 'BRA';
	    this.colors = _constants.COLORS;
	    this.types = _constants.ASSET_TYPES;
	    this.nature = _constants.USER_NATURE;
	    this.maxYear = new Date().getFullYear() + 1;
	    this.searchingPlate = false;
	    this.enterpriseIncludes = { country: ['*'] };
	    this.getInfoCountry();

	    this.devicesOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: this.vehicle ? this.vehicle.relationships.enterprise.id : '' },
	        'vehicle.id': { operator: 'is', value: null }
	      }
	    };
	    this.usersOptions = {
	      filters: {
	        'enterprise.id': { operator: 'in', value: this.vehicle ? this.vehicle.relationships.enterprise.id : '' }
	      }
	    };

	    var vehicleChange = function vehicleChange(id) {
	      _this.devicesOptions.filters['enterprise.id'].value = id;
	      _this.usersOptions.filters['enterprise.id'].value = id;
	    };

	    this.$scope.$watch(function () {
	      return _this.vehicle;
	    }, function (newVal) {
	      if (newVal && newVal.relationships && newVal.relationships.enterprise.id) {
	        vehicleChange(newVal.relationships.enterprise.id);
	      }
	    });
	  }

	  _createClass(NewVehicleController, [{
	    key: 'setState',
	    value: function setState(key) {
	      var _this2 = this;

	      Object.keys(this.step).forEach(function (k) {
	        _this2.step[k] = false;
	      });
	      this.step[key] = true;
	    }
	  }, {
	    key: 'getModelDetails',
	    value: function getModelDetails() {
	      var _this3 = this;

	      if (!this.vehicle.attributes.plate || !this.verifiedRegistry || this.countryCode !== 'BRA') {
	        return;
	      }
	      this.searchingPlate = true;
	      this.VehiclesService.consult(_constants.API.V5, _constants.API.VEHICLES, this.vehicle.attributes.plate).promise.then(function (res) {
	        _this3.vehicle.attributes = {};
	        _this3.vehicle.attributes = Object.assign(_this3.vehicle.attributes, res.data.attributes);
	      }).catch(function () {
	        _this3.vehicle.attributes = Object.assign(_this3.vehicle.attributes, internals._initialVehicle());
	      }).finally(function () {
	        _this3.searchingPlate = false;
	      });
	    }
	  }, {
	    key: 'getInfoCountry',
	    value: function getInfoCountry() {
	      this.infoCountry = _.get(this.selectedEnterprise, 'relationships.country.attributes', {});
	      var rulePlate = _.get(this.infoCountry, 'extras.assets.rulePlate', '');
	      this.rulePlate = rulePlate ? new RegExp(rulePlate.slice(1, -1)) : '';
	    }
	  }, {
	    key: 'changeEnterprise',
	    value: function changeEnterprise(enterprise) {
	      if (enterprise && enterprise.relationships.country.attributes.code !== this.countryCode) {
	        this.selectedEnterprise = enterprise;
	        var country = enterprise.relationships.country.attributes.code;
	        this.verifiedRegistry = country === 'BRA';
	        this.countryCode = country;
	        this.getInfoCountry();
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save(nextStep) {
	      var _this4 = this;

	      if (!this.form.$valid) {
	        return;
	      }
	      this.processing = true;
	      var asset = {
	        data: [{
	          attributes: {
	            plate: this.vehicle.attributes.plate,
	            vin: this.vehicle.attributes.vin,
	            code: this.vehicle.attributes.code,
	            brand: this.vehicle.attributes.brand,
	            model: this.vehicle.attributes.model,
	            trim: this.vehicle.attributes.model_full,
	            year: this.vehicle.attributes.year.toString(),
	            color: this.vehicle.attributes.color,
	            type: this.vehicle.attributes.type || 'other',
	            description: this.vehicle.attributes.description
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	            }
	          }
	        }]
	      };

	      (0, _helper.cleanBulkPayload)(asset, true);
	      this.MainService.create(_constants.API.V5, _constants.API.VEHICLES, asset).promise.then(function (res) {
	        _this4.processing = false;
	        if (!nextStep) _this4.close();else {
	          _this4.vehicle = {
	            type: 'vehicles',
	            id: res.data[0].id,
	            attributes: asset.data[0].attributes,
	            relationships: asset.data[0].relationships
	          };
	          _this4.setState('users');
	        }
	      }).catch(function () {
	        _this4.processing = false;
	      });
	    }
	  }, {
	    key: 'addUser',
	    value: function addUser() {
	      if (this.users.map(function (u) {
	        return u.id;
	      }).includes(this.selectedUser.id)) return;
	      this.users.push(this.selectedUser);
	      this.selectedUser = null;
	    }
	  }, {
	    key: 'removeUser',
	    value: function removeUser(index) {
	      this.users.splice(index, 1);
	    }
	  }, {
	    key: 'saveUsers',
	    value: function saveUsers() {
	      var _this5 = this;

	      if (this.users.length === 0) {
	        return;
	      }
	      this.processing = true;

	      var obj = {
	        data: []
	      };

	      this.users.forEach(function (u) {
	        obj.data.push({ user_id: u.id, asset_id: _this5.vehicle.id, nature: u.attributes.nature });
	      });

	      this.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {
	        _this5.processing = false;
	      });
	    }
	  }, {
	    key: 'addDevice',
	    value: function addDevice() {
	      if (this.devices.map(function (u) {
	        return u.id;
	      }).includes(this.selectedDevice.id)) return;
	      this.devices.push(this.selectedDevice);
	      this.selectedDevice = null;
	    }
	  }, {
	    key: 'removeDevice',
	    value: function removeDevice(index) {
	      this.devices.splice(index, 1);
	    }
	  }, {
	    key: 'saveDevices',
	    value: function saveDevices() {
	      var _this6 = this;

	      if (this.devices.length === 0) {
	        return;
	      }
	      this.processing = true;

	      var obj = {
	        data: []
	      };

	      this.devices.forEach(function (d, i) {
	        obj.data.push({ device_id: d.id, asset_id: _this6.vehicle.id, is_main_device: i === 0 });
	      });

	      this.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/devices', obj).promise.then(function () {
	        _this6.processing = false;
	        _this6.close();
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewVehicleController;
	}();

	exports.default = NewVehicleController;


	var internals = {
	  _initialVehicle: function _initialVehicle() {
	    return {
	      type: '',
	      brand: '',
	      model: '',
	      model_full: '',
	      year: '',
	      model_year: '',
	      color: '',
	      vin: ''
	    };
	  }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehicleGeneralController = function () {
	  VehicleGeneralController.$inject = ["$rootScope", "$scope", "$translate", "DialogService", "MainService", "StateManagement"];
	  function VehicleGeneralController($rootScope, $scope, $translate, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, VehicleGeneralController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.obj = {
	      includes: {
	        device: ['name', 'imei', 'deleted_at'],
	        enterprise: ['name', 'cnpj', 'email'],
	        behavior_config: ['*']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    var checkData = function checkData() {
	      return _this.checkItem();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('vehicle')) {
	        checkData();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });

	    this.loadAssociationHistory = this.loadAssociationHistory.bind(this);
	    this.reorder = this.reorder.bind(this);
	  }

	  _createClass(VehicleGeneralController, [{
	    key: 'checkItem',
	    value: function checkItem() {
	      var _StateManagement$getD = this.StateManagement.getData(['vehicle']),
	          vehicle = _StateManagement$getD.vehicle;

	      this.vehicle = vehicle;
	      this.loadData(1);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadAssociationHistory(page);
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.obj.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.loadAssociationHistory(1);
	    }
	  }, {
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(page) {
	      var _this2 = this;

	      this.loading = true;
	      this.obj.page = page;

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + this.vehicle.id + '/associations/devices', this.obj).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	        _this2.items = res.data;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'openDialogDevices',
	    value: function openDialogDevices() {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts('app/components/new-item/add-device.html', 'AddNewItemController');

	      this.DialogService.openDialog(opt, { enterprise: this.vehicle.relationships.enterprise }).then(function (res) {
	        var obj = {
	          data: [{
	            device_id: res.id,
	            asset_id: _this3.vehicle.id,
	            is_main_device: _this3.items.filter(function (i) {
	              return i.attributes.is_main_device && i.attributes.deleted_at == null;
	            }).length < 1
	          }]
	        };

	        _this3.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/devices', obj).promise.then(function () {
	          _this3.loadData(1);
	        });
	      });
	    }
	  }, {
	    key: 'setBehaviorConfig',
	    value: function setBehaviorConfig(item) {
	      var _this4 = this;

	      var opt = _dialog.DIALOG._opts('app/internal/management/vehicles/components/behavior-config/behavior-config.dialog.html', 'BehaviorConfigDialogController');

	      this.DialogService.openDialog(opt, item).then(function (res) {
	        var index = _this4.items.findIndex(function (i) {
	          return i.id === item.id;
	        });
	        var relationships = _this4.items[index].relationships;
	        var behaviorConfig = relationships.behavior_config;

	        if (behaviorConfig) {
	          if (res) {
	            behaviorConfig.attributes.name = res.attributes.name;
	          } else {
	            delete relationships.behavior_config;
	          }
	        } else if (res) {
	          relationships.behavior_config = {
	            attributes: {
	              name: res.attributes.name
	            }
	          };
	        }
	      });
	    }
	  }, {
	    key: 'setAssociationConfig',
	    value: function setAssociationConfig(item) {
	      var opt = _dialog.DIALOG._opts('app/internal/management/vehicles/components/association-config/association-config.dialog.html', 'AssociationConfigDialogController');

	      this.DialogService.openDialog(opt, item);
	    }
	  }, {
	    key: 'setMain',
	    value: function setMain(item) {
	      var _this5 = this;

	      var association = {
	        data: {
	          attributes: {
	            is_main_device: true
	          }
	        }
	      };
	      this.MainService.edit(_constants.API.V5, _constants.API.VEHICLES + '/' + this.vehicle.id + '/associations/devices/' + item.id, association).promise.then(function () {
	        _this5.items.forEach(function (i) {
	          i.attributes.is_main_device = false;
	        });
	        item.attributes.is_main_device = true;
	      });
	    }
	  }, {
	    key: 'removeDevice',
	    value: function removeDevice(item) {
	      var _this6 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'DEVICES_ASSOCIATION', label: 'DEVICES_ASSOCIATION', action: 'delete' }).then(function () {
	        var obj = {
	          data: [{
	            type: 'device_association',
	            id: item.id
	          }]
	        };

	        _this6.MainService.deleteMany(_constants.API.V5, _constants.API.VEHICLES + '/associations/devices', obj).promise.then(function () {
	          _this6.loadData(1);
	        });
	      });
	    }
	  }]);

	  return VehicleGeneralController;
	}();

	exports.default = VehicleGeneralController;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehicleUsersController = function () {
	  VehicleUsersController.$inject = ["$rootScope", "$scope", "$translate", "DialogService", "MainService", "StateManagement"];
	  function VehicleUsersController($rootScope, $scope, $translate, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, VehicleUsersController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.obj = {
	      includes: {
	        user: ['name', 'username', 'email', 'phone1', 'deleted_at']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    var checkData = function checkData() {
	      return _this.checkItem();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('vehicle')) {
	        checkData();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });

	    this.nature = _constants.USER_NATURE;
	    this.loadAssociationHistory = this.loadAssociationHistory.bind(this);
	    this.reorder = this.reorder.bind(this);
	  }

	  _createClass(VehicleUsersController, [{
	    key: 'checkItem',
	    value: function checkItem() {
	      var _StateManagement$getD = this.StateManagement.getData(['vehicle']),
	          vehicle = _StateManagement$getD.vehicle;

	      this.vehicle = vehicle;
	      this.loadData(1);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadAssociationHistory(page);
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.obj.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.loadAssociationHistory(1);
	    }
	  }, {
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(page) {
	      var _this2 = this;

	      this.loading = true;
	      this.obj.page = page;

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + this.vehicle.id + '/associations/users', this.obj).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	        _this2.items = res.data;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'openDialogUsers',
	    value: function openDialogUsers() {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts('app/components/new-item/add-user.html', 'AddNewItemController');

	      this.DialogService.openDialog(opt, { enterprise: this.vehicle.relationships.enterprise }).then(function (res) {
	        var obj = {
	          data: [{
	            user_id: res.id,
	            asset_id: _this3.vehicle.id
	          }]
	        };

	        _this3.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {
	          _this3.loadData(1);
	        });
	      });
	    }
	  }, {
	    key: 'removeUser',
	    value: function removeUser(item) {
	      var _this4 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'USER_PERMISSION', label: 'USER_PERMISSION', action: 'delete' }).then(function () {
	        var obj = {
	          data: [{
	            type: 'user_permission',
	            id: item.id
	          }]
	        };

	        _this4.MainService.deleteMany(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {
	          _this4.loadData(1);
	        });
	      });
	    }
	  }]);

	  return VehicleUsersController;
	}();

	exports.default = VehicleUsersController;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VerifiedRecordDialogController = function () {
	  VerifiedRecordDialogController.$inject = ["$state", "DialogService", "VehiclesService", "locals"];
	  function VerifiedRecordDialogController($state, DialogService, VehiclesService, locals) {
	    'ngInject';

	    _classCallCheck(this, VerifiedRecordDialogController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.VehiclesService = VehiclesService;

	    this.vehicle = locals.item;
	    this.colors = _constants.COLORS;
	    this.verifyPlatePattern();
	  }

	  _createClass(VerifiedRecordDialogController, [{
	    key: 'verifyPlatePattern',
	    value: function verifyPlatePattern() {
	      if (!/^[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/.test(this.vehicle.attributes.plate)) {
	        this.invalidData = true;
	      } else {
	        this.consult();
	      }
	    }
	  }, {
	    key: 'consult',
	    value: function consult() {
	      var _this = this;

	      this.processing = true;
	      this.VehiclesService.consult(_constants.API.V5, _constants.API.VEHICLES, this.vehicle.attributes.plate).promise.then(function (res) {
	        _this.processing = false;
	        _this.new_vehicle = {
	          attributes: {
	            plate: res.data.attributes.plate,
	            vin: res.data.attributes.vin,
	            year: res.data.attributes.year,
	            color: res.data.attributes.color,
	            brand: res.data.attributes.brand,
	            model: res.data.attributes.model,
	            trim: res.data.attributes.model_full,
	            type: res.data.attributes.type
	          }
	        };
	      }).catch(function () {
	        _this.processing = false;
	        _this.invalidData = true;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      this.DialogService.closeDialog(this.new_vehicle);
	    }
	  }]);

	  return VerifiedRecordDialogController;
	}();

	exports.default = VerifiedRecordDialogController;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _timeToInt = __webpack_require__(54);

	var _timeToInt2 = _interopRequireDefault(_timeToInt);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BehaviorConfigDialogController = function () {
	  BehaviorConfigDialogController.$inject = ["$state", "$window", "DialogService", "EnvironmentConfig", "MainService", "locals"];
	  function BehaviorConfigDialogController($state, $window, DialogService, EnvironmentConfig, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, BehaviorConfigDialogController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.currentEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.currentUser = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.association = locals.item;

	    this.tab = 'behavior';
	    this.weekdays = _constants.weekdays[this.currentUser.attributes.locale];
	    this.loadData();
	  }

	  _createClass(BehaviorConfigDialogController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      var obj = {
	        attributes: ['name', 'imei', 'code'],
	        includes: {
	          type: ['brand_alias', 'alias', 'type', 'protocol', 'inputs_count', 'outputs_count']
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.association.relationships.device.id, obj).promise.then(function (res) {
	        _this.device = res.data;
	        _this._generateTimeLine();
	        _this.selectedBehavior = _this.association.relationships.behavior_config;
	      });
	    }
	  }, {
	    key: 'getBehaviors',
	    value: function getBehaviors(query) {
	      var obj = {
	        attributes: ['*'],
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V4, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.uuid + '/behavior-configs', obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: '_generateTimeLine',
	    value: function _generateTimeLine() {
	      var _this2 = this;

	      if (this.association.relationships.behavior_config.attributes.time_restrictions) {
	        var days = Object.keys(this.association.relationships.behavior_config.attributes.time_restrictions);
	        if (days.length < 1) {
	          return;
	        }
	        var totalDailySeconds = 86400;
	        days.forEach(function (d) {
	          _this2.association.relationships.behavior_config.attributes.time_restrictions[d][0].ml = (0, _timeToInt2.default)()(_this2.association.relationships.behavior_config.attributes.time_restrictions[d][0].starts) / totalDailySeconds * 100;
	          _this2.association.relationships.behavior_config.attributes.time_restrictions[d][0].size = ((0, _timeToInt2.default)()(_this2.association.relationships.behavior_config.attributes.time_restrictions[d][0].ends) - (0, _timeToInt2.default)()(_this2.association.relationships.behavior_config.attributes.time_restrictions[d][0].starts)) / totalDailySeconds * 100;
	        });
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.progress = true;
	      var association = {
	        data: {
	          relationships: {
	            behavior_config: {
	              type: 'behavior_config',
	              id: this.selectedBehavior ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedBehavior.id) : null
	            }
	          }
	        }
	      };

	      this.MainService.edit(_constants.API.V5, _constants.API.VEHICLES + '/' + this.$state.params.id + '/associations/devices/' + this.association.id, association).promise.then(function () {
	        _this3.progress = false;
	        _this3.DialogService.closeDialog(_this3.selectedBehavior);
	      }).catch(function () {
	        _this3.progress = false;
	      });
	    }
	  }]);

	  return BehaviorConfigDialogController;
	}();

	exports.default = BehaviorConfigDialogController;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// import { cleanPayload } from '../../../../../utils/helper'

	var AssociationConfigDialogController = function () {
	  AssociationConfigDialogController.$inject = ["$state", "$window", "DialogService", "MainService", "locals"];
	  function AssociationConfigDialogController($state, $window, DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, AssociationConfigDialogController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.currentEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.association = locals.item;

	    this.alertTags = _constants.TAGS;
	    this.inputOptions = _constants.DEVICES_IO.IN;
	    this.outputOptions = _constants.DEVICES_IO.OUT;
	    this.inSize = 0;
	    this.outSize = 0;

	    this.tab = 'ios';
	    this.loadData();
	  }

	  _createClass(AssociationConfigDialogController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      var obj = {
	        attributes: ['name', 'imei', 'code'],
	        includes: {
	          type: ['brand_alias', 'alias', 'type', 'protocol', 'inputs_count', 'outputs_count']
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.association.relationships.device.id, obj).promise.then(function (res) {
	        _this.device = res.data;
	        _this._generateInAndOut();
	      });
	    }
	  }, {
	    key: '_generateInAndOut',
	    value: function _generateInAndOut() {
	      this.inSize = this.device.relationships.type.attributes.inputs_count;
	      this.outSize = this.device.relationships.type.attributes.outputs_count;
	      var max = Math.max(this.inSize, this.outSize);
	      this.inputMetrics = new Array(this.inSize);
	      this.outputMetrics = new Array(this.outSize);
	      for (var index = 1; index <= max; index++) {
	        if (index <= this.inSize) {
	          this.inputMetrics[index - 1] = index;
	        }
	        if (index <= this.outSize) {
	          this.outputMetrics[index - 1] = index;
	        }
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'prepareIos',
	    value: function prepareIos() {
	      this.progress = true;
	      var association = {
	        data: {
	          attributes: {
	            input_profile: _.omitBy(this.association.attributes.input_profile, function (e) {
	              return e === 'null';
	            }),
	            output_profile: _.omitBy(this.association.attributes.output_profile, function (e) {
	              return e === 'null';
	            })
	          }
	        }
	      };

	      this.save(association);
	    }
	  }, {
	    key: 'prepareSnooze',
	    value: function prepareSnooze() {
	      this.progress = true;
	      this.association.attributes.snoozed_tags = this.association.attributes.snoozed_until ? this.association.attributes.snoozed_tags : null;

	      var snoozed = {
	        data: {
	          attributes: {
	            snoozed_until: this.association.attributes.snoozed_until,
	            snoozed_tags: this.association.attributes.snoozed_tags
	          }
	        }
	      };

	      this.save(snoozed);
	    }
	  }, {
	    key: 'save',
	    value: function save(obj) {
	      var _this2 = this;

	      this.MainService.edit(_constants.API.V5, _constants.API.VEHICLES + '/' + this.$state.params.id + '/associations/devices/' + this.association.id, obj).promise.then(function () {
	        _this2.progress = false;
	        _this2.close();
	      }).catch(function () {
	        _this2.progress = false;
	      });
	    }
	  }]);

	  return AssociationConfigDialogController;
	}();

	exports.default = AssociationConfigDialogController;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehiclesService = function () {
	  VehiclesService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function VehiclesService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, VehiclesService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(VehiclesService, [{
	    key: 'consult',
	    value: function consult(version, model, plate) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, 'consult', plate].join('/'), method: 'GET', timeout: 15000 }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }]);

	  return VehiclesService;
	}();

	exports.default = VehiclesService;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(112);

	__webpack_require__(125);

	__webpack_require__(134);

	__webpack_require__(147);

	__webpack_require__(151);

	__webpack_require__(153);

	angular.module('phoenix.internal.monitoring', ['ui.router', 'phoenix.internal.monitoring.center', 'phoenix.internal.monitoring.history', 'phoenix.internal.monitoring.tracking', 'phoenix.internal.monitoring.sharings', 'phoenix.internal.monitoring.links', 'phoenix.internal.monitoring.events']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'monitoring',
	    url: '/monitoring',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _center = __webpack_require__(113);

	var _center2 = _interopRequireDefault(_center);

	var _centerBoard = __webpack_require__(114);

	var _centerBoard2 = _interopRequireDefault(_centerBoard);

	var _eventsList = __webpack_require__(115);

	var _eventsList2 = _interopRequireDefault(_eventsList);

	var _centerPanel = __webpack_require__(116);

	var _centerPanel2 = _interopRequireDefault(_centerPanel);

	var _createEvents = __webpack_require__(119);

	var _createEvents2 = _interopRequireDefault(_createEvents);

	var _eventsDetails = __webpack_require__(120);

	var _eventsDetails2 = _interopRequireDefault(_eventsDetails);

	var _alertsDetails = __webpack_require__(122);

	var _alertsDetails2 = _interopRequireDefault(_alertsDetails);

	var _alertsFilter = __webpack_require__(123);

	var _alertsFilter2 = _interopRequireDefault(_alertsFilter);

	var _eventsPriority = __webpack_require__(124);

	var _eventsPriority2 = _interopRequireDefault(_eventsPriority);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.center', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'center',
	    url: '/center',
	    parent: 'monitoring',
	    menu: true,
	    alias: 'center',
	    controller: _center2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/center/center.html',
	    report: true,
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    redirectTo: 'center.board'
	  }).state({
	    name: 'center-panel',
	    url: '/center/panel',
	    parent: 'monitoring',
	    controller: _centerPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/center/panel/center.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'center.board',
	    url: '/board?filters',
	    controller: _centerBoard2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/center/board/center.board.html',
	    params: {
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'center.events-list',
	    url: '/events/list?filters',
	    controller: _eventsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/center/list/events.list.html',
	    params: {
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('CenterController', _center2.default).controller('CenterBoardController', _centerBoard2.default).controller('EventsListController', _eventsList2.default).controller('CenterPanelController', _centerPanel2.default).controller('CreateEventsController', _createEvents2.default).controller('EventsDetailsController', _eventsDetails2.default).controller('AlertsDetailsController', _alertsDetails2.default).controller('AlertsFilterController', _alertsFilter2.default).directive('eventsPriority', _eventsPriority2.default.directiveFactory);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CenterController = function () {
	  CenterController.$inject = ["$scope", "$state", "DialogService"];
	  function CenterController($scope, $state, DialogService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, CenterController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.DialogService = DialogService;

	    this.selectedTags = [];
	    this.filterableTags = [].concat(_toConsumableArray(_constants.PRIORITIES.HIGH), _toConsumableArray(_constants.PRIORITIES.MEDIUM), _toConsumableArray(_constants.PRIORITIES.LOW));
	    this.filters = {};

	    this.options = {
	      stats: true
	    };

	    this.$scope.$on('preventingRequestStack', function (ev, data) {
	      _this.pendingRequest = data;
	    });
	  }

	  _createClass(CenterController, [{
	    key: 'resetFilters',
	    value: function resetFilters() {
	      this.selectedTags = [];
	      this.filters = {};
	    }
	  }, {
	    key: 'filterByTag',
	    value: function filterByTag(tag) {
	      this.pendingRequest = true;
	      var tagPosition = this.selectedTags.indexOf(tag);
	      tagPosition < 0 ? this.selectedTags.push(tag) : this.selectedTags.splice(tagPosition, 1);

	      this.$scope.$broadcast('selectFilterTags', this.selectedTags);
	    }
	  }, {
	    key: 'openFilter',
	    value: function openFilter() {
	      var _this2 = this;

	      var opt = internals._dialogOpts(internals._urlPaths.alertFilter.path, internals._urlPaths.alertFilter.ctrl);
	      this.DialogService.openDialog(opt, this.filters).then(function (res) {
	        _this2.filters = res;
	        _this2.filters.short = {};
	        if (res.enterprises) {
	          _this2.filters.short.euuid = res.enterprises.map(function (e) {
	            return e.uuid;
	          });
	        }
	        if (res.devices) {
	          _this2.filters.short.duuid = res.devices.map(function (d) {
	            return d.uuid;
	          });
	        }
	        if (!res.flood) {
	          _this2.filters.short.flood = res.flood;
	        }
	        if (res.fromDate) {
	          _this2.filters.short.fromDate = res.fromDate;
	          _this2.filters.short.toDate = res.toDate;
	        }
	        _this2.$scope.$broadcast('selectFilterValues', _this2.filters.short);
	      });
	    }
	  }, {
	    key: 'hasActiveFilter',
	    value: function hasActiveFilter() {
	      if (Object.keys(this.filters).length === 0) return false;

	      var _filters = this.filters,
	          fromDate = _filters.fromDate,
	          toDate = _filters.toDate,
	          customDate = _filters.customDate,
	          enterprises = _filters.enterprises,
	          devices = _filters.devices,
	          flood = _filters.flood;

	      var changeIntervalDate = false;

	      if (fromDate) {
	        var diffDate = moment(toDate).diff(moment(fromDate), 'days');
	        changeIntervalDate = customDate || diffDate !== 7;
	      }
	      return enterprises.length > 0 || devices.length > 0 || flood || changeIntervalDate;
	    }
	  }]);

	  return CenterController;
	}();

	exports.default = CenterController;


	var internals = {
	  _urlPaths: {
	    alertFilter: {
	      path: 'app/internal/monitoring/center/components/alerts-filter/alerts-filter.html',
	      ctrl: 'AlertsFilterController'
	    }
	  },
	  _dialogOpts: function _dialogOpts(path, controller) {
	    return {
	      url: path,
	      controllerName: controller,
	      controllerAlias: 'ctrl',
	      bindToController: true,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      hasBackdrop: true,
	      parent: angular.element('#page-body')
	    };
	  }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AlertsBoardController = function () {
	  AlertsBoardController.$inject = ["$interval", "$scope", "$state", "$translate", "DialogService", "HttpService", "MainService"];
	  function AlertsBoardController($interval, $scope, $state, $translate, DialogService, HttpService, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, AlertsBoardController);

	    this.$interval = $interval;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.HttpService = HttpService;
	    this.MainService = MainService;

	    this.options = {
	      new: false,
	      stats: true
	    };

	    this.alertsObj = internals._initialAlertsFilterState();
	    this.eventsObj = internals._initialEventsFilterState();
	    this.items = internals._initialItemsState();
	    this.selectedAlerts = [];

	    this.loading = {};

	    this.selectedAlertGroupId = null;
	    this.steps = ['todo', 'doing', 'done'];

	    this.$scope.$on('$destroy', function () {
	      _this.cancelIntervalUpdateFeatures();
	    });
	    this.$scope.$on('selectFilterTags', function (ev, data) {
	      _this.filterByTag(data);
	    });
	    this.$scope.$on('selectFilterValues', function (ev, data) {
	      _this.filterByValues(data);
	    });

	    this.triggerLoadData();
	  }

	  _createClass(AlertsBoardController, [{
	    key: 'openCreateEvents',
	    value: function openCreateEvents() {
	      var _this2 = this;

	      var opt = internals._dialogOpts(internals._urlPaths.createEvent.path, internals._urlPaths.createEvent.ctrl);
	      this.DialogService.openDialog(opt, this.selectedAlerts).then(function (res) {
	        _this2.createEvent(res, true);
	      });
	    }
	  }, {
	    key: 'openAlertsDetails',
	    value: function openAlertsDetails(item) {
	      var opt = internals._dialogOpts(internals._urlPaths.alertDetails.path, internals._urlPaths.alertDetails.ctrl);
	      this.DialogService.openDialog(opt, item);
	    }
	  }, {
	    key: 'openEventsDetails',
	    value: function openEventsDetails(item) {
	      var opt = internals._dialogOpts(internals._urlPaths.eventDetails.path, internals._urlPaths.eventDetails.ctrl);
	      this.DialogService.openDialog(opt, item);
	    }
	  }, {
	    key: 'countNewAlerts',
	    value: function countNewAlerts() {
	      var _this3 = this;

	      if (this.$state.current.name !== 'center.board') {
	        this.cancelIntervalUpdateFeatures();
	        return;
	      }
	      this.loading.count = true;
	      this.anyLoading();

	      var obj = angular.copy(this.alertsObj);
	      delete obj.limit;

	      if (this.items.alerts.length) {
	        obj.filters.id = { operator: 'gt', value: this.items.alerts[0].id };
	      }

	      this.HttpService.cancelRequests(_constants.API.V4 + '/' + _constants.API.ALERTS);
	      this.MainService.raw(_constants.API.V4, _constants.API.ALERTS + '/count', obj).promise.then(function (res) {
	        _this3.loading.count = false;
	        _this3.totalNewAlerts = res.data.count;
	        _this3.anyLoading();
	      });
	    }
	  }, {
	    key: '_startCountInterval',
	    value: function _startCountInterval() {
	      var _this4 = this;

	      if (this.intervalPromise) return;
	      this.intervalPromise = this.$interval(function () {
	        _this4.countNewAlerts();
	      }, 60000);
	    }
	  }, {
	    key: 'cancelIntervalUpdateFeatures',
	    value: function cancelIntervalUpdateFeatures() {
	      if (!this.intervalPromise) return;
	      this.$interval.cancel(this.intervalPromise);
	      this.intervalPromise = null;
	    }
	  }, {
	    key: 'filterByValues',
	    value: function filterByValues(data) {
	      if (data.euuid.length > 0) {
	        this.alertsObj.filters.euuid = { operator: 'in', value: data.euuid.join(',') };
	        this.eventsObj.filters.euuid = { operator: 'in', value: data.euuid.join(',') };
	      } else {
	        delete this.alertsObj.filters.euuid;
	        delete this.eventsObj.filters.euuid;
	      }
	      if (data.duuid.length > 0) {
	        this.alertsObj.filters.duuid = { operator: 'in', value: data.duuid.join(',') };
	        this.eventsObj.filters.duuid = { operator: 'in', value: data.duuid.join(',') };
	      } else {
	        delete this.alertsObj.filters.duuid;
	        delete this.eventsObj.filters.duuid;
	      }
	      if (data.flood === false) {
	        this.alertsObj.filters.flood = { operator: 'is', value: data.flood };
	      } else {
	        delete this.alertsObj.filters.flood;
	      }

	      if (data.fromDate) {
	        this.alertsObj.filters.from_date.value = data.fromDate;
	        this.alertsObj.filters.to_date.value = data.toDate;
	      }

	      this.items = internals._initialItemsState();
	      this.triggerLoadData();
	    }
	  }, {
	    key: 'filterByTag',
	    value: function filterByTag(tags) {
	      this.alertsObj.filters.tag = { operator: 'in', value: tags.join(',') };
	      this.eventsObj.filters.tag = { operator: 'in', value: tags.join(',') };

	      if (tags.length > 0) {
	        this.items = internals._initialItemsState();
	      } else {
	        delete this.alertsObj.filters.tag;
	        delete this.eventsObj.filters.tag;
	      }

	      this.items = internals._initialItemsState();
	      this.triggerLoadData();
	    }
	  }, {
	    key: 'triggerLoadData',
	    value: function triggerLoadData() {
	      this.unSelectAlerts();
	      this.loadAlertsData();
	      this.loadEventsData();
	    }
	  }, {
	    key: 'loadAlertsData',
	    value: function loadAlertsData() {
	      var _this5 = this;

	      var latest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      this.loading.alerts = true;
	      this.anyLoading();

	      if (this.items.alerts.length > 0) {
	        if (latest) {
	          this.alertsObj.filters.id = { operator: 'gt', value: this.items.alerts[0].id };
	        } else {
	          this.alertsObj.filters.id = { operator: 'lt', value: this.items.alerts.slice(-1)[0].id };
	        }
	      }

	      this.MainService.raw(_constants.API.V4, _constants.API.ALERTS, this.alertsObj).promise.then(function (res) {
	        _this5.stopPropagation = res.data.length === 0;
	        _this5.loading.alerts = false;
	        if (latest) {
	          if (_this5.totalNewAlerts > (_this5.alertsObj.limit || 20)) {
	            _this5.items.alerts = [];
	          }
	          _this5.items.alerts = [].concat(_toConsumableArray(res.data), _toConsumableArray(_this5.items.alerts));
	        } else {
	          _this5.items.alerts = [].concat(_toConsumableArray(_this5.items.alerts), _toConsumableArray(res.data));
	        }
	        delete _this5.alertsObj.filters.id;
	        _this5.totalNewAlerts = 0;
	        _this5._startCountInterval();
	        _this5.anyLoading();
	      });
	    }
	  }, {
	    key: 'loadEventsData',
	    value: function loadEventsData(key) {
	      var _this6 = this;

	      if (angular.isDefined(key)) {
	        this.loading[key] = true;
	        this.anyLoading();
	        delete this.eventsObj.any;
	        delete this.eventsObj.count;
	        this.eventsObj.filters.status = { operator: 'eq', value: key };
	        this.eventsObj.filters.id = { operator: 'lt', value: this.items.events[key].slice(-1)[0].id };
	      } else {
	        delete this.eventsObj.filters.status;
	        delete this.eventsObj.filters.id;
	        this.eventsObj.any = {
	          board: { operator: 'eq', value: true }
	        };
	        this.eventsObj.count = true;
	      }

	      this.MainService.raw(_constants.API.V4, _constants.API.EVENTS, this.eventsObj).promise.then(function (res) {
	        if (key) {
	          _this6.loading[key] = false;
	          _this6.items.events[key] = [].concat(_toConsumableArray(_this6.items.events[key]), _toConsumableArray(res.data));
	          _this6.anyLoading();
	        } else {
	          _this6.items.events = internals._formatData(res.data);
	          _this6.items.count = internals._formatCount(res.data);
	        }
	      });
	    }
	  }, {
	    key: 'loadMoreAlerts',
	    value: function loadMoreAlerts() {
	      if (this.stopPropagation || this.loading.alerts || this.items.alerts.length === 0) {
	        return;
	      }
	      this.loadAlertsData();
	    }
	  }, {
	    key: 'loadMoreEvents',
	    value: function loadMoreEvents(key) {
	      if (this.loading[key] || this.items.events[key].length === this.items.count[key]) {
	        return;
	      }
	      this.loadEventsData(key);
	    }
	  }, {
	    key: 'createEvent',
	    value: function createEvent(obj, multples, item, toPosition) {
	      var _this7 = this;

	      if (item) {
	        item.loading = true;
	      }
	      this.MainService.create(_constants.API.V4, _constants.API.EVENTS, obj).promise.then(function (res) {
	        if (item) {
	          _this7.items.events.todo[toPosition] = res.data;
	        }
	        if (multples) {
	          _this7.items.events.todo = [res.data].concat(_toConsumableArray(_this7.items.events.todo));
	          _this7.selectedAlerts = null;
	          _this7.items.alerts = _this7.items.alerts.filter(function (i) {
	            return !i.selected;
	          });
	        }
	        _this7.unSelectAlerts();
	      });
	    }
	  }, {
	    key: 'updateEvent',
	    value: function updateEvent(obj, item) {
	      this.MainService.update(_constants.API.V4, _constants.API.EVENTS, item.id, obj);
	    }
	  }, {
	    key: 'deleteEvent',
	    value: function deleteEvent(item, fromPosition, toPosition, key) {
	      var _this8 = this;

	      // remove item from list
	      this.items.alerts.splice(toPosition, 1);
	      var opt = internals._dialogOpts(internals._urlPaths.confirmAction.path, internals._urlPaths.confirmAction.ctrl);
	      this.DialogService.openDialog(opt, { title: 'EVENTS', label: 'EVENTS', action: 'delete' }).then(function () {
	        _this8.MainService.deleteMany(_constants.API.V4, _constants.API.EVENTS + '/' + item.id);
	      }).catch(function () {
	        // get back to original state
	        _this8.items.events[key].splice(fromPosition, 0, item);
	      });
	    }
	  }, {
	    key: 'mountEvent',
	    value: function mountEvent(item, from, to, fromPosition, toPosition) {
	      var _this9 = this;

	      var obj = {};

	      if (from === to) {
	        return;
	      }

	      var translations = ['ALERTS.LABEL.ALERT_OF', 'ALERT_TAG.' + item.attributes.tag.toUpperCase() + '.TITLE'];
	      this.$translate(translations).then(function (t) {
	        var keys = Object.keys(t);
	        obj = {
	          data: {
	            title: t[keys[0]] + ' ' + t[keys[1]],
	            alerts: [item.attributes]
	          }
	        };
	        _this9.createEvent(obj, false, item, toPosition);
	      });
	    }
	  }, {
	    key: 'moveEvent',
	    value: function moveEvent(item, from, to, fromPosition, toPosition, key) {
	      var _this10 = this;

	      var lastStatus = key;
	      // destroy event
	      if (this.items.alerts[toPosition] === item) {
	        this.deleteEvent(item, fromPosition, toPosition, key);
	      } else {
	        // update event
	        this.steps.forEach(function (k) {
	          if (_this10.items.events[k][toPosition] === item) {
	            _this10.items.events[k][toPosition].status = k;
	          }
	        });

	        if (lastStatus !== item.status) {
	          var obj = {
	            data: {
	              status: item.status
	            }
	          };
	          this.updateEvent(obj, item);
	          this.items.count[lastStatus] -= 1;
	          this.items.count[item.status] += 1;
	        }
	      }
	    }
	  }, {
	    key: 'selectAlert',
	    value: function selectAlert() {
	      this.selectedAlerts = this.items.alerts.filter(function (i) {
	        return i.selected;
	      });
	      if (this.selectedAlerts.length > 0) {
	        this.selectedAlertGroupId = this.selectedAlerts[0].relationships.vehicle.id;
	      } else {
	        this.selectedAlertGroupId = null;
	      }
	    }
	  }, {
	    key: 'checkDisabled',
	    value: function checkDisabled(i) {
	      return this.selectedAlertGroupId && this.selectedAlertGroupId !== i.relationships.vehicle.id;
	    }
	  }, {
	    key: 'unSelectAlerts',
	    value: function unSelectAlerts() {
	      var _this11 = this;

	      this.selectedAlertGroupId = null;
	      this.selectedAlerts.map(function (i) {
	        return _this11._setFalse(i);
	      });
	      this.selectedAlerts = [];
	    }
	  }, {
	    key: 'anyLoading',
	    value: function anyLoading() {
	      var _this12 = this;

	      this.pendingRequest = false;
	      Object.keys(this.loading).forEach(function (i) {
	        _this12.pendingRequest = _this12.pendingRequest || _this12.loading[i];
	      });
	      this.$scope.$emit('preventingRequestStack', this.pendingRequest);
	    }
	  }, {
	    key: '_setFalse',
	    value: function _setFalse(i) {
	      i.selected = false;
	    }
	  }]);

	  return AlertsBoardController;
	}();

	exports.default = AlertsBoardController;


	var internals = {
	  uriToJson: function uriToJson(uri) {
	    if (uri) {
	      return angular.fromJson(atob(decodeURIComponent(uri)));
	    } // eslint-disable-line
	  },
	  jsonToUri: function jsonToUri(data) {
	    if (Object.keys(data).length > 0) {
	      return encodeURIComponent(btoa(angular.toJson(data)));
	    } // eslint-disable-line
	  },

	  _urlPaths: {
	    confirmAction: {
	      path: 'app/components/dialog/confirmation/confirmation.dialog.html',
	      ctrl: 'ConfirmationDialogController'
	    },
	    createEvent: {
	      path: 'app/internal/monitoring/center/components/create-events/create-events.dialog.html',
	      ctrl: 'CreateEventsController'
	    },
	    alertDetails: {
	      path: 'app/internal/monitoring/center/components/alerts-details/alerts-details.dialog.html',
	      ctrl: 'AlertsDetailsController'
	    },
	    eventDetails: {
	      path: 'app/internal/monitoring/center/components/events-details/events-details.dialog.html',
	      ctrl: 'EventsDetailsController'
	    }
	  },
	  _formatCount: function _formatCount(data) {
	    var keys = Object.keys(data);
	    var obj = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;

	    try {
	      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var i = _step.value;

	        obj[i] = data[i].count;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }

	    return obj;
	  },
	  _formatData: function _formatData(data) {
	    var keys = Object.keys(data);

	    if (keys.includes('count')) {
	      return {
	        events: data.events
	      };
	    } else {
	      var obj = {};
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;

	      try {
	        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var i = _step2.value;

	          obj[i] = data[i].events;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }

	      return obj;
	    }
	  },
	  _dialogOpts: function _dialogOpts(path, controller) {
	    return {
	      url: path,
	      controllerName: controller,
	      controllerAlias: 'ctrl',
	      bindToController: true,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      hasBackdrop: true,
	      parent: angular.element('#page-body')
	    };
	  },
	  _initialItemsState: function _initialItemsState() {
	    return {
	      alerts: [],
	      count: {
	        todo: 0,
	        doing: 0,
	        done: 0
	      },
	      events: {
	        todo: [],
	        doing: [],
	        done: []
	      }
	    };
	  },
	  _initialAlertsFilterState: function _initialAlertsFilterState() {
	    return {
	      limit: 15,
	      filters: {
	        from_date: { operator: 'eq', value: moment().subtract(7, 'days').format('YYYY-MM-DD') },
	        to_date: { operator: 'eq', value: moment().format('YYYY-MM-DD') },
	        flood: { operator: 'is', value: false }
	      }
	    };
	  },
	  _initialEventsFilterState: function _initialEventsFilterState() {
	    return {
	      limit: 15,
	      any: {
	        board: { operator: 'eq', value: true }
	      },
	      count: true,
	      filters: {}
	    };
	  },
	  _initialCountFilterState: function _initialCountFilterState() {
	    return {
	      filters: {
	        from_date: { operator: 'eq', value: moment().subtract(1, 'days').format('YYYY-MM-DD') },
	        to_date: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	      }
	    };
	  }
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EventsListController = function () {
	  EventsListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  function EventsListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, EventsListController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.MainService = MainService;

	    this.query = {
	      filters: {},
	      limit: 15
	    };
	    this.items = [];

	    this.selectedTags = [];
	    this.filterableTags = [].concat(_toConsumableArray(_constants.PRIORITIES.HIGH), _toConsumableArray(_constants.PRIORITIES.MEDIUM));
	    var watchNavbar = this.$scope.$on('scrollEvent', function () {
	      _this.loadMore();
	    });

	    this.$scope.$on('$destroy', watchNavbar);
	    this.$scope.$on('selectFilterTags', function (ev, data) {
	      _this.filterByTag(data);
	    });
	    this.$scope.$on('selectFilterValues', function (ev, data) {
	      _this.filterByValues(data);
	    });

	    this.loadData(this.query);
	    this.translateKeys();
	  }

	  _createClass(EventsListController, [{
	    key: 'filterByTag',
	    value: function filterByTag(tags) {
	      this.query.filters.tag = { operator: 'in', value: tags.join(',') };

	      if (tags.length > 0) {
	        this.items = [];
	      } else {
	        delete this.query.filters.tag;
	      }

	      this.loadData(this.query);
	    }
	  }, {
	    key: 'filterByValues',
	    value: function filterByValues(data) {
	      if (data.euuid.length > 0) {
	        this.query.filters.euuid = { operator: 'in', value: data.euuid.join(',') };
	      } else {
	        delete this.query.filters.euuid;
	      }
	      if (data.duuid.length > 0) {
	        this.query.filters.duuid = { operator: 'in', value: data.duuid.join(',') };
	      } else {
	        delete this.query.filters.duuid;
	      }

	      this.items = [];
	      this.loadData(this.query);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(query) {
	      var _this2 = this;

	      this.loading = true;
	      this.MainService.raw(_constants.API.V4, _constants.API.EVENTS, query).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.items = [].concat(_toConsumableArray(_this2.items), _toConsumableArray(res.data));
	        _this2.responseLength = res.data.length;
	        _this2.amount = res.count;
	      }).catch(function () {
	        _this2.loading = false;
	      }).finally(function () {
	        _this2.$scope.$emit('preventingRequestStack', false);
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      if (this.responseLength === this.query.limit && !this.loading) {
	        this.query.filters.id = { operator: 'lt', value: this.items.slice(-1)[0].id };
	        this.loadData(this.query);
	      }
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this3 = this;

	      var keys = ['PANEL.HEADER.TITLE_ENTERPRISE', 'PANEL.HEADER.VEHICLE_PLATE_TYPE', 'PANEL.HEADER.CREATED_BY_CREATED_AT', 'PANEL.HEADER.STATUS_CHANGE'];

	      this.$translate(keys).then(function (t) {
	        _this3.headers = [{
	          label: t['PANEL.HEADER.TITLE_ENTERPRISE'],
	          sort: false,
	          prop: 'title'
	        }, {
	          label: t['PANEL.HEADER.VEHICLE_PLATE_TYPE'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.CREATED_BY_CREATED_AT'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.STATUS_CHANGE'],
	          sort: false
	        }];
	      });
	    }
	  }]);

	  return EventsListController;
	}();

	exports.default = EventsListController;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _colorPalettes = __webpack_require__(103);

	var _bar = __webpack_require__(117);

	var _bar2 = _interopRequireDefault(_bar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CenterPanelController = function () {
	  CenterPanelController.$inject = ["$translate", "$window", "MainService"];
	  function CenterPanelController($translate, $window, MainService) {
	    'ngInject';

	    _classCallCheck(this, CenterPanelController);

	    this.$translate = $translate;
	    this.$window = $window;
	    this.MainService = MainService;

	    this.alerts = {
	      range: {
	        startDate: moment().subtract(7, 'd'),
	        endDate: moment()
	      }
	    };

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));

	    this.dateRangeConfig = {
	      locale: {
	        format: 'DD/MM/YYYY',
	        applyLabel: 'Aplicar',
	        cancelLabel: 'Cancelar',
	        daysOfWeek: _constants.weekdays[user.locale],
	        monthNames: _constants.months[user.locale]
	      },
	      maxSpan: {
	        days: 62
	      },
	      maxDate: moment(new Date())
	    };
	    this.header = _initial.header();
	    this.loadData();
	  }

	  _createClass(CenterPanelController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      var obj = {
	        filters: {
	          euuid: { operator: 'in', value: this.selectedEnterprise.uuid },
	          from_date: { operator: 'eq', value: this.alerts.range.startDate.format('YYYY-MM-DD') },
	          to_date: { operator: 'eq', value: this.alerts.range.endDate.format('YYYY-MM-DD') }
	        }
	      };
	      this.loading = true;
	      this.MainService.raw(_constants.API.V4, _constants.API.ALERTS + '/' + _constants.API.REPORTS + '/enterprise', obj).promise.then(function (res) {
	        _this.loading = false;

	        _this.enterpriseSummary = res.data;
	        _this.groupedByType = _this._groupByType(_this.enterpriseSummary.attributes);
	        _this.tableData = _this.formatDataToShow(_this.groupedByType);
	        // this.buildGraph()
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: '_groupByType',
	    value: function _groupByType(items) {
	      this.types = _initial.types();
	      var groupedResults = {};
	      this.types.forEach(function (t, index) {
	        for (var key in items[t]) {
	          if (!groupedResults[key]) {
	            groupedResults[key] = [0, 0, 0, 0];
	          }
	          if (items[t][key]) {
	            groupedResults[key][index] = items[t][key];
	          }
	        }
	      });

	      return groupedResults;
	    }
	  }, {
	    key: 'formatDataToShow',
	    value: function formatDataToShow(items) {
	      var _this2 = this;

	      var totalRows = Object.keys(items);
	      var totalByData = [].concat(_toConsumableArray(Array(totalRows.length).keys()));

	      var obj = totalByData.map(function (i) {
	        var newObj = {};
	        for (var key in _this2.header) {
	          var name = _this2.header[key];
	          if (name === 'type') {
	            newObj[name] = totalRows[i];
	          } else {
	            var index = key - 1;
	            newObj[name] = items[totalRows[i]][index];
	          }
	        }
	        return newObj;
	      });

	      return obj;
	    }
	  }, {
	    key: 'buildGraph',
	    value: function buildGraph() {
	      this.data = [];
	      this.data.push([].concat(_toConsumableArray(this.types)));
	      for (var key in this.groupedByType) {
	        this.data.push(this.groupedByType[key]);
	      }

	      var options = {
	        bindTo: 'graph',
	        structure: 'rows',
	        type: 'bar',
	        legend: true,
	        format: 'number',
	        palette: _colorPalettes.PALETTES.old_green,
	        size: {
	          height: 300
	        },
	        region: {
	          size: 10
	        },
	        axis: {
	          x: true,
	          y: true
	        },
	        noData: 'Sem dados',
	        labels: {
	          x: 'Tipos',
	          y: 'Quantidade'
	        }
	      };

	      var report = {
	        tips: Object.keys(this.groupedByType),
	        names: this.types,
	        data: this.data,
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      (0, _bar2.default)(options, report);
	    }
	  }]);

	  return CenterPanelController;
	}();

	exports.default = CenterPanelController;


	var _initial = {
	  header: function header() {
	    return ['type', 'count', 'countFlood', 'handledCount', 'handledCountFlood'];
	  },
	  types: function types() {
	    return ['countByType', 'countFloodByType', 'handledCountByType', 'handledCountFloodByType'];
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = barGraph;

	var _formatNumber = __webpack_require__(100);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	var _buildRegions = __webpack_require__(118);

	var _buildRegions2 = _interopRequireDefault(_buildRegions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global c3 */


	function barGraph(options, report) {
	  var _data;

	  var tips = report.tips;
	  return c3.generate({
	    bindto: '#' + options.bindTo,
	    data: (_data = {}, _defineProperty(_data, options.structure, report.data), _defineProperty(_data, 'type', options.type), _defineProperty(_data, 'names', report.names), _defineProperty(_data, 'hide', false), _defineProperty(_data, 'empty', {
	      label: {
	        text: options.noData
	      }
	    }), _data),
	    color: {
	      pattern: options.palette
	    },
	    legend: {
	      show: options.legend,
	      position: options.legend_position
	    },
	    tooltip: {
	      grouped: true,
	      format: {
	        title: function title(x) {
	          return tips[x];
	        }
	      }
	    },
	    regions: (0, _buildRegions2.default)(options.region.size),
	    size: {
	      height: options.size.height
	    },
	    point: {
	      show: true,
	      r: 3
	    },
	    grid: {
	      y: {
	        show: true
	      },
	      x: {
	        show: false
	      }
	    },
	    interaction: {
	      enabled: true
	    },
	    bar: {
	      width: {
	        ratio: 0.8
	      }
	    },
	    axis: {
	      y: {
	        show: options.axis.y,
	        min: 0,
	        inner: false,
	        label: options.labels.y,
	        lines: report.lines.y,
	        tick: {
	          outer: false,
	          format: function format(d) {
	            return (0, _formatNumber2.default)(d, options.format);
	          },
	          count: 5
	        },
	        padding: {
	          top: 10,
	          bottom: 0
	        }
	      },
	      x: {
	        show: options.axis.x,
	        label: options.labels.x
	      }
	    }
	  });
	}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _buildRegions;
	function _buildRegions(size) {
	  var regions = [];
	  for (var index = 0; index < size - 1; index += 2) {
	    regions.push({ start: index, end: index + 1 });
	  }
	  return regions;
	}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CreateEventsController = function () {
	  CreateEventsController.$inject = ["$mdDialog", "locals"];
	  function CreateEventsController($mdDialog, locals) {
	    'ngInject';

	    _classCallCheck(this, CreateEventsController);

	    this.$mdDialog = $mdDialog;
	    this.locals = locals;

	    this.tinymceOptions = internals._setEditOpts();
	    this.currentItem = angular.copy(this.locals.item);
	    this.mountData();
	  }

	  _createClass(CreateEventsController, [{
	    key: 'mountData',
	    value: function mountData() {
	      this.vehicle = this.currentItem[0].relationships.vehicle;
	      this.alerts = this.currentItem.map(function (a) {
	        return [a.attributes.tag, a.attributes.val];
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          title: this.event.attributes.title,
	          description: this.event.attributes.description,
	          alerts: this.currentItem.map(function (a) {
	            return a.attributes;
	          })
	        }
	      };
	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return CreateEventsController;
	}();

	exports.default = CreateEventsController;


	var internals = {
	  _setEditOpts: function _setEditOpts() {
	    return {
	      inline: false,
	      menubar: false,
	      statusbar: false,
	      selector: 'textarea',
	      min_height: 110,
	      toolbar: 'undo redo bold italic alignleft aligncenter alignright bullist numlist outdent indent code'
	    };
	  }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _events = __webpack_require__(121);

	var mapstyle = _interopRequireWildcard(_events);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EventsDetailsController = function () {
	  EventsDetailsController.$inject = ["$state", "$timeout", "$translate", "DialogService", "GeocodingService", "MainService", "MapHelper", "locals"];
	  function EventsDetailsController($state, $timeout, $translate, DialogService, GeocodingService, MainService, MapHelper, locals) {
	    'ngInject';

	    _classCallCheck(this, EventsDetailsController);

	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.MapHelper = MapHelper;
	    this.locals = locals;

	    this.status = ['todo', 'doing', 'done'];
	    this.section = 'comments';
	    this.coords = [];
	    this.loadData();
	  }

	  _createClass(EventsDetailsController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'getMap',
	    value: function getMap() {
	      this.staticMapImage = this.MapHelper.getStaticMap(this._buildFeature(), { w: 500, h: 300 });
	    }
	  }, {
	    key: 'addLayers',
	    value: function addLayers() {
	      var layers = [this.MapHelper.layerBuilder('alarms', 'symbol', { source: 'points', layout: mapstyle.alarm.layout, paint: mapstyle.alarm.paint })];

	      this.MapHelper.addLayers(layers);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      this.loading = true;
	      this.MainService.show(_constants.API.V4, _constants.API.EVENTS, this.locals.item.id).promise.then(function (res) {
	        _this.loading = false;
	        _this.event = res.data;
	        _this.getMap();
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(key, val) {
	      var obj = {
	        data: {}
	      };
	      obj.data[key] = val;

	      return this.MainService.update(_constants.API.V4, _constants.API.EVENTS, this.event.id, obj).promise;
	    }
	  }, {
	    key: 'removeAlertFromEvent',
	    value: function removeAlertFromEvent(data, index) {
	      var _this2 = this;

	      var obj = {
	        data: {
	          alertIds: [data.id]
	        }
	      };

	      var opt = internals._dialogOpts(internals._urlPaths.confirmAction.path, internals._urlPaths.confirmAction.ctrl);
	      this.DialogService.openDialog(opt, { title: 'ALERT_HANDLED', label: 'ALERT_HANDLED', action: 'delete' }).then(function () {
	        _this2.MainService.deleteMany(_constants.API.V4, _constants.API.EVENTS + '/' + _this2.event.id + '/' + _constants.API.ALERTS, obj).promise.then(function () {
	          _this2.event.relationships.alerts.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'resolveAddress',
	    value: function resolveAddress(alert) {
	      if (alert.address) {
	        return;
	      }
	      this.GeocodingService.getAddressFromCoords(alert.attributes.lng, alert.attributes.lat).promise.then(function (res) {
	        alert.address = res.display_name;
	      });
	    }
	  }, {
	    key: 'filterByDeviceName',
	    value: function filterByDeviceName(alert) {
	      if (alert.specs) {
	        return;
	      }
	      var currentDevice = this.event.relationships.devices.filter(function (d) {
	        return d.id === alert.attributes.did;
	      })[0];
	      alert.specs = {};
	      alert.specs.imei = currentDevice.attributes.imei;
	      alert.specs.brand_alias = currentDevice.relationships.device_type.attributes.brand_alias;
	    }
	  }, {
	    key: '_buildFeature',
	    value: function _buildFeature() {
	      var coords = [];
	      for (var index in this.event.relationships.alerts) {
	        coords.push([this.event.relationships.alerts[index].attributes.lng, this.event.relationships.alerts[index].attributes.lat]);
	      }
	      return coords;
	    }
	  }]);

	  return EventsDetailsController;
	}();

	exports.default = EventsDetailsController;


	var internals = {
	  _urlPaths: {
	    confirmAction: {
	      path: 'app/components/dialog/confirmation/confirmation.dialog.html',
	      ctrl: 'ConfirmationDialogController'
	    }
	  },
	  _dialogOpts: function _dialogOpts(path, controller) {
	    return {
	      url: path,
	      controllerName: controller,
	      controllerAlias: 'ctrl',
	      bindToController: true,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      hasBackdrop: true,
	      parent: angular.element('#page-body')
	    };
	  }
	};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  alarm: {
	    paint: {
	      'icon-color': '#FFC107'
	    },
	    layout: {
	      'icon-image': 'alarm',
	      'icon-size': 0.5,
	      'icon-allow-overlap': true,
	      visibility: 'visible'
	    }
	  }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AlertsDetailsController = function () {
	  AlertsDetailsController.$inject = ["locals", "DialogService", "GeocodingService"];
	  function AlertsDetailsController(locals, DialogService, GeocodingService) {
	    'ngInject';

	    _classCallCheck(this, AlertsDetailsController);

	    this.locals = locals;
	    this.DialogService = DialogService;
	    this.GeocodingService = GeocodingService;

	    this.currentItem = angular.copy(this.locals.item);
	    this.resolveAddress();
	  }

	  _createClass(AlertsDetailsController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'resolveAddress',
	    value: function resolveAddress() {
	      var _this = this;

	      this.GeocodingService.getAddressFromCoords(this.currentItem.attributes.lng, this.currentItem.attributes.lat).promise.then(function (res) {
	        _this.currentItem.address = res.display_name;
	      });
	    }
	  }]);

	  return AlertsDetailsController;
	}();

	exports.default = AlertsDetailsController;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AlertsFilterController = function () {
	  AlertsFilterController.$inject = ["$window", "DialogService", "MainService", "locals"];
	  function AlertsFilterController($window, DialogService, MainService, locals) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, AlertsFilterController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.locals = locals;
	    this.tags = _constants.TAGS;
	    this.defaultDay = 7;

	    this.isDirty = false;
	    this.devicesOptions = {
	      filters: {
	        'enterprise.id': { operator: 'isn', value: null }
	      }
	    };

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    var apply = function apply() {
	      return _this.applyData();
	    };
	    this.dateRangeConfig = internals._initialdataOptions(user, apply);

	    this.fillFilterInfo();
	  }

	  _createClass(AlertsFilterController, [{
	    key: 'clearFilters',
	    value: function clearFilters() {
	      if (this.isDirty || this.selectedEnterprises.length > 0 || this.selectedDevices.length > 0 || !this.filterFlood || this.btnSelected !== this.defaultDay) {
	        this.isDirty = false;
	        this.copiedSelectedEnterprises = [].concat(_toConsumableArray(this.selectedEnterprises));
	        this.copiedSelectedDevices = [].concat(_toConsumableArray(this.selectedDevices));
	        this.selectedEnterprises = [];
	        this.selectedDevices = [];
	        this.filterFlood = true;
	        this.selectDate(this.defaultDay);
	      }
	    }
	  }, {
	    key: 'fillFilterInfo',
	    value: function fillFilterInfo() {
	      this.selectedEnterprises = this.locals.item.enterprises || [];
	      this.selectedDevices = this.locals.item.devices || [];
	      this.filterFlood = this.locals.item.flood ? !this.locals.item.flood : true;

	      if (this.locals.item.fromDate) {
	        var _locals$item = this.locals.item,
	            fromDate = _locals$item.fromDate,
	            toDate = _locals$item.toDate,
	            customDate = _locals$item.customDate;

	        var startDate = moment(fromDate);
	        var endDate = moment(toDate);

	        this.fromDate = fromDate;
	        this.toDate = toDate;
	        this.btnSelected = customDate ? -1 : endDate.diff(startDate, 'days');

	        if (customDate) {
	          this.customDate = true;
	          this.dateRangeConfig.startDate = startDate;
	          this.dateRangeConfig.endDate = endDate;
	          this.dateRange = { startDate: startDate, endDate: endDate };
	        }
	      } else {
	        this.btnSelected = this.defaultDay;
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.DialogService.finishDialog();
	      if (this.copiedSelectedEnterprises) {
	        this.selectedEnterprises = [].concat(_toConsumableArray(this.copiedSelectedEnterprises));
	      }
	      if (this.copiedSelectedDevices) {
	        this.selectedDevices = [].concat(_toConsumableArray(this.copiedSelectedDevices));
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter() {
	      var obj = {
	        enterprises: this.selectedEnterprises,
	        devices: this.selectedDevices,
	        flood: !this.filterFlood,
	        fromDate: this.fromDate || false,
	        toDate: this.toDate || false,
	        customDate: this.customDate || false
	      };
	      this.DialogService.closeDialog(obj);
	    }
	  }, {
	    key: 'handleEnterpriseChange',
	    value: function handleEnterpriseChange(item) {
	      this.selectedEnterprise = item;
	      this.addItem('selectedEnterprises', 'selectedEnterprise');
	    }
	  }, {
	    key: 'handleDeviceChange',
	    value: function handleDeviceChange(item) {
	      this.selectedDevice = item;
	      this.addItem('selectedDevices', 'selectedDevice');
	    }
	  }, {
	    key: 'addItem',
	    value: function addItem(type, model) {
	      var _this2 = this;

	      if (this[model] === null) {
	        return;
	      }

	      var checklist = this[type].filter(function (i) {
	        return i.id === _this2[model].id;
	      });
	      if (checklist.length < 1) {
	        this[type].push(this[model]);
	      }

	      this[model] = null;
	      this.enterprise = null;
	      this.device = null;
	      this.isDirty = true;
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(type, index) {
	      this[type].splice(index, 1);
	      this.isDirty = true;
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate(day) {
	      this.btnSelected = day;
	      this.fromDate = moment().subtract(day, 'day').format('YYYY-MM-DD');
	      this.toDate = moment().format('YYYY-MM-DD');
	      this.customDate = false;
	      this.dateRange = null;
	    }
	  }, {
	    key: 'applyData',
	    value: function applyData() {
	      this.btnSelected = -1;
	      this.customDate = true;
	      this.fromDate = this.dateRange.startDate.format('YYYY-MM-DD');
	      this.toDate = this.dateRange.endDate.format('YYYY-MM-DD');
	    }
	  }]);

	  return AlertsFilterController;
	}();

	exports.default = AlertsFilterController;


	var internals = {
	  _initialdataOptions: function _initialdataOptions(user, apply) {
	    return {
	      autoApply: true,
	      opens: 'right',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      maxSpan: {
	        days: 90
	      },
	      startDate: moment().subtract(7, 'days'),
	      endDate: moment(),
	      maxDate: moment(),
	      minDate: moment().subtract(90, 'days'),
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          apply();
	        }
	      }
	    };
	  }
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EventsPriority = function () {
	  function EventsPriority() {
	    _classCallCheck(this, EventsPriority);

	    this.restrict = 'E';
	    this.scope = {
	      includedTags: '='
	    };
	  }

	  _createClass(EventsPriority, [{
	    key: 'link',
	    value: function link(scope, element) {
	      if (scope.includedTags.filter(function (x) {
	        return _constants.PRIORITIES.HIGH.includes(x);
	      }).length > 0) {
	        element.addClass('mt4 w-10 h-4 bg-red-700 rounded-sm');
	      } else if (scope.includedTags.filter(function (x) {
	        return _constants.PRIORITIES.MEDIUM.includes(x);
	      }).length > 0) {
	        element.addClass('mt4 w-10 h-4 bg-orange-400 rounded-sm');
	      } else {
	        element.addClass('mt4 w-10 h-4 bg-blue-700 rounded-sm');
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new EventsPriority();
	    }
	  }]);

	  return EventsPriority;
	}();

	EventsPriority.directiveFactory.$inject = [];

	exports.default = EventsPriority;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _historyList = __webpack_require__(126);

	var _historyList2 = _interopRequireDefault(_historyList);

	var _historyPanel = __webpack_require__(127);

	var _historyPanel2 = _interopRequireDefault(_historyPanel);

	var _historyShow = __webpack_require__(128);

	var _historyShow2 = _interopRequireDefault(_historyShow);

	var _history = __webpack_require__(129);

	var _history2 = _interopRequireDefault(_history);

	var _trajectories = __webpack_require__(130);

	var _trajectories2 = _interopRequireDefault(_trajectories);

	var _duration = __webpack_require__(133);

	var _duration2 = _interopRequireDefault(_duration);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.history', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'history-list',
	    url: '/history/list?filters',
	    parent: 'monitoring',
	    menu: true,
	    alias: 'history',
	    controller: _historyList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/history/list/history.list.html',
	    report: true,
	    params: {
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.CLIENT), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'history-panel',
	    url: '/history/panel',
	    parent: 'monitoring',
	    controller: _historyPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/history/panel/history.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'history-show',
	    url: '/history/show/:id',
	    parent: 'monitoring',
	    controller: _historyShow2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/history/show/history.show.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.CLIENT), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            enterprise: ['name', 'email'],
	            vehicle: ['*'],
	            device: ['name', 'imei']
	          }
	        };
	        return MainService.raw(_constants.API.V5, _constants.API.TRAJECTORIES + '/' + $stateParams.id, obj);
	      }]
	    }
	  });
	}]).controller('HistoryShowController', _historyShow2.default).controller('HistoryListController', _historyList2.default).controller('HistoryStatsController', _historyPanel2.default).service('HistoryService', _history2.default).service('TrajectoryService', _trajectories2.default).filter('duration', _duration2.default);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global c3 */


	var HistoryListController = function (_ListController) {
	  HistoryListController.$inject = ["$scope", "$state", "$translate", "$window", "DialogService", "MainService"];
	  _inherits(HistoryListController, _ListController);

	  function HistoryListController($scope, $state, $translate, $window, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, HistoryListController);

	    var _this = _possibleConstructorReturn(this, (HistoryListController.__proto__ || Object.getPrototypeOf(HistoryListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$translate = $translate;
	    _this.$window = $window;
	    _this.DialogService = DialogService;

	    var user = angular.fromJson(_this.$window.localStorage.getItem('user'));
	    _this.opt = _dialog.DIALOG._opts('app/components/advanced-search/advanced-search.dialog.html', 'AdvancedSearchDialogController');

	    _this.query = {
	      attributes: ['*'],
	      includes: {
	        enterprise: ['*'],
	        vehicle: ['*'],
	        device: ['*']
	      },
	      filters: {
	        acc: { operator: 'btw', value: moment().subtract(30, 'd').format('YYYY-MM-DD') + ',' + moment().format('YYYY-MM-DD') }
	      },
	      limit: 15,
	      page: 1
	    };

	    _this.hist = {
	      range: {
	        startDate: moment().subtract(30, 'd'),
	        endDate: moment()
	      }
	    };

	    _this.dateRangeConfig = {
	      autoApply: true,
	      opens: 'left',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      maxSpan: {
	        days: 31
	      },
	      maxDate: moment(),
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          _this.applyFilter();
	        }
	      }
	    };

	    _this.options = {
	      stats: true
	    };

	    _this.setProps(_constants.API.V5, _constants.API.TRAJECTORIES, _this.query, false);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(HistoryListController, [{
	    key: 'applyFilter',
	    value: function applyFilter(res) {
	      this.selectedVehicle = res;
	      var start = moment(this.hist.range.startDate).format('YYYY-MM-DD');
	      var end = moment(this.hist.range.endDate).format('YYYY-MM-DD');

	      start === end ? this.query.filters.acc = { operator: 'eq', value: '' + start } : this.query.filters.acc = { operator: 'btw', value: start + ',' + end };
	      if (this.selectedVehicle) {
	        this.query.filters.vid = { operator: 'eq', value: this.selectedVehicle.id };
	      } else {
	        delete this.query.filters.vid;
	        delete this.query.filters.ls;
	      }

	      this.items = [];
	      this.query.page = 1;
	      this.loadData(this.query);
	    }

	    // openAdvancedFilter () {
	    //   this.DialogService.openDialog(this.opt)
	    //     .then((res) => {
	    //       this.query.filters.ls = { operator: 'geoIntersects', value: angular.toJson([...res.data.polygon.geometry.coordinates]) }
	    //       this.items = []
	    //       this.loadData(this.query)
	    //     })
	    // }

	  }, {
	    key: 'openPanel',
	    value: function openPanel(trajectory, index) {
	      if (trajectory.opened) {
	        return;
	      }

	      trajectory.opened = true;
	      this.hasMov = trajectory.attributes.mov.reduce(function (a, b) {
	        return a + b;
	      });
	      if (this.hasMov > 0) {
	        return c3.generate({
	          bindto: '#trajectory-' + index,
	          data: {
	            columns: [trajectory.attributes.mov],
	            type: 'bar'
	          },
	          bar: {
	            width: {
	              ratio: 0.9
	            }
	          },
	          size: {
	            width: 445,
	            height: 78
	          },
	          color: {
	            pattern: ['#3b83f6']
	          },
	          tooltip: {
	            show: false
	          },
	          legend: {
	            show: false
	          },
	          point: {
	            show: false
	          },
	          axis: {
	            y: {
	              show: false
	            },
	            x: {
	              tick: {
	                outer: false
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.PLATE_MODEL', 'PANEL.HEADER.DEVICE_DATE', 'PANEL.HEADER.DISTANCE_DURATION', 'PANEL.HEADER.ALERTS_COURSES'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.PLATE_MODEL']
	        }, {
	          label: t['PANEL.HEADER.DEVICE_DATE']
	        }, {
	          label: t['PANEL.HEADER.DISTANCE_DURATION'],
	          sort: true,
	          prop: 'dur'
	        }, {
	          label: t['PANEL.HEADER.ALERTS_COURSES'],
	          sort: true,
	          prop: 'alCnt'
	        }];
	      });
	    }
	  }]);

	  return HistoryListController;
	}(_list2.default);

	exports.default = HistoryListController;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _timeseries = __webpack_require__(99);

	var _timeseries2 = _interopRequireDefault(_timeseries);

	var _colorPalettes = __webpack_require__(103);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HistoryStatsController = function () {
	  HistoryStatsController.$inject = ["$window", "MainService"];
	  function HistoryStatsController($window, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, HistoryStatsController);

	    this.$window = $window;
	    this.MainService = MainService;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.data = {
	      movement: {
	        report: Array(7).fill(Array(24).fill({ v: -1 }))
	      }
	    };
	    this.query = {
	      filters: {
	        acc: { operator: 'btw', value: moment().subtract(29, 'd').format('YYYY-MM-DD') + ',' + moment().format('YYYY-MM-DD') }
	      }
	    };

	    this.vehiclesOptions = {
	      includes: {
	        devices: ['name', 'imei', 'code']
	      },
	      filters: {
	        'devices.name': { operator: 'isn', value: null }
	      }
	    };

	    this.hist = {
	      range: {
	        startDate: moment().subtract(29, 'd'),
	        endDate: moment()
	      }
	    };

	    this.dateRangeConfig = {
	      autoApply: true,
	      opens: 'left',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      maxSpan: {
	        days: 29
	      },
	      maxDate: moment(),
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          _this.loadData();
	        }
	      }
	    };

	    this.reduced = {
	      dis: 0,
	      stCnt: 0,
	      stDur: 0,
	      alCnt: 0,
	      hisDur: 0,
	      spMax: 0
	    };
	    this.weekdays = _constants.weekdays[user.attributes.locale];

	    this.loadData();
	  }

	  _createClass(HistoryStatsController, [{
	    key: 'applyFilter',
	    value: function applyFilter() {
	      var start = moment(this.hist.range.startDate).format('YYYY-MM-DD');
	      var end = moment(this.hist.range.endDate).format('YYYY-MM-DD');

	      start === end ? this.query.filters.acc = { operator: 'eq', value: '' + start } : this.query.filters.acc = { operator: 'btw', value: start + ',' + end };

	      this.data.movement.report = Array(7).fill(Array(24).fill({ v: -1 }));
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      this.selectedVehicle = res;
	      this.applyFilter();
	      this.processing = true;
	      if (this.selectedVehicle) {
	        if (this.selectedVehicle.relationships.devices.length === 0) return;
	        var did = this.selectedVehicle.relationships.devices[0].id;
	        var vid = this.selectedVehicle.id;

	        this.MainService.raw(_constants.API.V5, 'trajectories/reports/activity/device/' + did + '/' + vid, this.query).promise.then(function (res) {
	          _this2.prepareActivities(res);
	        }).finally(function () {
	          _this2.processing = false;
	        });

	        this.MainService.raw(_constants.API.V5, 'trajectories/reports/movement/device/' + did + '/' + vid, this.query).promise.then(function (res) {
	          _this2.prepareMovement(res);
	        }).finally(function () {
	          _this2.processing = false;
	        });
	      } else {
	        this.MainService.raw(_constants.API.V5, 'trajectories/reports/activity/enterprise', this.query).promise.then(function (res) {
	          _this2.prepareActivities(res);
	        }).finally(function () {
	          _this2.processing = false;
	        });

	        this.MainService.raw(_constants.API.V5, 'trajectories/reports/movement/enterprise', this.query).promise.then(function (res) {
	          _this2.prepareMovement(res);
	        }).finally(function () {
	          _this2.processing = false;
	        });
	      }
	    }
	  }, {
	    key: 'setSpectrum',
	    value: function setSpectrum(value) {
	      return 'square-' + parseInt(value / this.interval);
	    }
	  }, {
	    key: 'prepareMovement',
	    value: function prepareMovement(obj) {
	      var _this3 = this;

	      var report = [];
	      this.maxIndex = 0;
	      this.minIndex = 0;
	      obj.data.attributes.report.forEach(function (day) {
	        var daysObj = [];
	        day.forEach(function (hour) {
	          var obj = {};
	          obj.v = hour;
	          _this3.maxIndex = hour > _this3.maxIndex ? hour : _this3.maxIndex;
	          _this3.minIndex = hour < _this3.minIndex ? hour : _this3.minIndex;
	          daysObj.push(obj);
	        });
	        report.push(daysObj);
	      });

	      this.data.movement.report = report;
	      var range = this.maxIndex - this.minIndex;
	      this.interval = parseInt(range / 10);
	    }
	  }, {
	    key: 'prepareActivities',
	    value: function prepareActivities(obj) {
	      var size = obj.data.attributes.date.length;

	      var disReport = {
	        names: {
	          dis: 'Distância',
	          disAvg: 'Distância Média'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['dis'].concat(_toConsumableArray(obj.data.attributes.dis)), ['disAvg'].concat(_toConsumableArray(obj.data.attributes.disAvg || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var durReport = {
	        names: {
	          dur: 'Duração',
	          durAvg: 'Duração Média'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['dur'].concat(_toConsumableArray(obj.data.attributes.dur)), ['durAvg'].concat(_toConsumableArray(obj.data.attributes.durAvg || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var stopReport = {
	        names: {
	          stCnt: 'Paradas',
	          stCntAvg: 'Média de Paradas'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['stCnt'].concat(_toConsumableArray(obj.data.attributes.stCnt)), ['stCntAvg'].concat(_toConsumableArray(obj.data.attributes.stCntAvg || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var stopDurReport = {
	        names: {
	          stDur: 'Tempo parado',
	          stDurAvg: 'Tempo médio parado'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['stDur'].concat(_toConsumableArray(obj.data.attributes.stDur)), ['stDurAvg'].concat(_toConsumableArray(obj.data.attributes.stDurAvg || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var alReport = {
	        names: {
	          alCnt: 'Alertas',
	          alCntAvg: 'Média de alertas'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['alCnt'].concat(_toConsumableArray(obj.data.attributes.alCnt)), ['alCntAvg'].concat(_toConsumableArray(obj.data.attributes.alCntAvg || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var hisReport = {
	        names: {
	          hisDur: 'Tempo histórico',
	          hisDurAvg: 'Tempo médio histórico',
	          hisDurMax: 'Tempo histórico máximo',
	          hisDurMin: 'Tempo histórico mínimo'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['hisDur'].concat(_toConsumableArray(obj.data.attributes.hisDur)), ['hisDurAvg'].concat(_toConsumableArray(obj.data.attributes.hisDurAvg || Array(size).fill(0))), ['hisDurMax'].concat(_toConsumableArray(obj.data.attributes.hisDurMax || Array(size).fill(0))), ['hisDurMin'].concat(_toConsumableArray(obj.data.attributes.hisDurMin || Array(size).fill(0)))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      var spReport = {
	        names: {
	          spMax: 'Velocidade máxima',
	          spAvg: 'Velocidade Média'
	        },
	        data: [['dates'].concat(_toConsumableArray(obj.data.attributes.date)), ['spMax'].concat(_toConsumableArray(obj.data.attributes.spMax)), ['spAvg'].concat(_toConsumableArray(obj.data.attributes.spAvg))],
	        lines: {
	          y: [],
	          x: []
	        }
	      };

	      (0, _timeseries2.default)(internals.opts('distance-report', 'distance', 'california', obj.data.attributes.date[0], size), disReport);
	      (0, _timeseries2.default)(internals.opts('duration-report', 'time', 'blue', obj.data.attributes.date[0], size), durReport);
	      (0, _timeseries2.default)(internals.opts('stop-report', 'number', 'sunny', obj.data.attributes.date[0], size), stopReport);
	      (0, _timeseries2.default)(internals.opts('stop-duration-report', 'time', 'retro', obj.data.attributes.date[0], size), stopDurReport);
	      (0, _timeseries2.default)(internals.opts('alerts-report', 'number', 'neon', obj.data.attributes.date[0], size), alReport);
	      (0, _timeseries2.default)(internals.opts('historical-report', 'time', 'green', obj.data.attributes.date[0], size), hisReport);
	      (0, _timeseries2.default)(internals.opts('speed-report', 'speed', 'gold', obj.data.attributes.date[0], size), spReport);

	      this.reduced.dis = obj.data.attributes.dis.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      this.reduced.stCnt = obj.data.attributes.stCnt.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      this.reduced.stDur = obj.data.attributes.stDur.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      this.reduced.alCnt = obj.data.attributes.alCnt.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      this.reduced.hisDur = obj.data.attributes.hisDur.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      this.reduced.spMax = obj.data.attributes.spMax.reduce(function (a, b) {
	        return Math.max(a, b);
	      }, 0);
	    }
	  }]);

	  return HistoryStatsController;
	}();

	exports.default = HistoryStatsController;


	var internals = {
	  opts: function opts(id, format, colorName, start, size) {
	    return {
	      bindTo: id,
	      type: 'bar',
	      legend: false,
	      format: format,
	      hide: false,
	      palette: _colorPalettes.PALETTES[colorName],
	      size: {
	        height: 300
	      },
	      region: {
	        start: start,
	        size: size
	      },
	      axis: {
	        x: true,
	        y: true
	      },
	      noData: 'Sem dados',
	      labels: {
	        x: 'Dias',
	        y: 'Unidades'
	      }
	    };
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global c3 */


	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HistoryShowController = function () {
	  HistoryShowController.$inject = ["$scope", "$timeout", "GeocodingService", "GeoLocation", "MainService", "MapHelper", "RiskAreaService", "TrajectoryService", "selectedItem"];
	  function HistoryShowController($scope, $timeout, GeocodingService, GeoLocation, MainService, MapHelper, RiskAreaService, TrajectoryService, selectedItem) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, HistoryShowController);

	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.GeocodingService = GeocodingService;
	    this.GeoLocation = GeoLocation;
	    this.MainService = MainService;
	    this.MapHelper = MapHelper;
	    this.RiskAreaService = RiskAreaService;
	    this.TrajectoryService = TrajectoryService;
	    this.selectedItem = selectedItem;

	    this.ranges = [];
	    this.selectall = false;
	    this.trajectoriesData = false;
	    this.reducedSegments = {};
	    this.filterOptions = {
	      segment: true,
	      alarm: false,
	      stop: false,
	      riskarea: false,
	      mark: false,
	      selectedMarks: false
	    };
	    this.resolvePromises();
	    this.selectTab('segments');
	    this.loadingBox = false;
	    this.nextPrevLoad = false;
	    this.prevNextData = internals._initialPrevNext();
	    this.speeds = [40, 80, 100];

	    this.$scope.$on('trajectoriesDataLoaded', function () {
	      _this.trajectoriesData = true;
	    });
	    this.$scope.$on('geoDataEvent', function (ev, data) {
	      _this.setGeoData(data);
	    });
	    this.$scope.$on('geoDataPrevNextEvent', function (ev, data) {
	      _this.setGeoPrevNext(data);
	    });
	    this.$scope.$on('$destroy', function () {
	      _this.TrajectoryService.customizeSegments = false;
	    });
	  }

	  _createClass(HistoryShowController, [{
	    key: 'recompute',
	    value: function recompute() {
	      var _this2 = this;

	      if (this.trajectory.relationships.device == null || this.trajectory.relationships.vehicle == null) {
	        return;
	      }

	      var obj = {
	        attributes: ['*'],
	        filters: {
	          acc: { operator: 'eq', value: this.trajectory.attributes.acc },
	          did: { operator: 'eq', value: this.trajectory.relationships.device.id },
	          vid: { operator: 'eq', value: this.trajectory.relationships.vehicle.id }
	        },
	        includes: {
	          enterprise: ['*'],
	          vehicle: ['*'],
	          device: ['*']
	        },
	        any: {
	          recompute: { operator: 'eq', value: true }
	        }
	      };

	      this.recomputing = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.TRAJECTORIES + '/by-keys', obj).promise.then(function (res) {
	        _this2.prepareData(res);
	        _this2.recomputing = false;
	      }).catch(function () {
	        _this2.recomputing = false;
	      });
	    }
	  }, {
	    key: 'resolvePromises',
	    value: function resolvePromises() {
	      var _this3 = this;

	      this.selectedItem.promise.then(function (res) {
	        _this3.prepareData(res);
	      });
	    }
	  }, {
	    key: 'prepareData',
	    value: function prepareData(res) {
	      this.trajectory = res.data;
	      this.today = moment(res.data.attributes.acc.toString()).format('DD/MM/YYYY');
	      this.startOfDay = moment(this.trajectory.attributes.acc.toString()).startOf('d');
	      this.endOfDay = moment(this.trajectory.attributes.acc.toString()).endOf('d');
	      this.prepareUserList();
	      this.buildMap(res.data);
	      this.setTimerSlider();
	      this.setMovGraph();
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(lng, lat) {
	      var _this4 = this;

	      this.addressLoad = true;
	      this.GeocodingService.getAddressFromCoords(lng, lat).promise.then(function (res) {
	        _this4.geoData.address = res.display_name;
	        _this4.geoData.maxspeed = res.maxspeed;
	      }).finally(function () {
	        _this4.addressLoad = false;
	      });
	    }
	  }, {
	    key: 'setGeoData',
	    value: function setGeoData(data) {
	      var _this5 = this;

	      this.$timeout(function () {
	        if (data.properties && data.properties.point) {
	          _this5.geoData = data;
	          _this5.geoData.properties.type = _this5.geoData.properties.type.toLowerCase();
	          _this5.geoData.properties.point = angular.fromJson(_this5.geoData.properties.point);
	          _this5.getAddress(_this5.geoData.properties.point.lng, _this5.geoData.properties.point.lat);
	          _this5.nextPrevLoad = false;
	        } else {
	          _this5.geoData = null;
	        }
	      }, 1);
	    }
	  }, {
	    key: 'setGeoPrevNext',
	    value: function setGeoPrevNext(data) {
	      var _this6 = this;

	      this.$timeout(function () {
	        Object.assign(_this6.prevNextData, data);
	        _this6.loadingBox = false;
	      }, 1);
	    }
	  }, {
	    key: 'goToPrevNext',
	    value: function goToPrevNext(data, step) {
	      this.loadingBox = true;
	      this.TrajectoryService.goToMark({ lng: data.properties.point.lng, lat: data.properties.point.lat }, this.prevNextData.current + step);
	    }
	  }, {
	    key: 'prepareUserList',
	    value: function prepareUserList() {
	      var _this7 = this;

	      if (!this.trajectory.relationships.vehicle.attributes.user_names) return;

	      this.trajectory.relationships.vehicle.relationships ? this.trajectory.relationships.vehicle.relationships.users = [] : this.trajectory.relationships.vehicle.relationships = { users: [] };

	      this.trajectory.relationships.vehicle.attributes.user_names.split(';').forEach(function (u) {
	        _this7.trajectory.relationships.vehicle.relationships.users.push({
	          attributes: { name: u },
	          type: 'users'
	        });
	      });
	    }
	  }, {
	    key: 'focusOnPath',
	    value: function focusOnPath() {
	      this.transformSeg();
	      this.highlight();
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap(data) {
	      var _this8 = this;

	      var build = function build(data, coords) {
	        var mapOptions = Object.assign({}, _constants.behaveMapConfig, { zoom: 7, minZoom: 3 }, coords);
	        var mapStyle = { layer: 'streets', version: 'v12' };

	        _this8.MapHelper.mapBuilder(mapStyle, mapOptions, _constants.controls);

	        _this8.MapHelper.map.once('load', function () {
	          _this8.RiskAreaService.build({ show: false });
	          _this8.TrajectoryService.build({ acc: data.attributes.acc, did: data.relationships.device.id, eid: data.relationships.enterprise.id, vid: data.relationships.vehicle.id, fit: true, att: ['SEGMENT,DETAILED,ALARM,STOP'] });
	        });
	      };
	      if (data.attributes.cen.toString() === '0,0') {
	        var coords = null;
	        var getGeoLocation = this.GeoLocation.getCoords();
	        getGeoLocation.then(function (res) {
	          coords = { center: [res.lng, res.lat] };
	        }).finally(function () {
	          build(data, coords);
	        });
	      } else {
	        this.TrajectoryService.dispatchSegments(data);
	        build(data, { center: data.attributes.cen });
	      }
	    }
	  }, {
	    key: 'switchFilter',
	    value: function switchFilter(filter, value) {
	      this.filterOptions[value] = !this.filterOptions[value];
	      this.TrajectoryService.setFilterToLayer(filter, this.filterOptions[value]);
	    }
	  }, {
	    key: 'selectAllSegs',
	    value: function selectAllSegs() {
	      var _this9 = this;

	      this.trajectory.attributes.segs.forEach(function (seg) {
	        seg.checked = _this9.selectedAll;
	      });
	      this.transformSeg();
	      this.highlight();
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight() {
	      this.TrajectoryService.highlightPath(this.ranges);
	      this.TrajectoryService.highlightMark(this.ranges);
	    }
	  }, {
	    key: 'transformSeg',
	    value: function transformSeg() {
	      this.ranges = this.trajectory.attributes.segs.filter(function (seg) {
	        return seg.checked;
	      }).map(function (seg) {
	        return {
	          start: new Date(seg.sta.act) / 1000,
	          end: new Date(seg.end.act) / 1000
	        };
	      });
	      this._reduceSegments();
	      this.TrajectoryService.clearSelectedTrajectories();
	    }
	  }, {
	    key: 'filterByTime',
	    value: function filterByTime() {
	      var _this10 = this;

	      this.trajectory.attributes.segs.forEach(function (seg) {
	        seg.checked = _this10.reportTimeSlider.min <= new Date(seg.sta.act) / 1000 && _this10.reportTimeSlider.max >= new Date(seg.end.act) / 1000;
	        _this10.transformSeg();
	      });
	      this.highlight();
	    }
	  }, {
	    key: 'switchRiskAreas',
	    value: function switchRiskAreas() {
	      if (this.filterOptions.riskarea) this.RiskAreaService.hide();else this.RiskAreaService.show();
	      this.filterOptions.riskarea = !this.filterOptions.riskarea;
	    }
	  }, {
	    key: 'switchProfile',
	    value: function switchProfile() {
	      this.openProfile = !this.openProfile;
	    }
	  }, {
	    key: 'setTimerSlider',
	    value: function setTimerSlider() {
	      var _this11 = this;

	      this.reportTimeSlider = {
	        min: this.startOfDay.unix(),
	        max: this.endOfDay.unix(),
	        options: {
	          floor: this.startOfDay.unix(),
	          ceil: this.endOfDay.unix(),
	          draggableRange: true,
	          translate: function translate(value) {
	            return moment.unix(value).format('HH:mm');
	          },

	          onEnd: function onEnd() {
	            _this11.filterByTime();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tab) {
	      this.selectedTab = tab;
	      this.selectedPath = 'app/internal/monitoring/history/components/' + tab + '/_' + tab + '.html';
	    }
	  }, {
	    key: 'setMovGraph',
	    value: function setMovGraph() {
	      return c3.generate({
	        bindto: '#trajectory-mov',
	        data: {
	          columns: [this.trajectory.attributes.mov],
	          type: 'bar'
	        },
	        bar: {
	          width: {
	            ratio: 0.9
	          }
	        },
	        size: {
	          height: 36
	        },
	        color: {
	          pattern: ['#bfdbfe']
	        },
	        tooltip: {
	          show: false
	        },
	        legend: {
	          show: false
	        },
	        point: {
	          show: false
	        },
	        axis: {
	          y: {
	            show: false
	          },
	          x: {
	            show: false
	          }
	        }
	      });
	    }
	  }, {
	    key: '_reduceSegments',
	    value: function _reduceSegments() {
	      var _this12 = this;

	      var indexChecked = [];

	      this.reducedSegments = Object.assign({}, _constants.DEFAULT_REDUCED_SEG);
	      this.trajectory.attributes.segs.filter(function (seg, index) {
	        if (seg.checked) indexChecked.push(index);
	        return seg.checked;
	      }).forEach(function (s) {
	        for (var key in _constants.REDUCED_SEG_KEYS) {
	          _this12.reducedSegments[_constants.REDUCED_SEG_KEYS[key]] = angular.isUndefined(_this12.reducedSegments[_constants.REDUCED_SEG_KEYS[key]]) ? 0 : _this12.reducedSegments[_constants.REDUCED_SEG_KEYS[key]] + s[_constants.REDUCED_SEG_KEYS[key]];
	        }
	      });
	      this.TrajectoryService.setTrajectoryData(indexChecked);
	    }
	  }]);

	  return HistoryShowController;
	}();

	exports.default = HistoryShowController;


	var internals = {
	  _initialPrevNext: function _initialPrevNext() {
	    return {
	      current: 0,
	      prev: null,
	      next: null,
	      total: 0
	    };
	  }
	};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HistoryService = function () {
	  HistoryService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function HistoryService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, HistoryService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(HistoryService, [{
	    key: 'geometry',
	    value: function geometry(version, model, obj, data) {
	      data = {
	        data: {
	          groups: [{
	            groupedBy: 'ign'
	          }, {
	            groupedBy: 'spd',
	            intervals: [[0, 60], [60, 80], [80, 999]]
	          }]
	        }
	      };
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, version, model, 'geom'].join('/');

	      if (obj && obj.filters) {
	        query.push(this._buildFilterParams(obj.filters));
	      }

	      if (obj) {
	        url = url + ('?q=' + encodeURIComponent(btoa(query.join('&'))));
	      }

	      this.$http({ url: url, method: 'POST', data: data }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: '_buildFilterParams',
	    value: function _buildFilterParams(params) {
	      var filters = [];
	      for (var key in params) {
	        filters.push('filters[' + key + '][' + params[key].operator + ']=' + params[key].value);
	      }

	      return filters.join('&');
	    }
	  }]);

	  return HistoryService;
	}();

	exports.default = HistoryService;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _trajectories = __webpack_require__(131);

	var trajectoriesMapStyle = _interopRequireWildcard(_trajectories);

	var _mapOptions = __webpack_require__(132);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TrajectoryService = function () {
	  TrajectoryService.$inject = ["$http", "$rootScope", "EnvironmentConfig", "MapHelper"];
	  function TrajectoryService($http, $rootScope, EnvironmentConfig, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, TrajectoryService);

	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MapHelper = MapHelper;
	    this.markerId = null;
	    this.allMarkers = [];
	    this.allSegments = [];
	    this.markersSeparateInSeg = [];
	    this.customizeSegments = false;

	    this.focusData = {
	      features: [],
	      type: 'FeatureCollection'
	    };
	  }

	  _createClass(TrajectoryService, [{
	    key: 'build',
	    value: function build(params, groups) {
	      this.srcName = 'src-trajectories';
	      this.MapHelper.addSources(['src-trajectories'], [{ data: null, type: 'geojson', generateId: true }]);
	      this.getData(params, groups);
	    }
	  }, {
	    key: 'cleanData',
	    value: function cleanData() {
	      this.MapHelper.setDataToSource(['src-trajectories'], null);
	    }
	  }, {
	    key: 'getData',
	    value: function getData(params, groups) {
	      var _this = this;

	      var obj = {
	        attributes: params.att || ['*'],
	        filters: {
	          acc: { operator: 'in', value: params.acc },
	          eid: { operator: 'eq', value: params.eid },
	          did: { operator: 'eq', value: params.did },
	          vid: { operator: 'eq', value: params.vid }
	        }
	      };

	      var data = {
	        data: {
	          groups: []
	        }
	      };

	      groups ? data.data.groups = groups : data.data.groups.push({ groupedBy: 'ign', intervals: [[true, true]] });
	      if (this.customizeSegments) {
	        data.data.groups.push({ groupedBy: 'spd', intervals: [[0, 40], [40, 80], [80, 100], [100, 999]] });
	      }
	      var query = [];
	      var url = [this.EnvironmentConfig.API, 'v5', 'trajectories', 'geom'].join('/');

	      if (obj && obj.attributes) {
	        query.push(this._buildAttributesParams(obj.attributes));
	      }
	      if (obj && obj.filters) {
	        query.push(this._buildFilterParams(obj.filters));
	      }

	      if (obj) {
	        url = url + ('?q=' + encodeURIComponent(btoa(query.join('&'))));
	      } // eslint-disable-line
	      this.$http({ url: url, method: 'POST', data: data }).then(function (res) {
	        _this.data = _this.customizeSegments ? _this.reSegments(res.data.data) : res.data.data;
	        if (_this.data.features.length > 0) {
	          _this.filterMarkers(_this.data);
	          _this.focusData.features = _this.data.features;
	        }
	        _this.draw(params);
	      });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(params) {
	      this.MapHelper.setDataToSource('src-trajectories', this.data);

	      var layers = [
	      // SEGMENT
	      this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.path, 'line', { source: 'src-trajectories', layout: trajectoriesMapStyle.path.layout, paint: trajectoriesMapStyle.path.paint, filter: trajectoriesMapStyle.path.filter }),
	      // SELECTED SEGMENT + STROKE
	      this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.selectedPathStroke, 'line', { source: 'src-trajectories', layout: trajectoriesMapStyle.selectedStroke.layout, paint: trajectoriesMapStyle.selectedStroke.paint, filter: trajectoriesMapStyle.selectedStroke.filter }), this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.selectedPath, 'line', { source: 'src-trajectories', layout: trajectoriesMapStyle.selectedPath.layout, paint: trajectoriesMapStyle.selectedPath.paint, filter: trajectoriesMapStyle.selectedPath.filter }),
	      // SEGMENTS ARROWS
	      this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.selectedArrows, 'symbol', { source: 'src-trajectories', layout: trajectoriesMapStyle.arrows.layout, paint: trajectoriesMapStyle.arrows.paint, filter: trajectoriesMapStyle.arrows.filter, minzoom: 10 }), this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.arrows, 'symbol', { source: 'src-trajectories', layout: trajectoriesMapStyle.arrows.layout, paint: trajectoriesMapStyle.arrows.paint, filter: trajectoriesMapStyle.arrows.filter, minzoom: 10 }),
	      // MARKS
	      this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.marks, 'circle', { source: 'src-trajectories', layout: trajectoriesMapStyle.marks.layout, paint: trajectoriesMapStyle.marks.paint, filter: trajectoriesMapStyle.marks.filter }), this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.selectedMarks, 'circle', { source: 'src-trajectories', layout: trajectoriesMapStyle.selectedMarks.layout, paint: trajectoriesMapStyle.selectedMarks.paint, filter: trajectoriesMapStyle.selectedMarks.filter }), this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.alarms, 'symbol', { source: 'src-trajectories', layout: trajectoriesMapStyle.alarms.layout, paint: trajectoriesMapStyle.alarms.paint, filter: trajectoriesMapStyle.alarms.filter, minzoom: 10 }), this.MapHelper.layerBuilder(_mapOptions.LAYERS_NAME.stops, 'symbol', { source: 'src-trajectories', layout: trajectoriesMapStyle.stops.layout, paint: trajectoriesMapStyle.stops.paint, filter: trajectoriesMapStyle.stops.filter, minzoom: 10 })];

	      this.MapHelper.addLayers(layers);

	      if (params.fit) {
	        this._fitPath(this._fitAll('data'));
	      }

	      this._events();
	      this.$rootScope.$broadcast('trajectoriesDataLoaded', { status: true });
	    }
	  }, {
	    key: 'highlightPath',
	    value: function highlightPath(range) {
	      var _this2 = this;

	      var specificFilter = ['any'];
	      range.forEach(function (r) {
	        specificFilter.push(['==', 'sta', r.start], ['==', 'end', r.end]);
	      });

	      if (this.customizeSegments) {
	        var equivalentSegment = [];
	        range.forEach(function (r) {
	          equivalentSegment.push(_this2.customSegments.findIndex(function (item) {
	            return item.start === r.start && item.end === r.end;
	          }));
	        });

	        equivalentSegment.forEach(function (i) {
	          specificFilter.push(['==', 'segment', i]);
	        });
	      }

	      this.MapHelper.map.setLayoutProperty('selected-path-stroke', 'visibility', 'visible');
	      this.MapHelper.map.setLayoutProperty('selected-path', 'visibility', 'visible');

	      var filter = ['all', specificFilter, ['==', 'type', 'SEGMENT']];

	      this.MapHelper.map.setFilter('selected-path', filter);
	      this.MapHelper.map.setFilter('selected-path-stroke', filter);
	      this._fitPath(this._fitAll('focusData'));
	    }
	  }, {
	    key: 'highlightMark',
	    value: function highlightMark(range) {
	      var specificFilter = ['any'];
	      range.forEach(function (r) {
	        specificFilter.push(['all', ['>=', ['get', 'act', ['get', 'point']], r.start], ['<=', ['get', 'act', ['get', 'point']], r.end]]);
	      });
	      if (!this.customizeSegments) {
	        this.MapHelper.map.setLayoutProperty('selected-marks', 'visibility', 'visible');
	      }

	      var filter = ['all', specificFilter];
	      this.MapHelper.map.setFilter('selected-marks', filter);
	    }
	  }, {
	    key: 'setFilterToLayer',
	    value: function setFilterToLayer(label, value) {
	      this.MapHelper.setLayoutProps(label, ['visibility', value ? 'visible' : 'none']);
	    }
	  }, {
	    key: 'layersVisibility',
	    value: function layersVisibility(param) {
	      this.setFilterToLayer(Object.values(_mapOptions.LAYERS_NAME), param);
	    }
	  }, {
	    key: 'filterMarkers',
	    value: function filterMarkers(data) {
	      var _this3 = this;

	      this.allMarkers = data.features.filter(function (item) {
	        return item.properties.type === 'DETAILED';
	      });
	      this.allSegments = data.features.filter(function (item) {
	        return item.properties.type === 'SEGMENT';
	      });
	      if (this.customizeSegments) {
	        this.markersSeparateInSeg = this.customSegments.map(function (item) {
	          var segStart = item.start;
	          var segEnd = item.end;
	          return _this3.allMarkers.filter(function (mark) {
	            return mark.properties.point.act >= segStart && mark.properties.point.act <= segEnd;
	          });
	        });
	      } else {
	        this.markersSeparateInSeg = this.allSegments.map(function (item) {
	          var segStart = item.properties.start;
	          var segEnd = item.properties.end;
	          return _this3.allMarkers.filter(function (mark) {
	            return mark.properties.point.act >= segStart && mark.properties.point.act <= segEnd;
	          });
	        });
	      }
	    }
	  }, {
	    key: 'dispatchSegments',
	    value: function dispatchSegments(data) {
	      this.customizeSegments = true;
	      if (!data.attributes.segs) {
	        data.attributes.segs = [];
	      }
	      this.customSegments = data.attributes.segs.map(function (s) {
	        return {
	          start: new Date(s.sta.act) / 1000,
	          end: new Date(s.end.act) / 1000
	        };
	      });
	    }
	  }, {
	    key: 'reSegments',
	    value: function reSegments(data) {
	      var dataLocal = angular.copy(data);
	      this.customSegments.forEach(function (s, i) {
	        dataLocal.features.forEach(function (item) {
	          if (item.properties.type === 'SEGMENT' && (item.properties.start === s.start || item.properties.end === s.end || item.properties.start > s.start && item.properties.end < s.end)) {
	            item.properties.segment = i;
	            var speed = item.properties.groups.filter(function (i) {
	              return i.groupedBy === 'spd';
	            });
	            item.properties.spd = speed.length > 0 ? speed[0].groupValue : 0;
	          }
	        });
	      });
	      return dataLocal;
	    }
	  }, {
	    key: 'setTrajectoryData',
	    value: function setTrajectoryData(index) {
	      var _this4 = this;

	      if (!angular.isArray(index) || this.allSegments.length === 0) return;
	      this.segmentsSelect = index.map(function (item) {
	        return _this4.markersSeparateInSeg[item];
	      }).flat();
	      var segments = index.map(function (item) {
	        return _this4.allSegments[item];
	      });

	      if (this.customizeSegments) {
	        segments = [];
	        index.forEach(function (segSelected) {
	          var _segments;

	          var filteredSegments = [].concat(_toConsumableArray(_this4.allSegments.filter(function (i) {
	            return i.properties.segment === segSelected;
	          })));
	          (_segments = segments).push.apply(_segments, _toConsumableArray(filteredSegments));
	        });
	      }

	      this.focusData.features = index.length > 0 ? segments : this.allSegments;
	      this._fitAll('focusData');
	    }
	  }, {
	    key: '_fitPath',
	    value: function _fitPath(path) {
	      if (angular.isUndefined(path)) return;
	      var bbox = turf.bbox(path);
	      this.MapHelper.map.fitBounds(bbox, {
	        padding: 150
	      });
	    }
	  }, {
	    key: '_fitAll',
	    value: function _fitAll(collection) {
	      var bounds = [];
	      this[collection].features.filter(function (e) {
	        return e.properties.type === 'SEGMENT';
	      }).map(function (i) {
	        return bounds.push.apply(bounds, _toConsumableArray(i.geometry.coordinates));
	      });

	      if (bounds.length > 1) {
	        return turf.lineString(bounds);
	      }
	    }
	  }, {
	    key: 'goToMark',
	    value: function goToMark(coords, currentIndex) {
	      var _this5 = this;

	      this.MapHelper.map.flyTo({
	        center: { lng: coords.lng, lat: coords.lat },
	        speed: 1.7
	      });

	      this.MapHelper.map.once('moveend', function () {
	        _this5.setPrevNext(currentIndex);
	        _this5.MapHelper.map.fire('click', { point: _this5.MapHelper.map.project({ lng: coords.lng, lat: coords.lat }), originalEvent: { nextPrev: true } });
	      });
	    }
	  }, {
	    key: 'clearSelectedTrajectories',
	    value: function clearSelectedTrajectories() {
	      this.$rootScope.$broadcast('geoDataEvent', { properties: null });

	      if (this.markerId !== null) {
	        this.MapHelper.map.removeFeatureState({ source: 'src-trajectories', id: this.markerId });
	      }
	    }
	  }, {
	    key: 'setPrevNext',
	    value: function setPrevNext(index) {
	      if (!angular.isNumber(index) && angular.isUndefined(this.collectionMarks)) return;

	      var prevNext = internals._initialPrevNext();

	      if (this.collectionMarks.length > 0) {
	        prevNext.current = index;
	        prevNext.total = this.collectionMarks.length;
	        prevNext.next = index < this.collectionMarks.length - 1 ? this.collectionMarks[index + 1] : null;
	        prevNext.prev = index > 0 ? this.collectionMarks[index - 1] : 0;
	      }

	      this.$rootScope.$broadcast('geoDataPrevNextEvent', prevNext);
	    }
	  }, {
	    key: '_events',
	    value: function _events() {
	      var _this6 = this;

	      this.MapHelper.map.on('click', function (e) {
	        if (angular.isDefined(e.preventDefault)) e.preventDefault();
	        _this6.clearSelectedTrajectories();
	      });

	      this.MapHelper.map.on('click', ['selected-marks', 'marks'], function (e) {
	        if (e.features.length === 0) return;

	        _this6.markerId = e.features[0].id;
	        _this6.$rootScope.$broadcast('geoDataEvent', { properties: e.features[0].properties });
	        _this6.MapHelper.map.setFeatureState({ source: 'src-trajectories', id: _this6.markerId }, { click: true });

	        if (angular.isUndefined(e.originalEvent.nextPrev)) {
	          _this6.MapHelper.map.flyTo({
	            center: e.lngLat,
	            speed: 1
	          });

	          var currentMark = angular.fromJson(e.features[0].properties.point);
	          _this6.collectionMarks = e.features[0].layer.id === 'selected-marks' ? _this6.segmentsSelect : _this6.allMarkers;
	          var indexCurrentMark = _this6.collectionMarks.findIndex(function (item) {
	            return item.properties.point.act === currentMark.act;
	          });
	          _this6.setPrevNext(indexCurrentMark);
	        }
	      });

	      this.MapHelper.map.on('click', ['alarms', 'stops'], function (e) {
	        e.preventDefault();
	        _this6.$rootScope.$broadcast('geoDataEvent', { properties: e.features[0].properties });
	        _this6.$rootScope.$broadcast('geoDataPrevNextEvent', internals._initialPrevNext());
	      });
	      this.MapHelper.map.on('mouseenter', ['marks', 'selected-marks', 'alarms', 'stops'], function () {
	        _this6.MapHelper.map.getCanvas().style.cursor = 'pointer';
	      });
	      this.MapHelper.map.on('mouseleave', ['marks', 'selected-marks', 'alarms', 'stops'], function () {
	        _this6.MapHelper.map.getCanvas().style.cursor = '';
	      });
	    }
	  }, {
	    key: '_buildFilterParams',
	    value: function _buildFilterParams(params) {
	      var filters = [];
	      for (var key in params) {
	        filters.push('filters[' + key + '][' + params[key].operator + ']=' + params[key].value);
	      }

	      return filters.join('&');
	    }
	  }, {
	    key: '_buildAttributesParams',
	    value: function _buildAttributesParams(params) {
	      return 'attributes=' + params.join(',');
	    }
	  }]);

	  return TrajectoryService;
	}();

	exports.default = TrajectoryService;


	var internals = {
	  _initialPrevNext: function _initialPrevNext() {
	    return {
	      current: 0,
	      prev: null,
	      next: null,
	      total: 0
	    };
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  selectedPath: {
	    paint: {
	      'line-color': ['case', ['==', ['get', 'spd'], 0], '#5792f0', // blue
	      ['==', ['get', 'spd'], 1], '#fda943', // orange
	      ['==', ['get', 'spd'], 2], '#d21e27', // red
	      ['==', ['get', 'spd'], 3], '#8f1614', // dark-red
	      '#5792f0'],
	      'line-width': {
	        base: 4,
	        stops: [[4, 2], [8, 8], [16, 16], [22, 20]]
	      }
	    },
	    layout: {
	      'line-cap': 'round',
	      'line-join': 'round',
	      'line-round-limit': 0.5,
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'SEGMENT']
	  },
	  selectedStroke: {
	    paint: {
	      'line-gap-width': {
	        base: 4,
	        stops: [[4, 1], [8, 6], [16, 14], [22, 18]]
	      },
	      'line-color': ['case', ['==', ['get', 'spd'], 0], '#497cce', ['==', ['get', 'spd'], 1], '#dd7a02', ['==', ['get', 'spd'], 2], '#ac2b30', ['==', ['get', 'spd'], 3], '#751210', '#497cce'],
	      'line-width': {
	        base: 4,
	        stops: [[4, 2], [8, 2], [12, 3], [16, 3]]
	      }
	    },
	    layout: {
	      'line-cap': 'round',
	      'line-join': 'round',
	      'line-round-limit': 0.5,
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'SEGMENT']
	  },
	  path: {
	    paint: {
	      'line-opacity': 0.85,
	      'line-color': '#b2b5b7',
	      'line-width': {
	        base: 4,
	        stops: [[4, 2], [8, 8], [16, 16], [22, 20]]
	      }
	    },
	    layout: {
	      'line-cap': 'round',
	      'line-join': 'round',
	      'line-round-limit': 0.5
	    },
	    filter: ['==', 'type', 'SEGMENT']
	  },
	  marks: {
	    paint: {
	      'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, ['case', ['boolean', ['feature-state', 'click'], false], 2, 1], 12, ['case', ['boolean', ['feature-state', 'click'], false], 4, 3], 17, ['case', ['boolean', ['feature-state', 'click'], false], 7, 6]],
	      'circle-color': ['case', ['boolean', ['feature-state', 'click'], false], '#FFF', '#dadada'],
	      'circle-stroke-width': {
	        base: 2,
	        stops: [[1, 0], [12, 1], [15, 2]]
	      },
	      'circle-stroke-color': ['case', ['boolean', ['feature-state', 'click'], false], '#000', '#888']
	    },
	    layout: {
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'DETAILED']
	  },
	  selectedMarks: {
	    paint: {
	      'circle-radius': {
	        base: 4,
	        stops: [[1, 2], [12, 5], [17, 7]]
	      },
	      'circle-color': ['case', ['boolean', ['feature-state', 'click'], false], '#666', '#fafafa'],
	      'circle-stroke-width': {
	        base: 2,
	        stops: [[1, 0], [12, 1], [17, 2]]
	      },
	      'circle-stroke-color': '#333'
	    },
	    layout: {
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'DETAILED']
	  },
	  alarms: {
	    paint: {
	      'icon-color': '#FFC107'
	    },
	    layout: {
	      'icon-image': 'alarm',
	      'icon-size': 0.5,
	      'icon-allow-overlap': true,
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'ALARM']
	  },
	  stops: {
	    paint: {
	      'icon-color': '#F44336'
	    },
	    layout: {
	      'icon-image': 'stop',
	      'icon-size': 0.5,
	      'icon-allow-overlap': true,
	      visibility: 'none'
	    },
	    filter: ['==', 'type', 'STOP']
	  },
	  arrows: {
	    layout: {
	      'symbol-placement': 'line',
	      'text-field': '➞',
	      'text-size': {
	        base: 1,
	        stops: [[8, 24], [12, 20], [16, 16]]
	      },
	      'symbol-spacing': {
	        base: 1,
	        stops: [[9, 15], [12, 30], [22, 60]]
	      },
	      'text-keep-upright': false
	    },
	    paint: {
	      'text-color': '#EAEAEA'
	    },
	    filter: ['==', 'type', 'SEGMENT']
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAPSTYLES = exports.MAPSTYLES = {
	  streets: { layer: 'streets', version: 'v12' },
	  outdoors: { layer: 'outdoors', version: 'v12' },
	  light: { layer: 'light', version: 'v11' },
	  dark: { layer: 'dark', version: 'v11' },
	  // satellite: { layer: 'satellite', version: 'v9' },
	  'satellite-streets': { layer: 'satellite-streets', version: 'v12' },
	  'navigation-day': { layer: 'navigation-day', version: 'v1' },
	  'navigation-night': { layer: 'navigation-night', version: 'v1' }
	};

	var SOURCES = exports.SOURCES = ['src-tracking', 'src-trajectories', 'src-stations', 'src-risk-areas', 'src-geofences'];

	var LAYERS_NAME = exports.LAYERS_NAME = {
	  pathStroke: 'path-stroke',
	  path: 'path',
	  selectedPathStroke: 'selected-path-stroke',
	  selectedPath: 'selected-path',
	  selectedArrows: 'selected-arrows',
	  arrows: 'arrows',
	  marks: 'marks',
	  selectedMarks: 'selected-marks',
	  alarms: 'alarms',
	  stops: 'stops'
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = duration;
	function duration() {
	  'use strict';

	  return function (input, short) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '00:00';
	    }

	    var secNum = parseInt(input);
	    var hours = Math.floor(secNum / 3600);
	    var minutes = Math.floor((secNum - hours * 3600) / 60);
	    var seconds = secNum - hours * 3600 - minutes * 60;

	    if (hours < 10) {
	      hours = '0' + hours;
	    }
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	    if (seconds < 10) {
	      seconds = '0' + seconds;
	    }

	    if (short) {
	      return hours + ':' + minutes;
	    }
	    return hours + ':' + minutes + ':' + seconds;
	  };
	}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _tracking = __webpack_require__(135);

	var _tracking2 = _interopRequireDefault(_tracking);

	var _trajectories = __webpack_require__(136);

	var _trajectories2 = _interopRequireDefault(_trajectories);

	var _commands = __webpack_require__(137);

	var _commands2 = _interopRequireDefault(_commands);

	var _riskArea = __webpack_require__(138);

	var _riskArea2 = _interopRequireDefault(_riskArea);

	var _erb = __webpack_require__(140);

	var _erb2 = _interopRequireDefault(_erb);

	var _tracking3 = __webpack_require__(142);

	var _tracking4 = _interopRequireDefault(_tracking3);

	var _geocoding = __webpack_require__(146);

	var _geocoding2 = _interopRequireDefault(_geocoding);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.tracking', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'tracking',
	    url: '/tracking?z&lat&lng&t&e&d&v',
	    parent: 'monitoring',
	    menu: true,
	    alias: 'tracking',
	    controller: _tracking2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/tracking/tracking.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.CLIENT))
	    },
	    params: {
	      z: { value: '5', dynamic: true },
	      lng: { dynamic: true },
	      lat: { dynamic: true },
	      t: { dynamic: true },
	      e: { dynamic: true },
	      d: { dynamic: true },
	      v: { dynamic: true }
	    }
	  });
	}]).controller('TrackingController', _tracking2.default).controller('TrackingHistoryController', _trajectories2.default).controller('TrackingCommandsController', _commands2.default).service('RiskAreaService', _riskArea2.default).service('ERBService', _erb2.default).service('TrackingService', _tracking4.default).service('GeocodingService', _geocoding2.default);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _mapOptions = __webpack_require__(132);

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var enterpriseRoles = [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY));
	var timeSliderLabels = {
	  0: 'Agora',
	  900: '15 min',
	  1800: '30 min',
	  3600: '1 hr',
	  7200: '2 hrs',
	  18000: '5 hrs',
	  86400: '24 hrs',
	  90000: 'Sempre'
	};
	var expandCard = {
	  enterprise: true,
	  vehicle: true,
	  device: true,
	  chip: true,
	  location: true,
	  users: true,
	  live: true,
	  street: true
	};

	var TrackingController = function () {
	  TrackingController.$inject = ["$rootScope", "$scope", "$state", "$timeout", "$translate", "$window", "DialogService", "EnvironmentConfig", "GeocodingService", "MainService", "MapHelper", "MapService", "TrackingService"];
	  function TrackingController($rootScope, $scope, $state, $timeout, $translate, $window, DialogService, EnvironmentConfig, GeocodingService, MainService, MapHelper, MapService, TrackingService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, TrackingController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.$window = $window;

	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.MapHelper = MapHelper;
	    this.MapService = MapService;
	    this.TrackingService = TrackingService;

	    this.colors = _constants.COLORS;
	    this.mapStyles = _mapOptions.MAPSTYLES;

	    // roles
	    this.enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.me = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.role = this.$window.localStorage.getItem('role');
	    this.isEnterpriseRole = enterpriseRoles.includes(this.role);

	    // new definitions
	    this.geocoderSearch = false;
	    this.selectedTab = 'general';
	    this.loadConfig = {
	      type: this.isEnterpriseRole ? 'enterprises' : 'responsibles',
	      id: this.isEnterpriseRole ? this.enterprise.id : this.me.id

	      // selection
	    };this.selectedItem = null;
	    this.users = [];
	    this.typed = true;

	    this.reportTimeSlider = {
	      reportedSince: 90000,
	      reportedUpTo: 0,
	      options: {
	        rightToLeft: true,
	        floor: 0,
	        ceilLabel: '24 hrs',
	        highLabel: 'Now',
	        ceil: 90000,
	        showTicks: false,
	        showTicksValue: false,
	        stepsArray: [0, 900, 1800, 3600, 7200, 18000, 86400, 90000],
	        translate: function translate(value) {
	          return timeSliderLabels[value];
	        },

	        onEnd: function onEnd() {
	          _this.filters.reportedSince = _this.reportTimeSlider.reportedSince;
	          _this.filters.reportedUpTo = _this.reportTimeSlider.reportedUpTo;
	          _this.setFilters();
	        }
	      }
	    };

	    this.controls = {
	      showDeviceInfo: false,
	      showRiskAreas: false,
	      showErbs: false
	    };

	    this.filters = {
	      clustering: true,
	      reportedSince: 90000,
	      reportedUpTo: 0,
	      vehicleState: '0',
	      vehicleType: {
	        CAR: true,
	        MOTORCYCLE: true,
	        'TRUCK/BUS': true,
	        OTHER: true
	      }
	    };

	    this.hyperlinkOptions = {
	      'google-maps': { initial: 'G', name: 'Google Maps' },
	      'google-earth': { initial: 'E', name: 'Google Earth' },
	      'google-streetview': { initial: 'S', name: 'Street View' },
	      waze: { initial: 'W', name: 'Waze' },
	      'microsoft-bing': { initial: 'B', name: 'Bing' }
	    };

	    this.expand = expandCard;
	    this.selectedMapStyle = 'streets';

	    this.$scope.$on('$destroy', function () {
	      _this.TrackingService.destroy();
	      _this.TrackingService.cancelIntervalUpdateFeatures();
	    });
	    this.$scope.$on('pickVehicle', function (ev, data) {
	      _this.selectItemFromMap(data);
	    });
	    this.$scope.$on('trackingDataPushed', function (ev, data) {
	      _this.liveDataPropagation(data);
	    });
	    this.$scope.$on('trackingLastConPushed', function (ev, data) {
	      _this.liveLastConPropagation(data);
	    });
	    this.buildMap();
	  }

	  _createClass(TrackingController, [{
	    key: 'liveDataPropagation',
	    value: function liveDataPropagation(data) {
	      if (this.selectedItem && this.selectedItem.relationships.last_gps.attributes.last_gps_raw.act === data.properties.act) return;
	      this.defineLinktoProvider();
	      var source = {
	        ign: data.properties.ign,
	        dir: data.properties.dir,
	        act: data.properties.act,
	        pv: data.properties.pv,
	        bl: data.properties.bl,
	        o1: data.properties.o1,
	        spd: data.properties.spd,
	        lng: data.geometry.coordinates[0],
	        lat: data.geometry.coordinates[1]
	      };
	      Object.assign(this.selectedItem.relationships.last_gps.attributes.last_gps_raw, source);
	      this.getAddress(data.geometry.coordinates[0], data.geometry.coordinates[1]);
	    }
	  }, {
	    key: 'liveLastConPropagation',
	    value: function liveLastConPropagation(data) {
	      if (this.selectedItem && this.selectedItem.relationships.device_last_con && this.selectedItem.relationships.device_last_con === data.last_connection) return;
	      this.selectedItem.relationships.device_last_con = data.last_connection;
	    }
	  }, {
	    key: 'selectItemFromMap',
	    value: function selectItemFromMap(data) {
	      var _this2 = this;

	      if (this.selectedItem && this.selectedItem.id === (0, _helper.hashify)(this.EnvironmentConfig.SALT, data.id)) return;

	      var obj = {
	        attributes: ['name', 'imei', 'code', 'from_softruck', 'nature', 'created_at', 'active'],
	        includes: {
	          enterprise: ['name', 'cnpj', 'fantasy_name', 'email', 'assistance_emergency_tel', 'theft_emergency_tel'],
	          vehicle: ['plate', 'vin', 'type_name', 'color', 'code', 'batch', 'model_name', 'brand_name'],
	          chip: ['serial', 'number', 'service_provider', 'carrier'],
	          type: ['brand_alias', 'alias', 'type', 'protocol'],
	          last_gps: ['*']
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + (0, _helper.hashify)(this.EnvironmentConfig.SALT, data.id), obj).promise.then(function (res) {
	        _this2.selectedItem = res.data;
	        _this2.$state.go('.', { e: _this2.selectedItem.relationships.enterprise.id, d: _this2.selectedItem.id, v: _this2.selectedItem.relationships.vehicle ? _this2.selectedItem.relationships.vehicle.id : null }, { notify: false });
	      });
	    }
	  }, {
	    key: 'searchItems',
	    value: function searchItems(query) {
	      var _this3 = this;

	      if (!this.typed) return '';
	      var obj = {
	        attributes: ['name', 'imei', 'code', 'from_softruck', 'nature', 'created_at', 'active'],
	        includes: {
	          enterprise: ['name', 'cnpj', 'fantasy_name', 'email', 'assistance_emergency_tel', 'theft_emergency_tel'],
	          vehicle: ['plate', 'vin', 'type_name', 'color', 'code', 'batch', 'model_name', 'brand_name'],
	          chip: ['serial', 'number', 'service_provider', 'carrier'],
	          type: ['brand_alias', 'alias', 'type', 'protocol'],
	          last_gps: ['*']
	        },
	        filters: {
	          enterprise_id: { operator: 'isn', value: null }
	        },
	        limit: 6,
	        page: 1,
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, _constants.API.DEVICES, obj).promise.then(function (res) {
	        return res.data;
	      }).finally(function () {
	        _this3.typed = false;
	      });
	    }
	  }, {
	    key: 'searchPlaces',
	    value: function searchPlaces(query) {
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'showStyleOptions',
	    value: function showStyleOptions() {
	      this.openMapStyle = true;
	    }
	  }, {
	    key: 'keepStyleOptions',
	    value: function keepStyleOptions() {
	      this.$timeout.cancel(this.styleOptionsTimer);
	    }
	  }, {
	    key: 'hideStyleOptions',
	    value: function hideStyleOptions() {
	      var _this4 = this;

	      this.styleOptionsTimer = this.$timeout(function () {
	        _this4.openMapStyle = false;
	      }, 1600);
	    }
	  }, {
	    key: 'changeMapStyle',
	    value: function changeMapStyle(style) {
	      var keepStyleOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      if (this.selectedMapStyle === style) return;

	      this.MapHelper.setStyle(style, keepStyleOptions);
	      this.selectedMapStyle = style;
	    }
	  }, {
	    key: 'setFilters',
	    value: function setFilters() {
	      this.TrackingService.flush(this.loadConfig, this.filters);
	    }
	  }, {
	    key: 'setItemData',
	    value: function setItemData() {
	      if (!this.selectedItem) {
	        this.users = [];
	        this.selectedTab = 'general';
	        this.controls.showDeviceInfo = false;
	        this.loadConfig.type = this.isEnterpriseRole ? 'enterprises' : 'responsibles';
	        this.loadConfig.id = this.isEnterpriseRole ? this.enterprise.id : this.me.id;
	        this.$state.go('.', { t: 'general', e: null, d: null, v: null }, { notify: false });
	        this.TrackingService.new(this.loadConfig, this.filters);
	        this.focusTracking();
	        this.MapHelper.setLayoutProps(['navigation-marker'], ['visibility', 'none']);
	      } else {
	        this.controls.showDeviceInfo = true;
	        this.loadConfig.type = 'devices';
	        this.loadConfig.id = (0, _helper.decodify)(this.EnvironmentConfig.SALT, this.selectedItem.id);
	        this.$state.go('.', { e: this.selectedItem.relationships.enterprise.id, d: this.selectedItem.id, v: this.selectedItem.relationships.vehicle ? this.selectedItem.relationships.vehicle.id : null }, { notify: false });
	        if (this.selectedItem.attributes.active) {
	          this.TrackingService.flush(this.loadConfig);
	          if (this.selectedItem.relationships.last_gps) {
	            this.defineLinktoProvider();
	            this.getAddress(this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng, this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat);
	            this.TrackingService.moveTo([this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng, this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat]);
	          }
	          if (this.$state.params.d) {
	            this.MapHelper.setLayoutProps(['devices', 'device-labels'], ['visibility', 'none']);
	            this.MapHelper.setLayoutProps(['navigation-marker'], ['visibility', 'visible']);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'openDialogVehicles',
	    value: function openDialogVehicles() {
	      var _this5 = this;

	      this.opt = _dialog.DIALOG._opts('app/components/new-item/add-vehicle.html', 'AddNewItemController');
	      this.selectedItem.relationships.enterprise.id = (0, _helper.decodify)(this.EnvironmentConfig.SALT, this.selectedItem.relationships.enterprise.id);

	      this.DialogService.openDialog(this.opt, { enterprise: this.selectedItem.relationships.enterprise }).then(function (res) {
	        var vehicleData = res;
	        var obj = {
	          data: [{
	            device_id: _this5.$state.params.d,
	            asset_id: (0, _helper.hashify)(_this5.EnvironmentConfig.SALT, res.id),
	            is_main_device: true
	          }]
	        };

	        _this5.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/devices', obj).promise.then(function () {
	          _this5.selectedItem.relationships.vehicle = vehicleData;
	        });
	      });
	    }
	  }, {
	    key: 'openDialogUsers',
	    value: function openDialogUsers() {
	      var _this6 = this;

	      var opt = _dialog.DIALOG._opts('app/components/new-item/add-user.html', 'AddNewItemController');

	      this.DialogService.openDialog(opt, { enterprise: this.selectedItem.relationships.enterprise }).then(function (res) {
	        var obj = {
	          data: [{
	            type: 'user_permission',
	            user_id: res.id,
	            asset_id: _this6.selectedItem.relationships.vehicle.id
	          }]
	        };

	        _this6.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {});
	      });
	    }
	  }, {
	    key: 'activateDevice',
	    value: function activateDevice() {
	      var _this7 = this;

	      var action = this.selectedItem.attributes.active ? 'deactivation' : 'activation';
	      var obj = {
	        data: [{
	          type: 'devices',
	          id: this.selectedItem.id
	        }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'DEVICE_ACTIVATION', action: 'save' }).then(function () {
	        _this7.MainService.edit(_constants.API.V5, _constants.API.DEVICES + '/set-activation/' + action, obj).promise.then(function () {
	          if (action === 'activation') {
	            _this7.selectedItem.attributes.active = true;
	            _this7.TrackingService.flush(_this7.loadConfig);
	            _this7.TrackingService.moveTo([_this7.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng, _this7.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat]);
	          } else {
	            _this7.selectedItem.attributes.active = false;
	          }
	        });
	      }).catch(function () {
	        _this7.selectedItem.attributes.active = false;
	      });
	    }
	  }, {
	    key: 'goToLocation',
	    value: function goToLocation() {
	      if (!this.selectedPlace) return;

	      this.MapHelper.map.jumpTo({
	        center: [this.selectedPlace.geometry.location.lng, this.selectedPlace.geometry.location.lat],
	        zoom: 15
	      });
	      this.$state.go('.', { z: 12, lng: this.selectedPlace.geometry.location.lng, lat: this.selectedPlace.geometry.location.lat }, { notify: false });
	    }
	  }, {
	    key: 'setTab',
	    value: function setTab(tab) {
	      if (this.selectedTab !== tab) {
	        if (tab === 'trajectories') {
	          this.focusTrajectories();
	        }
	        if (tab === 'general') {
	          this.focusTracking();
	        }
	      }

	      this.$state.go('.', { t: tab }, { notify: false });
	      this.selectedTab = tab;
	    }
	  }, {
	    key: 'focusTrajectories',
	    value: function focusTrajectories() {
	      this.MapHelper.setLayoutProps(['devices', 'cluster', 'cluster-count', 'device-labels', 'navigation-marker'], ['visibility', 'none']);
	      this.TrackingService.cancelIntervalUpdateFeatures();
	    }
	  }, {
	    key: 'focusTracking',
	    value: function focusTracking() {
	      this.MapHelper.setLayoutProps(['devices', 'cluster', 'cluster-count', 'device-labels', 'navigation-marker'], ['visibility', 'visible']);
	      this.MapHelper.removeLayers(['path-stroke', 'path', 'selected-path-stroke', 'selected-path', 'selected-arrows', 'marks', 'selected-marks', 'arrows', 'stops', 'alarms']);
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap() {
	      var _this8 = this;

	      this.$state.go('.', { t: 'general', e: null, d: null, v: null }, { notify: false });
	      var build = this.MapService.new();
	      build.then(function () {
	        _this8.MapHelper.map.once('load', function () {
	          _this8.TrackingService.new(_this8.loadConfig, _this8.filters);
	        });
	      });
	    }
	  }, {
	    key: 'toggleErbs',
	    value: function toggleErbs() {
	      if (this.controls.showErbs) this.MapService.showErbs();else this.MapService.hideErbs();
	    }
	  }, {
	    key: 'toggleRiskarea',
	    value: function toggleRiskarea() {
	      if (this.controls.showRiskAreas) this.MapService.showRiskArea();else this.MapService.hideRiskArea();
	    }
	  }, {
	    key: 'defineLinktoProvider',
	    value: function defineLinktoProvider() {
	      var lat = this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat;
	      var lng = this.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng;

	      this.hyperlinkOptions['google-maps'].link = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
	      this.hyperlinkOptions['google-earth'].link = 'https://earth.google.com/web/search/' + lat + ',' + lng;
	      this.hyperlinkOptions['google-streetview'].link = 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + lat + ',' + lng;
	      this.hyperlinkOptions.waze.link = 'https://www.waze.com/ul?ll=' + lat + '%2C' + lng + '&navigate=yes&zoom=17';
	      this.hyperlinkOptions['microsoft-bing'].link = 'https://www.bing.com/maps?cp=' + lat + '~' + lng;
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(lng, lat) {
	      var _this9 = this;

	      this.GeocodingService.getAddressFromCoords(lng, lat).promise.then(function (res) {
	        _this9.selectedItem.relationships.last_gps.attributes.address = res.display_name;
	        _this9.selectedItem.relationships.last_gps.attributes.maxspeed = res.maxspeed;
	      });
	    }
	  }]);

	  return TrackingController;
	}();

	exports.default = TrackingController;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global c3 */


	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TrackingHistoryController = function () {
	  TrackingHistoryController.$inject = ["$scope", "$state", "$timeout", "GeocodingService", "MainService", "TrajectoryService"];
	  function TrackingHistoryController($scope, $state, $timeout, GeocodingService, MainService, TrajectoryService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, TrackingHistoryController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;

	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.TrajectoryService = TrajectoryService;

	    this.ranges = [];
	    this.selectall = false;
	    this.trajectoriesData = false;
	    this.filterOptions = {
	      segment: true,
	      alarm: false,
	      stop: false,
	      mark: false
	    };

	    this.loadData();
	    this.$scope.$on('trajectoriesDataLoaded', function () {
	      _this.trajectoriesData = true;
	    });
	    this.$scope.$on('geoDataEvent', function (ev, data) {
	      _this.setGeoData(data);
	    });
	  }

	  _createClass(TrackingHistoryController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      if (this.$state.params.d == null || this.$state.params.v == null) {
	        return;
	      }
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        filters: {
	          acc: { operator: 'eq', value: moment().format('YYYY-MM-DD') },
	          did: { operator: 'eq', value: this.$state.params.d },
	          vid: { operator: 'eq', value: this.$state.params.v }
	        },
	        any: {
	          recompute: { operator: 'eq', value: true }
	        }
	      };
	      this.MainService.raw(_constants.API.V5, _constants.API.TRAJECTORIES + '/by-keys', obj).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.trajectory = res.data;
	        _this2.startOfDay = moment(_this2.trajectory.attributes.acc.toString()).startOf('d');
	        _this2.endOfDay = moment(_this2.trajectory.attributes.acc.toString()).endOf('d');
	        _this2.buildMap(res.data);
	        _this2.setTimerSlider();
	        _this2.setMovGraph();
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap() {
	      this.TrajectoryService.build({ acc: moment().format('YYYY-MM-DD'), eid: this.$state.params.e, did: this.$state.params.d, vid: this.$state.params.v, fit: true });
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(lng, lat) {
	      var _this3 = this;

	      this.GeocodingService.getAddressFromCoords(lng, lat).promise.then(function (res) {
	        _this3.geoData.address = res.display_name;
	        _this3.geoData.maxspeed = res.maxspeed;
	      });
	    }
	  }, {
	    key: 'setGeoData',
	    value: function setGeoData(data) {
	      var _this4 = this;

	      this.$timeout(function () {
	        if (data.properties && data.properties.point) {
	          _this4.geoData = data;
	          _this4.geoData.properties.type = _this4.geoData.properties.type.toLowerCase();
	          _this4.geoData.properties.point = angular.fromJson(_this4.geoData.properties.point);
	          _this4.getAddress(_this4.geoData.properties.point.lng, _this4.geoData.properties.point.lat);
	        } else {
	          _this4.geoData = null;
	        }
	      }, 1);
	    }
	  }, {
	    key: 'switchFilter',
	    value: function switchFilter(filter, value) {
	      this.filterOptions[value] = !this.filterOptions[value];
	      this.TrajectoryService.setFilterToLayer(filter, this.filterOptions[value]);
	    }
	  }, {
	    key: 'selectAllSegs',
	    value: function selectAllSegs() {
	      var _this5 = this;

	      this.trajectory.attributes.segs.forEach(function (seg) {
	        seg.checked = _this5.selectedAll;
	      });
	      this.transformSeg();
	      this.highlight();
	    }
	  }, {
	    key: 'focusOnPath',
	    value: function focusOnPath() {
	      this.transformSeg();
	      this.highlight();
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight() {
	      this.TrajectoryService.highlightPath(this.ranges);
	      this.TrajectoryService.highlightMark(this.ranges);
	    }
	  }, {
	    key: 'transformSeg',
	    value: function transformSeg() {
	      this.ranges = this.trajectory.attributes.segs.filter(function (seg) {
	        return seg.checked;
	      }).map(function (seg) {
	        return {
	          start: new Date(seg.sta.act) / 1000,
	          end: new Date(seg.end.act) / 1000
	        };
	      });
	    }
	  }, {
	    key: 'filterByTime',
	    value: function filterByTime() {
	      var _this6 = this;

	      this.trajectory.attributes.segs.forEach(function (seg) {
	        seg.checked = _this6.reportTimeSlider.min <= new Date(seg.sta.act) / 1000 && _this6.reportTimeSlider.max >= new Date(seg.end.act) / 1000;
	        _this6.transformSeg();
	      });
	      this.highlight();
	    }
	  }, {
	    key: 'setMovGraph',
	    value: function setMovGraph() {
	      return c3.generate({
	        bindto: '#trajectory-mov',
	        data: {
	          columns: [this.trajectory.attributes.mov],
	          type: 'bar'
	        },
	        bar: {
	          width: {
	            ratio: 0.9
	          }
	        },
	        size: {
	          width: 354,
	          height: 36
	        },
	        color: {
	          pattern: ['#bfdbfe']
	        },
	        tooltip: {
	          show: false
	        },
	        legend: {
	          show: false
	        },
	        point: {
	          show: false
	        },
	        axis: {
	          y: {
	            show: false
	          },
	          x: {
	            show: false
	          }
	        }
	      });
	    }
	  }, {
	    key: 'setTimerSlider',
	    value: function setTimerSlider() {
	      var _this7 = this;

	      this.reportTimeSlider = {
	        min: this.startOfDay.unix(),
	        max: this.endOfDay.unix(),
	        options: {
	          floor: this.startOfDay.unix(),
	          ceil: this.endOfDay.unix(),
	          draggableRange: true,
	          translate: function translate(value) {
	            return moment.unix(value).format('HH:mm');
	          },

	          onEnd: function onEnd() {
	            _this7.filterByTime();
	          }
	        }
	      };
	    }
	  }]);

	  return TrackingHistoryController;
	}();

	exports.default = TrackingHistoryController;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TrackingCommandsController = function () {
	  TrackingCommandsController.$inject = ["$scope", "$state", "DialogService", "MainService"];
	  function TrackingCommandsController($scope, $state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, TrackingCommandsController);

	    this.$scope = $scope;
	    this.$state = $state;

	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.expand = {};
	    this.availableCommands = {};

	    this.getAvailableCommands();
	  }

	  _createClass(TrackingCommandsController, [{
	    key: 'getAvailableCommands',
	    value: function getAvailableCommands() {
	      var _this = this;

	      if (this.$state.params.d == null) {
	        return;
	      }

	      this.loading = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.d + '/available-commands').promise.then(function (res) {
	        _this.loading = false;
	        res.data.attributes.commands.forEach(function (command) {
	          var category = command.split(/-|_/)[0];
	          if (!Object.keys(_this.availableCommands).includes(category)) {
	            _this.availableCommands[category] = [];
	            _this.expand[category] = false;
	          }

	          var sample = {
	            name: command,
	            fields: []
	          };
	          var itens = command.match(/\<<(.*?)\>>/g);
	          if (itens) {
	            itens.forEach(function (i) {
	              var obj = {
	                name: i,
	                type: ['<<FILE_URL>>', '<<RAW>>'].includes(i) ? 'text' : 'number',
	                value: null
	              };
	              sample.fields.push(obj);
	            });
	          }

	          _this.availableCommands[category].push(sample);
	        });
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'prepareCommand',
	    value: function prepareCommand(command) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'COMMANDS', label: 'COMMANDS', action: 'save' }).then(function () {
	        var obj = {
	          data: {
	            device_ids: [_this2.$state.params.d]
	          }
	        };

	        if (command.fields.length) {
	          var values = [];
	          command.fields.forEach(function (i) {
	            values.push(i.value);
	          });
	          obj.data.command = command.name.split('-')[0] + '-' + values.join('-');
	        } else {
	          obj.data.command = command.name;
	        }

	        _this2.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/commands', obj);
	      });
	    }
	  }]);

	  return TrackingCommandsController;
	}();

	exports.default = TrackingCommandsController;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _riskAreas = __webpack_require__(139);

	var riskAreasMapStyle = _interopRequireWildcard(_riskAreas);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultSourceOptions = {
	  srcName: 'src-risk-areas',
	  show: false
	};

	var RiskAreaService = function () {
	  RiskAreaService.$inject = ["EnvironmentConfig", "MapHelper"];
	  function RiskAreaService(EnvironmentConfig, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, RiskAreaService);

	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MapHelper = MapHelper;
	  }

	  _createClass(RiskAreaService, [{
	    key: 'build',
	    value: function build() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { srcName: 'src-risk-areas' };

	      var sourceObj = Object.assign({}, defaultSourceOptions, options);
	      this.srcName = sourceObj.srcName;
	      this.MapHelper.addSources([sourceObj.srcName], [{ type: 'vector', url: 'mapbox://marcelosoftruck.3rofo7xz' }]);

	      var layers = [this.MapHelper.layerBuilder('risk-area', 'fill', { 'source-layer': 'risk-areas-5yiu13', source: sourceObj.srcName, layout: riskAreasMapStyle.area.layout, paint: riskAreasMapStyle.area.paint, minzoom: 10 }), this.MapHelper.layerBuilder('risk-area-border', 'line', { 'source-layer': 'risk-areas-5yiu13', source: sourceObj.srcName, layout: riskAreasMapStyle.border.layout, paint: riskAreasMapStyle.border.paint, minzoom: 10 }), this.MapHelper.layerBuilder('risk-area-label', 'symbol', { 'source-layer': 'risk-areas-5yiu13', source: sourceObj.srcName, layout: riskAreasMapStyle.label.layout, paint: riskAreasMapStyle.label.paint, minzoom: 12 })];

	      this.MapHelper.addLayers(layers);
	      if (!sourceObj.show) {
	        this.hide();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.MapHelper.map.setLayoutProperty('risk-area', 'visibility', 'none');
	      this.MapHelper.map.setLayoutProperty('risk-area-border', 'visibility', 'none');
	      this.MapHelper.map.setLayoutProperty('risk-area-label', 'visibility', 'none');
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.MapHelper.map.setLayoutProperty('risk-area', 'visibility', 'visible');
	      this.MapHelper.map.setLayoutProperty('risk-area-border', 'visibility', 'visible');
	      this.MapHelper.map.setLayoutProperty('risk-area-label', 'visibility', 'visible');
	    }
	  }]);

	  return RiskAreaService;
	}();

	exports.default = RiskAreaService;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  area: {
	    layout: {},
	    paint: {
	      'fill-color': '#FF5722', // #ed6498 #D15159 #d13737 ef3b5e
	      'fill-opacity': 0.3
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  },
	  border: {
	    layout: {},
	    paint: {
	      'line-opacity': 0.6,
	      'line-color': '#FF5722',
	      'line-width': {
	        'stops': [[11, 1], [12, 2]]
	      }
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  },
	  label: {
	    layout: {
	      'icon-allow-overlap': false,
	      'text-field': '{name}',
	      'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Regular'],
	      'text-size': ['interpolate', ['linear'], ['zoom'], 11, 11, 13, 13],
	      'text-transform': 'none',
	      'text-justify': 'center',
	      'text-letter-spacing': 0.05
	    },
	    paint: {
	      'text-color': '#fff',
	      'text-halo-color': '#212121',
	      'text-halo-width': 1,
	      'text-opacity': 1
	    },
	    filter: ['any', ['>=', ['number', ['get', 'area']], 700000], ['all', ['>=', ['number', ['get', 'area']], 200000], ['>=', ['zoom'], 11]], ['all', ['>=', ['number', ['get', 'area']], 100000], ['>=', ['zoom'], 12]], ['any', ['>=', ['zoom'], 13]]]
	  }
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _erb = __webpack_require__(141);

	var erbMapStyle = _interopRequireWildcard(_erb);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultSourceOptions = {
	  srcName: 'src-stations',
	  show: false
	};

	var ERBService = function () {
	  ERBService.$inject = ["MapHelper"];
	  function ERBService(MapHelper) {
	    'ngInject';

	    _classCallCheck(this, ERBService);

	    this.MapHelper = MapHelper;
	  }

	  _createClass(ERBService, [{
	    key: 'build',
	    value: function build() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { srcName: 'src-stations', show: false };

	      var sourceObj = Object.assign({}, defaultSourceOptions, options);
	      this.srcName = sourceObj.srcName;
	      this.MapHelper.addSources([sourceObj.srcName], [{ type: 'vector', url: 'mapbox://marcelosoftruck.1qwogdot' }]);

	      var layers = [this.MapHelper.layerBuilder('erb-stations', 'circle', { 'source-layer': 'erbs-6gkze7', source: sourceObj.srcName, paint: erbMapStyle.points.paint, minzoom: 8 })];

	      this.MapHelper.addLayers(layers);
	      this._events();
	      if (!sourceObj.show) {
	        this.hide();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.MapHelper.map.setLayoutProperty('erb-stations', 'visibility', 'none');
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.MapHelper.map.setLayoutProperty('erb-stations', 'visibility', 'visible');
	    }
	  }, {
	    key: '_events',
	    value: function _events() {
	      var _this = this;

	      this.MapHelper.map.on('mouseenter', 'erb-stations', function () {
	        _this.MapHelper.map.getCanvas().style.cursor = 'pointer';
	      });
	      this.MapHelper.map.on('mouseleave', 'erb-stations', function () {
	        _this.MapHelper.map.getCanvas().style.cursor = '';
	      });
	      this.MapHelper.map.on('click', 'erb-stations', function (e) {
	        var text = '<div>\n        <div><strong>' + e.features[0].properties.owner + '</strong><div>\n        <div>' + angular.fromJson(e.features[0].properties.gen) + '<div>\n      </div>';
	        new mapboxgl.Popup().setLngLat(e.lngLat).setHTML(text).addTo(_this.MapHelper.map);
	      });
	    }
	  }]);

	  return ERBService;
	}();

	exports.default = ERBService;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  points: {
	    paint: {
	      'circle-color': ['match', ['get', 'owner'], 'OI MÓVEL S.A.', '#fbb03b', 'TELEFÔNICA BRASIL S.A.', '#650099', 'CLARO S.A.', '#e55e5e', 'TIM S/A', '#3bb2d0', '#223b53'],
	      'circle-radius': 4
	    }
	  }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _trackingPoints = __webpack_require__(143);

	var points = _interopRequireWildcard(_trackingPoints);

	var _trackingCluster = __webpack_require__(144);

	var clusters = _interopRequireWildcard(_trackingCluster);

	var _trackingNavigation = __webpack_require__(145);

	var navigations = _interopRequireWildcard(_trackingNavigation);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MIN_ZOOM_TO_INTERVAL = 12;

	var TrackingService = function () {
	  TrackingService.$inject = ["$http", "$interval", "$rootScope", "$state", "$window", "EnvironmentConfig", "ERBService", "HttpService", "MapHelper", "RiskAreaService"];
	  function TrackingService($http, $interval, $rootScope, $state, $window, EnvironmentConfig, ERBService, HttpService, MapHelper, RiskAreaService) {
	    'ngInject';

	    _classCallCheck(this, TrackingService);

	    this.$window = $window;
	    this.$http = $http;
	    this.$interval = $interval;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.ERBService = ERBService;
	    this.HttpService = HttpService;
	    this.MapHelper = MapHelper;
	    this.RiskAreaService = RiskAreaService;

	    this.keepTracking = false;
	  }

	  _createClass(TrackingService, [{
	    key: 'new',
	    value: function _new(loadConfig, filter) {
	      this.build(loadConfig, filter);
	    }
	  }, {
	    key: 'build',
	    value: function build(params) {
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      this.params = params;
	      this.filters = filters;
	      this.draw();
	      this.events();
	      this.setNewData();
	    }
	  }, {
	    key: 'flush',
	    value: function flush(loadConfig, filters) {
	      this.params = loadConfig;
	      if (filters) this.filters = filters;
	      this.setNewData();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.MapHelper.deleteMap();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;

	      if (this.params.type === 'enterprises') {
	        this.updateFiltersByMov();
	      }

	      var url = [this.EnvironmentConfig.TRACKING_API, this.params.type, this.params.id].join('/');
	      var urlLastCon = url;

	      if (this.params && this.params.type) {
	        url = url + ('?' + this._buildFilterParams(this.filters));
	      }
	      this.HttpService.cancelRequests(url);

	      this.HttpService.createCancelableRequest({ url: url, method: 'GET' }).then(function (res) {
	        _this.data = res.data;
	        if (_this.params.type === 'devices') {
	          if (_this.keepTracking) {
	            _this.MapHelper.map.panTo(_this.data.geometry.coordinates, { duration: 1000 });
	          }
	          _this.$http({ url: urlLastCon + '/last-con', method: 'GET' }).then(function (res) {
	            _this.$rootScope.$broadcast('trackingLastConPushed', res.data);
	          });
	          _this.$rootScope.$broadcast('trackingDataPushed', _this.data);
	        }
	        _this.MapHelper.setDataToSource('src-tracking', _this.data);
	      }).catch(function () {
	        _this.cleanData();
	      });
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.MapHelper.addSources(['src-tracking'], [{ data: null, type: 'geojson', cluster: false, clusterMaxZoom: 14, clusterRadius: 30, maxzoom: 16, buffer: 0 }]);

	      var layers = [this.MapHelper.layerBuilder('cluster', 'circle', { source: 'src-tracking', filter: ['has', 'point_count'], paint: clusters.cluster.paint }), this.MapHelper.layerBuilder('cluster-count', 'symbol', { source: 'src-tracking', filter: ['has', 'point_count'], paint: clusters.count.paint, layout: clusters.count.layout }), this.MapHelper.layerBuilder('devices', 'circle', { source: 'src-tracking', filter: ['!has', 'point_count'], paint: points.point.paint }), this.MapHelper.layerBuilder('device-labels', 'symbol', { source: 'src-tracking', minzoom: 12, filter: ['!has', 'point_count'], layout: points.label.layout, paint: points.label.paint }), this.MapHelper.layerBuilder('navigation-marker', 'symbol', { source: 'src-tracking', filter: ['!has', 'point_count'], layout: navigations.navigation.layout })];

	      this.MapHelper.addLayers(layers);
	    }
	  }, {
	    key: 'cleanData',
	    value: function cleanData() {
	      this.MapHelper.setDataToSource('src-tracking', null);
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(coords) {
	      this.MapHelper.map.flyTo({ center: coords, zoom: 14 });
	    }
	  }, {
	    key: 'events',
	    value: function events() {
	      var _this2 = this;

	      this.MapHelper.map.on('click', ['devices', 'navigation-marker'], function (e) {
	        var feature = e.features[0].toJSON();
	        _this2.$rootScope.$broadcast('pickVehicle', { id: feature.properties.id });
	      });
	      this.MapHelper.map.on('zoomend', function () {
	        var zoom = _this2.MapHelper.map.getZoom();
	        var oldZoom = _this2.$state.params.z;
	        _this2.$state.go('.', { z: zoom }, { notify: false });
	        if (Math.abs(zoom - oldZoom) > 0.5) {
	          _this2.setNewData();
	        }
	      });
	      this.MapHelper.map.on('dragend', function () {
	        var oldCenter = { lng: _this2.$state.params.lng, lat: _this2.$state.params.lat };
	        var center = _this2.MapHelper.map.getCenter();
	        _this2.$state.go('.', { lng: center.lng, lat: center.lat }, { notify: false });

	        var centerPoint = turf.point([center.lng, center.lat]);
	        var oldCenterPoint = turf.point([oldCenter.lng, oldCenter.lat]);

	        var distance = turf.distance(centerPoint, oldCenterPoint);
	        if (distance > 1) {
	          _this2.setNewData();
	        }
	      });

	      this.MapHelper.map.on('mouseenter', ['devices', 'navigation-marker'], function () {
	        _this2.MapHelper.map.getCanvas().style.cursor = 'pointer';
	      });
	      this.MapHelper.map.on('mouseleave', ['devices', 'navigation-marker'], function () {
	        _this2.MapHelper.map.getCanvas().style.cursor = '';
	      });
	    }
	  }, {
	    key: 'setNewData',
	    value: function setNewData() {
	      if (this.$state.params.t === 'trajectories') {
	        return;
	      }
	      this._setTimer();
	      this.getData();
	    }
	  }, {
	    key: 'setIntervalUpdateFeatures',
	    value: function setIntervalUpdateFeatures(timer) {
	      var _this3 = this;

	      if (this.intervalPromise) return;
	      this.intervalPromise = this.$interval(function () {
	        _this3.setNewData();
	      }, timer);
	    }
	  }, {
	    key: 'cancelIntervalUpdateFeatures',
	    value: function cancelIntervalUpdateFeatures() {
	      if (!this.intervalPromise) return;
	      this.$interval.cancel(this.intervalPromise);
	      this.intervalPromise = null;
	    }
	  }, {
	    key: 'updateFiltersByMov',
	    value: function updateFiltersByMov() {
	      this.filters.bbox = this._getMapBbox();
	      this.filters.zoom = this.MapHelper.map.getZoom();
	    }
	  }, {
	    key: '_setTimer',
	    value: function _setTimer() {
	      var zoom = this.MapHelper.map.getZoom();
	      this.cancelIntervalUpdateFeatures();
	      this.keepTracking = false;
	      if (zoom < MIN_ZOOM_TO_INTERVAL && this.params.type === 'enterprises') {
	        this.setIntervalUpdateFeatures(120000);
	      } else if (zoom >= MIN_ZOOM_TO_INTERVAL && this.params.type === 'enterprises') {
	        this.setIntervalUpdateFeatures(30000);
	      } else if (zoom < MIN_ZOOM_TO_INTERVAL && this.params.type !== 'enterprises') {
	        this.setIntervalUpdateFeatures(30000);
	      } else if (zoom > MIN_ZOOM_TO_INTERVAL && this.params.type !== 'enterprises') {
	        this.keepTracking = true;
	        this.setIntervalUpdateFeatures(15000);
	      }
	    }
	  }, {
	    key: '_buildFilterParams',
	    value: function _buildFilterParams(params) {
	      var filters = [];
	      // auth
	      filters.push('token=' + this.$window.localStorage.getItem('token'));
	      // enterprise
	      if (params && params.bbox) {
	        filters.push('bbox=' + angular.toJson(params.bbox));
	      }
	      if (params && params.zoom) {
	        filters.push('zoom=' + params.zoom);
	      }

	      // rest
	      if (params && params.vehicleType) {
	        filters.push('vtypes=' + angular.toJson(this._transformVehicleType(params.vehicleType)));
	      }
	      if (params && params.reportedSince && params.reportedSince <= 86400) {
	        filters.push('reportedSince=' + moment().subtract(params.reportedSince, 'seconds').unix());
	      }
	      if (params && params.reportedUpTo && params.reportedUpTo > 0) {
	        filters.push('reportedUpTo=' + moment().subtract(params.reportedUpTo, 'seconds').unix());
	      }
	      if (params && params.vehicleState !== '0') {
	        filters.push('ign=' + params.vehicleState);
	      }
	      if (params && !params.clustering) {
	        filters.push('maxZoomCluster=' + 0);
	      }

	      return filters.join('&');
	    }
	  }, {
	    key: '_getMapBbox',
	    value: function _getMapBbox() {
	      var bounds = this.MapHelper.map.getBounds();
	      return [bounds._sw.lat, bounds._sw.lng, bounds._ne.lat, bounds._ne.lng];
	    }
	  }, {
	    key: '_transformVehicleType',
	    value: function _transformVehicleType(vehicleType) {
	      var types = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = Object.entries(vehicleType)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              key = _step$value[0],
	              value = _step$value[1];

	          if (value === true) {
	            types.push(key);
	          }
	          if (key === 'OTHER' && value === true) {
	            types.push(null);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      return types;
	    }
	  }]);

	  return TrackingService;
	}();

	exports.default = TrackingService;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  label: {
	    layout: {
	      'text-field': '{lbl}',
	      'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
	      'text-size': {
	        stops: [[8, 10], [17, 14]]
	      },
	      'text-transform': 'uppercase',
	      'text-letter-spacing': 0.05,
	      'text-offset': {
	        stops: [[8, [0, 1.5]], [17, [0, 1.75]]]
	      }
	    },
	    paint: {
	      'text-color': '#202',
	      'text-halo-color': '#fff',
	      'text-halo-width': 2
	    }
	  },
	  point: {
	    paint: {
	      'circle-color': {
	        property: 'st',
	        type: 'categorical',
	        stops: [['grn', '#00C1A2'], ['ylw', '#FFC107'], ['gry', '#647A90'], ['red', '#D32F2F']]
	      },
	      'circle-radius': {
	        stops: [[3, 3], [17, 12]]
	      },
	      'circle-stroke-width': {
	        stops: [[6, 0], [17, 4]]
	      },
	      'circle-opacity': {
	        stops: [[3, 0.7], [17, 1]]
	      },
	      'circle-stroke-color': '#fff'
	    }
	  }
	};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  count: {
	    layout: {
	      'text-field': '{point_count_abbreviated}',
	      'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
	      'text-size': 11,
	      'text-allow-overlap': true
	    },
	    paint: {
	      'text-color': '#fff'
	    }
	  },
	  cluster: {
	    paint: {
	      'circle-color': {
	        property: 'point_count',
	        type: 'interval',
	        stops: [[0, '#03A9F4'], [20, '#2196F3'], [50, '#1976D2']]
	      },
	      'circle-radius': {
	        property: 'point_count',
	        type: 'interval',
	        stops: [[0, 10], [20, 15], [50, 20]]
	      },
	      'circle-stroke-width': 2,
	      'circle-stroke-color': '#fff'
	    }
	  }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  navigation: {
	    layout: {
	      'icon-size': 0.4,
	      'icon-rotate': ['get', 'dir'],
	      'icon-image': ['get', 'st'],
	      visibility: 'none'
	    },
	    paint: {}
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GeocodingService = function () {
	  GeocodingService.$inject = ["$http", "$q", "$window", "EnvironmentConfig"];
	  function GeocodingService($http, $q, $window, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, GeocodingService);

	    this.$http = $http;
	    this.$q = $q;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;

	    this.boundingBox = '-56.00,-117.13%7C32.53,-34.00';

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.setLanguage(user);
	  }

	  _createClass(GeocodingService, [{
	    key: 'setLanguage',
	    value: function setLanguage(user) {
	      var localeMapping = {
	        pt_BR: 'pt-BR',
	        es_UY: 'es-419'
	      };

	      this.locale = localeMapping[user.attributes.locale] || 'en';
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(_ref) {
	      var lat = _ref.lat,
	          lng = _ref.lng;

	      var deferred = this.$q.defer();
	      this.$http({ method: 'GET', url: _constants.GOOGLE_REGEOCODING + '?latlng=' + lat + ',' + lng + '&key=' + _constants.GOOGLE_KEY + '&language=' + this.locale, skipAuthorization: true, timeout: 25000 }).then(function (_ref2) {
	        var data = _ref2.data;

	        deferred.resolve(data.results);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getPlaces',
	    value: function getPlaces(address) {
	      var deferred = this.$q.defer();
	      this.$http({ method: 'GET', url: _constants.GOOGLE_REGEOCODING + '?address=' + address + '&bounds=' + this.boundingBox + '&key=' + _constants.GOOGLE_KEY + '&language=' + this.locale, skipAuthorization: true, timeout: 25000 }).then(function (_ref3) {
	        var data = _ref3.data;

	        deferred.resolve(data.results);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getDistance',
	    value: function getDistance(origin, destination) {
	      var deferred = this.$q.defer();
	      this.$http({ method: 'GET', url: _constants.GOOGLE_DIRECTIONS + '?origin=' + origin + '&destination=' + destination + '&key=' + _constants.GOOGLE_KEY + '&language=' + this.locale, skipAuthorization: true, timeout: 25000 }).then(function (data) {
	        deferred.resolve(data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getAddressFromCoords',
	    value: function getAddressFromCoords(lng, lat) {
	      var headers = {
	        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE1MDU5MTcyODh9.wGxGQupRwojEcpQPbe2NqbmRlmH625tVYONoDE6IZPA',
	        'Content-Type': 'application/json'
	      };

	      var deferred = this.$q.defer();
	      var url = [this.EnvironmentConfig.GEOCODE, 'reverse_resolve', lng, lat].join('/');
	      this.$http({ url: url + '?forcemaxspeed=true', method: 'GET', skipAuthorization: true, headers: headers, timeout: 25000 }).then(function (res) {
	        deferred.resolve(res.data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getAddressFromPlaces',
	    value: function getAddressFromPlaces(obj) {
	      var headers = {
	        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE1MDU5MTcyODh9.wGxGQupRwojEcpQPbe2NqbmRlmH625tVYONoDE6IZPA',
	        'Content-Type': 'application/json'
	      };

	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.GEOCODE, 'resolve'].join('/');

	      if (obj && obj.search) {
	        query.push('q=' + obj.search);
	      }
	      if (obj && obj.format) {
	        query.push('locale=' + obj.format);
	      }
	      if (obj && obj.limit) {
	        query.push('limit=' + obj.limit);
	      }
	      if (obj && obj.polygonformat) {
	        query.push('polygonformat=' + obj.polygonformat);
	      }
	      if (obj && obj.polygonthreshold) {
	        query.push('polygonthreshold=' + obj.polygonthreshold);
	      }
	      if (obj && obj.addressdetails) {
	        query.push('addressdetails=' + obj.addressdetails);
	      }
	      if (obj && obj.extratags) {
	        query.push('extratags=' + obj.extratags);
	      }

	      if (obj) {
	        url = url + ('?' + query.join('&'));
	      }

	      this.$http({ url: url, method: 'GET', skipAuthorization: true, headers: headers, timeout: 25000 }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (res) {
	        deferred.reject(res.data);
	      });

	      return deferred;
	    }
	  }]);

	  return GeocodingService;
	}();

	exports.default = GeocodingService;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _sharingsList = __webpack_require__(148);

	var _sharingsList2 = _interopRequireDefault(_sharingsList);

	var _sharingsCreate = __webpack_require__(149);

	var _sharingsCreate2 = _interopRequireDefault(_sharingsCreate);

	var _sharings = __webpack_require__(150);

	var _sharings2 = _interopRequireDefault(_sharings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.sharings', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'sharings-list',
	    url: '/sharings/list?search&predicates',
	    parent: 'monitoring',
	    menu: true,
	    alias: 'sharings',
	    controller: _sharingsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/sharings/list/sharings.list.html',
	    params: {
	      search: { dynamic: true },
	      predicates: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'sharings-create',
	    url: '/sharings/create',
	    parent: 'monitoring',
	    controller: _sharingsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/sharings/create/sharings.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'sharings-edit',
	    url: '/sharings/edit/:uuid',
	    parent: 'monitoring',
	    controller: _sharingsCreate2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/sharings/create/sharings.create.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('SharingsListController', _sharingsList2.default).controller('SharingsCreateController', _sharingsCreate2.default).service('SharingsService', _sharings2.default);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _baseList = __webpack_require__(45);

	var _baseList2 = _interopRequireDefault(_baseList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var SharingsListController = function (_BaseListController) {
	  SharingsListController.$inject = ["$state", "$scope", "$translate", "GenericService"];
	  _inherits(SharingsListController, _BaseListController);

	  function SharingsListController($state, $scope, $translate, GenericService) {
	    'ngInject';

	    _classCallCheck(this, SharingsListController);

	    var _this = _possibleConstructorReturn(this, (SharingsListController.__proto__ || Object.getPrototypeOf(SharingsListController)).call(this, $scope, GenericService));

	    _this.$state = $state;
	    _this.$translate = $translate;

	    var query = {
	      limit: 15,
	      page: 1,
	      search: _this.$state.params.search,
	      order: { prop: 'created_at', order: 'DESC' },
	      predicates: _this.$state.params.predicates
	    };

	    _this.options = {
	      new: 'screen',
	      export: true
	    };

	    _this.setProps(_constants.API.V3, _constants.API.SHARINGS, query, null, { prop: 'deactivated_at' });
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(SharingsListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.HASH_TYPE', 'PANEL.HEADER.CREATED_VALID', 'PANEL.HEADER.PLATE_TYPE', 'PANEL.HEADER.USER_PHONE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.HASH_TYPE'],
	          sort: true,
	          prop: 'hash'
	        }, {
	          label: t['PANEL.HEADER.CREATED_VALID'],
	          sort: true,
	          prop: 'created_at'
	        }, {
	          label: t['PANEL.HEADER.PLATE_TYPE'],
	          sort: true,
	          prop: 'vehicle.plate'
	        }, {
	          label: t['PANEL.HEADER.USER_PHONE'],
	          sort: true,
	          prop: 'user.name'
	        }];
	      });
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(sharing) {
	      return moment(sharing.valid_until).format() > moment().format();
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus(sharing) {
	      sharing.active = !sharing.deactivated_at;
	    }
	  }, {
	    key: 'toggleSharing',
	    value: function toggleSharing(sharing) {
	      var data = {
	        deactivated_at: sharing.deactivated_at ? null : moment()
	      };
	      this.GenericService.update(_constants.API.V3, _constants.API.SHARINGS, sharing.uuid, data);
	    }
	  }]);

	  return SharingsListController;
	}(_baseList2.default);

	exports.default = SharingsListController;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SharingsCreateController = function () {
	  SharingsCreateController.$inject = ["$state", "GenericService", "GeocodingService"];
	  function SharingsCreateController($state, GenericService, GeocodingService) {
	    'ngInject';

	    _classCallCheck(this, SharingsCreateController);

	    this.$state = $state;
	    this.GenericService = GenericService;
	    this.GeocodingService = GeocodingService;

	    this.types = ['APPROPRIATION', 'THEFT', 'ROBBERY', 'KIDNAPPING', 'TOW', 'OTHER'];
	    this.sharing = {
	      type: 'ROBBERY',
	      minSharingDate: moment().toISOString(),
	      maxSharingDate: moment().add(30, 'd').toISOString()
	    };

	    this.isEdit();
	  }

	  _createClass(SharingsCreateController, [{
	    key: 'getVehicles',
	    value: function getVehicles(query) {
	      var defaultObj = {
	        search: query,
	        order: { prop: 'plate', order: 'ASC' }
	      };
	      var obj = Object.assign({}, defaultObj, this.item);
	      return this.GenericService.list(_constants.API.V1, _constants.API.VEHICLES, obj).promise.then(function (res) {
	        return res.rows;
	      });
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this = this;

	      if (angular.isDefined(this.$state.params.uuid)) {
	        this.GenericService.show(_constants.API.V3, _constants.API.SHARINGS, this.$state.params.uuid).promise.then(function (res) {
	          _this.sharing = Object.assign({}, _this.sharing, res);
	          _this.sharing.valid_until = moment(res.valid_until).format('YYYY-MM-DDTHH:mm:ss.SSS');
	          _this.options = {
	            archive: !_this.sharing.archived_at,
	            unarchive: _this.sharing.archived_at,
	            delete: _this.sharing.archived_at
	          };
	        });
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;

	      this.processing = true;
	      var data = {
	        type: this.sharing.type,
	        vehicle_id: this.sharing.vehicle.id,
	        valid_until: this.sharing.valid_until,
	        coordinates: this.sharing.uuid ? this.sharing.coordinates : [this.sharing.vehicle.device.last_gps.last_gps_raw.lng, this.sharing.vehicle.device.last_gps.last_gps_raw.lat],
	        formatted_address: this.sharing.formatted_address
	      };
	      if (this.sharing.uuid) {
	        this.GenericService.update(_constants.API.V3, _constants.API.SHARINGS, this.sharing.uuid, data).promise.finally(function () {
	          _this2.processing = false;
	        });
	      } else {
	        this.GenericService.create(_constants.API.V3, _constants.API.SHARINGS, data).promise.then(function () {
	          _this2.$state.go('sharings-list');
	        }).finally(function () {
	          _this2.processing = false;
	        });
	      }
	    }
	  }, {
	    key: 'resolveAddress',
	    value: function resolveAddress() {
	      var _this3 = this;

	      if (this.$state.params.uuid) {
	        return;
	      }
	      this.sharing.formatted_address = null;
	      if (!this.sharing.vehicle || !this.sharing.vehicle.device || !this.sharing.vehicle.device.last_gps || !this.sharing.vehicle.device.last_gps_raw) {
	        return;
	      }
	      var lat = this.sharing.vehicle.device.last_gps.last_gps_raw.lat;
	      var lng = this.sharing.vehicle.device.last_gps.last_gps_raw.lng;
	      this.GeocodingService.getAddress({ lat: lat, lng: lng }).promise.then(function (res) {
	        _this3.sharing.formatted_address = res[0].formatted_address;
	      });
	    }
	  }]);

	  return SharingsCreateController;
	}();

	exports.default = SharingsCreateController;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SharingsService = function SharingsService() {
	  'ngInject';

	  _classCallCheck(this, SharingsService);
	};

	exports.default = SharingsService;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _linksList = __webpack_require__(152);

	var _linksList2 = _interopRequireDefault(_linksList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.links', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'links-list',
	    url: '/links/list?search&filters',
	    parent: 'monitoring',
	    new: true,
	    menu: true,
	    alias: 'links',
	    controller: _linksList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/links/list/links.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('LinksListController', _linksList2.default);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var LinksListController = function (_ListController) {
	  LinksListController.$inject = ["$state", "$scope", "$translate", "DialogService", "EnvironmentConfig", "MainService"];
	  _inherits(LinksListController, _ListController);

	  function LinksListController($state, $scope, $translate, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, LinksListController);

	    var _this = _possibleConstructorReturn(this, (LinksListController.__proto__ || Object.getPrototypeOf(LinksListController)).call(this, $scope, $state, $translate, MainService));

	    _this.DialogService = DialogService;
	    _this.EnvironmentConfig = EnvironmentConfig;

	    _this.query = {
	      attributes: ['*'],
	      includes: {
	        enterprise: ['name,cnpj,email'],
	        creator: ['name,email,phone1'],
	        asset: ['plate,code,vin,type_name,brand_name,trim_name,model_name,year,color'],
	        device: ['name,imei']
	      },
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'new-sharing',
	      export: true,
	      stats: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.SHARINGS, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(LinksListController, [{
	    key: 'checkStatus',
	    value: function checkStatus(sharing) {
	      if (sharing.attributes.active) {
	        return;
	      }
	      sharing.attributes.active = !sharing.attributes.deactivated_at;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(sharing) {
	      if (sharing.attributes.valid) {
	        return;
	      }
	      sharing.attributes.valid = moment(sharing.attributes.valid_until).format() > moment().format() && sharing.attributes.active;
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(sharing) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = sharing.attributes.active ? 'activation' : 'deactivation';

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'SHARINGS_ACTIVATION', action: 'save' }).then(function () {
	        _this2.MainService.edit(_constants.API.V5, _constants.API.SHARINGS + '/' + sharing.id + '/set-activation/' + action).promise.then(function () {
	          sharing.attributes.deactivated_at = sharing.attributes.deactivated_at ? null : new Date();
	          sharing.attributes.ative = !sharing.attributes.ative;
	        });
	      }).catch(function () {
	        _this2.checkStatus(sharing);
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this3 = this;

	      var keys = ['PANEL.HEADER.HASH_TYPE', 'PANEL.HEADER.ENTERPRISE_CONTACT', 'PANEL.HEADER.VALID_USED', 'PANEL.HEADER.USER_PHONE'];

	      this.$translate(keys).then(function (t) {
	        _this3.headers = [{
	          label: t['PANEL.HEADER.HASH_TYPE'],
	          sort: true,
	          prop: 'hash'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_CONTACT'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.VALID_USED'],
	          sort: true,
	          prop: 'valid_until'
	        }, {
	          label: t['PANEL.HEADER.USER_PHONE'],
	          sort: true,
	          prop: 'creator.name'
	        }];
	      });
	    }
	  }]);

	  return LinksListController;
	}(_list2.default);

	exports.default = LinksListController;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _eventsEdit = __webpack_require__(154);

	var _eventsEdit2 = _interopRequireDefault(_eventsEdit);

	var _events = __webpack_require__(155);

	var _events2 = _interopRequireDefault(_events);

	var _comments = __webpack_require__(156);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.monitoring.events', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'events-edit',
	    url: '/center/events/edit/:uuid',
	    parent: 'monitoring',
	    controller: _eventsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/monitoring/events/edit/events.edit.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('EventsEditController', _eventsEdit2.default).service('EventsService', _events2.default).directive('comments', _comments.Comments);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _events = __webpack_require__(121);

	var mapstyle = _interopRequireWildcard(_events);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EventsEditController = function () {
	  EventsEditController.$inject = ["$state", "$timeout", "$translate", "$window", "DialogService", "GeocodingService", "MainService", "MapHelper"];
	  function EventsEditController($state, $timeout, $translate, $window, DialogService, GeocodingService, MainService, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, EventsEditController);

	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.MapHelper = MapHelper;

	    this.currentUser = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.status = ['todo', 'doing', 'done'];
	    this.section = 'comments';
	    this.loadData();
	  }

	  _createClass(EventsEditController, [{
	    key: 'getMap',
	    value: function getMap() {
	      this.staticMapImage = this.MapHelper.getStaticMap(this._buildFeature(), { w: 500, h: 300 });
	    }
	  }, {
	    key: 'addLayers',
	    value: function addLayers() {
	      var layers = [this.MapHelper.layerBuilder('alarms', 'symbol', { source: 'points', layout: mapstyle.alarm.layout, paint: mapstyle.alarm.paint })];

	      this.MapHelper.addLayers(layers);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      this.loading = true;
	      if (angular.isDefined(this.$state.params.uuid)) {
	        this.MainService.show(_constants.API.V4, _constants.API.EVENTS, this.$state.params.uuid).promise.then(function (res) {
	          _this.loading = false;
	          _this.event = res.data;
	          _this.getMap();
	        });
	      }
	    }
	  }, {
	    key: 'edit',
	    value: function edit(key, val) {
	      var obj = {
	        data: {}
	      };
	      obj.data[key] = val;

	      return this.MainService.update(_constants.API.V4, _constants.API.EVENTS, this.event.id, obj).promise;
	    }
	  }, {
	    key: 'removeAlertFromEvent',
	    value: function removeAlertFromEvent(data, index) {
	      var _this2 = this;

	      var obj = {
	        data: {
	          alertIds: [data.id]
	        }
	      };

	      var opt = internals._dialogOpts(internals._urlPaths.confirmAction.path, internals._urlPaths.confirmAction.ctrl);
	      this.DialogService.openDialog(opt, { title: 'ALERT_HANDLED', label: 'ALERT_HANDLED', action: 'delete' }).then(function () {
	        _this2.MainService.deleteMany(_constants.API.V4, _constants.API.EVENTS + '/' + _this2.event.id + '/' + _constants.API.ALERTS, obj).promise.then(function () {
	          _this2.event.relationships.alerts.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'resolveAddress',
	    value: function resolveAddress(alert) {
	      if (alert.address) {
	        return;
	      }
	      this.GeocodingService.getAddressFromCoords(alert.attributes.lng, alert.attributes.lat).promise.then(function (res) {
	        alert.address = res.display_name;
	      });
	    }
	  }, {
	    key: 'filterByDeviceName',
	    value: function filterByDeviceName(alert) {
	      if (alert.specs) {
	        return;
	      }
	      var currentDevice = this.event.relationships.devices.filter(function (d) {
	        return d.id === alert.attributes.did;
	      })[0];
	      alert.specs = {};
	      alert.specs.imei = currentDevice.attributes.imei;
	      alert.specs.brand_alias = currentDevice.relationships.device_type.attributes.brand_alias;
	    }
	  }, {
	    key: '_buildFeature',
	    value: function _buildFeature() {
	      var coords = [];
	      for (var index in this.event.relationships.alerts) {
	        coords.push([this.event.relationships.alerts[index].attributes.lng, this.event.relationships.alerts[index].attributes.lat]);
	      }
	      return coords;
	    }
	  }]);

	  return EventsEditController;
	}();

	exports.default = EventsEditController;


	var internals = {
	  _urlPaths: {
	    confirmAction: {
	      path: 'app/components/dialog/confirmation/confirmation.dialog.html',
	      ctrl: 'ConfirmationDialogController'
	    }
	  },
	  _dialogOpts: function _dialogOpts(path, controller) {
	    return {
	      url: path,
	      controllerName: controller,
	      controllerAlias: 'ctrl',
	      bindToController: true,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      hasBackdrop: true,
	      parent: angular.element('#page-body')
	    };
	  }
	};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// import { API } from '../../../constants/constants.js'

	var EventsService = function EventsService($http, $q, EnvironmentConfig) {
	  'ngInject';

	  _classCallCheck(this, EventsService);

	  this.$http = $http;
	  this.$q = $q;
	  this.EnvironmentConfig = EnvironmentConfig;
	};
	EventsService.$inject = ["$http", "$q", "EnvironmentConfig"];

	exports.default = EventsService;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.Comments = Comments;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function Comments() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/internal/monitoring/events/components/comments/comments.html',
	    replace: true,
	    controller: CommentsController,
	    controllerAs: 'ctrl',
	    scope: {
	      version: '@',
	      model: '@',
	      identifier: '@',
	      user: '@',
	      items: '='
	    }
	  };
	  return directive;
	}

	var CommentsController = function () {
	  CommentsController.$inject = ["$scope", "$translate", "MainService"];
	  function CommentsController($scope, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, CommentsController);

	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.MainService = MainService;
	    this.comments = this.$scope.items;

	    this.tinymceOptions = {
	      skin: 'lightgray',
	      inline: false,
	      menubar: false,
	      statusbar: false,
	      selector: 'textarea',
	      min_height: 110,
	      toolbar: 'undo redo bold italic alignleft aligncenter alignright bullist numlist outdent indent code'
	    };
	  }

	  _createClass(CommentsController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      var obj = {
	        data: {
	          text: this.comment
	        }
	      };

	      this.MainService.create(_constants.API.V4, _constants.API.EVENTS + '/' + this.$scope.identifier + '/comments', obj).promise.then(function (res) {
	        _this.comments.push(res.data.relationships.comments.slice(-1)[0]);
	        _this.comment = null;
	        _this.editable = false;
	      }).catch();
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item, index) {
	      var _this2 = this;

	      this.MainService.deleteMany(_constants.API.V4, _constants.API.EVENTS + '/' + this.$scope.identifier + '/comments/' + item.id).promise.then(function () {
	        _this2.comments.splice(index, 1);
	      }).catch();
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item) {
	      var _this3 = this;

	      var obj = {};
	      this.MainService.edit(_constants.API.V4, _constants.API.EVENTS + '/' + this.$scope.identifier + '/comments/' + item.id, obj).promise.then(function (res) {
	        _this3.comments = res.data.relationships.comments;
	      }).catch();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.editable = !this.editable;
	      this.comment = '';
	    }
	  }]);

	  return CommentsController;
	}();

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(158);

	__webpack_require__(168);

	__webpack_require__(182);

	// import './surveys/surveys'

	angular.module('phoenix.internal.operational', ['ui.router', 'phoenix.internal.operational.catalogs', 'phoenix.internal.operational.service-orders', 'phoenix.internal.operational.protocols'
	// 'phoenix.internal.operational.surveys'
	]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'operational',
	    url: '/operational',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _protocolsList = __webpack_require__(159);

	var _protocolsList2 = _interopRequireDefault(_protocolsList);

	var _protocolsEdit = __webpack_require__(160);

	var _protocolsEdit2 = _interopRequireDefault(_protocolsEdit);

	var _documents = __webpack_require__(161);

	var _documents2 = _interopRequireDefault(_documents);

	var _sharings = __webpack_require__(162);

	var _sharings2 = _interopRequireDefault(_sharings);

	var _users = __webpack_require__(163);

	var _users2 = _interopRequireDefault(_users);

	var _protocolsPanel = __webpack_require__(164);

	var _protocolsPanel2 = _interopRequireDefault(_protocolsPanel);

	var _locations = __webpack_require__(165);

	var _locations2 = _interopRequireDefault(_locations);

	var _sharings3 = __webpack_require__(166);

	var _sharings4 = _interopRequireDefault(_sharings3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.operational.protocols', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'protocols-list',
	    url: '/protocols/list?search&filters',
	    parent: 'operational',
	    menu: true,
	    alias: 'protocols',
	    controller: _protocolsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/list/protocols.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.OPERATOR), _toConsumableArray(_constants.ROLES.PROVIDER))
	    }
	  }).state({
	    name: 'protocols-create',
	    url: '/protocols/create',
	    parent: 'operational',
	    controller: _protocolsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/edit/protocols.edit.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.OPERATOR))
	    }
	  }).state({
	    name: 'protocols-edit',
	    url: '/protocols/edit/:id',
	    parent: 'operational',
	    controller: _protocolsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/edit/protocols.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.OPERATOR))
	    },
	    redirectTo: 'protocols-edit.documents'
	  }).state({
	    name: 'protocols-edit.documents',
	    url: '/documents',
	    controller: _documents2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/tabs/documents/documents.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.OPERATOR))
	    }
	  }).state({
	    name: 'protocols-edit.users',
	    url: '/users',
	    controller: _users2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/tabs/users/users.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.OPERATOR))
	    }
	  }).state({
	    name: 'protocols-edit.sharings',
	    url: '/sharings',
	    controller: _sharings2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/tabs/sharings/sharings.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.OPERATOR))
	    }
	  }).state({
	    name: 'protocols-panel',
	    url: '/protocols/panel',
	    parent: 'operational',
	    controller: _protocolsPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/protocols/panel/protocols.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('ProtocolsListController', _protocolsList2.default).controller('ProtocolsEditController', _protocolsEdit2.default).controller('ProtocolsDocumentsController', _documents2.default).controller('ProtocolsSharingsController', _sharings2.default).controller('ProtocolsUsersController', _users2.default).controller('ProtocolsPanelController', _protocolsPanel2.default).controller('TaskLocationsController', _locations2.default).controller('TaskSharingController', _sharings4.default);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ProtocolsListController = function (_ListController) {
	  ProtocolsListController.$inject = ["$state", "$scope", "$translate", "MainService"];
	  _inherits(ProtocolsListController, _ListController);

	  function ProtocolsListController($state, $scope, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, ProtocolsListController);

	    var _this = _possibleConstructorReturn(this, (ProtocolsListController.__proto__ || Object.getPrototypeOf(ProtocolsListController)).call(this, $scope, $state, $translate, MainService));

	    _this.query = {
	      attributes: ['*'],
	      includes: {},
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'screen',
	      export: true,
	      stats: true
	    };

	    _this.setProps(_constants.API.V5, _constants.API.PROTOCOLS, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(ProtocolsListController, [{
	    key: 'transformLocation',
	    value: function transformLocation(item) {
	      if (angular.isObject(item.attributes.addresses)) return;
	      item.attributes.addresses = angular.fromJson(item.attributes.addresses);
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.TOKEN_PRIORITY', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.TYPE_STATUS', 'PANEL.HEADER.VEHICLE_TYPE', 'PANEL.HEADER.TIME_DATE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.TOKEN_PRIORITY'],
	          sort: true,
	          prop: 'token'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise_name'
	        }, {
	          label: t['PANEL.HEADER.TYPE_STATUS'],
	          sort: true,
	          prop: 'type_name'
	        }, {
	          label: t['PANEL.HEADER.VEHICLE_TYPE'],
	          sort: true,
	          prop: 'asset_plate'
	        }, {
	          label: t['PANEL.HEADER.TIME_DATE'],
	          sort: true,
	          prop: 'due_date'
	        }];
	      });
	    }
	  }]);

	  return ProtocolsListController;
	}(_list2.default);

	exports.default = ProtocolsListController;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var mapConfig = {
	  boxZoom: true,
	  dragRotate: false,
	  minZoom: 4,
	  maxZoom: 17,
	  pitch: 0,
	  pitchWithRotate: false
	};

	var ServiceOrderEditController = function () {
	  ServiceOrderEditController.$inject = ["$scope", "$state", "$timeout", "$window", "DialogService", "EnvironmentConfig", "GeoLocation", "IsochronesService", "MainService", "MapHelper", "StateManagement"];
	  function ServiceOrderEditController($scope, $state, $timeout, $window, DialogService, EnvironmentConfig, GeoLocation, IsochronesService, MainService, MapHelper, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ServiceOrderEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GeoLocation = GeoLocation;
	    this.IsochronesService = IsochronesService;
	    this.MapHelper = MapHelper;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.priorities = _constants.TASK_PRIORITIES;
	    this.mapStyle = { layer: 'navigation-night', version: 'v1' };

	    this.usersOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: '' },
	        'roles.internal': { operator: 'eq', value: false }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.usersOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });

	    this.isEdit();
	  }

	  _createClass(ServiceOrderEditController, [{
	    key: 'getTypes',
	    value: function getTypes(query) {
	      var _this2 = this;

	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	        }
	      };

	      if (query) {
	        obj.filters.name = { operator: 'ilk', value: query };
	      }

	      return this.MainService.raw(_constants.API.V5, _constants.API.PROTOCOLS + '/types', obj).promise.then(function (res) {
	        return res.data;
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'getSections',
	    value: function getSections(query) {
	      var _this3 = this;

	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	        }
	      };

	      if (query) {
	        obj.filters.name = { operator: 'ilk', value: query };
	      }

	      return this.MainService.raw(_constants.API.V5, _constants.API.PROTOCOLS + '/sections', obj).promise.then(function (res) {
	        return res.data;
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'getGeoLocation',
	    value: function getGeoLocation() {
	      var _this4 = this;

	      this.coords = null;

	      if (this.protocol.relationships.addresses && this.protocol.relationships.addresses.length > 0) {
	        this.buildMap();
	      } else {
	        var getGeoLocation = this.GeoLocation.getCoords();
	        getGeoLocation.then(function (res) {
	          _this4.coords = [res.lng, res.lat];
	        }).finally(function () {
	          _this4.buildMap();
	        });
	      }
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap() {
	      var _this5 = this;

	      var markers = [];
	      var center = [];
	      if (this.protocol.relationships.addresses && this.protocol.relationships.addresses.length > 0) {
	        this.protocol.relationships.addresses.forEach(function (loc) {
	          if (angular.isArray(loc.attributes.coords)) {
	            markers.push([loc.attributes.coords[1], loc.attributes.coords[0]]);
	            center = { center: markers[0] };
	          }
	        });
	      } else {
	        center = this.coords ? { center: this.coords } : null;
	      }

	      var mapOptions = Object.assign({}, mapConfig, { zoom: 5 }, center);
	      this.MapHelper.mapBuilder(this.mapStyle, mapOptions);

	      this.MapHelper.map.once('load', function () {
	        _this5.IsochronesService.build({ center: center, markers: markers });
	      });
	    }
	  }, {
	    key: 'updateLocations',
	    value: function updateLocations() {
	      if (this.protocol.relationships.addresses) {
	        var markers = [];
	        var center = [];

	        this.protocol.relationships.addresses.forEach(function (loc) {
	          if (angular.isArray(loc.attributes.coords)) {
	            markers.push([loc.attributes.coords[1], loc.attributes.coords[0]]);
	          }
	        });
	        center = markers[0];
	        this.IsochronesService.rebuild({ center: center, markers: markers });
	      }
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this6 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.loading = true;
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            completed: ['username,name,email,phone1,phone2'],
	            completion: ['*'],
	            section: ['*'],
	            type: ['*'],
	            addresses: ['*'],
	            enterprise: ['name,cnpj,email,phone1,deactivated_at,timezone'],
	            assignee: ['username,name,email,phone1,phone2'],
	            asset: ['plate,code,vin,brand_name,trim_name,model_name,year,color'],
	            asset_users: ['username,name,email,phone1'],
	            asset_devices: ['name,imei']
	          }
	        };
	        this.MainService.raw(_constants.API.V5, _constants.API.PROTOCOLS + '/' + this.$state.params.id, obj).promise.then(function (res) {
	          _this6.protocol = res.data;
	          _this6.selectedAssignee = _this6.protocol.relationships.assignee;
	          _this6.selectedEnterprise = _this6.protocol.relationships.enterprise;
	          _this6.selectedAsset = _this6.protocol.relationships.asset;
	          _this6.selectedSection = _this6.protocol.relationships.section;
	          _this6.selectedPlace = _this6.protocol.relationships.addresses ? _this6.protocol.relationships.addresses : [];
	          _this6.selectedType = _this6.protocol.relationships.type;
	          _this6.protocol.attributes.due_date = res.data.attributes.due_date ? new Date(res.data.attributes.due_date) : '';
	          _this6.StateManagement.setData(['protocol'], [_this6.protocol]);
	          _this6.formatAddresses();
	        }).finally(function () {
	          _this6.loading = false;
	          if (_this6.protocol.attributes.due_date && !_this6.protocol.relationships.completion) {
	            _this6.$timeout(function () {
	              _this6.getGeoLocation();
	            }, 1000);
	          }
	        });
	      } else {
	        this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	        this.protocol = {
	          attributes: {},
	          relationships: {}
	        };
	      }
	    }
	  }, {
	    key: 'formatAddresses',
	    value: function formatAddresses() {
	      if (this.protocol.relationships.addresses && this.protocol.relationships.addresses.length > 0) {
	        this.protocol.relationships.addresses.forEach(function (address) {
	          if (address.attributes.coords && address.attributes.coords.coordinates) {
	            address.attributes.coords = address.attributes.coords.coordinates;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'addEditAddress',
	    value: function addEditAddress() {
	      var _this7 = this;

	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

	      var data = Object.assign({}, item || { attributes: {} }, { action: 'add' });

	      var opt = _dialog.DIALOG._opts('app/components/address-form/address-form.html', 'AddressFormController');
	      this.DialogService.openDialog(opt, data).then(function (address) {
	        if (index > -1) {
	          _this7.protocol.relationships.addresses[index] = { attributes: address.data.attributes };
	        } else {
	          if (angular.isUndefined(_this7.protocol.relationships.addresses)) {
	            _this7.protocol.relationships.addresses = [];
	          }
	          _this7.protocol.relationships.addresses.push({ attributes: address.data.attributes });
	        }
	        _this7.checkMap();
	        _this7.updateLocations();
	      });
	    }
	  }, {
	    key: 'deleteAddress',
	    value: function deleteAddress(index) {
	      this.protocol.relationships.addresses.splice(index, 1);
	      this.updateLocations();
	    }
	  }, {
	    key: 'checkMap',
	    value: function checkMap() {
	      var _this8 = this;

	      if (this.protocol.relationships.addresses && this.protocol.attributes.due_date) {
	        this.$timeout(function () {
	          _this8.buildMap();
	        }, 500);
	      }
	    }
	  }, {
	    key: 'customDate',
	    value: function customDate() {
	      var _this9 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_COMPLETE_DATE.path, _dialog.DIALOG.TASK_COMPLETE_DATE.ctrl);
	      this.DialogService.openDialog(opt).then(function (res) {
	        _this9.toggleComplete(res.date);
	      });
	    }
	  }, {
	    key: 'toggleComplete',
	    value: function toggleComplete() {
	      var _this10 = this;

	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      this.loading = true;
	      var obj = null;

	      if (!this.protocol.relationships.completion) {
	        obj = {
	          data: {
	            attributes: {
	              completed_at: date || new Date()
	            }
	          }
	        };
	      }
	      var action = this.protocol.relationships.completion ? 'uncomplete' : 'complete';

	      this.MainService.edit(_constants.API.V5, _constants.API.PROTOCOLS + '/' + this.$state.params.id + '/' + action, obj).promise.then(function (res) {
	        _this10.protocol.relationships.completion = res.data.relationships.completion;
	        if (!_this10.protocol.relationships.completion) {
	          _this10.$timeout(function () {
	            _this10.getGeoLocation();
	          }, 1000);
	        }
	      }).finally(function () {
	        _this10.loading = false;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this11 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        _this11.MainService.delete(_constants.API.V5, _constants.API.PROTOCOLS, _this11.protocol.id).promise.then(function () {
	          _this11.$state.go('protocols-list');
	        });
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this12 = this;

	      this.loading = true;
	      var protocol = {
	        data: {
	          attributes: {
	            name: this.protocol.attributes.name,
	            priority: this.protocol.attributes.priority,
	            description: this.protocol.attributes.description,
	            due_date: this.protocol.attributes.due_date || ''
	          },
	          relationships: {
	            type: {
	              type: 'type',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedType.id)
	            }
	          }
	        }
	      };

	      if (angular.isDefined(this.$state.params.id) || this.selectedAssignee) {
	        protocol.data.relationships.assignee = {
	          type: 'user',
	          id: this.selectedAssignee ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedAssignee.id) : null
	        };
	      }

	      if (this.selectedSection) {
	        protocol.data.relationships.section = {
	          type: 'section',
	          id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedSection.id)
	        };
	      }

	      if (angular.isDefined(this.$state.params.id)) {
	        (0, _helper.cleanPayload)(protocol.data);

	        if (this.protocol.relationships && this.protocol.relationships.addresses) {
	          protocol.data.relationships.addresses = this.protocol.relationships.addresses.map(function (i) {
	            (0, _helper.cleanPayload)(i, true);
	            i.attributes = (0, _helper.omit)(i.attributes, ['created_at', 'updated_at', 'model']);
	            return {
	              id: i.id,
	              attributes: i.attributes,
	              type: 'address'
	            };
	          });
	        } else {
	          protocol.data.relationships.addresses = [];
	        }

	        if (this.protocol.relationships.section && !this.selectedSection) {
	          protocol.data.relationships.section = {
	            type: 'section',
	            id: null
	          };
	        }

	        this.MainService.update(_constants.API.V5, _constants.API.PROTOCOLS, this.$state.params.id, protocol).promise.then(function (res) {
	          _this12.protocol = Object.assign(res.data, _this12.protocol);
	        }).finally(function () {
	          _this12.loading = false;
	        });
	      } else {
	        Object.assign(protocol.data.relationships, {
	          enterprise: {
	            type: 'enterprise',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	          },
	          type: {
	            type: 'type',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedType.id)
	          },
	          asset: {
	            type: 'asset',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedAsset.id)
	          }
	        });

	        if (this.protocol.relationships && this.protocol.relationships.addresses) {
	          protocol.data.relationships.addresses = this.protocol.relationships.addresses.map(function (i) {
	            (0, _helper.cleanPayload)(i, true);
	            return {
	              attributes: i.attributes,
	              type: 'address'
	            };
	          });
	        }

	        (0, _helper.cleanPayload)(protocol.data, true);
	        this.MainService.create(_constants.API.V5, _constants.API.PROTOCOLS, protocol).promise.then(function (res) {
	          _this12.$state.go('protocols-edit', { id: res.data.id }, { notify: false });
	          _this12.formatAddresses();
	          _this12.getGeoLocation();
	        }).finally(function () {
	          _this12.loading = false;
	        });
	      }
	    }
	  }]);

	  return ServiceOrderEditController;
	}();

	exports.default = ServiceOrderEditController;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProtocolsDocumentsController = function () {
	  ProtocolsDocumentsController.$inject = ["$state", "DialogService", "MainService"];
	  function ProtocolsDocumentsController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, ProtocolsDocumentsController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.model = this.$state.params.id;
	    this.documents = [];

	    this.query = {
	      attributes: ['*'],
	      sort: {
	        prop: 'created_at',
	        order: 'ASC'
	      }
	    };

	    this.loadData();
	  }

	  _createClass(ProtocolsDocumentsController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      this.loading = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.PROTOCOLS + '/' + this.$state.params.id + '/documents', this.query).promise.then(function (res) {
	        var _documents;

	        _this.total = res.count;
	        _this.stopPropagation = res.data.length === 0;
	        (_documents = _this.documents).push.apply(_documents, _toConsumableArray(res.data));
	        _this.query.page += 1;
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }]);

	  return ProtocolsDocumentsController;
	}();

	exports.default = ProtocolsDocumentsController;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProtocolsSharingsController = function () {
	  ProtocolsSharingsController.$inject = ["$rootScope", "$scope", "$state", "DialogService", "EnvironmentConfig", "MainService", "StateManagement"];
	  function ProtocolsSharingsController($rootScope, $scope, $state, DialogService, EnvironmentConfig, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ProtocolsSharingsController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.workspaceLoaded = false;
	    this.items = [];

	    this.query = {
	      attributes: ['*'],
	      includes: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      filters: {},
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    var workspace = function workspace() {
	      return _this.loadWorkspace();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (!newValue) return;
	      workspace();
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(ProtocolsSharingsController, [{
	    key: 'loadWorkspace',
	    value: function loadWorkspace() {
	      this.workspaceLoaded = true;

	      var _StateManagement$getD = this.StateManagement.getData(['protocol']),
	          protocol = _StateManagement$getD.protocol;

	      if (protocol !== this.protocol) {
	        this.protocol = protocol;
	        this.enterprise = protocol.relationships.enterprise;
	        this.devices = protocol.relationships.asset_devices;
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_SHARINGS.path, _dialog.DIALOG.TASK_SHARINGS.ctrl);
	      this.DialogService.openDialog(opt, this.protocol).then(function (res) {
	        _this2.items.push(res.data);
	      });
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus(sharing) {
	      if (sharing.attributes.active) {
	        return;
	      }
	      sharing.attributes.active = !sharing.attributes.deactivated_at;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(sharing) {
	      if (sharing.attributes.valid) {
	        return;
	      }
	      sharing.attributes.valid = moment(sharing.attributes.valid_until).format() > moment().format();
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(sharing) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = sharing.attributes.active ? 'activation' : 'deactivation';

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'SHARINGS_ACTIVATION', action: 'save' }).then(function () {
	        _this3.MainService.edit(_constants.API.V5, _constants.API.SHARINGS + '/' + sharing.id + '/set-activation/' + action).promise.then(function () {
	          sharing.attributes.deactivated_at = sharing.attributes.deactivated_at ? null : new Date();
	          sharing.attributes.ative = !sharing.attributes.ative;
	        });
	      }).catch(function () {
	        _this3.checkStatus(sharing);
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      if (this.stopPropagation || this.loading || this.items.length === 0) {
	        return;
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this4 = this;

	      this.query.filters.source = { operator: 'eq', value: this.protocol.attributes.token };

	      this.loading = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.SHARINGS, this.query).promise.then(function (res) {
	        var _items;

	        _this4.total = res.count;
	        _this4.stopPropagation = res.data.length === 0;
	        (_items = _this4.items).push.apply(_items, _toConsumableArray(res.data));
	        _this4.query.page += 1;
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return ProtocolsSharingsController;
	}();

	exports.default = ProtocolsSharingsController;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProtocolsUsersController = function () {
	  ProtocolsUsersController.$inject = ["$rootScope", "$scope", "DialogService", "MainService", "StateManagement"];
	  function ProtocolsUsersController($rootScope, $scope, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ProtocolsUsersController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.loading = false;
	    this.items = [];

	    var workspace = function workspace() {
	      return _this.loadWorkspace();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (!newValue) return;
	      workspace();
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(ProtocolsUsersController, [{
	    key: 'loadWorkspace',
	    value: function loadWorkspace() {
	      var _StateManagement$getD = this.StateManagement.getData(['protocol']),
	          protocol = _StateManagement$getD.protocol;

	      if (protocol !== this.protocol) {
	        this.protocol = protocol;
	        this.asset = protocol.relationships.asset;
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      var obj = {
	        includes: {
	          user: ['*']
	        }
	      };
	      this.items = [];
	      this.loading = true;

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + this.asset.id + '/associations/users', obj).promise.then(function (res) {
	        var _items;

	        (_items = _this2.items).push.apply(_items, _toConsumableArray(res.data));
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'addActive',
	    value: function addActive(item) {
	      item.attributes.active = !item.attributes.deactivated_at;
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(user) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = user.attributes.active ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'users',
	          id: user.id
	        }]
	      };

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'USER_ACTIVATION', action: 'save' }).then(function () {
	        _this3.MainService.edit(_constants.API.V5, _constants.API.USERS + '/set-activation/' + action, obj).promise.then(function () {
	          user.attributes.deactivated_at = user.attributes.deactivated_at ? null : new Date();
	          user.attributes.ative = !user.attributes.ative;
	        });
	      }).catch(function () {
	        user.attributes.active = !user.attributes.deactivated_at;
	      });
	    }
	  }]);

	  return ProtocolsUsersController;
	}();

	exports.default = ProtocolsUsersController;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global c3 */


	var _constants = __webpack_require__(9);

	var _colorPalettes = __webpack_require__(103);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProtocolsPanelController = function () {
	  ProtocolsPanelController.$inject = ["$translate", "$window", "MainService"];
	  function ProtocolsPanelController($translate, $window, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ProtocolsPanelController);

	    this.$translate = $translate;
	    this.$window = $window;
	    this.MainService = MainService;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.time = {
	      range: {
	        startDate: moment().startOf('M').format(),
	        endDate: moment().endOf('M').format()
	      }
	    };

	    this.dateRangeConfig = {
	      autoApply: true,
	      opens: 'left',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          _this.loadData();
	        }
	      }
	    };

	    this.weekdays = _constants.weekdays[user.attributes.locale];

	    this.loadData();
	  }

	  _createClass(ProtocolsPanelController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      this.loading = true;

	      var query = {
	        any: {
	          from_date: { operator: 'eq', value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') },
	          to_date: { operator: 'eq', value: moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD') }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.PROTOCOLS + '/reports/overview', query).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.data = res.data;
	        _this2.translateTypes();
	        _this2.setReportGraph();
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'translateTypes',
	    value: function translateTypes() {
	      var _this3 = this;

	      this.data.asset_type.forEach(function (type, index) {
	        _this3.data.asset_type[index] = _this3.$translate.instant('PROTOCOLS.ENUM.VEHICLE_TYPE.' + type.toUpperCase());
	      });
	    }
	  }, {
	    key: 'setReportGraph',
	    value: function setReportGraph() {
	      return c3.generate({
	        bindto: '#manage-items',
	        data: {
	          x: 'x',
	          columns: [['x'].concat(this.data.asset_type), [this.$translate.instant('PROTOCOLS.ENUM.GRAPH.TOTAL')].concat(this.data.abs.total_by_asset), [this.$translate.instant('PROTOCOLS.ENUM.GRAPH.CONCLUDED')].concat(this.data.abs.completed_by_asset)],
	          type: 'bar',
	          empty: {
	            label: {
	              text: this.$translate.instant('PROTOCOLS.HINT.NO_DATA')
	            }
	          }
	        },
	        size: {
	          height: 300
	        },
	        color: {
	          pattern: _colorPalettes.PALETTES.old_green
	        },
	        grid: {
	          y: {
	            show: true
	          },
	          x: {
	            show: false
	          }
	        },
	        legend: {
	          show: false
	        },
	        bar: {
	          width: {
	            ratio: 0.8
	          }
	        },
	        axis: {
	          x: {
	            type: 'category'
	          }
	        }
	      });
	    }
	  }]);

	  return ProtocolsPanelController;
	}();

	exports.default = ProtocolsPanelController;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskLocationsController = function () {
	  TaskLocationsController.$inject = ["$mdDialog", "GeocodingService", "MainService", "locals"];
	  function TaskLocationsController($mdDialog, GeocodingService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskLocationsController);

	    this.$mdDialog = $mdDialog;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;

	    this.selectedPlace = locals.item;
	  }

	  _createClass(TaskLocationsController, [{
	    key: 'getAddress',
	    value: function getAddress(query) {
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res.map(function (r) {
	          return {
	            attributes: {
	              location: {
	                formatted_address: r.formatted_address,
	                coords: [r.geometry.location.lat, r.geometry.location.lng]
	              }
	            }
	          };
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          type: 'locations',
	          attributes: {
	            description: this.selectedPlace.attributes.description,
	            location: {
	              formatted_address: this.selectedPlace.attributes.location.formatted_address,
	              coords: this.selectedPlace.attributes.location.coords
	            }
	          }
	        }
	      };

	      if (this.selectedPlace.id) {
	        obj.data.id = this.selectedPlace.id;
	      }

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskLocationsController;
	}();

	exports.default = TaskLocationsController;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _sharings = __webpack_require__(167);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskSharingController = function () {
	  TaskSharingController.$inject = ["$state", "$window", "DialogService", "EnvironmentConfig", "locals", "MainService"];
	  function TaskSharingController($state, $window, DialogService, EnvironmentConfig, locals, MainService) {
	    'ngInject';

	    _classCallCheck(this, TaskSharingController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.locals = locals;
	    this.MainService = MainService;

	    this.sharingResourcesOpts = _sharings.SHARING_OPTS;

	    this.protocol = { attributes: this.locals.item.attributes };
	    this.enterprise = this.locals.item.relationships.enterprise;
	    this.vehicle = this.locals.item.relationships.asset;
	    this.devices = this.locals.item.relationships.asset_devices;
	    this.selectedDevice = this.devices[0];

	    this.sharing = {
	      attributes: {
	        type: 'live-location',
	        resources: ['enterprise', 'asset']
	      }
	    };

	    this.updateMetaValidation();
	  }

	  _createClass(TaskSharingController, [{
	    key: 'toggle',
	    value: function toggle(item) {
	      var idx = this.sharing.attributes.resources.indexOf(item);
	      if (idx > -1) {
	        this.sharing.attributes.resources.splice(idx, 1);
	      } else {
	        this.sharing.attributes.resources.push(item);
	      }
	    }
	  }, {
	    key: 'exists',
	    value: function exists(item) {
	      if (this.sharing.attributes.resources == null) {
	        this.sharing.attributes.resources = [];
	      }
	      return this.sharing.attributes.resources.indexOf(item) > -1;
	    }
	  }, {
	    key: 'updateMetaValidation',
	    value: function updateMetaValidation() {
	      this.meta = {
	        min_date: moment().toISOString(),
	        max_date: moment().add(30, 'd').toISOString()
	      };
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.processing = true;
	      var sharing = {
	        data: {
	          attributes: {
	            type: this.sharing.attributes.type,
	            valid_until: this.sharing.attributes.valid_until,
	            source: this.protocol.attributes.token,
	            resources: this.sharing.attributes.resources
	          }
	        }
	      };

	      sharing.data.relationships = {
	        enterprise: {
	          type: 'enterprise',
	          id: this.enterprise.id
	        },
	        device: {
	          type: 'device',
	          id: this.selectedDevice.id
	        }
	      };

	      (0, _helper.cleanPayload)(sharing.data, true);
	      this.MainService.create(_constants.API.V5, _constants.API.SHARINGS, sharing).promise.then(function (res) {
	        _this.processing = false;
	        _this.DialogService.closeDialog(res);
	      }).catch(function () {
	        _this.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return TaskSharingController;
	}();

	exports.default = TaskSharingController;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SHARING_OPTS = exports.SHARING_OPTS = {
	  'live-location': {
	    resources: ['enterprise', 'chip', 'asset', 'history', 'user']
	  },
	  history: {
	    inputs: [{ type: 'date', name: 'from' }, { type: 'date', name: 'to' }],
	    resources: []
	  }
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _serviceOrdersList = __webpack_require__(169);

	var _serviceOrdersList2 = _interopRequireDefault(_serviceOrdersList);

	var _serviceOrdersEdit = __webpack_require__(170);

	var _serviceOrdersEdit2 = _interopRequireDefault(_serviceOrdersEdit);

	var _customFields = __webpack_require__(171);

	var _customFields2 = _interopRequireDefault(_customFields);

	var _documents = __webpack_require__(172);

	var _documents2 = _interopRequireDefault(_documents);

	var _acknowledgements = __webpack_require__(173);

	var _acknowledgements2 = _interopRequireDefault(_acknowledgements);

	var _templateList = __webpack_require__(174);

	var _templateList2 = _interopRequireDefault(_templateList);

	var _acknowledgements3 = __webpack_require__(175);

	var _acknowledgements4 = _interopRequireDefault(_acknowledgements3);

	var _completeDate = __webpack_require__(176);

	var _completeDate2 = _interopRequireDefault(_completeDate);

	var _settings = __webpack_require__(177);

	var _settings2 = _interopRequireDefault(_settings);

	var _expenses = __webpack_require__(178);

	var _expenses2 = _interopRequireDefault(_expenses);

	var _customFields3 = __webpack_require__(179);

	var _customFields4 = _interopRequireDefault(_customFields3);

	var _templateItems = __webpack_require__(180);

	var _templateItems2 = _interopRequireDefault(_templateItems);

	var _serviceOrdersPanel = __webpack_require__(181);

	var _serviceOrdersPanel2 = _interopRequireDefault(_serviceOrdersPanel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.operational.service-orders', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'service-orders-list',
	    url: '/service-orders/list?search&filters',
	    parent: 'operational',
	    menu: true,
	    alias: 'service-orders',
	    controller: _serviceOrdersList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/list/service-orders.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_LIST',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.PROVIDER))
	    }
	  }).state({
	    name: 'service-orders-create',
	    url: '/service-orders/create',
	    parent: 'operational',
	    controller: _serviceOrdersEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/edit/service-orders.edit.html',
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_CREATE',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'service-orders-edit',
	    url: '/service-orders/edit/:id',
	    parent: 'operational',
	    controller: _serviceOrdersEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/edit/service-orders.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    redirectTo: 'service-orders-edit.custom-fields'
	  }).state({
	    name: 'service-orders-edit.custom-fields',
	    url: '/custom-fields',
	    controller: _customFields2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/tabs/custom-fields/custom-fields.html',
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_CUSTOM',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'service-orders-edit.documents',
	    url: '/documents',
	    controller: _documents2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/tabs/documents/documents.html',
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_DOCUMENTS',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'service-orders-edit.acknowledgements',
	    url: '/acknowledgements',
	    controller: _acknowledgements2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/tabs/acknowledgements/acknowledgements.html',
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_ACK',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'service-orders-panel',
	    url: '/service-orders/panel',
	    parent: 'operational',
	    controller: _serviceOrdersPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/service-orders/panel/service-orders.panel.html',
	    data: {
	      requiresLogin: true,
	      pageTitle: 'SERVICE_ORDERS_PANEL',
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('ServiceOrderListController', _serviceOrdersList2.default).controller('ServiceOrderEditController', _serviceOrdersEdit2.default).controller('ServiceOrderCustomFieldsController', _customFields2.default).controller('ServiceOrderDocumentsController', _documents2.default).controller('ServiceOrderAcknowledgementsController', _acknowledgements2.default).controller('TemplateListController', _templateList2.default).controller('TaskAcknowledgementsController', _acknowledgements4.default).controller('TaskCompleteDateController', _completeDate2.default).controller('TaskExpensesController', _expenses2.default).controller('TaskCustomFieldsController', _customFields4.default).controller('TaskTemplateItemsController', _templateItems2.default).controller('TaskSettingsController', _settings2.default).controller('ServiceOrderPanelController', _serviceOrdersPanel2.default);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	var _dialog = __webpack_require__(30);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ServiceOrderListController = function (_ListController) {
	  ServiceOrderListController.$inject = ["$state", "$scope", "$translate", "DialogService", "MainService"];
	  _inherits(ServiceOrderListController, _ListController);

	  function ServiceOrderListController($state, $scope, $translate, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, ServiceOrderListController);

	    var _this = _possibleConstructorReturn(this, (ServiceOrderListController.__proto__ || Object.getPrototypeOf(ServiceOrderListController)).call(this, $scope, $state, $translate, MainService));

	    _this.DialogService = DialogService;

	    _this.query = {
	      attributes: ['*'],
	      includes: {},
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'screen',
	      export: true,
	      stats: true
	    };

	    _this.setProps(_constants.API.V5, _constants.API.SERVICE_ORDERS, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(ServiceOrderListController, [{
	    key: 'openGenerateOptions',
	    value: function openGenerateOptions(item) {
	      this.opt = _dialog.DIALOG._opts('app/components/generate-file/generate.dialog.html', 'GenerateDialogController');
	      Object.assign(this.opt, { escapeToClose: false });
	      this.DialogService.openDialog(this.opt, { item: item });
	    }
	  }, {
	    key: 'transformLocation',
	    value: function transformLocation(item) {
	      if (angular.isObject(item.attributes.addresses)) return;
	      item.attributes.addresses = angular.fromJson(item.attributes.addresses);
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.TOKEN_PRIORITY', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.TYPE_STATUS', 'PANEL.HEADER.VEHICLE_TYPE', 'PANEL.HEADER.TIME_DATE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.TOKEN_PRIORITY'],
	          sort: true,
	          prop: 'token'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise_name'
	        }, {
	          label: t['PANEL.HEADER.TYPE_STATUS'],
	          sort: true,
	          prop: 'type_name'
	        }, {
	          label: t['PANEL.HEADER.VEHICLE_TYPE'],
	          sort: true,
	          prop: 'asset_plate'
	        }, {
	          label: t['PANEL.HEADER.TIME_DATE'],
	          sort: true,
	          prop: 'due_date'
	        }];
	      });
	    }
	  }]);

	  return ServiceOrderListController;
	}(_list2.default);

	exports.default = ServiceOrderListController;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServiceOrderEditController = function () {
	  ServiceOrderEditController.$inject = ["$scope", "$state", "$window", "DialogService", "EnvironmentConfig", "GeocodingService", "MainService", "StateManagement"];
	  function ServiceOrderEditController($scope, $state, $window, DialogService, EnvironmentConfig, GeocodingService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ServiceOrderEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.priorities = _constants.TASK_PRIORITIES;
	    this.readOnly = true;

	    this.usersOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: '' },
	        'roles.internal': { operator: 'eq', value: false }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.usersOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });

	    this.isEdit();
	  }

	  _createClass(ServiceOrderEditController, [{
	    key: 'getTypes',
	    value: function getTypes(query) {
	      var _this2 = this;

	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	        }
	      };

	      if (query) {
	        obj.filters.name = { operator: 'ilk', value: query };
	      }

	      return this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/types', obj).promise.then(function (res) {
	        return res.data;
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'getSections',
	    value: function getSections(query) {
	      var _this3 = this;

	      this.loading = true;

	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	        }
	      };

	      if (query) {
	        obj.filters.name = { operator: 'ilk', value: query };
	      }

	      return this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/sections', obj).promise.then(function (res) {
	        return res.data;
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress(query) {
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res.map(function (r) {
	          return {
	            attributes: {
	              location: {
	                formatted_address: r.formatted_address,
	                coords: [r.geometry.location.lat, r.geometry.location.lng]
	              }
	            }
	          };
	        });
	      });
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this4 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.loading = true;
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            completed: ['username,name,email,phone1,phone2'],
	            section: ['*'],
	            completion: ['*'],
	            type: ['*'],
	            addresses: ['*'],
	            enterprise: ['name,cnpj,email,phone1,deactivated_at,timezone'],
	            assignee: ['username,name,email,phone1,phone2'],
	            asset: ['plate,code,vin,brand_name,trim_name,model_name,year,color']
	          }
	        };
	        this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id, obj).promise.then(function (res) {
	          _this4.serviceOrder = res.data;
	          _this4.selectedAssignee = _this4.serviceOrder.relationships.assignee;
	          _this4.selectedEnterprise = _this4.serviceOrder.relationships.enterprise;
	          _this4.selectedAsset = _this4.serviceOrder.relationships.asset;
	          _this4.selectedSection = _this4.serviceOrder.relationships.section;
	          _this4.selectedType = _this4.serviceOrder.relationships.type;
	          _this4.serviceOrder.attributes.due_date = res.data.attributes.due_date ? new Date(res.data.attributes.due_date) : '';

	          _this4.StateManagement.setData(['enterprise'], [_this4.serviceOrder.relationships.enterprise]);
	          _this4.checkReadOnly(_this4.serviceOrder.attributes.config);
	          _this4.formatAddresses();
	        }).finally(function () {
	          _this4.loading = false;
	        });
	      } else {
	        this.readOnly = false;
	        this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	        this.serviceOrder = {
	          attributes: {}
	        };
	      }
	    }
	  }, {
	    key: 'customDate',
	    value: function customDate() {
	      var _this5 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_COMPLETE_DATE.path, _dialog.DIALOG.TASK_COMPLETE_DATE.ctrl);
	      this.DialogService.openDialog(opt).then(function (res) {
	        _this5.toggleComplete(res.date);
	      });
	    }
	  }, {
	    key: 'toggleComplete',
	    value: function toggleComplete() {
	      var _this6 = this;

	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      this.loading = true;
	      var serviceOrder = null;

	      if (!this.serviceOrder.relationships.completion) {
	        serviceOrder = {
	          data: {
	            attributes: {
	              completed_at: date || new Date()
	            }
	          }
	        };
	      }
	      var action = this.serviceOrder.relationships.completion ? 'uncomplete' : 'complete';

	      this.MainService.edit(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/' + action, serviceOrder).promise.then(function (res) {
	        _this6.serviceOrder.relationships.completion = res.data.relationships.completion;
	        _this6.checkReadOnly(_this6.serviceOrder.attributes.config);
	      }).finally(function () {
	        _this6.loading = false;
	      });
	    }
	  }, {
	    key: 'formatAddresses',
	    value: function formatAddresses() {
	      if (this.serviceOrder.relationships.addresses && this.serviceOrder.relationships.addresses.length > 0) {
	        this.serviceOrder.relationships.addresses.forEach(function (address) {
	          if (address.attributes.coords && address.attributes.coords.coordinates) {
	            address.attributes.coords = address.attributes.coords.coordinates;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'addEditAddress',
	    value: function addEditAddress() {
	      var _this7 = this;

	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      var data = Object.assign({}, item || { attributes: {} }, { action: 'add' });

	      var opt = _dialog.DIALOG._opts('app/components/address-form/address-form.html', 'AddressFormController');
	      this.DialogService.openDialog(opt, data).then(function (address) {
	        _this7.serviceOrder.relationships = _this7.serviceOrder.relationships || {};
	        _this7.serviceOrder.relationships.addresses = [];
	        _this7.serviceOrder.relationships.addresses.push({ attributes: address.data.attributes });
	      });
	    }
	  }, {
	    key: 'deleteAddress',
	    value: function deleteAddress(index) {
	      this.serviceOrder.relationships.addresses.splice(index, 1);
	    }
	  }, {
	    key: 'openGenerateOptions',
	    value: function openGenerateOptions(item) {
	      this.opt = _dialog.DIALOG._opts('app/components/generate-file/generate.dialog.html', 'GenerateDialogController');
	      Object.assign(this.opt, { escapeToClose: false });
	      this.DialogService.openDialog(this.opt, { item: item });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this8 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        _this8.MainService.delete(_constants.API.V5, _constants.API.SERVICE_ORDERS, _this8.serviceOrder.id).promise.then(function () {
	          _this8.$state.go('service-orders-list');
	        });
	      });
	    }
	  }, {
	    key: 'openTermsTemplate',
	    value: function openTermsTemplate() {
	      var _this9 = this;

	      var opt = _dialog.DIALOG._opts('app/components/template-list/template-list.html', 'TemplateListController');

	      this.DialogService.openDialog(opt, { enterpriseId: this.selectedEnterprise.id }).then(function (templateModel) {
	        _this9.serviceOrder.attributes.description = templateModel.attributes.text;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this10 = this;

	      this.loading = true;
	      var serviceOrder = {
	        data: {
	          attributes: {
	            name: this.serviceOrder.attributes.name,
	            notes: this.serviceOrder.attributes.notes,
	            priority: this.serviceOrder.attributes.priority,
	            description: this.serviceOrder.attributes.description,
	            due_date: this.serviceOrder.attributes.due_date || '',
	            config: this.serviceOrder.attributes.config || ''
	          },
	          relationships: {
	            addresses: [],
	            type: {
	              type: 'type',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedType.id)
	            }
	          }
	        }
	      };

	      if (angular.isDefined(this.$state.params.id) || this.selectedAssignee) {
	        serviceOrder.data.relationships.assignee = {
	          type: 'user',
	          id: this.selectedAssignee ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedAssignee.id) : null
	        };
	      }

	      if (angular.isDefined(this.$state.params.id) || this.selectedSection) {
	        serviceOrder.data.relationships.section = {
	          type: 'section',
	          id: this.selectedSection ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedSection.id) : null
	        };
	      }

	      if (this.serviceOrder.relationships && this.serviceOrder.relationships.addresses) {
	        serviceOrder.data.relationships.addresses = this.serviceOrder.relationships.addresses.map(function (i) {
	          (0, _helper.cleanPayload)(i, true);
	          i.attributes = (0, _helper.omit)(i.attributes, ['created_at', 'updated_at', 'model']);
	          var obj = {
	            attributes: i.attributes,
	            type: 'address'
	          };

	          if (i.id) {
	            Object.assign(obj, { id: i.id });
	          }

	          return obj;
	        });
	      }

	      if (angular.isDefined(this.$state.params.id)) {
	        serviceOrder.data.attributes = (0, _helper.omit)(serviceOrder.data.attributes, ['config']);
	        (0, _helper.cleanPayload)(serviceOrder.data);
	        this.MainService.update(_constants.API.V5, _constants.API.SERVICE_ORDERS, this.$state.params.id, serviceOrder).promise.then(function (res) {
	          _this10.serviceOrder = Object.assign(res.data, _this10.serviceOrder);
	        }).finally(function () {
	          _this10.loading = false;
	        });
	      } else {
	        Object.assign(serviceOrder.data.relationships, {
	          enterprise: {
	            type: 'enterprise',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	          },
	          asset: {
	            type: 'asset',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedAsset.id)
	          }
	        });

	        (0, _helper.cleanPayload)(serviceOrder.data, true);
	        this.MainService.create(_constants.API.V5, _constants.API.SERVICE_ORDERS, serviceOrder).promise.then(function (res) {
	          _this10.$state.go('service-orders-edit', { id: res.data.id }, { notify: false });
	          _this10.formatAddresses();
	        }).finally(function () {
	          _this10.loading = false;
	        });
	      }
	    }
	  }, {
	    key: 'checkReadOnly',
	    value: function checkReadOnly(config) {
	      this.readOnly = config && angular.isDefined(config.lockOnComplete) && this.serviceOrder.relationships.completion ? config.lockOnComplete : false;
	      this.StateManagement.setData(['readOnly'], [{ readOnly: this.readOnly }]);
	    }
	  }, {
	    key: 'editSettings',
	    value: function editSettings(configs) {
	      var _this11 = this;

	      this.loading = true;
	      var settings = {
	        data: {
	          attributes: {
	            config: {}
	          }
	        }
	      };
	      Object.assign(settings.data.attributes.config, configs);

	      this.MainService.edit(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/config', settings).promise.then(function (res) {
	        _this11.serviceOrder.attributes.config = res.data.attributes.config;
	        _this11.checkReadOnly(_this11.serviceOrder.attributes.config);
	      }).finally(function () {
	        _this11.loading = false;
	      });
	    }
	  }, {
	    key: 'settings',
	    value: function settings() {
	      var _this12 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_SETTINGS.path, _dialog.DIALOG.TASK_SETTINGS.ctrl);
	      this.DialogService.openDialog(opt, this.serviceOrder.attributes.config).then(function (res) {
	        if (_this12.serviceOrder.id) {
	          _this12.editSettings(res.attributes);
	        } else {
	          _this12.serviceOrder.attributes.config = res.attributes;
	        }
	      });
	    }
	  }]);

	  return ServiceOrderEditController;
	}();

	exports.default = ServiceOrderEditController;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServiceOrderCustomFieldsController = function () {
	  ServiceOrderCustomFieldsController.$inject = ["$state", "$rootScope", "$scope", "$window", "DialogService", "MainService", "StateManagement"];
	  function ServiceOrderCustomFieldsController($state, $rootScope, $scope, $window, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ServiceOrderCustomFieldsController);

	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;
	    this.enterpriseLoad = false;

	    this.selectAllItems = false;
	    this.selectedItems = [];
	    this.custom_fields = [];
	    this.customFieldsBackup = [];
	    this.sortingActive = false;
	    this.readOnly = true;
	    this.total = 0;
	    this.loadingCustom = true;

	    this.query = {
	      attributes: ['*'],
	      sort: {
	        prop: 'order',
	        order: 'DESC'
	      },
	      count: true,
	      limit: '100',
	      page: 1,
	      search: null
	    };
	    this.iconField = internals._iconFieldFormat();

	    var enterprise = function enterprise() {
	      return _this.loadEnterprise();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && (newValue.includes('enterprise') || newValue.includes('readOnly'))) {
	        enterprise();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });

	    this.loadData();
	  }

	  _createClass(ServiceOrderCustomFieldsController, [{
	    key: 'resetSelectAll',
	    value: function resetSelectAll() {
	      this.selectAllItems = false;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem() {
	      this.selectedItems = this.custom_fields.filter(function (cf) {
	        return cf.selected;
	      });
	      this.selectAllItems = this.selectedItems.length === this.custom_fields.length;
	    }
	  }, {
	    key: 'toggleSection',
	    value: function toggleSection() {
	      var _this2 = this;

	      this.custom_fields.forEach(function (cf) {
	        cf.selected = _this2.selectAllItems;
	      });
	      this.selectItem();
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      if (this.stopPropagation || this.loading || this.custom_fields.length === 0) {
	        return;
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'loadEnterprise',
	    value: function loadEnterprise() {
	      this.enterpriseLoad = true;

	      var _StateManagement$getD = this.StateManagement.getData(['enterprise', 'readOnly']),
	          enterprise = _StateManagement$getD.enterprise,
	          readOnly = _StateManagement$getD.readOnly;

	      this.readOnly = readOnly && angular.isDefined(readOnly.readOnly) ? readOnly.readOnly : false;
	      this.currentEnterprise = enterprise;
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this3 = this;

	      this.loading = true;
	      this.loadingCustom = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/custom-fields', this.query).promise.then(function (res) {
	        var _custom_fields;

	        _this3.total = res.count;
	        _this3.stopPropagation = res.data.length === 0;
	        if (_this3.selectAllItems) {
	          res.data.forEach(function (d) {
	            d.selected = true;
	          });
	        }
	        (_custom_fields = _this3.custom_fields).push.apply(_custom_fields, _toConsumableArray(res.data));
	        _this3.customFieldsBackup = angular.copy(_this3.custom_fields);
	        _this3.query.page += 1;
	      }).finally(function () {
	        _this3.loading = false;
	        _this3.loadingCustom = false;
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(customField) {
	      var _this4 = this;

	      var fields = Object.assign({}, customField, { totalItems: this.total });

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_CUSTOM_FIELDS.path, _dialog.DIALOG.TASK_CUSTOM_FIELDS.ctrl);
	      this.DialogService.openDialog(opt, fields).then(function (obj) {
	        if (!customField) {
	          obj.attributes.order = (_this4.total + 1) * 100000;
	          _this4.create(obj);
	        } else {
	          _this4.edit(customField.id, obj);
	        }
	      });
	    }
	  }, {
	    key: 'openSort',
	    value: function openSort() {
	      this.sortingActive = !this.sortingActive;
	      this.custom_fields.forEach(function (i) {
	        return i.panelExpanded = false;
	      });
	    }
	  }, {
	    key: 'sort',
	    value: function sort(item, partTo, indexTo) {
	      var localeItem = angular.copy(item);
	      var total = this.total;
	      var orderPrev = indexTo === 0 ? (total + 1) * 100000 : partTo[indexTo - 1].attributes.order;
	      var orderNext = indexTo === total - 1 ? 0 : partTo[indexTo + 1].attributes.order;
	      localeItem.attributes.order = Math.floor((orderNext + orderPrev) / 2);

	      this.edit(item.id, localeItem);
	    }
	  }, {
	    key: 'create',
	    value: function create(obj) {
	      var _this5 = this;

	      var items = {
	        data: []
	      };

	      if (angular.isArray(obj)) {
	        items.data = [].concat(_toConsumableArray(obj));
	      } else {
	        items.data.push(obj);
	      }
	      this.MainService.create(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/custom-fields', items).promise.then(function (res) {
	        var _custom_fields2;

	        _this5.total += res.data.length;
	        (_custom_fields2 = _this5.custom_fields).unshift.apply(_custom_fields2, _toConsumableArray(res.data));
	        _this5.customFieldsBackup = angular.copy(_this5.custom_fields);
	      }).finally(function () {
	        _this5.loading = false;
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(customFieldsId, obj) {
	      var _this6 = this;

	      if (obj.attributes.field_format === 'checkbox' && obj.attributes.value) {
	        obj.attributes.value = angular.toJson(obj.attributes.value);
	      }
	      var items = {
	        data: (0, _helper.omit)(obj, ['created_at', 'updated_at', 'relationships', 'id', 'type', 'totalItems', 'panelExpanded', 'selected'])
	      };
	      (0, _helper.cleanPayload)(items.data, true);
	      var index = this.custom_fields.findIndex(function (item) {
	        return item.id === customFieldsId;
	      });

	      if (this.custom_fields[index].attributes.field_format !== obj.attributes.field_format) {
	        items.data.attributes.value = null;
	      }

	      this.MainService.update(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/custom-fields', customFieldsId, items).promise.then(function () {
	        Object.assign(_this6.custom_fields[index].attributes, obj.attributes);
	      }).catch(function () {
	        _this6.custom_fields.sort(function (a, b) {
	          return b.attributes.order - a.attributes.order;
	        });
	      });
	    }
	  }, {
	    key: 'getSavedItems',
	    value: function getSavedItems() {
	      var _this7 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_TEMPLATE_ITEM.path, _dialog.DIALOG.TASK_TEMPLATE_ITEM.ctrl);

	      this.DialogService.openDialog(opt, { enterpriseId: this.currentEnterprise.id }).then(function (obj) {
	        obj.forEach(function (item, index) {
	          item.attributes.order = (_this7.total + index + 1) * 100000;
	        });
	        obj.sort(function (a, b) {
	          return b.attributes.order - a.attributes.order;
	        });
	        _this7.create(obj);
	      });
	    }
	  }, {
	    key: 'tagAnswered',
	    value: function tagAnswered(id) {
	      var savedAnswer = this.customFieldsBackup.find(function (i) {
	        return i.id === id;
	      });
	      if (!savedAnswer) return null;

	      var attributes = savedAnswer.attributes;

	      var answer = attributes.value;

	      return attributes.field_format === 'checkbox' && answer && answer.length === 0 ? null : answer;
	    }
	  }, {
	    key: 'updateValues',
	    value: function updateValues(item) {
	      var _this8 = this;

	      var valueFormatted = String(item.attributes.value);
	      if (item.attributes.field_format === 'checkbox') {
	        valueFormatted = item.attributes.value.length === 0 ? null : angular.toJson(item.attributes.value);
	      }
	      var oldValue = this.customFieldsBackup.filter(function (i) {
	        return i.id === item.id;
	      });

	      if (oldValue[0].attributes.value !== valueFormatted) {
	        var items = {
	          data: {
	            attributes: {
	              value: valueFormatted || null
	            }
	          }
	        };
	        this.MainService.update(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/custom-fields/' + item.id, 'set-value', items).promise.then(function () {
	          _this8.customFieldsBackup = angular.copy(_this8.custom_fields);
	        });
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this9 = this;

	      var items = { data: [] };
	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'DISASSOCIATE', label: 'DISASSOCIATE', action: 'delete' }).then(function () {
	        _this9.custom_fields.forEach(function (cf) {
	          if (cf.selected) {
	            items.data.push({
	              type: 'task_custom_fields',
	              id: cf.id
	            });
	          }
	        });
	        _this9.loadingCustom = true;
	        _this9.MainService.deleteMany(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + _this9.$state.params.id + '/custom-fields', items).promise.then(function () {
	          _this9.total -= items.data.length;
	          _this9.custom_fields = _this9.custom_fields.filter(function (cf) {
	            return !items.data.map(function (i) {
	              return i.id;
	            }).includes(cf.id);
	          });
	          _this9.selectItem();
	          _this9.resetSelectAll();
	        }).finally(function () {
	          _this9.loadingCustom = false;
	        });
	      });
	    }
	  }, {
	    key: 'open',
	    value: function open(item) {
	      if (item.attributes.field_format === 'checkbox') {
	        item.attributes.value = item.attributes.value ? angular.fromJson(item.attributes.value) : [];
	      }
	    }
	  }, {
	    key: 'exists',
	    value: function exists(item, list) {
	      if (!list) return;
	      return list.indexOf(item) > -1;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(item, list) {
	      if (!list) return;
	      var idx = list.indexOf(item);
	      if (idx > -1) {
	        list.splice(idx, 1);
	      } else {
	        list.push(item);
	      }
	    }
	  }]);

	  return ServiceOrderCustomFieldsController;
	}();

	exports.default = ServiceOrderCustomFieldsController;


	var internals = {
	  _iconFieldFormat: function _iconFieldFormat() {
	    return {
	      date: 'calendar_today',
	      enum: 'list_alt',
	      checkbox: 'checklist',
	      number: 'pin',
	      text: 'insert_text'
	    };
	  }
	};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServiceOrderDocumentsController = function () {
	  ServiceOrderDocumentsController.$inject = ["$state", "DialogService", "MainService"];
	  function ServiceOrderDocumentsController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, ServiceOrderDocumentsController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.model = this.$state.params.id;
	    this.documents = [];

	    this.query = {
	      attributes: ['*'],
	      sort: {
	        prop: 'created_at',
	        order: 'ASC'
	      },
	      count: true
	    };

	    this.loadData();
	  }

	  _createClass(ServiceOrderDocumentsController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      this.loading = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/documents', this.query).promise.then(function (res) {
	        var _documents;

	        _this.stopPropagation = res.data.length === 0;
	        (_documents = _this.documents).push.apply(_documents, _toConsumableArray(res.data));
	        _this.count = res.count;
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }]);

	  return ServiceOrderDocumentsController;
	}();

	exports.default = ServiceOrderDocumentsController;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServiceOrderAcknowledgementsController = function () {
	  ServiceOrderAcknowledgementsController.$inject = ["$state", "$rootScope", "$scope", "$translate", "$window", "DialogService", "MainService", "StateManagement"];
	  function ServiceOrderAcknowledgementsController($state, $rootScope, $scope, $translate, $window, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ServiceOrderAcknowledgementsController);

	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.enterpriseLoad = false;
	    this.role = this.$window.localStorage.getItem('role');
	    this.user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.acknowledgements = [];
	    this.selectedItems = [];
	    this.ackPossibleAction = [];
	    this.readOnly = true;
	    this.selectAllItems = false;
	    this.loadingAck = true;

	    this.query = {
	      attributes: ['*'],
	      sort: {
	        prop: 'created_at',
	        order: 'ASC'
	      },
	      includes: {
	        acknowledger: ['*'],
	        requester: ['*']
	      },
	      count: true,
	      limit: 25,
	      page: 1,
	      search: null
	    };

	    var enterprise = function enterprise() {
	      return _this.loadEnterprise();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && (newValue.includes('enterprise') || newValue.includes('readOnly'))) {
	        enterprise();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });

	    this.loadData();
	  }

	  _createClass(ServiceOrderAcknowledgementsController, [{
	    key: 'loadMore',
	    value: function loadMore() {
	      if (this.stopPropagation || this.loading || this.documents.length === 0) {
	        return;
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'loadEnterprise',
	    value: function loadEnterprise() {
	      this.enterpriseLoad = true;

	      var _StateManagement$getD = this.StateManagement.getData(['enterprise', 'readOnly']),
	          enterprise = _StateManagement$getD.enterprise,
	          readOnly = _StateManagement$getD.readOnly;

	      this.readOnly = readOnly && angular.isDefined(readOnly.readOnly) ? readOnly.readOnly : false;
	      this.currentEnterprise = enterprise;
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      this.loading = true;
	      this.loadingAck = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.$state.params.id + '/acknowledgements', this.query).promise.then(function (res) {
	        var _acknowledgements;

	        _this2.total = res.count;
	        _this2.stopPropagation = res.data.length === 0;
	        (_acknowledgements = _this2.acknowledgements).push.apply(_acknowledgements, _toConsumableArray(res.data));
	        _this2.query.page += 1;
	        _this2.ackPossibleAction = _this2.acknowledgements.filter(function (ack) {
	          return !ack.attributes.acknowledged_at;
	        });
	      }).finally(function () {
	        _this2.loading = false;
	        _this2.loadingAck = false;
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_ACKNOWLEDGEMENTS_ACTION.path, _dialog.DIALOG.TASK_ACKNOWLEDGEMENTS_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { enterpriseId: this.currentEnterprise.id }).then(function (obj) {
	        var objCopy = angular.copy(obj);
	        Object.assign(obj, (0, _helper.omit)(obj, ['attributes']));
	        _this3.loadingAck = true;

	        _this3.MainService.create(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + _this3.$state.params.id + '/acknowledgements', obj).promise.then(function (res) {
	          var newValue = res.data;
	          newValue.new = true;
	          Object.assign(res.data.relationships.acknowledger, objCopy.data.relationships.acknowledger);
	          _this3.acknowledgements.push(newValue);
	          _this3.ackPossibleAction = _this3.acknowledgements.filter(function (ack) {
	            return !ack.attributes.acknowledged_at;
	          });
	        }).finally(function () {
	          _this3.loadingAck = false;
	        });
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this4 = this;

	      var items = { data: [] };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'ACK', label: 'ACK', action: 'delete' }).then(function () {
	        items.data = _this4.selectedItems.map(function (i) {
	          return {
	            type: 'task_acknowledgements',
	            id: i.id
	          };
	        });

	        _this4.loadingAck = true;
	        _this4.MainService.deleteMany(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + _this4.$state.params.id + '/acknowledgements', items).promise.then(function () {
	          _this4.total -= _this4.selectedItems.length;
	          _this4.acknowledgements = _this4.acknowledgements.filter(function (cf) {
	            return !_this4.selectedItems.map(function (i) {
	              return i.id;
	            }).includes(cf.id);
	          });
	          _this4.selectItem();
	          _this4.selectAllItems = false;
	          _this4.ackPossibleAction = _this4.acknowledgements.filter(function (ack) {
	            return !ack.attributes.acknowledged_at;
	          });
	        }).finally(function () {
	          _this4.loadingAck = false;
	        });
	      });
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem() {
	      this.selectedItems = this.acknowledgements.filter(function (ack) {
	        return ack.selected;
	      });
	      this.selectAllItems = this.selectedItems.length === this.ackPossibleAction.length;
	    }
	  }, {
	    key: 'toggleSectionAll',
	    value: function toggleSectionAll() {
	      var _this5 = this;

	      this.acknowledgements.forEach(function (ack) {
	        if (!ack.attributes.acknowledged_at) {
	          ack.selected = _this5.selectAllItems;
	        }
	      });
	      this.selectItem();
	    }
	  }]);

	  return ServiceOrderAcknowledgementsController;
	}();

	exports.default = ServiceOrderAcknowledgementsController;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TemplateListController = function () {
	  TemplateListController.$inject = ["$mdDialog", "MainService", "locals"];
	  function TemplateListController($mdDialog, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, TemplateListController);

	    this.$mdDialog = $mdDialog;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.locals = locals.item;

	    this.loadData(1);
	    this.loadData = this.loadData.bind(this);
	  }

	  _createClass(TemplateListController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      var _this = this;

	      this.items = [];
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        includes: {},
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        filters: {},
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      if (angular.isDefined(this.locals.enterpriseId)) {
	        Object.assign(obj.filters, { enterprise_id: { operator: 'eq', value: this.locals.enterpriseId } });
	      }

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.locals.enterpriseId + '/terms', obj).promise.then(function (res) {
	        _this.items = res.data;
	        _this.meta.count = res.count;
	        _this.meta.page = page;
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'apply',
	    value: function apply(item) {
	      this.$mdDialog.hide(item);
	    }
	  }]);

	  return TemplateListController;
	}();

	exports.default = TemplateListController;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskAcknowledgementsController = function () {
	  TaskAcknowledgementsController.$inject = ["$mdDialog", "$state", "MainService", "locals"];
	  function TaskAcknowledgementsController($mdDialog, $state, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskAcknowledgementsController);

	    this.$mdDialog = $mdDialog;
	    this.$state = $state;
	    this.MainService = MainService;

	    this.currentItem = angular.isDefined(locals.item.ack) ? angular.copy(locals.item.ack) : null;
	    this.api = angular.isDefined(locals.item.api) ? angular.copy(locals.item.api) : null;
	    this.enterpriseId = angular.isDefined(locals.item.enterpriseId) ? angular.copy(locals.item.enterpriseId) : null;
	  }

	  _createClass(TaskAcknowledgementsController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          relationships: {
	            acknowledger: {
	              type: 'user',
	              id: this.selectedUser.id,
	              attributes: {
	                name: this.selectedUser.attributes.name
	              }
	            }
	          }
	        }
	      };

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskAcknowledgementsController;
	}();

	exports.default = TaskAcknowledgementsController;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskCompleteDateController = function () {
	  TaskCompleteDateController.$inject = ["$mdDialog", "$scope"];
	  function TaskCompleteDateController($mdDialog, $scope) {
	    'ngInject';

	    _classCallCheck(this, TaskCompleteDateController);

	    this.$mdDialog = $mdDialog;
	    this.$scope = $scope;

	    this.completeAt = {
	      date: ''
	    };
	    this.meta = {
	      max_date: moment().add(1, 'm').toISOString()
	    };
	  }

	  _createClass(TaskCompleteDateController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'updateMetaValidation',
	    value: function updateMetaValidation() {
	      this.meta.max_date = moment().add(1, 'm').toISOString();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        date: this.completeAt.date
	      };

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskCompleteDateController;
	}();

	exports.default = TaskCompleteDateController;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskSettingsController = function () {
	  TaskSettingsController.$inject = ["$mdDialog", "$scope", "locals"];
	  function TaskSettingsController($mdDialog, $scope, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskSettingsController);

	    this.$mdDialog = $mdDialog;
	    this.$scope = $scope;

	    this.optionsRestrictions = internals._initialOptions();
	    this.settings = angular.isObject(locals.item) ? angular.copy(locals.item) : {};
	    this.config = {
	      deviceInteraction: this.settings.deviceInteraction || null,
	      lockOnComplete: this.settings.lockOnComplete || null,
	      assigneeDocumentsRestrictions: this.settings.assigneeDocumentsRestrictions || '',
	      assigneeAcknowledgeRestrictions: this.settings.assigneeAcknowledgeRestrictions || null
	    };
	  }

	  _createClass(TaskSettingsController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'updateMetaValidation',
	    value: function updateMetaValidation() {
	      this.meta.max_date = moment().add(1, 'm').toISOString();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        attributes: angular.copy(this.config)
	      };
	      (0, _helper.cleanPayload)(obj, true);

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskSettingsController;
	}();

	exports.default = TaskSettingsController;


	var internals = {
	  _initialOptions: function _initialOptions() {
	    return [{
	      name: 'ANY',
	      key: ''
	    }, {
	      name: 'CAMERA_ONLY',
	      key: 'cameraOnly'
	    }, {
	      name: 'VIEW_ONLY',
	      key: 'viewOnly'
	    }, {
	      name: 'ALL',
	      key: 'all'
	    }];
	  }
	};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskExpensesController = function () {
	  TaskExpensesController.$inject = ["$mdDialog", "$state", "MainService", "locals"];
	  function TaskExpensesController($mdDialog, $state, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskExpensesController);

	    this.$mdDialog = $mdDialog;
	    this.$state = $state;
	    this.MainService = MainService;

	    this.expense = locals.item;
	    this.categories = _constants.TASK_EXPENSE_TYPES;
	    this.convertData();
	  }

	  _createClass(TaskExpensesController, [{
	    key: 'convertData',
	    value: function convertData() {
	      if (this.expense) {
	        this.expense.attributes.category_locale = this.expense.attributes.category;
	        this.expense.attributes.amount_locale = this.expense.attributes.amount / 100;
	        this.expense.attributes.unit_price_locale = this.expense.attributes.unit_price / 100;
	        this.expense.attributes.total_price_locale = this.expense.attributes.total_price / 100;
	        this.expense.attributes.description_locale = this.expense.attributes.description;
	      }
	    }
	  }, {
	    key: 'calculateTotal',
	    value: function calculateTotal() {
	      var total = this.expense.attributes.amount_locale * this.expense.attributes.unit_price_locale;
	      this.expense.attributes.total_price_locale = Math.floor(total * 100) / 100;
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          type: 'expenses',
	          attributes: {
	            category: this.expense.attributes.category_locale,
	            amount: parseInt(this.expense.attributes.amount_locale * 100),
	            unit_price: parseInt(this.expense.attributes.unit_price_locale * 100),
	            total_price: parseInt(this.expense.attributes.total_price_locale * 100),
	            description: this.expense.attributes.description_locale
	          }
	        }
	      };

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskExpensesController;
	}();

	exports.default = TaskExpensesController;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskCustomFieldsController = function () {
	  TaskCustomFieldsController.$inject = ["$mdDialog", "$window", "MainService", "locals"];
	  function TaskCustomFieldsController($mdDialog, $window, MainService, locals) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, TaskCustomFieldsController);

	    this.$mdDialog = $mdDialog;
	    this.$window = $window;
	    this.MainService = MainService;
	    this.locals = angular.copy(locals);

	    this.openConfig = false;
	    this.editing = false;
	    this.formats = _constants.TASK_CUSTOM_FIELDS_FORMATS;

	    this.callbackSave = function (item) {
	      _this.save(item);
	    };

	    this.isEdit();
	  }

	  _createClass(TaskCustomFieldsController, [{
	    key: 'isEdit',
	    value: function isEdit() {
	      if (angular.isDefined(this.locals.item.attributes)) {
	        this.currentItem = this.locals.item;
	        this.editing = true;
	      } else {
	        this.currentItem = {
	          attributes: {
	            field_format: 'text',
	            possible_values: [],
	            is_required: true,
	            order: (this.locals.item.totalItems + 1) * 100000
	          }
	        };
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save(item) {
	      this.$mdDialog.hide(item.data);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }]);

	  return TaskCustomFieldsController;
	}();

	exports.default = TaskCustomFieldsController;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskTemplateItemsController = function () {
	  TaskTemplateItemsController.$inject = ["$mdDialog", "$window", "MainService", "EnvironmentConfig", "locals"];
	  function TaskTemplateItemsController($mdDialog, $window, MainService, EnvironmentConfig, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskTemplateItemsController);

	    this.$mdDialog = $mdDialog;
	    this.$window = $window;
	    this.MainService = MainService;
	    this.EnvironmentConfig = EnvironmentConfig;

	    this.locals = angular.copy(locals);

	    this.typeOfModel = 'items';
	    this.selectedItems = [];
	    this.countSelected = 0;
	    this.numItems = 100;
	    this.maxSelected = false;
	    this.newItem = false;
	    this.create = this.locals.item.create || false;
	    this.selectedSomeItem = false;

	    this.formats = _constants.TASK_CUSTOM_FIELDS_FORMATS;
	    this.addItem = internals._initialAddItems();
	    this.meta = {
	      page: 1,
	      limit: 10
	    };

	    this.loadData(1);
	    this.loadData = this.loadData.bind(this);
	    this.defineValidations = this.defineValidations.bind(this);
	  }

	  _createClass(TaskTemplateItemsController, [{
	    key: 'toggleModel',
	    value: function toggleModel(model) {
	      if (model !== this.typeOfModel) {
	        this.typeOfModel = model;
	        this.selectedItems = [];
	        this.defineValidations();
	        this.search = '';
	        this.newItem = model === 'new';

	        if (model !== 'new') {
	          this.loadData(1);
	        }
	        if (this.create) {
	          this.addItem = internals._initialAddItems();
	        }
	      }
	    }
	  }, {
	    key: 'defineValidations',
	    value: function defineValidations() {
	      var _this = this;

	      this.countSelected = this.selectedItems.length;
	      var totalForSelection = this.items.length;

	      if (this.typeOfModel === 'templates') {
	        this.countSelected = 0;
	        totalForSelection = this.totalSubItems || 0;

	        this.selectedItems.forEach(function (item) {
	          if (angular.isDefined(item.relationships.template_items)) {
	            _this.countSelected = item.relationships.template_items.length + _this.countSelected;
	          }
	        });
	      }

	      this.selectedSomeItem = this.countSelected > 0 && this.countSelected < totalForSelection;
	      this.maxSelected = this.countSelected > this.numItems;
	    }
	  }, {
	    key: 'checkEmptyItem',
	    value: function checkEmptyItem(item) {
	      if (this.typeOfModel === 'items') return false;
	      return angular.isUndefined(item.relationships.template_items);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      var _this2 = this;

	      this.items = [];
	      this.selectedItems = [];
	      this.countSelected = 0;
	      this.maxSelected = false;
	      this.loading = true;

	      var obj = {
	        attributes: ['*'],
	        includes: internals[this.typeOfModel].includes,
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        filters: {},
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit,
	        search: this.search
	      };

	      if (this.locals.item.enterpriseId) {
	        this.selectedEnterprise = { id: this.locals.item.enterpriseId };
	        obj.filters['enterprise.id'] = { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.locals.item.enterpriseId) };
	      }

	      this.MainService.raw(_constants.API.V5, _constants.API.CHECKLISTS + '/' + this.typeOfModel, obj).promise.then(function (res) {
	        _this2.items = res.data;
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	        if (_this2.typeOfModel === 'templates') {
	          _this2.totalSubItems = 0;
	          _this2.items.forEach(function (item) {
	            if (angular.isDefined(item.relationships.template_items)) {
	              _this2.totalSubItems = item.relationships.template_items.length + _this2.totalSubItems;
	            }
	          });
	        }
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'apply',
	    value: function apply() {
	      var items = [];

	      if (this.typeOfModel === 'templates') {
	        this.selectedItems.forEach(function (si) {
	          si.relationships.template_items.forEach(function (i) {
	            var formattedItem = angular.copy(si.relationships.items.filter(function (item) {
	              return item.id === i.attributes.item_id;
	            })[0]);
	            items.push((0, _helper.omit)(formattedItem, ['created_at', 'updated_at', 'id', 'type', 'value', 'enterprise_id']));
	          });
	        });
	      } else if (this.typeOfModel === 'items' && this.create) {
	        this.selectedItems.forEach(function (si) {
	          items.push((0, _helper.omit)(si, ['created_at', 'updated_at', 'type', 'value', 'enterprise_id', 'relationships']));
	        });
	      } else {
	        this.selectedItems.forEach(function (si) {
	          items.push((0, _helper.omit)(si, ['created_at', 'updated_at', 'id', 'type', 'value', 'enterprise_id', 'relationships']));
	        });
	      }

	      this.$mdDialog.hide(items);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'searchTasksItems',
	    value: function searchTasksItems() {
	      if (this.search == null || this.search === this.searched) {
	        return;
	      }
	      if (this.search === '') {
	        this.searchable = null;
	      }
	      this.searched = this.search;
	      this.loadData(1);
	    }
	  }]);

	  return TaskTemplateItemsController;
	}();

	exports.default = TaskTemplateItemsController;


	var internals = {
	  templates: {
	    includes: {
	      enterprise: ['name', 'cnpj', 'fantasy_name', 'email'],
	      items: ['*'],
	      template_items: ['*']
	    }
	  },
	  items: {
	    includes: {
	      enterprise: ['name', 'cnpj', 'fantasy_name', 'email']
	    }
	  },
	  _initialAddItems: function _initialAddItems() {
	    return {
	      attributes: {
	        possible_values: [],
	        field_format: 'text',
	        is_required: true
	      }
	    };
	  }
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global c3 */


	var _constants = __webpack_require__(9);

	var _colorPalettes = __webpack_require__(103);

	var _helper = __webpack_require__(21);

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServiceOrderPanelController = function () {
	  ServiceOrderPanelController.$inject = ["$state", "$translate", "$window", "MainService"];
	  function ServiceOrderPanelController($state, $translate, $window, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ServiceOrderPanelController);

	    this.$translate = $translate;
	    this.$window = $window;
	    this.$state = $state;
	    this.MainService = MainService;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.time = {
	      range: {
	        startDate: moment().startOf('M').format(),
	        endDate: moment().endOf('M').format()
	      }
	    };

	    this.dateRangeConfig = {
	      autoApply: true,
	      opens: 'left',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          _this.loadTypeGraphData();
	          _this.loadSectionTypesGraphData();
	          _this.loadDayStatusGraphData();
	          _this.loadAssigneeStatusGraphData();
	        }
	      }
	    };

	    this.weekdays = _constants.weekdays[user.attributes.locale];

	    this.loadTypeGraphData();
	    this.loadSectionTypesGraphData();
	    this.loadDayStatusGraphData();
	    this.loadAssigneeStatusGraphData();
	  }

	  _createClass(ServiceOrderPanelController, [{
	    key: 'loadTypeGraphData',
	    value: function loadTypeGraphData() {
	      var _this2 = this;

	      this.loading = true;
	      var query = {
	        any: {
	          groupBy: {
	            operator: 'eq',
	            value: 'asset_type,completed'
	          }
	        },
	        filters: {
	          'task_main_service_orders.due_date': {
	            operator: 'btw',
	            value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') + ',' + moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD')
	          }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, '' + _constants.API.SERVICE_ORDERS, query).promise.then(function (res) {
	        _this2.setReportGraph(res.data);
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'loadSectionTypesGraphData',
	    value: function loadSectionTypesGraphData() {
	      var _this3 = this;

	      this.loading = true;
	      var query = {
	        any: {
	          groupBy: {
	            operator: 'eq',
	            value: 'section_name,type_name'
	          }
	        },
	        filters: {
	          'task_main_service_orders.due_date': {
	            operator: 'btw',
	            value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') + ',' + moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD')
	          }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, '' + _constants.API.SERVICE_ORDERS, query).promise.then(function (res) {
	        _this3.setSectionTypesGraph(res.data);
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'loadDayStatusGraphData',
	    value: function loadDayStatusGraphData() {
	      var _this4 = this;

	      this.loading = true;
	      var query = {
	        any: {
	          groupBy: {
	            operator: 'eq',
	            value: 'due_date:day,completed'
	          }
	        },
	        filters: {
	          'task_main_service_orders.due_date': {
	            operator: 'btw',
	            value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') + ',' + moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD')
	          }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, '' + _constants.API.SERVICE_ORDERS, query).promise.then(function (res) {
	        _this4.setDayStatusGraph(res.data);
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    }
	  }, {
	    key: 'loadAssigneeStatusGraphData',
	    value: function loadAssigneeStatusGraphData() {
	      var _this5 = this;

	      this.loading = true;
	      var query = {
	        any: {
	          groupBy: {
	            operator: 'eq',
	            value: 'assignee_name,completed'
	          }
	        },
	        filters: {
	          'task_main_service_orders.due_date': {
	            operator: 'btw',
	            value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') + ',' + moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD')
	          }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, '' + _constants.API.SERVICE_ORDERS, query).promise.then(function (res) {
	        _this5.setAssigneeStatusGraph(res.data);
	      }).finally(function () {
	        _this5.loading = false;
	      });
	    }
	  }, {
	    key: 'makeGraph',
	    value: function makeGraph(response, config) {
	      var _this6 = this;

	      var map = {};
	      var data = new Set();
	      var columns = [];
	      var columnsConfig = internal.processConfig(config);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = response[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var row = _step.value;

	          var group = columnsConfig.group.value(row.attributes);
	          var category = columnsConfig.category.value(row.attributes);
	          var value = columnsConfig.value(row.attributes);

	          map[group] = map[group] || { total: 0 };
	          map[group][category] = parseInt(value);
	          map[group].total += parseInt(value);
	          data.add(category);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      var headers = Object.keys(map);
	      columns.push(['x'].concat(_toConsumableArray(headers)));

	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;

	      try {
	        var _loop = function _loop() {
	          var d = _step2.value;

	          columns.push([d].concat(_toConsumableArray(headers.map(function (header) {
	            return map[header][d] || 0;
	          }))));
	        };

	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }

	      columns.push(['total'].concat(_toConsumableArray(headers.map(function (header) {
	        return map[header].total || 0;
	      }))));
	      return {
	        x: 'x',
	        columns: columns,
	        type: 'bar',
	        names: Object.assign({}, config.names, { total: this.$translate.instant('SERVICE_ORDER.ENUM.GRAPH.TOTAL') }),
	        types: {
	          'total': 'point'
	        },
	        colors: {
	          'total': '#000000'
	        },
	        onclick: function onclick(data) {
	          return _this6.handleGraphClick(data, columns, columnsConfig);
	        },
	        groups: [Array.from(data)]
	      };
	    }
	  }, {
	    key: 'handleGraphClick',
	    value: function handleGraphClick(data, columns, config) {
	      var group_name = columns[0][data.index + 1];
	      var category_name = data.id;
	      if (category_name && category_name != 'total') {
	        var _filterObj;

	        var filterObj = (_filterObj = {}, _defineProperty(_filterObj, config.group.filter, { "operator": internal.op(group_name), "value": group_name, "type": "string" }), _defineProperty(_filterObj, config.category.filter, { "operator": internal.op(category_name), "value": category_name, "type": "string" }), _defineProperty(_filterObj, 'due_date', {
	          operator: 'btw',
	          value: moment(this.time.range.startDate).startOf('d').format('YYYY-MM-DD') + ',' + moment(this.time.range.endDate).endOf('d').format('YYYY-MM-DD')
	        }), _filterObj);
	        this.$state.go('service-orders-list', { filters: internal.jsonToUri(filterObj) });
	      }
	    }
	  }, {
	    key: 'setReportGraph',
	    value: function setReportGraph(graphData) {
	      var _this7 = this;

	      var data = this.makeGraph(graphData, {
	        group: 'asset_type', category: 'completed', value: 'count', names: {
	          true: this.$translate.instant('SERVICE_ORDER.LABEL.COMPLETED'),
	          false: this.$translate.instant('SERVICE_ORDER.LABEL.NOT_COMPLETED')
	        }
	      });

	      internal.graph({
	        data: data, bindto: '#manage-items', formatCategory: function formatCategory(i) {
	          var category = data.columns[0][i + 1];
	          if (category && category != 'null') {
	            return _this7.$translate.instant('SERVICE_ORDER.ENUM.VEHICLE_TYPE.' + category.toUpperCase());
	          } else {
	            return _this7.$translate.instant('SERVICE_ORDER.ENUM.GRAPH.NULL');
	          }
	        }
	      });
	    }
	  }, {
	    key: 'setSectionTypesGraph',
	    value: function setSectionTypesGraph(graphData) {
	      var _this8 = this;

	      var data = this.makeGraph(graphData, { group: 'section_name', category: 'type_name', value: 'count' });

	      internal.graph({
	        data: data, bindto: '#section-type', formatCategory: function formatCategory(i) {
	          var category = data.columns[0][i + 1];
	          return category && category != 'null' ? category : _this8.$translate.instant('SERVICE_ORDER.ENUM.GRAPH.NULL');
	        }
	      });
	    }
	  }, {
	    key: 'setDayStatusGraph',
	    value: function setDayStatusGraph(graphData) {
	      var data = this.makeGraph(graphData, {
	        group: { filter: 'due_date:day', value: function value(row) {
	            return moment.utc(row.due_date.day).format('YYYY-MM-DD');
	          } },
	        category: 'completed',
	        value: 'count',
	        names: {
	          true: this.$translate.instant('SERVICE_ORDER.LABEL.COMPLETED'),
	          false: this.$translate.instant('SERVICE_ORDER.LABEL.NOT_COMPLETED')
	        }
	      });
	      internal.graph({
	        data: data, bindto: '#day-status', formatCategory: function formatCategory(index) {
	          return moment.utc(data.columns[0][index + 1]).format('DD/MM/YYYY');
	        }
	      });
	    }
	  }, {
	    key: 'setAssigneeStatusGraph',
	    value: function setAssigneeStatusGraph(graphData) {
	      var _this9 = this;

	      var data = this.makeGraph(graphData, {
	        group: 'assignee_name',
	        category: 'completed',
	        value: 'count',
	        names: {
	          true: this.$translate.instant('SERVICE_ORDER.LABEL.COMPLETED'),
	          false: this.$translate.instant('SERVICE_ORDER.LABEL.NOT_COMPLETED')
	        }
	      });
	      internal.graph({
	        data: data, bindto: '#assignee-status', formatCategory: function formatCategory(i) {
	          var category = data.columns[0][i + 1];
	          return category && category != 'null' ? category : _this9.$translate.instant('SERVICE_ORDER.ENUM.GRAPH.NULL');
	        }
	      });
	    }
	  }]);

	  return ServiceOrderPanelController;
	}();

	exports.default = ServiceOrderPanelController;


	var internal = {
	  graph: function graph(_ref) {
	    var data = _ref.data,
	        bindto = _ref.bindto,
	        formatCategory = _ref.formatCategory;

	    return c3.generate({
	      bindto: bindto,
	      data: data,
	      zoom: {
	        enabled: true,
	        rescale: true
	      },
	      size: { height: 300 },
	      color: { pattern: _colorPalettes.PALETTES.old_green },
	      grid: { y: { show: true }, x: { show: false } },
	      bar: { width: { ratio: 0.8 } },
	      axis: { x: { type: 'category', tick: { format: formatCategory } } },
	      legend: {
	        show: true,
	        hide: ['total']
	      }
	    });
	  },
	  op: function op(value) {
	    return value && value != 'null' ? 'eq' : 'is';
	  },
	  jsonToUri: function jsonToUri(data) {
	    if (Object.keys(data).length > 0) {
	      return encodeURIComponent((0, _helper._encodeBase64)(angular.toJson(data)));
	    }
	  },
	  processConfig: function processConfig(config) {
	    return {
	      group: { filter: config.group.filter || config.group, value: angular.isFunction(config.group.value) ? config.group.value : function (row) {
	          return row[config.group];
	        } },
	      category: { filter: config.category.filter || config.category, value: angular.isFunction(config.category.value) ? config.category.value : function (row) {
	          return row[config.category].toString();
	        } },
	      value: function value(row) {
	        return row[config.value];
	      }
	    };
	  }
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _templatesList = __webpack_require__(183);

	var _templatesList2 = _interopRequireDefault(_templatesList);

	var _templatesEdit = __webpack_require__(184);

	var _templatesEdit2 = _interopRequireDefault(_templatesEdit);

	var _itemsList = __webpack_require__(185);

	var _itemsList2 = _interopRequireDefault(_itemsList);

	var _itemsEdit = __webpack_require__(186);

	var _itemsEdit2 = _interopRequireDefault(_itemsEdit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.operational.catalogs', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'catalogs',
	    url: '/catalogs',
	    parent: 'operational',
	    menu: true,
	    alias: 'catalogs',
	    report: false,
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    redirectTo: 'catalogs.item-list'
	  }).state({
	    name: 'catalogs.template-list',
	    url: '/templates/list?search&filters',
	    alias: 'catalogs.template',
	    controller: _templatesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/templates/list/templates.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'catalogs.template-create',
	    url: '/templates/create',
	    controller: _templatesEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/templates/edit/templates.edit.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'catalogs.template-edit',
	    url: '/templates/edit/:id',
	    controller: _templatesEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/templates/edit/templates.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'catalogs.item-list',
	    url: '/items/list?search&filters',
	    alias: 'catalogs.item',
	    controller: _itemsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/items/list/items.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'catalogs.item-create',
	    url: '/items/create',
	    controller: _itemsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/items/edit/items.edit.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  }).state({
	    name: 'catalogs.item-edit',
	    url: '/items/edit/:id',
	    controller: _itemsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/operational/catalogs/items/edit/items.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('CatalogsTemplateListController', _templatesList2.default).controller('CatalogsTemplateEditController', _templatesEdit2.default).controller('CatalogsItemListController', _itemsList2.default).controller('CatalogsItemEditController', _itemsEdit2.default);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CatalogsTemplateListController = function (_ListController) {
	  CatalogsTemplateListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  _inherits(CatalogsTemplateListController, _ListController);

	  function CatalogsTemplateListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, CatalogsTemplateListController);

	    var _this = _possibleConstructorReturn(this, (CatalogsTemplateListController.__proto__ || Object.getPrototypeOf(CatalogsTemplateListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$scope = $scope;
	    _this.$translate = $translate;

	    var query = {
	      attributes: ['*'],
	      includes: {
	        enterprise: ['name', 'cnpj'],
	        template_items: ['id']
	      },
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'screen',
	      export: false,
	      stats: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.CHECKLISTS + '/templates', query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(CatalogsTemplateListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.GROUP_NAME_CATEGORY', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.TASK_QUANTITY'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.GROUP_NAME_CATEGORY'],
	          sort: true,
	          prop: 'name'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.TASK_QUANTITY'],
	          sort: false
	        }];
	      });
	    }
	  }]);

	  return CatalogsTemplateListController;
	}(_list2.default);

	exports.default = CatalogsTemplateListController;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CatalogsTemplateEditController = function () {
	  CatalogsTemplateEditController.$inject = ["$scope", "$state", "$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function CatalogsTemplateEditController($scope, $state, $window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, CatalogsTemplateEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.isEdit();
	  }

	  _createClass(CatalogsTemplateEditController, [{
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        _this.MainService.delete(_constants.API.V5, _constants.API.CHECKLISTS + '/templates', _this.template.id).promise.then(function () {
	          _this.$state.go('catalogs.template-list');
	        });
	      });
	    }
	  }, {
	    key: 'mountTemplateItems',
	    value: function mountTemplateItems() {
	      var _this2 = this;

	      if (!this.template.relationships.template_items || !this.template.relationships.items) return;
	      this.template.relationships.template_items.forEach(function (ti) {
	        ti.relationships = {
	          item: _this2.template.relationships.items.filter(function (i) {
	            return i.id === ti.attributes.item_id;
	          })[0]
	        };
	      });
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this3 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.loading = true;
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            enterprise: ['name', 'cnpj', 'fantasy_name', 'email'],
	            items: ['*'],
	            template_items: ['*']
	          }
	        };

	        this.MainService.raw(_constants.API.V5, _constants.API.CHECKLISTS + '/templates/' + this.$state.params.id, obj).promise.then(function (res) {
	          _this3.template = res.data;
	          _this3.selectedEnterprise = res.data.relationships.enterprise;
	          _this3.mountTemplateItems();
	        }).finally(function () {
	          _this3.loading = false;
	        });
	      } else {
	        this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	        this.template = {
	          attributes: {}
	        };
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this4 = this;

	      this.processing = true;
	      var template = {
	        data: {
	          attributes: {
	            name: this.template.attributes.name,
	            category: this.template.attributes.category
	          }
	        }
	      };

	      if (angular.isDefined(this.$state.params.id)) {
	        (0, _helper.cleanPayload)(template.data);
	        this.MainService.update(_constants.API.V5, _constants.API.CHECKLISTS + '/templates', this.$state.params.id, template).promise.then(function () {
	          _this4.processing = false;
	        }).finally(function () {
	          _this4.processing = false;
	        });
	      } else {
	        template.data.relationships = {
	          enterprise: {
	            type: 'enterprise',
	            id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	          }
	        };

	        (0, _helper.cleanPayload)(template.data, true);
	        this.MainService.create(_constants.API.V5, _constants.API.CHECKLISTS + '/templates', template).promise.then(function (res) {
	          _this4.$state.go('catalogs.template-edit', { id: res.data.id }, { notify: false });
	        }).finally(function () {
	          _this4.processing = false;
	        });
	      }
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(item, index) {
	      var _this5 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'DISASSOCIATE', label: 'DISASSOCIATE', action: 'delete' }).then(function () {
	        var obj = {
	          data: [{
	            type: 'task_template_item',
	            id: item.id
	          }]
	        };

	        _this5.MainService.deleteMany(_constants.API.V5, _constants.API.CHECKLISTS + '/templates/' + _this5.$state.params.id + '/items', obj).promise.then(function () {
	          _this5.template.relationships.template_items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'addTaskItem',
	    value: function addTaskItem() {
	      var _this6 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.TASK_TEMPLATE_ITEM.path, _dialog.DIALOG.TASK_TEMPLATE_ITEM.ctrl);
	      var configDialog = {
	        enterpriseId: this.selectedEnterprise.id,
	        create: true
	      };

	      this.DialogService.openDialog(opt, configDialog).then(function (items) {
	        var obj = {
	          data: []
	        };

	        items.forEach(function (i) {
	          obj.data.push({
	            type: 'task_item',
	            id: i.id
	          });
	        });

	        _this6.MainService.create(_constants.API.V5, _constants.API.CHECKLISTS + '/templates/' + _this6.$state.params.id + '/items', obj).promise.then(function (res) {
	          var _template$relationshi, _template$relationshi2;

	          if (!_this6.template.relationships.items) {
	            _this6.template.relationships.items = [];
	          }
	          (_template$relationshi = _this6.template.relationships.items).push.apply(_template$relationshi, _toConsumableArray(items));

	          if (!_this6.template.relationships.template_items) {
	            _this6.template.relationships.template_items = [];
	          }

	          res.data.forEach(function (ti) {
	            ti.relationships.item = items.filter(function (i) {
	              return i.id === ti.relationships.item.id;
	            })[0];
	          });

	          (_template$relationshi2 = _this6.template.relationships.template_items).push.apply(_template$relationshi2, _toConsumableArray(res.data));
	        });
	      });
	    }
	  }]);

	  return CatalogsTemplateEditController;
	}();

	exports.default = CatalogsTemplateEditController;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CatalogsItemListController = function (_ListController) {
	  CatalogsItemListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  _inherits(CatalogsItemListController, _ListController);

	  function CatalogsItemListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, CatalogsItemListController);

	    var _this = _possibleConstructorReturn(this, (CatalogsItemListController.__proto__ || Object.getPrototypeOf(CatalogsItemListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$scope = $scope;
	    _this.$translate = $translate;

	    var query = {
	      attributes: ['*'],
	      includes: {
	        templates: ['*'],
	        enterprise: ['name', 'cnpj']
	      },
	      filters: {},
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      count: true,
	      limit: 25,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      new: 'screen',
	      export: false,
	      stats: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.CHECKLISTS + '/items', query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(CatalogsItemListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.TASK_NAME_CATEGORY', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.FORMAT_REQUIRED', 'PANEL.HEADER.TASK_CATEGORY'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.TASK_NAME_CATEGORY'],
	          sort: true,
	          prop: 'name'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.FORMAT_REQUIRED'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.TASK_CATEGORY'],
	          sort: false
	        }];
	      });
	    }
	  }, {
	    key: 'categoryNames',
	    value: function categoryNames(items) {
	      if (!angular.isArray(items)) return '-';

	      var uniqueCategory = [];
	      items.forEach(function (item) {
	        if (!uniqueCategory.includes(item.attributes.name)) {
	          uniqueCategory.push(item.attributes.name);
	        }
	      });

	      return uniqueCategory.sort().join(', ');
	    }
	  }]);

	  return CatalogsItemListController;
	}(_list2.default);

	exports.default = CatalogsItemListController;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CatalogsItemEditController = function () {
	  CatalogsItemEditController.$inject = ["$scope", "$state", "$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function CatalogsItemEditController($scope, $state, $window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, CatalogsItemEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.formats = _constants.TASK_CUSTOM_FIELDS_FORMATS;
	    this.isEdit();
	  }

	  _createClass(CatalogsItemEditController, [{
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        _this.MainService.delete(_constants.API.V5, _constants.API.CHECKLISTS + '/items', _this.item.id).promise.then(function () {
	          _this.$state.go('catalogs.item-list');
	        });
	      });
	    }
	  }, {
	    key: 'isEdit',
	    value: function isEdit() {
	      var _this2 = this;

	      if (angular.isDefined(this.$state.params.id)) {
	        this.loading = true;
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            enterprise: ['name', 'cnpj', 'fantasy_name', 'email'],
	            templates: ['*']
	          }
	        };

	        this.MainService.raw(_constants.API.V5, _constants.API.CHECKLISTS + '/items/' + this.$state.params.id, obj).promise.then(function (res) {
	          _this2.item = res.data;
	          _this2.selectedEnterprise = res.data.relationships.enterprise;
	        }).finally(function () {
	          _this2.loading = false;
	        });
	      } else {
	        this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	        this.item = {
	          attributes: {
	            possible_values: [],
	            field_format: 'text',
	            is_required: true
	          }
	        };
	      }
	    }
	  }]);

	  return CatalogsItemEditController;
	}();

	exports.default = CatalogsItemEditController;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(188);

	__webpack_require__(194);

	__webpack_require__(203);

	__webpack_require__(217);

	angular.module('phoenix.internal.organization', ['ui.router', 'phoenix.internal.organization.chips', 'phoenix.internal.organization.dashboard', 'phoenix.internal.organization.devices', 'phoenix.internal.organization.enterprises']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'organization',
	    url: '/organization',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _chipsList = __webpack_require__(189);

	var _chipsList2 = _interopRequireDefault(_chipsList);

	var _chipsEdit = __webpack_require__(190);

	var _chipsEdit2 = _interopRequireDefault(_chipsEdit);

	var _chipsPanel = __webpack_require__(191);

	var _chipsPanel2 = _interopRequireDefault(_chipsPanel);

	var _chips = __webpack_require__(192);

	var _chips2 = _interopRequireDefault(_chips);

	var _networkDiagnostic = __webpack_require__(193);

	var _networkDiagnostic2 = _interopRequireDefault(_networkDiagnostic);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.organization.chips', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'chips-list',
	    url: '/chips/list?search&filters',
	    parent: 'organization',
	    menu: true,
	    alias: 'chips',
	    controller: _chipsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/chips/list/chips.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'chips-panel',
	    url: '/chips/panel',
	    parent: 'organization',
	    controller: _chipsPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/chips/panel/chips.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'chips-edit',
	    url: '/chips/edit/:id',
	    parent: 'organization',
	    controller: _chipsEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/chips/edit/chips.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          attributes: ['*'],
	          includes: {
	            enterprise: ['name', 'cnpj', 'fantasy_name', 'email'],
	            device: ['name', 'imei']
	          }
	        };

	        return MainService.raw(_constants.API.V5, _constants.API.CHIPS + '/' + $stateParams.id, obj);
	      }]
	    }
	  });
	}]).controller('ChipsListController', _chipsList2.default).controller('ChipsEditController', _chipsEdit2.default).controller('ChipsStatsController', _chipsPanel2.default).service('ChipsService', _chips2.default).controller('NewtworkDiagnosticDialogController', _networkDiagnostic2.default);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TOTAL_PLAN_SIZE = 20971520;

	var ChipsListController = function (_ListController) {
	  ChipsListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  _inherits(ChipsListController, _ListController);

	  function ChipsListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, ChipsListController);

	    var _this = _possibleConstructorReturn(this, (ChipsListController.__proto__ || Object.getPrototypeOf(ChipsListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$scope = $scope;
	    _this.$translate = $translate;

	    _this.query = _this.initializeQuery();
	    _this.options = _this.initializeOptions();

	    _this.translateKeys();
	    _this.setProps(_constants.API.V5, _constants.API.CHIPS, _this.query, true, _this.transformContext.bind(_this));
	    return _this;
	  }

	  _createClass(ChipsListController, [{
	    key: 'initializeQuery',
	    value: function initializeQuery() {
	      return {
	        attributes: ['serial', 'number', 'carrier', 'service_provider', 'apn', 'apn_username', 'apn_password', 'from_softruck', 'created_at', 'updated_at', 'last_integration_source', 'last_integration_time'],
	        includes: {
	          enterprise: ['name', 'cnpj'],
	          device: ['name', 'imei', 'code'],
	          events: ['*']
	        },
	        sort: null,
	        count: true,
	        limit: 15,
	        page: 1,
	        search: null
	      };
	    }
	  }, {
	    key: 'initializeOptions',
	    value: function initializeOptions() {
	      return {
	        export: true,
	        stats: true
	      };
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.ICCID_NUMBER', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.CONSUMPTION', 'PANEL.HEADER.IMEI_IDENTIFIER', 'PANEL.HEADER.PROVIDER_SOURCE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = _this2.buildHeaders(t);
	      });
	    }
	  }, {
	    key: 'buildHeaders',
	    value: function buildHeaders(translations) {
	      return [{
	        label: translations['PANEL.HEADER.ICCID_NUMBER'],
	        sort: true,
	        prop: 'serial'
	      }, {
	        label: translations['PANEL.HEADER.ENTERPRISE_DOC'],
	        sort: true,
	        prop: 'enterprise.name'
	      }, {
	        label: translations['PANEL.HEADER.CONSUMPTION'],
	        sort: true,
	        prop: 'events.consumption_montly_data'
	      }, {
	        label: translations['PANEL.HEADER.IMEI_IDENTIFIER'],
	        sort: true,
	        prop: 'device.name'
	      }, {
	        label: translations['PANEL.HEADER.PROVIDER_SOURCE'],
	        sort: true,
	        prop: 'service_provider'
	      }];
	    }
	  }, {
	    key: 'transformContext',
	    value: function transformContext() {
	      var _this3 = this;

	      if (angular.isArray(this.items)) {
	        this.items.forEach(function (item) {
	          return _this3.processItem(item);
	        });
	      }
	    }
	  }, {
	    key: 'processItem',
	    value: function processItem(item) {
	      if (this.isValidItem(item)) {
	        var consumption = item.relationships.events.attributes.consumption_montly_data;
	        item.attributes.current_consumption = this.calculateConsumption(consumption);
	        item.attributes.current_consumption_status = this.determineConsumptionStatus(item.attributes.current_consumption);
	      } else {
	        this.setDefaultConsumption(item);
	      }
	    }
	  }, {
	    key: 'isValidItem',
	    value: function isValidItem(item) {
	      return item && item.attributes && item.attributes.from_softruck && item.attributes.service_provider === 'Vivo' && item.attributes.carrier === 'Vivo' && item.relationships && item.relationships.events && item.relationships.events.attributes.consumption_montly_data;
	    }
	  }, {
	    key: 'calculateConsumption',
	    value: function calculateConsumption(consumption) {
	      return consumption / TOTAL_PLAN_SIZE * 100;
	    }
	  }, {
	    key: 'determineConsumptionStatus',
	    value: function determineConsumptionStatus(consumption) {
	      return consumption < 90 ? 'bg-green-500' : 'bg-red-500';
	    }
	  }, {
	    key: 'setDefaultConsumption',
	    value: function setDefaultConsumption(item) {
	      item.attributes.current_consumption = 0;
	      item.attributes.current_consumption_status = 'bg-gray-500';
	    }
	  }]);

	  return ChipsListController;
	}(_list2.default);

	exports.default = ChipsListController;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChipsEditController = function () {
	  ChipsEditController.$inject = ["$state", "$window", "DialogService", "EnvironmentConfig", "MainService", "selectedItem"];
	  function ChipsEditController($state, $window, DialogService, EnvironmentConfig, MainService, selectedItem) {
	    'ngInject';

	    _classCallCheck(this, ChipsEditController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.selectedItem = selectedItem;

	    this.enterpriseIncludes = { country: ['code'] };

	    this.loadData();
	  }

	  _createClass(ChipsEditController, [{
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var obj = {
	        data: [{ id: this.chip.id, type: 'chips' }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.chip).then(function () {
	        _this.MainService.deleteMany(_constants.API.V5, _constants.API.CHIPS, obj).promise.then(function () {
	          _this.$state.go('chips-list');
	        });
	      });
	    }
	  }, {
	    key: 'getServiceProvider',
	    value: function getServiceProvider(text) {
	      var serviceProviders = _.get(this.selectedEnterprise, 'relationships.country.attributes.extras.chips.service_providers', []);
	      var textFormatted = text ? text.toLowerCase() : '';

	      return serviceProviders.filter(function (provider) {
	        return provider.toLowerCase().includes(textFormatted);
	      }).map(function (provider) {
	        return { name: provider };
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      var enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      this.loading = true;

	      this.selectedItem.promise.then(function (res) {
	        _this2.chip = res.data;
	        _this2.selectedEnterprise = res.data.relationships.enterprise;
	        _this2.selectedEnterprise.relationships = enterprise.relationships;
	        _this2.previewProvider = _this2.chip.attributes.service_provider;
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      var chip = {
	        data: {
	          attributes: {
	            apn: this.chip.attributes.apn,
	            apn_password: this.chip.attributes.apn_password,
	            apn_username: this.chip.attributes.apn_username,
	            carrier: this.chip.attributes.carrier,
	            number: this.chip.attributes.number,
	            pin: this.chip.attributes.pin,
	            plan_size: this.chip.attributes.plan_size,
	            puk: this.chip.attributes.puk,
	            serial: this.chip.attributes.serial,
	            service_provider: this.chip.attributes.service_provider,
	            status: this.chip.attributes.status
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: this.selectedEnterprise.id
	            }
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(chip.data);
	      this.MainService.update(_constants.API.V5, _constants.API.CHIPS, this.$state.params.id, chip).promise.then(function () {
	        _this3.processing = false;
	      }).catch(function () {
	        _this3.processing = false;
	      });
	    }
	  }, {
	    key: 'openDiagnostic',
	    value: function openDiagnostic() {
	      var opt = _dialog.DIALOG._opts('app/internal/organization/chips/components/network-diagnostic/network-diagnostic.dialog.html', 'NewtworkDiagnosticDialogController');

	      this.DialogService.openDialog(opt, this.chip);
	    }
	  }, {
	    key: 'command',
	    value: function command() {
	      var _this4 = this;

	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'network-reset';

	      if (!this.chip.attributes.from_softruck || this.chip.attributes.carrier !== 'Vivo') {
	        return;
	      }

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'RESET_NETWORK', label: 'RESET_NETWORK', action: 'send' }).then(function () {
	        var url = _constants.API.CHIPS + '/' + _this4.$state.params.id + '/commands/' + type;
	        _this4.MainService.create(_constants.API.V5, url).promise.then(function () {});
	      });
	    }
	  }]);

	  return ChipsEditController;
	}();

	exports.default = ChipsEditController;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _timeseries = __webpack_require__(99);

	var _timeseries2 = _interopRequireDefault(_timeseries);

	var _donut = __webpack_require__(102);

	var _donut2 = _interopRequireDefault(_donut);

	var _colorPalettes = __webpack_require__(103);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChipsStatsController = function () {
	  ChipsStatsController.$inject = ["$translate", "MainService"];
	  function ChipsStatsController($translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, ChipsStatsController);

	    this.$translate = $translate;

	    this.MainService = MainService;
	    this.manageItens();
	    this.distribution();

	    this.selectedKeys = ['created'];
	  }

	  _createClass(ChipsStatsController, [{
	    key: 'distribution',
	    value: function distribution() {
	      var _this = this;

	      this.loadingDistribution = true;
	      this.MainService.raw(_constants.API.V5, 'chips/reports/providers').promise.then(function (res) {
	        _this.loadingDistribution = false;
	        _this.providersDistribution = res.data;
	        _this.providersList = Object.keys(_this.providersDistribution);
	        _this.selectedProviders = _this.providersList;

	        var options = {
	          bindTo: 'chips-distribution',
	          type: 'donut',
	          format: 'number',
	          legend: false,
	          size: {
	            height: 300
	          },
	          palette: _colorPalettes.PALETTES.old_green
	        };

	        var report = {
	          names: _this.providersList,
	          data: _this.providersDistribution
	        };

	        _this.providers = (0, _donut2.default)(options, report);
	        _this.selectProviderKeys();
	      }).catch(function () {
	        _this.loadingDistribution = false;
	      });
	    }
	  }, {
	    key: 'manageItens',
	    value: function manageItens() {
	      var _this2 = this;

	      this.loadingManage = true;
	      var query = {
	        startDate: moment().add(1, 'd').format('YYYY-MM-DD'),
	        granularity: 'day',
	        recurrence: 30
	      };
	      this.MainService.raw(_constants.API.V5, ['chips', 'reports', 'management', query.startDate, query.granularity, query.recurrence].join('/')).promise.then(function (res) {
	        _this2.loadingManage = false;
	        var size = res.data.dates.length;

	        var options = {
	          bindTo: 'manage-items',
	          type: 'bar',
	          legend: false,
	          format: 'number',
	          palette: _colorPalettes.PALETTES.old_green,
	          size: {
	            height: 300
	          },
	          region: {
	            start: res.data.dates[0],
	            size: size
	          },
	          axis: {
	            x: true,
	            y: true
	          },
	          noData: 'Sem dados',
	          labels: {
	            x: 'Dias',
	            y: 'Unidades'
	          }
	        };

	        var report = {
	          names: {
	            created: 'Criados',
	            deleted: 'Deletados'
	          },
	          data: [['dates'].concat(_toConsumableArray(res.data.dates.splice(0, size - 1))), ['created'].concat(_toConsumableArray(res.data.created.splice(0, size - 1))), ['deleted'].concat(_toConsumableArray(res.data.deleted.splice(0, size - 1)))],
	          lines: {
	            y: [],
	            x: []
	          }
	        };

	        _this2.managedItems = (0, _timeseries2.default)(options, report);
	        _this2.selectManagedKeys();
	      }).catch(function () {
	        _this2.loadingManage = false;
	      });
	    }
	  }, {
	    key: 'selectManagedKeys',
	    value: function selectManagedKeys() {
	      this.managedItems.hide();
	      this.managedItems.show(this.selectedKeys);
	    }
	  }, {
	    key: 'selectProviderKeys',
	    value: function selectProviderKeys() {
	      this.providers.hide();
	      this.providers.show(this.selectedProviders);
	    }
	  }]);

	  return ChipsStatsController;
	}();

	exports.default = ChipsStatsController;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChipsService = function ChipsService() {
	  'ngInject';

	  _classCallCheck(this, ChipsService);
	};

	exports.default = ChipsService;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewtworkDiagnosticDialogController = function () {
	  NewtworkDiagnosticDialogController.$inject = ["DialogService", "MainService", "locals"];
	  function NewtworkDiagnosticDialogController(DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, NewtworkDiagnosticDialogController);

	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.chip = locals.item;

	    this.command();
	  }

	  _createClass(NewtworkDiagnosticDialogController, [{
	    key: 'command',
	    value: function command() {
	      var _this = this;

	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'diagnostic';

	      if (!this.chip.attributes.from_softruck || this.chip.attributes.carrier !== 'Vivo') {
	        return;
	      }
	      this.loading = true;
	      var path = _constants.API.CHIPS + '/' + this.chip.id + '/commands/' + type;
	      this.MainService.create(_constants.API.V5, path).promise.then(function (res) {
	        _this.diagnostic = res;
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewtworkDiagnosticDialogController;
	}();

	exports.default = NewtworkDiagnosticDialogController;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _dashboard = __webpack_require__(195);

	var _dashboard2 = _interopRequireDefault(_dashboard);

	var _dashboard3 = __webpack_require__(198);

	var _dashboard4 = _interopRequireDefault(_dashboard3);

	var _behavior = __webpack_require__(199);

	var _behavior2 = _interopRequireDefault(_behavior);

	var _vehicleStatus = __webpack_require__(200);

	var _vehicleStatus2 = _interopRequireDefault(_vehicleStatus);

	var _disconnectedDevicesDialog = __webpack_require__(201);

	var _disconnectedDevicesDialog2 = _interopRequireDefault(_disconnectedDevicesDialog);

	var _communicationStatus = __webpack_require__(202);

	var _communicationStatus2 = _interopRequireDefault(_communicationStatus);

	var _shortCurrency = __webpack_require__(197);

	var _shortCurrency2 = _interopRequireDefault(_shortCurrency);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.organization.dashboard', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'dashboard',
	    url: '/dashboard',
	    parent: 'organization',
	    menu: 'root',
	    alias: 'dashboard',
	    controller: _dashboard2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/dashboard/dashboard.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      loadSummary: ["MainService", function loadSummary(MainService) {
	        return MainService.raw('v5', 'enterprises/reports/overview');
	      }],
	      loadFleetValue: ["DashboardService", function loadFleetValue(DashboardService) {
	        return DashboardService.fleetvalue();
	      }]
	    }
	  });
	}]).controller('DashboardController', _dashboard2.default).service('DashboardService', _dashboard4.default).directive('behaviorChart', _behavior2.default.directiveFactory).controller('VehicleStatusController', _vehicleStatus2.default).controller('DisconnectedDevicesController', _disconnectedDevicesDialog2.default).directive('communicationStatus', _communicationStatus2.default.directiveFactory).filter('shortCurrency', _shortCurrency2.default);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import { ASSET_TYPES } from '../../../constants/constants.js'


	var _gauge = __webpack_require__(196);

	var _gauge2 = _interopRequireDefault(_gauge);

	var _donut = __webpack_require__(102);

	var _donut2 = _interopRequireDefault(_donut);

	var _colorPalettes = __webpack_require__(103);

	var _shortCurrency = __webpack_require__(197);

	var _shortCurrency2 = _interopRequireDefault(_shortCurrency);

	var _constants = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DashboardController = function () {
	  DashboardController.$inject = ["$translate", "$window", "DashboardService", "DialogService", "MainService", "loadFleetValue", "loadSummary"];
	  function DashboardController($translate, $window, DashboardService, DialogService, MainService, loadFleetValue, loadSummary) {
	    'ngInject';

	    _classCallCheck(this, DashboardController);

	    this.$translate = $translate;
	    this.$window = $window;
	    this.DashboardService = DashboardService;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.loadFleetValue = loadFleetValue;
	    this.loadSummary = loadSummary;

	    this.enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.communicationStandards = ['last_connection_time', 'last_gps_time'];
	    this.vehicleTypes = _constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    });
	    this.selectedVehicleTypes = this.vehicleTypes;
	    this.communicationStandard = 'last_connection_time';

	    this.resolvePromises();
	  }

	  _createClass(DashboardController, [{
	    key: 'loadVehiclesStatus',
	    value: function loadVehiclesStatus(standard) {
	      var _this = this;

	      this.communicationStandard = standard;
	      var params = '0,120,360,720,1440';
	      var obj = {
	        filters: {
	          'asset_type.name': { operator: 'in', value: this.selectedVehicleTypes }
	        },
	        any: {
	          never: { operator: 'eq', value: true },
	          infinity: { operator: 'eq', value: true }
	        }
	      };
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + _constants.API.REPORTS + '/communication/' + params, obj).promise.then(function (res) {
	        _this.mainCommunicationStatus = res.data;
	        _this.loading.status = false;
	        _this.totalConnectionCars = _.reduce(_.omit(res.data.last_connection_time), function (sum, i) {
	          return sum + i;
	        }, 0);
	        _this.totalComunicationCars = _.reduce(_.omit(res.data.last_gps_time), function (sum, i) {
	          return sum + i;
	        }, 0);

	        var intervalSize = res.data.intervals.length;
	        var vehicleStatus = [].concat(_toConsumableArray(res.data.intervals), _toConsumableArray(res.data.last_connection_time), _toConsumableArray(res.data.last_gps_time));
	        var structuredResult = [];
	        for (var key in vehicleStatus) {
	          if (!structuredResult[key % intervalSize]) structuredResult[key % intervalSize] = [];
	          structuredResult[key % intervalSize].push(vehicleStatus[key]);
	        }
	        _this.communicationStatus = structuredResult;
	        _this.changeCommunicationStandard(_this.communicationStandard);
	      });
	    }
	  }, {
	    key: 'changeCommunicationStandard',
	    value: function changeCommunicationStandard(type) {
	      if (type === 'last_connection_time') {
	        this.totalCars = this.totalConnectionCars;
	        this.step = 1;
	      } else {
	        this.totalCars = this.totalComunicationCars;
	        this.step = 2;
	      }
	      this.communicationStandard = type;
	      this.generateRiskRate(type);
	    }
	  }, {
	    key: 'generateRiskRate',
	    value: function generateRiskRate(type) {
	      var _this2 = this;

	      var rate = 0;
	      var arr = Object.values(this.mainCommunicationStatus[type]);
	      _.each(arr, function (i, k) {
	        rate = rate + i * k;
	      });

	      var riskRate = _.round(rate / this.totalCars * 2);
	      this.riskRate = {
	        risk_rate: _.isNaN(riskRate) ? 0 : riskRate
	      };

	      var preffix = 'DASHBOARD.RISK_RATE.STATUS.';
	      var statusColor = riskRate <= 3 ? 'GREEN' : riskRate <= 7 ? 'YELLOW' : 'RED';
	      var specs = {
	        min: 0,
	        max: 10,
	        range: [3, 6, 9, 10]
	      };

	      (0, _gauge2.default)('risk-area', 'number', ['risk_rate'], specs, this.riskRate, this.$translate);
	      this.$translate([preffix + statusColor + '.TITLE', preffix + statusColor + '.SUBTITLE']).then(function (t) {
	        _this2.riskRateWarning = {
	          title: t[preffix + statusColor + '.TITLE'],
	          subtitle: t[preffix + statusColor + '.SUBTITLE']
	        };
	      });
	    }
	  }, {
	    key: 'resolvePromises',
	    value: function resolvePromises() {
	      var _this3 = this;

	      this.loading = {
	        summary: true,
	        values: true,
	        status: true
	      };
	      this.loadVehiclesStatus('last_connection_time');
	      this.loadSummary.promise.then(function (res) {
	        _this3.loading.summary = false;
	        _this3.summary = res.data.attributes;
	      });
	      this.loadFleetValue.promise.then(function (res) {
	        _this3.loading.values = false;
	        _this3.fleet = res;
	        _this3.totalFleetValue = _.reduce(_this3.fleet.value, function (sum, i) {
	          return sum + i.totalValue;
	        }, 0);
	        _this3.valueChart();
	      });
	    }
	  }, {
	    key: 'showListNeverRespond',
	    value: function showListNeverRespond() {
	      var status = {
	        url: 'app/components/vehicle-status/vehicle-status.dialog.html',
	        controllerName: 'VehicleStatusController',
	        controllerAlias: 'ctrl',
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(status);
	    }
	  }, {
	    key: 'showListNoBattery',
	    value: function showListNoBattery() {
	      var dialog = {
	        url: 'app/components/disconnected-devices/disconnected-devices.dialog.html',
	        controllerName: 'DisconnectedDevicesController',
	        controllerAlias: 'ctrl',
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(dialog);
	    }
	  }, {
	    key: 'valueChart',
	    value: function valueChart() {
	      var fleet = {
	        car: this.fleet.value.car.quantity,
	        motorcycle: this.fleet.value.motorcycle.quantity,
	        truck: this.fleet.value.truck.quantity
	      };

	      var totalFleetValue = this.fleet.value.truck.totalValue.currentPrice + this.fleet.value.car.totalValue.currentPrice + this.fleet.value.motorcycle.totalValue.currentPrice;

	      var options = {
	        bindTo: 'donut',
	        type: 'donut',
	        format: 'number',
	        legend: false,
	        width_whole: 20,
	        title: (0, _shortCurrency2.default)()(totalFleetValue),
	        size: {
	          height: 160
	        },
	        palette: _colorPalettes.PALETTES.sunny
	      };

	      this.$translate(['DASHBOARD.VEHICLE_TYPE.CAR', 'DASHBOARD.VEHICLE_TYPE.MOTORCYCLE', 'DASHBOARD.VEHICLE_TYPE.TRUCK']).then(function (t) {
	        var report = {
	          names: { car: t['DASHBOARD.VEHICLE_TYPE.CAR'], motorcycle: t['DASHBOARD.VEHICLE_TYPE.MOTORCYCLE'], truck: t['DASHBOARD.VEHICLE_TYPE.TRUCK'] },
	          data: fleet
	        };
	        (0, _donut2.default)(options, report);
	      });
	    }
	  }]);

	  return DashboardController;
	}();

	exports.default = DashboardController;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	generateGaugeChart.$inject = ["bindTo", "_format", "datakeys", "specs", "sample", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _builddata = __webpack_require__(58);

	var _builddata2 = _interopRequireDefault(_builddata);

	var _buildnames = __webpack_require__(59);

	var _buildnames2 = _interopRequireDefault(_buildnames);

	var _formatNumber = __webpack_require__(61);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function generateGaugeChart(bindTo, _format, datakeys, specs, sample, $translate) {
	  'ngInject';

	  return c3.generate({
	    bindto: '#' + bindTo,
	    data: {
	      columns: (0, _builddata2.default)(null, datakeys, sample),
	      names: (0, _buildnames2.default)(datakeys, $translate),
	      type: 'gauge'
	    },
	    gauge: {
	      width: 20,
	      expand: true,
	      min: specs.min,
	      max: specs.max,
	      label: {
	        format: function format(d) {
	          return (0, _formatNumber2.default)(d, _format);
	        }
	      }
	    },
	    color: {
	      pattern: ['#22c55e', '#facc15', '#f97516', '#ef4444'],
	      threshold: {
	        values: specs.range
	      }
	    },
	    size: {
	      height: 180
	    },
	    legend: {
	      show: false
	    }
	  });
	} /* global c3 */

	exports.default = generateGaugeChart;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shortCurrency;
	function shortCurrency() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return;
	    }

	    var size = input.toString().length;

	    if (size > 3 && size <= 6) {
	      return (input / 1000).toFixed(1) + 'Mil';
	    } else if (size > 6 && size <= 9) {
	      return (input / 1000000).toFixed(1) + 'Mi';
	    } else if (size > 9) {
	      return (input / 1000000000).toFixed(1) + 'Bi';
	    } else {
	      return input.toFixed(1);
	    }
	  };
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DashboardService = function () {
	  DashboardService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function DashboardService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, DashboardService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(DashboardService, [{
	    key: 'fleetvalue',
	    value: function fleetvalue() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var deferred = this.$q.defer();
	      var url = [this.EnvironmentConfig.API, _constants.API.V2, _constants.API.DASHBOARD, 'fleet'].join('/');
	      var query = [];
	      var keys = Object.keys(obj);
	      keys.forEach(function (k) {
	        if (_.isObject(obj[k])) {
	          query.push(k + '[' + obj[k].prop + ']=' + obj[k].order);
	        } else if (!_.isNil(obj[k]) && obj[k] !== '') {
	          query.push(k + '=' + obj[k]);
	        }
	      });
	      this.$http({ url: url + (query.length ? '?' + query.join('&') : ''), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return DashboardService;
	}();

	exports.default = DashboardService;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BehaviorChart = function () {
	  function BehaviorChart($window, $translate) {
	    _classCallCheck(this, BehaviorChart);

	    this.$window = $window;
	    this.$translate = $translate;
	    this.restrict = 'E';
	    this.replace = true;
	  }

	  _createClass(BehaviorChart, [{
	    key: 'link',
	    value: function link(scope) {
	      var arr = scope.$parent.ctrl.fleet.communicationBehavior;
	      arr.unshift(this.$translate.instant('DASHBOARD.MOVEMENT.CONECTIONS'));

	      var c3 = this.$window.c3;
	      return c3.generate({
	        bindto: '#bar-chart',
	        data: {
	          columns: [arr],
	          type: 'area-spline',
	          names: this.$translate.instant('DASHBOARD.MOVEMENT.CONECTIONS')
	        },
	        color: {
	          pattern: ['#0079E2']
	        },
	        point: {
	          show: false
	        },
	        axis: {
	          x: {
	            tick: {
	              count: 24,
	              values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
	            },
	            label: this.$translate.instant('DASHBOARD.MOVEMENT.TIME_OF_DAY')
	          },
	          y: {
	            show: false
	          }
	        },
	        bar: {
	          width: {
	            ratio: 0.5
	          }
	        },
	        legend: {
	          show: false
	        },
	        padding: {
	          top: 24,
	          right: 16,
	          left: 16,
	          bottom: 0
	        },
	        size: {
	          height: 258
	        },
	        grid: {
	          x: {
	            show: true
	          }
	        }
	      });
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$window", "$translate", function directiveFactory($window, $translate) {
	      'ngInject';

	      return new BehaviorChart($window, $translate);
	    }]
	  }]);

	  return BehaviorChart;
	}();

	BehaviorChart.directiveFactory.$inject = ['$window', '$translate'];

	exports.default = BehaviorChart;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _fileSaver = __webpack_require__(46);

	var _fileSaver2 = _interopRequireDefault(_fileSaver);

	var _constants = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var VehicleStatusController = function () {
	  VehicleStatusController.$inject = ["$translate", "DialogService", "MainService"];
	  function VehicleStatusController($translate, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, VehicleStatusController);

	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.vehicleTypes = _constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    });
	    this.selectedStandard = 'last_connection_time';
	    this.selectedInterval = 'never';
	    this.selectedType = this.vehicleTypes;

	    this.communicationStandards = ['last_gps_time', 'last_connection_time'];
	    this.timeScale = {
	      never: { label: this.extractText('never'), key: 'never', operator: 'is', value: null },
	      '0-120': { label: this.extractText('0-120'), key: '0-120', operator: 'btw', value: moment().utc().subtract(120, 'minutes').format('YYYY-MM-DD HH:mm:ss') + ',' + moment().utc().format('YYYY-MM-DD HH:mm:ss') },
	      '120-360': { label: this.extractText('120-360'), key: '120-360', operator: 'btw', value: moment().utc().subtract(360, 'minutes').format('YYYY-MM-DD HH:mm:ss') + ',' + moment().utc().subtract(120, 'minutes').format('YYYY-MM-DD HH:mm:ss') },
	      '360-720': { label: this.extractText('360-720'), key: '360-720', operator: 'btw', value: moment().utc().subtract(720, 'minutes').format('YYYY-MM-DD HH:mm:ss') + ',' + moment().utc().subtract(360, 'minutes').format('YYYY-MM-DD HH:mm:ss') },
	      '720-1440': { label: this.extractText('720-1440'), key: '720-1440', operator: 'btw', value: moment().utc().subtract(1440, 'minutes').format('YYYY-MM-DD HH:mm:ss') + ',' + moment().utc().subtract(720, 'minutes').format('YYYY-MM-DD HH:mm:ss') },
	      '1440-inf': { label: this.extractText('1440-inf'), key: '1440-inf', operator: 'lt', value: '' + moment().utc().subtract(1440, 'minutes').format('YYYY-MM-DD HH:mm:ss') }
	    };
	    this.meta = {
	      page: 1,
	      limit: 10
	    };

	    this.query = {
	      attributes: ['name', 'imei'],
	      includes: {
	        vehicle: ['plate', 'vin', 'registration_number', 'color', 'type_name', 'year', 'model_name', 'brand_name', 'trim_name', 'user_names'],
	        chip: ['serial', 'number', 'service_provider'],
	        last_gps: ['last_gps_time', 'last_connection_time'],
	        type: ['alias', 'brand_alias'],
	        users: ['*']
	      },
	      filters: _defineProperty({
	        'vehicle.type_name': { operator: 'in', value: this.selectedType }
	      }, 'last_gps.' + this.selectedStandard, { operator: this.timeScale[this.selectedInterval].operator, value: this.timeScale[this.selectedInterval].value }),
	      count: true,
	      limit: 10
	    };

	    this.getCommunicationStatus = this.getCommunicationStatus.bind(this);
	    this.reorder = this.reorder.bind(this);
	    this.order = '-last_gps.' + this.selectedStandard;

	    this._setFilterState();
	    this.getCommunicationStatus(1);
	  }

	  _createClass(VehicleStatusController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'extractText',
	    value: function extractText(input) {
	      if (!input.includes('-')) {
	        return this.$translate.instant('VEHICLE_STATUS.INTERVAL.NEVER');
	      } else {
	        var interval = input.split('-');
	        return interval[0] / 60 + 'h-' + (interval[1] === 'inf' ? '∞' : interval[1] / 60 + 'h');
	      }
	    }
	  }, {
	    key: 'selectType',
	    value: function selectType() {
	      if (this.selectedType.length === 0) {
	        return;
	      }
	      if (this.selectedType === this.currentFilterState.types) {
	        return;
	      }
	      this.query.filters['vehicle.type_name'] = { operator: 'in', value: this.selectedType };
	      this.getCommunicationStatus(1);
	    }
	  }, {
	    key: 'selectStatus',
	    value: function selectStatus() {
	      if (this.selectedStandard === this.currentFilterState.status) {
	        return;
	      }
	      this._setIntervalFilter();
	    }
	  }, {
	    key: 'selectInterval',
	    value: function selectInterval() {
	      if (this.selectedInterval === this.currentFilterState.interval) {
	        return;
	      }
	      this._setIntervalFilter();
	    }
	  }, {
	    key: '_setIntervalFilter',
	    value: function _setIntervalFilter() {
	      delete this.query.filters['last_gps.last_gps_time'];
	      delete this.query.filters['last_gps.last_connection_time'];
	      this.query.filters['last_gps.' + this.selectedStandard] = { operator: this.timeScale[this.selectedInterval].operator, value: this.timeScale[this.selectedInterval].value };
	      this.query.sort = { prop: 'last_gps.' + this.selectedStandard, order: 'DESC' };
	      this.order = '-last_gps.' + this.selectedStandard;
	      this.getCommunicationStatus(1);
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.query.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.getCommunicationStatus(1);
	    }
	  }, {
	    key: 'getCommunicationStatus',
	    value: function getCommunicationStatus(page) {
	      var _this = this;

	      this.loading = true;
	      this.query.page = page;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES, this.query).promise.then(function (res) {
	        _this.meta.count = res.count;
	        _this.meta.page = page;
	        _this.communicationStatus = res.data;
	        _this._formatUserData();
	        _this._setFilterState();
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: '_setFilterState',
	    value: function _setFilterState() {
	      this.currentFilterState = {
	        status: this.selectedStandard,
	        types: this.selectedType,
	        interval: this.selectedInterval
	      };
	    }
	  }, {
	    key: '_formatUserData',
	    value: function _formatUserData() {
	      this.communicationStatus.forEach(function (item) {
	        if (item.relationships.users) {
	          var userNames = item.relationships.users.attributes.user_names.split(';');
	          var userPhones = item.relationships.users.attributes.user_phones.split(';');

	          item.relationships.users_assets = [];
	          for (var index = 0; index < userNames.length; index++) {
	            item.relationships.users_assets.push({
	              type: 'users',
	              attributes: {
	                name: userNames[index],
	                phone: userPhones[index]
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(type) {
	      var _this2 = this;

	      this.loading = true;
	      var query = {
	        desired: [{ a: 'devices.name' }, { a: 'devices.imei' }, { a: 'chip.serial' }, { a: 'chip.number' }, { a: 'chip.service_provider' }, { a: 'enterprise.name' }, { a: 'vehicle.plate' }, { a: 'vehicle.vin' }, { a: 'vehicle.code' }, { a: 'vehicle.type_name' }, { a: 'last_gps.last_gps_time' }, { a: 'last_gps.last_connection_time' }, { a: 'type.brand_alias' }, { a: 'type.alias' }, { a: 'users.user_names' }, { a: 'users.user_phones' }],
	        filters: this.query.filters,
	        format: type,
	        filename: 'vehicle-status',
	        locale: 'pt_BR'
	      };

	      this.MainService.export(_constants.API.V5, 'devices/export', query).promise.then(function (res) {
	        var type = {
	          csv: _constants.EXPORT_TYPE.CSV,
	          xlsx: _constants.EXPORT_TYPE.XLSX
	        };

	        var blob = new Blob([res], { type: type[query.format] });
	        _fileSaver2.default.saveAs(blob, query.filename, { autoBom: true });
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }]);

	  return VehicleStatusController;
	}();

	exports.default = VehicleStatusController;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _fileSaver = __webpack_require__(46);

	var _fileSaver2 = _interopRequireDefault(_fileSaver);

	var _constants = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DisconnectedDevicesController = function () {
	  DisconnectedDevicesController.$inject = ["DialogService", "MainService"];
	  function DisconnectedDevicesController(DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, DisconnectedDevicesController);

	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 10
	    };

	    this.vehicleTypes = _constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    });
	    this.selectedType = this.vehicleTypes;
	    this.selectedBatteryLevel = 'equal-0';

	    this.batteryScale = {
	      'below-3': { operator: 'lt', value: 3 },
	      'below-2': { operator: 'lt', value: 2 },
	      'below-1': { operator: 'lt', value: 1 },
	      'equal-0': { operator: 'eq', value: 0 }
	    };

	    this.query = {
	      attributes: ['name', 'imei'],
	      includes: {
	        vehicle: ['plate', 'vin', 'registration_number', 'color', 'type_name', 'year', 'model_name', 'brand_name', 'trim_name', 'user_names'],
	        chip: ['serial', 'number', 'service_provider'],
	        last_gps: ['last_gps_raw', 'last_gps_time', 'last_connection_time', 'last_battery_level', 'last_backup_battery_voltage', 'last_power_voltage'],
	        type: ['alias', 'brand_alias'],
	        users: ['*']
	      },
	      filters: {
	        'enterprise.id': { operator: 'isn', value: null },
	        'devices.active': { operator: 'eq', value: true },
	        'last_gps.last_power_voltage': { operator: 'eq', value: 0 },
	        'vehicle.type_name': { operator: 'in', value: this.selectedType }
	      },
	      sort: {
	        prop: 'last_gps.last_connection_time',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.getDisconnections = this.getDisconnections.bind(this);
	    this.reorder = this.reorder.bind(this);
	    this.order = '-last_gps.last_connection_time';

	    this._setFilterState();
	    this.getDisconnections(1);
	  }

	  _createClass(DisconnectedDevicesController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'selectBatteryLevel',
	    value: function selectBatteryLevel() {
	      if (this.selectedBatteryLevel === this.currentFilterState.batteryLevel) {
	        return;
	      }
	      this.query.filters['last_gps.last_power_voltage'] = this.batteryScale[this.selectedBatteryLevel];
	      this.getDisconnections(1);
	    }
	  }, {
	    key: 'selectType',
	    value: function selectType() {
	      if (this.selectedType.length === 0) {
	        return;
	      }
	      if (this.selectedType === this.currentFilterState.types) {
	        return;
	      }
	      this.query.filters['vehicle.type_name'] = { operator: 'in', value: this.selectedType };
	      this.getDisconnections(1);
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.query.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.getDisconnections(1);
	    }
	  }, {
	    key: 'getDisconnections',
	    value: function getDisconnections(page) {
	      var _this = this;

	      this.loading = true;
	      this.query.page = page;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES, this.query).promise.then(function (res) {
	        _this.meta.count = res.count;
	        _this.meta.page = page;
	        _this.items = res.data;
	        _this._formatUserData();
	        _this._setFilterState();
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(type) {
	      var _this2 = this;

	      this.loading = true;
	      var query = {
	        desired: [{ a: 'devices.name' }, { a: 'devices.imei' }, { a: 'vehicle.plate' }, { a: 'vehicle.vin' }, { a: 'vehicle.type_name' }, { a: 'chip.serial' }, { a: 'chip.number' }, { a: 'chip.service_provider' }, { a: 'vehicle.type_name' }, { a: 'last_gps.last_power_voltage' }, { a: 'last_gps.last_battery_level' }, { a: 'last_gps.last_gps_time' }, { a: 'last_gps.last_connection_time' }, { a: 'type.brand_alias' }, { a: 'type.alias' }, { a: 'users.user_names' }, { a: 'users.user_phones' }],
	        filters: this.query.filters,
	        format: type,
	        filename: 'disconnections',
	        locale: 'pt_BR'
	      };

	      this.MainService.export(_constants.API.V5, 'devices/export', query).promise.then(function (res) {
	        var type = {
	          csv: _constants.EXPORT_TYPE.CSV,
	          xlsx: _constants.EXPORT_TYPE.XLSX
	        };

	        var blob = new Blob([res], { type: type[query.format] });
	        _fileSaver2.default.saveAs(blob, query.filename, { autoBom: true });
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: '_formatUserData',
	    value: function _formatUserData() {
	      this.items.forEach(function (item) {
	        if (item.relationships.users) {
	          var userNames = item.relationships.users.attributes.user_names.split(';');
	          var userPhones = item.relationships.users.attributes.user_phones.split(';');

	          item.relationships.users_assets = [];
	          for (var index = 0; index < userNames.length; index++) {
	            item.relationships.users_assets.push({
	              type: 'users',
	              attributes: {
	                name: userNames[index],
	                phone: userPhones[index]
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: '_setFilterState',
	    value: function _setFilterState() {
	      this.currentFilterState = {
	        types: this.selectedType,
	        batteryLevel: this.selectedBatteryLevel
	      };
	    }
	  }]);

	  return DisconnectedDevicesController;
	}();

	exports.default = DisconnectedDevicesController;

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CommunicationStatus = function () {
	  function CommunicationStatus($translate) {
	    _classCallCheck(this, CommunicationStatus);

	    this.restrict = 'E';
	    this.$translate = $translate;
	    this.replace = true;
	    this.scope = {
	      steps: '@',
	      index: '@'
	    };
	    this.template = '<div></div>';

	    this.allStatus = [0, 120, 360, 720, 1440];
	  }

	  _createClass(CommunicationStatus, [{
	    key: 'link',
	    value: function link(scope, element) {
	      if (!scope.steps.includes('-')) {
	        element.append('<div class="never-reported-alert" title="' + this.$translate.instant('COMMUNICATION_STATUS.LABEL.NEVER') + '"><i class="material-symbols-outlined text-amber-400">report_problem</i></div>');
	      } else {
	        var interval = scope.steps.split('-');
	        var first = '<span data-metrics="hours">' + interval[0] / 60 + '</span>';
	        var last = interval[1] === 'inf' ? '<span>∞</span>' : '<span data-metrics="hours">' + interval[1] / 60 + '</span>';
	        element.append('<div>' + first + '<span class="st-caption ml8 mr8">-</span>' + last + '</div>');
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$translate", function directiveFactory($translate) {
	      'ngInject';

	      return new CommunicationStatus($translate);
	    }]
	  }]);

	  return CommunicationStatus;
	}();

	CommunicationStatus.directiveFactory.$inject = ['$translate'];

	exports.default = CommunicationStatus;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _devicesList = __webpack_require__(204);

	var _devicesList2 = _interopRequireDefault(_devicesList);

	var _devicesPanel = __webpack_require__(205);

	var _devicesPanel2 = _interopRequireDefault(_devicesPanel);

	var _devicesEditController = __webpack_require__(206);

	var _devicesEditController2 = _interopRequireDefault(_devicesEditController);

	var _general = __webpack_require__(207);

	var _general2 = _interopRequireDefault(_general);

	var _associations = __webpack_require__(208);

	var _associations2 = _interopRequireDefault(_associations);

	var _profile = __webpack_require__(209);

	var _profile2 = _interopRequireDefault(_profile);

	var _commands = __webpack_require__(210);

	var _commands2 = _interopRequireDefault(_commands);

	var _behavior = __webpack_require__(211);

	var _behavior2 = _interopRequireDefault(_behavior);

	var _gpsTable = __webpack_require__(213);

	var _gpsTable2 = _interopRequireDefault(_gpsTable);

	var _reportPoints = __webpack_require__(214);

	var _reportPoints2 = _interopRequireDefault(_reportPoints);

	var _direction = __webpack_require__(215);

	var _direction2 = _interopRequireDefault(_direction);

	var _batteryLife = __webpack_require__(216);

	var _batteryLife2 = _interopRequireDefault(_batteryLife);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.organization.devices', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'devices-list',
	    url: '/devices/list?search&filters',
	    parent: 'organization',
	    menu: true,
	    alias: 'devices',
	    controller: _devicesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/list/devices.list.html',
	    report: true,
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-panel',
	    url: '/devices/panel',
	    parent: 'organization',
	    controller: _devicesPanel2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/panel/devices.panel.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit',
	    url: '/devices/edit/:id',
	    parent: 'organization',
	    controller: _devicesEditController2.default,
	    controllerAs: 'ctrl',
	    params: {
	      id: { dynamic: true }
	    },
	    templateUrl: 'app/internal/organization/devices/edit/devices.edit.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          attributes: ['name', 'imei', 'code', 'from_softruck', 'nature', 'active'],
	          includes: {
	            enterprise: ['name', 'cnpj', 'fantasy_name', 'email', 'timezone'],
	            vehicle: ['plate', 'vin', 'type_name'],
	            chip: ['serial', 'number', 'service_provider'],
	            type: ['brand_alias', 'alias', 'type', 'protocol'],
	            last_gps: ['last_gps_time', 'last_connection_time', 'last_gps_raw', 'last_ignition_on_time', 'last_ignition_off_time']
	          }
	        };

	        return MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + $stateParams.id, obj);
	      }]
	    },
	    redirectTo: 'devices-edit.general'
	  }).state({
	    name: 'devices-edit.general',
	    url: '/general',
	    controller: _general2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/general/_general.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit.associations',
	    url: '/associations',
	    controller: _associations2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/associations/_associations.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit.profile',
	    url: '/profile',
	    controller: _profile2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/profile/_profile.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit.commands',
	    url: '/commands',
	    controller: _commands2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/commands/_commands.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit.behavior',
	    url: '/behavior',
	    controller: _behavior2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/behavior/_behavior.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'devices-edit.gps-table',
	    url: '/gps-table',
	    controller: _gpsTable2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/devices/tabs/gps-table/_gps-table.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('DevicesListController', _devicesList2.default).controller('DevicesPanelController', _devicesPanel2.default).controller('DevicesEditController', _devicesEditController2.default).controller('GeneralController', _general2.default).controller('AssociationsController', _associations2.default).controller('ProfileController', _profile2.default).controller('CommandsController', _commands2.default).controller('BehaviorController', _behavior2.default).controller('GPSTableController', _gpsTable2.default).controller('ReportPointsController', _reportPoints2.default).filter('direction', _direction2.default).filter('battery', _batteryLife2.default);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var DevicesListController = function (_ListController) {
	  DevicesListController.$inject = ["$scope", "$state", "$translate", "DialogService", "GeocodingService", "MainService"];
	  _inherits(DevicesListController, _ListController);

	  function DevicesListController($scope, $state, $translate, DialogService, GeocodingService, MainService) {
	    'ngInject';

	    _classCallCheck(this, DevicesListController);

	    var _this = _possibleConstructorReturn(this, (DevicesListController.__proto__ || Object.getPrototypeOf(DevicesListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$translate = $translate;
	    _this.DialogService = DialogService;
	    _this.GeocodingService = GeocodingService;

	    _this.query = {
	      attributes: ['name', 'imei', 'from_softruck', 'code', 'created_at', 'updated_at', 'last_integration_source', 'last_integration_time', 'active'],
	      includes: {
	        enterprise: ['name', 'cnpj'],
	        vehicle: ['plate', 'vin', 'type_name'],
	        chip: ['serial', 'number', 'service_provider', 'carrier'],
	        last_gps: ['last_gps_time', 'last_connection_time', 'last_gps_raw'],
	        type: ['brand_alias', 'alias', 'type'],
	        users: ['*']
	      },
	      filters: {},
	      sort: null,
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      export: true,
	      stats: true
	    };

	    _this.setProps(_constants.API.V5, _constants.API.DEVICES, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(DevicesListController, [{
	    key: 'setState',
	    value: function setState(state) {
	      var _this2 = this;

	      this.items.map(function (e) {
	        return _this2.checkStatus(e);
	      });
	      var selectedItems = [];
	      var obj = {
	        data: []
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      if (state === 'activation') {
	        selectedItems = this.items.filter(function (e) {
	          return e.selected === true && !e.attributes.active;
	        }).map(function (e) {
	          return e.id;
	        });
	      } else {
	        selectedItems = this.items.filter(function (e) {
	          return e.selected === true && e.attributes.active;
	        }).map(function (e) {
	          return e.id;
	        });
	      }

	      for (var i in selectedItems) {
	        obj.data.push({ type: 'devices', id: selectedItems[i] });
	      }

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'DEVICE_ACTIVATION', action: 'save' }).then(function () {
	        _this2.MainService.edit(_constants.API.V5, _constants.API.DEVICES + '/set-activation/' + state, obj).promise.then(function () {
	          if (state === 'activation') {
	            _this2.items.filter(function (e) {
	              return e.selected === true && !e.attributes.active;
	            }).forEach(function (e) {
	              e.attributes.active = true;
	            });
	          } else {
	            _this2.items.filter(function (e) {
	              return e.selected === true && e.attributes.active;
	            }).forEach(function (e) {
	              e.attributes.active = false;
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(device) {
	      var _this3 = this;

	      var action = device.attributes.active ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'devices',
	          id: device.id
	        }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'DEVICE_ACTIVATION', action: 'save' }).then(function () {
	        _this3.MainService.edit(_constants.API.V5, _constants.API.DEVICES + '/set-activation/' + action, obj).promise.then(function () {
	          if (action === 'activation') {
	            device.attributes.active = true;
	          } else {
	            device.attributes.active = false;
	          }
	        });
	      }).catch(function () {
	        device.attributes.active = !device.attributes.active;
	      });
	    }
	  }, {
	    key: 'checkUsers',
	    value: function checkUsers(device) {
	      if (!device.relationships.users) return;

	      device.relationships ? device.relationships.users_assets = [] : device.relationships = { users_assets: [] };

	      var userNames = device.relationships.users.attributes.user_names.split(';');
	      var userPhones = device.relationships.users.attributes.user_phones.split(';');

	      for (var index = 0; index < userNames.length; index++) {
	        device.relationships.users_assets.push({
	          attributes: {
	            name: userNames[index],
	            phone: userPhones[index]
	          },
	          type: 'users'
	        });
	      }
	    }
	  }, {
	    key: 'resolveAddress',
	    value: function resolveAddress(device) {
	      if (device.relationships.address || !device.relationships.last_gps) {
	        return;
	      }
	      this.GeocodingService.getAddressFromCoords(device.relationships.last_gps.attributes.last_gps_raw.lng, device.relationships.last_gps.attributes.last_gps_raw.lat).promise.then(function (res) {
	        device.relationships.address = res.display_name;
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this4 = this;

	      var keys = ['PANEL.HEADER.IMEI_MODEL', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.CHIP_NUMBER_SERIAL', 'PANEL.HEADER.VEHICLE_TYPE', 'PANEL.HEADER.LAST_GPS'];

	      this.$translate(keys).then(function (t) {
	        _this4.headers = [{
	          label: t['PANEL.HEADER.IMEI_MODEL'],
	          sort: true,
	          prop: 'name'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.CHIP_NUMBER_SERIAL'],
	          sort: true,
	          prop: 'chip.number'
	        }, {
	          label: t['PANEL.HEADER.VEHICLE_TYPE'],
	          sort: true,
	          prop: 'vehicle.plate'
	        }, {
	          label: t['PANEL.HEADER.LAST_GPS'],
	          sort: true,
	          prop: 'last_gps.last_gps_time'
	        }];
	      });
	    }
	  }]);

	  return DevicesListController;
	}(_list2.default);

	exports.default = DevicesListController;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _timeseries = __webpack_require__(99);

	var _timeseries2 = _interopRequireDefault(_timeseries);

	var _donut = __webpack_require__(102);

	var _donut2 = _interopRequireDefault(_donut);

	var _colorPalettes = __webpack_require__(103);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DevicesStatsController = function () {
	  DevicesStatsController.$inject = ["$translate", "MainService"];
	  function DevicesStatsController($translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, DevicesStatsController);

	    this.$translate = $translate;
	    this.MainService = MainService;

	    this.vehicleTypes = _constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    });
	    this.groupedData = {};
	    this.ungroupedData = {};
	    this.reportStatus();
	    this.manageItens();
	    this.distribution();

	    this.selectedKeys = ['created'];
	  }

	  _createClass(DevicesStatsController, [{
	    key: 'reportStatus',
	    value: function reportStatus() {
	      var _this = this;

	      this.loadingStatus = true;
	      this.step = 1;
	      var params = '0,60,120,360,720,1440,2880,4320,5760';
	      var obj = {
	        any: {
	          never: { operator: 'eq', value: true },
	          infinity: { operator: 'eq', value: true }
	        },
	        filters: {
	          'asset_type.name': { operator: 'in', value: this.vehicleTypes }
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + _constants.API.REPORTS + '/communication/' + params, obj).promise.then(function (res) {
	        _this.loadingStatus = false;
	        _this.mainCommunicationStatus = res.data;
	        _this.totalConnectionCars = _.reduce(_.omit(res.data.last_connection_time), function (sum, i) {
	          return sum + i;
	        }, 0);
	        _this.totalComunicationCars = _.reduce(_.omit(res.data.last_gps_time), function (sum, i) {
	          return sum + i;
	        }, 0);

	        var intervalSize = res.data.intervals.length;
	        var vehicleStatus = [].concat(_toConsumableArray(res.data.intervals), _toConsumableArray(res.data.last_connection_time), _toConsumableArray(res.data.last_gps_time));
	        var structuredResult = [];
	        for (var key in vehicleStatus) {
	          if (!structuredResult[key % intervalSize]) structuredResult[key % intervalSize] = [];
	          structuredResult[key % intervalSize].push(vehicleStatus[key]);
	        }
	        _this.communicationStatus = structuredResult;
	      }).catch(function () {
	        _this.loadingStatus = false;
	      });
	    }
	  }, {
	    key: 'distribution',
	    value: function distribution() {
	      var _this2 = this;

	      this.loadingDistribution = true;
	      this.MainService.raw(_constants.API.V5, 'devices/reports/models').promise.then(function (res) {
	        _this2.loadingDistribution = false;
	        _this2.modelDistribution = res.data;
	        for (var key in _this2.modelDistribution) {
	          var modelKeys = Object.keys(_this2.modelDistribution[key]);
	          var accumulator = 0;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;

	          try {
	            for (var _iterator = modelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var i = _step.value;

	              accumulator += _this2.modelDistribution[key][i];
	              _this2.ungroupedData[key + '-' + i] = _this2.modelDistribution[key][i];
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }

	          _this2.groupedData[key] = accumulator;
	        }

	        _this2.modelsList = Object.keys(_this2.groupedData);
	        _this2.selectedModels = _this2.modelsList;

	        var options = {
	          bindTo: 'devices-distribution',
	          type: 'donut',
	          legend: false,
	          size: {
	            height: 300
	          },
	          palette: _colorPalettes.PALETTES.old_green
	        };

	        var report = {
	          names: _this2.modelsList,
	          data: _this2.groupedData
	        };

	        _this2.models = (0, _donut2.default)(options, report);
	        _this2.selectModelKeys();
	      }).catch(function () {
	        _this2.loadingDistribution = false;
	      });
	    }
	  }, {
	    key: 'selectModelKeys',
	    value: function selectModelKeys() {
	      this.models.hide();
	      this.models.show(this.selectedModels);
	    }
	  }, {
	    key: 'manageItens',
	    value: function manageItens() {
	      var _this3 = this;

	      this.loadingManage = true;
	      var query = {
	        startDate: moment().add(1, 'd').format('YYYY-MM-DD'),
	        granularity: 'day',
	        recurrence: 30
	      };
	      this.MainService.raw(_constants.API.V5, ['devices', 'reports', 'management', query.startDate, query.granularity, query.recurrence].join('/')).promise.then(function (res) {
	        _this3.loadingManage = false;
	        var size = res.data.dates.length;

	        var options = {
	          bindTo: 'manage-items',
	          type: 'bar',
	          hide: true,
	          legend: false,
	          format: 'number',
	          palette: _colorPalettes.PALETTES.old_green,
	          size: {
	            height: 300
	          },
	          region: {
	            start: res.data.dates[0],
	            size: size
	          },
	          axis: {
	            x: true,
	            y: true
	          },
	          noData: 'Sem dados',
	          labels: {
	            x: 'Dias',
	            y: 'Unidades'
	          }
	        };

	        var report = {
	          names: {
	            created: 'Criados',
	            deleted: 'Deletados',
	            activated: 'Ativados',
	            deactivated: 'Desativados'
	          },
	          data: [['dates'].concat(_toConsumableArray(res.data.dates.splice(0, size - 1))), ['created'].concat(_toConsumableArray(res.data.created.splice(0, size - 1))), ['deleted'].concat(_toConsumableArray(res.data.deleted.splice(0, size - 1))), ['activated'].concat(_toConsumableArray(res.data.activated.splice(0, size - 1))), ['deactivated'].concat(_toConsumableArray(res.data.deactivated.splice(0, size - 1)))],
	          lines: {
	            y: [],
	            x: []
	          }
	        };

	        _this3.managedItems = (0, _timeseries2.default)(options, report);
	        _this3.selectManagedKeys();
	      }).catch(function () {
	        _this3.loadingManage = false;
	      });
	    }
	  }, {
	    key: 'selectManagedKeys',
	    value: function selectManagedKeys() {
	      this.managedItems.hide();
	      this.managedItems.show(this.selectedKeys);
	    }
	  }]);

	  return DevicesStatsController;
	}();

	exports.default = DevicesStatsController;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DevicesEditController = function () {
	  DevicesEditController.$inject = ["$rootScope", "$scope", "$state", "DialogService", "EnvironmentConfig", "MainService", "selectedItem", "StateManagement"];
	  function DevicesEditController($rootScope, $scope, $state, DialogService, EnvironmentConfig, MainService, selectedItem, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, DevicesEditController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.selectedItem = selectedItem;
	    this.StateManagement = StateManagement;
	    this.ownership = true;
	    this.loadData();

	    var checkOwnership = function checkOwnership() {
	      return _this.checkOwnership();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('device')) {
	        checkOwnership();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });

	    this.chipsOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: '' },
	        'device.name': { operator: 'is', value: null }
	      }
	    };

	    this.vehiclesOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: '' }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.chipsOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	      _this.vehiclesOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });
	  }

	  _createClass(DevicesEditController, [{
	    key: 'checkOwnership',
	    value: function checkOwnership() {
	      if (this.device) {
	        this.ownership = this.device.attributes.from_softruck || this.device.attributes.active;
	      }
	    }
	  }, {
	    key: 'checkChangableItem',
	    value: function checkChangableItem() {
	      if (this.device) {
	        return this.selectedChip || this.selectedVehicle;
	      }
	    }
	  }, {
	    key: 'checkDeviceName',
	    value: function checkDeviceName() {
	      var _this2 = this;

	      this.processing = true;

	      var validation = function validation(value) {
	        _this2.form.name.$setValidity('nameDeviceTaken', value);
	      };

	      if (this.device.attributes.name && this.device.attributes.name !== this.nameCurrent && this.lastNameCheck !== this.device.attributes.name && !this.checking) {
	        this.checking = true;
	        var deviceName = {
	          data: {
	            names: [this.device.attributes.name]
	          }
	        };

	        this.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/check-names', deviceName).promise.then(function (res) {
	          _this2.lastNameCheck = res.data[0].name;
	          _this2.lastTakenCheck = !res.data[0].isTaken;
	          validation(_this2.lastTakenCheck);
	        }).finally(function () {
	          _this2.checking = false;
	          _this2.processing = false;
	        });
	      } else if (this.device.attributes.name === this.nameCurrent || !this.device.attributes.name) {
	        validation(true);
	        this.processing = false;
	      } else if (this.lastNameCheck === this.device.attributes.name) {
	        validation(this.lastTakenCheck);
	        this.processing = false;
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this3 = this;

	      var obj = {
	        data: [{ id: this.device.id, type: 'devices' }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.device).then(function () {
	        _this3.MainService.deleteMany(_constants.API.V5, _constants.API.DEVICES, obj).promise.then(function () {
	          _this3.$state.go('devices-list');
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this4 = this;

	      this.loading = true;
	      this.selectedItem.promise.then(function (res) {
	        _this4.loading = false;
	        _this4.device = res.data;
	        _this4.nameCurrent = _this4.device.attributes.name;

	        _this4.selectedEnterprise = res.data.relationships.enterprise;
	        _this4.selectedModel = res.data.relationships.type;
	        if (res.data.relationships.chip) {
	          _this4.selectedChip = res.data.relationships.chip;
	        }
	        if (res.data.relationships.vehicle) {
	          _this4.selectedVehicle = res.data.relationships.vehicle;
	        }
	        _this4.StateManagement.setData(['device'], [_this4.device]);
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this5 = this;

	      if (this.processing) return;
	      this.processing = true;
	      var device = {
	        data: {
	          attributes: {
	            name: this.device.attributes.name,
	            imei: this.device.attributes.imei,
	            code: this.device.attributes.code
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	            },
	            type: {
	              type: 'type',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedModel.id)
	            },
	            chip: {
	              type: 'chip',
	              id: this.selectedChip ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedChip.id) : null
	            },
	            vehicle: {
	              type: 'vehicle',
	              id: this.selectedVehicle ? (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedVehicle.id) : null
	            }
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(device.data);
	      this.MainService.update(_constants.API.V5, _constants.API.DEVICES, this.$state.params.id, device).promise.finally(function () {
	        _this5.processing = false;
	      });
	    }
	  }]);

	  return DevicesEditController;
	}();

	exports.default = DevicesEditController;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ActivationsController = function () {
	  ActivationsController.$inject = ["$rootScope", "$scope", "$state", "$translate", "DialogService", "MainService", "StateManagement"];
	  function ActivationsController($rootScope, $scope, $state, $translate, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ActivationsController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.obj = {
	      includes: {
	        activator: ['name', 'username', 'email', 'deleted_at'],
	        deactivator: ['name', 'username', 'email', 'deleted_at']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.loadActivationHistory = this.loadActivationHistory.bind(this);
	    this.loadData(1);

	    var active = function active(value) {
	      _this.isActive = value;
	    };
	    var deviceData = function deviceData(value) {
	      _this.device = value;
	    };

	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('device')) {
	        var _StateManagement$getD = _this.StateManagement.getData(['device']),
	            device = _StateManagement$getD.device;

	        active(device.attributes.active);
	        deviceData(device);
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(ActivationsController, [{
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadActivationHistory(page);
	    }
	  }, {
	    key: 'loadActivationHistory',
	    value: function loadActivationHistory(page) {
	      var _this2 = this;

	      this.loading = true;
	      this.obj.page = page;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id + '/activation-history', this.obj).promise.then(function (res) {
	        _this2.loading = false;
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	        _this2.items = res.data;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState() {
	      var _this3 = this;

	      var action = this.isActive ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'devices',
	          id: this.$state.params.id
	        }]
	      };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'DEVICE_ACTIVATION', action: 'save' }).then(function () {
	        _this3.MainService.edit(_constants.API.V5, _constants.API.DEVICES + '/set-activation/' + action, obj).promise.then(function () {
	          _this3.loadActivationHistory(1);

	          if (_this3.device) {
	            _this3.device.attributes.active = _this3.isActive;
	            _this3.StateManagement.setData(['device'], [_this3.device]);
	          }
	        }).catch(function () {
	          _this3.isActive = !_this3.isActive;
	        });
	      }).catch(function () {
	        _this3.isActive = !_this3.isActive;
	      });
	    }
	  }]);

	  return ActivationsController;
	}();

	exports.default = ActivationsController;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AssociationsController = function () {
	  AssociationsController.$inject = ["$state", "DialogService", "MainService"];
	  function AssociationsController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, AssociationsController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.obj = {
	      includes: {
	        device: ['imei', 'name', 'code'],
	        vehicle: ['plate', 'code', 'vin', 'type_name', 'deleted_at'],
	        enterprise: ['name', 'cnpj']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.loadAssociationHistory = this.loadAssociationHistory.bind(this);
	    this.loadData(1);
	  }

	  _createClass(AssociationsController, [{
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadAssociationHistory(page);
	    }
	  }, {
	    key: 'generateReport',
	    value: function generateReport(item) {
	      var _this = this;

	      var opt = {
	        url: 'app/components/report-points/report-points.dialog.html',
	        controllerName: 'ReportPointsController',
	        controllerAlias: 'ctrl',
	        bindToController: true,
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        parent: angular.element('#page-body')
	      };

	      var data = {
	        vehicle: item.relationships.vehicle,
	        device: item.relationships.device,
	        min_date: moment(item.attributes.created_at).format(),
	        max_date: item.attributes.deleted_at ? moment(item.attributes.deleted_at).format() : moment().format()
	      };

	      this.DialogService.openDialog(opt, data).then(function (res) {
	        _this.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/' + _this.$state.params.id + '/reports/points', res);
	      });
	    }
	  }, {
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(page) {
	      var _this2 = this;

	      this.loading = true;
	      this.obj.page = page;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id + '/association-history', this.obj).promise.then(function (res) {
	        _this2.meta.count = res.count;
	        _this2.meta.page = page;
	        _this2.items = res.data;
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }]);

	  return AssociationsController;
	}();

	exports.default = AssociationsController;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProfileController = function () {
	  ProfileController.$inject = ["$rootScope", "$scope", "$state", "MainService", "StateManagement"];
	  function ProfileController($rootScope, $scope, $state, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ProfileController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    var device = function device() {
	      return _this.loadData();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('device')) {
	        device();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(ProfileController, [{
	    key: 'loadData',
	    value: function loadData() {
	      this.loading = true;

	      var _StateManagement$getD = this.StateManagement.getData(['device']),
	          device = _StateManagement$getD.device;

	      this.item = device;
	      this.loading = false;
	    }
	  }]);

	  return ProfileController;
	}();

	exports.default = ProfileController;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CommandsController = function () {
	  CommandsController.$inject = ["$mdDialog", "$rootScope", "$state", "$translate", "MainService"];
	  function CommandsController($mdDialog, $rootScope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, CommandsController);

	    this.$mdDialog = $mdDialog;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 10
	    };

	    this.obj = {
	      includes: {
	        user: ['username', 'email', 'name'],
	        enterprise: ['name', 'cnpj']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.filtered = [];
	    this.categories = [];
	    this.availableCommands = [];
	    this.loadCommandHistory = this.loadCommandHistory.bind(this);
	    this.reorder = this.reorder.bind(this);
	    this.order = '-created_at';
	    this.preventOpen = $rootScope.clientStatus === 'overdue';
	    this.loadData(1);
	  }

	  _createClass(CommandsController, [{
	    key: 'reorder',
	    value: function reorder(attr) {
	      this.obj.sort = attr.indexOf('-') > -1 ? { prop: '' + attr.substring(1), order: 'DESC' } : { prop: attr, order: 'ASC' };
	      this.loadCommandHistory(1);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadCommandHistory(page);
	      this.getAvailableCommands();
	    }
	  }, {
	    key: 'prepareCommand',
	    value: function prepareCommand(command) {
	      var _this = this;

	      var confirm = this.$mdDialog.confirm().title(this.$translate.instant('DEVICES.DIALOG.COMMANDS.SEND')).textContent(this.$translate.instant('DEVICES.DIALOG.COMMANDS.DEVICE_TEXT')).ok(this.$translate.instant('DEVICES.DIALOG.ACTIONS.OK')).cancel(this.$translate.instant('DEVICES.DIALOG.ACTIONS.NOK'));

	      this.$mdDialog.show(confirm).then(function () {
	        var obj = {
	          data: {
	            device_ids: [_this.$state.params.id]
	          }
	        };

	        if (command.fields.length) {
	          var values = [];
	          command.fields.forEach(function (i) {
	            values.push(i.value);
	          });
	          obj.data.command = command.name.split('-')[0] + '-' + values.join('-');
	        } else {
	          obj.data.command = command.name;
	        }

	        _this.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/commands', obj).promise.then(function () {
	          _this.loadCommandHistory(1);
	        }).catch(function () {});
	      });
	    }
	  }, {
	    key: 'filterCommands',
	    value: function filterCommands(category) {
	      var _this2 = this;

	      this.filtered = [];
	      this.availableCommands.forEach(function (f) {
	        var sample = {
	          name: null,
	          fields: []
	        };
	        if (f.match(category)) {
	          sample.name = f;
	          var itens = f.match(/\<<(.*?)\>>/g);
	          if (itens) {
	            itens.forEach(function (i) {
	              var obj = {
	                name: i,
	                type: ['<<FILE_URL>>', '<<RAW>>'].includes(i) ? 'text' : 'number',
	                value: null
	              };
	              sample.fields.push(obj);
	            });
	          }
	          _this2.filtered.push(sample);
	        }
	      });
	    }
	  }, {
	    key: 'getAvailableCommands',
	    value: function getAvailableCommands() {
	      var _this3 = this;

	      this.loadingCommands = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id + '/available-commands').promise.then(function (res) {
	        _this3.loadingCommands = false;
	        res.data.attributes.commands.forEach(function (command) {
	          var category = command.split(/-|_/)[0];
	          if (!_this3.categories.includes(category)) _this3.categories.push(category);
	        });
	        _this3.availableCommands = res.data.attributes.commands;
	      }).catch(function () {
	        _this3.loadingCommands = false;
	      });
	    }
	  }, {
	    key: 'loadCommandHistory',
	    value: function loadCommandHistory(page) {
	      var _this4 = this;

	      this.loadingHistory = true;
	      this.obj.page = page;
	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id + '/commands-history', this.obj).promise.then(function (res) {
	        _this4.loadingHistory = false;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	        _this4.items = res.data;
	      }).catch(function () {
	        _this4.loadingHistory = false;
	      });
	    }
	  }]);

	  return CommandsController;
	}();

	exports.default = CommandsController;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _timeseries = __webpack_require__(212);

	var _timeseries2 = _interopRequireDefault(_timeseries);

	var _constants = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BehaviorController = function () {
	  BehaviorController.$inject = ["$state", "$window", "$translate", "MainService"];
	  function BehaviorController($state, $window, $translate, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, BehaviorController);

	    this.$state = $state;
	    this.$window = $window;
	    this.$translate = $translate;
	    this.MainService = MainService;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.dateRangeConfig = {
	      autoApply: true,
	      opens: 'left',
	      locale: {
	        format: 'DD/MM/YYYY',
	        daysOfWeek: _constants.weekdays[user.attributes.locale],
	        monthNames: _constants.months[user.attributes.locale]
	      },
	      maxSpan: {
	        days: 31
	      },
	      eventHandlers: {
	        'apply.daterangepicker': function applyDaterangepicker() {
	          _this.getBehavior();
	        }
	      },
	      maxDate: moment(new Date())
	    };

	    this.profile = {
	      range: {
	        startDate: moment().subtract(30, 'days'),
	        endDate: moment()
	      },
	      formated: {}
	    };

	    this.getBehavior();
	    this.behavior = {
	      dates: [],
	      rgps: [],
	      igmi: [],
	      igma: [],
	      igav: [],
	      gife: [],
	      naco: [],
	      nadi: [],
	      plsc: [],
	      plgs: [],
	      plbl: [],
	      igon: [],
	      igof: [],
	      blo: [],
	      con: [],
	      coff: []
	    };
	  }

	  _createClass(BehaviorController, [{
	    key: 'getItem',
	    value: function getItem() {
	      var _this2 = this;

	      if (this.$state.params.device) {
	        this.device = this.$state.params.device;
	        this.getBehavior();
	      } else {
	        var obj = {
	          attributes: ['id']
	        };

	        this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id, obj).promise.then(function (res) {
	          _this2.device = res.data;
	          _this2.getBehavior();
	        });
	      }
	    }
	  }, {
	    key: 'getBehavior',
	    value: function getBehavior() {
	      var _this3 = this;

	      this.loading = true;

	      this.profile.formated.startDate = moment(this.profile.range.startDate).format('YYYY-MM-DD');
	      this.profile.formated.endDate = moment(this.profile.range.endDate).format('YYYY-MM-DD');

	      var query = {
	        limit: 31,
	        attributes: ['prof'],
	        filters: {
	          did: { operator: 'eq', value: this.$state.params.id },
	          acc: { operator: 'btw', value: this.profile.formated.startDate + ',' + this.profile.formated.endDate }
	        },
	        sort: { prop: 'acc', order: 'ASC' }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.TRAJECTORIES, query).promise.then(function (res) {
	        _this3.loading = false;
	        _this3.formatData(res.data);
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'formatData',
	    value: function formatData(data) {
	      var _this4 = this;

	      data.forEach(function (d, i) {
	        var item = d.attributes.prof ? d.attributes.prof : {};
	        _this4.behavior.dates.push(moment(_this4.profile.range.startDate).add(i, 'd').format('YYYY-MM-DD'));
	        _this4.behavior.rgps.push(item.rgps ? item.rgps : 0);
	        _this4.behavior.igmi.push(item.igmi ? item.igmi : 0);
	        _this4.behavior.igma.push(item.igma ? item.igma : 0);
	        _this4.behavior.igav.push(item.igav ? item.igav : 0);
	        _this4.behavior.gife.push(item.gife ? item.gife : 0);
	        _this4.behavior.naco.push(item.naco ? item.naco : 0);
	        _this4.behavior.nadi.push(item.nadi ? item.nadi : 0);
	        _this4.behavior.plsc.push(item.plsc ? item.plsc : 0);
	        _this4.behavior.plgs.push(item.plgs ? item.plgs : 0);
	        _this4.behavior.plbl.push(item.plbl ? item.plbl : 0);
	        _this4.behavior.igon.push(item.igon ? item.igon : 0);
	        _this4.behavior.igof.push(item.igof ? item.igof : 0);
	        _this4.behavior.blo.push(item.blo ? item.blo : 0);
	        _this4.behavior.con.push(item.con ? item.con : 0);
	        _this4.behavior.coff.push(item.coff ? item.coff : 0);
	      });
	      this.buildGraph();
	    }
	  }, {
	    key: 'buildGraph',
	    value: function buildGraph() {
	      var graphs = [['bar', 'percent', 'gps', 'dates', ['rgps']], ['bar', 'percent', 'ign-error', 'dates', ['gife']], ['bar', 'number', 'num-alerts', 'dates', ['naco', 'nadi']], ['step-area', 'number', 'ign-dis', 'dates', ['igmi', 'igma', 'igav']], ['step-area', 'boolean', 'ign-state', 'dates', ['igon', 'igof']], ['bar', 'percent', 'low-signal', 'dates', ['plsc', 'plgs', 'plbl']], ['line', 'number', 'battery-life', 'dates', ['blo']], ['bar', 'time', 'communication-time', 'dates', ['con', 'coff']]];
	      for (var index = 0; index < graphs.length; index++) {
	        (0, _timeseries2.default)(graphs[index][0], graphs[index][1], graphs[index][2], graphs[index][3], graphs[index][4], this.behavior, this.$translate);
	      }
	    }
	  }]);

	  return BehaviorController;
	}();

	exports.default = BehaviorController;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	generateGraph.$inject = ["type", "_format", "bindTo", "dates", "datakeys", "sample", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _builddata = __webpack_require__(58);

	var _builddata2 = _interopRequireDefault(_builddata);

	var _buildnames = __webpack_require__(59);

	var _buildnames2 = _interopRequireDefault(_buildnames);

	var _randomcolors = __webpack_require__(60);

	var _randomcolors2 = _interopRequireDefault(_randomcolors);

	var _formatNumber = __webpack_require__(61);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global c3 */

	function generateGraph(type, _format, bindTo, dates, datakeys, sample, $translate) {
	  'ngInject';

	  var formattedLabel = function formattedLabel(d, type) {
	    if (type === 'boolean') {
	      var res = (0, _formatNumber2.default)(d, type);
	      return '' + $translate.instant('DEVICES.ENUM.HIS.' + res.toString().toUpperCase());
	    }
	    return (0, _formatNumber2.default)(d, type);
	  };

	  return c3.generate({
	    bindto: '#' + bindTo,
	    data: {
	      x: 'x',
	      columns: (0, _builddata2.default)(dates, datakeys, sample),
	      names: (0, _buildnames2.default)(datakeys, $translate),
	      type: type
	    },
	    color: {
	      pattern: (0, _randomcolors2.default)()
	    },
	    legend: {
	      show: true,
	      position: 'inset',
	      inset: {
	        anchor: 'top-right',
	        x: 0,
	        y: 0,
	        step: 1
	      }
	    },
	    size: {
	      height: 256
	    },
	    grid: {
	      y: {
	        show: true
	      }
	    },
	    tooltip: {
	      grouped: false
	    },
	    axis: {
	      y: {
	        tick: {
	          count: 7,
	          format: function format(d) {
	            return formattedLabel(d, _format);
	          }
	        }
	      },
	      x: {
	        type: 'timeseries',
	        tick: {
	          format: '%d/%m'
	        }
	      }
	    }
	  });
	}
	exports.default = generateGraph;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GPSTableController = function () {
	  GPSTableController.$inject = ["$rootScope", "$scope", "$state", "$timeout", "$translate", "MainService", "StateManagement"];
	  function GPSTableController($rootScope, $scope, $state, $timeout, $translate, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, GPSTableController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.meta = {
	      count: 0,
	      limit: 100,
	      limitOptions: [100, 200, 300],
	      page: 1,
	      pageOptions: true,
	      order: '-act'
	    };
	    this.dataObj = [];
	    this.max_date = moment().add(1, 'days').format('YYYY-MM-DD');
	    this.headers = _initial.header();
	    this.error = false;

	    var loadTimezone = function loadTimezone() {
	      return _this.timezone();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('device')) {
	        loadTimezone();
	      }
	    });

	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(GPSTableController, [{
	    key: 'search',
	    value: function search() {
	      var _this2 = this;

	      var dataBackup = this.dataObj;
	      var today = moment(this.day).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

	      this.error = false;
	      this.loading = true;
	      this.dataObj = [];

	      if (this.prevSearch === this.day && !today) {
	        this.$timeout(function () {
	          _this2.loading = false;
	          _this2.dataObj = dataBackup;
	        }, 200);

	        return;
	      }

	      this.MainService.raw(_constants.API.V5, _constants.API.DEVICES + '/' + this.$state.params.id + '/points?day=' + moment(this.day).format('YYYY-MM-DD')).promise.then(function (res) {
	        _this2.data = res.data;
	        _this2.prevSearch = _this2.day;
	        if (_this2.data.act) {
	          _this2.clearData();
	          _this2.formatValues();
	          _this2.formatDataToShow();
	        } else {
	          _this2.headers = _initial.header();
	        }
	      }).catch(function () {
	        _this2.headers = _initial.header();
	        _this2.error = true;
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'clearData',
	    value: function clearData() {
	      var _this3 = this;

	      var serializer = ['acc', 'eid', 'did', 'id', 'ttl', 'alarmAcc', 'fix', 'msg'];
	      var checkTranslate = Object.keys(this.data).sort(this.organizeHeaders);
	      checkTranslate.forEach(function (header) {
	        var key = 'DEVICES.LAST_GPS_RAW.' + header.toUpperCase();
	        var translate = _this3.$translate.instant(key);

	        if (key === translate) {
	          serializer.push(header);
	        }
	      });
	      serializer.forEach(function (item) {
	        delete _this3.data[item];
	      });
	    }
	  }, {
	    key: 'timezone',
	    value: function timezone() {
	      var _StateManagement$getD = this.StateManagement.getData(['device']),
	          device = _StateManagement$getD.device;

	      this.enterpriseTz = device.relationships.enterprise.attributes.timezone;
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(timestamp) {
	      var date = new Date(timestamp * 1000);
	      var timeZone = this.enterpriseTz ? { timeZone: this.enterpriseTz } : {};
	      var dateTimezone = date.toLocaleString('en', timeZone);

	      return moment(dateTimezone).format('DD/MM/yyyy HH:mm:ss');
	    }
	  }, {
	    key: 'showDescription',
	    value: function showDescription(column) {
	      return column === 'act' || column === 'cat';
	    }
	  }, {
	    key: 'mapIfExist',
	    value: function mapIfExist(key, mappingFunction) {
	      if (this.data[key]) {
	        this.data[key] = this.data[key].map(mappingFunction);
	      }
	    }
	  }, {
	    key: 'formatValues',
	    value: function formatValues() {
	      var _this4 = this;

	      this.mapIfExist('spd', function (speed) {
	        return angular.isNumber(speed) ? speed + ' km/h' : '-';
	      });
	      this.mapIfExist('act', function (act) {
	        return act ? _this4.formatDate(act) : '-';
	      });
	      this.mapIfExist('cat', function (cat) {
	        return cat ? _this4.formatDate(cat) : '-';
	      });
	      this.mapIfExist('lat', function (lat) {
	        return lat ? lat.toString().substring(0, 10) : '-';
	      });
	      this.mapIfExist('lng', function (lng) {
	        return lng ? lng.toString().substring(0, 10) : '-';
	      });
	      this.mapIfExist('val', function (val) {
	        return val ? _this4.$translate.instant('ALERT_VAL.' + val.toUpperCase() + '.TITLE') : '';
	      });
	      this.mapIfExist('tag', function (tag) {
	        return tag ? _this4.$translate.instant('ALERT_TAG.' + tag.toUpperCase() + '.TITLE') : '';
	      });
	      this.mapIfExist('ign', function (ign) {
	        return _this4.$translate.instant('DEVICES.ENUM.IGN.' + ign.toString().toUpperCase());
	      });
	      this.mapIfExist('his', function (his) {
	        return _this4.$translate.instant('DEVICES.ENUM.HIS.' + his.toString().toUpperCase());
	      });
	      this.mapIfExist('pv', function (pv) {
	        return angular.isNumber(pv) ? pv + 'V' : '';
	      });
	      this.mapIfExist('bbv', function (bbv) {
	        return angular.isNumber(bbv) ? bbv + 'V' : '';
	      });
	      this.mapIfExist('bl', function (bl) {
	        return angular.isNumber(bl) ? bl + '%' : '';
	      });
	      this.mapIfExist('dis', function (dis) {
	        return angular.isNumber(dis) ? (dis / 1000).toFixed(3) + ' m' : '';
	      });
	    }
	  }, {
	    key: 'formatDataToShow',
	    value: function formatDataToShow() {
	      var _this5 = this;

	      var totalByData = [].concat(_toConsumableArray(Array(this.data.act.length).keys()));
	      this.headers = Object.keys(this.data).sort(this.organizeHeaders);
	      this.meta.count = totalByData.length;

	      this.dataObj = totalByData.map(function (i) {
	        var newObj = {};
	        for (var key in _this5.data) {
	          newObj[key] = _this5.data[key][i];
	        }
	        return newObj;
	      });
	    }
	  }, {
	    key: 'organizeHeaders',
	    value: function organizeHeaders(a, b) {
	      var priorityOrder = _initial.header();

	      if (priorityOrder.includes(a) && priorityOrder.includes(b)) {
	        return priorityOrder.indexOf(a) - priorityOrder.indexOf(b);
	      } else if (priorityOrder.includes(a)) {
	        return -1;
	      } else if (priorityOrder.includes(b)) {
	        return 1;
	      } else {
	        return 0;
	      }
	    }
	  }]);

	  return GPSTableController;
	}();

	exports.default = GPSTableController;


	var _initial = {
	  header: function header() {
	    return ['act', 'cat', 'org', 'lat', 'lng', 'tag', 'val', 'spd', 'bbv', 'bl', 'pv'];
	  }
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ReportPointsController = function () {
	  ReportPointsController.$inject = ["$mdDialog", "$window", "locals", "DialogService"];
	  function ReportPointsController($mdDialog, $window, locals, DialogService) {
	    'ngInject';

	    _classCallCheck(this, ReportPointsController);

	    this.$mdDialog = $mdDialog;
	    this.$window = $window;
	    this.locals = locals;
	    this.DialogService = DialogService;

	    this.meta = angular.copy(this.locals.item);
	    this.report = {
	      type: 'CSV'
	    };
	    this.dtk = this.$window.localStorage.getItem('notification_dtk');
	    this.updateInputs();
	  }

	  _createClass(ReportPointsController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'updateInputs',
	    value: function updateInputs() {
	      var formatDate = 'yyyy-MM-DDTHH:mm:ss';
	      var createdAt = moment(this.meta.min_date);
	      var deletedAt = moment(this.meta.max_date);
	      this.report.from_date = createdAt.add(1, 'second').format(formatDate);
	      this.report.min_date = createdAt.format(formatDate);
	      this.report.to_date = deletedAt.diff(createdAt, 'days') < 30 ? deletedAt.format(formatDate) : createdAt.add(30, 'days').format(formatDate);
	      this.report.max_date = deletedAt.add(1, 'second').format(formatDate);
	    }
	  }, {
	    key: 'updatePeriod',
	    value: function updatePeriod() {
	      this.form.to_date.$setValidity('interval', (0, _helper.validationMaxReportInterval)(this.report.from_date, this.report.to_date, 'quarter'));
	      this.form.to_date.$setValidity('finalBiggerInitial', (0, _helper.finalBiggerInitial)(this.report.from_date, this.report.to_date));
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          vehicle_id: this.meta.vehicle.id,
	          from_date: this.report.from_date,
	          to_date: this.report.to_date,
	          type: this.report.type
	        }
	      };

	      if (this.dtk) {
	        obj.data.dtk = this.dtk;
	      }
	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return ReportPointsController;
	}();

	exports.default = ReportPointsController;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = direction;
	/**
	 * The mapbox orientation is to the North on 0 degrees
	 */
	function direction($translate) {
	  'use strict';
	  /**
	   *
	   * @param {number} input
	   */

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return;
	    }

	    var degrees = input % 360;

	    if (degrees >= 22.5 && degrees < 67.5) {
	      return $translate.instant('DIRECTIONS.NE');
	    } else if (degrees >= 67.5 && degrees < 112.5) {
	      return $translate.instant('DIRECTIONS.E');
	    } else if (degrees >= 112.5 && degrees < 157.5) {
	      return $translate.instant('DIRECTIONS.SE');
	    } else if (degrees >= 157.5 && degrees < 202.5) {
	      return $translate.instant('DIRECTIONS.S');
	    } else if (degrees >= 202.5 && degrees < 247.5) {
	      return $translate.instant('DIRECTIONS.SW');
	    } else if (degrees >= 247.5 && degrees < 292.5) {
	      return $translate.instant('DIRECTIONS.W');
	    } else if (degrees >= 292.5 && degrees < 337.5) {
	      return $translate.instant('DIRECTIONS.NW');
	    } else {
	      return $translate.instant('DIRECTIONS.N');
	    }
	  };
	}

	direction.$inject = ['$translate'];

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = battery;
	function battery() {
	  'use strict';
	  /**
	   *
	   * @param {string} input
	   */

	  return function (input) {
	    var batteryLife = Math.round(input);
	    var icon = 'battery_alert';

	    if (batteryLife >= 20 && batteryLife < 30) {
	      icon = 'battery_20';
	    } else if (batteryLife >= 30 && batteryLife < 50) {
	      icon = 'battery_30';
	    } else if (batteryLife >= 50 && batteryLife < 60) {
	      icon = 'battery_50';
	    } else if (batteryLife >= 60 && batteryLife < 80) {
	      icon = 'battery_60';
	    } else if (batteryLife >= 80 && batteryLife < 90) {
	      icon = 'battery_80';
	    } else if (batteryLife >= 90 && batteryLife < 100) {
	      icon = 'battery_90';
	    } else if (batteryLife === 100) {
	      icon = 'battery_full';
	    }

	    return 'assets/holders/' + icon + '.svg';
	  };
	}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _enterprisesList = __webpack_require__(218);

	var _enterprisesList2 = _interopRequireDefault(_enterprisesList);

	var _enterprisesEdit = __webpack_require__(219);

	var _enterprisesEdit2 = _interopRequireDefault(_enterprisesEdit);

	var _addresses = __webpack_require__(220);

	var _addresses2 = _interopRequireDefault(_addresses);

	var _templates = __webpack_require__(221);

	var _templates2 = _interopRequireDefault(_templates);

	var _behaviorConfigs = __webpack_require__(222);

	var _behaviorConfigs2 = _interopRequireDefault(_behaviorConfigs);

	var _customizations = __webpack_require__(223);

	var _customizations2 = _interopRequireDefault(_customizations);

	var _notifications = __webpack_require__(224);

	var _notifications2 = _interopRequireDefault(_notifications);

	var _operationals = __webpack_require__(225);

	var _operationals2 = _interopRequireDefault(_operationals);

	var _customFilters = __webpack_require__(226);

	var _customFilters2 = _interopRequireDefault(_customFilters);

	var _publicKeys = __webpack_require__(227);

	var _publicKeys2 = _interopRequireDefault(_publicKeys);

	var _webhooks = __webpack_require__(228);

	var _webhooks2 = _interopRequireDefault(_webhooks);

	var _integrations = __webpack_require__(229);

	var _integrations2 = _interopRequireDefault(_integrations);

	var _newEnterpriseBehaviorConfig = __webpack_require__(230);

	var _newEnterpriseBehaviorConfig2 = _interopRequireDefault(_newEnterpriseBehaviorConfig);

	var _addressForm = __webpack_require__(231);

	var _addressForm2 = _interopRequireDefault(_addressForm);

	var _templateForm = __webpack_require__(232);

	var _templateForm2 = _interopRequireDefault(_templateForm);

	var _alerts = __webpack_require__(233);

	var _alerts2 = _interopRequireDefault(_alerts);

	var _resources = __webpack_require__(234);

	var _resources2 = _interopRequireDefault(_resources);

	var _customFilters3 = __webpack_require__(235);

	var _customFilters4 = _interopRequireDefault(_customFilters3);

	var _webhooks3 = __webpack_require__(237);

	var _webhooks4 = _interopRequireDefault(_webhooks3);

	var _publicKeys3 = __webpack_require__(238);

	var _publicKeys4 = _interopRequireDefault(_publicKeys3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.organization.enterprises', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'enterprises-list',
	    url: '/enterprises/list?search&filters',
	    parent: 'organization',
	    menu: true,
	    alias: 'enterprises',
	    controller: _enterprisesList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/list/enterprises.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit',
	    url: '/enterprises/edit/:id',
	    parent: 'organization',
	    controller: _enterprisesEdit2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/edit/enterprises.edit.html',
	    params: {
	      id: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    },
	    resolve: { /* @ngInject */
	      selectedItem: ["MainService", "$stateParams", function selectedItem(MainService, $stateParams) {
	        var obj = {
	          includes: {
	            document: ['file_size', 'created_at', 'folder', 'key_name', 'mime', 'name'],
	            country: ['*']
	          },
	          sort: { prop: 'name', order: 'ASC' }
	        };

	        return MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + $stateParams.id, obj);
	      }]
	    },
	    redirectTo: 'enterprises-edit.addresses'
	  }).state({
	    name: 'enterprises-edit.addresses',
	    url: '/addresses',
	    controller: _addresses2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/addresses/_addresses.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.behavior-configs',
	    url: '/behavior-configs',
	    controller: _behaviorConfigs2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/behavior-configs/_behavior-configs.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.notifications',
	    url: '/notifications',
	    controller: _notifications2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/notifications/_notifications.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.customizations',
	    url: '/customizations',
	    controller: _customizations2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/customizations/_customizations.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.public-keys',
	    url: '/public-keys',
	    controller: _publicKeys2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/public-keys/_public-keys.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.webhooks',
	    url: '/webhooks',
	    controller: _webhooks2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/webhooks/_webhooks.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.templates',
	    url: '/templates',
	    controller: _templates2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/templates/_templates.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.operationals',
	    url: '/operationals',
	    controller: _operationals2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/operationals/_operationals.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.custom-filters',
	    url: '/custom-filters',
	    controller: _customFilters2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/custom-filters/_custom-filters.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  }).state({
	    name: 'enterprises-edit.integrations',
	    url: '/integrations',
	    controller: _integrations2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/organization/enterprises/tabs/integrations/_integrations.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  });
	}]).controller('EnterprisesListController', _enterprisesList2.default).controller('EnterprisesEditController', _enterprisesEdit2.default).controller('EnterprisesAddressesController', _addresses2.default).controller('EnterprisesBehaviorConfigsController', _behaviorConfigs2.default).controller('EnterprisesCustomizationsController', _customizations2.default).controller('EnterprisesNotificationsController', _notifications2.default).controller('EnterprisesTemplatesController', _templates2.default).controller('EnterprisesOperationalsController', _operationals2.default).controller('EnterprisesIntegrationsController', _integrations2.default).controller('NewEnterpriseBehaviorConfigController', _newEnterpriseBehaviorConfig2.default).controller('EnterprisesPublicKeysController', _publicKeys2.default).controller('EnterprisesWebhooksController', _webhooks2.default).controller('EnterprisesTemplatesController', _templates2.default).controller('EnterprisesOperationalsController', _operationals2.default).controller('EnterprisesCustomFiltersController', _customFilters2.default).controller('NewEnterpriseBehaviorConfigController', _newEnterpriseBehaviorConfig2.default).controller('AddressFormController', _addressForm2.default).controller('TemplateFormController', _templateForm2.default).controller('TaskResourcesController', _resources2.default).controller('CustomFiltersDialogController', _customFilters4.default).controller('WebhooksController', _webhooks4.default).controller('PublicKeysController', _publicKeys4.default).service('AlertsNotificationService', _alerts2.default);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var EnterprisesListController = function (_ListController) {
	  EnterprisesListController.$inject = ["$state", "$scope", "$translate", "DialogService", "MainService"];
	  _inherits(EnterprisesListController, _ListController);

	  function EnterprisesListController($state, $scope, $translate, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesListController);

	    var _this = _possibleConstructorReturn(this, (EnterprisesListController.__proto__ || Object.getPrototypeOf(EnterprisesListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$translate = $translate;
	    _this.DialogService = DialogService;

	    _this.query = {
	      attributes: ['assistance_emergency_tel', 'cnpj', 'contact_name', 'created_at', 'description', 'email', 'fantasy_name', 'last_integration_source', 'last_integration_time', 'main_client', 'name', 'phone1', 'phone2', 'state_registration_no', 'theft_emergency_tel', 'deactivated_at', 'timezone', 'updated_at', 'webpage'],
	      filters: {},
	      sort: { prop: 'name', order: 'ASC' },
	      count: true,
	      limit: 15,
	      page: 1,
	      search: null
	    };

	    _this.options = {
	      export: true,
	      stats: false
	    };

	    _this.setProps(_constants.API.V5, _constants.API.ENTERPRISES, _this.query);
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(EnterprisesListController, [{
	    key: 'checkStatus',
	    value: function checkStatus(enterprise) {
	      enterprise.attributes.active = !enterprise.attributes.deactivated_at;
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(enterprise) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = enterprise.attributes.active ? 'activation' : 'deactivation';
	      var obj = {
	        data: {
	          action_at: null
	        }
	      };

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'ENTERPRISE_ACTIVATION', action: 'save' }).then(function () {
	        _this2.MainService.edit(_constants.API.V5, _constants.API.ENTERPRISES + '/' + enterprise.id + '/set-activation/' + action, obj).promise.then(function () {
	          enterprise.attributes.deactivated_at = enterprise.attributes.deactivated_at ? null : new Date();
	          enterprise.attributes.ative = !enterprise.attributes.ative;
	        });
	      }).catch(function () {
	        _this2.checkStatus(enterprise);
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this3 = this;

	      var keys = ['PANEL.HEADER.ENTERPRISE_NAME', 'PANEL.HEADER.DOC', 'PANEL.HEADER.EMAIL_PHONE', 'PANEL.HEADER.ADDRESS'];

	      this.$translate(keys).then(function (t) {
	        _this3.headers = [{
	          label: t['PANEL.HEADER.ENTERPRISE_NAME'],
	          sort: true,
	          prop: 'name'
	        }, {
	          label: t['PANEL.HEADER.DOC']
	        }, {
	          label: t['PANEL.HEADER.EMAIL_PHONE']
	        }];
	      });
	    }
	  }]);

	  return EnterprisesListController;
	}(_list2.default);

	exports.default = EnterprisesListController;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesEditController = function () {
	  EnterprisesEditController.$inject = ["$scope", "$state", "$window", "DialogService", "MainService", "EnvironmentConfig", "selectedItem", "StateManagement"];
	  function EnterprisesEditController($scope, $state, $window, DialogService, MainService, EnvironmentConfig, selectedItem, StateManagement) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesEditController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.selectedItem = selectedItem;
	    this.StateManagement = StateManagement;

	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.langUser = user.attributes.locale.replace('_', '-');
	    this.loadData();
	  }

	  _createClass(EnterprisesEditController, [{
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.enterprise).then(function () {
	        _this.MainService.delete(_constants.API.V5, _constants.API.ENTERPRISES, _this.enterprise.id).promise.then(function () {
	          _this.$state.go('enterprises-list');
	        });
	      });
	    }
	  }, {
	    key: 'translateCountryName',
	    value: function translateCountryName(country) {
	      return country.language === this.langUser ? country.local_name : country.name;
	    }
	  }, {
	    key: 'getTimezones',
	    value: function getTimezones() {
	      if (!this.selectedCountry) {
	        this.enterprise.attributes.timezone = '';
	        return;
	      }

	      this.timezoneList = this.selectedCountry.attributes.timezones;

	      if (this.timezoneList.length === 1) {
	        this.enterprise.attributes.timezone = this.timezoneList[0];
	      }
	    }
	  }, {
	    key: 'getContries',
	    value: function getContries(query) {
	      var obj = {
	        attributes: ['*'],
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/countries', obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      this.loading = true;
	      this.selectedItem.promise.then(function (res) {
	        _this2.loading = false;
	        _this2.enterprise = res.data;
	        _this2.StateManagement.setData(['enterprise'], [_this2.enterprise]);
	        _this2.selectedCountry = res.data.relationships.country;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.loading = true;
	      var enterprise = {
	        data: {
	          attributes: {
	            name: this.enterprise.attributes.name,
	            fantasy_name: this.enterprise.attributes.fantasy_name,
	            cnpj: this.enterprise.attributes.cnpj,
	            email: this.enterprise.attributes.email,
	            contact_name: this.enterprise.attributes.contact_name,
	            phone1: this.enterprise.attributes.phone1,
	            phone2: this.enterprise.attributes.phone2,
	            description: this.enterprise.attributes.description,
	            webpage: this.enterprise.attributes.webpage,
	            timezone: this.enterprise.attributes.timezone,
	            theft_emergency_tel: this.enterprise.attributes.theft_emergency_tel,
	            assistance_emergency_tel: this.enterprise.attributes.assistance_emergency_tel
	          },
	          relationships: {
	            country: {
	              type: 'country',
	              id: this.selectedCountry.id
	            }
	          }
	        }
	      };

	      (0, _helper.cleanBulkPayload)(enterprise, true);
	      this.MainService.update(_constants.API.V5, _constants.API.ENTERPRISES, this.$state.params.id, enterprise).promise.finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesEditController;
	}();

	exports.default = EnterprisesEditController;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesAddressesController = function () {
	  EnterprisesAddressesController.$inject = ["$state", "DialogService", "MainService"];
	  function EnterprisesAddressesController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesAddressesController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.path = [_constants.API.ENTERPRISES, this.$state.params.id, _constants.API.ADDRESSES].join('/');
	    this.opt = _dialog.DIALOG._opts('app/components/address-form/address-form.html', 'AddressFormController');

	    this.loadAddresses = this.loadAddresses.bind(this);
	    this.loadAddresses(1);
	  }

	  _createClass(EnterprisesAddressesController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.opt, { attributes: { model: 'enterprises' } }).then(function (address) {
	        _this.MainService.create(_constants.API.V5, _this.path, address).promise.then(function (res) {
	          address = Object.assign(address, res.data);
	          _this.items.push(address);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data, index) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'ADDRESSES', label: 'ADDRESSES', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _this2.path, data.id).promise.then(function () {
	          _this2.items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      this.DialogService.openDialog(this.opt, item).then(function (address) {
	        _this3.MainService.update(_constants.API.V5, _this3.path, item.id, address).promise.then(function (res) {
	          address = Object.assign(address, res.data);
	          _this3.items[index] = address;
	        });
	      });
	    }
	  }, {
	    key: 'loadAddresses',
	    value: function loadAddresses(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;

	      var obj = {
	        attributes: ['*'],
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, this.path, obj).promise.then(function (res) {
	        _this4.loading = false;
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesAddressesController;
	}();

	exports.default = EnterprisesAddressesController;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesTemplatesController = function () {
	  EnterprisesTemplatesController.$inject = ["$state", "DialogService", "MainService"];
	  function EnterprisesTemplatesController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesTemplatesController);

	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.$state = $state;

	    this.enterpriseId = this.$state.params.id;
	    this.url = _constants.API.ENTERPRISES + '/' + this.enterpriseId + '/terms';

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.opt = _dialog.DIALOG._opts('app/components/template-form/template-form.html', 'TemplateFormController');

	    this.loadTemplate = this.loadTemplate.bind(this);
	    this.loadTemplate(1);
	  }

	  _createClass(EnterprisesTemplatesController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      var item = {
	        attributes: {
	          name: '',
	          text: null
	        }
	      };

	      this.DialogService.openDialog(this.opt, item).then(function (template) {
	        _this.MainService.create(_constants.API.V5, _this.url, template).promise.then(function () {
	          _this.loadTemplate(1);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'TEMPLATES', label: 'TEMPLATES', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _this2.url, data.id).promise.then(function () {
	          var currentPage = _this2.meta.page > 1 && _this2.items.length === 1 ? _this2.meta.page - 1 : _this2.meta.page;
	          _this2.loadTemplate(currentPage);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      var data = {
	        attributes: {
	          name: item.attributes.name,
	          text: item.attributes.text
	        }
	      };

	      this.DialogService.openDialog(this.opt, data).then(function (template) {
	        _this3.MainService.update(_constants.API.V5, _this3.url, item.id, template).promise.then(function (res) {
	          template = Object.assign(template, res.data);
	          _this3.items[index] = template;
	        });
	      });
	    }
	  }, {
	    key: 'loadTemplate',
	    value: function loadTemplate(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;

	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, this.url, obj).promise.then(function (res) {
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesTemplatesController;
	}();

	exports.default = EnterprisesTemplatesController;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesBehaviorConfigsController = function () {
	  EnterprisesBehaviorConfigsController.$inject = ["$rootScope", "$scope", "DialogService", "MainService", "StateManagement"];
	  function EnterprisesBehaviorConfigsController($rootScope, $scope, DialogService, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, EnterprisesBehaviorConfigsController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.opt = _dialog.DIALOG._opts('app/internal/organization/enterprises/components/new-enterprise-behavior-config/new-enterprise-behavior-config.dialog.html', 'NewEnterpriseBehaviorConfigController');

	    var loadBehaviorConfig = function loadBehaviorConfig() {
	      return _this.loadData(1);
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('enterprise')) {
	        loadBehaviorConfig();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(EnterprisesBehaviorConfigsController, [{
	    key: 'add',
	    value: function add() {
	      var _this2 = this;

	      this.DialogService.openDialog(this.opt).then(function (behavior) {
	        _this2.MainService.create(_constants.API.V4, _this2.path, behavior).promise.then(function (res) {
	          behavior = Object.assign(behavior, res.data);
	          _this2.items.push(behavior);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data, index) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'BEHAVIOR', label: 'BEHAVIOR', action: 'delete' }).then(function () {
	        _this3.MainService.delete(_constants.API.V4, _this3.path, data.uuid).promise.then(function () {
	          _this3.items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this4 = this;

	      this.DialogService.openDialog(this.opt, item).then(function (behavior) {
	        _this4.MainService.update(_constants.API.V4, _this4.path, item.uuid, behavior).promise.then(function (res) {
	          behavior = Object.assign(behavior, res.data);
	          _this4.items[index] = behavior;
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadBehaviorConfig(page);
	    }
	  }, {
	    key: 'loadBehaviorConfig',
	    value: function loadBehaviorConfig(page) {
	      var _this5 = this;

	      this.items = [];
	      this.loading = true;

	      var _StateManagement$getD = this.StateManagement.getData(['enterprise']),
	          enterprise = _StateManagement$getD.enterprise;

	      this.path = [_constants.API.ENTERPRISES, enterprise.uuid, _constants.API.BEHAVIOR_CONFIGS].join('/');

	      var obj = {
	        includes: {},
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V4, this.path, obj).promise.then(function (res) {
	        _this5.items = res.data;
	        _this5.meta.count = res.count;
	        _this5.meta.page = page;
	      }).finally(function () {
	        _this5.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesBehaviorConfigsController;
	}();

	exports.default = EnterprisesBehaviorConfigsController;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesCustomizationsController = function () {
	  EnterprisesCustomizationsController.$inject = ["$state", "DialogService", "EnvironmentConfig", "MainService"];
	  function EnterprisesCustomizationsController($state, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesCustomizationsController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.routeDomain = this.EnvironmentConfig.ROUTE_DOMAIN;
	    this.layout = _constants.CUSTOMIZATION_LAYOUT;

	    this.loadData();
	  }

	  _createClass(EnterprisesCustomizationsController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.loading = true;
	      var customization = {
	        data: {
	          attributes: {
	            layout: 'CENTER',
	            domain: '' + this.customization.attributes.short_domain + this.routeDomain,
	            color1: this.customization.attributes.color1,
	            color2: this.customization.attributes.color2
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(customization.data, true);
	      if (this.customization.id) {
	        this.MainService.update(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.$state.params.id + '/customizations', this.customization.id, customization).promise.finally(function () {
	          _this.loading = false;
	        });
	      } else {
	        this.MainService.create(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.$state.params.id + '/customizations', customization).promise.then(function () {
	          _this.close();
	        }).finally(function () {
	          _this.loading = false;
	        });
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'CUSTOMIZATION', label: 'CUSTOMIZATION', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this2.$state.params.id + '/customizations', _this2.customization.id).promise.then(function () {
	          _this2.customization = null;
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this3 = this;

	      this.loading = true;
	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.$state.params.id + '/customizations').promise.then(function (res) {
	        _this3.loading = false;
	        _this3.customization = res.data;
	        _this3.customization.attributes.short_domain = _this3.customization.attributes.domain.split('.')[0];
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesCustomizationsController;
	}();

	exports.default = EnterprisesCustomizationsController;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesNotificationsController = function () {
	  EnterprisesNotificationsController.$inject = ["$rootScope", "$scope", "$window", "AlertsNotificationService", "StateManagement"];
	  function EnterprisesNotificationsController($rootScope, $scope, $window, AlertsNotificationService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, EnterprisesNotificationsController);

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$window = $window;
	    this.AlertsNotificationService = AlertsNotificationService;
	    this.StateManagement = StateManagement;

	    this.role = this.$window.localStorage.getItem('role');
	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    var loadNotifications = function loadNotifications() {
	      return _this.loadData();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('enterprise')) {
	        loadNotifications();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(EnterprisesNotificationsController, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;

	      var _StateManagement$getD = this.StateManagement.getData(['enterprise']),
	          enterprise = _StateManagement$getD.enterprise;

	      this.enterpriseUuid = enterprise.uuid;
	      this.AlertsNotificationService.getAlertsConfig(this.enterpriseUuid).promise.then(function (configResponse) {
	        _this2.alertsConfig = configResponse.config;
	        _this2.inherit = configResponse.inherit;
	        // this.showInheritOption = !this.enterprise.attributes.main_client
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      this.AlertsNotificationService.updateAlertsConfig(this.enterpriseUuid, this.inherit, this.alertsConfig).promise.then(function (res) {
	        _this3.alertsConfig = res.config;
	        _this3.inherit = res.inherit;
	      }).finally(function () {
	        _this3.processing = false;
	      });
	    }
	  }]);

	  return EnterprisesNotificationsController;
	}();

	exports.default = EnterprisesNotificationsController;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesOperationalsController = function () {
	  EnterprisesOperationalsController.$inject = ["$rootScope", "$scope", "DialogService", "EnvironmentConfig", "MainService", "StateManagement"];
	  function EnterprisesOperationalsController($rootScope, $scope, DialogService, EnvironmentConfig, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, EnterprisesOperationalsController);

	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;

	    this.meta = {
	      types: {
	        page: 1,
	        limit: 5
	      },
	      sections: {
	        page: 1,
	        limit: 5
	      }
	    };

	    this.loading = {
	      types: false,
	      sections: false
	    };

	    this.opt = _dialog.DIALOG._opts('app/components/task/resources/resources.dialog.html', 'TaskResourcesController');

	    this.resources = _constants.TASK_RESOUCES;
	    this.loadTypes = this.loadTypes.bind(this);
	    this.loadSections = this.loadSections.bind(this);
	    this.btnTaskTypes = true;
	    this.btnTaskSections = false;

	    var loadItems = function loadItems() {
	      return _this.getItem();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('enterprise')) {
	        loadItems();
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(EnterprisesOperationalsController, [{
	    key: 'getItem',
	    value: function getItem() {
	      var _StateManagement$getD = this.StateManagement.getData(['enterprise']),
	          enterprise = _StateManagement$getD.enterprise;

	      this.enterprise = enterprise;
	      this.loadData(this.resources[0]);
	    }
	  }, {
	    key: 'add',
	    value: function add(type) {
	      var _this2 = this;

	      var resource = {
	        type: type === 'types' ? 'task_types' : 'task_sections'
	      };
	      this.DialogService.openDialog(this.opt, resource).then(function (item) {
	        item.data.relationships = {
	          enterprise: {
	            type: 'enterprise',
	            id: (0, _helper.hashify)(_this2.EnvironmentConfig.SALT, _this2.enterprise.id)
	          }
	        };
	        _this2.MainService.create(_constants.API.V5, _this2.selectedType + '/' + type, item).promise.then(function () {
	          type === 'types' ? _this2.loadTypes(1) : _this2.loadSections(1);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(unit, resource, index) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'RESOURCE', label: 'RESOURCE', action: 'delete' }).then(function () {
	        _this3.MainService.delete(_constants.API.V5, _this3.selectedType + '/' + resource, unit.id).promise.then(function () {
	          _this3[resource].splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(unit, resource, index) {
	      var _this4 = this;

	      this.DialogService.openDialog(this.opt, unit).then(function (item) {
	        _this4.MainService.update(_constants.API.V5, _this4.selectedType + '/' + resource, unit.id, item).promise.then(function (res) {
	          item = Object.assign(item, res.data);
	          _this4[resource][index] = item;
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(resource) {
	      this.selectedType = resource;
	      this.loadTypes(1);
	      this.loadSections(1);
	      this.btnTaskTypes = resource === 'service-orders';
	      this.btnTaskSections = resource === 'protocols';
	    }
	  }, {
	    key: 'loadTypes',
	    value: function loadTypes(page) {
	      var _this5 = this;

	      this.types = [];
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.enterprise.id) }
	        },
	        page: page || this.meta.types.page,
	        count: true,
	        limit: this.meta.types.limit
	      };

	      this.loading.types = true;
	      this.MainService.raw(_constants.API.V5, this.selectedType + '/types', obj).promise.then(function (res) {
	        _this5.loading.types = false;
	        _this5.types = res.data;
	        _this5.meta.types.count = res.count;
	        _this5.meta.types.page = page;
	      }).catch(function () {
	        _this5.loading.types = false;
	      });
	    }
	  }, {
	    key: 'loadSections',
	    value: function loadSections(page) {
	      var _this6 = this;

	      this.sections = [];
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'name',
	          order: 'ASC'
	        },
	        filters: {
	          'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.enterprise.id) }
	        },
	        page: page || this.meta.sections.page,
	        count: true,
	        limit: this.meta.sections.limit
	      };

	      this.loading.sections = true;
	      this.MainService.raw(_constants.API.V5, this.selectedType + '/sections', obj).promise.then(function (res) {
	        _this6.loading.sections = false;
	        _this6.sections = res.data;
	        _this6.meta.sections.count = res.count;
	        _this6.meta.sections.page = page;
	      }).catch(function () {
	        _this6.loading.sections = false;
	      });
	    }
	  }]);

	  return EnterprisesOperationalsController;
	}();

	exports.default = EnterprisesOperationalsController;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesCustomFiltersController = function () {
	  EnterprisesCustomFiltersController.$inject = ["$state", "DialogService", "MainService"];
	  function EnterprisesCustomFiltersController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesCustomFiltersController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.opt = _dialog.DIALOG._opts('app/components/custom-filters/custom-filters.dialog.html', 'CustomFiltersDialogController');

	    this.currentEnterprise = {
	      id: this.$state.params.id
	    };

	    this.loadFilters = this.loadFilters.bind(this);
	    this.loadFilters(1);
	  }

	  _createClass(EnterprisesCustomFiltersController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.opt).then(function (data) {
	        _this.MainService.create(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this.currentEnterprise.id + '/custom-filters', data).promise.then(function () {
	          _this.loadFilters(1);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'CUSTOM_FILTERS', label: 'CUSTOM_FILTERS', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this2.currentEnterprise.id + '/custom-filters', item.id).promise.then(function () {
	          var currentPage = 1;
	          if (_this2.meta.page > 1) {
	            currentPage = _this2.items.length === 1 ? _this2.meta.page - 1 : _this2.meta.page;
	          }

	          _this2.loadFilters(currentPage);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      var obj = item.attributes;

	      this.DialogService.openDialog(this.opt, obj).then(function (data) {
	        _this3.MainService.update(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this3.currentEnterprise.id + '/custom-filters', item.id, data).promise.then(function (res) {
	          data = Object.assign(data, res.data);
	          _this3.items[index] = data;
	        });
	      });
	    }
	  }, {
	    key: 'loadFilters',
	    value: function loadFilters(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        includes: {},
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.id + '/custom-filters', obj).promise.then(function (res) {
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesCustomFiltersController;
	}();

	exports.default = EnterprisesCustomFiltersController;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesPublicKeysController = function () {
	  EnterprisesPublicKeysController.$inject = ["$state", "DialogService", "MainService"];
	  function EnterprisesPublicKeysController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesPublicKeysController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.path = [_constants.API.ENTERPRISES, this.$state.params.id, 'public-keys'].join('/');
	    this.opt = _dialog.DIALOG._opts('app/components/public-keys/public-keys.html', 'PublicKeysController');

	    this.loadData(1);
	    this.loadPublicKeys = this.loadPublicKeys.bind(this);
	  }

	  _createClass(EnterprisesPublicKeysController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.opt).then(function (address) {
	        _this.MainService.create(_constants.API.V5, _this.path, address).promise.then(function (res) {
	          address = Object.assign(address, res.data);
	          _this.items.push(address);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data, index) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'PUBLIC_KEYS', label: 'PUBLIC_KEYS', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _this2.path, data.id).promise.then(function () {
	          _this2.items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      this.DialogService.openDialog(this.opt, item).then(function (data) {
	        _this3.MainService.update(_constants.API.V5, _this3.path, item.id, data).promise.then(function (res) {
	          data = Object.assign(data, res.data);
	          _this3.items[index] = data;
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadPublicKeys(page);
	    }
	  }, {
	    key: 'loadPublicKeys',
	    value: function loadPublicKeys(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, this.path, obj).promise.then(function (res) {
	        _this4.loading = false;
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesPublicKeysController;
	}();

	exports.default = EnterprisesPublicKeysController;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesWebhooksController = function () {
	  EnterprisesWebhooksController.$inject = ["$state", "DialogService", "MainService"];
	  function EnterprisesWebhooksController($state, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesWebhooksController);

	    this.$state = $state;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.path = [_constants.API.ENTERPRISES, this.$state.params.id, 'webhooks'].join('/');
	    this.opt = _dialog.DIALOG._opts('app/components/webhooks/webhooks.html', 'WebhooksController');

	    this.loadData(1);
	    this.loadWebhooks = this.loadWebhooks.bind(this);
	  }

	  _createClass(EnterprisesWebhooksController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.opt).then(function (data) {
	        _this.MainService.create(_constants.API.V5, _this.path, data).promise.then(function (res) {
	          data = Object.assign(data, res.data);
	          _this.items.push(data);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(data, index) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { title: 'WEBHOOKS', label: 'WEBHOOKS', action: 'delete' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _this2.path, data.id).promise.then(function () {
	          _this2.items.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      this.DialogService.openDialog(this.opt, item).then(function (data) {
	        _this3.MainService.update(_constants.API.V5, _this3.path, item.id, data).promise.then(function (res) {
	          data = Object.assign(data, res.data);
	          _this3.items[index] = data;
	        });
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      this.loadWebhooks(page);
	    }
	  }, {
	    key: 'loadWebhooks',
	    value: function loadWebhooks(page) {
	      var _this4 = this;

	      this.items = [];
	      this.loading = true;
	      var obj = {
	        attributes: ['*'],
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page || this.meta.page,
	        count: true,
	        limit: this.meta.limit
	      };

	      this.MainService.raw(_constants.API.V5, this.path, obj).promise.then(function (res) {
	        _this4.loading = false;
	        _this4.items = res.data;
	        _this4.meta.count = res.count;
	        _this4.meta.page = page;
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesWebhooksController;
	}();

	exports.default = EnterprisesWebhooksController;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EnterprisesIntegrationsController = function () {
	  EnterprisesIntegrationsController.$inject = ["$state", "$translate", "DialogService", "MainService"];
	  function EnterprisesIntegrationsController($state, $translate, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesIntegrationsController);

	    this.$state = $state;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.meta = {
	      page: 1,
	      limit: 5
	    };

	    this.dialogOpts = _dialog.DIALOG._opts('app/components/integrations/integrations.dialog.html', 'IntegrationsDialogController');

	    this.currentEnterprise = {
	      id: this.$state.params.id
	    };

	    this.loadData = this.loadData.bind(this);
	    this.usedSource = [];
	    this.loadData(1);
	  }

	  _createClass(EnterprisesIntegrationsController, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;

	      this.DialogService.openDialog(this.dialogOpts, { usedSource: this.usedSource }).then(function (data) {
	        _this.MainService.create(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this.currentEnterprise.id + '/integrations', data).promise.then(function () {
	          _this.loadData(1);
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { type: 'integrations' }).then(function () {
	        _this2.MainService.delete(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this2.currentEnterprise.id + '/integrations', item.id).promise.then(function () {
	          var currentPage = 1;
	          if (_this2.meta.page > 1) {
	            currentPage = _this2.items.length === 1 ? _this2.meta.page - 1 : _this2.meta.page;
	          }

	          _this2.loadData(currentPage);
	        });
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(item, index) {
	      var _this3 = this;

	      var obj = item;

	      this.DialogService.openDialog(this.dialogOpts, obj).then(function (data) {
	        _this3.MainService.update(_constants.API.V5, _constants.API.ENTERPRISES + '/' + _this3.currentEnterprise.id + '/integrations', item.id, data).promise.then(function (res) {
	          data = Object.assign(data, res.data);
	          _this3.items[index] = data;
	        });
	      });
	    }
	  }, {
	    key: 'translateIntegratedEntities',
	    value: function translateIntegratedEntities(values) {
	      var _this4 = this;

	      if (!angular.isArray(values) || values.length === 0) return '';
	      var teste = values.map(function (i) {
	        var key = 'INTEGRATIONS.ENUM.OPTIONS.INTEGRATIONS_ENTITIES.' + i.toUpperCase();
	        return _this4.$translate.instant(key);
	      });
	      return teste.join(', ');
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(page) {
	      var _this5 = this;

	      this.items = [];
	      this.loading = true;

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.id + '/integrations').promise.then(function (res) {
	        _this5.items = res.data;
	        _this5.meta.count = res.count;
	        _this5.meta.page = page;
	        _this5.usedSource = _this5.items.map(function (i) {
	          return i.attributes.source;
	        });
	      }).finally(function () {
	        _this5.loading = false;
	      });
	    }
	  }]);

	  return EnterprisesIntegrationsController;
	}();

	exports.default = EnterprisesIntegrationsController;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewEnterpriseBehaviorConfigController = function () {
	  NewEnterpriseBehaviorConfigController.$inject = ["$mdDialog", "DialogService", "locals"];
	  function NewEnterpriseBehaviorConfigController($mdDialog, DialogService, locals) {
	    'ngInject';

	    _classCallCheck(this, NewEnterpriseBehaviorConfigController);

	    this.$mdDialog = $mdDialog;
	    this.DialogService = DialogService;
	    this.locals = locals;

	    this.behavior = angular.copy(this.locals.item);
	  }

	  _createClass(NewEnterpriseBehaviorConfigController, [{
	    key: 'save',
	    value: function save() {
	      var behavior = {
	        data: {
	          attributes: {
	            name: this.behavior.attributes.name,
	            speed_max: this.behavior.attributes.speed_max,
	            voltage_min: this.behavior.attributes.voltage_min,
	            battery_level_min: this.behavior.attributes.battery_level_min
	          }
	        }
	      };

	      this.$mdDialog.hide(behavior);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewEnterpriseBehaviorConfigController;
	}();

	exports.default = NewEnterpriseBehaviorConfigController;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AddressFormController = function () {
	  AddressFormController.$inject = ["$mdDialog", "GeocodingService", "locals"];
	  function AddressFormController($mdDialog, GeocodingService, locals) {
	    'ngInject';

	    _classCallCheck(this, AddressFormController);

	    this.$mdDialog = $mdDialog;
	    this.GeocodingService = GeocodingService;
	    this.locals = locals;

	    this.currentAddress = angular.copy(this.locals.item);

	    if (this.currentAddress.attributes.coords && this.currentAddress.attributes.coords.coordinates) {
	      this.currentAddress.attributes.coords = this.currentAddress.attributes.coords.coordinates;
	    }

	    this.action = this.currentAddress && angular.isDefined(this.currentAddress.action) ? this.currentAddress.action : 'save';

	    this.checkAndDefineType();
	  }

	  _createClass(AddressFormController, [{
	    key: 'checkAndDefineType',
	    value: function checkAndDefineType() {
	      if (this.currentAddress.attributes.model && this.currentAddress.attributes.model !== 'tasks') {
	        this.types = _constants.ADDRESSES_TYPE[this.currentAddress.attributes.model.toUpperCase()];
	        this.currentAddress.attributes.type = this.currentAddress.attributes.type || this.types[0];
	      }
	    }
	  }, {
	    key: 'formatItem',
	    value: function formatItem(item) {
	      var data = {};
	      data.coords = [item[0].geometry.location.lat, item[0].geometry.location.lng];

	      var _loop = function _loop(key) {
	        var component = item[0].address_components.find(function (ac) {
	          return ac.types.includes(_constants.ADDRESSES_KEYS[key].key);
	        });
	        data[key] = component ? component.long_name : null;
	        if (_constants.ADDRESSES_KEYS[key].shortKey && component.short_name) data[_constants.ADDRESSES_KEYS[key].shortKey] = component ? component.short_name : null;
	      };

	      for (var key in _constants.ADDRESSES_KEYS) {
	        _loop(key);
	      }
	      return data;
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress() {
	      var _this = this;

	      var pattern = /^\d{5}-?\d{3}$|^\d{5}$|^[A-Z]\d{4}([A-Z]{3})?$|^\d{7}$|^\d{4}$|^\d{6}$/;
	      if (!pattern.test(this.currentAddress.attributes.zip_code)) {
	        return;
	      }
	      this.loading = true;

	      return this.GeocodingService.getPlaces(this.currentAddress.attributes.zip_code).promise.then(function (res) {
	        if (!res.length) {
	          return;
	        }
	        var address = _this.formatItem(res);
	        _this.currentAddress.attributes = Object.assign({}, _this.currentAddress.attributes, address);
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save(item) {
	      var _this2 = this;

	      var region = item.attributes.zip_code ? item.attributes.region_short : item.attributes.region;

	      var formattedAddress = [item.attributes.street, item.attributes.street_number, item.attributes.complement, item.attributes.city, region, item.attributes.zip_code, item.attributes.country].filter(function (v) {
	        return v;
	      }).join(', ');

	      var obj = {
	        data: {
	          attributes: {
	            type: item.attributes && item.attributes.type ? item.attributes.type : '',
	            coords: item.attributes.coords,
	            formatted_address: formattedAddress,
	            street_number: item.attributes.street_number,
	            street: item.attributes.street,
	            complement: item.attributes.complement,
	            city: item.attributes.city,
	            region: item.attributes.region,
	            region_short: item.attributes.region_short,
	            country: item.attributes.country,
	            country_code: item.attributes.country_code,
	            zip_code: item.attributes.zip_code,
	            description: item.attributes.description
	          }
	        }
	      };

	      this.GeocodingService.getPlaces(formattedAddress).promise.then(function (res) {
	        if (res.length > 0) {
	          obj.data.attributes.coords = [res[0].geometry.location.lat, res[0].geometry.location.lng];
	        }
	      }).finally(function () {
	        (0, _helper.cleanPayload)(obj.data, true);
	        _this2.$mdDialog.hide(obj);
	      });
	    }
	  }]);

	  return AddressFormController;
	}();

	exports.default = AddressFormController;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TemplateFormController = function () {
	  TemplateFormController.$inject = ["$mdDialog", "locals"];
	  function TemplateFormController($mdDialog, locals) {
	    'ngInject';

	    _classCallCheck(this, TemplateFormController);

	    this.$mdDialog = $mdDialog;
	    this.locals = angular.copy(locals);

	    this.currentAttr = this.locals.item;
	    this.contentText = '';
	    this.maxCharacters = 12000;
	  }

	  _createClass(TemplateFormController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save(item) {
	      var obj = {
	        data: item
	      };

	      (0, _helper.cleanPayload)(obj.data);
	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TemplateFormController;
	}();

	exports.default = TemplateFormController;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AlertsNotificationService = function () {
	  AlertsNotificationService.$inject = ["$http", "$q", "EnvironmentConfig"];
	  function AlertsNotificationService($http, $q, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, AlertsNotificationService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(AlertsNotificationService, [{
	    key: 'getAlertsConfig',
	    value: function getAlertsConfig(euuid) {
	      var _this = this;

	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.ENTERPRISES, euuid, 'configuration', _constants.API.ALERTS].join('/'), method: 'GET' }).then(function (res) {
	        _this.formatConfig(res.data.data.config);
	        deferred.resolve(res.data.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'updateAlertsConfig',
	    value: function updateAlertsConfig(euuid, inherit, config) {
	      var _this2 = this;

	      var deferred = this.$q.defer();
	      config = config.map(function (configAlert) {
	        configAlert = Object.assign({}, configAlert);
	        if (configAlert.recipients) {
	          configAlert.recipients = Object.entries(configAlert.recipients).reduce(function (acc, _ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                recipient = _ref2[0],
	                enable = _ref2[1];

	            if (enable) {
	              acc.push(recipient);
	            }
	            return acc;
	          }, []);
	        }
	        return configAlert;
	      });
	      var data = { data: { inherit: inherit, config: config } };
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.ENTERPRISES, euuid, 'configuration', _constants.API.ALERTS].join('/'), method: 'PUT', data: data }).then(function (res) {
	        _this2.formatConfig(res.data.data.config);
	        deferred.resolve(res.data.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });
	      return deferred;
	    }
	  }, {
	    key: 'formatConfig',
	    value: function formatConfig(config) {
	      config.forEach(function (config) {
	        if (config.recipients) {
	          config.recipients = config.recipients.reduce(function (acc, recipient) {
	            acc[recipient] = true;
	            return acc;
	          }, {});
	        }
	      });
	    }
	  }]);

	  return AlertsNotificationService;
	}();

	exports.default = AlertsNotificationService;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TaskResourcesController = function () {
	  TaskResourcesController.$inject = ["$mdDialog", "$state", "locals"];
	  function TaskResourcesController($mdDialog, $state, locals) {
	    'ngInject';

	    _classCallCheck(this, TaskResourcesController);

	    this.$mdDialog = $mdDialog;
	    this.$state = $state;

	    this.localsItem = angular.copy(locals.item);
	  }

	  _createClass(TaskResourcesController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var obj = {
	        data: {
	          attributes: {
	            name: this.localsItem.attributes.name
	          }
	        }
	      };

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return TaskResourcesController;
	}();

	exports.default = TaskResourcesController;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _queryOptions = __webpack_require__(236);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CustomFiltersDialogController = function () {
	  CustomFiltersDialogController.$inject = ["$mdDialog", "$timeout", "locals"];
	  function CustomFiltersDialogController($mdDialog, $timeout, locals) {
	    'ngInject';

	    _classCallCheck(this, CustomFiltersDialogController);

	    this.$mdDialog = $mdDialog;
	    this.$timeout = $timeout;
	    this.attr = angular.copy(locals.item);

	    this.selectedFilters = {};
	    this.selectDisabled = angular.isDefined(this.attr);
	    var allowed = ['vehicles', 'users', 'devices', 'chips', 'protocols', 'enterprises', 'service-orders'];
	    this.pages = Object.keys(_queryOptions.FILTERS).filter(function (p) {
	      return allowed.includes(p);
	    });

	    if (this.attr) {
	      this.name = this.attr.name;
	      this.selectedPage = this.attr.model;
	      this.model = this.attr.model;
	      this.selectedFilters = angular.fromJson(this.attr.filter);
	    }
	  }

	  _createClass(CustomFiltersDialogController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'selectPage',
	    value: function selectPage() {
	      var _this = this;

	      this.model = '';
	      this.$timeout(function () {
	        _this.model = _this.selectedPage;
	        _this.selectedFilters = {};
	      }, 50);
	    }
	  }, {
	    key: 'save',
	    value: function save(filter) {
	      if (!this.form.$valid) {
	        this.form.$setSubmitted();
	        return;
	      }

	      var obj = {
	        data: {
	          attributes: {
	            name: this.name,
	            filter: angular.toJson(filter)
	          }
	        }
	      };

	      if (angular.isUndefined(this.attr)) {
	        Object.assign(obj.data.attributes, { model: this.selectedPage });
	      }

	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return CustomFiltersDialogController;
	}();

	exports.default = CustomFiltersDialogController;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FILTERS_OPERATORS = exports.FILTERS = undefined;

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var FILTERS = exports.FILTERS = {
	  vehicles: [{
	    key: 'asset_vehicles.plate',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'asset_vehicles.vin',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'asset_vehicles.registration_number',
	    type: 'string'
	  }, {
	    key: 'asset_vehicles.brand_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset_vehicles.batch',
	    type: 'string'
	  }, {
	    key: 'asset_vehicles.code',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset_vehicles.type_name',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    })))
	  }, {
	    key: 'asset_vehicles.model_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset_vehicles.year',
	    type: 'string'
	  }, {
	    key: 'asset_vehicles.deactivated_at',
	    type: 'shortdate'
	  }, {
	    key: 'asset_vehicles.enterprise_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset_vehicles.user_names',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset_vehicles.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'asset_vehicles.last_integration_source',
	    type: 'string'
	  }, {
	    key: 'asset_vehicles.last_integration_time',
	    type: 'shortdate'
	  }, {
	    key: 'devices.name',
	    type: 'string'
	  }, {
	    key: 'devices.imei',
	    type: 'string'
	  }, {
	    key: 'devices.code',
	    type: 'string'
	  }],
	  users: [{
	    key: 'users.username',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'users.email',
	    type: 'string',
	    search: true
	  }, {
	    key: 'users.name',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'users.phone1',
	    type: 'string'
	  }, {
	    key: 'users.phone2',
	    type: 'string'
	  }, {
	    key: 'users.last_login_at',
	    type: 'shortdate'
	  }, {
	    key: 'users.document_number',
	    type: 'string'
	  }, {
	    key: 'users.cpf',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'users.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'users.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'users.deactivated_at',
	    type: 'shortdate'
	  }, {
	    key: 'users.last_integration_source',
	    type: 'string'
	  }, {
	    key: 'users.last_integration_time',
	    type: 'shortdate'
	  }, {
	    key: 'enterprise.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'enterprise.cnpj',
	    type: 'string'
	  }, {
	    key: 'roles.name',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.CLIENT), _toConsumableArray(_constants.ROLES.READ_ONLY), _toConsumableArray(_constants.ROLES.OPERATOR), _toConsumableArray(_constants.ROLES.PROVIDER))
	  }, {
	    key: 'addresses.formatted_address',
	    type: 'string'
	  }, {
	    key: 'addresses.city',
	    type: 'string'
	  }, {
	    key: 'addresses.zip_code',
	    type: 'string'
	  }],
	  devices: [{
	    key: 'devices.name',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'devices.imei',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'devices.batch',
	    type: 'string'
	  }, {
	    key: 'devices.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'devices.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'devices.last_integration_source',
	    type: 'string'
	  }, {
	    key: 'devices.last_integration_time',
	    type: 'shortdate'
	  }, {
	    key: 'devices.code',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'chip.serial',
	    type: 'string',
	    search: true
	  }, {
	    key: 'chip.number',
	    type: 'string',
	    search: true
	  }, {
	    key: 'chip.service_provider',
	    type: 'string'
	  }, {
	    key: 'chip.carrier',
	    type: 'string'
	  }, {
	    key: 'devices.active',
	    type: 'boolean',
	    options: [].concat(_toConsumableArray(_constants.DEVICE_STATUS))
	  }, {
	    key: 'type.alias',
	    type: 'string'
	  }, {
	    key: 'type.brand_alias',
	    type: 'string',
	    search: true
	  }, {
	    key: 'enterprise.name',
	    type: 'string'
	  }, {
	    key: 'last_gps.last_connection_time',
	    type: 'date',
	    utc: true
	  }, {
	    key: 'last_gps.last_gps_time',
	    type: 'date',
	    utc: true
	  }, {
	    key: 'last_gps.last_battery_level',
	    type: 'number'
	  }, {
	    key: 'last_gps.last_backup_battery_voltage',
	    type: 'number'
	  }, {
	    key: 'last_gps.last_power_voltage',
	    type: 'number'
	  }, {
	    key: 'vehicle.plate',
	    type: 'string',
	    search: true
	  }, {
	    key: 'vehicle.vin',
	    type: 'string'
	  }, {
	    key: 'vehicle.code',
	    type: 'string'
	  }, {
	    key: 'users.user_names',
	    type: 'string'
	  }, {
	    key: 'users.user_phones',
	    type: 'string'
	  }],
	  chips: [{
	    key: 'chips.serial',
	    type: 'string',
	    massive: true,
	    search: true

	  }, {
	    key: 'chips.number',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'chips.batch',
	    type: 'string'
	  }, {
	    key: 'chips.carrier',
	    type: 'string',
	    search: true
	  }, {
	    key: 'chips.service_provider',
	    type: 'string',
	    search: true
	  }, {
	    key: 'chips.from_softruck',
	    type: 'boolean',
	    options: [].concat(_toConsumableArray(_constants.ONWERSHIP))
	  }, {
	    key: 'chips.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'chips.last_integration_source',
	    type: 'string'
	  }, {
	    key: 'chips.last_integration_time',
	    type: 'shortdate'
	  }, {
	    key: 'device.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'device.imei',
	    type: 'string'
	  }, {
	    key: 'device.code',
	    type: 'string'
	  }, {
	    key: 'enterprise.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'enterprise.cnpj',
	    type: 'string'
	  }],
	  enterprises: [{
	    key: 'enterprises.name',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'enterprises.phone1',
	    type: 'string'
	  }, {
	    key: 'enterprises.phone2',
	    type: 'string'
	  }, {
	    key: 'enterprises.email',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'enterprises.contact_name',
	    type: 'string'
	  }, {
	    key: 'enterprises.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'enterprises.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'enterprises.cnpj',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'enterprises.assistance_emergency_tel',
	    type: 'string'
	  }, {
	    key: 'enterprises.theft_emergency_tel',
	    type: 'string'
	  }, {
	    key: 'enterprises.deactivated_at',
	    type: 'shortdate'
	  }, {
	    key: 'addresses.formatted_address',
	    type: 'string'
	  }, {
	    key: 'addresses.city',
	    type: 'string'
	  }, {
	    key: 'addresses.zip_code',
	    type: 'string'
	  }],
	  trajectories: [{
	    key: 'acc',
	    type: 'shortdate'
	  }, {
	    key: 'vDis',
	    type: 'number'
	  }, {
	    key: 'alCnt',
	    type: 'number'
	  }, {
	    key: 'dur',
	    type: 'number'
	  }, {
	    key: 'gpsCnt',
	    type: 'number'
	  }, {
	    key: 'hisDur',
	    type: 'number'
	  }, {
	    key: 'sgCnt',
	    type: 'number'
	  }, {
	    key: 'spAvg',
	    type: 'number'
	  }, {
	    key: 'spMax',
	    type: 'number'
	  }, {
	    key: 'stCnt',
	    type: 'number'
	  }, {
	    key: 'stDur',
	    type: 'number'
	  }],
	  'service-orders': [{
	    key: 'task_main_service_orders.token',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'task_main_service_orders.section_name',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.priority',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.TASK_PRIORITIES))
	  }, {
	    key: 'task_main_service_orders.due_date',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_service_orders.type_name',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.addresses',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_service_orders.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_service_orders.enterprise_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_service_orders.enterprise_cnpj',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.asset_plate',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_service_orders.asset_type',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    })))
	  }, {
	    key: 'task_main_service_orders.asset_brand',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.asset_model',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.asset_year',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.asset_trim',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.assignee_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_service_orders.completed_by_name',
	    type: 'string'
	  }, {
	    key: 'task_main_service_orders.completed_at',
	    type: 'date'
	  }],
	  protocols: [{
	    key: 'task_main_protocols.token',
	    type: 'string',
	    massive: true,
	    search: true
	  }, {
	    key: 'task_main_protocols.section_name',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.priority',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.TASK_PRIORITIES))
	  }, {
	    key: 'task_main_protocols.due_date',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_protocols.type_name',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.addresses',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_protocols.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'task_main_protocols.enterprise_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_protocols.enterprise_cnpj',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.asset_plate',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_protocols.asset_type',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    })))
	  }, {
	    key: 'task_main_protocols.asset_brand',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.asset_model',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.asset_year',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.asset_trim',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.assignee_name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'task_main_protocols.completed_by_name',
	    type: 'string'
	  }, {
	    key: 'task_main_protocols.completed_at',
	    type: 'date'
	  }],
	  sharings: [{
	    key: 'sharings_v4.hash',
	    type: 'string',
	    search: true
	  }, {
	    key: 'sharings_v4.type',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.SHARINGS_TYPES))
	  }, {
	    key: 'sharings_v4.valid_until',
	    type: 'shortdate'
	  }, {
	    key: 'sharings_v4.description',
	    type: 'string'
	  }, {
	    key: 'sharings_v4.source',
	    type: 'string',
	    options: [].concat(_toConsumableArray(_constants.SHARINGS_SOURCES))
	  }, {
	    key: 'sharings_v4.deactivated_at',
	    type: 'shortdate'
	  }, {
	    key: 'sharings_v4.created_at',
	    type: 'shortdate'
	  }, {
	    key: 'sharings_v4.updated_at',
	    type: 'shortdate'
	  }, {
	    key: 'creator.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'creator.email',
	    type: 'string'
	  }, {
	    key: 'enterprise.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'enterprise.cnpj',
	    type: 'string'
	  }, {
	    key: 'enterprise.email',
	    type: 'string'
	  }, {
	    key: 'device.name',
	    type: 'string',
	    search: true
	  }, {
	    key: 'device.imei',
	    type: 'string'
	  }, {
	    key: 'device.code',
	    type: 'string'
	  }, {
	    key: 'asset.plate',
	    type: 'string',
	    search: true
	  }, {
	    key: 'asset.vin',
	    type: 'string'
	  }, {
	    key: 'asset.brand_name',
	    type: 'string'
	  }, {
	    key: 'asset.model_name',
	    type: 'string'
	  }, {
	    key: 'asset.type_name',
	    type: 'string'
	  }, {
	    key: 'asset.trim_name',
	    type: 'string'
	  }],
	  'operation-logs': [{
	    key: 'model',
	    type: 'enum',
	    options: [].concat(_toConsumableArray(_constants.LOGS))
	  }, {
	    key: 'operation_at',
	    type: 'shortdate'
	  }, {
	    key: 'operation_type',
	    type: 'boolean',
	    options: [].concat(_toConsumableArray(_constants.OPERATION))
	  }, {
	    key: 'enterprise.name',
	    type: 'string'
	  }, {
	    key: 'user.name',
	    type: 'string'
	  }, {
	    key: 'user.username',
	    type: 'string'
	  }]
	};

	var FILTERS_OPERATORS = exports.FILTERS_OPERATORS = {
	  string: ['eq', 'neq', 'ilk', 'ew', 'sw'],
	  number: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte', 'btw', 'nbtw'],
	  boolean: ['eq', 'neq'],
	  date: ['gt', 'gte', 'lt', 'lte', 'btw', 'nbtw'],
	  shortdate: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte', 'btw', 'nbtw'],
	  enum: ['in', 'nin']
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WebhooksController = function () {
	  WebhooksController.$inject = ["$mdDialog", "locals"];
	  function WebhooksController($mdDialog, locals) {
	    'ngInject';

	    _classCallCheck(this, WebhooksController);

	    this.$mdDialog = $mdDialog;
	    this.locals = locals;

	    this.currentWebhook = angular.copy(this.locals.item);
	  }

	  _createClass(WebhooksController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save(item) {
	      var obj = {
	        data: {
	          attributes: {
	            name: item.attributes.name,
	            url: item.attributes.url
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(obj.data);
	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return WebhooksController;
	}();

	exports.default = WebhooksController;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PublicKeysController = function () {
	  PublicKeysController.$inject = ["$mdDialog", "locals"];
	  function PublicKeysController($mdDialog, locals) {
	    'ngInject';

	    _classCallCheck(this, PublicKeysController);

	    this.$mdDialog = $mdDialog;
	    this.locals = locals;

	    this.currentPublicKey = angular.copy(this.locals.item);
	  }

	  _createClass(PublicKeysController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'save',
	    value: function save(item) {
	      var obj = {
	        data: {
	          attributes: {
	            name: item.attributes.name
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(obj.data);
	      this.$mdDialog.hide(obj);
	    }
	  }]);

	  return PublicKeysController;
	}();

	exports.default = PublicKeysController;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(240);

	__webpack_require__(242);

	angular.module('phoenix.internal.reports', ['ui.router', 'phoenix.internal.reports.boundary', 'phoenix.internal.reports.diagnosis']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'reports',
	    url: '/reports',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _boundary = __webpack_require__(241);

	var _boundary2 = _interopRequireDefault(_boundary);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.reports.boundary', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'boundary',
	    url: '/boundary',
	    parent: 'reports',
	    menu: true,
	    alias: 'boundary',
	    controller: _boundary2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/reports/boundary/boundary.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('BoundaryController', _boundary2.default);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // "MAPBOX": "pk.eyJ1IjoibWFyY2Vsb3NvZnRydWNrIiwiYSI6ImNsaDg2Z3lvYTAyNzUzZW82YjJ3eHY5N3YifQ.SasWJpeK6vXeMXlEwEXZrQ",


	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BoundaryController = function () {
	  BoundaryController.$inject = ["$scope", "$timeout", "$window", "GeocodingService", "GeoLocation", "MainService", "MapHelper", "TrajectoryService"];
	  function BoundaryController($scope, $timeout, $window, GeocodingService, GeoLocation, MainService, MapHelper, TrajectoryService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, BoundaryController);

	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.GeoLocation = GeoLocation;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	    this.MapHelper = MapHelper;
	    this.TrajectoryService = TrajectoryService;

	    this.trajectoriesData = false;
	    this.associationHistory = [];
	    this.controls = {
	      showInfo: true,
	      hasmoved: false,
	      requested: 0
	    };

	    this.query = {
	      attributes: ['*'],
	      includes: {
	        enterprise: ['name,email'],
	        vehicle: ['plate,vin'],
	        device: ['name,imei']
	      },
	      filters: {},
	      limit: 32,
	      page: 1
	    };

	    this.getGeoLocation();
	    this.$scope.$on('trajectoriesDataLoaded', function () {
	      _this.trajectoriesData = true;
	    });
	  }

	  _createClass(BoundaryController, [{
	    key: 'getGeoLocation',
	    value: function getGeoLocation() {
	      var _this2 = this;

	      this.coords = null;

	      var getGeoLocation = this.GeoLocation.getCoords();
	      getGeoLocation.then(function (res) {
	        _this2.coords = { center: [res.lng, res.lat] };
	      }).finally(function () {
	        _this2.buildMap();
	      });
	    }
	  }, {
	    key: 'buildMap',
	    value: function buildMap() {
	      var _this3 = this;

	      var mapOptions = Object.assign({}, _constants.behaveMapConfig, { zoom: 5, minZoom: 7, maxZoom: 14 }, this.coords);
	      var mapStyle = { layer: 'streets', version: 'v12' };

	      this.MapHelper.mapBuilder(mapStyle, mapOptions, _constants.controls);

	      this.MapHelper.map.once('load', function () {
	        _this3.MapHelper.map.on('moveend', function () {
	          _this3.updateBounds();
	        });
	      });
	    }
	  }, {
	    key: 'getVehicles',
	    value: function getVehicles(query) {
	      var obj = {
	        attributes: ['plate,vin,brand_name,trim_name,type_name,year'],
	        // includes: {
	        //   devices: ['name', 'imei', 'code']
	        // },
	        // filters: {
	        //   'devices.name': { operator: 'isn', value: null }
	        // },
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES, obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getPlaces',
	    value: function getPlaces(query) {
	      var obj = {
	        search: query,
	        format: 'jsonv2',
	        // polygonformat: 'geojson',
	        // polygonthreshold: 0.003,
	        limit: 5,
	        extratags: '0',
	        addressdetails: '1'
	      };

	      return this.GeocodingService.getAddressFromPlaces(obj).promise.then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'updateBounds',
	    value: function updateBounds() {
	      var _this4 = this;

	      var bounds = this.MapHelper.map.getBounds();
	      var bbox = [bounds._sw.lng, bounds._sw.lat, bounds._ne.lng, bounds._ne.lat];

	      this.$timeout(function () {
	        _this4.polygon = turf.bboxPolygon(bbox);
	        _this4.controls.hasmoved = true;
	      }, 100);
	    }
	  }, {
	    key: 'toLocation',
	    value: function toLocation() {
	      if (!this.selectedPlace) {
	        return;
	      }

	      this.MapHelper.map.jumpTo({ center: [this.selectedPlace.lon, this.selectedPlace.lat], zoom: 14 });
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter() {
	      this.report.from_date === this.report.to_date ? this.query.filters.acc = { operator: 'eq', value: '' + this.report.from_date } : this.query.filters.acc = { operator: 'btw', value: this.report.from_date + ',' + this.report.to_date };

	      if (this.polygon) {
	        this.query.filters.ls = { operator: 'geoIntersects', value: angular.toJson([].concat(_toConsumableArray(this.polygon.geometry.coordinates))) };
	      } else {
	        delete this.query.filters.ls;
	      }

	      if (this.selectedVehicle) {
	        this.query.filters.did = { operator: 'eq', value: this.selectedAssociation.relationships.device.id };
	        this.query.filters.vid = { operator: 'eq', value: this.selectedVehicle.id };
	      } else {
	        delete this.query.filters.vid;
	        delete this.query.filters.did;
	      }
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var _this5 = this;

	      this.loading = true;
	      this.trajectories = [];
	      this.applyFilter();
	      this.MainService.raw(_constants.API.V5, _constants.API.TRAJECTORIES, this.query).promise.then(function (res) {
	        _this5.controls.requested++;
	        _this5.controls.hasmoved = false;
	        _this5.loading = false;
	        _this5.trajectories = res.data;
	        if (_this5.trajectories.length > 0) {
	          _this5.TrajectoryService.build({ acc: _this5.trajectories.map(function (t) {
	              return t.attributes.acc;
	            }).toString(), did: _this5.selectedAssociation.relationships.device.id, eid: _this5.selectedAssociation.relationships.enterprise.id, vid: _this5.selectedAssociation.relationships.vehicle.id, fit: true, att: ['SEGMENT,DETAILED,ALARM,STOP'] });
	        }
	        _this5.TrajectoryService.layersVisibility(_this5.trajectories.length > 0);
	      }).catch(function () {
	        _this5.loading = false;
	      });
	    }
	  }, {
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(page) {
	      var _this6 = this;

	      this.loadingAssociationHistory = true;
	      this.associationHistory = [];
	      var obj = {
	        includes: {
	          device: ['name', 'imei', 'deleted_at'],
	          enterprise: ['name', 'cnpj'],
	          vehicle: ['plate', 'vin']
	        },
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: page,
	        count: true,
	        limit: 10
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + this.selectedVehicle.id + '/associations/devices', obj).promise.then(function (res) {
	        _this6.loadingAssociationHistory = false;
	        _this6.associationHistory = res.data;
	      }).catch(function () {
	        _this6.loadingAssociationHistory = false;
	      });
	    }
	  }, {
	    key: 'focusOnPath',
	    value: function focusOnPath() {
	      this.transformSeg();
	      this.highlight();
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight() {
	      this.TrajectoryService.highlightPath(this.ranges);
	      this.TrajectoryService.highlightMark(this.ranges);
	    }
	  }, {
	    key: 'transformSeg',
	    value: function transformSeg() {
	      this.ranges = this.trajectories.map(function (t) {
	        return t.attributes.segs.filter(function (seg) {
	          return seg.checked;
	        }).map(function (seg) {
	          return {
	            start: new Date(seg.sta.act) / 1000,
	            end: new Date(seg.end.act) / 1000
	          };
	        });
	      }).filter(function (t) {
	        return t.length > 0;
	      }).flat(2);
	    }
	  }, {
	    key: 'openSideNav',
	    value: function openSideNav() {
	      if (!this.selectedVehicle) {
	        return;
	      }

	      this.limits = internals._initialLimits;
	      this.report = internals._initialReport;
	      this.loadAssociationHistory(1);
	      this.controls.showInfo = true;
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.TrajectoryService.cleanData();
	      this.trajectories = null;
	      this.report.from_date = null;
	      this.report.to_date = null;

	      if (this.selectedAssociation) {
	        this.defineLimits(this.selectedAssociation);
	      }
	    }
	  }, {
	    key: 'defineLimits',
	    value: function defineLimits(item) {
	      this.selectedAssociation = item;

	      var formatDate = 'HH:mm:ss YYYY-MM-DD';
	      var formatDateModel = 'yyyy-MM-DD';
	      var deletedAt = item.attributes.deleted_at ? moment(item.attributes.deleted_at) : moment();
	      var createdAt = moment(item.attributes.created_at);

	      this.limits = {
	        max: deletedAt.endOf('d').format(formatDate),
	        min: createdAt.startOf('d').format(formatDate)
	      };
	      this.report = {
	        from_date: createdAt.format(formatDateModel),
	        to_date: deletedAt.diff(createdAt, 'days') < 30 ? deletedAt.format(formatDateModel) : createdAt.add(30, 'days').format(formatDateModel)
	      };
	    }
	  }, {
	    key: 'validationDate',
	    value: function validationDate() {
	      this.form.to_date.$setValidity('interval', (0, _helper.validationMaxReportInterval)(this.report.from_date, this.report.to_date, 'month'));
	      this.form.to_date.$setValidity('finalBiggerInitial', (0, _helper.finalBiggerInitial)(this.report.from_date, this.report.to_date));
	    }
	  }]);

	  return BoundaryController;
	}();

	exports.default = BoundaryController;


	var internals = {
	  _initialLimits: function _initialLimits() {
	    return {
	      limits: {
	        max: null,
	        min: null
	      }
	    };
	  },
	  _initialReport: function _initialReport() {
	    return {
	      report: {
	        from_date: null,
	        to_date: null
	      }
	    };
	  }
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _diagnosis = __webpack_require__(243);

	var _diagnosis2 = _interopRequireDefault(_diagnosis);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.reports.diagnosis', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'diagnosis',
	    url: '/diagnosis',
	    parent: 'reports',
	    menu: true,
	    alias: 'diagnosis',
	    controller: _diagnosis2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/reports/diagnosis/diagnosis.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY))
	    }
	  });
	}]).controller('DiagnosisController', _diagnosis2.default);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global c3 */


	var _constants = __webpack_require__(9);

	var _formatNumber = __webpack_require__(100);

	var _formatNumber2 = _interopRequireDefault(_formatNumber);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DiagnosisController = function () {
	  DiagnosisController.$inject = ["$translate", "$window", "MainService"];
	  function DiagnosisController($translate, $window, MainService) {
	    'ngInject';

	    _classCallCheck(this, DiagnosisController);

	    this.$translate = $translate;
	    this.$window = $window;
	    this.MainService = MainService;

	    this.selected = {
	      data1: null,
	      data2: null
	    };

	    this.dataMap = internals.map;

	    this.selectedDevice = [];
	    this.meta = {
	      page: 1,
	      limit: 3
	    };

	    this.diagnosis = {};
	    this.obj = {
	      includes: {
	        device: ['name', 'imei', 'deleted_at'],
	        enterprise: ['name', 'cnpj']
	      },
	      sort: {
	        prop: 'created_at',
	        order: 'DESC'
	      },
	      page: this.meta.page,
	      count: true,
	      limit: this.meta.limit
	    };

	    this.loadAssociationHistory = this.loadAssociationHistory.bind(this);
	    this.defineValidations = this.defineValidations.bind(this);
	  }

	  _createClass(DiagnosisController, [{
	    key: 'loadAssociationHistory',
	    value: function loadAssociationHistory(page) {
	      var _this = this;

	      var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	      if (angular.isObject(res)) {
	        this.selectedVehicle = res;
	      }
	      if (!this.selectedVehicle) {
	        return;
	      }
	      this.loading = true;
	      this.obj.page = page;

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + this.selectedVehicle.id + '/associations/devices', this.obj).promise.then(function (res) {
	        _this.loading = false;
	        _this.meta.count = res.count;
	        _this.meta.page = page;
	        _this.items = res.data;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'defineValidations',
	    value: function defineValidations() {
	      var formatDate = 'yyyy-MM-DDTHH:mm:ss';
	      var deletedAt = this.selectedDevice[0].attributes.deleted_at === null ? moment().subtract(1, 'second') : moment(this.selectedDevice[0].attributes.deleted_at);
	      var createdAt = moment(this.selectedDevice[0].attributes.created_at);

	      this.diagnosis.from_date = createdAt.add(1, 'second').format(formatDate);
	      this.diagnosis.min_date = createdAt.format(formatDate);
	      this.diagnosis.to_date = deletedAt.diff(createdAt, 'days') < 30 ? deletedAt.format(formatDate) : createdAt.add(30, 'days').format(formatDate);
	      this.diagnosis.max_date = deletedAt.add(1, 'second').format(formatDate);
	    }
	  }, {
	    key: 'updatePeriod',
	    value: function updatePeriod() {
	      this.form.to_date.$setValidity('interval', (0, _helper.validationMaxReportInterval)(this.diagnosis.from_date, this.diagnosis.to_date, 'month'));
	      this.form.to_date.$setValidity('finalBiggerInitial', (0, _helper.finalBiggerInitial)(this.diagnosis.from_date, this.diagnosis.to_date));
	    }
	  }, {
	    key: 'searchAsyncReport',
	    value: function searchAsyncReport() {
	      var _this2 = this;

	      var device = this.selectedDevice[0].relationships.device;

	      var obj = {
	        data: {
	          vehicle_uuid: this.selectedVehicle.uuid,
	          from_date: this.diagnosis.from_date,
	          to_date: this.diagnosis.to_date,
	          type: 'RAW'
	        }
	      };

	      this.MainService.create(_constants.API.V4, _constants.API.DEVICES + '/' + device.uuid + '/reports/points', obj).promise.then(function (res) {
	        _this2.data = res.data;
	        _this2.report = {
	          data: [['dates'].concat(_toConsumableArray(_this2.data.report_data.act)), ['data1', []], ['data2', []]]
	        };

	        _this2.graph = _this2.timeseriesMultiDataGraph();
	      });
	    }
	  }, {
	    key: 'onSelectDataType',
	    value: function onSelectDataType(data, type) {
	      if (!this.data.report_data[type]) return;
	      this.graph.load({
	        columns: [[data].concat(_toConsumableArray(this.data.report_data[type]))]
	      });
	      this.graph.data.names({
	        data1: this.selected.data1 ? this.dataMap[this.selected.data1].name : 'data1',
	        data2: this.selected.data2 ? this.dataMap[this.selected.data2].name : 'data2'
	      });
	    }
	  }, {
	    key: 'formattedLabel',
	    value: function formattedLabel(d, selected) {
	      var type = selected ? this.dataMap[selected].format : 'number';
	      if (type === 'boolean') {
	        var res = (0, _formatNumber2.default)(d, type);
	        return '' + this.$translate.instant('DIAGNOSIS.ENUM.TYPE_BOOLEAN.' + res.toString().toUpperCase());
	      }
	      return (0, _formatNumber2.default)(d, type);
	    }
	  }, {
	    key: 'timeseriesMultiDataGraph',
	    value: function timeseriesMultiDataGraph() {
	      var _this3 = this;

	      return c3.generate({
	        bindto: '#diagnosis-report',
	        data: {
	          x: 'dates',
	          columns: this.report.data,
	          types: {
	            data1: 'area',
	            data2: 'line'
	          },
	          empty: {
	            label: {
	              text: 'No data'
	            }
	          }
	        },
	        color: {
	          pattern: ['#D5D5D5', '#E04D01']
	        },
	        legend: {
	          show: true
	        },
	        size: {
	          height: 300
	        },
	        bar: {
	          width: {
	            ratio: 0.8
	          }
	        },
	        point: {
	          show: true,
	          r: 1
	        },
	        grid: {
	          y: {
	            show: true
	          },
	          x: {
	            show: false
	          }
	        },
	        zoom: {
	          enabled: true
	        },
	        interaction: {
	          enabled: true
	        },
	        subchart: {
	          show: true,
	          size: {
	            height: 60
	          }
	        },
	        tooltip: {
	          show: true,
	          format: {
	            title: function title(d) {
	              return moment(d * 1000).format('HH:mm:ss DD/MM/YYYY');
	            }
	          }
	        },
	        axis: {
	          y: {
	            show: true,
	            min: 0,
	            inner: true,
	            tick: {
	              outer: false,
	              count: 5,
	              format: function format(d) {
	                return _this3.formattedLabel(d, _this3.selected.data1);
	              }
	            },
	            padding: {
	              top: 10,
	              bottom: 0
	            }
	          },
	          y2: {
	            show: true,
	            min: 0,
	            inner: true,
	            tick: {
	              outer: false,
	              count: 5,
	              format: function format(d) {
	                return _this3.formattedLabel(d, _this3.selected.data2);
	              }
	            },
	            padding: {
	              top: 10,
	              bottom: 0
	            }
	          },
	          x: {
	            show: true,
	            label: 'Dias',
	            type: 'timeseries',
	            tick: {
	              count: 5,
	              format: function format(d) {
	                return moment(d * 1000).format('DD/MM/YYYY');
	              }
	            }
	          }
	        }
	      });
	    }
	  }]);

	  return DiagnosisController;
	}();

	exports.default = DiagnosisController;


	var internals = {
	  map: {
	    alt: {
	      format: 'distance',
	      name: 'alt'
	    },
	    bbv: {
	      format: 'voltage',
	      name: 'bbv'
	    },
	    bl: {
	      format: 'percentage',
	      name: 'bl'
	    },
	    dir: {
	      format: 'number',
	      name: 'dir'
	    },
	    dis: {
	      format: 'distance',
	      name: 'dis'
	    },
	    gsm: {
	      format: 'number',
	      name: 'gsm'
	    },
	    hmt: {
	      format: 'time',
	      name: 'hmt'
	    },
	    i1: {
	      format: 'number',
	      name: 'i1'
	    },
	    i2: {
	      format: 'number',
	      name: 'i2'
	    },
	    i3: {
	      format: 'number',
	      name: 'i3'
	    },
	    ign: {
	      format: 'boolean',
	      name: 'ign'
	    },
	    o1: {
	      format: 'number',
	      name: 'o1'
	    },
	    o2: {
	      format: 'number',
	      name: 'o2'
	    },
	    pv: {
	      format: 'milivoltage',
	      name: 'pv'
	    },
	    rfid: {
	      format: 'data',
	      name: 'rfid'
	    },
	    sc: {
	      format: 'number',
	      name: 'sc'
	    },
	    spd: {
	      format: 'speed',
	      name: 'spd'
	    },
	    vl: {
	      format: 'number',
	      name: 'vl'
	    }
	  }
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(245);

	angular.module('phoenix.internal.settings', ['ui.router', 'phoenix.internal.settings.user-notification']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'settings',
	    url: '/settings',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _userNotificationShow = __webpack_require__(246);

	var _userNotificationShow2 = _interopRequireDefault(_userNotificationShow);

	var _userNotification = __webpack_require__(247);

	var _userNotification2 = _interopRequireDefault(_userNotification);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.settings.user-notification', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'user-notification',
	    url: '/user-notification',
	    parent: 'settings',
	    menu: false,
	    alias: 'user-notification',
	    controller: _userNotificationShow2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/settings/user-notification/show/user-notification.show.html',
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.CLIENT))
	    }
	  });
	}]).controller('UserNotificationController', _userNotificationShow2.default).service('UserNotificationService', _userNotification2.default);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserNotificationController = function () {
	  UserNotificationController.$inject = ["$window", "UserNotificationService"];
	  function UserNotificationController($window, UserNotificationService) {
	    'ngInject';

	    _classCallCheck(this, UserNotificationController);

	    this.$window = $window;

	    this.UserNotificationService = UserNotificationService;

	    this.user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.role = this.$window.localStorage.getItem('role');
	    this.deviceToken = this.$window.localStorage.getItem('notification_dtk');
	    this.permissionGranted = this.UserNotificationService.isAlreadySubscribed();

	    this.isUserAdmin = [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER)).includes(this.role);
	    if (this.permissionGranted && this.deviceToken) {
	      this.enableConfiguration = true;
	      this.loadData(this.deviceToken);
	    } else {
	      this.enableConfiguration = false;
	    }
	  }

	  _createClass(UserNotificationController, [{
	    key: 'loadData',
	    value: function loadData(deviceToken) {
	      var _this = this;

	      this.UserNotificationService.getAlertsConfig(this.user.uuid, deviceToken).promise.then(function (res) {
	        _this.alertsConfig = Object.assign({}, _this._checkAvailability(res));
	      });
	    }
	  }, {
	    key: 'subscribeNotification',
	    value: function subscribeNotification() {
	      var _this2 = this;

	      this.processingNotificationsPermission = true;
	      if (this.enableConfiguration) {
	        this.UserNotificationService.subscribeNotification().promise.then(function (deviceToken) {
	          _this2.deviceToken = deviceToken;
	          _this2.loadData(deviceToken);
	        }).finally(function () {
	          _this2.processingNotificationsPermission = false;
	        });
	      } else {
	        this.UserNotificationService.unsubscribeNotification().promise.finally(function () {
	          _this2.processingNotificationsPermission = false;
	        });
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      this.processing = true;
	      this.UserNotificationService.updateAlertsConfig(this.user.uuid, this.deviceToken, this.alertsConfig).promise.finally(function () {
	        _this3.processing = false;
	      });
	    }
	  }, {
	    key: '_checkAvailability',
	    value: function _checkAvailability(config) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = config.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var i = _step.value;

	          i.available = i.recipients && (i.recipients.includes('responsibles') || this.isUserAdmin && i.recipients.includes('admin'));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      return config;
	    }
	  }]);

	  return UserNotificationController;
	}();

	exports.default = UserNotificationController;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserNotificationService = function () {
	  UserNotificationService.$inject = ["$http", "$q", "$window", "EnvironmentConfig", "FirebaseMessagingService", "SubscriberNotificationService"];
	  function UserNotificationService($http, $q, $window, EnvironmentConfig, FirebaseMessagingService, SubscriberNotificationService) {
	    'ngInject';

	    _classCallCheck(this, UserNotificationService);

	    this.$http = $http;
	    this.$q = $q;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.FirebaseMessagingService = FirebaseMessagingService;
	    this.SubscriberNotificationService = SubscriberNotificationService;
	  }

	  _createClass(UserNotificationService, [{
	    key: 'getAlertsConfig',
	    value: function getAlertsConfig(uuid, dtk) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.USERS, uuid, 'configuration', _constants.API.ALERTS].join('/') + '?dtk=' + dtk, method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'updateAlertsConfig',
	    value: function updateAlertsConfig(uuid, dtk, config) {
	      var deferred = this.$q.defer();
	      var alertConfig = {};
	      alertConfig = config.data.map(function (configAlert) {
	        configAlert = { type: configAlert.type, enabled: !!configAlert.enabled };
	        return configAlert;
	      });
	      var data = { data: { dtk: dtk, config: alertConfig } };
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.USERS, uuid, 'configuration', _constants.API.ALERTS].join('/'), method: 'PUT', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });
	      return deferred;
	    }
	  }, {
	    key: 'subscribeNotification',
	    value: function subscribeNotification() {
	      var _this = this;

	      var deferred = this.$q.defer();
	      this.FirebaseMessagingService.getToken().then(function (res) {
	        _this.SubscriberNotificationService.registerToken(res).promise.then(function () {
	          deferred.resolve(res);
	        });
	      }).catch(function (err) {
	        deferred.reject(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: 'unsubscribeNotification',
	    value: function unsubscribeNotification() {
	      var _this2 = this;

	      var deferred = this.$q.defer();
	      this.FirebaseMessagingService.getToken().then(function (res) {
	        _this2.SubscriberNotificationService.unregisterToken(res).promise.then(function () {
	          deferred.resolve(res);
	        });
	      }).catch(function (err) {
	        deferred.reject(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: 'isAlreadySubscribed',
	    value: function isAlreadySubscribed() {
	      return this.$window.Notification.permission === 'granted';
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      return this.FirebaseMessagingService.getToken();
	    }
	  }]);

	  return UserNotificationService;
	}();

	exports.default = UserNotificationService;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(249);

	angular.module('phoenix.internal.audit', ['ui.router', 'phoenix.internal.audit.logs']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'audit',
	    url: '/audit',
	    parent: 'internal',
	    template: '<ui-view/>'
	  });
	}]);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _constants = __webpack_require__(9);

	var _logsList = __webpack_require__(250);

	var _logsList2 = _interopRequireDefault(_logsList);

	var _logsDialog = __webpack_require__(251);

	var _logsDialog2 = _interopRequireDefault(_logsDialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	angular.module('phoenix.internal.audit.logs', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  $stateProvider.state({
	    name: 'logs',
	    url: '/logs?search&filters',
	    parent: 'audit',
	    menu: 'logs',
	    alias: 'logs',
	    controller: _logsList2.default,
	    controllerAs: 'ctrl',
	    templateUrl: 'app/internal/audit/logs/list/logs.list.html',
	    params: {
	      search: { dynamic: true },
	      filters: { dynamic: true }
	    },
	    data: {
	      requiresLogin: true,
	      canAccess: [].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER))
	    }
	  });
	}]).controller('LogsListController', _logsList2.default).controller('LogsDialogController', _logsDialog2.default);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _list = __webpack_require__(72);

	var _list2 = _interopRequireDefault(_list);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var LogsListController = function (_ListController) {
	  LogsListController.$inject = ["$scope", "$state", "$translate", "MainService"];
	  _inherits(LogsListController, _ListController);

	  function LogsListController($scope, $state, $translate, MainService) {
	    'ngInject';

	    _classCallCheck(this, LogsListController);

	    var _this = _possibleConstructorReturn(this, (LogsListController.__proto__ || Object.getPrototypeOf(LogsListController)).call(this, $scope, $state, $translate, MainService));

	    _this.$state = $state;
	    _this.$scope = $scope;
	    _this.$translate = $translate;

	    _this.template = 'list';

	    _this.setProps(_constants.API.V5, 'operation-logs', _initial.query());
	    _this.translateKeys();
	    return _this;
	  }

	  _createClass(LogsListController, [{
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.MODULE_OPERATION', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.NAME_USERNAME', 'PANEL.HEADER.TIME_DATE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.MODULE_OPERATION'],
	          sort: true,
	          prop: 'model'
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: true,
	          prop: 'enterprise.name'
	        }, {
	          label: t['PANEL.HEADER.NAME_USERNAME'],
	          sort: true,
	          prop: 'user.name'
	        }, {
	          label: t['PANEL.HEADER.TIME_DATE'],
	          sort: true,
	          prop: 'operation_at'
	        }];
	      });
	    }
	  }]);

	  return LogsListController;
	}(_list2.default);

	exports.default = LogsListController;


	var _initial = {
	  query: function query() {
	    return {
	      attributes: ['*'],
	      count: true,
	      filters: {},
	      includes: {
	        user: ['name', 'username'],
	        enterprise: ['name', 'cnpj']
	      },
	      limit: 15,
	      page: 1,
	      sort: {
	        prop: 'operation_at',
	        order: 'DESC'
	      }
	    };
	  }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LogsDialogController = function () {
	  LogsDialogController.$inject = ["$mdDialog", "$translate", "DialogService", "MainService", "locals"];
	  function LogsDialogController($mdDialog, $translate, DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, LogsDialogController);

	    this.$mdDialog = $mdDialog;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.MainService = MainService;
	    this.attr = angular.copy(locals.item);

	    this.items = [];
	    this.loading = false;
	    this.template = 'dialog';

	    this.pagination = {
	      current: 1,
	      limit: 15
	    };

	    this.loadData();
	    this.translateKeys();
	  }

	  _createClass(LogsDialogController, [{
	    key: 'close',
	    value: function close() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'modelData',
	    value: function modelData(item) {
	      item.modelKey = [];
	      item.modelValues = [];

	      if (!item.attributes.model_data && !item.attributes.model_data.attributes) return;

	      item.modelKey = Object.keys(item.attributes.model_data.attributes);
	      item.modelValues = Object.values(item.attributes.model_data.attributes);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;

	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	      this.loading = true;
	      this.items = [];

	      var model = this.attr.relationships.model;

	      var obj = Object.assign(_initial.query(), { page: page, limit: this.pagination.limit });

	      model.type = model.type.replace('_', '-');

	      if (angular.isArray(this.attr.relationships.sub_models)) {
	        obj.filters = {
	          sub_models: { operator: 'in', value: this.attr.relationships.sub_models[0].type },
	          sub_models_ids: { operator: 'in', value: this.attr.relationships.sub_models[0].id }
	        };
	      } else {
	        obj.filters = {
	          sub_models: { operator: 'is', value: null }
	        };
	      }

	      this.MainService.raw(_constants.API.V5, 'operation-logs/' + model.type + '/' + model.id, obj).promise.then(function (res) {
	        _this.items = res.data;
	        _this.count = res.count;
	        _this.pagination.current = page;
	      }).finally(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;

	      var keys = ['PANEL.HEADER.MODULE_OPERATION', 'PANEL.HEADER.ENTERPRISE_DOC', 'PANEL.HEADER.NAME_USERNAME', 'PANEL.HEADER.TIME_DATE'];

	      this.$translate(keys).then(function (t) {
	        _this2.headers = [{
	          label: t['PANEL.HEADER.MODULE_OPERATION'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.ENTERPRISE_DOC'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.NAME_USERNAME'],
	          sort: false
	        }, {
	          label: t['PANEL.HEADER.TIME_DATE'],
	          sort: false
	        }];
	      });
	    }
	  }]);

	  return LogsDialogController;
	}();

	exports.default = LogsDialogController;


	var _initial = {
	  query: function query() {
	    return {
	      count: true,
	      filters: {},
	      includes: {
	        user: ['name', 'username'],
	        enterprise: ['*']
	      },
	      page: 1,
	      sort: {
	        prop: 'operation_at',
	        order: 'DESC'
	      }
	    };
	  }
	};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(253);

	var _navbar = __webpack_require__(254);

	var _navigator = __webpack_require__(255);

	var _title = __webpack_require__(256);

	var _export = __webpack_require__(257);

	var _exportDialog = __webpack_require__(258);

	var _actions = __webpack_require__(259);

	var _search = __webpack_require__(260);

	var _panelHeader = __webpack_require__(263);

	var _streetView = __webpack_require__(264);

	var _easyLink = __webpack_require__(265);

	var _copyPaste = __webpack_require__(266);

	var _documents = __webpack_require__(267);

	var _document = __webpack_require__(270);

	var _pushNotificationBar = __webpack_require__(272);

	var _textareaEditor = __webpack_require__(273);

	var _userList = __webpack_require__(274);

	var _editor = __webpack_require__(275);

	var _accordion = __webpack_require__(277);

	var _accordionItem = __webpack_require__(278);

	var _buttonDropdown = __webpack_require__(279);

	var _progress = __webpack_require__(280);

	var _progress2 = _interopRequireDefault(_progress);

	var _access = __webpack_require__(281);

	var _access2 = _interopRequireDefault(_access);

	var _warning = __webpack_require__(282);

	var _warning2 = _interopRequireDefault(_warning);

	var _scroll = __webpack_require__(283);

	var _scroll2 = _interopRequireDefault(_scroll);

	var _horizontalSlide = __webpack_require__(284);

	var _horizontalSlide2 = _interopRequireDefault(_horizontalSlide);

	var _reportIndicator = __webpack_require__(285);

	var _reportIndicator2 = _interopRequireDefault(_reportIndicator);

	var _emptyInput = __webpack_require__(286);

	var _emptyInput2 = _interopRequireDefault(_emptyInput);

	var _logsAccordion = __webpack_require__(287);

	var _pagination = __webpack_require__(288);

	var _userAssetPermissions = __webpack_require__(289);

	var _deviceAssetAssociation = __webpack_require__(290);

	var _chips = __webpack_require__(291);

	var _devices = __webpack_require__(292);

	var _deviceModel = __webpack_require__(293);

	var _enterprises = __webpack_require__(294);

	var _users = __webpack_require__(295);

	var _vehicles = __webpack_require__(296);

	var _advancedFilter = __webpack_require__(297);

	var _customFieldsForm = __webpack_require__(298);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.directives', []).directive('menu', _menu.Menu).directive('navbar', _navbar.Navbar).directive('navigator', _navigator.NavigatorBar).directive('titleBar', _title.TitleBar).directive('exportBar', _export.ExportBar).directive('exportDialogBar', _exportDialog.ExportDialogBar).directive('actionsBar', _actions.ActionsBar).directive('searchBar', _search.SearchBar).directive('panelHeader', _panelHeader.PanelHeader).directive('streetView', _streetView.StreetView).directive('documents', _documents.DocumentsDirective).directive('singleDocument', _document.SingleDocumentDirective).directive('pushNotificationBar', _pushNotificationBar.PushNotificationBar).directive('textareaEditor', _textareaEditor.TextareaEditor).directive('editor', _editor.Editor).directive('accordion', _accordion.Accordion).directive('accordionItem', _accordionItem.AccordionItem).directive('buttonDropdown', _buttonDropdown.ButtonDropdown).directive('userList', _userList.UserList).directive('progress', _progress2.default.directiveFactory).directive('canAccess', _access2.default.directiveFactory).directive('warningElements', _warning2.default.directiveFactory).directive('whenScrolled', _scroll2.default.directiveFactory).directive('horizontalSlide', _horizontalSlide2.default.directiveFactory).directive('easyLink', _easyLink.EasyLinkDirective).directive('copyPaste', _copyPaste.CopyPasteDirective).directive('reportIndicator', _reportIndicator2.default.directiveFactory).directive('logsAccordion', _logsAccordion.LogsAccordion).directive('pagination', _pagination.Pagination).directive('emptyInput', _emptyInput2.default.directiveFactory).directive('deviceAssetAssociation', _deviceAssetAssociation.DeviceAssetAssociation).directive('userAssetPermissions', _userAssetPermissions.UserAssetPermissions).directive('customFieldsForm', _customFieldsForm.CustomFieldsForm).directive('chipsAutocomplete', _chips.ChipsAutocomplete).directive('deviceModelAutocomplete', _deviceModel.DeviceModelAutocomplete).directive('devicesAutocomplete', _devices.DevicesAutocomplete).directive('enterprisesAutocomplete', _enterprises.EnterprisesAutocomplete).directive('usersAutocomplete', _users.UsersAutocomplete).directive('vehiclesAutocomplete', _vehicles.VehiclesAutocomplete).directive('advancedFilter', _advancedFilter.AdvancedFilter);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.Menu = Menu;

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function Menu() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/menu/menu.html',
	    replace: true,
	    controller: MenuController,
	    controllerAs: 'ctrl',
	    scope: {}
	  };

	  return directive;
	}

	var MenuController = function () {
	  MenuController.$inject = ["$state", "$window", "DialogService", "EnvironmentConfig"];
	  function MenuController($state, $window, DialogService, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, MenuController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;

	    this.myCompany = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.newItems = ['new-vehicle', 'new-chip', 'new-device', 'new-user', 'new-enterprise', 'from-out-source'];

	    this.buildMenu();
	  }

	  _createClass(MenuController, [{
	    key: 'redirect',
	    value: function redirect() {
	      var id = (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.myCompany.id);
	      this.$state.go('enterprises-edit', { id: id });
	    }
	  }, {
	    key: 'openAction',
	    value: function openAction(action) {
	      action = action.replace(/_/gi, '-');
	      var dialog = {
	        url: 'app/components/actions/' + action + '/' + action + '.dialog.html',
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        bindToController: true,
	        preserveScope: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(dialog);
	    }
	  }, {
	    key: 'buildMenu',
	    value: function buildMenu() {
	      var role = this.$window.localStorage.getItem('role');
	      var allStates = this.$state.get();
	      var models = ['organization', 'operational', 'reports', 'monitoring', 'management', 'fleet', 'audit', 'settings'];
	      var mainMenu = {
	        root: {},
	        management: [],
	        organization: [],
	        operational: [],
	        monitoring: [],
	        fleet: [],
	        reports: [],
	        audit: [],
	        logs: {},
	        settings: []
	      };
	      for (var index = 0; index < allStates.length; index++) {
	        var obj = {};
	        if (models.includes(allStates[index].parent) && allStates[index].data.canAccess.includes(role)) {
	          obj.link = allStates[index].name;
	          obj.name = allStates[index].alias;
	          obj.parent = allStates[index].parent;
	          obj.report = allStates[index].report;
	          obj.new = allStates[index].new;
	          if (allStates[index].menu === true) {
	            mainMenu[allStates[index].parent].push(obj);
	          } else if (allStates[index].menu === 'root') {
	            mainMenu.root = obj;
	          } else if (allStates[index].menu === 'logs') {
	            mainMenu.logs = obj;
	          }
	        }
	      }

	      this.menu = mainMenu;
	    }
	  }]);

	  return MenuController;
	}();

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.Navbar = Navbar;

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function Navbar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navbar/navbar.directive.html',
	    replace: true,
	    controller: NavbarController,
	    controllerAs: 'ctrl',
	    bindToController: true
	    // scope: {}
	  };

	  return directive;
	}

	var NavbarController = function () {
	  NavbarController.$inject = ["$location", "$state", "$window", "EnvironmentConfig", "SessionService"];
	  function NavbarController($location, $state, $window, EnvironmentConfig, SessionService) {
	    'ngInject';

	    _classCallCheck(this, NavbarController);

	    this.$location = $location;
	    this.$state = $state;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.SessionService = SessionService;

	    this.defineUsername();
	  }

	  _createClass(NavbarController, [{
	    key: 'defineUsername',
	    value: function defineUsername() {
	      this.me = angular.fromJson(this.$window.localStorage.getItem('user'));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.SessionService.logout();
	    }
	  }, {
	    key: 'getPath',
	    value: function getPath() {
	      return this.$location.path().split('/').splice(1, 3);
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      this.$state.go('users-edit', { id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.me.id) });
	    }
	  }]);

	  return NavbarController;
	}();

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.NavigatorBar = NavigatorBar;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function NavigatorBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator/navigator.directive.html',
	    replace: true,
	    controller: NavigatorController,
	    controllerAs: 'ctrl',
	    scope: {
	      contract: '=',
	      model: '@',
	      version: '@',
	      filters: '=',
	      exportList: '=',
	      amount: '='
	    }
	  };

	  return directive;
	}

	var NavigatorController = function () {
	  NavigatorController.$inject = ["$location", "$mdDialog", "$scope", "$state", "$translate", "DialogService", "GenericService"];
	  function NavigatorController($location, $mdDialog, $scope, $state, $translate, DialogService, GenericService) {
	    'ngInject';

	    _classCallCheck(this, NavigatorController);

	    this.$location = $location;
	    this.$mdDialog = $mdDialog;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.DialogService = DialogService;
	    this.GenericService = GenericService;
	    this.loadingExport = false;
	    this.selectedItems = 0;
	    this.pickAll = false;
	    this.path = this.$location.path().split('/').splice(1, 3);
	  }

	  _createClass(NavigatorController, [{
	    key: 'add',
	    value: function add(type) {
	      if (type === 'screen') {
	        var currentState = this.$state.current;
	        this.$state.go(currentState.alias + '-create');
	      } else {
	        this.openAction(type);
	      }
	    }
	  }, {
	    key: 'openAction',
	    value: function openAction(action) {
	      action = action.replace(/_/gi, '-');
	      var dialog = {
	        url: 'app/components/actions/' + action + '/' + action + '.dialog.html',
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        bindToController: true,
	        preserveScope: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(dialog);
	    }
	  }, {
	    key: 'goToStats',
	    value: function goToStats() {
	      var currentState = this.$state.current;
	      this.$state.go(currentState.alias + '-panel');
	    }
	  }, {
	    key: 'archive',
	    value: function archive() {
	      var _this = this;

	      var data = void 0;
	      if (this.$scope.version === 'v3') {
	        data = { uuids: [this.$state.params.uuid] };
	      } else {
	        data = { ids: [this.$state.params.id] };
	      }

	      this.GenericService.archive(this.$scope.version, this.$scope.model, data).promise.then(function () {
	        _this.$scope.contract = {
	          archive: false,
	          unarchive: true,
	          delete: true
	        };
	      });
	    }
	  }, {
	    key: 'unarchive',
	    value: function unarchive() {
	      var _this2 = this;

	      var data = void 0;
	      if (this.$scope.version === 'v3') {
	        data = { uuids: [this.$state.params.uuid] };
	      } else {
	        data = { ids: [this.$state.params.id] };
	      }

	      this.GenericService.unarchive(this.$scope.version, this.$scope.model, data).promise.then(function () {
	        _this2.$scope.contract = {
	          archive: true,
	          unarchive: false,
	          delete: false
	        };
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this3 = this;

	      var data = void 0;
	      if (this.$scope.version === 'v3') {
	        data = { uuids: [this.$state.params.uuid] };
	      } else {
	        data = this.$state.params.id;
	      }

	      var confirm = this.$mdDialog.confirm().title(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.TITLE')).textContent(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.TEXT')).ok(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.OK')).cancel(this.$translate.instant('NAVIGATOR.DIALOG.CONFIRM.NOK'));

	      this.$mdDialog.show(confirm).then(function () {
	        _this3.GenericService.delete(_this3.$scope.version, _this3.$scope.model, data).promise.then(function () {
	          _this3.$state.go(_this3.path[1] + '-list');
	        });
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection() {
	      var _this4 = this;

	      this.$scope.exportList.map(function (e) {
	        e.checked = !_this4.pickAll;
	        if (!_this4.pickAll) {
	          _this4.selectedItems = _this4.$scope.exportList.length;
	        } else {
	          _this4.selectedItems = 0;
	        }
	      });
	    }
	  }, {
	    key: 'recalculateSelected',
	    value: function recalculateSelected(state) {
	      if (!state) {
	        this.selectedItems = this.selectedItems + 1;
	      } else {
	        this.selectedItems = this.selectedItems - 1;
	      }
	    }
	  }, {
	    key: 'prepareToExport',
	    value: function prepareToExport(type) {
	      this.loadingExport = true;
	      var toExport = this.$scope.exportList.filter(function (el) {
	        return el.checked === true;
	      });
	      var filename = this.$translate.instant('NAVBAR.' + this.path[1].toUpperCase());
	      this.$scope.$emit('export', { toExport: toExport, type: type, filename: filename });
	    }
	  }]);

	  return NavigatorController;
	}();

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.TitleBar = TitleBar;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function TitleBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator-wrapper/title/title.directive.html',
	    replace: true,
	    controller: TitleBarController,
	    controllerAs: 'ctrl',
	    scope: {
	      contract: '=',
	      amount: '='
	    }
	  };

	  return directive;
	}

	var TitleBarController = function () {
	  TitleBarController.$inject = ["$location", "$scope", "$state"];
	  function TitleBarController($location, $scope, $state) {
	    'ngInject';

	    _classCallCheck(this, TitleBarController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.path = $location.path().split('/').splice(1, 3);
	  }

	  _createClass(TitleBarController, [{
	    key: 'goToStats',
	    value: function goToStats() {
	      var currentState = this.$state.current;
	      var checkChildState = currentState.name.split('.');

	      checkChildState.length > 1 ? this.$state.go(checkChildState[0] + '-panel') : this.$state.go(currentState.alias + '-panel');
	    }
	  }]);

	  return TitleBarController;
	}();

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.ExportBar = ExportBar;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function ExportBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator-wrapper/export/export.directive.html',
	    replace: true,
	    controller: ExportBarController,
	    controllerAs: 'ctrl',
	    scope: {
	      contract: '=',
	      filters: '=',
	      exportList: '='
	    }
	  };

	  return directive;
	}

	var ExportBarController = function () {
	  ExportBarController.$inject = ["$location", "$rootScope", "$scope", "$translate"];
	  function ExportBarController($location, $rootScope, $scope, $translate) {
	    'ngInject';

	    _classCallCheck(this, ExportBarController);

	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.loadingExport = false;
	    this.selectedItems = 0;
	    this.pickAll = false;
	    this.path = $location.path().split('/').splice(1, 3);
	    this.preventOpen = $rootScope.clientStatus === 'overdue';
	  }

	  _createClass(ExportBarController, [{
	    key: 'toggleSelection',
	    value: function toggleSelection() {
	      var _this = this;

	      this.$scope.exportList.map(function (e) {
	        e.checked = !_this.pickAll;
	        if (!_this.pickAll) {
	          _this.selectedItems = _this.$scope.exportList.length;
	        } else {
	          _this.selectedItems = 0;
	        }
	      });
	    }
	  }, {
	    key: 'recalculateSelected',
	    value: function recalculateSelected(state) {
	      if (!state) {
	        this.selectedItems = this.selectedItems + 1;
	      } else {
	        this.selectedItems = this.selectedItems - 1;
	      }
	    }
	  }, {
	    key: 'prepareToExport',
	    value: function prepareToExport(type) {
	      this.loadingExport = true;
	      var toExport = this.$scope.exportList.filter(function (el) {
	        return el.checked === true;
	      });
	      var filename = this.$translate.instant('NAVBAR.' + this.path[1].toUpperCase());
	      this.$scope.$emit('export', { toExport: toExport, type: type, filename: filename });
	    }
	  }]);

	  return ExportBarController;
	}();

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.ExportDialogBar = ExportDialogBar;

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function ExportDialogBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator-wrapper/export-dialog/export-dialog.directive.html',
	    replace: true,
	    controller: ExportDialogBarController,
	    controllerAs: 'ctrl',
	    scope: {
	      contract: '=',
	      model: '@',
	      version: '@'
	    }
	  };

	  return directive;
	}

	var ExportDialogBarController = function () {
	  ExportDialogBarController.$inject = ["$scope", "$rootScope", "DialogService"];
	  function ExportDialogBarController($scope, $rootScope, DialogService) {
	    'ngInject';

	    _classCallCheck(this, ExportDialogBarController);

	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.DialogService = DialogService;

	    this.preventOpen = $rootScope.clientStatus === 'overdue';
	    this.opt = _dialog.DIALOG._opts('app/components/export-list/export.dialog.html', 'ExportDialogController');
	  }

	  _createClass(ExportDialogBarController, [{
	    key: 'openOptions',
	    value: function openOptions() {
	      this.DialogService.openDialog(this.opt, { model: this.$scope.model, version: this.$scope.version });
	    }
	  }]);

	  return ExportDialogBarController;
	}();

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.ActionsBar = ActionsBar;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function ActionsBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator-wrapper/actions/actions.directive.html',
	    replace: true,
	    controller: ActionsBarController,
	    controllerAs: 'ctrl',
	    scope: {
	      contract: '='
	    }
	  };

	  return directive;
	}

	var ActionsBarController = function () {
	  ActionsBarController.$inject = ["$scope", "$state", "DialogService"];
	  function ActionsBarController($scope, $state, DialogService) {
	    'ngInject';

	    _classCallCheck(this, ActionsBarController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.DialogService = DialogService;
	  }

	  _createClass(ActionsBarController, [{
	    key: 'add',
	    value: function add(type) {
	      var currentState = this.$state.current;
	      switch (type) {
	        case 'screen':
	          this.$state.go(currentState.alias + '-create');
	          break;
	        case 'child-screen':
	          this.$state.go(currentState.alias.split('.')[0] + '.create');
	          break;
	        default:
	          this.openAction(type);
	      }
	    }
	  }, {
	    key: 'openAction',
	    value: function openAction(action) {
	      action = action.replace(/_/gi, '-');
	      var dialog = {
	        url: 'app/components/actions/' + action + '/' + action + '.dialog.html',
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        hasBackdrop: true,
	        bindToController: true,
	        preserveScope: true,
	        parent: angular.element('#page-body')
	      };

	      this.DialogService.openDialog(dialog);
	    }
	  }]);

	  return ActionsBarController;
	}();

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.SearchBar = SearchBar;

	var _helper = __webpack_require__(21);

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	var _listRecommendedQueries = __webpack_require__(261);

	var _queryOptions = __webpack_require__(236);

	var _tooltipsSearch = __webpack_require__(262);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function SearchBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/navigator-wrapper/search/search.directive.html',
	    replace: true,
	    controller: SearchBarController,
	    controllerAs: 'ctrl',
	    scope: {
	      model: '@',
	      filter: '=',
	      typeable: '=',
	      historyModel: '@'
	    }
	  };

	  return directive;
	}

	var SearchBarController = function () {
	  SearchBarController.$inject = ["$document", "$rootScope", "$scope", "$state", "$translate", "$timeout", "$window", "DialogService", "MainService"];
	  function SearchBarController($document, $rootScope, $scope, $state, $translate, $timeout, $window, DialogService, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, SearchBarController);

	    this.$document = $document;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.opt = _dialog.DIALOG._opts('app/components/advanced-filter/advanced-filter.dialog.html', 'AdvancedFilterDialogController');
	    if (this.$scope.model && this.$state.current.name !== 'sharings-list') {
	      this.recommendedQuery = _listRecommendedQueries.RECOMMENDED_QUERIES[this.$scope.model.toUpperCase()];
	      this.queryOptions = _queryOptions.FILTERS[this.$scope.model] ? _queryOptions.FILTERS[this.$scope.model] : [];
	    }

	    this.hasOptions = true;
	    this.preventOpen = $rootScope.clientStatus === 'overdue';
	    this.tooltipKey = this.generateKeyTooltip();
	    this.searchText = '';
	    this.backupText = '';
	    this.keyupCount = 0;
	    this.BackSpaceCount = 0;
	    this.loading = true;
	    this.shouldClose = true;
	    this.typeSearch = 'single';
	    this.historyModel = this.$scope.historyModel || this.$scope.model;

	    this.meta = {
	      count: 0,
	      limit: 10,
	      page: 1
	    };

	    this.checkFilters();
	    this.checkMassiveAndSingle();
	    this.buildRecommendedList();
	    this.buildMassiveAndSingleList(this.typeSearch);
	    this.buildHistoryList();

	    var loading = function loading() {
	      return _this.setLoading();
	    };
	    this.$rootScope.$watch('requestLoading', function (newValue) {
	      if (!newValue) {
	        loading();
	      }
	    });
	  }

	  _createClass(SearchBarController, [{
	    key: 'setLoading',
	    value: function setLoading() {
	      this.loading = false;
	      this.hasParams = angular.isDefined(this.$state.params.filters) || angular.isDefined(this.$state.params.search);
	    }
	  }, {
	    key: 'checkFilters',
	    value: function checkFilters() {
	      var _this2 = this;

	      this.$translate(['NAVIGATOR.LABEL.CUSTOMIZED_QUERY']).then(function (t) {
	        _this2.customizedQuery = t['NAVIGATOR.LABEL.CUSTOMIZED_QUERY'];
	        _this2.searchText = angular.isDefined(_this2.$state.params.search) ? _this2.$state.params.search : '';
	        if (angular.isDefined(_this2.$state.params.filters)) {
	          _this2.searchText = _this2.customizedQuery;
	          _this2.decodeFilters();
	        }
	      });
	    }
	  }, {
	    key: 'decodeFilters',
	    value: function decodeFilters() {
	      var decoded = angular.fromJson((0, _helper._decodeBase64)(decodeURIComponent(this.$state.params.filters)));
	      var keys = Object.keys(decoded);

	      if ((decoded[keys[0]].operator === 'ilk' || decoded[keys[0]].operator === 'in') && keys.length === 1) {
	        var name = [this.$scope.model, keys[0]].join('.').toUpperCase();
	        if (!name.includes('NAVIGATOR.')) {
	          this.searchForData = {
	            key: keys[0],
	            name: name
	          };

	          this.typeSearch = decoded[keys[0]].operator === 'in' ? 'massive' : 'single';
	          this.searchFor = true;
	          this.searchText = decoded[keys[0]].value;
	          this.buildMassiveAndSingleList(this.typeSearch);
	        }
	      }
	    }
	  }, {
	    key: 'generateKeyTooltip',
	    value: function generateKeyTooltip() {
	      if (!this.$state.$current.self.alias) {
	        return '';
	      }

	      var url = this.$state.$current.self.alias.replaceAll(/\.|-/g, '_');
	      var values = _tooltipsSearch.TOOLTIPS_SEARCH.filter(function (item) {
	        return item.url === url;
	      });

	      return values.length > 0 ? values[0].key : '';
	    }
	  }, {
	    key: 'checkMassiveAndSingle',
	    value: function checkMassiveAndSingle() {
	      this.hasMassiveSearch = this.queryOptions ? this.queryOptions.filter(function (qr) {
	        return qr.type === 'string' && qr.massive;
	      }).length > 0 : false;
	      this.hasSingleSearch = this.queryOptions ? this.queryOptions.filter(function (qr) {
	        return qr.type === 'string' && qr.search;
	      }).length > 0 : false;
	    }
	  }, {
	    key: 'toogleTypeSearch',
	    value: function toogleTypeSearch() {
	      this.searchFor = false;
	      this.searchForData = {};
	      this.typeList = !this.typeList;
	      this.focusInput();
	    }
	  }, {
	    key: 'selectedTypeSearch',
	    value: function selectedTypeSearch(type) {
	      this.typeSearch = type;
	      this.typeList = !this.typeList;
	      this.inputDisabled = type === 'custom';

	      if (type === 'custom') {
	        this.buildCustomFilter();
	      } else {
	        this.buildMassiveAndSingleList(this.typeSearch);
	      }
	      this.focusInput();
	    }
	  }, {
	    key: 'openAdvancedFilter',
	    value: function openAdvancedFilter() {
	      var _this3 = this;

	      var obj = {
	        model: this.$scope.model,
	        params: this.lastSearchType === 'single' || this.lastSearchType === 'custom'
	      };
	      this.openSearchBar = false;

	      this.DialogService.openDialog(this.opt, obj).then(function (res) {
	        _this3.$scope.$emit('advancedFilter', res);
	        _this3.searchText = _this3.customizedQuery;
	        _this3.hasParams = true;
	      });
	    }
	  }, {
	    key: 'closeEvent',
	    value: function closeEvent() {
	      if (!this.hasParams) {
	        this.closeSearchBar();
	      } else {
	        this.hasParams = false;
	        this.searchFor = false;
	        this.searchForData = {};
	        this.search();
	      }
	    }
	  }, {
	    key: 'focusInput',
	    value: function focusInput() {
	      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      var el = angular.element(this.$document);
	      var container = el.find('.search-bar__input');
	      container[0].focus();
	      this.shouldClose = close;
	    }
	  }, {
	    key: 'inputEvents',
	    value: function inputEvents(event) {
	      this.openSearchBar = true;

	      if (event.type === 'keyup') {
	        this.keyupCount++;
	      }

	      if (this.keyupCount === 0 && this.lastSearchType && this.lastSearchType === 'recommended' && !this.dirty || this.searchText === this.customizedQuery) {
	        this.backupText = this.searchText;
	        this.searchText = '';
	      }
	      this.dirty = true;

	      if (event.keyCode === 13) {
	        if (this.typeSearch === 'massive' && !this.searchFor) return;
	        if (this.searchFor) {
	          if (!this.searchText) return;
	          this.searchByKey(this.searchForData);
	        } else {
	          var newItem = {
	            key: this.searchText,
	            name: this.searchText,
	            type: 'search'
	          };
	          this.search(this.searchText.length > 0 ? newItem : null);
	        }
	      }

	      if (event.keyCode === 8 && this.searchForData && this.searchForData.key && !this.searchText) {
	        this.BackSpaceCount++;

	        if (this.BackSpaceCount > 2) {
	          this.clearSearchFor();
	          this.BackSpaceCount = 0;
	        }
	      }
	    }
	  }, {
	    key: 'buildRecommendedList',
	    value: function buildRecommendedList() {
	      var header = [];
	      var recommended = [];
	      var tags = [];

	      if (this.recommendedQuery && !this.searchFor) {
	        tags = Object.keys(this.recommendedQuery).map(function (k) {
	          return {
	            key: k,
	            name: k.toUpperCase(),
	            type: 'recommended'
	          };
	        });

	        header.push({ title: true });
	        recommended.push({ tags: tags });
	      }
	      this.listRecommended = [].concat(header, recommended);
	    }
	  }, {
	    key: 'buildMassiveAndSingleList',
	    value: function buildMassiveAndSingleList(type) {
	      var _this4 = this;

	      var header = [];
	      var searchFor = [];
	      var rulesMap = function rulesMap(qr) {
	        return {
	          key: qr.key,
	          name: [_this4.$scope.model, qr.key].join('.').toUpperCase(),
	          type: type
	        };
	      };

	      var list = this.hasSingleSearch ? this.queryOptions.filter(function (qr) {
	        return qr.type === 'string' && qr.search;
	      }).map(rulesMap) : [];

	      if (type === 'massive' && this.hasMassiveSearch) {
	        list = this.queryOptions.filter(function (qr) {
	          return qr.type === 'string' && qr.massive;
	        }).map(rulesMap);
	      }

	      if (this.hasMassiveSearch || this.hasSingleSearch) {
	        header.push({
	          text: 'SEARCH_FOR',
	          title: true
	        });
	        searchFor.push({ list: list });
	      }

	      this.listSingleMassive = [].concat(header, searchFor);
	    }
	  }, {
	    key: 'buildHistoryList',
	    value: function buildHistoryList() {
	      var notFound = [];
	      var header = [{
	        title: true
	      }];
	      var history = this.getSearch();

	      if (history.length === 0) {
	        notFound.push({
	          empty: true
	        });
	      }
	      this.listHistory = [].concat(header, _toConsumableArray(history), notFound);
	    }
	  }, {
	    key: 'buildCustomFilter',
	    value: function buildCustomFilter() {
	      if (angular.isArray(this.listCustom)) return;
	      var header = [{
	        title: true
	      }];

	      this.listCustom = [].concat(header);
	      this.loadFilters();
	    }
	  }, {
	    key: 'closeSearchBar',
	    value: function closeSearchBar() {
	      var _this5 = this;

	      this.$timeout(function () {
	        if (_this5.shouldClose) {
	          _this5.openSearchBar = false;
	          _this5.typeList = false;
	        }

	        if (_this5.shouldClose && _this5.keyupCount === 0 && _this5.lastSearchType && _this5.lastSearchType === 'recommended' && _this5.backupText.length > 0) {
	          _this5.searchText = _this5.backupText;
	        }

	        if (_this5.shouldClose && _this5.backupText === _this5.customizedQuery && _this5.keyupCount === 0) {
	          _this5.searchText = _this5.backupText;
	        }

	        if (_this5.shouldClose) {
	          _this5.backupText = '';
	          _this5.dirty = false;
	        }

	        _this5.shouldClose = true;
	      }, 300);
	    }
	  }, {
	    key: 'setSearchFor',
	    value: function setSearchFor(item) {
	      this.searchFor = true;
	      this.searchForData = item;
	      this.focusInput();
	    }
	  }, {
	    key: 'clearSearchFor',
	    value: function clearSearchFor() {
	      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      this.searchFor = false;
	      this.searchForData = {};
	      this.focusInput(close);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      var noParms = !this.$state.params.search && !this.$state.params.filters && !this.searchText && !item;
	      if (item && item.name === this.$state.params.search && this.searchText === this.$state.params.search || noParms) return;

	      this.$rootScope.$broadcast('searchList', item ? item.name : null);
	      this.searchText = item ? item.name : '';
	      this.lastSearchType = 'search';
	      this.reset();
	      this.closeSearchBar();

	      if (item) {
	        this.setSearch(item);
	        this.buildHistoryList();
	      }
	    }
	  }, {
	    key: 'searchRecommended',
	    value: function searchRecommended(item) {
	      var data = this.recommendedQuery[item.key];

	      this.searchText = this.$translate.instant('NAVIGATOR.ENUM.RECOMMENDED_QUERIES.' + item.name);
	      this.$rootScope.$broadcast('changeFilter', { data: data, options: { keepFilters: false } });
	      this.lastSearchType = 'recommended';
	      this.reset();
	      this.closeSearchBar();
	      this.setSearch(item);
	      this.buildHistoryList();
	    }
	  }, {
	    key: 'searchByKey',
	    value: function searchByKey(item) {
	      var fromHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      var value = item.type === 'massive' ? this.searchText.replaceAll(', ', ',') : this.searchText;

	      if (fromHistory) {
	        value = item.type === 'massive' ? item.value.replaceAll(', ', ',') : item.value;
	        this.searchText = item.value;
	        this.searchFor = true;
	        this.typeSearch = item.type;
	        this.searchForData = {
	          key: item.key,
	          name: item.name,
	          type: item.type
	        };
	        this.buildMassiveAndSingleList(item.type);
	      }

	      var data = {
	        key: item.key,
	        val: {
	          operator: item.type === 'massive' ? 'in' : 'ilk',
	          value: value
	        }
	      };
	      this.$rootScope.$broadcast('changeFilter', { data: data, options: { keepFilters: false } });
	      this.lastSearchType = item.type;
	      this.reset();
	      this.closeSearchBar();

	      var history = item;
	      history.value = this.searchText;
	      this.setSearch(history);
	      this.buildHistoryList();
	    }
	  }, {
	    key: 'searchCustom',
	    value: function searchCustom(item) {
	      var fromHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      var filter = fromHistory ? item.filter : item.attributes.filter;
	      var name = fromHistory ? item.name : item.attributes.name;
	      var history = {
	        filter: filter,
	        key: name,
	        name: name,
	        type: 'custom',
	        value: name
	      };

	      this.setSearch(history);
	      this.buildHistoryList();
	      this.typeSearch = 'single';
	      this.lastSearchType = 'custom';
	      this.$scope.$emit('advancedFilter', this.decodeCustomFilters(filter));
	      this.searchText = this.customizedQuery;
	      this.hasParams = true;
	      this.inputDisabled = false;

	      if (fromHistory) {
	        this.closeSearchBar();
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.backupText = '';
	      this.dirty = false;
	      this.keyupCount = 0;
	      this.loading = true;
	    }
	  }, {
	    key: 'removeHistory',
	    value: function removeHistory(item) {
	      var _this6 = this;

	      var history = this.getSearch();
	      var remove = history.findIndex(function (i) {
	        return i.key === item.key;
	      });
	      if (item.value) {
	        remove = history.findIndex(function (i) {
	          return i.key === item.key && i.value === item.value;
	        });
	      }
	      history.splice(remove, 1);
	      history.reverse();

	      var prevSearch = angular.fromJson(this.$window.localStorage.getItem('search'));
	      prevSearch[this.historyModel] = [];
	      this.$window.localStorage.setItem('search', angular.toJson(prevSearch));
	      history.map(function (i) {
	        return _this6.setSearch(i);
	      });
	      this.shouldClose = false;
	      this.focusInput();
	      this.buildHistoryList();
	    }
	  }, {
	    key: 'setSearch',
	    value: function setSearch(item) {
	      if (this.historyModel) {
	        var prevSearch = angular.fromJson(this.$window.localStorage.getItem('search')) || {};
	        var currentSearches = prevSearch[this.historyModel] || [];
	        var existingIndex = currentSearches.findIndex(function (i) {
	          return i.key === item.key;
	        });

	        if (item.value) {
	          existingIndex = currentSearches.findIndex(function (i) {
	            return i.key === item.key && i.value === item.value && i.type === item.type;
	          });
	        }

	        if (existingIndex !== -1) {
	          currentSearches.splice(existingIndex, 1);
	        } else if (currentSearches.length > 4) {
	          currentSearches.pop();
	        }
	        currentSearches.unshift(item);
	        prevSearch[this.historyModel] = currentSearches;
	        this.$window.localStorage.setItem('search', angular.toJson(prevSearch));
	      }
	    }
	  }, {
	    key: 'getSearch',
	    value: function getSearch() {
	      if (!this.historyModel) return [];

	      var prevSearch = angular.fromJson(this.$window.localStorage.getItem('search'));
	      return prevSearch && prevSearch[this.historyModel] ? prevSearch[this.historyModel] : [];
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      this.itemsEnd = this.meta.count <= this.listCustom.length - 1;
	      if (!this.loadingCustom && !this.itemsEnd) {
	        this.meta.page = ++this.meta.page;
	        this.loadFilters();
	      }
	    }
	  }, {
	    key: 'loadFilters',
	    value: function loadFilters() {
	      var _this7 = this;

	      if (!this.enterprise) {
	        this.enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      }
	      var items = [];
	      var notFound = [{
	        empty: true
	      }];
	      this.loadingCustom = true;
	      var obj = {
	        attributes: ['name', 'filter'],
	        count: true,
	        filters: {
	          model: { operator: 'eq', value: this.$scope.model }
	        },
	        includes: {},
	        limit: this.meta.limit,
	        page: this.meta.page,
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        }
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.enterprise.id + '/custom-filters', obj).promise.then(function (res) {
	        items = res.data;
	        _this7.meta.count = res.count;
	      }).finally(function () {
	        var newItems = items.length === 0 && _this7.listCustom.length === 1 ? notFound : items;
	        _this7.listCustom = [].concat(_toConsumableArray(_this7.listCustom), newItems);
	        _this7.loadingCustom = false;
	      });
	    }
	  }, {
	    key: 'decodeCustomFilters',
	    value: function decodeCustomFilters(item) {
	      if (!angular.isObject(item)) return {};
	      var obj = angular.copy(item);

	      for (var key in obj) {
	        if (obj[key].type === 'shortdate' || obj[key].type === 'date') {
	          var formatDate = obj[key].type === 'shortdate' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';

	          var _ref = [].concat(_toConsumableArray(obj[key].value)),
	              period = _ref[0],
	              value = _ref[1];

	          if (obj[key].operator === 'eq') {
	            var interval = '';
	            if (value < 0) {
	              var start = moment().add(value, period);
	              var end = moment().add(-1, period);
	              interval = start.startOf(period).format(formatDate) + ',' + end.endOf(period).format(formatDate);
	            } else if (value > 0) {
	              var _start = moment().add(1, period);
	              var _end = moment().add(value, period);
	              interval = _start.startOf(period).format(formatDate) + ',' + _end.endOf(period).format(formatDate);
	            } else {
	              interval = moment().startOf(period).format(formatDate) + ',' + moment().endOf(period).format(formatDate);
	            }
	            obj[key].operator = 'btw';
	            obj[key].value = interval;
	          } else {
	            obj[key].value = value === 0 ? moment().startOf(period).format(formatDate) : moment().add(value, period).format(formatDate);
	          }
	        }
	      }

	      return obj;
	    }
	  }]);

	  return SearchBarController;
	}();

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RECOMMENDED_QUERIES = exports.RECOMMENDED_QUERIES = {
	  DEVICES: {
	    NO_CHIP_DEVICES: {
	      key: 'chip.serial',
	      val: { operator: 'is', value: null }
	    },
	    ACTIVATED: {
	      key: 'devices.active',
	      val: { operator: 'eq', value: true }
	    },
	    DEACTIVATED: {
	      key: 'devices.active',
	      val: { operator: 'eq', value: false }
	    },
	    FREE: {
	      key: 'vehicle.id',
	      val: { operator: 'is', value: null }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    },
	    NO_COMMUNICATION_24H: {
	      key: 'last_gps.last_gps_time',
	      val: { operator: 'lt', value: moment().subtract(1, 'd').format('YYYY-MM-DD HH:mm:ss') }
	    },
	    NOT_CONNECTED_24H: {
	      key: 'last_gps.last_connection_time',
	      val: { operator: 'lt', value: moment().subtract(1, 'd').format('YYYY-MM-DD HH:mm:ss') }
	    }
	  },
	  VEHICLES: {
	    ACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'is', value: null }
	    },
	    DEACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'isn', value: null }
	    },
	    FREE: {
	      key: 'devices.name',
	      val: { operator: 'is', value: null }
	    },
	    IN_USE: {
	      key: 'devices.name',
	      val: { operator: 'isn', value: null }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  CHIPS: {
	    FREE: {
	      key: 'device.name',
	      val: { operator: 'is', value: null }
	    },
	    IN_USE: {
	      key: 'device.name',
	      val: { operator: 'isn', value: null }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  ENTERPRISES: {
	    ACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'is', value: null }
	    },
	    DEACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'isn', value: null }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  TRAJECTORIES: {
	    ACC_TODAY: {
	      key: 'acc',
	      val: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	    },
	    SPEED_SEGMENTS: [{
	      key: 'spMax',
	      val: { operator: 'gt', value: 120 }
	    }, {
	      key: 'acc',
	      val: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	    }],
	    ALERT_COUNT: [{
	      key: 'alCnt',
	      val: { operator: 'gt', value: 30 }
	    }, {
	      key: 'acc',
	      val: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	    }],
	    GPS_COUNT: [{
	      key: 'gpsCnt',
	      val: { operator: 'gt', value: 1500 }
	    }, {
	      key: 'acc',
	      val: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	    }]
	  },
	  USERS: {
	    ACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'is', value: null }
	    },
	    DEACTIVATED: {
	      key: 'deactivated_at',
	      val: { operator: 'isn', value: null }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  'SERVICE-ORDERS': {
	    COMPLETED: {
	      key: 'completed',
	      val: { operator: 'eq', value: true }
	    },
	    INCOMPLETED: {
	      key: 'completed',
	      val: { operator: 'neq', value: true }
	    },
	    DELAYED: [{
	      key: 'due_date',
	      val: { operator: 'lt', value: moment().format('YYYY-MM-DD') }
	    }, {
	      key: 'completed',
	      val: { operator: 'neq', value: true }
	    }],
	    DUE_TODAY: {
	      key: 'due_date',
	      val: { operator: 'btw', value: moment().format('YYYY-MM-DD') + ',' + moment().add(1, 'day').format('YYYY-MM-DD') }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  SURVEYS: {
	    DUE_TODAY: {
	      key: 'due_date',
	      val: { operator: 'eq', value: moment().format('YYYY-MM-DD') }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  PROTOCOLS: {
	    COMPLETED: {
	      key: 'completed',
	      val: { operator: 'eq', value: true }
	    },
	    INCOMPLETED: {
	      key: 'completed',
	      val: { operator: 'neq', value: true }
	    },
	    DUE_TODAY: {
	      key: 'due_date',
	      val: { operator: 'btw', value: moment().format('YYYY-MM-DD') + ',' + moment().add(1, 'day').format('YYYY-MM-DD') }
	    },
	    CREATED_THIS_MONTH: {
	      key: 'created_at',
	      val: { operator: 'gt', value: moment().startOf('M').format('YYYY-MM-DD') }
	    }
	  },
	  'OPERATION-LOGS': {
	    USERS: {
	      key: 'model',
	      val: { operator: 'eq', value: 'users' }
	    },
	    VEHICLES: {
	      key: 'model',
	      val: { operator: 'eq', value: 'vehicles' }
	    },
	    ENTERPRISES: {
	      key: 'model',
	      val: { operator: 'eq', value: 'enterprises' }
	    },
	    CHIPS: {
	      key: 'model',
	      val: { operator: 'eq', value: 'chips' }
	    },
	    SERVICE_ORDERS: {
	      key: 'model',
	      val: { operator: 'eq', value: 'service_orders' }
	    },
	    PROTOCOLS: {
	      key: 'model',
	      val: { operator: 'eq', value: 'protocols' }
	    }
	  }
	};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOOLTIPS_SEARCH = exports.TOOLTIPS_SEARCH = [{
	  key: 'CHIPS',
	  url: 'chips'
	}, {
	  key: 'DEVICES',
	  url: 'devices'
	}, {
	  key: 'ENTERPRISES',
	  url: 'enterprises'
	}, {
	  key: 'FUELS',
	  url: 'fuels'
	}, {
	  key: 'IDENTIFICATIONS',
	  url: 'identifications'
	}, {
	  key: 'PROTOCOLS',
	  url: 'protocols'
	}, {
	  key: 'SERVICE_ORDERS',
	  url: 'service_orders'
	}, {
	  key: 'SHARINGS',
	  url: 'links'
	}, {
	  key: 'SHARINGS',
	  url: 'sharings'
	}, {
	  key: 'TRIPS',
	  url: 'trips'
	}, {
	  key: 'USERS',
	  url: 'users'
	}, {
	  key: 'VEHICLES',
	  url: 'vehicles'
	}, {
	  key: 'LOGS',
	  url: 'logs'
	}];

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.PanelHeader = PanelHeader;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function PanelHeader() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/panel-header/panel-header.html',
	    controller: PanelHeaderController,
	    controllerAs: 'ctrl',
	    scope: {
	      data: '=',
	      checkbox: '='
	    }
	  };
	  return directive;
	}

	var PanelHeaderController = function () {
	  PanelHeaderController.$inject = ["$state", "$scope", "$rootScope"];
	  function PanelHeaderController($state, $scope, $rootScope) {
	    'ngInject';

	    _classCallCheck(this, PanelHeaderController);

	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;

	    this.hasCheckbox = angular.isDefined(this.$scope.checkbox);
	  }

	  _createClass(PanelHeaderController, [{
	    key: 'order',
	    value: function order(header) {
	      this.deactivate();
	      header.active = true;
	      if (header.active) header.asc = header.asc === 'ASC' ? 'DESC' : 'ASC';
	      this.$scope.$emit('order', { prop: header.prop, order: header.asc });
	    }
	  }, {
	    key: 'getDirection',
	    value: function getDirection(header) {
	      return { asc: header.asc === 'ASC', desc: header.asc === 'DESC', active: header.active };
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this.$scope.data.forEach(function (h) {
	        h.active = false;
	      });
	    }
	  }]);

	  return PanelHeaderController;
	}();

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.StreetView = StreetView;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function StreetView() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/street-view/street-view.directive.html',
	    replace: true,
	    controller: StreetViewController,
	    controllerAs: 'ctrl',
	    scope: {
	      lat: '=',
	      lng: '=',
	      width: '=',
	      height: '=',
	      loading: '@'
	    }
	  };

	  return directive;
	}

	var StreetViewController = function () {
	  StreetViewController.$inject = ["$scope", "$sce"];
	  function StreetViewController($scope, $sce) {
	    'ngInject';

	    _classCallCheck(this, StreetViewController);

	    this.$scope = $scope;
	    this.$sce = $sce;
	    this.trustedSrc();
	  }

	  _createClass(StreetViewController, [{
	    key: 'trustedSrc',
	    value: function trustedSrc() {
	      this.src = this.$sce.trustAsResourceUrl(_constants.GOOGLE_STREETVIEW + '?location=' + this.$scope.lat + ',' + this.$scope.lng + '&key=' + _constants.GOOGLE_KEY + '&source=outdoor');
	    }
	  }]);

	  return StreetViewController;
	}();

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EasyLinkDirective = EasyLinkDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function EasyLinkDirective() {
	  'ngInject';

	  var directive = {
	    restrict: 'A',
	    templateUrl: 'app/directives/easy-link/easy-link.html',
	    controller: EasyLinkController,
	    controllerAs: 'ctrl',
	    replace: true,
	    scope: {
	      link: '@',
	      placeholder: '@'
	    }
	  };

	  return directive;
	}

	var EasyLinkController = function EasyLinkController($scope) {
	  'ngInject';

	  _classCallCheck(this, EasyLinkController);

	  this.$scope = $scope;

	  this.link = this.$scope.link;
	  this.placeholder = this.$scope.placeholder;
	};
	EasyLinkController.$inject = ["$scope"];

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.CopyPasteDirective = CopyPasteDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function CopyPasteDirective() {
	  'ngInject';

	  var directive = {
	    restrict: 'A',
	    templateUrl: 'app/directives/copy-paste/copy-paste.html',
	    controller: CopyPasteController,
	    controllerAs: 'ctrl',
	    replace: true,
	    scope: {
	      value: '@'
	    }
	  };

	  return directive;
	}

	var CopyPasteController = function () {
	  CopyPasteController.$inject = ["$scope", "$timeout"];
	  function CopyPasteController($scope, $timeout) {
	    'ngInject';

	    _classCallCheck(this, CopyPasteController);

	    this.$scope = $scope;
	    this.$timeout = $timeout;

	    this.value = this.$scope.value;
	    this.copied = false;
	  }

	  _createClass(CopyPasteController, [{
	    key: 'copy',
	    value: function copy(event) {
	      this.copied = true;
	      this.preventPropagation(event);
	    }
	  }, {
	    key: 'preventPropagation',
	    value: function preventPropagation(event) {
	      var _this = this;

	      this.$timeout(function () {
	        event.clearSelection();
	        _this.copied = false;
	      }, 1200);
	    }
	  }]);

	  return CopyPasteController;
	}();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentsDirective = DocumentsDirective;

	var _documents = __webpack_require__(268);

	var _documents2 = _interopRequireDefault(_documents);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function DocumentsDirective() {
	  'ngInject';

	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/documents/many/documents.html',
	    controller: _documents2.default,
	    controllerAs: 'ctrl',
	    replace: true,
	    scope: {
	      count: '=',
	      identifier: '=',
	      files: '=',
	      loadingExternal: '=',
	      service: '@',
	      version: '@'
	    }
	  };

	  return directive;
	}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _dialog = __webpack_require__(30);

	var _fontIcon = __webpack_require__(269);

	var _fontIcon2 = _interopRequireDefault(_fontIcon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DocumentsController = function () {
	  DocumentsController.$inject = ["$http", "$rootScope", "$scope", "DialogService", "EnvironmentConfig", "MainService", "StateManagement"];
	  function DocumentsController($http, $rootScope, $scope, DialogService, EnvironmentConfig, MainService, StateManagement) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, DocumentsController);

	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.StateManagement = StateManagement;

	    this.readOnly = true;
	    this.selectedItems = [];
	    this.galleryItems = [];
	    this.selectAllItems = false;
	    this.loading = false;

	    var config = function config() {
	      return _this.checkReadOnly();
	    };
	    var watcher = this.$rootScope.$watch('statesList', function (newValue) {
	      if (angular.isArray(newValue) && newValue.includes('readOnly')) {
	        config();
	      } else {
	        _this.readOnly = false;
	      }
	    });
	    this.$scope.$on('$destroy', function () {
	      watcher();
	    });
	  }

	  _createClass(DocumentsController, [{
	    key: 'checkReadOnly',
	    value: function checkReadOnly() {
	      var _StateManagement$getD = this.StateManagement.getData(['readOnly']),
	          readOnly = _StateManagement$getD.readOnly;

	      this.readOnly = angular.isDefined(readOnly.readOnly) ? readOnly.readOnly : false;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this2 = this;

	      var items = { data: [] };

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, { deleteText: true }).then(function () {
	        items.data = _this2.selectedItems.map(function (i) {
	          return {
	            type: 'task_documents',
	            id: i.id
	          };
	        });
	        _this2.MainService.deleteMany(_this2.$scope.version, _this2.$scope.service + '/' + _this2.$scope.identifier + '/documents', items).promise.then(function () {
	          _this2.$scope.files = _this2.$scope.files.filter(function (file) {
	            return !items.data.map(function (f) {
	              return f.id;
	            }).includes(file.id);
	          });
	          _this2.$scope.count = _this2.$scope.count - items.data.length;
	          _this2.selectItem();
	          _this2.filterGalleryItems();
	        });
	      });
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile(file) {
	      var _this3 = this;

	      if (!file) {
	        return;
	      }

	      this.loading = true;
	      var obj = {
	        data: {
	          attributes: {
	            file_name: Date.now() + '-' + file.name
	          }
	        }
	      };

	      this.$scope.files.push({ attributes: { name: file.name, file_size: file.size, progress: true } });

	      this.MainService.create(this.$scope.version, this.$scope.service + '/' + this.$scope.identifier + '/documents/signed-link', obj).promise.then(function (res) {
	        var url = res.data.signed_link;

	        _this3.$http.put(url, file, { headers: { 'x-amz-tagging': 'draft=draft', 'Content-Type': file.type }, skipAuthorization: true }).then(function () {
	          var confirmedObj = {
	            data: {
	              attributes: {
	                name: file.name,
	                key_name: obj.data.attributes.file_name,
	                file_size: file.size
	              }
	            }
	          };

	          _this3.MainService.create(_this3.$scope.version, _this3.$scope.service + '/' + _this3.$scope.identifier + '/documents/confirm-upload', confirmedObj).promise.then(function (res) {
	            delete res.data.relationships;
	            _this3.$scope.files.pop();
	            _this3.$scope.files.push(res.data);
	            _this3.$scope.count++;
	            _this3.filterGalleryItems();
	          });
	        });
	      }).catch(function () {
	        _this3.$scope.files.pop();
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: 'toggleSectionAll',
	    value: function toggleSectionAll() {
	      var _this4 = this;

	      this.$scope.files.forEach(function (file) {
	        file.selected = _this4.selectAllItems;
	      });
	      this.selectItem();
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem() {
	      this.selectedItems = this.$scope.files.filter(function (file) {
	        return file.selected;
	      });
	      this.selectAllItems = this.$scope.files.length > 0 && this.selectedItems.length === this.$scope.files.length;
	    }
	  }, {
	    key: 'checkPreview',
	    value: function checkPreview(extension) {
	      var check = (0, _fontIcon2.default)();

	      return check(extension) === 'image';
	    }
	  }, {
	    key: 'addGallery',
	    value: function addGallery(item, last) {
	      if (!angular.isObject(item)) return;

	      var check = (0, _fontIcon2.default)();
	      item.gallery = check(item.attributes.mime) === 'image';

	      if (last) {
	        this.filterGalleryItems();
	      }
	    }
	  }, {
	    key: 'filterGalleryItems',
	    value: function filterGalleryItems() {
	      this.galleryItems = this.$scope.files.filter(function (i) {
	        return i.gallery;
	      });
	    }
	  }, {
	    key: 'openGallery',
	    value: function openGallery(image) {
	      var current = this.galleryItems.findIndex(function (select) {
	        return select.id === image.id;
	      });
	      var images = this.galleryItems.map(function (i) {
	        return {
	          src: 'https://' + i.attributes.folder,
	          alt: i.attributes.name
	        };
	      });
	      var opt = _dialog.DIALOG._opts('app/components/gallery/gallery.dialog.html', 'GalleryDialogController');
	      this.DialogService.openDialog(opt, { images: images, current: current });
	    }
	  }]);

	  return DocumentsController;
	}();

	exports.default = DocumentsController;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mimeFont;
	function mimeFont() {
	  'use strict';

	  return function (input) {
	    var type = 'draft';

	    if (input == null) {
	      type = 'draft';
	    } else if (input.indexOf('spreadsheet') > -1 || input.indexOf('ms-excel') > -1) {
	      type = 'analytics';
	    } else if (input.indexOf('presentation') > -1 || input.indexOf('ms-powerpoint') > -1) {
	      type = 'slideshow';
	    } else if (input.indexOf('wordprocessing') > -1 || input.indexOf('msword') > -1 || input.indexOf('text/plain') > -1) {
	      type = 'description';
	    } else if (input.indexOf('application/pdf') > -1) {
	      type = 'picture_as_pdf';
	    } else if (input.indexOf('image/jpeg') > -1 || input.indexOf('image/png') > -1 || input.indexOf('image/gif') > -1 || input.indexOf('image/svg+xml') > -1) {
	      type = 'image';
	    } else if (input.indexOf('application/zip') > -1) {
	      type = 'folder_zip';
	    } else if (input.indexOf('application/xml') > -1) {
	      type = 'code_blocks';
	    }

	    return type;
	  };
	}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleDocumentDirective = SingleDocumentDirective;

	var _document = __webpack_require__(271);

	var _document2 = _interopRequireDefault(_document);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function SingleDocumentDirective() {
	  'ngInject';

	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/documents/single/document.html',
	    controller: _document2.default,
	    controllerAs: 'ctrl',
	    replace: true,
	    scope: {
	      identifier: '=',
	      file: '=',
	      service: '@',
	      version: '@',
	      pattern: '@',
	      dimensions: '=',
	      size: '='
	    }
	  };

	  return directive;
	}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _dialog = __webpack_require__(30);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DocumentsController = function () {
	  DocumentsController.$inject = ["$http", "$scope", "$timeout", "DialogService", "EnvironmentConfig", "MainService"];
	  function DocumentsController($http, $scope, $timeout, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, DocumentsController);

	    this.$http = $http;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.transformData();
	  }

	  _createClass(DocumentsController, [{
	    key: 'transformData',
	    value: function transformData() {
	      if (this.$scope.file && this.$scope.file.attributes) {
	        this.$scope.file.attributes.folder = this.EnvironmentConfig.MEDIA + '/' + this.$scope.file.attributes.folder;
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.STRONG_CONFIRMATION_ACTION.path, _dialog.DIALOG.STRONG_CONFIRMATION_ACTION.ctrl);
	      this.DialogService.openDialog(opt, this.protocol).then(function () {
	        _this.MainService.delete(_this.$scope.version, _this.$scope.service + '/' + _this.$scope.identifier + '/documents', _this.$scope.file.uuid).promise.then(function () {
	          delete _this.$scope.file;
	        });
	      });
	    }
	  }, {
	    key: 'validateOrDie',
	    value: function validateOrDie(file, width, height, dimensions, size) {
	      var _this2 = this;

	      if (!file) {
	        return;
	      }
	      if (file.size > size * 1000) {
	        this.validation = {
	          sizeError: true
	        };
	        this.$timeout(function () {
	          _this2.$scope.file = null;
	        }, 100);
	      } else if (dimensions && (dimensions.w !== width || dimensions.h !== height)) {
	        this.validation = {
	          dimensionError: true
	        };
	        this.$timeout(function () {
	          _this2.$scope.file = null;
	        }, 100);
	      } else {
	        this.uploadFile(file);
	      }
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile(file) {
	      var _this3 = this;

	      this.loading = true;
	      var obj = {
	        data: {
	          attributes: {
	            file_name: Date.now() + '-' + file.name
	          }
	        }
	      };

	      this.$scope.file = file;

	      this.MainService.create(this.$scope.version, this.$scope.service + '/' + this.$scope.identifier + '/documents/signed-link', obj).promise.then(function (res) {
	        var url = res.data.signed_link;

	        _this3.$http.put(url, file, { headers: { 'x-amz-tagging': 'draft=draft', 'Content-Type': file.type }, skipAuthorization: true }).then(function () {
	          var confirmedObj = {
	            data: {
	              attributes: {
	                name: file.name,
	                key_name: obj.data.attributes.file_name,
	                file_size: file.size
	              }
	            }
	          };

	          _this3.MainService.create(_this3.$scope.version, _this3.$scope.service + '/' + _this3.$scope.identifier + '/documents/confirm-upload', confirmedObj).promise.then(function (res) {
	            _this3.$scope.file = res.data;
	            _this3.transformData();
	          });
	        }).finally(function () {
	          _this3.loading = false;
	        });
	      });
	    }
	  }]);

	  return DocumentsController;
	}();

	exports.default = DocumentsController;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.PushNotificationBar = PushNotificationBar;

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function PushNotificationBar() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/push-notification-bar/push-notification-bar.directive.html',
	    replace: true,
	    controller: PushNotificationBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {}
	  };

	  return directive;
	}

	var PushNotificationBarController = function () {
	  PushNotificationBarController.$inject = ["$window", "UserNotificationService"];
	  function PushNotificationBarController($window, UserNotificationService) {
	    'ngInject';

	    _classCallCheck(this, PushNotificationBarController);

	    this.$window = $window;
	    this.UserNotificationService = UserNotificationService;
	    this.role = this.$window.localStorage.getItem('role');
	    this.checkShowBar();
	  }

	  _createClass(PushNotificationBarController, [{
	    key: 'checkShowBar',
	    value: function checkShowBar() {
	      var tried = this.$window.localStorage.getItem('notification_attempt');
	      if ([].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.CLIENT)).includes(this.role) && !tried) {
	        if (this.UserNotificationService.isAlreadySubscribed()) {
	          this.showBar = false;
	        } else {
	          this.showBar = true;
	        }
	      } else {
	        this.showBar = false;
	      }
	    }
	  }, {
	    key: 'dismissBar',
	    value: function dismissBar() {
	      this.showBar = false;
	      this.$window.localStorage.setItem('notification_attempt', true);
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var _this = this;

	      this.processing = true;
	      this.UserNotificationService.subscribeNotification().promise.then(function () {
	        _this.processing = false;
	        _this.showBar = false;
	      }).catch(function () {
	        _this.processing = false;
	      });
	    }
	  }]);

	  return PushNotificationBarController;
	}();

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.TextareaEditor = TextareaEditor;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function TextareaEditor() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/inplace-editor/textarea/textarea-editor.directive.html',
	    replace: true,
	    controller: TextareaEditorController,
	    controllerAs: 'ctrl',
	    scope: {
	      text: '@',
	      value: '=',
	      key: '@',
	      save: '&onSave'
	    }
	  };

	  return directive;
	}

	var TextareaEditorController = function () {
	  TextareaEditorController.$inject = ["$scope"];
	  function TextareaEditorController($scope) {
	    'ngInject';

	    _classCallCheck(this, TextareaEditorController);

	    this.$scope = $scope;

	    this.tinymceOptions = {
	      skin: 'lightgray',
	      inline: false,
	      menubar: false,
	      statusbar: false,
	      selector: 'textarea',
	      min_height: 110,
	      toolbar: 'undo redo bold italic alignleft aligncenter alignright bullist numlist outdent indent code'
	    };

	    this._setData();
	  }

	  _createClass(TextareaEditorController, [{
	    key: '_setData',
	    value: function _setData() {
	      this.value = this.$scope.value || '';
	      this.text = angular.copy(this.value);
	      this.key = this.$scope.key;
	      this.editable = true;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.editable = !this.editable;
	      this.text = angular.copy(this.value);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.editable = false;
	      this.$scope.save({ key: this.key, val: this.text }).then(function () {
	        _this.value = angular.copy(_this.text);
	      }).catch(function () {
	        _this.text = angular.copy(_this.value);
	      }).finally(function () {
	        _this.editable = true;
	      });
	    }
	  }]);

	  return TextareaEditorController;
	}();

	exports.default = TextareaEditorController;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.UserList = UserList;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function UserList() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.horizontal === 'true' ? 'app/directives/user-list/user-horizontal-list.html' : 'app/directives/user-list/user-vertical-list.html';
	    },
	    repace: true,
	    controller: UserListController,
	    controllerAs: 'ctrl',
	    scope: {
	      users: '=',
	      clickable: '=',
	      initials: '=',
	      horizontal: '=',
	      recordable: '=',
	      size: '@'
	    }
	  };
	  return directive;
	}

	var UserListController = function () {
	  UserListController.$inject = ["$scope", "DialogService"];
	  function UserListController($scope, DialogService) {
	    'ngInject';

	    _classCallCheck(this, UserListController);

	    this.$scope = $scope;
	    this.DialogService = DialogService;
	    this.users = Object.assign([], this.$scope.users);

	    if (this.$scope.initials) this.patternGenerator();
	  }

	  _createClass(UserListController, [{
	    key: 'patternGenerator',
	    value: function patternGenerator() {
	      if (this.users.length > 0) {
	        this.users.forEach(function (i) {
	          i.attributes.initials = i.attributes.name.split(' ').map(function (n, i, a) {
	            return i === 0 || i + 1 === a.length ? n[0] : null;
	          }).join('');
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var status = {
	        url: 'app/directives/user-list-dialog/user-list-dialog.html',
	        controllerName: 'UsersListDialogController',
	        controllerAlias: 'ctrl',
	        bindToController: true,
	        clickOutsideToClose: true,
	        escapeToClose: true
	      };

	      this.DialogService.openDialog(status, this.users);
	    }
	  }]);

	  return UserListController;
	}();

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.Editor = Editor;

	var _constants = __webpack_require__(9);

	var _quill = __webpack_require__(276);

	var _quill2 = _interopRequireDefault(_quill);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function Editor() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/editor/editor.html',
	    replace: true,
	    controller: EditorController,
	    controllerAs: 'ctrl',
	    scope: {
	      noBorder: '<', //        True: hide border - Default false
	      btnCancel: '<', //       True: show cancel button - Default false
	      btnSave: '<', //         True: show save button - Default false
	      charactersMax: '<', //   Number: show max characters
	      content: '=', //         *Set and get content of editor
	      contentOnlyText: '=', // Return text no formatting
	      customClassCss: '@', //  Custom Class CSS - String
	      empty: '<', //           Returns whether the editor is empty
	      id: '@', //              *Id html
	      invalid: '<', //         True: change color border - Default false
	      placeholder: '@', //     Text for placeholder
	      readOnly: '=', //        Read only
	      saved: '<', //           Return when click the save button
	      toolbarTools: '<', //    Array content keys of sections
	      toolbarHide: '<' //      True: hide toolbar tools - Default false
	    }
	  };
	  return directive;
	}

	var EditorController = function () {
	  EditorController.$inject = ["$scope", "$window", "$timeout", "$document"];
	  function EditorController($scope, $window, $timeout, $document) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, EditorController);

	    this.$scope = $scope;
	    this.$window = $window;
	    this.$document = $document;
	    this.$timeout = $timeout;

	    this.render = !!this.$scope.id;
	    this.toolbarSections = {};
	    this.toolbarEnable = !this.$scope.toolbarHide;
	    this.readOnly = this.$scope.readOnly || false;

	    if (this.render) {
	      this.idEditor = 'quill-' + this.$scope.id;
	      this.idToolbar = 'quill-toolbar-' + this.$scope.id;
	      this.idCounter = 'quill-counter-' + this.$scope.id;
	      this.initEditor();
	      this.toolbarCheckSections();
	    }

	    var reloadContent = function reloadContent() {
	      return _this.checkInitialContent();
	    };
	    var current = function current() {
	      return _this.currentContent;
	    };

	    this.$scope.$watch('content', function (newValue) {
	      if (newValue !== current()) {
	        reloadContent();
	      }
	    });
	  }

	  _createClass(EditorController, [{
	    key: 'focusEditor',
	    value: function focusEditor() {
	      this.quill.focus();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      if (!this.previousContent) {
	        this.quill.setContents([{ insert: '\n' }]);
	        this.sendContent();
	      } else {
	        this.quill.setContents(this.previousContent);
	        this.sendContent();
	      }
	    }
	  }, {
	    key: 'checkInitialContent',
	    value: function checkInitialContent() {
	      if (angular.isUndefined(this.quill)) return;

	      try {
	        this.previousContent = angular.fromJson(this.$scope.content);
	      } catch (e) {
	        this.previousContent = this.$scope.content;
	      }

	      if (this.$scope.content) {
	        this.quill.setContents(this.previousContent);
	      }
	      if (angular.isDefined(this.$scope.contentOnlyText)) {
	        this.$scope.contentOnlyText = this.quill.getLength() > 1 ? this.quill.getText() : null;
	      }
	      if (this.$scope.contentOnlyText) {
	        this.$scope.contentOnlyText = this.quill.getText();
	      }
	    }
	  }, {
	    key: 'clickToolbar',
	    value: function clickToolbar() {
	      this.focusEditor();
	      this.sendContent();
	    }
	  }, {
	    key: 'countCharacters',
	    value: function countCharacters() {
	      if (this.$scope.charactersMax) {
	        this.charactersCount = this.quill.getLength() - 1;
	      }
	    }
	  }, {
	    key: 'initEditor',
	    value: function initEditor() {
	      var _this2 = this;

	      this.$window.setTimeout(function () {
	        _this2.quill = new _quill2.default('#' + _this2.idEditor, {
	          modules: {
	            toolbar: '#' + _this2.idToolbar
	          },
	          placeholder: _this2.$scope.placeholder,
	          readOnly: _this2.readOnly,
	          theme: 'snow'
	        });
	        _this2.checkInitialContent();
	        _this2.countCharacters();
	      }, 200);
	    }
	  }, {
	    key: 'pasteEvent',
	    value: function pasteEvent() {
	      var _this3 = this;

	      this.quill.update();
	      this.$timeout(function () {
	        _this3.removeImg();
	      }, 100);
	    }
	  }, {
	    key: 'removeImg',
	    value: function removeImg() {
	      var el = angular.element(this.$document[0]);
	      el.find('.quill').find('img').remove();
	    }
	  }, {
	    key: 'returnEditor',
	    value: function returnEditor() {
	      if (!this.quill.hasFocus()) {
	        this.previousContent = angular.fromJson(this.$scope.content);
	      }
	    }
	  }, {
	    key: 'savedContent',
	    value: function savedContent() {
	      this.sendContent();
	      this.$scope.saved(this.$scope.content);
	    }
	  }, {
	    key: 'sendContent',
	    value: function sendContent() {
	      this.currentContent = angular.toJson(this.quill.getContents());
	      this.$scope.content = angular.toJson(this.quill.getContents());

	      if (this.$scope.empty) {
	        this.$scope.empty(this.quill.getLength() <= 1);
	      }

	      if (angular.isDefined(this.$scope.contentOnlyText)) {
	        this.$scope.contentOnlyText = this.quill.getLength() > 1 ? this.quill.getText() : null;
	      }
	      this.countCharacters();
	    }
	  }, {
	    key: 'toolbarCheckSections',
	    value: function toolbarCheckSections() {
	      var _this4 = this;

	      var hasTools = angular.isArray(this.$scope.toolbarTools);

	      _constants.TOOLBARSECTION.forEach(function (section) {
	        var includeKey = hasTools ? _this4.$scope.toolbarTools.includes(section) : false;
	        var newKey = _defineProperty({}, section, includeKey);
	        Object.assign(_this4.toolbarSections, newKey);
	      });
	    }
	  }, {
	    key: 'writing',
	    value: function writing() {
	      this.sendContent();
	    }
	  }]);

	  return EditorController;
	}();

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;


	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;


	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {

	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);


	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};


	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};

	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};

	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};

	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};

	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};

	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};

	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};

	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};

	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};

	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};

	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};

	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};

	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};


	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);

	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }

	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};

	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};

	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};

	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};

	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};

	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};


	module.exports = Delta;


	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {

	'use strict';

	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;

	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}

		return toStr.call(arr) === '[object Array]';
	};

	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}

		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }

		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};

	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};

	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}

		return obj[name];
	};

	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;

		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}

		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);

					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}

							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}

		// Return the modified object
		return target;
	};


	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _break = __webpack_require__(16);

	var _break2 = _interopRequireDefault(_break);

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var NEWLINE_LENGTH = 1;

	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);

	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);

	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }

	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);

	  return BlockEmbed;
	}(_parchment2.default.Embed);

	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements


	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);

	  function Block(domNode) {
	    _classCallCheck(this, Block);

	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

	    _this2.cache = {};
	    return _this2;
	  }

	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);

	  return Block;
	}(_parchment2.default.Block);

	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}

	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;

	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(50);

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _editor = __webpack_require__(14);

	var _editor2 = _interopRequireDefault(_editor);

	var _emitter3 = __webpack_require__(8);

	var _emitter4 = _interopRequireDefault(_emitter3);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _selection = __webpack_require__(15);

	var _selection2 = _interopRequireDefault(_selection);

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	var _theme = __webpack_require__(34);

	var _theme2 = _interopRequireDefault(_theme);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var debug = (0, _logger2.default)('quill');

	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;

	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);

	  function Quill(container) {
	    var _this2 = this;

	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    _classCallCheck(this, Quill);

	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }

	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;

	      var _overload = overload(index, length, source);

	      var _overload2 = _slicedToArray(_overload, 4);

	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];

	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;

	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;

	      var formats = void 0;

	      var _overload3 = overload(index, length, name, value, source);

	      var _overload4 = _slicedToArray(_overload3, 4);

	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];

	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;

	      var formats = void 0;

	      var _overload5 = overload(index, length, name, value, source);

	      var _overload6 = _slicedToArray(_overload5, 4);

	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];

	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

	      var _overload7 = overload(index, length);

	      var _overload8 = _slicedToArray(_overload7, 2);

	      index = _overload8[0];
	      length = _overload8[1];

	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

	      var _overload9 = overload(index, length);

	      var _overload10 = _slicedToArray(_overload9, 2);

	      index = _overload10[0];
	      length = _overload10[1];

	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;

	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;

	      var formats = void 0;

	      var _overload11 = overload(index, 0, name, value, source);

	      var _overload12 = _slicedToArray(_overload11, 4);

	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];

	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;

	      var _overload13 = overload(index, length, source);

	      var _overload14 = _slicedToArray(_overload13, 4);

	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];

	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;

	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);

	        var _overload16 = _slicedToArray(_overload15, 4);

	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];

	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;

	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);

	  return Quill;
	}();

	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";

	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};

	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}

	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;

	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;

	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}

	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}

	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });

	    var _map2 = _slicedToArray(_map, 2);

	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });

	    var _map4 = _slicedToArray(_map3, 2);

	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}

	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;

	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);

	  function Inline() {
	    _classCallCheck(this, Inline);

	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }

	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);

	  return Inline;
	}(_parchment2.default.Inline);

	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];

	exports.default = Inline;

	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);

	  function TextBlot() {
	    _classCallCheck(this, TextBlot);

	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }

	  return TextBlot;
	}(_parchment2.default.Text);

	exports.default = TextBlot;

	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _eventemitter = __webpack_require__(54);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:events');

	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;

	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});

	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);

	  function Emitter() {
	    _classCallCheck(this, Emitter);

	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }

	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;

	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);

	  return Emitter;
	}(_eventemitter2.default);

	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};

	exports.default = Emitter;

	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  _classCallCheck(this, Module);

	  this.quill = quill;
	  this.options = options;
	};

	Module.DEFAULTS = {};

	exports.default = Module;

	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';

	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;

	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}

	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}

	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};

	exports.default = namespace;

	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);

	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;

	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();

	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;

	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}

	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}

	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}

	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;


	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Code = function (_Inline) {
	  _inherits(Code, _Inline);

	  function Code() {
	    _classCallCheck(this, Code);

	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }

	  return Code;
	}(_inline2.default);

	Code.blotName = 'code';
	Code.tagName = 'CODE';

	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);

	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);

	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }

	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;

	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;

	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];

	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;

	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];

	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);

	  return CodeBlock;
	}(_block2.default);

	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';

	exports.Code = Code;
	exports.default = CodeBlock;

	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _op = __webpack_require__(20);

	var _op2 = _interopRequireDefault(_op);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _code = __webpack_require__(13);

	var _code2 = _interopRequireDefault(_code);

	var _cursor = __webpack_require__(24);

	var _cursor2 = _interopRequireDefault(_cursor);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	var _break = __webpack_require__(16);

	var _break2 = _interopRequireDefault(_break);

	var _clone = __webpack_require__(21);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(11);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ASCII = /^[ -~]*$/;

	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);

	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }

	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;

	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);

	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];

	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];

	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];

	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);

	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];

	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);

	  return Editor;
	}();

	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}

	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}

	exports.default = Editor;

	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _clone = __webpack_require__(21);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(11);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _emitter3 = __webpack_require__(8);

	var _emitter4 = _interopRequireDefault(_emitter3);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var debug = (0, _logger2.default)('quill:selection');

	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	  _classCallCheck(this, Range);

	  this.index = index;
	  this.length = length;
	};

	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;

	    _classCallCheck(this, Selection);

	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;

	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }

	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;

	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;

	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;

	      var _leaf$position = leaf.position(offset, true);

	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];

	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);

	        var _scroll$leaf3 = this.scroll.leaf(index + length);

	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];

	        if (leaf == null) return null;

	        var _leaf$position3 = leaf.position(offset, true);

	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];

	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;

	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];

	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;

	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);

	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];

	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;

	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];

	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

	      var oldRange = this.lastRange;

	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];

	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;

	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;

	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);

	  return Selection;
	}();

	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}

	exports.Range = Range;
	exports.default = Selection;

	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);

	  function Break() {
	    _classCallCheck(this, Break);

	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }

	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);

	  return Break;
	}(_parchment2.default.Embed);

	Break.blotName = 'break';
	Break.tagName = 'BR';

	exports.default = Break;

	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;


	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;


	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;


	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {

	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);


	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },

	  iterator: function (ops) {
	    return new Iterator(ops);
	  },

	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};


	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};

	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};

	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};

	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};

	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};

	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};

	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};


	module.exports = lib;


	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {

	var clone = (function() {
	'use strict';

	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}

	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}

	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}

	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}

	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];

	  var useBuffer = typeof Buffer != 'undefined';

	  if (typeof circular == 'undefined')
	    circular = true;

	  if (typeof depth == 'undefined')
	    depth = Infinity;

	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;

	    if (depth === 0)
	      return parent;

	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }

	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }

	    if (circular) {
	      var index = allParents.indexOf(parent);

	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }

	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }

	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }

	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }

	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }

	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }

	    return child;
	  }

	  return _clone(parent, depth);
	}

	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;

	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};

	// private utility functions

	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;

	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;

	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;

	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;

	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;

	return clone;
	})();

	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}


	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _emitter = __webpack_require__(8);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	var _break = __webpack_require__(16);

	var _break2 = _interopRequireDefault(_break);

	var _code = __webpack_require__(13);

	var _code2 = _interopRequireDefault(_code);

	var _container = __webpack_require__(25);

	var _container2 = _interopRequireDefault(_container);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}

	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);

	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);

	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }

	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];

	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];

	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);

	  return Scroll;
	}(_parchment2.default.Scroll);

	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

	exports.default = Scroll;

	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _clone = __webpack_require__(21);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(11);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _op = __webpack_require__(20);

	var _op2 = _interopRequireDefault(_op);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:keyboard');

	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);

	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);

	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);

	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }

	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;

	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;

	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];

	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];

	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];

	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);

	  return Keyboard;
	}(_module2.default);

	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};

	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];

	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];

	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;

	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];

	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];

	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};

	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;

	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }

	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];

	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}

	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;

	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];

	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];

	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}

	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;

	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];

	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];

	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}

	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}

	function handleEnter(range, context) {
	  var _this3 = this;

	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}

	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;

	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];

	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}

	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}

	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}

	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;

	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);

	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);

	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);

	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }

	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });

	        var _map2 = _slicedToArray(_map, 2);

	        start = _map2[0];
	        end = _map2[1];

	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;

	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);

	  return Cursor;
	}(_parchment2.default.Embed);

	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


	exports.default = Cursor;

	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);

	  function Container() {
	    _classCallCheck(this, Container);

	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }

	  return Container;
	}(_parchment2.default.Container);

	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

	exports.default = Container;

	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);

	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);

	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }

	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);

	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);

	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});

	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;

	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Link = function (_Inline) {
	  _inherits(Link, _Inline);

	  function Link() {
	    _classCallCheck(this, Link);

	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }

	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);

	  return Link;
	}(_inline2.default);

	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}

	exports.default = Link;
	exports.sanitize = _sanitize;

	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _keyboard = __webpack_require__(23);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	var _dropdown = __webpack_require__(107);

	var _dropdown2 = _interopRequireDefault(_dropdown);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var optionsCounter = 0;

	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}

	var Picker = function () {
	  function Picker(select) {
	    var _this = this;

	    _classCallCheck(this, Picker);

	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);

	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;

	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }

	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;

	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');

	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;

	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });

	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;

	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');

	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';

	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);

	      this.options = options;

	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;

	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;

	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);

	  return Picker;
	}();

	exports.default = Picker;

	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	var _break = __webpack_require__(16);

	var _break2 = _interopRequireDefault(_break);

	var _container = __webpack_require__(25);

	var _container2 = _interopRequireDefault(_container);

	var _cursor = __webpack_require__(24);

	var _cursor2 = _interopRequireDefault(_cursor);

	var _embed = __webpack_require__(35);

	var _embed2 = _interopRequireDefault(_embed);

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	var _scroll = __webpack_require__(22);

	var _scroll2 = _interopRequireDefault(_scroll);

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	var _clipboard = __webpack_require__(55);

	var _clipboard2 = _interopRequireDefault(_clipboard);

	var _history = __webpack_require__(42);

	var _history2 = _interopRequireDefault(_history);

	var _keyboard = __webpack_require__(23);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,

	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});

	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

	exports.default = _quill2.default;

	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;


	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;


	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;


	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;


	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);

	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }

	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;

	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);

	  return Theme;
	}();

	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};

	exports.default = Theme;

	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _text = __webpack_require__(7);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var GUARD_TEXT = '\uFEFF';

	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);

	  function Embed(node) {
	    _classCallCheck(this, Embed);

	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }

	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;

	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);

	  return Embed;
	}(_parchment2.default.Embed);

	exports.default = Embed;

	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};

	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;

	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _color = __webpack_require__(26);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});

	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;

	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};

	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;

	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};

	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);

	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);

	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }

	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);

	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);

	var FontStyle = new FontStyleAttributor('font', 'font-family', config);

	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;

	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});

	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;

	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};

	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var History = function (_Module) {
	  _inherits(History, _Module);

	  function History(quill, options) {
	    _classCallCheck(this, History);

	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }

	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);

	  return History;
	}(_module2.default);

	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};

	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}

	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}

	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;

	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _emitter = __webpack_require__(8);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _keyboard = __webpack_require__(23);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	var _theme = __webpack_require__(34);

	var _theme2 = _interopRequireDefault(_theme);

	var _colorPicker = __webpack_require__(59);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _iconPicker = __webpack_require__(60);

	var _iconPicker2 = _interopRequireDefault(_iconPicker);

	var _picker = __webpack_require__(28);

	var _picker2 = _interopRequireDefault(_picker);

	var _tooltip = __webpack_require__(61);

	var _tooltip2 = _interopRequireDefault(_tooltip);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ALIGNS = [false, 'center', 'right', 'justify'];

	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

	var FONTS = [false, 'serif', 'monospace'];

	var HEADERS = ['1', '2', '3', false];

	var SIZES = ['small', false, 'large', 'huge'];

	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);

	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);

	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }

	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;

	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);

	  return BaseTheme;
	}(_theme2.default);

	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;

	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});

	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);

	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);

	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }

	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;

	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);

	  return BaseTooltip;
	}(_tooltip2.default);

	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}

	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}

	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;

	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;


	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;


	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;


	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;


	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;


	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;


	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}

	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}

	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}

	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;

	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}

	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});

	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {

	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */


	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;


	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }

	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }

	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);

	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);

	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);

	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};


	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;

	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }

	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }

	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }

	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }

	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }

	  return diff_bisect_(text1, text2);
	};


	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }

	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};


	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);

	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);

	  return diffs.concat(diffsb);
	};


	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }

	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }

	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }

	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};


	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }

	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};


	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;

	module.exports = diff;

	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}

	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];

	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}

	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;

	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}

	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}


	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;

	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';

	exports = module.exports = supportsArgumentsClass ? supported : unsupported;

	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};

	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {

	'use strict';

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];

	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];

	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }

	  return ee;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}


	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend2 = __webpack_require__(3);

	var _extend3 = _interopRequireDefault(_extend2);

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	var _align = __webpack_require__(36);

	var _background = __webpack_require__(37);

	var _code = __webpack_require__(13);

	var _code2 = _interopRequireDefault(_code);

	var _color = __webpack_require__(26);

	var _direction = __webpack_require__(38);

	var _font = __webpack_require__(39);

	var _size = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:clipboard');

	var DOM_KEY = '__ql-matcher';

	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});

	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});

	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);

	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);

	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];

	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }

	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }

	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];

	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;

	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;

	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];

	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);

	  return Clipboard;
	}(_module2.default);

	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};

	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}

	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}

	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}

	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}

	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}

	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}

	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}

	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}

	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}

	function matchIgnore() {
	  return new _quillDelta2.default();
	}

	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}

	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}

	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}

	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}

	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}

	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;

	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);

	  function Bold() {
	    _classCallCheck(this, Bold);

	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }

	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);

	  return Bold;
	}(_inline2.default);

	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];

	exports.default = Bold;

	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _quillDelta = __webpack_require__(2);

	var _quillDelta2 = _interopRequireDefault(_quillDelta);

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(10);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:toolbar');

	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);

	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);

	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;

	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update


	      _this.update(range);
	    });
	    return _this;
	  }

	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;

	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();

	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];

	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];

	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);

	  return Toolbar;
	}(_module2.default);

	Toolbar.DEFAULTS = {};

	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}

	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}

	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}

	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;

	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};

	exports.default = Toolbar;
	exports.addControls = addControls;

	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _picker = __webpack_require__(28);

	var _picker2 = _interopRequireDefault(_picker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);

	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);

	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }

	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);

	  return ColorPicker;
	}(_picker2.default);

	exports.default = ColorPicker;

	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _picker = __webpack_require__(28);

	var _picker2 = _interopRequireDefault(_picker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);

	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);

	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }

	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);

	  return IconPicker;
	}(_picker2.default);

	exports.default = IconPicker;

	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;

	    _classCallCheck(this, Tooltip);

	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }

	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);

	  return Tooltip;
	}();

	exports.default = Tooltip;

	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _emitter = __webpack_require__(8);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _base = __webpack_require__(43);

	var _base2 = _interopRequireDefault(_base);

	var _link = __webpack_require__(27);

	var _link2 = _interopRequireDefault(_link);

	var _selection = __webpack_require__(15);

	var _icons = __webpack_require__(41);

	var _icons2 = _interopRequireDefault(_icons);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);

	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);

	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }

	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }

	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);

	  return SnowTheme;
	}(_base2.default);

	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});

	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);

	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);

	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }

	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;

	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];

	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);

	  return SnowTooltip;
	}(_base.BaseTooltip);

	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

	exports.default = SnowTheme;

	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _core = __webpack_require__(29);

	var _core2 = _interopRequireDefault(_core);

	var _align = __webpack_require__(36);

	var _direction = __webpack_require__(38);

	var _indent = __webpack_require__(64);

	var _blockquote = __webpack_require__(65);

	var _blockquote2 = _interopRequireDefault(_blockquote);

	var _header = __webpack_require__(66);

	var _header2 = _interopRequireDefault(_header);

	var _list = __webpack_require__(67);

	var _list2 = _interopRequireDefault(_list);

	var _background = __webpack_require__(37);

	var _color = __webpack_require__(26);

	var _font = __webpack_require__(39);

	var _size = __webpack_require__(40);

	var _bold = __webpack_require__(56);

	var _bold2 = _interopRequireDefault(_bold);

	var _italic = __webpack_require__(68);

	var _italic2 = _interopRequireDefault(_italic);

	var _link = __webpack_require__(27);

	var _link2 = _interopRequireDefault(_link);

	var _script = __webpack_require__(69);

	var _script2 = _interopRequireDefault(_script);

	var _strike = __webpack_require__(70);

	var _strike2 = _interopRequireDefault(_strike);

	var _underline = __webpack_require__(71);

	var _underline2 = _interopRequireDefault(_underline);

	var _image = __webpack_require__(72);

	var _image2 = _interopRequireDefault(_image);

	var _video = __webpack_require__(73);

	var _video2 = _interopRequireDefault(_video);

	var _code = __webpack_require__(13);

	var _code2 = _interopRequireDefault(_code);

	var _formula = __webpack_require__(74);

	var _formula2 = _interopRequireDefault(_formula);

	var _syntax = __webpack_require__(75);

	var _syntax2 = _interopRequireDefault(_syntax);

	var _toolbar = __webpack_require__(57);

	var _toolbar2 = _interopRequireDefault(_toolbar);

	var _icons = __webpack_require__(41);

	var _icons2 = _interopRequireDefault(_icons);

	var _picker = __webpack_require__(28);

	var _picker2 = _interopRequireDefault(_picker);

	var _colorPicker = __webpack_require__(59);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _iconPicker = __webpack_require__(60);

	var _iconPicker2 = _interopRequireDefault(_iconPicker);

	var _tooltip = __webpack_require__(61);

	var _tooltip2 = _interopRequireDefault(_tooltip);

	var _bubble = __webpack_require__(108);

	var _bubble2 = _interopRequireDefault(_bubble);

	var _snow = __webpack_require__(62);

	var _snow2 = _interopRequireDefault(_snow);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,

	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,

	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);

	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,

	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,

	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,

	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,

	  'formats/image': _image2.default,
	  'formats/video': _video2.default,

	  'formats/list/item': _list.ListItem,

	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,

	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,

	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);

	exports.default = _core2.default;

	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);

	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);

	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }

	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);

	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);

	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});

	exports.IndentClass = IndentClass;

	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);

	  function Blockquote() {
	    _classCallCheck(this, Blockquote);

	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }

	  return Blockquote;
	}(_block2.default);

	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';

	exports.default = Blockquote;

	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Header = function (_Block) {
	  _inherits(Header, _Block);

	  function Header() {
	    _classCallCheck(this, Header);

	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }

	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);

	  return Header;
	}(_block2.default);

	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

	exports.default = Header;

	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(4);

	var _block2 = _interopRequireDefault(_block);

	var _container = __webpack_require__(25);

	var _container2 = _interopRequireDefault(_container);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);

	  function ListItem() {
	    _classCallCheck(this, ListItem);

	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }

	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);

	  return ListItem;
	}(_block2.default);

	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';

	var List = function (_Container) {
	  _inherits(List, _Container);

	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);

	  function List(domNode) {
	    _classCallCheck(this, List);

	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };

	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }

	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);

	  return List;
	}(_container2.default);

	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];

	exports.ListItem = ListItem;
	exports.default = List;

	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _bold = __webpack_require__(56);

	var _bold2 = _interopRequireDefault(_bold);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);

	  function Italic() {
	    _classCallCheck(this, Italic);

	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }

	  return Italic;
	}(_bold2.default);

	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];

	exports.default = Italic;

	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Script = function (_Inline) {
	  _inherits(Script, _Inline);

	  function Script() {
	    _classCallCheck(this, Script);

	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }

	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);

	  return Script;
	}(_inline2.default);

	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];

	exports.default = Script;

	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);

	  function Strike() {
	    _classCallCheck(this, Strike);

	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }

	  return Strike;
	}(_inline2.default);

	Strike.blotName = 'strike';
	Strike.tagName = 'S';

	exports.default = Strike;

	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inline = __webpack_require__(6);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);

	  function Underline() {
	    _classCallCheck(this, Underline);

	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }

	  return Underline;
	}(_inline2.default);

	Underline.blotName = 'underline';
	Underline.tagName = 'U';

	exports.default = Underline;

	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _link = __webpack_require__(27);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ATTRIBUTES = ['alt', 'height', 'width'];

	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);

	  function Image() {
	    _classCallCheck(this, Image);

	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }

	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);

	  return Image;
	}(_parchment2.default.Embed);

	Image.blotName = 'image';
	Image.tagName = 'IMG';

	exports.default = Image;

	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _block = __webpack_require__(4);

	var _link = __webpack_require__(27);

	var _link2 = _interopRequireDefault(_link);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ATTRIBUTES = ['height', 'width'];

	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);

	  function Video() {
	    _classCallCheck(this, Video);

	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }

	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);

	  return Video;
	}(_block.BlockEmbed);

	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';

	exports.default = Video;

	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _embed = __webpack_require__(35);

	var _embed2 = _interopRequireDefault(_embed);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);

	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);

	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }

	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);

	  return FormulaBlot;
	}(_embed2.default);

	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';

	var Formula = function (_Module) {
	  _inherits(Formula, _Module);

	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);

	  function Formula() {
	    _classCallCheck(this, Formula);

	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }

	  return Formula;
	}(_module2.default);

	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;

	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(0);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(5);

	var _quill2 = _interopRequireDefault(_quill);

	var _module = __webpack_require__(9);

	var _module2 = _interopRequireDefault(_module);

	var _code = __webpack_require__(13);

	var _code2 = _interopRequireDefault(_code);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);

	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);

	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }

	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);

	  return SyntaxCodeBlock;
	}(_code2.default);

	SyntaxCodeBlock.className = 'ql-syntax';

	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});

	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);

	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);

	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);

	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }

	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;

	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);

	  return Syntax;
	}(_module2.default);

	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};

	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;

	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {

	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {

	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(3);

	var _extend2 = _interopRequireDefault(_extend);

	var _emitter = __webpack_require__(8);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _base = __webpack_require__(43);

	var _base2 = _interopRequireDefault(_base);

	var _selection = __webpack_require__(15);

	var _icons = __webpack_require__(41);

	var _icons2 = _interopRequireDefault(_icons);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);

	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);

	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }

	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }

	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);

	  return BubbleTheme;
	}(_base2.default);

	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});

	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);

	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);

	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }

	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;

	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);

	  return BubbleTooltip;
	}(_base.BaseTooltip);

	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;

	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63);


	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22).Buffer))

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Accordion = Accordion;
	function Accordion() {
	  var directive = {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    scope: {
	      name: '@', // Required
	      keepOpen: '='
	    },
	    template: '<div><div class="accordion border-solid border-gray-200 border-0 border-b"><ng-transclude></ng-transclude></div></div>'
	  };
	  return directive;
	}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.AccordionItem = AccordionItem;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function AccordionItem() {
	  var directive = {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    scope: {
	      classTitle: '@',
	      index: '@', // Required
	      initOpen: '=',
	      textTitle: '@' // Required
	    },
	    templateUrl: 'app/directives/accordion/accordion-item.html',
	    controllerAs: 'ctrl',
	    controller: AccordionItemController
	  };
	  return directive;
	}

	var AccordionItemController = function () {
	  AccordionItemController.$inject = ["$scope", "$rootScope", "$translate"];
	  function AccordionItemController($scope, $rootScope, $translate) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, AccordionItemController);

	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$translate = $translate;
	    this.contextName = this.$scope.$parent.$parent.name || 'accordion';
	    this.keepOpen = this.$scope.$parent.$parent.keepOpen;

	    this.titleStyle = this.$scope.classTitle || 'font-semibold text-gray-800';
	    this.internalIndex = this.$scope.initOpen ? this.$scope.index : -1;
	    this.toggle = false;

	    this.$scope.$on(this.contextName, function (ev, data) {
	      _this.setInternalIndex(data);
	    });
	  }

	  _createClass(AccordionItemController, [{
	    key: 'openCloseItem',
	    value: function openCloseItem() {
	      if (this.keepOpen) {
	        this.toggle = !this.toggle;
	        this.internalIndex = this.toggle ? this.$scope.index : -1;
	      } else {
	        var index = this.$scope.index === this.internalIndex ? -1 : this.$scope.index;
	        this.$rootScope.$broadcast(this.contextName, { index: index });
	      }
	    }
	  }, {
	    key: 'setInternalIndex',
	    value: function setInternalIndex(data) {
	      this.internalIndex = data.index;
	    }
	  }]);

	  return AccordionItemController;
	}();

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonDropdown = ButtonDropdown;
	function ButtonDropdown() {
	  var directive = {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    scope: {
	      buttonTranslate: '@',
	      clickEvent: '&',
	      disabled: '='
	    },
	    templateUrl: 'app/directives/button-dropdown/button-dropdown.html'
	  };
	  return directive;
	}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Progress = function () {
	  function Progress() {
	    _classCallCheck(this, Progress);

	    this.restrict = 'E';
	    this.template = '<span></span>';
	    this.replace = true;
	    this.scope = {
	      theme: '@'
	    };
	  }

	  _createClass(Progress, [{
	    key: 'link',
	    value: function link(scope, element) {
	      if (scope.theme === 'light') {
	        element.append('<div><svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></div>');
	      } else {
	        element.append('<div><svg class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></div>');
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new Progress();
	    }
	  }]);

	  return Progress;
	}();

	Progress.directiveFactory.$inject = [];

	exports.default = Progress;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CanAccess = function () {
	  function CanAccess($window) {
	    _classCallCheck(this, CanAccess);

	    this.$window = $window;
	    this.restrict = 'A';
	  }

	  _createClass(CanAccess, [{
	    key: 'link',
	    value: function link(scope, element, attrs) {
	      var access = attrs.canAccess.split(',');
	      var roles = _constants.ROLES;
	      var permissions = access.map(function (e) {
	        return roles[e];
	      }).reduce(function (a, b) {
	        return a.concat(b);
	      }, []);

	      if (access) {
	        var contract = this.$window.localStorage.getItem('role');

	        if (!permissions.includes(contract)) {
	          element.remove();
	        }
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$window", function directiveFactory($window) {
	      'ngInject';

	      return new CanAccess($window);
	    }]
	  }]);

	  return CanAccess;
	}();

	CanAccess.directiveFactory.$inject = ['$window'];

	exports.default = CanAccess;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WarningElements = function () {
	  function WarningElements($translate) {
	    _classCallCheck(this, WarningElements);

	    this.restrict = 'A';
	    this.$translate = $translate;
	  }

	  _createClass(WarningElements, [{
	    key: 'link',
	    value: function link(scope, element, attrs) {
	      var mathItUp = {
	        '>': function _(x, y) {
	          return x > y;
	        },
	        '<': function _(x, y) {
	          return x < y;
	        }
	        // [type, operator, diff]
	      };var data = attrs.warningElements.split(',');

	      if (data[0] === 'date') {
	        if (mathItUp[data[1]](moment().subtract(data[2], 'h').unix(), moment(attrs.value).unix())) {
	          element.append('<span class="warning-signs"><i class="material-symbols-outlined" title="' + this.$translate.instant('AVALIATION.CONNECTION') + '">warning</i></span>');
	        }
	      }

	      if (data[0] === 'pattern') {
	        if (!/^(?=(?:.*[0-9]){3})[A-Z][A-Z0-9]{5}[0-9]$/.test(attrs.value)) {
	          element.append('<span class="warning-signs"><i class="material-symbols-outlined" title="' + this.$translate.instant('AVALIATION.PLATE') + '">warning</i></span>');
	        }
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$translate", function directiveFactory($translate) {
	      'ngInject';

	      return new WarningElements($translate);
	    }]
	  }]);

	  return WarningElements;
	}();

	WarningElements.directiveFactory.$inject = ['$translate'];

	exports.default = WarningElements;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WhenScrolled = function () {
	  function WhenScrolled($window) {
	    _classCallCheck(this, WhenScrolled);

	    this.restrict = 'A';
	    this.$window = $window;
	  }

	  _createClass(WhenScrolled, [{
	    key: 'link',
	    value: function link(scope, element, attrs) {
	      var _this = this;

	      var raw = element[0];
	      var parent = void 0,
	          parentScrollHandler = void 0;

	      if (attrs.position && attrs.position === 'sticky') {
	        parent = element.parents('#content');

	        parentScrollHandler = function parentScrollHandler() {
	          var init = _this.$window.localStorage.getItem('notification_attempt') ? 0 : 48;
	          var rect = raw.getBoundingClientRect();
	          if (rect.top <= init) {
	            element.addClass('is-sticky');
	          } else {
	            element.removeClass('is-sticky');
	          }
	        };
	        parent.bind('scroll', parentScrollHandler);
	      }

	      element.bind('scroll', function (e) {
	        // preventing horizontal scroll from trigger unnecessary callings
	        if (raw.scrollTop === e.scrollTop) {
	          return;
	        }
	        if (raw.scrollTop + raw.offsetHeight + 10 >= raw.scrollHeight) {
	          scope.$apply(attrs.whenScrolled);
	        }
	      });

	      scope.$on('$destroy', function () {
	        if (parent) {
	          parent.unbind('scroll', parentScrollHandler);
	        }
	      });
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$window", function directiveFactory($window) {
	      'ngInject';

	      return new WhenScrolled($window);
	    }]
	  }]);

	  return WhenScrolled;
	}();

	exports.default = WhenScrolled;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HorizontalSlide = function () {
	  function HorizontalSlide($timeout) {
	    _classCallCheck(this, HorizontalSlide);

	    this.$timeout = $timeout;
	    this.restrict = 'A';
	  }

	  _createClass(HorizontalSlide, [{
	    key: 'link',
	    value: function link(scope, element) {
	      var raw = element[0];
	      element.addClass('horizontal-slide-wrapper');

	      var nodeSize = raw.offsetWidth;
	      var scrollableNodeSize = void 0;

	      this.$timeout(function () {
	        var child = raw.children[0];
	        var childElement = angular.element(child);
	        scrollableNodeSize = child.scrollWidth;

	        var buttons = void 0,
	            leftButton = void 0,
	            rightButton = void 0;

	        if (scrollableNodeSize > nodeSize) {
	          // add slide buttons
	          element.append('<button id="horizontal-right-button" class="horizontal-slide-button horizontal-slide-right-button no-button absolute left-0 top-0 h-full"><i class="material-symbols-outlined">chevron_left</i></button>');
	          element.append('<button id="horizontal-left-button" class="horizontal-slide-button horizontal-slide-left-button no-button absolute right-0 top-0 h-full"><i class="material-symbols-outlined">chevron_right</i></button>');

	          buttons = element.find('.horizontal-slide-button');
	          leftButton = angular.element(buttons[0]);
	          rightButton = angular.element(buttons[1]);

	          // add right button
	          if (child.scrollWidth > child.offsetWidth) {
	            rightButton.css({ opacity: '100', 'z-index': '70' });
	          }
	          leftButton.on('click', function () {
	            // smooth scroll left
	            child.scrollTo({ top: 0, left: child.scrollLeft - nodeSize, behavior: 'smooth' });
	          });

	          rightButton.on('click', function () {
	            // smooth scroll right
	            child.scrollTo({ top: 0, left: child.scrollLeft + nodeSize, behavior: 'smooth' });
	          });
	        }

	        childElement.on('scroll', function () {
	          // draw left
	          if (child.scrollLeft > 0) {
	            leftButton.css({ opacity: '100', 'z-index': '70' });
	          }
	          // erase left
	          if (child.scrollLeft === 0) {
	            leftButton.css({ opacity: '0', 'z-index': '10' });
	          }
	          // draw rignt
	          if (child.scrollWidth > child.offsetWidth) {
	            rightButton.css({ opacity: '100', 'z-index': '70' });
	          }
	          // erase right
	          if (child.scrollLeft + child.offsetWidth >= child.scrollWidth) {
	            rightButton.css({ opacity: '0', 'z-index': '10' });
	          }
	        });
	      }, 200);
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$timeout", function directiveFactory($timeout) {
	      'ngInject';

	      return new HorizontalSlide($timeout);
	    }]
	  }]);

	  return HorizontalSlide;
	}();

	HorizontalSlide.directiveFactory.$inject = ['$timeout'];

	exports.default = HorizontalSlide;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ReportIndicator = function () {
	  function ReportIndicator() {
	    _classCallCheck(this, ReportIndicator);

	    this.restrict = 'E';
	    this.replace = true;
	    this.scope = {
	      lastGps: '@',
	      ignition: '@'
	    };
	  }

	  _createClass(ReportIndicator, [{
	    key: 'link',
	    value: function link(scope, element) {
	      var ign = scope.ignition === '' ? false : angular.fromJson(scope.ignition);
	      var diff = (new Date().valueOf() - new Date(scope.lastGps * 1000)) / 1000;

	      if (diff <= 120 && ign) {
	        return element.append('<span class="report-indicator grn"></span>');
	      } else if (diff > 120 && diff <= 86400 && ign) {
	        return element.append('<span class="report-indicator ylw"></span>');
	      } else if (diff > 86400) {
	        return element.append('<span class="report-indicator red"></span>');
	      }
	      return element.append('<span class="report-indicator gry"></span>');
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new ReportIndicator();
	    }
	  }]);

	  return ReportIndicator;
	}();

	exports.default = ReportIndicator;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EmptyInput = function () {
	  function EmptyInput() {
	    _classCallCheck(this, EmptyInput);

	    this.restrict = 'A';
	    this.require = 'ngModel';
	  }

	  _createClass(EmptyInput, [{
	    key: 'link',
	    value: function link(scope, element, attrs, ctrl) {
	      element.parent().append('<div class="absolute right-4 top-10">' + '<button role="empty" class="no-button" type="button">' + '<i class="text-gray-400 material-symbols-outlined">cancel</i>' + '</button>' + '</div>');

	      element.siblings().find('button').on('click', function () {
	        ctrl.$setViewValue('');
	        ctrl.$render();
	        // scope.$apply()
	      });
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';

	      return new EmptyInput();
	    }
	  }]);

	  return EmptyInput;
	}();

	exports.default = EmptyInput;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.LogsAccordion = LogsAccordion;

	var _dialog = __webpack_require__(30);

	var _quill = __webpack_require__(276);

	var _quill2 = _interopRequireDefault(_quill);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function LogsAccordion() {
	  var directive = {
	    controller: LogsAccordionController,
	    controllerAs: 'ctrl',
	    replace: true,
	    restrict: 'E',
	    templateUrl: 'app/directives/logs-accordion/logs-accordion.html',
	    scope: {
	      items: '=',
	      template: '@'
	    }
	  };

	  return directive;
	}

	var LogsAccordionController = function () {
	  LogsAccordionController.$inject = ["$translate", "DialogService"];
	  function LogsAccordionController($translate, DialogService) {
	    'ngInject';

	    _classCallCheck(this, LogsAccordionController);

	    this.$translate = $translate;
	    this.DialogService = DialogService;

	    this.options = {};
	    this.dialogOpts = _dialog.DIALOG._opts('app/internal/audit/logs/dialog/logs.dialog.html', 'LogsDialogController');
	  }

	  _createClass(LogsAccordionController, [{
	    key: 'formatValue',
	    value: function formatValue(key, value, item) {
	      if (!value) return '-';

	      if (item.model === 'chips') {
	        return this.formatChipsValue(key, value);
	      }

	      if (item.model === 'enterprises') {
	        return this.formatEnterprisesValue(key, value);
	      }

	      if (item.model === 'service_orders' || item.model === 'protocols') {
	        return this.formatServiceOrdersValue(key, value);
	      }

	      if (item.model === 'users') {
	        return this.formatUsersValue(key, value);
	      }

	      if (item.model === 'vehicles') {
	        return this.formatVehiclesValue(key, value);
	      }

	      return value;
	    }
	  }, {
	    key: 'formatChipsValue',
	    value: function formatChipsValue(key, value) {
	      var fullDate = _initial.fullDate();

	      if (fullDate.includes(key)) return moment(value).format(_initial.fullDateFormat);

	      if (key === 'from_softruck') return this.$translate.instant('LOGS.LABEL.CHIPS.' + value.toString().toUpperCase());

	      return value;
	    }
	  }, {
	    key: 'formatEnterprisesValue',
	    value: function formatEnterprisesValue(key, value) {
	      var fullDate = _initial.fullDate();

	      if (fullDate.includes(key)) return moment(value).format(_initial.fullDateFormat);

	      if (key === 'apps') return value.ios + ', ' + value.android;
	      if (key === 'coords') return value.coordinates[0] + ', ' + value.coordinates[1];
	      if (key === 'layout') return this.$translate.instant('LOGS.LABEL.ENTERPRISES.' + value.toUpperCase());
	      if (key === 'model') return this.$translate.instant('LOGS.ENUM.PAGES.' + value.toUpperCase());
	      if (key === 'type') return this.$translate.instant('ADDRESS_FORM.TYPES.' + value.toUpperCase());

	      if (key === 'text') {
	        try {
	          angular.fromJson(value);
	          this.quill = new _quill2.default('#quill-container', {
	            readOnly: true,
	            theme: null
	          });
	          this.quill.setContents(angular.fromJson(value));
	          return this.quill.getText();
	        } catch (e) {
	          return '';
	        }
	      }

	      return value;
	    }
	  }, {
	    key: 'formatServiceOrdersValue',
	    value: function formatServiceOrdersValue(key, value) {
	      var _this = this;

	      var fullDate = _initial.fullDate();

	      if (fullDate.includes(key)) return moment(value).format(_initial.fullDateFormat);

	      if (key === 'config' && angular.isObject(value)) {
	        var text = '';

	        Object.keys(value).forEach(function (k, index) {
	          if (index > 0) {
	            text += '; ';
	          }
	          text += _this.$translate.instant('LOGS.LABEL.SERVICE_ORDERS.' + k.toUpperCase()) + ' ';
	          text += '' + _this.$translate.instant('LOGS.LABEL.SERVICE_ORDERS.' + value[k].toString().toUpperCase());
	        });

	        return text;
	      }

	      if (key === 'priority') {
	        return this.$translate.instant('SERVICE_ORDER.ENUM.PRIORITY.' + value.toUpperCase());
	      }

	      if (key === 'notes' || key === 'description') {
	        this.quill = new _quill2.default('#quill-container', {
	          readOnly: true,
	          theme: null
	        });
	        this.quill.setContents(angular.fromJson(value));
	        return this.quill.getText();
	      }

	      return value;
	    }
	  }, {
	    key: 'formatUsersValue',
	    value: function formatUsersValue(key, value) {
	      var fullDate = _initial.fullDate();
	      var shortDate = _initial.shortDate();

	      if (fullDate.includes(key)) return moment(value).format(_initial.fullDateFormat);

	      if (shortDate.includes(key)) return moment(value).format(_initial.shortDateFormat);

	      if (key === 'coords') return value.coordinates[0] + ', ' + value.coordinates[1];
	      if (key === 'locale') return this.$translate.instant('LOGS.LABEL.USERS.' + value.toUpperCase());
	      if (key === 'model') return this.$translate.instant('LOGS.ENUM.PAGES.' + value.toUpperCase());
	      if (key === 'type') return this.$translate.instant('ADDRESS_FORM.TYPES.' + value.toUpperCase());
	      if (key === 'user_type') return this.$translate.instant('USERS.ENUM.ROLE.' + value.toUpperCase());

	      return value;
	    }
	  }, {
	    key: 'formatVehiclesValue',
	    value: function formatVehiclesValue(key, value) {
	      var fullDate = _initial.fullDate();

	      if (fullDate.includes(key)) return moment(value).format(_initial.fullDateFormat);

	      return value;
	    }
	  }, {
	    key: 'modelData',
	    value: function modelData(item) {
	      var _this2 = this;

	      if (item.modelKey) return;
	      item.modelKey = [];
	      item.modelValues = [];
	      item.model = item.relationships.model.type;

	      if (!item.attributes.model_data || !item.attributes.model_data.attributes) return;

	      var subModel = item.relationships.sub_models ? item.relationships.sub_models[0].type : null;
	      var keysToShow = this.resolveKeysOrder(item.model, subModel);
	      var attributes = item.attributes.model_data.attributes;

	      item.modelKey = Object.keys(attributes).filter(function (key) {
	        return keysToShow.includes(key);
	      }).sort(function (a, b) {
	        return _this2.organizeHeaders(a, b, item.model, subModel);
	      });
	      item.modelValues = item.modelKey.map(function (key) {
	        return attributes[key];
	      });
	    }
	  }, {
	    key: 'openHistory',
	    value: function openHistory(item) {
	      this.DialogService.openDialog(this.dialogOpts, item);
	    }
	  }, {
	    key: 'organizeHeaders',
	    value: function organizeHeaders(a, b, model, submodel) {
	      var priorityOrder = this.resolveKeysOrder(model, submodel);

	      var isAIncluded = priorityOrder.includes(a);
	      var isBIncluded = priorityOrder.includes(b);

	      if (isAIncluded && isBIncluded) {
	        return priorityOrder.indexOf(a) - priorityOrder.indexOf(b);
	      } else if (isAIncluded) {
	        return -1;
	      } else if (isBIncluded) {
	        return 1;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: 'resolveKeysOrder',
	    value: function resolveKeysOrder(model, submodel) {
	      var keysModel = submodel || 'main';
	      var priorityOrder = [];

	      if (submodel === 'addresses') {
	        priorityOrder = _initial.addresses();
	      } else {
	        priorityOrder = _initial[model] && _initial[model][keysModel] && angular.isFunction(_initial[model][keysModel].keysOrder) ? _initial[model][keysModel].keysOrder() : [];
	      }

	      return priorityOrder;
	    }
	  }]);

	  return LogsAccordionController;
	}();

	var _initial = {
	  addresses: function addresses() {
	    return ['type', 'street', 'street_number', 'complement', 'city', 'region', 'region_short', 'country', 'country_code', 'continent_code', 'zip_code', 'formatted_address', 'coords', 'description', 'model', 'order', 'created_at', 'updated_at'];
	  },
	  fullDate: function fullDate() {
	    return ['created_at', 'updated_at', 'deactivated_at', 'reset_session_at', 'verification_code_expired_at', 'completed_at', 'due_date', 'last_integration_time'];
	  },
	  fullDateFormat: 'DD/MM/YYYY HH:mm:ss',
	  shortDate: function shortDate() {
	    return ['birthdate'];
	  },
	  shortDateFormat: 'DD/MM/YYYY',
	  chips: {
	    main: {
	      keysOrder: function keysOrder() {
	        return ['serial', 'number', 'service_provider', 'carrier', 'apn', 'apn_username', 'apn_password', 'pin', 'puk', 'plan_size', 'status', 'batch', 'from_softruck', 'last_integration_time', 'last_integration_source', 'created_at', 'updated_at', 'archived_at'];
	      }
	    }
	  },
	  enterprises: {
	    customizations: {
	      keysOrder: function keysOrder() {
	        return ['domain', 'color1', 'color2', 'apps', 'layout', 'created_at', 'updated_at'];
	      }
	    },
	    custom_filters: {
	      keysOrder: function keysOrder() {
	        return ['name', 'model', 'created_at', 'updated_at'];
	      }
	    },
	    main: {
	      keysOrder: function keysOrder() {
	        return ['name', 'fantasy_name', 'cnpj', 'state_registration_no', 'email', 'contact_name', 'phone1', 'phone2', 'assistance_emergency_tel', 'theft_emergency_tel', 'webpage', 'timezone', 'description', 'last_integration_time', 'last_integration_source', 'comunication_config', 'created_at', 'updated_at', 'archived_at', 'deactivated_at'];
	      }
	    },
	    terms: {
	      keysOrder: function keysOrder() {
	        return ['name', 'text', 'created_at', 'updated_at'];
	      }
	    }
	  },
	  protocols: {
	    main: {
	      keysOrder: function keysOrder() {
	        return ['token', 'due_date', 'priority', 'notes', 'description', 'completed_at', 'config', 'name', 'order', 'created_at', 'updated_at'];
	      }
	    }
	  },
	  service_orders: {
	    main: {
	      keysOrder: function keysOrder() {
	        return ['token', 'due_date', 'priority', 'notes', 'description', 'completed_at', 'config', 'name', 'order', 'created_at', 'updated_at'];
	      }
	    }
	  },
	  users: {
	    main: {
	      keysOrder: function keysOrder() {
	        return ['name', 'username', 'email', 'document_number', 'cpf', 'document_type', 'birthdate', 'phone1', 'phone2', 'emergency_contact', 'emergency_phone', 'user_type', 'locale', 'last_integration_time', 'last_integration_source', 'external_identification', 'created_at', 'updated_at', 'archived_at', 'deactivated_at'];
	      }
	    }
	  },
	  vehicles: {
	    main: {
	      keysOrder: function keysOrder() {
	        return ['plate', 'vin', 'code', 'brand', 'model', 'year', 'trim', 'color', 'description', 'registration_number', 'batch', 'last_integration_time', 'last_integration_source', 'created_at', 'updated_at', 'archived_at', 'deactivated_at'];
	      }
	    }
	  }
	};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.Pagination = Pagination;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function Pagination() {
	  var directive = {
	    controller: PaginationController,
	    controllerAs: 'ctrl',
	    replace: true,
	    restrict: 'E',
	    templateUrl: 'app/directives/pagination/pagination.html',
	    scope: {
	      count: '=',
	      current: '=',
	      limit: '=',
	      paginate: '&'
	    }
	  };

	  return directive;
	}

	var PaginationController = function () {
	  PaginationController.$inject = ["$scope"];
	  function PaginationController($scope) {
	    'ngInject';

	    _classCallCheck(this, PaginationController);

	    this.$scope = $scope;
	  }

	  _createClass(PaginationController, [{
	    key: 'current',
	    value: function current() {
	      if (this.$scope.current === 1) return 1;
	      return (this.$scope.current - 1) * this.$scope.limit + 1;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      if (this.$scope.limit * this.$scope.current >= this.$scope.count) return;
	      this.$scope.paginate({ page: this.$scope.current + 1 });
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      if (this.$scope.current === 1) return;
	      this.$scope.paginate({ page: this.$scope.current - 1 });
	    }
	  }, {
	    key: 'total',
	    value: function total() {
	      if (this.$scope.current === 1) return this.$scope.limit < this.$scope.count ? this.$scope.limit : this.$scope.count;
	      if (this.$scope.current <= Math.floor(this.$scope.count / this.$scope.limit)) return this.$scope.limit * this.$scope.current;
	      return this.$scope.count;
	    }
	  }]);

	  return PaginationController;
	}();

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.UserAssetPermissions = UserAssetPermissions;

	var _constants = __webpack_require__(9);

	var _dialog = __webpack_require__(30);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function UserAssetPermissions() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/user-asset-permissions/user-asset-permissions.html',
	    replace: true,
	    controller: UserAssetPermissionsController,
	    controllerAs: 'ctrl',
	    scope: {
	      asset: '='
	    }
	  };
	  return directive;
	}

	var UserAssetPermissionsController = function () {
	  UserAssetPermissionsController.$inject = ["$scope", "DialogService", "MainService", "$window"];
	  function UserAssetPermissionsController($scope, DialogService, MainService, $window) {
	    'ngInject';

	    _classCallCheck(this, UserAssetPermissionsController);

	    this.$scope = $scope;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    var role = this.$window.localStorage.getItem('role');

	    if ([].concat(_toConsumableArray(_constants.ROLES.INTERNALS), _toConsumableArray(_constants.ROLES.MANAGER), _toConsumableArray(_constants.ROLES.READ_ONLY)).includes(role)) {
	      this.getUsersFromAssets(this.$scope.asset.id);
	    }
	  }

	  _createClass(UserAssetPermissionsController, [{
	    key: 'getUsersFromAssets',
	    value: function getUsersFromAssets(id) {
	      var _this = this;

	      this.loading = true;
	      var obj = {
	        includes: {
	          user: ['name', 'username', 'email', 'phone1', 'deactivated_at']
	        },
	        filters: {
	          deleted_at: { operator: 'is', value: null }
	        },
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: 1,
	        count: true,
	        limit: 10
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + id + '/associations/users', obj).promise.then(function (res) {
	        _this.loading = false;
	        _this.users = res.data;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState(item) {
	      var _this2 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);
	      var action = item.relationships.user.attributes.deactivated_at ? 'activation' : 'deactivation';
	      var obj = {
	        data: [{
	          type: 'users',
	          id: item.relationships.user.id
	        }]
	      };

	      this.DialogService.openDialog(opt, { title: 'ACTIVATION', label: 'USER_ACTIVATION', action: 'save' }).then(function () {
	        _this2.MainService.edit(_constants.API.V5, _constants.API.USERS + '/set-activation/' + action, obj).promise.then(function () {
	          item.relationships.user.attributes.deactivated_at = item.relationships.user.attributes.deactivated_at ? null : new Date();
	        });
	      }).catch(function () {
	        item.relationships.user.attributes.deactivated_at = item.relationships.user.attributes.deactivated_at ? new Date() : null;
	      });
	    }
	  }, {
	    key: 'removeUser',
	    value: function removeUser(item, index) {
	      var _this3 = this;

	      var opt = _dialog.DIALOG._opts(_dialog.DIALOG.CONFIRMATION_ACTION.path, _dialog.DIALOG.CONFIRMATION_ACTION.ctrl);

	      this.DialogService.openDialog(opt, { title: 'USER_PERMISSION', label: 'USER_PERMISSION', action: 'save' }).then(function () {
	        var obj = {
	          data: [{
	            type: 'user_permission',
	            id: item.id
	          }]
	        };

	        _this3.MainService.deleteMany(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {
	          _this3.users.splice(index, 1);
	        });
	      });
	    }
	  }, {
	    key: 'openDialogUsers',
	    value: function openDialogUsers() {
	      var _this4 = this;

	      var opt = _dialog.DIALOG._opts('app/components/new-item/add-user.html', 'AddNewItemController');

	      this.DialogService.openDialog(opt).then(function (res) {
	        var obj = {
	          data: [{
	            user_id: res.id,
	            asset_id: _this4.selectedItem.relationships.vehicles[0].id
	          }]
	        };

	        _this4.MainService.create(_constants.API.V5, _constants.API.VEHICLES + '/associations/users', obj).promise.then(function () {});
	      });
	    }
	  }]);

	  return UserAssetPermissionsController;
	}();

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.DeviceAssetAssociation = DeviceAssetAssociation;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function DeviceAssetAssociation() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/device-asset-association/device-asset-association.html',
	    replace: true,
	    controller: DeviceAssetAssociationController,
	    controllerAs: 'ctrl',
	    scope: {
	      asset: '='
	    }
	  };
	  return directive;
	}

	var DeviceAssetAssociationController = function () {
	  DeviceAssetAssociationController.$inject = ["$scope", "DialogService", "MainService"];
	  function DeviceAssetAssociationController($scope, DialogService, MainService) {
	    'ngInject';

	    _classCallCheck(this, DeviceAssetAssociationController);

	    this.$scope = $scope;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.getUsersFromAssets(this.$scope.asset.id);
	  }

	  _createClass(DeviceAssetAssociationController, [{
	    key: 'getUsersFromAssets',
	    value: function getUsersFromAssets(id) {
	      var _this = this;

	      this.loading = { users: true };
	      var obj = {
	        includes: {
	          user: ['name', 'username', 'email', 'phone1', 'deactivated_at']
	        },
	        filters: {
	          deleted_at: { operator: 'is', value: null }
	        },
	        sort: {
	          prop: 'created_at',
	          order: 'DESC'
	        },
	        page: 1,
	        count: true,
	        limit: 10
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES + '/' + id + '/associations/users', obj).promise.then(function (res) {
	        _this.loading = { users: false };
	        _this.users = res.data;
	      }).catch(function () {
	        _this.loading = { users: false };
	      });
	    }
	  }]);

	  return DeviceAssetAssociationController;
	}();

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.ChipsAutocomplete = ChipsAutocomplete;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function ChipsAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/chips-autocomplete/chips.html',
	    replace: true,
	    controller: ChipsAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      form: '=', // required
	      searchText: '=', // required
	      selectedItem: '=', // required
	      filters: '='
	    }
	  };

	  return directive;
	}

	var ChipsAutocompleteController = function () {
	  ChipsAutocompleteController.$inject = ["$scope", "MainService"];
	  function ChipsAutocompleteController($scope, MainService) {
	    'ngInject';

	    _classCallCheck(this, ChipsAutocompleteController);

	    this.$scope = $scope;
	    this.MainService = MainService;
	  }

	  _createClass(ChipsAutocompleteController, [{
	    key: 'getChips',
	    value: function getChips(query) {
	      var _this = this;

	      var scopeFilters = this.$scope.filters || {};
	      var filters = Object.assign({}, scopeFilters);

	      var obj = {
	        attributes: ['serial,number,service_provider,carrier'],
	        filters: filters,
	        search: query
	      };

	      if (angular.equals(this.previousQuery, obj)) return this.previousData;
	      this.previousQuery = angular.copy(obj);

	      return this.MainService.raw(_constants.API.V5, _constants.API.CHIPS, obj).promise.then(function (res) {
	        _this.previousData = res.data;
	        return res.data;
	      });
	    }
	  }]);

	  return ChipsAutocompleteController;
	}();

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.DevicesAutocomplete = DevicesAutocomplete;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function DevicesAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/devices-autocomplete/devices.html',
	    replace: true,
	    controller: DevicesAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      form: '=', // required
	      searchText: '=', // required
	      selectedItem: '=', // required
	      autoFocus: '=',
	      clearButton: '=',
	      filters: '=',
	      hideLabel: '=',
	      includes: '=',
	      labelText: '@',
	      onItemChange: '&',
	      requiredItem: '='
	    }
	  };
	  return directive;
	}

	var DevicesAutocompleteController = function () {
	  DevicesAutocompleteController.$inject = ["$scope", "EnvironmentConfig", "MainService"];
	  function DevicesAutocompleteController($scope, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, DevicesAutocompleteController);

	    this.$scope = $scope;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.required = angular.isDefined(this.$scope.requiredItem) ? this.$scope.requiredItem : true;
	  }

	  _createClass(DevicesAutocompleteController, [{
	    key: 'getDevices',
	    value: function getDevices(query) {
	      var _this = this;

	      var defaultIncludes = {
	        type: ['brand_alias,alias'],
	        vehicle: ['plate,type_name']
	      };
	      var scopeFilters = this.$scope.filters || {};
	      var scopeIncludes = this.$scope.includes || {};
	      var filters = Object.assign({}, scopeFilters);
	      var includes = Object.assign({}, defaultIncludes, scopeIncludes);

	      var obj = {
	        attributes: ['name,imei'],
	        filters: filters,
	        includes: includes,
	        search: query
	      };

	      if (angular.equals(this.previousQuery, obj)) return this.previousData;
	      this.previousQuery = angular.copy(obj);
	      return this.MainService.raw(_constants.API.V5, _constants.API.DEVICES, obj).promise.then(function (res) {
	        _this.previousData = res.data;
	        return res.data;
	      });
	    }
	  }]);

	  return DevicesAutocompleteController;
	}();

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.DeviceModelAutocomplete = DeviceModelAutocomplete;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function DeviceModelAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/device-model-autocomplete/device-model.html',
	    replace: true,
	    controller: DeviceModelAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      selectedItem: '=', // required
	      searchText: '=', // required
	      form: '=' // required
	    }
	  };

	  return directive;
	}

	var DeviceModelAutocompleteController = function () {
	  DeviceModelAutocompleteController.$inject = ["MainService"];
	  function DeviceModelAutocompleteController(MainService) {
	    'ngInject';

	    _classCallCheck(this, DeviceModelAutocompleteController);

	    this.MainService = MainService;
	  }

	  _createClass(DeviceModelAutocompleteController, [{
	    key: 'getDeviceType',
	    value: function getDeviceType(query) {
	      var obj = {
	        attributes: ['alias,supported,brand_alias,type,protocol'],
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, 'devices/models', obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }]);

	  return DeviceModelAutocompleteController;
	}();

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.EnterprisesAutocomplete = EnterprisesAutocomplete;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function EnterprisesAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/enterprises-autocomplete/enterprises.html',
	    replace: true,
	    controller: EnterprisesAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      selectedItem: '=', // required
	      searchText: '=', // required
	      form: '=', // required
	      onItemChange: '&',
	      requiredItem: '=',
	      disabledItem: '=',
	      minLength: '=',
	      clearButton: '=',
	      includes: '='
	    }
	  };

	  return directive;
	}

	var EnterprisesAutocompleteController = function () {
	  EnterprisesAutocompleteController.$inject = ["$scope", "EnvironmentConfig", "MainService"];
	  function EnterprisesAutocompleteController($scope, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, EnterprisesAutocompleteController);

	    this.$scope = $scope;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.required = angular.isDefined(this.$scope.requiredItem) ? this.$scope.requiredItem : true;
	    this.minLength = angular.isDefined(this.$scope.minLength) ? this.$scope.minLength : 2;
	  }

	  _createClass(EnterprisesAutocompleteController, [{
	    key: 'getEnterprises',
	    value: function getEnterprises(query) {
	      var _this = this;

	      var defaultIncludes = {
	        document: ['folder']
	      };
	      var scopeIncludes = this.$scope.includes || {};
	      var includes = Object.assign({}, defaultIncludes, scopeIncludes);

	      var obj = {
	        attributes: ['name,cnpj,email,phone1'],
	        includes: includes,
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES, obj).promise.then(function (res) {
	        var data = res.data;

	        data.forEach(function (i) {
	          if (i.relationships.document) {
	            i.relationships.document.attributes.folder = _this.EnvironmentConfig.MEDIA + '/' + i.relationships.document.attributes.folder;
	          }
	        });
	        return data;
	      });
	    }
	  }]);

	  return EnterprisesAutocompleteController;
	}();

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.UsersAutocomplete = UsersAutocomplete;

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function UsersAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/users-autocomplete/users.html',
	    transclude: true,
	    replace: true,
	    controller: UsersAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      form: '=', // required
	      searchText: '=', // required
	      selectedItem: '=', // required
	      autoFocus: '=',
	      clearButton: '=',
	      disabledItem: '=',
	      filters: '=',
	      hideLabel: '=',
	      labelText: '@',
	      minLength: '=',
	      onItemChange: '&',
	      requiredItem: '='
	    }
	  };

	  return directive;
	}

	var UsersAutocompleteController = function () {
	  UsersAutocompleteController.$inject = ["$scope", "EnvironmentConfig", "MainService"];
	  function UsersAutocompleteController($scope, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, UsersAutocompleteController);

	    this.$scope = $scope;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.required = angular.isDefined(this.$scope.requiredItem) ? this.$scope.requiredItem : true;
	    this.minLength = angular.isDefined(this.$scope.minLength) ? this.$scope.minLength : 2;
	  }

	  _createClass(UsersAutocompleteController, [{
	    key: 'getUsers',
	    value: function getUsers(query) {
	      var _this = this;

	      var scopeFilters = this.$scope.filters || {};

	      var filters = Object.assign({}, scopeFilters);

	      var obj = {
	        attributes: ['name,cpf,email,phone1'],
	        filters: filters,
	        includes: {
	          roles: ['name']
	        },
	        search: query
	      };
	      if (angular.equals(this.previousQuery, obj)) return this.previousData;
	      this.previousQuery = angular.copy(obj);

	      return this.MainService.raw(_constants.API.V5, _constants.API.USERS, obj).promise.then(function (res) {
	        _this.previousData = res.data;
	        return res.data;
	      });
	    }
	  }]);

	  return UsersAutocompleteController;
	}();

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.VehiclesAutocomplete = VehiclesAutocomplete;

	var _constants = __webpack_require__(9);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function VehiclesAutocomplete() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/form/vehicles-autocomplete/vehicles.html',
	    replace: true,
	    controller: VehiclesAutocompleteController,
	    controllerAs: 'ctrl',
	    scope: {
	      form: '=', // required
	      selectedItem: '=', // required
	      searchText: '=', // required
	      autoFocus: '=',
	      attributes: '=',
	      clearButton: '=',
	      disabledItem: '=',
	      filters: '=',
	      hideLabel: '=',
	      includes: '=',
	      minLength: '=',
	      onItemChange: '&',
	      requiredItem: '='
	    }
	  };
	  return directive;
	}

	var VehiclesAutocompleteController = function () {
	  VehiclesAutocompleteController.$inject = ["$scope", "MainService"];
	  function VehiclesAutocompleteController($scope, MainService) {
	    'ngInject';

	    _classCallCheck(this, VehiclesAutocompleteController);

	    this.$scope = $scope;
	    this.MainService = MainService;

	    this.required = angular.isDefined(this.$scope.requiredItem) ? this.$scope.requiredItem : true;
	    this.minLength = angular.isDefined(this.$scope.minLength) ? this.$scope.minLength : 2;
	  }

	  _createClass(VehiclesAutocompleteController, [{
	    key: 'getVehicles',
	    value: function getVehicles(query) {
	      var _this = this;

	      var scopeAttributes = this.$scope.attributes || [];
	      var scopeFilters = this.$scope.filters || {};
	      var scopeIncludes = this.$scope.includes || {};

	      var filters = Object.assign({}, scopeFilters);
	      var includes = Object.assign({}, scopeIncludes);
	      var attributes = ['plate,vin,brand_name,trim_name,type_name,year'].concat(_toConsumableArray(scopeAttributes));

	      var obj = {
	        attributes: attributes,
	        filters: filters,
	        includes: includes,
	        search: query
	      };

	      if (angular.equals(this.previousQuery, obj)) return this.previousData;
	      this.previousQuery = angular.copy(obj);

	      return this.MainService.raw(_constants.API.V5, _constants.API.VEHICLES, obj).promise.then(function (res) {
	        _this.previousData = res.data;
	        return res.data;
	      });
	    }
	  }]);

	  return VehiclesAutocompleteController;
	}();

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.AdvancedFilter = AdvancedFilter;

	var _constants = __webpack_require__(9);

	var _queryOptions = __webpack_require__(236);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function AdvancedFilter() {
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/directives/advanced-filter/advanced-filter.html',
	    replace: true,
	    controller: AdvancedFilterController,
	    controllerAs: 'ctrl',
	    scope: {
	      btnText: '@',
	      filterOutput: '&',
	      model: '=',
	      relativeDate: '=',
	      selectedFilters: '='
	    }
	  };

	  return directive;
	}

	var AdvancedFilterController = function () {
	  AdvancedFilterController.$inject = ["$scope", "$timeout", "MainService"];
	  function AdvancedFilterController($scope, $timeout, MainService) {
	    'ngInject';

	    _classCallCheck(this, AdvancedFilterController);

	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.MainService = MainService;

	    this.filters = _queryOptions.FILTERS[this.$scope.model];
	    this.filterOperators = _queryOptions.FILTERS_OPERATORS;
	    this.btnText = this.$scope.btnText || 'SEARCH';
	    this.intervals = internals.dateIntervals();
	    this.hasCount = ['users', 'vehicles', 'chips', 'devices', 'enterprises', 'protocols', 'service-orders'].includes(this.$scope.model);
	    this.debounceTimeout = null;
	    this.count = -1;

	    this.initializeFilterState();
	  }

	  _createClass(AdvancedFilterController, [{
	    key: 'initializeFilterState',
	    value: function initializeFilterState() {
	      var _this = this;

	      this.filters.forEach(function (f) {
	        f.selected = false;
	      });
	      if (this.$scope.relativeDate) {
	        this.filterOperators.shortdate = this.filterOperators.shortdate.filter(function (op) {
	          return op !== 'btw' && op !== 'nbtw' && op !== 'neq';
	        });
	        this.filterOperators.date = angular.copy(this.filterOperators.date.filter(function (op) {
	          return op !== 'btw' && op !== 'nbtw';
	        }));
	        if (!this.filterOperators.date.includes('eq')) {
	          this.filterOperators.date.unshift('eq');
	        }
	      }

	      if (angular.isObject(this.$scope.selectedFilters) && Object.keys(this.$scope.selectedFilters).length > 0) {
	        Object.keys(this.$scope.selectedFilters).forEach(function (k) {
	          var filter = _this.filters.find(function (f) {
	            return f.key === k;
	          });
	          if (filter) {
	            filter.selected = true;
	          }
	          var type = _this.$scope.selectedFilters[k].type;
	          if (_this.$scope.relativeDate && (type === 'shortdate' || type === 'date')) {
	            var obj = _this.decodeDate(_this.$scope.selectedFilters[k].value);
	            Object.assign(_this.$scope.selectedFilters[k], obj);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'mountFilter',
	    value: function mountFilter(tag) {
	      tag.selected = true;
	      if (!(tag.key in this.$scope.selectedFilters)) {
	        this.$scope.selectedFilters[tag.key] = { operator: null, value: null, type: tag.type, options: tag.options, transform: tag.utc };
	      }
	    }
	  }, {
	    key: 'updateFilterValues',
	    value: function updateFilterValues(k) {
	      var _this2 = this;

	      this.$scope.selectedFilters[k].value = this.$scope.selectedFilters[k].value1 + ',' + this.$scope.selectedFilters[k].value2;

	      if (this.debounceTimeout) {
	        this.$timeout.cancel(this.debounceTimeout);
	      }

	      this.debounceTimeout = this.$timeout(function () {
	        _this2.getCount();
	      }, 1000);
	    }
	  }, {
	    key: 'removeField',
	    value: function removeField(key) {
	      this.filters.forEach(function (f) {
	        if (f.key === key) {
	          f.selected = false;
	        }
	      });
	      delete this.$scope.selectedFilters[key];
	    }
	  }, {
	    key: 'emptySelection',
	    value: function emptySelection() {
	      return Object.keys(this.$scope.selectedFilters).length === 0;
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount() {
	      var _this3 = this;

	      var _$scope = this.$scope,
	          selectedFilters = _$scope.selectedFilters,
	          relativeDate = _$scope.relativeDate,
	          model = _$scope.model;


	      if (!angular.isObject(selectedFilters) || Object.keys(selectedFilters).length === 0) {
	        this.count = -1;
	        this.countLoading = false;
	        this.showCount = false;
	        return;
	      }

	      if (relativeDate || !this.hasCount || !this.form.$valid) return;

	      this.countLoading = true;
	      this.triggerSearch(false);

	      var query = { filters: this.$scope.selectedFilters };

	      this.MainService.raw(_constants.API.V5, model + '/count', query).promise.then(function (res) {
	        _this3.showCount = true;
	        _this3.count = res.count;
	      }).catch(function () {
	        _this3.showCount = false;
	      }).finally(function () {
	        _this3.countLoading = false;
	        _this3.form.$setPristine();
	      });
	    }
	  }, {
	    key: 'triggerSearch',
	    value: function triggerSearch() {
	      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      if (this.hasCount && !this.$scope.relativeDate && this.form.$dirty) return;

	      for (var key in this.$scope.selectedFilters) {
	        if (!this.$scope.relativeDate && this.$scope.selectedFilters[key].type === 'date' && this.$scope.selectedFilters[key].transform) {
	          var dates = this.$scope.selectedFilters[key].value.split(',');
	          if (dates.length === 2) {
	            this.$scope.selectedFilters[key].value = moment(dates[0]).utc().format('YYYY-MM-DD HH:mm:ss') + ',' + moment(dates[1]).utc().format('YYYY-MM-DD HH:mm:ss');
	          } else {
	            this.$scope.selectedFilters[key].value = moment(this.$scope.selectedFilters[key].value).utc().format('YYYY-MM-DD HH:mm:ss');
	          }
	        }
	        if (this.$scope.selectedFilters[key].selectedDate) {
	          this.relativeValues(this.$scope.selectedFilters[key]);
	          delete this.$scope.selectedFilters[key].selectedDate;
	          delete this.$scope.selectedFilters[key].relativeDate;
	        }
	      }
	      if (close) {
	        this.$scope.filterOutput({ filter: this.$scope.selectedFilters });
	      }
	    }
	  }, {
	    key: 'decodeDate',
	    value: function decodeDate(item) {
	      if (!angular.isArray(item) && (item.length !== 2 || item.length !== 3)) return {};

	      var relativeDate = internals.dateIntervals().filter(function (o) {
	        return o.type === item[0];
	      })[0];
	      var selectedDate = angular.toJson(relativeDate);

	      if (item.length === 3) {
	        if (item[2] === 'prev') {
	          relativeDate.value = '-2';
	          relativeDate.prev = item[1] * -1;
	        } else {
	          relativeDate.value = '2';
	          relativeDate.next = item[1];
	        }
	      } else {
	        relativeDate.value = item[1];
	      }

	      return { relativeDate: relativeDate, selectedDate: selectedDate };
	    }
	  }, {
	    key: 'emptyFilters',
	    value: function emptyFilters() {
	      this.filters.forEach(function (f) {
	        f.selected = false;
	      });
	      this.$scope.selectedFilters = {};
	    }
	  }, {
	    key: 'selectInterval',
	    value: function selectInterval(item) {
	      item.relativeDate = angular.fromJson(item.selectedDate);
	    }
	  }, {
	    key: 'relativeValues',
	    value: function relativeValues(item) {
	      var selected = item.relativeDate;
	      var period = +selected.value;

	      switch (period) {
	        case -2:
	          item.value = [selected.type, selected.prev * -1, 'prev'];
	          break;
	        case 2:
	          item.value = [selected.type, +selected.next, 'next'];
	          break;
	        default:
	          item.value = [selected.type, period];
	          break;
	      }
	    }
	  }]);

	  return AdvancedFilterController;
	}();

	var internals = {
	  dateIntervals: function dateIntervals() {
	    return [{
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'hours',
	      value: -1
	    }, {
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'days',
	      value: -1
	    }, {
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'weeks',
	      value: -1
	    }, {
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'months',
	      value: -1
	    }, {
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'quarters',
	      value: -1
	    }, {
	      next: 1,
	      op: 'gt',
	      prev: 1,
	      type: 'years',
	      value: -1
	    }];
	  }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.CustomFieldsForm = CustomFieldsForm;

	var _helper = __webpack_require__(21);

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function CustomFieldsForm() {
	  var directive = {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    scope: {
	      create: '=',
	      customClassCss: '@',
	      enterprise: '=',
	      enterpriseShow: '=',
	      item: '=', // Required
	      readOnly: '=',
	      returnContent: '=',
	      saved: '<'
	    },
	    templateUrl: 'app/directives/custom-fields-form/custom-fields-form.html',
	    controllerAs: 'ctrl',
	    controller: CustomFieldsFormController
	  };
	  return directive;
	}

	var CustomFieldsFormController = function () {
	  CustomFieldsFormController.$inject = ["$scope", "$state", "EnvironmentConfig", "MainService"];
	  function CustomFieldsFormController($scope, $state, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, CustomFieldsFormController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.MainService = MainService;
	    this.EnvironmentConfig = EnvironmentConfig;

	    this.item = this.$scope.item;
	    this.readOnly = this.$scope.readOnly || false;
	    this.returnContent = this.$scope.returnContent || false;
	    this.selectedEnterprise = this.$scope.enterprise;
	    this.showEnterprise = angular.isDefined(this.$scope.enterpriseShow) ? this.$scope.enterpriseShow : true;

	    this.formats = _constants.TASK_CUSTOM_FIELDS_FORMATS;
	  }

	  _createClass(CustomFieldsFormController, [{
	    key: 'formValidation',
	    value: function formValidation() {
	      this.form.new_value.$setValidity('required', this.item.attributes.possible_values.length > 1);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      if (this.item.attributes.field_format === 'enum' || this.item.attributes.field_format === 'checkbox') {
	        this.formValidation();
	      } else {
	        this.item.attributes.possible_values = [];
	      }
	      if (!this.form.$valid) return;
	      this.processing = true;

	      var item = {
	        data: {
	          attributes: {
	            name: this.item.attributes.name,
	            cluster: this.item.attributes.cluster,
	            field_format: this.item.attributes.field_format,
	            possible_values: this.item.attributes.possible_values,
	            is_required: this.item.attributes.is_required,
	            order: this.item.attributes.order || null
	          }
	        }
	      };
	      var enterprise = {};

	      if (this.selectedEnterprise) {
	        enterprise.enterprise = {
	          type: 'enterprise',
	          id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	        };
	      }

	      if (this.returnContent) {
	        this.processing = false;
	        this.$scope.saved(item);
	      } else {
	        if (this.$state.current.name === 'catalogs.item-edit') {
	          (0, _helper.cleanPayload)(item.data);
	          this.MainService.update(_constants.API.V5, _constants.API.CHECKLISTS + '/items', this.$state.params.id, item).promise.then(function () {
	            _this.processing = false;
	          }).finally(function () {
	            _this.processing = false;
	          });
	        } else {
	          if (this.selectedEnterprise) {
	            item.data.relationships = enterprise;
	          }

	          (0, _helper.cleanPayload)(item.data, true);
	          this.MainService.create(_constants.API.V5, _constants.API.CHECKLISTS + '/items', item).promise.then(function (res) {
	            if (_this.$state.current.name === 'catalogs.item-create') {
	              _this.$state.go('catalogs.item-edit', { id: res.data.id }, { notify: false });
	            } else {
	              _this.item = internals._initialAddItems();
	              _this.form.$setPristine();
	            }
	          }).finally(function () {
	            _this.processing = false;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'enterAddPossibleValue',
	    value: function enterAddPossibleValue(event) {
	      if (event.keyCode === 13) {
	        event.preventDefault();
	        this.addPossibleValue();
	      }
	    }
	  }, {
	    key: 'validateRepeat',
	    value: function validateRepeat() {
	      if (!this.item.attributes.new_value) {
	        this.form.new_value.$setValidity('repeat', !this.item.attributes.new_value);
	      }
	    }
	  }, {
	    key: 'addPossibleValue',
	    value: function addPossibleValue() {
	      if (!this.item.attributes.new_value) {
	        return;
	      }
	      if (!this.item.attributes.possible_values) {
	        this.item.attributes.possible_values = [];
	      }

	      var valuesLowCase = this.item.attributes.possible_values.map(function (text) {
	        return text.toLowerCase();
	      });
	      var repeatItem = valuesLowCase.includes(this.item.attributes.new_value.toLowerCase());
	      this.form.new_value.$setValidity('repeat', !repeatItem);
	      if (repeatItem) {
	        return;
	      }

	      this.item.attributes.possible_values.push(this.item.attributes.new_value);
	      this.formValidation();
	      this.item.attributes.new_value = null;
	    }
	  }, {
	    key: 'removePossibleValue',
	    value: function removePossibleValue(index) {
	      this.item.attributes.possible_values.splice(index, 1);
	      this.formValidation();
	    }
	  }]);

	  return CustomFieldsFormController;
	}();

	var internals = {
	  _initialAddItems: function _initialAddItems() {
	    return {
	      attributes: {
	        possible_values: [],
	        field_format: 'text',
	        is_required: true
	      }
	    };
	  }
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _acc = __webpack_require__(300);

	var _acc2 = _interopRequireDefault(_acc);

	var _fileIcon = __webpack_require__(301);

	var _fileIcon2 = _interopRequireDefault(_fileIcon);

	var _fontIcon = __webpack_require__(269);

	var _fontIcon2 = _interopRequireDefault(_fontIcon);

	var _humanize = __webpack_require__(302);

	var _humanize2 = _interopRequireDefault(_humanize);

	var _timeToString = __webpack_require__(303);

	var _timeToString2 = _interopRequireDefault(_timeToString);

	var _device = __webpack_require__(304);

	var _device2 = _interopRequireDefault(_device);

	var _application = __webpack_require__(305);

	var _application2 = _interopRequireDefault(_application);

	var _phone = __webpack_require__(306);

	var _phone2 = _interopRequireDefault(_phone);

	var _unique = __webpack_require__(307);

	var _unique2 = _interopRequireDefault(_unique);

	var _trust = __webpack_require__(308);

	var _trust2 = _interopRequireDefault(_trust);

	var _floatToTime = __webpack_require__(62);

	var _floatToTime2 = _interopRequireDefault(_floatToTime);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.filters', []).filter('accOn', _acc2.default).filter('mime', _fileIcon2.default).filter('mimeFont', _fontIcon2.default).filter('humanizeDate', _humanize2.default).filter('timeToString', _timeToString2.default).filter('applicationUserAgent', _application2.default).filter('deviceUserAgent', _device2.default).filter('phoneFilter', _phone2.default).filter('unique', _unique2.default).filter('trust', _trust2.default).filter('floatToTime', _floatToTime2.default);

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = accOn;
	function accOn() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return;
	    }

	    return moment(input.toString()).format('DD/MM/YYYY');
	  };
	}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mime;
	function mime() {
	  'use strict';

	  return function (input) {
	    var type = 'unknown';

	    if (input == null) {
	      type = 'unknown';
	    } else if (input.indexOf('spreadsheet') > -1 || input.indexOf('ms-excel') > -1) {
	      type = 'xls';
	    } else if (input.indexOf('presentation') > -1 || input.indexOf('ms-powerpoint') > -1) {
	      type = 'ppt';
	    } else if (input.indexOf('wordprocessing') > -1 || input.indexOf('msword') > -1) {
	      type = 'doc';
	    } else if (input.indexOf('application/pdf') > -1) {
	      type = 'pdf';
	    } else if (input.indexOf('text/plain') > -1) {
	      type = 'txt';
	    } else if (input.indexOf('image/jpeg') > -1 || input.indexOf('image/png') > -1 || input.indexOf('image/gif') > -1 || input.indexOf('image/svg+xml') > -1) {
	      type = 'png';
	    } else if (input.indexOf('application/zip') > -1) {
	      type = 'zip';
	    } else if (input.indexOf('application/xml') > -1) {
	      type = 'xml';
	    }

	    return 'assets/mimes/' + type + '.svg';
	  };
	}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = humanizeDate;
	function humanizeDate($translate) {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '';
	    }

	    var now = moment();
	    var date = moment(input);
	    var diff = now.date() - date.date();
	    var samePeriod = now.month() === date.month() && now.year() === date.year();

	    if (diff === 0 && samePeriod) {
	      return $translate.instant('DURATION.LABEL.TODAY') + ', ' + date.format('HH:mm');
	    }if (diff >= 1 && diff < 2 && samePeriod) {
	      return $translate.instant('DURATION.LABEL.YESTERDAY') + ', ' + date.format('HH:mm');
	    } else {
	      var month = 'MONTHS.FULL.' + date.format('MMMM').toUpperCase();
	      return date.format('DD') + ',  ' + $translate.instant(month);
	    }
	  };
	}

	humanizeDate.$inject = ['$translate'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = timeToString;

	var _constants = __webpack_require__(9);

	function timeToString($translate, $window) {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '';
	    }

	    var date = new Date(input);
	    if (!date || _.isNaN(date.getTime())) return '';

	    var user = angular.fromJson($window.localStorage.getItem('user')) || 'pt_BR';
	    var daysOfWeek = _constants.weekdays[user.attributes.locale];
	    var monthNames = _constants.months[user.attributes.locale];

	    var dayWeek = daysOfWeek[date.getDay()];
	    var day = ('0' + date.getDate()).slice(-2);
	    var month = monthNames[date.getMonth()];
	    var hours = ('0' + date.getHours()).slice(-2);
	    var minutes = ('0' + date.getMinutes()).slice(-2);
	    var separatorOf = $translate.instant('DURATION.LABEL.OF');

	    if (user.attributes.locale === 'en_US') {
	      return dayWeek + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes;
	    }
	    return dayWeek + '. ' + day + ' ' + separatorOf + ' ' + month + '. ' + hours + ':' + minutes;
	  };
	}

	timeToString.$inject = ['$translate', '$window'];

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deviceUserAgent;
	function deviceUserAgent() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '';
	    }

	    var deviceRegex = /\((.*?)\)/;
	    var deviceMatch = input.match(deviceRegex);
	    var device = deviceMatch ? deviceMatch[1] : '-';

	    return device;
	  };
	}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = applicationUserAgent;
	function applicationUserAgent() {
	  'use strict';

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return '';
	    }

	    var browserRegex = /\b(\w+)\/([\d.]+)\b/;
	    var browserMatch = input.match(browserRegex);
	    var browserName = browserMatch ? browserMatch[1] : '-';
	    var browserVersion = browserMatch ? browserMatch[2] : '-';

	    return browserName + ' - ' + browserVersion;
	  };
	}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = phoneFilter;
	function phoneFilter() {
	  'use strict';

	  return function (input) {
	    var value = input || '';

	    if (!value) {
	      return value;
	    }

	    var phoneMask8D = new StringMask('(00) 0000-0000');
	    var phoneMask9D = new StringMask('(00) 00000-0000');
	    var phoneMask13D = new StringMask('00 (00) 00000-0000');
	    var phoneMask0800 = new StringMask('0000-000-0000');

	    var formatedValue = void 0;
	    value = value + '';
	    if (value.indexOf('0800') === 0) {
	      formatedValue = phoneMask0800.apply(value);
	    } else if (value.length < 11) {
	      formatedValue = phoneMask8D.apply(value);
	    } else if (value.length >= 11 && value.length < 13) {
	      formatedValue = phoneMask9D.apply(value);
	    } else if (value.length === 13) {
	      formatedValue = phoneMask13D.apply(value);
	    } else {
	      formatedValue = value;
	    }
	    return formatedValue;
	  };
	}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unique;
	function unique() {
	  'use strict';

	  return function (input, keyname) {
	    var output = [],
	        keys = [];
	    angular.forEach(input, function (item) {
	      var key = item[keyname];
	      if (keys.indexOf(key) === -1) {
	        keys.push(key);
	        output.push(item);
	      }
	    });
	    return output;
	  };
	}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trust;
	/**
	 * The mapbox orientation is to the North on 0 degrees
	 */
	function trust($sce) {
	  'use strict';
	  /**
	   *
	   * @param {number} input
	   */

	  return function (input) {
	    if (_.isNaN(input) || _.isNull(input) || _.isUndefined(input)) {
	      return;
	    }

	    return $sce.trustAsHtml(input);
	  };
	}

	trust.$inject = ['$sce'];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _main = __webpack_require__(38);

	var _main2 = _interopRequireDefault(_main);

	var _http = __webpack_require__(310);

	var _http2 = _interopRequireDefault(_http);

	var _generic = __webpack_require__(311);

	var _generic2 = _interopRequireDefault(_generic);

	var _isochrones = __webpack_require__(312);

	var _isochrones2 = _interopRequireDefault(_isochrones);

	var _riskArea = __webpack_require__(138);

	var _riskArea2 = _interopRequireDefault(_riskArea);

	var _dialog = __webpack_require__(314);

	var _dialog2 = _interopRequireDefault(_dialog);

	var _firebaseMessaging = __webpack_require__(315);

	var _firebaseMessaging2 = _interopRequireDefault(_firebaseMessaging);

	var _subscriberNotification = __webpack_require__(316);

	var _subscriberNotification2 = _interopRequireDefault(_subscriberNotification);

	var _map = __webpack_require__(317);

	var _map2 = _interopRequireDefault(_map);

	var _map3 = __webpack_require__(318);

	var _map4 = _interopRequireDefault(_map3);

	var _stateManagement = __webpack_require__(319);

	var _stateManagement2 = _interopRequireDefault(_stateManagement);

	var _geoLocation = __webpack_require__(320);

	var _geoLocation2 = _interopRequireDefault(_geoLocation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.services', []).service('MainService', _main2.default).service('HttpService', _http2.default).service('GenericService', _generic2.default).service('IsochronesService', _isochrones2.default).service('RiskAreaService', _riskArea2.default).service('DialogService', _dialog2.default).service('FirebaseMessagingService', _firebaseMessaging2.default).service('SubscriberNotificationService', _subscriberNotification2.default).service('MapService', _map2.default).service('MapHelper', _map4.default).service('StateManagement', _stateManagement2.default).service('GeoLocation', _geoLocation2.default);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HttpService = function () {
	  HttpService.$inject = ["$http", "$q"];
	  function HttpService($http, $q) {
	    'ngInject';

	    _classCallCheck(this, HttpService);

	    this.$http = $http;
	    this.$q = $q;
	  }

	  _createClass(HttpService, [{
	    key: 'cancelRequests',
	    value: function cancelRequests() {
	      var specifiesUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	      this.$http.pendingRequests.forEach(function (request) {
	        var isBaseURLContained = request.url.includes(specifiesUrl);
	        if (specifiesUrl && isBaseURLContained) {
	          request.cancel.resolve('Request canceled');
	        } else {
	          if (request.cancel && request.timeout) {
	            request.cancel.resolve('Request canceled');
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createCancelableRequest',
	    value: function createCancelableRequest(config) {
	      var deferred = this.$q.defer();
	      config.timeout = deferred.promise;
	      config.cancel = deferred;

	      return this.$http(config);
	    }
	  }]);

	  return HttpService;
	}();

	exports.default = HttpService;

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/* global btoa */

	var GenericService = function () {
	  GenericService.$inject = ["$http", "$q", "EnvironmentConfig", "Upload", "$state", "$rootScope"];
	  function GenericService($http, $q, EnvironmentConfig, Upload, $state, $rootScope) {
	    'ngInject';

	    _classCallCheck(this, GenericService);

	    this.$http = $http;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.Upload = Upload;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	  }

	  _createClass(GenericService, [{
	    key: 'archive',
	    value: function archive(version, model, data) {
	      var deferred = this.$q.defer();

	      this.$http({ url: [this.EnvironmentConfig.API, version, model, 'archive'].join('/'), method: 'POST', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'unarchive',
	    value: function unarchive(version, model, data) {
	      var deferred = this.$q.defer();

	      this.$http({ url: [this.EnvironmentConfig.API, version, model, 'unarchive'].join('/'), method: 'POST', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'create',
	    value: function create(version, model, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model].join('/'), method: 'POST', data: data, timeout: 120000 }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(version, model, item) {
	      var obj = {};
	      if (version === 'v3') {
	        obj = { url: [this.EnvironmentConfig.API, version, model, 'delete'].join('/'), data: item, method: 'DELETE' };
	      } else {
	        obj = { url: [this.EnvironmentConfig.API, version, model, item].join('/'), method: 'DELETE' };
	      }
	      var deferred = this.$q.defer();
	      this.$http(obj).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'export',
	    value: function _export(version, model, obj) {
	      var deferred = this.$q.defer();
	      var encodedString = null;
	      var query = [];
	      var url = [this.EnvironmentConfig.API, version, 'export', model].join('/');
	      var keys = Object.keys(obj);
	      keys.forEach(function (k) {
	        if (_.isObject(obj[k])) {
	          if (k === 'export') {
	            encodedString = encodeURIComponent(btoa(angular.toJson(obj[k])));
	          } else {
	            query.push(k + '[' + obj[k].prop + ']=' + obj[k].order);
	          }
	        } else if (!_.isNil(obj[k]) && obj[k] !== '') {
	          query.push(k + '=' + obj[k]);
	        }
	      });
	      url = url + (query.length ? '?' + query.join('&') : '');
	      url = url + (encodedString ? '&export=' + encodedString : '');
	      this.$http({ url: url, method: 'GET', responseType: 'blob' }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'simpleRaw',
	    value: function simpleRaw(version, model, obj) {
	      var deferred = this.$q.defer();
	      var url = [this.EnvironmentConfig.API, version, model].join('/');

	      if (obj) {
	        url = url + obj;
	      }

	      this.$http({ url: url, method: 'GET' }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'raw',
	    value: function raw(version, model, obj) {
	      var deferred = this.$q.defer();
	      var url = [this.EnvironmentConfig.API, version, model].join('/');

	      if (obj) {
	        url = url + ('?q=' + encodeURIComponent(btoa(obj)));
	      }

	      this.$http({ url: url, method: 'GET' }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'list',
	    value: function list(version, model, obj) {
	      var deferred = this.$q.defer();
	      var query = [];
	      var url = [this.EnvironmentConfig.API, version, model].join('/');
	      var keys = Object.keys(obj);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;

	          var value = obj[key];
	          if (_.isObject(value)) {
	            if (value.prop && value.order) {
	              query.push(this._buildOrderParam(key, value.prop, value.order));
	            } else {
	              this._buildObjectParam(query, key, value);
	            }
	          } else if (!_.isNil(value) && value !== '') {
	            query.push(key + '=' + value);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      url = url + (query.length ? '?' + query.join('&') : '');
	      this.$http({ url: url, method: 'GET' }).then(function (res) {
	        if (res && res.data) {
	          deferred.resolve(res.data);
	        }
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'show',
	    value: function show(version, model, identifier) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, identifier].join('/'), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'update',
	    value: function update(version, model, identifier, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, identifier].join('/'), method: 'PUT', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'bulkCreate',
	    value: function bulkCreate(version, model, data) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, 'bulk'].join('/'), method: 'POST', data: data }).then(function (res) {
	        deferred.resolve(res.data);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'getFilterFields',
	    value: function getFilterFields(version, model) {
	      var deferred = this.$q.defer();
	      this.$http({ url: [this.EnvironmentConfig.API, version, model, version === 'v3' ? 'filter-fields' : 'filter_fields'].join('/'), method: 'GET' }).then(function (res) {
	        deferred.resolve(res.data);
	      });
	      return deferred;
	    }
	  }, {
	    key: '_buildOrderParam',
	    value: function _buildOrderParam(key, prop, order) {
	      return key + '[' + prop + ']=' + order;
	    }
	  }, {
	    key: '_buildObjectParam',
	    value: function _buildObjectParam(query, paramName, obj) {
	      var keys = Object.keys(obj);
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;

	      try {
	        var _loop = function _loop() {
	          var key = _step2.value;

	          var value = obj[key];
	          if (_.isArray(value)) {
	            value.forEach(function (v) {
	              query.push(paramName + '[' + key + '][]=' + v);
	            });
	          } else {
	            query.push(paramName + '[' + key + ']=' + value);
	          }
	        };

	        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }]);

	  return GenericService;
	}();

	exports.default = GenericService;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	var _isochrones = __webpack_require__(313);

	var isochronesMapStyle = _interopRequireWildcard(_isochrones);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultSourceOptions = {
	  center: [],
	  markers: [],
	  srcName: 'src-isochrone',
	  show: false
	};

	var IsochronesService = function () {
	  IsochronesService.$inject = ["$http", "EnvironmentConfig", "MapHelper"];
	  function IsochronesService($http, EnvironmentConfig, MapHelper) {
	    'ngInject';

	    _classCallCheck(this, IsochronesService);

	    this.$http = $http;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MapHelper = MapHelper;
	  }

	  _createClass(IsochronesService, [{
	    key: 'build',
	    value: function build() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { center: [], srcName: 'src-isochrone' };

	      var sourceObj = Object.assign({}, defaultSourceOptions, options);

	      if (sourceObj.markers.length > 1) {
	        sourceObj.center = turf.center(turf.points(sourceObj.markers)).geometry.coordinates;
	      } else {
	        sourceObj.center = sourceObj.markers[0];
	      }

	      if (angular.isArray(sourceObj.center) && sourceObj.center.length) {
	        this.srcName = sourceObj.srcName;
	        this.fitBounds(sourceObj);
	        this.addMarkers(sourceObj);
	        this.addIso(sourceObj);
	      }
	    }
	  }, {
	    key: 'fitBounds',
	    value: function fitBounds(sourceObj) {
	      if (sourceObj.markers.length < 2) return;
	      var fitLine = turf.lineString(sourceObj.markers);
	      this.MapHelper.map.fitBounds(turf.bbox(fitLine), {
	        padding: 150
	      });
	    }
	  }, {
	    key: 'rebuild',
	    value: function rebuild(sourceObj) {
	      this.addMarkers(sourceObj);
	      this.fitBounds(sourceObj);
	    }
	  }, {
	    key: 'addMarkers',
	    value: function addMarkers(sourceObj) {
	      if (this.MapHelper.hasSource('src-markers') == null) {
	        this.MapHelper.addSources(['src-markers'], [{ type: 'geojson', data: turf.multiPoint(sourceObj.markers) }]);

	        var layers = [this.MapHelper.layerBuilder('marker-locations', 'circle', { source: 'src-markers', paint: isochronesMapStyle.markers.paint })];
	        this.MapHelper.addLayers(layers);
	      } else {
	        var data = turf.featureCollection([turf.multiPoint(sourceObj.markers)]);
	        this.MapHelper.setDataToSource('src-markers', data);
	      }
	    }
	  }, {
	    key: 'addIso',
	    value: function addIso(sourceObj) {
	      this.MapHelper.addSources([sourceObj.srcName], [{ type: 'geojson', data: this._getIsoData(sourceObj) }]);

	      var layers = [this.MapHelper.layerBuilder('isochrone-border', 'line', { source: 'src-isochrone', paint: isochronesMapStyle.polygons.isochrone.border.paint }), this.MapHelper.layerBuilder('quantized-label', 'symbol', { source: 'src-isochrone', layout: isochronesMapStyle.polygons.isochrone.labels.layout, paint: isochronesMapStyle.polygons.isochrone.labels.paint })];

	      this.MapHelper.addLayers(layers);
	    }
	  }, {
	    key: '_getIsoData',
	    value: function _getIsoData(sourceObj) {
	      var token = this.EnvironmentConfig.MAPBOX;
	      var spectro = ['f1f075', '56b881', '3887be', '4a4a8b'];
	      var spectroString = spectro.join(',');
	      return 'https://api.mapbox.com/isochrone/v1/mapbox/driving/' + sourceObj.markers[0] + ',' + sourceObj.markers[1] + '?contours_minutes=5,15,30,60&contours_colors=' + spectroString + '&denoise=0.8&polygons=false&generalize=20&access_token=' + token;
	    }
	  }]);

	  return IsochronesService;
	}();

	exports.default = IsochronesService;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  polygons: {
	    isochrone: {
	      layer: {
	        paint: {
	          'fill-color': ['get', 'color'],
	          'fill-opacity': 0.05
	        }
	      },
	      border: {
	        paint: {
	          'line-color': ['get', 'color'],
	          'line-width': {
	            base: 1,
	            stops: [[10, 2], [14, 3]]
	          }
	        }
	      },
	      labels: {
	        layout: {
	          'text-field': '{contour} MIN',
	          'text-font': ['DIN Offc Pro Bold'],
	          'symbol-placement': 'line',
	          'text-allow-overlap': true,
	          'text-padding': 1,
	          'text-max-angle': 90,
	          'text-size': {
	            base: 1.2,
	            stops: [[12, 8], [14, 12]]
	          },
	          'text-letter-spacing': 0.1
	        },
	        paint: {
	          'text-halo-color': 'hsl(55, 1%, 20%)',
	          'text-color': {
	            property: 'contour',
	            type: 'interval',
	            stops: [[5, '#f1f075'], [10, '#f1f075'], [15, '#56b881'], [30, '#3887be'], [60, '#4a4a8b'], [70, '#4a4a8b']]
	          },
	          'text-halo-width': 12
	        }
	      }
	    }
	  },
	  focus: {
	    paint: {
	      'circle-color': '#fff',
	      'circle-opacity': 0.15,
	      'circle-radius': {
	        base: 24,
	        stops: [[12, 24], [14, 26], [22, 30]]
	      },
	      'circle-stroke-width': 2,
	      'circle-stroke-color': '#fff'
	    }
	  },
	  arc: {
	    arrows: {
	      layout: {
	        'symbol-placement': 'line',
	        'text-field': '▶',
	        'text-size': {
	          base: 1,
	          stops: [[4, 32], [8, 24], [12, 12]]
	        },
	        'symbol-spacing': {
	          base: 1,
	          stops: [[9, 15], [12, 30], [22, 60]]
	        },
	        'text-keep-upright': false
	      },
	      paint: {
	        'text-color': '#FFFFFF'
	      }
	    },
	    paint: {
	      'line-width': 2,
	      'line-color': '#fff',
	      'line-dasharray': [1, 2]
	    }
	  },
	  device: {
	    paint: {
	      'circle-color': {
	        property: 'st',
	        type: 'categorical',
	        stops: [['grn', '#4CAF50'], ['ylw', '#FFC107'], ['gry', '#607D8B'], ['red', '#D32F2F']]
	      },
	      'circle-radius': {
	        base: 2,
	        stops: [[12, 4], [14, 6], [22, 10]]
	      },
	      'circle-stroke-width': 2,
	      'circle-stroke-color': '#fff'
	    }
	  },
	  center: {
	    paint: {
	      'circle-color': '#F44336',
	      'circle-radius': {
	        base: 2,
	        stops: [[12, 4], [14, 6], [22, 10]]
	      },
	      'circle-stroke-width': 2,
	      'circle-stroke-color': '#D32F2F'
	    }
	  },
	  markers: {
	    paint: {
	      'circle-color': '#d1d5db',
	      'circle-radius': {
	        base: 2,
	        stops: [[12, 4], [14, 6], [22, 10]]
	      },
	      'circle-stroke-width': 2,
	      'circle-stroke-color': '#6b7280'
	    }
	  }
	};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DialogService = function () {
	  DialogService.$inject = ["$mdDialog", "$document"];
	  function DialogService($mdDialog, $document) {
	    'ngInject';

	    _classCallCheck(this, DialogService);

	    this.$mdDialog = $mdDialog;
	    this.$document = $document;
	  }

	  _createClass(DialogService, [{
	    key: 'openDialog',
	    value: function openDialog(options, item) {
	      return this.$mdDialog.show({
	        templateUrl: options.url,
	        controller: options.controllerName,
	        controllerAs: options.controllerAlias,
	        clickOutsideToClose: options.clickOutsideToClose,
	        escapeToClose: options.escapeToClose,
	        bindToController: options.bindToController,
	        preserveScope: options.preserveScope,
	        isolateScope: options.isolateScope,
	        hasBackdrop: options.hasBackdrop,
	        fullscreen: options.fullscreen,
	        locals: { item: item },
	        parent: options.parent || angular.element(this.$document[0].body),
	        onComplete: options.onComplete,
	        multiple: options.multiple
	      });
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(res) {
	      this.$mdDialog.hide(res);
	    }
	  }, {
	    key: 'finishDialog',
	    value: function finishDialog() {
	      this.$mdDialog.cancel();
	    }
	  }]);

	  return DialogService;
	}();

	exports.default = DialogService;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FirebaseMessagingService = function () {
	  FirebaseMessagingService.$inject = ["$state", "$translate", "$window", "EnvironmentConfig"];
	  function FirebaseMessagingService($state, $translate, $window, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, FirebaseMessagingService);

	    this.$state = $state;
	    this.$translate = $translate;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(FirebaseMessagingService, [{
	    key: 'initializeApp',
	    value: function initializeApp() {
	      var _this = this;

	      if (!this.$window.firebase.apps.length) {
	        this.$window.firebase.initializeApp(this.EnvironmentConfig.FIREBASE);
	      }
	      navigator.serviceWorker.register('/firebase-messaging-sw.js').then(function () {
	        _this.$window.firebase.messaging().onMessage(_this.onMessage.bind(_this));
	      });
	    }
	  }, {
	    key: 'onMessage',
	    value: function onMessage(payload) {
	      var notification = new Notification(this.$translate.instant('PUSH_NOTIFICATION.ALERT.TITLE'), {
	        body: payload.data.message,
	        icon: _constants.NOTIFICATIONS.icon,
	        requireInteraction: true
	      });
	      var audio = new Audio(_constants.NOTIFICATIONS.audio);
	      audio.play();
	      notification.onclick = function () {
	        notification.close();
	      };
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      return this.$window.firebase.messaging().getToken({ vapidKey: this.EnvironmentConfig.FIREBASE.vapidKey });
	    }
	  }]);

	  return FirebaseMessagingService;
	}();

	exports.default = FirebaseMessagingService;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SubscriberNotificationService = function () {
	  SubscriberNotificationService.$inject = ["$http", "$q", "$window", "EnvironmentConfig"];
	  function SubscriberNotificationService($http, $q, $window, EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, SubscriberNotificationService);

	    this.$http = $http;
	    this.$q = $q;
	    this.$window = $window;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }

	  _createClass(SubscriberNotificationService, [{
	    key: 'registerToken',
	    value: function registerToken(notificationToken) {
	      var _this = this;

	      var deferred = this.$q.defer();
	      var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	      var enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      var data = {
	        data: {
	          name: user.attributes.name,
	          locale: user.attributes.locale,
	          timezone: enterprise.attributes.timezone,
	          token: notificationToken,
	          platform: 'GCM',
	          shortname: 'frontphoenix'
	        }
	      };
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.USERS, user.uuid, 'configuration', _constants.SUBSCRIBER.SUBSCRIPTIONS].join('/'), method: 'PUT', data: data }).then(function (res) {
	        _this.$window.localStorage.setItem('notification_attempt', true);
	        _this.$window.localStorage.setItem('notification_dtk', notificationToken);
	        deferred.resolve(res);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }, {
	    key: 'unregisterToken',
	    value: function unregisterToken(notificationToken) {
	      var _this2 = this;

	      var deferred = this.$q.defer();
	      var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	      this.$http({ url: [this.EnvironmentConfig.API, _constants.API.V4, _constants.API.USERS, user.uuid, 'configuration', _constants.SUBSCRIBER.SUBSCRIPTIONS, notificationToken].join('/'), method: 'DELETE' }).then(function (res) {
	        _this2.$window.localStorage.removeItem('notification_dtk');
	        deferred.resolve(res);
	      }).catch(function (data) {
	        deferred.reject(data);
	      });

	      return deferred;
	    }
	  }]);

	  return SubscriberNotificationService;
	}();

	exports.default = SubscriberNotificationService;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var mapConfig = {
	  boxZoom: true,
	  dragRotate: false,
	  minZoom: 4,
	  maxZoom: 17,
	  pitch: 0,
	  pitchWithRotate: false
	};

	var MapService = function () {
	  MapService.$inject = ["$q", "$state", "$window", "ERBService", "GeoLocation", "MapHelper", "RiskAreaService", "TrajectoryService", "TrackingService"];
	  function MapService($q, $state, $window, ERBService, GeoLocation, MapHelper, RiskAreaService, TrajectoryService, TrackingService) {
	    'ngInject';

	    _classCallCheck(this, MapService);

	    this.$q = $q;
	    this.$state = $state;
	    this.$window = $window;
	    this.ERBService = ERBService;
	    this.GeoLocation = GeoLocation;
	    this.MapHelper = MapHelper;
	    this.RiskAreaService = RiskAreaService;
	    this.TrajectoryService = TrajectoryService;
	    this.TrackingService = TrackingService;
	  }

	  _createClass(MapService, [{
	    key: 'new',
	    value: function _new() {
	      var _this = this;

	      var deferred = this.$q.defer();

	      var loadConfig = { lng: -43.93952, lat: -19.93955 };
	      var getGeoLocation = this.GeoLocation.getCoords(false);
	      getGeoLocation.then(function (res) {
	        loadConfig = { lng: res.lng, lat: res.lat };
	      }).finally(function () {
	        var mapOptions = Object.assign({}, mapConfig, { zoom: _this.$state.params.z || 5, center: loadConfig });
	        var controls = { navigation: true, geolocation: true, fullscreen: true };

	        _this.MapHelper.mapBuilder(_this.mapStyle, mapOptions, controls);
	        _this.MapHelper.map.once('load', function () {
	          _this.$state.go('.', loadConfig, { notify: false });
	          _this.ERBService.build();
	          _this.RiskAreaService.build();
	        });
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.MapHelper.deleteMap();
	    }
	  }, {
	    key: 'showRiskArea',
	    value: function showRiskArea() {
	      this.RiskAreaService.show();
	    }
	  }, {
	    key: 'hideRiskArea',
	    value: function hideRiskArea() {
	      this.RiskAreaService.hide();
	    }
	  }, {
	    key: 'showErbs',
	    value: function showErbs() {
	      this.ERBService.show();
	    }
	  }, {
	    key: 'hideErbs',
	    value: function hideErbs() {
	      this.ERBService.hide();
	    }
	  }]);

	  return MapService;
	}();

	exports.default = MapService;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global mapboxgl */


	var _mapOptions = __webpack_require__(132);

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var imagePath = {
	  grn: 'assets/images/map-icons/u1.png',
	  gry: 'assets/images/map-icons/u4.png',
	  red: 'assets/images/map-icons/u2.png',
	  ylw: 'assets/images/map-icons/u3.png',
	  alarm: 'assets/images/map-icons/alarm48.png',
	  stop: 'assets/images/map-icons/stop48.png'
	};

	var defaultMapOptions = {
	  attributionControl: false,
	  bearing: 0,
	  logoPosition: 'bottom-right',
	  container: 'map',
	  center: [-43.93952, -19.93955],
	  pitch: 0,
	  zoom: 5,
	  maxBounds: [[-180, -80], [180, 80]]
	};

	var defaultMapControllers = {
	  navigation: false,
	  geolocation: false,
	  draw: false,
	  fullscreen: false
	};

	var defaultLayer = {
	  layer: 'streets',
	  version: 'v12'
	};

	var currentPosition = {
	  positionOptions: {
	    enableHighAccuracy: true
	  },
	  trackUserLocation: true
	};

	var defaultSourceOptions = function defaultSourceOptions(data) {
	  return {
	    type: 'geojson',
	    cluster: false,
	    data: data,
	    clusterMaxZoom: 0,
	    clusterRadius: 0
	  };
	};

	var defaultLayerOptions = {
	  source: { type: 'FeatureCollection', features: [] },
	  layout: {},
	  paint: {},
	  metadata: { definition: 'internal' },
	  minzoom: 3
	};

	var MapHelper = function () {
	  MapHelper.$inject = ["EnvironmentConfig"];
	  function MapHelper(EnvironmentConfig) {
	    'ngInject';

	    _classCallCheck(this, MapHelper);

	    this.EnvironmentConfig = EnvironmentConfig;
	    this.setAccessToken();

	    this.sourcesToKeep = {};
	    this.layersToKeep = [];
	  }

	  /**
	   *
	   * @param {object} layer - layer to be initialized on the map
	   * @param {object} options - options to be initialized on the map
	   */


	  _createClass(MapHelper, [{
	    key: 'mapBuilder',
	    value: function mapBuilder(layer, options, controllers) {
	      var layerMerged = Object.assign({}, defaultLayer, layer);
	      var mapOptions = Object.assign({}, defaultMapOptions, options);
	      var mapControls = Object.assign({}, defaultMapControllers, controllers);

	      mapOptions.style = 'mapbox://styles/mapbox/' + layerMerged.layer + '-' + layerMerged.version + '?optimize=true';

	      this.map = new mapboxgl.Map(mapOptions);
	      this.loadImages(Object.keys(imagePath), Object.values(imagePath));

	      if (mapControls.navigation) this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');
	      if (mapControls.geolocation) this.map.addControl(new mapboxgl.GeolocateControl(currentPosition), 'top-right');
	      if (mapControls.fullscreen) this.map.addControl(new mapboxgl.FullscreenControl(), 'top-right');

	      return this.map;
	    }

	    /**
	     *
	     * @param {string} type
	     * @param {boolean} cluster
	     * @param {object} data
	     * @param {number} clusterMaxZoom - Property used only in case of cluster
	     * @param {number} clusterRadius - Property used only in case of cluster
	     */

	  }, {
	    key: 'sourceBuilder',
	    value: function sourceBuilder(data, options) {
	      var sourceOptions = Object.assign({}, defaultSourceOptions(data), options);
	      return sourceOptions;
	    }

	    /**
	     *
	     * @param {number} id - ID of the layer
	     * @param {string} type - Type of the layer
	     * @param {string} source - Name/object of the source
	     * @param {object} filter - Array/Object that defines filter to this layer
	     * @param {object} layout - Layout of the layer
	     * @param {object} paint - paint of the layer
	     */

	  }, {
	    key: 'layerBuilder',
	    value: function layerBuilder(id, type, options) {
	      var layerObj = Object.assign({}, defaultLayerOptions, options);
	      layerObj.id = id;
	      layerObj.type = type;

	      return layerObj;
	    }

	    /**
	     *
	     * @param {string} source - ID of the source
	     * @param {object} data - GeoJSON data object
	     */

	  }, {
	    key: 'setDataToSource',
	    value: function setDataToSource(source, data) {
	      if (!this.map.getSource(source)) return;
	      this.map.getSource(source).setData(data);
	    }

	    /**
	     *
	     * @param {Array} names
	     * @param {Array} paths
	     */

	  }, {
	    key: 'loadImages',
	    value: function loadImages(names, paths) {
	      var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.map;

	      names.forEach(function (name, index) {
	        map.loadImage(paths[index], function (error, image) {
	          if (error) return;
	          if (map.hasImage(name) === false) {
	            map.addImage(name, image);
	          }
	        });
	      });
	    }

	    /**
	     *
	     * @param {string} style
	     */

	  }, {
	    key: 'setStyle',
	    value: function setStyle(style, keepStyleOptions) {
	      if (keepStyleOptions) {
	        this.keepStyles();
	      }
	      this.map.setStyle('mapbox://styles/mapbox/' + _mapOptions.MAPSTYLES[style].layer + '-' + _mapOptions.MAPSTYLES[style].version);
	    }
	  }, {
	    key: 'keepStyles',
	    value: function keepStyles() {
	      var _this = this;

	      var sourcesToKeep = {};
	      // copy layers
	      var layersToKeep = this.map.getStyle().layers.filter(function (l) {
	        return l.metadata && l.metadata.definition === 'internal';
	      });
	      // copy sources
	      var sources = this.map.getStyle().sources;
	      _mapOptions.SOURCES.forEach(function (s) {
	        if (sources[s]) {
	          sourcesToKeep[s] = sources[s];
	        }
	      });

	      this.map.once('style.load', function () {
	        _this.loadImages(Object.keys(imagePath), Object.values(imagePath));

	        for (var src in sourcesToKeep) {
	          _this.map.addSource(src, sourcesToKeep[src]);
	        }

	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;

	        try {
	          for (var _iterator = layersToKeep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var layer = _step.value;

	            if (_.isUndefined(_this.map.getLayer(layer.id))) _this.map.addLayer(layer);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }

	    /**
	     *
	     * @param {Array} layers - IDs of the layers to be removed
	     */

	  }, {
	    key: 'removeLayers',
	    value: function removeLayers(layers) {
	      var _this2 = this;

	      layers.forEach(function (layer) {
	        if (_this2.map.getLayer(layer)) _this2.map.removeLayer(layer);
	      });
	    }

	    /**
	     *
	     * @param {Array} sources - IDs of the sources to be removed
	     */

	  }, {
	    key: 'removeSources',
	    value: function removeSources(sources) {
	      var _this3 = this;

	      sources.forEach(function (src) {
	        if (_this3.map.getSource(src)) _this3.map.removeSource(src);
	      });
	    }

	    /**
	     *
	     * @param {Array} layers - IDs of the layers to
	     * @param {Array} clauses - Expressions to filter layers
	     */

	  }, {
	    key: 'setFilters',
	    value: function setFilters(layers, clauses) {
	      var _this4 = this;

	      layers.forEach(function (layer, index) {
	        if (!clauses) _this4.map.setFilter(layer);else if (clauses.length > 1) _this4.map.setFilter(layer, clauses[index]);else _this4.map.setFilter(layer, clauses[0]);
	      });
	    }
	  }, {
	    key: 'setLayoutProps',
	    value: function setLayoutProps(layers, props) {
	      var _this5 = this;

	      layers.forEach(function (layer) {
	        if (_this5.map.getLayer(layer)) {
	          _this5.map.setLayoutProperty(layer, props[0], props[1]);
	        }
	      });
	    }

	    /**
	     *
	     * @param {Array} iControls
	     * @param {Array} positions
	     */

	  }, {
	    key: 'addControls',
	    value: function addControls(iControls, positions) {
	      var _this6 = this;

	      iControls.forEach(function (iControl, index) {
	        if (positions.length === 1) _this6.map.addControl(iControl, positions[0]);else _this6.map.addControl(iControl, positions[index]);
	      });
	    }

	    /**
	     *
	     * @param {Array} sources - IDs of the sources
	     * @param {Array} data - Source objects
	     */

	  }, {
	    key: 'addSources',
	    value: function addSources(sources, data) {
	      var _this7 = this;

	      sources.forEach(function (src, index) {
	        if (!_this7.map.getSource(src)) {
	          if (data == null || data[index] == null) {
	            _this7.map.addSource(src, _this7.sourceBuilder('geojson', false, null));
	          } else {
	            _this7.map.addSource(src, data[index]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'hasSource',
	    value: function hasSource(source) {
	      return this.map.getSource(source);
	    }

	    /**
	     *
	     * @param {Array} layers - Style layers
	     */

	  }, {
	    key: 'addLayers',
	    value: function addLayers(layers) {
	      var befores = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	      for (var layerIndex in layers) {
	        var layer = layers[layerIndex];
	        var before = befores[layerIndex];
	        if (_.isUndefined(this.map.getLayer(layer.id))) this.map.addLayer(layer, before);
	      }
	    }
	  }, {
	    key: 'getStaticMap',
	    value: function getStaticMap(feat, size) {
	      var dimensions = size.w + 'x' + size.h;
	      var features = turf.points(feat);
	      var center = turf.center(features);
	      var zoom = '13';
	      var encoode = encodeURIComponent(angular.toJson(features));

	      return 'https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/geojson(' + encoode + ')/' + center.geometry.coordinates + ',' + zoom + '/' + dimensions + '@2x?access_token=' + this.EnvironmentConfig.MAPBOX;
	    }
	  }, {
	    key: 'setAccessToken',
	    value: function setAccessToken() {
	      mapboxgl.accessToken = this.EnvironmentConfig.MAPBOX;
	    }
	  }, {
	    key: 'deleteMap',
	    value: function deleteMap() {
	      this.map.remove();
	      this.map = null;
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter() {
	      return this.map.getCenter();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds() {
	      var bounds = this.map.getBounds();
	      return { topLeft: [bounds._ne.lat, bounds._sw.lng], bottomRight: [bounds._sw.lat, bounds._ne.lng] };
	    }
	  }]);

	  return MapHelper;
	}();

	exports.default = MapHelper;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StateManagement = function () {
	  StateManagement.$inject = ["$window", "$rootScope"];
	  function StateManagement($window, $rootScope) {
	    'ngInject';

	    _classCallCheck(this, StateManagement);

	    this.$window = $window;
	    this.$rootScope = $rootScope;

	    this.allkeys = {};
	    this.prefixDefault = 'state-';
	    this.regexPrefixDefault = /state-/;
	  }

	  _createClass(StateManagement, [{
	    key: 'setData',
	    value: function setData(keys, values) {
	      var _this = this;

	      var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	      if (!angular.isArray(keys) && !angular.isArray(values)) return '';
	      if (keys.length !== values.length) return '';

	      keys.forEach(function (key, index) {
	        _this.allkeys[key] = values[index];

	        if (persist) {
	          var keyFormated = '' + _this.prefixDefault + key;
	          _this.$window.sessionStorage.setItem(keyFormated, angular.toJson(values[index]));
	        }
	      });

	      this.$rootScope.statesList = keys;
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;

	      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	      if (!angular.isArray(keys)) return '';

	      if (keys.length === 0) {
	        return Object.assign({}, this.allkeys, this.getAllSessionStorage());
	      } else {
	        var obj = {};
	        keys.forEach(function (key) {
	          var keyFormated = '' + _this2.prefixDefault + key;

	          if (_this2.allkeys[key]) {
	            obj[key] = _this2.allkeys[key];
	          } else if (_this2.$window.sessionStorage.getItem(keyFormated) !== null) {
	            obj[key] = angular.fromJson(_this2.$window.sessionStorage.getItem(keyFormated));
	          }
	        });
	        return obj;
	      }
	    }
	  }, {
	    key: 'getAllSessionStorage',
	    value: function getAllSessionStorage() {
	      var removePrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      var sessionStorageData = {};

	      for (var i = 0; i < this.$window.sessionStorage.length; i++) {
	        var key = this.$window.sessionStorage.key(i);

	        if (this.regexPrefixDefault.test(key)) {
	          var value = this.$window.sessionStorage.getItem(key);
	          var keyFormated = removePrefix ? key.replace(this.regexPrefixDefault, '') : key;
	          sessionStorageData[keyFormated] = angular.fromJson(value);
	        }
	      }
	      return sessionStorageData;
	    }
	  }, {
	    key: 'clearSessionStore',
	    value: function clearSessionStore() {
	      var _this3 = this;

	      var keys = Object.keys(this.getAllSessionStorage(false));
	      this.allkeys = {};
	      keys.forEach(function (item) {
	        _this3.$window.sessionStorage.removeItem(item);
	      });
	    }
	  }]);

	  return StateManagement;
	}();

	exports.default = StateManagement;

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GeoLocation = function () {
	  GeoLocation.$inject = ["$q", "$window"];
	  function GeoLocation($q, $window) {
	    'ngInject';

	    _classCallCheck(this, GeoLocation);

	    this.$q = $q;
	    this.$window = $window;

	    this.storageKey = 'coords';
	  }

	  _createClass(GeoLocation, [{
	    key: 'defaultAddresses',
	    value: function defaultAddresses() {
	      var enterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	      var user = angular.fromJson(this.$window.localStorage.getItem('user'));

	      this.enterpriseAddress = enterprise.relationships.addresses ? enterprise.relationships.addresses[0] : null;
	      this.userAddress = user.relationships.addresses ? user.relationships.addresses[0] : null;
	    }
	  }, {
	    key: 'getCoords',
	    value: function getCoords() {
	      var browser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.browser = browser;

	      var deferred = this.$q.defer();
	      var keys = angular.fromJson(this.$window.localStorage.getItem(this.storageKey));

	      if (keys) {
	        var centerDefault = {
	          lat: -19.93955,
	          lng: -43.93952
	        };
	        var coords = Object.assign(centerDefault, keys);
	        deferred.resolve(coords);
	      } else {
	        this.defaultAddresses();

	        this.getLatLog().then(deferred.resolve).catch(deferred.reject);
	      }
	      return deferred.promise;
	    }
	  }, {
	    key: 'getLatLog',
	    value: function getLatLog() {
	      var _this = this;

	      var deferred = this.$q.defer();

	      var enterpriseUserCoords = function enterpriseUserCoords(location) {
	        var formattedCoords = {
	          lat: location.coordinates[0],
	          lng: location.coordinates[1]
	        };
	        _this.$window.localStorage.setItem(_this.storageKey, angular.toJson(formattedCoords));
	        deferred.resolve(formattedCoords);
	      };

	      var enterpriseUser = function enterpriseUser() {
	        if (_this.userAddress && _this.userAddress.attributes.coords) {
	          enterpriseUserCoords(_this.userAddress.attributes.coords);
	        } else if (_this.enterpriseAddress && _this.enterpriseAddress.attributes.coords) {
	          enterpriseUserCoords(_this.enterpriseAddress.attributes.coords);
	        } else {
	          _this.$window.localStorage.setItem(_this.storageKey, angular.toJson({}));
	          deferred.reject();
	        }
	      };

	      if (this.browser) {
	        this.getBrowserLocation().then(function (res) {
	          _this.$window.localStorage.setItem(_this.storageKey, angular.toJson(res));
	          deferred.resolve(res);
	        }).catch(function () {
	          enterpriseUser();
	        });
	      } else {
	        enterpriseUser();
	      }

	      return deferred.promise;
	    }
	  }, {
	    key: 'getBrowserLocation',
	    value: function getBrowserLocation() {
	      var _this2 = this;

	      var deferred = this.$q.defer();

	      if (this.$window.navigator && this.$window.navigator.geolocation) {
	        var timeoutDuration = 10000;
	        var timeout = this.$window.setTimeout(function () {
	          deferred.reject();
	        }, timeoutDuration);

	        this.$window.navigator.geolocation.getCurrentPosition(function (position) {
	          _this2.$window.clearTimeout(timeout);
	          deferred.resolve({
	            lat: position.coords.latitude,
	            lng: position.coords.longitude
	          });
	        }, function () {
	          deferred.reject();
	        });
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    }
	  }]);

	  return GeoLocation;
	}();

	exports.default = GeoLocation;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _exportDialog = __webpack_require__(322);

	var _exportDialog2 = _interopRequireDefault(_exportDialog);

	var _generateDialog = __webpack_require__(323);

	var _generateDialog2 = _interopRequireDefault(_generateDialog);

	var _advancedSearch = __webpack_require__(324);

	var _advancedSearch2 = _interopRequireDefault(_advancedSearch);

	var _advancedFilter = __webpack_require__(325);

	var _advancedFilter2 = _interopRequireDefault(_advancedFilter);

	var _confirmationDialog = __webpack_require__(326);

	var _confirmationDialog2 = _interopRequireDefault(_confirmationDialog);

	var _strongConfirmationDialog = __webpack_require__(327);

	var _strongConfirmationDialog2 = _interopRequireDefault(_strongConfirmationDialog);

	var _newChip = __webpack_require__(328);

	var _newChip2 = _interopRequireDefault(_newChip);

	var _newDevice = __webpack_require__(329);

	var _newDevice2 = _interopRequireDefault(_newDevice);

	var _newEnterprise = __webpack_require__(330);

	var _newEnterprise2 = _interopRequireDefault(_newEnterprise);

	var _newSharing = __webpack_require__(331);

	var _newSharing2 = _interopRequireDefault(_newSharing);

	var _newUser = __webpack_require__(332);

	var _newUser2 = _interopRequireDefault(_newUser);

	var _fromOutSource = __webpack_require__(333);

	var _fromOutSource2 = _interopRequireDefault(_fromOutSource);

	var _addNewDialog = __webpack_require__(334);

	var _addNewDialog2 = _interopRequireDefault(_addNewDialog);

	var _galleryDialog = __webpack_require__(335);

	var _galleryDialog2 = _interopRequireDefault(_galleryDialog);

	var _updatingDialog = __webpack_require__(336);

	var _updatingDialog2 = _interopRequireDefault(_updatingDialog);

	var _reloadDialog = __webpack_require__(11);

	var _reloadDialog2 = _interopRequireDefault(_reloadDialog);

	var _integrations = __webpack_require__(337);

	var _integrations2 = _interopRequireDefault(_integrations);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('phoenix.controller', []).controller('ExportDialogController', _exportDialog2.default).controller('GenerateDialogController', _generateDialog2.default).controller('AdvancedSearchDialogController', _advancedSearch2.default).controller('AdvancedFilterDialogController', _advancedFilter2.default).controller('ConfirmationDialogController', _confirmationDialog2.default).controller('StrongConfirmationDialogController', _strongConfirmationDialog2.default).controller('NewChipController', _newChip2.default).controller('NewDeviceController', _newDevice2.default).controller('NewEnterpriseController', _newEnterprise2.default).controller('NewSharingController', _newSharing2.default).controller('NewUserController', _newUser2.default).controller('FromOutSourceController', _fromOutSource2.default).controller('AddNewItemController', _addNewDialog2.default).controller('GalleryDialogController', _galleryDialog2.default).controller('UpdatingDialogController', _updatingDialog2.default).controller('ReloadDialogController', _reloadDialog2.default).controller('IntegrationsDialogController', _integrations2.default);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _fileSaver = __webpack_require__(46);

	var _fileSaver2 = _interopRequireDefault(_fileSaver);

	var _queryOptions = __webpack_require__(236);

	var _helper = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ExportDialogController = function () {
	  ExportDialogController.$inject = ["$state", "$window", "DialogService", "MainService", "locals"];
	  function ExportDialogController($state, $window, DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, ExportDialogController);

	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.model = locals.item.model.replace('_', '-');
	    this.version = locals.item.version;
	    this.user = angular.fromJson(this.$window.localStorage.getItem('user'));

	    this.type = 'CSV';
	    this.pickAll = false;
	    this.chosen = [];
	    this.query = {};
	    this.mountOptions();
	    this.mountQueryFilters();
	  }

	  _createClass(ExportDialogController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'export',
	    value: function _export() {
	      var _this = this;

	      this.loading = true;
	      var query = {
	        desired: this.chosen,
	        filters: this.query.filters,
	        format: this.type.toLowerCase(),
	        search: this.query.search,
	        filename: _.deburr(this.model),
	        locale: this.user.attributes.locale
	      };

	      this.MainService.export(this.version, this.model + '/export', query).promise.then(function (res) {
	        var type = {
	          csv: 'text/csv;charset=utf-8',
	          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
	        };
	        var blob = new Blob([res], { type: type[query.format] });
	        _fileSaver2.default.saveAs(blob, query.filename, { autoBom: true });
	        _this.close();
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'mountQueryFilters',
	    value: function mountQueryFilters() {
	      if (this.$state.params.filters) {
	        this.query.filters = internals.uriToJson(this.$state.params.filters);
	      }
	      if (this.$state.params.search) {
	        this.query.search = this.$state.params.search;
	      }
	    }
	  }, {
	    key: 'mountOptions',
	    value: function mountOptions() {
	      var exportList = [];

	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = _queryOptions.FILTERS['' + this.model][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var i = _step.value;

	          exportList.push(internals.formatExport(i));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      this.exportables = exportList;
	    }
	  }, {
	    key: 'toggleAllSelections',
	    value: function toggleAllSelections() {
	      var _this2 = this;

	      this.chosen = Object.assign(this.chosen, this.exportables);
	      this.chosen.forEach(function (c) {
	        c.checked = _this2.pickAll;
	      });
	      if (!this.pickAll) this.chosen = [];
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(item) {
	      var _this3 = this;

	      var hasItem = this.chosen.filter(function (elem) {
	        return elem.a === item.a;
	      });
	      if (hasItem.length > 0) {
	        this.chosen.forEach(function (elem, index) {
	          if (elem.a === item.a) _this3.chosen.splice(index, 1);
	        });
	      } else {
	        this.chosen.push(item);
	      }
	    }
	  }]);

	  return ExportDialogController;
	}();

	exports.default = ExportDialogController;


	var internals = {
	  uriToJson: function uriToJson(uri) {
	    if (uri) {
	      return angular.fromJson((0, _helper._decodeBase64)(decodeURIComponent(uri)));
	    }
	  },
	  formatExport: function formatExport(filter) {
	    return {
	      a: filter.key,
	      t: filter.type
	    };
	  }
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _fileSaver = __webpack_require__(46);

	var _fileSaver2 = _interopRequireDefault(_fileSaver);

	var _constants = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GenerateDialogController = function () {
	  GenerateDialogController.$inject = ["$timeout", "DialogService", "MainService", "locals"];
	  function GenerateDialogController($timeout, DialogService, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, GenerateDialogController);

	    this.$timeout = $timeout;
	    this.DialogService = DialogService;
	    this.MainService = MainService;

	    this.selectedItem = angular.copy(locals.item.item);

	    this.sectionsDesired = internals._initialDesired();
	    this.pickAll = false;
	  }

	  _createClass(GenerateDialogController, [{
	    key: 'toggleAllSelections',
	    value: function toggleAllSelections() {
	      var _this = this;

	      this.sectionsDesired.forEach(function (i) {
	        if (i.name !== 'default') {
	          i.checked = _this.pickAll;
	        }
	      });
	    }
	  }, {
	    key: 'checkToggleSelections',
	    value: function checkToggleSelections() {
	      var _this2 = this;

	      this.$timeout(function () {
	        var anyCheck = _this2.sectionsDesired.filter(function (i) {
	          return i.checked && i.name !== 'default';
	        });
	        _this2.pickAll = anyCheck.length > 2;
	      }, 100);
	    }
	  }, {
	    key: 'generate',
	    value: function generate() {
	      var _this3 = this;

	      this.loading = true;

	      var query = {
	        desired: this.sectionsDesired.filter(function (i) {
	          return i.name !== 'default' && i.checked;
	        }).map(function (i) {
	          return { a: i.name };
	        })
	      };

	      if (!query.desired.length) {
	        query = null;
	      }

	      this.MainService.export(_constants.API.V5, _constants.API.SERVICE_ORDERS + '/' + this.selectedItem.id + '/generate-file', query).promise.then(function (res) {
	        var blob = new Blob([res], { type: 'application/pdf;charset=utf-8' }); // eslint-disable-line
	        _fileSaver2.default.saveAs(blob, _this3.selectedItem.attributes.token, { autoBom: true });
	        _this3.close();
	      }).finally(function () {
	        _this3.loading = true;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return GenerateDialogController;
	}();

	exports.default = GenerateDialogController;


	var internals = {
	  _initialDesired: function _initialDesired() {
	    return [{
	      name: 'default',
	      checked: true
	    }, {
	      name: 'custom_fields',
	      checked: false
	    }, {
	      name: 'documents',
	      checked: false
	    }, {
	      name: 'acknowledgements',
	      checked: false
	    }];
	  }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _turf = __webpack_require__(52);

	var turf = _interopRequireWildcard(_turf);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AdvancedSearchDialogController = function () {
	  AdvancedSearchDialogController.$inject = ["DialogService", "GeocodingService", "MainService"];
	  function AdvancedSearchDialogController(DialogService, GeocodingService, MainService) {
	    'ngInject';

	    _classCallCheck(this, AdvancedSearchDialogController);

	    this.DialogService = DialogService;
	    this.GeocodingService = GeocodingService;
	    this.MainService = MainService;
	  }

	  _createClass(AdvancedSearchDialogController, [{
	    key: 'searchPlaces',
	    value: function searchPlaces(query) {
	      return this.GeocodingService.getPlaces(query).promise.then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'triggerSearch',
	    value: function triggerSearch() {
	      var bounds = this.selectedPlace.geometry.bounds;
	      var bbox = [bounds.southwest.lng, bounds.southwest.lat, bounds.northeast.lng, bounds.northeast.lat];
	      var obj = {
	        data: {
	          polygon: turf.bboxPolygon(bbox)
	        }
	      };

	      this.DialogService.closeDialog(obj);
	    }
	  }]);

	  return AdvancedSearchDialogController;
	}();

	exports.default = AdvancedSearchDialogController;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	var _queryOptions = __webpack_require__(236);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AdvancedFilterDialogController = function () {
	  AdvancedFilterDialogController.$inject = ["$state", "DialogService", "locals"];
	  function AdvancedFilterDialogController($state, DialogService, locals) {
	    'ngInject';

	    _classCallCheck(this, AdvancedFilterDialogController);

	    this.$state = $state;
	    this.DialogService = DialogService;

	    this.item = locals.item;
	    this.model = this.item.model;
	    this.filters = _queryOptions.FILTERS[this.model];
	    this.selectedFilters = {};

	    this.getParams();
	  }

	  _createClass(AdvancedFilterDialogController, [{
	    key: 'getParams',
	    value: function getParams() {
	      var _this = this;

	      if (this.$state.params.filters && this.item.params) {
	        var filters = internals.uriToJson(this.$state.params.filters);
	        var keys = Object.keys(filters);

	        this.filters.forEach(function (item) {
	          if (keys.includes(item.key)) {
	            _this.selectedFilters[item.key] = filters[item.key];
	          }
	        });

	        var _loop = function _loop(iterator) {
	          if (_this.selectedFilters[iterator].type == null) {
	            _this.selectedFilters[iterator].type = _this.filters.filter(function (filter) {
	              return filter.key === iterator;
	            })[0].type;
	          }
	          if (_this.selectedFilters[iterator].operator === 'btw' && !_this.selectedFilters[iterator].value1) {
	            var split = _this.selectedFilters[iterator].value.split(',');

	            if (split.length > 1) {
	              _this.selectedFilters[iterator].value1 = split[0];
	              _this.selectedFilters[iterator].value2 = split[1];
	            }
	          }
	        };

	        for (var iterator in this.selectedFilters) {
	          _loop(iterator);
	        }
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (!this.$state.params.filters) {
	        this.filters.forEach(function (f) {
	          f.selected = false;
	        });
	      }
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'triggerSearch',
	    value: function triggerSearch(filter) {
	      this.DialogService.closeDialog(filter);
	    }
	  }]);

	  return AdvancedFilterDialogController;
	}();

	exports.default = AdvancedFilterDialogController;


	var internals = {
	  uriToJson: function uriToJson(uri) {
	    if (uri) {
	      return angular.fromJson((0, _helper._decodeBase64)(decodeURIComponent(uri)));
	    }
	  }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ConfirmationDialogController = function () {
	  ConfirmationDialogController.$inject = ["locals", "DialogService"];
	  function ConfirmationDialogController(locals, DialogService) {
	    'ngInject';

	    _classCallCheck(this, ConfirmationDialogController);

	    this.DialogService = DialogService;
	    this.options = locals.item;
	  }

	  _createClass(ConfirmationDialogController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'save',
	    value: function save(res) {
	      this.DialogService.closeDialog(res);
	    }
	  }]);

	  return ConfirmationDialogController;
	}();

	exports.default = ConfirmationDialogController;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StrongConfirmationDialogController = function () {
	  StrongConfirmationDialogController.$inject = ["$window", "DialogService", "locals"];
	  function StrongConfirmationDialogController($window, DialogService, locals) {
	    'ngInject';

	    _classCallCheck(this, StrongConfirmationDialogController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.me = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.lang = this.me.attributes.locale.split('_')[0];

	    this.item = locals;
	    this.deleteText = angular.isObject(this.item.item) && angular.isDefined(this.item.item.deleteText) ? this.item.item.deleteText : false;
	    var type = angular.isObject(this.item.item) && angular.isDefined(this.item.item.type) ? this.item.item.type : null;
	    this.defaultText = type && type === 'integrations' ? 'integrations' : 'text';

	    this.strong = {
	      checked: false
	    };

	    this.setVefification();
	  }

	  _createClass(StrongConfirmationDialogController, [{
	    key: 'setVefification',
	    value: function setVefification() {
	      switch (this.lang) {
	        case 'pt':
	          this.strong.verified_text = this.deleteText ? 'excluir' : 'remover';
	          break;
	        case 'es':
	          this.strong.verified_text = this.deleteText ? 'eliminar' : 'remover';
	          break;
	        case 'en':
	          this.strong.verified_text = this.deleteText ? 'delete' : 'remove';
	          break;
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'save',
	    value: function save(res) {
	      this.DialogService.closeDialog(res);
	    }
	  }]);

	  return StrongConfirmationDialogController;
	}();

	exports.default = StrongConfirmationDialogController;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewChipController = function () {
	  NewChipController.$inject = ["$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function NewChipController($window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, NewChipController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.enterpriseIncludes = { country: ['code', 'extras'] };
	  }

	  _createClass(NewChipController, [{
	    key: 'getServiceProvider',
	    value: function getServiceProvider(text) {
	      var serviceProviders = _.get(this.selectedEnterprise, 'relationships.country.attributes.extras.chips.service_providers', []);
	      var textFormatted = text ? text.toLowerCase() : '';

	      return serviceProviders.filter(function (provider) {
	        return provider.toLowerCase().includes(textFormatted);
	      }).map(function (provider) {
	        return { name: provider };
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.processing = true;
	      var chip = {
	        data: [{
	          attributes: {
	            service_provider: this.chip.service_provider,
	            serial: this.chip.serial.toString(),
	            number: this.chip.number.toString(),
	            carrier: this.chip.carrier,
	            apn: this.chip.apn,
	            apn_username: this.chip.apn_username,
	            apn_password: this.chip.apn_password,
	            pin: this.chip.pin,
	            puk: this.chip.puk,
	            plan_size: this.chip.plan_size,
	            status: this.chip.status
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	            }
	          }
	        }]
	      };

	      (0, _helper.cleanBulkPayload)(chip, true);
	      this.MainService.create(_constants.API.V5, _constants.API.CHIPS, chip).promise.then(function () {
	        _this.processing = false;
	        _this.close();
	      }).catch(function () {
	        _this.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewChipController;
	}();

	exports.default = NewChipController;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewDeviceController = function () {
	  NewDeviceController.$inject = ["$scope", "$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function NewDeviceController($scope, $window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, NewDeviceController);

	    this.$scope = $scope;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.device = {
	      activate: true
	    };

	    this.chipsOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) },
	        'device.name': { operator: 'is', value: null }
	      }
	    };
	    this.vehiclesOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.chipsOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	      _this.vehiclesOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });
	  }

	  _createClass(NewDeviceController, [{
	    key: 'checkChangableItem',
	    value: function checkChangableItem() {
	      if (this.device) {
	        return this.selectedChip || this.selectedVehicle;
	      }
	    }
	  }, {
	    key: 'checkDeviceName',
	    value: function checkDeviceName() {
	      var _this2 = this;

	      this.processing = true;

	      var validation = function validation(value) {
	        _this2.form.name.$setValidity('nameDeviceTaken', value);
	      };

	      if (this.device.name && this.lastNameCheck !== this.device.name && !this.checking) {
	        this.checking = true;
	        var deviceName = {
	          data: {
	            names: [this.device.name]
	          }
	        };

	        this.MainService.create(_constants.API.V5, _constants.API.DEVICES + '/check-names', deviceName).promise.then(function (res) {
	          _this2.lastNameCheck = res.data[0].name;
	          _this2.lastTakenCheck = !res.data[0].isTaken;
	          validation(_this2.lastTakenCheck);
	        }).finally(function () {
	          _this2.checking = false;
	          _this2.processing = false;
	        });
	      } else if (!this.device.name) {
	        validation(true);
	        this.processing = false;
	      } else if (this.lastNameCheck === this.device.name) {
	        validation(this.lastTakenCheck);
	        this.processing = false;
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      if (this.processing) return;
	      this.processing = true;
	      var device = {
	        data: [{
	          attributes: {
	            name: this.device.name,
	            imei: this.device.imei,
	            code: this.device.code
	          },
	          activate: this.device.activate,
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	            },
	            type: {
	              type: 'type',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedModel.id)
	            }
	          }
	        }]
	      };

	      if (this.selectedChip) {
	        device.data[0].relationships.chip = {
	          type: 'chip',
	          id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedChip.id)
	        };
	      }

	      if (this.selectedVehicle) {
	        device.data[0].relationships.vehicle = {
	          type: 'vehicle',
	          id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedVehicle.id)
	        };
	      }

	      (0, _helper.cleanBulkPayload)(device, true);
	      this.MainService.create(_constants.API.V5, _constants.API.DEVICES, device).promise.then(function () {
	        _this3.close();
	      }).finally(function () {
	        _this3.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewDeviceController;
	}();

	exports.default = NewDeviceController;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewEnterpriseController = function () {
	  NewEnterpriseController.$inject = ["$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function NewEnterpriseController($window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, NewEnterpriseController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    var user = angular.fromJson(this.$window.localStorage.getItem('user'));
	    this.langUser = user.attributes.locale.replace('_', '-');
	    this.enterprise = {
	      attributes: {}
	    };
	  }

	  _createClass(NewEnterpriseController, [{
	    key: 'translateCountryName',
	    value: function translateCountryName(country) {
	      return country.language === this.langUser ? country.local_name : country.name;
	    }
	  }, {
	    key: 'getTimezones',
	    value: function getTimezones() {
	      if (!this.selectedCountry) {
	        this.enterprise.attributes.timezone = '';
	        return;
	      }
	      this.timezoneList = this.selectedCountry.attributes.timezones;

	      if (this.timezoneList.length === 1) {
	        this.enterprise.attributes.timezone = this.timezoneList[0];
	      }
	    }
	  }, {
	    key: 'getContries',
	    value: function getContries(query) {
	      var obj = {
	        attributes: ['*'],
	        search: query
	      };

	      return this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/countries', obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;

	      this.processing = true;
	      var enterprise = {
	        data: {
	          attributes: {
	            name: this.enterprise.attributes.name.toString(),
	            cnpj: this.enterprise.attributes.cnpj.toString(),
	            timezone: this.enterprise.attributes.timezone.toString(),
	            email: this.enterprise.attributes.email.toString(),
	            contact_name: this.enterprise.attributes.contact_name ? this.enterprise.attributes.contact_name.toString() : null,
	            phone1: this.enterprise.attributes.phone1 ? this.enterprise.attributes.phone1.toString() : null,
	            phone2: this.enterprise.attributes.phone2 ? this.enterprise.attributes.phone2.toString() : null,
	            description: this.enterprise.attributes.description ? this.enterprise.attributes.description.toString() : null,
	            webpage: this.enterprise.attributes.webpage ? this.enterprise.attributes.webpage.toString() : null,
	            theft_emergency_tel: this.enterprise.attributes.theft_emergency_tel ? this.enterprise.attributes.theft_emergency_tel.toString() : null,
	            assistance_emergency_tel: this.enterprise.attributes.assistance_emergency_tel ? this.enterprise.attributes.assistance_emergency_tel.toString() : null
	          },
	          relationships: {
	            country: {
	              type: 'country',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedCountry.id)
	            }
	          }
	        }
	      };

	      (0, _helper.cleanPayload)(enterprise.data, true);
	      this.MainService.create(_constants.API.V5, _constants.API.ENTERPRISES, enterprise).promise.then(function () {
	        _this.processing = false;
	        _this.close();
	      }).catch(function () {
	        _this.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewEnterpriseController;
	}();

	exports.default = NewEnterpriseController;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _sharings = __webpack_require__(167);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewSharingController = function () {
	  NewSharingController.$inject = ["$scope", "$state", "$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function NewSharingController($scope, $state, $window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, NewSharingController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.types = _constants.SHARINGS_TYPES;
	    this.sharingResourcesOpts = _sharings.SHARING_OPTS;

	    this.selected = [];
	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));

	    this.sharing = {
	      attributes: {
	        type: 'live-location',
	        resources: []
	      }
	    };
	    this.customDate = false;

	    this.devicesOptions = {
	      filters: {
	        'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id) }
	      }
	    };

	    var enterpriseIdChange = function enterpriseIdChange(id) {
	      _this.devicesOptions.filters['enterprise.id'].value = (0, _helper.hashify)(_this.EnvironmentConfig.SALT, id);
	    };

	    this.$scope.$watch(function () {
	      return _this.selectedEnterprise;
	    }, function (newVal) {
	      if (newVal && newVal.id) {
	        enterpriseIdChange(newVal.id);
	      }
	    });

	    this.updateResourceTemplate();
	    this.updateMetaValidation();
	  }

	  _createClass(NewSharingController, [{
	    key: 'toggle',
	    value: function toggle(item) {
	      var idx = this.sharing.attributes.resources.indexOf(item);
	      if (idx > -1) {
	        this.sharing.attributes.resources.splice(idx, 1);
	      } else {
	        this.sharing.attributes.resources.push(item);
	      }
	    }
	  }, {
	    key: 'exists',
	    value: function exists(item) {
	      if (this.sharing.attributes.resources == null) {
	        this.sharing.attributes.resources = [];
	      }
	      return this.sharing.attributes.resources.indexOf(item) > -1;
	    }
	  }, {
	    key: 'updateMetaValidation',
	    value: function updateMetaValidation() {
	      this.meta = {
	        min_date: moment().toISOString(),
	        max_date: moment().add(31, 'd').toISOString()
	      };
	    }
	  }, {
	    key: 'updateResourceTemplate',
	    value: function updateResourceTemplate() {
	      this.resources = '/app/components/actions/new-sharing/components/_' + this.sharing.attributes.type + '.html';
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate(day, index) {
	      this.btnSelected = index;
	      this.sharing.attributes.valid_until = moment().add(day, 'd').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;

	      this.processing = true;
	      var sharing = {
	        data: {
	          attributes: {
	            valid_until: this.sharing.attributes.valid_until,
	            description: this.sharing.attributes.description
	          }
	        }
	      };

	      sharing.data.attributes.type = this.sharing.attributes.type;
	      sharing.data.attributes.resources = this.sharing.attributes.resources;
	      sharing.data.relationships = {
	        enterprise: {
	          type: 'enterprise',
	          id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	        },
	        device: {
	          type: 'device',
	          id: this.selectedDevice.id
	        }
	      };

	      (0, _helper.cleanPayload)(sharing.data, true);
	      this.MainService.create(_constants.API.V5, _constants.API.SHARINGS, sharing).promise.then(function () {
	        _this2.close();
	        _this2.$state.go('links-list', {}, { reload: true });
	      }).finally(function () {
	        _this2.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewSharingController;
	}();

	exports.default = NewSharingController;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewUserController = function () {
	  NewUserController.$inject = ["$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function NewUserController($window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, NewUserController);

	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));
	    this.roles = [];
	    this.languages = _constants.LANGUAGES;
	    this.languageMapping = {
	      pt: 'pt_BR',
	      en: 'en_US',
	      es: 'es_UY'
	    };

	    this.getRoles();
	    this.getLanguage();
	  }

	  _createClass(NewUserController, [{
	    key: 'getRoles',
	    value: function getRoles() {
	      var _this = this;

	      var obj = {
	        attributes: ['name']
	      };

	      this.MainService.raw(_constants.API.V5, _constants.API.USERS + '/roles', obj).promise.then(function (res) {
	        _this.roles = res.data;
	      });
	    }
	  }, {
	    key: 'getLanguage',
	    value: function getLanguage() {
	      if (this.selectedEnterprise && this.selectedEnterprise.relationships && this.selectedEnterprise.relationships.country) {
	        var language = this.selectedEnterprise.relationships.country.attributes.language.slice(0, 2);

	        this.user = {
	          attributes: {
	            locale: this.languageMapping[language] || null
	          }
	        };
	      }
	    }
	  }, {
	    key: 'checkUserName',
	    value: function checkUserName() {
	      var _this2 = this;

	      this.processing = true;

	      var validation = function validation(value) {
	        _this2.form.username.$setValidity('usernameTaken', value);
	      };

	      if (this.user.attributes.username && this.lastUsernameCheck !== this.user.attributes.username && !this.checking) {
	        this.checking = true;
	        var username = {
	          data: {
	            usernames: [this.user.attributes.username]
	          }
	        };

	        this.MainService.create(_constants.API.V5, _constants.API.USERS + '/check-usernames', username).promise.then(function (res) {
	          _this2.lastUsernameCheck = res.data[0].username;
	          _this2.lastTakenCheck = !res.data[0].isTaken;
	          validation(_this2.lastTakenCheck);
	        }).finally(function () {
	          _this2.processing = false;
	          _this2.checking = false;
	        });
	      } else if (!this.user.attributes.username) {
	        validation(true);
	        this.processing = false;
	      } else if (this.lastUsernameCheck === this.user.attributes.username) {
	        validation(this.lastTakenCheck);
	        this.processing = false;
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;

	      if (this.processing) return;
	      this.processing = true;
	      var user = {
	        data: [{
	          attributes: {
	            name: this.user.attributes.name.toString(),
	            username: this.user.attributes.username.toString(),
	            email: this.user.attributes.email ? this.user.attributes.email.toString() : null,
	            cpf: this.user.attributes.cpf.toString(),
	            phone1: this.user.attributes.phone1.toString(),
	            locale: this.user.attributes.locale.toString(),
	            document_number: this.user.attributes.document_number ? this.user.attributes.document_number.toString() : null,
	            birthdate: this.user.attributes.birthdate ? this.user.attributes.birthdate.toString() : null,
	            password: this.user.attributes.password ? this.user.attributes.password.toString() : null,
	            phone2: this.user.attributes.phone2 ? this.user.attributes.phone2.toString() : null,
	            emergency_contact: this.user.attributes.emergency_contact ? this.user.attributes.emergency_contact.toString() : null,
	            emergency_phone: this.user.attributes.emergency_phone ? this.user.attributes.emergency_phone.toString() : null
	          },
	          relationships: {
	            enterprise: {
	              type: 'enterprise',
	              id: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.selectedEnterprise.id)
	            },
	            roles: {
	              type: 'roles',
	              id: this.user.relationships.roles.id
	            }
	          }
	        }]
	      };

	      (0, _helper.cleanBulkPayload)(user, true);
	      this.MainService.create(_constants.API.V5, _constants.API.USERS, user).promise.then(function () {
	        _this3.processing = false;
	        _this3.close();
	      }).catch(function () {
	        _this3.processing = false;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return NewUserController;
	}();

	exports.default = NewUserController;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global FileReader:false */
	/* global XLSX:false */


	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FromOutSourceController = function () {
	  FromOutSourceController.$inject = ["$timeout", "$window", "DialogService", "EnvironmentConfig", "MainService"];
	  function FromOutSourceController($timeout, $window, DialogService, EnvironmentConfig, MainService) {
	    'ngInject';

	    _classCallCheck(this, FromOutSourceController);

	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.selectedEnterprise = angular.fromJson(this.$window.localStorage.getItem('enterprise'));

	    this.items = {
	      data: []
	    };

	    this.maxImports = 1000;

	    this.selectedEntity = null;
	    this.importables = _constants.IMPORTABLES;
	    this.vehicleTypes = _constants.ASSET_TYPES.map(function (a) {
	      return a.name;
	    });
	    this.historyKeys = [];
	    this.changeStep(1);
	    this.buildFilePatterns();
	  }

	  _createClass(FromOutSourceController, [{
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }, {
	    key: 'changeStep',
	    value: function changeStep(step) {
	      this.activeStep = step;
	    }
	  }, {
	    key: 'buildFilePatterns',
	    value: function buildFilePatterns() {
	      var mimes = _constants.FILES.SHEETS.MIMES;
	      var extensions = _constants.FILES.SHEETS.EXTENSIONS;
	      this.pattern = mimes.join(',') + ',' + extensions.join(',');
	    }
	  }, {
	    key: 'selectEntity',
	    value: function selectEntity() {
	      this.previewData = [];
	      this.buildTable(this.selectedEntity);
	      this.changeStep(2);
	    }
	  }, {
	    key: 'uploadFiles',
	    value: function uploadFiles(file) {
	      var _this = this;

	      if (!file.length) return;
	      this.loading = true;
	      this.fileName = file[0].name;
	      this.items.data = [];
	      this.previewData = [];
	      this.desiredKeys = [];
	      this.historyKeys = [];
	      this.form.$setPristine();
	      var reader = new FileReader();
	      reader.onload = function (e) {
	        var data = e.target.result;
	        var workbook = XLSX.read(data, { type: 'binary', raw: true });
	        var sheetNameList = workbook.SheetNames;
	        sheetNameList.forEach(function (sheetName) {
	          var jsonObject = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
	          _this._pushXLSXDataToPayload(jsonObject);
	        });
	      };
	      reader.readAsBinaryString(file[0]);
	    }
	  }, {
	    key: 'buildTable',
	    value: function buildTable(entity) {
	      var tableSize = this.importables[entity].keys.length;
	      this.tableColHolder = [].concat(_toConsumableArray(Array(tableSize + 1).keys())).slice(1);
	      this.tableRowHolder = [].concat(_toConsumableArray(Array(15).keys())).slice(2);
	    }
	  }, {
	    key: 'createItens',
	    value: function createItens() {
	      var _this2 = this;

	      this.processing = true;
	      var content = angular.copy(this.itemsForUpload);
	      content.data.forEach(function (item) {
	        delete item.empty;
	        delete item.duplicated;
	        delete item.emptyKeys;
	        delete item.duplicatedKeys;
	        (0, _helper.cleanPayload)(item, true);
	      });

	      this.MainService.create(_constants.API.V4, this.selectedEntity, content).promise.then(function () {
	        _this2.processing = false;
	        _this2.close();
	      }).catch(function () {
	        _this2.processing = false;
	      });
	    }
	  }, {
	    key: 'removeItemFromList',
	    value: function removeItemFromList(index) {
	      this.previewData.splice(index, 1);
	      if (this.previewData.length === 0) {
	        this.backPreviewTable();
	      } else {
	        this.prepareToPush();
	      }
	    }
	  }, {
	    key: 'backPreviewTable',
	    value: function backPreviewTable() {
	      this.changeStep(3);
	      this.form.$setPristine();
	      this.previewData = [];
	      this.desiredKeys = [];
	      this.historyKeys = [];
	      this.historyKeys = [];
	    }
	  }, {
	    key: 'mapKeys',
	    value: function mapKeys(index, key) {
	      if (this.desiredKeys[index]) {
	        this.historyKeys[index] = key;
	      } else {
	        delete this.historyKeys[index];
	      }
	      this.buildPreviewData();
	    }
	  }, {
	    key: 'buildPreviewData',
	    value: function buildPreviewData() {
	      var _this3 = this;

	      this.previewData = [];
	      this.items.data.forEach(function (elem, index) {
	        if (angular.isUndefined(_this3.previewData[index])) _this3.previewData.push({});

	        _this3.historyKeys.forEach(function (key, i) {
	          _this3.previewData[index][key] = elem[_this3.desiredKeys[i]] ? elem[_this3.desiredKeys[i]].toString() : '';
	        });
	      });
	    }
	  }, {
	    key: 'prepareToPush',
	    value: function prepareToPush() {
	      var _this4 = this;

	      this.formatting = true;
	      this.disabledSubmit = false;
	      this.itemsForUpload = {
	        data: []
	      };

	      this.previewData.forEach(function (elem, indexFor) {
	        var newItem = {
	          attributes: elem
	        };
	        newItem.emptyKeys = [];
	        newItem.duplicatedKeys = [];

	        if (_this4.selectedEntity === 'vehicles') {
	          var plates = _this4.previewData.map(function (item) {
	            return item.plate;
	          });
	          plates.splice(indexFor, 1);

	          newItem.empty = !elem.plate;
	          newItem.duplicated = plates.includes(elem.plate);
	          newItem.emptyKeys.push('plate');
	          newItem.duplicatedKeys.push('plate');

	          newItem.attributes.type = _this4.selectedType;
	          newItem.attributes.batch = _this4.batch;
	          newItem.relationships = {
	            enterprise: {
	              type: 'enterprise',
	              uuid: _this4.selectedEnterprise.uuid
	            }
	          };
	        }

	        if (_this4.selectedEntity === 'devices') {
	          var name = _this4.previewData.map(function (item) {
	            return item.name;
	          });
	          var imei = _this4.previewData.map(function (item) {
	            return item.imei;
	          });

	          name.splice(indexFor, 1);
	          imei.splice(indexFor, 1);

	          newItem.empty = !elem.name || !elem.imei;
	          newItem.duplicated = name.includes(elem.name) || imei.includes(elem.imei);
	          if (!elem.name) newItem.emptyKeys.push('name');
	          if (!elem.imei) newItem.emptyKeys.push('imei');
	          if (name.includes(elem.name)) newItem.duplicatedKeys.push('name');
	          if (imei.includes(elem.imei)) newItem.duplicatedKeys.push('imei');

	          newItem.attributes.batch = _this4.batch;
	          newItem.relationships = {
	            device_types: {
	              type: 'device_types',
	              id: (0, _helper.decodify)(_this4.EnvironmentConfig.SALT, _this4.selectedModel.id)
	            },
	            enterprises: {
	              type: 'enterprises',
	              id: (0, _helper.decodify)(_this4.EnvironmentConfig.SALT, _this4.selectedEnterprise.id)
	            }
	          };
	        }

	        if (_this4.selectedEntity === 'chips') {
	          var serial = _this4.previewData.map(function (item) {
	            return item.serial;
	          });
	          var number = _this4.previewData.map(function (item) {
	            return item.number;
	          });

	          serial.splice(indexFor, 1);
	          number.splice(indexFor, 1);

	          newItem.empty = !elem.serial || !elem.number || !elem.service_provider;
	          newItem.duplicated = serial.includes(elem.serial) || number.includes(elem.number);
	          if (!elem.serial) newItem.emptyKeys.push('serial');
	          if (!elem.number) newItem.emptyKeys.push('imei');
	          if (!elem.service_provider) newItem.emptyKeys.push('service_provider');
	          if (serial.includes(elem.serial)) newItem.duplicatedKeys.push('serial');
	          if (number.includes(elem.number)) newItem.duplicatedKeys.push('number');

	          newItem.attributes.batch = _this4.batch;
	          newItem.relationships = {
	            enterprise: {
	              type: 'enterprise',
	              uuid: _this4.selectedEnterprise.uuid
	            }
	          };
	        }

	        if (newItem.empty || newItem.duplicated) _this4.disabledSubmit = true;
	        _this4.itemsForUpload.data.push(newItem);
	      });

	      this.exceededLimit = this.itemsForUpload.data.length > this.maxImports;
	      this.selectedKeys = Object.keys(this.itemsForUpload.data[0].attributes);
	      this.changeStep(4);
	      this.formatting = false;
	    }
	  }, {
	    key: '_pushXLSXDataToPayload',
	    value: function _pushXLSXDataToPayload(data) {
	      var _this5 = this;

	      if (data.length === 0) {
	        return;
	      }

	      data.forEach(function (item) {
	        var keys = [].concat(_toConsumableArray(Object.keys(item)));
	        var keysFormataded = keys.map(function (item) {
	          return (0, _helper.utf8Decode)(item);
	        });

	        keysFormataded.forEach(function (key, index) {
	          var oldKey = keys[index];
	          var newValue = _defineProperty({}, key, (0, _helper.utf8Decode)(item[oldKey]));
	          Object.assign(item, newValue);

	          if (oldKey !== key) {
	            delete item[oldKey];
	          }
	        });
	      });

	      this.fileKeys = [];
	      data.forEach(function (item) {
	        var keys = Object.keys(item);
	        _this5.fileKeys = keys.length >= _this5.fileKeys.length ? [null].concat(_toConsumableArray(keys)) : _this5.fileKeys;
	      });

	      this.$timeout(function () {
	        _this5.items.data = data;
	        _this5.loading = false;
	        _this5.changeStep(3);
	      }, 1000);
	    }
	  }]);

	  return FromOutSourceController;
	}();

	exports.default = FromOutSourceController;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _constants = __webpack_require__(9);

	var _helper = __webpack_require__(21);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AddNewItemController = function () {
	  AddNewItemController.$inject = ["DialogService", "EnvironmentConfig", "MainService", "locals"];
	  function AddNewItemController(DialogService, EnvironmentConfig, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, AddNewItemController);

	    this.DialogService = DialogService;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;
	    this.locals = locals;

	    this.enterprise = this.locals.item && this.locals.item.enterprise ? this.locals.item.enterprise : null;

	    this.devicesOptions = {
	      filters: {
	        'vehicle.id': { operator: 'is', value: null }
	      }
	    };
	    this.usersOptions = {
	      includes: { enterprise: ['name'] }
	    };
	    this.vehiclesOptions = {
	      attributes: ['brand_name,vin,model_name,batch']
	    };
	    if (this.enterprise) {
	      this.devicesOptions.filters['enterprise.id'] = { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.enterprise.id) };
	      this.usersOptions.filters = { 'enterprise.id': { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.enterprise.id) } };
	    }
	  }

	  _createClass(AddNewItemController, [{
	    key: 'getTaskItems',
	    value: function getTaskItems(query) {
	      var obj = {
	        attributes: ['*'],
	        includes: {
	          enterprise: ['name']
	        },
	        filters: {},
	        search: query
	      };

	      if (this.enterprise) {
	        obj.filters['enterprise.id'] = { operator: 'eq', value: (0, _helper.hashify)(this.EnvironmentConfig.SALT, this.enterprise.id) };
	      }

	      return this.MainService.raw(_constants.API.V5, _constants.API.CHECKLISTS + '/items', obj).promise.then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close(res) {
	      this.DialogService.closeDialog(res);
	    }
	  }, {
	    key: 'finish',
	    value: function finish() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return AddNewItemController;
	}();

	exports.default = AddNewItemController;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GalleryDialogController = function () {
	  GalleryDialogController.$inject = ["$timeout", "DialogService", "locals"];
	  function GalleryDialogController($timeout, DialogService, locals) {
	    'ngInject';

	    _classCallCheck(this, GalleryDialogController);

	    this.$timeout = $timeout;
	    this.DialogService = DialogService;

	    this.images = angular.copy(locals.item.images);
	    this.currentIndex = locals.item.current ? angular.copy(locals.item.current) : 0;
	    this.total = angular.isArray(this.images) ? this.images.length : 0;
	    this.loading = true;
	    this.title = '';

	    this.init();
	  }

	  _createClass(GalleryDialogController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;

	      this.$timeout(function () {
	        _this.updateLinkDownload();
	        _this.loading = false;
	      }, 300);
	    }
	  }, {
	    key: 'updateLinkDownload',
	    value: function updateLinkDownload() {
	      this.currentLink = this.images[this.currentIndex].src;
	      this.currentAlt = this.images[this.currentIndex].alt;
	      this.title = this.images[this.currentIndex].alt;
	    }
	  }, {
	    key: 'keyboardEvent',
	    value: function keyboardEvent(event) {
	      if (event.keyCode === 37 && !this.loading) {
	        this.prevSlide();
	      }
	      if (event.keyCode === 39 && !this.loading) {
	        this.nextSlide();
	      }
	    }
	  }, {
	    key: 'nextSlide',
	    value: function nextSlide() {
	      if (this.currentIndex === this.images.length - 1) return '';
	      this.currentIndex++;
	      this.updateLinkDownload();
	    }
	  }, {
	    key: 'prevSlide',
	    value: function prevSlide() {
	      if (this.currentIndex === 0) return '';
	      this.currentIndex--;
	      this.updateLinkDownload();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.DialogService.finishDialog();
	    }
	  }]);

	  return GalleryDialogController;
	}();

	exports.default = GalleryDialogController;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UpdatingDialogController = function () {
	  UpdatingDialogController.$inject = ["$interval", "$window", "DialogService"];
	  function UpdatingDialogController($interval, $window, DialogService) {
	    'ngInject';

	    _classCallCheck(this, UpdatingDialogController);

	    this.$interval = $interval;
	    this.$window = $window;
	    this.DialogService = DialogService;

	    this.setInterval();
	  }

	  _createClass(UpdatingDialogController, [{
	    key: 'setInterval',
	    value: function setInterval() {
	      var _this = this;

	      this.intervalPromise = this.$interval(function () {
	        _this.checkRefreshToken();
	      }, 300);
	    }
	  }, {
	    key: 'cancelInterval',
	    value: function cancelInterval() {
	      if (!this.intervalPromise) return;
	      this.$interval.cancel(this.intervalPromise);
	      this.intervalPromise = null;
	    }
	  }, {
	    key: 'checkRefreshToken',
	    value: function checkRefreshToken() {
	      var finishAuthentication = !this.$window.localStorage.getItem('authenticating_token');

	      if (finishAuthentication) {
	        this.DialogService.closeDialog();
	        this.cancelInterval();
	      }
	    }
	  }]);

	  return UpdatingDialogController;
	}();

	exports.default = UpdatingDialogController;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helper = __webpack_require__(21);

	var _constants = __webpack_require__(9);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var IntegrationsDialogController = function () {
	  IntegrationsDialogController.$inject = ["$document", "$mdDialog", "$mdSelect", "$state", "$timeout", "EnvironmentConfig", "MainService", "locals"];
	  function IntegrationsDialogController($document, $mdDialog, $mdSelect, $state, $timeout, EnvironmentConfig, MainService, locals) {
	    'ngInject';

	    _classCallCheck(this, IntegrationsDialogController);

	    this.$document = $document;
	    this.$mdDialog = $mdDialog;
	    this.$mdSelect = $mdSelect;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.EnvironmentConfig = EnvironmentConfig;
	    this.MainService = MainService;

	    this.data = _initial.data();
	    this.editing = false;
	    this.locals = angular.copy(locals);
	    this.source = _initial.source();
	    this.usedSource = [];

	    if (this.locals.item) {
	      if (this.locals.item.attributes && this.locals.item.attributes.auth) {
	        this.isEdit();
	        this.currentEnterprise = {
	          id: this.$state.params.id
	        };
	      }
	      if (this.locals.item.usedSource) {
	        this.usedSource = this.locals.item.usedSource;
	      }
	    }
	  }

	  _createClass(IntegrationsDialogController, [{
	    key: 'isEdit',
	    value: function isEdit() {
	      this.data = this.locals.item.attributes;
	      this.editing = true;
	      this.changeSource();
	    }
	  }, {
	    key: 'changeSource',
	    value: function changeSource() {
	      var _this = this;

	      if (!this.editing) {
	        this.data.integrated_entities = null;

	        if (['mutual', 'hinova-sga'].includes(this.data.source)) {
	          Object.assign(this.data.config, _initial.activeSituation());
	        } else {
	          ['user_active_situation', 'vehicle_active_situation'].forEach(function (key) {
	            return delete _this.data.config[key];
	          });
	        }
	      }
	      this.entities = this.data.source === 'hinova-sgr' ? _initial.entitiesAll() : _initial.entitiesDefault();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.$mdDialog.cancel();
	    }
	  }, {
	    key: 'checkSourceUsed',
	    value: function checkSourceUsed(item) {
	      return this.usedSource.includes(item);
	    }
	  }, {
	    key: 'validateUrl',
	    value: function validateUrl(url) {
	      try {
	        this.url = new URL(url);
	        this.form.api_url.$setValidity('invalid', this.url.protocol === 'http:' || this.url.protocol === 'https:');
	      } catch (_) {
	        this.form.api_url.$setValidity('invalid', false);
	      }
	    }
	  }, {
	    key: 'forceClose',
	    value: function forceClose() {
	      var _this2 = this;

	      this.$timeout(function () {
	        _this2.$mdSelect.hide();
	      }, 50);
	    }
	  }, {
	    key: 'generateToken',
	    value: function generateToken() {
	      var _this3 = this;

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.id + '/integrations/' + this.locals.item.id + '/generate-token').promise.then(function (res) {
	        if (res.status === 'ok') {
	          _this3.code = res.token;
	        }
	      }).finally(function () {
	        _this3.disabledBtn = true;
	      });
	    }
	  }, {
	    key: 'configureIntegration',
	    value: function configureIntegration(type) {
	      var _this4 = this;

	      this.loading = true;
	      this.type = type;
	      this.tooltipVisible = true;

	      this.MainService.create(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.id + '/integrations/' + this.locals.item.id + '/configure').promise.then(function (res) {
	        _this4.successIcon = res.data.configured;
	      }).catch(function () {
	        _this4.successIcon = false;
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    }
	  }, {
	    key: 'testIntegration',
	    value: function testIntegration(type) {
	      var _this5 = this;

	      this.loading = true;
	      this.type = type;
	      this.tooltipVisible = true;

	      this.MainService.raw(_constants.API.V5, _constants.API.ENTERPRISES + '/' + this.currentEnterprise.id + '/integrations/' + this.locals.item.id + '/test').promise.then(function (res) {
	        _this5.successIcon = !res.data.error;
	      }).catch(function () {
	        _this5.successIcon = false;
	      }).finally(function () {
	        _this5.loading = false;
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      this.form.$setSubmitted();

	      if (this.form.$valid) {
	        this.save();
	      }
	    }
	  }, {
	    key: 'upperCase',
	    value: function upperCase(key, chip, index) {
	      this.data.config[key][index] = chip.toUpperCase();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      if (!this.editing && this.data.auth.api_url) {
	        this.validateUrl(this.data.auth.api_url);
	        if (this.form.$invalid) return;
	      }

	      this.data.default_user_role_id = (0, _helper.hashify)(this.EnvironmentConfig.SALT, 6);
	      if (this.editing) {
	        (0, _helper.omit)(this.data, ['created_at', 'updated_at', 'deleted_at', 'auth', 'scheduled_sync', 'source']);
	      }

	      var data = {
	        data: this.data
	      };
	      (0, _helper.cleanPayload)(data, false, 'data');
	      this.$mdDialog.hide(data);
	    }
	  }]);

	  return IntegrationsDialogController;
	}();

	exports.default = IntegrationsDialogController;


	var _initial = {
	  activeSituation: function activeSituation() {
	    return {
	      user_active_situation: [],
	      vehicle_active_situation: []
	    };
	  },
	  data: function data() {
	    return {
	      auth: {},
	      config: {
	        use_external_id_to_match: true
	      }
	    };
	  },
	  entitiesDefault: function entitiesDefault() {
	    return ['vehicles', 'users'];
	  },
	  entitiesAll: function entitiesAll() {
	    return ['vehicles', 'users', 'devices', 'chips'];
	  },
	  source: function source() {
	    return ['hinova-sgr', 'hinova-sga', 'siprov', 'mutual'];
	  }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var moduleName = __webpack_require__(339);

	module.exports = moduleName;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = angular.module('ui.utils.masks', [
		__webpack_require__(340),
		__webpack_require__(387),
		__webpack_require__(399),
		__webpack_require__(401),
		__webpack_require__(403)
	]).name;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var m = angular.module('ui.utils.masks.global', [])
		.directive('uiCreditCardMask', __webpack_require__(341))
		.directive('uiDateMask', __webpack_require__(344))
		.directive('uiMoneyMask', __webpack_require__(379))
		.directive('uiNumberMask', __webpack_require__(382))
		.directive('uiPercentageMask', __webpack_require__(384))
		.directive('uiScientificNotationMask', __webpack_require__(385))
		.directive('uiTimeMask', __webpack_require__(386));

	module.exports = m.name;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var ccSize = 16;

	var ccMask = new StringMask('0000 0000 0000 0000');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.toString().replace(/[^0-9]/g, '').slice(0, ccSize);
		},
		format: function(cleanValue) {
			var formatedValue;

			formatedValue = ccMask.apply(cleanValue) || '';

			return formatedValue.trim().replace(/[^0-9]$/, '');
		},
		validations: {
			creditCard: function(value) {
				var valueLength = value && value.toString().length;
				return valueLength === ccSize;
			}
		}
	});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    /* istanbul ignore next */
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.StringMask = factory();
	    }
	}(this, function() {
	    var tokens = {
	        '0': {pattern: /\d/, _default: '0'},
	        '9': {pattern: /\d/, optional: true},
	        '#': {pattern: /\d/, optional: true, recursive: true},
	        'A': {pattern: /[a-zA-Z0-9]/},
	        'S': {pattern: /[a-zA-Z]/},
	        'U': {pattern: /[a-zA-Z]/, transform: function(c) { return c.toLocaleUpperCase(); }},
	        'L': {pattern: /[a-zA-Z]/, transform: function(c) { return c.toLocaleLowerCase(); }},
	        '$': {escape: true}
	    };

	    function isEscaped(pattern, pos) {
	        var count = 0;
	        var i = pos - 1;
	        var token = {escape: true};
	        while (i >= 0 && token && token.escape) {
	            token = tokens[pattern.charAt(i)];
	            count += token && token.escape ? 1 : 0;
	            i--;
	        }
	        return count > 0 && count % 2 === 1;
	    }

	    function calcOptionalNumbersToUse(pattern, value) {
	        var numbersInP = pattern.replace(/[^0]/g,'').length;
	        var numbersInV = value.replace(/[^\d]/g,'').length;
	        return numbersInV - numbersInP;
	    }

	    function concatChar(text, character, options, token) {
	        if (token && typeof token.transform === 'function') {
	            character = token.transform(character);
	        }
	        if (options.reverse) {
	            return character + text;
	        }
	        return text + character;
	    }

	    function hasMoreTokens(pattern, pos, inc) {
	        var pc = pattern.charAt(pos);
	        var token = tokens[pc];
	        if (pc === '') {
	            return false;
	        }
	        return token && !token.escape ? true : hasMoreTokens(pattern, pos + inc, inc);
	    }

	    function hasMoreRecursiveTokens(pattern, pos, inc) {
	        var pc = pattern.charAt(pos);
	        var token = tokens[pc];
	        if (pc === '') {
	            return false;
	        }
	        return token && token.recursive ? true : hasMoreRecursiveTokens(pattern, pos + inc, inc);
	    }

	    function insertChar(text, char, position) {
	        var t = text.split('');
	        t.splice(position, 0, char);
	        return t.join('');
	    }

	    function StringMask(pattern, opt) {
	        this.options = opt || {};
	        this.options = {
	            reverse: this.options.reverse || false,
	            usedefaults: this.options.usedefaults || this.options.reverse
	        };
	        this.pattern = pattern;
	    }

	    StringMask.prototype.process = function proccess(value) {
	        if (!value) {
	            return {result: '', valid: false};
	        }
	        value = value + '';
	        var pattern2 = this.pattern;
	        var valid = true;
	        var formatted = '';
	        var valuePos = this.options.reverse ? value.length - 1 : 0;
	        var patternPos = 0;
	        var optionalNumbersToUse = calcOptionalNumbersToUse(pattern2, value);
	        var escapeNext = false;
	        var recursive = [];
	        var inRecursiveMode = false;

	        var steps = {
	            start: this.options.reverse ? pattern2.length - 1 : 0,
	            end: this.options.reverse ? -1 : pattern2.length,
	            inc: this.options.reverse ? -1 : 1
	        };

	        function continueCondition(options) {
	            if (!inRecursiveMode && !recursive.length && hasMoreTokens(pattern2, patternPos, steps.inc)) {
	                // continue in the normal iteration
	                return true;
	            } else if (!inRecursiveMode && recursive.length &&
	                hasMoreRecursiveTokens(pattern2, patternPos, steps.inc)) {
	                // continue looking for the recursive tokens
	                // Note: all chars in the patterns after the recursive portion will be handled as static string
	                return true;
	            } else if (!inRecursiveMode) {
	                // start to handle the recursive portion of the pattern
	                inRecursiveMode = recursive.length > 0;
	            }

	            if (inRecursiveMode) {
	                var pc = recursive.shift();
	                recursive.push(pc);
	                if (options.reverse && valuePos >= 0) {
	                    patternPos++;
	                    pattern2 = insertChar(pattern2, pc, patternPos);
	                    return true;
	                } else if (!options.reverse && valuePos < value.length) {
	                    pattern2 = insertChar(pattern2, pc, patternPos);
	                    return true;
	                }
	            }
	            return patternPos < pattern2.length && patternPos >= 0;
	        }

	        /**
	         * Iterate over the pattern's chars parsing/matching the input value chars
	         * until the end of the pattern. If the pattern ends with recursive chars
	         * the iteration will continue until the end of the input value.
	         *
	         * Note: The iteration must stop if an invalid char is found.
	         */
	        for (patternPos = steps.start; continueCondition(this.options); patternPos = patternPos + steps.inc) {
	            // Value char
	            var vc = value.charAt(valuePos);
	            // Pattern char to match with the value char
	            var pc = pattern2.charAt(patternPos);

	            var token = tokens[pc];
	            if (recursive.length && token && !token.recursive) {
	                // In the recursive portion of the pattern: tokens not recursive must be seen as static chars
	                token = null;
	            }

	            // 1. Handle escape tokens in pattern
	            // go to next iteration: if the pattern char is a escape char or was escaped
	            if (!inRecursiveMode || vc) {
	                if (this.options.reverse && isEscaped(pattern2, patternPos)) {
	                    // pattern char is escaped, just add it and move on
	                    formatted = concatChar(formatted, pc, this.options, token);
	                    // skip escape token
	                    patternPos = patternPos + steps.inc;
	                    continue;
	                } else if (!this.options.reverse && escapeNext) {
	                    // pattern char is escaped, just add it and move on
	                    formatted = concatChar(formatted, pc, this.options, token);
	                    escapeNext = false;
	                    continue;
	                } else if (!this.options.reverse && token && token.escape) {
	                    // mark to escape the next pattern char
	                    escapeNext = true;
	                    continue;
	                }
	            }

	            // 2. Handle recursive tokens in pattern
	            // go to next iteration: if the value str is finished or
	            //                       if there is a normal token in the recursive portion of the pattern
	            if (!inRecursiveMode && token && token.recursive) {
	                // save it to repeat in the end of the pattern and handle the value char now
	                recursive.push(pc);
	            } else if (inRecursiveMode && !vc) {
	                // in recursive mode but value is finished. Add the pattern char if it is not a recursive token
	                formatted = concatChar(formatted, pc, this.options, token);
	                continue;
	            } else if (!inRecursiveMode && recursive.length > 0 && !vc) {
	                // recursiveMode not started but already in the recursive portion of the pattern
	                continue;
	            }

	            // 3. Handle the value
	            // break iterations: if value is invalid for the given pattern
	            if (!token) {
	                // add char of the pattern
	                formatted = concatChar(formatted, pc, this.options, token);
	                if (!inRecursiveMode && recursive.length) {
	                    // save it to repeat in the end of the pattern
	                    recursive.push(pc);
	                }
	            } else if (token.optional) {
	                // if token is optional, only add the value char if it matchs the token pattern
	                //                       if not, move on to the next pattern char
	                if (token.pattern.test(vc) && optionalNumbersToUse) {
	                    formatted = concatChar(formatted, vc, this.options, token);
	                    valuePos = valuePos + steps.inc;
	                    optionalNumbersToUse--;
	                } else if (recursive.length > 0 && vc) {
	                    valid = false;
	                    break;
	                }
	            } else if (token.pattern.test(vc)) {
	                // if token isn't optional the value char must match the token pattern
	                formatted = concatChar(formatted, vc, this.options, token);
	                valuePos = valuePos + steps.inc;
	            } else if (!vc && token._default && this.options.usedefaults) {
	                // if the token isn't optional and has a default value, use it if the value is finished
	                formatted = concatChar(formatted, token._default, this.options, token);
	            } else {
	                // the string value don't match the given pattern
	                valid = false;
	                break;
	            }
	        }

	        return {result: formatted, valid: valid};
	    };

	    StringMask.prototype.apply = function(value) {
	        return this.process(value).result;
	    };

	    StringMask.prototype.validate = function(value) {
	        return this.process(value).valid;
	    };

	    StringMask.process = function(value, pattern, options) {
	        return new StringMask(pattern, options).process(value);
	    };

	    StringMask.apply = function(value, pattern, options) {
	        return new StringMask(pattern, options).apply(value);
	    };

	    StringMask.validate = function(value, pattern, options) {
	        return new StringMask(pattern, options).validate(value);
	    };

	    return StringMask;
	}));


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function maskFactory(maskDefinition) {
		return function MaskDirective() {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function(scope, element, attrs, ctrl) {
					ctrl.$formatters.push(function formatter(value) {
						if (ctrl.$isEmpty(value)) {
							return value;
						}

						var cleanValue = maskDefinition.clearValue(value.toString(), attrs);
						return maskDefinition.format(cleanValue);
					});

					ctrl.$parsers.push(function parser(value) {
						if (ctrl.$isEmpty(value)) {
							return value;
						}

						var cleanValue = maskDefinition.clearValue(value.toString(), attrs);
						var formattedValue = maskDefinition.format(cleanValue);

						if (ctrl.$viewValue !== formattedValue) {
							ctrl.$setViewValue(formattedValue);
							ctrl.$render();
						}

						if (angular.isUndefined(maskDefinition.getModelValue)) {
							return cleanValue;
						}

						var actualModelType = typeof ctrl.$modelValue;
						return maskDefinition.getModelValue(formattedValue, actualModelType);
					});

					angular.forEach(maskDefinition.validations, function(validatorFn, validationErrorKey) {
						ctrl.$validators[validationErrorKey] = function validator(modelValue, viewValue) {
							return ctrl.$isEmpty(modelValue) || validatorFn(modelValue, viewValue, attrs);
						};
					});
				}
			};
		};
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var formatDate = __webpack_require__(345);
	var parseDate = __webpack_require__(369);
	var isValidDate = __webpack_require__(347);
	var StringMask = __webpack_require__(342);

	function isISODateString(date) {
		return /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}([-+][0-9]{2}:[0-9]{2}|Z)$/
			.test(date.toString());
	}

	var dateFormatMapByLocale = {
		'pt-br': 'DD/MM/YYYY',
		'es-ar': 'DD/MM/YYYY',
		'es-mx': 'DD/MM/YYYY',
		'es'   : 'DD/MM/YYYY',
		'en-us': 'MM/DD/YYYY',
		'en'   : 'MM/DD/YYYY',
		'fr-fr': 'DD/MM/YYYY',
		'fr'   : 'DD/MM/YYYY',
		'ru'   : 'DD.MM.YYYY'
	};

	function DateMaskDirective($locale) {
		var dateFormat = dateFormatMapByLocale[$locale.id] || 'YYYY-MM-DD';

		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				attrs.parse = attrs.parse || 'true';

				dateFormat = attrs.uiDateMask || dateFormat;

				var dateMask = new StringMask(dateFormat.replace(/[YMD]/g,'0'));

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return null;
					}

					var cleanValue = value;
					if (typeof value === 'object' || isISODateString(value)) {
						cleanValue = formatDate(value, dateFormat);
					}

					cleanValue = cleanValue.replace(/[^0-9]/g, '');
					var formatedValue = dateMask.apply(cleanValue) || '';

					return formatedValue.trim().replace(/[^0-9]$/, '');
				}

				ctrl.$formatters.push(formatter);

				ctrl.$parsers.push(function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var formatedValue = formatter(value);

					if (ctrl.$viewValue !== formatedValue) {
						ctrl.$setViewValue(formatedValue);
						ctrl.$render();
					}

					return attrs.parse === 'false'
						? formatedValue
						: parseDate(formatedValue, dateFormat, new Date());
				});

				ctrl.$validators.date =	function validator(modelValue, viewValue) {
					if (ctrl.$isEmpty(modelValue)) {
						return true;
					}

					return isValidDate(parseDate(viewValue, dateFormat, new Date())) && viewValue.length === dateFormat.length;
				};
			}
		};
	}
	DateMaskDirective.$inject = ['$locale'];

	module.exports = DateMaskDirective;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(347);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(348);

	var _index6 = _interopRequireDefault(_index5);

	var _index7 = __webpack_require__(361);

	var _index8 = _interopRequireDefault(_index7);

	var _index9 = __webpack_require__(367);

	var _index10 = _interopRequireDefault(_index9);

	var _index11 = __webpack_require__(368);

	var _index12 = _interopRequireDefault(_index11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 * | Long format             | LT    | 05:30 a.m.                       |
	 * |                         | LTS   | 05:30:15 a.m.                    |
	 * |                         | L     | 07/02/1995                       |
	 * |                         | l     | 7/2/1995                         |
	 * |                         | LL    | July 2 1995                      |
	 * |                         | ll    | Jul 2 1995                       |
	 * |                         | LLL   | July 2 1995 05:30 a.m.           |
	 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
	 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
	 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }

	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};

	  var locale = options.locale || _index6.default;

	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }

	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }

	  var localeFormatters = locale.formatters || {};
	  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
	  var formatLong = locale.formatLong;

	  var originalDate = (0, _index2.default)(dirtyDate, options);

	  if (!(0, _index4.default)(originalDate, options)) {
	    return 'Invalid Date';
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = originalDate.getTimezoneOffset();
	  var utcDate = (0, _index12.default)(originalDate, -timezoneOffset, options);

	  var formatterOptions = (0, _index10.default)(options);
	  formatterOptions.locale = locale;
	  formatterOptions.formatters = _index8.default;

	  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
	  // Right now, please don't use it in locales. If you have to use an original date,
	  // please restore it from `date`, adding a timezone offset to it.
	  formatterOptions._originalDate = originalDate;

	  var result = formatStr.replace(longFormattingTokensRegExp, function (substring) {
	    if (substring[0] === '[') {
	      return substring;
	    }

	    if (substring[0] === '\\') {
	      return cleanEscapedString(substring);
	    }

	    return formatLong(substring);
	  }).replace(formattingTokensRegExp, function (substring) {
	    var formatter = localeFormatters[substring] || _index8.default[substring];

	    if (formatter) {
	      return formatter(utcDate, formatterOptions);
	    } else {
	      return cleanEscapedString(substring);
	    }
	  });

	  return result;
	}

	function cleanEscapedString(input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '');
	  }
	  return input.replace(/\\/g, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;

	var patterns = {
	  dateTimeDelimeter: /[T ]/,
	  plainTime: /:/,

	  // year tokens
	  YY: /^(\d{2})$/,
	  YYY: [/^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	  ],
	  YYYY: /^(\d{4})/,
	  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	  ],

	  // date tokens
	  MM: /^-(\d{2})$/,
	  DDD: /^-?(\d{3})$/,
	  MMDD: /^-?(\d{2})-?(\d{2})$/,
	  Www: /^-?W(\d{2})$/,
	  WwwD: /^-?W(\d{2})-?(\d{1})$/,

	  HH: /^(\d{2}([.,]\d*)?)$/,
	  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

	  // timezone tokens
	  timezone: /([Z+-].*)$/,
	  timezoneZ: /^(Z)$/,
	  timezoneHH: /^([+-])(\d{2})$/,
	  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
	};

	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument is null, it is treated as an invalid date.
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
	 *
	 * @param {*} argument - the value to convert
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = toDate('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = toDate('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function toDate(argument, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }

	  if (argument === null) {
	    return new Date(NaN);
	  }

	  var options = dirtyOptions || {};

	  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }

	  // Clone the date
	  if (argument instanceof Date) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument !== 'string') {
	    return new Date(argument);
	  }

	  var dateStrings = splitDateString(argument);

	  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	  var year = parseYearResult.year;
	  var restDateString = parseYearResult.restDateString;

	  var date = parseDate(restDateString, year);

	  if (date) {
	    var timestamp = date.getTime();
	    var time = 0;
	    var offset;

	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time);
	    }

	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone);
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset();
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
	    }

	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE);
	  } else {
	    return new Date(argument);
	  }
	}

	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimeter);
	  var timeString;

	  if (patterns.plainTime.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	  }

	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }

	  return dateStrings;
	}

	function parseYear(dateString, additionalDigits) {
	  var patternYYY = patterns.YYY[additionalDigits];
	  var patternYYYYY = patterns.YYYYY[additionalDigits];

	  var token;

	  // YYYY or ±YYYYY
	  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
	  if (token) {
	    var yearString = token[1];
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    };
	  }

	  // YY or ±YYY
	  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
	  if (token) {
	    var centuryString = token[1];
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    };
	  }

	  // Invalid ISO-formatted year
	  return {
	    year: null
	  };
	}

	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null;
	  }

	  var token;
	  var date;
	  var month;
	  var week;

	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0);
	    date.setUTCFullYear(year);
	    return date;
	  }

	  // YYYY-MM
	  token = patterns.MM.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    date.setUTCFullYear(year, month);
	    return date;
	  }

	  // YYYY-DDD or YYYYDDD
	  token = patterns.DDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    var dayOfYear = parseInt(token[1], 10);
	    date.setUTCFullYear(year, 0, dayOfYear);
	    return date;
	  }

	  // YYYY-MM-DD or YYYYMMDD
	  token = patterns.MMDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    var day = parseInt(token[2], 10);
	    date.setUTCFullYear(year, month, day);
	    return date;
	  }

	  // YYYY-Www or YYYYWww
	  token = patterns.Www.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    return dayOfISOYear(year, week);
	  }

	  // YYYY-Www-D or YYYYWwwD
	  token = patterns.WwwD.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    var dayOfWeek = parseInt(token[2], 10) - 1;
	    return dayOfISOYear(year, week, dayOfWeek);
	  }

	  // Invalid ISO-formatted date
	  return null;
	}

	function parseTime(timeString) {
	  var token;
	  var hours;
	  var minutes;

	  // hh
	  token = patterns.HH.exec(timeString);
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR;
	  }

	  // hh:mm or hhmm
	  token = patterns.HHMM.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseFloat(token[2].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
	  }

	  // hh:mm:ss or hhmmss
	  token = patterns.HHMMSS.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseInt(token[2], 10);
	    var seconds = parseFloat(token[3].replace(',', '.'));
	    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	  }

	  // Invalid ISO-formatted time
	  return null;
	}

	function parseTimezone(timezoneString) {
	  var token;
	  var absoluteOffset;

	  // Z
	  token = patterns.timezoneZ.exec(timezoneString);
	  if (token) {
	    return 0;
	  }

	  // ±hh
	  token = patterns.timezoneHH.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60;
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }

	  // ±hh:mm or ±hhmm
	  token = patterns.timezoneHHMM.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
	  }

	  return 0;
	}

	function dayOfISOYear(isoYear, week, day) {
	  week = week || 0;
	  day = day || 0;
	  var date = new Date(0);
	  date.setUTCFullYear(isoYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid('2014-02-31')
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
	  }

	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  return !isNaN(date);
	}
	module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(349);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(350);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(352);

	var _index6 = _interopRequireDefault(_index5);

	var _index7 = __webpack_require__(353);

	var _index8 = _interopRequireDefault(_index7);

	var _index9 = __webpack_require__(356);

	var _index10 = _interopRequireDefault(_index9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 */
	var locale = {
	  formatDistance: _index2.default,
	  formatLong: _index4.default,
	  formatRelative: _index6.default,
	  localize: _index8.default,
	  match: _index10.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */
	    , firstWeekContainsDate: 1
	  }
	};

	exports.default = locale;
	module.exports = exports['default'];

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },

	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },

	  halfAMinute: 'half a minute',

	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },

	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },

	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },

	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },

	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },

	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },

	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },

	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },

	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },

	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },

	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};

	function formatDistance(token, count, options) {
	  options = options || {};

	  var result;
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }

	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }

	  return result;
	}
	module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(351);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var formatLong = (0, _index2.default)({
	  LT: 'h:mm aa',
	  LTS: 'h:mm:ss aa',
	  L: 'MM/DD/YYYY',
	  LL: 'MMMM D YYYY',
	  LLL: 'MMMM D YYYY h:mm aa',
	  LLLL: 'dddd, MMMM D YYYY h:mm aa'
	});

	exports.default = formatLong;
	module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;

	function buildShortLongFormat(format) {
	  return format.replace(tokensToBeShortedPattern, function (token) {
	    return token.slice(1);
	  });
	}

	/**
	 * @name buildFormatLongFn
	 * @category Locale Helpers
	 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 *
	 * @description
	 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 * Returns a function which takes one of the following tokens as the argument:
	 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
	 * and returns a long format string written as `format` token strings.
	 * See [format]{@link https://date-fns.org/docs/format}
	 *
	 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
	 * by shortening some of the tokens from corresponding unshortened formats
	 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
	 *
	 * @param {Object} obj - the object with long formats written as `format` token strings
	 * @param {String} obj.LT - time format: hours and minutes
	 * @param {String} obj.LTS - time format: hours, minutes and seconds
	 * @param {String} obj.L - short date format: numeric day, month and year
	 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
	 * @param {String} obj.LL - long date format: day, month in words, and year
	 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
	 * @param {String} obj.LLL - long date and time format
	 * @param {String} [obj.lll] - long date and time format (shortened)
	 * @param {String} obj.LLLL - long date, time and weekday format
	 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
	 * @returns {Function} `formatLong` property of the locale
	 *
	 * @example
	 * // For `en-US` locale:
	 * locale.formatLong = buildFormatLongFn({
	 *   LT: 'h:mm aa',
	 *   LTS: 'h:mm:ss aa',
	 *   L: 'MM/DD/YYYY',
	 *   LL: 'MMMM D YYYY',
	 *   LLL: 'MMMM D YYYY h:mm aa',
	 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
	 * })
	 */
	function buildFormatLongFn(obj) {
	  var formatLongLocale = {
	    LTS: obj.LTS,
	    LT: obj.LT,
	    L: obj.L,
	    LL: obj.LL,
	    LLL: obj.LLL,
	    LLLL: obj.LLLL,
	    l: obj.l || buildShortLongFormat(obj.L),
	    ll: obj.ll || buildShortLongFormat(obj.LL),
	    lll: obj.lll || buildShortLongFormat(obj.LLL),
	    llll: obj.llll || buildShortLongFormat(obj.LLLL)
	  };

	  return function (token) {
	    return formatLongLocale[token];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: '[last] dddd [at] LT',
	  yesterday: '[yesterday at] LT',
	  today: '[today at] LT',
	  tomorrow: '[tomorrow at] LT',
	  nextWeek: 'dddd [at] LT',
	  other: 'L'
	};

	function formatRelative(token, date, baseDate, options) {
	  return formatRelativeLocale[token];
	}
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(354);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(355);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var weekdayValues = {
	  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};

	var monthValues = {
	  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};

	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var timeOfDayValues = {
	//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
	//   }
	//
	// And later:
	//
	//   var localize = {
	//     // The callback takes the hours as the argument and returns the array index
	//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
	//       if (hours >= 17) {
	//         return 3
	//       } else if (hours >= 12) {
	//         return 2
	//       } else if (hours >= 4) {
	//         return 1
	//       } else {
	//         return 0
	//       }
	//     }),
	//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
	//   }
	var timeOfDayValues = {
	  uppercase: ['AM', 'PM'],
	  lowercase: ['am', 'pm'],
	  long: ['a.m.', 'p.m.']
	};

	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);

	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	  // 'dayOfMonth' or 'dayOfWeek'

	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	}

	var localize = {
	  ordinalNumber: ordinalNumber,
	  weekday: (0, _index2.default)(weekdayValues, 'long'),
	  weekdays: (0, _index4.default)(weekdayValues, 'long'),
	  month: (0, _index2.default)(monthValues, 'long'),
	  months: (0, _index4.default)(monthValues, 'long'),
	  timeOfDay: (0, _index2.default)(timeOfDayValues, 'long', function (hours) {
	    return hours / 12 >= 1 ? 1 : 0;
	  }),
	  timesOfDay: (0, _index4.default)(timeOfDayValues, 'long')
	};

	exports.default = localize;
	module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	/**
	 * @name buildLocalizeFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
	 * used by `format` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
	 * `localize.month` takes the month index (0 - January).
	 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
	 *   and converts it into value array index
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var timeOfDayValues = {
	 *   uppercase: ['AM', 'PM'],
	 *   lowercase: ['am', 'pm'],
	 *   long: ['a.m.', 'p.m.']
	 * }
	 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	 *   // 0 is a.m. array index, 1 is p.m. array index
	 *   return (hours / 12) >= 1 ? 1 : 0
	 * })
	 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
	 * locale.localize.timeOfDay(5) //=> 'a.m.'
	 */
	function buildLocalizeFn(values, defaultType, indexCallback) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var valuesArray = values[type] || values[defaultType];
	    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
	    return valuesArray[index];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeArrayFn;
	/**
	 * @name buildLocalizeArrayFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var weekdayValues = {
	 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	 * }
	 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
	 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
	 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
	 */
	function buildLocalizeArrayFn(values, defaultType) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    return values[type] || values[defaultType];
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(357);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(358);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(359);

	var _index6 = _interopRequireDefault(_index5);

	var _index7 = __webpack_require__(360);

	var _index8 = _interopRequireDefault(_index7);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;

	var matchWeekdaysPatterns = {
	  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};

	var parseWeekdayPatterns = {
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};

	var matchMonthsPatterns = {
	  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};

	var parseMonthPatterns = {
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};

	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var matchTimesOfDayPatterns = {
	//     long: /^((in the)? (night|morning|afternoon|evening?))/i
	//   }
	//
	//   var parseTimeOfDayPatterns = {
	//     any: [/(night|morning)/i, /(afternoon|evening)/i]
	//   }
	var matchTimesOfDayPatterns = {
	  short: /^(am|pm)/i,
	  long: /^([ap]\.?\s?m\.?)/i
	};

	var parseTimeOfDayPatterns = {
	  any: [/^a/i, /^p/i]
	};

	var match = {
	  ordinalNumbers: (0, _index6.default)(matchOrdinalNumbersPattern),
	  ordinalNumber: _index8.default,
	  weekdays: (0, _index2.default)(matchWeekdaysPatterns, 'long'),
	  weekday: (0, _index4.default)(parseWeekdayPatterns, 'any'),
	  months: (0, _index2.default)(matchMonthsPatterns, 'long'),
	  month: (0, _index4.default)(parseMonthPatterns, 'any'),
	  timesOfDay: (0, _index2.default)(matchTimesOfDayPatterns, 'long'),
	  timeOfDay: (0, _index4.default)(parseTimeOfDayPatterns, 'any')
	};

	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	/**
	 * @name buildMatchFn
	 * @category Locale Helpers
	 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 * The result of the match function will be passed into corresponding parser function
	 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
	 *
	 * @param {Object} values - the object with RegExps
	 * @param {String} defaultType - the default type for the match function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var matchWeekdaysPatterns = {
	 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	 * }
	 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
	 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
	 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
	 */
	function buildMatchFn(patterns, defaultType) {
	  return function (dirtyString, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var pattern = patterns[type] || patterns[defaultType];
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildParseFn;
	/**
	 * @name buildParseFn
	 * @category Locale Helpers
	 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
	 * The argument of the resulting function is the result of the corresponding match function
	 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
	 *
	 * @param {Object} values - the object with arrays of RegExps
	 * @param {String} defaultType - the default type for the parser function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var parseWeekdayPatterns = {
	 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	 * }
	 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
	 * var matchResult = locale.match.weekdays('Friday')
	 * locale.match.weekday(matchResult) //=> 5
	 */
	function buildParseFn(patterns, defaultType) {
	  return function (matchResult, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var patternsArray = patterns[type] || patterns[defaultType];
	    var string = matchResult[1];

	    return patternsArray.findIndex(function (pattern) {
	      return pattern.test(string);
	    });
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	/**
	 * @name buildMatchPatternFn
	 * @category Locale Helpers
	 * @summary Build match function from a single RegExp.
	 *
	 * @description
	 * Build match function from a single RegExp.
	 * Usually used for building `match.ordinalNumbers` property of the locale.
	 *
	 * @param {Object} pattern - the RegExp
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
	 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
	 */
	function buildMatchPatternFn(pattern) {
	  return function (dirtyString) {
	    var string = String(dirtyString);
	    return string.match(pattern);
	  };
	}
	module.exports = exports["default"];

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseDecimal;
	/**
	 * @name parseDecimal
	 * @category Locale Helpers
	 * @summary Parses the match result into decimal number.
	 *
	 * @description
	 * Parses the match result into decimal number.
	 * Uses the string matched with the first set of parentheses of match RegExp.
	 *
	 * @param {Array} matchResult - the object returned by matching function
	 * @returns {Number} the parsed value
	 *
	 * @example
	 * locale.match = {
	 *   ordinalNumbers: (dirtyString) {
	 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
	 *   },
	 *   ordinalNumber: parseDecimal
	 * }
	 */
	function parseDecimal(matchResult) {
	  return parseInt(matchResult[1], 10);
	}
	module.exports = exports["default"];

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(362);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(363);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(366);

	var _index6 = _interopRequireDefault(_index5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function M(date) {
	    return date.getUTCMonth() + 1;
	  },

	  // Month: 1st, 2nd, ..., 12th
	  'Mo': function Mo(date, options) {
	    var month = date.getUTCMonth() + 1;
	    return options.locale.localize.ordinalNumber(month, { unit: 'month' });
	  },

	  // Month: 01, 02, ..., 12
	  'MM': function MM(date) {
	    return addLeadingZeros(date.getUTCMonth() + 1, 2);
	  },

	  // Month: Jan, Feb, ..., Dec
	  'MMM': function MMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'short' });
	  },

	  // Month: January, February, ..., December
	  'MMMM': function MMMM(date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), { type: 'long' });
	  },

	  // Quarter: 1, 2, 3, 4
	  'Q': function Q(date) {
	    return Math.ceil((date.getUTCMonth() + 1) / 3);
	  },

	  // Quarter: 1st, 2nd, 3rd, 4th
	  'Qo': function Qo(date, options) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    return options.locale.localize.ordinalNumber(quarter, { unit: 'quarter' });
	  },

	  // Day of month: 1, 2, ..., 31
	  'D': function D(date) {
	    return date.getUTCDate();
	  },

	  // Day of month: 1st, 2nd, ..., 31st
	  'Do': function Do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDate(), { unit: 'dayOfMonth' });
	  },

	  // Day of month: 01, 02, ..., 31
	  'DD': function DD(date) {
	    return addLeadingZeros(date.getUTCDate(), 2);
	  },

	  // Day of year: 1, 2, ..., 366
	  'DDD': function DDD(date) {
	    return (0, _index2.default)(date);
	  },

	  // Day of year: 1st, 2nd, ..., 366th
	  'DDDo': function DDDo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index2.default)(date), { unit: 'dayOfYear' });
	  },

	  // Day of year: 001, 002, ..., 366
	  'DDDD': function DDDD(date) {
	    return addLeadingZeros((0, _index2.default)(date), 3);
	  },

	  // Day of week: Su, Mo, ..., Sa
	  'dd': function dd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'narrow' });
	  },

	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': function ddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'short' });
	  },

	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': function dddd(date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), { type: 'long' });
	  },

	  // Day of week: 0, 1, ..., 6
	  'd': function d(date) {
	    return date.getUTCDay();
	  },

	  // Day of week: 0th, 1st, 2nd, ..., 6th
	  'do': function _do(date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDay(), { unit: 'dayOfWeek' });
	  },

	  // Day of ISO week: 1, 2, ..., 7
	  'E': function E(date) {
	    return date.getUTCDay() || 7;
	  },

	  // ISO week: 1, 2, ..., 53
	  'W': function W(date) {
	    return (0, _index4.default)(date);
	  },

	  // ISO week: 1st, 2nd, ..., 53th
	  'Wo': function Wo(date, options) {
	    return options.locale.localize.ordinalNumber((0, _index4.default)(date), { unit: 'isoWeek' });
	  },

	  // ISO week: 01, 02, ..., 53
	  'WW': function WW(date) {
	    return addLeadingZeros((0, _index4.default)(date), 2);
	  },

	  // Year: 00, 01, ..., 99
	  'YY': function YY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2);
	  },

	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function YYYY(date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4);
	  },

	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function GG(date) {
	    return String((0, _index6.default)(date)).substr(2);
	  },

	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function GGGG(date) {
	    return (0, _index6.default)(date);
	  },

	  // Hour: 0, 1, ... 23
	  'H': function H(date) {
	    return date.getUTCHours();
	  },

	  // Hour: 00, 01, ..., 23
	  'HH': function HH(date) {
	    return addLeadingZeros(date.getUTCHours(), 2);
	  },

	  // Hour: 1, 2, ..., 12
	  'h': function h(date) {
	    var hours = date.getUTCHours();
	    if (hours === 0) {
	      return 12;
	    } else if (hours > 12) {
	      return hours % 12;
	    } else {
	      return hours;
	    }
	  },

	  // Hour: 01, 02, ..., 12
	  'hh': function hh(date) {
	    return addLeadingZeros(formatters['h'](date), 2);
	  },

	  // Minute: 0, 1, ..., 59
	  'm': function m(date) {
	    return date.getUTCMinutes();
	  },

	  // Minute: 00, 01, ..., 59
	  'mm': function mm(date) {
	    return addLeadingZeros(date.getUTCMinutes(), 2);
	  },

	  // Second: 0, 1, ..., 59
	  's': function s(date) {
	    return date.getUTCSeconds();
	  },

	  // Second: 00, 01, ..., 59
	  'ss': function ss(date) {
	    return addLeadingZeros(date.getUTCSeconds(), 2);
	  },

	  // 1/10 of second: 0, 1, ..., 9
	  'S': function S(date) {
	    return Math.floor(date.getUTCMilliseconds() / 100);
	  },

	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function SS(date) {
	    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2);
	  },

	  // Millisecond: 000, 001, ..., 999
	  'SSS': function SSS(date) {
	    return addLeadingZeros(date.getUTCMilliseconds(), 3);
	  },

	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function Z(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset(), ':');
	  },

	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function ZZ(date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset());
	  },

	  // Seconds timestamp: 512969520
	  'X': function X(date, options) {
	    var originalDate = options._originalDate || date;
	    return Math.floor(originalDate.getTime() / 1000);
	  },

	  // Milliseconds timestamp: 512969520900
	  'x': function x(date, options) {
	    var originalDate = options._originalDate || date;
	    return originalDate.getTime();
	  },

	  // AM, PM
	  'A': function A(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'uppercase' });
	  },

	  // am, pm
	  'a': function a(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'lowercase' });
	  },

	  // a.m., p.m.
	  'aa': function aa(date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), { type: 'long' });
	  }
	};

	function formatTimezone(offset, delimeter) {
	  delimeter = delimeter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
	}

	function addLeadingZeros(number, targetLength) {
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return output;
	}

	exports.default = formatters;
	module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MILLISECONDS_IN_DAY = 86400000;

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCDayOfYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(364);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(365);

	var _index6 = _interopRequireDefault(_index5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MILLISECONDS_IN_WEEK = 604800000;

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeek(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var diff = (0, _index4.default)(date, dirtyOptions).getTime() - (0, _index6.default)(date, dirtyOptions).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate, dirtyOptions) {
	  var weekStartsOn = 1;

	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;

	var _index = __webpack_require__(366);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(364);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index4.default)(fourthOfJanuary, dirtyOptions);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(364);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();

	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index4.default)(fourthOfJanuaryOfNextYear, dirtyOptions);

	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index4.default)(fourthOfJanuaryOfThisYear, dirtyOptions);

	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	function cloneObject(dirtyObject) {
	  dirtyObject = dirtyObject || {};
	  var object = {};

	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      object[property] = dirtyObject[property];
	    }
	  }

	  return object;
	}
	module.exports = exports["default"];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addUTCMinutes;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function addUTCMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setUTCMinutes(date.getUTCMinutes() + amount);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(370);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(348);

	var _index6 = _interopRequireDefault(_index5);

	var _index7 = __webpack_require__(373);

	var _index8 = _interopRequireDefault(_index7);

	var _index9 = __webpack_require__(374);

	var _index10 = _interopRequireDefault(_index9);

	var _index11 = __webpack_require__(367);

	var _index12 = _interopRequireDefault(_index11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TIMEZONE_UNIT_PRIORITY = 110;
	var MILLISECONDS_IN_MINUTE = 60000;

	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format.
	 *
	 * Accepted format tokens:
	 * | Unit                    | Priority | Token | Input examples                   |
	 * |-------------------------|----------|-------|----------------------------------|
	 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
	 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
	 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
	 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
	 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
	 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         |          | MM    | 01, 02, ..., 12                  |
	 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
	 * |                         |          | MMMM  | January, February, ..., December |
	 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
	 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         |          | WW    | 01, 02, ..., 53                  |
	 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
	 * |                         |          | do    | 0th, 1st, ..., 6th               |
	 * |                         |          | dd    | Su, Mo, ..., Sa                  |
	 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
	 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
	 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
	 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
	 * |                         |          | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
	 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         |          | DDDD  | 001, 002, ..., 366               |
	 * | Time of day             | 60       | A     | AM, PM                           |
	 * |                         |          | a     | am, pm                           |
	 * |                         |          | aa    | a.m., p.m.                       |
	 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
	 * |                         |          | HH    | 00, 01, ... 23                   |
	 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
	 * |                         |          | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
	 * |                         |          | mm    | 00, 01, ..., 59                  |
	 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
	 * |                         |          | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | 120      | X     | 512969520                        |
	 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
	 *
	 * Values will be assigned to the date in the ascending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
	 *
	 * `baseDate` must be passed for correct work of the function.
	 * If you're not sure which `baseDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
	 * | Token | Input examples                 |
	 * |-------|--------------------------------|
	 * | LT    | 05:30 a.m.                     |
	 * | LTS   | 05:30:15 a.m.                  |
	 * | L     | 07/02/1995                     |
	 * | l     | 7/2/1995                       |
	 * | LL    | July 2 1995                    |
	 * | ll    | Jul 2 1995                     |
	 * | LLL   | July 2 1995 05:30 a.m.         |
	 * | lll   | Jul 2 1995 05:30 a.m.          |
	 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
	 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
	 *
	 * The characters wrapped in square brackets in the format string are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse(
	 *   '02/11/2014',
	 *   'MM/DD/YYYY',
	 *   new Date()
	 * )
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in English locale in the context of 2010 year:
	 * import eoLocale from 'date-fns/locale/eo'
	 * var result = parse(
	 *   '28-a de februaro',
	 *   'Do [de] MMMM',
	 *   new Date(2010, 0, 1)
	 *   {locale: eoLocale}
	 * )
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
	  }

	  var dateString = String(dirtyDateString);
	  var options = dirtyOptions || {};

	  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }

	  var locale = options.locale || _index6.default;
	  var localeParsers = locale.parsers || {};
	  var localeUnits = locale.units || {};

	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }

	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }

	  var formatString = String(dirtyFormatString).replace(longFormattingTokensRegExp, function (substring) {
	    if (substring[0] === '[') {
	      return substring;
	    }

	    if (substring[0] === '\\') {
	      return cleanEscapedString(substring);
	    }

	    return locale.formatLong(substring);
	  });

	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index2.default)(dirtyBaseDate, options);
	    } else {
	      return new Date(NaN);
	    }
	  }

	  var subFnOptions = (0, _index12.default)(options);
	  subFnOptions.locale = locale;

	  var tokens = formatString.match(locale.parsingTokensRegExp || defaultParsingTokensRegExp);
	  var tokensLength = tokens.length;

	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];

	  var i;
	  for (i = 0; i < tokensLength; i++) {
	    var token = tokens[i];
	    var parser = localeParsers[token] || _index8.default[token];
	    if (parser) {
	      var matchResult;

	      if (parser.match instanceof RegExp) {
	        matchResult = parser.match.exec(dateString);
	      } else {
	        matchResult = parser.match(dateString, subFnOptions);
	      }

	      if (!matchResult) {
	        return new Date(NaN);
	      }

	      var unitName = parser.unit;
	      var unit = localeUnits[unitName] || _index10.default[unitName];

	      setters.push({
	        priority: unit.priority,
	        set: unit.set,
	        value: parser.parse(matchResult, subFnOptions),
	        index: setters.length
	      });

	      var substring = matchResult[0];
	      dateString = dateString.slice(substring.length);
	    } else {
	      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
	      if (dateString.indexOf(head) === 0) {
	        dateString = dateString.slice(head.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  }

	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return a - b;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).reverse();
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });

	  var date = (0, _index2.default)(dirtyBaseDate, options);

	  if (isNaN(date)) {
	    return new Date(NaN);
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	  var utcDate = (0, _index4.default)(date, date.getTimezoneOffset());

	  var dateValues = { date: utcDate };

	  var settersLength = uniquePrioritySetters.length;
	  for (i = 0; i < settersLength; i++) {
	    var setter = uniquePrioritySetters[i];
	    dateValues = setter.set(dateValues, setter.value, subFnOptions);
	  }

	  return dateValues.date;
	}

	function dateToSystemTimezone(dateValues) {
	  var date = dateValues.date;
	  var time = date.getTime();

	  // Get the system timezone offset at (moment of time - offset)
	  var offset = date.getTimezoneOffset();

	  // Get the system timezone offset at the exact moment of time
	  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();

	  // Convert date in timezone "UTC+00:00" to the system timezone
	  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE);

	  return dateValues;
	}

	function cleanEscapedString(input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '');
	  }
	  return input.replace(/\\/g, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;

	var _index = __webpack_require__(371);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the mintues subtracted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }

	  var amount = Number(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount, dirtyOptions);
	}
	module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;

	var _index = __webpack_require__(372);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MILLISECONDS_IN_MINUTE = 60000;

	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }

	  var amount = Number(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE, dirtyOptions);
	}
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
	  }

	  var timestamp = (0, _index2.default)(dirtyDate, dirtyOptions).getTime();
	  var amount = Number(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var patterns = {
	  'M': /^(1[0-2]|0?\d)/, // 0 to 12
	  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
	  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
	  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
	  'YYYY': /^(\d{1,4})/, // 0 to 9999
	  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
	  'm': /^([0-5]?\d)/, // 0 to 59
	  'Z': /^([+-])(\d{2}):(\d{2})/,
	  'ZZ': /^([+-])(\d{2})(\d{2})/,
	  singleDigit: /^(\d)/,
	  twoDigits: /^(\d{2})/,
	  threeDigits: /^(\d{3})/,
	  fourDigits: /^(\d{4})/,
	  anyDigits: /^(\d+)/
	};

	function parseDecimal(matchResult) {
	  return parseInt(matchResult[1], 10);
	}

	var parsers = {
	  // Year: 00, 01, ..., 99
	  'YY': {
	    unit: 'twoDigitYear',
	    match: patterns.twoDigits,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult);
	    }
	  },

	  // Year: 1900, 1901, ..., 2099
	  'YYYY': {
	    unit: 'year',
	    match: patterns.YYYY,
	    parse: parseDecimal
	  },

	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': {
	    unit: 'isoYear',
	    match: patterns.twoDigits,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) + 1900;
	    }
	  },

	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': {
	    unit: 'isoYear',
	    match: patterns.YYYY,
	    parse: parseDecimal
	  },

	  // Quarter: 1, 2, 3, 4
	  'Q': {
	    unit: 'quarter',
	    match: patterns.singleDigit,
	    parse: parseDecimal
	  },

	  // Ordinal quarter
	  'Qo': {
	    unit: 'quarter',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'quarter' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'quarter' });
	    }
	  },

	  // Month: 1, 2, ..., 12
	  'M': {
	    unit: 'month',
	    match: patterns.M,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) - 1;
	    }
	  },

	  // Ordinal month
	  'Mo': {
	    unit: 'month',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'month' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'month' }) - 1;
	    }
	  },

	  // Month: 01, 02, ..., 12
	  'MM': {
	    unit: 'month',
	    match: patterns.twoDigits,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) - 1;
	    }
	  },

	  // Month: Jan, Feb, ..., Dec
	  'MMM': {
	    unit: 'month',
	    match: function match(string, options) {
	      return options.locale.match.months(string, { type: 'short' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.month(matchResult, { type: 'short' });
	    }
	  },

	  // Month: January, February, ..., December
	  'MMMM': {
	    unit: 'month',
	    match: function match(string, options) {
	      return options.locale.match.months(string, { type: 'long' }) || options.locale.match.months(string, { type: 'short' });
	    },
	    parse: function parse(matchResult, options) {
	      var parseResult = options.locale.match.month(matchResult, { type: 'long' });

	      if (parseResult == null) {
	        parseResult = options.locale.match.month(matchResult, { type: 'short' });
	      }

	      return parseResult;
	    }
	  },

	  // ISO week: 1, 2, ..., 53
	  'W': {
	    unit: 'isoWeek',
	    match: patterns.W,
	    parse: parseDecimal
	  },

	  // Ordinal ISO week
	  'Wo': {
	    unit: 'isoWeek',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'isoWeek' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'isoWeek' });
	    }
	  },

	  // ISO week: 01, 02, ..., 53
	  'WW': {
	    unit: 'isoWeek',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // Day of week: 0, 1, ..., 6
	  'd': {
	    unit: 'dayOfWeek',
	    match: patterns.singleDigit,
	    parse: parseDecimal
	  },

	  // Ordinal day of week
	  'do': {
	    unit: 'dayOfWeek',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'dayOfWeek' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'dayOfWeek' });
	    }
	  },

	  // Day of week: Su, Mo, ..., Sa
	  'dd': {
	    unit: 'dayOfWeek',
	    match: function match(string, options) {
	      return options.locale.match.weekdays(string, { type: 'narrow' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.weekday(matchResult, { type: 'narrow' });
	    }
	  },

	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': {
	    unit: 'dayOfWeek',
	    match: function match(string, options) {
	      return options.locale.match.weekdays(string, { type: 'short' }) || options.locale.match.weekdays(string, { type: 'narrow' });
	    },
	    parse: function parse(matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, { type: 'short' });

	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, { type: 'narrow' });
	      }

	      return parseResult;
	    }
	  },

	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': {
	    unit: 'dayOfWeek',
	    match: function match(string, options) {
	      return options.locale.match.weekdays(string, { type: 'long' }) || options.locale.match.weekdays(string, { type: 'short' }) || options.locale.match.weekdays(string, { type: 'narrow' });
	    },
	    parse: function parse(matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, { type: 'long' });

	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, { type: 'short' });

	        if (parseResult == null) {
	          parseResult = options.locale.match.weekday(matchResult, { type: 'narrow' });
	        }
	      }

	      return parseResult;
	    }
	  },

	  // Day of ISO week: 1, 2, ..., 7
	  'E': {
	    unit: 'dayOfISOWeek',
	    match: patterns.singleDigit,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult);
	    }
	  },

	  // Day of month: 1, 2, ..., 31
	  'D': {
	    unit: 'dayOfMonth',
	    match: patterns.D,
	    parse: parseDecimal
	  },

	  // Ordinal day of month
	  'Do': {
	    unit: 'dayOfMonth',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'dayOfMonth' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'dayOfMonth' });
	    }
	  },

	  // Day of month: 01, 02, ..., 31
	  'DD': {
	    unit: 'dayOfMonth',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // Day of year: 1, 2, ..., 366
	  'DDD': {
	    unit: 'dayOfYear',
	    match: patterns.DDD,
	    parse: parseDecimal
	  },

	  // Ordinal day of year
	  'DDDo': {
	    unit: 'dayOfYear',
	    match: function match(string, options) {
	      return options.locale.match.ordinalNumbers(string, { unit: 'dayOfYear' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, { unit: 'dayOfYear' });
	    }
	  },

	  // Day of year: 001, 002, ..., 366
	  'DDDD': {
	    unit: 'dayOfYear',
	    match: patterns.threeDigits,
	    parse: parseDecimal
	  },

	  // AM, PM
	  'A': {
	    unit: 'timeOfDay',
	    match: function match(string, options) {
	      return options.locale.match.timesOfDay(string, { type: 'short' });
	    },
	    parse: function parse(matchResult, options) {
	      return options.locale.match.timeOfDay(matchResult, { type: 'short' });
	    }
	  },

	  // a.m., p.m.
	  'aa': {
	    unit: 'timeOfDay',
	    match: function match(string, options) {
	      return options.locale.match.timesOfDay(string, { type: 'long' }) || options.locale.match.timesOfDay(string, { type: 'short' });
	    },
	    parse: function parse(matchResult, options) {
	      var parseResult = options.locale.match.timeOfDay(matchResult, { type: 'long' });

	      if (parseResult == null) {
	        parseResult = options.locale.match.timeOfDay(matchResult, { type: 'short' });
	      }

	      return parseResult;
	    }
	  },

	  // Hour: 0, 1, ... 23
	  'H': {
	    unit: 'hours',
	    match: patterns.H,
	    parse: parseDecimal
	  },

	  // Hour: 00, 01, ..., 23
	  'HH': {
	    unit: 'hours',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // Hour: 1, 2, ..., 12
	  'h': {
	    unit: 'timeOfDayHours',
	    match: patterns.M,
	    parse: parseDecimal
	  },

	  // Hour: 01, 02, ..., 12
	  'hh': {
	    unit: 'timeOfDayHours',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // Minute: 0, 1, ..., 59
	  'm': {
	    unit: 'minutes',
	    match: patterns.m,
	    parse: parseDecimal
	  },

	  // Minute: 00, 01, ..., 59
	  'mm': {
	    unit: 'minutes',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // Second: 0, 1, ..., 59
	  's': {
	    unit: 'seconds',
	    match: patterns.m,
	    parse: parseDecimal
	  },

	  // Second: 00, 01, ..., 59
	  'ss': {
	    unit: 'seconds',
	    match: patterns.twoDigits,
	    parse: parseDecimal
	  },

	  // 1/10 of second: 0, 1, ..., 9
	  'S': {
	    unit: 'milliseconds',
	    match: patterns.singleDigit,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) * 100;
	    }
	  },

	  // 1/100 of second: 00, 01, ..., 99
	  'SS': {
	    unit: 'milliseconds',
	    match: patterns.twoDigits,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) * 10;
	    }
	  },

	  // Millisecond: 000, 001, ..., 999
	  'SSS': {
	    unit: 'milliseconds',
	    match: patterns.threeDigits,
	    parse: parseDecimal
	  },

	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': {
	    unit: 'timezone',
	    match: patterns.Z,
	    parse: function parse(matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return sign === '+' ? absoluteOffset : -absoluteOffset;
	    }
	  },

	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': {
	    unit: 'timezone',
	    match: patterns.ZZ,
	    parse: function parse(matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return sign === '+' ? absoluteOffset : -absoluteOffset;
	    }
	  },

	  // Seconds timestamp: 512969520
	  'X': {
	    unit: 'timestamp',
	    match: patterns.anyDigits,
	    parse: function parse(matchResult) {
	      return parseDecimal(matchResult) * 1000;
	    }
	  },

	  // Milliseconds timestamp: 512969520900
	  'x': {
	    unit: 'timestamp',
	    match: patterns.anyDigits,
	    parse: parseDecimal
	  }
	};

	parsers['a'] = parsers['A'];

	exports.default = parsers;
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(375);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(376);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(377);

	var _index6 = _interopRequireDefault(_index5);

	var _index7 = __webpack_require__(378);

	var _index8 = _interopRequireDefault(_index7);

	var _index9 = __webpack_require__(364);

	var _index10 = _interopRequireDefault(_index9);

	var _index11 = __webpack_require__(365);

	var _index12 = _interopRequireDefault(_index11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MILLISECONDS_IN_MINUTE = 60000;

	function setTimeOfDay(hours, timeOfDay) {
	  var isAM = timeOfDay === 0;

	  if (isAM) {
	    if (hours === 12) {
	      return 0;
	    }
	  } else {
	    if (hours !== 12) {
	      return 12 + hours;
	    }
	  }

	  return hours;
	}

	var units = {
	  twoDigitYear: {
	    priority: 10,
	    set: function set(dateValues, value) {
	      var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
	      var year = century * 100 + value;
	      dateValues.date.setUTCFullYear(year, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  year: {
	    priority: 10,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCFullYear(value, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  isoYear: {
	    priority: 10,
	    set: function set(dateValues, value, options) {
	      dateValues.date = (0, _index12.default)((0, _index8.default)(dateValues.date, value, options), options);
	      return dateValues;
	    }
	  },

	  quarter: {
	    priority: 20,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCMonth((value - 1) * 3, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  month: {
	    priority: 30,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCMonth(value, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  isoWeek: {
	    priority: 40,
	    set: function set(dateValues, value, options) {
	      dateValues.date = (0, _index10.default)((0, _index6.default)(dateValues.date, value, options), options);
	      return dateValues;
	    }
	  },

	  dayOfWeek: {
	    priority: 50,
	    set: function set(dateValues, value, options) {
	      dateValues.date = (0, _index2.default)(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  dayOfISOWeek: {
	    priority: 50,
	    set: function set(dateValues, value, options) {
	      dateValues.date = (0, _index4.default)(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  dayOfMonth: {
	    priority: 50,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCDate(value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  dayOfYear: {
	    priority: 50,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCMonth(0, value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  timeOfDay: {
	    priority: 60,
	    set: function set(dateValues, value, options) {
	      dateValues.timeOfDay = value;
	      return dateValues;
	    }
	  },

	  hours: {
	    priority: 70,
	    set: function set(dateValues, value, options) {
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  timeOfDayHours: {
	    priority: 70,
	    set: function set(dateValues, value, options) {
	      var timeOfDay = dateValues.timeOfDay;
	      if (timeOfDay != null) {
	        value = setTimeOfDay(value, timeOfDay);
	      }
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues;
	    }
	  },

	  minutes: {
	    priority: 80,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCMinutes(value, 0, 0);
	      return dateValues;
	    }
	  },

	  seconds: {
	    priority: 90,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCSeconds(value, 0);
	      return dateValues;
	    }
	  },

	  milliseconds: {
	    priority: 100,
	    set: function set(dateValues, value) {
	      dateValues.date.setUTCMilliseconds(value);
	      return dateValues;
	    }
	  },

	  timezone: {
	    priority: 110,
	    set: function set(dateValues, value) {
	      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE);
	      return dateValues;
	    }
	  },

	  timestamp: {
	    priority: 120,
	    set: function set(dateValues, value) {
	      dateValues.date = new Date(value);
	      return dateValues;
	    }
	  }
	};

	exports.default = units;
	module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }

	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var day = Number(dirtyDay);

	  var currentDay = date.getUTCDay();

	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;

	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay, dirtyOptions) {
	  var day = Number(dirtyDay);

	  if (day % 7 === 0) {
	    day = day - 7;
	  }

	  var weekStartsOn = 1;
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var currentDay = date.getUTCDay();

	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;

	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(363);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var isoWeek = Number(dirtyISOWeek);
	  var diff = (0, _index4.default)(date, dirtyOptions) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeekYear;

	var _index = __webpack_require__(346);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(365);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MILLISECONDS_IN_DAY = 86400000;

	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeekYear(dirtyDate, dirtyISOYear, dirtyOptions) {
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var isoYear = Number(dirtyISOYear);
	  var dateStartOfYear = (0, _index4.default)(date, dirtyOptions);
	  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  date = (0, _index4.default)(fourthOfJanuary, dirtyOptions);
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var validators = __webpack_require__(380);
	var PreFormatters = __webpack_require__(381);

	function MoneyMaskDirective($locale, $parse) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
					thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP,
					currencySym = $locale.NUMBER_FORMATS.CURRENCY_SYM,
					symbolSeparation = ' ',
					decimals = $parse(attrs.uiMoneyMask)(scope),
					backspacePressed = false;

				element.bind('keydown keypress', function(event) {
					backspacePressed = event.which === 8;
				});

				function maskFactory(decimals) {
					var decimalsPattern = decimals > 0 ? decimalDelimiter + new Array(decimals + 1).join('0') : '';
					var maskPattern =  '#' + thousandsDelimiter + '##0' + decimalsPattern;
					if (angular.isDefined(attrs.uiCurrencyAfter)) {
						maskPattern += symbolSeparation;
					} else {
						maskPattern =  symbolSeparation + maskPattern;
					}
					return new StringMask(maskPattern, {reverse: true});
				}

				if (angular.isDefined(attrs.uiDecimalDelimiter)) {
					decimalDelimiter = attrs.uiDecimalDelimiter;
				}

				if (angular.isDefined(attrs.uiThousandsDelimiter)) {
					thousandsDelimiter = attrs.uiThousandsDelimiter;
				}

				if (angular.isDefined(attrs.uiHideGroupSep)) {
					thousandsDelimiter = '';
				}

				if (angular.isDefined(attrs.uiHideSpace)) {
					symbolSeparation = '';
				}

				if (angular.isDefined(attrs.currencySymbol)) {
					currencySym = attrs.currencySymbol;
					if (attrs.currencySymbol.length === 0) {
						symbolSeparation = '';
					}
				}

				if (isNaN(decimals)) {
					decimals = 2;
				}
				decimals = parseInt(decimals);
				var moneyMask = maskFactory(decimals);

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return '';
					}

					if (angular.isDefined(attrs.uiIntegerModel)) {
						value /= Math.pow(10, decimals);
					}

					var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value < 0) ? '-' : '';
					var valueToFormat = PreFormatters.prepareNumberToFormatter(value, decimals);

					if (angular.isDefined(attrs.uiCurrencyAfter)) {
						return prefix + moneyMask.apply(valueToFormat) + currencySym;
					}

					return prefix + currencySym + moneyMask.apply(valueToFormat);
				}

				function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return null;
					}

					var actualNumber = value.replace(/[^\d]+/g,''), formatedValue;
					actualNumber = actualNumber.replace(/^[0]+([1-9])/,'$1');
					actualNumber = actualNumber || '0';

					if (backspacePressed && angular.isDefined(attrs.uiCurrencyAfter) && actualNumber !== 0) {
						actualNumber = actualNumber.substring(0, actualNumber.length - 1);
						backspacePressed = false;
					}

					if (angular.isDefined(attrs.uiCurrencyAfter)) {
						formatedValue = moneyMask.apply(actualNumber) + currencySym;
					} else {
						formatedValue = currencySym + moneyMask.apply(actualNumber);
					}

					if (angular.isDefined(attrs.uiNegativeNumber)) {
						var isNegative = (value[0] === '-'),
							needsToInvertSign = (value.slice(-1) === '-');

						//only apply the minus sign if it is negative or(exclusive)
						//needs to be negative and the number is different from zero
						if (needsToInvertSign ^ isNegative && !!actualNumber) {
							actualNumber *= -1;
							formatedValue = '-' + formatedValue;
						}
					}

					if (value !== formatedValue) {
						ctrl.$setViewValue(formatedValue);
						ctrl.$render();
					}

					var retValue = parseInt(formatedValue.replace(/[^\d\-]+/g,''));

					if (!isNaN(retValue)) {
						if (!angular.isDefined(attrs.uiIntegerModel)) {
							retValue /= Math.pow(10, decimals);
						}

						return retValue;
					}

					return null;
				}

				ctrl.$formatters.push(formatter);
				ctrl.$parsers.push(parser);

				if (attrs.uiMoneyMask) {
					scope.$watch(attrs.uiMoneyMask, function(_decimals) {
						decimals = isNaN(_decimals) ? 2 : _decimals;
						decimals = parseInt(decimals);
						moneyMask = maskFactory(decimals);

						parser(ctrl.$viewValue);
					});
				}

				if (attrs.currency) {
					scope.$watch(attrs.currency, function(_currency) {
						currencySym = _currency;
						moneyMask = maskFactory(decimals);
						parser(ctrl.$viewValue);
					});
				}

				if (attrs.min) {
					var minVal;

					ctrl.$validators.min = function(modelValue) {
						return validators.minNumber(ctrl, modelValue, minVal);
					};

					scope.$watch(attrs.min, function(value) {
						minVal = value;
						ctrl.$validate();
					});
				}

				if (attrs.max) {
					var maxVal;

					ctrl.$validators.max = function(modelValue) {
						return validators.maxNumber(ctrl, modelValue, maxVal);
					};

					scope.$watch(attrs.max, function(value) {
						maxVal = value;
						ctrl.$validate();
					});
				}
			}
		};
	}
	MoneyMaskDirective.$inject = ['$locale', '$parse'];

	module.exports = MoneyMaskDirective;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
		maxNumber: function(ctrl, value, limit) {
			var max = parseFloat(limit, 10);
			return ctrl.$isEmpty(value) || isNaN(max) || value <= max;
		},
		minNumber: function(ctrl, value, limit) {
			var min = parseFloat(limit, 10);
			return ctrl.$isEmpty(value) || isNaN(min) || value >= min;
		}
	};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';

	function clearDelimitersAndLeadingZeros(value) {
		if (value === '0') {
			return '0';
		}

		var cleanValue = value.toString().replace(/^-/,'').replace(/^0*/, '');
		return cleanValue.replace(/[^0-9]/g, '');
	}

	function prepareNumberToFormatter(value, decimals) {
		return clearDelimitersAndLeadingZeros((parseFloat(value)).toFixed(decimals));
	}

	module.exports = {
		clearDelimitersAndLeadingZeros: clearDelimitersAndLeadingZeros,
		prepareNumberToFormatter: prepareNumberToFormatter
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var validators = __webpack_require__(380);
	var NumberMasks = __webpack_require__(383);
	var PreFormatters = __webpack_require__(381);

	function NumberMaskDirective($locale, $parse) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
					thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP,
					decimals = $parse(attrs.uiNumberMask)(scope);

				if (angular.isDefined(attrs.uiHideGroupSep)) {
					thousandsDelimiter = '';
				}

				if (isNaN(decimals)) {
					decimals = 2;
				}

				var viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter),
					modelMask = NumberMasks.modelMask(decimals);

				function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return null;
					}

					var valueToFormat = PreFormatters.clearDelimitersAndLeadingZeros(value) || '0';
					var formatedValue = viewMask.apply(valueToFormat);
					var actualNumber = parseFloat(modelMask.apply(valueToFormat));

					if (angular.isDefined(attrs.uiNegativeNumber)) {
						var isNegative = (value[0] === '-'),
							needsToInvertSign = (value.slice(-1) === '-');

						//only apply the minus sign if it is negative or(exclusive) or the first character
						//needs to be negative and the number is different from zero
						if ((needsToInvertSign ^ isNegative) || value === '-') {
							actualNumber *= -1;
							formatedValue = '-' + ((actualNumber !== 0) ? formatedValue : '');
						}
					}

					if (ctrl.$viewValue !== formatedValue) {
						ctrl.$setViewValue(formatedValue);
						ctrl.$render();
					}

					return actualNumber;
				}

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value < 0) ? '-' : '';
					var valueToFormat = PreFormatters.prepareNumberToFormatter(value, decimals);
					return prefix + viewMask.apply(valueToFormat);
				}

				function clearViewValueIfMinusSign() {
					if (ctrl.$viewValue === '-') {
						ctrl.$setViewValue('');
						ctrl.$render();
					}
				}

				element.on('blur', clearViewValueIfMinusSign);

				ctrl.$formatters.push(formatter);
				ctrl.$parsers.push(parser);

				if (attrs.uiNumberMask) {
					scope.$watch(attrs.uiNumberMask, function(_decimals) {
						decimals = isNaN(_decimals) ? 2 : _decimals;
						viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter);
						modelMask = NumberMasks.modelMask(decimals);

						parser(ctrl.$viewValue);
					});
				}

				if (attrs.min) {
					var minVal;

					ctrl.$validators.min = function(modelValue) {
						return validators.minNumber(ctrl, modelValue, minVal);
					};

					scope.$watch(attrs.min, function(value) {
						minVal = value;
						ctrl.$validate();
					});
				}

				if (attrs.max) {
					var maxVal;

					ctrl.$validators.max = function(modelValue) {
						return validators.maxNumber(ctrl, modelValue, maxVal);
					};

					scope.$watch(attrs.max, function(value) {
						maxVal = value;
						ctrl.$validate();
					});
				}
			}
		};
	}
	NumberMaskDirective.$inject = ['$locale', '$parse'];

	module.exports = NumberMaskDirective;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	function viewMask(decimals, decimalDelimiter, thousandsDelimiter) {
		var mask = '#' + thousandsDelimiter + '##0';

		if (decimals > 0) {
			mask += decimalDelimiter;
			for (var i = 0; i < decimals; i++) {
				mask += '0';
			}
		}

		return new StringMask(mask, {
			reverse: true
		});
	}

	function modelMask(decimals) {
		var mask = '###0';

		if (decimals > 0) {
			mask += '.';
			for (var i = 0; i < decimals; i++) {
				mask += '0';
			}
		}

		return new StringMask(mask, {
			reverse: true
		});
	}

	module.exports = {
		viewMask: viewMask,
		modelMask: modelMask
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var validators = __webpack_require__(380);
	var NumberMasks = __webpack_require__(383);
	var PreFormatters = __webpack_require__(381);

	function preparePercentageToFormatter(value, decimals, modelMultiplier) {
		return PreFormatters.clearDelimitersAndLeadingZeros((parseFloat(value)*modelMultiplier).toFixed(decimals));
	}

	function PercentageMaskDirective($locale) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP;

				var backspacePressed = false;
				element.bind('keydown keypress', function(event) {
					backspacePressed = event.which === 8;
				});

				var thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP;
				if (angular.isDefined(attrs.uiHideGroupSep)) {
					thousandsDelimiter = '';
				}

				var percentageSymbol = ' %';
				if (angular.isDefined(attrs.uiHidePercentageSign)) {
					percentageSymbol = '';
				} else if (angular.isDefined(attrs.uiHideSpace)) {
					percentageSymbol = '%';
				}

				var decimals = parseInt(attrs.uiPercentageMask);
				if (isNaN(decimals)) {
					decimals = 2;
				}

				var modelValue = {
					multiplier : 100,
					decimalMask: 2
				};
				if (angular.isDefined(attrs.uiPercentageValue)) {
					modelValue.multiplier  = 1;
					modelValue.decimalMask = 0;
				}

				var numberDecimals = decimals + modelValue.decimalMask;
				var viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter),
					modelMask = NumberMasks.modelMask(numberDecimals);

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}
					var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value < 0) ? '-' : '';
					var valueToFormat = preparePercentageToFormatter(value, decimals, modelValue.multiplier);
					var formatedValue = prefix + viewMask.apply(valueToFormat) + percentageSymbol;

					return formatedValue;
				}

				function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return null;
					}

					var valueToFormat = PreFormatters.clearDelimitersAndLeadingZeros(value) || '0';
					if (percentageSymbol !== '' && value.length > 1 && value.indexOf('%') === -1) {
						valueToFormat = valueToFormat.slice(0, valueToFormat.length - 1);
					}

					if (backspacePressed && value.length === 1 && value !== '%') {
						valueToFormat = '0';
					}

					var formatedValue = viewMask.apply(valueToFormat) + percentageSymbol;
					var actualNumber = parseFloat(modelMask.apply(valueToFormat));

					if (angular.isDefined(attrs.uiNegativeNumber)) {
						var isNegative = (value[0] === '-'),
							needsToInvertSign = (value.slice(-1) === '-');

						//only apply the minus sign if it is negative or(exclusive) or the first character
						//needs to be negative and the number is different from zero
						if ((needsToInvertSign ^ isNegative) || value === '-') {
							actualNumber *= -1;
							formatedValue = '-' + ((actualNumber !== 0) ? formatedValue : '');
						}
					}

					if (ctrl.$viewValue !== formatedValue) {
						ctrl.$setViewValue(formatedValue);
						ctrl.$render();
					}

					return actualNumber;
				}

				ctrl.$formatters.push(formatter);
				ctrl.$parsers.push(parser);

				if (attrs.uiPercentageMask) {
					scope.$watch(attrs.uiPercentageMask, function(_decimals) {
						decimals = isNaN(_decimals) ? 2 : _decimals;

						numberDecimals = decimals + modelValue.decimalMask;
						viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter);
						modelMask = NumberMasks.modelMask(numberDecimals);

						parser(formatter(ctrl.$modelValue));
					});
				}

				if (attrs.min) {
					var minVal;

					ctrl.$validators.min = function(modelValue) {
						return validators.minNumber(ctrl, modelValue, minVal);
					};

					scope.$watch(attrs.min, function(value) {
						minVal = value;
						ctrl.$validate();
					});
				}

				if (attrs.max) {
					var maxVal;

					ctrl.$validators.max = function(modelValue) {
						return validators.maxNumber(ctrl, modelValue, maxVal);
					};

					scope.$watch(attrs.max, function(value) {
						maxVal = value;
						ctrl.$validate();
					});
				}
			}
		};
	}
	PercentageMaskDirective.$inject = ['$locale'];

	module.exports = PercentageMaskDirective;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	function ScientificNotationMaskDirective($locale, $parse) {
		var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
			defaultPrecision = 2;

		function significandMaskBuilder(decimals) {
			var mask = '0';

			if (decimals > 0) {
				mask += decimalDelimiter;
				for (var i = 0; i < decimals; i++) {
					mask += '0';
				}
			}

			return new StringMask(mask, {
				reverse: true
			});
		}

		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var decimals = $parse(attrs.uiScientificNotationMask)(scope);

				if (isNaN(decimals)) {
					decimals = defaultPrecision;
				}

				var significandMask = significandMaskBuilder(decimals);

				function splitNumber(value) {
					var stringValue = value.toString(),
						splittedNumber = stringValue.match(/(-?[0-9]*)[\.]?([0-9]*)?[Ee]?([\+-]?[0-9]*)?/);

					return {
						integerPartOfSignificand: splittedNumber[1],
						decimalPartOfSignificand: splittedNumber[2],
						exponent: splittedNumber[3] | 0
					};
				}

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					if (typeof value === 'number') {
						value = value.toExponential(decimals);
					} else {
						value = value.toString().replace(decimalDelimiter, '.');
					}

					var formattedValue, exponent;
					var splittedNumber = splitNumber(value);

					var integerPartOfSignificand = splittedNumber.integerPartOfSignificand || 0;
					var numberToFormat = integerPartOfSignificand.toString();
					if (angular.isDefined(splittedNumber.decimalPartOfSignificand)) {
						numberToFormat += splittedNumber.decimalPartOfSignificand;
					}

					var needsNormalization =
						(integerPartOfSignificand >= 1 || integerPartOfSignificand <= -1) &&
						(
							(angular.isDefined(splittedNumber.decimalPartOfSignificand) &&
							splittedNumber.decimalPartOfSignificand.length > decimals) ||
							(decimals === 0 && numberToFormat.length >= 2)
						);

					if (needsNormalization) {
						exponent = numberToFormat.slice(decimals + 1, numberToFormat.length);
						numberToFormat = numberToFormat.slice(0, decimals + 1);
					}

					formattedValue = significandMask.apply(numberToFormat);

					if (splittedNumber.exponent !== 0) {
						exponent = splittedNumber.exponent;
					}

					if (angular.isDefined(exponent)) {
						formattedValue += 'e' + exponent;
					}

					var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value[0] === '-') ? '-' : '';

					return prefix + formattedValue;
				}

				function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var isExponentNegative = /e-/.test(value);
					var cleanValue = value.replace('e-', 'e');
					var viewValue = formatter(cleanValue);

					var needsToInvertSign = (value.slice(-1) === '-');

					if (needsToInvertSign ^ isExponentNegative) {
						viewValue = viewValue.replace(/(e[-]?)/, 'e-');
					}

					if (needsToInvertSign && isExponentNegative) {
						viewValue = viewValue[0] !== '-' ? ('-' + viewValue) : viewValue.replace(/^(-)/,'');
					}

					var modelValue = parseFloat(viewValue.replace(decimalDelimiter, '.'));

					if (ctrl.$viewValue !== viewValue) {
						ctrl.$setViewValue(viewValue);
						ctrl.$render();
					}

					return modelValue;
				}

				ctrl.$formatters.push(formatter);
				ctrl.$parsers.push(parser);

				ctrl.$validators.max = function validator(value) {
					return ctrl.$isEmpty(value) || value < Number.MAX_VALUE;
				};
			}
		};
	}
	ScientificNotationMaskDirective.$inject = ['$locale', '$parse'];

	module.exports = ScientificNotationMaskDirective;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	module.exports = function TimeMaskDirective() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var timeFormat = '00:00:00';

				if (angular.isDefined(attrs.uiTimeMask) && attrs.uiTimeMask === 'short') {
					timeFormat = '00:00';
				}

				var formattedValueLength = timeFormat.length;
				var unformattedValueLength = timeFormat.replace(':', '').length;
				var timeMask = new StringMask(timeFormat);

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var cleanValue = value.replace(/[^0-9]/g, '').slice(0, unformattedValueLength) || '';
					return (timeMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
				}

				ctrl.$formatters.push(formatter);

				ctrl.$parsers.push(function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var viewValue = formatter(value);
					var modelValue = viewValue;

					if (ctrl.$viewValue !== viewValue) {
						ctrl.$setViewValue(viewValue);
						ctrl.$render();
					}

					return modelValue;
				});

				ctrl.$validators.time = function(modelValue) {
					if (ctrl.$isEmpty(modelValue)) {
						return true;
					}

					var splittedValue = modelValue.toString().split(/:/).filter(function(v) {
						return !!v;
					});

					var hours = parseInt(splittedValue[0]),
						minutes = parseInt(splittedValue[1]),
						seconds = parseInt(splittedValue[2] || 0);

					return modelValue.toString().length === formattedValueLength &&
						hours < 24 && minutes < 60 && seconds < 60;
				};
			}
		};
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var m = angular.module('ui.utils.masks.br', [])
		.directive('uiBrBoletoBancarioMask', __webpack_require__(388))
		.directive('uiBrCarPlateMask', __webpack_require__(389))
		.directive('uiBrCepMask', __webpack_require__(390))
		.directive('uiBrCnpjMask', __webpack_require__(391))
		.directive('uiBrCpfMask', __webpack_require__(393))
		.directive('uiBrCpfcnpjMask', __webpack_require__(394))
		.directive('uiBrNumeroBeneficioMask', __webpack_require__(395))
		.directive('uiBrIeMask', __webpack_require__(396))
		.directive('uiNfeAccessKeyMask', __webpack_require__(397))
		.directive('uiBrPhoneNumberMask', __webpack_require__(398));

	module.exports = m.name;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var boletoBancarioMask = new StringMask('00000.00000 00000.000000 00000.000000 0 00000000000000');
	var tributoBancarioMask = new StringMask('00000000000-0 00000000000-0 00000000000-0 00000000000-0');

	module.exports = maskFactory({
		clearValue: function (rawValue) {
			return rawValue.replace(/[^0-9]/g, '').slice(0, 48);
		},
		format: function (cleanValue) {
			if (cleanValue.length === 0) {
				return cleanValue;
			}
			if (cleanValue[0] === '8')
				return tributoBancarioMask.apply(cleanValue).replace(/[^0-9]$/, '');
			return boletoBancarioMask.apply(cleanValue).replace(/[^0-9]$/, '');
		},
		validations: {
			brBoletoBancario: function (value) {
				return [47, 48].indexOf(value.length) >= 0;
			}
		}
	});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var carPlateMask = new StringMask('UUU-0000');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^a-zA-Z0-9]/g, '').slice(0, 7);
		},
		format: function(cleanValue) {
			return (carPlateMask.apply(cleanValue) || '').replace(/[^a-zA-Z0-9]$/, '');
		},
		validations: {
			carPlate: function(value) {
				return value.length === 7;
			}
		}
	});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var cepMask = new StringMask('00000-000');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 8);
		},
		format: function(cleanValue) {
			return (cepMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
		},
		validations: {
			cep: function(value) {
				return value.toString().trim().length === 8;
			}
		}
	});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var BrV = __webpack_require__(392);

	var maskFactory = __webpack_require__(343);

	var cnpjPattern = new StringMask('00.000.000\/0000-00');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^\d]/g, '').slice(0, 14);
		},
		format: function(cleanValue) {
			return (cnpjPattern.apply(cleanValue) || '').trim().replace(/[^0-9]$/, '');
		},
		validations: {
			cnpj: function(value) {
				return BrV.cnpj.validate(value);
			}
		}
	});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * br-validations
	 * A library of validations applicable to several Brazilian data like I.E., CNPJ, CPF and others
	 * @version v0.3.0
	 * @link http://github.com/the-darc/br-validations
	 * @license MIT
	 */
	(function (root, factory) {
		/* istanbul ignore next */
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.BrV = factory();
		}
	}(this, function () {
	var CNPJ = {};

	CNPJ.validate = function(c) {
		var b = [6,5,4,3,2,9,8,7,6,5,4,3,2];
		c = c.replace(/[^\d]/g,'');

		var r = /^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/;
		if (!c || c.length !== 14 || r.test(c)) {
			return false;
		}
		c = c.split('');

		for (var i = 0, n = 0; i < 12; i++) {
			n += c[i] * b[i+1];
		}
		n = 11 - n%11;
		n = n >= 10 ? 0 : n;
		if (parseInt(c[12]) !== n)  {
			return false;
		}

		for (i = 0, n = 0; i <= 12; i++) {
			n += c[i] * b[i];
		}
		n = 11 - n%11;
		n = n >= 10 ? 0 : n;
		if (parseInt(c[13]) !== n)  {
			return false;
		}
		return true;
	};


	var CPF = {};

	CPF.validate = function(cpf) {
		cpf = cpf.replace(/[^\d]+/g,'');
		var r = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;
		if (!cpf || cpf.length !== 11 || r.test(cpf)) {
			return false;
		}
		function validateDigit(digit) {
			var add = 0;
			var init = digit - 9;
			for (var i = 0; i < 9; i ++) {
				add += parseInt(cpf.charAt(i + init)) * (i+1);
			}
			return (add%11)%10 === parseInt(cpf.charAt(digit));
		}
		return validateDigit(9) && validateDigit(10);
	};

	var IE = function(uf) {
		if (!(this instanceof IE)) {
			return new IE(uf);
		}

		this.rules = IErules[uf] || [];
		this.rule;
		IE.prototype._defineRule = function(value) {
			this.rule = undefined;
			for (var r = 0; r < this.rules.length && this.rule === undefined; r++) {
				var str = value.replace(/[^\d]/g,'');
				var ruleCandidate = this.rules[r];
				if (str.length === ruleCandidate.chars && (!ruleCandidate.match || ruleCandidate.match.test(value))) {
					this.rule = ruleCandidate;
				}
			}
			return !!this.rule;
		};

		IE.prototype.validate = function(value) {
			if (!value || !this._defineRule(value)) {
				return false;
			}
			return this.rule.validate(value);
		};
	};

	var IErules = {};

	var algorithmSteps = {
		handleStr: {
			onlyNumbers: function(str) {
				return str.replace(/[^\d]/g,'').split('');
			},
			mgSpec: function(str) {
				var s = str.replace(/[^\d]/g,'');
				s = s.substr(0,3)+'0'+s.substr(3, s.length);
				return s.split('');
			}
		},
		sum: {
			normalSum: function(handledStr, pesos) {
				var nums = handledStr;
				var sum = 0;
				for (var i = 0; i < pesos.length; i++) {
					sum += parseInt(nums[i]) * pesos[i];
				}
				return sum;
			},
			individualSum: function(handledStr, pesos) {
				var nums = handledStr;
				var sum = 0;
				for (var i = 0; i < pesos.length; i++) {
					var mult = parseInt(nums[i]) * pesos[i];
					sum += mult%10 + parseInt(mult/10);
				}
				return sum;
			},
			apSpec: function(handledStr, pesos) {
				var sum = this.normalSum(handledStr, pesos);
				var ref = handledStr.join('');
				if (ref >= '030000010' && ref <= '030170009') {
					return sum + 5;
				}
				if (ref >= '030170010' && ref <= '030190229') {
					return sum + 9;
				}
				return sum;
			}
		},
		rest: {
			mod11: function(sum) {
				return sum%11;
			},
			mod10: function(sum) {
				return sum%10;
			},
			mod9: function(sum) {
				return sum%9;
			}
		},
		expectedDV: {
			minusRestOf11: function(rest) {
				return rest < 2 ? 0 : 11 - rest;
			},
			minusRestOf11v2: function(rest) {
				return rest < 2 ? 11 - rest - 10 : 11 - rest;
			},
			minusRestOf10: function(rest) {
				return rest < 1 ? 0 : 10 - rest;
			},
			mod10: function(rest) {
				return rest%10;
			},
			goSpec: function(rest, handledStr) {
				var ref = handledStr.join('');
				if (rest === 1) {
					return ref >= '101031050' && ref <= '101199979' ? 1 : 0;
				}
				return rest === 0 ? 0 : 11 - rest;
			},
			apSpec: function(rest, handledStr) {
				var ref = handledStr.join('');
				if (rest === 0) {
					return ref >= '030170010' && ref <= '030190229' ? 1 : 0;
				}
				return rest === 1 ? 0 : 11 - rest;
			},
			voidFn: function(rest) {
				return rest;
			}
		}
	};


	/**
	 * options {
	 *     pesos: Array of values used to operate in sum step
	 *     dvPos: Position of the DV to validate considering the handledStr
	 *     algorithmSteps: The four DV's validation algorithm steps names
	 * }
	 */
	function validateDV(value, options) {
		var steps = options.algorithmSteps;

		// Step 01: Handle String
		var handledStr = algorithmSteps.handleStr[steps[0]](value);

		// Step 02: Sum chars
		var sum = algorithmSteps.sum[steps[1]](handledStr, options.pesos);

		// Step 03: Rest calculation
		var rest = algorithmSteps.rest[steps[2]](sum);

		// Fixed Step: Get current DV
		var currentDV = parseInt(handledStr[options.dvpos]);

		// Step 04: Expected DV calculation
		var expectedDV = algorithmSteps.expectedDV[steps[3]](rest, handledStr);

		// Fixed step: DV verification
		return currentDV === expectedDV;
	}

	function validateIE(value, rule) {
		for (var i = 0; i < rule.dvs.length; i++) {
			// console.log('>> >> dv'+i);
			if (!validateDV(value, rule.dvs[i])) {
				return false;
			}
		}
		return true;
	}

	IErules.PE = [{
		//mask: new StringMask('0000000-00'),
		chars: 9,
		dvs: [{
			dvpos: 7,
			pesos: [8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		// mask: new StringMask('00.0.000.0000000-0'),
		chars: 14,
		pesos: [[1,2,3,4,5,9,8,7,6,5,4,3,2]],
		dvs: [{
			dvpos: 13,
			pesos: [5,4,3,2,1,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11v2']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.RS = [{
		// mask: new StringMask('000/0000000'),
		chars: 10,
		dvs: [{
			dvpos: 9,
			pesos: [2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.AC = [{
		// mask: new StringMask('00.000.000/000-00'),
		chars: 13,
		match: /^01/,
		dvs: [{
			dvpos: 11,
			pesos: [4,3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 12,
			pesos: [5,4,3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.MG = [{
		// mask: new StringMask('000.000.000/0000'),
		chars: 13,
		dvs: [{
			dvpos: 12,
			pesos: [1,2,1,2,1,2,1,2,1,2,1,2],
			algorithmSteps: ['mgSpec', 'individualSum', 'mod10', 'minusRestOf10']
		},{
			dvpos: 12,
			pesos: [3,2,11,10,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.SP = [{
		// mask: new StringMask('000.000.000.000'),
		chars: 12,
		match: /^[0-9]/,
		dvs: [{
			dvpos: 8,
			pesos: [1,3,4,5,6,7,8,10],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
		},{
			dvpos: 11,
			pesos: [3,2,10,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		// mask: new StringMask('P-00000000.0/000')
		chars: 12,
		match: /^P/i,
		dvs: [{
			dvpos: 8,
			pesos: [1,3,4,5,6,7,8,10],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.DF = [{
		// mask: new StringMask('00000000000-00'),
		chars: 13,
		dvs: [{
			dvpos: 11,
			pesos: [4,3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 12,
			pesos: [5,4,3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.ES = [{
		// mask: new StringMask('000.000.00-0')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.BA = [{
		// mask: new StringMask('000000-00')
		chars: 8,
		match: /^[0123458]/,
		dvs: [{
			dvpos: 7,
			pesos: [7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
		},{
			dvpos: 6,
			pesos: [8,7,6,5,4,3,0,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		chars: 8,
		match: /^[679]/,
		dvs: [{
			dvpos: 7,
			pesos: [7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 6,
			pesos: [8,7,6,5,4,3,0,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		// mask: new StringMask('0000000-00')
		chars: 9,
		match: /^[0-9][0123458]/,
		dvs: [{
			dvpos: 8,
			pesos: [8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
		},{
			dvpos: 7,
			pesos: [9,8,7,6,5,4,3,0,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		chars: 9,
		match: /^[0-9][679]/,
		dvs: [{
			dvpos: 8,
			pesos: [8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 7,
			pesos: [9,8,7,6,5,4,3,0,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.AM = [{
		//mask: new StringMask('00.000.000-0')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.RN = [{
		// {mask: new StringMask('00.000.000-0')
		chars: 9,
		match: /^20/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	},{
		// {mask: new StringMask('00.0.000.000-0'), chars: 10}
		chars: 10,
		match: /^20/,
		dvs: [{
			dvpos: 8,
			pesos: [10,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.RO = [{
		// mask: new StringMask('0000000000000-0')
		chars: 14,
		dvs: [{
			dvpos: 13,
			pesos: [6,5,4,3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11v2']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.PR = [{
		// mask: new StringMask('00000000-00')
		chars: 10,
		dvs: [{
			dvpos: 8,
			pesos: [3,2,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		},{
			dvpos: 9,
			pesos: [4,3,2,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.SC = [{
		// {mask: new StringMask('000.000.000'), uf: 'SANTA CATARINA'}
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.RJ = [{
		// {mask: new StringMask('00.000.00-0'), uf: 'RIO DE JANEIRO'}
		chars: 8,
		dvs: [{
			dvpos: 7,
			pesos: [2,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.PA = [{
		// {mask: new StringMask('00-000000-0')
		chars: 9,
		match: /^15/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.SE = [{
		// {mask: new StringMask('00000000-0')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.PB = [{
		// {mask: new StringMask('00000000-0')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.CE = [{
		// {mask: new StringMask('00000000-0')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.PI = [{
		// {mask: new StringMask('000000000')
		chars: 9,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.MA = [{
		// {mask: new StringMask('000000000')
		chars: 9,
		match: /^12/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.MT = [{
		// {mask: new StringMask('0000000000-0')
		chars: 11,
		dvs: [{
			dvpos: 10,
			pesos: [3,2,9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.MS = [{
		// {mask: new StringMask('000000000')
		chars: 9,
		match: /^28/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.TO = [{
		// {mask: new StringMask('00000000000'),
		chars: 11,
		match: /^[0-9]{2}((0[123])|(99))/,
		dvs: [{
			dvpos: 10,
			pesos: [9,8,0,0,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.AL = [{
		// {mask: new StringMask('000000000')
		chars: 9,
		match: /^24[03578]/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.RR = [{
		// {mask: new StringMask('00000000-0')
		chars: 9,
		match: /^24/,
		dvs: [{
			dvpos: 8,
			pesos: [1,2,3,4,5,6,7,8],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod9', 'voidFn']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.GO = [{
		// {mask: new StringMask('00.000.000-0')
		chars: 9,
		match: /^1[015]/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'goSpec']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];

	IErules.AP = [{
		// {mask: new StringMask('000000000')
		chars: 9,
		match: /^03/,
		dvs: [{
			dvpos: 8,
			pesos: [9,8,7,6,5,4,3,2],
			algorithmSteps: ['onlyNumbers', 'apSpec', 'mod11', 'apSpec']
		}],
		validate: function(value) { return validateIE(value, this); }
	}];


	var PIS = {};

	PIS.validate = function(pis) {
		pis = pis.replace(/[^\d]+/g,'');
		var r = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;

		if (!pis || pis.length !== 11 || r.test(pis)) {
			return false;
		}

		var pisi = pis.substring(0,10);
		var pisd = pis.substring(10);

		function calculateDigit(pis){
	        var p = [3,2,9,8,7,6,5,4,3,2];
	        var s = 0;
	        for(var i = 0; i <= 9; i++){
	            s += parseInt(pis.charAt(i)) * p[i];
	        }
	        var r = 11 - (s%11);
	        return (r === 10 || r === 11) ? 0 : r;
		}

		return Number(pisd) === calculateDigit(pisi);
	};

		return {
			ie: IE,
			cpf: CPF,
			cnpj: CNPJ,
			pis: PIS
		};
	}));

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var BrV = __webpack_require__(392);

	var maskFactory = __webpack_require__(343);

	var cpfPattern = new StringMask('000.000.000-00');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^\d]/g, '').slice(0, 11);
		},
		format: function(cleanValue) {
			return (cpfPattern.apply(cleanValue) || '').trim().replace(/[^0-9]$/, '');
		},
		validations: {
			cpf: function(value) {
				return BrV.cpf.validate(value);
			}
		}
	});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var BrV = __webpack_require__(392);
	var maskFactory = __webpack_require__(343);

	var cnpjPattern = new StringMask('00.000.000\/0000-00');
	var cpfPattern = new StringMask('000.000.000-00');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^\d]/g, '').slice(0, 14);
		},
		format: function(cleanValue) {
			var formatedValue;

			if (cleanValue.length > 11) {
				formatedValue = cnpjPattern.apply(cleanValue);
			} else {
				formatedValue = cpfPattern.apply(cleanValue) || '';
			}

			return formatedValue.trim().replace(/[^0-9]$/, '');
		},
		validations: {
			cpf: function(value) {
				return value.length > 11 || BrV.cpf.validate(value);
			},
			cnpj: function(value) {
				return value.length <= 11 || BrV.cnpj.validate(value);
			}
		}
	});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	var maskFactory = __webpack_require__(343);

	var numeroBeneficioPattern = new StringMask('###.###.###-#', {reverse: true});

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^\d]/g, '').slice(0, 10);
		},
		format: function(cleanValue) {
			return (numeroBeneficioPattern.apply(cleanValue) || '').trim().replace(/[^0-9]$/, '');
		},
		validations: {}
	});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var BrV = __webpack_require__(392);

	var ieMasks = {
		'AC': [{mask: new StringMask('00.000.000/000-00')}],
		'AL': [{mask: new StringMask('000000000')}],
		'AM': [{mask: new StringMask('00.000.000-0')}],
		'AP': [{mask: new StringMask('000000000')}],
		'BA': [{chars: 8, mask: new StringMask('000000-00')}, {mask: new StringMask('0000000-00')}],
		'CE': [{mask: new StringMask('00000000-0')}],
		'DF': [{mask: new StringMask('00000000000-00')}],
		'ES': [{mask: new StringMask('00000000-0')}],
		'GO': [{mask: new StringMask('00.000.000-0')}],
		'MA': [{mask: new StringMask('000000000')}],
		'MG': [{mask: new StringMask('000.000.000/0000')}],
		'MS': [{mask: new StringMask('000000000')}],
		'MT': [{mask: new StringMask('0000000000-0')}],
		'PA': [{mask: new StringMask('00-000000-0')}],
		'PB': [{mask: new StringMask('00000000-0')}],
		'PE': [{chars: 9, mask: new StringMask('0000000-00')}, {mask: new StringMask('00.0.000.0000000-0')}],
		'PI': [{mask: new StringMask('000000000')}],
		'PR': [{mask: new StringMask('000.00000-00')}],
		'RJ': [{mask: new StringMask('00.000.00-0')}],
		'RN': [{chars: 9, mask: new StringMask('00.000.000-0')}, {mask: new StringMask('00.0.000.000-0')}],
		'RO': [{mask: new StringMask('0000000000000-0')}],
		'RR': [{mask: new StringMask('00000000-0')}],
		'RS': [{mask: new StringMask('000/0000000')}],
		'SC': [{mask: new StringMask('000.000.000')}],
		'SE': [{mask: new StringMask('00000000-0')}],
		'SP': [{mask: new StringMask('000.000.000.000')}, {mask: new StringMask('-00000000.0/000')}],
		'TO': [{mask: new StringMask('00000000000')}]
	};

	function BrIeMaskDirective($parse) {
		function clearValue(value) {
			if (!value) {
				return value;
			}

			return value.replace(/[^0-9]/g, '');
		}

		function getMask(uf, value) {
			if (!uf || !ieMasks[uf]) {
				return;
			}

			if (uf === 'SP' && /^P/i.test(value)) {
				return ieMasks.SP[1].mask;
			}

			var masks = ieMasks[uf];
			var i = 0;
			while (masks[i].chars && masks[i].chars < clearValue(value).length && i < masks.length - 1) {
				i++;
			}

			return masks[i].mask;
		}

		function applyIEMask(value, uf) {
			var mask = getMask(uf, value);

			if (!mask) {
				return value;
			}

			var processed = mask.process(clearValue(value));
			var formatedValue = processed.result || '';
			formatedValue = formatedValue.trim().replace(/[^0-9]$/, '');

			if (uf === 'SP' && /^p/i.test(value)) {
				return 'P' + formatedValue;
			}

			return formatedValue;
		}

		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				var state = ($parse(attrs.uiBrIeMask)(scope) || '').toUpperCase();

				function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					return applyIEMask(value, state);
				}

				function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var formatedValue = applyIEMask(value, state);
					var actualValue = clearValue(formatedValue);

					if (ctrl.$viewValue !== formatedValue) {
						ctrl.$setViewValue(formatedValue);
						ctrl.$render();
					}

					if (state && state.toUpperCase() === 'SP' && /^p/i.test(value)) {
						return 'P' + actualValue;
					}

					return actualValue;
				}

				ctrl.$formatters.push(formatter);
				ctrl.$parsers.push(parser);

				ctrl.$validators.ie = function validator(modelValue) {
					return ctrl.$isEmpty(modelValue) || BrV.ie(state).validate(modelValue);
				};

				scope.$watch(attrs.uiBrIeMask, function(newState) {
					state = (newState || '').toUpperCase();

					parser(ctrl.$viewValue);
					ctrl.$validate();
				});
			}
		};
	}
	BrIeMaskDirective.$inject = ['$parse'];

	module.exports = BrIeMaskDirective;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	var maskFactory = __webpack_require__(343);

	var nfeAccessKeyMask = new StringMask('0000 0000 0000 0000 0000 0000 0000 0000 0000 0000 0000');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.replace(/[^0-9]/g, '').slice(0, 44);
		},
		format: function(cleanValue) {
			return (nfeAccessKeyMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
		},
		validations: {
			nfeAccessKey: function(value) {
				return value.length === 44;
			}
		}
	});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	var maskFactory = __webpack_require__(343);

	var phoneMask8D = {
			countryCode : new StringMask('+00 (00) 0000-0000'),   //with country code
			areaCode    : new StringMask('(00) 0000-0000'),       //with area code
			simple      : new StringMask('0000-0000')             //without area code
		}, phoneMask9D = {
			countryCode : new StringMask('+00 (00) 00000-0000'), //with country code
			areaCode    : new StringMask('(00) 00000-0000'),     //with area code
			simple      : new StringMask('00000-0000')           //without area code
		}, phoneMask0800 = {
			countryCode : null,                                   //N/A
			areaCode    : null,                                   //N/A
			simple      : new StringMask('0000-000-0000')         //N/A, so it's "simple"
		};

	var brPhoneMaskOptions = {
		'countryCode': {sliceSize: 13, min: 12, max: 13},
		'areaCode': {sliceSize: 11, min: 10, max: 11},
		'simple': {sliceSize: 9, min: 8, max: 9},
		'all': {sliceSize: 13, min: 8, max: 13}
	};

	function findOption(attrs) {
		var brPhoneMaskOption = brPhoneMaskOptions.all;

		if (attrs && attrs.uiBrPhoneNumberMask) {
			var maskOption = attrs.uiBrPhoneNumberMask;
			angular.forEach(brPhoneMaskOptions, function(value, key) {
				if (key === maskOption) {
					brPhoneMaskOption = value;
					return;
				}
			});
		}

		return brPhoneMaskOption;
	}

	module.exports = maskFactory({
		clearValue: function(rawValue, attrs) {
			var brPhoneMaskOption = findOption(attrs);
			return rawValue.toString().replace(/[^0-9]/g, '').slice(0, brPhoneMaskOption.sliceSize);
		},
		format: function(cleanValue) {
			var formattedValue;

			if (cleanValue.indexOf('0800') === 0) {
				formattedValue = phoneMask0800.simple.apply(cleanValue);
			} else if (cleanValue.length < 9) {
				formattedValue = phoneMask8D.simple.apply(cleanValue) || '';
			} else if (cleanValue.length < 10) {
				formattedValue = phoneMask9D.simple.apply(cleanValue);
			} else if (cleanValue.length < 11) {
				formattedValue = phoneMask8D.areaCode.apply(cleanValue);
			} else if (cleanValue.length < 12) {
				formattedValue = phoneMask9D.areaCode.apply(cleanValue);
			} else if (cleanValue.length < 13) {
				formattedValue = phoneMask8D.countryCode.apply(cleanValue);
			} else {
				formattedValue = phoneMask9D.countryCode.apply(cleanValue);
			}

			return formattedValue.trim().replace(/[^0-9]$/, '');
		},
		getModelValue: function(formattedValue, originalModelType) {
			var cleanValue = this.clearValue(formattedValue);
			return originalModelType === 'number' ? parseInt(cleanValue) : cleanValue;
		},
		validations: {
			brPhoneNumber: function(value, view, attrs) {
				var brPhoneMaskOption = findOption(attrs);
				var valueLength = value && value.toString().length;

				//8- 8D without AC
				//9- 9D without AC
				//10- 8D with AC
				//11- 9D with AC and 0800
				//12- 8D with AC plus CC
				//13- 9D with AC plus CC
				return valueLength >= brPhoneMaskOption.min && valueLength <= brPhoneMaskOption.max;
			}
		}
	});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var m = angular.module('ui.utils.masks.ch', [])
		.directive('uiChPhoneNumberMask', __webpack_require__(400));

	module.exports = m.name;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);

	var maskFactory = __webpack_require__(343);

	var phoneMask = new StringMask('+00 00 000 00 00');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 11);
		},
		format: function(cleanValue) {
			var formatedValue;

			formatedValue = phoneMask.apply(cleanValue) || '';

			return formatedValue.trim().replace(/[^0-9]$/, '');
		},
		validations: {
			chPhoneNumber: function(value) {
				var valueLength = value && value.toString().length;
				return valueLength === 11;
			}
		}
	});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var m = angular.module('ui.utils.masks.fr', [])
		.directive('uiFrPhoneNumberMask', __webpack_require__(402));

	module.exports = m.name;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var phoneMaskFR = new StringMask('00 00 00 00 00');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 10);
		},
		format: function(cleanValue) {
			var formattedValue;

			formattedValue = phoneMaskFR.apply(cleanValue) || '';

			return formattedValue.trim().replace(/[^0-9]$/, '');
		},
		validations: {
			frPhoneNumber: function(value) {
				var valueLength = value && value.toString().length;
				return valueLength === 10;
			}
		}
	});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var m = angular.module('ui.utils.masks.us', [])
		.directive('uiUsPhoneNumberMask', __webpack_require__(404));

	module.exports = m.name;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StringMask = __webpack_require__(342);
	var maskFactory = __webpack_require__(343);

	var phoneMaskUS = new StringMask('(000) 000-0000'),
		phoneMaskINTL = new StringMask('+00-00-000-000000');

	module.exports = maskFactory({
		clearValue: function(rawValue) {
			return rawValue.toString().replace(/[^0-9]/g, '');
		},
		format: function(cleanValue) {
			var formattedValue;

			if (cleanValue.length < 11) {
				formattedValue = phoneMaskUS.apply(cleanValue) || '';
			} else {
				formattedValue = phoneMaskINTL.apply(cleanValue);
			}

			return formattedValue.trim().replace(/[^0-9]$/, '');
		},
		validations: {
			usPhoneNumber: function(value) {
				return value && value.toString().length > 9;
			}
		}
	});


/***/ })
/******/ ]);
angular.module("phoenix").run(["$templateCache", function($templateCache) {$templateCache.put("app/access/access.html","<div class=client-area><div class=stripes-wrapper><div class=\"grid-root grid-top-right\"><div style=\"grid-row: 1 / span 1; grid-column: 7 / span 9\"><div class=box-column><span class=\"box box-blue\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color1}\"></span></div></div><div style=\"grid-row: 2 / span 1;  grid-column: 5 / span 11\"><div class=box-column><span class=\"box box-dark-blue\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\"></span></div></div><div style=\"grid-row: 4 / span 1;  grid-column: 1 / span 4\"><div class=box-column><span class=\"box box-light\"></span></div></div></div><div class=\"grid-root grid-bottom-left\"><div style=\"grid-row: 1 / span 1; grid-column: 1 / span 3\"><div class=box-column><span class=\"box box-light\"></span></div></div><div style=\"grid-row: 2 / span 1; grid-column: 1 / span 7\"><div class=box-column><span class=box></span></div></div><div style=\"grid-row: 3 / span 1; grid-column: 1 / span 7\"><div class=box-column><span class=box></span></div></div><div style=\"grid-row: 4 / span 1; grid-column: 3 / span 8\"><div class=box-column><span class=\"box box-dark-blue\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\"></span></div></div><div style=\"grid-row: 5 / span 1; grid-column: 1 / span 6\"><div class=box-column><span class=\"box box-blue\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color1}\"></span></div></div><div style=\"grid-row: 6 / span 1; grid-column: 7 / span 12\"><div class=box-column><span class=\"box box-gray\"></span></div></div></div></div></div><div class=\"w-screen h-screen absolute items-center content-center access-form-wrapper bottom-10\" layout=column layout-align=\"center stretch\"><div><div ng-if=\"!currentEnterprise.type || !currentEnterprise.relationships.document\" class=\"w-96 h-20\" layout layout-align=\"center center\"><svg width=120px viewbox=\"0 0 136 29\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g stroke=none stroke-width=1 fill=none fill-rule=evenodd><path d=\"M12.06,15.328 C11.6759981,14.8239975 11.1480034,14.3860019 10.476,14.014 C9.80399664,13.6419981 9.07200396,13.456 8.28,13.456 C7.58399652,13.456 6.94800288,13.5999986 6.372,13.888 C5.79599712,14.1760014 5.508,14.6559966 5.508,15.328 C5.508,16.0000034 5.82599682,16.4739986 6.462,16.75 C7.09800318,17.0260014 8.02799388,17.3079986 9.252,17.596 C9.90000324,17.7400007 10.5539967,17.9319988 11.214,18.172 C11.8740033,18.4120012 12.4739973,18.729998 13.014,19.126 C13.5540027,19.522002 13.9919983,20.0139971 14.328,20.602 C14.6640017,21.1900029 14.832,21.9039958 14.832,22.744 C14.832,23.8000053 14.634002,24.6939963 14.238,25.426 C13.841998,26.1580037 13.3140033,26.7519977 12.654,27.208 C11.9939967,27.6640023 11.2260044,27.993999 10.35,28.198 C9.47399562,28.402001 8.56800468,28.504 7.632,28.504 C6.28799328,28.504 4.98000636,28.2580025 3.708,27.766 C2.43599364,27.2739975 1.3800042,26.5720046 0.54,25.66 L3.384,22.996 C3.8640024,23.6200031 4.48799616,24.135998 5.256,24.544 C6.02400384,24.952002 6.87599532,25.156 7.812,25.156 C8.12400156,25.156 8.44199838,25.1200004 8.766,25.048 C9.09000162,24.9759996 9.38999862,24.8620008 9.666,24.706 C9.94200138,24.5499992 10.1639992,24.3400013 10.332,24.076 C10.5000008,23.8119987 10.584,23.4880019 10.584,23.104 C10.584,22.3839964 10.2540033,21.8680016 9.594,21.556 C8.9339967,21.2439984 7.9440066,20.9320016 6.624,20.62 C5.97599676,20.4759993 5.34600306,20.2900011 4.734,20.062 C4.12199694,19.8339989 3.5760024,19.5340019 3.096,19.162 C2.6159976,18.7899981 2.23200144,18.3280028 1.944,17.776 C1.65599856,17.2239972 1.512,16.5400041 1.512,15.724 C1.512,14.7639952 1.70999802,13.9360035 2.106,13.24 C2.50200198,12.5439965 3.02399676,11.9740022 3.672,11.53 C4.32000324,11.0859978 5.05199592,10.7560011 5.868,10.54 C6.68400408,10.3239989 7.52399568,10.216 8.388,10.216 C9.63600624,10.216 10.8539941,10.4319978 12.042,10.864 C13.2300059,11.2960022 14.1719965,11.9559956 14.868,12.844 L12.06,15.328 Z M17.568,19.288 C17.568,17.9199932 17.8139975,16.6780056 18.306,15.562 C18.7980025,14.4459944 19.4639958,13.492004 20.304,12.7 C21.1440042,11.907996 22.1399942,11.2960022 23.292,10.864 C24.4440058,10.4319978 25.6679935,10.216 26.964,10.216 C28.2600065,10.216 29.4839942,10.4319978 30.636,10.864 C31.7880058,11.2960022 32.7839958,11.907996 33.624,12.7 C34.4640042,13.492004 35.1299975,14.4459944 35.622,15.562 C36.1140025,16.6780056 36.36,17.9199932 36.36,19.288 C36.36,20.6560068 36.1140025,21.9039944 35.622,23.032 C35.1299975,24.1600056 34.4640042,25.125996 33.624,25.93 C32.7839958,26.734004 31.7880058,27.3639977 30.636,27.82 C29.4839942,28.2760023 28.2600065,28.504 26.964,28.504 C25.6679935,28.504 24.4440058,28.2760023 23.292,27.82 C22.1399942,27.3639977 21.1440042,26.734004 20.304,25.93 C19.4639958,25.125996 18.7980025,24.1600056 18.306,23.032 C17.8139975,21.9039944 17.568,20.6560068 17.568,19.288 Z M21.96,19.288 C21.96,18.6159966 22.061999,17.9500033 22.266,17.29 C22.470001,16.6299967 22.775998,16.0360026 23.184,15.508 C23.592002,14.9799974 24.1079969,14.5540016 24.732,14.23 C25.3560031,13.9059984 26.0999957,13.744 26.964,13.744 C27.8280043,13.744 28.5719969,13.9059984 29.196,14.23 C29.8200031,14.5540016 30.335998,14.9799974 30.744,15.508 C31.152002,16.0360026 31.457999,16.6299967 31.662,17.29 C31.866001,17.9500033 31.968,18.6159966 31.968,19.288 C31.968,19.9600034 31.866001,20.6319966 31.662,21.304 C31.457999,21.9760034 31.152002,22.5759974 30.744,23.104 C30.335998,23.6320026 29.8200031,24.0639983 29.196,24.4 C28.5719969,24.7360017 27.8280043,24.904 26.964,24.904 C26.0999957,24.904 25.3560031,24.7360017 24.732,24.4 C24.1079969,24.0639983 23.592002,23.6320026 23.184,23.104 C22.775998,22.5759974 22.470001,21.9760034 22.266,21.304 C22.061999,20.6319966 21.96,19.9600034 21.96,19.288 Z M41.22,14.176 L37.944,14.176 L37.944,10.72 L41.22,10.72 L41.22,8.164 C41.22,7.13199484 41.3339989,6.14200474 41.562,5.194 C41.7900011,4.24599526 42.1739973,3.4120036 42.714,2.692 C43.2540027,1.9719964 43.9679956,1.4020021 44.856,0.982 C45.7440044,0.5619979 46.8599933,0.352 48.204,0.352 C48.6840024,0.352 49.0859984,0.36999982 49.41,0.406 C49.7340016,0.44200018 50.0639983,0.50799952 50.4,0.604 L50.112,4.276 C49.8719988,4.20399964 49.6140014,4.14400024 49.338,4.096 C49.0619986,4.04799976 48.7680016,4.024 48.456,4.024 C47.8319969,4.024 47.3280019,4.1439988 46.944,4.384 C46.5599981,4.6240012 46.266001,4.93599808 46.062,5.32 C45.857999,5.70400192 45.7200004,6.12399772 45.648,6.58 C45.5759996,7.03600228 45.54,7.47999784 45.54,7.912 L45.54,10.72 L49.536,10.72 L49.536,14.176 L45.54,14.176 L45.54,28 L41.22,28 L41.22,14.176 Z M52.316,14.176 L52.316,10.72 L55.34,10.72 L55.34,5.716 L59.588,5.716 L59.588,10.72 L63.908,10.72 L63.908,14.176 L59.588,14.176 L59.588,22.204 C59.588,22.9720038 59.7259986,23.6079975 60.002,24.112 C60.2780014,24.6160025 60.8959952,24.868 61.856,24.868 C62.1440014,24.868 62.4559983,24.8380003 62.792,24.778 C63.1280017,24.7179997 63.4279987,24.6280006 63.692,24.508 L63.836,27.892 C63.4519981,28.0360007 62.9960026,28.1499996 62.468,28.234 C61.9399974,28.3180004 61.4360024,28.36 60.956,28.36 C59.8039942,28.36 58.8680036,28.1980016 58.148,27.874 C57.4279964,27.5499984 56.8580021,27.1060028 56.438,26.542 C56.0179979,25.9779972 55.7300008,25.3300037 55.574,24.598 C55.4179992,23.8659963 55.34,23.0800042 55.34,22.24 L55.34,14.176 L52.316,14.176 Z M67.04,10.72 L71.18,10.72 L71.18,13.6 L71.252,13.6 C71.7320024,12.591995 72.4039957,11.7760031 73.268,11.152 C74.1320043,10.5279969 75.1399942,10.216 76.292,10.216 C76.4600008,10.216 76.639999,10.2219999 76.832,10.234 C77.024001,10.2460001 77.1919993,10.2759998 77.336,10.324 L77.336,14.284 C77.0479986,14.2119996 76.802001,14.1640001 76.598,14.14 C76.393999,14.1159999 76.196001,14.104 76.004,14.104 C75.0199951,14.104 74.228003,14.2839982 73.628,14.644 C73.027997,15.0040018 72.5600017,15.4359975 72.224,15.94 C71.8879983,16.4440025 71.6600006,16.9599974 71.54,17.488 C71.4199994,18.0160026 71.36,18.4359984 71.36,18.748 L71.36,28 L67.04,28 L67.04,10.72 Z M95.912,28 L91.808,28 L91.808,25.228 L91.736,25.228 C91.3519981,26.0920043 90.6860047,26.8539967 89.738,27.514 C88.7899953,28.1740033 87.6680065,28.504 86.372,28.504 C85.2439944,28.504 84.278004,28.306002 83.474,27.91 C82.669996,27.513998 82.0100026,26.9920032 81.494,26.344 C80.9779974,25.6959968 80.6000012,24.9520042 80.36,24.112 C80.1199988,23.2719958 80,22.4080044 80,21.52 L80,10.72 L84.32,10.72 L84.32,20.296 C84.32,20.8000025 84.3559996,21.3279972 84.428,21.88 C84.5000004,22.4320028 84.6559988,22.9299978 84.896,23.374 C85.1360012,23.8180022 85.4659979,24.1839986 85.886,24.472 C86.3060021,24.7600014 86.8639965,24.904 87.56,24.904 C88.2320034,24.904 88.8259974,24.7660014 89.342,24.49 C89.8580026,24.2139986 90.2779984,23.8600022 90.602,23.428 C90.9260016,22.9959978 91.1719992,22.4980028 91.34,21.934 C91.5080008,21.3699972 91.592,20.8000029 91.592,20.224 L91.592,10.72 L95.912,10.72 L95.912,28 Z M112.904,15.508 C112.567998,15.0279976 112.064003,14.6260016 111.392,14.302 C110.719997,13.9779984 110.036003,13.816 109.34,13.816 C108.547996,13.816 107.852003,13.9779984 107.252,14.302 C106.651997,14.6260016 106.154002,15.0519974 105.758,15.58 C105.361998,16.1080026 105.068001,16.7019967 104.876,17.362 C104.683999,18.0220033 104.588,18.6879966 104.588,19.36 C104.588,20.0320034 104.689999,20.6979967 104.894,21.358 C105.098001,22.0180033 105.403998,22.6119974 105.812,23.14 C106.220002,23.6680026 106.729997,24.0939984 107.342,24.418 C107.954003,24.7420016 108.667996,24.904 109.484,24.904 C110.156003,24.904 110.827997,24.7720013 111.5,24.508 C112.172003,24.2439987 112.711998,23.8600025 113.12,23.356 L115.82,26.092 C115.099996,26.8600038 114.182006,27.4539979 113.066,27.874 C111.949994,28.2940021 110.744006,28.504 109.448,28.504 C108.175994,28.504 106.970006,28.300002 105.83,27.892 C104.689994,27.483998 103.694004,26.884004 102.842,26.092 C101.989996,25.299996 101.318002,24.3400056 100.826,23.212 C100.333998,22.0839944 100.088,20.8000072 100.088,19.36 C100.088,17.967993 100.333998,16.7080056 100.826,15.58 C101.318002,14.4519944 101.983996,13.492004 102.824,12.7 C103.664004,11.907996 104.641994,11.2960022 105.758,10.864 C106.874006,10.4319978 108.067994,10.216 109.34,10.216 C110.612006,10.216 111.841994,10.4559976 113.03,10.936 C114.218006,11.4160024 115.159997,12.0759958 115.856,12.916 L112.904,15.508 Z M118.736,0.784 L123.056,0.784 L123.056,17.992 L123.164,17.992 L129.716,10.72 L135.26,10.72 L127.772,18.532 L135.728,28 L130.004,28 L123.164,19.144 L123.056,19.144 L123.056,28 L118.736,28 L118.736,0.784 Z\" id=softruck fill=#212121></path></g></svg></div><div ng-if=\"currentEnterprise.type && currentEnterprise.relationships.document\" class=\"w-96 mb24\"><div layout layout-align=\"center center\"><div class=icon-mask><img alt=\"Enterprise Logo\" ng-src={{mediaApi}}/{{currentEnterprise.relationships.document.attributes.folder}} height=148></div></div></div></div><div ui-view></div></div><div class=\"absolute color-gray-300 p16 w-full bottom-0\" layout layout-align=\"center center\"><div>© Softruck</div><div class=\"ml8 mr8\">·</div><a translate=LOGIN.BUTTON.PRIVACY target=_blank href=https://politicadeprivacidade.softruck.com/ ></a></div>");
$templateCache.put("app/internal/internal.html","<push-notification-bar></push-notification-bar><div id=page-body flex><div id=menu-wrapper><menu></menu></div><md-content md-scroll id=content flex when-scrolled=checkScroll()><div class=st-content-wrapper layout=column layout-align=\"start stretch\"><div id=navbar-wrapper><navbar></navbar></div><div ui-view></div></div></md-content></div>");
$templateCache.put("app/states/404.html","<div layout=column layout-align=\"center center\" flex=100><div layout layout-align=\"center center\"><h2 translate=STATE.TITLE.NOT_FOUND></h2></div><div layout layout-align=\"center center\"><p translate=STATE.LABEL.404></p></div></div>");
$templateCache.put("app/access/code/code.html","<div class=\"bg-white rounded-md shadow-xl access-container\"><div ng-if=\"ctrl.step > 1\" class=pb-4><button type=button class=\"no-button no-padding\" ng-click=ctrl.backStep() layout layout-align=\"start center\"><i class=material-symbols-outlined>arrow_left_alt</i> <span translate=LOGIN.BUTTON.BACK class=\"text-gray-700 text-base pl-1\"></span></button></div><div><p ng-if=\"ctrl.step === 1\" class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.BY_CODE></p><p ng-if=\"ctrl.step === 1\" class=\"text-sm font-normal leading-tight text-gray-500\" translate=LOGIN.TEXT.WANT_TO_ACCESS></p><p ng-if=\"ctrl.step === 2\" class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.WHAT_USER></p><p ng-if=\"ctrl.step === 2 && ctrl.actionType === \'have-code\'\" class=\"text-sm font-normal leading-tight text-gray-500\" translate=LOGIN.TEXT.TYPE_USER></p><p ng-if=\"ctrl.step === 2 && ctrl.actionType === \'send\'\" class=\"text-sm font-normal leading-tight text-gray-500\" translate=LOGIN.TEXT.SEND></p><p ng-if=\"ctrl.step === 3\" class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.TYPE_CODE></p><p ng-if=\"ctrl.step === 3 && ctrl.actionType === \'have-code\'\" class=\"text-sm font-normal leading-tight text-gray-500 w-80\" translate=LOGIN.TEXT.HAS_CODE_DETAIL></p><p ng-if=\"ctrl.step === 3 && ctrl.actionType === \'send\'\" class=\"text-sm font-normal leading-tight text-gray-500 w-80\" translate=LOGIN.TEXT.SEND_CODE_DETAIL></p></div><div ng-if=\"ctrl.step === 1\" layout=column class=mt-4><button class=\"rounded-md bg-blue-700 border-0 text-white p10 h-10\" ng-click=\"ctrl.actionType = \'send\'; ctrl.step = 2\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\" translate=LOGIN.BUTTON.SEND_EMAIL type=button></button> <button type=button ng-click=\"ctrl.actionType = \'have-code\'; ctrl.step = 2\" class=\"rounded-md border-gray-500 bg-white border-solid border text-gray-800 p10 mt-4 relative h-10\" translate=LOGIN.BUTTON.HAVE_CODE></button></div><form ng-if=\"ctrl.step > 1\" layout=column name=ctrl.form ng-submit=\"ctrl.form.$valid && (ctrl.step === 2 ? ctrl.generateCode() : ctrl.authenticate())\" novalidate><div ng-if=\"ctrl.step === 2\" class=\"w-full relative py-4\"><label class=\"text-sm font-bold leading-none text-gray-600\" translate=LOGIN.LABEL.USERNAME></label><input class=\"mt-1 rounded-md block w-full box-border bg-white\" ng-class=\"{\n          \'border-gray-300\': !ctrl.form.$submitted || ctrl.form.user.$valid,\n          \'border-red-600\': ctrl.form.$submitted && ctrl.form.user.$invalid\n        }\" type=text name=user ng-model=ctrl.user.username autocomplete=off required> <span ng-if=\"ctrl.form.$submitted && ctrl.form.user.$invalid\" class=\"text-xs text-red-600 absolute bottom-0 left-0\" translate=LOGIN.VALIDATION.REQUIRED></span></div><div ng-if=\"ctrl.step === 3\" class=\"w-full py-4\"><label class=\"text-sm font-bold leading-none text-gray-600\" translate=LOGIN.LABEL.CODE></label><div layout layout-align=\"space-between start\" class=mt-1><input autocomplete=off class=\"rounded-md block w-10 box-border text-center\" ng-class=\"{\n            \'border-gray-300\': !ctrl.form.$submitted || ctrl.form[\'code_\' + num].$valid,\n            \'border-red-600\': (ctrl.form.$submitted && ctrl.form[\'code_\' + num].$invalid) || ctrl.invalidCode\n          }\" maxlength=1 name=code_{{num}} ng-init=\"code === 1 && $event.target.focus()\" ng-keyup=\"ctrl.moveFocus($event, num)\" ng-model=ctrl.user.code[$index] ng-paste=\"ctrl.moveFocus($event, num)\" ng-repeat=\"num in [0,1,2,3,4,5]\" restrict-input=[^0-9] type=text required></div></div><button aria-label=Continue class=\"rounded-md bg-blue-700 border-0 text-white p10 mt-2 h-10\" ng-class=\"{\n        \'opacity-70\': ctrl.invalidCode\n      }\" layout layout-align=\"center center\" ng-disabled=\"ctrl.loading || ctrl.invalidCode\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\" type=submit><progress theme=light ng-if=ctrl.loading class=mr-1></progress><span translate=LOGIN.BUTTON.CONTINUE></span></button></form><div ng-if=\"ctrl.step === 3 && ctrl.actionType === \'send\'\" class=\"mt-4 access-actions\" layout layout-align=\"start center\"><span class=\"text-gray-800 text-sm\" translate=LOGIN.LABEL.NOT_RECEIVED></span> <button type=button class=\"no-button text-indigo-700 text-sm\" ng-disabled=ctrl.count ng-click=ctrl.generateCode() translate=LOGIN.BUTTON.RESEND></button> <span ng-if=ctrl.count class=\"text-xs text-gray-800\"><span class=pr-1 translate=LOGIN.LABEL.IN></span>00:{{ctrl.count.toString().padStart(2, \'0\')}}s</span></div></div><div class=\"m24 access-actions\" layout layout-align=\"center center\"><a class=\"text-indigo-700 text-sm\" ui-sref=signin translate=LOGIN.BUTTON.BACK_LOGIN></a></div>");
$templateCache.put("app/access/external/external.html","<div><div ng-if=ctrl.loading><progress></progress></div></div>");
$templateCache.put("app/access/forgot/forgot.html","<div class=\"bg-white rounded-md shadow-xl access-container\"><div><span class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.FORGOT></span></div><form layout=column name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.sendPassword()\" novalidate><div class=\"w-full mt16\"><div class=\"text-sm font-bold leading-none text-gray-600 mt12 h-5\" translate=LOGIN.LABEL.USERNAME></div><input class=\"mt12 border-gray-300 rounded-md block w-full box-border\" type=text name=text ng-model=ctrl.user.username autocomplete=off required></div><button type=submit class=\"rounded-md bg-blue-700 border-0 text-white p10 mt24 relative h-10\" layout layout-align=\"center center\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\" ng-disabled=ctrl.loading aria-label=Send><progress class=\"absolute float-left left-3\" theme=light ng-if=ctrl.loading></progress><span translate=LOGIN.BUTTON.SEND></span></button></form></div><div class=\"m24 access-actions\" layout layout-align=\"center center\"><a class=\"text-indigo-700 text-sm\" ui-sref=signin translate=LOGIN.BUTTON.BACK_LOGIN></a></div>");
$templateCache.put("app/access/reset/reset.html","<div class=\"bg-white rounded-md shadow-xl access-container\"><div><span class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.DEFINE_PASS></span></div><form layout=column name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.resetPassword()\" novalidate><div class=\"w-full mt16 relative\"><div class=\"text-sm font-bold leading-none text-gray-600 mt12 h-5\" translate=LOGIN.LABEL.NEW_PASSWORD></div><password-meter ng-model=ctrl.user.password></password-meter><div class=relative><input class=\"mt12 border-gray-300 rounded-md block w-full box-border h-10\" type=\"{{ctrl.type ? \'text\' : \'password\'}}\" name=password ng-model=ctrl.user.password autocomplete=off required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.type = !ctrl.type\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.type ? \'visibility\' : \'visibility_off\'}}</i></a></div></div><div class=\"w-full mt16\"><div class=\"text-sm font-bold leading-none text-gray-600 mt12 h-5\" translate=LOGIN.LABEL.CONFIRM_PASSWORD></div><div class=relative><input class=\"mt12 border-gray-300 rounded-md block w-full box-border h-10\" type=\"{{ctrl.type_confirm ? \'text\' : \'password\'}}\" name=confirm-password ng-model=ctrl.user.confirm_password autocomplete=off required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.type_confirm = !ctrl.type_confirm\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.type_confirm ? \'visibility\' : \'visibility_off\'}}</i></a></div><div ng-if=\"ctrl.form.$submitted && (ctrl.user.password !== ctrl.user.confirm_password)\"><div class=\"text-xs text-red-600 mt4 truncate\" translate=LOGIN.VALIDATION.DONT_MATCH></div></div></div><button type=submit class=\"rounded-md bg-blue-700 border-0 text-white p10 mt24 relative h-10\" layout layout-align=\"center center\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\" ng-disabled=ctrl.loading aria-label=Send><progress class=\"absolute float-left left-3\" theme=light ng-if=ctrl.loading></progress><span translate=LOGIN.BUTTON.SEND></span></button></form></div><div class=\"m24 access-actions\" layout layout-align=\"center center\"><a class=\"text-indigo-700 text-sm\" ui-sref=signin translate=LOGIN.BUTTON.BACK_LOGIN></a></div>");
$templateCache.put("app/access/signin/signin.html","<div class=\"bg-white rounded-md shadow-xl access-container\"><div><span class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGIN.TITLE.TO_ACCOUNT></span></div><form layout=column name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.login()\" novalidate><div class=\"w-full mt16\"><div class=\"text-sm font-bold leading-none text-gray-600 mt12 h-5\" translate=LOGIN.LABEL.USERNAME></div><input class=\"mt12 border-gray-300 rounded-md block w-full box-border h-10\" type=text name=text ng-model=ctrl.user.username autocomplete=off required></div><div class=\"w-full mt16 mb12\"><div class=\"text-sm font-bold leading-none text-gray-600 mt12 h-5\" translate=LOGIN.LABEL.PASSWORD></div><div class=relative><input class=\"mt12 border-gray-300 rounded-md block w-full box-border h-10\" type=\"{{ctrl.type ? \'text\' : \'password\'}}\" name=password ng-model=ctrl.user.password autocomplete=off required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.type = !ctrl.type\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.type ? \'visibility\' : \'visibility_off\'}}</i></a></div></div><div><div class=\"st-input-container no-padding\" layout=column flex><label class=st-label flex><input type=checkbox name=keep_connected ng-model=ctrl.user.keep_connected> <span translate=LOGIN.LABEL.KEEP_CONNECTED></span></label></div></div><button type=submit class=\"rounded-md bg-blue-700 border-0 text-white p10 mt24 relative h-10\" layout layout-align=\"center center\" ng-style=\"{\'background-color\': currentEnterprise.relationships.customization.attributes.color2}\" ng-disabled=ctrl.loading aria-label=Send><progress class=\"absolute float-left left-3\" theme=light ng-if=ctrl.loading></progress><span translate=LOGIN.BUTTON.LOGIN></span></button></form></div><div class=\"m24 access-actions\" layout layout-align=\"space-between center\"><a class=\"text-indigo-700 text-sm\" ui-sref=forgot translate=LOGIN.BUTTON.FORGOT_PASSWORD></a> <a class=\"text-indigo-700 text-sm\" ui-sref=code translate=LOGIN.BUTTON.BY_CODE></a></div>");
$templateCache.put("app/components/address-form/address-form.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=50 flex-gt-md=35 class=st-dialog aria-label=Address><!-- dialog header --><div layout layout-align=\"space-between center\" class=st-dialog-header><span class=md-title translate=ADDRESS_FORM.TITLE.HEADER></span></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentAddress)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=address-card layout=column layout-align=\"space-between stretch\" flex><div ng-if=ctrl.types layout layout-align=space-between><div class=\"st-radio-container st-input-container\" layout=column><div class=st-label translate=ADDRESS_FORM.LABEL.TYPE></div><div class=st-caption translate=ADDRESS_FORM.LABEL.TYPE_CAPTION></div><div class=\"mt8 pt8\" layout><label class=mr8 ng-repeat=\"type in ctrl.types\"><input type=radio ng-model=ctrl.currentAddress.attributes.type value={{type}}> <span translate=\"{{ \'ADDRESS_FORM.TYPES.\' + type.toUpperCase()}}\"></span></label></div></div></div><div class=st-input-container layout=column flex=40><label class=st-label translate=ADDRESS_FORM.LABEL.ZIP_CODE></label><div layout layout-align=\"start center\"><input class=\"st-input-type input-type\" name=zip_code ng-model=ctrl.currentAddress.attributes.zip_code type=text ng-model-options=\"{ debounce: 1200 }\" maxlength=9 ng-change=ctrl.getAddress() autocomplete=off><div ng-show=ctrl.loading class=pl4><progress></progress></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex=40><label class=st-label translate=ADDRESS_FORM.LABEL.STATE></label><input class=\"st-input-type input-type\" name=region ng-model=ctrl.currentAddress.attributes.region type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.$error\"><div class=st-input-validation ng-show=ctrl.form.region.$error.required translate=ADDRESS_FORM.VALIDATION.REGION></div></div></div><div class=st-input-container layout=column flex=60><label class=st-label translate=ADDRESS_FORM.LABEL.CITY></label><input class=\"st-input-type input-type\" name=city ng-model=ctrl.currentAddress.attributes.city type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.$error\"><div class=st-input-validation ng-show=ctrl.form.city.$error.required translate=ADDRESS_FORM.VALIDATION.CITY></div></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex=70><label class=st-label translate=ADDRESS_FORM.LABEL.STREET></label><input class=\"st-input-type input-type\" name=address ng-model=ctrl.currentAddress.attributes.street type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.$error\"><div class=st-input-validation ng-show=ctrl.form.address.$error.required translate=ADDRESS_FORM.VALIDATION.ADDRESS></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=ADDRESS_FORM.LABEL.NUMBER></label><input class=\"st-input-type input-type\" name=number ng-model=ctrl.currentAddress.attributes.street_number type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.$error\"><div class=st-input-validation ng-show=ctrl.form.number.$error.required translate=ADDRESS_FORM.VALIDATION.NUMBER></div></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex=50><label class=\"st-label st-optional\" translate=ADDRESS_FORM.LABEL.COMPLEMENT></label><input class=\"st-input-type input-type\" ng-model=ctrl.currentAddress.attributes.complement type=text autocomplete=off></div><div class=st-input-container layout=column flex=50><label class=st-label translate=ADDRESS_FORM.LABEL.COUNTRY></label><input class=\"st-input-type input-type\" name=country ng-model=ctrl.currentAddress.attributes.country type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.$error\"><div class=st-input-validation ng-show=ctrl.form.country.$error.required translate=ADDRESS_FORM.VALIDATION.COUNTRY></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=ADDRESS_FORM.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.currentAddress.attributes.description rows=4 maxlength=255></textarea></div></div><br><div class=st-dialog-footer layout layout-align=\"space-between center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=ADDRESS_FORM.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=\"{{\'ADDRESS_FORM.ACTION.\' + ctrl.action.toUpperCase()}}\"></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/components/advanced-filter/advanced-filter.dialog.html","<md-dialog flex-xs=95 flex-sm=75 flex-md=65 flex-gt-md=55 class=st-dialog aria-label=\"Advanced Filter Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=ADVANCED_FILTER.TITLE.HEADER></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><advanced-filter filter-output=ctrl.triggerSearch(filter) model=ctrl.model selected-filters=ctrl.selectedFilters></advanced-filter></md-dialog>");
$templateCache.put("app/components/advanced-search/advanced-search.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Advanced Search Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=ADVANCED_FILTER.TITLE.HEADER></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=\"st-dialog-wrapper p16\"><div class=st-dialog-body><form name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.triggerSearch()\" novalidate flex><md-autocomplete placeholder=\"{{\'TRACKING.PLACEHOLDER.SEARCH_PLACES\' | translate}}\" md-input-name=autocomplete_search_places md-selected-item=ctrl.selectedPlace md-search-text=ctrl.item md-items=\"item in ctrl.searchPlaces(ctrl.item)\" md-item-text=item.formatted_address md-min-length=3 md-delay=800 md-autofocus md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-clear-button=false md-selected-item-change=ctrl.presentLocation() required md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><span class=mr8><i class=\"material-symbols-outlined text-gray-400\">location_on</i></span><div class=results-info><span md-highlight-text=ctrl.item class=\"text-sm text-gray-700 font-normal\">{{item.formatted_address}}</span></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.place}}\' }\"></span></md-not-found></md-autocomplete><div class=mt24 layout layout-align=\"end center\"><button type=submit class=\"altnav-action save\" aria-label=Save ng-disabled=ctrl.emptySelection()><span translate=ADVANCED_FILTER.ACTION.SEARCH></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/components/change-password/change-password.dialog.html","<md-dialog flex-xs=90 flex-sm=60 flex-md=40 flex-lg=35 flex-xl=25 class=\"st-dialog mini\" aria-label=\"Change password\"><!-- dialog header --><div class=st-dialog-header><p class=\"text-xl font-bold\" translate=CHANGE_PASSWORD_DIALOG.TITLE.NEW_PASSWORD></p><p class=\"pt4 text-base truncate\">{{ ctrl.user.attributes.name }}</p></div><div class=\"st-dialog-wrapper pl16 pr16\"><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(false)\" layout=column layout-align=\"space-between stretch\" novalidate><div ng-if=ctrl.showForm class=pb24><md-radio-group ng-model=ctrl.type class=\"md-blue md-sm md-top\" aria-labelledby=typePassword><md-radio-button value=automatically class=\"mt8 pb8\"><div layout=column><p class=\"text-gray-900 text-sm\" translate=CHANGE_PASSWORD_DIALOG.LABEL.AUTOMATICALLY></p><p class=\"text-gray-500 text-xs\" translate=CHANGE_PASSWORD_DIALOG.LABEL.NEXT_STEP></p></div></md-radio-button><md-radio-button value=create class=mt8><p class=\"text-gray-900 text-sm\" translate=CHANGE_PASSWORD_DIALOG.LABEL.CREATE></p></md-radio-button></md-radio-group><div ng-show=\"ctrl.type === \'create\'\" class=\"st-input-container no-padding w-80\"><div layout=column class=\"pt16 pl24 pr16 mr16 relative\"><password-meter ng-model=ctrl.newPassword></password-meter><label class=st-label translate=CHANGE_PASSWORD_DIALOG.LABEL.NEW_PASSWORD></label><input class=\"st-input-type input-type\" name=password type=text ng-model=ctrl.newPassword translate-attr=\"{ placeholder: \'CHANGE_PASSWORD_DIALOG.PLACEHOLDER.TYPE_NEW_PASSWORD\' }\" minlength=8 autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.password.$invalid\"><div class=st-input-validation ng-message=required translate=CHANGE_PASSWORD_DIALOG.VALIDATION.MIN_LENGTH></div></div></div><!-- <md-checkbox ng-model=\"ctrl.oneTimePassword\" aria-label=\"One time password\" class=\"md-blue md-sm ml24 mt4\">\n            <span class=\"whitespace-nowrap text-xs text-gray-600\" translate=\"CHANGE_PASSWORD_DIALOG.LABEL.OTP\"></span>\n          </md-checkbox> --></div></div><div ng-if=!ctrl.showForm class=\"st-input-container no-padding w-80\"><div layout=column class=\"pt16 pb16\"><label class=st-label translate=CHANGE_PASSWORD_DIALOG.LABEL.NEW_PASSWORD></label><div layout layout-align=\"start center\"><input id=new_password class=\"st-input-type input-type\" name=new_password type=text ng-model=ctrl.newPassword readonly> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#new_password\' }}\"><i class=\"text-xl material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div class=\"st-dialog-footer no-padding\"><div layout layout-align=\"space-between center\" class=\"pt8 pb8\"><div><button ng-show=ctrl.showForm type=button class=\"altnav-action mr8 cancel\" aria-label=Cancel ng-click=ctrl.finish()><span translate=CHANGE_PASSWORD_DIALOG.ACTIONS.CANCEL></span></button></div><button ng-if=\"ctrl.type === \'automatically\' && ctrl.showForm\" type=button class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Generate ng-click=ctrl.save()><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=CHANGE_PASSWORD_DIALOG.ACTIONS.GENERATE></span></button> <button ng-if=\"ctrl.type !== \'automatically\' && ctrl.showForm\" type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=CHANGE_PASSWORD_DIALOG.ACTIONS.SAVE></span></button> <button ng-if=\"ctrl.type === \'automatically\' && !ctrl.showForm\" type=button class=\"altnav-action save\" aria-label=Close ng-click=ctrl.finish()><span translate=CHANGE_PASSWORD_DIALOG.ACTIONS.CLOSE></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/components/custom-filters/custom-filters.dialog.html","<md-dialog flex-xs=95 flex-sm=95 flex-md=90 flex-lg=75 flex-xl=50 class=\"st-dialog dialog-template custom-filter-dialog\"><div class=\"h-full overflow-y-auto pr16\"><div layout layout-align=\"space-between center\" class=st-dialog-header><p class=md-title translate=CUSTOM_FILTERS.TITLE.HEADER></p><button type=button class=\"altnav-action no-padding\" ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form layout=column layout-align=\"space-between stretch\" novalidate><div layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=start><div class=st-input-container layout=column flex=50><label for=name class=\"st-label st-required\" translate=CUSTOM_FILTERS.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.name type=text maxlength=50 required autocomplete=off><div ng-if=ctrl.form.$submitted><span class=st-input-validation ng-show=ctrl.form.name.$error.required translate=CUSTOM_FILTERS.VALIDATION.REQUIRED></span></div></div></div><div layout layout-align=start><div class=\"st-input-container m4\" flex=50><label for=name class=\"st-label st-required\" translate=CUSTOM_FILTERS.LABEL.MODULE></label><md-select class=st-input-select ng-model=ctrl.selectedPage aria-label=Page ng-change=ctrl.selectPage() ng-disabled=ctrl.selectDisabled required md-no-asterisk><md-option ng-repeat=\"p in ctrl.pages\" ng-value=p><span translate=\"{{\'CUSTOM_FILTERS.ENUM.PAGES.\' + p.toUpperCase()}}\"></span></md-option></md-select></div></div></div></form><advanced-filter btn-text=SAVE filter-output=ctrl.save(filter) model=ctrl.model ng-if=ctrl.model relative-date=true selected-filters=ctrl.selectedFilters></advanced-filter><div ng-if=!ctrl.model class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button disabled class=\"altnav-action add mr8\"><span translate=TEMPLATE_FORM.ACTION.SAVE></span></button></div></div></div></md-dialog>");
$templateCache.put("app/components/disconnected-devices/disconnected-devices.dialog.html","<md-dialog flex-xs=95 flex-sm=85 flex-md=80 flex-gt-md=70 class=st-dialog aria-label=\"Disconnet vehicles\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><div><div layout><span class=\"text-lg font-bold leading-tight text-gray-700\" translate=DISCONNECTED.TITLE.HEADER></span> <span class=ml12><progress ng-if=ctrl.loading></progress></span></div><div class=\"text-sm font-medium leading-tight text-gray-500 truncate\" translate=DISCONNECTED.LABEL.REASON></div></div></div><div layout layout-align=\"start center\"><md-menu can-access=INTERNALS,MANAGER md-position-mode=\"target-right target\" md-offset=\"0 46\"><button type=button class=\"no-button altnav-action\" ng-click=$mdMenu.open($event) ng-disabled=ctrl.loading><i class=material-symbols-outlined>download</i></button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button aria-label=\"Export CSV\" ng-click=\"ctrl.export(\'csv\')\"><span class=st-subhead translate=DISCONNECTED.LABEL.CSV></span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Export XLSX\" ng-click=\"ctrl.export(\'xlsx\')\"><span class=st-subhead translate=DISCONNECTED.LABEL.XLSX></span></md-button></md-menu-item></md-menu-content></md-menu><button type=button class=\"no-button altnav-action\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></button></div></div></div><div class=\"st-dialog-wrapper communitation-partner\"><div class=\"st-dialog-body no-padding\" layout=column layout-align=\"space-between stretch\"><div class=st-dialog-filter layout layout-align=\"start center\"><div class=\"st-input-container no-padding\" layout=column flex=15><md-select class=st-input-select name=baterry_level ng-model=ctrl.selectedBatteryLevel aria-label=\"Select baterry level\" md-no-asterisk md-on-close=ctrl.selectBatteryLevel() ng-disabled=ctrl.loading><md-option ng-repeat=\"(key, value) in ctrl.batteryScale\" ng-value=key>{{\'DISCONNECTED.ENUM.LEVELS.\' + key.toUpperCase() | translate}}</md-option></md-select></div><div class=\"st-input-container no-padding mr12 ml12\" layout=column flex=30><md-select class=st-input-select name=\"select type\" ng-model=ctrl.selectedType aria-label=\"Select Type\" multiple md-no-asterisk md-on-close=ctrl.selectType() ng-disabled=ctrl.loading><md-option ng-repeat=\"t in ctrl.vehicleTypes\" ng-value=t>{{\'DISCONNECTED.ENUM.VEHICLE_TYPE.\' + t.toUpperCase() | translate}}</md-option></md-select></div></div><md-table-container><table class=st-main-table md-table><thead class=st-table-head md-head md-order=ctrl.order md-on-reorder=ctrl.reorder><tr md-row><th md-column md-order-by=vehicle.plate><span translate=DISCONNECTED.LABEL.PLATE></span></th><th md-column><span translate=DISCONNECTED.LABEL.USERS></span></th><th md-column><span translate=DISCONNECTED.LABEL.DEVICE_TYPE></span></th><th md-column md-order-by=last_gps.last_gps_time><span translate=DISCONNECTED.LABEL.LAST_GPS></span></th><th md-column md-order-by=last_gps.last_connection_time><span translate=DISCONNECTED.LABEL.LAST_CONNECTION_TIME></span></th><th md-column><span translate=DISCONNECTED.LABEL.POWER_VOLTAGE></span></th><th md-column md-order-by=last_gps.last_battery_level><span translate=DISCONNECTED.LABEL.BATTERY_LEVEL></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><div><div><span>{{::item.relationships.vehicle.attributes.plate}}</span> <span class=\"st-tag ml8 truncate\" translate=\"{{\'DISCONNECTED.ENUM.VEHICLE_TYPE.\' + item.relationships.vehicle.attributes.type_name.toUpperCase()}}\"></span></div><div class=st-caption>{{::item.relationships.vehicle.attributes.vin}}</div></div></td><td md-cell><div><user-list users=item.relationships.users_assets recordable=true initials=true horizontal=true clickable=false size=sm></user-list></div></td><td md-cell><div><div>{{item.attributes.imei}}</div><div class=st-caption>{{::item.relationships.type.attributes.brand_alias}} {{item.relationships.type.attributes.alias}}</div></div></td><td md-cell>{{::item.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell>{{::item.relationships.last_gps.attributes.last_connection_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell><span data-metrics=voltage>{{::item.relationships.last_gps.attributes.last_power_voltage}}</span></td><td md-cell><span data-metrics=percentage>{{::item.relationships.last_gps.attributes.last_battery_level | number: \'1\'}}</span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=DISCONNECTED.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.getDisconnections md-boundary-links md-label=\"{page: \'{{\'DISCONNECTED.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DISCONNECTED.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DISCONNECTED.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div></md-dialog>");
$templateCache.put("app/components/export-list/export.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=50 class=st-dialog aria-label=\"Export Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=EXPORT_DIALOG.TITLE.HEADER></span> <span class=ml12 ng-if=ctrl.loading><progress></progress></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=\"st-dialog-wrapper p16\"><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.chosen.length && ctrl.export()\" novalidate flex><div layout layout-align=\"space-between center\"><div><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=EXPORT_DIALOG.LABEL.DATA></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=EXPORT_DIALOG.LABEL.REPORT></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=role_type ng-model=ctrl.type aria-label=\"Select Type\" md-no-asterisk required><md-option ng-repeat=\"t in [\'CSV\', \'XLSX\']\" value={{t}} translate=\"{{\'EXPORT_DIALOG.ENUM.FORMAT_TYPE.\' + t.toUpperCase()}}\"></md-option></md-select></div></div><div class=mt24><div class=\"border border-solid rounded-md border-gray-300\" layout=column layout-align=\"space-between stretch\"><div layout><div flex=40 class=\"pt12 pb12 pl8 pr8 h-12 border-0 border-r border-b border-solid border-gray-300\"><label class=st-nav-label layout><input ng-model=ctrl.pickAll name=pickAll type=checkbox ng-change=ctrl.toggleAllSelections()> <span class=\"text-sm font-bold leading-tight text-gray-700 truncate\" translate=EXPORT_DIALOG.TITLE.LIST_DATA translate-attr=\"{ title: \'EXPORT_DIALOG.TITLE.LIST_DATA\' }\"></span></label></div><div flex=60 class=\"p12 h-12 border-0 border-b border-solid border-gray-300\"><span class=\"text-sm font-bold leading-tight text-gray-500 truncate block\" translate=EXPORT_DIALOG.TITLE.DATA_DEFINITION translate-attr=\"{ title: \'EXPORT_DIALOG.TITLE.DATA_DEFINITION\'}\"></span></div></div><div layout layout-align=\"space-between start\"><div flex=40 class=\"border-0 border-r border-solid border-gray-300\"><div class=export-dialog-wrapper-list><div class=h-8 ng-repeat=\"item in ctrl.exportables\"><label class=\"p8 box-border w-full\" layout><input ng-model=item.checked ng-value=checked name=check-{{$index}} type=checkbox ng-change=ctrl.toggleSelection(item)> <span class=\"text-sm font-bold leading-tight text-gray-700 truncate\" translate=\"{{\'FILTER_LIST.BUTTON.\' + item.a.toUpperCase()}}\" translate-attr=\"{ title: \'FILTER_LIST.BUTTON.\' + item.a.toUpperCase() }\"></span></label></div></div></div><div flex=60 sv-root><div sv-part=ctrl.chosen class=\"export-dialog-wrapper-list float-left w-full\"><div sv-placeholder class=\"h-6 bg-gray-100 rounded-md m12 p8\"></div><div ng-repeat=\"item in ctrl.chosen\" sv-element class=\"m12 p8 rounded-md bg-gray-100 cursor-grab select-none export-dialog-item\"><span class=\"text-sm font-bold leading-tight text-gray-500 mr8\">{{$index + 1}}</span> <span class=\"text-sm font-normal leading-tight text-gray-500\" translate=\"{{\'FILTER_LIST.BUTTON.\' + item.a.toUpperCase()}}\"></span></div><div ng-if=\"ctrl.chosen.length === 0\" class=p24><div class=\"border-2 border-dashed border-gray-200 rounded-md p24\"><div class=\"text-base font-bold leading-tight text-gray-500\" translate=EXPORT_DIALOG.HINT.NO_DATA></div><div class=\"text-sm leading-tight text-gray-500\" translate=EXPORT_DIALOG.HINT.CHOOSE_DATA></div></div></div></div></div></div></div></div><div class=mt24 layout layout-align=\"end center\"><button type=submit class=\"altnav-action save\" aria-label=Export><span translate=EXPORT_DIALOG.ACTION.GENERATE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/gallery/gallery.dialog.html","<md-dialog flex-xs=90 flex-sm=90 flex-md=80 flex-gt-md=70 aria-label=Gallery class=\"gallery-modal bg-black\" ng-keydown=ctrl.keyboardEvent($event)><div layout layout-align=\"space-between center\" class=\"bg-white p12\"><p class=\"text-gray-500 text-base truncate\" ng-if=!ctrl.title translate=GALLERY.TITLE.HEADER></p><p class=\"text-gray-500 text-base truncate\" ng-if=ctrl.title>{{ctrl.title}}</p><button type=button class=\"no-button text-gray-500\" aria-label=Cancel ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></button></div><div class=p24><div class=\"carousel__container relative overflow-hidden w-full h-full\" layout layout-align=\"center center\"><a ng-if=!ctrl.loading class=\"text-white absolute top-0 right-0 z-10\" href={{ctrl.currentLink}} target=_blank download={{ctrl.currentAlt}}><i class=\"material-symbols-outlined text-2xl text-white\" layout layout-align=\"center center\">download</i></a><div ng-if=!ctrl.loading class=\"carousel__slides display-flex w-full\" ng-style=\"{\'transform\': \'translateX(\' + (-ctrl.currentIndex * 100) + \'%)\'}\"><div class=\"carousel__slide display-flex items-center justify-center min-w-full h-full relative box-border\" ng-repeat=\"image in ctrl.images\"><img ng-src={{image.src}} alt={{image.alt}} class=\"max-h-full max-w-full\"></div></div><div ng-if=ctrl.loading class=\"carousel__loading w-full h-full\"><div class=\"w-full h-full display-flex justify-center items-center\"><progress theme=light></progress></div></div><div ng-if=!ctrl.loading class=\"carousel__controls absolute w-full display-flex justify-between\"><button class=\"carousel__control border-0 cursor-pointer p8 border-none\" ng-class=\"{\'opacity-25\': ctrl.currentIndex === 0 }\" ng-click=ctrl.prevSlide() ng-disabled=\"ctrl.currentIndex === 0\"><i class=\"material-symbols-outlined text-2xl text-white\">arrow_back_ios</i></button> <button class=\"carousel__control border-0 cursor-pointer p8 border-none\" ng-class=\"{\'opacity-25\': ctrl.currentIndex === ctrl.images.length - 1 }\" ng-click=ctrl.nextSlide() ng-disabled=\"ctrl.currentIndex === ctrl.images.length - 1\"><i class=\"material-symbols-outlined text-2xl text-white\">arrow_forward_ios</i></button></div><div ng-if=\"ctrl.total > 0 && !ctrl.loading\" class=\"carousel__count absolute bottom-0 right-0\"><p class=\"text-white text-sm\">{{ctrl.currentIndex + 1}}/{{ctrl.total}}</p></div></div></div><div class=\"p12 bg-white\"><button type=button class=\"select-none altnav-action no-back float-right mr8\" translate=GALLERY.ACTION.CLOSE ng-click=ctrl.close()></button></div></md-dialog>");
$templateCache.put("app/components/generate-file/generate.dialog.html","<md-dialog flex-xs=90 flex-sm=65 flex-md=40 flex-lg=30 flex-xl=20 class=st-dialog aria-label=\"Generate Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=GENERATE_DIALOG.TITLE.HEADER></span> <span class=ml12 ng-if=ctrl.loading><progress></progress></span></div></div><div class=pt4><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=GENERATE_DIALOG.LABEL.REPORT></p></div></div><div class=\"st-dialog-wrapper pl16 pr16 pb16\"><form class=st-dialog-body name=ctrl.form ng-submit=ctrl.generate() novalidate flex><div><div class=\"border border-solid rounded-md border-gray-300\" layout=column layout-align=\"space-between stretch\"><div layout=column layout-align=\"space-between start\" class=\"pt12 pb12 pl8 pr8 border-0 border-b border-solid border-gray-300\"><label class=cursor-pointer layout><input ng-model=ctrl.pickAll name=pickAll type=checkbox ng-change=ctrl.toggleAllSelections() ng-disabled=ctrl.loading> <span class=\"text-sm text-gray-600 pl4\" translate=GENERATE_DIALOG.TITLE.LIST_DATA></span></label></div><div layout=column layout-align=\"space-between start\"><div ng-repeat=\"item in ctrl.sectionsDesired\"><label class=p8 ng-class=\"{\'cursor-pointer\': item.name !== \'default\'}\" layout><input ng-model=item.checked ng-value=item.checked name=check-{{$index}} ng-click=ctrl.checkToggleSelections() ng-disabled=\"item.name === \'default\' || ctrl.loading\" type=checkbox> <span class=\"text-sm text-gray-600 pl4\" translate=\"{{\'GENERATE_DIALOG.ENUM.SECTIONS_DESIRED.\' + item.name.toUpperCase()}}\"></span></label></div></div></div></div><div class=mt16 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.close() ng-disabled=ctrl.loading><span translate=GENERATE_DIALOG.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Generate ng-disabled=ctrl.loading><span translate=GENERATE_DIALOG.ACTION.GENERATE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/integrations/integrations.dialog.html","<md-dialog flex-xs=95 flex-sm=95 flex-md=90 flex-lg=75 flex-xl=50 class=\"st-dialog dialog-template custom-filter-dialog\"><div class=\"h-full overflow-y-auto pr16\"><div layout layout-align=\"space-between center\" class=st-dialog-header><p class=md-title translate=INTEGRATIONS.TITLE.HEADER></p><button type=button class=\"altnav-action no-padding\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></button></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form novalidate flex><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.SOURCE></label><md-select class=st-input-select name=source ng-disabled=ctrl.editing ng-model=ctrl.data.source md-on-close=ctrl.changeSource() aria-label=\"Select value\" ng-change=ctrl.forceClose() md-no-asterisk required><md-option ng-repeat=\"i in ctrl.source\" ng-value=i ng-disabled=ctrl.checkSourceUsed(i)>{{\'INTEGRATIONS.ENUM.OPTIONS.NAMES.\' + i.toUpperCase() | translate}}</md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.source.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.INTEGRATED_ENTITIES></label><md-select class=st-input-select ng-disabled=!ctrl.data.source name=integrated_entities ng-model=ctrl.data.integrated_entities aria-label=\"Select value\" multiple md-no-asterisk required><md-option ng-repeat=\"e in ctrl.entities\" ng-value=e>{{\'INTEGRATIONS.ENUM.OPTIONS.INTEGRATIONS_ENTITIES.\' + e.toUpperCase() | translate}}</md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.integrated_entities.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div></div><div ng-if=\"ctrl.data.source && ctrl.data.source !== \'siprov\'\" layout layout-align=\"space-between start\" class=flex-wrap><p class=\"text-gray-700 text-base border-0 border-b border-solid border-gray-300 ml-4 mr-4 mb-2 pt-2 pb-0.5\" flex=100 translate=INTEGRATIONS.TITLE.AUTH></p><div ng-if=\"ctrl.data.source !== \'siprov\'\" class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.API_KEY></label><textarea class=\"st-input-type input-textarea\" name=api_key ng-model=ctrl.data.auth.api_key rows=4 ng-required=!ctrl.editing ng-readonly=ctrl.editing></textarea><div ng-if=\"ctrl.form.$submitted && ctrl.form.api_key.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div><div class=st-input-container layout=column flex=50><div ng-if=\"ctrl.data.source === \'hinova-sgr\'\" class=pb-3><div class=\"st-input-container no-padding\" layout=column><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.USERNAME></label><input class=\"st-input-type input-type\" name=username ng-model=ctrl.data.auth.username ng-readonly=ctrl.editing ng-required=!ctrl.editing type=text autocomplete=off><div ng-if=\"ctrl.form.$submitted && ctrl.form.username.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div></div><div ng-if=\"ctrl.data.source === \'hinova-sgr\'\" class=pb-3><div class=\"st-input-container no-padding\" layout=column><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.PASSWORD></label><input class=\"st-input-type input-type\" ng-class=\"{ \'with-visibility\': !ctrl.editing }\" name=password ng-model=ctrl.data.auth.password ng-readonly=ctrl.editing ng-required=!ctrl.editing type=\"{{ctrl.type ? \'text\' : \'password\'}}\" autocomplete=off> <button type=button class=\"no-button absolute right-0 top-7\" ng-click=\"ctrl.type = !ctrl.type\" ng-if=!ctrl.editing><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.type ? \'visibility\' : \'visibility_off\'}}</i></button><div ng-if=\"ctrl.form.$submitted && ctrl.form.password.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div></div><div ng-if=\"ctrl.data.source === \'mutual\'\" class=pb-3><div class=\"st-input-container no-padding\" layout=column><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.API_URL></label><input class=\"st-input-type input-type\" name=api_url ng-blur=ctrl.validateUrl(ctrl.data.auth.api_url) ng-model=ctrl.data.auth.api_url ng-readonly=ctrl.editing ng-required=!ctrl.editing type=text autocomplete=off translate-attr=\"{ placeholder: \'INTEGRATIONS.PLACEHOLDER.URL\' }\"><div ng-if=\"ctrl.form.$submitted && ctrl.form.api_url.$invalid\"><div class=st-input-validation ng-show=ctrl.form.api_url.$error.required translate=INTEGRATIONS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.api_url.$error.invalid translate=INTEGRATIONS.VALIDATION.INVALID></div></div></div></div><div ng-if=\"ctrl.data.source === \'hinova-sgr\'\" class=pb-3><div class=\"st-input-container no-padding\" layout=column><label class=\"st-label st-required\" translate=INTEGRATIONS.LABEL.MOBILE_CODE></label><input class=\"st-input-type input-type\" name=mobile_code ng-model=ctrl.data.auth.mobile_code ng-pattern=/^\\d*$/ type=text autocomplete=off ng-required=!ctrl.editing ng-readonly=ctrl.editing><div ng-if=\"ctrl.form.$submitted && ctrl.form.mobile_code.$invalid\"><div class=st-input-validation ng-if=ctrl.form.mobile_code.$error.required ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-if=ctrl.form.mobile_code.$error.pattern ng-message=pattern translate=INTEGRATIONS.VALIDATION.NUM></div></div></div></div></div></div><div ng-if=\"ctrl.data.source && ctrl.data.source !== \'siprov\'\" layout layout-align=\"start start\" class=flex-wrap><p class=\"text-gray-700 text-base border-0 border-b border-solid border-gray-300 ml-4 mr-4 mb-2 pt-2 pb-0.5\" flex=100 translate=INTEGRATIONS.TITLE.CONFIG></p><div ng-if=\"ctrl.data.source === \'hinova-sgr\'\" class=st-input-container layout=column flex=50><md-checkbox aria-label=\"Vehicle disassociation\" class=md-blue ng-model=ctrl.data.config.deactivate_vehicle_after_disassociation><span class=\"text-sm text-gray-800\" translate=INTEGRATIONS.LABEL.DEACTIVATE_VEHICLE_AFTER_DISASSOCIATION></span></md-checkbox></div><div ng-if=\"ctrl.data.source === \'mutual\'\" class=st-input-container layout=column flex=50><md-checkbox aria-label=\"Prevent user activation\" class=md-blue ng-model=ctrl.data.config.prevent_user_activation_with_open_protocol><span class=\"text-sm text-gray-800\" translate=INTEGRATIONS.LABEL.PREVENT_USER_ACTIVATION_WITH_OPEN_PROTOCOL></span></md-checkbox></div><div layout flex=100><div ng-if=\"ctrl.data.source === \'hinova-sga\' || ctrl.data.source === \'mutual\'\" class=st-input-container layout=column flex=50><label class=\"st-label st-required pb-1\" translate=INTEGRATIONS.LABEL.USER_ACTIVE_SITUATION></label><div class=\"border-2 rounded border-solid\" ng-class=\"{\n                \'border-gray-300\': (!ctrl.form.$submitted && ctrl.form.user_active_situation.$invalid) || ctrl.form.user_active_situation.$valid,\n                \'border-red-400\': ctrl.form.$submitted && ctrl.form.user_active_situation.$invalid\n              }\"><md-chips input-aria-label=\"User active situation\" md-add-on-blur=true md-on-add=\"ctrl.upperCase(\'user_active_situation\', $chip, $index)\" name=user_active_situation ng-model=ctrl.data.config.user_active_situation ng-required=true placeholder=\"{{\'INTEGRATIONS.PLACEHOLDER.SITUATION\' | translate}}\" secondary-placeholder=\"{{\'INTEGRATIONS.PLACEHOLDER.SITUATION_PLUS\' | translate}}\"></md-chips></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.user_active_situation.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div><div ng-if=\"ctrl.data.source === \'hinova-sga\' || ctrl.data.source === \'mutual\'\" class=st-input-container layout=column flex=50><label class=\"st-label st-required pb-1\" translate=INTEGRATIONS.LABEL.VEHICLE_ACTIVE_SITUATION></label><div class=\"border-2 rounded border-solid\" ng-class=\"{\n                \'border-gray-300\': (!ctrl.form.$submitted && ctrl.form.vehicle_active_situation.$invalid) || ctrl.form.vehicle_active_situation.$valid,\n                \'border-red-400\': ctrl.form.$submitted && ctrl.form.vehicle_active_situation.$invalid\n              }\"><md-chips input-aria-label=\"Vehicle active situation\" md-add-on-blur=true md-on-add=\"ctrl.upperCase(\'vehicle_active_situation\', $chip, $index)\" name=vehicle_active_situation ng-model=ctrl.data.config.vehicle_active_situation ng-required=true placeholder=\"{{\'INTEGRATIONS.PLACEHOLDER.SITUATION\' | translate}}\" secondary-placeholder=\"{{\'INTEGRATIONS.PLACEHOLDER.SITUATION_PLUS\' | translate}}\"></md-chips></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.vehicle_active_situation.$invalid\"><div class=st-input-validation ng-message=required translate=INTEGRATIONS.VALIDATION.REQUIRED></div></div></div></div></div></form><div ng-if=\"ctrl.editing && ctrl.data.source === \'siprov\'\"><p class=\"text-gray-700 text-base border-0 border-b border-solid border-gray-300 ml-4 mr-4 mb-2 pt-2 pb-0.5\" flex=100>Gerenciamento</p><div class=st-input-container layout layout-align=\"start center\" flex=100><button type=button class=\"altnav-action save\" aria-label=\"Generate token\" ng-click=ctrl.generateToken() ng-disabled=ctrl.code><span translate=INTEGRATIONS.ACTION.GENERATE></span></button><div ng-if=ctrl.code flex=50 class=pl-1 layout><input id=code class=\"st-input-type input-type w-full\" name=code ng-model=ctrl.code type=text readonly> <button class=\"copy-btn ml8 no-button\" ngclipboard data-clipboard-target=#code><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></button></div></div></div><div class=\"px-3 pt-5 pb-3\" layout layout-align=\"space-between center\" flex><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.close()><span translate=INTEGRATIONS.ACTION.CANCEL></span></button><div layout layout-align=\"end center\"><div ng-if=ctrl.loading class=mr-2><progress></progress></div><div class=mr-2 ng-if=ctrl.successIcon><i class=\"material-symbols-outlined text-green-600\">check</i></div><div class=mr-2 ng-if=\"!ctrl.loading && ctrl.type && !ctrl.successIcon\"><md-tooltip md-direction=top md-z-index=999 md-visible=ctrl.tooltipVisible ng-mouseenter=\"ctrl.tooltipVisible = false\"><span translate>{{ \'INTEGRATIONS.TOOLTIP.\' + ctrl.type.toUpperCase() }}</span></md-tooltip><i class=\"material-symbols-outlined text-yellow-500\">warning</i></div><button type=button class=\"altnav-action save mr-3\" aria-label=\"Test integration\" ng-if=\"ctrl.data.source === \'hinova-sgr\'\" ng-disabled=ctrl.loading ng-click=\"ctrl.testIntegration(\'test\')\"><span translate=INTEGRATIONS.ACTION.TEST></span></button> <button type=button class=\"altnav-action save mr-3\" aria-label=\"Generate integration\" ng-if=\"ctrl.data.source === \'hinova-sgr\'\" ng-disabled=ctrl.loading ng-click=\"ctrl.configureIntegration(\'generate\')\"><span translate=INTEGRATIONS.ACTION.CONFIGURE></span></button> <button type=button class=\"altnav-action save\" aria-label=Save ng-click=ctrl.submitForm()><span translate=INTEGRATIONS.ACTION.SAVE></span></button></div></div></div></div></md-dialog>");
$templateCache.put("app/components/new-item/add-device.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"New item\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=NEW_ITEM.TITLE.ASSOCIATE></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.finish()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><div class=\"pl16 pr16\"><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=NEW_ITEM.LABEL.NEW_DEVICE></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=NEW_ITEM.LABEL.NEW_SUB></div></div><form class=\"st-form-inputs p2 mt4\" name=ctrl.form novalidate ng-submit=\"ctrl.form.$valid && ctrl.close(ctrl.selectedDevice)\"><div class=\"st-input-container no-padding\" layout=column flex><div class=p16><devices-autocomplete auto-focus=true filters=ctrl.devicesOptions.filters form=ctrl.form hide-label=true search-text=ctrl.device selected-item=ctrl.selectedDevice></devices-autocomplete></div></div><div class=\"st-form-inputs p12\" layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.finish()><span translate=NEW_ITEM.ACTION.CANCEL></span></button> <button class=\"altnav-action save\" aria-label=Add><span translate=NEW_ITEM.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/components/new-item/add-task_item.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=45 flex-gt-md=40 class=st-dialog aria-label=\"New item\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=NEW_ITEM.TITLE.TASK_GROUP></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><div class=\"pl16 pr16\"><p class=\"text-sm leading-tight text-gray-800 truncate\" no-data-holder translate=NEW_ITEM.LABEL.SEARCH></p></div><br><form><!-- items --><div class=\"st-input-container no-padding\" layout=column flex><div class=\"pl12 pr12\"><label class=\"st-label st-required\" translate=NEW_ITEM.LABEL.SEARCH_TASK></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'NEW_ITEM.PLACEHOLDER.SEARCH_TASK\' | translate}}\" md-input-name=autocomplete_item md-selected-item=ctrl.selectedItem md-search-text=ctrl.itemType md-items=\"item in ctrl.getTaskItems(ctrl.itemType)\" md-item-text=item.attributes.name md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match required md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><div class=results-info layout=column layout-align=\"space-between stretch\"><span layout layout-align=\"start center\"><span md-highlight-text=ctrl.itemType class=st-subhead>{{item.attributes.name}}</span> <span class=\"st-caption ml8\">{{item.attributes.phone1 | phoneFilter}}</span> </span><span><span class=st-caption>{{item.attributes.email}}</span></span></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.itemType}}\' }\"></span></md-not-found></md-autocomplete></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_item.$invalid\"><div class=st-input-validation ng-message=required translate=FORM_PARTS.VALIDATION.ITEM></div></div></div><br><div class=\"st-form-inputs p12\" layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.finish()><span translate=NEW_ITEM.ACTION.CANCEL></span></button> <button type=button class=\"altnav-action save\" aria-label=Add ng-click=ctrl.close(ctrl.selectedItem) ng-disabled=!ctrl.selectedItem><span translate=NEW_ITEM.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/components/new-item/add-user.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=45 flex-gt-md=35 class=st-dialog aria-label=\"New item\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=NEW_ITEM.TITLE.ASSOCIATE></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><div class=\"pl16 pr16\"><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=NEW_ITEM.LABEL.NEW_USER></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=NEW_ITEM.LABEL.NEW_SUB></div></div><form class=\"st-form-inputs p2 mt4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.close(ctrl.selectedUser)\" novalidate><!-- users --><div class=\"st-input-container no-padding\" layout=column flex><div class=p16><users-autocomplete auto-focus=true filters=ctrl.usersOptions.filters form=ctrl.form hide-label=true includes=ctrl.usersOptions.includes search-text=ctrl.user selected-item=ctrl.selectedUser></users-autocomplete></div></div><div class=\"st-form-inputs pt12 pb12 pl16 pr16\" layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.finish()><span translate=NEW_ITEM.ACTION.CANCEL></span></button> <button class=\"altnav-action save\" aria-label=Add><span translate=NEW_ITEM.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/components/new-item/add-vehicle.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"New item\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=NEW_ITEM.TITLE.ASSOCIATE></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><div class=\"pl16 pr16\"><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=NEW_ITEM.LABEL.NEW_VEHICLE></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=NEW_ITEM.LABEL.NEW_SUB></div></div><form class=\"st-form-inputs p2 mt4\" name=ctrl.form novalidate ng-submit=\"ctrl.form.$valid && ctrl.close(ctrl.selectedVehicles)\"><div class=\"st-input-container no-padding\" layout=column flex><div class=p16><vehicles-autocomplete attributes=ctrl.vehiclesOptions.attributes auto-focus=true form=ctrl.form hide-label=true search-text=ctrl.vehicle selected-item=ctrl.selectedVehicles></vehicles-autocomplete></div><div class=\"st-form-inputs pr12\" layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.finish()><span translate=NEW_ITEM.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Add><span translate=NEW_ITEM.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/public-keys/public-keys.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=45 flex-gt-md=35 class=st-dialog aria-label=Address><!-- dialog header --><div layout layout-align=\"space-between center\" class=st-dialog-header><span class=md-title translate=PUBLIC_KEYS.TITLE.HEADER></span></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentPublicKey)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=address-card layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=PUBLIC_KEYS.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.currentPublicKey.attributes.name type=text translate-attr=\"{ placeholder: \'PUBLIC_KEYS.PLACEHOLDER.TYPE_NAME\' }\" autocomplete=off required></div></div><br><div class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=PUBLIC_KEYS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=PUBLIC_KEYS.ACTION.SAVE></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/components/report-points/report-points.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Report Points\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=REPORT_POINTS.TITLE.HEADER></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close() data-test=report_points.action.close_modal><i class=material-symbols-outlined>close</i></a></div></div></div><br><div class=\"st-dialog-wrapper p8\"><div class=st-dialog-body><div class=m8><div layout layout-align=\"space-between center\" class=mb16><div flex=30><div class=st-caption translate=REPORT_POINTS.LABEL.PLATE></div><div class=st-subhead>{{ctrl.meta.vehicle.attributes.plate || \'-\'}}</div></div><div flex=50 class=\"ml8 mr8\"><div class=st-caption translate=REPORT_POINTS.LABEL.VIN></div><div class=st-subhead>{{ctrl.meta.vehicle.attributes.vin || \'-\'}}</div></div><div flex><div class=st-caption translate=REPORT_POINTS.LABEL.TYPE></div><span class=st-subhead translate=\"{{\'REPORT_POINTS.ENUM.VEHICLE_TYPE.\' + (ctrl.meta.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span></div></div><div layout layout-align=\"space-between center\"><div flex=30><div class=st-caption translate=REPORT_POINTS.LABEL.IDENTIFIER></div><div class=st-subhead>{{ctrl.meta.device.attributes.name || \'-\'}}</div></div><div flex=50 class=\"ml8 mr8\"><div class=st-caption translate=REPORT_POINTS.LABEL.IMEI></div><div class=st-subhead>{{ctrl.meta.device.attributes.imei || \'-\'}}</div></div><div flex><div class=st-caption translate=REPORT_POINTS.LABEL.CODE></div><div class=st-subhead>{{ctrl.meta.device.attributes.code || \'-\'}}</div></div></div></div><form name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentAddress)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=\"p8 mt16\"><div class=st-title-small translate=REPORT_POINTS.TITLE.CHOOSE_FORMAT></div><div class=st-caption translate=REPORT_POINTS.HINT.LINK></div></div><div layout=column layout-align=\"space-between stretch\" class=\"mt8 mb8\"><label class=mb8><input type=radio ng-model=ctrl.report.type value=CSV> <span translate=REPORT_POINTS.ENUM.FORMAT.CSV></span></label><label class=mb8><input type=radio ng-model=ctrl.report.type value=XLSX> <span translate=REPORT_POINTS.ENUM.FORMAT.XLSX></span></label><label class=mb8><input type=radio ng-model=ctrl.report.type value=KML> <span translate=REPORT_POINTS.ENUM.FORMAT.KML></span></label></div><div class=\"p8 mt16\"><div class=st-title-small translate=REPORT_POINTS.TITLE.DEFINE_PERIOD></div><div class=st-caption translate=REPORT_POINTS.HINT.VALID_PERIOD translate-values=\"{ max: \'{{ctrl.meta.max_date | date: \'dd/MM/yyyy\'}}\', min: \'{{ctrl.meta.min_date | date: \'dd/MM/yyyy\'}}\' }\"></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=REPORT_POINTS.LABEL.FROM_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=from_date placeholder=\"HH:MM:SS DD/MM/AAAA\" required type=text data-test=report_points.from_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-change=ctrl.updatePeriod() ng-max=ctrl.report.max_date ng-min=ctrl.report.min_date ng-model=ctrl.report.from_date><div ng-if=\"ctrl.form.$submitted && ctrl.form.from_date.$error\" data-test=report_points.validation.from_date><div class=st-input-validation ng-show=ctrl.form.from_date.$error.required translate=REPORT_POINTS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.min translate=REPORT_POINTS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.max translate=REPORT_POINTS.VALIDATION.MAX></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=REPORT_POINTS.LABEL.TO_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=to_date placeholder=\"HH:MM:SS DD/MM/AAAA\" required type=text data-test=report_points.to_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-max=ctrl.report.max_date ng-min=ctrl.report.min_date ng-model=ctrl.report.to_date ng-change=ctrl.updatePeriod()><div ng-if=\"ctrl.form.$submitted && ctrl.form.to_date.$error\" data-test=report_points.validation.to_date><div class=st-input-validation ng-show=ctrl.form.to_date.$error.required translate=REPORT_POINTS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.min translate=REPORT_POINTS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.max translate=REPORT_POINTS.VALIDATION.MAX></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.interval translate=REPORT_POINTS.VALIDATION.INTERVAL></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.finalBiggerInitial translate=REPORT_POINTS.VALIDATION.FINAL_BIGGER_INITIAL></div></div></div></div><br><div class=\"st-dialog-footer p12\" layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.cancel() data-test=report_points.action.cancel><span translate=REPORT_POINTS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save data-test=report_points.action.save><span translate=REPORT_POINTS.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/components/template-form/template-form.html","<md-dialog flex-xs=95 flex-sm=80 flex-md=70 flex-gt-md=60 class=\"st-dialog dialog-template\"><div class=\"h-full overflow-y-auto pr16\"><div layout layout-align=\"space-between center\" class=st-dialog-header><p class=md-title translate=TEMPLATE_FORM.TITLE.HEADER></p></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentAttr)\" layout=column layout-align=\"space-between stretch\" novalidate><div layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=start><div class=st-input-container layout=column flex=50><label for=name class=\"st-label st-required\" translate=TEMPLATE_FORM.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.currentAttr.attributes.name type=text maxlength=50 required autocomplete=off><div ng-if=ctrl.form.$submitted><span class=st-input-validation ng-show=ctrl.form.name.$error.required translate=TEMPLATE_FORM.VALIDATION.REQUIRED></span></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex=100><label for=text class=\"st-label st-required pb4\" translate=TEMPLATE_FORM.LABEL.CONTENT></label><editor characters-max=ctrl.maxCharacters content=ctrl.currentAttr.attributes.text content-only-text=ctrl.contentText id=template-content invalid=\"ctrl.form.text.$invalid && ctrl.form.$submitted\" toolbar-tools=\"[\'size\', \'align\']\"></editor><input type=hidden name=text ng-model=ctrl.contentText maxlength=\"{{ctrl.maxCharacters + 1}}\" required><div ng-if=ctrl.form.$submitted><span class=st-input-validation ng-show=ctrl.form.text.$error.required translate=TEMPLATE_FORM.VALIDATION.REQUIRED></span> <span class=st-input-validation ng-show=ctrl.form.text.$error.maxlength translate=TEMPLATE_FORM.VALIDATION.MAXLENGTH></span></div></div></div><div class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" ng-click=ctrl.cancel()><span translate=TEMPLATE_FORM.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\"><span translate=TEMPLATE_FORM.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/template-list/template-list.html","<md-dialog flex-xs=95 flex-sm=80 flex-md=70 flex-gt-md=60 class=\"st-dialog dialog-template\"><div class=\"h-full overflow-y-auto pr16\"><div layout layout-align=\"space-between center\" class=st-dialog-header><div><p class=md-title translate=TEMPLATE_LIST.TITLE.HEADER></p><p class=\"text-gray-500 text-xs\" translate=TEMPLATE_LIST.HINT.HEADER></p></div><button type=button class=altnav-action ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><div class=m8><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><p translate=TEMPLATE_LIST.LABEL.NAME></p></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.name}}</td><td md-cell><button class=no-button ng-click=ctrl.apply(item)><i class=material-symbols-outlined>chevron_right</i></button></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=2><div layout=column layout-align=\"center center\"><p class=\"no-content-text mt8\" translate=TEMPLATE_LIST.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadData md-boundary-links md-label=\"{page: \'{{\'TEMPLATE_LIST.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'TEMPLATE_LIST.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'TEMPLATE_LIST.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div></div></div></md-dialog>");
$templateCache.put("app/components/upgrade-plan/upgrade-plan.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=50 flex-gt-md=45 class=\"st-dialog mini\" aria-label=\"Upgrade Plan Dialog\"><div class=\"st-dialog-wrapper p12\"><div class=st-dialog-body><h2 class=title translate=UPGRADE_PLAN.TITLE.WELCOME></h2><br><p class=helper translate=UPGRADE_PLAN.LABEL.REQUEST_ACCESS></p></div></div></md-dialog>");
$templateCache.put("app/components/user-list-dialog/user-list-dialog.html","<md-dialog flex-sm=90 flex-md=40 flex-gt-md=35 class=st-dialog aria-label=\"Vehicle users\"><div layout layout-align=\"space-between center\" class=st-dialog-header><h2 translate=VEHICLE_USERS_DIALOG.TITLE.HEADER></h2></div><md-dialog-content ng-cloak><div class=st-dialog-body><div class=st-input-container layout=column flex><input class=\"st-input-type input-type\" ng-model=ctrl.search type=text autocomplete=off translate-attr=\"{placeholder: \'VEHICLE_USERS_DIALOG.PLACEHOLDER.TYPE_USER\'}\" ng-model-options=\"{ debounce: 600 }\"></div><div><ul class=vehicle-users-expanded-list><li class=vehicle-users-expanded-item ng-repeat=\"user in ctrl.item | filter: ctrl.search\"><span class=st-subhead>{{user.name}}</span> <span class=st-aux>{{user.phone1 | phoneFilter}}</span></li></ul></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/vehicle-sharing/vehicle-sharing.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=45 flex-gt-md=35 class=st-dialog aria-label=Address><!-- dialog header --><div layout layout-align=\"space-between center\" class=st-dialog-header><h3 translate=VEHICLE_SHARING.TITLE.HEADER></h3></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.sharing)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=address-card layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=start><div layout=column layout-align=\"space-between start\" class=\"st-card m12\" flex><span class=st-subhead>{{ctrl.sharing.vehicle.plate}}</span> <span class=st-caption>{{ctrl.sharing.vehicle.properties.brand.name}} {{ctrl.sharing.vehicle.properties.model.name}}</span></div></div><div layout layout-align=space-between><div class=\"st-radio-container st-input-container\" layout=column><div class=st-label translate=VEHICLE_SHARING.LABEL.TYPE></div><div class=\"mt8 pt8\" layout><label class=mr8 ng-repeat=\"type in ctrl.types\"><input type=radio ng-model=ctrl.sharing.type value={{type}} ng-disabled={{ctrl.sharing.disabled}}> <span translate=\"{{ \'VEHICLE_SHARING.TYPES.\' + type.toUpperCase()}}\"></span></label></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=VEHICLE_SHARING.LABEL.VALID_UNTIL></label><input class=\"st-input-type input-type\" name=validUntil ng-model=ctrl.sharing.valid_until type=text placeholder=\"HH:MM DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" min={{ctrl.sharing.minSharingDate}} max={{ctrl.sharing.maxSharingDate}} autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.validUntil.$error\"><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.required translate=VEHICLE_SHARING.VALIDATION.REQUIRED_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.min translate=VEHICLE_SHARING.VALIDATION.MIN_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.max translate=VEHICLE_SHARING.VALIDATION.MAX_VALID_UNTIL></div></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLE_SHARING.LABEL.ADDRESS></label><input class=\"st-input-type input-type\" ng-model=ctrl.sharing.formatted_address type=text autocomplete=off required disabled></div></div><br><div class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=VEHICLE_SHARING.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=VEHICLE_SHARING.ACTION.SAVE></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/components/vehicle-status/vehicle-status.dialog.html","<md-dialog flex-xs=95 flex-sm=85 flex-md=80 flex-gt-md=70 class=st-dialog aria-label=\"Critical state vehicles\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><div><div layout><span class=\"text-lg font-bold leading-tight text-gray-700\" translate=VEHICLE_STATUS.TITLE.HEADER></span> <span class=ml12><progress ng-if=ctrl.loading></progress></span></div><div class=\"text-sm font-medium leading-tight text-gray-500 truncate\" translate=VEHICLE_STATUS.TITLE.DESC></div></div></div><div layout layout-align=\"start center\"><md-menu can-access=INTERNALS,MANAGER md-position-mode=\"target-right target\" md-offset=\"0 46\"><button type=button class=\"no-button altnav-action\" ng-click=$mdMenu.open($event) ng-disabled=ctrl.loading><i class=material-symbols-outlined>download</i></button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button aria-label=\"Export CSV\" ng-click=\"ctrl.export(\'csv\')\"><span class=st-subhead translate=VEHICLE_STATUS.LABEL.CSV></span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Export XLSX\" ng-click=\"ctrl.export(\'xlsx\')\"><span class=st-subhead translate=VEHICLE_STATUS.LABEL.XLSX></span></md-button></md-menu-item></md-menu-content></md-menu><button type=button class=\"no-button altnav-action\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></button></div></div></div><div class=\"st-dialog-wrapper communitation-partner\"><div class=\"st-dialog-body no-padding\" layout=column layout-align=\"space-between stretch\"><div class=st-dialog-filter layout layout-align=\"start center\"><div class=\"st-input-container no-padding\" layout=column flex=15><md-select class=st-input-select name=communication ng-model=ctrl.selectedStandard aria-label=\"Select communication\" md-no-asterisk md-on-close=ctrl.selectStatus() ng-disabled=ctrl.loading><md-option ng-repeat=\"standard in ctrl.communicationStandards\" ng-value=standard translate=\"{{\'VEHICLE_STATUS.STANDARD.\' + standard.toUpperCase()}}\"></md-option></md-select></div><div class=\"st-input-container no-padding mr12 ml12\" layout=column flex=15><md-select class=st-input-select name=type ng-model=ctrl.selectedType aria-label=\"Select Type\" multiple md-no-asterisk md-on-close=ctrl.selectType() ng-disabled=ctrl.loading><md-option ng-repeat=\"t in ctrl.vehicleTypes\" ng-value=t>{{\'DASHBOARD.VEHICLE_TYPE.\' + t.toUpperCase() | translate}}</md-option></md-select></div><div class=\"st-input-container no-padding\" layout=column flex=15><md-select class=st-input-select name=interval ng-model=ctrl.selectedInterval aria-label=\"Select communication\" md-no-asterisk md-on-close=ctrl.selectInterval() ng-disabled=ctrl.loading><md-option ng-repeat=\"(key, value) in ctrl.timeScale\" ng-value=key>{{value.label}}</md-option></md-select></div></div><md-table-container><table class=st-main-table md-table><thead class=st-table-head md-head md-order=ctrl.order md-on-reorder=ctrl.reorder><tr md-row><th md-column md-order-by=vehicle.plate><span translate=VEHICLE_STATUS.LABEL.VEHICLE></span></th><th md-column><span translate=VEHICLE_STATUS.LABEL.USERS></span></th><th md-column><span translate=VEHICLE_STATUS.LABEL.DEVICE_TYPE></span></th><th md-column md-numeric md-order-by=imei><span translate=VEHICLE_STATUS.LABEL.DEVICE></span></th><th md-column md-numeric md-order-by=last_gps.last_gps_time><span translate=VEHICLE_STATUS.LABEL.LAST_COMMUNICATION></span></th><th md-column md-numeric md-order-by=last_gps.last_connection_time><span translate=VEHICLE_STATUS.LABEL.LAST_CONNECTION></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.communicationStatus\"><td md-cell><div><div><span class=\"text-xs font-bold text-gray-700\">{{::item.relationships.vehicle.attributes.plate}}</span> <span class=\"st-tag ml8 text-sm font-bold text-gray-700\" translate=\"{{\'VEHICLE_STATUS.VEHICLE_TYPE.\' + item.relationships.vehicle.attributes.type_name.toUpperCase()}}\"></span></div><div class=\"text-xs text-gray-500\">{{::item.relationships.vehicle.attributes.vin}}</div></div></td><td md-cell><div><user-list users=item.relationships.users_assets recordable=true initials=true horizontal=true clickable=false size=sm></user-list></div></td><td md-cell><div><div class=\"text-xs font-bold text-gray-700\">{{::item.relationships.type.attributes.brand_alias}}</div><div class=\"text-xs text-gray-500\">{{::item.relationships.type.attributes.alias}}</div></div></td><td md-cell><div><div class=\"text-xs font-bold text-gray-700\">{{::item.attributes.name}}</div><div class=\"text-xs text-gray-500\">{{::item.attributes.imei}}</div></div></td><td md-cell><span class=\"text-xs text-gray-700\">{{::item.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></td><td md-cell><span class=\"text-xs text-gray-700\">{{::item.relationships.last_gps.attributes.last_connection_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></td></tr><tr ng-if=\"(!ctrl.communicationStatus || ctrl.communicationStatus.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=VEHICLE_STATUS.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.getCommunicationStatus md-boundary-links md-label=\"{page: \'{{\'VEHICLE_STATUS.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'VEHICLE_STATUS.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'VEHICLE_STATUS.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div></md-dialog>");
$templateCache.put("app/components/webhooks/webhooks.html","<md-dialog flex-xs=95 flex-sm=55 flex-md=45 flex-gt-md=35 class=st-dialog aria-label=Webhooks><!-- dialog header --><div layout layout-align=\"space-between center\" class=st-dialog-header><span class=md-title translate=WEBHOOKS.TITLE.HEADER></span></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentWebhook)\" layout=column layout-align=\"space-between stretch\" novalidate><div layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=WEBHOOKS.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.currentWebhook.attributes.name type=text translate-attr=\"{ placeholder: \'WEBHOOKS.PLACEHOLDER.TYPE_NAME\' }\" autocomplete=off required></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=WEBHOOKS.LABEL.URL></label><input class=\"st-input-type input-type\" name=url ng-model=ctrl.currentWebhook.attributes.url type=text translate-attr=\"{ placeholder: \'WEBHOOKS.PLACEHOLDER.TYPE_URL\' }\" autocomplete=off required></div></div><br><div class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=WEBHOOKS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=WEBHOOKS.ACTION.SAVE></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/directives/accordion/accordion-item.html","<div class=accordion__item><div ng-click=ctrl.openCloseItem() class=\"accordion__header cursor-pointer pt16 pb16 border-solid border-gray-200 border-0 border-t\"><p ng-class=ctrl.titleStyle>{{ctrl.$translate.instant(textTitle)}}</p><span class=\"accordion__expand-icon pl8\"><i class=\"material-symbols-outlined text-gray-400\" ng-class=\"{\'rotate-180\': ctrl.internalIndex === index}\">expand_more</i></span></div><div ng-class=\"{ \'expand pt4 pb4\': ctrl.toggle || ctrl.internalIndex === index }\" class=accordion__body><div class=overflow-hidden><ng-transclude></ng-transclude></div></div></div>");
$templateCache.put("app/directives/advanced-filter/advanced-filter.html","<div class=\"st-dialog-wrapper p16\"><div class=st-dialog-body><div><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=ADVANCED_FILTER.LABEL.FIELDS></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=ADVANCED_FILTER.LABEL.PICK_FIELD></div></div><div class=mt4 layout layout-wrap><button type=button class=\"no-button st-tags mr8 mt8 pointer\" ng-repeat=\"(k, v) in ctrl.filters\" ng-class=\"{\'selected\': v.selected}\" ng-click=ctrl.mountFilter(v)><span class=truncate translate=\"{{\'ADVANCED_FILTER.ENUM.\' + (model + \'.\' + v.key).toUpperCase()}}\"></span></button></div></div><form class=mt24 name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.triggerSearch()\" novalidate flex><div><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=ADVANCED_FILTER.LABEL.SELECTED_FIELDS></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=ADVANCED_FILTER.LABEL.SELECTED_FIELDS_SUB></div></div><div class=\"advanced-filter_table mt12 border border-solid border-gray-300 rounded-md overflow-hidden\"><div ng-repeat=\"(k, v) in selectedFilters\" layout class=\"wrapper border-0 border-solid border-gray-300\" ng-class=\"{\'border-b\': !$last}\"><div flex=20 flex-gt-md=25 class=\"p12 bg-slate-100 border-0 border-r border-solid border-gray-300\" layout layout-align=\"start center\"><span class=\"text-sm font-bold leading-tight text-gray-700 truncate\" translate=\"{{\'ADVANCED_FILTER.ENUM.\' + (model + \'.\' + k).toUpperCase()}}\"></span></div><div flex=20 flex-gt-md=25 class=p8 layout layout-align=\"none center\"><div class=\"st-input-container no-padding grow w-full\"><md-select class=st-input-select name=operator md-on-close=ctrl.getCount() ng-model=v.operator aria-label=\"Select operator\" placeholder=\"{{\'ADVANCED_FILTER.PLACEHOLDER.SELECT_OPTION\' | translate}}\" md-no-asterisk required flex><md-option ng-repeat=\"op in ctrl.filterOperators[v.type]\" value={{op}} translate=\"{{\'ADVANCED_FILTER.ENUM.OPERATOR.\' + (v.type + \'.\' + op).toUpperCase()}}\"></md-option></md-select><div class=pt4><md-select aria-label=\"Select interval\" class=st-input-select flex md-no-asterisk name=time ng-change=ctrl.selectInterval(v) ng-if=\"relativeDate && (v.type === \'shortdate\' || v.type === \'date\')\" ng-model=v.selectedDate placeholder=\"{{\'ADVANCED_FILTER.PLACEHOLDER.SELECT_OPTION\' | translate}}\" required><md-option ng-repeat=\"i in ctrl.intervals\" value={{i}} ng-if=\"v.type === \'date\' || i.type !== \'hours\'\" translate=\"{{\'ADVANCED_FILTER.ENUM.INTERVALS.\' + i.type.toUpperCase()}}\"></md-option></md-select></div></div></div><div flex=55 flex-gt-md=55 class=p8><div class=\"st-input-container no-padding\" layout=column flex><div ng-if=\"v.type === \'string\'\"><input class=\"st-input-type input-type w-full\" type=text ng-model=v.value ng-change=ctrl.getCount() ng-model-options=\"{ debounce: 1000 }\" autocomplete=off translate-attr=\"{ placeholder: \'ADVANCED_FILTER.PLACEHOLDER.TYPE_A_TEXT\' }\" required></div><div ng-if=\"v.type === \'number\'\"><input ng-if=\"![\'btw\', \'nbtw\'].includes(v.operator)\" class=\"st-input-type input-type w-full\" type=number ng-model=v.value ng-change=ctrl.getCount() ng-model-options=\"{ debounce: 1000 }\" autocomplete=off translate-attr=\"{ placeholder: \'ADVANCED_FILTER.PLACEHOLDER.TYPE_A_NUMBER\' }\" required><div ng-if=\"[\'btw\', \'nbtw\'].includes(v.operator)\" layout><input class=\"st-input-type input-type w-full\" type=text ng-model=v.value1 ng-change=ctrl.updateFilterValues(k) translate-attr=\"{ placeholder: \'ADVANCED_FILTER.PLACEHOLDER.TYPE_A_NUMBER\' }\" autocomplete=off ui-number-mask=0 required> <span class=w-3></span> <input class=\"st-input-type input-type w-full\" type=text ng-model=v.value2 ng-change=ctrl.updateFilterValues(k) translate-attr=\"{ placeholder: \'ADVANCED_FILTER.PLACEHOLDER.TYPE_A_NUMBER\' }\" autocomplete=off ui-number-mask=0 required></div></div><div ng-if=\"v.type === \'date\' && !relativeDate\"><input ng-if=\"![\'btw\', \'nbtw\'].includes(v.operator)\" class=\"st-input-type input-type w-full\" type=text ng-model=v.value ng-change=ctrl.getCount() ng-model-options=\"{ debounce: 1000 }\" placeholder=\"HH:MM DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-dd HH:mm:ss\" autocomplete=off required><div ng-if=\"[\'btw\', \'nbtw\'].includes(v.operator)\" layout><input class=\"st-input-type input-type w-full\" type=text ng-model=v.value1 placeholder=\"HH:MM DD/MM/AAAA\" ng-change=ctrl.updateFilterValues(k) datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-dd HH:mm:ss\" autocomplete=off required> <span class=w-3></span> <input class=\"st-input-type input-type w-full\" type=text ng-model=v.value2 placeholder=\"HH:MM DD/MM/AAAA\" ng-change=ctrl.updateFilterValues(k) datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-dd HH:mm:ss\" autocomplete=off required></div></div><div ng-if=\"v.type === \'shortdate\' && !relativeDate\"><input ng-if=\"![\'btw\', \'nbtw\'].includes(v.operator)\" class=\"st-input-type input-type w-full\" type=text ng-model=v.value ng-change=ctrl.getCount() ng-model-options=\"{ debounce: 1000 }\" placeholder=DD/MM/AAAA datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd autocomplete=off required><div ng-if=\"[\'btw\', \'nbtw\'].includes(v.operator)\" layout><input class=\"st-input-type input-type w-full\" type=text ng-model=v.value1 placeholder=DD/MM/AAAA ng-change=ctrl.updateFilterValues(k) datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd autocomplete=off required> <span class=w-3></span> <input class=\"st-input-type input-type w-full\" type=text ng-model=v.value2 placeholder=DD/MM/AAAA ng-change=ctrl.updateFilterValues(k) datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd autocomplete=off required></div></div><div ng-if=\"v.type === \'enum\' || v.type === \'boolean\'\"><md-select class=st-input-select name=enum md-on-close=ctrl.getCount() ng-model=v.value aria-label=\"Select value\" required multiple md-no-asterisk><md-option ng-repeat=\"i in v.options\" ng-value=i>{{\'ADVANCED_FILTER.ENUM.OPTIONS.\' + [k,i].join(\'.\').toString().toUpperCase() | translate}}</md-option></md-select></div><div ng-if=\"(v.type === \'date\' || v.type === \'shortdate\') && relativeDate\"><div ng-show=v.relativeDate.op><md-radio-group ng-model=v.relativeDate.value name=timePeriod class=\"md-blue md-sm md-top\" aria-labelledby=intervals required><div layout class=\"pt4 pb4\"><div class=\"pr24 text-sm text-gray-700\" layout=column layout-align=\"space-between start\"><md-radio-button value=-1 aria-label=Previous><span translate=\"{{\'ADVANCED_FILTER.LABEL.PREV_INTERVALS.\' + v.relativeDate.type.toUpperCase()}}\"></span></md-radio-button><md-radio-button value=0 aria-label=Current><span translate=\"{{\'ADVANCED_FILTER.LABEL.CURRENT_INTERVALS.\' + v.relativeDate.type.toUpperCase()}}\"></span></md-radio-button><md-radio-button value=1 aria-label=Next><span translate=\"{{\'ADVANCED_FILTER.LABEL.NEXT_INTERVALS.\' + v.relativeDate.type.toUpperCase()}}\"></span></md-radio-button></div><div class=\"text-sm text-gray-700\" layout=column layout-align=\"space-between start\"><div layout layout-align=\"start center\"><md-radio-button value=-2 aria-label=Previous><span class=w-16 translate=\"{{\'ADVANCED_FILTER.LABEL.PREV_INTERVALS.CUSTOM_\' + v.relativeDate.type.toUpperCase()}}\"></span></md-radio-button><input class=\"st-input-type input-type w-16\" type=number ng-model=v.relativeDate.prev ng-disabled=\"v.relativeDate.value !== \'-2\'\" min=1 required> <span class=\"pl4 ml2 lowercase\" translate=\"{{\'ADVANCED_FILTER.ENUM.INTERVALS.\' + v.relativeDate.type.toUpperCase()}}\"></span></div><div layout layout-align=\"start center\"><md-radio-button value=2 aria-label=Next><span class=w-16 translate=\"{{\'ADVANCED_FILTER.LABEL.NEXT_INTERVALS.CUSTOM_\' + v.relativeDate.type.toUpperCase()}}\"></span></md-radio-button><input class=\"st-input-type input-type w-16\" type=number ng-model=v.relativeDate.next ng-disabled=\"v.relativeDate.value !== \'2\'\" min=1 required> <span class=\"pl4 ml2 lowercase\" translate=\"{{\'ADVANCED_FILTER.ENUM.INTERVALS.\' + v.relativeDate.type.toUpperCase()}}\"></span></div></div></div></md-radio-group></div></div></div></div><div flex=5 layout layout-align=\"center center\"><button type=button class=\"no-button no-padding\" ng-click=\"ctrl.removeField(k); ctrl.getCount()\"><i class=\"material-symbols-outlined text-gray-400\">close</i></button></div></div><div ng-if=ctrl.emptySelection() class=\"p8 m24\" layout=column layout-align=\"center center\"><div class=\"text-sm font-bold leading-tight text-gray-500\" translate=ADVANCED_FILTER.HINT.NO_DATA></div><div class=\"text-sm font-bold leading-tight text-gray-500\" translate=ADVANCED_FILTER.HINT.CLICK_TO_PICK></div></div></div><div class=mt24 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action no-back\" ng-click=\"ctrl.emptyFilters(); ctrl.getCount()\" aria-label=Clear><span translate=ADVANCED_FILTER.ACTION.CLEAR></span></button><div layout layout-align=\"center center\"><progress ng-if=ctrl.countLoading class=pr-1></progress><button aria-label=Save class=altnav-action ng-class=\"{\n            \'light\': ctrl.hasCount && !relativeDate && (ctrl.count <= 0 || (ctrl.count > 0 && ctrl.form.$invalid)),\n            \'save\': !ctrl.hasCount || relativeDate || (ctrl.count > 0 && ctrl.form.$valid)\n          }\" ng-disabled=\"ctrl.emptySelection() || ctrl.countLoading || (!relativeDate && !ctrl.count)\" type=submit><span ng-if=relativeDate translate=\"{{\'ADVANCED_FILTER.ACTION.\' + ctrl.btnText}}\"></span> <span ng-if=\"!relativeDate && (ctrl.emptySelection() || ctrl.count === -1)\" translate=ADVANCED_FILTER.ACTION.SEE_RESULTS></span> <span ng-if=\"!relativeDate && !ctrl.emptySelection() && (ctrl.count === 0 || (ctrl.count > -1 && ctrl.form.$invalid))\" translate=ADVANCED_FILTER.ACTION.NO_RESULTS></span> <span ng-if=\"!relativeDate && !ctrl.emptySelection() && ctrl.count > 0 && ctrl.form.$valid\"><span translate=ADVANCED_FILTER.ACTION.SEE></span> <span ng-if=ctrl.showCount>{{ctrl.count}}</span> <span translate=ADVANCED_FILTER.ACTION.RESULTS></span></span></button></div></div></form></div>");
$templateCache.put("app/directives/button-dropdown/button-dropdown.html","<div class=\"border border-solid border-gray-200 rounded relative z-10 btn-dropdown\" layout><button type=button class=\"no-button pl12 pr12\" ng-click=clickEvent() ng-disabled=disabled><span class=\"text-sm text-gray-800 font-bold\" translate=\"{{\'BUTTON_DROPDOWN.ACTION.\' + (buttonTranslate.toUpperCase() || \'COMPLETE\')}}\"></span></button><div class=\"border-0 border-l border-solid border-gray-200\"><md-menu md-position-mode=\"right bottom\" md-offset=\"0 4\"><md-button aria-label=\"Open options\" class=\"md-icon-button no-padding no-margin\" ng-click=$mdMenu.open($event) ng-disabled=disabled><i class=\"material-symbols-outlined text-gray-400 text-lg h3\">expand_more</i></md-button><md-menu-content width=3 class=md-dense data-ng-transclude></md-menu-content></md-menu></div></div>");
$templateCache.put("app/directives/copy-paste/copy-paste.html","<span class=copy-paste><span class=copy-paste-label><span>{{ctrl.value}}</span> <button ng-if=ctrl.value type=button class=no-button ngclipboard data-clipboard-text={{ctrl.value}} ngclipboard-success=ctrl.copy(e)><i ng-if=!ctrl.copied class=\"copy-paste-icon text-base material-symbols-outlined\">content_copy</i> <i ng-if=ctrl.copied class=\"copy-paste-icon text-base material-symbols-outlined\">check_circle</i><md-tooltip ng-if=ctrl.copied md-direction=top md-delay=200><span translate=COPY_PASTE.LABEL.COPIED></span></md-tooltip></button> </span></span>");
$templateCache.put("app/directives/custom-fields-form/custom-fields-form.html","<form class=\"st-form-inputs custom-fields-form w-full\" ng-class=[customClassCss] name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate><div layout=column layout-align=\"space-between stretch\" class=custom-fields-form__fieldset><div layout=column layout-align=\"space-between stretch\"><!-- enterprise --><div ng-if=ctrl.showEnterprise layout layout-align=\"space-between center\"><div flex=100><enterprises-autocomplete disabled-item=ctrl.readOnly form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div></div><div><div layout layout-align=\"space-between center\"><!-- name --><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=CUSTOM_FIELDS_FORM.LABEL.NAME></label><input class=\"st-input-type input-type\" type=text name=name ng-model=ctrl.item.attributes.name autocomplete=off translate-attr=\"{ placeholder: \'CUSTOM_FIELDS_FORM.PLACEHOLDER.TYPE_NAME\' }\" maxlength=80 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$error\"><div class=st-input-validation ng-show=ctrl.form.name.$error.required translate=CUSTOM_FIELDS_FORM.VALIDATION.NAME></div></div></div><!-- format --><div class=st-input-container layout=column flex><label class=st-label translate=CUSTOM_FIELDS_FORM.LABEL.FIELD_FORMAT></label><md-select class=st-input-select name=field_format ng-model=ctrl.item.attributes.field_format aria-label=\"Select format\" md-no-asterisk flex style=\"margin-bottom:4px;margin-top: 4px\"><md-option ng-repeat=\"f in ctrl.formats\" ng-value=f translate=\"{{\'CUSTOM_FIELDS_FORM.ENUM.FIELD_FORMAT.\' + f.toUpperCase()}}\"></md-option></md-select></div></div></div><div ng-if=\"ctrl.item.attributes.field_format === \'enum\' || ctrl.item.attributes.field_format === \'checkbox\'\"><div class=st-input-container layout=column flex=40><label class=st-label translate=CUSTOM_FIELDS_FORM.LABEL.NEW_VALUE></label><div layout><div><input class=\"st-input-type input-type\" type=text name=new_value ng-keypress=ctrl.enterAddPossibleValue($event) ng-keyup=ctrl.validateRepeat() ng-model=ctrl.item.attributes.new_value autocomplete=off translate-attr=\"{ placeholder: \'CUSTOM_FIELDS_FORM.PLACEHOLDER.TYPE_VALUE\' }\" maxlength=50 flex><div ng-if=\"ctrl.form.$submitted && ctrl.form.new_value.$error.required\"><span class=st-input-validation ng-show=ctrl.form.new_value.$error.required translate=CUSTOM_FIELDS_FORM.VALIDATION.NEW_VALUE></span></div><div ng-if=ctrl.form.new_value.$error.repeat><span class=st-input-validation ng-show=ctrl.form.new_value.$error.repeat translate=CUSTOM_FIELDS_FORM.VALIDATION.REPEAT></span></div></div><button type=button class=\"altnav-action light mt4 ml4\" ng-click=ctrl.addPossibleValue()><span class=\"material-symbols-outlined text-base\">add</span></button></div></div><div class=p4><md-table-container class=\"st-wrapper-table custom-fields-form__table-possible-values max-h-80\"><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><p class=\"text-sm text-gray-500 font-semibold\" translate=CUSTOM_FIELDS_FORM.LABEL.POSSIBLE_VALUES></p></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"option in ctrl.item.attributes.possible_values track by $index\"><td md-cell><p class=\"text-sm text-gray-700 truncate\">{{option}}</p></td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button class=no-button ng-click=ctrl.removePossibleValue($index)><i class=\"material-symbols-outlined text-xl\">delete</i></button></div></td></tr><tr ng-if=\"(!ctrl.item.attributes.possible_values || ctrl.item.attributes.possible_values.length == 0) && !ctrl.loading\"><td class=\"st-table-no-content no-padding\" colspan=2><div layout=column layout-align=\"center center\" class=\"border-0 border-t-2 border-solid border-gray-200 text-sm pt4 pb2\"><p class=\"no-content-text pt12 pb12 leading-4\" translate=CUSTOM_FIELDS_FORM.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container></div></div><div class=st-input-container layout=column><md-checkbox ng-model=ctrl.item.attributes.is_required aria-label=\"Required item\" class=\"md-blue md-sm\"><span class=\"whitespace-nowrap text-sm text-gray-800\" translate=CUSTOM_FIELDS_FORM.LABEL.IS_REQUIRED></span></md-checkbox><p class=\"st-caption ml24\" translate=CUSTOM_FIELDS_FORM.HINT.IS_REQUIRED></p></div></div></div><div class=\"custom-fields-form__footer mt16 pt2\"><div class=\"st-form-actions p12\" can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><div layout class=w-full><ng-transclude class=w-full></ng-transclude></div><div layout><button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=!create translate=CUSTOM_FIELDS_FORM.ACTION.SAVE></span> <span ng-if=create translate=CUSTOM_FIELDS_FORM.ACTION.CREATE></span></button></div></div></div></form>");
$templateCache.put("app/directives/device-asset-association/device-asset-association.html","<div flex><div class=mb8 ng-repeat=\"item in ctrl.users\"><div layout layout-align=\"space-between center\"><div><div><span class=\"text-xs font-bold leading-tight text-gray-700\">{{item.relationships.user.attributes.name}}</span> <span class=\"st-tags xs\" ng-if=item.relationships.user.attributes.deactivated_at><span translate=USER_ASSET_PERMISSIONS.LABEL.DEACTIVATED></span></span></div><a ng-href=\"https://api.whatsapp.com/send?phone={{u.attributes.phone1}}\" target=_blank><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.user.attributes.phone1 | phoneFilter}}</div></a></div><div><md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\"><a href=\"\" class=m4 ng-click=$mdMenu.open($event)><i class=\"material-symbols-outlined text-gray-500\">more_vert</i></a><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item ng-if=item.relationships.user.attributes.deactivated_at><md-button aria-label=Activate><a ng-click=ctrl.updateState(item) class=link-actions><span class=st-subhead translate=USER_ASSET_PERMISSIONS.ACTION.ACTIVATE></span></a></md-button></md-menu-item><md-menu-item ng-if=!item.relationships.user.attributes.deactivated_at><md-button aria-label=Deactivate><a ng-click=ctrl.updateState(item) class=link-actions><span class=st-subhead translate=USER_ASSET_PERMISSIONS.ACTION.DEACTIVATE></span></a></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Remove Association\"><a ng-click=ctrl.removeUser(item) class=link-actions><span class=st-subhead translate=USER_ASSET_PERMISSIONS.ACTION.DISASSOCIATE></span></a></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div ng-if=\"ctrl.users.length === 0\"><p class=\"mt16 mb16 text-xs leading-tight text-gray-500 truncate\" translate=USER_ASSET_PERMISSIONS.HINT.NO_USER_ASSOCIATED></p></div></div>");
$templateCache.put("app/directives/easy-link/easy-link.html","<span class=easy-link><a class=easy-link-anchor ng-href={{ctrl.link}} target=_blank><span class=easy-link-label><span>{{ctrl.placeholder}}</span> <i class=\"easy-link-icon text-base material-symbols-outlined\">link</i> </span></a></span>");
$templateCache.put("app/directives/editor/editor.html","<div ng-paste=ctrl.pasteEvent($event)><div ng-if=ctrl.render class=quill ng-class=\"{\n      \'border\': !noBorder,\n      \'error\': invalid,\n      \'editing\': ctrl.quill.hasFocus()\n    }\"><div id={{ctrl.idToolbar}} ng-show=\"ctrl.toolbarEnable || ctrl.quill.hasFocus()\" class=quill__toolbar ng-click=ctrl.clickToolbar()><div ng-if=ctrl.toolbarSections.size class=quill__separator><select class=\"ql-header quill__select\" title=Estilos><option value=1 translate=EDITOR.TOOLBAR.HEADER_1></option><option value=2 translate=EDITOR.TOOLBAR.HEADER_2></option><option value=3 translate=EDITOR.TOOLBAR.HEADER_3></option><option value=4 translate=EDITOR.TOOLBAR.HEADER_4></option><option value=5 translate=EDITOR.TOOLBAR.HEADER_5></option><option value=6 translate=EDITOR.TOOLBAR.HEADER_6></option><option selected translate=EDITOR.TOOLBAR.NORMAL></option></select></div><div ng-if=ctrl.toolbarSections.size class=quill__separator><select class=\"ql-size quill__select\" title=Fontes><option value=small translate=EDITOR.TOOLBAR.SIZE_SMALL></option><option selected translate=EDITOR.TOOLBAR.NORMAL></option><option value=large translate=EDITOR.TOOLBAR.SIZE_LARGE></option><option value=huge translate=EDITOR.TOOLBAR.SIZE_HUGE></option></select></div><div class=quill__separator><button class=\"ql-bold quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.BOLD\' }\"></button> <button class=\"ql-italic quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.ITALIC\' }\"></button> <button class=\"ql-underline quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.UNDERLINE\' }\"></button> <button class=\"ql-strike quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.STRIKE\' }\"></button><select class=\"ql-color quill__multi\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.COLOR\' }\"></select><select class=\"ql-background quill__multi\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.BACKGROUND\' }\"></select></div><div ng-if=ctrl.toolbarSections.align class=quill__separator><select class=\"ql-align quill__multi\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.ALIGN\' }\"></select><button class=\"ql-list quill__btn\" value=bullet translate-attr=\"{ title: \'EDITOR.TOOLBAR.LIST_BULLET\' }\"></button> <button class=\"ql-list quill__btn\" value=ordered translate-attr=\"{ title: \'EDITOR.TOOLBAR.LIST_ORDERED\' }\"></button> <button class=\"ql-indent quill__btn\" value=-1 translate-attr=\"{ title: \'EDITOR.TOOLBAR.INDENT_MINUS\' }\"></button> <button class=\"ql-indent quill__btn\" value=+1 translate-attr=\"{ title: \'EDITOR.TOOLBAR.INDENT_PLUS\' }\"></button></div><div ng-if=ctrl.toolbarSections.code class=quill__separator><button class=\"ql-blockquote quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.BLOCKQUOTE\' }\"></button> <button class=\"ql-code-block quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.CODE\' }\"></button></div><div class=quill__separator><button class=\"ql-clean quill__btn\" translate-attr=\"{ title: \'EDITOR.TOOLBAR.CLEAN\' }\"></button></div></div><div id={{ctrl.idEditor}} class=quill__editor ng-class=[customClassCss] ng-click=ctrl.focusEditor() ng-keyup=ctrl.writing() ng-mousedown=ctrl.returnEditor()></div></div><div class=pt8 layout=row layout-align=\"space-between center\"><div class=display-flex><button ng-if=\"ctrl.quill.hasFocus() && btnSave\" type=button class=\"altnav-action save mr8\" ng-click=ctrl.savedContent()><span translate=EDITOR.ACTION.SAVE></span></button> <button ng-if=\"ctrl.quill.hasFocus() && btnCancel\" type=button class=\"altnav-action cancel\" ng-click=ctrl.cancel()><span translate=EDITOR.ACTION.CANCEL></span></button></div><p ng-if=charactersMax class=\"md-caption text-gray-500\">{{ctrl.charactersCount}}/{{charactersMax}} <span translate=EDITOR.LABEL.COUNTER></span></p></div></div>");
$templateCache.put("app/directives/logs-accordion/logs-accordion.html","<div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"log in items\" ng-class=\"{\'opened\': log.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span translate=\"{{\'LOGS.ENUM.PAGES.\' + log.relationships.model.type.toUpperCase()}}\"></span> <span ng-if=log.relationships.sub_models>/ {{\'LOGS.ENUM.TABS.\' + log.relationships.sub_models[0].type.toUpperCase() | translate}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'LOGS.ENUM.OPERATIONS.\' + log.attributes.operation_type}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::log.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::log.relationships.enterprise.attributes.cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::log.relationships.user.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::log.relationships.user.attributes.username}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::log.attributes.operation_at | date: \'HH:mm\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::log.attributes.operation_at | date: \'dd/MM/yyyy\'}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"log.panelExpanded = !log.panelExpanded; log.panelExpanded && ctrl.modelData(log)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout=column class=\"pt16 pb16\"><p class=\"pb-4 text-sm text-gray-700\"><span translate=LOGS.LABEL.ID class=font-bold></span> <span copy-paste value={{log.attributes.model_data.id}}></span></p><div class=\"border border-solid border-gray-200 rounded-md w-full\"><md-table-container><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=LOGS.LABEL.ITEM></span></th><th md-column><span translate=LOGS.LABEL.VALUE></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in log.modelKey\" ng-if=log.modelValues[$index]><td md-cell translate class=w-1/4>{{\'LOGS.LABEL.\' + log.model.toUpperCase() + \'.\' + item.toUpperCase() }}</td><td md-cell class=w-3/4><span class=\"block pt4 pb4\">{{log.panelExpanded && ctrl.formatValue(item, log.modelValues[$index], log)}}</span></td><td id=quill-container class=hidden></td></tr><tr ng-if=\"!log.modelKey || log.modelKey.length == 0\"><td class=st-table-no-content colspan=2><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=LOGS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div></div></div><div class=st-expansion-footer ng-if=\"template === \'list\'\"><div layout layout-align=\"end center\" class=\"pt16 pb8\" flex><button type=button class=\"altnav-action light\" ng-click=ctrl.openHistory(log) translate=LOGS.ACTION.HISTORY></button></div></div></div></div></div>");
$templateCache.put("app/directives/menu/menu.html","<div id=menu><div class=st-nav-wrapper><div class=st-nav-aux layout=column><div class=st-company-area layout layout-align=\"center center\"><div class=\"image-holder no-border mr8\"><object class=image-holder-fallback ng-class=\"{\'company-holder\': !ctrl.myCompany.relationships.document}\" ng-attr-data={{ctrl.EnvironmentConfig.MEDIA}}/{{ctrl.myCompany.relationships.document.attributes.folder}} type=image/gif></object></div><div class=company-box><a can-access=INTERNALS,MANAGER,READ_ONLY,OPERATOR ng-click=ctrl.redirect() class=\"company-name cursor-pointer\">{{ctrl.myCompany.attributes.name}}</a> <span can-access=CLIENT,PROVIDER class=company-name>{{ctrl.myCompany.attributes.name}}</span> <span class=company-slogan>{{ctrl.myCompany.attributes.email}}</span></div></div><div><div class=\"pl16 mt16\" can-access=INTERNALS,MANAGER><md-menu md-position-mode=\"target-right target\" md-offset=\"0 48\"><button aria-label=\"Create new item\" class=\"altnav-action save w-full\" ng-click=$mdMenu.open($event)><span translate=\"{{\'MENU.ACTION.NEW_ITEM\'}}\"></span></button><md-menu-content width=180><md-menu-item ng-repeat=\"item in ctrl.newItems\"><md-button ng-click=ctrl.openAction(item) aria-label={{item}}><span translate=\"{{\'MENU.ACTION.\' + item.replaceAll(\'-\',\'_\').toUpperCase()}}\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><ul class=\"st-main-menu mt16 grow\" layout=column><li class=\"st-main-list p8\" can-access=INTERNALS,MANAGER,READ_ONLY><button type=button class=\"font-base font-semibold pl8 h-6 border-0 text-gray-700 bg-transparent\" ui-sref={{ctrl.menu.root.link}} layout><span class=mr8><img ng-src=assets/icons/menu/{{ctrl.menu.root.name}}.svg translate-attr=\"{alt: \'MENU.\' + ctrl.menu.root.name.toUpperCase() }\"></span><div class=\"h-6 leading-normal\" translate=\"{{ \'MENU.\' + ctrl.menu.root.name.toUpperCase()}}\" flex></div></button></li><li ng-repeat=\"(key, menu) in ctrl.menu\" ng-if=menu.length class=\"st-main-list p8\"><button type=button class=\"font-base font-semibold pl8 h-6 border-0 text-gray-700 align-center bg-transparent\" ng-click=\"ctrl.selectedParent = key\" layout><span class=mr8><img ng-src=assets/icons/menu/{{key}}.svg translate-attr=\"{alt: \'MENU.\' + key.toUpperCase() }\"></span><div class=\"h-6 leading-normal\" translate=\"{{ \'MENU.\' + key.toUpperCase()}}\" flex></div><i class=\"material-symbols-outlined rotate\" ng-class=\"{\'rotate-180\': key === ctrl.selectedParent}\">expand_more</i></button><ul class=st-sub-menu ng-class=\"{opened: key === ctrl.selectedParent}\"><li ng-repeat=\"item in menu\" class=sub-menu-item><a class=access-page ui-sref={{item.link}}><span class=list-style-circle></span> <span translate=\"{{ \'MENU.\' + item.name.toUpperCase()}}\"></span> <span ng-if=item.new class=\"absolute left-0\"><span class=\"w-2 h-2 block ml8 bg-red-400 rounded-full\"></span> </span></a><a ng-if=item.report class=\"absolute float-right right-0 top-1 report-icon\" ui-sref=\"{{item.name + \'-panel\'}}\"><i class=\"material-symbols-outlined text-base\">timeline</i></a></li></ul></li><li class=\"st-main-list p8 mt-auto\" can-access=INTERNALS,MANAGER><button type=button class=\"font-base font-semibold pl8 h-6 border-0 text-gray-700 bg-transparent\" ui-sref={{ctrl.menu.logs.link}} layout><span class=mr8><img ng-src=assets/icons/menu/{{ctrl.menu.logs.name}}.svg translate-attr=\"{alt: \'MENU.\' + ctrl.menu.logs.name.toUpperCase() }\"></span><div class=\"h-6 leading-normal\" translate=\"{{ \'MENU.\' + ctrl.menu.logs.name.toUpperCase()}}\" flex></div></button></li></ul></div></div></div>");
$templateCache.put("app/directives/navbar/navbar.directive.html","<div class=navbar layout layout-align=\"space-between center\"><div class=\"text-xs text-gray-600 box-content breadcrumb\"><div ng-repeat=\"locate in ctrl.getPath()\"><span class=\"capitalize leading-loose text-sm item\" ng-class=\"{ selected: $last }\" translate=\"{{\'NAVBAR.\' + locate.toUpperCase()}}\"></span> <span class=\"separator mr4\" ng-if=!$last><span class=\"text-sm font-bold m4\">/</span></span></div></div><div class=navbar-options layout layout-align=\"space-between center\"><div class=quick-functions can-access=INTERNALS,MANAGER><a href=https://ajuda.softruck.com/ target=_blank class=\"link-actions m8\" translate-attr=\"{ title: \'NAVBAR.TUTORIAL\' }\"><i class=\"material-symbols-outlined text-gray-500 text-xl\">help</i> </a><a ui-sref=files-list class=\"link-actions m8\" translate-attr=\"{ title: \'NAVBAR.FILES\' }\"><i class=\"material-symbols-outlined text-gray-500 text-xl\">folder</i></a></div><md-menu layout layout-align=\"start center\" md-position-mode=\"target-right target\" md-offset=\"12 48\"><a href=\"\" layout layout-align=\"start center\" class=\"user-options w-8 h-8 ml8 relative overflow-hidden rounded-full bg-white\" data-test=navbar.action.open_menu_user ng-click=$mdMenu.open()><object class=user-image-fallback type=image/gif></object></a><md-menu-content width=3><md-menu-item can-access=INTERNALS,MANAGER,READ_ONLY,CLIENT><md-button class=no-pad aria-label=Profile ng-click=ctrl.redirect()><div>{{ctrl.me.attributes.name}}</div></md-button></md-menu-item><md-menu-item can-access=INTERNALS,MANAGER,CLIENT><md-button aria-label=\"User Notifications\" ui-sref=user-notification><div translate=NAVBAR.NOTIFICATIONS></div></md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ctrl.logout() aria-label=Logout data-test=navbar.action.logout><div translate=NAVBAR.LOGOUT></div></md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/directives/navigator/navigator.directive.html","<div class=st-filter-bar layout layout-align=\"space-between center\" flex><div class=screen-info layout layout-align=\"start center\" flex><div class=st-title translate=\"{{ \'NAVIGATOR.CRUMBS.\' + ctrl.path[1].toUpperCase()}}\"></div><div ng-if=amount class=\"st-caption navigator-amount-title ml8\"><span translate=NAVIGATOR.LABEL.TOTAL_AMOUNT></span> <span class=ml8>{{amount | number:\'0\'}}</span></div><a ng-if=ctrl.$scope.contract.stats href=\"\" class=icon-helper ng-click=ctrl.goToStats()><i class=material-symbols-outlined>timeline</i></a></div><div can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><button ng-if=ctrl.$scope.contract.archive type=button ng-click=ctrl.archive() class=altnav-action layout layout-align=\"center center\" aria-label=Archive><span translate=NAVIGATOR.ACTION.ARCHIVE></span></button> <button ng-if=ctrl.$scope.contract.unarchive type=button ng-click=ctrl.unarchive() class=altnav-action layout layout-align=\"center center\" aria-label=Unarchive><span translate=NAVIGATOR.ACTION.UNARCHIVE></span></button> <button ng-if=ctrl.$scope.contract.delete type=button ng-click=ctrl.delete() class=\"altnav-action delete\" layout layout-align=\"center center\" aria-label=Delete><span translate=NAVIGATOR.ACTION.DELETE></span></button></div></div>");
$templateCache.put("app/directives/pagination/pagination.html","<div layout=column layout-align=\"center center\"><p class=\"text-sm text-gray-700 pb-1\"><span class=\"font-semibold text-gray-900\">{{ctrl.current()}}</span> <span>-</span> <span class=\"font-semibold text-gray-900\">{{ctrl.total()}}</span> <span translate=PAGINATION.LABEL.OF></span> <span class=\"font-semibold text-gray-900\">{{count}}</span></p><div layout><button ng-disabled=\"current === 1\" ng-click=ctrl.prev() class=\"no-button altnav-action light text-sm font-bold leading-tight text-gray-700\"><span translate=PAGINATION.ACTION.PREV></span></button> <button ng-disabled=\"(limit * current) >= count\" ng-click=ctrl.next() class=\"no-button altnav-action light text-sm font-bold leading-tight text-gray-700 ml8\"><span translate=PAGINATION.ACTION.NEXT></span></button></div></div>");
$templateCache.put("app/directives/panel-header/panel-header.html","<div class=\"panel-header-wrapper w-full\" flex><ul class=\"panel-header box-content text-xs text-gray-500 uppercase\" layout layout-align=\"space-between center\"><li class=\"panel-item w-10\" ng-if=ctrl.hasCheckbox><input type=checkbox ng-model=ctrl.selected aria-label=Selected ng-change=ctrl.select()></li><li class=\"panel-item items-center\" ng-class=\"{\'sort\': ctrl.$scope.sort, \'active\': header.active}\" ng-repeat=\"header in ctrl.$scope.data\" flex><div ng-if=header.sort layout layout-align=\"{{header.layoutRawAlign || \'start center\'}}\"><button type=button class=\"no-button uppercase text-gray-500 no-padding\" ng-click=ctrl.order(header) ng-disabled=ctrl.$rootScope.requestLoading>{{header.label}}</button> <i class=\"material-symbols-outlined order-icon text-sm\" ng-class=ctrl.getDirection(header)>arrow_upward</i></div><div ng-if=!header.sort layout layout-align=\"{{header.layoutRawAlign || \'start center\'}}\"><span>{{header.label}}</span></div></li></ul></div>");
$templateCache.put("app/directives/push-notification-bar/push-notification-bar.directive.html","<div class=notification-bar layout layout-align=\"space-between center\" ng-show=ctrl.showBar hide-xs hide-sm><b class=message translate><span translate=NOTIFICATION_BAR.LABEL.MESSAGE></span></b><div class=navigator-action-bar layout layout-align=\"end center\"><button type=button ng-click=ctrl.activate() ng-disabled=ctrl.processing class=altnav-action><i class=material-symbols-outlined>notifications</i> <span ng-if=!ctrl.processing translate=NOTIFICATION_BAR.ACTIONS.ACTIVATE></span> <span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span></button> <button type=button ng-click=ctrl.dismissBar() class=\"ml12 altnav-action\"><i class=material-symbols-outlined>close</i> <span translate=NOTIFICATION_BAR.ACTIONS.CLOSE></span></button></div></div>");
$templateCache.put("app/directives/street-view/street-view.directive.html","<div id=street-view><iframe lat={{lat}} lng={{lng}} width={{width}} height={{height}} style=border:0 loading={{loading}} ng-src={{ctrl.src}}></iframe></div>");
$templateCache.put("app/directives/user-asset-permissions/user-asset-permissions.html","<div flex><div class=mb8 ng-repeat=\"item in ctrl.users\"><div layout layout-align=\"space-between center\"><div><div><span class=\"text-xs font-bold leading-tight text-gray-700\">{{item.relationships.user.attributes.name}}</span> <span class=\"st-tags xs\" ng-if=item.relationships.user.attributes.deactivated_at><span translate=USER_ASSET_PERMISSIONS.LABEL.DEACTIVATED></span></span></div><a ng-href=\"https://api.whatsapp.com/send?phone={{item.relationships.user.attributes.phone1}}\" target=_blank><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.user.attributes.phone1 | phoneFilter}}</div></a></div><div><div can-access=INTERNALS,MANAGER><md-menu md-position-mode=\"target-right target\"><a href=\"\" class=m4 ng-click=$mdMenu.open($event)><i class=\"material-symbols-outlined text-gray-500\">more_vert</i></a><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button aria-label=Activate><a ng-click=ctrl.toggleState(item) class=link-actions><span class=st-subhead translate=\"{{item.relationships.user.attributes.deactivated_at ? \'USER_ASSET_PERMISSIONS.ACTION.ACTIVATE\' : \'USER_ASSET_PERMISSIONS.ACTION.DEACTIVATE\'}}\"></span></a></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Remove Association\"><a ng-click=\"ctrl.removeUser(item, $index)\" class=link-actions><span class=st-subhead translate=USER_ASSET_PERMISSIONS.ACTION.DISASSOCIATE></span></a></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div ng-if=\"ctrl.users.length === 0\"><p class=\"mt16 mb16 text-xs leading-tight text-gray-500 truncate\" translate=USER_ASSET_PERMISSIONS.HINT.NO_USER_ASSOCIATED></p></div></div>");
$templateCache.put("app/directives/user-list/user-horizontal-list.html","<div><div ng-if=\"ctrl.users.length == 1\"><div class=\"text-xs font-bold text-gray-700 truncate\">{{ctrl.users[0].attributes.name}}</div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{ctrl.users[0].attributes.phone | phoneFilter}}</div></div><ul ng-if=\"ctrl.users.length > 1\" class=user-horizontal-short-list><li class=user-short-item ng-repeat=\"u in ::ctrl.users | limitTo: 3 \"><a href=\"\" class=user-item ng-class=ctrl.$scope.size ng-click=\"ctrl.$scope.clickable && ctrl.open()\"><div ng-if=ctrl.$scope.initials class=user-item-initial>{{u.attributes.initials}}</div><md-tooltip md-direction=top ng-if=u.attributes.name><span>{{u.attributes.name}}</span></md-tooltip></a></li></ul><div ng-if=\"ctrl.$scope.recordable && ctrl.users.length === 0\"><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=VEHICLE_USERS.LABEL.NO_RECORDS></span></div></div>");
$templateCache.put("app/directives/user-list/user-vertical-list.html","<div><div ng-if=ctrl.$scope.users><div class=\"vehicle-users-short-item mb8\" layout layout-align=\"space-between center\" ng-repeat=\"u in ::ctrl.$scope.users\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback user-holder\" ng-attr-data={{u.picture.address}} type=image/gif></object></span><div layout=column flex><div class=\"text-xs text-gray-700 font-semibold truncate\">{{u.attributes.name}}</div><div layout ng-if=u.attributes.phone1><div class=\"text-xs text-slate-500 truncate\">{{u.attributes.phone1 | phoneFilter}}</div><a class=ml12 ng-href=\"https://api.whatsapp.com/send?phone={{u.attributes.phone1}}\" target=_blank><img src=assets/holders/whatsapp.svg alt=whatsapp height=18></a></div></div></div><div ng-if=\"ctrl.$scope.recordable && ctrl.$scope.users.length === 0\"><span class=\"text-sm text-gray-500\" translate=VEHICLE_USERS.LABEL.NO_RECORDS></span></div></div></div>");
$templateCache.put("app/components/actions/form-parts/_chips-form.html","<div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=FORM_PARTS.LABEL.SERIAL></label><input class=\"st-input-type input-type\" type=text name=serial ng-model=ctrl.chip.serial ui-number-mask=0 ui-hide-group-sep autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.SERIAL\' }\" maxlength=20 required></div><div class=st-input-container layout=column flex><label class=st-label translate=FORM_PARTS.LABEL.NUMBER></label><input class=\"st-input-type input-type\" type=text name=number ng-model=ctrl.chip.number ui-br-phone-number-mask autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.NUMBER\' }\" maxlength=20 required></div><div class=st-input-container layout=column flex><label class=st-label translate=FORM_PARTS.LABEL.SERVICE_PROVIDER></label><input class=\"st-input-type input-type\" type=text name=service_provider ng-model=ctrl.chip.service_provider ui-hide-group-sep autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.SERVICE_PROVIDER\' }\" required></div><div class=st-input-container layout=column flex><label class=st-label translate=FORM_PARTS.LABEL.CARRIER></label><input class=\"st-input-type input-type\" type=text name=carrier ng-model=ctrl.chip.carrier ui-hide-group-sep autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.CARRIER\' }\" required></div></div>");
$templateCache.put("app/components/actions/form-parts/_device-info.html","<div layout layout-align=\"space-between center\"><div flex ng-include src=\"\'app/components/actions/form-parts/_device-model.html\'\"></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FORM_PARTS.LABEL.IMEI></label><input class=\"st-input-type input-type\" type=text name=imei ng-model=ctrl.device.imei ng-pattern=/^[0-9]{1,15}$/ autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.TYPE_IMEI\' }\" maxlength=15 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.imei.$error\"><div class=st-input-validation ng-show=ctrl.form.imei.$error.pattern translate=FORM_PARTS.VALIDATION.IMEI_PATTERN></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FORM_PARTS.LABEL.IDENTIFIER></label><input class=\"st-input-type input-type\" type=text name=name ng-model=ctrl.device.name ui-hide-group-sep autocomplete=off translate-attr=\"{ placeholder: \'FORM_PARTS.PLACEHOLDER.TYPE_NAME\' }\" required></div></div>");
$templateCache.put("app/components/actions/form-parts/_device-model.html","<!-- device type--><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FORM_PARTS.LABEL.DEVICE_MODEL></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'FORM_PARTS.PLACEHOLDER.TYPE_MODEL\' | translate}}\" md-input-name=autocomplete_device_model md-selected-item=ctrl.selectedModel md-search-text=ctrl.deviceModel md-items=\"item in ctrl.getDeviceType(ctrl.deviceModel)\" md-item-text=item.attributes.alias md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match required md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback device-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><span><span md-highlight-text=ctrl.deviceModel class=\"st-subhead-lite capitalize\">{{item.attributes.brand_alias}}</span> <span md-highlight-text=ctrl.deviceModel class=\"st-subhead ml8\">{{item.attributes.alias}}</span> </span><span><span class=st-caption translate=\"{{\'FORM_PARTS.DEVICE_TYPE.\' + item.attributes.type}}\"></span></span></div><div><div class=device-model ng-class=\"{\'supported\': item.attributes.supported}\"></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.deviceModel}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_device_model.$invalid\"><div class=st-input-validation ng-message=required translate=FORM_PARTS.VALIDATION.DEVICE_MODEL></div></div></div>");
$templateCache.put("app/components/actions/form-parts/_enterprises-search.html","<div layout layout-align=\"space-between center\"><!-- enterprise --><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FORM_PARTS.LABEL.ENTERPRISE></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'FORM_PARTS.PLACEHOLDER.TYPE_ENTERPRISE\' | translate}}\" md-input-name=autocomplete_enterprise md-selected-item=ctrl.selectedEnterprise md-selected-item-change=\"ctrl.addItem(\'selectedEnterprises\', \'selectedEnterprise\')\" md-search-text=ctrl.enterprise md-items=\"item in ctrl.getEnterprises(ctrl.enterprise)\" md-item-text=item.attributes.name md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback company-holder\" ng-attr-data={{item.relationships.picture.address}} type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\"><span><span md-highlight-text=ctrl.enterprise class=st-subhead>{{item.attributes.name}}</span> <span md-highlight-text=ctrl.enterprise class=\"st-subhead-lite ml8\">{{item.attributes.fantasy_name}}</span> </span><span><span class=st-caption>{{item.attributes.email}}</span></span></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.enterprise}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_enterprise.$invalid\"><div class=st-input-validation ng-message=required translate=FORM_PARTS.VALIDATION.ENTERPRISE></div></div></div></div>");
$templateCache.put("app/components/actions/form-parts/_full-table.html","<md-table-container><table class=st-main-table md-table><thead class=\"st-table-head table-underline\" md-head><tr md-row><th md-column><span translate=FORM_PARTS.LABEL.DEVICE_TYPE></span></th><th md-column><span translate=FORM_PARTS.LABEL.IMEI></span></th><th md-column><span translate=FORM_PARTS.LABEL.IDENTIFIER></span></th><th md-column><span translate=FORM_PARTS.LABEL.SERIAL></span></th><th md-column><span translate=FORM_PARTS.LABEL.NUMBER></span></th><th md-column><span translate=FORM_PARTS.LABEL.SERVICE_PROVIDER></span></th><th md-column><span translate=FORM_PARTS.LABEL.CARRIER></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items.data\"><td md-cell>{{ctrl.selectedModel.attributes.brand_alias}} {{ctrl.selectedModel.attributes.alias}}</td><td md-cell>{{item.devices.imei}}</td><td md-cell>{{item.devices.name}}</td><td md-cell>{{item.chips.serial}}</td><td md-cell>{{item.chips.number}}</td><td md-cell>{{item.chips.service_provider}}</td><td md-cell>{{item.chips.carrier}}</td><td md-cell><a href=\"\" ng-click=ctrl.removeDeviceFromList(item)><i class=material-symbols-outlined>delete_outline</i></a></td></tr><tr ng-if=\"(!ctrl.items.data || ctrl.items.data.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=FORM_PARTS.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/actions/form-parts/_short-chip-table.html","<md-table-container><table class=st-main-table md-table><thead class=\"st-table-head table-underline\" md-head><tr md-row><th md-column><span translate=FORM_PARTS.LABEL.SERIAL></span></th><th md-column><span translate=FORM_PARTS.LABEL.NUMBER></span></th><th md-column><span translate=FORM_PARTS.LABEL.SERVICE_PROVIDER></span></th><th md-column><span translate=FORM_PARTS.LABEL.CARRIER></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items.data\"><td md-cell>{{item.attributes.serial}}</td><td md-cell>{{item.attributes.number | phoneFilter}}</td><td md-cell>{{item.attributes.service_provider}}</td><td md-cell>{{item.attributes.carrier}}</td><td md-cell><a href=\"\" ng-click=ctrl.removeChipFromList(item)><i class=material-symbols-outlined>delete_outline</i></a></td></tr><tr ng-if=\"(!ctrl.items.data || ctrl.items.data.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=FORM_PARTS.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/actions/form-parts/_short-device-table.html","<md-table-container><table class=st-main-table md-table><thead class=\"st-table-head table-underline\" md-head><tr md-row><th md-column><span translate=FORM_PARTS.LABEL.DEVICE_TYPE></span></th><th md-column><span translate=FORM_PARTS.LABEL.IMEI></span></th><th md-column><span translate=FORM_PARTS.LABEL.IDENTIFIER></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items.data\"><td md-cell>{{ctrl.selectedModel.attributes.brand_alias}} {{ctrl.selectedModel.attributes.alias}}</td><td md-cell>{{item.attributes.imei}}</td><td md-cell>{{item.attributes.name}}</td><td md-cell><a href=\"\" ng-click=ctrl.removeDeviceFromList(item)><i class=material-symbols-outlined>delete_outline</i></a></td></tr><tr ng-if=\"(!ctrl.items.data || ctrl.items.data.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=FORM_PARTS.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/actions/from-out-source/from-out-source.dialog.html","<md-dialog ng-controller=\"FromOutSourceController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=70 class=\"st-dialog h-4/5\" aria-label=\"From out source\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div layout=column layout-align=\"start stretch\"><div layout><span class=\"inline-block text-xl font-bold text-gray-900\" translate=IMPORT_FROM_FILES.TITLE.IMPORT_MAIN></span> <span class=\"ml12 mt4\"><progress ng-if=ctrl.loading></progress></span></div><div ng-if=\"ctrl.activeStep > 2\"><span class=\"text-sm leading-tight text-gray-500 truncate mr8\">{{ctrl.fileName}}</span> <span class=\"bg-blue-100 rounded-md p2\" ng-if=\"ctrl.activeStep < 4\"><button class=\"no-button text-sm font-medium leading-tight text-blue-700\" ngf-select=ctrl.uploadFiles($files) ngf-pattern=ctrl.pattern ngf-accept=ctrl.pattern ngf-max-size=10MB ngf-multiple=false translate=IMPORT_FROM_FILES.ACTION.CHANGE_FILE></button></span></div></div><button type=button class=\"no-button text-gray-500\" aria-label=Cancel ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></button></div></div><div class=st-dialog-wrapper flex><form class=\"st-dialog-body h-full\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.prepareToPush()\" novalidate layout=column layout-align=\"space-between stretch\"><!-- first step --><div ng-if=\"ctrl.activeStep === 1\"><div class=p16><div><span class=\"text-base font-bold leading-tight text-gray-900\" translate=IMPORT_FROM_FILES.LABEL.WHAT_TO_IMPORT></span></div><div><span class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.MAX_ITEMS translate-values=\"{ max: \'{{ctrl.maxImports}}\' }\"></span></div></div><div class=\"st-input-container m4\" flex=40><md-select class=st-input-select ng-model=ctrl.selectedEntity aria-label=Importables ng-change=ctrl.selectEntity()><md-option disabled></md-option><md-option ng-repeat=\"(k,v) in ctrl.importables\" ng-value=k ng-disabled=!v.available>{{\'IMPORT_FROM_FILES.ENUM.ENTITY.\' + k.toUpperCase() | translate}}</md-option></md-select></div></div><!-- import file --><div ng-if=\"ctrl.activeStep === 2\"><div layout=column layout-align=\"space-between stretch\" class=\"h-inherit p16\"><div><div class=\"text-base font-bold leading-tight text-gray-900\" translate=IMPORT_FROM_FILES.LABEL.SELECT_FILE></div><div class=\"text-sm font-medium leading-tight text-gray-500 mt8 mb8\" translate=IMPORT_FROM_FILES.LABEL.BE_SURE></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.SHEET_HEADER></div><div ngf-drop=ctrl.uploadFiles($files) ngf-pattern=ctrl.pattern ngf-accept=ctrl.pattern class=\"border-2 border-dashed border-gray-300 rounded-md p24 mt16 mb16 bg-gray-100\" ngf-max-size=10MB ngf-multiple=false ngf-drag-over-class=\"\'dragover\'\"><div layout layout-align=\"start center\"><div class=mr16><img src=assets/holders/document.svg alt=\"No results\" height=60></div><div class=ml16 layout=column><div><span class=\"text-sm font-normal leading-tight text-gray-700\" translate=IMPORT_FROM_FILES.LABEL.IMPORT_OR_DRAG></span> <span><button class=\"no-button text-sm font-bold leading-tight text-gray-700\" ngf-select=ctrl.uploadFiles($files) ngf-pattern=ctrl.pattern ngf-accept=ctrl.pattern ngf-max-size=10MB ngf-multiple=false translate=IMPORT_FROM_FILES.ACTION.FROM_FILE></button> </span><span class=\"text-sm font-normal leading-tight text-gray-700\" translate=IMPORT_FROM_FILES.LABEL.TO_LOAD></span></div><div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.SUPPORTED></div></div></div></div></div><div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.REQUIRED_DATA></div><div class=mt8><span class=\"mr8 st-tags\" ng-repeat=\"k in ctrl.importables[ctrl.selectedEntity].required\"><span translate=\"{{\'IMPORT_FROM_FILES.ENUM.KEYS.\' + ctrl.selectedEntity.toUpperCase() + \'.\' + k.toUpperCase()}}\"></span></span></div></div></div></div></div><!-- preview --><div layout ng-if=\"ctrl.activeStep === 3\"><div flex=65 class=mr12><div layout=column><div class=ml4 layout layout-align=\"space-between center\"><enterprises-autocomplete flex=50 clear-button=true form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete><device-model-autocomplete flex=50 form=ctrl.form ng-if=\"ctrl.selectedEntity === \'devices\'\" search-text=ctrl.deviceModel selected-item=ctrl.selectedModel></device-model-autocomplete><div class=st-input-container layout=column flex=50 ng-if=\"ctrl.selectedEntity === \'vehicles\'\"><label class=\"st-label st-required\" translate=IMPORT_FROM_FILES.LABEL.VEHICLE_TYPE></label><md-select class=st-input-select name=type ng-model=ctrl.selectedType aria-label=\"Select Type\" required md-no-asterisk><md-option ng-repeat=\"t in ctrl.vehicleTypes\" value={{t}} translate=\"{{\'NEW_VEHICLE.ENUM.TYPES.\' + t.toUpperCase()}}\"></md-option></md-select></div></div><div class=\"ml12 mr12 mt12 overflow-auto border border-gray-200 rounded-sm border-solid\"><table class=import-table><thead class=import-table-head><tr><th></th><th class=\"text-xs font-bold leading-tight text-center text-gray-500\" ng-repeat=\"h in ctrl.tableColHolder track by $index\">{{h}}</th></tr></thead><tbody class=import-table-body><tr><td class=\"text-xs font-bold leading-tight text-center text-gray-500\">1</td><td ng-repeat=\"i in ctrl.importables[ctrl.selectedEntity].keys\"><span class=\"text-xs font-bold leading-tight text-gray-700 whitespace-nowrap\" translate=\"{{\'IMPORT_FROM_FILES.ENUM.KEYS.\' + (ctrl.selectedEntity + \'.\' + i).toUpperCase()}}\"></span></td></tr><tr ng-repeat=\"r in ctrl.tableRowHolder | limitTo: 8\" ng-if=\"ctrl.previewData.length === 0\"><td class=\"text-xs font-bold leading-tight text-center text-gray-500\">{{r}}</td><td class=\"text-xs font-bold leading-tight text-center text-gray-500\" ng-repeat=\"h in ctrl.tableColHolder track by $index\"></td></tr><tr ng-repeat=\"(k,v) in ctrl.previewData | limitTo: 8  track by $index\" ng-if=\"ctrl.previewData.length > 0\"><td class=\"text-xs font-bold leading-tight text-center text-gray-500\">{{$index + 2}}</td><td ng-repeat=\"i in ctrl.importables[ctrl.selectedEntity].keys\"><span class=truncate>{{v[i]}}</span></td></tr></tbody></table></div><div flex><div class=st-input-container layout=column flex=50><label class=st-label translate=IMPORT_FROM_FILES.LABEL.BATCH></label><input class=\"st-input-type input-type\" type=text name=batch maxlength=50 ng-model=ctrl.batch autocomplete=off></div></div></div></div><div flex=35 class=pr16><div layout=column><div><span class=\"text-base font-bold leading-tight text-gray-900\" translate=IMPORT_FROM_FILES.LABEL.DATA_ASSOCIATION></span></div><div><span class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.SHEET_HEADER_HELPER></span></div><br><div><div layout><div flex=40 class=\"text-xs font-bold leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.DATA></div><div flex=60 class=\"text-xs font-bold leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.CORRESPONDENT></div></div><div layout=column ng-repeat=\"i in ctrl.importables[ctrl.selectedEntity].keys\"><div layout layout-align=\"space-between center\"><div flex><span class=\"st-tags whitespace-nowrap\" ng-class=\"{\'st-required\': ctrl.importables[ctrl.selectedEntity].required.includes(i)}\" translate=\"{{\'IMPORT_FROM_FILES.ENUM.KEYS.\' + (ctrl.selectedEntity + \'.\' + i).toUpperCase()}}\"></span></div><div flex=nogrow class=\"text-gray-500 mr8\"><i class=material-symbols-outlined>arrow_right</i></div><div flex=60><div class=\"st-input-container container-sm\"><md-select class=st-input-select ng-model=ctrl.desiredKeys[$index] ng-change=\"ctrl.mapKeys($index, i)\" aria-label=Keys ng-required=ctrl.importables[ctrl.selectedEntity].required.includes(i) md-no-asterisk><md-option ng-repeat=\"option in ctrl.fileKeys\" ng-value=option>{{option}}</md-option></md-select></div></div></div></div></div></div></div></div><!-- final --><div ng-if=\"ctrl.activeStep === 4\"><div layout=column class=m16><div><div><span class=\"text-base font-bold leading-tight text-gray-900\" translate=IMPORT_FROM_FILES.LABEL.GENERAL></span></div><div><span class=\"text-sm font-medium leading-tight text-gray-500\" translate=IMPORT_FROM_FILES.LABEL.CHECK_DATA></span></div></div><div layout class=mt12><div flex=30 class=\"rounded-md bg-gray-100 p16 mr16\"><div class=\"text-base font-bold leading-tight text-gray-900\">{{ctrl.selectedEnterprise.attributes.name}}</div><div class=\"text-sm font-medium leading-tight text-gray-500\">{{ctrl.selectedEnterprise.attributes.cnpj}}</div></div><div flex=30 class=\"rounded-md bg-gray-100 p16\" ng-if=\"ctrl.selectedEntity === \'devices\'\"><div class=\"text-base font-bold leading-tight text-gray-900\">{{ctrl.selectedModel.attributes.brand_alias}}</div><div class=\"text-sm font-medium leading-tight text-gray-500\">{{ctrl.selectedModel.attributes.alias}}</div></div></div></div><md-table-container class=\"m12 border border-solid border-gray-200 h-96\"><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column ng-repeat=\"k in ctrl.selectedKeys\"><span translate=\"{{\'IMPORT_FROM_FILES.ENUM.KEYS.\' + (ctrl.selectedEntity + \'.\' + k).toUpperCase()}}\"></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr ng-repeat=\"item in ctrl.itemsForUpload.data track by $index\" ng-class=\"{\n                  \'bg-yellow-50\': item.duplicated && !item.empty,\n                  \'bg-red-100\': item.empty\n                }\" class=no-bg-white md-row><td md-cell ng-repeat=\"(k, v) in item.attributes\"><div class=relative ng-class=\"{\n                      \'pt16\': item.duplicated,\n                      \'pt8\': item.empty && !item.duplicated\n                    }\"><span ng-if=\"item.duplicatedKeys.includes(k) && item.duplicated\" class=\"st-tags st-tags-sm absolute top-0 left-0 bg-yellow-300 text-yellow-800\" translate=IMPORT_FROM_FILES.LABEL.TAG_DUPLICATED></span> <span ng-if=\"item.emptyKeys.includes(k) && item.empty\" class=\"st-tags st-tags-sm absolute top-0 left-0 bg-red-300 text-red-800\" translate=IMPORT_FROM_FILES.LABEL.TAG_REQUIRED></span> <span ng-if=\"k === \'type\'\" translate=\"{{\'NEW_VEHICLE.ENUM.TYPES.\' + (v).toUpperCase()}}\"></span> <span ng-if=\"k !== \'type\'\">{{v}}</span></div></td><td md-cell><a href=\"\" ng-click=ctrl.removeItemFromList($index)><i class=material-symbols-outlined>delete_outline</i></a></td></tr><tr ng-if=\"(!ctrl.itemsForUpload.data || ctrl.itemsForUpload.data.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=\"{{ctrl.selectedKeys.length + 1}}\"><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=104> <span class=\"no-content-text mt8\" translate=FILES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><div layout=row layout-align=\"space-between center\" class=\"ml12 mr12\"><div><p ng-if=ctrl.disabledSubmit class=\"md-caption text-red-600\"><sup>*</sup> <span translate=IMPORT_FROM_FILES.VALIDATION.DUPLICATED_ITEMS></span></p><p ng-if=\"!ctrl.disabledSubmit && ctrl.exceededLimit\" class=\"md-caption text-red-600\"><sup>*</sup> <span translate=IMPORT_FROM_FILES.VALIDATION.MAX_ITEMS translate-values=\"{ max: \'{{ctrl.maxImports}}\' }\"></span></p></div><div><p class=md-caption ng-class=\"{\n              \'text-gray-700\': ctrl.itemsForUpload.data.length <= ctrl.maxImports,\n              \'text-red-700\': ctrl.itemsForUpload.data.length > ctrl.maxImports\n            }\">{{ctrl.itemsForUpload.data.length}}/{{ctrl.maxImports}}</p></div></div></div><div layout layout-align=\"space-between center\" class=m16><div ng-if=\"ctrl.activeStep > 1\"><button type=button class=\"altnav-action cancel\" aria-label=Back ng-click=\"ctrl.activeStep = ctrl.activeStep - 1\"><span translate=IMPORT_FROM_FILES.ACTION.BACK></span></button></div><div ng-if=\"ctrl.activeStep === 3\"><button type=submit class=\"altnav-action save\" aria-label=\"Validate submition\" ng-disabled=\"ctrl.formatting || (ctrl.form.$submitted && ctrl.form.$invalid)\"><span translate=IMPORT_FROM_FILES.ACTION.NEXT></span></button></div><div ng-if=\"ctrl.activeStep === 4\"><button type=button class=\"altnav-action save\" aria-label=\"Validate submition\" ng-click=ctrl.createItens() ng-disabled=\"ctrl.processing || ctrl.disabledSubmit || ctrl.exceededLimit\"><span translate=IMPORT_FROM_FILES.ACTION.IMPORT></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/components/actions/new-chip/new-chip.dialog.html","<md-dialog ng-controller=\"NewChipController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=60 class=st-dialog aria-label=\"New Chip\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_CHIP.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_CHIP.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><div flex=60><enterprises-autocomplete clear-button=true form=ctrl.form includes=ctrl.enterpriseIncludes search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_CHIP.LABEL.PROVIDER></label><md-autocomplete class=st-input-autocomplete data-test=new_chip.service_provider md-clear-button=false md-input-name=service_provider md-item-text=item.name md-items=\"item in ctrl.getServiceProvider(ctrl.chip.service_provider)\" md-min-length=0 md-no-cache md-search-text=ctrl.chip.service_provider md-search-text-change=\"ctrl.chip.service_provider = ctrl.chip.service_provider.substring(0,15)\" ng-disabled=ctrl.chip.attributes.from_softruck placeholder=\"{{\'NEW_CHIP.PLACEHOLDER.TYPE_SERVICE_PROVIDER\' | translate}}\" required><md-item-template><span class=\"st-caption text-gray-700\">{{item.name}}</span></md-item-template></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.service_provider.$error\"><div class=st-input-validation ng-show=ctrl.form.service_provider.$error.required translate=NEW_CHIP.VALIDATION.SERVICE_PROVIDER></div></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_CHIP.LABEL.SERIAL></label><input class=\"st-input-type input-type\" type=text name=serial data-test=serial ng-model=ctrl.chip.serial autocomplete=off translate-attr=\"{ placeholder: \'NEW_CHIP.PLACEHOLDER.TYPE_SERIAL\' }\" maxlength=20 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.serial.$error\"><div class=st-input-validation ng-show=ctrl.form.serial.$error.required translate=NEW_CHIP.VALIDATION.SERIAL></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_CHIP.LABEL.NUMBER></label><input class=\"st-input-type input-type\" type=text name=number data-test=number ng-model=ctrl.chip.number autocomplete=off translate-attr=\"{ placeholder: \'NEW_CHIP.PLACEHOLDER.TYPE_NUMBER\' }\" maxlength=20 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.number.$error\"><div class=st-input-validation ng-show=ctrl.form.number.$error.required translate=NEW_CHIP.VALIDATION.NUMBER></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.CARRIER></label><input class=\"st-input-type input-type\" type=text name=carrier data-test=carrier ng-model=ctrl.chip.carrier autocomplete=off translate-attr=\"{ placeholder: \'NEW_CHIP.PLACEHOLDER.TYPE_CARRIER\' }\"></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.APN></label><input class=\"st-input-type input-type\" type=text name=apn data-test=apn ng-model=ctrl.chip.apn autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.APN_USERNAME></label><input class=\"st-input-type input-type\" type=text name=apn_username data-test=apn_username ng-model=ctrl.chip.apn_username autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.APN_PASSWORD></label><input class=\"st-input-type input-type\" type=text name=apn_password data-test=apn_password ng-model=ctrl.chip.apn_password autocomplete=off></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.PIN></label><input class=\"st-input-type input-type\" type=text name=pin data-test=pin ng-model=ctrl.chip.pin autocomplete=off maxlength=4></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.PUK></label><input class=\"st-input-type input-type\" type=text name=puk data-test=puk ui-hide-group-sep ng-model=ctrl.chip.puk autocomplete=off maxlength=8></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.PLAN_SIZE></label><input class=\"st-input-type input-type\" type=text name=plan_size data-test=plan_size ng-model=ctrl.chip.plan_size autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_CHIP.LABEL.STATUS></label><input class=\"st-input-type input-type\" type=text name=status data-test=status ng-model=ctrl.chip.status autocomplete=off></div></div></div><br><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.close() data-test=cancel><span translate=NEW_CHIP.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save data-test=save><span translate=NEW_CHIP.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-device/new-device.dialog.html","<md-dialog ng-controller=\"NewDeviceController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=60 class=st-dialog aria-label=\"New device\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_DEVICE.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_DEVICE.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><enterprises-autocomplete flex clear-button=!ctrl.checkChangableItem() disabled-item=ctrl.checkChangableItem() form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete><device-model-autocomplete flex form=ctrl.form search-text=ctrl.deviceModel selected-item=ctrl.selectedModel></device-model-autocomplete></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_DEVICE.LABEL.IMEI></label><input class=\"st-input-type input-type\" type=text name=imei ng-model=ctrl.device.imei ng-pattern=/^[0-9]{1,20}$/ autocomplete=off translate-attr=\"{ placeholder: \'NEW_DEVICE.PLACEHOLDER.TYPE_IMEI\' }\" maxlength=20 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.imei.$error\"><div class=st-input-validation ng-show=ctrl.form.imei.$error.required translate=NEW_DEVICE.VALIDATION.IMEI></div><div class=st-input-validation ng-show=ctrl.form.imei.$error.pattern translate=NEW_DEVICE.VALIDATION.IMEI_PATTERN></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_DEVICE.LABEL.IDENTIFIER></label><div class=relative flex><input autocomplete=off class=\"st-input-type input-type w-full\" maxlength=20 name=name ng-change=ctrl.checkDeviceName() ng-model=ctrl.device.name ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }\" required translate-attr=\"{ placeholder: \'NEW_DEVICE.PLACEHOLDER.TYPE_NAME\' }\" type=text ui-hide-group-sep><div ng-if=ctrl.checking class=\"absolute bottom-2 right-1 w-6 h-6 bg-white\" layout layout-align=\"center center\"><progress></progress></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_DEVICE.VALIDATION.NAME></div></div><div ng-if=\"ctrl.form.name.$invalid && !ctrl.checking\"><div class=st-input-validation ng-show=ctrl.form.name.$error.nameDeviceTaken translate=NEW_DEVICE.VALIDATION.USER_DEVICE_TAKEN></div></div><div ng-if=ctrl.selectedModel><div class=st-input-hint translate=\"{{ \'DEVICES.HINT.PROTOCOL.\' + ctrl.selectedModel.attributes.protocol.toUpperCase()}}\"></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_DEVICE.LABEL.CODE></label><input class=\"st-input-type input-type\" type=text name=code maxlength=20 ng-model=ctrl.device.code ui-hide-group-sep autocomplete=off translate-attr=\"{ placeholder: \'NEW_DEVICE.PLACEHOLDER.TYPE_CODE\' }\"></div></div></div><div layout layout-align=\"space-between center\"><chips-autocomplete flex=50 filters=ctrl.chipsOptions.filters form=ctrl.form search-text=ctrl.chip selected-item=ctrl.selectedChip></chips-autocomplete><vehicles-autocomplete flex clear-button=true filters=ctrl.vehiclesOptions.filters form=ctrl.form required-item=false search-text=ctrl.vehicle selected-item=ctrl.selectedVehicle></vehicles-autocomplete></div><div><div class=st-input-container layout=column flex><label class=st-label flex><input type=checkbox ng-model=ctrl.device.activate> <span translate=NEW_DEVICE.LABEL.ACTIVATE></span></label><span class=\"st-caption ml24\" translate=NEW_DEVICE.HINT.ACTIVATE></span></div></div><br><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_DEVICE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=NEW_DEVICE.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-enterprise/new-enterprise.dialog.html","<md-dialog ng-controller=\"NewEnterpriseController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=60 class=st-dialog aria-label=\"New enterprise\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_ENTERPRISE.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_ENTERPRISE.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_ENTERPRISE.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.enterprise.attributes.name type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_ENTERPRISE.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_ENTERPRISE.LABEL.IDENTIFIER></label><input class=\"st-input-type input-type\" name=cnpj ng-model=ctrl.enterprise.attributes.cnpj type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.cnpj.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_ENTERPRISE.VALIDATION.CNPJ></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_ENTERPRISE.LABEL.EMAIL></label><input class=\"st-input-type input-type\" name=email ng-model=ctrl.enterprise.attributes.email type=email autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.email.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_ENTERPRISE.VALIDATION.MAIL></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.CONTACT></label><input class=\"st-input-type input-type\" name=contact_name ng-model=ctrl.enterprise.attributes.contact_name type=text autocomplete=off></div><!-- country selector --><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.COUNTRY></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'ENTERPRISES.PLACEHOLDER.SELECT_COUNTRY\' | translate}}\" md-input-name=autocomplete_country md-selected-item=ctrl.selectedCountry md-selected-item-change=ctrl.getTimezones() md-search-text=ctrl.country md-items=\"item in ctrl.getContries(ctrl.country)\" md-item-text=ctrl.translateCountryName(item.attributes) md-min-length=0 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match required><md-item-template><div class=item layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.country class=\"text-sm text-gray-700 font-bold\">{{ctrl.translateCountryName(item.attributes)}}</span></div></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.country}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_country.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_ENTERPRISE.VALIDATION.COUNTRY></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_ENTERPRISE.LABEL.TIMEZONE></label><md-select class=st-input-select name=timezone ng-model=ctrl.enterprise.attributes.timezone aria-label=\"Select Timezone\" md-no-asterisk required flex style=margin-bottom:6px ng-disabled=!ctrl.selectedCountry><md-option ng-repeat=\"tz in ctrl.timezoneList\" value={{tz}}>{{tz}}</md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.timezone.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_ENTERPRISE.VALIDATION.TIMEZONE></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.PHONE></label><input class=\"st-input-type input-type\" name=phone1 ng-model=ctrl.enterprise.attributes.phone1 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.PHONE></label><input class=\"st-input-type input-type\" name=phone2 ng-model=ctrl.enterprise.attributes.phone2 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.WEBPAGE></label><input class=\"st-input-type input-type\" name=webpage ng-model=ctrl.enterprise.attributes.webpage type=text autocomplete=off placeholder=\"E.g. www.softruck.com.br\"></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.ASSIST_CONTACT></label><input class=\"st-input-type input-type\" name=assistance_emergency_tel ng-model=ctrl.enterprise.attributes.assistance_emergency_tel type=text autocomplete=off placeholder=\"E.g. 0800 123 4567\"></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.THEIF_CONTACT></label><input class=\"st-input-type input-type\" name=theft_emergency_tel ng-model=ctrl.enterprise.attributes.theft_emergency_tel type=text autocomplete=off placeholder=\"E.g. 0800 123 4567\"></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.enterprise.attributes.description rows=4></textarea></div></div><br><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_ENTERPRISE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=NEW_ENTERPRISE.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-report-points/new-report-points.dialog.html","<md-dialog ng-controller=\"NewReportFileController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=60 class=st-dialog aria-label=\"New report points\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_REPORT_POINTS.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_REPORT_POINTS.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=\"st-form-inputs p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><!-- device --><div flex><devices-autocomplete form=ctrl.form min-length=3 on-item-change=ctrl.loadAssociationHistory(selectedItem) search-text=ctrl.device selected-item=ctrl.selectedDevice></devices-autocomplete></div><div class=\"border border-solid rounded-md border-gray-300 m8 overflow-auto\" ng-if=ctrl.selectedDevice><div class=\"h-12 pt4 pb4 pl16 pr16\" layout layout-align=\"space-between center\"><div flex=5></div><div flex=25><span class=\"text-xs font-bold leading-tight text-gray-500\" translate=NEW_REPORT_POINTS.LABEL.VEHICLE></span></div><div flex=30><span class=\"text-xs font-bold leading-tight text-gray-500\" translate=NEW_REPORT_POINTS.LABEL.ENTERPRISE></span></div><div flex=20><span class=\"text-xs font-bold leading-tight text-gray-500\" translate=NEW_REPORT_POINTS.LABEL.ASSOCIATED_AT></span></div><div flex=20><span class=\"text-xs font-bold leading-tight text-gray-500\" translate=NEW_REPORT_POINTS.LABEL.DESASSOCIATED_AT></span></div></div><md-radio-group ng-model=ctrl.selectedAssociation required><div class=\"border-0 border-t border-gray-300 pt8 pb8 pl16 pr16 h-12\" ng-repeat=\"item in ctrl.items.data\" layout layout-align=\"space-between start\" flex><div flex=5><md-radio-button ng-value=item aria-label=item-{{$index}} ng-click=ctrl.updateInputsFromAndTo(item)></md-radio-button></div><div flex=25><div class=\"text-xs font-bold leading-tight text-gray-700\"><span>{{item.relationships.vehicle.attributes.plate}}</span> <span class=\"text-xs font-bold leading-tight text-gray-500 ml8\" ng-if=item.relationships.vehicle.attributes.deleted_at>(<span translate=NEW_REPORT_POINTS.LABEL.DELETED_ITEM></span>)</span></div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.vehicle.attributes.vin}}</div></div><div flex=30><div><div class=\"text-xs font-bold leading-tight text-gray-700\">{{item.relationships.enterprise.attributes.name}}</div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.enterprise.attributes.cnpj}}</div></div></div><div flex=20><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</div></div><div flex=20><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.attributes.deleted_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</div></div></div></md-radio-group><div class=st-card-skeleton ng-if=\"ctrl.loading && !ctrl.items.data\" ng-repeat=\"skeleton in [1,2,3]\"><div layout class=\"pt8 pb8 pl16 pr16\"><span flex=5></span> <span flex=25 class=\"mr12 st-skeleton-item\"></span> <span flex=30 class=\"mr12 st-skeleton-item\"></span> <span flex=20 class=\"mr12 st-skeleton-item\"></span> <span flex=20 class=\"mr12 st-skeleton-item\"></span></div></div><div ng-if=\"!ctrl.loading && ctrl.items.data.length === 0\"><div class=\"text-sm leading-tight text-gray-500 truncate text-center p24\" translate=NEW_REPORT_POINTS.HINT.NOT_FOUND></div></div></div><div><div class=\"p8 mt16\"><div class=st-title-small translate=REPORT_POINTS.TITLE.CHOOSE_FORMAT></div><div class=st-caption translate=REPORT_POINTS.HINT.LINK></div></div><md-radio-group layout layout-align=\"space-between stretch\" ng-model=ctrl.report.type aria-labelledby=\"Report type\" class=m8 required><md-radio-button value=CSV flex=20 aria-label=CSV><span translate=NEW_REPORT_POINTS.TYPE.CSV></span></md-radio-button><md-radio-button value=XLSX flex=20 aria-label=XLSX><span translate=NEW_REPORT_POINTS.TYPE.XLSX></span></md-radio-button><md-radio-button value=KML flex=20 aria-label=KML><span translate=NEW_REPORT_POINTS.TYPE.KML></span></md-radio-button></md-radio-group></div><div class=\"p8 mt16\"><div class=st-title-small translate=NEW_REPORT_POINTS.TITLE.DEFINE_PERIOD></div><div class=st-caption translate=NEW_REPORT_POINTS.HINT.VALID_PERIOD translate-values=\"{ min: \'{{ctrl.report.from_date | date: \'dd/MM/yyyy\'}}\', max: \'{{ctrl.report.to_date | date: \'dd/MM/yyyy\'}}\' }\"></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=NEW_REPORT_POINTS.LABEL.FROM_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=from_date placeholder=\"HH:MM:SS DD/MM/AAAA\" type=text required data-test=new_report_points.from_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-change=ctrl.updatePeriod() ng-max=ctrl.report.max_date ng-min=ctrl.report.min_date ng-model=ctrl.report.from_date><div ng-if=\"ctrl.form.$submitted && ctrl.form.from_date.$error\" data-test=new_report_points.validation.from_date><div class=st-input-validation ng-show=ctrl.form.from_date.$error.required translate=NEW_REPORT_POINTS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.min translate=NEW_REPORT_POINTS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.max translate=NEW_REPORT_POINTS.VALIDATION.MAX></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_REPORT_POINTS.LABEL.TO_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=to_date placeholder=\"HH:MM:SS DD/MM/AAAA\" type=text required data-test=new_report_points.to_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-change=ctrl.updatePeriod() ng-max=ctrl.report.max_date ng-min=ctrl.report.min_date ng-model=ctrl.report.to_date><div ng-if=\"ctrl.form.$submitted && ctrl.form.to_date.$error\" data-test=new_report_points.validation.to_date><div class=st-input-validation ng-show=ctrl.form.to_date.$error.required translate=NEW_REPORT_POINTS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.min translate=NEW_REPORT_POINTS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.max translate=NEW_REPORT_POINTS.VALIDATION.MAX></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.interval translate=NEW_REPORT_POINTS.VALIDATION.INTERVAL></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.finalBiggerInitial translate=NEW_REPORT_POINTS.VALIDATION.FINAL_BIGGER_INITIAL></div></div></div></div><br><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close() data-test=new_report_points.action.cancel><span translate=NEW_REPORT_POINTS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save data-test=new_report_points.action.save><span translate=NEW_REPORT_POINTS.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-sharing/new-sharing.dialog.html","<md-dialog ng-controller=\"NewSharingController as ctrl\" flex-xs=95 flex-sm=50 flex-md=55 flex-gt-md=40 class=st-dialog aria-label=\"New Sharing\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_SHARING.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_SHARING.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><input type=hidden name=status ng-model=ctrl.sharing.attributes.type value=ctrl.types[0]><div layout=column layout-align=\"space-between stretch\"><enterprises-autocomplete clear-button=!ctrl.selectedDevice.id disabled-item=ctrl.selectedDevice.id form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete><div layout=column><div class=\"st-input-container no-padding\"><p class=\"st-label st-required pt12 pl12\" translate=NEW_SHARING.LABEL.VALID_UNTIL></p></div><div layout class=\"ml12 mt4 border border-transparent border-solid rounded\" ng-class=\"{\'border-red-400 w-fit\': !ctrl.customDate && ctrl.form.$submitted && ctrl.form.valid_until.$invalid}\" ng-style=\"{\'margin-bottom\': !ctrl.customDate  ? \'1px\' : \'0\'}\"><div ng-show=!ctrl.customDate layout><button class=\"altnav-action mr4\" ng-class=\"{\'save\': ctrl.btnSelected === $index, \'light\': ctrl.btnSelected !== $index}\" ng-click=\"ctrl.selectDate(day, $index)\" type=button ng-repeat=\"day in [1,7,15,30]\"><span>{{day}}</span> <span ng-if=\"day === 1\" class=pl4 translate=NEW_SHARING.LABEL.DAY></span> <span ng-if=\"day !== 1\" class=pl4 translate=NEW_SHARING.LABEL.DAYS></span></button></div><button class=altnav-action ng-click=\"ctrl.customDate = !ctrl.customDate\" ng-class=\"{\'save\': ctrl.btnSelected === -1, \'light\': ctrl.btnSelected !== -1, \'mr4\': ctrl.customDate}\" type=button translate=NEW_SHARING.ACTION.CUSTOM_DATE></button><div class=\"st-input-container no-padding\" ng-show=ctrl.customDate layout=column flex=30><input autocomplete=off class=\"st-input-type input-type no-margin\" datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" max={{ctrl.meta.max_date}} min={{ctrl.meta.min_date}} name=valid_until ng-change=\"ctrl.btnSelected = -1\" ng-model=ctrl.sharing.attributes.valid_until placeholder=\"E.g. DD/MM/AAAA\" required type=text></div></div><div class=\"pt8 pl12 pb8\" ng-if=\"ctrl.form.$submitted && ctrl.form.valid_until.$invalid\"><div class=\"st-input-container no-padding\"><div class=st-input-validation ng-show=ctrl.form.valid_until.$error.required translate=NEW_SHARING.VALIDATION.REQUIRED_VALID_UNTIL></div><div class=\"st-input-validation whitespace-nowrap\" ng-show=ctrl.form.valid_until.$error.min translate=NEW_SHARING.VALIDATION.MIN_VALID_UNTIL></div><div class=\"st-input-validation whitespace-nowrap\" ng-show=ctrl.form.valid_until.$error.max translate=NEW_SHARING.VALIDATION.MAX_VALID_UNTIL></div></div></div></div><devices-autocomplete clear-button=true filters=ctrl.devicesOptions.filters form=ctrl.form search-text=ctrl.device selected-item=ctrl.selectedDevice></devices-autocomplete><div class=st-input-container layout=column flex><label class=st-label translate=NEW_SHARING.LABEL.ASSOCIATED_VEHICLE></label><input class=\"st-input-type input-type\" name=plate ng-model=ctrl.selectedDevice.relationships.vehicle.attributes.plate type=text translate-attr=\"{ placeholder: \'NEW_SHARING.PLACEHOLDER.VEHICLE\' }\" autocomplete=off disabled></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_SHARING.LABEL.RESOURCES></label><span class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_SHARING.LABEL.CHOOSE_RESOURCES></span><div class=\"mt8 bg-gray-100 rounded-md pb12 pt12\" layout><span class=p8 ng-repeat=\"resource in ctrl.sharingResourcesOpts[ctrl.sharing.attributes.type].resources\"><label><input type=checkbox ng-checked=ctrl.exists(resource) ng-click=ctrl.toggle(resource) ng-disabled=ctrl.sharing.uuid> <span translate=\"{{\'NEW_SHARING.ENUM.RESOURSES.\' + resource.toUpperCase()}}\"></span></label></span></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_SHARING.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" ng-model=ctrl.sharing.attributes.description rows=2></textarea></div><br><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_SHARING.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=NEW_SHARING.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-user/new-user.dialog.html","<md-dialog ng-controller=\"NewUserController as ctrl\" flex-xs=95 flex-sm=80 flex-md=75 flex-gt-md=60 class=st-dialog aria-label=\"New device\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_USER.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_USER.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><div flex=50><enterprises-autocomplete clear-button=true form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.LANGUAGE></label><md-select class=st-input-select name=lang_type ng-model=ctrl.user.attributes.locale aria-label=\"Select Language\" md-no-asterisk required><md-option ng-repeat=\"l in ctrl.languages\" value={{l}} translate=\"{{\'NEW_USER.ENUM.LANG.\' + l.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.lang_type.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.LANG></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.user.attributes.name type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.USERNAME></label><div class=\"mt4 mb4 relative\" flex><input autocomplete=off class=\"st-input-type input-type no-margin w-full\" name=username ng-change=ctrl.checkUserName() ng-model=ctrl.user.attributes.username ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 700, \'blur\': 0 } }\" required restrict-input=[^.@a-z0-9\\s] type=text><div ng-if=ctrl.checking class=\"absolute bottom-1 right-1 w-6 h-6 bg-white\" layout layout-align=\"center center\"><progress></progress></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.username.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.USERNAME></div></div><div ng-if=\"ctrl.form.username.$invalid && !ctrl.checking\"><div class=st-input-validation ng-show=ctrl.form.username.$error.usernameTaken translate=NEW_USER.VALIDATION.USERNAME_TAKEN></div></div></div><div class=st-input-container layout=column flex><label class=st-label ng-class=\"{\'st-required\': ctrl.user.relationships.roles.id != 6}\" translate=NEW_USER.LABEL.EMAIL></label><input ng-required=\"ctrl.user.relationships.roles.id != 6\" class=\"st-input-type input-type\" name=email ng-model=ctrl.user.attributes.email type=email autocomplete=off><div ng-if=\"ctrl.form.$submitted && ctrl.form.email.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.EMAIL></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_USER.LABEL.DOC></label><input class=\"st-input-type input-type\" maxlength=20 ng-model=ctrl.user.attributes.document_number type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.SSN></label><input class=\"st-input-type input-type\" name=ssn maxlength=20 ng-model=ctrl.user.attributes.cpf type=text autocomplete=off placeholder=\"E.g. 123.456.789-01\" required></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_USER.LABEL.BIRTH_DATE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.birthdate type=text placeholder=\"E.g. DD/MM/AAAA\" datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd autocomplete=off></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.TYPE></label><md-select class=st-input-select name=role_type ng-model=ctrl.user.relationships.roles.id aria-label=\"Select Type\" md-no-asterisk required><md-option ng-repeat=\"t in ctrl.roles\" value={{t.id}} translate=\"{{\'NEW_USER.ENUM.ROLE.\' + t.attributes.name.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.role_type.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.ROLES></div></div></div><div class=st-input-container layout=column ng-if=\"ctrl.user.relationships.roles.id == 6\" flex><label class=st-label translate=NEW_USER.LABEL.PASSWORD></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.password type=text autocomplete=off ng-disabled=ctrl.user.attributes.email></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_USER.LABEL.CELLPHONE></label><input class=\"st-input-type input-type\" name=mobile ng-model=ctrl.user.attributes.phone1 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask required><div ng-if=\"ctrl.form.$submitted && ctrl.form.mobile.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_USER.VALIDATION.PHONE></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_USER.LABEL.PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.phone2 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_USER.LABEL.EMERGENCY_CONTACT></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.emergency_contact type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_USER.LABEL.EMERGENCY_PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.emergency_phone type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div></div><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_USER.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=NEW_USER.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/actions/new-vehicle/new-vehicle.dialog.html","<md-dialog ng-controller=\"NewVehicleController as ctrl\" flex-xs=95 flex-sm=60 flex-md=55 flex-gt-md=45 class=st-dialog style=\"height: 80vh\" aria-label=\"New vehicle\"><!-- dialog header --><div class=st-dialog-header><div><div layout layout-align=\"space-between center\"><div layout layout-alig=\"start center\"><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_VEHICLE.TITLE.NEW></div><progress ng-if=ctrl.loading></progress></div><div ng-if=ctrl.verifiedRegistry class=\"rounded-md bg-green-100 text-green-700 pl8 pr8\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-lg\">verified</i> <span class=\"font-bold ml8 text-sm\" translate=NEW_VEHICLE.LABEL.VERIFIED></span></div></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_VEHICLE.TITLE.DESC></div></div></div><div class=\"st-dialog-wrapper h-full\"><div class=\"st-dialog-body h-full\" layout=column layout-align=\"space-between stretch\" flex><div class=h-full><div class=h-full ng-if=ctrl.step.main><form class=\"st-form-inputs h-full\" name=ctrl.form novalidate flex><div class=h-full layout=column layout-align=\"space-between stretch\"><div><enterprises-autocomplete clear-button=true form=ctrl.form includes=ctrl.enterpriseIncludes on-item-change=ctrl.changeEnterprise(selectedItem) search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><div layout layout-align=\"space-between center\"><label class=st-label ng-class=\"{\'st-required\': !ctrl.vehicle.attributes.vin}\" translate=NEW_VEHICLE.LABEL.PLATE></label><div class=cursor-pointer><md-tooltip md-direction=top md-z-index=9999 class=h-inherit style=\"margin-top: 0\"><div class=\"text-sm p4 w-80\"><p translate=NEW_VEHICLE.TOOLTIP.TEXT_1 translate-values=\"{ country: \'{{ctrl.infoCountry.localName}}\' }\"></p><p translate=NEW_VEHICLE.TOOLTIP.TEXT_2></p></div></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></div></div><input autocomplete=off class=\"st-input-type input-type\" maxlength={{ctrl.infoCountry.extras.assets.maxCharsPlate}} name=plate translate-attr=\"{placeholder: \'NEW_VEHICLE.PLACEHOLDER.COUNTRIES.\' + ctrl.infoCountry.name.toUpperCase() }\" restrict-input=[^a-zA-Z0-9] restrict-input-uppercase=true type=text data-test=new_vehicle.plate_input ng-change=ctrl.getModelDetails() ng-model=ctrl.vehicle.attributes.plate ng-pattern=ctrl.rulePlate ng-required=!ctrl.vehicle.attributes.vin><div class=\"absolute bottom-4 right-2 w-8 h-8\" layout layout-align=\"center center\"><progress ng-if=ctrl.searchingPlate></progress></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.plate.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_VEHICLE.VALIDATION.PLATE></div></div><div ng-if=\"ctrl.form.plate.$touched && ctrl.form.plate.$invalid\"><div class=\"st-input-validation items-center display-flex\" ng-message=pattern><span class=pr4><i class=\"material-symbols-outlined text-base pt2\">error</i></span> <span class=pt2 translate=NEW_VEHICLE.VALIDATION.RULES_PLATE></span></div></div></div><div class=st-input-container layout=column flex><label class=st-label ng-class=\"{\'st-required\': !ctrl.vehicle.attributes.plate}\" translate=NEW_VEHICLE.LABEL.VIN></label><input class=\"st-input-type input-type\" name=vin ng-model=ctrl.vehicle.attributes.vin type=text autocomplete=off ng-required=!ctrl.vehicle.attributes.plate><div ng-if=\"ctrl.form.$submitted && ctrl.form.vin.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_VEHICLE.VALIDATION.VIN></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_VEHICLE.LABEL.CODE></label><input class=\"st-input-type input-type\" name=code ng-model=ctrl.vehicle.attributes.code type=text autocomplete=off maxlength=16></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_VEHICLE.LABEL.BRAND></label><input class=\"st-input-type input-type\" name=brand_name ng-model=ctrl.vehicle.attributes.brand type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_VEHICLE.LABEL.MODEL></label><input class=\"st-input-type input-type\" name=model_name ng-model=ctrl.vehicle.attributes.model type=text autocomplete=off></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_VEHICLE.LABEL.TYPE></label><md-select class=st-input-select name=type ng-model=ctrl.vehicle.attributes.type aria-label=\"Select Type\" md-no-asterisk required><md-option ng-repeat=\"t in ctrl.types\" value={{t.name}} translate=\"{{\'NEW_VEHICLE.ENUM.TYPES.\' + t.name.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.type.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_VEHICLE.VALIDATION.TYPE></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_VEHICLE.LABEL.COLOR></label><md-select class=st-input-select name=color ng-model=ctrl.vehicle.attributes.color aria-label=\"Select Color\" md-no-asterisk required><md-option ng-repeat=\"c in ctrl.colors\" value={{c.hex}} translate=\"{{\'NEW_VEHICLE.ENUM.COLOR.\' + c.name.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.color.$invalid\"><div class=st-input-validation ng-message=required translate=NEW_VEHICLE.VALIDATION.COLOR></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_VEHICLE.LABEL.TRIM></label><input class=\"st-input-type input-type\" name=model_full ng-model=ctrl.vehicle.attributes.model_full type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=NEW_VEHICLE.LABEL.YEAR></label><input class=\"st-input-type input-type\" name=year ng-model=ctrl.vehicle.attributes.year type=text autocomplete=off required min=1930 max={{ctrl.maxYear}} ui-number-mask=0 ui-hide-group-sep><div ng-if=\"ctrl.form.$submitted && ctrl.form.year.$invalid\"><div class=st-input-validation ng-message=required translate=VEHICLES.VALIDATION.YEAR></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=NEW_VEHICLE.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.vehicle.attributes.description rows=4></textarea></div></div></div><div class=\"m12 pb12\" layout layout-align=\"space-between center\"><div><button type=submit class=\"altnav-action light\" aria-label=Save ng-click=\"ctrl.form.$valid && ctrl.save(true)\" ng-disabled=ctrl.searchingPlate><span translate=NEW_VEHICLE.ACTION.CONTINUE></span></button></div><div layout><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_VEHICLE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=\"ctrl.searchingPlate || ctrl.processing\" aria-label=Save ng-click=\"ctrl.form.$valid && ctrl.save()\"><span translate=NEW_VEHICLE.ACTION.SAVE></span></button></div></div></div></form></div><div class=h-full ng-if=ctrl.step.users><div class=h-full layout=column layout-align=\"space-between stretch\"><div><div class=\"m16 p16 bg-gray-100 rounded-md\"><div><span class=\"text-base font-bold leading-tight text-gray-700\">{{ctrl.vehicle.attributes.plate}}</span> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=\"{{\'NEW_VEHICLE.ENUM.TYPES.\' + ctrl.vehicle.attributes.type.toUpperCase()}}\"></span></div><div><span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.brand}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.model}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.year}}</span> <span class=\"text-xs leading-tight text-gray-500\" translate=\"{{\'NEW_VEHICLE.ENUM.COLOR.\' + (ctrl.colors[ctrl.vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span></div></div><div class=m4><div class=st-form-inputs flex><div layout layout-align=\"space-between center\"><div flex><users-autocomplete filters=ctrl.usersOptions.filters form=ctrl.form required-item=false search-text=ctrl.user selected-item=ctrl.selectedUser></users-autocomplete></div><button type=button class=\"altnav-action light mt16 mr12\" aria-label=Add ng-click=ctrl.addUser()><i class=material-symbols-outlined>add</i></button></div><div class=\"m12 border border-solid border-gray-200 rounded-md\"><div class=\"leading-loose border-0 border-solid border-gray-200 p8 pl16 pr16 item\" ng-class=\"{\'border-b\': !$last}\" ng-repeat=\"user in ctrl.users\" layout layout-align=\"start center\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback user-holder\" ng-attr-data={{user.relationships.picture.address}} type=image/gif></object></span><span layout=column layout-align=\"space-between stretch\" flex><span><span class=\"text-base font-bold leading-tight text-gray-700\">{{user.attributes.name}}</span> <span class=\"text-sm leading-tight text-gray-700\">{{user.attributes.cpf}}</span> </span><span class=\"text-xs leading-tight text-gray-500\">{{user.attributes.email}}</span> </span><!-- <div class=\"st-input-container\" flex=\"60\">\n                        <md-select class=\"st-input-select\" name=\"nature\" ng-model=\"user.attributes.nature\" aria-label=\"Select nature\" md-no-asterisk>\n                          <md-option ng-repeat=\"n in ctrl.nature\" value=\"{{n}}\" translate=\"{{\'NEW_VEHICLE.ENUM.NATURE.\' + n.toUpperCase()}}\"></md-option>\n                        </md-select>\n                      </div> --><div><button class=\"no-button text-gray-500\" type=button ng-click=ctrl.removeUser($index)><i class=material-symbols-outlined>close</i></button></div></div><div ng-if=\"!ctrl.users || ctrl.users.length == 0\"><div layout=column layout-align=\"center center\"><span class=\"no-content-text p24\" translate=NEW_VEHICLE.NOT_FOUND.ANY></span></div></div></div></div></div></div><div class=m12 layout layout-align=\"space-between center\"><div><button type=submit class=\"altnav-action light\" aria-label=Save ng-click=\"ctrl.setState(\'devices\')\"><span translate=NEW_VEHICLE.ACTION.ADD_DEVICES></span></button></div><div layout><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_VEHICLE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save ng-click=ctrl.saveUsers()><span translate=NEW_VEHICLE.ACTION.SAVE></span></button></div></div></div></div><div class=h-full ng-if=ctrl.step.devices><div class=h-full layout=column layout-align=\"space-between stretch\"><div><div class=\"m16 p16 bg-gray-100 rounded-md\"><div><span class=\"text-base font-bold leading-tight text-gray-700\">{{ctrl.vehicle.attributes.plate}}</span> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=\"{{\'NEW_VEHICLE.ENUM.TYPES.\' + ctrl.vehicle.attributes.type.toUpperCase()}}\"></span></div><div><span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.brand}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.model}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{ctrl.vehicle.attributes.year}}</span> <span class=\"text-xs leading-tight text-gray-500\" translate=\"{{\'NEW_VEHICLE.ENUM.COLOR.\' + (ctrl.colors[ctrl.vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span></div></div><div class=m4><div class=st-form-inputs flex><div layout layout-align=\"space-between center\"><div flex><devices-autocomplete clear-button=true filters=ctrl.devicesOptions.filters form=ctrl.form search-text=ctrl.device selected-item=ctrl.selectedDevice></devices-autocomplete></div><button type=button class=\"altnav-action light mt16 mr12\" aria-label=Add ng-click=ctrl.addDevice()><i class=material-symbols-outlined>add</i></button></div><div class=\"m12 border border-solid border-gray-200 rounded-md\"><div class=\"leading-loose border-0 border-solid border-gray-200 p8 pl16 pr16 item\" ng-class=\"{\'border-b\': !$last}\" ng-repeat=\"device in ctrl.devices\" layout layout-align=\"start center\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback device-holder\" ng-attr-data={{device.relationships.picture.address}} type=image/gif></object></span><span layout=column layout-align=\"space-between stretch\" flex><span><span class=\"text-base font-bold leading-tight text-gray-700\">{{device.attributes.name}}</span> <span class=\"text-sm leading-tight text-gray-700\">{{device.attributes.imei}}</span> </span><span><span class=\"text-xs leading-tight text-gray-500\">{{device.relationships.device_types.attributes.brand_alias}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{device.relationships.device_types.attributes.alias}}</span></span></span><div><button class=\"no-button text-gray-500\" type=button ng-click=ctrl.removeDevice($index)><i class=material-symbols-outlined>close</i></button></div></div><div ng-if=\"!ctrl.devices || ctrl.devices.length == 0\"><div layout=column layout-align=\"center center\"><span class=\"no-content-text p24\" translate=NEW_VEHICLE.NOT_FOUND.ANY></span></div></div></div></div></div></div><div class=m12 layout layout-align=\"space-between center\"><div><button type=submit class=\"altnav-action light\" aria-label=Save ng-click=\"ctrl.setState(\'users\')\"><span translate=NEW_VEHICLE.ACTION.ADD_USERS></span></button></div><div layout><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_VEHICLE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save ng-click=ctrl.saveDevices()><span translate=NEW_VEHICLE.ACTION.SAVE></span></button></div></div></div></div></div></div></div></md-dialog>");
$templateCache.put("app/components/dialog/confirmation/confirmation.dialog.html","<md-dialog flex-xs=95 flex-sm=30 flex-md=30 flex-gt-md=30 aria-label=\"Confirm Dialog\" class=p8><div class=m16><span class=\"inline-block text-xl font-bold text-slate-900 select-none\" translate=\"{{\'CONFIRMATION_DIALOG.TITLE.\' + ctrl.options.title}}\"></span></div><div class=m16><span class=\"text-sm leading-tight text-gray-500 text-justify select-none\" translate=\"{{\'CONFIRMATION_DIALOG.LABEL.\' + ctrl.options.label}}\"></span></div><form name=ctrl.form ng-submit=ctrl.save()><div layout layout-align=\"end center\" class=p8><button type=button class=\"select-none altnav-action\" translate=CONFIRMATION_DIALOG.ACTION.CANCEL ng-click=ctrl.close()></button> <button type=submit md-autofocus=\"\" class=\"md-raised altnav-action delete\" aria-label=Delete><span translate=\"{{\'CONFIRMATION_DIALOG.ACTION.\' + ctrl.options.action.toUpperCase()}}\"></span></button></div></form></md-dialog>");
$templateCache.put("app/components/dialog/reload/reload.dialog.html","<div class=\"w-1\\4 m16\" layout layout-align=\"center start\"><md-dialog flex-xs=100 flex-sm=100 flex-md=100 flex-gt-md=100 aria-label=\"Confirm Dialog\" class=\"p8 z-10\"><div class=m16><p class=\"text-xl font-bold text-slate-900\" translate=RELOAD_DIALOG.TITLE.HEADER></p></div><div class=m16><p class=\"text-sm text-gray-500 whitespace-nowrap\" translate=RELOAD_DIALOG.LABEL.LINE-1></p><p class=\"text-sm text-gray-500 whitespace-nowrap\" translate=RELOAD_DIALOG.LABEL.LINE-2></p></div><div class=m16><button type=button class=\"select-none altnav-action no-back float-right\" ng-click=ctrl.reloadNoCache() translate=RELOAD_DIALOG.ACTION.RELOAD></button></div></md-dialog></div>");
$templateCache.put("app/components/dialog/strong-confirmation/strong-confirmation.dialog.html","<md-dialog flex-xs=95 flex-sm=50 flex-md=40 flex-gt-md=35 aria-label=\"Confirm Dialog\" class=p8><div class=m16><div class=\"inline-block text-xl font-bold text-slate-900 select-none\" translate=\"{{ \'STRONG_CONFIRMATION_DIALOG.TITLE.\' + (ctrl.deleteText ? \'DELETE\' : \'ITEM\') }}\"></div></div><form name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate><div class=m16><div class=\"text-sm leading-tight text-gray-500 text-justify select-none\" translate=\"{{ \'STRONG_CONFIRMATION_DIALOG.HINT.\' + ctrl.defaultText.toUpperCase() }}\"></div><div ng-if=\"ctrl.item.type === \'device\'\"><div class=\"mt16 mtb16\"></div><div class=\"text-sm leading-tight text-gray-500 text-justify select-none\" translate=STRONG_CONFIRMATION_DIALOG.HINT.AFTER_REMOVE></div></div></div><div class=\"ml4 mr4 st-input-container\"><p class=\"st-label st-required\" translate=\"{{ \'STRONG_CONFIRMATION_DIALOG.LABEL.\' + (ctrl.deleteText ? \'CONFIRM_DELETE\' : \'CONFIRM_TEXT\') }}\"></p><md-input-container md-no-float class=\"md-block no-margin\"><input class=\"st-input-type input-type\" type=text md-autofocus=\"\" aria-label=Confirm name=confirm ng-model=ctrl.strong.confirm autocomplete=off required translate-attr=\"{ placeholder: \'STRONG_CONFIRMATION_DIALOG.PLACEHOLDER.\' + (ctrl.deleteText ? \'DELETE\' : \'REMOVE\') }\"></md-input-container></div><div class=\"mb16 mr16 ml16\"><button type=submit class=\"select-none altnav-action no-back float-right delete\" translate=\"{{ \'STRONG_CONFIRMATION_DIALOG.ACTION.\' + (ctrl.deleteText ? \'DELETE\' : \'REMOVE\') }}\" ng-click=ctrl.save() ng-disabled=\"!(ctrl.strong.confirm === ctrl.strong.verified_text)\"></button> <button type=button class=\"no-button select-none altnav-action no-back float-right mr8\" translate=STRONG_CONFIRMATION_DIALOG.ACTION.CANCEL ng-click=ctrl.close()></button></div></form></md-dialog>");
$templateCache.put("app/components/dialog/updating/updating.dialog.html","<div class=\"w-1\\4 m16\" layout layout-align=\"center start\"><md-dialog flex-xs=100 flex-sm=100 flex-md=100 flex-gt-md=100 aria-label=\"Confirm Dialog\" class=\"p8 z-10\"><div class=m16><div layout layout-align=\"center center\" class=w-48><i class=\"material-symbols-outlined text-gray-400 text-4xl animate-spin\">progress_activity</i></div><p class=\"text-lg text-slate-900 text-center pt24\" translate=UPDATING.LABEL.TEXT></p></div></md-dialog></div>");
$templateCache.put("app/components/task/acknowledgements/acknowledgements.dialog.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=40 flex-gt-md=35 class=st-dialog aria-label=\"Add new acknowledgement\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=ACKNOWLEDGEMENTS.TITLE.HEADER></p><p class=\"text-xs leading-tight text-gray-500\" translate=ACKNOWLEDGEMENTS.TITLE.SUB_ACK></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div flex><users-autocomplete disabled-item=\"ctrl.currentItem.id && ctrl.currentItem.attributes.acknowledged\" form=ctrl.form search-text=ctrl.user selected-item=ctrl.selectedUser></users-autocomplete></div><div class=\"st-form-actions m12\" can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=ACKNOWLEDGEMENTS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save ng-disabled=\"ctrl.currentItem.id && ctrl.currentItem.attributes.acknowledged\"><span translate=ACKNOWLEDGEMENTS.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/complete-date/complete-date.dialog.html","<md-dialog flex-xs=80 flex-sm=60 flex-md=35 flex-gt-md=25 class=st-dialog aria-label=\"Custom date complete\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=COMPLETED_DATE.TITLE.HEADER></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div class=\"st-input-container pb8\" layout=column flex><label class=st-label translate=COMPLETED_DATE.LABEL.DATE></label><input autocomplete=off class=\"st-input-type input-type\" datetime=\"HH:mm dd/MM/yyyy\" name=completed_at ng-change=ctrl.updateMetaValidation() ng-max=ctrl.meta.max_date ng-model=ctrl.completeAt.date placeholder=\"E.g. DD/MM/AAAA\" required type=text><div ng-if=\"ctrl.form.$submitted && ctrl.form.completed_at.$invalid\"><div class=st-input-validation ng-show=ctrl.form.completed_at.$error.required translate=COMPLETED_DATE.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.completed_at.$error.max translate=COMPLETED_DATE.VALIDATION.MAX></div></div></div><div class=\"st-form-actions m12 pt8\" layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=COMPLETED_DATE.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save ng-disabled=\"ctrl.currentItem.id && ctrl.currentItem.attributes.acknowledged\"><span translate=COMPLETED_DATE.ACTION.COMPLETE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/custom-fields/custom-fields.dialog.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=50 flex-gt-md=40 class=st-dialog aria-label=\"Add new custom field\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p ng-if=!ctrl.editing class=\"inline-block text-xl font-bold text-slate-900\" translate=CUSTOM_FIELDS.TITLE.HEADER_NEW></p><p ng-if=ctrl.editing class=\"inline-block text-xl font-bold text-slate-900\" translate=CUSTOM_FIELDS.TITLE.HEADER_EDIT></p></div></div></div><div class=\"st-dialog-wrapper pl4 pr4 pt4\"><custom-fields-form enterprise-show=false item=ctrl.currentItem return-content=true saved=ctrl.callbackSave><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=ACKNOWLEDGEMENTS.ACTION.CANCEL></span></button></custom-fields-form></div></md-dialog>");
$templateCache.put("app/components/task/expenses/expenses.dialog.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=50 flex-gt-md=45 class=st-dialog aria-label=\"Add new acknowledgement\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=EXPENSES.TITLE.HEADER></p><p class=\"text-xs leading-tight text-gray-500\" translate=EXPENSES.TITLE.SUB_ACK></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div><div class=st-input-container layout=column flex=50><label class=st-label translate=EXPENSES.LABEL.CATEGORY></label><md-select class=st-input-select name=status ng-model=ctrl.expense.attributes.category_locale aria-label=\"Select category\" md-no-asterisk required flex style=margin-bottom:0><md-option ng-repeat=\"c in ctrl.categories\" value={{c}}>{{\'EXPENSES.ENUM.CATEGORY.\' + c.toUpperCase() | translate}}</md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.status.$invalid\"><div class=st-input-validation ng-message=required translate=EXPENSES.VALIDATION.CATEGORY></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=EXPENSES.LABEL.AMOUNT></label><input class=\"st-input-type input-type\" name=amount ng-model=ctrl.expense.attributes.amount_locale type=text autocomplete=off required ui-number-mask=2 min=0 ng-change=ctrl.calculateTotal()><div ng-if=\"ctrl.form.$submitted && ctrl.form.amount.$invalid\"><div class=st-input-validation ng-message=required translate=EXPENSES.VALIDATION.AMOUNT></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=EXPENSES.LABEL.UNIT></label><input class=\"st-input-type input-type\" name=unit_price ng-model=ctrl.expense.attributes.unit_price_locale type=text autocomplete=off required ui-number-mask=2 min=0 ng-change=ctrl.calculateTotal()><div ng-if=\"ctrl.form.$submitted && ctrl.form.unit_price.$invalid\"><div class=st-input-validation ng-message=required translate=EXPENSES.VALIDATION.UNIT-PRICE></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=EXPENSES.LABEL.TOTAL></label><input class=\"st-input-type input-type\" name=total_price ng-model=ctrl.expense.attributes.total_price_locale type=text autocomplete=off disabled readonly></div></div><div class=st-input-container layout=column flex><label class=st-label translate=EXPENSES.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.expense.attributes.description_locale rows=4></textarea></div></div><div class=\"st-form-actions m12\" can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=EXPENSES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=EXPENSES.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/locations/locations.dialog.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=50 flex-gt-md=45 class=st-dialog aria-label=\"Add new acknowledgement\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=LOCATIONS.TITLE.HEADER></p><p class=\"text-xs leading-tight text-gray-500\" translate=LOCATIONS.TITLE.SUB_ACK></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div><!-- place --><div class=st-input-container layout=column flex><label class=st-label translate=LOCATIONS.LABEL.LOCATION></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'LOCATIONS.PLACEHOLDER.TYPE_ADDRRESS\' | translate}}\" md-input-name=place md-selected-item=ctrl.selectedPlace md-search-text=ctrl.searchedPlace md-items=\"item in ctrl.getAddress(ctrl.searchedPlace)\" md-item-text=item.attributes.location.formatted_address md-min-length=3 md-delay=1000 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-no-cache md-require-match><md-item-template><div class=item layout layout-align=\"start center\"><div class=results-info layout=column layout-align=\"space-between stretch\"><span><span md-highlight-text=ctrl.searchedPlace class=st-subhead>{{item.attributes.location.formatted_address}}</span></span></div></div></md-item-template><md-not-found><span translate=LOCATIONS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.searchedPlace}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.place.$error\"><div class=st-input-validation ng-show=ctrl.form.place.$error.required translate=LOCATIONS.VALIDATION.LOCATION_REQUIRED></div><div class=st-input-validation ng-show=\"ctrl.form.place.$error[\'md-require-match\']\" translate=LOCATIONS.VALIDATION.LOCATION_MATCH></div></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=LOCATIONS.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.selectedPlace.attributes.description rows=4></textarea></div><div class=\"st-form-actions m12\" can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=LOCATIONS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=LOCATIONS.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/resources/resources.dialog.html","<md-dialog flex-xs=95 flex-sm=60 flex-md=30 flex-gt-md=30 class=st-dialog aria-label=\"Add new resource\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=\"{{\'RESOURCES.TITLE.HEADER_\' + ctrl.localsItem.type.toUpperCase()}}\"></p><p class=\"text-xs leading-tight text-gray-500\" translate=\"{{\'RESOURCES.TITLE.SUB_ACK_\' + ctrl.localsItem.type.toUpperCase()}}\"></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=RESOURCES.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.localsItem.attributes.name type=text autofocus autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=RESOURCES.VALIDATION.REQUIRED></div></div></div></div></div><div class=\"st-form-actions m12\" can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=RESOURCES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=RESOURCES.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/settings/settings.dialog.html","<md-dialog flex-xs=80 flex-sm=70 flex-md=45 flex-lg=35 flex-gt-lg=25 class=st-dialog aria-label=\"Custom date complete\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div><p class=\"inline-block text-xl font-bold text-slate-900\" translate=OS_SETTINGS.TITLE.HEADER></p></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate><div class=st-input-container layout layout-align=\"start center\"><label class=\"st-label pr8\" translate=OS_SETTINGS.LABEL.DEVICE></label><md-switch class=\"st-activation-switch no-margin\" name=deviceInteraction ng-model=ctrl.config.deviceInteraction ng-false-value=null aria-label=Device></div><div class=st-input-container layout layout-align=\"start center\"><label class=\"st-label pr8\" translate=OS_SETTINGS.LABEL.LOCK></label><md-switch class=\"st-activation-switch no-margin\" name=lockOnComplete ng-model=ctrl.config.lockOnComplete ng-false-value=null aria-label=Lock></div><div class=st-input-container layout layout-align=\"start center\"><label class=\"st-label pr8\" translate=OS_SETTINGS.LABEL.ACKNOWLEDGE_RESTRICTIONS></label><md-switch class=\"st-activation-switch no-margin\" name=assigneeAcknowledgeRestrictions ng-model=ctrl.config.assigneeAcknowledgeRestrictions ng-true-value=\"\'completeCustomFields\'\" ng-false-value=null aria-label=\"Acknowledge Restrictions\"></div><div layout><div class=\"st-input-container w-full\" layout layout-align=\"start center\"><label class=\"st-label pb2\" translate=OS_SETTINGS.LABEL.DOCUMENTS_RESTRICTIONS></label><md-select class=\"st-input-select w-1/3\" name=assigneeDocumentsRestrictions ng-model=ctrl.config.assigneeDocumentsRestrictions aria-label=\"Select the option\" md-no-asterisk><md-option ng-repeat=\"item in ctrl.optionsRestrictions\" value={{item.key}} translate=\"{{\'OS_SETTINGS.ENUM.DOCUMENTS_RESTRICTIONS.\' + item.name }}\"></md-option></md-select></div></div><!-- <div layout>\n        <div class=\"st-input-container\" layout=\"column\" flex=\"60\">\n          <label class=\"st-label\" translate=\"OS_SETTINGS.LABEL.CONCLUSION\"></label>\n          <md-select class=\"st-input-select\" name=\"setFillDate\" ng-model=\"ctrl.config.setFillDate\" aria-label=\"Select date\" md-no-asterisk>\n            <md-option value=\"before\" translate=\"OS_SETTINGS.ENUM.DATE.BEFORE\"></md-option>\n            <md-option value=\"after\" translate=\"OS_SETTINGS.ENUM.DATE.AFTER\"></md-option>\n            <md-option value=\"-\" translate=\"OS_SETTINGS.ENUM.DATE.BOTH\"></md-option>\n          </md-select>\n        </div>\n      </div> --><div class=\"st-form-actions m12 pt8\" layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel()><span translate=OS_SETTINGS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save ng-disabled=\"ctrl.currentItem.id && ctrl.currentItem.attributes.acknowledged\"><span translate=OS_SETTINGS.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/components/task/sharings/sharings.dialog.html","<md-dialog flex-xs=95 flex-sm=50 flex-md=55 flex-gt-md=40 class=st-dialog aria-label=\"Task Sharing\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=TASK_SHARING.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=TASK_SHARING.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div><div class=\"m12 border border-solid border-gray-200 rounded-md p12\"><div class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{ctrl.vehicle.attributes.plate}}</div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{ctrl.vehicle.attributes.brand_name}} {{ctrl.vehicle.attributes.model_name}} {{ctrl.vehicle.attributes.trim_name}}</div></div></div><!-- <div class=\"m12\" ng-if=\"ctrl.devices.length > 1\"> --><div class=m12><div class=\"text-xs font-bold leading-tight text-gray-700 truncate mb12\" translate=TASK_SHARING.LABEL.AVAILABLE_DEVICES></div><md-radio-group ng-model=ctrl.selectedDevice aria-labelledby=\"Radio device\" required><md-radio-button ng-repeat=\"device in ctrl.devices\" ng-value=device>{{device.attributes.name}}</md-radio-button></md-radio-group></div><div layout><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=TASK_SHARING.LABEL.VALID_UNTIL></label><input class=\"st-input-type input-type\" name=valid_until ng-model=ctrl.sharing.attributes.valid_until type=text placeholder=\"E.g. DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" min={{ctrl.meta.min_date}} max={{ctrl.meta.max_date}} datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.valid_until.$error\"><div class=st-input-validation ng-show=ctrl.form.valid_until.$error.required translate=TASK_SHARING.VALIDATION.REQUIRED_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.valid_until.$error.min translate=TASK_SHARING.VALIDATION.MIN_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.valid_until.$error.max translate=TASK_SHARING.VALIDATION.MAX_VALID_UNTIL></div></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=TASK_SHARING.LABEL.RESOURCES></label><span class=\"text-sm font-medium leading-tight text-gray-500\" translate=TASK_SHARING.LABEL.CHOOSE_RESOURCES></span><div class=\"mt8 bg-gray-100 rounded-md pb12 pt12\" layout><span class=p8 ng-repeat=\"resource in ctrl.sharingResourcesOpts[ctrl.sharing.attributes.type].resources\"><label><input type=checkbox ng-checked=ctrl.exists(resource) ng-click=ctrl.toggle(resource)> <span translate=\"{{\'TASK_SHARING.ENUM.RESOURSES.\' + resource.toUpperCase()}}\"></span></label></span></div></div><div class=m16 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.close()><span translate=TASK_SHARING.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=\"ctrl.processing || !ctrl.selectedDevice\" aria-label=Save><span translate=TASK_SHARING.ACTION.SAVE></span></button></div></div></form></div></div></md-dialog>");
$templateCache.put("app/components/task/template-items/template-items.dialog.html","<md-dialog flex-xs=95 flex-sm=80 flex-md=70 flex-gt-md=60 class=\"st-dialog dialog-template template-items\"><div class=\"h-full overflow-y-auto pr16\"><div layout layout-align=\"space-between center\" class=st-dialog-header><p class=\"md-title font-semibold\" translate=\"{{ \'TEMPLATE_ITEMS.TITLE.\' + (ctrl.create ? \'CREATE_ASSOCIATE\' : \'ASSOCIATE\') }}\"></p><button type=button class=altnav-action ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\" class=pr16><div class=\"details-tab-wrapper mt4 ml16 mr16\"><div class=details-tabs><button type=button class=details-tab-item ng-class=\"{active: ctrl.typeOfModel === \'items\'}\" ng-click=\"ctrl.toggleModel(\'items\')\" data-test=template_items.enum.tabs.items><span translate=TEMPLATE_ITEMS.ENUM.TABS.ITEMS></span></button> <button ng-if=!ctrl.create type=button class=details-tab-item ng-class=\"{active: ctrl.typeOfModel === \'templates\'}\" ng-click=\"ctrl.toggleModel(\'templates\')\" data-test=template_items.enum.tabs.templates><span translate=TEMPLATE_ITEMS.ENUM.TABS.TEMPLATES></span></button> <button ng-if=ctrl.create type=button class=details-tab-item ng-class=\"{active: ctrl.typeOfModel === \'new\'}\" ng-click=\"ctrl.toggleModel(\'new\')\" data-test=template_items.enum.tabs.new><span translate=TEMPLATE_ITEMS.ENUM.TABS.NEW></span></button></div></div></div><div ng-show=!ctrl.newItem class=\"pt16 pl16 pr16\" layout layout-align=\"space-between center\"><div><div layout layout-align=\"start center\" class=\"pb4 pt4\"><form name=ctrl.formSearch class=\"search-bar h-8 relative\" ng-submit=\"ctrl.formSearch.$valid && ctrl.searchTasksItems()\" novalidate><div layout class=\"relative h-full\"><div class=\"text-gray-400 no-padding absolute top-0 left-0 m2 z-10\" layout layout-align=\"center center\" translate-attr=\"{ title: \'TEMPLATE_ITEMS.TOOLTIP.SEARCH\' }\"><i class=\"material-symbols-outlined text-lg\">search</i></div><input type=text name=search class=\"search-bar-input box-border border-0 text-sm text-gray-800 h-8 rounded pl24 pr8\" autocomplete=off ng-model=ctrl.search translate-attr=\"{ placeholder: \'TEMPLATE_ITEMS.PLACEHOLDER.SEARCH\' }\"></div></form></div></div><div><p ng-if=!ctrl.create layout layout-align=\"end center\"><span class=\"md-caption text-gray-500 pr4\" translate=TEMPLATE_ITEMS.HINT.SELECTED_ITEMS></span> <span class=\"st-tags tag-purple\">{{ctrl.countSelected}}/{{ctrl.numItems}}</span></p><div class=\"relative md-caption text-red-500\"><p ng-show=\"ctrl.maxSelected && ctrl.typeOfModel === \'templates\'\" class=\"right-0 top-0 leading-3 w-60 absolute\"><sup>*</sup> <span translate=TEMPLATE_ITEMS.VALIDATION.MAX_TEMPLATES translate-values=\"{ max: \'{{ctrl.numItems}}\' }\"></span></p><p ng-show=\"ctrl.maxSelected && ctrl.typeOfModel === \'items\'\" class=\"right-0 top-0 leading-3 absolute whitespace-nowrap\"><sup>*</sup> <span translate=TEMPLATE_ITEMS.VALIDATION.MAX_ITEMS translate-values=\"{ max: \'{{ctrl.numItems}}\' }\"></span></p></div></div></div><div ng-show=!ctrl.newItem class=\"mt16 mr8 ml8 mb8\"><md-table-container class=\"st-wrapper-table template-items__table\"><table class=st-main-table md-table md-row-select multiple ng-model=ctrl.selectedItems><thead class=st-table-head md-head><tr md-row class=md-sm ng-class=\"{\'md-indeterminate\' : ctrl.selectedSomeItem }\"><th md-column><p translate=TEMPLATE_ITEMS.LABEL.NAME></p></th><th ng-if=\"ctrl.typeOfModel === \'templates\'\" md-column><p translate=TEMPLATE_ITEMS.LABEL.ITEMS></p></th><th ng-if=\"ctrl.typeOfModel === \'templates\'\" md-column><p translate=TEMPLATE_ITEMS.LABEL.CATEGORY></p></th><th ng-if=\"ctrl.typeOfModel === \'items\'\" md-column><p translate=TEMPLATE_ITEMS.LABEL.RESPONSE_TYPE></p></th><th ng-if=\"ctrl.typeOfModel === \'items\'\" md-column><p translate=TEMPLATE_ITEMS.LABEL.IS_REQUIRED></p></th></tr></thead><tbody class=st-table-body md-body><tr class=md-sm ng-disabled=::ctrl.checkEmptyItem(item) ng-repeat=\"item in ctrl.items\" md-auto-select=true md-on-deselect=ctrl.defineValidations md-on-select=ctrl.defineValidations md-select=item md-row data-test=template_items.action.select-{{$index}}><td md-cell><span class=\"block mt8 mb8\">{{item.attributes.name}}</span></td><td ng-if=\"ctrl.typeOfModel === \'templates\'\" md-cell><span ng-if=item.relationships.template_items.length>{{item.relationships.template_items.length.toString().padStart(2, \'0\')}}</span> <span ng-if=!item.relationships.template_items.length>-</span></td><td ng-if=\"ctrl.typeOfModel === \'templates\'\" md-cell><span class=\"block pt8 pb8\">{{item.attributes.category}}</span></td><td ng-if=\"ctrl.typeOfModel === \'items\'\" md-cell translate=\"{{\'TEMPLATE_ITEMS.ENUM.FIELD_FORMAT.\' + item.attributes.field_format.toUpperCase()}}\"></td><td ng-if=\"ctrl.typeOfModel === \'items\'\" md-cell translate=\"{{\'TEMPLATE_ITEMS.ENUM.FIELD_REQUIRED.\' + (item.attributes.is_required ? \'TRUE\' : \'FALSE\') }}\"></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3,4]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><p class=\"no-content-text mt8\" translate=TEMPLATE_ITEMS.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadData md-boundary-links md-label=\"{page: \'{{\'TEMPLATE_ITEMS.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'TEMPLATE_ITEMS.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'TEMPLATE_ITEMS.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div><div ng-if=ctrl.create ng-show=ctrl.newItem class=\"pl4 pr4\"><custom-fields-form ng-if=!ctrl.loading create=true custom-class-css=template-items-form enterprise=ctrl.selectedEnterprise enterprise-show=false item=ctrl.addItem><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.cancel() data-test=template_items.action.cancel><span translate=TEMPLATE_ITEMS.ACTION.CANCEL></span></button></custom-fields-form></div><div ng-show=\"!ctrl.newItem || !ctrl.create\" class=\"st-form-actions mt6 ml16 mr16 mb12\" can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel mr12\" aria-label=Cancel ng-click=ctrl.cancel() data-test=template_items.action.cancel><span translate=TEMPLATE_ITEMS.ACTION.CANCEL></span></button> <button type=button class=\"altnav-action save\" aria-label=Save ng-disabled=\"(ctrl.countSelected === 0 || ctrl.maxSelected)\" ng-click=ctrl.apply() data-test=template_items.action.apply><span translate=TEMPLATE_ITEMS.ACTION.APPLY></span></button></div></div></div></div></md-dialog>");
$templateCache.put("app/directives/documents/many/documents.html","<div><div layout layout-align=\"space-between center\" class=m24><div layout layout-align=\"start center\"><div class=w-6><md-checkbox aria-label=\"Selected all\" class=\"md-blue md-sm\" md-indeterminate=\"ctrl.selectedItems.length > 0 && ctrl.selectedItems.length < files.length\" ng-change=ctrl.toggleSectionAll() ng-disabled=\"files.length === 0 || ctrl.readOnly\" ng-model=ctrl.selectAllItems></md-checkbox></div><p><span class=\"font-semibold text-base text-gray-800\" translate=DOCUMENTS.TITLE.HEADER></span> <span ng-if=count class=\"text-gray-500 text-sm\">({{count.toString().padStart(2, \'0\')}})</span></p></div><button class=\"altnav-action outlined text-gray-400 p8\" ng-disabled=\"ctrl.loading || ctrl.readOnly\" ng-show=\"ctrl.selectedItems.length === 0\" ngf-max-size=10MB ngf-select=ctrl.uploadFile($file) type=button><i class=\"material-symbols-outlined text-lg\">add</i></button> <button type=button class=\"altnav-action outlined text-rose-500 p8\" ng-click=ctrl.remove() ng-show=\"ctrl.selectedItems.length > 0\"><span class=\"material-symbols-outlined text-lg\">delete</span> <span class=text-caption translate=DOCUMENTS.ACTION.DELETE></span></button></div><!-- loaded files --><div class=overflow-y-scroll style=\"height: calc(100vh - 265px);padding-top: 1px\"><div ng-if=loadingExternal layout layout-align=\"center start\" class=pt16><progress></progress></div><div ng-if=\"files.length === 0 && !ctrl.loading && !loadingExternal\" ngf-drop=ctrl.uploadFile($file) ngf-max-size=10MB ngf-drag-over-class=\"\'dragover\'\" ng-disabled=ctrl.readOnly><div layout layout-align=\"center center\"><div class=\"p24 mt24 ml24 mr24 mb24 border border-solid border-gray-300 rounded\" flex=100 layout layout-align=\"center center\"><div class=w-60><div layout=column layout-align=\"center center\"><span layout layout-align=\"center center\" class=\"text-gray-800 text-base\"><i class=\"material-symbols-outlined text-2xl pr8\">attach_file</i> <span translate=DOCUMENTS.LABEL.NO_FILE></span> </span><span ng-if=!ctrl.readOnly class=\"pt12 text-gray-800 text-sm text-center\"><span translate=DOCUMENTS.LABEL.TO_LOAD></span> \"<i class=\"material-symbols-outlined text-base\">add</i>\"</span></div></div></div></div></div><ul class=st-expansion-panel><li class=\"st-expansion-panel-item not-animation rounded-none no-margin\" ng-repeat=\"attach in files\" ng-init=\"ctrl.addGallery(attach, $last)\"><div layout layout-align=\"start center\" class=\"st-expansion-header upload-files__container\"><div layout layout-align=\"start start\" class=grow><div class=\"w-6 h-5 shrink-0\" layout layout-align=\"start center\" ng-click=$event.stopPropagation()><md-checkbox aria-label=Selected class=\"md-blue md-sm\" ng-change=ctrl.selectItem() ng-if=!attach.attributes.progress ng-model=attach.selected ng-disabled=ctrl.readOnly></md-checkbox><div ng-if=attach.attributes.progress class=\"w-6 h-10\" layout layout-align=\"center center\" flex><progress></progress></div></div><div layout=column class=\"grow min-w-0\"><div layout layout-align=\"space-between center\"><a ng-if=!attach.gallery class=\"text-sm text-gray-800 truncate block relative pr8 document-link\" ng-class=\"{\'disabled-item\': attach.attributes.progress}\" ng-href=https://{{attach.attributes.folder}} target=_blank translate-attr=\"{ title: \'DOCUMENTS.ACTION.DOWNLOAD\' }\" download={{attach.attributes.name}}><span class=\"text-sm truncate block pr12\">{{attach.attributes.name}}</span> <i ng-if=!attach.attributes.progress class=\"material-symbols-outlined text-sm hidden absolute top-0 h-6 right-1\" layout layout-align=\"center center\">download</i> </a><span ng-if=attach.gallery class=\"text-sm text-gray-800 truncate block relative pr12 cursor-pointer document-link\" ng-click=ctrl.openGallery(attach)><span class=\"text-sm truncate block pr12\">{{attach.attributes.name}}</span> <i class=\"material-symbols-outlined text-sm hidden absolute top-0 h-6 right-1\" layout layout-align=\"center center\">visibility</i></span><div layout layout-align=\"start center\" class=h-5><i ng-if=!attach.attributes.progress class=\"material-symbols-outlined text-gray-400 text-xl\">{{attach.attributes.mime | mimeFont}}</i></div></div><div layout layout-align=\"space-between center\" class=\"pt4 h-5 text-xs text-gray-500\"><span data-metrics=file>{{attach.attributes.file_size /1000000 | number: 2}}</span> <span>{{attach.attributes.created_at | date: \'dd/MM/yyyy\'}}</span></div></div></div></div></li></ul></div></div>");
$templateCache.put("app/directives/documents/single/document.html","<div><div class=st-image-holder><div ng-if=!ctrl.$scope.file.attributes class=holder-base ng-class=ctrl.$scope.service></div><img ngf-thumbnail=ctrl.$scope.file.attributes.folder ngf-size=\"{width: 120, height: 120, quality: 0.9}\" alt=Image><div class=image-progress ng-if=ctrl.loading><progress theme=light></progress></div><span can-access=INTERNALS,MANAGER class=add-image-hover><button ng-if=ctrl.$scope.file type=button aria-label=Remove ng-click=ctrl.delete()><i class=material-symbols-outlined>cancel</i></button> <button ng-if=!ctrl.$scope.file type=button name=file ngf-select ng-model=ctrl.$scope.file ngf-pattern={{ctrl.$scope.pattern}} ngf-accept={{ctrl.$scope.pattern}} ngf-dimensions=\"ctrl.validateOrDie($file, $width, $height, ctrl.$scope.dimensions, ctrl.$scope.size)\" aria-label=Image><i class=material-symbols-outlined>image</i></button></span></div><div ng-if=ctrl.validation.dimensionError><span class=\"m12 text-xs leading-tight text-gray-600\" translate=DOCUMENTS.VALIDATION.DIMENSIONS translate-values=\"{ width: \'{{ctrl.$scope.dimensions.w}}\', height: \'{{ctrl.$scope.dimensions.h}}\' }\"></span></div><div ng-if=ctrl.validation.sizeError><span class=\"m12 text-xs leading-tight text-gray-600\" translate=DOCUMENTS.VALIDATION.SIZE translate-values=\"{ max: \'{{ctrl.$scope.size / 1000}}\' }\"></span></div></div>");
$templateCache.put("app/directives/form/chips-autocomplete/chips.html","<div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS_AUTOCOMPLETE.LABEL.CHIP></label><md-autocomplete class=st-input-autocomplete data-test=form.chips_autocomplete md-clear-button=true md-delay=800 md-input-name=autocomplete_chips md-item-text=item.attributes.number md-items=\"item in ctrl.getChips(searchText)\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=3 md-no-cache md-require-match md-search-text=searchText md-selected-item=selectedItem placeholder=\"{{\'CHIPS_AUTOCOMPLETE.PLACEHOLDER.TYPE_CHIP\' | translate}}\"><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback chip-holder\" type=image/gif></object></span><div layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><span md-highlight-text=searchText class=\"text-sm text-gray-700 font-bold truncate pr8\">{{item.attributes.serial}}</span> <span class=\"text-xs text-gray-700 truncate\">{{item.attributes.service_provider}}</span></div><div layout layout-align=\"space-between center\"><span md-highlight-text=searchText class=\"text-xs text-gray-400 truncate pr8\">{{item.attributes.number}}</span> <span class=\"text-xs text-gray-400 truncate\">{{item.attributes.carrier}}</span></div></div></div></md-item-template><md-not-found><span translate=CHIPS_AUTOCOMPLETE.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_chips.$invalid\"><div class=st-input-validation ng-message=required translate=CHIPS_AUTOCOMPLETE.VALIDATION.CHIP></div></div></div></div>");
$templateCache.put("app/directives/form/device-model-autocomplete/device-model.html","<div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=DEVICE_MODEL_AUTOCOMPLETE.LABEL.DEVICE_MODEL></label><md-autocomplete class=st-input-autocomplete data-test=form.device_model_autocomplete md-clear-button=true md-delay=800 md-input-name=autocomplete_device_model md-item-text=item.attributes.alias md-items=\"item in ctrl.getDeviceType(searchText)\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=2 md-require-match md-search-text=searchText md-selected-item=selectedItem placeholder=\"{{\'DEVICE_MODEL_AUTOCOMPLETE.PLACEHOLDER.DEVICE_MODEL\' | translate}}\" ng-required=true><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback device-holder\" type=image/gif></object></span><div layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><span class=\"text-sm text-gray-700 truncate\"><span md-highlight-text=searchText>{{item.attributes.brand_alias}}</span> <span md-highlight-text=searchText class=\"font-bold pl4\">{{item.attributes.alias}}</span></span><div class=\"w-2 h-2 rounded-full\" ng-class=\"{ \'bg-green-600\': item.attributes.supported, \'bg-red-600\': !item.attributes.supported }\"></div></div><div layout layout-align=\"space-between center\"><span class=\"text-xs text-gray-700 truncate\" translate=\"{{\'DEVICE_MODEL_AUTOCOMPLETE.ENUM.DEVICE_TYPE.\' + item.attributes.type}}\"></span></div></div></div></md-item-template><md-not-found><span translate=DEVICE_MODEL_AUTOCOMPLETE.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_device_model.$invalid\"><div class=st-input-validation ng-message=required translate=DEVICE_MODEL_AUTOCOMPLETE.VALIDATION.DEVICE_MODEL></div></div></div></div>");
$templateCache.put("app/directives/form/devices-autocomplete/devices.html","<div layout layout-align=\"space-between center\"><div class=st-input-container ng-class=\"{\'no-padding\': hideLabel}\" layout=column flex><label ng-if=!hideLabel class=st-label ng-class=\"{\'st-required\': ctrl.required}\" translate=\"{{\'DEVICE_AUTOCOMPLETE.LABEL.\' + (labelText || \'DEVICE\')}}\"></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" data-test=form.device_autocomplete md-autofocus=\"autoFocus || false\" md-delay=800 md-input-name=autocomplete_device md-item-text=item.attributes.name md-items=\"item in ctrl.getDevices(searchText)\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=2 md-no-cache md-require-match md-search-text=searchText md-selected-item=selectedItem md-selected-item-change=\"onItemChange({ selectedItem: selectedItem })\" ng-required=ctrl.required placeholder=\"{{\'DEVICE_AUTOCOMPLETE.PLACEHOLDER.\' + (labelText || \'TYPE_DEVICE\') | translate}}\"><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback device-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><span md-highlight-text=searchText class=\"text-sm leading-none text-gray-700 font-bold truncate\">{{item.attributes.name}}</span> <span class=\"text-xs leading-none text-gray-700 truncate\">{{item.relationships.type.attributes.brand_alias}} {{item.relationships.type.attributes.alias}}</span></div><div layout layout-align=\"space-between center\"><span md-highlight-text=searchText class=\"text-xs leading-none text-gray-400 truncate\">{{item.attributes.imei}}</span> <span ng-if=item.relationships.vehicle class=\"text-xs truncate\"><span md-highlight-text=searchText>{{item.relationships.vehicle.attributes.plate}}</span> | <span translate>{{\'DEVICE_AUTOCOMPLETE.ENUM.VEHICLE_TYPE.\' + (item.relationships.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}</span></span></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_device.$invalid\"><div class=st-input-validation ng-message=required translate=DEVICE_AUTOCOMPLETE.VALIDATION.DEVICE></div></div></div></div>");
$templateCache.put("app/directives/form/enterprises-autocomplete/enterprises.html","<div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label ng-class=\"{\'st-required\': ctrl.required}\" translate=ENTERPRISE_AUTOCOMPLETE.LABEL.ENTERPRISE></label><md-autocomplete class=st-input-autocomplete data-test=form.enterprise_autocomplete md-clear-button=\"clearButton || false\" md-delay=800 md-input-name=autocomplete_enterprise md-item-text=item.attributes.name md-items=\"item in ctrl.getEnterprises(searchText)\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=ctrl.minLength md-require-match md-search-text=searchText md-selected-item=selectedItem md-selected-item-change=\"onItemChange({ selectedItem: selectedItem })\" ng-disabled=\"disabledItem || false\" ng-required=ctrl.required placeholder=\"{{\'ENTERPRISE_AUTOCOMPLETE.PLACEHOLDER.TYPE_ENTERPRISE\' | translate}}\"><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback company-holder\" ng-attr-data={{item.relationships.document.attributes.folder}} type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><span md-highlight-text=ctrl.enterprise class=\"text-sm leading-none text-gray-700 font-bold truncate\">{{item.attributes.name}}</span> <span class=\"text-xs leading-none text-gray-700 truncate\">{{item.attributes.cnpj}}</span></div><div layout layout-align=\"space-between center\"><span class=\"text-xs leading-none text-gray-400 truncate\">{{item.attributes.email}}</span> <span ng-if=item.attributes.phone1 class=\"text-xs leading-none font-bold truncate\">{{item.attributes.phone1 | phoneFilter}}</span></div></div></div></md-item-template><md-not-found><span translate=ENTERPRISE_AUTOCOMPLETE.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_enterprise.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISE_AUTOCOMPLETE.VALIDATION.ENTERPRISE></div></div></div></div>");
$templateCache.put("app/directives/form/users-autocomplete/users.html","<div layout layout-align=\"space-between center\"><div class=st-input-container ng-class=\"{\'no-padding\': hideLabel}\" layout=column flex><label ng-if=!hideLabel class=st-label ng-class=\"{\'st-required\': ctrl.required}\" translate=\"{{\'USERS_AUTOCOMPLETE.LABEL.\' + (labelText || \'USER\') }}\"></label><md-autocomplete class=st-input-autocomplete data-test=form.users_autocomplete md-autofocus=\"autoFocus || false\" md-clear-button=\"clearButton || false\" md-delay=800 md-input-name=autocomplete_users md-item-text=item.attributes.name md-items=\"item in ctrl.getUsers(searchText)\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=ctrl.minLength md-no-cache md-require-match md-search-text=searchText md-selected-item=selectedItem md-selected-item-change=\"onItemChange({ selectedItem: selectedItem })\" ng-disabled=\"disabledItem || false\" ng-required=ctrl.required placeholder=\"{{\'USERS_AUTOCOMPLETE.PLACEHOLDER.TYPE_USER\' | translate}}\"><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback user-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div class=\"w-8/12 truncate shrink\"><span md-highlight-text=ctrl.user class=\"text-sm leading-none text-gray-700 font-bold\">{{item.attributes.name}}</span></div><span class=\"w-4/12 truncate block shrink text-right\"><span class=\"text-xs leading-none text-gray-700\">{{item.attributes.phone1 | phoneFilter}}</span></span></div><div layout layout-align=\"space-between center\"><span class=\"text-xs leading-none text-gray-400\">{{item.attributes.cpf}}</span> <span class=\"text-xs leading-none font-bold\" translate=\"{{\'USERS_AUTOCOMPLETE.ENUM.ROLE_TYPE.\' + item.relationships.roles[0].attributes.name.toUpperCase()}}\"></span></div></div></div></md-item-template><md-not-found><span translate=USERS_AUTOCOMPLETE.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_users.$invalid\"><div class=st-input-validation ng-message=required translate=\"{{\'USERS_AUTOCOMPLETE.VALIDATION.\' + (labelText || \'USER\')}}\"></div></div><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/directives/form/vehicles-autocomplete/vehicles.html","<div layout layout-align=\"space-between center\"><div class=st-input-container ng-class=\"{\'no-padding\': hideLabel}\" layout=column flex><label ng-if=!hideLabel class=st-label ng-class=\"{\'st-required\': ctrl.required}\" translate=VEHICLE_AUTOCOMPLETE.LABEL.VEHICLE></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" data-test=form.vehicle_autocomplete md-autofocus=\"autoFocus || false\" md-clear-button=\"clearButton || false\" md-delay=800 md-input-name=autocomplete_vehicle md-items=\"item in ctrl.getVehicles(searchText)\" md-item-text=\"item.attributes.plate || item.attributes.vin\" md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-min-length=ctrl.minLength md-no-cache md-require-match md-search-text=searchText md-selected-item=selectedItem md-selected-item-change=\"onItemChange({ selectedItem: selectedItem })\" ng-disabled=\"disabledItem || false\" ng-required=ctrl.required placeholder=\"{{\'VEHICLE_AUTOCOMPLETE.PLACEHOLDER.TYPE_PLATE\' | translate}}\"><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback vehicle-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=searchText class=\"text-sm text-gray-700 font-bold\">{{item.attributes.plate || item.attributes.vin}}</span></div><span><span class=\"text-xs leading-none text-gray-700\" translate=\"{{\'VEHICLE_AUTOCOMPLETE.ENUM.VEHICLE_TYPE.\' + (item.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span></span></div><div layout layout-align=\"space-between center\"><span class=\"text-xs leading-none text-gray-400 w-9/12 truncate block\"><span ng-if=item.attributes.brand_name>{{item.attributes.brand_name}}</span> <span ng-if=\"item.attributes.brand_name && item.attributes.trim_name\" class=\"pr2 pl2\">|</span> <span ng-if=item.attributes.trim_name>{{item.attributes.trim_name}}</span> </span><span class=\"text-xs leading-none text-gray-400\">{{item.attributes.year}}</span></div></div></div></md-item-template><md-not-found><span translate=VEHICLE_AUTOCOMPLETE.HINT.NO_RESULTS translate-values=\"{ name: \'{{searchText}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"form.$submitted && form.autocomplete_vehicle.$invalid\"><div class=st-input-validation ng-message=required translate=VEHICLE_AUTOCOMPLETE.VALIDATION.VEHICLE></div></div></div></div>");
$templateCache.put("app/directives/inplace-editor/textarea/textarea-editor.directive.html","<div class=\"textarea-editor pb12 pt12\" layout=column flex><div class=\"pl12 pr12\" ng-if=ctrl.text><div class=\"text-base text-gray-700 font-semibold\" translate=\"{{\'INPLACE_EDITOR.LABEL.\' + ctrl.key.toUpperCase()}}\"></div></div><div ng-if=ctrl.editable><div class=\"textarea-content-wrapper mt8 pl12 pr12 rounded\" ng-click=\"ctrl.editable = !ctrl.editable\"><div class=\"textarea-content pt12 pb12\"><div ng-if=!ctrl.value class=\"text-sm font-normal text-slate-500\" translate=\"{{\'INPLACE_EDITOR.PLACEHOLDER.\' + ctrl.key.toUpperCase()}}\"></div><div class=\"text-sm font-normal text-slate-800\" ng-bind-html=\"ctrl.value | trust\"></div></div></div></div><div class=p12 ng-if=!ctrl.editable><textarea ui-tinymce=ctrl.tinymceOptions class=\"st-input-type input-textarea\" ng-model=ctrl.text translate-attr=\"{ placeholder: \'EVENTS.PLACEHOLDER.DESCRIPTION\' }\"></textarea><div class=pt12 layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" ng-click=ctrl.close()><span translate=INPLACE_EDITOR.ACTION.CANCEL></span></button> <button type=button class=\"altnav-action save\" ng-click=ctrl.save()><span translate=INPLACE_EDITOR.ACTION.SAVE></span></button></div></div></div>");
$templateCache.put("app/directives/navigator-wrapper/actions/actions.directive.html","<div class=\"group-button add\" can-access=INTERNALS,MANAGER,OPERATOR><a class=item-button-group href=\"\" ng-click=ctrl.add(ctrl.$scope.contract.new) translate-attr=\"{ title: \'NAVIGATOR.ACTION.ADD\' }\"><i class=material-symbols-outlined>add</i> <span class=\"ml8 mr8\" translate=NAVIGATOR.ACTION.ADD></span></a><md-menu ng-if=ctrl.$scope.contract.actions md-position-mode=\"target-right target\" md-offset=\"0 48\"><a class=item-button-group href=\"\" ng-click=$mdMenu.open($event)><i class=material-symbols-outlined>expand_more</i></a><md-menu-content width=2><md-menu-item ng-repeat=\"action in ctrl.$scope.contract.actions\"><md-button ng-click=ctrl.openAction(action) aria-label={{action}}><span class=st-drag-anchor translate=\"{{\'NAVIGATOR.VIEWS.\' + action.toUpperCase()}}\"></span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/directives/navigator-wrapper/export/export.directive.html","<div layout layout-align=\"space-between center\" can-access=INTERNALS,MANAGER class=mr12><md-menu ng-if=ctrl.$scope.contract.export md-position-mode=\"target-right target\" md-offset=\"-130 60\"><button type=button class=\"altnav-action no-back sm-icons\" translate-attr=\"{ title: \'NAVIGATOR.LABEL.EXPORTING\' }\" ng-click=$mdMenu.open($event) ng-disabled=ctrl.preventOpen><i class=material-symbols-outlined>launch</i> <span translate=NAVIGATOR.ACTION.EXPORT></span></button><md-menu-content class=st-nav-menu-list sv-root sv-part=ctrl.$scope.exportList width=4><div class=st-nav-menu-header><label class=st-nav-label><input ng-model=ctrl.pickAll name=pickAll type=checkbox ng-click=ctrl.toggleSelection() md-prevent-menu-close> <span translate=NAVIGATOR.ACTION.PICKALL></span></label></div><div class=st-nav-menu-item ng-repeat=\"f in ctrl.$scope.exportList\" sv-element><label class=st-nav-label><input ng-model=f.checked ng-value=checked name=check-{{$index}} type=checkbox ng-click=ctrl.recalculateSelected(f.checked) md-prevent-menu-close> <span class=st-drag-anchor translate={{f.attr}}></span></label></div><div class=st-nav-menu-bottom><button type=button class=st-nav-menu-button ng-disabled=\"ctrl.selectedItems == 0\" ng-click=\"ctrl.prepareToExport(\'CSV\')\" translate=NAVIGATOR.EXPORT.EXPORT></button></div></md-menu-content></md-menu></div>");
$templateCache.put("app/directives/navigator-wrapper/export-dialog/export-dialog.directive.html","<div layout layout-align=\"space-between center\" can-access=INTERNALS,MANAGER class=mr12><button type=button class=\"altnav-action no-button no-back sm-icons\" translate-attr=\"{ title: \'NAVIGATOR.LABEL.EXPORTING\' }\" ng-click=ctrl.openOptions() ng-disabled=ctrl.preventOpen><i class=material-symbols-outlined>launch</i> <span translate=NAVIGATOR.ACTION.EXPORT></span></button></div>");
$templateCache.put("app/directives/navigator-wrapper/search/search.directive.html","<div class=search-bar><div layout layout-align=\"space-between center\"><div class=\"relative w-72 h-8\"><div class=\"search-bar__container h-8 box-border border-gray-300 border border-solid rounded bg-white\" ng-class=\"{\n          \'--open absolute z-50 top-0 right-0 h-10 w-open\': ctrl.openSearchBar,\n          \'relative w-72\' : !ctrl.openSearchBar\n        }\" layout layout-align=\"start center\"><p class=\"st-tags cursor-pointer mr8\" ng-if=\"ctrl.hasMassiveSearch && ctrl.openSearchBar\" layout layout-align=\"center center\" ng-click=ctrl.toogleTypeSearch()><span class=\"text-sm mr4\" translate=\"{{\'NAVIGATOR.ACTION.\' + ctrl.typeSearch.toUpperCase()}}\"></span></p><p class=\"st-tags cursor-pointer ml8 mr8\" ng-if=\"ctrl.hasSingleSearch && ctrl.searchFor && ctrl.openSearchBar\" layout layout-align=\"center center\"><span class=\"text-sm mr4\" translate=\"{{\'NAVIGATOR.ENUM.\' + ctrl.searchForData.name}}\"></span> <button type=button class=\"no-button no-padding\" ng-click=ctrl.clearSearchFor()><i class=\"material-symbols-outlined text-base text-gray-700 cursor-pointer\">close</i></button></p><input class=\"search-bar__input h-full box-border border-0 rounded text-gray-800 text-sm grow outline-none no-padding\" data-test=navigator.search-input ng-blur=ctrl.closeSearchBar() ng-class=\"{ \'cursor-not-allowed\': ctrl.loading }\" ng-disabled=ctrl.loading ng-focus=ctrl.inputEvents($event) ng-keyup=ctrl.inputEvents($event) ng-readonly=ctrl.inputDisabled ng-model=ctrl.searchText placeholder=\"{{\'NAVIGATOR.PLACEHOLDER.SEARCH_BAR\' | translate}}\" type=text> <button type=button class=no-button ng-if=\"ctrl.searchText && ctrl.openSearchBar\" ng-click=\"ctrl.searchText= \'\'; ctrl.focusInput()\" layout layout-align=\"center center\"><span class=\"text-sm text-gray-400\" translate=NAVIGATOR.ACTION.CLEAR></span></button> <button type=button class=\"no-button no-padding\" ng-if=\"ctrl.openSearchBar || ctrl.hasParams\" ng-click=ctrl.closeEvent()><i class=\"material-symbols-outlined text-lg text-gray-700\">close</i></button></div><div class=\"search-bar__list absolute top-10 right-0 bg-white z-50 w-open rounded box-border\" ng-class=\"{\'hidden\': !ctrl.openSearchBar || ctrl.searchFor}\" when-scrolled=\"ctrl.typeSearch === \'custom\' && !ctrl.itemsEnd && ctrl.loadMore()\"><ul ng-if=!ctrl.typeList class=\"pt-4 pb-4\" ng-class=\"{\'h-56\': ctrl.typeSearch === \'custom\'}\"><!-- SEARCH SINGLE AND MASSIVE --><li ng-if=\"ctrl.typeSearch !== \'custom\'\" ng-repeat=\"item in ctrl.listSingleMassive\" class=\"pl-4 pr-4\"><p ng-if=item.title class=\"text-stone-500 text-xs font-bold\" translate>{{\'NAVIGATOR.TITLE.\' + item.text}}</p><div ng-if=!item.title class=\"display-flex flex-wrap pt-1\" ng-class=\"{\'mb-2 pb-2 border-0 border-b border-solid border-gray-200\': ctrl.typeSearch === \'single\' || !ctrl.searchText}\"><span ng-repeat=\"item in item.list\" ng-click=ctrl.setSearchFor(item) class=\"search-bar__tags search-bar__selected st-tags mr-1 mt-1 cursor-pointer\" layout layout-align=\"start center\"><span layout layout-align=\"center center\"><span class=\"text-xs text-gray-900\" translate=\"{{\'NAVIGATOR.ENUM.\' + item.name}}\"></span></span></span></div></li><!-- RECOMMENDED --><li ng-if=\"!ctrl.searchText && ctrl.typeSearch === \'single\'\" ng-repeat=\"item in ctrl.listRecommended\" class=\"pl-4 pr-4\"><p ng-if=item.title class=\"text-stone-500 text-xs font-bold mb-2\" translate=NAVIGATOR.TITLE.RECOMMENDED></p><div ng-if=!item.title class=\"display-flex flex-wrap mb-2 pb-2 border-0 border-b border-solid border-gray-200\"><span ng-repeat=\"tag in item.tags\" ng-click=ctrl.searchRecommended(tag) class=\"search-bar__tags search-bar__selected st-tags mr-1 mt-1 cursor-pointer\" layout layout-align=\"start center\"><span layout layout-align=\"center center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-1\">trending_up</i> <span class=\"text-xs text-gray-900\" translate=\"{{\'NAVIGATOR.ENUM.RECOMMENDED_QUERIES.\' + tag.name}}\"></span></span></span></div></li><!-- HISTORY --><li ng-if=\"!ctrl.searchText && ctrl.typeSearch !== \'custom\'\" ng-repeat=\"item in ctrl.listHistory\" class=mb-2><p ng-if=item.title class=\"text-stone-500 text-xs font-bold mb-2 pl-4 pr-4\" translate=NAVIGATOR.TITLE.HISTORY></p><p ng-if=item.empty class=\"search-bar__default h-8 pl-4 pr-4\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">history</i> <span class=\"text-xs text-gray-900\" translate=NAVIGATOR.HINT.NOT_FOUND></span></p><div ng-if=!item.title ng-class=\"{\'border-0 border-b border-solid border-gray-200 pb-2\': $last && (filter || ctrl.searchText)}\"><div ng-if=\"item.key && item.value && item.type !== \'custom\'\" ng-click=\"ctrl.searchByKey(item, true)\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4 w-full\" layout layout-align=\"space-between center\"><button class=\"no-button no-padding\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">history</i> <span class=st-tags layout layout-align=\"center center\" translate>{{\'NAVIGATOR.ACTION.\' + item.type.toUpperCase()}}</span> <span class=\"st-tags ml-1\" layout layout-align=\"center center\" translate=\"{{\'NAVIGATOR.ENUM.\' + item.name}}\">{{item.name}}</span> <span class=\"text-xs text-gray-900 truncate grow ml-1\">{{item.value}}</span></button> <button type=button class=\"no-button no-padding\" ng-click=ctrl.removeHistory(item)><i class=\"search-bar__remove-history material-symbols-outlined text-base text-gray-900\">close</i></button></div><div ng-if=\"item.type === \'recommended\'\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\" layout layout-align=\"space-between center\"><div ng-click=ctrl.searchRecommended(item) class=w-full><button class=\"no-button no-padding\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">history</i> <span class=st-tags layout layout-align=\"center center\"><i class=\"material-symbols-outlined text-xs\">trending_up</i> <span translate=\"{{\'NAVIGATOR.ENUM.RECOMMENDED_QUERIES.\' + item.name}}\"></span></span></button></div><button type=button class=\"no-button no-padding\" ng-click=ctrl.removeHistory(item)><i class=\"search-bar__remove-history material-symbols-outlined text-base text-gray-900\">close</i></button></div><div ng-if=\"item.type === \'search\'\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\" layout layout-align=\"space-between center\"><div ng-click=ctrl.search(item) class=w-full><button class=\"no-button no-padding\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-base text-gray-800 pr-2\">history</i> <span class=\"text-xs text-gray-900 truncate grow\">{{item.name}}</span></button></div><button type=button class=\"no-button no-padding\" ng-click=ctrl.removeHistory(item)><i class=\"search-bar__remove-history material-symbols-outlined text-base text-gray-900\">close</i></button></div><div ng-if=\"item.type === \'custom\'\" ng-click=\"ctrl.searchCustom(item, true)\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4 w-full\" layout layout-align=\"space-between center\"><button class=\"no-button no-padding\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">history</i> <span class=st-tags layout layout-align=\"center center\" translate>{{\'NAVIGATOR.ACTION.\' + item.type.toUpperCase()}}</span> <span class=\"text-xs text-gray-900 truncate grow ml-1\">{{item.value}}</span></button> <button type=button class=\"no-button no-padding\" ng-click=ctrl.removeHistory(item)><i class=\"search-bar__remove-history material-symbols-outlined text-base text-gray-900\">close</i></button></div></div></li><!-- CUSTOM --><li ng-if=\"ctrl.typeSearch === \'custom\'\" ng-repeat=\"item in ctrl.listCustom\"><p ng-if=item.title class=\"text-stone-500 text-xs font-bold mb-2 pl-4 pr-4\" layout layout-align=\"start center\"><span translate=NAVIGATOR.TITLE.CUSTOM></span> <span ng-if=!ctrl.loadingCustom class=\"bg-gray-900 text-white text-xs rounded-full h-5 w-5 ml-1\" layout layout-align=\"center center\">{{ctrl.meta.count}}</span></p><p ng-if=item.empty class=\"search-bar__default h-8 pl-4 pr-4\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">filter_alt</i> <span class=\"text-xs text-gray-900\" translate=NAVIGATOR.HINT.NOT_FOUND_CUSTOM></span></p><button ng-if=\"!item.title && !item.empty\" class=\"no-button no-padding w-full\" ng-click=ctrl.searchCustom(item)><span class=\"search-bar__default h-8 pl-4 pr-4\" layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-sm text-gray-800 pr-2\">filter_alt</i> <span class=\"text-xs text-gray-900\">{{item.attributes.name}}</span></span></button></li><li ng-if=\"ctrl.typeSearch === \'custom\' && ctrl.loadingCustom\"><div layout layout-align=\"center center\" class=\"pt-2 pb-2\"><progress></progress></div></li><li ng-if=\"filter && !ctrl.searchText && ctrl.typeSearch !== \'custom\'\"><div class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\"><button type=button class=\"no-button no-padding h-8 w-full\" layout layout-align=\"start center\" ng-click=ctrl.openAdvancedFilter() ng-disabled=ctrl.preventOpen><i class=\"material-symbols-outlined text-sm pr-2\">filter_list</i> <span class=text-sm translate=NAVIGATOR.ACTION.ADVANCED_FILTER></span></button></div></li><li ng-if=\"ctrl.searchText && ctrl.typeSearch === \'single\'\" layout layout-align=\"start center\" class=\"pl-4 pr-4\"><span ng-if=!!ctrl.tooltipKey class=\"cursor-pointer mr4\"><md-tooltip md-direction=bottom md-z-index=9999><p translate=\"{{\'NAVIGATOR.ENUM.TOOLTIP.\' + ctrl.tooltipKey}}\"></p></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></span><p class=\"text-sm text-gray-700 h-8\" layout layout-align=\"start center\" flex><span class=whitespace-nowrap translate=NAVIGATOR.LABEL.RESULT_FOR></span> <span class=truncate>\"{{ctrl.searchText}}\"</span> <span class=\"ml-auto pl-8 whitespace-nowrap\" translate=NAVIGATOR.LABEL.TYPE_ENTER></span></p></li></ul><ul ng-if=ctrl.typeList class=\"search-bar__type-list pt-4 pb-4\"><li class=\"mb-2 pl-4 pr-4\"><p class=\"text-stone-500 text-xs font-bold\" translate=NAVIGATOR.TITLE.SEARCH_TYPE></p></li><li layout layout-align=\"start center\" class=\"search-bar__type-list--item mb-2\"><div ng-click=\"ctrl.selectedTypeSearch(\'single\')\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\" flex layout layout-align=\"start center\"><button type=button class=\"no-button no-padding\"><p class=\"st-tags search-bar__tags\" translate=NAVIGATOR.ACTION.SINGLE></p></button><p class=\"text-gray-500 text-xs pl-2\" translate=NAVIGATOR.HINT.SINGLE></p></div></li><li ng-if=ctrl.hasMassiveSearch layout layout-align=\"start center\" class=\"search-bar__type-list--item mb-2\"><div ng-click=\"ctrl.selectedTypeSearch(\'massive\')\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\" flex layout layout-align=\"start center\"><button type=button class=\"no-button no-padding\"><p class=\"st-tags search-bar__tags\" translate=NAVIGATOR.ACTION.MASSIVE></p></button><p class=\"text-gray-500 text-xs pl-2\" translate=NAVIGATOR.HINT.MASSIVE></p></div></li><li layout layout-align=\"start center\" class=\"search-bar__type-list--item mb-2\"><div ng-click=\"ctrl.selectedTypeSearch(\'custom\')\" class=\"search-bar__default search-bar__selected relative h-8 pl-4 pr-4\" flex layout layout-align=\"start center\"><button type=button class=\"no-button no-padding\"><p class=\"st-tags search-bar__tags\" translate=NAVIGATOR.ACTION.CUSTOM></p></button><p class=\"text-gray-500 text-xs pl-2\" translate=NAVIGATOR.HINT.CUSTOM></p></div></li></ul></div></div></div></div>");
$templateCache.put("app/directives/navigator-wrapper/title/title.directive.html","<div class=\"screen-info text-gray-500 h-full\" layout layout-align=\"start center\" flex><div class=\"text-2xl leading-tight items-baseline font-bold text-gray-900\" translate=\"{{ \'NAVIGATOR.CRUMBS.\' + ctrl.path[1].toUpperCase()}}\"></div><div ng-if=\"(amount || amount === 0)\" class=\"text-sm leading-tight items-baseline text-gray-500 ml8 pt4\"><span translate=NAVIGATOR.LABEL.TOTAL_AMOUNT></span> <span class=ml2>{{amount | number:0}}</span></div><a ng-if=ctrl.$scope.contract.stats href=\"\" class=icon-helper ng-click=ctrl.goToStats()><i class=material-symbols-outlined>timeline</i></a></div>");
$templateCache.put("app/internal/monitoring/center/center.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar contract=ctrl.options></title-bar></div></div><div layout layout-align=\"space-between center\" class=\"details-tab-wrapper mt16 ml16 mr16\"><div layout class=details-tabs><button ui-sref-active=active ui-sref=center.board class=details-tab-item ng-click=ctrl.resetFilters()><span class=tab-text translate=ALERTS.TABS.GENERAL></span> <span class=tab-bar></span></button> <button ui-sref-active=active ui-sref=center.events-list class=details-tab-item ng-click=ctrl.resetFilters()><span class=tab-text translate=ALERTS.TABS.EVENTS></span> <span class=tab-bar></span></button><!-- <button ui-sref-active=\"active\" ui-sref=\"center.hybrid\" class=\"details-tab-item\" ng-click=\"ctrl.resetFilters()\">\n      <span class=\"tab-text\" translate=\"ALERTS.TABS.MAP\"></span>\n      <span class=\"tab-bar\"></span>\n    </button> --><!-- <button ui-sref-active=\"active\" class=\"details-tab-item\">\n      <span class=\"tab-text\">Relatórios</span>\n      <span class=\"tab-bar\"></span>\n    </button> --></div><div><button class=\"altnav-action sm-icons\" translate-attr=\"{ title: \'NAVIGATOR.LABEL.EXPORTING\' }\" ng-click=ctrl.openFilter() ng-disabled=ctrl.pendingRequest ng-class=\"{ \'badge\': ctrl.hasActiveFilter() }\"><i class=material-symbols-outlined>filter_list</i> <span translate=ALERTS.ACTION.FILTER></span></button></div></div><div layout=column flex=100><div flex ng-include src=\"\'app/internal/monitoring/center/components/filterable-tags/_filterable-tags.html\'\"></div><div ui-view></div></div>");
$templateCache.put("app/internal/monitoring/tracking/tracking.html","<div id=map-wrapper><!-- change layer --><!-- <div id=\"map-preview\" ng-class=\"{sliced: ctrl.controls.showDeviceInfo, opened: ctrl.openFilter, satellite: ctrl.mapStyle.layer === \'streets\', streets: ctrl.mapStyle.layer === \'satellite\'}\" ng-click=\"ctrl.setMapStyle()\"></div> --><!-- map --><div id=map class=tracking flex><div id=map-style-wrapper class=\"bg-white rounded-md absolute w-16 h-16 bottom-2 left-2\" ng-click=ctrl.showStyleOptions() ng-class=\"{opened: ctrl.controls.showDeviceInfo}\"><div class=\"map-style-options bg-white rounded-md bottom-0 absolute p8\" ng-class=\"{ hovered: ctrl.openMapStyle }\" ng-mouseenter=ctrl.keepStyleOptions() ng-mouseleave=ctrl.hideStyleOptions()><div layout layout-align=\"start center\"><button type=button ng-repeat=\"(k, i) in ctrl.mapStyles\" class=\"style-item w-12 h-12 bg-gray-200 rounded-md relative no-button map-style-sprite {{k}}\" ng-click=ctrl.changeMapStyle(k)></button></div></div><div class=\"w-14 h-14 bg-gray-200 rounded-md relative no-button m4 selected-map-style map-style-sprite {{ctrl.selectedMapStyle}}\"></div></div></div><!-- search --><!-- device --><div id=sidenav-search-wrapper><div id=sidenav-search><button type=button class=\"no-button absolute z-10 w-10 h-10 left-0\"><i class=\"material-symbols-outlined text-gray-600\">search</i></button><!-- search for devices --><md-autocomplete ng-if=!ctrl.geocoderSearch placeholder=\"{{\'TRACKING.PLACEHOLDER.SEARCH_ITEMS\' | translate}}\" md-input-name=autocomplete_search_items md-selected-item=ctrl.selectedItem md-search-text=ctrl.item md-items=\"item in ctrl.searchItems(ctrl.item)\" md-item-text=\"item.relationships.vehicle ? item.relationships.vehicle.attributes.plate : item.attributes.name\" md-min-length=3 md-delay=800 md-autofocus md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-selected-item-change=ctrl.setItemData() md-no-cache ng-keyup=\"ctrl.typed = true\"><md-item-template><div class=item layout layout-align=\"start center\"><span class=\"indicator w-8 display-flex items-center justify-center\"><report-indicator last-gps={{item.relationships.last_gps.attributes.last_gps_raw.act}} ignition={{item.relationships.last_gps.attributes.last_gps_raw.ign}}></report-indicator></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><span md-highlight-text=ctrl.item class=\"text-xs leading-tight text-gray-700 truncate\">{{item.relationships.vehicle ? item.relationships.vehicle.attributes.plate : item.attributes.name}}</span> <span class=\"st-tags xs\" ng-if=item.attributes.active><span translate=TRACKING.LABEL.ACTIVATED></span></span></div><div layout layout-align=\"space-between center\"><span><span ng-if=item.relationships.vehicle><span translate=\"{{\'TRACKING.ENUM.VEHICLE_TYPE.\' + item.relationships.vehicle.attributes.type_name.toUpperCase()}}\"></span> </span><span ng-if=!item.relationships.vehicle><span>{{item.relationships.type.attributes.brand_alias}} <span class=\"font-bold text-gray-700\">{{item.relationships.type.attributes.alias}}</span></span> </span></span><span class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.item}}\' }\"></span></md-not-found></md-autocomplete><!-- search for places --><md-autocomplete ng-if=ctrl.geocoderSearch placeholder=\"{{\'TRACKING.PLACEHOLDER.SEARCH_PLACES\' | translate}}\" md-input-name=autocomplete_search_places md-selected-item=ctrl.selectedPlace md-search-text=ctrl.item md-items=\"item in ctrl.searchPlaces(ctrl.item)\" md-item-text=item.formatted_address md-min-length=3 md-delay=800 md-autofocus md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-clear-button=false md-selected-item-change=ctrl.goToLocation() md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><span class=mr8><i class=\"material-symbols-outlined text-gray-400\">location_on</i></span><div class=results-info><span md-highlight-text=ctrl.item class=\"text-sm text-gray-700 font-normal\">{{item.formatted_address}}</span></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.place}}\' }\"></span></md-not-found></md-autocomplete><div class=\"absolute right-0 top-0\"><button type=button class=\"no-button w-10 h-10\" ng-click=\"ctrl.geocoderSearch = !ctrl.geocoderSearch\" ng-disabled=ctrl.selectedItem><i class=material-symbols-outlined ng-class=\"ctrl.geocoderSearch ? \'text-blue-600\' : \'text-gray-600\'\">explore</i></button> <button type=button class=\"no-button w-10 h-10\" ng-click=\"ctrl.controls.showDeviceInfo = !ctrl.controls.showDeviceInfo\"><i class=\"material-symbols-outlined text-gray-600\">tune</i></button></div></div></div><!-- sidenav --><div id=sidenav-map ng-class=\"{opened: ctrl.controls.showDeviceInfo}\"><div class=sidenav-main-info><div ng-if=!ctrl.selectedItem><!-- slider --><div class=m16><div><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.INTERVAL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.INTERVAL_CAP></span></div><div layout=column layout-align=space-between><div layout layout-align=\"space-between center\"><rzslider class=st-time-slider rz-slider-model=ctrl.reportTimeSlider.reportedUpTo rz-slider-high=ctrl.reportTimeSlider.reportedSince rz-slider-options=ctrl.reportTimeSlider.options flex></rzslider></div></div></div><!-- vehicle state --><div class=m16><div layout=column><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.VEHICLE_STATE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.VEHICLE_STATE_CAP></span></div><div layout=column layout-align=\"space-between stretch\" class=m8><label><input type=radio ng-model=ctrl.filters.vehicleState value=0 ng-change=ctrl.setFilters() checked> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.IGNITION.ALL></span></label><label><input type=radio ng-model=ctrl.filters.vehicleState value=true ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.IGNITION.TRUE></span></label><label><input type=radio ng-model=ctrl.filters.vehicleState value=false ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.IGNITION.FALSE></span></label></div></div><!-- vehicle type --><div class=m16><div layout=column><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.VEHICLE_TYPE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.VEHICLE_TYPE_CAP></span></div><div layout=column layout-align=\"space-between stretch\" class=m8><label><input type=checkbox ng-model=ctrl.filters.vehicleType.CAR ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.VEHICLE_TYPE.CAR></span></label><label><input type=checkbox ng-model=ctrl.filters.vehicleType.MOTORCYCLE ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.VEHICLE_TYPE.MOTORCYCLE></span></label><label><input type=checkbox ng-model=\"ctrl.filters.vehicleType[\'TRUCK/BUS\']\" ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.VEHICLE_TYPE.TRUCK/BUS></span></label><label><input type=checkbox ng-model=ctrl.filters.vehicleType.OTHER ng-change=ctrl.setFilters()> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.ENUM.VEHICLE_TYPE.OTHER></span></label></div></div><!-- clustering activation --><div class=m16 layout layout-align=\"space-between center\"><div layout=column><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.CLUSTERING></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.CLUSTERING_CAP></span></div><div><md-switch class=st-activation-switch ng-model=ctrl.filters.clustering ng-change=ctrl.setFilters() md-no-ink aria-label=\"Clustering Definition Switch\"></div></div><!-- clustering activation --><div class=m16 layout layout-align=\"space-between center\"><div layout=column><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.RISKAREA></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.RISKAREA_CAP></span></div><div><md-switch class=st-activation-switch ng-model=ctrl.controls.showRiskAreas ng-change=ctrl.toggleRiskarea() md-no-ink aria-label=\"Riskarea switch\"></div></div><!-- clustering activation --><div class=m16 layout layout-align=\"space-between center\"><div layout=column><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.ERB_STATION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.LABEL.ERB_STATION_CAP></span></div><div><md-switch class=st-activation-switch ng-model=ctrl.controls.showErbs ng-change=ctrl.toggleErbs() md-no-ink aria-label=\"Erbs Switch\"></div></div></div><div ng-if=ctrl.selectedItem><!-- tabs --><div class=\"details-tab-wrapper m16\" flex><div class=details-tabs><button class=details-tab-item ng-class=\"{active: ctrl.selectedTab === \'general\'}\" ng-click=\"ctrl.setTab(\'general\')\"><span translate=TRACKING.ENUM.TAB.GENERAL></span></button> <button can-access=INTERNALS,MANAGER,OPERATOR class=details-tab-item ng-class=\"{active: ctrl.selectedTab === \'commands\'}\" ng-click=\"ctrl.setTab(\'commands\')\"><span translate=TRACKING.ENUM.TAB.COMMANDS></span></button> <button class=details-tab-item ng-class=\"{active: ctrl.selectedTab === \'trajectories\'}\" ng-click=\"ctrl.setTab(\'trajectories\')\" ng-disabled=!ctrl.selectedItem.relationships.vehicle><span translate=TRACKING.ENUM.TAB.TRAJECTORIES></span></button></div></div><div ng-if=\"ctrl.selectedTab === \'general\'\"><div flex ng-include=\"\'app/internal/monitoring/tracking/components/general/_general.html\'\"></div></div><div ng-if=\"ctrl.selectedTab === \'commands\'\" can-access=INTERNALS,MANAGER><div ng-include=\"\'app/internal/monitoring/tracking/components/commands/_commands.html\'\"></div></div><div ng-if=\"ctrl.selectedTab === \'trajectories\'\"><div flex ng-include=\"\'app/internal/monitoring/tracking/components/trajectories/_trajectories.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/internal/organization/dashboard/dashboard.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div><md-grid-list md-cols=8 md-gutter=16px md-row-height=150px><md-grid-tile md-rowspan=1 md-colspan=8><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div><div class=st-subhead translate=DASHBOARD.ITEMS.ACTIVES_ITEM></div><div class=st-caption translate=DASHBOARD.ITEMS.CHECKING></div></div><div layout layout-align=\"space-between center\"><div class=mr24 layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.VEHICLES></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=vehicles-list><span no-data-holder>{{ctrl.summary.vehicles.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div><div><div class=st-caption translate=DASHBOARD.ITEMS.ACTIVES></div><span><span no-data-holder>{{ctrl.summary.vehicles.actives | number}}</span></span></div></div></div><div class=\"pr24 pl24 border-0 border-l border-solid border-gray-300\" layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.DEVICES></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=devices-list><span no-data-holder>{{ctrl.summary.devices.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div><div><div class=st-caption translate=DASHBOARD.ITEMS.ACTIVES></div><span><span no-data-holder>{{ctrl.summary.devices.actives | number}}</span></span></div></div></div><div class=\"pr24 pl24 border-0 border-r border-l border-solid border-gray-300\" layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.USERS></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=users-list><span no-data-holder>{{ctrl.summary.users.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div><div><div class=st-caption translate=DASHBOARD.ITEMS.ACTIVES></div><span><span no-data-holder>{{ctrl.summary.users.actives | number}}</span></span></div></div></div><div class=ml24 layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.CHIPS></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=chips-list><span no-data-holder>{{ctrl.summary.chips.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div></div></div><div class=\"pr24 pl24 border-0 border-r border-l border-solid border-gray-300\" layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.ENTERPRISES></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=enterprises-list><span no-data-holder>{{ctrl.summary.enterprises.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div></div></div><div class=ml24 layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.PROTOCOLS></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=protocols-list><span no-data-holder>{{ctrl.summary.protocols.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div></div></div><div class=\"pr24 pl24 border-0 border-l border-solid border-gray-300\" layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.ITEMS.SERVICE_ORDERS></div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.ITEMS.TOTAL></div><a ui-sref=service-orders-list><span no-data-holder>{{ctrl.summary.serviceOrders.total | number}}</span> <span class=\"text-gray-500 material-symbols-outlined text-sm\">north_east</span></a></div></div></div></div></div></md-grid-tile><md-grid-tile md-rowspan=1 md-colspan=2><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div><div class=st-subhead translate=DASHBOARD.RISK_PROFILE.YOUR_VEHICLES></div><div class=st-caption translate=DASHBOARD.RISK_PROFILE.NO_CONNECTION></div></div><div class=md-headline>{{ctrl.mainCommunicationStatus.last_gps_time[5] | number}}</div><div class=st-subhead-lite translate=DASHBOARD.RISK_PROFILE.CRITIC_STATE></div></div></md-grid-tile><md-grid-tile md-rowspan=1 md-colspan=1><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div layout=column layout-align=\"center center\" flex><button type=button class=no-button layout=column layout-align=\"center center\" ng-click=ctrl.showListNoBattery()><i class=\"material-symbols-outlined rotate-90 text-3xl\">battery_2_bar</i><div class=md-headline>{{ctrl.fleet.batteryLevel | number}}</div></button></div><div class=\"st-caption center\" translate=DASHBOARD.RISK_PROFILE.DISCONNECTED_DEVICES></div></div></md-grid-tile><md-grid-tile md-rowspan=3 md-colspan=3><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div class=fleet-value flex><div><div class=st-subhead translate=DASHBOARD.FLEET.VALUE></div><div class=st-caption translate=DASHBOARD.FLEET.KEEP_UP_VALUE></div></div><div layout layout-align=\"space-between center\"><div flex=50><div id=donut></div></div><div flex><ul class=vehicle-list layout=column layout-align=\"space-between stretch\"><li class=item-type><span class=st-caption translate=DASHBOARD.FLEET.TRUCK></span> <span class=st-aux>{{ctrl.fleet.value.truck.totalValue.currentPrice | currency}}</span></li><li class=item-type><span class=st-caption translate=DASHBOARD.FLEET.CAR></span> <span class=st-aux>{{ctrl.fleet.value.car.totalValue.currentPrice | currency}}</span></li><li class=item-type><span class=st-caption translate=DASHBOARD.FLEET.MOTORCYCLE></span> <span class=st-aux>{{ctrl.fleet.value.motorcycle.totalValue.currentPrice | currency}}</span></li></ul></div></div></div><div><div><div class=st-subhead translate=DASHBOARD.FLEET.STATISTICS></div><div class=st-caption translate=DASHBOARD.FLEET.VALUE_METRICS></div></div><br><br><div layout layout-align=\"space-between center\"><div flex=50><div class=mb8><div class=st-subhead translate=DASHBOARD.FLEET.GROWTH></div><div class=st-caption translate=DASHBOARD.FLEET.30_DAYS></div></div><div class=mt8><div class=md-display-1>{{ctrl.fleet.value.truck.totalValue.currentPrice + ctrl.fleet.value.car.totalValue.currentPrice + ctrl.fleet.value.motorcycle.totalValue.currentPrice | shortCurrency}}</div></div></div><div flex=50><div class=mb8><div class=st-subhead translate=DASHBOARD.FLEET.DEVALUATION></div><div class=st-caption translate=DASHBOARD.FLEET.30_DAYS></div></div><div class=mt8><div class=md-display-1>{{ctrl.fleet.value.truck.totalValue.depreciation + ctrl.fleet.value.car.totalValue.depreciation + ctrl.fleet.value.motorcycle.totalValue.depreciation | shortCurrency}}</div></div></div></div><br><br><div><div class=st-caption translate=DASHBOARD.FLEET.SOURCE></div></div></div></div></md-grid-tile><md-grid-tile md-rowspan=1 md-colspan=2><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div><div class=st-subhead translate=DASHBOARD.COVER.GSM></div><div class=st-caption translate=DASHBOARD.COVER.AVG_GSM_TIME></div></div><div class=md-headline>{{86400 *ctrl.fleet.signal | duration}}</div><div layout layout-align=\"space-between center\"><div><div class=st-caption translate=DASHBOARD.COVER.MAX_GSM_TIME></div><div>{{ctrl.fleet.signalMax | duration}}</div></div><div><div class=st-caption translate=DASHBOARD.COVER.MIN_GSM_TIME></div><div>{{ctrl.fleet.signalMin | duration}}</div></div></div></div></md-grid-tile><md-grid-tile md-rowspan=2 md-colspan=3><div class=\"bg-white border border-solid border-gray-200 rounded-md h-full w-full overflow-hidden relative\" layout=column layout-align=\"space-between stretch\" flex><div class=\"mt16 ml16 mr8\"><div layout layout-align=\"space-between center\"><div><div class=st-subhead translate=DASHBOARD.COMMUNICATION.STATUS></div><div class=st-caption translate=DASHBOARD.COMMUNICATION.CHECK_CONNECTIONS></div></div><button type=button class=no-button ng-click=ctrl.showListNeverRespond()><i class=material-symbols-outlined>open_in_new</i></button></div></div><div class=\"ml16 mr16 mb4\" layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><button type=button class=\"chips-status-item mr8\" ng-class=\"{\'active\': ctrl.communicationStandard === standard}\" ng-repeat=\"standard in ctrl.communicationStandards\" ng-click=ctrl.changeCommunicationStandard(standard)><span translate=\"{{\'DASHBOARD.STANDARD.\' + standard.toUpperCase()}}\"></span></button></div><div class=\"st-input-container no-padding\" layout=column flex=20><md-select class=st-input-select name=plan_id ng-model=ctrl.selectedVehicleTypes aria-label=\"Select Type\" multiple md-no-asterisk md-on-close=ctrl.loadVehiclesStatus(ctrl.communicationStandard)><md-option ng-repeat=\"t in ctrl.vehicleTypes\" ng-value=t>{{ \'DASHBOARD.VEHICLE_TYPE.\' + t.toUpperCase() | translate }}</md-option></md-select></div></div><ul class=communication-legends layout=column layout-align=\"space-between stretch\"><li class=item layout layout-align=\"start center\" ng-repeat=\"steps in ctrl.communicationStatus track by $index\" flex><div><communication-status class=communication-status steps={{steps[0]}} index={{$index}}></communication-status></div><div layout layout-align=\"space-between center\" flex><div class=column-bar flex=85><div class=\"square light-grey column-holder\"></div><div class=\"square light-blue\" ng-style=\"{width: 100 * steps[ctrl.step] / ctrl.totalCars + \'%\'}\"><md-tooltip><span>{{steps[ctrl.step] | number:\'0\'}} <span translate=DASHBOARD.COMMUNICATION.VEHICLES></span></span></md-tooltip></div></div><span class=\"ml8 right\" data-metrics=percentage>{{100 * steps[ctrl.step] / ctrl.totalCars | number:\'1\'}}</span></div></li></ul></div></md-grid-tile><md-grid-tile md-rowspan=2 md-colspan=2><div class=st-panel-card layout=column layout-align=\"space-between stretch\" flex><div class=st-subhead translate=DASHBOARD.RISK_RATE.RATE></div><div><div id=risk-area></div><div class=risk-description><div class=rd-title>{{ctrl.riskRateWarning.title}}</div><div class=rd-subtitle>{{ctrl.riskRateWarning.subtitle}}</div></div></div></div></md-grid-tile><md-grid-tile md-rowspan=2 md-colspan=8><div class=\"st-panel-card no-padding\" layout=column layout-align=\"start stretch\" flex><div class=\"ml8 pl8 mt8 pt8\"><div class=st-subhead translate=DASHBOARD.MOVEMENT.PROFILE></div><div class=st-caption translate=DASHBOARD.MOVEMENT.BEHAVIOR></div></div><behavior-chart id=bar-chart ng-if=!ctrl.loading.values flex=100></behavior-chart></div></md-grid-tile></md-grid-list></div></div></div>");
$templateCache.put("app/internal/reports/boundary/boundary.html","<div id=map-wrapper class=boundary-map><div id=map class=boundary><div class=new-search-area ng-if=\"ctrl.trajectories && ctrl.controls.hasmoved && ctrl.controls.requested >= 1\"><button class=\"altnav-action white md-whiteframe-2dp\" type=button ng-click=ctrl.search()><span layout><span class=mr8 translate=BOUNDARY.ACTION.NEW_SEARCH></span></span></button></div></div><div id=sidenav-map class=left-0 ng-class=\"{opened: ctrl.controls.showInfo}\"><form ng-if=!ctrl.trajectories name=ctrl.form class=form-trajectories ng-submit=\"ctrl.form.$valid && ctrl.search()\" novalidate><div id=sidenav-search-wrapper><div id=sidenav-search><button type=button class=\"no-button absolute z-10 w-10 h-10 left-0\"><i class=\"material-symbols-outlined text-gray-600\">search</i></button><!-- search for devices --><md-autocomplete placeholder=\"{{\'BOUNDARY.PLACEHOLDER.TYPE_VEHICLE\' | translate}}\" md-input-name=autocomplete_search_items md-selected-item=ctrl.selectedVehicle md-search-text=ctrl.vehicle md-items=\"item in ctrl.getVehicles(ctrl.vehicle)\" md-item-text=\"item.attributes.plate || item.attributes.vin\" md-min-length=3 md-delay=800 md-autofocus md-clear-button=false md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-selected-item-change=ctrl.openSideNav()><md-item-template><div class=item layout layout-align=\"start center\" flex><span class=\"image-holder small-image mr8\"><object class=\"image-holder-fallback vehicle-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=vehicle class=\"text-sm text-gray-700 font-bold\">{{item.attributes.plate || item.attributes.vin}}</span></div><span><span class=\"text-xs leading-none text-gray-700\" translate=\"{{\'BOUNDARY.ENUM.VEHICLE_TYPE.\' + (item.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span></span></div><div layout layout-align=\"space-between center\"><span class=\"text-xs leading-none text-gray-400 w-9/12 truncate block\"><span ng-if=item.attributes.brand_name>{{item.attributes.brand_name}}</span> <span ng-if=\"item.attributes.brand_name && item.attributes.trim_name\" class=\"pr2 pl2\">|</span> <span ng-if=item.attributes.trim_name>{{item.attributes.trim_name}}</span> </span><span class=\"text-xs leading-none text-gray-400\">{{item.attributes.year}}</span></div></div></div></md-item-template><md-not-found><span translate=BOUNDARY.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.vehicle}}\' }\"></span></md-not-found></md-autocomplete></div></div><div class=sidenav-main-info ng-if=ctrl.selectedVehicle><!-- device --><div class=m16><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BOUNDARY.TITLE.ASSOCIATIONS></div><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.TITLE.SUB_ASSOCIATIONS></div></div><div class=m16><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"item in ctrl.associationHistory\"><div class=\"st-expansion-header header-sm\"><label layout layout-align=\"space-between center\" flex><span class=w-8><input type=radio name=association ng-model=ctrl.selectedAssociationUuid value={{item.uuid}} ng-change=ctrl.defineLimits(item) required> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{item.relationships.device.attributes.imei}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{item.relationships.device.attributes.name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{item.attributes.created_at | date: \'dd/MM/yyyy\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{item.attributes.deleted_at | date: \'dd/MM/yyyy\'}}</span></span></label></div></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.association.$error\"><div class=\"st-input-validation text-sm text-red-500 mt4\" ng-show=ctrl.form.association.$error.required translate=BOUNDARY.VALIDATION.REQUIRED></div></div></div><br><!-- period --><div class=m16><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BOUNDARY.TITLE.PERIOD></div><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.TITLE.SUB_PERIOD></div></div><div layout layout-align=\"space-between center\" class=m4><div class=st-input-container layout=column flex><label class=st-label translate=BOUNDARY.LABEL.FROM_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=from_date placeholder=DD/MM/AAAA required type=text datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd ng-disabled=!ctrl.selectedAssociation ng-change=ctrl.validationDate() ng-max=ctrl.limits.max ng-min=ctrl.limits.min ng-model=ctrl.report.from_date><div ng-if=\"ctrl.form.$submitted && ctrl.form.from_date.$error\" class=relative><div class=st-input-validation ng-show=ctrl.form.from_date.$error.required translate=BOUNDARY.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.min translate=BOUNDARY.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.max translate=BOUNDARY.VALIDATION.MAX></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=BOUNDARY.LABEL.TO_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=to_date type=text placeholder=DD/MM/AAAA required datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd ng-change=ctrl.validationDate() ng-disabled=!ctrl.selectedAssociation ng-max=ctrl.limits.max ng-min=ctrl.limits.min ng-model=ctrl.report.to_date><div ng-if=\"ctrl.form.$submitted && ctrl.form.to_date.$error\" class=relative><div class=st-input-validation ng-show=ctrl.form.to_date.$error.required translate=BOUNDARY.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.min translate=BOUNDARY.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.max translate=BOUNDARY.VALIDATION.MAX></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.interval translate=BOUNDARY.VALIDATION.INTERVAL></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.finalBiggerInitial translate=BOUNDARY.VALIDATION.FINAL_BIGGER_INITIAL></div></div></div></div><br><!-- place --><div class=m16><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BOUNDARY.TITLE.LOCATION></div><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.TITLE.SUB_LOCATION></div></div><div class=m4><div class=st-input-container layout=column flex><label class=st-label translate=BOUNDARY.LABEL.PLACE></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'BOUNDARY.PLACEHOLDER.TYPE_PLACE\' | translate}}\" md-input-name=autocomplete_vehicle md-selected-item=ctrl.selectedPlace md-search-text=ctrl.place md-items=\"item in ctrl.getPlaces(ctrl.place)\" md-item-text=item.display_name md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-selected-item-change=ctrl.toLocation() md-require-match md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><div class=results-info layout=column layout-align=\"space-between stretch\"><span><span md-highlight-text=ctrl.place class=st-subhead>{{item.display_name}}</span> </span><span><span class=st-caption>{{item.address.state}} {{item.address.country}}</span></span></div></div></md-item-template><md-not-found><span translate=BOUNDARY.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.place}}\' }\"></span></md-not-found></md-autocomplete></div></div><div class=m16 can-access=INTERNALS,MANAGER,READ_ONLY layout layout-align=\"end center\"><div layout><button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=BOUNDARY.ACTION.SEARCH></span></button></div></div></div></form><div class=sidenav-main-info ng-if=ctrl.trajectories><div class=\"absolute h-7 pt16 pb16 top-0 w-full\"><button type=button class=\"no-button ml12\" layout ng-click=ctrl.cleanSearch()><i class=\"material-symbols-outlined text-gray-600 mr12\">arrow_back</i><div class=\"text-xl font-bold leading-tight text-gray-700\">{{ctrl.selectedVehicle.attributes.plate || ctrl.selectedVehicle.attributes.vin}}</div></button></div><div class=m16><div ng-if=\"ctrl.trajectories.length === 0 && !ctrl.loading\"><div class=p4><div class=\"text-base font-bold leading-tight text-gray-700\" translate=BOUNDARY.HINT.NOT_FOUND></div></div><div class=p4><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=BOUNDARY.HINT.CHANGE_PARAMS></div></div></div><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"trajectory in ctrl.trajectories\" ng-class=\"{\'opened\': trajectory.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::trajectory.relationships.device.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.acc | accOn}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" data-metrics=distance no-data-holder>{{::trajectory.attributes.vDis / 1000 | number:1}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.dur | duration}}</span> </span><button class=\"no-button st-expansion-panel-icon\" ng-click=\"trajectory.panelExpanded = !trajectory.panelExpanded\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=\"st-expansion-content content-sm\"><div id=segments-list ng-class=\"{\'slider-opened\': ctrl.openSlider}\"><div class=list-item ng-repeat=\"seg in trajectory.attributes.segs | orderBy: \'sta.act\'\" layout=column layout-align=\"start stretch\"><div layout layout-align=\"space-between center\"><label class=item-pick><input ng-model=seg.checked ng-value=true name=pick-{{$index}} type=checkbox ng-change=ctrl.focusOnPath() ng-disabled=!ctrl.trajectoriesData> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=BOUNDARY.LABEL.ROUTES translate-values=\"{ item: {{$index + 1}}, total: {{trajectory.attributes.sgCnt}} }\"></span></label></div><div class=\"mt12 mb12\"><div layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.TOTAL_DISTANCE></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=distance>{{seg.vDis / 1000 | number:1}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.TOTAL_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.dur | duration}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.TOTAL_STOP_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.stDur | duration}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.SPEED_MAX></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{seg.spMax | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.SPEED_AVG></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{seg.spAvg | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.STOPS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.stCnt}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.ALERTS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.alCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=BOUNDARY.LABEL.MESSAGES></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.gpsCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500 truncate\" translate=BOUNDARY.LABEL.TOTAL_HIST_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{seg.hisDur | duration}}</span></div></div></div><div class=overflow-hidden><span ng-repeat=\"tag in seg.alTags\"><span class=\"st-tags truncate mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div><div class=item-details layout=column layout-align=\"space-between stretch\"><div layout class=\"details-marker starts-at\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.sta.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BOUNDARY.LABEL.START></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.sta.adr}}</div><div layout><span id=\"{{ \'location-departure\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.sta.lat | number:\'6\'}},{{seg.sta.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-departure\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div layout class=\"details-marker ends-at mt8\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.end.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BOUNDARY.LABEL.END></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.end.adr}}</div><div layout><span id=\"{{ \'location-arrival\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.end.lat | number:\'6\'}},{{seg.end.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-arrival\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/internal/reports/diagnosis/diagnosis.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=\"bg-white border border-solid border-gray-200 rounded-md\"><div><div class=m24><div class=\"text-base font-bold text-gray-800\" translate=DIAGNOSIS.TITLE.ANALYSIS></div><div class=\"text-sm font-normal text-gray-400\" translate=DIAGNOSIS.TITLE.ANALYSIS_SUMMARY></div></div><div class=m12 flex=50><!-- vehicle --><vehicles-autocomplete form=ctrl.form on-item-change=\"ctrl.loadAssociationHistory(1, selectedItem)\" required-item=false search-text=ctrl.vehicle selected-item=ctrl.selectedVehicle></vehicles-autocomplete></div><div class=m24><div class=\"text-base font-bold text-gray-800\" translate=DIAGNOSIS.TITLE.RELATION></div><div class=\"text-sm font-normal text-gray-400\" translate=DIAGNOSIS.TITLE.RELATION_SUMMARY></div></div><div class=\"m24 border border-solid border-gray-200 rounded-md\"><md-table-container><table class=st-main-table md-table md-row-select ng-model=ctrl.selectedDevice><thead class=st-table-head md-head md-order=ctrl.order md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=DIAGNOSIS.LABEL.DEVICE></span></th><th md-column><span translate=DIAGNOSIS.LABEL.ENTERPRISE></span></th><th md-column><span translate=DIAGNOSIS.LABEL.ASSOCIATED_AT></span></th><th md-column><span translate=DIAGNOSIS.LABEL.DISASSOCIATED_AT></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row md-select=item ng-repeat=\"item in ctrl.items\" md-on-select=ctrl.defineValidations><td md-cell>{{item.relationships.device.attributes.name}}</td><td md-cell><div>{{item.relationships.enterprise.attributes.name}}</div><div>{{item.relationships.enterprise.attributes.cnpj}}</div></td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.deleted_at | date: \'HH:mm dd/MM/yyyy\'}}</td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=5><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=DIAGNOSIS.HINT.NO_RESULTS></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAssociationHistory md-boundary-links md-label=\"{page: \'{{\'DIAGNOSIS.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DIAGNOSIS.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DIAGNOSIS.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div><form class=m16 layout layout-align=\"space-between end\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.searchAsyncReport()\" novalidate><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=DIAGNOSIS.LABEL.FROM_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=from_date placeholder=\"HH:MM:SS DD/MM/AAAA\" required type=text data-test=diagnosis.from_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-disabled=\"ctrl.selectedDevice.length === 0\" ng-disabled=ctrl.disabledInputs ng-max=ctrl.diagnosis.max_date ng-min=ctrl.diagnosis.min_date ng-model=ctrl.diagnosis.from_date ng-change=ctrl.updatePeriod()><div ng-if=\"ctrl.form.$submitted && ctrl.form.from_date.$error\" data-test=diagnosis.validation.from_date><div class=st-input-validation ng-show=ctrl.form.from_date.$error.required translate=DIAGNOSIS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.min translate=DIAGNOSIS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.from_date.$error.max translate=DIAGNOSIS.VALIDATION.MAX></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=DIAGNOSIS.LABEL.TO_DATE></label><input autocomplete=off class=\"st-input-type input-type\" name=to_date placeholder=\"HH:MM:SS DD/MM/AAAA\" required type=text data-test=diagnosis.to_date datetime=\"HH:mm:ss dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss ng-disabled=\"ctrl.selectedDevice.length === 0\" ng-disabled=ctrl.disabledInputs ng-max=ctrl.diagnosis.max_date ng-min=ctrl.diagnosis.min_date ng-model=ctrl.diagnosis.to_date ng-change=ctrl.updatePeriod()><div ng-if=\"ctrl.form.$submitted && ctrl.form.to_date.$error\" data-test=diagnosis.validation.to_date><div class=st-input-validation ng-show=ctrl.form.to_date.$error.required translate=DIAGNOSIS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.min translate=DIAGNOSIS.VALIDATION.MIN></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.max translate=DIAGNOSIS.VALIDATION.MAX></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.interval translate=DIAGNOSIS.VALIDATION.INTERVAL></div><div class=st-input-validation ng-show=ctrl.form.to_date.$error.finalBiggerInitial translate=DIAGNOSIS.VALIDATION.FINAL_BIGGER_INITIAL></div></div></div></div><div class=\"mr8 mb16\"><button type=submit class=\"altnav-action save\" aria-label=Save data-test=diagnosis.action.search ng-disabled=\"ctrl.selectedDevice.length === 0\"><span translate=DIAGNOSIS.ACTION.SEARCH></span></button></div></form><div class=m24><div class=\"text-base font-bold text-gray-800\" translate=DIAGNOSIS.TITLE.VISUALIZATION></div><div class=\"text-sm font-normal text-gray-400\" translate=DIAGNOSIS.TITLE.VISUALIZATION_SUMMARY></div></div><div><div class=m24 layout layout-align=\"end center\"><div class=\"st-input-container no-padding\" flex=20><label class=\"st-label st-required\" translate=DIAGNOSIS.LABEL.DATA1></label><md-select class=st-input-select name=keys ng-model=ctrl.selected.data1 aria-label=\"Select Data 1\" ng-change=\"ctrl.onSelectDataType(\'data1\', ctrl.selected.data1)\" translate-attr=\"{ placeholder: \'DIAGNOSIS.PLACEHOLDER.SELECT_DATA1\' }\" ng-disabled=\"ctrl.selectedDevice.length === 0\" data-test=diagnosis.select_data_1><md-option ng-repeat=\"(k,v) in ctrl.dataMap\" ng-value=k translate=\"{{\'DIAGNOSIS.ENUM.METRICS.\' + v.name.toUpperCase()}}\"></md-option></md-select></div><div class=\"st-input-container no-padding ml16\" flex=20><label class=\"st-label st-required\" translate=DIAGNOSIS.LABEL.DATA2></label><md-select class=st-input-select name=keys ng-model=ctrl.selected.data2 aria-label=\"Select Data 2\" ng-change=\"ctrl.onSelectDataType(\'data2\', ctrl.selected.data2)\" translate-attr=\"{ placeholder: \'DIAGNOSIS.PLACEHOLDER.SELECT_DATA2\' }\" ng-disabled=\"ctrl.selectedDevice.length === 0\" data-test=\" diagnosis.select_data_2\"><md-option ng-repeat=\"(k,v) in ctrl.dataMap\" ng-value=k translate=\"{{\'DIAGNOSIS.ENUM.METRICS.\' + v.name.toUpperCase()}}\"></md-option></md-select></div></div><div id=diagnosis-report class=\"h-80 m24\"></div></div></div></div></div>");
$templateCache.put("app/components/actions/new-sharing/components/_history.html","");
$templateCache.put("app/components/actions/new-sharing/components/_service-order.html","<!-- device --><div class=st-input-container layout=column flex><label class=st-label translate=FORM_PARTS.LABEL.SERVICE_ORDERS></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'FORM_PARTS.PLACEHOLDER.TYPE_SERVICE_ORDERS\' | translate}}\" md-input-name=autocomplete_serviceOrder md-selected-item=ctrl.selectedServiceOrder md-search-text=ctrl.serviceOrder md-items=\"item in ctrl.getServiceOrders(ctrl.serviceOrder)\" md-item-text=item.attributes.token md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-clear-button=false ng-disabled=ctrl.sharing.uuid md-no-cache><md-item-template><div class=item layout layout-align=\"start center\"><span class=\"image-holder mr8\"><object class=\"image-holder-fallback device-holder\" type=image/gif></object></span><div class=results-info layout=column layout-align=\"space-between stretch\"><span><span md-highlight-text=ctrl.serviceOrder class=st-subhead>{{item.attributes.token}}</span> <span md-highlight-text=ctrl.serviceOrder class=\"st-subhead-lite ml8\">{{item.attributes.type}}</span></span></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{serviceOrder}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_serviceOrder.$invalid\"><div class=st-input-validation ng-message=required translate=FORM_PARTS.VALIDATION.DEVICE></div></div></div>");
$templateCache.put("app/internal/audit/logs/dialog/logs.dialog.html","<md-dialog flex-xs=95 flex-sm=90 flex-md=85 flex-gt-md=80 class=st-dialog aria-label=\"Logs History\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><p class=\"text-lg font-bold leading-tight text-gray-700\" translate=LOGS.TITLE.HISTORY></p></div></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body layout=column layout-align=\"space-between stretch\"><div layout=column flex=100><div ng-hide=ctrl.loading ng-include src=\"\'app/internal/audit/logs/list/_list-view.html\'\"></div><div ng-if=ctrl.loading class=\"m24 p24\" layout layout-align=\"center center\" flex><progress></progress></div><div ng-if=\"ctrl.count > ctrl.pagination.limit\" class=pb-4><pagination count=ctrl.count current=ctrl.pagination.current limit=ctrl.pagination.limit paginate=ctrl.loadData(page)></pagination></div></div></div></div><div class=\"st-form-actions m12 pt8\" layout layout-align=\"end center\"><button type=button class=\"altnav-action save\" aria-label=Close ng-click=ctrl.close()><span>Fechar</span></button></div></md-dialog>");
$templateCache.put("app/internal/audit/logs/list/_list-view.html","<div class=card-content><logs-accordion items=ctrl.items template={{ctrl.template}}></logs-accordion><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"text-sm text-gray-500 leading-tight font-bold mt24\" translate=LOGS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading class=\"m24 p24\" layout layout-align=\"center center\" flex><progress></progress></div></div>");
$templateCache.put("app/internal/audit/logs/list/logs.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><search-bar model=operation-logs filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/audit/logs/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/fleet/fuels/create/fuels.create.html","<div class=navigator-wrapper><navigator contract=ctrl.options version=v1 model=fuels></navigator></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.VEHICLE></label><md-autocomplete class=st-input-autocomplete md-input-name=autocomplete_user md-selected-item=ctrl.fuel.vehicle md-search-text=ctrl.vehicle md-items=\"item in ctrl.getVehicle(ctrl.vehicle)\" md-item-text=item.plate md-require-match md-min-length=2 md-delay=1200 placeholder=\"{{\'FUELS.PLACEHOLDER.TYPE_PLATE\' | translate}}\" md-no-cache required><span md-highlight-text=ctrl.vehicle>{{item.plate}}</span><md-not-found><span translate=FUELS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.vehicle}}\' }\"></span></md-not-found></md-autocomplete></div><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.ENTERPRISE></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.enterprise.name type=text disabled></div><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.CODE></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.code type=text disabled></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.FUELED_AT></label><input class=\"st-input-type input-type\" name=fueled_at ng-model=ctrl.fuel.fueled_at type=text datetime=\"HH:mm dd/MM/yyyy\" placeholder=\"HH:mm DD/MM/AAAA\" ng-change=ctrl.getLastRegister() ng-model-options=\"{ debounce: 1200 }\" autocomplete=off required></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.ODOMETER></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.fueled_odometer type=text min=0 ui-number-mask=0 required></div><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.LAST_FUELED_AT></label><input class=\"st-input-type input-type\" name=last_fueled_at ng-model=ctrl.fuel.last_fueled_at type=text datetime=dd/MM/yyyy placeholder=DD/MM/AAAA autocomplete=off readonly disabled></div><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.LAST_ODOMETER></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.last_odometer type=text max={{ctrl.fuel.odometer}} ui-number-mask=0 readonly disabled></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.INVOICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.invoice_no type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.TYPE></label><md-select class=st-input-select name=fuel_type ng-model=ctrl.fuel.fuel_type aria-label=\"Fuel type\" md-no-asterisk required flex><md-option ng-repeat=\"type in [\'Gasoline\', \'Alcohol\', \'Diesel\', \'LNG\']\" ng-value=type translate=\"{{\'FUELS.TYPE.\' + type.toUpperCase()}}\"></md-option></md-select></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.TOTAL_AMOUNT></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.total_amount type=text ng-change=ctrl.updateTotalPrice() autocomplete=off ui-number-mask=2 required></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.UNITY_PRICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.fuel.unity_price type=text ng-change=ctrl.updateTotalPrice() autocomplete=off ui-number-mask=3 required></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=FUELS.LABEL.TOTAL_PRICE></label><input class=\"st-input-type input-type\" ng-model=\"ctrl.fuel.total_price \" type=text autocomplete=off ui-number-mask=2 required></div></div><div class=st-input-container layout=column flex><label class=st-label translate=FUELS.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" ng-model=ctrl.fuel.comments rows=4></textarea></div><div can-access=INTERNALS,MANAGER class=st-form-actions layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=fuels-list><span translate=FUELS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=FUELS.ACTION.SAVE></span></button></div></form></div></div>");
$templateCache.put("app/internal/fleet/fuels/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"fuel in ctrl.items\" ng-class=\"{\'opened\': fuel.panelExpanded}\"><div class=st-expansion-header ng-click=\"fuel.panelExpanded = !fuel.panelExpanded\"><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::fuel.vehicle.plate}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.code}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" data-metrics=distance no-data-holder>{{::fuel.fueled_odometer | number:\'1\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.fueled_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::fuel.total_amount}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'FUELS.TYPE.\' + fuel.fuel_type.toUpperCase()}}\"></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::fuel.total_price | currency}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.unity_price | currency}}</span> </span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=50><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.CONSUMPTION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=efficiency no-data-holder>{{::fuel.fuel_consumption | number:\'1\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.DATE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.fueled_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.enterprise.name}}</span></div></div><div flex><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.ODOMETER></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder data-metrics=distance>{{::fuel.fueled_odometer | number:\'1\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.ODOMETER></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder data-metrics=distance>{{::fuel.odometer_diff | number:\'1\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.TOTAL_PRICE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.total_price | currency}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=FUELS.LABEL.UNITY_PRICE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::fuel.unity_price | currency}}</span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=FUELS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::fuel.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=FUELS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::fuel.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"fuels-edit({id: fuel.id})\"><span translate=FUELS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=FUELS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/fleet/fuels/list/fuels.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-bar contract=ctrl.options filters=ctrl.filters export-list=ctrl.exportList></export-bar><search-bar model=fuels filter=false typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4></div><panel-header data=ctrl.headers></panel-header></div><div layout=column flex=100><div ng-include src=\"\'app/internal/fleet/fuels/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/fleet/identifications/create/identifications.create.html","<div class=navigator-wrapper><navigator contract=ctrl.options version=v1 model=identifications></navigator></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><div flex><enterprises-autocomplete clear-button=!ctrl.selectedUser.id disabled-item=ctrl.selectedUser.id form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=IDENTIFICATIONS.LABEL.CODE></label><input class=\"st-input-type input-type\" name=code ng-model=ctrl.identification.code type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.code.$invalid\"><div class=st-input-validation ng-message=required translate=IDENTIFICATIONS.VALIDATION.CODE></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=IDENTIFICATIONS.LABEL.TYPE></label><md-select class=st-input-select name=type ng-model=ctrl.identification.type aria-label=\"Select type\" md-no-asterisk required flex style=margin-bottom:0><md-option ng-repeat=\"t in ctrl.types\" value={{t}} translate=\"{{\'IDENTIFICATIONS.TYPE.\' + t.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.type.$invalid\"><div class=st-input-validation ng-message=required translate=IDENTIFICATIONS.VALIDATION.TYPE></div></div></div></div><div layout=column layout-align=\"space-between stretch\"><h4 class=st-label-title translate=IDENTIFICATIONS.LABEL.ASSOCIATE></h4><div layout layout-align=\"space-between center\"><div flex><users-autocomplete clear-button=true filters=ctrl.usersOptions.filters form=ctrl.form required-item=false search-text=ctrl.user selected-item=ctrl.selectedUser></users-autocomplete></div></div><br></div><div can-access=INTERNALS,MANAGER class=st-form-actions layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ui-sref=identifications-list><span translate=IDENTIFICATIONS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=IDENTIFICATIONS.ACTION.SAVE></span></button></div></div></form></div></div>");
$templateCache.put("app/internal/fleet/identifications/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"identification in ctrl.items\" ng-class=\"{\'opened\': identification.panelExpanded}\"><div class=st-expansion-header ng-click=\"identification.panelExpanded = !identification.panelExpanded\"><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\">{{::identification.code}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{ \'IDENTIFICATIONS.TYPE.\' + identification.type.toUpperCase()}}\"></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::identification.user.name || \'Sem associação\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::identification.enterprise.name}}</span> </span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=40><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=IDENTIFICATIONS.LABEL.ASSOCIATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::identification.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=IDENTIFICATIONS.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::identification.enterprise.name}}</span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=IDENTIFICATIONS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::identification.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=IDENTIFICATIONS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::identification.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"identifications-edit({id: identification.id})\"><span translate=IDENTIFICATIONS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=IDENTIFICATIONS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/fleet/identifications/list/identifications.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-bar contract=ctrl.options filters=ctrl.filters export-list=ctrl.exportList></export-bar><search-bar model=identifications filter=false typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/fleet/identifications/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/fleet/trips/create/trips.create.html","<div class=navigator-wrapper><navigator></navigator></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form layout=column layout-align=\"space-between stretch\" novalidate flex><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.VEHICLE></label><md-autocomplete class=st-input-autocomplete md-input-name=autocomplete_vehicle md-selected-item=ctrl.trip.vehicle md-search-text=ctrl.vehicle md-items=\"item in ctrl.getVehicle(ctrl.vehicle)\" md-item-text=item.plate md-min-length=2 md-delay=1200 placeholder=\"{{\'TRIPS.PLACEHOLDER.TYPE_PLATE\' | translate}}\" md-no-cache md-require-match required><md-item-template><span md-highlight-text=ctrl.vehicle>{{item.plate}}</span></md-item-template><md-not-found><span translate=TRIPS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.vehicle}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_vehicle.$error\"><div class=st-input-validation ng-show=ctrl.form.autocomplete_vehicle.$error.required translate=TRIPS.VALIDATION.PLATE></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.OS></label><input class=\"st-input-type input-type\" ng-model=ctrl.trip.service_order type=text></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.CODE></label><input class=\"st-input-type input-type\" ng-model=ctrl.trip.code type=text disabled></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.START_AT></label><input class=\"st-input-type input-type\" name=start_at ng-model=ctrl.trip.start_at type=text datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" ng-change=ctrl._updatePeriod() autocomplete=off max={{ctrl.maxValidDate}} required><div ng-if=\"ctrl.form.$submitted && ctrl.form.start_at.$error\"><div class=st-input-validation ng-show=ctrl.form.start_at.$error.required translate=TRIPS.VALIDATION.DATE_REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.start_at.$error.max translate=TRIPS.VALIDATION.DATE_ABOVE_MAX></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.END_AT></label><input class=\"st-input-type input-type\" name=end_at ng-model=ctrl.trip.end_at type=text datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" ng-change=ctrl._updatePeriod() autocomplete=off min={{ctrl.minValidDate}} required><div ng-if=\"ctrl.form.$submitted && ctrl.form.end_at.$error\"><div class=st-input-validation ng-show=ctrl.form.end_at.$error.required translate=TRIPS.VALIDATION.DATE_REQUIRED></div></div></div></div></form><br><h3 translate=TRIPS.TITLE.LOCATIONS></h3><form class=st-form-inputs name=ctrl.formLocations ng-submit=\"ctrl.formLocations.$valid && ctrl.addLocationToTrip(ctrl.selectedLocation)\" novalidate><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=TRIPS.LABEL.LOCATION></label><md-autocomplete class=st-input-autocomplete md-input-name=autocomplete_user md-selected-item=ctrl.selectedLocation.address md-search-text=ctrl.address md-items=\"item in ctrl.getAddress(ctrl.address)\" md-item-text=item.formatted_address md-min-length=2 md-delay=1200 placeholder=\"{{\'TRIPS.PLACEHOLDER.TYPE_ADDRESS\' | translate}}\" md-require-match md-no-cache required><span md-highlight-text=ctrl.address>{{item.formatted_address}}</span><md-not-found><span translate=TRIPS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.address}}\' }\"></span></md-not-found></md-autocomplete></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.ACTION></label><md-select class=st-input-select name=action ng-model=ctrl.selectedLocation.action aria-label=\"Select Action\" md-no-asterisk required flex><md-option ng-repeat=\"action in [\'load\', \'unload\', \'stop\', \'holding\']\" value={{action}} translate=\"{{\'TRIPS.CHECKPOINTS.\' + action.toUpperCase()}}\"></md-option></md-select></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.DURATION></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedLocation.duration ui-time-mask=short required></div><button type=submit class=inline-form-add-button><i class=material-symbols-outlined>add</i></button></div></form><ul sv-root sv-part=ctrl.trip.locations class=st-reorder-list sv-on-sort=\"ctrl._move($item, $partFrom, $partTo, $indexFrom, $indexTo)\"><li class=st-reorder-head><div class=\"md-caption secondary-info\" layout layout-align=\"space-between center\"><span flex=60 translate=TRIPS.LABEL.LOCATION></span> <span flex=20 translate=TRIPS.LABEL.ACTION></span> <span flex=20 translate=TRIPS.LABEL.DURATION></span></div></li><li class=st-reorder-item ng-repeat=\"location in ctrl.trip.locations | orderBy: \'location.order\'\" sv-element><div class=md-caption layout layout-align=\"space-between center\"><div class=st-no-wrap flex=60><span class=secondary-info title={{location.address}}>{{location.address}}</span></div><div class=st-no-wrap flex=20><span translate=\"{{\'TRIPS.CHECKPOINTS.\' + location.action.toUpperCase()}}\"></span></div><div class=st-no-wrap flex=20><span>{{location.duration | duration:\'short\'}}</span></div></div><md-button aria-label=\"Remove locations\" class=\"md-icon-button st-reorder-action\" ng-click=ctrl.removeLocationsFromTrip(location) md-no-ink><i class=material-symbols-outlined>close</i></md-button></li><li ng-if=\"!ctrl.trip.locations || ctrl.trip.locations.length == 0\"><div class=alt-info layout layout-align=\"center center\" layout-margin layout-padding translate=TRIPS.HINT.INSERT></div></li></ul><br><div ng-if=\"ctrl.trip.locations.length > 1\" layout layout-align=\"end center\"><div layout=column layout-align=\"center end\" class=mr8><label class=st-label translate=TRIPS.LABEL.ESTIMATED_DISTANCE></label><span data-metrics=distance>{{ctrl.trip.estimated_distance / 1000 | number:1}}</span></div><div layout=column layout-align=\"center end\" class=\"mr8 ml8\"><label class=st-label translate=TRIPS.LABEL.ESTIMATED_DRIVING_TIME></label><span>{{ctrl.trip.estimated_driving_time | duration}}</span></div><div layout=column layout-align=\"center end\"><label class=st-label translate=TRIPS.LABEL.ESTIMATED_TIME></label><span>{{ctrl.trip.estimated_trip_time | duration}}</span></div></div><br><md-card><div id=map class=trip></div></md-card><div class=trips-legends layout layout-align=\"space-between center\" flex><div><span class=\"circle load\"></span> <span translate=TRIPS.CHECKPOINTS.LOAD></span></div><div><span class=\"circle unload\"></span> <span translate=TRIPS.CHECKPOINTS.UNLOAD></span></div><div><span class=\"circle stop\"></span> <span translate=TRIPS.CHECKPOINTS.STOP></span></div><div><span class=\"circle holding\"></span> <span translate=TRIPS.CHECKPOINTS.HOLDING></span></div></div><br><h3 translate=TRIPS.TITLE.USERS></h3><form class=st-form-inputs name=ctrl.formUsers ng-submit=\"ctrl.formUsers.$valid && ctrl.addUserToTrip(ctrl.selectedUser)\" novalidate><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.USER></label><md-autocomplete class=st-input-autocomplete md-input-name=autocomplete_user md-selected-item=ctrl.selectedUser.user md-search-text=ctrl.user md-items=\"item in ctrl.getUser(ctrl.user)\" md-item-text=item.name md-min-length=2 md-delay=1200 placeholder=\"{{\'TRIPS.PLACEHOLDER.TYPE_NAME\' | translate}}\" md-require-match md-no-cache ng-disabled=!ctrl.trip.vehicle required><span md-highlight-text=ctrl.user>{{item.name}}</span><md-not-found><span translate=TRIPS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.vehicle}}\' }\"></span></md-not-found></md-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.ROLE></label><md-select class=st-input-select name=roles ng-model=ctrl.selectedUser.role aria-label=\"Select Role\" md-no-asterisk required flex><md-option ng-repeat=\"role in [\'conductor\', \'helper\']\" value={{role}} translate=\"{{\'TRIPS.ROLES.\' + role.toUpperCase()}}\"></md-option></md-select></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.COMMON_HOURS></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedUser.common_hours type=text ui-time-mask=short></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.EXTRA_HOURS></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedUser.extra_hours type=text ui-time-mask=short></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.NIGHT_HOURS></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedUser.night_hours type=text ui-time-mask=short></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.EXTRA_NIGHT_HOURS></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedUser.extra_night_hours type=text ui-time-mask=short></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.HOLDING_HOURS></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedUser.holding_hours type=text ui-time-mask=short></div><button type=submit class=inline-form-add-button><i class=material-symbols-outlined>add</i></button></div></form><br><ul class=st-reorder-list><li class=st-reorder-head><div class=\"md-caption secondary-info\" layout layout-align=\"space-between center\"><span flex=50 translate=TRIPS.LABEL.USER></span> <span flex=20 translate=TRIPS.LABEL.COMMON_HOURS></span> <span flex=30 translate=TRIPS.LABEL.EXTRA_HOURS></span> <span flex=30 translate=TRIPS.LABEL.NIGHT_HOURS></span> <span flex=30 translate=TRIPS.LABEL.EXTRA_NIGHT_HOURS></span> <span flex=30 translate=TRIPS.LABEL.HOLDING_HOURS></span></div></li><li class=st-reorder-item ng-repeat=\"listedUsers in ctrl.trip.users\"><div class=md-caption layout layout-align=\"space-between center\"><div class=st-no-wrap flex=20><span>{{listedUsers.user.name}}</span></div><div class=st-no-wrap flex=20><span>{{listedUsers.common_hours | duration:\'short\'}}</span></div><div class=st-no-wrap flex=20><span>{{listedUsers.extra_hours | duration:\'short\'}}</span></div><div class=st-no-wrap flex=20><span>{{listedUsers.night_hours | duration:\'short\'}}</span></div><div class=st-no-wrap flex=20><span>{{listedUsers.extra_night_hours | duration:\'short\'}}</span></div><div class=st-no-wrap flex=20><span>{{listedUsers.holding_hours | duration:\'short\'}}</span></div></div><md-button aria-label=\"Remove users\" class=\"md-icon-button st-reorder-action\" ng-click=ctrl.removeUsersFromTrip(listedUsers) md-no-ink><i class=material-symbols-outlined>close</i></md-button></li><li ng-if=\"!ctrl.trip.users || ctrl.trip.users.length == 0\"><div class=alt-info layout layout-align=\"center center\" layout-margin layout-padding translate=TRIPS.HINT.INSERT></div></li></ul><br><h3 translate=TRIPS.TITLE.EXPENSES></h3><form class=st-form-inputs name=ctrl.formExpenses ng-submit=\"ctrl.formExpenses.$valid && ctrl.addExpensesToTrip(ctrl.selectedExpense)\" novalidate><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex=25><label class=\"st-label st-required\" translate=TRIPS.LABEL.CATEGORIES></label><md-select class=st-input-select name=category ng-model=ctrl.selectedExpense.category aria-label=\"Select Category\" md-no-asterisk required flex><md-option ng-repeat=\"category in [\'toll\', \'bath\', \'meal\', \'accomodation\', \'other\']\" value={{category}} translate=\"{{\'TRIPS.CATEGORY.\' + category.toUpperCase()}}\"></md-option></md-select></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.DESCRIPTION></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedExpense.description type=text></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.AMOUNT></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedExpense.amount type=text ui-number-mask=0 min=0 ng-change=ctrl._updateTotalExpensesPrice() required></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.UNITY_PRICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedExpense.unity_price type=text ui-money-mask=2 ng-change=ctrl._updateTotalExpensesPrice() required></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.TOTAL_PRICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedExpense.total_price type=text ui-money-mask=2 readonly></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.INVOICE_NO></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedExpense.invoice_no type=text></div><button type=submit class=inline-form-add-button><i class=material-symbols-outlined>add</i></button></div></form><br><ul class=st-reorder-list><li class=st-reorder-head><div class=\"md-caption secondary-info\" layout layout-align=\"space-between center\"><span flex=50 translate=TRIPS.LABEL.CATEGORIES></span> <span flex=20 translate=TRIPS.LABEL.DESCRIPTION></span> <span flex=30 translate=TRIPS.LABEL.AMOUNT></span> <span flex=30 translate=TRIPS.LABEL.UNITY_PRICE></span> <span flex=30 translate=TRIPS.LABEL.TOTAL_PRICE></span> <span flex=30 translate=TRIPS.LABEL.INVOICE_NO></span></div></li><li class=st-reorder-item ng-repeat=\"expense in ctrl.trip.expenses\"><div class=md-caption layout layout-align=\"space-between center\"><div class=st-no-wrap flex=20><span translate=\"{{\'TRIPS.CATEGORY.\' + expense.category.toUpperCase()}}\"></span></div><div class=st-no-wrap flex=20><span>{{expense.description}}</span></div><div class=st-no-wrap flex=20><span>{{expense.amount}}</span></div><div class=st-no-wrap flex=20><span>{{expense.unity_price | currency}}</span></div><div class=st-no-wrap flex=20><span>{{expense.total_price | currency}}</span></div><div class=st-no-wrap flex=20><span>{{expense.invoice_no}}</span></div></div><md-button aria-label=\"Remove expenses\" class=\"md-icon-button st-reorder-action\" ng-click=ctrl.removeExpensesFromTrip(expense) md-no-ink><i class=material-symbols-outlined>close</i></md-button></li><li ng-if=\"!ctrl.trip.expenses || ctrl.trip.expenses.length == 0\"><div class=alt-info layout layout-align=\"center center\" layout-margin layout-padding translate=TRIPS.HINT.INSERT></div></li></ul><br><h3 translate=TRIPS.TITLE.REVENUES></h3><form class=st-form-inputs name=ctrl.formRevenues ng-submit=\"ctrl.formRevenues.$valid && ctrl.addRevenuesToTrip(ctrl.selectedRevenue)\" novalidate><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.TYPES></label><md-select class=st-input-select name=roles ng-model=ctrl.selectedRevenue.type aria-label=\"Select Type\" ng-change=ctrl._updateUnityBase() md-no-asterisk required flex><md-option ng-repeat=\"type in [\'distance\', \'time\', \'cubic\', \'weight\', \'fixed\']\" value={{type}} translate=\"{{\'TRIPS.TYPE.\' + type.toUpperCase()}}\"></md-option></md-select></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.UNITY_VALUE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue[ctrl.selectedRevenue.metricUnity] type=text ui-number-mask=1 min=0 ng-change=ctrl._updateTotalPrice() ng-disabled=\"ctrl.selectedRevenue.type == \'fixed\'\" required><div ng-show=ctrl.selectedRevenue.unity_base_price class=st-input-group><span class=st-input-metrics translate=\"{{\'TRIPS.BASE_UNITY.\' + ctrl.selectedRevenue.unity_base_price.toUpperCase()}}\"></span></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=TRIPS.LABEL.BASE_PRICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue.base_price type=text ui-money-mask=2 min=0 ng-change=ctrl._updateTotalPrice() required></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.TOTAL_PRICE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue.total_price type=text ui-number-mask=2 min=0 readonly></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.GROSS_WEIGHT></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue.gross_weight type=text ui-number-mask=1 min=0 ng-change=ctrl._updateTare()></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.NET_WEIGHT></label><input class=\"st-input-type input-type\" name=net_weight ng-model=ctrl.selectedRevenue.net_weight type=text ui-number-mask=1 min=0 max=ctrl.selectedRevenue.gross_weight ng-change=ctrl._updateTare();ctrl._updateBilling()><div ng-if=\"ctrl.formRevenues.$submitted && ctrl.formRevenues.net_weight.$error\"><div class=st-input-validation ng-show=ctrl.formRevenues.net_weight.$error.max translate=TRIPS.VALIDATION.GREATER_THAN></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.TARE></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue.tare type=text ui-number-mask=1 readonly></div><div class=st-input-container layout=column flex><label class=st-label translate=TRIPS.LABEL.BILLED_AMOUNT></label><input class=\"st-input-type input-type\" ng-model=ctrl.selectedRevenue.billed_amount type=text ui-money-mask=2></div><button type=submit class=inline-form-add-button><i class=material-symbols-outlined>add</i></button></div></form><br><ul class=st-reorder-list><li class=st-reorder-head><div class=\"md-caption secondary-info\" layout layout-align=\"space-between center\"><span flex translate=TRIPS.LABEL.UNITY_VALUE></span> <span flex translate=TRIPS.LABEL.BASE_PRICE></span> <span flex translate=TRIPS.LABEL.TOTAL_PRICE></span> <span flex translate=TRIPS.LABEL.GROSS_WEIGHT></span> <span flex translate=TRIPS.LABEL.NET_WEIGHT></span> <span flex translate=TRIPS.LABEL.TARE></span> <span flex translate=TRIPS.LABEL.BILLED_AMOUNT></span></div></li><li class=st-reorder-item ng-repeat=\"revenue in ctrl.trip.revenues\"><div class=md-caption layout layout-align=\"space-between center\"><div class=st-no-wrap flex><span ng-show=\"revenue.unity_base_price === \'km\'\">{{revenue.distance_value}}<span class=secondary-info translate=\"{{\'TRIPS.BASE_UNITY.\' + revenue.unity_base_price.toUpperCase()}}\"></span></span> <span ng-show=\"revenue.unity_base_price === \'m3\'\">{{revenue.cubic_value}}<span class=secondary-info translate=\"{{\'TRIPS.BASE_UNITY.\' + revenue.unity_base_price.toUpperCase()}}\"></span></span> <span ng-show=\"revenue.unity_base_price === \'kg\'\">{{revenue.weight_value}}<span class=secondary-info translate=\"{{\'TRIPS.BASE_UNITY.\' + revenue.unity_base_price.toUpperCase()}}\"></span></span> <span ng-show=\"revenue.unity_base_price === \'hour\'\">{{revenue.time_value}}<span class=secondary-info translate=\"{{\'TRIPS.BASE_UNITY.\' + revenue.unity_base_price.toUpperCase()}}\"></span></span> <span ng-show=\"revenue.unity_base_price === \'unit\'\">{{revenue.fixed_value}}<span class=secondary-info translate=\"{{\'TRIPS.BASE_UNITY.\' + revenue.unity_base_price.toUpperCase()}}\"></span></span></div><div class=st-no-wrap flex><span>{{revenue.base_price | currency}}</span></div><div class=st-no-wrap flex><span>{{revenue.total_price | currency}}</span></div><div class=st-no-wrap flex><span data-metrics=weight>{{revenue.gross_weight}}</span></div><div class=st-no-wrap flex><span data-metrics=weight>{{revenue.net_weight}}</span></div><div class=st-no-wrap flex><span data-metrics=weight>{{revenue.tare}}</span></div><div class=st-no-wrap flex><span>{{revenue.billed_amount | currency}}</span></div></div><md-button aria-label=\"Remove revenue\" class=\"md-icon-button st-reorder-action\" ng-click=ctrl.removeRevenuesFromTrip(revenue) md-no-ink><i class=material-symbols-outlined>close</i></md-button></li><li ng-if=\"!ctrl.trip.revenues || ctrl.trip.revenues.length == 0\"><div class=alt-info layout layout-align=\"center center\" layout-margin layout-padding translate=TRIPS.HINT.INSERT></div></li></ul><form class=st-form-inputs name=ctrl.formbtn ng-submit=\"ctrl.form.$setSubmitted(); ctrl.form.$valid && ctrl.save()\" novalidate><div can-access=INTERNALS,MANAGER class=st-form-actions layout layout-align=\"space-between center\"><div><button type=button ng-click=ctrl.delete() class=\"altnav-action cancel\" aria-label=Delete><span translate=TRIPS.ACTION.DELETE></span></button></div><div layout><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ui-sref=trips-list><span translate=TRIPS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=TRIPS.ACTION.SAVE></span></button></div></div></form></div></div>");
$templateCache.put("app/internal/fleet/trips/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"trip in ctrl.items\" ng-class=\"{\'opened\': trip.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::trip.code}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.vehicle.plate}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::trip.enterprise.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.service_order}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" data-metrics=distance no-data-holder>{{::trip.estimated_distance / 1000 | number:\'1\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.estimated_trip_time | duration}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" no-data-holder>{{::trip.start_at | date: \'HH:mm dd/MM/yyyy\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.end_at | date: \'HH:mm dd/MM/yyyy\'}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"trip.panelExpanded = !trip.panelExpanded\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=50><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.START_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.start_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.END_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.end_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.enterprise.name}}</span></div></div><div flex><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.ESTIMATED_DISTANCE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=distance>{{::trip.estimated_distance / 1000 | number:\'1\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.ESTIMATED_DRIVING_TIME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.estimated_driving_time | duration}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRIPS.LABEL.ESTIMATED_TIME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trip.estimated_trip_time | duration}}</span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=TRIPS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::trip.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=TRIPS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::trip.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"trips-edit({id: trip.id})\"><span translate=TRIPS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=TRIPS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/fleet/trips/list/trips.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-bar contract=ctrl.options filters=ctrl.filters export-list=ctrl.exportList></export-bar><search-bar model=trips filter=false typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/fleet/trips/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/fleet/trips/panel/trips.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=\"st-form-section st-card\"><form class=m12 layout layout-align=\"start end\" name=ctrl.params novalidate><div class=\"st-input-container no-padding\" layout=column flex=30><label class=\"st-label st-required\" translate=TRIPS.LABEL.START_AT></label><input class=\"st-input-type input-type\" name=range ng-model=ctrl.trips.range type=text date-range-picker options=ctrl.dateRangeConfig placeholder=\"{{\'TRIPS.PLACEHOLDER.PICK_DATE\'}}\" autocomplete=off></div><button type=button class=report-add-new-btn ng-click=\"ctrl.addNew(\'vehicle\')\"><span translate=TRIPS.ACTION.ADD_VEHICLES></span></button> <button type=button class=report-add-new-btn ng-click=\"ctrl.addNew(\'user\')\"><span translate=TRIPS.ACTION.ADD_USER></span></button> <button type=submit class=\"altnav-action save mb4 ml12 h-9\" ng-click=ctrl.loadData()><i class=material-symbols-outlined>search</i></button></form><br><div layout layout-align=\"space-between center\"><div class=m12 flex=50><div class=secondary-info translate=TRIPS.LABEL.SELECTED_VEHICLES></div><div class=st-caption ng-if=\"ctrl.selectedVehicles.length == 0\"><br><span translate=TRIPS.HINT.NO_VEHICLES></span></div><div><md-chips class=report-chips ng-change=ctrl.loadData() ng-model=ctrl.selectedVehicles readonly md-removable=true input-aria-label=\"Selected Vehicles\"><md-chip-template><span>{{$chip.attributes.plate}}</span></md-chip-template><span class=remover-chips md-chip-remove aria-label=Remove><i class=material-symbols-outlined>close</i></span></md-chips></div></div><div class=m12 flex=50><div class=secondary-info translate=TRIPS.LABEL.SELECTED_USERS></div><div class=st-caption ng-if=\"ctrl.selectedUsers.length == 0\"><br><span translate=TRIPS.HINT.NO_USERS></span></div><div><md-chips class=report-chips ng-change=ctrl.loadData() ng-model=ctrl.selectedUsers readonly md-removable=true input-aria-label=\"Selected Users\"><md-chip-template><span>{{$chip.attributes.name}}</span></md-chip-template><span class=remover-chips md-chip-remove aria-label=Remove><i class=material-symbols-outlined>close</i></span></md-chips></div></div></div><div class=m12 ng-if=!ctrl.reported layout layout-align=\"center center\" layout-margin layout-padding><div layout=column layout-align=\"center center\" layout-margin><i class=material-symbols-outlined>search</i><div class=secondary-info translate=TRIPS.HINT.NOT_FOUND></div></div></div><div class=m12 ng-if=ctrl.reported><div layout layout-align=\"start center\"><div><span class=st-title-lite translate=TRIPS.TITLE.TOTAL_TRIPS></span> <span>{{ctrl.reported.quantity}}</span></div></div><br><div layout layout-align=\"space-between center\"><div flex class=mr8><div layout layout-align=\"start center\" class=mb8><span class=st-subhead translate=TRIPS.TITLE.DISTANCE></span></div><div layout=column layout-align=\"space-between stretch\" class=st-card><span layout=column><span class=st-caption translate=TRIPS.LABEL.TRAVELED></span> <span class=st-subhead-lite data-metrics=distance>{{ctrl.reported.estDist_sum/1000 | number: 1}}</span></span><div layout layout-align=\"space-between center\"><span><span class=st-caption translate=TRIPS.LABEL.BIGGEST_TRIP></span> <span class=st-subhead-lite data-metrics=distance>{{ctrl.reported.maxEstDist/1000| number: 1}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.SMALLEST_TRIP></span> <span class=st-subhead-lite data-metrics=distance>{{ctrl.reported.minEstDist/1000 | number: 1}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.AVG_TRIP></span> <span class=st-subhead-lite data-metrics=distance>{{ctrl.reported.estDist_avg/1000 | number: 1}}</span></span></div></div></div><div flex class=\"ml8 mr8\"><div layout layout-align=\"start center\" class=mb8><span class=st-subhead translate=TRIPS.TITLE.TRIP_TIME></span></div><div layout=column layout-align=\"space-between stretch\" class=st-card><span layout=column><span class=st-caption translate=TRIPS.LABEL.TOTAL_TIME></span> <span class=st-subhead-lite>{{ctrl.reported.estTripTime_sum | duration}}</span></span><div layout layout-align=\"space-between center\"><span><span class=st-caption translate=TRIPS.LABEL.BIGGEST_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.maxEstTripTime | duration}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.SMALLEST_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.minEstTripTime | duration}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.AVG_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.estTripTime_avg | duration}}</span></span></div></div></div><div flex class=ml8><div layout layout-align=\"start center\" class=mb8><span class=st-subhead translate=TRIPS.TITLE.DRIVING_TIME></span></div><div layout=column layout-align=\"space-between stretch\" class=st-card><span layout=column><span class=st-caption translate=TRIPS.LABEL.TOTAL_TIME></span> <span class=st-subhead-lite>{{ctrl.reported.estDriv_sum | duration}}</span></span><div layout layout-align=\"space-between center\"><span><span class=st-caption translate=TRIPS.LABEL.BIGGEST_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.maxEstDriv | duration}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.SMALLEST_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.minEstDriv | duration}}</span> </span><span><span class=st-caption translate=TRIPS.LABEL.AVG_TRIP></span> <span class=st-subhead-lite>{{ctrl.reported.estDriv_avg | duration}}</span></span></div></div></div></div></div><br><div ng-if=ctrl.reported><div class=section-content><!-- estDist_values --><div class=title-holder><h4 class=m12 translate=TRIPS.TITLE.EST_DISTANCE></h4></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=distance class=\"graph-content bar-chart\"></div></div></div><div class=section-content><!-- estTripTime_values, estDriv_values --><div class=title-holder><h4 class=m12 translate=TRIPS.TITLE.TRIP_TIME></h4></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=time class=\"graph-content bar-chart\"></div></div></div></div></div></div>");
$templateCache.put("app/internal/management/files/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"file in ctrl.items\" ng-class=\"{\'opened\': file.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span copy-paste value={{file.relationships.vehicle.attributes.plate}}>{{::file.relationships.vehicle.attributes.plate}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'FILES.ENUM.VEHICLE_TYPE.\' + (file.relationships.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::file.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::file.relationships.enterprise.attributes.cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span copy-paste value={{file.relationships.device.attributes.name}}>{{::file.relationships.device.attributes.name}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::file.relationships.device.attributes.imei}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::file.attributes.file_format}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'FILES.ENUM.FILE_STATUS.\' + file.attributes.status.toUpperCase()}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::file.relationships.user.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span>{{::file.relationships.user.attributes.email}}</span></span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"file.panelExpanded = !file.panelExpanded;ctrl.checkAvailability(file)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><span layout layout-align=\"space-between center\"><span class=\"mt8 mb8\" flex=70><span class=\"mt8 mb8\" layout=column><span layout=column><span class=st-aux translate=FILES.LABEL.PERIOD></span> <span class=st-subhead no-data-holder><span>{{::file.attributes.from_date | date: \'dd/MM/yyyy\'}}</span> <span translate=FILES.LABEL.UNTIL></span> <span>{{::file.attributes.to_date | date: \'dd/MM/yyyy\'}}</span> </span></span></span><span class=\"mt8 mb8\" layout=column><span class=mt8 layout=column><span class=st-aux translate=FILES.LABEL.TIMEZONE></span> <span class=st-subhead no-data-holder>{{::file.attributes.timezone}}</span></span></span></span></span></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=st-thin translate=FILES.LABEL.CREATED_AT></span> <span class=st-aux>{{::file.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=st-thin translate=FILES.LABEL.UPDATED_AT></span> <span class=st-aux>{{::file.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><a ng-if=\"file.attributes.file_address && !file.attributes.expired\" can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action cancel\" href={{file.attributes.file_address}} target=_blank><i class=material-symbols-outlined>download</i> <span translate=FILES.ACTION.DOWNLOAD></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=FILES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/management/files/list/files.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><search-bar model=files filter=false typeable=true></search-bar><actions-bar can-access=INTERNALS,MANAGER contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/management/files/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/management/geofences/create/geofences.create.html","<div class=\"st-card mr16\" style=\"height: calc(100vh - 168px); overflow: auto\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout=column layout-align=\"space-between stretch\"><div class=\"st-title-small ml12\" translate=GEOFENCES.LABEL.CREATE_GEOFENCE></div><div><enterprises-autocomplete clear-button=true form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=GEOFENCES.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.geofence.name type=text autocomplete=off placeholder=\"{{\'GEOFENCES.PLACEHOLDER.NAME\' | translate}}\" required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=GEOFENCES.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=GEOFENCES.LABEL.ALERT></label><span><span class=st-caption translate=GEOFENCES.LABEL.ALERT_DESCRIPTION></span></span><div ng-if=\"ctrl.form.$submitted && ctrl.form.code.$invalid\"><div class=st-input-validation ng-message=required translate=GEOFENCES.VALIDATION.CODE></div></div><div class=mt8 layout=row flex><label class=st-label flex><input type=checkbox ng-model=ctrl.geofence.triggers.in> <span translate=GEOFENCES.ALERT_TRIGGERS.IN></span></label><label class=st-label flex><input type=checkbox ng-model=ctrl.geofence.triggers.out> <span translate=GEOFENCES.ALERT_TRIGGERS.OUT></span></label></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=GEOFENCES.LABEL.GEOFENCE_TYPE></label><span><span class=st-caption translate=GEOFENCES.LABEL.GEOFENCE_TYPE_DESCRIPTION></span></span><div ng-if=\"ctrl.form.$submitted && ctrl.form.code.$invalid\"><div class=st-input-validation ng-message=required translate=GEOFENCES.VALIDATION.COLOR></div></div><div class=mt8 layout=row flex><label class=st-label flex><input type=radio ng-model=ctrl.geofenceType value=circle ng-change=ctrl.updateGeofenceType()> <span translate=GEOFENCES.GEOFENCE_TYPES.CIRCLE></span></label><label class=st-label flex><input type=radio ng-model=ctrl.geofenceType value=polygon ng-change=ctrl.updateGeofenceType()> <span translate=GEOFENCES.GEOFENCE_TYPES.POLYGON></span></label></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=GEOFENCES.LABEL.COLOR></label><span><span class=st-caption translate=GEOFENCES.LABEL.COLOR_DESCRIPTION></span></span><div layout layout-align=\"start center\" layout-wrap flex class=mt8><button type=button class=\"color-picker mr8 mb8\" layout layout-align=\"center center\" ng-repeat=\"color in ctrl.colors\" ng-style=\"{\'background-color\': color}\" ng-click=ctrl.updateColor(color)><i class=\"material-symbols-outlined text-white bold\" ng-if=\"ctrl.geofence.color == color\">done</i></button></div></div><div class=st-input-container layout=column flex><label class=st-label translate=GEOFENCES.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" ng-model=ctrl.geofence.description rows=4></textarea></div><div can-access=INTERNALS,MANAGER class=\"st-form-actions mr12\" layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ui-sref=geofences.list><span translate=GEOFENCES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=\"ctrl.processing || !ctrl.geoFeature\" aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=GEOFENCES.ACTION.SAVE></span></button></div></div></form></div>");
$templateCache.put("app/internal/management/geofences/list/geofences.list.html","<div class=\"pr16 geofences-list\" when-scrolled=checkScroll(key)><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"geofence in ctrl.items\" ng-class=\"{\'opened\': geofence.panelExpanded}\"><div class=st-expansion-header ng-click=\"geofence.panelExpanded = !geofence.panelExpanded; ctrl.checkStatus(geofence)\"><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\"><span>{{::geofence.name}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span translate=\"{{\'GEOFENCES.TYPE.\' + (geofence.radius ? \'CIRCLE\' : \'POLYGON\')}}\"></span> </span></span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=40><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=GEOFENCES.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::geofence.enterprise.name}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=GEOFENCES.LABEL.AREA></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::geofence.area | number:0}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=GEOFENCES.LABEL.DESCRIPTION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::geofence.description}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=GEOFENCES.LABEL.TRIGGER_IN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span translate=\"{{\'GEOFENCES.TRIGGERS.\' + geofence.triggers.in.toString().toUpperCase()}}\"></span></span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=GEOFENCES.LABEL.TRIGGER_OUT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span translate=\"{{\'GEOFENCES.TRIGGERS.\' + geofence.triggers.out.toString().toUpperCase()}}\"></span></span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=GEOFENCES.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::geofence.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><a class=\"altnav-action light\" ui-sref=\"geofences.edit({id: geofence._id})\"><span translate=GEOFENCES.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=GEOFENCES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/management/geofences/map/geofences.html","<div class=navigator-wrapper flex><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><search-bar ng-if=\"ctrl.mode == \'list\'\" model=geofences filter=false typeable=true></search-bar><actions-bar ng-if=\"ctrl.mode == \'list\'\" contract=ctrl.options></actions-bar><button ng-if=\"ctrl.mode == \'create\' && ctrl.$state.params.id\" type=button ng-click=ctrl.delete() class=\"altnav-action delete\" layout layout-align=\"center center\" aria-label=Delete><span translate=NAVIGATOR.ACTION.DELETE></span></button></div></div><div id=geofence-wrapper layout layout-align=\"space-between start\"><div flex=40><div ui-view></div></div><div flex=60 style=\"position: relative\"><div id=map></div></div></div>");
$templateCache.put("app/internal/management/users/edit/users.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div ng-if=ctrl.user.uuid><single-document identifier=ctrl.user.uuid version=v4 file=ctrl.user.relationships.document service=users pattern=\"\'image/*\'\" size=2000></single-document></div><div layout layout-align=\"space-between center\"><div flex=50><enterprises-autocomplete clear-button=true form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.user.relationships.enterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=USERS.LABEL.LANGUAGE></label><md-select class=st-input-select name=lang_type ng-model=ctrl.user.attributes.locale aria-label=\"Select Language\" md-no-asterisk required><md-option ng-repeat=\"l in ctrl.languages\" value={{l}} translate=\"{{\'USERS.ENUM.LANG.\' + l.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.lang_type.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.LANG></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.user.attributes.name type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.USERNAME></label><div class=\"mt4 mb4 relative\" flex><input autocomplete=off class=\"st-input-type input-type no-margin w-full\" name=username ng-change=ctrl.checkUserName() ng-model=ctrl.user.attributes.username ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 700, \'blur\': 0 } }\" required restrict-input=[^.@a-z0-9\\s] type=text><div ng-if=ctrl.checking class=\"absolute bottom-1 right-1 w-6 h-6 bg-white\" layout layout-align=\"center center\"><progress></progress></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.username.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.USERNAME></div></div><div ng-if=\"ctrl.form.username.$invalid && !ctrl.checking\"><div class=st-input-validation ng-show=ctrl.form.username.$error.usernameTaken translate=USERS.VALIDATION.USERNAME_TAKEN></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.EMAIL></label><input class=\"st-input-type input-type\" name=email ng-model=ctrl.user.attributes.email type=email autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.email.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.EMAIL></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.DOC></label><input class=\"st-input-type input-type\" maxlength=20 ng-model=ctrl.user.attributes.document_number type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.SSN></label><input class=\"st-input-type input-type\" name=ssn maxlength=20 ng-model=ctrl.user.attributes.cpf type=text autocomplete=off placeholder=\"E.g. 123.456.789-01\" required></div><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.BIRTH_DATE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.birthdate type=text empty-input placeholder=\"E.g. DD/MM/AAAA\" datetime=dd/MM/yyyy datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" autocomplete=off></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.TYPE></label><input ng-if=ctrl.roleReadOnly type=text class=\"st-input-type input-type\" translate-attr=\"{value: \'USERS.ENUM.ROLE.\' + ctrl.user.relationships.roles[0].attributes.name.toUpperCase() }\" disabled readonly><md-select ng-if=!ctrl.roleReadOnly class=st-input-select name=role_type ng-model=ctrl.user.relationships.roles[0].id aria-label=\"Select Type\" md-no-asterisk required><md-option ng-repeat=\"t in ctrl.roles\" value={{t.id}} translate=\"{{\'USERS.ENUM.ROLE.\' + t.attributes.name.toUpperCase()}}\"></md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.role_type.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.ROLES></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=USERS.LABEL.CELLPHONE></label><input class=\"st-input-type input-type\" name=mobile ng-model=ctrl.user.attributes.phone1 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask required><div ng-if=\"ctrl.form.$submitted && ctrl.form.mobile.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.PHONE></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.phone2 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.EMERGENCY_CONTACT></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.emergency_contact type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.EMERGENCY_PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.user.attributes.emergency_phone type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div></div><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=USERS.ACTION.DELETE></span></button><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=users-list><span translate=USERS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=USERS.ACTION.SAVE></span></button></div></div></form><br><div class=\"details-tab-wrapper ml12 mr12\" flex><div class=details-tabs><button type=button ui-sref-active=active ui-sref=users-edit.addresses class=details-tab-item ng-disabled=!ctrl.user><span translate=USERS.ENUM.TABS.ADDRESSES></span></button> <button type=button ui-sref-active=active ui-sref=users-edit.subscriptions class=details-tab-item ng-disabled=!ctrl.user><span translate=USERS.ENUM.TABS.SUBSCRIPTIONS></span></button> <button type=button ui-sref-active=active ui-sref=users-edit.acknowledgements class=details-tab-item ng-disabled=!ctrl.user><span translate=USERS.ENUM.TABS.ACK></span></button> <button type=button ui-sref-active=active ui-sref=users-edit.sessions class=details-tab-item ng-disabled=!ctrl.user><span translate=USERS.ENUM.TABS.SESSIONS></span></button> <button ng-if=ctrl.showTabSecurity type=button ui-sref-active=active ui-sref=users-edit.security class=details-tab-item><span translate=USERS.ENUM.TABS.SECURITY></span></button><!-- <button ui-sref-active=\"active\" ui-sref=\"users-edit.time-restrictions\" class=\"details-tab-item\" ng-disabled=\"!ctrl.user\">\n          <span translate=\"USERS.ENUM.TABS.TIME_RESTRICTIONS\"></span>\n        </button> --></div></div><br><br><div ui-view></div></div></div>");
$templateCache.put("app/internal/management/users/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"user in ctrl.items\" ng-class=\"{\'opened\': user.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" layout layout-align=\"space-between center\"><span class=\"mr4 truncate\">{{::user.attributes.name}}</span> <span class=\"st-tags tag-important xs\" ng-if=user.attributes.deactivated_at><span translate=USERS.LABEL.DEACTIVATED></span></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.username}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::user.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.relationships.enterprise.attributes.cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::user.attributes.email}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.phone1 | phoneFilter}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::user.attributes.cpf}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.document_number}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::user.attributes.emergency_contact}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.emergency_phone | phoneFilter}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"user.panelExpanded = !user.panelExpanded; ctrl.checkStatus(user)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><!-- <div class=\"st-expansion-content has-selector\"> --><div layout class=\"pt16 pb16\"><div flex=50><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=USERS.LABEL.PERSONAL></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.SSN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.cpf}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.DOC_NUM></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.document_number}}</span></div></div><div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.BIRTHDAY></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.birthdate | date: \'dd/MM/yyyy\':\'Z\'}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=USERS.LABEL.INTEGRATION></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.INTEGRATED></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.last_integration_source}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.INTEGRATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.last_integration_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div><div flex><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=USERS.LABEL.SETTINGS></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.TYPE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'USERS.ENUM.ROLE.\' + user.relationships.roles[0].attributes.name}}\"></span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.LANGUAGE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'USERS.ENUM.LANG.\' + user.attributes.locale.toUpperCase()}}\"></span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=USERS.LABEL.EMERGENCY></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.EMERGENCY_CONTACT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.emergency_contact}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.EMERGENCY_CONTACT_PHONE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.emergency_phone | phoneFilter}}</span></div></div><div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.LAST_ACCESS></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::user.attributes.last_login_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div></div></div><div class=st-expansion-footer><!-- <div class=\"st-expansion-footer has-selector\"> --><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=USERS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::user.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=USERS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::user.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><span layout layout-align=\"space-between center\"><span ng-show=user.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=USERS.LABEL.ACTIVE></span> <span ng-show=!user.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=USERS.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=user.attributes.active ng-change=ctrl.toggleState(user) md-no-ink aria-label=Estado></span><div><a class=\"mr8 ml8\" href=\"\" ng-click=ctrl.changePassword(user) aria-label=\"Change password\"><i class=material-symbols-outlined>vpn_key</i><md-tooltip><span translate=USERS.ACTION.CHANGE_PASSWORD></span></md-tooltip></a></div><div><a class=\"mr8 ml8\" href=\"\" ng-click=ctrl.resendEmail(user) aria-label=\"Resend email\"><i class=material-symbols-outlined>mail_outline</i><md-tooltip><span translate=USERS.ACTION.RESEND_EMAIL></span></md-tooltip></a></div><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"users-edit({id: user.id})\"><span translate=USERS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=USERS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/management/users/list/users.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=users version=v5></export-dialog-bar><search-bar model=users filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/management/users/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/management/vehicles/edit/vehicles.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div ng-if=ctrl.vehicle.uuid><single-document identifier=ctrl.vehicle.uuid version=v4 file=ctrl.vehicle.relationships.document service=assets pattern=\"\'image/*\'\" size=2000></single-document></div><div><enterprises-autocomplete clear-button=true form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label ng-class=\"{\'st-required\': !ctrl.vehicle.attributes.vin}\" translate=VEHICLES.LABEL.PLATE></label><input class=\"st-input-type input-type\" name=plate ng-model=ctrl.vehicle.attributes.plate type=text autocomplete=off ng-required=!ctrl.vehicle.attributes.vin><div ng-if=\"ctrl.form.$submitted && ctrl.form.plate.$invalid\"><div class=st-input-validation ng-message=required translate=VEHICLES.VALIDATION.PLATE></div></div></div><div class=st-input-container layout=column flex><label class=st-label ng-class=\"{\'st-required\': !ctrl.vehicle.attributes.plate}\" translate=VEHICLES.LABEL.VIN></label><input class=\"st-input-type input-type\" name=vin ng-model=ctrl.vehicle.attributes.vin type=text autocomplete=off maxlength=20 ng-required=!ctrl.vehicle.attributes.plate><div ng-if=\"ctrl.form.$submitted && ctrl.form.vin.$invalid\"><div class=st-input-validation ng-message=required translate=VEHICLES.VALIDATION.VIN></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLES.LABEL.CODE></label><input class=\"st-input-type input-type\" name=code ng-model=ctrl.vehicle.attributes.code type=text autocomplete=off maxlength=16></div></div><div class=\"p24 m12 bg-gray-100 rounded-md\" ng-if=!ctrl.forceEdit><div class=\"m12 bg-white rounded-md overflow-hidden border border-solid border-gray-200\"><div layout><div class=\"p16 border-0 border-b border-solid border-gray-200\" flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.BRAND></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::ctrl.vehicle.attributes.brand_name}}</span></div><div class=\"p16 border-x border-y-0 border-b border-solid border-gray-200\" flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.MODEL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::ctrl.vehicle.attributes.model_name}}</span></div><div class=\"p16 border-0 border-b border-solid border-gray-200\" flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.YEAR></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::ctrl.vehicle.attributes.year}}</span></div></div><div layout><div class=p16 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.TRIM></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::ctrl.vehicle.attributes.trim_name}}</span></div><div class=\"p16 border-x border-y-0 border-solid border-gray-200\" flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.BODY_TYPE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::ctrl.vehicle.attributes.body_type}}</span></div><div class=p16 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.COLOR></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'VEHICLES.ENUM.COLOR.\' + (ctrl.colors[ctrl.vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span></div></div></div><div class=ml12 layout><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=VEHICLES.LABEL.NOT_RIGHT_INFO></span> <span class=\"ml8 text-xs leading-tight text-blue-500 truncate\"><a href=\"\" translate=VEHICLES.ACTION.CLICK_HERE ng-click=\"ctrl.forceEdit = !ctrl.forceEdit\"></a></span></div></div><div ng-if=ctrl.forceEdit><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLES.LABEL.BRAND></label><input class=\"st-input-type input-type\" name=brand_name ng-model=ctrl.vehicle.attributes.brand_name type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLES.LABEL.MODEL></label><input class=\"st-input-type input-type\" name=model_name ng-model=ctrl.vehicle.attributes.model_name type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=VEHICLES.LABEL.YEAR></label><input class=\"st-input-type input-type\" name=year ng-model=ctrl.vehicle.attributes.year type=text autocomplete=off required ui-number-mask=0 ui-hide-group-sep min=1930 max={{ctrl.maxYear}}><div ng-if=\"ctrl.form.$submitted && ctrl.form.year.$invalid\"><div class=st-input-validation ng-message=required translate=VEHICLES.VALIDATION.YEAR></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLES.LABEL.TRIM></label><input class=\"st-input-type input-type\" name=trim_name ng-model=ctrl.vehicle.attributes.trim_name type=text autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=VEHICLES.LABEL.TYPE></label><md-select class=\"st-input-select st-required\" name=types ng-model=ctrl.vehicle.attributes.type_name aria-label=\"Select Type\" md-no-asterisk required><md-option ng-repeat=\"t in ctrl.types\" value={{t.name}} translate=\"{{\'VEHICLES.ENUM.TYPE.\' + t.name.toUpperCase()}}\"></md-option></md-select></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=VEHICLES.LABEL.COLOR></label><md-select class=st-input-select name=colors ng-model=ctrl.vehicle.attributes.color aria-label=\"Select Color\" md-no-asterisk required><md-option ng-repeat=\"c in ctrl.colors\" value={{c.hex}} translate=\"{{\'VEHICLES.ENUM.COLOR.\' + c.name.toUpperCase()}}\"></md-option></md-select></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=VEHICLES.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.vehicle.attributes.description rows=4></textarea></div></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=VEHICLES.ACTION.DELETE></span></button><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=vehicles-list><span translate=VEHICLES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=VEHICLES.ACTION.SAVE></span></button></div></div></form><br><br><div class=\"details-tab-wrapper ml12 mr12\" flex><div class=details-tabs><button type=button ui-sref-active=active ui-sref=vehicles-edit.general class=details-tab-item ng-disabled=!ctrl.vehicle><span translate=VEHICLES.ENUM.TABS.GENERAL></span></button> <button type=button ui-sref-active=active ui-sref=vehicles-edit.users class=details-tab-item ng-disabled=!ctrl.vehicle><span translate=VEHICLES.ENUM.TABS.USERS></span></button></div></div><br><br><div ui-view></div></div></div>");
$templateCache.put("app/internal/management/vehicles/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"vehicle in ctrl.items\" ng-class=\"{\'opened\': vehicle.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout class=pr8 flex><span class=\"w-6 ml4\" layout layout-align=\"start center\"><span class=indicator><report-indicator last-gps={{vehicle.relationships.last_gps.attributes.last_gps_raw.act}} ignition={{vehicle.relationships.last_gps.attributes.last_gps_raw.ign}}></report-indicator></span></span><span layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" layout layout-align=\"space-between center\"><span layout layout-align=\"start center\"><span class=mr4 copy-paste value=\"{{vehicle.attributes.plate || vehicle.attributes.vin}}\">{{vehicle.attributes.plate || vehicle.attributes.vin}}</span> </span><span class=\"st-tags tag-important xs mr12\" ng-if=vehicle.attributes.deactivated_at><span translate=VEHICLES.LABEL.DEACTIVATED></span></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.code}}</span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{vehicle.attributes.enterprise_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{vehicle.attributes.enterprise_cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{vehicle.attributes.brand_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{vehicle.attributes.model_name}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder translate=\"{{\'VEHICLES.ENUM.TYPE.\' + (vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'VEHICLES.ENUM.COLOR.\' + (ctrl.colors[vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::vehicle.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.getMainDevice(vehicle)}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"vehicle.panelExpanded = !vehicle.panelExpanded; ctrl.openPanel(vehicle)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=\"st-expansion-content has-selector\"><div layout class=\"pt16 pb16\"><div flex=50 layout=column layout-align=\"space-between stretch\"><div><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=VEHICLES.LABEL.VEHICLE_DETAILS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.VIN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.vin}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.TRIM></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.relationships.last_gps.attributes.last_gps_raw.dis / 1000 | number:\'1\'}}</span></div></div></div><div><div class=\"text-xs mb8 mt12 leading-tight text-gray-500 truncate uppercase\" translate=VEHICLES.LABEL.CONTROL></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.enterprise_name}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.BATCH></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.batch}}</span></div></div></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.USER></div><div ng-if=vehicle.panelExpanded><user-list users=vehicle.relationships.users recordable=true initials=true horizontal=true clickable=false></user-list></div></div><div><div class=\"text-xs mb8 mt12 leading-tight text-gray-500 truncate uppercase\" translate=VEHICLES.LABEL.INTEGRATION></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.INTEGRATED></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.last_integration_source}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.INTEGRATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.attributes.last_integration_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div><div class=ml4 flex ng-if=vehicle.relationships.last_gps.attributes.last_gps_raw><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=VEHICLES.LABEL.MESSAGE_DETAILS></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.LAST_CONNECTION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.relationships.last_gps.attributes.last_connection_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.LAST_COMUNICATION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.LAST_ADDRESS></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::vehicle.relationships.address}}</div><div layout><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{::vehicle.relationships.last_gps.attributes.last_gps_raw.lat | number:\'6\'}}, {{::vehicle.relationships.last_gps.attributes.last_gps_raw.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div><div class=mt12 layout><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.PV></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=voltage>{{::vehicle.relationships.last_gps.attributes.last_gps_raw.pv | number:\'1\'}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.BL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=percentage>{{::vehicle.relationships.last_gps.attributes.last_gps_raw.bl | number:\'1\'}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.DIR></div><span class=\"text-xs leading-tight text-gray-500 truncate\">{{::vehicle.relationships.last_gps.attributes.last_gps_raw.dir | direction}}</span></span></div><div class=mt12 layout><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.SC></div><span class=\"text-xs leading-tight text-gray-500 truncate\">{{::vehicle.relationships.last_gps.attributes.last_gps_raw.sc}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.ORG></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{\'VEHICLES.ENUM.ORIGIN.\' + vehicle.relationships.last_gps.attributes.last_gps_raw.org.toUpperCase()}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.IGN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{\'VEHICLES.ENUM.IGNITION.\' + vehicle.relationships.last_gps.attributes.last_gps_raw.ign.toString().toUpperCase()}}\"></span></span></div></div></div></div><div class=\"st-expansion-footer has-selector\"><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=VEHICLES.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::vehicle.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=VEHICLES.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::vehicle.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><span class=mr8 can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><span ng-show=vehicle.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=VEHICLES.LABEL.ACTIVE></span> <span ng-show=!vehicle.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=VEHICLES.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=vehicle.attributes.active md-no-ink aria-label=State ng-change=ctrl.toggleState(vehicle)></span><span class=mr8 can-access=INTERNALS,MANAGER><button type=button class=\"no-button mt16\" ng-click=ctrl.updateVerified(vehicle)><i class=material-symbols-outlined>verified</i></button> </span><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"vehicles-edit.general({id: vehicle.id, vehicle: vehicle})\"><span translate=VEHICLES.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=VEHICLES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/management/vehicles/list/vehicles.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=vehicles version=v5></export-dialog-bar><search-bar model=vehicles filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/management/vehicles/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/management/vehicles/panel/vehicles.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div layout><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex=60><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=VEHICLES.TITLE.MANAGEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=VEHICLES.TITLE.MANAGEMENT_SUB></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedKeys aria-label=\"Select keys\" multiple ng-change=ctrl.selectManagedKeys() translate-attr=\"{ placeholder: \'VEHICLES.PLACEHOLDER.SELECT_KEY\' }\" ng-disabled=ctrl.loadingManage><md-option ng-repeat=\"k in [\'created\', \'deleted\']\" ng-value=k>{{\'VEHICLES.ENUM.KEYS.\' + k.toUpperCase() | translate}}</md-option></md-select></div></div><br><div id=manage-items class=\"h-80 m24\"></div></div><div class=\"border border-solid border-gray-200 rounded-md bg-white ml16\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=VEHICLES.TITLE.MODEL></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=VEHICLES.TITLE.MODEL_DISTRIBUTION></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedModels aria-label=\"Select Models\" multiple ng-change=ctrl.selectModelKeys() translate-attr=\"{ placeholder: \'VEHICLES.PLACEHOLDER.SELECT_MODELS\' }\" ng-disabled=ctrl.loadingDistribution><md-option ng-repeat=\"p in ctrl.modelsList\" ng-value=p>{{\'VEHICLES.ENUM.TYPE.\' + p.toUpperCase() | translate}}</md-option></md-select></div></div><br><div id=vehicles-distribution class=\"h-80 m24\"></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/center/board/_alert-card.html","<div sv-root=cards sv-on-sort=\"ctrl.mountEvent($item, $partFrom, $partTo, $indexFrom, $indexTo)\"><div class=st-board-handler ng-class=\"{\'no-content\': ctrl.items.alerts.length === 0}\" sv-part=ctrl.items.alerts when-scrolled=ctrl.loadMoreAlerts()><div sv-placeholder class=st-board-placeholder></div><div class=\"st-element relative\" ng-repeat=\"i in ctrl.items.alerts track by $index\" sv-element ng-mouseover=\"i.hovered = true\" ng-mouseleave=\"i.hovered = false\"><!-- skeleton loading --><div ng-if=i.loading class=st-card-skeleton><div class=w-4/6><span class=st-skeleton-item></span></div><div class=w-3/6><span class=st-skeleton-item></span></div><div class=\"h-10 relative\"><div class=\"w-2/6 float-left\"><span class=st-skeleton-item></span></div><div class=\"w-1/6 float-right\"><span class=st-skeleton-item></span></div></div></div><!-- content --><div ng-if=!i.loading layout=column layout-align=\"space-between stretch\" ng-class=\"{\'opacity-50\': (!i.selected && ctrl.selectedAlerts.length > 0 && ctrl.selectedAlertGroupId !== i.relationships.vehicle.id)}\"><div class=st-sector layout=column layout-align=\"start stretch\"><div layout layout-align=\"space-between center\" flex><div layout layout-align=\"start center\"><div sv-handle class=st-dragger ng-if=!ctrl.selectedAlertGroupId></div><input type=checkbox id={{i.attributes.id}} ng-model=i.selected aria-label=Selected ng-change=ctrl.selectAlert() ng-disabled=ctrl.checkDisabled(i)><label for={{i.id}}><div class=truncate layout layout-align=\"start center\"><div class=\"text-base font-bold leading-tight text-gray-700\">{{i.relationships.vehicle.attributes.plate || i.relationships.vehicle.attributes.vin}}</div><span class=ml4 ng-class=\"{\'hide show-gt-md\': i.attributes.flood}\">&middot;</span><div class=\"text-xs font-medium leading-tight text-gray-500 m4\" ng-class=\"{\'hide show-gt-md\': i.attributes.flood}\" flex><span translate=\"{{\'ALERTS.VEHICLE_TYPE.\' + (i.relationships.vehicle.attributes.type.toUpperCase() || \'NO_TYPE\')}}\"></span></div></div></label></div><div><button class=\"open-details absolute bg-white right-0 top-0 mr8 mt12 no-button text-gray-300\" ng-click=ctrl.openAlertsDetails(i)><i class=material-symbols-outlined>visibility</i></button></div><div ng-if=i.attributes.flood><span class=\"st-tags tag-purple tag-flood\" translate=ALERT_TAG.SPAM.TITLE></span></div></div></div><div class=\"truncate mb12 mt12\" layout layout-align=\"start center\"><span class=\"st-tags mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(i.attributes.tag)}\"><span translate=\"{{\'ALERT_TAG.\' + i.attributes.tag.toUpperCase() + \'.TITLE\'}}\"></span> </span><span class=st-tags ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(i.attributes.tag)}\"><span translate=\"{{\'ALERT_VAL.\' + i.attributes.val.toUpperCase() + \'.TITLE\'}}\"></span></span></div><div class=\"st-sector mt4\" layout layout-align=\"space-between center\"><div ng-class=\"{hide: i.hovered}\" flex><user-list users=i.relationships.vehicle.relationships.responsibles initials=true horizontal=true clickable=false size=sm></user-list></div><div class=\"text-xs font-semibold leading-tight text-gray-500\" ng-class=\"{hide: !i.hovered}\" flex><span ng-if=i.relationships.vehicle.relationships.responsibles.length translate=ALERTS.LABEL.AMOUNT_RESPONSIBLES translate-values=\"{ amount: {{i.relationships.vehicle.relationships.responsibles.length}} }\"></span></div><div class=\"text-xs font-semibold leading-tight text-gray-500\">{{i.attributes.act * 1000 | humanizeDate}}</div></div></div></div><div ng-if=ctrl.loading.alerts layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div></div>");
$templateCache.put("app/internal/monitoring/center/board/_event-card.html","<div sv-root=cards sv-on-sort=\"ctrl.moveEvent($item, $partFrom, $partTo, $indexFrom, $indexTo, key)\"><div class=st-board-handler ng-class=\"{\'no-content\': ctrl.items.events[key].length === 0}\" sv-part=value when-scrolled=ctrl.loadMoreEvents(key)><div sv-placeholder class=st-board-placeholder></div><div class=\"st-element relative\" ng-repeat=\"i in value track by $index\" sv-element ng-mouseover=\"i.hovered = true\" ng-mouseleave=\"i.hovered = false\"><!-- skeleton loading --><div ng-if=i.loading class=st-card-skeleton><div class=w-4/6><span class=st-skeleton-item></span></div><div class=w-3/6><span class=st-skeleton-item></span></div><div class=\"h-10 relative\"><div class=\"w-2/6 float-left\"><span class=st-skeleton-item></span></div><div class=\"w-1/6 float-right\"><span class=st-skeleton-item></span></div></div></div><!-- content --><div ng-if=!i.loading layout=column layout-align=\"space-between stretch\"><div><div layout layout-align=\"space-between center\" flex><div layout=column layout-align=\"start stretch\" flex><div class=\"text-base font-bold leading-tight text-gray-700 truncate\">{{i.attributes.title}}</div></div><div><button class=\"open-details absolute bg-white right-0 top-0 mr8 mt12 no-button text-gray-300\" ng-click=ctrl.openEventsDetails(i)><i class=material-symbols-outlined>visibility</i></button></div></div></div><div class=\"truncate mt8 mb8\"><span ng-repeat=\"tag in i.attributes.tags\"><span class=\"st-tags mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div><div class=\"truncate mt4 mb4\"><div><span class=\"text-xs font-bold leading-3 text-gray-700\">{{i.relationships.vehicle.attributes.plate}}</span></div><div class=\"text-xs font-normal leading-3 text-gray-500 max-h-40\"><span class=html-wrap-content ng-bind-html=\"i.attributes.description | trust\"></span></div></div><div class=\"st-sector mt8\" layout layout-align=\"space-between center\"><div ng-class=\"{hide: i.hovered}\" flex><user-list users=i.relationships.vehicle.relationships.responsibles initials=true horizontal=true clickable=false size=sm></user-list></div><div class=\"text-xs font-semibold leading-tight text-gray-500\" ng-class=\"{hide: !i.hovered}\" flex><span ng-if=i.relationships.vehicle.relationships.responsibles.length translate=ALERTS.LABEL.AMOUNT_RESPONSIBLES translate-values=\"{ amount: {{i.relationships.vehicle.relationships.responsibles.length}} }\"></span></div><div class=\"text-xs font-semibold leading-tight text-gray-500\">{{i.attributes.createdAt | humanizeDate}}</div></div></div></div><div ng-if=ctrl.loading[key] layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div></div>");
$templateCache.put("app/internal/monitoring/center/board/center.board.html","<div layout layout-align=\"space-between start\" class=st-board-content><div flex class=st-board><!-- alerts --><div class=st-board-header><div class=st-board-item translate=\"{{\'ALERTS.BOARD.ALERTS\'}}\"></div></div><a href=\"\" class=\"st-board-badge z-10\" layout layout-align=\"space-between center\" ng-click=ctrl.loadAlertsData(true) ng-if=\"ctrl.totalNewAlerts || this.loading.count\"><i class=material-symbols-outlined>autorenew</i> <span ng-if=\"ctrl.totalNewAlerts === 1\" translate=ALERTS.LABEL.ONE_NEW translate-values=\"{ amount: \'{{ctrl.totalNewAlerts | number}}\' }\"></span> <span ng-if=\"ctrl.totalNewAlerts > 1\" translate=ALERTS.LABEL.NEW translate-values=\"{ amount: \'{{ctrl.totalNewAlerts | number}}\' }\"></span></a><div flex ng-include src=\"\'app/internal/monitoring/center/board/_alert-card.html\'\"></div></div><!-- events --><div flex class=st-board ng-repeat=\"(key, value) in ctrl.items.events\"><div class=st-board-header layout layout-align=\"start center\"><div class=st-board-item translate=\"{{\'ALERTS.BOARD.\' + key.toUpperCase()}}\"></div><div class=ml8>({{ctrl.items.count[key]}})</div></div><div flex ng-include src=\"\'app/internal/monitoring/center/board/_event-card.html\'\"></div></div></div><div class=\"select-actions-wrapper opacity-90\" ng-class=\"{opened: ctrl.selectedAlerts.length}\"><div class=\"select-actions font-bold text-white\" layout layout-align=\"space-between center\"><span>{{ctrl.selectedAlerts.length}} <span class=ml8 translate=ALERTS.LABEL.SELECTED_ALERTS></span> </span><span><button class=\"no-button text-white\" ng-click=ctrl.openCreateEvents()><span class=material-symbols-outlined>article</span></button> <button class=\"no-button text-white\" ng-click=ctrl.unSelectAlerts()><span class=material-symbols-outlined>close</span></button></span></div></div>");
$templateCache.put("app/internal/monitoring/center/list/events.list.html","<div class=card-content><panel-header data=ctrl.headers></panel-header><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"event in ctrl.items\" ng-class=\"{\'opened\': event.panelExpanded}\"><div class=st-expansion-header ng-click=\"event.panelExpanded = !event.panelExpanded\"><span layout layout-align=\"space-between center\" flex><!-- <span class=\"mr8\" layout=\"column\">\n            <input type=\"checkbox\" ng-model=\"event.selected\" aria-label=\"Selected\">\n          </span> --> <span class=mr8 layout=column flex><span class=\"text-xs font-semibold leading-tight text-gray-700 truncate\" no-data-holder>{{::event.attributes.title}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::event.relationships.enterprise.attributes.name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-semibold leading-tight text-gray-700 truncate\" no-data-holder>{{event.relationships.vehicle.attributes.plate || event.relationships.vehicle.attributes.vin}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span translate=\"{{\'ALERTS.VEHICLE_TYPE.\' + (event.relationships.vehicle.attributes.type.toUpperCase() || \'NO_TYPE\')}}\"></span> </span></span><span class=mr8 layout=column flex><span class=\"text-xs font-semibold leading-tight text-gray-700 truncate\" no-data-holder>{{::event.relationships.user.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::event.attributes.createdAt | date: \'dd/MM/yyyy\'}}</span> </span><span layout=column flex><span class=\"text-xs font-semibold leading-tight text-gray-700 truncate\" no-data-holder translate=\"{{\'ALERTS.BOARD.\' + event.attributes.status.toUpperCase()}}\"></span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::event.relationships.statusHistory[(event.relationships.statusHistory.length - 1)].attributes.updatedAt | date: \'dd/MM/yyyy\'}}</span> </span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><!-- <div class=\"st-expansion-content has-selector\"> --> <span layout layout-align=\"space-between start\"><span class=\"mt8 mb8\" flex=50><div layout><span class=\"mt8 mb8\" layout=column flex><span layout=column><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.TOTAL_ALERTS></span> <span class=\"text-xs font-semibold leading-tight text-gray-700\" no-data-holder>{{::event.attributes.alertsCount}}</span> </span></span><span class=\"mt8 mb8\" layout=column flex><span layout=column><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.TOTAL_COMMENTS></span> <span class=\"text-xs font-semibold leading-tight text-gray-700\" no-data-holder>{{::event.attributes.commentsCount}}</span></span></span></div><div><span class=\"mt8 mb8\" layout=column><span layout=column><span class=\"text-xs leading-tight text-gray-500\"><span translate=ALERTS.LABEL.DEVICES></span> <span>({{event.relationships.devices.length}})</span></span><div layout layout-wrap><span ng-repeat=\"device in event.relationships.devices\"><span class=\"mr8 text-xs font-semibold leading-tight text-gray-700\" no-data-holder>{{device.attributes.name}}</span></span></div></span></span></div><div><span class=\"mt16 mb8\" layout=column><span layout=column><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.RESPONSIBLES></span> <span ng-if=\"event.relationships.vehicle.relationships.responsibles.length === 0\" class=\"text-xs font-semibold leading-tight text-gray-500\" translate=ALERTS.HINT.NO_RECORD></span><user-list users=event.relationships.vehicle.relationships.responsibles initials=true horizontal=true clickable=false></user-list></span></span></div></span><span class=\"mt8 mb8\" flex><span class=\"mt8 mb8\" layout=column><span layout=column><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.ALERTS></span><div layout layout-wrap><span ng-repeat=\"tag in event.attributes.tags\"><span class=\"st-tags mr4\" ng-class=\"{\'tag-important\': [\'batery\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div></span></span><span class=\"mt8 mb8\" layout=column layout-align=\"start stretch\" flex><span layout=column><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.DESCRIPTION></span><div class=\"text-xs font-semibold leading-tight text-gray-700 max-h-40 truncate\"><span ng-bind-html=\"event.attributes.description | trust \"></span> <span ng-if=!event.attributes.description class=\"text-xs font-semibold leading-tight text-gray-500\" translate=ALERTS.HINT.NO_RECORD></span></div></span></span></span></span></div><div class=st-expansion-footer><!-- <div class=\"st-expansion-footer has-selector\"> --><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-600\">{{::event.attributes.createdAt | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-500\" translate=ALERTS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-600\">{{::event.attributes.updatedAt | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div can-access=INTERNALS,MANAGER,READ_ONLY layout layout-align=\"end center\"><a class=\"altnav-action light\" ui-sref=\"events-edit({uuid: event.id})\"><span translate=ALERTS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=ALERTS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/monitoring/center/panel/center.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"start center\"><title-bar></title-bar><progress ng-if=ctrl.loading></progress></div></div><div class=card-content><div class=\"st-form-section st-card\"><form layout layout-align=\"start end\" name=ctrl.params ng-submit=\"ctrl.params.$valid && ctrl.loadData()\" novalidate><!-- enterprise --><div flex><enterprises-autocomplete clear-button=true form=ctrl.params search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div class=st-input-container layout=column flex=45><label class=\"st-label st-required\" translate=ALERTS.LABEL.RANGE></label><input class=\"st-input-type input-type\" name=range ng-model=ctrl.alerts.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'ALERTS.PLACEHOLDER.PICK_DATE\'}\" autocomplete=off></div><div class=mb12><button type=submit class=\"altnav-action save mb4\"><i class=material-symbols-outlined>search</i></button></div></form><br><div flex><div><div layout layout-align=\"space-between center\"><div class=\"m16 p16 border border-solid rounded-md border-gray-200\" ng-repeat=\"c in [\'count\',\'countFlood\',\'handledCount\',\'handledCountFlood\']\" flex><div class=\"text-base font-semibold leading-tight text-gray-700 truncate\" flex translate=\"{{\'ALERTS.LABEL.\' + c.toUpperCase()}}\"></div><div class=\"text-sm font-medium leading-tight text-gray-400\" flex>{{ctrl.enterpriseSummary.attributes[c] || 0 | number:\'0\'}}</div></div></div></div><!-- <div class=\"m12\">\n        <div class=\"pt16 pb16\">\n          <div id=\"graph\" class=\"mt16 mb16\"></div>\n        </div>\n      </div> --><div><md-table-container class=\"m12 border border-solid border-gray-200 h-96 pr8 pl8\"><table class=st-main-table md-table><thead class=st-table-head md-head md-order=type><tr md-row><th md-column ng-repeat=\"value in ctrl.header\" md-order-by=\"{{value !== \'type\' ? value : null}}\" md-numeric=\"value !== \'type\'\"><span translate=\"{{\'ALERTS.LABEL.\' + value.toUpperCase()}}\"></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"value in ctrl.tableData | orderBy: type\"><td md-cell ng-repeat=\"h in ctrl.header\" md-numeric=\"h !== \'type\'\"><span ng-if=\"h === \'type\'\" translate=\"{{\'ALARMS.\' + value[h].toUpperCase()}}\"></span> <span ng-if=\"h !== \'type\'\">{{value[h]}}</span></td></tr><tr md-row class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3,4]\"><td md-cell colspan=5><span class=st-skeleton-item></span></td></tr><tr md-row ng-if=\"(ctrl.enterpriseSummary.attributes.count === 0) && !ctrl.loading\"><td md-cell class=st-table-no-content colspan=5><div layout=column layout-align=\"center center\" class=\"mt24 pt24\"><img src=assets/holders/no-results.svg alt=\"No results\" height=52> <span class=\"no-content-text mt8\" translate=ALERTS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div></div><br><br></div></div>");
$templateCache.put("app/internal/monitoring/events/edit/events.edit.html","<div class=card-content><div class=\"st-form-section st-card\"><div layout layout-align=\"space-between start\"><div class=mr24 flex=60><!-- Event --><div layout=column layout-align=\"start stretch\"><!-- Status --><div><div class=st-input-container flex=30><md-select class=st-input-select name=status ng-model=ctrl.event.attributes.status aria-label=\"Select status\" md-no-asterisk ng-change=\"ctrl.edit(\'status\', ctrl.event.attributes.status)\"><md-option ng-repeat=\"s in ctrl.status\" value={{s}} translate=\"{{\'EVENTS.STATUS.\' + s.toUpperCase()}}\"></md-option></md-select></div></div><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-head.html\'\"></div><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_alert-panel.html\'\"></div></div><!-- Comments section --><div layout=column layout-align=\"start stretch\"><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-interaction.html\'\"></div></div></div><div flex><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-short-data.html\'\"></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/history/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"trajectory in ctrl.items\" ng-class=\"{\'opened\': trajectory.panelExpanded}\"><div class=st-expansion-header ng-click=\"trajectory.panelExpanded = !trajectory.panelExpanded; ctrl.openPanel(trajectory, $index)\"><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::trajectory.relationships.vehicle.attributes.plate || trajectory.relationships.vehicle.attributes.vin}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.relationships.vehicle.attributes.brand_name}} {{::trajectory.relationships.vehicle.attributes.model_name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::trajectory.relationships.device.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.acc | accOn}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" data-metrics=distance no-data-holder>{{::trajectory.attributes.vDis / 1000 | number:1}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.dur | duration}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::trajectory.attributes.alCnt}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.sgCnt}}</span> </span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=50 layout=column layout-align=\"space-between stretch\"><div><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.CONTROL></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.ENTERPRISE></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.relationships.enterprise.attributes.name}}</div></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.CNPJ></div><div class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.relationships.enterprise.attributes.cnpj}}</div></div></div></div><div class=mt24><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.STATS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.SPEED_MAX></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=speed no-data-holder>{{::trajectory.attributes.spMax}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.SPEED_AVG></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=speed no-data-holder>{{::trajectory.attributes.spAvg}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.RISK_ANALYSIS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.RISK_TIME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.raDur | duration}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.HIST_TIME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.hisDur | duration}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.STOPS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.TOTAL_STOP></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.stCnt}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.STOP_TIME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::trajectory.attributes.stDur | duration}}</span></div></div></div></div><div flex><div><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.ALERTS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.TAGS></div><span ng-repeat=\"tag in trajectory.attributes.alTags\"><span class=\"st-tags mr4 mt4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div></div></div><div class=mt24><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=TRAJECTORIES.LABEL.MOVEMENT></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.BEHAVIOR></div><span ng-if=\"ctrl.hasMov == 0\" class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=TRAJECTORIES.HINT.NO_ACTIVITY></span><div id=trajectory-{{$index}} class=h-28></div></div></div></div></div></div></div><div class=st-expansion-footer><div class=h-full layout layout-align=\"end center\" flex><a class=\"altnav-action light\" ui-sref=\"history-show({id: trajectory.id})\"><span translate=TRAJECTORIES.ACTION.DETAILS></span></a></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=TRAJECTORIES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/monitoring/history/list/history.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><div class=\"st-input-container no-padding relative\" style=\"width: 528px\"><vehicles-autocomplete form=ctrl.form hide-label=true on-item-change=ctrl.applyFilter(selectedItem) required-item=false search-text=ctrl.vehicle selected-item=ctrl.selectedVehicle></vehicles-autocomplete><!-- <div id=\"filter-by-location\">\n          <button type=\"button\" class=\"no-button\" ng-disabled=\"!ctrl.selectedVehicle\" ng-click=\"ctrl.openAdvancedFilter()\">\n            <i class=\"material-symbols-outlined\">resize</i>\n          </button>\n        </div> --><div class=\"absolute top-0 right-0\" id=date-period><input name=range ng-model=ctrl.hist.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'TRAJECTORIES.PLACEHOLDER.PICK_DATE\' }\" autocomplete=off></div></div></div><div class=\"pt-1.5 pb-px\"><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex><div ng-include src=\"\'app/internal/monitoring/history/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/monitoring/history/panel/history.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar><!-- vehicle --><div class=\"st-input-container no-padding relative\" style=\"width: 528px\"><vehicles-autocomplete filters=ctrl.vehiclesOptions.filters form=ctrl.form hide-label=true includes=ctrl.vehiclesOptions.includes on-item-change=ctrl.loadData(selectedItem) required-item=false search-text=ctrl.vehicle selected-item=ctrl.selectedVehicle></vehicles-autocomplete><div class=\"absolute top-0 right-0\" id=date-period><input name=range ng-model=ctrl.hist.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'TRAJECTORIES.PLACEHOLDER.PICK_DATE\' }\" autocomplete=off></div></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white p12\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=TRAJECTORIES.TITLE.MOVEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.MOVEMENT_SUMMARY></div></div></div><div id=movement-report layout=column layout-align=\"start stretch\"><div layout><span class=hour-label-holder></span> <span data-metrics=hours class=\"hour-label text-gray-400 font-semibold text-xs\" ng-repeat=\"h in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]\">{{h}}</span></div><div class=movement-days ng-repeat=\"day in ctrl.data.movement.report track by $index\" layout><span class=\"day-label text-gray-400 font-semibold text-xs\">{{ctrl.weekdays[$index]}}</span><div class=movement-hours ng-repeat=\"hour in day track by $index\"><div class=square ng-class=ctrl.setSpectrum(hour.v)></div></div></div><div layout layout-align=\"end center\"><div class=subtitle><span class=square-wrapper><span class=square ng-class=\"\'square-\'+ {{i}}\" ng-repeat=\"i in [1,2,3,4,5,6,7,8,9,10]\"></span></span><div layout layout-align=\"space-between center\"><span class=\"text-gray-400 font-semibold text-xs\">Mín</span> <span class=\"text-gray-400 font-semibold text-xs\">Máx</span></div></div></div></div><br><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.DISTANCE></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\" data-metrics=distance>{{ctrl.reduced.dis / 1000 | number: \'1\'}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.DISTANCE_SUMMARY></div></div><div id=distance-report class=\"h-80 m24\"></div></div><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.STOP></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\">{{ctrl.reduced.stCnt | number: \'0\'}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.STOP_SUMMARY></div></div><div id=stop-report class=\"h-80 m24\"></div></div><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.STOP_DUR></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\">{{ctrl.reduced.stDur | duration}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.STOP_DUR_SUMMARY></div></div><div id=stop-duration-report class=\"h-80 m24\"></div></div><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.ALERTS></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\">{{ctrl.reduced.alCnt | number: \'0\'}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.ALERTS_SUMMARY></div></div><div id=alerts-report class=\"h-80 m24\"></div></div><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.HISTORICAL></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\">{{ctrl.reduced.hisDur | duration}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.HISTORICAL_SUMMARY></div></div><div id=historical-report class=\"h-80 m24\"></div></div><div><div class=m24><div><span class=\"text-base font-bold text-gray-800 mr12\" translate=TRAJECTORIES.TITLE.SPEED></span> <span class=\"rounded-sm bg-gray-200 text-sm text-gray-800 pl8 pr8 font-bold\" data-metrics=speed>{{ctrl.reduced.spMax}}</span></div><div class=\"text-sm font-normal text-gray-400\" translate=TRAJECTORIES.TITLE.SPEED_SUMMARY></div></div><div id=speed-report class=\"h-80 m24\"></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/history/show/history.show.html","<div id=map-wrapper layout laytou-align=\"space-between start\"><div flex=30><div layout=column layout-align=\"start stretch\"><div class=p24><div layout layout-align=\"space-between center\"><!-- vehicle details --><div flex><div class=\"image-holder mr8\"><object class=\"image-holder-fallback vehicle-holder\" ng-attr-data={{ctrl.trajectory.relationships.vehicle.attributes.picture_link}} type=image/gif></object></div><div><div layout layout-align=\"start center\"><span class=\"text-sm font-bold leading-tight text-gray-700 mr16\">{{ctrl.trajectory.relationships.vehicle.attributes.plate}}</span> <span class=\"text-xs leading-tight text-gray-500\">{{ctrl.trajectory.relationships.vehicle.attributes.vin}}</span></div><div layout layout-align=\"start center\" class=pt2><span ng-if=ctrl.trajectory.relationships.vehicle.attributes.brand_name class=\"text-xs mr8 leading-tight text-gray-500 truncate\">{{ctrl.trajectory.relationships.vehicle.attributes.brand_name}} {{ctrl.trajectory.relationships.vehicle.attributes.trim_name}}</span> <span class=\"text-xs font-bold rounded-sm pl8 pr8 leading-tight bg-blue-100 text-blue-600\">{{ctrl.trajectory.relationships.device.attributes.name}}</span></div></div></div></div><div class=mt16 layout=column layout-align=\"space-between stretch\" flex><div layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_DISTANCE></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=distance>{{ctrl.trajectory.attributes.vDis / 1000 | number:1}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.dur | duration}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_STOP_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.stDur | duration}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SPEED_MAX></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{ctrl.trajectory.attributes.spMax | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SPEED_AVG></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{ctrl.trajectory.attributes.spAvg | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.STOPS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.stCnt}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.ALERTS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.alCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.MESSAGES></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.gpsCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRAJECTORIES.LABEL.TOTAL_RISK_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.raDur | duration}}</span></div></div><div class=mt8 layout><div flex=66><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.USERS></div><!-- users --><div ng-if=ctrl.trajectory><user-list users=ctrl.trajectory.relationships.vehicle.relationships.users recordable=true initials=true horizontal=true clickable=false></user-list></div></div><div flex><div class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRAJECTORIES.LABEL.DAY></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.today}}</span></div></div></div></div><div><div flex ng-include src=ctrl.selectedPath></div></div></div></div><div flex=70 class=relative><div id=map class=history></div><div id=speed-legend ng-class=\"{\'opened\': ctrl.ranges.length > 0}\"><div class=speed-guide><div ng-repeat=\"speed in ctrl.speeds\" class=guide>{{speed}}km/h</div></div><div class=speed-colors><div class=\"square blue\"></div><div class=\"square orange\"></div><div class=\"square red\"></div><div class=\"square dark-red\"></div></div></div><div id=segments-additional-info class=p12 layout=column layout-align=\"space-between stretch\" ng-class=\"{\'opened h-48\': (ctrl.ranges.length > 0 || ctrl.geoData.properties || ctrl.nextPrevLoad), \'h-auto\': !ctrl.geoData.properties}\"><div ng-if=ctrl.geoData.properties class=relative><div layout=row layout-align=\"space-between stretch\"><div><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.TITLE.ADDITIONAL_POINT></span><div class=\"mt8 mb8\"><div flex><div class=\"text-xs leading-tight text-gray-500 h-8\"><span ng-if=\"!ctrl.geoData.address && !ctrl.addressLoad\">-</span> <span ng-if=ctrl.addressLoad><progress></progress></span>{{ctrl.geoData.address}}</div></div></div></div><div ng-if=ctrl.prevNextData.total layout=column layout-align=\"start end\"><p class=\"text-xs text-gray-500 pb4 pr4\">{{ctrl.prevNextData.current + 1 }}/{{ctrl.prevNextData.total}}</p><div layout=row><button aria-label=Previous class=\"h-6 w-6 no-padding rounded-full border-0 mr4\" type=button ng-class=\"{\n                  \'bg-gray-50 text-gray-300\': !ctrl.prevNextData.prev,\n                  \'bg-gray-200 text-gray-700\': !!ctrl.prevNextData.prev\n                }\" ng-click=\"ctrl.goToPrevNext(ctrl.prevNextData.prev, -1); ctrl.nextPrevLoad = true\" ng-disabled=\"!ctrl.prevNextData.prev || ctrl.addressLoad\"><i class=\"material-symbols-outlined leading-6\">chevron_left</i></button> <button aria-label=Next class=\"h-6 w-6 no-padding rounded-full border-0\" type=button ng-class=\"{\n                  \'bg-gray-50 text-gray-300\': !ctrl.prevNextData.next,\n                  \'bg-gray-200 text-gray-700\': !!ctrl.prevNextData.next\n                }\" ng-click=\"ctrl.goToPrevNext(ctrl.prevNextData.next, 1); ctrl.nextPrevLoad = true\" ng-disabled=\"!ctrl.prevNextData.next || ctrl.addressLoad\"><i class=\"material-symbols-outlined leading-6 pl2\">chevron_right</i></button></div></div></div><div layout layout-align=\"space-between center\" class=pb4><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.act * 1000 | date: \'HH:mm:ss dd/MM/yyyy\' }}</span> <span ng-if=\"ctrl.geoData.properties.point.org === \'AlarmEvent\'\"><span class=st-tags translate=\"{{\'ALERT_TAG.\' + ctrl.geoData.properties.point.tag.toUpperCase() + \'.TITLE\'}}\"></span> <span class=st-tags translate=\"{{\'ALERT_VAL.\' + ctrl.geoData.properties.point.val.toUpperCase() + \'.TITLE\'}}\"></span> </span><span ng-if=ctrl.geoData.properties.duration><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.STOPED_BY></span> <span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.duration | duration }}</span></span></div><div><div class=mb12 layout layout-align=\"space-between center\"><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.LAT></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.lat | number:\'6\'}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.LNG></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.lng | number:\'6\'}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.PV></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" data-metrics=voltage>{{ctrl.geoData.properties.point.pv}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.BL></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" data-metrics=percentage>{{ctrl.geoData.properties.point.bl}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SC></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.sc | number:\'0\'}}</span></span></div><div layout layout-align=\"space-between center\"><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.BBV></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" data-metrics=voltage>{{ctrl.geoData.properties.point.bbv}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.DIR></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.dir | direction}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.IGN></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" translate=\"{{\'TRAJECTORIES.ENUM.IGN.\' + ctrl.geoData.properties.point.ign.toString().toUpperCase()}}\"></span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SPD></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{ctrl.geoData.properties.point.spd}}</span> </span><span flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.CAT></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.geoData.properties.point.cat * 1000 | date: \'HH:mm dd/MM/yyyy\' }}</span></span></div></div></div><div ng-if=\"ctrl.reducedSegments && !ctrl.geoData.properties\"><div><span class=\"text-sm font-bold leading-tight text-gray-700 mb8\" translate=TRAJECTORIES.TITLE.ADDITIONAL></span></div><div class=mt16 layout layout-align=\"space-between center\"><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_DISTANCE></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.vDis/ctrl.trajectory.attributes.vDis) * 100 || 0) | number:1}}</span></div><span class=\"mt4 text-sm font-bold leading-tight text-gray-700\" data-metrics=distance>{{ctrl.reducedSegments.vDis / 1000 | number:1}}</span> </span><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_TIME></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.dur/ctrl.trajectory.attributes.dur) * 100 || 0) | number:1}}</span></div><div class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.reducedSegments.dur | duration}}</div></span><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.MESSAGES></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.gpsCnt/ctrl.trajectory.attributes.gpsCnt) * 100 || 0) | number:1}}</span></div><div class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.reducedSegments.gpsCnt | number:0}}</div></span><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.STOPS></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.stCnt/ctrl.trajectory.attributes.stCnt) * 100 || 0) | number:1}}</span></div><div class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.reducedSegments.stCnt | number:0}}</div></span><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_STOP_TIME></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.stDur/ctrl.trajectory.attributes.stDur) * 100 || 0) | number:1}}</span></div><div class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.reducedSegments.stDur | duration}}</div></span><span><div layout><span class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.ALERTS></span> <span ng-if=!ctrl.selectedAll class=\"ml4 text-xs font-bold bg-blue-100 text-blue-600 rounded-sm pl4 pr4\" data-metrics=percentage>{{((ctrl.reducedSegments.alCnt/ctrl.trajectory.attributes.alCnt) * 100 || 0) | number:1}}</span></div><div class=\"mt4 text-sm font-bold leading-tight text-gray-700\">{{ctrl.reducedSegments.alCnt | number:0}}</div></span></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/links/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"sharing in ctrl.items\" ng-class=\"{\'opened\': sharing.panelExpanded}\"><div class=st-expansion-header ng-mouseenter=ctrl.checkStatus(sharing);ctrl.isValid(sharing)><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\"><span easy-link link={{ctrl.EnvironmentConfig.SHARING}}/{{sharing.attributes.type}}/{{sharing.attributes.hash}} placeholder={{::sharing.attributes.hash}}></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{ \'LINKS.ENUM.TYPE.\' + sharing.attributes.type.toUpperCase()}}\"></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.sharing.relationships.enterprise.attributes.email}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.attributes.valid_until | date: \'HH:mm dd/MM/yyyy\':\'Z\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.attributes.tokens_generated}}<span class=ml4 translate=LINKS.LABEL.USED></span></span> </span><span layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.relationships.creator.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.creator.attributes.phone1 | phoneFilter}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"sharing.panelExpanded = !sharing.panelExpanded\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=50 layout=column layout-align=\"space-between stretch\"><div><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=LINKS.LABEL.CONTROL></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.PLATE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.asset.attributes.plate}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.VIN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.asset.attributes.vin}}</span></div></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.BRAND></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.asset.attributes.brand_name}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.MODEL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.asset.attributes.model_name}}</span></div></div></div><div><div class=\"text-xs mb8 mt12 leading-tight text-gray-500 truncate uppercase\" translate=LINKS.LABEL.ITEM></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.IMEI></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.device.attributes.imei}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.IDENTIFIER></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.relationships.device.attributes.name}}</span></div></div></div></div><div class=ml4 flex><div class=\"text-xs mb8 leading-tight text-gray-500 truncate uppercase\" translate=LINKS.LABEL.MESSAGE_DETAILS></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.RESOURSES></div><span ng-repeat=\"resource in sharing.attributes.resources\"><span class=\"st-tags mr4 mt4\"><span translate=\"{{\'LINKS.ENUM.RESOURSES.\' + resource.toUpperCase()}}\"></span></span></span></div></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.DESCRIPTION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.attributes.description}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.SOURCE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.attributes.source}}</span></div></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=LINKS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::sharing.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=LINKS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::sharing.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div ng-if=sharing.attributes.valid can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><span layout layout-align=\"space-between center\"><span ng-show=sharing.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=LINKS.LABEL.ACTIVE></span> <span ng-show=!sharing.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=LINKS.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=sharing.attributes.active md-no-ink aria-label=State ng-change=ctrl.toggleState(sharing)></span></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=LINKS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/monitoring/links/list/links.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><search-bar model=sharings history-model=links filter=false typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/monitoring/links/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/monitoring/sharings/create/sharings.create.html","<div class=navigator-wrapper><navigator contract=ctrl.options version=v3 model=sharings></navigator></div><div class=card-content><div class=\"st-form-section st-card\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex=60><div layout=column layout-align=\"space-between stretch\"><!-- vehicle --><div><!-- <h3 class=\"ml12\" translate=\"SHARINGS.TITLE.VEHICLE\"></h3> --><div class=st-input-container layout=column flex><label class=st-label translate=SHARINGS.LABEL.VEHICLE></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'SHARINGS.PLACEHOLDER.TYPE_PLATE\' | translate}}\" ng-disabled=ctrl.sharing.uuid md-clear-button=!ctrl.sharing.uuid md-input-name=autocomplete_vehicle md-selected-item=ctrl.sharing.vehicle md-search-text=ctrl.vehicle md-selected-item-change=ctrl.resolveAddress() md-items=\"item in ctrl.getVehicles(ctrl.vehicle)\" md-item-text=item.plate md-min-length=3 md-delay=1000 required md-require-match md-no-cache><span md-highlight-text=ctrl.vehicle>{{item.plate}}</span><md-not-found><span translate=SHARINGS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.vehicle}}\' }\"></span></md-not-found></md-autocomplete></div></div><!-- types --><div layout layout-align=space-between><div class=\"st-radio-container st-input-container\" layout=column><div class=st-label translate=SHARINGS.LABEL.TYPE></div><div class=\"mt8 pt8\" layout><label class=mr8 ng-repeat=\"type in ctrl.types\"><input type=radio ng-model=ctrl.sharing.type value={{type}}> <span translate=\"{{ \'SHARINGS.TYPE.\' + type.toUpperCase()}}\"></span></label></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=SHARINGS.LABEL.VALID_UNTIL></label><input class=\"st-input-type input-type\" name=validUntil ng-model=ctrl.sharing.valid_until type=text placeholder=\"HH:MM DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" datetime-model=yyyy-MM-ddTHH:mm:ss.sss min={{ctrl.sharing.minSharingDate}} max={{ctrl.sharing.maxSharingDate}} autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.validUntil.$error\"><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.required translate=SHARINGS.VALIDATION.REQUIRED_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.min translate=SHARINGS.VALIDATION.MIN_VALID_UNTIL></div><div class=st-input-validation ng-show=ctrl.form.validUntil.$error.max translate=SHARINGS.VALIDATION.MAX_VALID_UNTIL></div></div></div></div><div layout layout-align=start><div class=st-input-container layout=column flex><label class=st-label translate=SHARINGS.LABEL.FORMATTED_ADDRESS></label><input class=\"st-input-type input-type\" ng-model=ctrl.sharing.formatted_address type=text autocomplete=off required disabled></div></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=sharings-list><span translate=SHARINGS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\"><md-progress-circular class=md-hue-2 md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=SHARINGS.ACTION.SAVE></span></button></div></div></form></div></div>");
$templateCache.put("app/internal/monitoring/sharings/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"sharing in ctrl.items\" ng-class=\"{\'opened\': sharing.panelExpanded}\"><div class=st-expansion-header ng-click=\"sharing.panelExpanded = !sharing.panelExpanded; ctrl.checkStatus(sharing)\"><span layout layout-align=\"space-between center\" flex><!-- <span class=\"mr8\" layout=\"column\">\n            <input type=\"checkbox\" ng-model=\"sharing.selected\" aria-label=\"Selected\">\n          </span> --> <span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\"><a ng-href=http://live.softruck.com/{{sharing.hash}} target=_blank>{{::sharing.hash}}</a> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{ \'SHARINGS.TYPE.\' + sharing.type.toUpperCase()}}\"></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.valid_until | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.vehicle.plate}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{ \'SHARINGS.VEHICLE_TYPE.\' + sharing.vehicle.type.toUpperCase()}}\"></span> </span><span layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.user.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.user.phone | phoneFilter}}</span> </span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=40><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SHARINGS.LABEL.FORMATTED_ADDRESS></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.formatted_address}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SHARINGS.LABEL.COORDS></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.coordinates.toString()}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SHARINGS.LABEL.CAR_VALUE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.vehicle.properties.value | currency}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SHARINGS.LABEL.RESPONSIBLES></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><vehicle-users users=sharing.vehicle.users></span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=SHARINGS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::sharing.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=SHARINGS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::sharing.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div can-access=INTERNALS,MANAGER layout layout-align=\"end center\"><span ng-if=\"ctrl.isValid(sharing) \" layout layout-align=\"space-between center\"><span ng-show=sharing.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=SHARINGS.LABEL.ACTIVE></span> <span ng-show=!sharing.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=SHARINGS.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=sharing.active md-no-ink aria-label=Estado ng-change=ctrl.toggleSharing(sharing)></span><a class=\"altnav-action light\" ui-sref=\"sharings-edit({uuid: sharing.uuid})\"><span translate=SHARINGS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=SHARINGS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/monitoring/sharings/list/sharings.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><search-bar model=sharings filter=false typeable=true></search-bar><!-- <export-bar contract=\"ctrl.options\" filters=\"ctrl.filters\" export-list=\"ctrl.exportList\"></export-bar> --><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/monitoring/sharings/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/operational/protocols/edit/protocols.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=\"pt8 pl16 pr16 pb16\"><div class=\"bg-white rounded-md border border-solid border-gray-200\"><div layout layout-align=\"space-between start\"><div class=\"border-0 border-r border-solid border-gray-200 h-full\" flex=60><form class=\"st-form-inputs relative\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate style=\"height: calc(100vh - 124px)\"><div class=\"p12 overflow-y-scroll h-full\"><!-- title --><div layout layout-align=\"space-between center\" class=p12><div><div ng-if=!ctrl.protocol.id><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=PROTOCOLS.TITLE.TYPE_OF></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=PROTOCOLS.TITLE.TYPE_OF_DESC></div></div><div layout ng-if=ctrl.protocol.id><div class=\"text-lg font-extrabold leading-tight text-gray-700\">{{ctrl.protocol.attributes.token}}</div></div></div><div layout><div ng-if=ctrl.protocol.id can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"start end\" class=h-8><button-dropdown ng-if=!ctrl.protocol.relationships.completion click-event=ctrl.toggleComplete() disabled><md-menu-item><md-button ng-click=ctrl.customDate() aria-label=\"Custom date\"><span md-menu-align-target translate=PROTOCOLS.LABEL.CUSTOM_DATE></span></md-button></md-menu-item></button-dropdown><div><button type=button class=\"altnav-action light\" ng-class=\"{\'done\': ctrl.protocol.relationships.completion}\" ng-if=ctrl.protocol.relationships.completion ng-disabled=ctrl.loading ng-click=ctrl.toggleComplete()><span translate=PROTOCOLS.ACTION.COMPLETED></span></button></div></div></div></div><!-- first line --><div layout layout-align=\"space-between center\"><!-- enterprise --><div flex=50><enterprises-autocomplete disabled-item=\"ctrl.selectedAssignee || ctrl.selectedAsset || ctrl.serviceOrder.id || ctrl.selectedSection || ctrl.selectedType\" form=ctrl.form min-length=0 search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><!-- vehicle --><div class=flex><vehicles-autocomplete disabled-item=ctrl.protocol.id form=ctrl.form min-length=0 search-text=ctrl.vehicle selected-item=ctrl.selectedAsset></vehicles-autocomplete></div></div><!-- second line --><div layout><!-- type selector --><div class=st-input-container layout=column flex><div layout><label class=\"st-label st-required\" translate=PROTOCOLS.LABEL.TYPE></label><span class=\"cursor-pointer ml4\"><md-tooltip md-direction=top md-z-index=9999 class=h-inherit style=\"margin-top: 0\"><div class=\"text-sm w-64\"><p translate=PROTOCOLS.TOOLTIP.TYPE class=\"w-64 p4 whitespace-normal\"></p></div></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></span></div><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'PROTOCOLS.PLACEHOLDER.SELECT_TYPE\' | translate}}\" md-input-name=autocomplete_type md-selected-item=ctrl.selectedType md-search-text=ctrl.type md-items=\"item in ctrl.getTypes(ctrl.type)\" md-item-text=item.attributes.name md-min-length=0 md-delay=800 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match md-no-cache=true required><md-item-template><div class=item ng-show=!ctrl.loading layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.type class=\"text-sm text-gray-700 font-bold\">{{item.attributes.name}}</span></div></div></div></div></md-item-template><md-not-found><span translate=PROTOCOLS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.type}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_type.$invalid\"><div class=st-input-validation ng-message=required translate=PROTOCOLS.VALIDATION.TYPE_REQUIRED></div></div></div><!-- date --><div class=st-input-container layout=column flex><div layout layout-align=\"start center\"><label class=st-label translate=PROTOCOLS.LABEL.DATE></label><div class=\"cursor-pointer ml4\"><md-tooltip md-direction=top md-z-index=9999 class=h-inherit style=\"margin-top: 0\"><div class=\"text-sm w-60\"><p translate=PROTOCOLS.TOOLTIP.DATE class=\"w-60 p4 whitespace-normal\"></p></div></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></div></div><input class=\"st-input-type input-type\" ng-model=ctrl.protocol.attributes.due_date type=text ng-change=ctrl.checkMap() placeholder=\"E.g. DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" autocomplete=off></div><!-- priority selector --><div class=st-input-container layout=column flex><div><label class=st-label translate=PROTOCOLS.LABEL.PRIORITY></label></div><md-select class=st-input-select name=status ng-model=ctrl.protocol.attributes.priority aria-label=\"Select priority\" placeholder=\"{{\'PROTOCOLS.PLACEHOLDER.SELECT_PRIORITY\' | translate}}\" md-no-asterisk style=\"margin-top: 6px\" flex><md-option ng-repeat=\"p in ctrl.priorities\" ng-value=p layout layout-align=\"start center\" class=\"task-priorities {{p}}\">{{ \'PROTOCOLS.ENUM.PRIORITY.\' + p.toUpperCase() | translate }}</md-option></md-select></div></div><!-- third line --><div layout layout-align=\"space-between center\"><!-- type selector --><div class=st-input-container layout=column flex=50><label class=st-label translate=PROTOCOLS.LABEL.SECTION></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'PROTOCOLS.PLACEHOLDER.SELECT_SECTION\' | translate}}\" md-input-name=autocomplete_section md-selected-item=ctrl.selectedSection md-search-text=ctrl.section md-items=\"item in ctrl.getSections(ctrl.section)\" md-item-text=item.attributes.name md-min-length=0 md-delay=800 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match md-no-cache=true><md-item-template><div class=item ng-show=!ctrl.loading layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.section class=\"text-sm text-gray-700 font-bold\">{{item.attributes.name}}</span></div></div></div></div></md-item-template><md-not-found><span translate=PROTOCOLS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.section}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_section.$invalid\"><div class=st-input-validation ng-message=required translate=PROTOCOLS.VALIDATION.SECTION_REQUIRED></div></div></div><!-- users --><users-autocomplete flex=50 clear-button=true filters=ctrl.usersOptions.filters form=ctrl.form label-text=PROVIDER min-length=0 required-item=false search-text=ctrl.user selected-item=ctrl.selectedAssignee><div class=st-input-hint translate=PROTOCOLS.HINT.PROVIDER></div></users-autocomplete></div><!-- forth line --><div><!-- place --><div class=p12 layout=column flex><div layout layout-align=\"start center\"><span class=\"text-base font-bold leading-tight text-gray-700\" translate=PROTOCOLS.LABEL.LOCATIONS></span><div class=h-7 layout layout-align=\"start center\"><button ng-disabled=ctrl.loading type=button class=\"no-button mt4\" ng-click=ctrl.addEditAddress() can-access=INTERNALS,MANAGER,OPERATOR><i class=material-symbols-outlined>add_circle</i></button></div></div><div class=\"mt8 mb8\"><md-table-container class=\"st-wrapper-table no-margin\"><table class=st-main-table md-table><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.protocol.relationships.addresses\"><td md-cell><span class=truncate>{{item.attributes.formatted_address}}</span> <span class=\"text-xs text-gray-500 truncate\">{{item.attributes.description}}</span></td><td md-cell><div can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"end start\"><span ng-if=\"!item.attributes.geometry && !item.attributes.coords\" translate-attr=\"{title: \'PROTOCOLS.HINT.NOT_COORDS\' }\"><i class=\"material-symbols-outlined text-xl text-red-500\">location_disabled</i> </span><button class=no-button type=button ng-click=\"ctrl.addEditAddress(item, $index)\" translate-attr=\"{title:\'PROTOCOLS.ACTION.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button type=button ng-click=ctrl.deleteAddress($index) translate-attr=\"{title:\'PROTOCOLS.ACTION.REMOVE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.protocol\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.protocol.relationships.addresses || ctrl.protocol.relationships.addresses.length == 0) && !(ctrl.loading && !ctrl.protocol)\"><td class=\"pt16 pb24\" colspan=2><div layout=column layout-align=\"center center\"><span class=no-content-text translate=PROTOCOLS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div></div></div><accordion class=\"mt24 pl12 pr12 pb24\" name=protocols keep-open=true><accordion-item text-title=PROTOCOLS.LABEL.PUBLIC_DESCRIPTION index=0><editor ng-if=ctrl.protocol class=mt4 custom-class-css=\"h-40 bg-white\" content=ctrl.protocol.attributes.description id=description toolbar-tools=\"[\'size\', \'align\']\"></editor></accordion-item></accordion><div ng-if=\"ctrl.protocol.attributes.due_date && ctrl.protocol.relationships.addresses && !ctrl.protocol.relationships.completion\"><div class=\"h-96 bottom-0 w-full p12 box-border\"><div id=map class=\"h-full rounded-md border border-solid border-gray-300\"></div></div></div></div><div class=\"p24 sticky bottom-0 right-0 left-0 rounded-b-md border-0 border-t border-solid border-gray-200\"><div class=st-form-actions can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"space-between center\"><div><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || !ctrl.protocol.id\" ng-if=ctrl.protocol.id><span translate=PROTOCOLS.ACTION.DELETE></span></button></div><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-disabled=ctrl.loading ui-sref=protocols-list><span translate=\"{{ctrl.protocol.id ? \'PROTOCOLS.ACTION.BACK\' : \'PROTOCOLS.ACTION.CANCEL\'}}\"></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.loading aria-label=Save><span translate=PROTOCOLS.ACTION.SAVE></span></button></div></div></div></form></div><div flex class=\"service-orders__tabs relative\"><div><div class=\"details-tab-wrapper m24\"><div class=details-tabs><button type=button ng-disabled=!ctrl.protocol.id ui-sref-active=active ui-sref=protocols-edit.documents class=details-tab-item><span translate=PROTOCOLS.ENUM.TABS.DOCUMENTS></span></button> <button type=button ng-disabled=!ctrl.protocol.id ui-sref-active=active ui-sref=protocols-edit.sharings class=details-tab-item><span translate=PROTOCOLS.ENUM.TABS.SHARINGS></span></button> <button type=button ng-disabled=!ctrl.protocol.id ui-sref-active=active ui-sref=protocols-edit.users class=details-tab-item><span translate=PROTOCOLS.ENUM.TABS.USERS></span></button></div></div><div><div ui-view></div></div></div></div></div></div></div>");
$templateCache.put("app/internal/operational/protocols/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"protocol in ctrl.items\" ng-class=\"{\'opened\': protocol.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span layout layout-align=\"space-between center\"><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::protocol.attributes.token}}</span> <span ng-if=protocol.attributes.completed class=\"st-tags tag-green xs truncate mr16\" translate=\"{{\'PROTOCOLS.ENUM.COMPLETED.\' + (protocol.attributes.completed_at != null).toString().toUpperCase()}}\"></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder layout><span class=\"task-priorities {{protocol.attributes.priority}} font-bold\"></span> <span class=ml4 translate=\"{{\'PROTOCOLS.ENUM.PRIORITY.\' + (protocol.attributes.priority.toUpperCase() || \'NO_PRIORITY\')}}\"></span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::protocol.attributes.enterprise_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::protocol.attributes.enterprise_cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::protocol.attributes.type_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::protocol.attributes.section_name}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::protocol.attributes.asset_plate}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'PROTOCOLS.ENUM.VEHICLE_TYPE.\' + (protocol.attributes.asset_type.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::protocol.attributes.due_date | date: \'HH:mm\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::protocol.attributes.due_date | date: \'dd/MM/yyyy\'}}</span> </span><button type=button class=\"st-expansion-panel-icon no-button\" ng-click=\"protocol.panelExpanded = !protocol.panelExpanded; ctrl.transformLocation(protocol)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt8 pb8\"><div flex=40 class=pr24><div><p class=\"text-gray-400 font-semibold text-xs pb4\"><span class=leading-5 translate=PROTOCOLS.LABEL.ASSIGNEE></span></p><div ng-if=protocol.attributes.assignee_name><div><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::protocol.attributes.assignee_name}}</span></div><div><span class=\"text-xs leading-tight text-gray-500 truncate\"><span>{{::protocol.attributes.assignee_username}}</span> <span>{{::protocol.attributes.assignee_phone | phoneFilter}}</span></span></div></div><div ng-if=!protocol.attributes.assignee_name><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=PROTOCOLS.HINT.NOT_FOUND></span></div></div></div><div flex><div><p class=\"text-gray-400 font-semibold text-xs pb4\"><span class=leading-5 translate=PROTOCOLS.LABEL.LOCATIONS></span></p><div layout ng-repeat=\"location in protocol.attributes.addresses track by $index\"><div><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::location.formatted_address}}</span><div ng-if=location.coords layout layout-align=\"start center\"><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-gray-500 truncate\"><span>{{location.coords[0] | number:\'6\'}}, {{location.coords[1] | number:\'6\'}}</span> </span><a href=\"\" class=ml8 ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm text-gray-500 material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div ng-if=!protocol.attributes.locations><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=PROTOCOLS.HINT.NOT_FOUND></span></div></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=PROTOCOLS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::protocol.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=PROTOCOLS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::protocol.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span ng-if=protocol.attributes.completed_at class=ml16><span class=\"text-xs leading-tight text-gray-700\" translate=PROTOCOLS.LABEL.COMPLETED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::protocol.attributes.completed_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><a can-access=INTERNALS,MANAGER,OPERATOR,READ_ONLY class=\"altnav-action outlined\" ui-sref=\"protocols-edit({id: protocol.id})\"><span class=text-gray-500 translate=PROTOCOLS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=PROTOCOLS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/operational/protocols/list/protocols.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=protocols version=v5></export-dialog-bar><search-bar model=protocols filter=true typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/operational/protocols/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/operational/protocols/panel/protocols.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar><div class=\"st-input-container no-padding relative\"><input class=\"st-input-type input-type\" name=range ng-model=ctrl.time.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'TRAJECTORIES.PLACEHOLDER.PICK_DATE\' }\" autocomplete=off></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=PROTOCOLS.TITLE.MANAGEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=PROTOCOLS.TITLE.MANAGEMENT_SUB></div></div></div><div id=manage-items class=\"h-80 m24\"></div></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/edit/service-orders.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=\"pt8 pl16 pr16 pb16\"><div class=\"bg-white rounded-md border border-solid border-gray-200\"><div layout layout-align=\"space-between start\"><div class=\"border-0 border-r border-solid border-gray-200 h-full\" flex=60><form class=\"st-form-inputs relative\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" layout=column layout-align=\"space-between stretch\" novalidate style=\"height: calc(100vh - 124px)\"><div class=\"p12 overflow-y-scroll h-full\"><!-- title --><div layout layout-align=\"space-between center\" class=p12><div><div ng-if=!ctrl.serviceOrder.id><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=SERVICE_ORDER.TITLE.TYPE_OF></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=SERVICE_ORDER.TITLE.TYPE_OF_DESC></div></div><div layout ng-if=ctrl.serviceOrder.id><div class=\"text-lg font-extrabold leading-tight text-gray-700\">{{ctrl.serviceOrder.attributes.token}}</div><button type=button class=\"altnav-action no-button\" ng-if=ctrl.loadingFile><progress class=\"float-left left-3\"></progress></button> <button type=button can-access=INTERNALS,MANAGER class=\"altnav-action no-button\" ng-click=ctrl.openGenerateOptions(ctrl.serviceOrder) ng-if=!ctrl.loadingFile><i class=material-symbols-outlined>download</i></button></div></div><div layout><div ng-if=ctrl.serviceOrder.id layout layout-align=\"start end\" can-access=INTERNALS,MANAGER,OPERATOR class=h-8><button-dropdown ng-if=!ctrl.serviceOrder.relationships.completion click-event=ctrl.toggleComplete() disabled><md-menu-item><md-button ng-click=ctrl.customDate() aria-label=\"Custom date\"><span md-menu-align-target translate=SERVICE_ORDER.LABEL.CUSTOM_DATE></span></md-button></md-menu-item></button-dropdown><div><button type=button class=\"altnav-action light\" ng-class=\"{\'done\': ctrl.serviceOrder.relationships.completion }\" ng-if=ctrl.serviceOrder.relationships.completion ng-click=ctrl.toggleComplete() ng-disabled=ctrl.loading><span translate=SERVICE_ORDER.ACTION.COMPLETED></span></button></div></div><button type=button can-access=INTERNALS,MANAGER class=\"no-button ml8\" ng-click=ctrl.settings()><i class=\"material-symbols-outlined text-gray-800 text-lg\">settings</i></button></div></div><!-- first line --><div layout layout-align=\"space-between center\"><!-- enterprise --><div flex=50><enterprises-autocomplete disabled-item=\"ctrl.selectedAssignee || ctrl.selectedAsset || ctrl.serviceOrder.id || ctrl.selectedSection || ctrl.selectedType\" form=ctrl.form min-length=0 search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><!-- vehicle --><div class=flex><vehicles-autocomplete disabled-item=ctrl.serviceOrder.id form=ctrl.form min-length=0 search-text=ctrl.vehicle selected-item=ctrl.selectedAsset></vehicles-autocomplete></div></div><!-- second line --><div layout><!-- type selector --><div class=st-input-container layout=column flex><div layout><label class=\"st-label st-required\" translate=SERVICE_ORDER.LABEL.TYPE></label><span class=\"cursor-pointer ml4\"><md-tooltip md-direction=top md-z-index=9999 class=h-inherit style=\"margin-top: 0\"><div class=\"text-sm w-64\"><p translate=SERVICE_ORDER.TOOLTIP.TYPE class=\"w-64 p4 whitespace-normal\"></p></div></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></span></div><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'SERVICE_ORDER.PLACEHOLDER.SELECT_TYPE\' | translate}}\" md-input-name=autocomplete_type md-selected-item=ctrl.selectedType md-search-text=ctrl.type md-items=\"item in ctrl.getTypes(ctrl.type)\" md-item-text=item.attributes.name md-min-length=0 md-delay=800 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match required md-no-cache=true ng-disabled=ctrl.readOnly required><md-item-template><div class=item ng-show=!ctrl.loading layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.type class=\"text-sm text-gray-700 font-bold\">{{item.attributes.name}}</span></div></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.type}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_type.$invalid\"><div class=st-input-validation ng-message=required translate=SERVICE_ORDER.VALIDATION.TYPE_REQUIRED></div></div></div><!-- date --><div class=st-input-container layout=column flex><div layout layout-align=\"start center\"><label class=st-label translate=SERVICE_ORDER.LABEL.DATE></label><div class=\"cursor-pointer ml4\"><md-tooltip md-direction=top md-z-index=9999 class=h-inherit style=\"margin-top: 0\"><div class=\"text-sm w-60\"><p translate=SERVICE_ORDER.TOOLTIP.DATE class=\"w-60 p4 whitespace-normal\"></p></div></md-tooltip><i class=\"material-symbols-outlined text-base\">help</i></div></div><input class=\"st-input-type input-type\" ng-model=ctrl.serviceOrder.attributes.due_date type=text placeholder=\"E.g. DD/MM/AAAA\" ng-readonly=ctrl.readOnly datetime=\"HH:mm dd/MM/yyyy\" autocomplete=off></div><!-- priority selector --><div class=st-input-container layout=column flex><div><label class=st-label translate=SERVICE_ORDER.LABEL.PRIORITY></label></div><md-select class=st-input-select name=status ng-model=ctrl.serviceOrder.attributes.priority aria-label=\"Select priority\" placeholder=\"{{\'SERVICE_ORDER.PLACEHOLDER.SELECT_PRIORITY\' | translate}}\" md-no-asterisk style=\"margin-top: 6px\" flex ng-disabled=ctrl.readOnly><md-option ng-repeat=\"p in ctrl.priorities\" ng-value=p layout layout-align=\"start center\" class=\"task-priorities {{p}}\">{{\'SERVICE_ORDER.ENUM.PRIORITY.\' + p.toUpperCase() | translate}}</md-option></md-select></div></div><!-- third line --><div layout layout-align=\"space-between center\"><!-- type selector --><div class=st-input-container layout=column flex=50><label class=st-label translate=SERVICE_ORDER.LABEL.SECTION></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'SERVICE_ORDER.PLACEHOLDER.SELECT_SECTION\' | translate}}\" md-input-name=autocomplete_section md-selected-item=ctrl.selectedSection md-search-text=ctrl.section md-items=\"item in ctrl.getSections(ctrl.section)\" md-item-text=item.attributes.name md-min-length=0 md-delay=800 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match md-no-cache=true ng-disabled=ctrl.readOnly><md-item-template><div class=item ng-show=!ctrl.loading layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.section class=\"text-sm text-gray-700 font-bold\">{{item.attributes.name}}</span></div></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.section}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_section.$invalid\"><div class=st-input-validation ng-message=required translate=SERVICE_ORDER.VALIDATION.SECTION_REQUIRED></div></div></div><!-- users --><users-autocomplete flex=50 clear-button=!ctrl.readOnly disabled-item=ctrl.readOnly filters=ctrl.usersOptions.filters form=ctrl.form label-text=PROVIDER min-length=0 required-item=false search-text=ctrl.user selected-item=ctrl.selectedAssignee><div class=st-input-hint translate=SERVICE_ORDER.HINT.PROVIDER></div></users-autocomplete></div><!-- forth line --><div><!-- place --><div layout class=p12><span class=\"text-base font-bold leading-tight text-gray-700\" translate=SERVICE_ORDER.LABEL.LOCATION></span><div class=h-7 layout layout-align=\"start center\"><button ng-if=\"!(ctrl.serviceOrder.relationships.addresses && ctrl.serviceOrder.relationships.addresses.length > 0)\" type=button class=no-button ng-click=ctrl.addEditAddress() can-access=INTERNALS,MANAGER><i class=material-symbols-outlined>add_circle</i></button></div></div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.serviceOrder.relationships.addresses\"><td md-cell style=\"border: 0\">{{item.attributes.formatted_address}}</td><td md-cell style=\"border: 0\"><div can-access=INTERNALS,MANAGER layout layout-align=\"end start\"><span ng-if=\"!item.attributes.geometry && !item.attributes.coords\" translate-attr=\"{title: \'SERVICE_ORDER.HINT.NOT_COORDS\' }\"><i class=\"material-symbols-outlined text-xl text-red-500\">location_disabled</i> </span><button class=no-button type=button ng-click=ctrl.addEditAddress(item) translate-attr=\"{title:\'SERVICE_ORDER.ACTION.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button type=button ng-click=ctrl.deleteAddress($index) translate-attr=\"{title:\'SERVICE_ORDER.ACTION.REMOVE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.serviceOrder\" ng-repeat=\"skeleton in [1]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.serviceOrder.relationships.addresses || ctrl.serviceOrder.relationships.addresses.length === 0) && !(ctrl.loading && !ctrl.serviceOrder)\"><td class=\"pt16 pb24\" colspan=2><div layout=column layout-align=\"center center\"><span class=no-content-text translate=SERVICE_ORDER.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div><accordion class=\"mt24 pl12 pr12 pb24\" name=service-orders keep-open=true><accordion-item text-title=SERVICE_ORDER.ACTION.PRIVATE_DESCRIPTION index=0><div layout layout-align=\"space-between end\" class=\"pt12 pb8\"><label class=\"text-xs text-gray-500 leading-4 font-semibold\" translate=SERVICE_ORDER.LABEL.PRIVATE_DESCRIPTION></label></div><editor ng-if=ctrl.serviceOrder class=mt4 custom-class-css=\"h-52 bg-white\" content=ctrl.serviceOrder.attributes.notes id=notes read-only=ctrl.readOnly toolbar-tools=\"[\'size\', \'align\']\"></editor><p class=\"text-gray-400 text-xs\" translate=SERVICE_ORDER.TITLE.PRIVATE_DESCRIPTION></p><br></accordion-item><accordion-item text-title=SERVICE_ORDER.ACTION.PUBLIC_DESCRIPTION index=1><div layout layout-align=\"space-between end\" class=\"pt4 pb8\"><label class=\"text-xs text-gray-500 leading-4 font-semibold\" translate=SERVICE_ORDER.LABEL.PUBLIC_DESCRIPTION></label><button type=button class=\"altnav-action outlined mr2\" ng-click=ctrl.openTermsTemplate() ng-disabled=ctrl.readOnly><span translate=SERVICE_ORDER.ACTION.SAVED_DESCRIPTION></span></button></div><editor ng-if=ctrl.serviceOrder class=mt4 custom-class-css=\"h-52 bg-white\" content=ctrl.serviceOrder.attributes.description id=description read-only=ctrl.readOnly toolbar-tools=\"[\'size\', \'align\']\"></editor><p class=\"text-gray-400 text-xs\" translate=SERVICE_ORDER.TITLE.PUBLIC_DESCRIPTION></p><br></accordion-item></accordion></div><div class=\"p24 sticky bottom-0 right-0 left-0 rounded-b-md border-0 border-t border-solid border-gray-300 bg-white z-10\"><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><div><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || !ctrl.serviceOrder.id\" ng-if=ctrl.serviceOrder.id><span translate=SERVICE_ORDER.ACTION.DELETE></span></button></div><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=service-orders-list><span ng-if=!ctrl.loading translate=\"{{ctrl.serviceOrder.id ? \'SERVICE_ORDER.ACTION.BACK\' : \'SERVICE_ORDER.ACTION.CANCEL\'}}\"></span> <span ng-if=ctrl.loading><progress></progress></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=\"ctrl.loading || ctrl.readOnly\" aria-label=Save><span translate=SERVICE_ORDER.ACTION.SAVE></span></button></div></div></div></form></div><div flex class=service-orders__tabs><div><div class=\"details-tab-wrapper m24\"><div class=details-tabs><button type=button ng-disabled=!ctrl.serviceOrder.id ui-sref-active=active ui-sref=service-orders-edit.custom-fields class=details-tab-item><span translate=SERVICE_ORDER.ENUM.TABS.CUSTOM_FIELDS></span></button> <button type=button ng-disabled=!ctrl.serviceOrder.id ui-sref-active=active ui-sref=service-orders-edit.documents class=details-tab-item><span translate=SERVICE_ORDER.ENUM.TABS.DOCUMENTS></span></button> <button type=button ng-disabled=!ctrl.serviceOrder.id ui-sref-active=active ui-sref=service-orders-edit.acknowledgements class=details-tab-item><span translate=SERVICE_ORDER.ENUM.TABS.ACKNOWLEDGEMENTS></span></button></div></div><div><div ui-view></div></div></div></div></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"so in ctrl.items\" ng-class=\"{\'opened\': so.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span layout layout-align=\"space-between center\"><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::so.attributes.token}}</span> <span ng-if=so.attributes.completed class=\"st-tags tag-green xs truncate mr16\" translate=\"{{\'SERVICE_ORDER.ENUM.COMPLETED.\' + (so.attributes.completed_at != null).toString().toUpperCase()}}\"></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder layout><span class=\"task-priorities {{so.attributes.priority}} font-bold\"></span> <span class=ml4 translate=\"{{\'SERVICE_ORDER.ENUM.PRIORITY.\' + (so.attributes.priority.toUpperCase() || \'NO_PRIORITY\')}}\"></span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::so.attributes.enterprise_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::so.attributes.enterprise_cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::so.attributes.type_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::so.attributes.section_name}}</span> </span><span layout=column class=pr8 flex><span><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::so.attributes.asset_plate}}</span> <span ng-if=so.attributes.asset_deleted_at class=\"text-xs leading-tight text-gray-500 truncate\" translate=SERVICE_ORDER.LABEL.ASSET_DELETED></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'SERVICE_ORDER.ENUM.VEHICLE_TYPE.\' + (so.attributes.asset_type.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::so.attributes.due_date | date: \'HH:mm\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::so.attributes.due_date | date: \'dd/MM/yyyy\'}}</span> </span><button type=button class=\"st-expansion-panel-icon no-button\" ng-click=\"so.panelExpanded = !so.panelExpanded; ctrl.transformLocation(so)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt8 pb8\"><div flex=40 class=pr24><div><p class=\"text-gray-400 font-semibold text-xs pb4\"><span class=leading-5 translate=SERVICE_ORDER.LABEL.ASSIGNEE></span></p><div ng-if=so.attributes.assignee_name><div><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::so.attributes.assignee_name}}</span></div><div><span class=\"text-xs leading-tight text-gray-500 truncate\"><span>{{::so.attributes.assignee_username}}</span> <span>{{::so.attributes.assignee_phone | phoneFilter}}</span></span></div></div><div ng-if=!so.attributes.assignee_name><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=SERVICE_ORDER.HINT.NOT_FOUND></span></div></div></div><div flex><div><p class=\"text-gray-400 font-semibold text-xs pb4\"><span class=leading-5 translate=SERVICE_ORDER.LABEL.ADDRRESS></span></p><div layout ng-repeat=\"location in so.attributes.addresses track by $index\"><div><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{::location.formatted_address}}</span><div ng-if=location.coords layout layout-align=\"start center\"><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-gray-500 truncate\"><span>{{location.coords[0] | number:\'6\'}}, {{location.coords[1] | number:\'6\'}}</span> </span><a href=\"\" class=ml8 ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm text-gray-500 material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div ng-if=!so.attributes.locations><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=SERVICE_ORDER.HINT.NOT_FOUND></span></div></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=SERVICE_ORDER.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::so.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=SERVICE_ORDER.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::so.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span ng-if=so.attributes.completed_at class=ml16><span class=\"text-xs leading-tight text-gray-700\" translate=SERVICE_ORDER.LABEL.COMPLETED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::so.attributes.completed_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div ng-if=!so.attributes.asset_deleted_at layout layout-align=\"end center\"><button type=button can-access=INTERNALS,MANAGER class=\"altnav-action outlined mr16\" ng-click=ctrl.openGenerateOptions(so) ng-disabled=so.loadingFile><i class=\"material-symbols-outlined text-base pr8\">download</i> <span class=text-gray-500 translate=SERVICE_ORDER.ACTION.GENERATE_FILE></span> <span class=ml4 ng-if=so.loadingFile><progress></progress></span></button> <a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action outlined\" ui-sref=\"service-orders-edit({id: so.id})\"><span class=text-gray-500 translate=SERVICE_ORDER.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=SERVICE_ORDER.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/operational/service-orders/list/service-orders.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=service_orders version=v5></export-dialog-bar><search-bar model=service-orders filter=true typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/operational/service-orders/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/panel/service-orders.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar><div class=\"st-input-container no-padding relative\"><input class=\"st-input-type input-type\" name=range ng-model=ctrl.time.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'TRAJECTORIES.PLACEHOLDER.PICK_DATE\' }\" autocomplete=off></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=SERVICE_ORDER.TITLE.MANAGEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=SERVICE_ORDER.TITLE.MANAGEMENT_SUB></div></div></div><div id=manage-items class=\"h-80 m24\"></div></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=SERVICE_ORDER.TITLE.SECTION_TYPE></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=SERVICE_ORDER.TITLE.SECTION_TYPE_SUB></div></div></div><div id=section-type class=\"h-80 m24\"></div></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=SERVICE_ORDER.TITLE.DAY_STATUS></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=SERVICE_ORDER.TITLE.DAY_STATUS_SUB></div></div></div><div id=day-status class=\"h-80 m24\"></div></div></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=SERVICE_ORDER.TITLE.ASSIGNEE_STATUS></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=SERVICE_ORDER.TITLE.ASSIGNEE_STATUS_SUB></div></div></div><div id=assignee-status class=\"h-80 m24\"></div></div></div></div>");
$templateCache.put("app/internal/operational/surveys/edit/surveys.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=\"pt8 pl16 pr16 pb16\"><div class=\"bg-white rounded-md border border-solid border-gray-200\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div layout layout-align=\"space-between start\"><div class=\"p12 border-0 border-r border-solid border-gray-200\" flex=60 layout=column layout-align=\"start stretch\"><!-- title --><div layout layout-align=\"space-between center\" class=p12><div><div ng-if=!ctrl.survey.id><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=SURVEYS.TITLE.TYPE_OF></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=SURVEYS.TITLE.TYPE_OF_DESC></div></div><div layout ng-if=ctrl.survey.id><div class=\"text-lg font-extrabold leading-tight text-gray-700\">{{ctrl.survey.attributes.token}}</div><button type=button can-access=INTERNALS,MANAGER class=\"altnav-action no-button\" ng-click=ctrl.generateFile(ctrl.survey) ng-disabled=ctrl.loadingFile><i class=material-symbols-outlined>download</i></button></div></div><div layout><div><button type=button class=\"no-button altnav-action mr12\" ng-class=\"{\'done\': ctrl.survey.attributes.completed_at != null}\" ng-click=\"ctrl.toggleComplete(ctrl.survey.id, ctrl.survey)\"><span ng-if=ctrl.survey.attributes.completed_at translate=SURVEYS.ACTION.COMPLETED></span> <span ng-if=!ctrl.survey.attributes.completed_at translate=SURVEYS.ACTION.COMPLETE></span></button></div><div ng-if=\"ctrl.availableSections.length > 0\"><div class=\"st-input-container no-padding\"><md-select class=\"st-input-select no-padding no-margin\" name=section ng-model=ctrl.selectedSection ng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"Select section\" md-no-asterisk flex><md-option ng-repeat=\"section in ctrl.availableSections\" ng-value=section>{{section.attributes.name}}</md-option></md-select></div></div></div></div><!-- first line --><div layout layout-align=\"space-between center\"><!-- enterprise --><div flex=40><enterprises-autocomplete disabled-item=\"ctrl.selectedAssignee || ctrl.selectedAsset || ctrl.survey.id\" form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><!-- vehicle --><div class=flex><vehicles-autocomplete disabled-item=ctrl.survey.id form=ctrl.form min-length=0 search-text=ctrl.vehicle selected-item=ctrl.selectedAsset></vehicles-autocomplete></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=SURVEYS.LABEL.TYPE></label><md-select class=\"st-input-select w-min-fit\" name=type ng-model=ctrl.selectedType ng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"Select type\" md-no-asterisk required flex style=\"margin-top: 0;margin-bottom:0\" ng-disabled=ctrl.survey.id><md-option ng-repeat=\"type in ctrl.availableTypes\" ng-value=type>{{type.attributes.name}}</md-option></md-select></div></div><!-- second line --><div layout><div class=st-input-container layout=column flex=50><label class=st-label translate=SURVEYS.LABEL.DATE></label><input class=\"st-input-type input-type\" ng-model=ctrl.survey.attributes.due_date type=text placeholder=\"E.g. DD/MM/AAAA\" datetime=\"HH:mm dd/MM/yyyy\" datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" autocomplete=off></div><div class=st-input-container layout=column flex=50><label class=st-label translate=SURVEYS.LABEL.PRIORITY></label><md-select class=st-input-select name=status ng-model=ctrl.survey.attributes.priority aria-label=\"Select priority\" md-no-asterisk flex style=margin-bottom:0><md-option ng-repeat=\"p in ctrl.priorities\" ng-value=p translate=\"{{\'SURVEYS.ENUM.PRIORITY.\' + p.toUpperCase()}}\"></md-option></md-select></div></div><!-- third line --><div layout><!-- users --><div flex=50><users-autocomplete clear-button=true filters=\"{\n                    \'enterprise.id\': { operator: \'eq\', value: ctrl.getUsersFilters() }\n                }\" form=ctrl.form label-text=PROVIDER min-length=0 required-item=false search-text=ctrl.user selected-item=ctrl.selectedAssignee><div class=st-input-hint translate=SURVEYS.HINT.PROVIDER></div></users-autocomplete></div></div><!-- forth line --><div><!-- place --><div class=st-input-container layout=column flex><label class=st-label translate=SURVEYS.LABEL.LOCATION></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'SURVEYS.PLACEHOLDER.TYPE_ADDRRESS\' | translate}}\" md-input-name=place md-selected-item=ctrl.selectedPlace md-search-text=ctrl.occurrenceAddress md-items=\"item in ctrl.getAddress(ctrl.occurrenceAddress)\" md-item-text=item.attributes.location.formatted_address md-min-length=3 md-delay=1000 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-no-cache md-require-match><md-item-template><div class=item layout layout-align=\"start center\"><div class=results-info layout=column layout-align=\"space-between stretch\"><span><span md-highlight-text=ctrl.occurrenceAddress class=st-subhead>{{item.attributes.location.formatted_address}}</span></span></div></div></md-item-template><md-not-found><span translate=SURVEYS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.occurrenceAddress}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.place.$error\"><div class=st-input-validation ng-show=ctrl.form.place.$error.required translate=SURVEYS.VALIDATION.LOCATION_REQUIRED></div><div class=st-input-validation ng-show=\"ctrl.form.place.$error[\'md-require-match\']\" translate=SURVEYS.VALIDATION.LOCATION_MATCH></div></div></div></div><!-- fifth line --><div><div class=st-input-container layout=column flex><label class=st-label translate=SURVEYS.LABEL.PRIVATE_DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=notes ng-model=ctrl.survey.attributes.notes rows=4></textarea></div><div class=st-input-container layout=column flex><label class=st-label translate=SURVEYS.LABEL.PUBLIC_DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" name=description ng-model=ctrl.survey.attributes.description rows=4></textarea></div></div><!-- sixth line --><div><div class=st-input-container layout=column flex><div layout layout-align=\"start center\"><label class=st-label translate=SURVEYS.LABEL.EXPENSES></label><button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.addExpense()><span class=material-symbols-outlined>add_circle</span></button></div><md-table-container class=\"mt2 border border-solid border-gray-300\"><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=SURVEYS.LABEL.CATEGORY></span></th><th md-column><span translate=SURVEYS.LABEL.DESCRIPTION></span></th><th md-column md-numeric><span translate=SURVEYS.LABEL.AMOUNT></span></th><th md-column md-numeric><span translate=SURVEYS.LABEL.UNIT_PRICE></span></th><th md-column md-numeric><span translate=SURVEYS.LABEL.TOTAL_PRICE></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"expense in ctrl.survey.relationships.expenses\"><td md-cell md-truncate class=md-ellipsis style=\"max-width: 75px\"><span translate>{{\'EXPENSES.ENUM.CATEGORY.\' + expense.attributes.category.toUpperCase()}}</span></td><td md-cell md-truncate class=md-ellipsis style=\"max-width: 75px\">{{expense.attributes.description}}</td><td md-cell>{{expense.attributes.amount / 100}}</td><td md-cell>{{(expense.attributes.unit_price / 100) | currency}}</td><td md-cell>{{(expense.attributes.total_price / 100) | currency}}</td><td md-cell><button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.addExpense(expense)><span class=material-symbols-outlined>edit</span></button> <button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.removeExpense(expense)><span class=material-symbols-outlined>delete</span></button></td></tr><tr ng-if=\"(!ctrl.survey.relationships.expenses || ctrl.survey.relationships.expenses.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=DISCONECTED.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container></div></div><div class=\"st-form-actions m12\" can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><div><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing || !ctrl.survey.id\" ng-if=ctrl.survey.id><span translate=SURVEYS.ACTION.DELETE></span></button></div><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=surveys-list><span translate=SURVEYS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=SURVEYS.ACTION.SAVE></span></button></div></div></div><div class=h-full layout=column layout-align=\"space-between stretch\" flex=40><!-- checklist line --><div ng-if=ctrl.survey.id><div layout=column flex><div class=p12 layout layout-align=\"start center\"><label class=\"ml12 text-gray-700 text-base font-bold\" translate=SURVEYS.LABEL.CHECKLIST></label></div><div layout=column layout-align=\"start stretch\"><div class=\"rounded-md p8 ml16\" ng-repeat=\"check in ctrl.survey.relationships.task_child\" layout layout-align=\"start center\"><button type=button class=\"no-button no-margin no-padding\" ng-click=\"ctrl.toggleComplete(check.id, check)\"><span class=material-symbols-outlined ng-class=\"{\'text-green-600\': check.attributes.completed_at}\">check_circle</span></button> <span class=\"text-sm ml4 font-normal leading-tight text-gray-800 truncate\">{{check.attributes.name}}</span></div></div><div class=\"p8 ml24\" ng-if=ctrl.newTextArea><button type=button class=\"no-button ml12 w-full align-left text-sm font-normal leading-tight text-gray-500 truncate\" translate=SURVEYS.LABEL.ADD_LIST ng-click=ctrl.addTextArea() flex></button></div><div class=ml24 ng-if=!ctrl.newTextArea><textarea class=\"pl16 outline-none resize-none w-full border-0\" placeholder=\"{{\'SURVEYS.LABEL.ADD_LIST\' | translate}}\" name=new-task ng-model=ctrl.newTask rows=1 autofocus flex ng-blur=ctrl.resetText($event) ng-keypress=ctrl.addChecklist($event)></textarea></div></div><div class=\"border-0 border-b border-solid border-gray-200\"></div></div><!-- ack line --><div ng-if=ctrl.survey.id><div class=p12 layout=column flex><div layout layout-align=\"start center\"><label class=\"m12 text-gray-700 text-base font-bold\" translate=SURVEYS.LABEL.ACKNOWLEDGEMENTS></label><button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.addAcknowledgement(ctrl.survey)><span class=material-symbols-outlined>add_circle</span></button></div><div><div class=\"rounded-md p12\" ng-repeat=\"ack in ctrl.survey.relationships.acknowledgements\" layout><div flex><div layout layout-align=\"space-between center\"><button type=button class=no-button ng-click=\"ctrl.addAcknowledgement(ctrl.survey, ack)\"><p class=\"text-sm font-bold leading-tight text-gray-900\">{{ack.relationships.acknowledger.attributes.name}}</p></button> <span><a class=\"text-sm font-normal leading-tight text-gray-500 truncate\" ng-href=\"https://api.whatsapp.com/send?phone={{ack.relationships.acknowledger.attributes.phone1}}\" target=_blank><span><img src=assets/holders/whatsapp.svg alt=whatsapp height=18></span><span class=text-gray-500>{{::ack.relationships.acknowledger.attributes.phone1 | phoneFilter}}</span></a></span></div><div layout layout-align=\"space-between center\"><div><span class=st-tags ng-class=\"{\'tag-green\': ack.attributes.acknowledged === true, \'tag-important\': ack.attributes.acknowledged === false}\" translate>{{\'SURVEYS.ENUM.ACK.\' + (ack.attributes.acknowledged.toString().toUpperCase() || \'PENDING\')}}</span></div><div><span class=\"text-sm font-normal leading-tight text-gray-500 truncate\">{{ack.attributes.acknowledged_at | date: \'HH:mm dd/MM/yyyy\':\'Z\'}}</span></div></div><div ng-if=ack.attributes.should_rate layout layout-align=\"start center\"><div ng-repeat=\"i in [1,2,3,4,5]\"><span class=\"text-gray-300 material-symbols-outlined\" ng-class=\"{\'text-yellow-500\': i <= ack.attributes.rate}\">star</span></div></div><div ng-if=!ack.attributes.should_rate layout layout-align=\"start center\"><span class=\"text-sm font-normal leading-tight text-gray-500 truncate\" translate=SURVEYS.LABEL.NO_RATE></span></div></div></div><div class=p12 ng-if=!ctrl.survey.relationships.acknowledgements.length><span class=\"text-sm font-normal leading-tight text-gray-500 truncate\" translate=SURVEYS.LABEL.NO_ACKS></span></div></div></div><div class=\"border-0 border-b border-solid border-gray-200\"></div></div><!-- doc line --><div class=p12 ng-if=ctrl.survey.id><documents identifier=ctrl.survey.id version=v5 files=ctrl.survey.relationships.documents service=surveys></documents></div></div></div></form></div></div>");
$templateCache.put("app/internal/operational/surveys/list/_list-view.html","<div class=card-content><div class=relative><panel-header data=ctrl.headers></panel-header></div><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"survey in ctrl.items\" ng-class=\"{\'opened\': survey.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><!-- <span class=\"mr8\" layout=\"column\">\n            <input type=\"checkbox\" ng-model=\"survey.selected\" aria-label=\"Selected\">\n          </span> --> <span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::survey.attributes.token}}</span> <span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::survey.attributes.name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::survey.attributes.type_name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.section_name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span><span>{{::survey.attributes.asset_plate}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'SURVEYS.ENUM.VEHICLE_TYPE.\' + (survey.attributes.asset_type.toUpperCase() || \'NO_TYPE\')}}\"></span> </span></span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.asset_model}} {{::survey.attributes.asset_brand}}</span> </span><span layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::survey.attributes.due_date | date: \'HH:mm:ss dd/MM/yyyy\':\'Z\'}}</span> <span ng-if=survey.attributes.priority class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'SURVEYS.ENUM.PRIORITY.\' + survey.attributes.priority.toUpperCase()}}\"></span> <span ng-if=!survey.attributes.priority class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>-</span> </span><button type=button class=\"st-expansion-panel-icon no-button\" ng-click=\"survey.panelExpanded = !survey.panelExpanded\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><!-- <div class=\"st-expansion-content has-selector\"> --><div layout class=\"pt16 pb16\"><div flex=50><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=SURVEYS.LABEL.CONTROL></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.ENTERPRISE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.enterprise_name}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.ENTERPRISE_DOC></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.enterprise_cnpj}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=SURVEYS.LABEL.CONTACT></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.USER_NAME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.assignee_name}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.ASSIGNEE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.assignee_username}}</span></div></div><div layout><div class=mt12 flex=50><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.PHONE></div><a ng-href=\"https://api.whatsapp.com/send?phone={{survey.attributes.assignee_phone}}\" target=_blank><div class=\"text-xs leading-tight text-blue-500 truncate\">{{::survey.attributes.assignee_phone | phoneFilter}}</div></a></div></div></div></div><div flex><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=SURVEYS.LABEL.ITEM></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.VEHICLE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.asset_plate}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.TYPE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'SURVEYS.ENUM.VEHICLE_TYPE.\' + (survey.attributes.asset_type.toUpperCase() || \'NO_TYPE\')}}\"></span></div></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.BRAND></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.asset_brand}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.MODEL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::survey.attributes.asset_model}}</span></div></div></div><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=SURVEYS.LABEL.LOCATION></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=SURVEYS.LABEL.ADDRRESS></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::survey.attributes.location.formatted_address}}</div><div layout><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{survey.attributes.location.coords[0] | number:\'6\'}},{{survey.attributes.location.coords[1] | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div></div></div></div></div><div class=st-expansion-footer><!-- <div class=\"st-expansion-footer has-selector\"> --><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=SURVEYS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::survey.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=SURVEYS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::survey.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><button type=button can-access=INTERNALS,MANAGER class=\"altnav-action light mr12\" ng-click=ctrl.generateFile(survey) ng-disabled=ctrl.loadingFile><span class=text-gray-500 translate=SURVEYS.ACTION.GENERATE_FILE></span></button> <a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"surveys-edit({id: survey.id})\"><span class=text-gray-500 translate=SURVEYS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=SURVEYS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/operational/surveys/list/surveys.list.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=surveys version=v5></export-dialog-bar><search-bar model=surveys filter=true typeable=true></search-bar><actions-bar contract=ctrl.options></actions-bar></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/operational/surveys/list/_list-view.html\'\"></div></div>");
$templateCache.put("app/internal/organization/chips/edit/chips.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\"><div layout layout-align=\"space-between center\" flex=70><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=CHIPS.TITLE.CHIP></span> <span ng-if=::ctrl.chip.attributes.from_softruck><span ng-class=\"{\'st-tags tag-purple\': ctrl.chip.attributes.from_softruck}\" translate=\"{{\'CHIPS.ENUM.OWNERSHIP.\' + ctrl.chip.attributes.from_softruck.toString().toUpperCase()}}\"></span></span><progress ng-if=ctrl.loading></progress></div><div can-access=INTERNALS,MANAGER class=mr16><md-menu data-test=chips.action.menu-actions md-position-mode=\"target-right target\" md-offset=\"0 48\"><button type=button class=\"altnav-action light no-button\" ng-click=$mdMenu.open($event) ng-disabled=\"ctrl.chip.attributes.carrier !== \'Vivo\' ||!ctrl.chip.attributes.from_softruck || ctrl.loading || ctrl.processing\"><span translate=CHIPS.LABEL.ACTIONS></span></button><md-menu-content width=2><md-menu-item ng-if=\"ctrl.chip.attributes.carrier === \'Vivo\'\"><md-button ng-click=ctrl.openDiagnostic() aria-label=Diagnostic><span translate=CHIPS.ACTION.DIAGNOSTIC></span></md-button></md-menu-item><md-menu-item ng-if=\"ctrl.chip.attributes.carrier === \'Vivo\'\"><md-button ng-click=\"ctrl.command(\'network-reset\')\" aria-label=Network-reset><span translate=CHIPS.ACTION.RESET></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex=70><div layout=column layout-align=\"space-between stretch\"><div><enterprises-autocomplete clear-button=!ctrl.chip.relationships.device disabled-item=!!ctrl.chip.relationships.device form=ctrl.form includes=ctrl.enterpriseIncludes search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CHIPS.LABEL.SERIAL></label><input class=\"st-input-type input-type\" type=text name=serial ng-model=ctrl.chip.attributes.serial autocomplete=off translate-attr=\"{ placeholder: \'CHIPS.PLACEHOLDER.TYPE_SERIAL\' }\" maxlength=20 ng-disabled=ctrl.chip.attributes.from_softruck required><div><div class=st-input-hint translate=CHIPS.HINT.SERIAL></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.serial.$error\"><div class=st-input-validation ng-show=ctrl.form.serial.$error.required translate=CHIPS.VALIDATION.SERIAL></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CHIPS.LABEL.NUMBER></label><input class=\"st-input-type input-type\" type=text name=number ng-model=ctrl.chip.attributes.number autocomplete=off translate-attr=\"{ placeholder: \'CHIPS.PLACEHOLDER.TYPE_NUMBER\' }\" ng-disabled=ctrl.chip.attributes.from_softruck maxlength=20 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.number.$invalid\"><div class=st-input-validation ng-message=required translate=CHIPS.VALIDATION.NUMBER></div></div></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CHIPS.LABEL.SERVICE_PROVIDER></label><md-autocomplete class=st-input-autocomplete data-test=chips.service_provider md-clear-button=false md-input-name=service_provider md-item-text=item.name md-items=\"item in ctrl.getServiceProvider(ctrl.chip.attributes.service_provider)\" md-min-length=0 md-no-cache md-search-text=ctrl.chip.attributes.service_provider md-search-text-change=\"ctrl.chip.attributes.service_provider = ctrl.chip.attributes.service_provider.substring(0,15)\" md-selected-item=ctrl.previewProvider ng-disabled=ctrl.chip.attributes.from_softruck placeholder=\"{{\'CHIPS.PLACEHOLDER.TYPE_SERVICE_PROVIDER\' | translate}}\" required><md-item-template><span class=\"st-caption text-gray-700\">{{item.name}}</span></md-item-template></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.service_provider.$error\"><div class=st-input-validation ng-show=ctrl.form.service_provider.$error.required translate=CHIPS.VALIDATION.SERVICE_PROVIDER></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.CARRIER></label><input class=\"st-input-type input-type\" type=text name=carrier ng-model=ctrl.chip.attributes.carrier autocomplete=off ng-disabled=ctrl.chip.attributes.from_softruck translate-attr=\"{ placeholder: \'CHIPS.PLACEHOLDER.TYPE_CARRIER\' }\"></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.APN></label><input class=\"st-input-type input-type\" type=text name=apn ng-model=ctrl.chip.attributes.apn ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.APN_USERNAME></label><input class=\"st-input-type input-type\" type=text name=apn_username ng-model=ctrl.chip.attributes.apn_username ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.APN_PASSWORD></label><input class=\"st-input-type input-type\" type=text name=apn_password ng-model=ctrl.chip.attributes.apn_password ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.PIN></label><input class=\"st-input-type input-type\" type=text name=pin ng-model=ctrl.chip.attributes.pin ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off maxlength=4></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.PUK></label><input class=\"st-input-type input-type\" type=text name=puk ng-model=ctrl.chip.attributes.puk ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off maxlength=8></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.PLAN_SIZE></label><input class=\"st-input-type input-type\" type=text name=plan_size ng-model=ctrl.chip.attributes.plan_size ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off maxlength=20></div></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.STATUS></label><input class=\"st-input-type input-type\" type=text name=status ng-model=ctrl.chip.attributes.status ng-disabled=ctrl.chip.attributes.from_softruck autocomplete=off maxlength=20></div><div class=st-input-container layout=column flex><label class=st-label translate=CHIPS.LABEL.DEVICE_ASSOCIATED></label><input class=\"st-input-type input-type\" type=text name=device ng-model=ctrl.chip.relationships.device.attributes.name disabled readonly></div></div></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button ng-if=!ctrl.chip.attributes.from_softruck data-test=chips.action.delete type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=CHIPS.ACTION.DELETE></span></button><div ng-if=ctrl.chip.attributes.from_softruck></div><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=chips-list><span translate=CHIPS.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=CHIPS.ACTION.SAVE></span></button></div></div></div></form></div></div>");
$templateCache.put("app/internal/organization/chips/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"chip in ctrl.items\" ng-class=\"{\'opened\': chip.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\"><span copy-paste value={{chip.attributes.serial}}>{{::chip.attributes.serial}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span copy-paste value={{chip.attributes.number}}>{{chip.attributes.number | phoneFilter}}</span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::chip.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.enterprise.attributes.cnpj}}</span> </span><span class=pr8 flex><div layout layout-align=\"start center\" ng-class=\"{\'opacity-40\': !chip.relationships.events}\"><div class=\"relative rounded-sm overflow-hidden h-2 w-1/5 mr8\"><div class=\"w-full h-full bg-gray-200 absolute\"></div><div class=\"h-full absolute {{chip.attributes.current_consumption_status}}\" ng-style=\"{width: {{chip.attributes.current_consumption}} + \'%\'}\"></div></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=file no-data-holder>{{((chip.relationships.events.attributes.consumption_montly_data / 1000000) || 0).toFixed(1)}}</span></div></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span copy-paste value={{chip.relationships.device.attributes.imei}}>{{::chip.relationships.device.attributes.imei}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span copy-paste value={{chip.relationships.device.attributes.name}}>{{::chip.relationships.device.attributes.name}}</span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::chip.attributes.service_provider}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.carrier}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"chip.panelExpanded = !chip.panelExpanded; ctrl.checkStatus(chip)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex=50><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=CHIPS.LABEL.DEVICE></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.IMEI></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.device.attributes.imei}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.IDENTIFIER></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.device.attributes.name}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.DEVICE_CODE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.device.attributes.code}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=CHIPS.LABEL.CONTROL></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.BATCH></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.batch}}</span></div><div class=mt12 flex ng-if=chip.attributes.from_softruck><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.OWNERSHIP></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span ng-class=\"{\'st-tags tag-purple\': chip.attributes.from_softruck}\" translate=\"{{\'CHIPS.ENUM.OWNERSHIP.\' + chip.attributes.from_softruck.toString().toUpperCase()}}\"></span></span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=CHIPS.LABEL.INTEGRATION></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.INTEGRATED></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.last_integration_source}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.INTEGRATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.last_integration_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div><div flex ng-if=chip.attributes.from_softruck><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=CHIPS.LABEL.CONNECTION></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.APN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.apn}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.APN_USERNAME></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.apn_username}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.APN_PASSWORD></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.attributes.apn_password}}</span></div></div><div flex ng-if=\"chip.attributes.from_softruck && chip.relationships.events\"><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=CHIPS.LABEL.CONNECTION></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.NETWORK_APN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.events.attributes.network_apn}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.NETWORK_OPERATOR></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.events.attributes.network_operator}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.PRESENCE_LEVEL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.events.attributes.presence_level}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.PRESENCE_EVENT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::chip.relationships.events.attributes.presence_event}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=CHIPS.LABEL.LBS></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span>{{::chip.relationships.events.attributes.lat}},{{::chip.relationships.events.attributes.lng}}</span></span></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=CHIPS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::chip.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=CHIPS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::chip.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div can-access=INTERNALS,MANAGER,READ_ONLY layout layout-align=\"end center\"><a class=\"altnav-action light\" ui-sref=\"chips-edit({id: chip.id})\"><span translate=CHIPS.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"text-sm text-gray-500 leading-tight font-bold mt24\" translate=CHIPS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading class=\"m24 p24\" layout layout-align=\"center center\" flex><progress></progress></div></div>");
$templateCache.put("app/internal/organization/chips/list/chips.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=chips version=v5></export-dialog-bar><search-bar model=chips filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/organization/chips/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/organization/chips/panel/chips.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div layout><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex=60><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=CHIPS.TITLE.MANAGEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=CHIPS.TITLE.MANAGEMENT_SUB></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedKeys aria-label=\"Select keys\" multiple ng-change=ctrl.selectManagedKeys() translate-attr=\"{ placeholder: \'CHIPS.PLACEHOLDER.SELECT_KEY\' }\" ng-disabled=ctrl.loadingManage><md-option ng-repeat=\"k in [\'created\', \'deleted\']\" ng-value=k>{{\'CHIPS.ENUM.KEYS.\' + k.toUpperCase() | translate}}</md-option></md-select></div></div><br><div id=manage-items class=\"h-80 m24\"></div></div><div class=\"border border-solid border-gray-200 rounded-md bg-white ml16\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=CHIPS.TITLE.PROVIDER></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=CHIPS.TITLE.PROVIDER_DISTRIBUTION></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedProviders aria-label=\"Select Providers\" multiple ng-change=ctrl.selectProviderKeys() translate-attr=\"{ placeholder: \'CHIPS.PLACEHOLDER.SELECT_PROVIDERS\' }\" ng-disabled=ctrl.loadingDistribution><md-option ng-repeat=\"p in ctrl.providersList\" ng-value=p>{{p}}</md-option></md-select></div></div><br><div id=chips-distribution class=\"h-80 m24\"></div></div></div></div></div>");
$templateCache.put("app/internal/organization/devices/edit/devices.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\"><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.DEVICE></span> <span ng-if=::ctrl.device.attributes.from_softruck><span ng-class=\"{\'st-tags tag-purple\': ctrl.device.attributes.from_softruck}\" translate=\"{{\'DEVICES.ENUM.OWNERSHIP.\' + ctrl.device.attributes.from_softruck.toString().toUpperCase()}}\"></span></span><progress ng-if=ctrl.loading></progress></div></div><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex=70><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><enterprises-autocomplete flex clear-button=!ctrl.checkChangableItem() disabled-item=ctrl.checkChangableItem() form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete><device-model-autocomplete flex form=ctrl.form search-text=ctrl.deviceModel selected-item=ctrl.selectedModel></device-model-autocomplete></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=DEVICES.LABEL.IMEI></label><input class=\"st-input-type input-type\" type=text name=imei ng-model=ctrl.device.attributes.imei ng-pattern=/^[0-9]{1,20}$/ autocomplete=off translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.TYPE_IMEI\' }\" maxlength=20 ng-disabled=ctrl.device.attributes.from_softruck required><div ng-if=\"ctrl.form.$submitted && ctrl.form.imei.$error\"><div class=st-input-validation ng-show=ctrl.form.imei.$error.required translate=DEVICES.VALIDATION.IMEI></div><div class=st-input-validation ng-show=ctrl.form.imei.$error.pattern translate=DEVICES.VALIDATION.IMEI_PATTERN></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=DEVICES.LABEL.IDENTIFIER></label><div class=relative flex><input autocomplete=off class=\"st-input-type input-type w-full\" maxlength=20 name=name ng-change=ctrl.checkDeviceName() ng-disabled=\"ctrl.device.attributes.from_softruck || ctrl.device.relationships.last_gps.attributes.last_connection_time\" ng-model=ctrl.device.attributes.name ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }\" required translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.TYPE_NAME\' }\" type=text ui-hide-group-sep><div ng-if=ctrl.checking class=\"absolute bottom-2 right-1 w-6 h-6 bg-white\" layout layout-align=\"center center\"><progress></progress></div></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=DEVICES.VALIDATION.NAME></div></div><div ng-if=\"ctrl.form.name.$invalid && !ctrl.checking\"><div class=st-input-validation ng-show=ctrl.form.name.$error.nameDeviceTaken translate=DEVICES.VALIDATION.USER_DEVICE_TAKEN></div></div><div ng-if=ctrl.selectedModel><div class=st-input-hint translate=\"{{ \'DEVICES.HINT.PROTOCOL.\' + ctrl.selectedModel.attributes.protocol.toUpperCase()}}\"></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=DEVICES.LABEL.CODE></label><input class=\"st-input-type input-type\" type=text name=code maxlength=20 ng-model=ctrl.device.attributes.code autocomplete=off translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.TYPE_CODE\' }\"></div></div></div><!-- chip --><div layout layout-align=\"space-between center\"><chips-autocomplete flex=50 filters=ctrl.chipsOptions.filters form=ctrl.form search-text=ctrl.chip selected-item=ctrl.selectedChip></chips-autocomplete><vehicles-autocomplete flex clear-button=true filters=ctrl.vehiclesOptions.filters form=ctrl.form required-item=false search-text=ctrl.vehicle selected-item=ctrl.selectedVehicle></vehicles-autocomplete></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing || ctrl.ownership\"><span translate=DEVICES.ACTION.DELETE></span></button><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=devices-list><span translate=DEVICES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=DEVICES.ACTION.SAVE></span></button></div></div></div></form><br><div class=\"details-tab-wrapper ml12 mr12\" flex><div class=details-tabs><button type=button ui-sref-active=active ui-sref=devices-edit.general class=details-tab-item ng-disabled=!ctrl.device><span translate=DEVICES.TABS.GENERAL></span></button> <button type=button ui-sref-active=active ui-sref=devices-edit.associations class=details-tab-item ng-disabled=!ctrl.device><span translate=DEVICES.TABS.ASSOCIATIONS></span></button> <button type=button ui-sref-active=active ui-sref=devices-edit.profile class=details-tab-item ng-disabled=\"(!ctrl.device || !ctrl.device.relationships.type)\"><span translate=DEVICES.TABS.PROFILE></span></button> <button type=button ui-sref-active=active ui-sref=devices-edit.commands class=details-tab-item ng-disabled=\"(!ctrl.device || !ctrl.device.relationships.type)\" can-access=INTERNALS,MANAGER><span translate=DEVICES.TABS.COMMANDS></span></button> <button type=button ui-sref-active=active ui-sref=devices-edit.behavior class=details-tab-item ng-disabled=\"(!ctrl.device || !ctrl.device.relationships.type)\"><span translate=DEVICES.TABS.BEHAVIOR></span></button> <button type=button ui-sref-active=active ui-sref=devices-edit.gps-table class=details-tab-item ng-disabled=\"(!ctrl.device || !ctrl.device.relationships.type)\"><span translate=DEVICES.TABS.GPS_RECORD></span></button></div></div><br><br><div ui-view></div></div></div>");
$templateCache.put("app/internal/organization/devices/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"device in ctrl.items\" ng-class=\"{\'opened\': device.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span layout class=pr8 flex><span class=\"w-6 ml4\" layout layout-align=\"start center\"><span class=indicator><report-indicator last-gps={{device.relationships.last_gps.attributes.last_gps_raw.act}} ignition={{device.relationships.last_gps.attributes.last_gps_raw.ign}}></report-indicator></span></span><span layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" layout layout-align=\"space-between center\"><span class=pr16 copy-paste value={{device.attributes.imei}}>{{::device.attributes.imei}}</span> <span class=\"st-tags tag-important xs\" ng-if=!device.attributes.active><span translate=DEVICES.LABEL.DEACTIVATED></span></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{device.relationships.type.attributes.brand_alias}} {{device.relationships.type.attributes.alias}}</span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::device.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.relationships.enterprise.attributes.cnpj}}</span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span layout layout-align=\"space-between center\"><span>{{::device.relationships.chip.attributes.serial}}</span> <span class=\"st-tags xs truncate mr16\">{{::device.relationships.chip.attributes.service_provider}}</span> </span></span><span layout layout-align=\"space-between center\" class=\"text-xs text-gray-500\"><span class=\"truncate pr8\" no-data-holder copy-paste value={{device.relationships.chip.attributes.number}}>{{::device.relationships.chip.attributes.number | phoneFilter}}</span> <span class=\"truncate mr16\">{{::device.relationships.chip.attributes.carrier}}</span> </span></span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span copy-paste value=\"{{device.relationships.vehicle.attributes.plate || device.relationships.vehicle.attributes.vin}}\">{{::device.relationships.vehicle.attributes.plate || device.relationships.vehicle.attributes.vin}} </span></span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'DEVICES.VEHICLE_TYPE.\' + (device.relationships.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span layout=column class=pr8 flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::device.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.relationships.last_gps.attributes.last_gps_time | date: \'dd/MM/yyyy\'}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"device.panelExpanded = !device.panelExpanded; ctrl.resolveAddress(device); ctrl.checkUsers(device)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=\"st-expansion-content has-selector\"><div layout class=\"pt16 pb16\"><div flex=40><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=DEVICES.LABEL.CONTROL></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.IDENTIFIER></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.attributes.name}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.CODE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.attributes.code}}</span></div><div class=mt12 flex ng-if=device.attributes.from_softruck><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.OWNERSHIP></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span ng-class=\"{\'st-tags tag-purple\': device.attributes.from_softruck}\" translate=\"{{\'DEVICES.ENUM.OWNERSHIP.\' + device.attributes.from_softruck.toString().toUpperCase()}}\"></span></span></div></div></div><div class=mt24><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VEHICLES.LABEL.USER></div><div ng-if=device.panelExpanded><user-list users=device.relationships.users_assets recordable=true initials=true horizontal=true clickable=false></user-list></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=DEVICES.LABEL.INTEGRATIONS></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.INTEGRATED></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.attributes.last_integration_source}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.INTEGRATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.attributes.last_integration_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div><div class=ml4 flex><div flex ng-if=device.relationships.last_gps.attributes.last_connection_time><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=DEVICES.LABEL.CONNECTION_DETAILS></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.LAST_CONNECTION></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::device.relationships.last_gps.attributes.last_connection_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div><div class=mt12 flex ng-if=device.relationships.last_gps.attributes.last_gps_raw><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LABEL.LAST_ADDRESS></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::device.relationships.address}}</div><div layout><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{::device.relationships.last_gps.attributes.last_gps_raw.lat | number:\'6\'}}, {{::device.relationships.last_gps.attributes.last_gps_raw.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div><div class=mt24 layout><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.PV></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=voltage>{{::device.relationships.last_gps.attributes.last_gps_raw.pv}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.BL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=percentage>{{::device.relationships.last_gps.attributes.last_gps_raw.bl | number:\'0\'}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.DIR></div><span class=\"text-xs leading-tight text-gray-500 truncate\">{{::device.relationships.last_gps.attributes.last_gps_raw.dir | direction}}</span></span></div><div class=mt24 layout><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.SC></div><span class=\"text-xs leading-tight text-gray-500 truncate\">{{::device.relationships.last_gps.attributes.last_gps_raw.sc}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.ORG></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{\'DEVICES.ORIGIN.\' + device.relationships.last_gps.attributes.last_gps_raw.org.toUpperCase()}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.IGN></div><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{\'DEVICES.POWER.\' + device.relationships.last_gps.attributes.last_gps_raw.ign.toString().toUpperCase()}}\"></span></span></div></div></div></div></div><div class=\"st-expansion-footer has-selector\"><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=DEVICES.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::device.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=DEVICES.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::device.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><span class=mr8 can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><span ng-show=device.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=DEVICES.LABEL.ACTIVE></span> <span ng-show=!device.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=DEVICES.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=device.attributes.active md-no-ink aria-label=State ng-change=ctrl.toggleState(device)></span><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"devices-edit.general({id: device.id})\"><span translate=DEVICES.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"text-sm text-gray-500 leading-tight font-bold mt24\" translate=DEVICES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/organization/devices/list/devices.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=devices version=v5></export-dialog-bar><search-bar model=devices filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/organization/devices/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/organization/devices/panel/devices.panel.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=main-content flex layout=column layout-align=\"start stretch\"><div layout><div class=\"border border-solid border-gray-200 rounded-md bg-white\" layout=column layout-align=\"space-between stretch\" flex><div class=m24><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=DEVICES.TITLE.STATUS></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=DEVICES.TITLE.CONNECTION_OVERVIEW></div></div><ul class=\"p0 m0 list-none\" layout=column layout-align=\"space-between stretch\"><li class=\"leading-loose border-0 border-solid border-gray-200 pl24 pr24\" ng-class=\"{\'border-b\': !$last}\" layout layout-align=\"start center\" ng-repeat=\"steps in ctrl.communicationStatus track by $index\" ng-click=ctrl.newInterval(steps,$index) flex><div><communication-status class=w-24 steps={{steps[0]}} index={{$index}}></communication-status></div><div class=h-10 layout layout-align=\"space-between center\" flex><div class=\"relative column-bar h-inherit\" flex=90><div class=\"w-full absolute float-left bg-gray-100 h-2 top-4 rounded-sm\"></div><div class=\"absolute float-left bg-blue-500 h-2 top-4 rounded-sm\" ng-style=\"{width: 100 * steps[ctrl.step] / ctrl.totalComunicationCars + \'%\'}\"></div></div><span class=ml8 flex=15 layout layout-align=\"end center\">{{steps[ctrl.step] / ctrl.totalComunicationCars | percentage:\'1\'}}</span></div></li></ul></div><div class=\"border border-solid border-gray-200 rounded-md bg-white ml16\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=DEVICES.TITLE.MODELS></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=DEVICES.TITLE.MODELS_DISTRIBUTION></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedModels aria-label=\"Select Models\" multiple ng-change=ctrl.selectModelKeys() translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.SELECT_MODELS\' }\"><md-option ng-repeat=\"m in ctrl.modelsList\" ng-value=m>{{m.toUpperCase() | translate}}</md-option></md-select></div></div><br><div id=devices-distribution class=\"h-80 m24\"></div></div></div><div class=mt24 layout><div class=\"border border-solid border-gray-200 rounded-md bg-white\" flex><div class=m24 layout layout-align=\"space-between center\"><div><div layout layout-align=\"space-between center\"><div class=\"inline-block text-base font-bold text-gray-800\" translate=DEVICES.TITLE.MANAGEMENT></div></div><div class=\"inline-block text-sm font-normal text-gray-400\" translate=DEVICES.TITLE.MANAGEMENT_SUB></div></div><div class=\"st-input-container no-padding\" flex=20><md-select class=st-input-select name=keys ng-model=ctrl.selectedKeys aria-label=\"Select keys\" multiple ng-change=ctrl.selectManagedKeys() translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.SELECT_KEY\' }\"><md-option ng-repeat=\"k in [\'created\', \'deleted\', \'activated\', \'deactivated\']\" ng-value=k>{{\'DEVICES.ENUM.KEYS.\' + k.toUpperCase() | translate}}</md-option></md-select></div></div><div id=manage-items class=\"h-80 m24\"></div></div></div></div></div>");
$templateCache.put("app/internal/organization/enterprises/edit/enterprises.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\" layout=column layout-align=\"start stretch\"><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate autocomplete=none flex><div ng-if=ctrl.enterprise.uuid><single-document identifier=ctrl.enterprise.uuid version=v4 file=ctrl.enterprise.relationships.document service=enterprises pattern=\"\'image/*\'\" dimensions=\"{ h:1024, w:1024 }\" size=2500></single-document></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.enterprise.attributes.name type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.FANTASY_NAME></label><input class=\"st-input-type input-type\" name=fantasy ng-model=ctrl.enterprise.attributes.fantasy_name type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.FANTASY></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.IDENTIFIER></label><input class=\"st-input-type input-type\" name=doc ng-model=ctrl.enterprise.attributes.cnpj type=text autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.doc.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.CNPJ></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.EMAIL></label><input class=\"st-input-type input-type\" name=email ng-model=ctrl.enterprise.attributes.email type=email autocomplete=off required><div ng-if=\"ctrl.form.$submitted && ctrl.form.email.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.MAIL></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.CONTACT></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.contact_name type=text autocomplete=off></div><!-- country selector --><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.COUNTRY></label><md-autocomplete class=\"st-input-autocomplete w-min-fit\" placeholder=\"{{\'ENTERPRISES.PLACEHOLDER.SELECT_COUNTRY\' | translate}}\" md-input-name=autocomplete_country md-selected-item=ctrl.selectedCountry md-selected-item-change=ctrl.getTimezones() md-search-text=ctrl.country md-items=\"item in ctrl.getContries(ctrl.country)\" md-item-text=ctrl.translateCountryName(item.attributes) md-min-length=0 md-menu-class=selectors-autocomplete md-clear-button=false md-menu-container-class=selectors-autocomplete-container md-require-match required><md-item-template><div class=item layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.country class=\"text-sm text-gray-700 font-bold\">{{ctrl.translateCountryName(item.attributes)}}</span></div></div></div></div></md-item-template><md-not-found><span translate=FORM_PARTS.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.country}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_country.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.COUNTRY></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.TIMEZONE></label><md-select class=st-input-select name=timezone ng-model=ctrl.enterprise.attributes.timezone aria-label=\"Select Timezone\" md-no-asterisk required md-require-match flex style=margin-bottom:6px ng-disabled=!ctrl.selectedCountry><md-option ng-repeat=\"tz in ctrl.timezoneList\" value={{tz}}>{{tz}}</md-option></md-select><div ng-if=\"ctrl.form.$submitted && ctrl.form.timezone.$invalid\"><div class=st-input-validation ng-message=required translate=ENTERPRISES.VALIDATION.TIMEZONE></div></div></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.phone1 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.PHONE></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.phone2 type=text autocomplete=off placeholder=\"E.g. (12) 34567-8901\" ui-br-phone-number-mask></div><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.WEBPAGE></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.webpage type=text autocomplete=off placeholder=\"E.g. www.softruck.com.br\"></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.ASSIST_CONTACT></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.assistance_emergency_tel type=text autocomplete=off placeholder=\"E.g. 0800 123 4567\"></div><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.THEIF_CONTACT></label><input class=\"st-input-type input-type\" ng-model=ctrl.enterprise.attributes.theft_emergency_tel type=text autocomplete=off placeholder=\"E.g. 0800 123 4567\"></div></div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.DESCRIPTION></label><textarea class=\"st-input-type input-textarea\" ng-model=ctrl.enterprise.attributes.description rows=4></textarea></div></div><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=ENTERPRISES.ACTION.DELETE></span></button><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=enterprises-list><span translate=ENTERPRISES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.loading aria-label=Save><span translate=ENTERPRISES.ACTION.SAVE></span></button></div></div></form><br><div class=\"details-tab-wrapper ml12 mr12\" flex><div class=details-tabs><button type=button ui-sref-active=active ui-sref=enterprises-edit.addresses class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.ADDRESSES></span></button> <button type=button ui-sref-active=active ui-sref=enterprises-edit.behavior-configs class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.BEHAVIOR_CONFIGS></span></button> <button type=button ui-sref-active=active ui-sref=enterprises-edit.notifications class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.NOTIFICATIONS></span></button> <button type=button ui-sref-active=active ui-sref=enterprises-edit.customizations class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.CUSTOMIZATION></span></button> <button ui-sref-active=active ui-sref=enterprises-edit.public-keys class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.PUBLIC_KEYS></span></button><!-- <button ui-sref-active=\"active\" ui-sref=\"enterprises-edit.webhooks\" class=\"details-tab-item\" ng-disabled=\"!ctrl.enterprise\">\n          <span translate=\"ENTERPRISES.TABS.WEBHOOKS\"></span>\n        </button> --> <button ui-sref-active=active ui-sref=enterprises-edit.templates class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.TEMPLATES></span></button> <button type=button ui-sref-active=active ui-sref=enterprises-edit.operationals class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.OPERATIONALS></span></button> <button type=button ui-sref-active=active ui-sref=enterprises-edit.custom-filters class=details-tab-item ng-disabled=!ctrl.enterprise><span translate=ENTERPRISES.TABS.CUSTOM_FILTERS></span></button><!-- <button type=\"button\" ui-sref-active=\"active\" ui-sref=\"enterprises-edit.integrations\" class=\"details-tab-item\" ng-disabled=\"!ctrl.enterprise\">\n          <span translate=\"ENTERPRISES.TABS.INTEGRATIONS\"></span>\n        </button> --></div></div><br><br><div ui-view></div></div></div>");
$templateCache.put("app/internal/organization/enterprises/list/_list-view.html","<div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"enterprise in ctrl.items\" ng-class=\"{\'opened\': enterprise.panelExpanded}\"><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><!-- <span class=\"mr8\" layout=\"column\">\n            <input type=\"checkbox\" ng-model=\"enterprise.selected\" aria-label=\"Selected\">\n          </span> --> <span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\" layout layout-align=\"space-between center\"><span class=\"mr4 truncate\">{{::enterprise.attributes.name}}</span> <span class=\"st-tags tag-important xs\" ng-if=enterprise.attributes.deactivated_at><span translate=ENTERPRISES.LABEL.DEACTIVATED></span></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.fantasy_name}}</span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder><span copy-paste value={{enterprise.attributes.cnpj}}>{{::enterprise.attributes.cnpj}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::enterprise.attributes.email}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.phone1 | phoneFilter}}</span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"enterprise.panelExpanded = !enterprise.panelExpanded; ctrl.checkStatus(enterprise)\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><!-- <div class=\"st-expansion-content has-selector\"> --><div layout class=\"pt16 pb16\"><div flex=65><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=ENTERPRISES.LABEL.FAST_CALL></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.ASSIST_CONTACT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.assistance_emergency_tel}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.THEIF_CONTACT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.theft_emergency_tel}}</span></div></div></div><div class=mt24><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=ENTERPRISES.LABEL.CONTROL></div><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.WEBPAGE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.webpage}}</span></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.TIMEZONE></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.timezone}}</span></div></div></div><div><div class=\"text-xs mb8 mt12 leading-tight font-medium text-gray-400 truncate uppercase\" translate=ENTERPRISES.LABEL.INTEGRATION></div><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.INTEGRATED></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.last_integration_source}}</span></div><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.INTEGRATED_AT></div><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::enterprise.attributes.last_integration_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div></div></div></div></div><div class=st-expansion-footer><!-- <div class=\"st-expansion-footer has-selector\"> --><div layout layout-align=\"space-between center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::enterprise.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::enterprise.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span><div layout layout-align=\"end center\"><span can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><span ng-show=enterprise.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=ENTERPRISES.LABEL.ACTIVE></span> <span ng-show=!enterprise.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=ENTERPRISES.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=enterprise.attributes.active md-no-ink aria-label=State ng-change=ctrl.toggleState(enterprise)></span><a can-access=INTERNALS,MANAGER,READ_ONLY class=\"altnav-action light\" ui-sref=\"enterprises-edit({id: enterprise.id})\"><span translate=ENTERPRISES.ACTION.DETAILS></span></a></div></div></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=64> <span class=\"st-subhead mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center center\" layout-padding layout-margin flex><progress></progress></div></div>");
$templateCache.put("app/internal/organization/enterprises/list/enterprises.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between center\"><title-bar contract=ctrl.options amount=ctrl.amount></title-bar><export-dialog-bar contract=ctrl.options model=enterprises version=v4></export-dialog-bar><search-bar model=enterprises filter=true typeable=true></search-bar></div><div class=pt-4><panel-header data=ctrl.headers></panel-header></div></div><div layout=column flex=100><div ng-include src=\"\'app/internal/organization/enterprises/list/_list-view.html\'\"></div></div></div>");
$templateCache.put("app/internal/settings/user-notification/show/user-notification.show.html","<div class=navigator-wrapper flex=100><div class=st-filter-bar layout layout-align=\"space-between center\"><title-bar></title-bar></div></div><div class=card-content><div class=\"st-form-section st-card\"><div layout=column><h3 class=m12 translate=USER_NOTIFICATION.LABEL.ENABLE_NOTIFICATION></h3><div class=m12 layout layout-align=\"start center\" ng-if=!ctrl.permissionGranted><i class=material-symbols-outlined>info</i> <span class=ml12>As suas definições de permissão de notificações no navegador estão bloqueadas. Caso queria receber as mensagens, favor habilitá-las.</span></div><div class=m12 flex layout layout-align=\"start center\"><md-switch class=st-activation-switch ng-model=ctrl.enableConfiguration ng-change=ctrl.subscribeNotification() ng-disabled=\"ctrl.processing || !ctrl.permissionGranted || ctrl.processingNotificationsPermission\" md-no-ink aria-label=\"Enable Switch\"></md-switch><div layout=column><span class=st-head translate=USER_NOTIFICATION.LABEL.NOTIFICATION_ACTIVATED></span> <span class=st-aux translate=USER_NOTIFICATION.LABEL.ACTIVATED_DESCRIPTION></span></div><progress class=ml12 ng-if=ctrl.processingNotificationsPermission></progress></div></div><div layout=column novalidate flex=60 ng-if=ctrl.enableConfiguration><div class=m12 layout layout-align=\"space-between start\"><div flex><div layout layout-align=\"start center\"><h3 translate=USER_NOTIFICATION.TITLE></h3><div class=ml12><progress ng-if=ctrl.processing></progress></div></div><div flex layout layout-align=\"start center\"><span class=st-caption flex=50 translate=USER_NOTIFICATION.LABEL.ALERT_NAME></span> <span class=\"st-caption center\" flex translate=USER_NOTIFICATION.LABEL.ACTIVATED></span></div><div ng-repeat=\"alert in ctrl.alertsConfig.data \"><div flex layout layout-align=\"space between center\" class=alert-row ng-class=\"alert.available? \'\' : \'disabled\'\"><div flex=50 layout=column class=alert><span class=\"st-subhead st-no-wrap\" translate=\"{{\'USER_NOTIFICATION.ENUM.TYPES.\' + alert.type.toUpperCase() + \'.TITLE\'}}\"></span> <span class=\"st-caption st-no-wrap\" translate=\"{{\'USER_NOTIFICATION.ENUM.TYPES.\' + alert.type.toUpperCase() + \'.DESCRIPTION\'}}\"></span><div layout><span class=recipient-item ng-repeat=\"recipient in alert.recipients\" translate=\"{{\'USER_NOTIFICATION.LABEL.\' + recipient.toUpperCase()}}\"></span></div></div><div flex layout=column layout-align=\"center center\" class=m12><md-switch class=st-activation-switch ng-model=alert.enabled name=alert-{{$index}} ng-disabled=!alert.available md-no-ink aria-label=\"Enable Switch\" ng-change=ctrl.save()></div></div></div></div></div></div></div></div>");
$templateCache.put("app/internal/management/users/tabs/acknowledgements/_acknowledgements.html","<div><div class=\"m12 mb24\"><p class=\"text-base font-bold text-gray-700\" translate=USERS.TITLE.ACK></p><p class=\"text-sm font-medium text-gray-700\" translate=USERS.TITLE.ACK_DESC></p></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=USERS.LABEL.ACK></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><div layout layout-align=\"space-between center\" class=pt8><a class=\"underline text-sm text-gray-800 cursor-pointer\" ui-sref=\"service-orders-edit.acknowledgements({id: item.relationships.task.id})\">{{item.relationships.task.attributes.token}}</a><div><span class=\"st-tags font-normal\" translate ng-class=\"{\'tag-green\': item.attributes.acknowledged === true, \'tag-important\': item.attributes.acknowledged === false}\" ng-if=item.attributes.acknowledged_at>{{\'USERS.ENUM.ACK.\' + (item.attributes.acknowledged.toString().toUpperCase())}}</span></div></div><div layout layout-align=\"space-between center\" class=\"pt8 pb8\"><div ng-if=\"!item.attributes.acknowledged_at || item.attributes.rate\" layout layout-align=\"start center\" class=h-4><div ng-repeat=\"i in [1,2,3,4,5]\"><i class=\"text-gray-200 material-symbols-outlined fill text-lg pr2\" ng-class=\"{\'text-yellow-500\': i <= item.attributes.rate}\">star</i></div></div><span ng-if=\"item.attributes.acknowledged_at && !item.attributes.rate\" class=\"text-sm text-gray-500\">-</span><div><p ng-if=item.attributes.acknowledged_at class=\"text-xs text-gray-500\"><span translate=SERVICE_ORDER.HINT.ACK_AT></span> <span>{{ ::item.attributes.acknowledged_at | timeToString }}</span></p></div></div></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=1><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=USERS.HINT.ACK_NOT_FOUND>Nehuma assinatura solicitada</span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAcknowledgements md-boundary-links md-label=\"{page: \'{{\'USERS.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'USERS.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'USERS.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div>");
$templateCache.put("app/internal/management/users/tabs/addresses/_addresses.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=USERS.TITLE.ADDRESSES></span><progress ng-if=ctrl.loading></progress><button type=button class=no-button ng-click=ctrl.add() can-access=INTERNALS,MANAGER><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=USERS.TITLE.ADDRESSES_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=USERS.LABEL.ADDRESS_TYPE></span></th><th md-column><span translate=USERS.LABEL.ADDRESS_FORMATTED></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><span translate=\"{{\'USERS.ENUM.ADDRESS_TYPE.\' + item.attributes.type }}\"></span></td><td md-cell>{{item.attributes.formatted_address}}</td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'USERS.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button type=button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'USERS.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=USERS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAddresses md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/management/users/tabs/security/_security.html","<div class=p12><div><p class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=USERS.TITLE.SECURITY></p><p class=\"text-sm font-medium leading-tight text-gray-700\" translate=USERS.TITLE.SECURITY_DESC></p></div></div><div class=\"pt12 pb24\"><form class=\"st-dialog-body form-security w-96\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" flex novalidate><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.CURRENT_PASSWORD></label><div class=relative layout=column><input autocomplete=off class=\"st-input-type input-type\" name=current_password ng-model=ctrl.security.attributes.old_password type=\"{{ctrl.typeCurrent ? \'text\' : \'password\'}}\" required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.typeCurrent = !ctrl.typeCurrent\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.typeCurrent ? \'visibility\' : \'visibility_off\'}}</i></a></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.current_password.$invalid\"><div class=st-input-validation ng-message=required translate=USERS.VALIDATION.REQUIRED></div></div></div><div class=st-input-container layout=column flex><password-meter ng-model=ctrl.security.attributes.new_password></password-meter><label class=st-label translate=USERS.LABEL.NEW_PASSWORD></label><div class=relative layout=column><input autocomplete=off class=\"st-input-type input-type\" minlength=8 name=new_password ng-model=ctrl.security.attributes.new_password type=\"{{ctrl.typeNew ? \'text\' : \'password\'}}\" required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.typeNew = !ctrl.typeNew\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.typeNew ? \'visibility\' : \'visibility_off\'}}</i></a></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.new_password.$invalid\"><div class=st-input-validation ng-show=ctrl.form.new_password.$error.minlength translate=USERS.VALIDATION.MIN_LENGHT></div><div class=st-input-validation ng-show=ctrl.form.new_password.$error.required translate=USERS.VALIDATION.REQUIRED></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=USERS.LABEL.CONFIRM_PASSWORD></label><div class=relative layout=column><input autocomplete=off class=\"st-input-type input-type\" minlength=8 name=confirm ng-keyup=\"ctrl.form.$submitted && ctrl.checkEqualPassword()\" ng-model=ctrl.confirmPassword type=\"{{ctrl.typeConfirm ? \'text\' : \'password\'}}\" required> <a class=\"absolute right-2 top-2\" href=\"\" ng-click=\"ctrl.typeConfirm = !ctrl.typeConfirm\"><i class=\"material-symbols-outlined text-gray-300\">{{ctrl.typeConfirm ? \'visibility\' : \'visibility_off\'}}</i></a></div><div ng-if=\"ctrl.form.$submitted && ctrl.form.confirm.$invalid\"><div class=st-input-validation ng-show=ctrl.form.confirm.$error.minlength translate=USERS.VALIDATION.MIN_LENGHT></div><div class=st-input-validation ng-show=ctrl.form.confirm.$error.required translate=USERS.VALIDATION.REQUIRED></div><div class=st-input-validation ng-show=ctrl.form.confirm.$error.dontMatch translate=USERS.VALIDATION.DONT_MATCH></div></div></div><div class=\"pr12 pl12 pt16 pb12\" layout layout-align=\"end start\"><button type=submit class=\"altnav-action save\" ng-disabled=ctrl.processing aria-label=Save><span ng-if=ctrl.processing layout layout-align=\"center center\" class=\"w-9 h-full\"><md-progress-circular class=md-white md-diameter=20px></md-progress-circular></span><span ng-if=!ctrl.processing translate=USERS.ACTION.SAVE></span></button></div></form></div>");
$templateCache.put("app/internal/management/users/tabs/sessions/_sessions.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=USERS.TITLE.SESSIONS></span><progress ng-if=ctrl.loading></progress></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=USERS.TITLE.SESSIONS_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=USERS.LABEL.OS></span></th><th md-column><span translate=USERS.LABEL.DEVICE></span></th><th md-column><span translate=USERS.LABEL.IP></span></th><th md-column md-order-by=created_at><span translate=USERS.LABEL.CREATED_AT></span></th><th md-column md-order-by=issued_at><span translate=USERS.LABEL.ISSUED_AT></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><span><span>{{item.attributes.user_agent_name.operation_system.name}} {{item.attributes.user_agent_name.operation_system.version}}</span> <span ng-if=item.attributes.currentSession class=\"st-tags tag-purple ml8\" translate=USERS.LABEL.CURRENT_SESSION></span></span></td><td md-cell><span><span>{{item.attributes.user_agent_name.browser.name}} {{item.attributes.user_agent_name.browser.version}}</span></span></td><td md-cell><span><span>{{item.attributes.last_seen_ip}}</span></span></td><td md-cell>{{item.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.issued_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'USERS.HINT.DELETE\'}\" aria-label=Delete ng-disabled=ctrl.loading><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3,4]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=6><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=USERS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadSessions md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/management/users/tabs/subscriptions/_subscriptions.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=USERS.TITLE.SUBSCRIPTIONS></span><progress ng-if=ctrl.loading></progress></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=USERS.TITLE.SUBSCRIPTIONS_DESC></div></div><div class=m12><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"item in ctrl.items.dat\" ng-class=\"{\'opened\': item.panelExpanded}\"><div class=st-expansion-header ng-click=\"item.panelExpanded = !item.panelExpanded\"><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder translate=\"{{\'USERS.ENUM.SUBS.\' + item.plt.toUpperCase()}}\"></span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span ng-if=\"[\'softruckadmin\', \'frontphoenix\', \'softruck\', \'stagingapp\'].includes(item.snm)\"><span translate=\"{{\'USERS.ENUM.SUBS.\' + item.snm.toUpperCase()}}\"></span> </span><span ng-if=\"![\'softruckadmin\', \'frontphoenix\', \'softruck\', \'stagingapp\'].includes(item.snm)\"><span>{{item.snm}}</span> </span></span></span><span class=mr8 layout=column flex><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span>{{::item.config.alerts_disabled.length}}</span> <span translate=USERS.LABEL.DISABLED_ALERTS></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder><span>{{::item.config.vehicles.length}}</span> <span translate=USERS.LABEL.VEHICLES_SUBSCRIPTIONS></span> </span></span><a href=\"\" class=st-expansion-panel-icon><i class=material-symbols-outlined>expand_more</i></a></span></div><div class=st-expansion-container><div class=st-expansion-content><div layout class=\"pt16 pb16\"><div flex><div ng-if=item.config.alerts_disabled.length><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.DISABLED_ALERTS></div><span class=\"text-xs leading-tight text-gray-500 truncate\" ng-repeat=\"alert in item.config.alerts_disabled\" no-data-holder><span class=mr12 translate=\"{{\'USERS.ENUM.TYPES.\' + alert.toUpperCase()}}\"></span></span></div></div></div><div class=mt24 ng-if=item.config.vehicles.length><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=USERS.LABEL.VEHICLES></div><md-table-container class=\"mt12 border border-solid border-gray-200\"><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=USERS.LABEL.PLATE></span></th><th md-column><span translate=USERS.LABEL.NOTIFICATION_TYPE></span></th><th md-column><span translate=USERS.LABEL.ACTIVATED_GEOFENCES></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"vehicle in item.config.vehicles\"><td md-cell><span class=st-label>{{::vehicle.plate}}</span></td><td md-cell><span class=recipient-item ng-repeat=\"alt in vehicle.alt\">{{::alt}}</span></td><td md-cell><span class=st-label>{{::vehicle.gids.length}}</span></td></tr></tbody></table></md-table-container></div></div></div></div></div></div><div class=st-expansion-footer><div layout layout-align=\"start center\" flex><span class=\"mt8 mb8\" layout><span class=mr8><span class=\"text-xs leading-tight text-gray-700\" translate=USERS.LABEL.CREATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::item.cat | date: \'HH:mm:ss dd/MM/yyyy\'}}</span> </span><span class=ml8><span class=\"text-xs leading-tight text-gray-700\" translate=USERS.LABEL.UPDATED_AT></span> <span class=\"text-xs leading-tight text-gray-500\">{{::item.uat | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></span></span></div></div></div></div></div></div>");
$templateCache.put("app/internal/management/users/tabs/time-restrictions/_subscriptions.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.ADDRESSES></span><progress ng-if=ctrl.loading></progress><button type=button class=no-button ng-click=ctrl.add()><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.ADDRESSES_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.ADDRESS_TYPE></span></th><th md-column><span translate=ENTERPRISES.LABEL.ADDRESS_FORMATTED></span></th><th md-column><span translate=ENTERPRISES.LABEL.CREATED_AT></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.type}}</td><td md-cell>{{item.relationships.address.attributes.formatted_address}}</td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell><button can-access=MANAGER,INTERNALS type=button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button can-access=MANAGER,INTERNALS type=button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAddresses md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/management/vehicles/components/association-config/association-config.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Association Config Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=ASSOCIATION_CONFIG.TITLE.HEADER></span> <span class=\"ml12 mt4\"><progress ng-if=ctrl.processing></progress></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><div class=\"details-tab-wrapper m16\" flex><div class=details-tabs><button type=button class=details-tab-item ng-class=\"{active: ctrl.tab === \'ios\'}\" ng-click=\"ctrl.tab = \'ios\'\"><span translate=ASSOCIATION_CONFIG.ENUM.TABS.IOS></span></button> <button type=button class=details-tab-item ng-class=\"{active: ctrl.tab === \'snooze\'}\" ng-click=\"ctrl.tab = \'snooze\'\"><span translate=ASSOCIATION_CONFIG.ENUM.TABS.ALERTS></span></button></div></div><form ng-if=\"ctrl.tab === \'ios\'\" name=ctrl.formIo ng-submit=\"ctrl.formIo.$valid && ctrl.prepareIos()\" novalidate flex><div><div class=m16><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=ASSOCIATION_CONFIG.LABEL.MAPPING></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=ASSOCIATION_CONFIG.LABEL.MAPPING_DETAILS></div></div><div class=m4 class=pt24 layout layout-align=\"space-between stretch\"><div class=mt12 flex=50><span class=\"text-sm font-bold leading-tight text-gray-700 ml16\" translate=ASSOCIATION_CONFIG.LABEL.INPUT_MAP></span><div ng-if=ctrl.inSize><div class=\"st-input-container mt12\" layout=column ng-repeat=\"i in ctrl.inputMetrics\" flex=70><label class=st-label translate=\"{{\'ASSOCIATION_CONFIG.ENUM.INPUT.\' + i}}\"></label><md-select class=st-input-select ng-model=\"ctrl.association.attributes.input_profile[\'i\'+i]\" aria-label=Inputs><md-option value=null><span translate=ASSOCIATION_CONFIG.ENUM.INPUT.NONE></span></md-option><md-option ng-repeat=\"in in ctrl.inputOptions\" ng-value=in translate=\"{{\'ASSOCIATION_CONFIG.ENUM.INPUT.\' + in.toUpperCase()}}\"></md-option></md-select></div></div><div ng-if=\"ctrl.inSize == 0\"><span class=\"mt8 mb8 text-sm text-gray-500 ml16\" translate=ASSOCIATION_CONFIG.HINT.NO_INPUT></span></div></div><div class=mt12 flex=50><span class=\"text-sm font-bold leading-tight text-gray-700 ml16\" translate=ASSOCIATION_CONFIG.LABEL.OUTPUT_MAP></span><div ng-if=ctrl.outSize><div class=\"st-input-container mt12\" layout=column ng-repeat=\"o in ctrl.outputMetrics\" flex=70><label class=st-label translate=\"{{\'ASSOCIATION_CONFIG.ENUM.OUTPUT.\' + o}}\"></label><md-select class=st-input-select ng-model=\"ctrl.association.attributes.output_profile[\'o\'+o]\" aria-label=Outputs><md-option value=null><span translate=ASSOCIATION_CONFIG.ENUM.OUTPUT.NONE></span></md-option><md-option ng-repeat=\"out in ctrl.outputOptions\" ng-value=out translate=\"{{\'ASSOCIATION_CONFIG.ENUM.OUTPUT.\' + out.toUpperCase()}}\"></md-option></md-select></div></div><div ng-if=\"ctrl.outSize == 0\"><span class=\"mt8 mb8 text-sm text-gray-500 ml16\" translate=ASSOCIATION_CONFIG.HINT.NO_OUTPUT></span></div></div></div></div><br><br><div class=m16 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action no-back\" ng-click=ctrl.close() aria-label=Clear><span translate=ASSOCIATION_CONFIG.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=save ng-disabled=ctrl.processing><span translate=ASSOCIATION_CONFIG.ACTION.SAVE></span></button></div></form><form ng-if=\"ctrl.tab === \'snooze\'\" name=ctrl.formSnooze ng-submit=\"ctrl.formSnooze.$valid && ctrl.prepareSnooze()\" novalidate flex><div><div class=m16><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=ASSOCIATION_CONFIG.LABEL.SNOOZE></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=ASSOCIATION_CONFIG.LABEL.SNOOZE_DETAILS></div></div><div class=m4><div class=mt12 flex=70><div class=\"st-input-container mt12\" layout=column><label class=st-label translate=ASSOCIATION_CONFIG.LABEL.SNOOZED_UNTIL></label><input class=\"st-input-type input-type\" ng-model=ctrl.association.attributes.snoozed_until type=text empty-input placeholder=DD/MM/AAAA datetime=dd/MM/yyyy datetime-model=\"yyyy-MM-ddTHH:mm:ss.sss\'Z\'\" autocomplete=off></div></div><div class=mt12 flex=70><div class=\"st-input-container mt12\" layout=column><label class=st-label translate=ASSOCIATION_CONFIG.LABEL.TAGS></label><md-select class=st-input-select name=keys ng-model=ctrl.association.attributes.snoozed_tags aria-label=\"Select tags\" multiple translate-attr=\"{ placeholder: \'ASSOCIATION_CONFIG.PLACEHOLDER.SELECT_TAGS\' }\" ng-disabled=!ctrl.association.attributes.snoozed_until><md-option ng-repeat=\"t in ctrl.alertTags\" ng-value=t>{{\'ALERT_TAG.\' + t.toUpperCase() + \'.TITLE\' | translate}}</md-option></md-select><div class=\"text-gray-700 text-xs\"><span translate=ASSOCIATION_CONFIG.LABEL.SNOOZE_ALL></span></div></div></div></div></div><br><br><div class=m16 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action no-back\" ng-click=ctrl.close() aria-label=Clear><span translate=ASSOCIATION_CONFIG.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=save ng-disabled=ctrl.processing><span translate=ASSOCIATION_CONFIG.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/internal/management/vehicles/components/behavior-config/behavior-config.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Behavior Config Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=BEHAVIOR_CONFIG.TITLE.HEADER></span> <span class=\"ml12 mt4\"><progress ng-if=ctrl.processing></progress></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=\"st-dialog-wrapper p16\"><div class=st-dialog-body><div><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=BEHAVIOR_CONFIG.LABEL.DETAILS></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=BEHAVIOR_CONFIG.LABEL.MANAGE_DETAILS></div></div><form class=mt24 name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div><div class=mt24 layout><!-- users --><div class=\"st-input-container no-padding\" layout=column flex><label class=st-label translate=BEHAVIOR_CONFIG.LABEL.BEHAVIOR_CONFIG></label><md-autocomplete class=st-input-autocomplete placeholder=\"{{\'BEHAVIOR_CONFIG.PLACEHOLDER.TYPE_BEHAVIOR\' | translate}}\" md-input-name=autocomplete_behavior md-selected-item=ctrl.selectedBehavior md-search-text=ctrl.behavior md-items=\"item in ctrl.getBehaviors(ctrl.behavior)\" md-item-text=item.attributes.name md-min-length=2 md-delay=800 md-menu-class=selectors-autocomplete md-menu-container-class=selectors-autocomplete-container md-require-match md-no-cache><md-item-template><div class=item layout layout-align=\"start center\" flex><div class=results-info layout=column layout-align=\"space-between stretch\" flex><div layout layout-align=\"space-between center\"><div><span md-highlight-text=ctrl.behavior class=\"text-sm leading-none text-gray-700 font-bold\">{{item.attributes.name}}</span></div></div></div></div></md-item-template><md-not-found><span translate=BEHAVIOR_CONFIG.HINT.NO_RESULTS translate-values=\"{ name: \'{{ctrl.behavior}}\' }\"></span></md-not-found></md-autocomplete><div ng-if=\"ctrl.form.$submitted && ctrl.form.autocomplete_behavior.$invalid\"><div class=st-input-validation ng-show=\"ctrl.form.place.$error[\'md-require-match\']\" translate=BEHAVIOR_CONFIG.VALIDATION.MATCH></div></div></div></div><div ng-if=ctrl.selectedBehavior class=mt24 layout><div flex=50><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BEHAVIOR_CONFIG.LABEL.BATTERY_LEVEL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=percentage no-data-holder>{{ctrl.selectedBehavior.attributes.battery_level_min}}</span></div><div class=mt24 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BEHAVIOR_CONFIG.LABEL.SPEED_MAX></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=speed no-data-holder>{{ctrl.selectedBehavior.attributes.speed_max}}</span></div><div class=mt24 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=BEHAVIOR_CONFIG.LABEL.MIN_VOL></div><span class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=voltage no-data-holder>{{ctrl.selectedBehavior.attributes.voltage_min}}</span></div></div></div></div><div class=mt24 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action no-back\" ng-click=ctrl.close() aria-label=Clear><span translate=BEHAVIOR_CONFIG.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=save ng-disabled=ctrl.processing><span translate=BEHAVIOR_CONFIG.ACTION.SAVE></span></button></div></form></div></div></md-dialog>");
$templateCache.put("app/internal/management/vehicles/components/verified-record/verified-record.dialog.html","<md-dialog flex-xs=95 flex-sm=75 flex-md=65 flex-gt-md=55 class=st-dialog aria-label=\"Advanced Filter Dialog\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=VERIFIED_RECORD.TITLE.HEADER></span> <span class=\"ml12 mt4\"><progress ng-if=ctrl.processing></progress></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=\"st-dialog-wrapper p16\"><div class=st-dialog-body><div><div class=\"text-sm font-bold leading-tight text-gray-700\" no-data-holder translate=VERIFIED_RECORD.LABEL.KEEP_RECORDS_UPDATED></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=VERIFIED_RECORD.LABEL.WHY_UPDATE></div></div></div><form class=mt24 name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.update()\" novalidate flex><div layout><div class=\"mr12 bg-gray-100 rounded-md p16\" flex=50><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.PLATE></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.plate}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.VIN></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.vin}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.BRAND></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.brand_name}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.MODEL></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.model_name}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.VERSION></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.trim_name}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.COLOR></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=\"{{\'VERIFIED_RECORD.ENUM.COLOR.\' + (ctrl.colors[ctrl.vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.TYPE></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=\"{{\'VERIFIED_RECORD.ENUM.VEHICLE_TYPE.\' + (ctrl.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.YEAR></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.vehicle.attributes.year}}</span></span></div><div class=\"ml12 bg-gray-100 rounded-md p16\" flex=50><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.PLATE></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.plate}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.VIN></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.vin}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.BRAND></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.brand}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.MODEL></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.model}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.VERSION></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.trim}}</span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.COLOR></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=\"{{\'VERIFIED_RECORD.ENUM.COLOR.\' + (ctrl.colors[ctrl.new_vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.TYPE></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder translate=\"{{\'VERIFIED_RECORD.ENUM.VEHICLE_TYPE.\' + (ctrl.new_vehicle.attributes.type.toUpperCase() || \'NO_TYPE\')}}\"></span> </span><span flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=VERIFIED_RECORD.LABEL.YEAR></div><span class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{ctrl.new_vehicle.attributes.year}}</span></span></div></div><div class=mt24 layout layout-align=\"space-between center\"><button type=button class=\"altnav-action no-back\" ng-click=ctrl.close() aria-label=Clear><span translate=VERIFIED_RECORD.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=update ng-disabled=\"ctrl.processing || ctrl.invalidData\"><span translate=VERIFIED_RECORD.ACTION.UPDATE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/internal/management/vehicles/tabs/general/_general.html","<div><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=VEHICLES.TITLE.ASSOCIATION_HISTORY></span><progress ng-if=ctrl.loading></progress><button can-access=INTERNALS,MANAGER type=button class=no-button ng-click=ctrl.openDialogDevices()><i class=material-symbols-outlined>add_circle</i></button></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=VEHICLES.LABEL.DEVICE></span></th><th md-column><span translate=VEHICLES.LABEL.ENTERPRISE></span></th><th md-column md-order-by=created_at><span translate=VEHICLES.LABEL.ASSOCIATED_AT></span></th><th md-column><span translate=VEHICLES.LABEL.DESASSOCIATED_AT></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><div><div layout layout-align=\"start center\" class=\"pt2 pb2\"><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{item.relationships.device.attributes.name}}</span> <span class=\"st-caption ml8\" ng-if=item.relationships.device.attributes.deleted_at>(<span translate=VEHICLES.LABEL.DELETED_ITEM></span>) </span><span class=\"st-tags xs ml4\" ng-if=\"item.attributes.is_main_device && !item.attributes.deleted_at\"><span translate=VEHICLES.LABEL.MAIN></span></span> <span class=\"st-tags tag-blue xs ml4 truncate max-w-20 inline-block\">{{item.relationships.behavior_config.attributes.name}}</span></div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.device.attributes.imei}}</div></div></td><td md-cell><div><div class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{item.relationships.enterprise.attributes.name}}</div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.enterprise.attributes.cnpj}}</div></div></td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.deleted_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button ng-if=\"!item.attributes.deleted_at && !item.attributes.is_main_device\" class=no-button ng-click=ctrl.setMain(item)><i class=material-symbols-outlined>star</i></button> <button type=button ng-if=!item.attributes.deleted_at class=no-button ng-click=ctrl.setBehaviorConfig(item)><i class=material-symbols-outlined>keyboard_option_key</i></button> <button type=button ng-if=!item.attributes.deleted_at class=no-button ng-click=ctrl.setAssociationConfig(item)><i class=material-symbols-outlined>settings</i></button> <button type=button ng-if=!item.attributes.deleted_at class=no-button ng-click=ctrl.removeDevice(item)><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=VEHICLES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAssociationHistory md-boundary-links md-label=\"{page: \'{{\'VEHICLES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'VEHICLES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'VEHICLES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div>");
$templateCache.put("app/internal/management/vehicles/tabs/users/_users.html","<div><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=VEHICLES.TITLE.USER_ASSOCIATION_HISTORY></span><progress ng-if=ctrl.loading></progress><button can-access=INTERNALS,MANAGER class=no-button ng-click=ctrl.openDialogUsers()><i class=material-symbols-outlined>add_circle</i></button></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=VEHICLES.LABEL.USER></span></th><th md-column><span translate=VEHICLES.LABEL.USER_CONTACT></span></th><th md-column md-order-by=created_at><span translate=VEHICLES.LABEL.ASSOCIATED_AT></span></th><th md-column><span translate=VEHICLES.LABEL.DESASSOCIATED_AT></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><div><div class=\"text-xs font-bold leading-tight text-gray-700 truncate\"><span>{{item.relationships.user.attributes.name}}</span> <span class=\"st-caption ml8\" ng-if=item.relationships.user.attributes.deleted_at>(<span translate=VEHICLES.LABEL.DELETED_ITEM></span>)</span></div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.user.attributes.username}}</div></div></td><td md-cell><div><div class=\"text-xs font-bold leading-tight text-gray-700 truncate\">{{item.relationships.user.attributes.email}}</div><div class=\"text-xs leading-tight text-gray-500 truncate\">{{item.relationships.user.attributes.phone1 | phoneFilter}}</div></div></td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.deleted_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button ng-if=!item.attributes.deleted_at class=no-button ng-click=ctrl.removeUser(item)><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=VEHICLES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAssociationHistory md-boundary-links md-label=\"{page: \'{{\'VEHICLES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'VEHICLES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'VEHICLES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div>");
$templateCache.put("app/internal/monitoring/center/components/alerts-details/alerts-details.dialog.html","<md-dialog flex-xs=95 flex-sm=70 flex-md=60 flex-gt-md=50 class=st-dialog aria-label=\"Alert details card\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><div layout=column layout-align=\"start strech\"><span class=\"inline-block text-xl font-bold text-slate-900\" translate=ALERTS_DETAILS.TITLE.HEADER></span><div class=mt4><span class=st-tags translate=\"{{\'ALERT_TAG.\' + ctrl.currentItem.attributes.tag.toUpperCase() + \'.TITLE\'}}\"></span> <span class=st-tags translate=\"{{\'ALERT_VAL.\' + ctrl.currentItem.attributes.val.toUpperCase() + \'.TITLE\'}}\"></span></div></div><span ng-if=ctrl.currentItem.attributes.flood class=\"st-tags tag-purple ms-auto self-end\" translate=ALERT_TAG.SPAM.TITLE></span> <button type=button class=\"no-button text-slate-500\" aria-label=Cancel ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div></div><div class=st-dialog-wrapper><div class=\"st-dialog-body pl12 pb12 pr12\" layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\" class=mb16><div class=\"p16 bg-slate-100 rounded\" layout=column flex><i class=material-symbols-outlined>business</i> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.ENTERPRISE></span> <span class=\"text-sm leading-tight text-gray-500 truncate\" title={{ctrl.currentItem.relationships.enterprise.attributes.name}}>{{ctrl.currentItem.relationships.enterprise.attributes.name}}</span></div><div class=\"p16 bg-slate-100 rounded ml16 mr16\" layout=column flex><i class=material-symbols-outlined>network_wifi</i> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.DEVICE></span> <span class=\"text-sm leading-tight text-gray-500\">{{ctrl.currentItem.relationships.device.attributes.imei}}</span></div><div class=\"p16 bg-slate-100 rounded\" layout=column flex><i class=material-symbols-outlined>directions_car_filled</i> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.VEHICLE></span> <span class=\"text-sm leading-tight text-gray-500\">{{ctrl.currentItem.relationships.vehicle.attributes.plate || ctrl.currentItem.relationships.vehicle.attributes.vin}}</span></div></div><div class=\"p16 bg-slate-100 rounded\" flex><div layout=column flex><i class=material-symbols-outlined>home</i> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.ADDRESS></span> <span class=\"text-sm leading-tight text-gray-500\">{{ctrl.currentItem.address || \'-\'}}</span><div layout><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{ctrl.currentItem.attributes.lat | number:\'6\'}},{{ctrl.currentItem.attributes.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div><div layout class=\"mt16 mb16\"><div class=\"text-base text-gray-700 font-semibold\" translate=ALERTS_DETAILS.LABEL.RESPONSIBLES></div><div class=\"text-base text-gray-400 font-medium ml4\">({{ctrl.currentItem.relationships.vehicle.relationships.responsibles.length}})</div></div><div class=mb12 layout=column layout-align=\"start stretch\"><user-list users=ctrl.currentItem.relationships.vehicle.relationships.responsibles initials=true clickable=false horizontal=false recordable=true></user-list></div></div><div><div class=\"inline-block text-xl font-bold text-slate-900 mt16\" translate=ALERTS_DETAILS.TITLE.ADDITIONAL_INFO></div></div><div layout layout-wrap layout-align=\"space-between start\" class=\"mt16 mb16\"><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.DATE></span> <span class=\"text-sm leading-tight text-gray-500\">{{ctrl.currentItem.attributes.actiso | date: \'HH:mm:ss dd/MM/yyyy\' || \'-\'}}</span></div><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.IGN></span> <span class=\"text-sm leading-tight text-gray-500\" translate=\"{{\'ALERTS_DETAILS.LABEL.IGNITION.\' + ctrl.currentItem.attributes.ign.toString().toUpperCase() | translate}}\"></span></div><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.HIS></span> <span class=\"text-sm leading-tight text-gray-500\" translate=\"{{\'ALERTS_DETAILS.LABEL.HISTORY.\' + ctrl.currentItem.attributes.his.toString().toUpperCase() | translate}}\"></span></div><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.SPEED></span> <span class=\"text-sm leading-tight text-gray-500\" data-metrics=speed>{{ctrl.currentItem.attributes.spd.toString() || \'-\'}}</span></div><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.BATTERY_LEVEL></span> <span class=\"text-sm leading-tight text-gray-500\" data-metrics=percentage>{{ctrl.currentItem.attributes.bl.toString() || \'-\'}}</span></div><div layout=column class=mb12 flex=33><span class=\"text-sm font-bold leading-tight text-gray-700\" translate=ALERTS_DETAILS.LABEL.POWER_VOLTAGE></span> <span class=\"text-sm leading-tight text-gray-500\" data-metrics=voltage>{{ctrl.currentItem.attributes.pv.toString() || \'-\'}}</span></div></div></div></div></md-dialog>");
$templateCache.put("app/internal/monitoring/center/components/alerts-filter/alerts-filter.html","<md-dialog flex-xs=95 flex-sm=70 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=Address><!-- dialog header --><div layout layout-align=\"space-between center\" class=st-dialog-header><span class=\"text-base text-xl font-bold text-slate-900\" translate=ALERTS_FILTER.TITLE.FILTER></span> <button type=button class=\"no-button text-slate-500\" aria-label=Cancel ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentAddress)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=\"pr8 pl8 pb8\" layout=column layout-align=\"space-between stretch\" flex><!-- filter devices --><div><div><devices-autocomplete filters=ctrl.devicesOptions.filters form=ctrl.form label-text=VEHICLE on-item-change=ctrl.handleDeviceChange(selectedItem) required-item=false search-text=ctrl.device selected-item=ctrl.selectedDevice></devices-autocomplete></div><div class=\"ml12 mr12\"><div layout layout-wrap><div class=\"st-tags mr8 mt8 pointer rounded-sm\" ng-repeat=\"item in ctrl.selectedDevices\"><span>{{item.relationships.vehicle.attributes.plate}}</span> <span><button class=\"no-button no-padding ml4\" ng-click=\"ctrl.removeItem(\'selectedDevices\', $index)\"><i class=\"material-symbols-outlined text-xs\">close</i></button></span></div></div></div></div><!-- filter enterprises --><div class=mt4><div layout><div flex><div layout layout-align=\"space-between center\"><!-- enterprise --><div flex=100><enterprises-autocomplete form=ctrl.form on-item-change=ctrl.handleEnterpriseChange(selectedItem) required-item=false search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div></div></div></div><div class=\"ml12 mr12\"><div layout layout-wrap><div class=\"st-tags mr8 mt8 pointer rounded-sm\" ng-repeat=\"item in ctrl.selectedEnterprises\"><span>{{item.attributes.name}}</span> <span><button class=\"no-button no-padding ml4\" ng-click=\"ctrl.removeItem(\'selectedEnterprises\', $index)\"><i class=\"material-symbols-outlined text-xs\">close</i></button></span></div></div></div><div layout=column class=\"pl12 pr12\"><p class=text-base>Intervalo de Tempo</p><p class=st-caption>Escolha o período dos últimos dias ou personalize a data para os Meus Alertas</p><div layout class=pt8><div layout ng-show=!ctrl.customDate><button class=\"altnav-action mr4\" ng-class=\"{\'save\': ctrl.btnSelected === day, \'light\': ctrl.btnSelected !== day}\" ng-click=ctrl.selectDate(day) type=button ng-repeat=\"day in [7,15,30,60,90]\"><span>{{day}}</span> <span class=pl4 translate=ALERTS_FILTER.ACTION.DAYS></span></button></div><div layout><button class=\"altnav-action mb4\" ng-click=\"ctrl.customDate = !ctrl.customDate\" ng-class=\"{\'save\': ctrl.btnSelected === -1, \'light\': ctrl.btnSelected !== -1, \'mr4\': ctrl.customDate}\" type=button translate=ALERTS_FILTER.ACTION.CUSTOM_DATE></button><div class=\"st-input-container no-padding\"><input autocomplete=off class=\"st-input-type input-type no-margin w-56\" date-range-picker name=range ng-model=ctrl.dateRange ng-show=ctrl.customDate options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'ALERTS_FILTER.PLACEHOLDER.CUSTOM_DATE\' }\" type=text></div></div></div></div><div><div class=\"pl8 inline-block pt24 pb16\" layout=column flex><label class=\"st-label pointer\" flex><input type=checkbox ng-model=ctrl.filterFlood> <span translate=ALERTS_FILTER.ACTION.SPAM></span></label><p class=\"st-caption ml24\" translate=ALERTS.HINT.SPAM></p></div></div></div><div class=\"st-dialog-footer mt12\" layout layout-align=\"space-between center\" flex><button type=button class=\"altnav-action cancel\" aria-label=Cancel ng-click=ctrl.clearFilters()><span translate=ALERTS_FILTER.ACTION.CLEAR></span></button> <button type=submit class=\"altnav-action save mr4\" aria-label=Save ng-click=ctrl.filter()><span translate=ALERTS_FILTER.ACTION.FILTER></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/internal/monitoring/center/components/create-events/create-events.dialog.html","<md-dialog flex-xs=95 flex-sm=50 flex-md=40 flex-gt-md=35 class=st-dialog aria-label=\"Create event card\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between start\"><span class=\"inline-block text-xl font-bold text-slate-900\" translate=CREATE_EVENTS.TITLE.HEADER></span> <button type=button class=\"no-button text-slate-500\" aria-label=Cancel ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div><div layout=column layout-align=\"start stretch\"><div class=mt8 layout layout-align=\"start center\"><div class=\"text-base font-bold leading-tight text-gray-700 truncate\">{{ctrl.vehicle.attributes.plate || ctrl.vehicle.attributes.vin}}</div><span class=\"ml4 mr4\">&middot;</span><div class=\"text-xs font-medium leading-tight text-gray-500 m4\" flex><span translate=\"{{\'ALERTS.VEHICLE_TYPE.\' + ctrl.vehicle.attributes.type.toUpperCase()}}\"></span></div></div><div class=overflow-hidden><div class=\"mt16 overflow-auto no-scrollbar\" layout layout-align=\"start center\"><span ng-repeat=\"alert in ctrl.alerts\" layout><span class=\"st-tags mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(alert[0])}\"><span translate=\"{{\'ALERT_TAG.\' + alert[0].toUpperCase() + \'.TITLE\'}}\"></span> </span><span class=\"st-tags mr12\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(alert[1])}\"><span translate=\"{{\'ALERT_VAL.\' + alert[1].toUpperCase() + \'.TITLE\'}}\"></span></span></span></div></div></div></div><div class=st-dialog-wrapper><form class=\"st-dialog-body p4\" name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.currentAddress)\" layout=column layout-align=\"space-between stretch\" novalidate><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CREATE_EVENTS.LABEL.TITLE></label><input class=\"st-input-type input-type\" type=text name=title ng-model=ctrl.event.attributes.title autocomplete=off translate-attr=\"{ placeholder: \'CREATE_EVENTS.PLACEHOLDER.TITLE\' }\" required><div ng-if=\"ctrl.form.$submitted && ctrl.form.title.$error\"><div class=st-input-validation ng-show=ctrl.form.title.$error.required translate=CREATE_EVENTS.VALIDATION.TITLE></div></div></div><div class=st-input-container layout=column flex><label class=st-label translate=CREATE_EVENTS.LABEL.DESCRIPTION></label><div class=\"mt4 mb4\"><textarea ui-tinymce=ctrl.tinymceOptions class=\"st-input-type input-textarea\" ng-model=ctrl.event.attributes.description translate-attr=\"{ placeholder: \'EVENTS.PLACEHOLDER.DESCRIPTION\' }\"></textarea></div></div><div class=p12 layout layout-align=\"end center\" flex><button type=submit class=\"altnav-action save\" aria-label=Save><span translate=ADDRESS_FORM.ACTION.SAVE></span></button></div></form></div></md-dialog>");
$templateCache.put("app/internal/monitoring/center/components/events-details/events-details.dialog.html","<md-dialog flex-xs=95 flex-sm=85 flex-md=80 flex-gt-md=75 class=st-dialog aria-label=\"Event card\"><!-- dialog header --><div class=\"st-dialog-header no-padding\"><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><!-- Status --><div class=st-input-container layout=column flex><md-select class=st-input-select name=status ng-model=ctrl.event.attributes.status aria-label=\"Select status\" md-no-asterisk ng-change=\"ctrl.edit(\'status\', ctrl.event.attributes.status)\"><md-option ng-repeat=\"s in ctrl.status\" value={{s}} translate=\"{{\'EVENTS.STATUS.\' + s.toUpperCase()}}\"></md-option></md-select></div><div class=\"p16 rounded text-slate-500\"><span translate=EVENTS.LABEL.HISTORY_CREATED translate-values=\"{ user: \'{{ctrl.event.relationships.user.attributes.name}}\', date: \'{{ctrl.event.attributes.createdAt | date: \'HH:mm:ss dd/MM/yyyy\'}}\' }\"></span></div></div><button type=button class=\"no-button text-slate-500\" aria-label=Cancel ng-click=ctrl.cancel()><i class=material-symbols-outlined>close</i></button></div></div><div class=st-dialog-wrapper><div class=st-dialog-body flex><div layout layout-align=\"space-between start\"><div class=mr24 flex=60><!-- Event --><div layout=column layout-align=\"start stretch\"><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-head.html\'\"></div><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_alert-panel.html\'\"></div></div><!-- Comments section --><div layout=column layout-align=\"start stretch\"><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-interaction.html\'\"></div></div></div><div flex><div ng-include src=\"\'app/internal/monitoring/events/edit/partials/_event-short-data.html\'\"></div></div></div></div></div></md-dialog>");
$templateCache.put("app/internal/monitoring/center/components/filterable-tags/_filterable-tags.html","<div class=m16><div id=filter-tags-wrapper class=overflow-hidden horizontal-slide><div class=\"overflow-auto no-scrollbar z-50\" layout><button class=\"no-button st-tags mr8 pointer\" ng-repeat=\"tag in ctrl.filterableTags\" ng-class=\"{\'selected\': ctrl.selectedTags.includes(tag)}\" ng-disabled=ctrl.pendingRequest ng-click=ctrl.filterByTag(tag)><span class=truncate translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></button></div></div></div>");
$templateCache.put("app/internal/monitoring/events/components/comments/comments.html","<div><!-- textarea --><div><div class=st-input-container ng-if=!ctrl.editable layout=column flex><textarea class=\"st-input-type input-textarea\" ng-model=ctrl.comment rows=1 ng-focus=\"ctrl.editable = !ctrl.editable\" translate-attr=\"{ placeholder: \'COMMENT.PLACEHOLDER.NEW_COMMENT\' }\"></textarea></div><div class=p12 ng-if=ctrl.editable><textarea ui-tinymce=ctrl.tinymceOptions class=\"st-input-type input-textarea\" ng-model=ctrl.comment></textarea><div class=pt12 layout layout-align=\"end center\"><button class=\"altnav-action cancel mr8\" ng-click=ctrl.cancel()><span translate=COMMENT.ACTION.CANCEL></span></button> <button class=\"altnav-action save\" ng-click=ctrl.add()><span translate=COMMENT.ACTION.SAVE></span></button></div></div></div><!-- comments --><div class=mb24 layout=column layout-align=\"start stretch\"><div class=\"pl12 pr12\" layout=column layout-align=\"start stretch\"><div class=mb12 layout=column layout-align=\"start stretch\" ng-repeat=\"comment in ctrl.comments\" flex><div><div><div class=\"image-holder no-border mr8\"><object class=\"image-holder-fallback user-holder\" type=image/gif></object></div></div><div layout=column><div layout layout-align=\"space-between center\"><div layout=column><div class=\"text-sm font-medium text-slate-900\">{{comment.relationships.user.attributes.name}}</div><div class=\"text-sm text-slate-500 truncate\">{{comment.relationships.user.attributes.email}}</div></div><div class=\"text-sm font-normal leading-3 text-gray-400\">{{comment.attributes.createdAt | date: \'dd/MM/yyyy\'}}</div></div><div class=\"text-sm text-slate-500 pt8\" ng-bind-html=\"comment.attributes.text | trust\"></div><div layout=column flex><div layout><!-- <button class=\"text-xs text-slate-700 underline no-button no-padding mr16\" ng-click=\"ctrl.edit(comment)\" ng-disabled=\"ctrl.$scope.user != comment.relationships.user.id\">\n                  <span translate=\"COMMENT.ACTION.EDIT\"></span>\n                </button> --> <button class=\"text-xs text-slate-700 underline no-button no-padding\" ng-click=\"ctrl.delete(comment, $index)\"><span translate=COMMENT.ACTION.DELETE></span></button></div></div></div></div></div><div ng-if=\"ctrl.comments.length === 0\" layout layout-align=\"start center\"><span class=\"material-symbols-outlined text-slate-500\">chat</span> <span class=\"text-sm text-slate-500 truncate ml8\" translate=COMMENT.HINT.NO_RECORDS></span></div></div></div></div>");
$templateCache.put("app/internal/monitoring/events/edit/partials/_alert-panel.html","<!-- Alerts --><div layout class=\"pl12 pr12\"><div class=\"text-base text-gray-700 font-semibold\" translate=EVENTS.TITLE.ALERTS></div><div class=\"text-base text-gray-400 font-medium ml4\">({{ctrl.event.relationships.alerts.length}})</div></div><div class=\"st-expansion-panel alert-panel\"><div class=st-expansion-panel-item ng-repeat=\"alert in ctrl.event.relationships.alerts\" ng-class=\"{\'opened\': alert.panelExpanded, \'area-important\': [\'batery\',\'emergency\',\'power\'].includes(alert.attributes.tag)}\"><div class=st-expansion-header layout layout-align=\"start center\"><div class=\"alert-padding-area st-caption\" ng-class=\"{\'alert-padding-important\': [\'batery\',\'emergency\',\'power\'].includes(alert.attributes.tag)}\">{{alert.attributes.act * 1000 | humanizeDate}}</div><div class=alert-tag-area flex><span class=\"st-tags mr4\" ng-class=\"{\'tag-important\': [\'batery\',\'emergency\',\'power\'].includes(alert.attributes.tag)}\"><span translate=\"{{\'ALERT_TAG.\' + alert.attributes.tag.toUpperCase() + \'.TITLE\'}}\"></span> </span><span class=st-tags ng-class=\"{\'tag-important\': [\'batery\',\'emergency\',\'power\'].includes(alert.attributes.tag)}\"><span translate=\"{{\'ALERT_VAL.\' + alert.attributes.val.toUpperCase() + \'.TITLE\'}}\"></span></span></div><div class=alert-icon-area><button ng-if=\"ctrl.event.relationships.alerts.length > 1\" class=\"no-button hover-display float-left mr12 text-slate-500\" ng-click=\"ctrl.removeAlertFromEvent(alert, $index)\"><i class=material-symbols-outlined>delete</i></button> <button class=\"no-button st-expansion-panel-icon text-slate-500\" ng-click=\"alert.panelExpanded = !alert.panelExpanded; ctrl.resolveAddress(alert); ctrl.filterByDeviceName(alert)\"><i class=material-symbols-outlined>arrow_drop_down</i></button></div></div><div class=st-expansion-container><div class=st-expansion-content><div class=\"mt16 mb16\" layout layout-wrap><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.DEVICE></div><span class=\"text-sm leading-tight text-gray-500 truncate\">{{alert.specs.imei}}<span class=\"ml4 text-xs\">({{alert.specs.brand_alias}})</span></span></div><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.SPEED></div><span class=\"text-sm leading-tight text-gray-500\" data-metrics=speed>{{alert.attributes.spd.toString() || \'-\'}}</span></div><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.IGNITION></div><span class=\"text-sm leading-tight text-gray-500\" translate=\"{{\'EVENTS.IGNITION.\' + alert.attributes.ign.toString().toUpperCase()}}\"></span></div><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.BATTERY_LEVEL></div><span class=\"text-sm leading-tight text-gray-500\" data-metrics=percentage>{{alert.attributes.bl.toString() || \'-\'}}</span></div><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.SATELLITES></div><span class=\"text-sm leading-tight text-gray-500\">{{alert.attributes.sc.toString() || \'-\'}}</span></div><div class=mb16 layout=column flex=33><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.DATE></div><span class=\"text-sm leading-tight text-gray-500\">{{alert.attributes.act * 1000 | date:\'HH:mm dd/MM/yyyy\'}}</span></div></div><div class=\"mt16 mb16\" layout=column><div class=\"text-sm font-bold leading-tight text-gray-700\" translate=EVENTS.LABEL.ADDRESS></div><span class=\"text-sm leading-tight text-gray-500\">{{alert.address}}</span> <span class=\"text-sm leading-tight text-gray-500\">{{alert.attributes.lat}}, {{alert.attributes.lng}}</span></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/events/edit/partials/_event-head.html","<!-- Title --><div class=\"inline-block text-2xl font-bold text-slate-900 pl12 pr12\">{{ctrl.event.attributes.title}}</div><!-- Description --><div ng-if=!ctrl.loading><textarea-editor text=true value=ctrl.event.attributes.description key=description on-save=ctrl.edit(key,val)></textarea-editor></div>");
$templateCache.put("app/internal/monitoring/events/edit/partials/_event-interaction.html","<!-- tabs --><div class=\"details-tab-wrapper m12\" layout><div class=details-tabs><button class=\"no-button details-tab-item\" ng-click=\"ctrl.section = \'comments\'\" ng-class=\"{active: ctrl.section === \'comments\'}\"><span translate=EVENTS.ACTION.COMMENTS></span></button></div><div class=details-tabs><button class=\"no-button details-tab-item\" ng-click=\"ctrl.section = \'history\'\" ng-class=\"{active: ctrl.section === \'history\'}\"><span translate=EVENTS.ACTION.HISTORY></span></button></div></div><div ng-if=!ctrl.loading><div ng-if=\"ctrl.section === \'comments\'\"><comments version=V4 model=EVENTS identifier={{ctrl.event.id}} items=ctrl.event.relationships.comments user={{ctrl.currentUser.id}}></comments></div><div ng-if=\"ctrl.section === \'history\'\"><div class=pt16><div class=m12 layout=column layout-align=\"start strech\"><div class=\"p16 rounded\"><span translate=EVENTS.LABEL.HISTORY_CREATED translate-values=\"{ user: \'{{ctrl.event.relationships.user.attributes.name}}\', date: \'{{ctrl.event.attributes.createdAt | date: \'HH:mm:ss dd/MM/yyyy\'}}\' }\"></span></div><div class=\"p16 rounded\" layout ng-repeat=\"history in ctrl.event.relationships.statusHistory\"><span translate=EVENTS.LABEL.HISTORY_EDITED translate-values=\"{ status: \'{{ctrl.$translate.instant(\'EVENTS.STATUS.\' + history.attributes.status.toUpperCase())}}\', user: \'{{history.relationships.user.attributes.name}}\', date: \'{{history.attributes.updatedAt | date: \'HH:mm:ss dd/MM/yyyy\'}}\' }\"></span></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/events/edit/partials/_event-short-data.html","<!-- Vehicle Data --><div layout=column layout-align=\"start stretch\"><!-- short data --><div><div class=\"text-base text-gray-700 font-semibold pt12 pb12\" translate=EVENTS.TITLE.VEHICLE_DATA></div><div layout layout-align=\"space-between center\"><div class=\"st-card bg-grey no-shadow mr8 short-pad\" layout flex><span class=\"image-holder mr8\"><object class=\"image-holder-fallback vehicle-holder\" ng-attr-data={{ctrl.event.relationships.vehicle.attributes.picture.address}} type=image/gif></object></span><div layout=column layout-align=\"space-between stretch\" flex><div class=\"text-base text-gray-700 font-semibold truncate leading-3\">{{ctrl.event.relationships.vehicle.attributes.plate || ctrl.event.relationships.vehicle.attributes.vin}}</div><div class=\"text-sm text-slate-500 truncate leading-3\" translate=\"{{\'EVENTS.ENUM.VEHICLE_TYPE.\' + (ctrl.event.relationships.vehicle.attributes.type.toUpperCase() || \'NO_TYPE\')}}\"></div></div></div><div class=\"st-card bg-grey no-shadow ml8 short-pad\" layout flex><span class=\"image-holder mr8\"><object class=\"image-holder-fallback company-holder\" ng-attr-data={{ctrl.event.relationships.enterprise.attributes.picture.address}} type=image/gif></object></span><div layout=column layout-align=\"space-between stretch\" flex><div class=\"text-base text-gray-700 font-semibold truncate leading-3\">{{ctrl.event.relationships.enterprise.attributes.name}}</div><div class=\"text-sm text-slate-500 truncate leading-3\">{{ctrl.event.relationships.enterprise.attributes.cnpj}}</div></div></div></div></div><!-- responsibles --><div><div layout class=\"pt12 pb12\"><div class=\"text-base text-gray-700 font-semibold\" translate=EVENTS.TITLE.RESPONSIBLES></div><div class=\"text-base text-gray-400 font-medium ml4\">({{ctrl.event.relationships.vehicle.relationships.responsibles.length}})</div></div><div class=mb12 layout=column layout-align=\"start stretch\"><user-list users=ctrl.event.relationships.vehicle.relationships.responsibles initials=true horizontal=false recordable=true></user-list></div></div><!-- map  --><div><div class=\"text-base text-gray-700 font-semibold pt12 pb12\" translate=EVENTS.TITLE.MAP></div><div><div id=static-map class=\"events-details rounded\"><img class=static-image src={{ctrl.staticMapImage}} alt=\"Static map\"></div></div></div></div>");
$templateCache.put("app/internal/monitoring/history/components/segments/_segments.html","<div id=list-header layout layout-align=\"space-between center\"><div><label ng-if=\"ctrl.trajectory.attributes.segs && ctrl.trajectory.attributes.segs.length > 0\" class=st-nav-label><input name=selectall ng-model=ctrl.selectedAll indeterminate type=checkbox ng-change=ctrl.selectAllSegs() ng-disabled=\"ctrl.openSlider || !ctrl.trajectoriesData\"> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.ACTION.SELECT_ALL></span></label></div><div layout layout-align=\"space-between center\"><button type=button class=\"icon-action no-button\" can-access=INTERNALS,MANAGER ng-class=\"{spin: ctrl.recomputing}\" translate-attr=\"{title: \'TRAJECTORIES.HINT.REPLAY\'}\" ng-disabled=\"ctrl.recomputing || !ctrl.trajectoriesData\" ng-click=ctrl.recompute()><i class=material-symbols-outlined>settings_backup_restore</i></button> <button class=\"icon-action no-button\" ng-click=\"ctrl.openSlider = !ctrl.openSlider\" translate-attr=\"{title: \'TRAJECTORIES.HINT.SLIDER\'}\" ng-disabled=\"ctrl.selectedAll || !ctrl.trajectoriesData\"><i class=material-symbols-outlined>flip</i></button><md-menu md-position-mode=\"right target\" md-offset=\"0 56\"><button class=\"icon-action no-button\" ng-click=$mdMenu.open($event) ng-disabled=!ctrl.trajectoriesData><i class=material-symbols-outlined>more_vert</i></button><md-menu-content class=st-nav-menu-list width=3><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'path\', \'path-stroke\', \'arrows\'], \'segment\')\" ng-model=ctrl.filterOptions.segment md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.SEGMENTS></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'marks\'], \'mark\'); ctrl.switchFilter([\'selected-marks\'], \'selectedMarks\')\" ng-model=ctrl.filterOptions.mark md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.MARK></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'stops\'], \'stop\')\" ng-model=ctrl.filterOptions.stop md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.STOPS></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'alarms\'], \'alarm\')\" ng-model=ctrl.filterOptions.alarm md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.ALERTS></span></label></div></md-menu-content></md-menu></div></div><div id=slider-filter ng-class=\"{\'opened\': ctrl.openSlider}\"><div class=relative><div class=mov-profile><div id=trajectory-mov></div></div></div><rzslider class=st-time-slider rz-slider-model=ctrl.reportTimeSlider.min rz-slider-high=ctrl.reportTimeSlider.max rz-slider-options=ctrl.reportTimeSlider.options flex></rzslider></div><div><div id=segments-list class=trajectories ng-class=\"{\'slider-opened\': ctrl.openSlider}\"><div class=list-item ng-repeat=\"seg in ctrl.trajectory.attributes.segs | orderBy: \'sta.act\'\" layout=column layout-align=\"start stretch\"><div layout layout-align=\"space-between center\"><label class=item-pick><input ng-model=seg.checked ng-value=true name=pick-{{$index}} type=checkbox ng-change=ctrl.focusOnPath() ng-disabled=!ctrl.trajectoriesData> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRAJECTORIES.LABEL.ROUTES translate-values=\"{ item: {{$index + 1}}, total: {{ctrl.trajectory.attributes.sgCnt}} }\"></span></label></div><div class=overflow-hidden><span ng-repeat=\"tag in seg.alTags\"><span class=\"st-tags truncate mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div><div ng-if=\"seg.iDev.length > 0\" class=\"mt2 mb2\"><div class=\"text-sm text-gray-500\" translate=TRAJECTORIES.LABEL.IDENTIFICATIONS></div><span ng-repeat=\"card in seg.iDev | unique: \'code\'\"><span class=\"st-tags tag-purple truncate mr4\">{{card.code}}</span></span></div><div class=item-details layout=column layout-align=\"space-between stretch\"><div layout class=\"details-marker starts-at\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.sta.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.START></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.sta.adr}}</div><div layout><span id=\"{{ \'location-departure\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.sta.lat | number:\'6\'}},{{seg.sta.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-departure\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div layout class=\"details-marker ends-at mt8\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.end.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.END></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.end.adr}}</div><div layout><span id=\"{{ \'location-arrival\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.end.lat | number:\'6\'}},{{seg.end.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-arrival\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div></div></div><div ng-if=\"ctrl.trajectory.attributes.sgCnt === 0\" class=no-activity><br><br><div class=\"no-activity-text pl8 pr8\" translate=TRAJECTORIES.HINT.NO_ACTIVITY></div></div></div></div>");
$templateCache.put("app/internal/monitoring/tracking/components/commands/_commands.html","<section ng-controller=\"TrackingCommandsController as ctrl\"><div layout=column layout-align=\"start stretch\" flex><span ng-if=ctrl.loading class=m24><progress></progress></span><div ng-repeat=\"(k,v) in ctrl.availableCommands\" class=m16><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=\"{{\'DEVICES.CATEGORY.\' +  k.toUpperCase()}}\"></div></div><button type=button class=no-button ng-click=\"ctrl.expand[k] = !ctrl.expand[k]\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand[k]}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand[k]}\"><div ng-repeat=\"item in v\" layout layout-align=\"space-between center\" class=\"border border-solid border-gray-200 rounded-md mt8 mb8 p12\"><div layout=column layout-align=\"start stretch\"><span class=\"text-base leading-tight text-gray-700 truncate\" translate=\"{{\'DEVICES.COMMANDS.\' +  item.name.toUpperCase()}}\"></span><div class=st-input-container ng-repeat=\"field in item.fields\"><input class=\"st-input-type input-type\" type={{field.type}} ng-model=field.value min=0 placeholder=\"{{\'DEVICES.PARAMS.\' + field.name.toUpperCase() | translate}}\" required></div></div><button type=button class=no-button ng-click=ctrl.prepareCommand(item)><span class=\"material-symbols-outlined text-base leading-tight text-gray-700\">arrow_forward</span></button></div></div></div></div></section>");
$templateCache.put("app/internal/monitoring/tracking/components/general/_general.html","<div ng-if=ctrl.selectedItem><!-- status --><div class=\"m16 mt24\"><div class=mt24 ng-if=!ctrl.selectedItem.attributes.active><div class=\"p16 bg-orange-50 rounded-md\" layout><div flex=15><div class=\"h-10 w-10 bg-orange-100 rounded-full\" layout layout-align=\"center center\"><img src=assets/holders/device.svg alt=\"No results\" height=70%></div></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.ACTIVE></div><div><span class=\"text-xs leading-tight text-gray-500\" translate=TRACKING.LABEL.ACTIVE_STATUS></span> <button can-access=INTERNALS,MANAGER type=button class=\"no-button text-xs font-bold text-blue-700\" href=\"\" ng-click=ctrl.activateDevice()><span translate=TRACKING.ACTION.ACTIVATE></span></button></div></div></div></div></div><!-- enterprise data --><div class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.ENTERPRISE></div><span ng-show=!ctrl.expand.enterprise class=\"h-4 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.enterprise.attributes.name}}</span></div><button type=button class=no-button ng-click=\"ctrl.expand.enterprise = !ctrl.expand.enterprise\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.enterprise}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.enterprise}\"><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.ENTERPRISE_NAME></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.enterprise.attributes.name}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.EMAIL></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.enterprise.attributes.email}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.ASSIST_CONTACT></div><div class=\"bg-gray-100 rounded-md p8 mr16 mt8\" layout><i class=\"text-base material-symbols-outlined mr12\">call</i> <span class=\"text-base text-gray-500\" no-data-holder>{{ctrl.selectedItem.relationships.enterprise.attributes.assistance_emergency_tel}}</span></div></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.THEIF_CONTACT></div><div class=\"bg-gray-100 rounded-md p8 mt8\" layout><i class=\"text-base material-symbols-outlined mr12\">call</i> <span class=\"text-base text-gray-500\" no-data-holder>{{ctrl.selectedItem.relationships.enterprise.attributes.theft_emergency_tel}}</span></div></div></div></div></div><!-- vehicle data --><div class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div><span class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.VEHICLE></span></div><span ng-show=\"!ctrl.expand.vehicle && ctrl.selectedItem.relationships.vehicle\" class=\"h-4 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.plate}}</span> <button can-access=INTERNALS,MANAGER type=button ng-if=!ctrl.selectedItem.relationships.vehicle class=no-button ng-click=ctrl.openDialogVehicles()><span class=\"text-xs leading-tight text-blue-500 truncate\">(Adicionar veículo)</span></button></div><button type=button class=no-button ng-click=\"ctrl.expand.vehicle = !ctrl.expand.vehicle\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.vehicle}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.vehicle}\"><div ng-if=ctrl.selectedItem.relationships.vehicle><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.PLATE></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.plate}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.VEHICLE_TYPE></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'TRACKING.ENUM.VEHICLE_TYPE.\' + (ctrl.selectedItem.relationships.vehicle.attributes.type_name.toUpperCase() || \'NO_TYPE\')}}\"></p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.BRAND></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.brand_name || \'-\'}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.MODEL></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.model_name || \'-\'}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.VIN></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.vin || \'-\'}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.COLOR></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'TRACKING.ENUM.COLOR.\' + (ctrl.colors[ctrl.selectedItem.relationships.vehicle.attributes.color].name.toUpperCase() || \'NO_COLOR\')}}\"></p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.VEHICLE_CODE></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.code || \'-\'}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.BATCH></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.vehicle.attributes.batch || \'-\'}}</p></div></div></div><div ng-if=!ctrl.selectedItem.relationships.vehicle><p class=\"mt16 mb16 text-xs leading-tight text-gray-500 truncate\" translate=TRACKING.HINT.NO_VEHICLE_ASSOCIATED></p></div></div></div><!-- user data --><div class=\"m16 mt24\" can-access=INTERNALS,MANAGER,READ_ONLY><div layout layout-align=\"space-between center\"><div layout><div><span class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.USERS></span></div><!-- <button ng-if=\"ctrl.selectedItem.relationships.vehicles\" class=\"no-button\" ng-click=\"ctrl.openDialogUsers()\">\n          <span class=\"text-xs leading-tight text-blue-500 truncate\">(Adicionar usuário)</span>\n        </button> --></div><button type=button class=no-button ng-click=\"ctrl.expand.users = !ctrl.expand.users\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.users}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.users}\"><div flex><div ng-if=ctrl.selectedItem.relationships.vehicle><user-asset-permissions asset=ctrl.selectedItem.relationships.vehicle></user-asset-permissions></div></div></div></div><!-- device data --><div can-access=INTERNALS,MANAGER,READ_ONLY class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.DEVICE></div><span ng-show=!ctrl.expand.device class=\"h-4 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8\" no-data-holder>{{ctrl.selectedItem.attributes.name}}</span></div><button type=button class=no-button ng-click=\"ctrl.expand.device = !ctrl.expand.device\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.device}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.device}\"><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.IDENTIFIER></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.attributes.name}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.IMEI></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.attributes.imei}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.BRAND_MODEL></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.type.attributes.brand_alias}} {{ctrl.selectedItem.relationships.type.attributes.alias}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.CODE></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.attributes.code}}</p></div></div></div></div><!-- chip data --><div can-access=INTERNALS,MANAGER,READ_ONLY class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.CHIP></div><span ng-show=!ctrl.expand.chip class=\"h-4 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8\" no-data-holder>{{ctrl.selectedItem.relationships.chip.attributes.number | phoneFilter}}</span></div><button type=button class=no-button ng-click=\"ctrl.expand.chip = !ctrl.expand.chip\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.chip}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.chip}\"><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.ICCID></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.chip.attributes.serial}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.CHIP_NUMBER></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.chip.attributes.number | phoneFilter}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.PROVIDER></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.chip.attributes.service_provider || \'-\'}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.CARRIER></div><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.chip.attributes.carrier || \'-\'}}</p></div></div></div></div><!-- location data --><div class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.LAST_COMMUNICATION></div><span ng-if=ctrl.selectedItem.relationships.last_gps ng-show=!ctrl.expand.live class=\"h-4 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.act * 1000 | date:\'HH:mm dd/MM/yyyy\'}}</span></div><button type=button class=no-button ng-click=\"ctrl.expand.live = !ctrl.expand.live\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.live}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.live}\"><div layout><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.TIME></div><p ng-if=ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.act * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</p><p ng-if=!ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>-</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.TIME_CON></div><p ng-if=ctrl.selectedItem.relationships.device_last_con class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.device_last_con * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</p><p ng-if=!ctrl.selectedItem.relationships.device_last_con class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>-</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.POWER_VOLTAGE></div><p ng-if=ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=voltage no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.pv}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.BATTERY_LEVEL></div><p ng-if=ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=percentage no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.bl}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.SPEED></div><p ng-if=ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=speed no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.spd}}</p></div><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.DIRECTION></div><p ng-if=ctrl.selectedItem.relationships.last_gps class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.dir | direction}}</p></div></div><div layout class=mt16><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.IGNITION></div><div ng-if=ctrl.selectedItem.relationships.last_gps class=mt2><p class=\"pt4 pl4 mr8 float-left box-border\"><report-indicator last-gps={{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.act}} ignition={{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.ign}}></report-indicator></p><p class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'TRACKING.ENUM.IGNITION.\' + ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.ign.toString().toUpperCase()}}\"></p></div></div></div></div></div><!-- location data --><div class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div layout><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.LOCATION></div><span ng-show=!ctrl.expand.location class=\"h-4 w-52 text-xs font-semibold text-gray-700 bg-gray-100 rounded-sm truncate pl8 pr8 ml8\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.address}}</span></div><button type=button class=no-button ng-click=\"ctrl.expand.location = !ctrl.expand.location\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.location}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.location}\"><div flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRACKING.LABEL.LAST_ADDRESS></div><div class=\"text-xs leading-tight text-gray-500 mt8\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.address}}</div><div layout><span id=\"{{ \'location-\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat | number:\'6\'}}, {{ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div><div layout layout-align=\"space-between center\" class=\"mt16 mb16\"><span ng-repeat=\"(k,v) in ctrl.hyperlinkOptions\"><a ng-href={{v.link}} target=_blank class=\"w-10 h-10 p4 rounded-full bg-gray-200\" layout=column layout-align=\"center center\"><img class=text-gray-400 ng-src=assets/icons/{{k}}.svg alt={{v.initial}}><md-tooltip>{{v.name}}</md-tooltip></a></span></div><div class=\"text-xs font-bold leading-tight text-gray-700 mt12\" translate=TRACKING.LABEL.TRACK_SPEED></div><p class=\"text-xs leading-tight text-gray-500 truncate\" data-metrics=speed no-data-holder>{{ctrl.selectedItem.relationships.last_gps.attributes.maxspeed}}</p></div></div></div><!-- street view --><div class=\"m16 mt24\"><div layout layout-align=\"space-between center\"><div class=\"text-xs leading-tight text-gray-500 truncate uppercase\" translate=TRACKING.LABEL.STREET_VIEW></div><button type=button class=no-button ng-click=\"ctrl.expand.street = !ctrl.expand.street\"><i class=\"material-symbols-outlined text-gray-500\" ng-class=\"{\'rotate-90\': ctrl.expand.street}\">chevron_right</i></button></div><div class=tracking-panel ng-class=\"{opened: ctrl.expand.street}\"><div class=street-info layout=column layout-align=\"start start\"><div ng-if=ctrl.selectedItem.relationships.last_gps><street-view lat=ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.lat lng=ctrl.selectedItem.relationships.last_gps.attributes.last_gps_raw.lng width=388 height=200 loading=lazy></street-view></div></div></div></div></div>");
$templateCache.put("app/internal/monitoring/tracking/components/trajectories/_trajectories.html","<div ng-controller=\"TrackingHistoryController as ctrl\"><div layout=column layout-align=\"start stretch\"><div class=\"ml16 mr16\" layout=column layout-align=\"space-between stretch\" flex><div layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_DISTANCE></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=distance>{{ctrl.trajectory.attributes.vDis / 1000 | number:1}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.dur | duration}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.TOTAL_STOP_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.stDur | duration}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SPEED_MAX></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{ctrl.trajectory.attributes.spMax | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.SPEED_AVG></div><span class=\"text-sm font-bold leading-tight text-gray-700\" data-metrics=speed>{{ctrl.trajectory.attributes.spAvg | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.STOPS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.stCnt}}</span></div></div><div class=mt8 layout><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.ALERTS></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.alCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500\" translate=TRAJECTORIES.LABEL.MESSAGES></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.gpsCnt | number:0}}</span></div><div flex><div class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRAJECTORIES.LABEL.TOTAL_RISK_TIME></div><span class=\"text-sm font-bold leading-tight text-gray-700\">{{ctrl.trajectory.attributes.raDur | duration}}</span></div></div></div></div><div><div id=list-header layout layout-align=\"space-between center\"><label class=st-nav-label><input name=selectall ng-model=ctrl.selectedAll type=checkbox ng-change=ctrl.selectAllSegs() ng-disabled=\"ctrl.openSlider || !ctrl.trajectoriesData\"> <span class=\"text-sm font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.ACTION.SELECT_ALL></span></label><div layout layout-align=\"space-between center\"><button type=button class=\"icon-action no-button\" ng-click=\"ctrl.openSlider = !ctrl.openSlider\" translate-attr=\"{title: \'TRAJECTORIES.HINT.SLIDER\'}\" ng-disabled=\"ctrl.selectedAll || !ctrl.trajectoriesData\"><i class=material-symbols-outlined>flip</i></button><md-menu md-position-mode=\"right target\" md-offset=\"0 56\"><button type=button class=\"icon-action no-button\" ng-click=$mdMenu.open($event) ng-disabled=!ctrl.trajectoriesData><i class=material-symbols-outlined>more_vert</i></button><md-menu-content class=st-nav-menu-list width=3><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'path\', \'path-stroke\', \'arrows\'], \'segment\')\" ng-model=ctrl.filterOptions.segment md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.SEGMENTS></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'marks\'], \'mark\')\" ng-model=ctrl.filterOptions.mark md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.MARK></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'stops\'], \'stop\')\" ng-model=ctrl.filterOptions.stop md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.STOPS></span></label></div><div class=st-nav-menu-header><label class=st-nav-label><input name=alerts type=checkbox ng-click=\"ctrl.switchFilter([\'alarms\'], \'alarm\')\" ng-model=ctrl.filterOptions.alarm md-prevent-menu-close ng-disabled=!ctrl.trajectoriesData> <span translate=TRAJECTORIES.LABEL.ALERTS></span></label></div></md-menu-content></md-menu></div></div><div id=slider-filter ng-class=\"{\'opened\': ctrl.openSlider}\"><div class=relative><div class=mov-profile><div id=trajectory-mov></div></div></div><rzslider class=st-time-slider rz-slider-model=ctrl.reportTimeSlider.min rz-slider-high=ctrl.reportTimeSlider.max rz-slider-options=ctrl.reportTimeSlider.options flex></rzslider></div><div><div id=segments-list ng-class=\"{\'slider-opened\': ctrl.openSlider}\" class=tracking><div class=m24><progress ng-if=ctrl.loading></progress></div><div class=list-item ng-repeat=\"seg in ctrl.trajectory.attributes.segs | orderBy: \'sta.act\'\" layout=column layout-align=\"start stretch\"><div layout layout-align=\"space-between center\"><label class=item-pick><input ng-model=seg.checked ng-value=true name=pick-{{$index}} type=checkbox ng-change=ctrl.focusOnPath(seg) ng-disabled=!ctrl.trajectoriesData> <span class=\"text-xs leading-tight text-gray-500 truncate\" translate=TRAJECTORIES.LABEL.ROUTES translate-values=\"{ item: {{$index + 1}}, total: {{ctrl.trajectory.attributes.sgCnt}} }\"></span></label></div><div class=overflow-hidden><span ng-repeat=\"tag in seg.alTags\"><span class=\"st-tags truncate mr4\" ng-class=\"{\'tag-important\': [\'battery\',\'communication\',\'emergency\',\'power\'].includes(tag)}\"><span translate=\"{{\'ALERT_TAG.\' + tag.toUpperCase() + \'.TITLE\'}}\"></span></span></span></div><div class=item-details layout=column layout-align=\"space-between stretch\"><div layout class=\"details-marker starts-at\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.sta.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.START></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.sta.adr}}</div><div layout><span id=\"{{ \'location-departure\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.sta.lat | number:\'6\'}},{{seg.sta.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-departure\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div><div layout class=\"details-marker ends-at mt8\"><div class=\"text-xs leading-tight text-gray-500 truncate\"><b>{{seg.end.act | date:\'HH:mm\'}}</b></div><div class=ml8 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=TRAJECTORIES.LABEL.END></div><div class=\"text-xs leading-tight text-gray-500\" no-data-holder>{{::seg.end.adr}}</div><div layout><span id=\"{{ \'location-arrival\' + $index }}\" class=\"text-xs leading-tight text-blue-500 font-bold truncate\" no-data-holder>{{seg.end.lat | number:\'6\'}},{{seg.end.lng | number:\'6\'}}</span> <a href=\"\" class=\"copy-btn ml8\" ngclipboard data-clipboard-target=\"{{ \'#location-arrival\' + $index }}\"><i class=\"text-sm material-symbols-outlined\" alt=\"Copy to clipboard\">content_copy</i></a></div></div></div></div></div><div ng-if=\"ctrl.trajectory.attributes.sgCnt === 0\" class=no-activity><br><br><div class=\"no-activity-text pl8 pr8\" translate=TRAJECTORIES.HINT.NO_ACTIVITY></div></div></div></div></div></div>");
$templateCache.put("app/internal/operational/catalogs/items/edit/items.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\"><div layout layout-align=\"space-between center\" flex=70><div class=\"m12 mb24\" layout><span ng-if=\"!ctrl.item.id && !ctrl.loading\" class=\"text-lg font-extrabold leading-tight text-gray-700\" translate=CATALOGS.TITLE.ITEMS_NEW></span> <span ng-if=\"ctrl.item.id && !ctrl.loading\" class=\"text-lg font-extrabold leading-tight text-gray-700\" translate=CATALOGS.TITLE.ITEMS_EDIT></span><progress ng-if=ctrl.loading></progress></div></div><div layout flex=70><custom-fields-form ng-if=!ctrl.loading enterprise=ctrl.selectedEnterprise item=ctrl.item read-only=!!ctrl.item.id><div layout layout-align=\"space-between center\" class=w-full><div><button type=button ng-if=ctrl.item.id class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=CATALOGS.ACTION.DELETE></span></button></div><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=catalogs.item-list><span ng-if=!ctrl.loading translate=\"{{ctrl.item.id ? \'CATALOGS.ACTION.BACK\' : \'CATALOGS.ACTION.CANCEL\'}}\"></span> <span ng-if=ctrl.loading><progress></progress></span></button></div></custom-fields-form></div><br><div ng-if=ctrl.item.id flex=70><div><div><div class=\"m12 mb24\" layout=column><p class=\"st-title-small mr12\" translate=CATALOGS.TITLE.ASSIGNED_TEMPLATES></p><p class=\"st-caption pt4\" translate=CATALOGS.HINT.GROUP_LINKED></p><progress ng-if=ctrl.loading></progress></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span class=\"text-sm text-gray-500 font-normal\" translate=CATALOGS.LABEL.TEMPLATE></span></th><th md-column><span class=\"text-sm text-gray-500 font-normal\" translate=CATALOGS.LABEL.CATEGORY></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"template in ctrl.item.relationships.templates\"><td md-cell><span class=\"text-sm text-gray-800\">{{template.attributes.name}}</span></td><td md-cell><span class=\"text-sm text-gray-800\">{{template.attributes.category}}</span></td></tr><tr ng-if=\"(!ctrl.item.relationships.templates || ctrl.item.relationships.templates.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=2><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=CATALOGS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div></div></div></div></div>");
$templateCache.put("app/internal/operational/catalogs/items/list/items.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between end\"><div layout=column layout-align=\"start start\"><title-bar></title-bar><div layout layout-align=\"space-between center\" class=\"details-tab-wrapper mt-5 mr-4\"><div layout class=details-tabs><button ui-sref-active=active ui-sref=catalogs.item-list class=details-tab-item><span class=tab-text translate=CATALOGS.ENUM.TABS.ITEMS></span></button> <button ui-sref-active=active ui-sref=catalogs.template-list class=details-tab-item><span class=tab-text translate=CATALOGS.ENUM.TABS.TEMPLATES></span></button></div></div></div><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-3><panel-header data=ctrl.headers></panel-header></div></div><div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"item in ctrl.items\"><div class=st-expansion-header><div layout layout-align=\"space-between start\" flex><div flex><span layout=column class=pr8><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::item.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::item.attributes.cluster}}</span></span></div><div flex><span layout=column class=pr8><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::item.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::item.relationships.enterprise.attributes.cnpj}}</span></span></div><div layout=column flex><span layout=column class=pr8><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder translate=\"{{\'CATALOGS.ENUM.FIELD_FORMAT.\' + item.attributes.field_format.toUpperCase()}}\"></span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder translate=\"{{\'CATALOGS.ENUM.REQUIRED.\' + item.attributes.is_required.toString().toUpperCase()}}\"></span></span></div><div flex><span layout=column class=\"pr24 mr24\"><span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{ctrl.categoryNames(item.relationships.templates)}}</span></span></div><button type=button class=\"no-button st-expansion-panel-icon mt4\" ui-sref=\"catalogs.item-edit({id: item.id})\"><i class=material-symbols-outlined>chevron_right</i></button></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"text-sm text-gray-500 leading-tight font-bold mt24\" translate=CATALOGS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading class=\"m24 p24\" layout layout-align=\"center center\" flex><progress></progress></div></div></div>");
$templateCache.put("app/internal/operational/catalogs/templates/edit/templates.edit.html","<div class=navigator-wrapper><title-bar></title-bar></div><div class=card-content><div class=\"st-form-section st-card\"><div layout layout-align=\"space-between center\" flex=70><div class=\"m8 mb12\" layout><span ng-if=\"!ctrl.template.id && !ctrl.loading\" class=\"text-lg font-extrabold leading-tight text-gray-700\" translate=CATALOGS.TITLE.TEMPLATE_NEW></span> <span ng-if=\"ctrl.template.id && !ctrl.loading\" class=\"text-lg font-extrabold leading-tight text-gray-700\" translate=CATALOGS.TITLE.TEMPLATE_EDIT></span><progress ng-if=ctrl.loading></progress></div></div><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex=70><div layout=column layout-align=\"space-between stretch\"><div layout layout-align=\"space-between center\"><!-- enterprise --><div flex=100><enterprises-autocomplete disabled-item=ctrl.template.id form=ctrl.form search-text=ctrl.enterprise selected-item=ctrl.selectedEnterprise></enterprises-autocomplete></div></div><div><div layout layout-align=\"space-between center\"><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CATALOGS.LABEL.NAME></label><input class=\"st-input-type input-type\" type=text name=name ng-model=ctrl.template.attributes.name autocomplete=off translate-attr=\"{ placeholder: \'CATALOGS.PLACEHOLDER.TYPE_NAME\' }\" maxlength=255 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.name.$error\"><div class=st-input-validation ng-show=ctrl.form.name.$error.required translate=CATALOGS.VALIDATION.NAME></div></div></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=CATALOGS.LABEL.CATEGORY></label><input class=\"st-input-type input-type\" type=text name=category ng-model=ctrl.template.attributes.category autocomplete=off translate-attr=\"{ placeholder: \'CATALOGS.PLACEHOLDER.TYPE_CATEGORY\' }\" maxlength=255 required><div ng-if=\"ctrl.form.$submitted && ctrl.form.category.$invalid\"><div class=st-input-validation ng-message=required translate=CATALOGS.VALIDATION.CATEGORY></div></div></div></div></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><div><button type=button ng-if=ctrl.template.id class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || ctrl.processing\"><span translate=CATALOGS.ACTION.DELETE></span></button></div><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=catalogs.template-list><span ng-if=!ctrl.loading translate=\"{{ctrl.template.id ? \'CATALOGS.ACTION.BACK\' : \'CATALOGS.ACTION.CANCEL\'}}\"></span> <span ng-if=ctrl.loading><progress></progress></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.processing aria-label=Save><span translate=CATALOGS.ACTION.SAVE></span></button></div></div></div></form><br><div ng-if=ctrl.template.id flex=70><div><div><div class=\"m12 mb24\" layout=column><div layout layout-align=\"start center\"><p class=\"st-title-small mr4 pb4 inline-block\" translate=CATALOGS.TITLE.ITEMS_LINKED></p><progress ng-if=ctrl.loading></progress><button can-access=INTERNALS,MANAGER type=button class=no-button ng-click=ctrl.addTaskItem()><i class=material-symbols-outlined>add_circle</i></button></div><p class=\"st-caption pt2\" translate=CATALOGS.HINT.TASK_LINKED></p></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span class=\"text-sm text-gray-500 font-normal\" translate=CATALOGS.LABEL.ITEM_NAME></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"template in ctrl.template.relationships.template_items\"><td md-cell><span class=\"text-sm text-gray-800\">{{template.relationships.item.attributes.name}}</span></td><td md-cell><div can-access=INTERNALS,MANAGER><button type=button class=no-button ng-click=\"ctrl.removeItem(template, $index)\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr ng-if=\"(!ctrl.template.relationships.template_items || ctrl.template.relationships.template_items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=2><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=CATALOGS.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container></div></div></div></div></div>");
$templateCache.put("app/internal/operational/catalogs/templates/list/templates.list.html","<div class=\"navigator-wrapper list-sticky\" flex=100><div class=\"st-filter-bar filter-sticky\" when-scrolled position=sticky><div layout layout-align=\"space-between end\"><div layout=column layout-align=\"start start\"><title-bar></title-bar><div layout layout-align=\"space-between center\" class=\"details-tab-wrapper mt-5 mr-4\"><div layout class=details-tabs><button ui-sref-active=active ui-sref=catalogs.item-list class=details-tab-item><span class=tab-text translate=CATALOGS.ENUM.TABS.ITEMS></span></button> <button ui-sref-active=active ui-sref=catalogs.template-list class=details-tab-item><span class=tab-text translate=CATALOGS.ENUM.TABS.TEMPLATES></span></button></div></div></div><actions-bar contract=ctrl.options></actions-bar></div><div class=pt-3><panel-header data=ctrl.headers></panel-header></div></div><div class=card-content><div class=st-expansion-panel><div class=st-expansion-panel-item ng-repeat=\"item in ctrl.items\"><div class=st-expansion-header><div layout layout-align=\"space-between center\" flex><div flex><span layout=column class=pr8><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::item.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::item.attributes.category}}</span></span></div><div flex><span layout=column class=pr8><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::item.relationships.enterprise.attributes.name}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::item.relationships.enterprise.attributes.cnpj}}</span></span></div><div flex><span layout=column class=\"pr24 mr24\"><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{item.relationships.template_items.length.toString().padStart(2, \'0\')}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>-</span></span></div><button type=button class=\"no-button st-expansion-panel-icon mt4\" ui-sref=\"catalogs.template-edit({id: item.id})\"><i class=material-symbols-outlined>chevron_right</i></button></div></div></div></div><div ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><div><div class=h-64 layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"text-sm text-gray-500 leading-tight font-bold mt24\" translate=CATALOGS.HINT.NOT_FOUND></span></div></div></div><div ng-if=ctrl.loading class=\"m24 p24\" layout layout-align=\"center center\" flex><progress></progress></div></div></div>");
$templateCache.put("app/internal/operational/protocols/tabs/documents/documents.html","<div><documents files=ctrl.documents identifier=ctrl.model loading-external=ctrl.loading service=protocols version=v5></documents></div>");
$templateCache.put("app/internal/operational/protocols/tabs/sharings/sharings.html","<div class=acknowledger><div layout layout-align=\"space-between center\" class=m24><div layout><p class=\"text-gray-800 text-base font-semibold\" translate=PROTOCOLS.ENUM.TABS.SHARINGS></p></div><div layout><button type=button class=\"altnav-action outlined text-gray-400 p8\" ng-disabled=!ctrl.workspaceLoaded ng-click=ctrl.add()><i class=\"material-symbols-outlined text-lg\">add</i></button></div></div><div><div class=\"st-expansion-panel detail\"><div class=\"st-expansion-panel-item rounded-none no-margin\" ng-repeat=\"sharing in ctrl.items\" ng-class=\"{\'opened\': sharing.panelExpanded}\"><div class=\"st-expansion-header cursor-pointer\" ng-mouseenter=ctrl.checkStatus(sharing);ctrl.isValid(sharing)><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\"><span easy-link link={{ctrl.EnvironmentConfig.SHARING}}/{{sharing.attributes.type}}/{{sharing.attributes.hash}} placeholder=\"SHR-{{::sharing.attributes.hash | limitTo: 6}}\"></span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\" translate=\"{{ \'LINKS.ENUM.TYPE.\' + sharing.attributes.type.toUpperCase()}}\"></span> </span><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700 truncate\" no-data-holder>{{::sharing.attributes.valid_until | date: \'HH:mm dd/MM/yyyy\':\'Z\'}}</span> <span class=\"text-xs leading-tight text-gray-500 truncate\" no-data-holder>{{::sharing.attributes.tokens_generated}}<span class=ml4 translate=LINKS.LABEL.USED></span></span> </span><button type=button class=\"no-button st-expansion-panel-icon\" ng-click=\"sharing.panelExpanded = !sharing.panelExpanded\"><i class=material-symbols-outlined>expand_more</i></button></span></div><div class=st-expansion-container><div class=st-expansion-content><div class=ml4 flex><div layout><div class=mt12 flex><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=LINKS.LABEL.RESOURSES></div><span ng-repeat=\"resource in sharing.attributes.resources\"><span class=\"st-tags mr4 mt4\"><span translate=\"{{\'LINKS.ENUM.RESOURSES.\' + resource.toUpperCase()}}\"></span></span></span></div></div></div><div ng-if=sharing.attributes.valid can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"end center\"><span layout layout-align=\"space-between center\"><span ng-show=sharing.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=LINKS.LABEL.ACTIVE></span> <span ng-show=!sharing.attributes.active class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=LINKS.LABEL.DEACTIVATED></span><md-switch class=st-activation-switch ng-model=sharing.attributes.active md-no-ink aria-label=State ng-change=ctrl.toggleState(sharing)></span></div></div></div></div><div ng-if=\"!ctrl.items.length && !ctrl.loading\" layout layout-align=\"center center\"><div class=\"p16 mt24 ml24 mr24 mb24 border border-solid border-gray-300 rounded\" flex=100 layout layout-align=\"center center\"><div class=w-72><div layout=column layout-align=\"center center\"><span layout layout-align=\"center center\" class=\"text-gray-800 text-base\"><i class=\"material-symbols-outlined text-2xl pr8\">share</i> <span translate=PROTOCOLS.HINT.NO_SHARING_1></span> </span><span class=\"pt12 text-gray-800 text-sm text-center\"><span translate=PROTOCOLS.HINT.NO_SHARING_2></span> \"<i class=\"material-symbols-outlined text-base\">add</i>\"</span></div></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center start\" class=pt16><progress></progress></div></div></div></div>");
$templateCache.put("app/internal/operational/protocols/tabs/users/users.html","<div class=acknowledger><div layout layout-align=\"space-between center\" class=m24><div layout><p class=\"text-gray-800 text-base font-semibold pt4 pb4\" translate=PROTOCOLS.ENUM.TABS.USERS></p></div></div><div><div class=\"st-expansion-panel detail\"><div class=\"st-expansion-panel-item rounded-none no-margin\" ng-repeat=\"vehicle in ctrl.items\" ng-init=ctrl.addActive(vehicle.relationships.user)><div class=st-expansion-header><span layout layout-align=\"space-between center\" flex><span class=mr8 layout=column flex><span class=\"text-xs font-bold leading-tight text-gray-700\"><span>{{vehicle.relationships.user.attributes.name}}</span> </span><span class=\"text-xs leading-tight text-gray-500 truncate\">{{vehicle.relationships.user.attributes.email}}</span> </span><span can-access=INTERNALS,MANAGER,OPERATOR layout layout-align=\"space-between center\"><span ng-show=!vehicle.relationships.user.attributes.deactivated_at class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=PROTOCOLS.LABEL.ACTIVE></span> <span ng-show=vehicle.relationships.user.attributes.deactivated_at class=\"st-subhead st-no-wrap mr8\" no-data-holder translate=PROTOCOLS.LABEL.DEACTIVATED></span><md-switch class=\"st-activation-switch no-margin\" ng-model=vehicle.relationships.user.attributes.active ng-change=ctrl.toggleState(vehicle.relationships.user) md-no-ink aria-label=Estado></span></span></div></div><div ng-if=\"!ctrl.items.length && !ctrl.loading\" layout layout-align=\"center center\"><div class=\"p16 mt24 ml24 mr24 mb24 border border-solid border-gray-300 rounded\" flex=100 layout layout-align=\"center center\"><div class=w-72><div layout=column layout-align=\"center center\"><span layout layout-align=\"center center\" class=\"text-gray-800 text-sm\"><i class=\"material-symbols-outlined text-2xl pr8\">person</i> <span translate=PROTOCOLS.HINT.NO_USER></span></span></div></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center start\" class=pt16><progress></progress></div></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/tabs/acknowledgements/acknowledgements.html","<div class=acknowledger><div layout layout-align=\"space-between center\" class=m24><div layout layout-align=\"start center\"><div class=w-6><md-checkbox aria-label=\"Selected all\" class=\"md-blue md-sm\" md-indeterminate=\"ctrl.selectedItems.length > 0 && ctrl.selectedItems.length < ctrl.ackPossibleAction.length\" ng-change=ctrl.toggleSectionAll() ng-disabled=\"ctrl.ackPossibleAction.length === 0 || ctrl.readOnly\" ng-model=ctrl.selectAllItems></md-checkbox></div><p class=\"text-gray-800 text-base font-semibold\" translate=SERVICE_ORDER.LABEL.ACKNOWLEDGEMENTS></p></div><div layout><button type=button class=\"altnav-action outlined text-gray-400 p8\" ng-click=ctrl.add() ng-disabled=\"!ctrl.enterpriseLoad || ctrl.readOnly\" ng-show=\"ctrl.selectedItems.length === 0\"><i class=\"material-symbols-outlined text-lg\">add</i></button> <button type=button class=\"altnav-action outlined text-rose-500 p8\" ng-click=ctrl.remove() ng-disabled=ctrl.readOnly ng-show=\"ctrl.selectedItems.length > 0\"><span class=\"material-symbols-outlined text-lg\">delete</span> <span class=text-caption translate=SERVICE_ORDER.ACTION.DELETE></span></button></div></div><div class=overflow-y-scroll style=\"height: calc(100vh - 265px);padding-top: 1px\"><div class=\"st-expansion-panel detail task-custom-fields-panel\"><div class=\"st-expansion-panel-item rounded-none no-margin\" ng-repeat=\"ack in ctrl.acknowledgements\" ng-class=\"{\n          \'opened\': check.panelExpanded,\n          \'not-animation\': ctrl.loadingAck\n        }\"><div class=\"st-expansion-header cursor-pointer\" ng-click=\"check.panelExpanded = !check.panelExpanded\"><div layout layout-align=\"start start\"><div class=\"w-6 h-5 shrink-0\" layout layout-align=\"start center\" ng-click=$event.stopPropagation()><md-checkbox aria-label=Selected class=\"md-blue md-sm\" data-test=ack.attributes.acknowledged_at ng-change=ctrl.selectItem() ng-disabled=\"ack.attributes.acknowledged_at || ctrl.readOnly\" ng-model=ack.selected></md-checkbox></div><div layout=column class=w-full><div layout layout-align=\"space-between center\"><span ng-if=ack.relationships.acknowledger.attributes.name class=\"task-custom__name text-sm text-gray-800 truncate w-44\">{{ack.relationships.acknowledger.attributes.name}}</span> <span ng-if=!ack.relationships.acknowledger.attributes.name class=\"task-custom__name text-xs text-gray-600 truncate w-44 pt2\" translate=SERVICE_ORDER.HINT.NO_REQUESTER></span><div><span class=\"st-tags font-normal\" translate ng-class=\"{\'tag-green\': ack.attributes.acknowledged === true, \'tag-important\': ack.attributes.acknowledged === false}\" ng-if=ack.attributes.acknowledged_at>{{\'SERVICE_ORDER.ENUM.ACK.\' + (ack.attributes.acknowledged.toString().toUpperCase())}}</span></div></div><div layout layout-align=\"space-between center\" class=pt4><div ng-if=\"!ack.attributes.acknowledged_at || ack.attributes.rate\" layout layout-align=\"start center\" class=h-4><div ng-repeat=\"i in [1,2,3,4,5]\"><i class=\"text-gray-200 material-symbols-outlined fill text-lg pr2\" ng-class=\"{\'text-yellow-500\': i <= ack.attributes.rate}\">star</i></div></div><span ng-if=\"ack.attributes.acknowledged_at && !ack.attributes.rate\" class=\"text-sm text-gray-500\">-</span><div><p ng-if=ack.attributes.acknowledged_at class=\"text-xs text-gray-500\"><span translate=SERVICE_ORDER.HINT.ACK_AT></span> <span>{{ ack.attributes.acknowledged_at | timeToString }}</span></p></div></div></div></div></div><div class=st-expansion-container><div><div ng-if=\"ack.attributes.claims && ack.attributes.claims.length > 0\" class=\"pr24 pl24 pb16 pt12\"><p layout layout-align=\"start center\"><i class=\"material-symbols-outlined text-gray-700 text-xl\">family_star</i> <span class=\"text-gray-700 pl8 font-semibold text-xs\" translate=SERVICE_ORDER.HINT.CLAIMS></span></p><div layout layout-wrap class=\"pr24 pl16 ml4\"><span class=\"st-tags font-normal ml4 mt8 bg-gray-100 rounded-2xl\" ng-repeat=\"claim in ack.attributes.claims\" translate>{{\'SERVICE_ORDER.ENUM.ACK.\' + (claim.toUpperCase())}}</span></div></div><p class=\"text-gray-800 bg-gray-100 pl24 pt8 pb8 font-medium text-xs\" translate=SERVICE_ORDER.TITLE.ACK_DETAIL></p><div ng-if=\"ack.attributes.ip || ack.attributes.geom\" class=\"pl24 pr24 pt16 pb16\"><p layout layout-align=\"start center\" class=\"text-gray-700 font-semibold text-xs\"><i class=\"material-symbols-outlined text-lg\">near_me</i> <span class=pl8 translate=SERVICE_ORDER.TITLE.ACK_IP_LOCATION></span></p><p class=\"text-xs text-gray-500 pl24\"><span>{{ack.attributes.ip}}</span> <span ng-if=\"ack.attributes.ip && ack.attributes.geom\">-</span> <span>{{ack.attributes.geom}}</span></p></div><div ng-if=ack.attributes.user_agent class=\"pl24 pr24 pt16 pb16\"><p layout layout-align=\"start center\" class=\"text-gray-700 font-semibold text-xs\"><i class=\"material-symbols-outlined text-lg\">devices</i> <span class=pl8 translate=SERVICE_ORDER.TITLE.ACK_DEVICE></span></p><p class=\"text-xs text-gray-500 pl24\"><span>{{ ack.attributes.user_agent | deviceUserAgent }}</span></p></div><div ng-if=ack.attributes.user_agent class=\"pl24 pr24 pt16 pb16\"><p layout layout-align=\"start center\" class=\"text-gray-700 font-semibold text-xs\"><i class=\"material-symbols-outlined text-lg\">language</i> <span class=pl8 translate=SERVICE_ORDER.TITLE.ACK_APPLICATION></span></p><p class=\"text-xs text-gray-500 pl24\"><span>{{ ack.attributes.user_agent | applicationUserAgent }}</span></p></div><div ng-if=ack.attributes.acknowledged_at class=\"pl24 pr24 pt16 pb16\"><p layout layout-align=\"start center\" class=\"text-gray-700 font-semibold text-xs\"><i class=\"material-symbols-outlined text-lg\">language</i> <span class=pl8 translate=SERVICE_ORDER.TITLE.ACK_DATE_HOUR></span></p><p class=\"text-xs text-gray-500 pl24\"><span>{{ ack.attributes.acknowledged_at | date: \'dd/MM/yyyy, HH:mm:ss\' }}</span></p></div><div class=\"pl24 pr24 pt16 pb16\"><p layout layout-align=\"start center\" class=\"text-gray-700 font-semibold text-xs\"><i class=\"material-symbols-outlined text-lg\">manage_accounts</i> <span class=pl8 translate=SERVICE_ORDER.TITLE.ACK_SIG_REQUESTER></span></p><p class=\"text-xs text-gray-500 pl24\"><span ng-if=ack.relationships.requester.attributes.name>{{ ack.relationships.requester.attributes.name }} - <span translate>{{ \'SERVICE_ORDER.ENUM.USER_TYPE.\' + (ack.relationships.requester.attributes.user_type.toString().toUpperCase())}}</span> </span><span ng-if=\"!ack.relationships.requester.attributes.name && ack.new\">{{ ctrl.user.attributes.name }} - <span translate>{{ \'SERVICE_ORDER.ENUM.USER_TYPE.\' + (ctrl.role)}}</span> </span><span ng-if=\"!ack.relationships.requester.attributes.name && !ack.new\"><span translate=SERVICE_ORDER.HINT.NO_REQUESTER></span></span></p></div></div></div></div><div ng-if=\"!ctrl.acknowledgements.length && !ctrl.loading\" layout layout-align=\"center center\"><div class=\"p24 mt24 ml24 mr24 mb24 border border-solid border-gray-300 rounded\" flex=100 layout layout-align=\"center center\"><div class=w-64><div layout=column layout-align=\"center center\"><span layout layout-align=\"center center\" class=\"text-gray-800 text-base\"><i class=\"material-symbols-outlined text-2xl pr8\">signature</i> <span translate=SERVICE_ORDER.HINT.NO_ACKS_1></span> </span><span ng-if=!ctrl.readOnly class=\"pt12 text-gray-800 text-sm text-center\"><span translate=SERVICE_ORDER.HINT.NO_ACKS_2></span> \"<i class=\"material-symbols-outlined text-base\">add</i>\"</span></div></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center start\" class=pt16><progress></progress></div></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/tabs/comments/comments.html","");
$templateCache.put("app/internal/operational/service-orders/tabs/custom-fields/custom-fields.html","<div class=task-custom><div layout layout-align=\"space-between center\" class=m24><div layout layout-align=\"start center\"><div class=w-6><md-checkbox aria-label=\"Selected all\" class=\"md-blue md-sm mr8\" md-indeterminate=\"ctrl.selectedItems.length > 0 && ctrl.selectedItems.length < ctrl.total\" ng-change=ctrl.toggleSection() ng-hide=ctrl.sortingActive ng-disabled=\"ctrl.total === 0 || ctrl.readOnly\" ng-model=ctrl.selectAllItems></md-checkbox></div><p class=\"text-gray-800 text-base font-semibold\" translate=SERVICE_ORDER.LABEL.TOTAL_CUSTOM_FIELDS></p><button class=\"task-custom__btn-sort ml4 no-button text-gray-300\" ng-class=\"{ \'invisible\': ctrl.total < 2, \'active\': ctrl.sortingActive }\" ng-click=ctrl.openSort() translate-attr=\"{ title: \'SERVICE_ORDER.ACTION.SORT\' }\" type=button><i class=\"material-symbols-outlined text-lg\">page_info</i></button></div><div layout><div layout ng-class=\"{ \'invisible\': ctrl.sortingActive }\"><button can-access=INTERNALS,MANAGER type=button class=\"altnav-action outlined text-gray-400 p8 mr8\" ng-click=ctrl.getSavedItems() ng-disabled=ctrl.readOnly ng-show=\"ctrl.selectedItems.length === 0\" translate-attr=\"{ title: \'SERVICE_ORDER.ACTION.LOAD_ITEM\' }\"><span class=\"material-symbols-outlined text-lg\">bookmark</span></button> <button can-access=INTERNALS,MANAGER type=button class=\"altnav-action outlined text-gray-400 p8\" ng-click=ctrl.add() ng-disabled=ctrl.readOnly ng-show=\"ctrl.selectedItems.length === 0\" translate-attr=\"{ title: \'SERVICE_ORDER.ACTION.NEW_ITEM\' }\"><span class=\"material-symbols-outlined text-lg\">add</span></button> <button can-access=INTERNALS,MANAGER type=button class=\"altnav-action outlined text-rose-500 p8\" ng-click=ctrl.remove() ng-disabled=ctrl.readOnly ng-show=\"ctrl.selectedItems.length > 0\"><span class=\"material-symbols-outlined text-lg\">delete</span> <span class=text-caption translate=SERVICE_ORDER.ACTION.DELETE></span></button></div><button can-access=INTERNALS,MANAGER class=\"altnav-action outlined text-gray-500 p8\" ng-click=\"ctrl.sortingActive = !ctrl.sortingActive\" ng-show=ctrl.sortingActive type=button><span class=text-caption translate=SERVICE_ORDER.ACTION.LEAVE></span></button></div></div><div class=overflow-y-scroll style=\"height: calc(100vh - 265px);padding-top: 1px\" when-scrolled=ctrl.loadMore()><div ng-if=ctrl.sortingActive sv-root sv-part=ctrl.custom_fields sv-on-sort=\"ctrl.sort($item, $partTo, $indexTo)\" class=st-expansion-panel><div class=\"st-expansion-panel-item task-custom__sort-element rounded-none\" sv-element ng-repeat=\"check in ctrl.custom_fields\"><div class=st-expansion-header><span layout layout-align=\"space-between start\" flex><span layout flex><span class=\"w-6 h-5\" layout layout-align=\"start center\"><span class=indicator><i class=\"material-symbols-outlined text-lg text-gray-500\">drag_indicator</i> </span></span><span layout=column flex><span layout layout-align=\"space-between center\"><span class=\"task-custom__name text-gray-800 mr12 pr16 relative\" ng-class=\"{\'truncate\': !check.panelExpanded }\" no-data-holder title={{check.attributes.name}} ng-click=\"ctrl.add(check); $event.stopPropagation()\"><span class=\"task-custom__name--text text-sm\" ng-class=\"{\'truncate\': !check.panelExpanded }\">{{check.attributes.name}}</span> <i class=\"task-custom__name--icon hidden material-symbols-outlined text-xs absolute top-0 right-0\">edit</i> </span><span><span class=\"st-tags invisible\" translate=SERVICE_ORDER.LABEL.TAG_ANSWERED></span> </span></span><span class=pt4 layout no-data-holder><i layout layout-align=\"center center\" class=\"material-symbols-outlined text-xs bg-gray-100 w-4 h-4 text-gray-400 rounded\">{{ctrl.iconField[check.attributes.field_format]}}</i> <i ng-if=check.attributes.is_required layout layout-align=\"center center\" class=\"material-symbols-outlined text-xs bg-gray-100 w-4 h-4 text-gray-400 ml4 rounded\">error</i></span></span></span></span></div></div></div><div ng-if=!ctrl.sortingActive class=\"st-expansion-panel detail\"><div class=\"st-expansion-panel-item rounded-none no-margin\" ng-repeat=\"check in ctrl.custom_fields\" ng-class=\"{\n          \'opened\': check.panelExpanded,\n          \'not-animation\': ctrl.loadingCustom\n        }\"><div class=\"st-expansion-header cursor-pointer\" ng-click=\"check.panelExpanded = !check.panelExpanded; ctrl.open(check)\"><span layout layout-align=\"space-between center\" flex><span layout flex><span class=\"w-6 h-5\" layout layout-align=\"start center\"><span class=indicator ng-click=$event.stopPropagation()><md-checkbox aria-label=Selected class=\"md-blue md-sm\" data-test=service_order.action.item_delete ng-change=ctrl.selectItem() ng-disabled=ctrl.readOnly ng-model=check.selected></md-checkbox></span></span><span layout=column flex><span layout layout-align=\"space-between center\"><span class=\"task-custom__name text-gray-800 mr12 pr16 relative\" ng-class=\"{\'truncate\': !check.panelExpanded }\" no-data-holder title={{check.attributes.name}}><span ng-if=!ctrl.readOnly ng-click=\"ctrl.add(check); $event.stopPropagation()\"><span class=\"task-custom__name--text text-sm\" ng-class=\"{\'truncate\': !check.panelExpanded }\">{{check.attributes.name}}</span> <i class=\"task-custom__name--icon hidden material-symbols-outlined text-xs absolute top-0 right-0\">edit</i> </span><span ng-if=ctrl.readOnly><span class=\"task-custom__name--text text-sm\" ng-class=\"{\'truncate\': !check.panelExpanded }\">{{check.attributes.name}}</span> </span></span><span><span class=\"st-tags tag-green\" ng-class=\"{ \'visible\': ctrl.tagAnswered(check.id), \'invisible\': !ctrl.tagAnswered(check.id) }\" translate=SERVICE_ORDER.LABEL.TAG_ANSWERED></span> </span></span><span class=pt4 layout no-data-holder><i layout layout-align=\"center center\" class=\"material-symbols-outlined text-xs bg-gray-100 w-4 h-4 text-gray-400 rounded\">{{ctrl.iconField[check.attributes.field_format]}}</i> <i ng-if=check.attributes.is_required layout layout-align=\"center center\" class=\"material-symbols-outlined text-xs bg-gray-100 w-4 h-4 text-gray-400 ml4 rounded\">error</i></span></span></span></span></div><div class=st-expansion-container><div class=st-expansion-content><div class=pl24><p class=\"text-gray-500 font-semibold text-xs\"><span class=leading-5 translate=SERVICE_ORDER.LABEL.POSSIBLE_VALUES></span></p><div class=pt8><div ng-if=\"check.attributes.field_format === \'text\'\" class=\"st-input-container no-padding\" layout=column flex><textarea class=\"st-input-type input-textarea\" data-test=service_order.label.value_text ng-model=check.attributes.value ng-name=description-{{$index}} ng-readonly=ctrl.readOnly translate-attr=\"{ placeholder: \'SERVICE_ORDER.PLACEHOLDER.FIELD_FORMAT_TEXT\' }\"></textarea></div><div ng-if=\"check.attributes.field_format === \'number\'\" class=\"st-input-container mt4 no-padding\" layout=column><input autocomplete=off class=st-input-type data-test=service_order.label.value_number type=text ui-number-mask maxlength=14 translate-attr=\"{ placeholder: \'SERVICE_ORDER.PLACEHOLDER.FIELD_FORMAT_NUMBER\' }\" ng-model=check.attributes.value ng-name=description-{{$index}} ng-readonly=ctrl.readOnly></div><div ng-if=\"check.attributes.field_format === \'date\'\" class=\"st-input-container mt4 no-padding\" layout=column><input autocomplete=off class=st-input-type data-test=service_order.label.value_date datetime=dd/MM/yyyy datetime-model=yyyy-MM-dd ng-model=check.attributes.value ng-name=description-{{$index}} ng-readonly=ctrl.readOnly translate-attr=\"{ placeholder: \'SERVICE_ORDER.PLACEHOLDER.FIELD_FORMAT_DATE\' }\" type=text></div><div ng-if=\"check.attributes.field_format === \'enum\'\" layout=column flex><md-radio-group ng-model=check.attributes.value class=\"md-blue md-sm\" aria-labelledby=answers><div ng-repeat=\"item in check.attributes.possible_values\" class=\"pt8 pb8\"><md-radio-button class=\"radio-input no-margin\" data-test=service_order.label.value_enum_{{$index}} ng-disabled=ctrl.readOnly value={{item}}><span class=\"text-xs font-medium text-gray-800\">{{item}}</span></md-radio-button></div></md-radio-group></div><div ng-if=\"check.attributes.field_format === \'checkbox\'\" layout=column flex><div ng-repeat=\"item in check.attributes.possible_values\" class=\"pt8 pb8\"><md-checkbox aria-label=Selected class=\"md-blue md-sm\" ng-disabled=ctrl.readOnly ng-checked=\"ctrl.exists(item, check.attributes.value)\" ng-click=\"ctrl.toggle(item, check.attributes.value)\"><span class=\"text-xs truncate block font-medium text-gray-800\">{{item}}</span></md-checkbox></div></div><div layout layout-align=\"end start\" ng-if=!ctrl.readOnly class=pt24><button type=button class=\"altnav-action save no-padding h-7\" aria-label=Save ng-click=ctrl.updateValues(check)><span class=\"text-xs pr8 pl8\" translate=SERVICE_ORDER.ACTION.VALIDATE_RESPONSE></span></button></div></div></div></div></div></div><div ng-if=\"(!ctrl.custom_fields || ctrl.custom_fields.length == 0) && !ctrl.loading\" layout layout-align=\"center center\"><div class=\"p24 mt24 ml24 mr24 mb24 border border-solid border-gray-300 rounded\" flex=100 layout layout-align=\"center center\"><div class=w-64><div layout=column layout-align=\"center center\"><span layout layout-align=\"center center\" class=\"text-gray-800 text-base\"><i class=\"material-symbols-outlined text-2xl pr8\">list_alt_add</i> <span translate=SERVICE_ORDER.HINT.FIELDS_NOT_FOUND_1></span> </span><span ng-if=!ctrl.readOnly class=\"pt12 text-gray-800 text-sm text-center\"><span translate=SERVICE_ORDER.HINT.FIELDS_NOT_FOUND_2></span> \"<i class=\"material-symbols-outlined text-base\">add</i>\" <span translate=SERVICE_ORDER.HINT.FIELDS_NOT_FOUND_3></span> <span translate=SERVICE_ORDER.HINT.FIELDS_NOT_FOUND_4></span> <i class=\"material-symbols-outlined text-base\">bookmark</i></span></div></div></div></div><div ng-if=ctrl.loading layout layout-align=\"center start\" class=pt16><progress></progress></div></div></div></div>");
$templateCache.put("app/internal/operational/service-orders/tabs/documents/documents.html","<div><documents files=ctrl.documents identifier=ctrl.model loading-external=ctrl.loading service=service-orders version=v5 count=ctrl.count></documents></div>");
$templateCache.put("app/internal/operational/service-orders/tabs/expenses/expenses.html","<div><div class=st-input-container layout=column flex><div layout layout-align=\"start center\"><label class=st-label translate=SERVICE_ORDER.LABEL.EXPENSES></label><button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.addExpense()><span class=material-symbols-outlined>add_circle</span></button></div><md-table-container class=\"mt2 border border-solid border-gray-300\"><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=SERVICE_ORDER.LABEL.CATEGORY></span></th><th md-column><span translate=SERVICE_ORDER.LABEL.DESCRIPTION></span></th><th md-column md-numeric><span translate=SERVICE_ORDER.LABEL.AMOUNT></span></th><th md-column md-numeric><span translate=SERVICE_ORDER.LABEL.UNIT_PRICE></span></th><th md-column md-numeric><span translate=SERVICE_ORDER.LABEL.TOTAL_PRICE></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"expense in ctrl.serviceOrder.relationships.expenses\"><td md-cell md-truncate class=md-ellipsis style=\"max-width: 75px\"><span translate>{{\'EXPENSES.ENUM.CATEGORY.\' + expense.attributes.category.toUpperCase()}}</span></td><td md-cell md-truncate class=md-ellipsis style=\"max-width: 75px\">{{expense.attributes.description}}</td><td md-cell>{{expense.attributes.amount / 100}}</td><td md-cell>{{(expense.attributes.unit_price / 100) | currency}}</td><td md-cell>{{(expense.attributes.total_price / 100) | currency}}</td><td md-cell><button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=\"ctrl.addExpense($index, expense)\"><span class=material-symbols-outlined>edit</span></button> <button type=button class=\"text-xs leading-tight text-gray-500 truncate no-button\" ng-click=ctrl.removeExpense($index)><span class=material-symbols-outlined>delete</span></button></td></tr><tr ng-if=\"(!ctrl.serviceOrder.relationships.expenses || ctrl.serviceOrder.relationships.expenses.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=8><div layout=column layout-align=\"center center\"><img src=assets/holders/no-results.svg alt=\"No results\" height=100> <span class=\"no-content-text mt8\" translate=DISCONECTED.NOT_FOUND.ANY></span></div></td></tr></tbody></table></md-table-container></div></div>");
$templateCache.put("app/internal/organization/chips/components/network-diagnostic/network-diagnostic.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Sim card network\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout layout-align=\"start center\"><span class=title translate=NEWTWORK_DIAGNOSTIC.TITLE.HEADER></span> <span class=\"ml12 mt4\"><progress ng-if=ctrl.processing></progress></span></div><div layout layout-align=\"start center\"><a href=\"\" ng-click=ctrl.close()><i class=material-symbols-outlined>close</i></a></div></div></div><div class=st-dialog-wrapper><div class=st-dialog-body><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=NEWTWORK_DIAGNOSTIC.LABEL.STATUS></span></th><th md-column><span translate=NEWTWORK_DIAGNOSTIC.LABEL.DIAGNOSTIC></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row><td md-cell><div layout layout-align=\"start center\" class=w-48><span ng-if=ctrl.loading><progress></progress></span><span ng-if=!ctrl.loading><span ng-class=\"{\'text-green-500\': ctrl.diagnostic.data.attributes.diagnostic.global, \'text-amber-500\': !ctrl.diagnostic.data.attributes.diagnostic.global}\" class=material-symbols-outlined>{{ctrl.diagnostic.data.attributes.diagnostic.global ? \'check_circle\' : \'warning\'}}</span> </span><span class=ml8 translate=NEWTWORK_DIAGNOSTIC.LABEL.ADMIN></span></div></td><td md-cell>{{ctrl.diagnostic.data.attributes.diagnostic.radio_access}}</td></tr><tr md-row><td md-cell><div layout layout-align=\"start center\" class=w-48><span ng-if=ctrl.loading><progress></progress></span><span ng-if=!ctrl.loading><span ng-class=\"{\'text-green-500\': ctrl.diagnostic.data.attributes.diagnostic.data, \'text-amber-500\': !ctrl.diagnostic.data.attributes.diagnostic.data}\" class=material-symbols-outlined>{{ctrl.diagnostic.data.attributes.diagnostic.data ? \'check_circle\' : \'warning\'}}</span> </span><span class=ml8 translate=NEWTWORK_DIAGNOSTIC.LABEL.DATA></span></div></td><td md-cell><div ng-repeat=\"desc in ctrl.diagnostic.data.attributes.diagnostic.data_description.split(\';\')\"><span translate=\"{{\'NEWTWORK_DIAGNOSTIC.ENUM.DIAGNOSTIC.\' + desc}}\"></span></div></td></tr><tr md-row><td md-cell><div layout layout-align=\"start center\" class=w-48><span ng-if=ctrl.loading><progress></progress></span><span ng-if=!ctrl.loading><span ng-class=\"{\'text-green-500\': ctrl.diagnostic.data.attributes.diagnostic.gsm, \'text-amber-500\': !ctrl.diagnostic.data.attributes.diagnostic.gsm}\" class=material-symbols-outlined>{{ctrl.diagnostic.data.attributes.diagnostic.gsm ? \'check_circle\' : \'warning\'}}</span> </span><span class=ml8 translate=NEWTWORK_DIAGNOSTIC.LABEL.GSM></span></div></td><td md-cell>{{ctrl.diagnostic.data.attributes.diagnostic.gsm_description}}</td></tr><tr md-row><td md-cell><div layout layout-align=\"start center\" class=w-48><span ng-if=ctrl.loading><progress></progress></span><span ng-if=!ctrl.loading><span ng-class=\"{\'text-green-500\': ctrl.diagnostic.data.attributes.diagnostic.gprs, \'text-amber-500\': !ctrl.diagnostic.data.attributes.diagnostic.gprs}\" class=material-symbols-outlined>{{ctrl.diagnostic.data.attributes.diagnostic.gprs ? \'check_circle\' : \'warning\'}}</span> </span><span class=ml8 translate=NEWTWORK_DIAGNOSTIC.LABEL.GPRS></span></div></td><td md-cell>{{ctrl.diagnostic.data.attributes.diagnostic.gprs_description}}</td></tr><tr md-row><td md-cell><div layout layout-align=\"start center\" class=w-48><span ng-if=ctrl.loading><progress></progress></span><span ng-if=!ctrl.loading><span ng-class=\"{\'text-green-500\': ctrl.diagnostic.data.attributes.diagnostic.sms, \'text-amber-500\': !ctrl.diagnostic.data.attributes.diagnostic.sms}\" class=material-symbols-outlined>{{ctrl.diagnostic.data.attributes.diagnostic.sms ? \'check_circle\' : \'warning\'}}</span> </span><span class=ml8 translate=NEWTWORK_DIAGNOSTIC.LABEL.SMS></span></div></td><td md-cell><div ng-repeat=\"desc in ctrl.diagnostic.data.attributes.diagnostic.sms_description.split(\';\')\"><span translate=\"{{\'NEWTWORK_DIAGNOSTIC.ENUM.DIAGNOSTIC.\' + desc}}\"></span></div></td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/internal/organization/devices/tabs/associations/_associations.html","<div flex=70><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.ASSOCIATION_HISTORY></span><progress ng-if=ctrl.loading></progress></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=DEVICES.LABEL.VEHICLE></span></th><th md-column><span translate=DEVICES.LABEL.ENTERPRISE></span></th><th md-column><span translate=DEVICES.LABEL.ASSOCIATED_AT></span></th><th md-column><span translate=DEVICES.LABEL.DESASSOCIATED_AT></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><div><div class=st-subhead><span>{{item.relationships.vehicle.attributes.plate}}</span> <span class=\"st-caption ml8\" ng-if=item.relationships.vehicle.attributes.deleted_at>(<span translate=DEVICES.LABEL.DELETED_ITEM></span>)</span></div><div class=st-subhead-lite>{{item.relationships.vehicle.attributes.vin}}</div></div></td><td md-cell><div><div class=st-subhead>{{item.relationships.enterprise.attributes.name}}</div><div class=st-subhead-lite>{{item.relationships.enterprise.attributes.cnpj}}</div></div></td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.deleted_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell><button can-access=MANAGER,INTERNALS class=no-button ng-click=ctrl.generateReport(item) ng-disabled=item.relationships.vehicle.attributes.deleted_at translate-attr=\"{title:\'DEVICES.HINT.REPORT_POINTS\'}\"><i class=material-symbols-outlined>summarize</i></button></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=DEVICES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAssociationHistory md-boundary-links md-label=\"{page: \'{{\'DEVICES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DEVICES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DEVICES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div>");
$templateCache.put("app/internal/organization/devices/tabs/behavior/_behavior.html","<div><div class=\"m12 mb24\" layout layout-align=\"space-between center\"><div layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.BEHAVIOR></span><progress ng-if=ctrl.loading></progress></div><div class=\"st-input-container no-padding\" layout=column flex=20><input class=\"st-input-type input-type\" name=range ng-model=ctrl.profile.range type=text date-range-picker options=ctrl.dateRangeConfig translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.PICK_DATE\' }\" autocomplete=off></div></div></div><br><div layout layout-align=\"space-between start\" layout-wrap><div class=section-content flex=50><!-- gps_recurrence --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.GPS_RECURRENCE></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.GPS_RECURRENCE></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=gps class=\"graph-content bar-chart\"></div></div></div><div class=section-content flex=50><!-- gps_ignition_off_error --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.GPS_IGN_ERROR></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.GPS_IGN_ERROR></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=ign-error class=\"graph-content bar-chart\"></div></div></div><div class=section-content flex=50><!-- num_alarms_connection, num_alarms_disconnection, num_alarms_emergency_power --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.ALERT_CONNECTIONS></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.ALERT_CONNECTIONS></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=num-alerts class=\"graph-content bar-chart\"></div></div></div><div class=section-content flex=50><!-- ignition_distance_min, ignition_distance_max, ignition_distance_average --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.GPS_START_DIST></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.GPS_START_DIST></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=ign-dis class=\"graph-content step-chart\"></div></div></div><div class=section-content flex=50><!-- all_ignition_on, all_ignition_off --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.IGN_STATE></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.IGN_STATE></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=ign-state class=\"graph-content step-chart\"></div></div></div><div class=section-content flex=50><!-- perc_low_satellite_count, perc_low_gps_signal, perc_low_battery_level--><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.SIGNAL_QUALITY></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.SIGNAL_QUALITY></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=low-signal class=\"graph-content bar-chart\"></div></div></div><div class=section-content flex=50><!-- battery_level_oscillation --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.BATTERY_LEVEL_OSCILLATION></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.BATTERY_LEVEL_OSCILLATION></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=battery-life class=\"graph-content line-chart\"></div></div></div><div class=section-content flex=50><!-- mean_time_communication_on, mean_time_communication_off --><div class=title-holder><h4 class=m12 translate=DEVICES.TITLE.COMMUNICATION_TIME></h4><div class=\"m12 md-caption secondary-info\">{{ctrl.profile.formated.startDate | date: \'dd/MM/yyyy\'}} . {{ctrl.profile.formated.endDate | date: \'dd/MM/yyyy\'}}</div></div><div class=\"tip-area m12 md-caption secondary-info\" translate=DEVICES.TIPS.COMMUNICATION_TIME></div><br><div class=\"graph-wrapper _md-graph m12\"><div id=communication-time class=\"graph-content bar-chart\"></div></div></div></div>");
$templateCache.put("app/internal/organization/devices/tabs/commands/_commands.html","<div flex=70><section><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.COMMANDS_CENTER></span><progress ng-if=ctrl.loadingCommands></progress></div></div><div layout=column layout-align=\"start stretch\" flex><div ng-if=\"ctrl.availableCommands.length === 0\"><p class=ml12 translate=DEVICES.LABEL.NO_COMMANDS></p></div><div ng-if=\"ctrl.availableCommands.length > 0\" layout layout-align=\"space-between start\"><div layout=column flex=30><ul class=commands-categories><li class=\"st-title-lite commands-list\" ng-repeat=\"category in ctrl.categories\"><a ng-click=ctrl.filterCommands(category) href=\"\"><span translate=\"{{\'DEVICES.CATEGORY.\' +  category.toUpperCase()}}\"></span></a></li></ul></div><div layout=column layout-align=\"start stretch\" flex=70><ul class=commands-categories><li ng-repeat=\"item in ctrl.filtered\" layout layout-align=\"space-between center\" class=\"st-card commands-card\"><div layout=column layout-align=\"start stretch\"><span class=st-head translate=\"{{\'DEVICES.COMMANDS.\' +  item.name.toUpperCase()}}\"></span><div class=st-input-container ng-repeat=\"field in item.fields\"><input class=\"st-input-type input-type\" type={{field.type}} ng-model=field.value min=0 placeholder=\"{{\'DEVICES.PARAMS.\' + field.name.toUpperCase() | translate}}\" required></div></div><button type=button ng-click=ctrl.prepareCommand(item) class=\"commands-action no-button\" ng-disabled=ctrl.preventOpen><span class=material-symbols-outlined>arrow_forward</span></button></li></ul></div></div></div></section><br><section><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.COMMANDS_HISTORY></span><progress ng-if=ctrl.loadingHistory></progress></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head md-order=ctrl.order md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=DEVICES.HISTORY.COMMAND></span></th><th md-column><span translate=DEVICES.HISTORY.TYPE></span></th><th md-column><span translate=DEVICES.HISTORY.STATUS></span></th><th md-column><span translate=DEVICES.HISTORY.SOURCE></span></th><th md-column><span translate=DEVICES.HISTORY.CONTENT></span></th><th md-column md-order-by=created_at><span translate=DEVICES.HISTORY.DATE></span></th><th md-column><span translate=DEVICES.HISTORY.USERNAME></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell translate=\"{{\'DEVICES.COMMANDS.\' + item.attributes.command.toUpperCase()}}\"></td><td md-cell translate=\"{{\'DEVICES.TYPE.\' + item.attributes.type.toUpperCase()}}\"></td><td md-cell translate=\"{{\'DEVICES.STATUS.\' + item.attributes.status.toUpperCase()}}\"></td><td md-cell translate=\"{{\'DEVICES.SOURCE.\' + item.attributes.source.toUpperCase()}}\"></td><td md-cell>{{item.attributes.text}}</td><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.relationships.user.attributes.username}}</td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loadingHistory && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loadingHistory\"><td class=st-table-no-content colspan=7><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=DEVICES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadCommandHistory md-boundary-links md-label=\"{page: \'{{\'DEVICES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DEVICES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DEVICES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></section></div>");
$templateCache.put("app/internal/organization/devices/tabs/general/_general.html","<div flex=70><div><div class=\"m12 mb12\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.ACTIVATION_HISTORY></span><progress ng-if=ctrl.loading></progress></div></div><div><div can-access=INTERNALS,MANAGER class=st-input-container layout=column flex><div layout layout-align=\"start center\"><md-switch class=st-activation-switch ng-model=ctrl.isActive ng-change=ctrl.changeState() ng-disabled=ctrl.loading md-no-ink aria-label=\"Enable Switch\"></md-switch><div><div translate=DEVICES.LABEL.ACTIVATE></div><div class=st-caption translate=DEVICES.HINT.ACTIVATE></div></div></div></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head md-order=ctrl.order md-on-reorder=ctrl.reorder><tr md-row><th md-column><span translate=DEVICES.LABEL.ACTIVATED_AT></span></th><th md-column><span translate=DEVICES.LABEL.ACTIVATED_BY></span></th><th md-column><span translate=DEVICES.LABEL.DEACTIVATED_AT></span></th><th md-column><span translate=DEVICES.LABEL.DEACTIVATED_BY></span></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.created_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.relationships.activator.attributes.name}}</td><td md-cell>{{item.attributes.deleted_at | date: \'HH:mm dd/MM/yyyy\'}}</td><td md-cell>{{item.relationships.deactivator.attributes.name}}</td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=DEVICES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadActivationHistory md-boundary-links md-label=\"{page: \'{{\'DEVICES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DEVICES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DEVICES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div>");
$templateCache.put("app/internal/organization/devices/tabs/gps-table/_gps-table.html","<div><div class=\"m12 mb24\" layout layout-align=\"space-between center\"><div layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.TABLE></span><progress ng-if=ctrl.loading></progress></div><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.search()\" novalidate layout><div class=\"st-input-container no-padding\" layout=column flex><input autocomplete=off class=\"st-input-type h-8\" datetime=dd/MM/yyyy name=day ng-max=ctrl.max_date ng-model=ctrl.day required translate-attr=\"{ placeholder: \'DEVICES.PLACEHOLDER.SELECT_DATE\' }\" type=text><div ng-if=\"ctrl.form.$submitted && ctrl.form.day.$error\"><div class=st-input-validation ng-show=ctrl.form.day.$error.required translate=DEVICES.VALIDATION.DATE></div><div class=st-input-validation ng-show=ctrl.form.day.$error.max translate=DEVICES.VALIDATION.MAX></div></div></div><button type=submit class=\"h-8 bg-black border-none rounded-r-md\" ng-disabled=ctrl.loading aria-label=Search><i class=\"material-symbols-outlined text-white text-xl\">search</i></button></form></div></div><div><md-table-container class=st-wrapper-table style=\"max-height: 80vh\"><table class=st-main-table md-table><thead class=st-table-head md-head md-order=ctrl.meta.order><tr md-row><th md-column ng-repeat=\"header in ctrl.headers\" md-order-by={{header}} md-desc={{ctrl.showDescription(header)}}><span class=\"text-gray-500 text-xs\" translate=\"{{\'DEVICES.LAST_GPS_RAW.\' + header.toUpperCase()}}\"></span></th></tr></thead><tbody class=st-table-body md-body><tr ng-if=!ctrl.loading md-row ng-repeat=\"i in ctrl.dataObj | orderBy: ctrl.meta.order | limitTo: ctrl.meta.limit : (ctrl.meta.page -1) * ctrl.meta.limit\"><td md-cell ng-repeat=\"h in ctrl.headers\"><span class=\"block text-gray-800 text-sm\" ng-class=\"{\'whitespace-nowrap\': i[h] !== \'msg\'}\">{{i[h]}}</span></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3,4]\"><td md-cell colspan={{ctrl.headers.length}}><span class=st-skeleton-item></span></td></tr><tr ng-if=\"!ctrl.loading && ctrl.dataObj.length === 0\"><td class=st-table-no-content colspan={{ctrl.headers.length}}><div layout=column layout-align=\"center center\"><span ng-if=!ctrl.error class=\"no-content-text mt8\" translate=DEVICES.HINT.NOT_FOUND></span> <span ng-if=ctrl.error class=\"no-content-text mt8\" translate=DEVICES.HINT.ERROR></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-limit-options=ctrl.meta.limitOptions md-page=ctrl.meta.page md-page-select=ctrl.meta.pageOptions md-total={{ctrl.meta.count}} md-boundary-links md-label=\"{page: \'{{\'DEVICES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'DEVICES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'DEVICES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/devices/tabs/profile/_profile.html","<div flex=70><div><div class=\"m12 mb24\" layout><span class=\"st-title-small mr12\" translate=DEVICES.TITLE.LAST_REPORT></span><progress ng-if=ctrl.loading></progress></div></div><div><div class=m4 layout><div class=\"border border-solid border-gray-200 rounded-md p16 m8\"><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LABEL.LAST_GPS></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div><div class=\"border border-solid border-gray-200 rounded-md p16 m8\"><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LABEL.LAST_GPRS></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_connection_time | date: \'HH:mm:ss dd/MM/yyyy\'}}</span></div></div><div class=\"section-content mt12\"><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.ABOUT_REPORT></span><div class=m12 layout layout-align=\"start center\"><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.BL></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.bl.toString() | number:\'2\' || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.BBV></div><span class=\"text-sm leading-tight text-gray-700 truncate\" data-metrics=voltage>{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.bbv.toString() | number:\'2\' || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.ORG></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.org.toString() || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.HIS></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{\'DEVICES.ENUM.HIS.\' + ctrl.item.relationships.last_gps.attributes.last_gps_raw.his.toString().toUpperCase()}}\" translate-default=-></span></span></div><div class=m12 layout layout-align=\"start center\"><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.FIX></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{\'DEVICES.ENUM.FIX.\' + ctrl.item.relationships.last_gps.attributes.last_gps_raw.fix.toString().toUpperCase()}}\" translate-default=-></span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.SC></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.sc.toString() || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.GSM></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.gsm.toString() || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.VL></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.vl.toString() || \'-\'}}</span></span></div></div><div class=section-content ng-if=\"[\'AlarmEvent\',\'SWEvent\'].includes(ctrl.item.relationships.last_gps.attributes.last_gps_raw.org)\"><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.ALERT_CONTEXT></span><div class=m12 layout layout-align=\"start center\"><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.MSG></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.msg.toString() || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.TAG></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{\'ALERT_TAG.\' + ctrl.item.relationships.last_gps.attributes.last_gps_raw.tag.toUpperCase() + \'.TITLE\'}}\" translate-default=-></span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=DEVICES.LAST_GPS_RAW.VAL></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{\'ALERT_VAL.\' + ctrl.item.relationships.last_gps.attributes.last_gps_raw.val.toUpperCase() + \'.TITLE\'}}\" translate-default=-></span></span></div></div><div class=section-content><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.GEO_CONTEXT></span><div class=m12 layout layout-align=\"start center\"><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.PV></div><span class=\"text-sm leading-tight text-gray-700 truncate\" data-metrics=voltage>{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.pv.toString() | number:\'2\' || \'-\'}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.DIR></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.dir.toString() | direction}}\"></span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.DIS></div><span class=\"text-sm leading-tight text-gray-700 truncate\" data-metrics=distance>{{(ctrl.item.relationships.last_gps.attributes.last_gps_raw.dis || 0) / 1000}}</span></span></div><div class=m12 layout layout-align=\"start center\"><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.HMT></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.hmt.toString() | duration}}</span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.IGN></div><span class=\"text-sm leading-tight text-gray-700 truncate\" translate=\"{{\'DEVICES.ENUM.IGN.\' + ctrl.item.relationships.last_gps.attributes.last_gps_raw.ign.toString().toUpperCase()}}\" translate-default=-></span> </span><span flex class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.SPD></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.spd.toString() || \'-\'}}</span></span></div></div><div class=section-content><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.META_DATA></span><div class=m12 layout layout-align=\"start center\"><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.LAT></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.lat | number:\'6\' || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.LNG></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.lng | number:\'6\' || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.LOC></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.loc.toString() || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.ALT></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.alt.toString() || \'-\'}}</span></span></div><div class=m12 layout layout-align=\"start center\"><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.MOD></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.mod.toString() || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.CB></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.cb.toString() || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.SV></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.sv.toString() || \'-\'}}</span></span></div></div><div class=section-content><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.AGPS></span><div class=m12 layout layout-align=\"start center\"><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.LAC></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.lac || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.MNC></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.mnc || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.MCC></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.mcc || \'-\'}}</span></span></div><div class=m12 layout layout-align=\"start center\"><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.CID></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.cid || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.MD></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.md || \'-\'}}</span> </span><span flex=25 class=profile-box><div class=\"text-xs font-bold leading-tight text-gray-500 truncate\" translate=DEVICES.LAST_GPS_RAW.MN></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw.mn || \'-\'}}</span></span></div></div><div class=section-content><span class=\"text-lg font-bold leading-tight text-gray-700 m12\" translate=DEVICES.TITLE.ADDITIONAL></span><div layout layout-align=\"start center\"><span class=\"bg-gray-100 rounded-md p16 m12 w-40 h-20\" flex ng-repeat=\"i in [\'i1\', \'i2\', \'i3\', \'i4\', \'i5\', \'i6\']\"><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=\"{{\'DEVICES.LAST_GPS_RAW.\' + i.toUpperCase()}}\"></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw[i]}}</span></span></div><div layout layout-align=\"start center\"><span class=\"bg-gray-100 rounded-md p16 m12 w-40 h-20\" flex ng-repeat=\"o in [\'o1\', \'o2\', \'o3\', \'o4\', \'o5\', \'o6\']\"><div class=\"text-xs font-bold leading-tight text-gray-700\" translate=\"{{\'DEVICES.LAST_GPS_RAW.\' + o.toUpperCase()}}\"></div><span class=\"text-sm leading-tight text-gray-700 truncate\">{{ctrl.item.relationships.last_gps.attributes.last_gps_raw[o]}}</span></span></div></div></div></div>");
$templateCache.put("app/internal/organization/enterprises/components/new-enterprise-behavior-config/new-enterprise-behavior-config.dialog.html","<md-dialog flex-xs=95 flex-sm=65 flex-md=55 flex-gt-md=45 class=st-dialog aria-label=\"Enterprise Behavior config\"><!-- dialog header --><div class=st-dialog-header><div layout layout-align=\"space-between center\"><div layout><div><div class=\"text-lg font-bold leading-tight text-gray-700\" translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.TITLE.NEW></div><div class=\"text-sm font-medium leading-tight text-gray-500\" translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.TITLE.DESC></div></div></div></div></div><div class=st-dialog-wrapper><form class=st-dialog-body name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save(ctrl.behavior)\" layout=column layout-align=\"space-between stretch\" novalidate><div layout=column layout-align=\"space-between stretch\" flex><div><div class=st-input-container layout=column flex><label class=st-label translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.LABEL.NAME></label><input class=\"st-input-type input-type\" name=name ng-model=ctrl.behavior.attributes.name type=text autocomplete=off required></div></div><div class=mb24><div class=st-input-container layout=column flex=50><label class=st-label translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.LABEL.BATTERY_LEVEL></label><input class=\"st-input-type input-type\" name=battery_level_min ng-model=ctrl.behavior.attributes.battery_level_min type=text ui-number-mask=0 min=0 max=100 autocomplete=off></div><div class=\"ml12 text-xs leading-tight text-gray-700\" translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.HINT.BATTERY_LEVEL></div></div><div class=mb24><div class=st-input-container layout=column flex=50><label class=st-label translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.LABEL.SPEED_MAX></label><input class=\"st-input-type input-type\" name=speed_max ng-model=ctrl.behavior.attributes.speed_max type=text ui-number-mask=0 min=0 max=360 autocomplete=off></div><div class=\"ml12 text-xs leading-tight text-gray-700\" translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.HINT.SPEED_MAX></div></div><div class=mb24><div class=st-input-container layout=column flex=50><label class=st-label translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.LABEL.VOLTAGE_MIN></label><input class=\"st-input-type input-type\" name=voltage_min ng-model=ctrl.behavior.attributes.voltage_min type=text ui-number-mask=0 min=0 autocomplete=off></div><div class=\"ml12 text-xs leading-tight text-gray-700\" translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.HINT.VOLTAGE_MIN></div></div><!-- <div class=\"mb24\">\n          <div class=\"st-input-container\" layout=\"column\" flex=\"50\">\n            <label class=\"st-label\" translate=\"NEW_ENTERPRISE_BEHAVIOR_CONFIG.LABEL.TIME_RESTRICTIONS\"></label>\n            <input class=\"st-input-type input-type\" name=\"time_restrictions\" ng-model=\"ctrl.behavior.attributes.time_restrictions\" type=\"text\" autocomplete=\"off\">\n          </div>\n          <div class=\"ml12 text-xs leading-tight text-gray-700\" translate=\"NEW_ENTERPRISE_BEHAVIOR_CONFIG.HINT.TIME_RESTRICTIONS\"></div>\n        </div> --><br><div class=st-dialog-footer layout layout-align=\"end center\" flex><button type=button class=\"altnav-action cancel mr8\" aria-label=Cancel ng-click=ctrl.close()><span translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save\" aria-label=Save><span translate=NEW_ENTERPRISE_BEHAVIOR_CONFIG.ACTION.SAVE></span></button></div></div></form></div></md-dialog>");
$templateCache.put("app/internal/organization/enterprises/tabs/addresses/_addresses.html","<div class=\"m12 mb24\"><div layout layout-align=\"start center\" class=h-6><span class=\"text-base font-bold leading-tight text-gray-700 mr8\" translate=ENTERPRISES.TITLE.ADDRESSES></span><progress ng-if=ctrl.loading class=pl8></progress><button type=button class=no-button ng-if=!ctrl.loading ng-click=ctrl.add() can-access=INTERNALS,MANAGER><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.ADDRESSES_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.ADDRESS_TYPE></span></th><th md-column><span translate=ENTERPRISES.LABEL.ADDRESS_FORMATTED></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><span translate=\"{{\'ENTERPRISES.ENUM.ADDRESS_TYPE.\' + item.attributes.type }}\"></span></td><td md-cell>{{item.attributes.formatted_address}}</td><td md-cell><div can-access=INTERNALS,MANAGER><button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadAddresses md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/behavior-configs/_behavior-configs.html","<div class=\"m12 mb24\"><div layout layout-align=\"start center\" class=h-6><span class=\"text-base font-bold leading-tight text-gray-700 mr8\" translate=ENTERPRISES.TITLE.BEHAVIOR></span><progress ng-if=ctrl.loading class=pl8></progress><button can-access=INTERNALS,MANAGER class=no-button ng-if=!ctrl.loading ng-click=ctrl.add()><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.BEHAVIOR_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.BEHAVIOR_NAME></span></th><th md-column><span translate=ENTERPRISES.LABEL.BATTERY_LEVEL></span></th><th md-column><span translate=ENTERPRISES.LABEL.SPEED_MAX></span></th><th md-column><span translate=ENTERPRISES.LABEL.VOLTAGE_MIN></span></th><th md-column><span translate=ENTERPRISES.LABEL.TIME_RESTRICTIONS></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell><span class=\"pt4 pb4 inline-block\">{{item.attributes.name}}</span></td><td md-cell><span data-metrics=percentage>{{item.attributes.battery_level_min}}</span></td><td md-cell><span data-metrics=speed>{{item.attributes.speed_max}}</span></td><td md-cell><span data-metrics=voltage>{{item.attributes.voltage_min}}</span></td><td md-cell><span translate=\"{{\'ENTERPRISES.LABEL.\' + (item.attributes.time_restrictions ? \'RESTRICTED\' : \'NO_RESTRICTED\')}}\"></span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=6><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadBehaviorConfig md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/custom-filters/_custom-filters.html","<div class=\"m12 mb24\"><div layout layout-align=\"start center\" class=h-6><p class=\"text-base font-bold leading-tight text-gray-700 mr8\" translate=ENTERPRISES.TITLE.CUSTOM_FILTERS></p><progress ng-if=ctrl.loading class=pl8></progress><button can-access=INTERNALS,MANAGER class=no-button ng-if=!ctrl.loading ng-click=ctrl.add()><i class=material-symbols-outlined>add_circle</i></button></div><p class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.CUSTOM_FILTERS_DESC></p></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><p translate=ENTERPRISES.LABEL.CUSTOM_FILTES_NAME></p></th><th md-column><p translate=ENTERPRISES.LABEL.CUSTOM_FILTES_MODEL></p></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.name}}</td><td md-cell><span translate>{{\'CUSTOM_FILTERS.ENUM.PAGES.\' + item.attributes.model.toUpperCase()}}</span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" title=Edit><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" title=Delete><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=3><div layout=column layout-align=\"center center\"><p class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadFilters md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/customizations/_customizations.html","<div class=\"m12 mb24\"><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.CUSTOMIZATION></span><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.CUSTOMIZATION_DESC></div></div><div><form class=st-form-inputs name=ctrl.form ng-submit=\"ctrl.form.$valid && ctrl.save()\" novalidate flex><div><div class=st-input-container layout=column flex=50><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.DOMAIN></label><input class=\"st-input-type input-type\" name=domain ng-model=ctrl.customization.attributes.short_domain type=text maxlength=28 restrict-input=[^a-z0-9\\s] autocomplete=off required><div class=\"absolute right-6 top-9 h-8 pt4 pb4 box-border\"><span class=\"text-sm font-medium leading-tight text-gray-500\">{{ctrl.routeDomain}}</span></div></div><div layout><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.COLOR1></label><input class=\"st-input-type input-type\" name=color1 ng-model=ctrl.customization.attributes.color1 type=text autocomplete=off required> <input class=\"absolute right-4 top-10\" ng-model=ctrl.customization.attributes.color1 type=color autocomplete=off></div><div class=st-input-container layout=column flex><label class=\"st-label st-required\" translate=ENTERPRISES.LABEL.COLOR2></label><input class=\"st-input-type input-type\" name=color2 ng-model=ctrl.customization.attributes.color2 type=text autocomplete=off required> <input class=\"absolute right-4 top-10\" ng-model=ctrl.customization.attributes.color2 type=color autocomplete=off></div></div><div class=m12><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.CUSTOMIZED_APP></span></div><div layout><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.APP_STORE></label><input class=\"st-input-type input-type\" ng-model=ctrl.customization.attributes.apps.ios type=text autocomplete=off disabled></div><div class=st-input-container layout=column flex><label class=st-label translate=ENTERPRISES.LABEL.GOOLGE_PLAY></label><input class=\"st-input-type input-type\" ng-model=ctrl.customization.attributes.apps.android type=text autocomplete=off disabled></div></div></div><br><div class=st-form-actions can-access=INTERNALS,MANAGER layout layout-align=\"space-between center\"><button type=button class=\"altnav-action cancel\" aria-label=Delete ng-click=ctrl.delete() ng-disabled=\"ctrl.loading || !ctrl.customization.id\"><span translate=ENTERPRISES.ACTION.DELETE></span></button><div layout><button type=button class=\"altnav-action cancel\" aria-label=Cancel ui-sref=enterprises-list><span translate=ENTERPRISES.ACTION.CANCEL></span></button> <button type=submit class=\"altnav-action save ml12\" ng-disabled=ctrl.loading aria-label=Save><span translate=ENTERPRISES.ACTION.SAVE></span></button></div></div></form></div><br>");
$templateCache.put("app/internal/organization/enterprises/tabs/integrations/_integrations.html","<div class=\"m12 mb24\"><div layout layout-align=\"start center\" class=h-6><p class=\"text-base font-bold leading-tight text-gray-700 mr-1\" translate=ENTERPRISES.TITLE.INTEGRATION></p><progress ng-if=ctrl.loading class=pl-px></progress><button can-access=INTERNALS,MANAGER class=\"no-button no-padding\" ng-if=!ctrl.loading ng-click=ctrl.add()><i class=\"material-symbols-outlined pt-1.5\">add_circle</i></button></div><p class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.INTEGRATION_DESC></p></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><p translate=ENTERPRISES.LABEL.INTEGRATION></p></th><th md-column><p translate=ENTERPRISES.LABEL.INTEGRATED_ENTITIES></p></th><th md-column><p translate=ENTERPRISES.LABEL.CREATED_AT></p></th><th md-column><p translate=ENTERPRISES.LABEL.UPDATED_AT></p></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{\'INTEGRATIONS.ENUM.OPTIONS.NAMES.\' + item.attributes.source.toUpperCase() | translate}}</td><td md-cell>{{ ctrl.translateIntegratedEntities(item.attributes.integrated_entities) }}</td><td md-cell>{{item.attributes.created_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell>{{item.attributes.updated_at | date: \'HH:mm:ss dd/MM/yyyy\'}}</td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" title=Edit><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" title=Delete><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=3><div layout=column layout-align=\"center center\"><p class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadFilters md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/notifications/_notifications.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.NOTIFICATION></span><progress ng-if=ctrl.loading></progress></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.NOTIFICATION_DESC></div><div flex layout layout-align=\"start center\" ng-if=ctrl.showInheritOption><md-switch class=st-activation-switch ng-model=ctrl.inherit md-no-ink aria-label=\"Inherit Switch\" ng-change=ctrl.save()><div layout=column><span class=\"text-base font-bold leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.INHERIT></span> <span class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.LABEL.INHERIT_DESCRIPTION></span></div></div></div><div><div layout=column><div layout=column><div class=m12 layout layout-align=\"space-between start\"><div flex><div flex layout layout-align=\"start center\"><span class=st-caption flex=50 translate=ENTERPRISES.LABEL.ALERT_NAME></span> <span class=\"st-caption center\" flex translate=ENTERPRISES.LABEL.ADMIN></span> <span class=\"st-caption center\" flex translate=ENTERPRISES.LABEL.RESPONSIBLES></span></div><div ng-repeat=\"alert in ctrl.alertsConfig\" flex layout layout-align=\"space between center\"><div flex=50 layout=column><span class=\"st-subhead st-no-wrap\" translate=\"{{\'ENTERPRISES.ENUM.TYPES.\' + alert.type.toUpperCase() + \'.TITLE\'}}\"></span> <span class=\"st-caption st-no-wrap\" translate=\"{{\'ENTERPRISES.ENUM.TYPES.\' + alert.type.toUpperCase() + \'.DESCRIPTION\'}}\"></span></div><div flex layout=column layout-align=\"center center\" class=m12><input type=checkbox ng-model=alert.recipients.admin name=alert-admin-{{$index}} ng-change=ctrl.save() ng-disabled=\"ctrl.role == \'VISITOR\'\"></div><div flex layout=column layout-align=\"center center\" class=m12><input type=checkbox ng-model=alert.recipients.responsibles name=alert-responsibles-{{$index}} ng-change=ctrl.save() ng-disabled=\"ctrl.role == \'VISITOR\'\"></div></div></div></div></div><br><br></div></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/operationals/_operationals.html","<div class=\"m12 mb24\"><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.OPERATIONS></span><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.OPERATIONS_DESC></div></div><div><div flex><div class=\"m12 mb24\" layout><div ng-repeat=\"resource in ctrl.resources\"><button ng-if=\"resource === \'service-orders\'\" class=\"altnav-action mr12\" ng-class=\"{\'light\': ctrl.btnTaskTypes}\" aria-label=Resource type=button ng-click=ctrl.loadData(resource)><span translate=\"{{\'ENTERPRISES.ENUM.RESOURCES.\' + resource.toUpperCase()}}\"></span></button> <button ng-if=\"resource === \'protocols\'\" class=\"altnav-action mr12\" ng-class=\"{\'light\': ctrl.btnTaskSections}\" aria-label=Resource type=button ng-click=ctrl.loadData(resource)><span translate=\"{{\'ENTERPRISES.ENUM.RESOURCES.\' + resource.toUpperCase()}}\"></span></button></div></div><div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.TYPES></span> <button can-access=INTERNALS,MANAGER class=no-button ng-click=\"ctrl.add(\'types\')\"><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.TYPES_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.ADDRESS_TYPE></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.types\"><td md-cell><span>{{item.attributes.name}}</span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button type=button class=no-button ng-click=\"ctrl.edit(item, \'types\', $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button type=button class=no-button ng-click=\"ctrl.delete(item, \'types\', $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading.types && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.types || ctrl.types.length == 0) && !ctrl.loading.types\"><td class=st-table-no-content colspan=3><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.types.limit md-page=ctrl.meta.types.page md-total={{ctrl.meta.types.count}} md-on-paginate=ctrl.loadTypes md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div><div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.SECTIONS></span> <button can-access=INTERNALS,MANAGER class=no-button ng-click=\"ctrl.add(\'sections\')\"><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.SECTIONS_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.SECTIONS></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.sections\"><td md-cell><span>{{item.attributes.name}}</span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button type=button class=no-button ng-click=\"ctrl.edit(item, \'sections\', $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button type=button class=no-button ng-click=\"ctrl.delete(item, \'sections\', $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading.sections && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.sections || ctrl.sections.length == 0) && !ctrl.loading.sections\"><td class=st-table-no-content colspan=3><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.sections.limit md-page=ctrl.meta.sections.page md-total={{ctrl.meta.sections.count}} md-on-paginate=ctrl.loadSections md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div></div></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/public-keys/_public-keys.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.PUBLIC_KEYS></span><progress ng-if=ctrl.loading></progress><button can-access=INTERNALS,MANAGER class=no-button ng-click=ctrl.add()><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.PUBLIC_KEYS_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.NAME></span></th><th md-column><span translate=ENTERPRISES.LABEL.TOKEN></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.name}}</td><td md-cell><span class=\"pt4 pb4 inline-block\">{{item.attributes.token}}</span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadPublicKeys md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/templates/_templates.html","<div class=\"m12 mb24\"><div layout layout-align=\"start center\" class=h-6><p class=\"text-base font-bold leading-tight text-gray-700 mr8\" translate=ENTERPRISES.TITLE.TEMPLATES></p><progress ng-if=ctrl.loading class=pl8></progress><button class=no-button ng-if=!ctrl.loading ng-click=ctrl.add() can-access=INTERNALS,MANAGER><i class=material-symbols-outlined>add_circle</i></button></div><p class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.TEMPLATES_DESC></p></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><p translate=ENTERPRISES.LABEL.TEMPLATES_NAME></p></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.name}}</td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" title=Editar><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=ctrl.delete(item) title=Excluir><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=ctrl.loading ng-repeat=\"skeleton in [1,2,3,4,5]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=2><div layout=column layout-align=\"center center\"><p class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></p></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadTemplate md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");
$templateCache.put("app/internal/organization/enterprises/tabs/webhooks/_webhooks.html","<div class=\"m12 mb24\"><div layout><span class=\"text-base font-bold leading-tight text-gray-700 mr12\" translate=ENTERPRISES.TITLE.WEBHOOKS></span><progress ng-if=ctrl.loading></progress><button can-access=INTERNALS,MANAGER class=no-button ng-click=ctrl.add()><i class=material-symbols-outlined>add_circle</i></button></div><div class=\"text-sm font-medium leading-tight text-gray-700\" translate=ENTERPRISES.TITLE.WEBHOOKS_DESC></div></div><div><md-table-container class=st-wrapper-table><table class=st-main-table md-table><thead class=st-table-head md-head><tr md-row><th md-column><span translate=ENTERPRISES.LABEL.NAME></span></th><th md-column><span translate=ENTERPRISES.LABEL.URL></span></th><th md-column md-numeric></th></tr></thead><tbody class=st-table-body md-body><tr md-row ng-repeat=\"item in ctrl.items\"><td md-cell>{{item.attributes.name}}</td><td md-cell><span class=\"pt4 pb4 inline-block\">{{item.attributes.url}}</span></td><td md-cell class=w-20><div can-access=INTERNALS,MANAGER layout><button class=no-button ng-click=\"ctrl.edit(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.EDIT\'}\"><i class=material-symbols-outlined>edit</i></button> <button class=no-button ng-click=\"ctrl.delete(item, $index)\" translate-attr=\"{title:\'ENTERPRISES.HINT.DELETE\'}\"><i class=material-symbols-outlined>delete</i></button></div></td></tr><tr class=st-table-skeleton ng-if=\"ctrl.loading && !ctrl.items\" ng-repeat=\"skeleton in [1,2,3]\"><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td><td md-cell><span class=st-skeleton-item></span></td></tr><tr ng-if=\"(!ctrl.items || ctrl.items.length == 0) && !ctrl.loading\"><td class=st-table-no-content colspan=4><div layout=column layout-align=\"center center\"><span class=\"no-content-text mt8\" translate=ENTERPRISES.HINT.NOT_FOUND></span></div></td></tr></tbody></table></md-table-container><md-table-pagination class=st-main-table-footer md-limit=ctrl.meta.limit md-page=ctrl.meta.page md-total={{ctrl.meta.count}} md-on-paginate=ctrl.loadWebhooks md-boundary-links md-label=\"{page: \'{{\'ENTERPRISES.PAGINATION.PAGE\' | translate}}\', rowsPerPage: \'{{\'ENTERPRISES.PAGINATION.ROWS_PER_PAGE\' | translate}}\', of: \'{{\'ENTERPRISES.PAGINATION.OF\' | translate}}\'}\"></md-table-pagination></div>");}]);